// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"9DeGw":[function(require,module,exports) {
require("7659718e374ca55b").register(require("c20993d5bd5940d1").getBundleURL("3PVz6"), JSON.parse('["3PVz6","index.5b47bc8d.js","h29mo","../horus.00f0c3fc.png"]'));

},{"7659718e374ca55b":"7Chvu","c20993d5bd5940d1":"ggWeI"}],"7Chvu":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"ggWeI":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"giyNJ":[function(require,module,exports) {
var _jsxRuntime = require("react/jsx-runtime");
"use strict";
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = About;
exports.getAppInfo = getAppInfo;
var _react = require("d2b0e9115936f3bd");
var _utils = require("908245a590b59b42");
var _External = _interopRequireDefault(require("bcd939582904d7ac"));
var _LogFile = _interopRequireDefault(require("79e4270a56c28402"));
var _appbutton = _interopRequireDefault(require("9fd0b9e2eb7be734"));
var _reusable = require("6301e783070592d8");
var _core = require("552e6f65ab01451d");
var _hooks = require("50ff3d1ab3b55209");
var _reactQuery = require("95d40589c8482e83");
var _horus = _interopRequireDefault(require("aa830d25bbcf763c"));
var _rotatinglines = _interopRequireDefault(require("763fe8a4a0ed4922"));
var _marked = require("b6189308683320b6");
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var _$t = r.pop();
                if (_$t in e) return next.value = _$t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
} // Horus web-server utils
// @ts-ignore
function getAppInfo() {
    return _getAppInfo.apply(this, arguments);
}
function _getAppInfo() {
    _getAppInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
        var response, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return (0, _utils.horusGet)("/api/version");
                case 2:
                    response = _context2.sent;
                    if (response.ok) {
                        _context2.next = 5;
                        break;
                    }
                    throw new Error("Error getting application info");
                case 5:
                    _context2.next = 7;
                    return response.json();
                case 7:
                    data = _context2.sent;
                    if (data.ok) {
                        _context2.next = 10;
                        break;
                    }
                    throw new Error("Error getting application info: " + data.msg);
                case 10:
                    return _context2.abrupt("return", data.appINFO);
                case 11:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return _getAppInfo.apply(this, arguments);
}
function About() {
    var _appInfo$mode;
    var _useState = (0, _react.useState)({}), _useState2 = _slicedToArray(_useState, 2), appInfo = _useState2[0], setAppInfo = _useState2[1];
    var _useState3 = (0, _react.useState)(true), _useState4 = _slicedToArray(_useState3, 2), gettingInfo = _useState4[0], setGettingInfo = _useState4[1];
    var getVersion = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        setGettingInfo(true);
                        getAppInfo().then(function(info) {
                            setAppInfo(info);
                        }).catch(function(error) {
                            alert(error.message);
                        }).finally(function() {
                            setGettingInfo(false);
                        });
                    case 2:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function getVersion() {
            return _ref.apply(this, arguments);
        };
    }();
    var _useDisclosure = (0, _hooks.useDisclosure)(false), _useDisclosure2 = _slicedToArray(_useDisclosure, 2), opened = _useDisclosure2[0], _useDisclosure2$ = _useDisclosure2[1], open = _useDisclosure2$.open, close = _useDisclosure2$.close;
    (0, _react.useEffect)(function() {
        getVersion();
    }, []);
    if (gettingInfo) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "grid grid-cols-1 place-items-center h-full",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_rotatinglines.default, {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-row flex-wrap justify-around items-center overflow-hidden h-full w-full ",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            appInfo.APP_VERSION && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-2 horus-container animated-gradient !text-black",
                                children: [
                                    "Version: ",
                                    appInfo.APP_VERSION
                                ]
                            }),
                            appInfo.platform && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-2 horus-container animated-gradient !text-black",
                                children: [
                                    "Platform: ",
                                    appInfo.platform
                                ]
                            }),
                            appInfo.mode && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-2 horus-container animated-gradient !text-black",
                                children: [
                                    "Mode: ",
                                    (_appInfo$mode = appInfo.mode) === null || _appInfo$mode === void 0 ? void 0 : _appInfo$mode.toUpperCase()
                                ]
                            }),
                            appInfo.debug && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-2 horus-container animated-gradient !text-orange-400 font-semibold",
                                children: [
                                    "Debug mode enabled - Python version: ",
                                    appInfo.PYTHON_VERSION
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: _horus.default,
                                alt: "Horus Logo",
                                className: "object-fit m-auto",
                                width: 100
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_appbutton.default, {
                                action: open,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row gap-2 items-center justify-center",
                                    children: [
                                        "License ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LogFile.default, {
                                            className: "w-5 h-5"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                className: "app-button text-black text-decoration-none",
                                href: "https://horus.bsc.es/",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-row gap-2 items-center",
                                    children: [
                                        "Learn more about Horus",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_External.default, {
                                            className: "w-5 h-5"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reusable.BlurredModal, {
                onHide: close,
                show: opened,
                overRoot: true,
                maxContentSize: {
                    width: "90vw",
                    height: "90vh"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LicenseView, {})
            })
        ]
    });
}
function LicenseView() {
    var _useQuery = (0, _reactQuery.useQuery)({
        queryKey: [
            "license"
        ],
        queryFn: function queryFn() {
            return (0, _utils.horusGet)("/license").then(function(r) {
                return r.text();
            });
        }
    }), data = _useQuery.data, isLoading = _useQuery.isLoading;
    if (isLoading || !data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Container, {
        size: "md",
        py: "xl",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Center, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_core.Stack, {
                align: "center",
                gap: "md",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Loader, {
                        color: "cyan",
                        size: "lg"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Text, {
                        size: "lg",
                        c: "dimmed",
                        children: "Loading license..."
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Container, {
        size: "md",
        py: "xl",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Paper, {
            shadow: "sm",
            p: "xl",
            radius: "md",
            withBorder: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.TypographyStylesProvider, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        userSelect: "auto",
                        whiteSpace: "pre-wrap",
                        overflowWrap: "break-word",
                        wordBreak: "break-word",
                        textAlign: "center",
                        // fontSize: "20px",
                        // fontWeight: 700,
                        lineHeight: 1.6,
                        color: "var(--mantine-color-text)"
                    },
                    dangerouslySetInnerHTML: {
                        __html: '\n                <style>\n                  pre, code {\n                    white-space: pre-wrap !important;\n                    word-break: break-word;\n                    overflow-wrap: break-word;\n                    font-size: "14px"\n                  }\n                  pre {\n                    overflow-x: auto;\n                    background: var(--mantine-color-gray-0);\n                    padding: 1rem;\n                    border-radius: 0.5rem;\n                    margin: 1rem 0;\n                    text-align: left;\n                  }\n                  code {\n                    font-family: monospace;\n                  }\n                </style>\n                '.concat(_marked.marked.parse(data), "\n              ")
                    }
                })
            })
        })
    });
}

},{"react/jsx-runtime":"iKGFf","d2b0e9115936f3bd":"9MtAM","908245a590b59b42":"fkrhY","bcd939582904d7ac":"jFOQz","79e4270a56c28402":"hcRqb","9fd0b9e2eb7be734":"8pehK","6301e783070592d8":"jJFYt","552e6f65ab01451d":"jWKSM","50ff3d1ab3b55209":"9HEEB","95d40589c8482e83":"h4000","aa830d25bbcf763c":"bSoFW","763fe8a4a0ed4922":"8tPZ5","b6189308683320b6":"678Yq"}],"jFOQz":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ExternalIcon;
function ExternalIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: "w-6 h-6",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor"
    }, props), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
        })
    }));
}

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","react/jsx-runtime":"iKGFf"}],"hcRqb":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LogFile;
function LogFile(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: "w-6 h-6",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        strokeWidth: 0,
        stroke: "currentColor"
    }, props), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#clip0_4_787)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M8 17H16V15H8V17ZM8 13H16V11H8V13ZM8 9H16V7H8V9ZM4 21C3.45 21 2.97933 20.8043 2.588 20.413C2.196 20.021 2 19.55 2 19V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V19C22 19.55 21.8043 20.021 21.413 20.413C21.021 20.8043 20.55 21 20 21H4ZM4 19H20V5H4V19Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "clip0_4_787",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "currentColor"
                    })
                })
            })
        ]
    }));
}

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","react/jsx-runtime":"iKGFf"}],"jWKSM":[function(require,module,exports) {
"use strict";
var reactRemoveScroll = require("d74bb5bc9a85aac1");
var keys = require("7b254950b9d254cc");
var deepMerge = require("1e331ec65be3c231");
var camelToKebabCase = require("ea715a757b99b401");
var px = require("c25f48167623a47c");
var rem = require("aa3f1ee1629b2602");
var filterProps = require("d9d07573261a0799");
var isNumberLike = require("f3f5ede1739995f3");
var isElement = require("a60357884690482f");
var createSafeContext = require("bab650a68f94ea27");
var createOptionalContext = require("6798fe3554ea6fa1");
var getSafeId = require("d4c6630e633e9a0f");
var createScopedKeydownHandler = require("b676f1651d308404");
var findElementAncestor = require("110a6013d18cab16");
var getDefaultZIndex = require("29c19aa94c30e22c");
var closeOnEscape = require("f23e8030781321fd");
var noop = require("2ad1348077c4e3");
var getSize = require("5f70873e029f33b9");
var createEventHandler = require("8612e35eb078526c");
var getBreakpointValue = require("5441632baee1b67b");
var getSortedBreakpoints = require("623fb1f62d443062");
var getBaseValue = require("772207fe81ba72b2");
var getContextItemIndex = require("3242dafacfcad102");
var useHovered = require("ffcc5facc241d99d");
var createUseExternalEvents = require("8979423dc1b94599");
var getEnv = require("e29c89e0a20badbb");
var memoize = require("f0d4691202fda8fe");
var findClosestNumber = require("fb70dfc37a7d946f");
var getRefProp = require("3648d2ae9ea4658");
var createVarsResolver = require("8b10d29c2697e4c2");
var resolveClassNames = require("51d6a9cd4241b2eb");
var resolveStyles = require("21a26b6edc0b372a");
var useResolvedStylesApi = require("4f2a58fe797651a9");
var getGlobalClassNames = require("514a9116dd8ea7b5");
var useStyles = require("2a5304a047c3c096");
var localStorageManager = require("ad976ae0e957c651");
var isMantineColorScheme = require("b170f06c512ab2b8");
var getPrimaryShade = require("818a357df313fbc2");
var parseThemeColor = require("2972d38cf1554d27");
var getThemeColor = require("5fae84dc9e11c32f");
var defaultVariantColorsResolver = require("7fe450bfad711223");
var getGradient = require("beb58bfbdf03d225");
var toRgba = require("ffc340219aaa849a");
var rgba = require("e97a79df6b133882");
var darken = require("b70b19de704a5c0e");
var lighten = require("c865dc68009ce470");
var luminance = require("bb6fe25b0e75757f");
var getContrastColor = require("8684e08b8c7f0809");
var getAutoContrastValue = require("ebea444811f7c282");
var colorsTuple = require("1d89631227cbb7e1");
var useMantineColorScheme = require("8b44922bf706de3d");
var useProviderColorScheme = require("542313c2bde7fe1");
var useComputedColorScheme = require("b6b4ec3f4b082c52");
var ColorSchemeScript = require("403d1aa3ed101d0a");
var defaultTheme = require("f040488ad8e778d1");
var mergeMantineTheme = require("2d1481c0961043e3");
var MantineProvider = require("8d10f3554ef75610");
var Mantine_context = require("3a827cf5e2cde4b8");
var MantineThemeProvider = require("5c11eeb95cd8a72");
var useProps = require("67b2cfd982a9ec4c");
var convertCssVariables = require("d8d5b82e0aba39e8");
var createTheme = require("72c87ef5e974569e");
var mergeThemeOverrides = require("55b065956fcaada6");
var defaultCssVariablesResolver = require("e3a04bd4e2e8b623");
require("77c0b7933b34f5c5");
var getCssColorVariables = require("b7207fb74c61116e");
var virtualColor = require("a80bbd21e5eedd93");
var useMatches = require("dc21c2fa1615a927");
var mantineHtmlProps = require("c4b7396eceac19b6");
var InlineStyles = require("49f3a36eebd4f5a7");
var stylesToString = require("453f579b633dc5e");
var extractStyleProps = require("238aa1de7943e973");
var stylePropsData = require("d390a13a6da49601");
var parseStyleProps = require("dd11ee38dc11373a");
var useRandomClassname = require("9ca1a68ba926e3fc");
var getStyleObject = require("76b4676ee9765a19");
var Box = require("940bbd0357ea0f17");
var factory = require("1e0cfa3f3c33e973");
var polymorphicFactory = require("d7a08be9f63f9f48");
var createPolymorphicComponent = require("7c7d897f98a15fea");
var DirectionProvider = require("30ce75ade59c2d70");
var Collapse = require("e39ff5aae0fd6df3");
var ScrollArea = require("fc8f10b3036d83c2");
var UnstyledButton = require("6d090f58ad94397e");
var VisuallyHidden = require("b465d57df88b85e3");
var Paper = require("a9e2081d7a04c0fa");
var Popover = require("164e2ffc7647ea71");
var PopoverDropdown = require("cec00ce2dfcd821c");
var PopoverTarget = require("abf097e0b0ef6cf1");
var ActionIcon = require("53bae168e191f2db");
var ActionIconGroup = require("21ab77df8639af89");
var ActionIconGroupSection = require("7dd567863320e2cb");
var CloseIcon = require("aad179558a569c03");
var CloseButton = require("650143e999baf2da");
var Group = require("8ca31fde80104d2d");
var Loader = require("38c68c8dfff47e11");
var Overlay = require("9c47a8c5bff9b1b7");
var ModalBase = require("ef5aea8dc375ce26");
var ModalBaseBody = require("eb686ba3de37ddb6");
var ModalBaseCloseButton = require("ec0d86a06d693734");
var ModalBaseContent = require("c2628a601f57c224");
var ModalBaseHeader = require("5b6e1f1d2ec13141");
var ModalBaseOverlay = require("636915bf7a94c06c");
var ModalBaseTitle = require("2d0eacb777133ad");
var NativeScrollArea = require("a700b18772475632");
var Input = require("348f1bc0c63d0bbb");
var InputWrapper = require("1371b0f53a735639");
var InputDescription = require("3f3116dbb8d0c123");
var InputError = require("32df5518b4b01d29");
var InputLabel = require("c79c217309d22e82");
var InputPlaceholder = require("792cf076a4219745");
var InputClearButton = require("1a969d70ab0080b0");
var useInputProps = require("9e85cfe1d64f0b9c");
var InputWrapper_context = require("8baee7339341a877");
var InputBase = require("fbbbbd67daf49521");
var flexProps = require("c217a80f07b6174f");
var Flex = require("1537aa53754a973c");
var FloatingIndicator = require("fb2a87fdfe606ca4");
var Accordion = require("c80ae3b62928c168");
var AccordionChevron = require("c4be96c7ad3ab460");
var AccordionItem = require("2b33791cc465ab31");
var AccordionPanel = require("f5c95d850e591645");
var AccordionControl = require("a3cfcdf3dbc0c612");
var Affix = require("fd62470cc9790b60");
var Alert = require("4284b31501bc8080");
var Anchor = require("caa85cf0529a2f42");
var AngleSlider = require("314b0ec896ee168d");
var AppShell = require("ab9c918abd776e2f");
var AppShellAside = require("37ed88297a5a9dda");
var AppShellFooter = require("fa5cc1a760290399");
var AppShellHeader = require("5ff750d6c9f0381f");
var AppShellNavbar = require("7d84de56e9a71b82");
var AppShellSection = require("b39a5d55da116db3");
var AppShellMain = require("9708fc66caa9b165");
var AspectRatio = require("31a24caf647ffef3");
var Autocomplete = require("910a206a6348bbd7");
var Avatar = require("1baa7087c64fb70c");
var AvatarGroup = require("b7aaf4823336ca17");
var BackgroundImage = require("67d060e5ac970568");
var Badge = require("c2e1f0d9c2a52313");
var Blockquote = require("3c7fd6b4609f6538");
var Breadcrumbs = require("6d4b49952ff927dc");
var Burger = require("4c1941ebb6ca59d6");
var Button = require("566a253e5cf92c47");
var ButtonGroup = require("2b26f38606b9047c");
var ButtonGroupSection = require("4d64cc35308c00c0");
var Card = require("4b49e86b60232f16");
var CardSection = require("2544f5eab1aa93e2");
var Center = require("645fdbfe1535010c");
var Checkbox = require("166653f339ce6bcd");
var CheckboxGroup = require("4a554ddcbb672db9");
var CheckIcon = require("d73925c78656a2b6");
var CheckboxIndicator = require("7dd03985033a653d");
var CheckboxCard = require("3bf7ba3c13521364");
var CheckboxCard_context = require("9d833c5fac2acb16");
var CheckboxGroup_context = require("1c5440f5f324a9dc");
var Chip = require("5f8be18f94b5174f");
var ChipGroup = require("c070e00941014d60");
var Code = require("934127a5d4f85e12");
var ColorPicker = require("9fe4367c193d70e4");
var AlphaSlider = require("5b8e8ed496bc6c30");
var HueSlider = require("692f8d5eeb633628");
var converters = require("302be0ee6146c21f");
var parsers = require("97490a63e62cdeab");
var ColorInput = require("dafc695117901d6a");
var ColorSwatch = require("ea2c5efdace20377");
var getParsedComboboxData = require("6a422477baf33cb3");
var getOptionsLockup = require("c848c9d2c9565086");
var ComboboxChevron = require("c68d4fd529f3d6d6");
var Combobox = require("6a352d793ee1a3a5");
var ComboboxDropdown = require("de91e12855700672");
var ComboboxOptions = require("602bbb35f49b249e");
var ComboboxOption = require("35845ea3449ac7e8");
var ComboboxTarget = require("7f882847bc7cfb54");
var ComboboxSearch = require("451ad6cf1211dea9");
var ComboboxEmpty = require("efc42b26efa16503");
var ComboboxFooter = require("ce0b40ea220d3af6");
var ComboboxHeader = require("f73af4e667be4636");
var ComboboxEventsTarget = require("b0a5c643c1f1ed6a");
var ComboboxDropdownTarget = require("f54565415512c284");
var ComboboxGroup = require("a279428f30471606");
var ComboboxClearButton = require("a3a447cdd47f62ce");
var ComboboxHiddenInput = require("3d1d1a0d99ee4ea8");
var OptionsDropdown = require("8d4718a23b7cc6a4");
var useCombobox = require("df0b30f574900091");
var useVirtualizedCombobox = require("81cd23a430ce6fda");
var useComboboxTargetProps = require("9bd9c78d78fe886e");
var isOptionsGroup = require("4d13fb15d739a97b");
var defaultOptionsFilter = require("ddae22c171fb53bf");
var Container = require("5bd75d84233bb149");
var CopyButton = require("21bde815d04f9d00");
var Dialog = require("c26af61f3b246333");
var Divider = require("8e5a968d2d719706");
var Drawer = require("bd85d028da5e71de");
var DrawerRoot = require("550d8e2008876f4a");
var DrawerBody = require("b4328ed02dfbf4a8");
var DrawerCloseButton = require("2158525718737d0a");
var DrawerContent = require("13d6db6cc483b575");
var DrawerHeader = require("800f93ece6c22719");
var DrawerOverlay = require("b32270d92d0886b7");
var DrawerTitle = require("fbe946856692171e");
var DrawerStack = require("455383411dc283c7");
var Fieldset = require("1f16bdfd1ac2a0f6");
var FileButton = require("6de3f4193df10813");
var FileInput = require("bc4a23d52fa97a5b");
var useDelayedHover = require("34db9316e52043be");
var useFloatingAutoUpdate = require("12334423b540e56f");
var getFloatingPosition = require("2631b2ee368d7255");
var FloatingArrow = require("8363c6eca9e33177");
var FocusTrap = require("490f530d1d71b38d");
var Grid = require("e2180d8f329081ff");
var GridCol = require("96f50251817bb6b");
var Highlight = require("3de0da9051f35a8d");
var HoverCard = require("8a1d5b89825606c1");
var HoverCardDropdown = require("b10110fc12f26c16");
var HoverCardTarget = require("bba45314afe9ff95");
var Image = require("132b405a15690185");
var Indicator = require("976c3214db845324");
var JsonInput = require("ac455c6bc6e123d0");
var Kbd = require("4e9bfadc10dbca37");
var List = require("ef81c6c241d979");
var ListItem = require("555dc3eca36d0c6d");
var LoadingOverlay = require("84a7ab05b18baf2a");
var Mark = require("91f46d0c33960810");
var Menu = require("13f1315d3fcbd1d");
var MenuDivider = require("6287f91be122d570");
var MenuItem = require("aef27e88747ec9aa");
var MenuLabel = require("40947de7f7c020a9");
var MenuDropdown = require("2039090f01ecbfa8");
var MenuTarget = require("fbe5c0c3ecc6ba89");
var Modal = require("5a8c544bc01bb027");
var ModalRoot = require("a65f4b31246073e2");
var ModalBody = require("81488d4cfb299ea2");
var ModalCloseButton = require("421108b307669fc3");
var ModalContent = require("f99b1d0ed1e8b303");
var ModalHeader = require("f7dd0c530c9155b9");
var ModalOverlay = require("fd8eab6a7404288c");
var ModalTitle = require("c1804914ac005da6");
var ModalStack = require("df5fd175e0e89baa");
var useModalsStack = require("1e441fe9a3c6880d");
var MultiSelect = require("c0bbe12b7238ecfb");
var NativeSelect = require("488d01daa740ac25");
var NavLink = require("4772b46f61ce7c69");
var Notification = require("4f109eb1c46a78d3");
var NumberFormatter = require("cbfc4d535b3a357e");
var NumberInput = require("b5f9a8447f74cf53");
var Pagination = require("8f68c8738939df5b");
var PaginationControl = require("4eabc826578775c8");
var PaginationDots = require("4ca68d2f44923468");
var PaginationEdges = require("ebaab3dbf38f7ed");
var PaginationItems = require("c7c27d0de8f22651");
var PaginationRoot = require("469002692db9cfb9");
var PasswordInput = require("79e0cdb6e78490de");
var Pill = require("ccc5c7b716946db5");
var PillGroup = require("6f0fe7b24a3f32f");
var PillsInput = require("1fb0cbd7b2069766");
var PillsInputField = require("13988138ff75ecbd");
var PinInput = require("1876846a79c20c08");
var Portal = require("ea00fa5d4a1b91a0");
var OptionalPortal = require("b1f319d1415df98");
var Progress = require("459a72ac2e6e1ca7");
var ProgressLabel = require("a0605e66d802ce30");
var ProgressRoot = require("d7bc053fff304fa");
var ProgressSection = require("82d15c6e16f54d91");
var Radio = require("23a2702d33fb1d76");
var RadioGroup = require("2add3621c269c744");
var RadioIcon = require("3e41a0de3a2cf845");
var RadioCard = require("fea03f92a95bc9a");
var RadioCard_context = require("ef65386218e20bde");
var RadioIndicator = require("e51b49e9193c22f");
var Rating = require("1b8fa0142c355a89");
var RingProgress = require("cf1d84abfc32072a");
var SegmentedControl = require("dc152ba4354d733e");
var Select = require("2f2ec480405dd79b");
var SemiCircleProgress = require("4bf95e9d625217d2");
var SimpleGrid = require("c8aa26c248d1d449");
var Skeleton = require("176e5dcf2ef02ee0");
var Slider = require("8bebf51c7e83fe6e");
var RangeSlider = require("c6356c4921cdb10d");
var Space = require("c0d686f12d0d7aea");
var Spoiler = require("d0084e91b0d5e886");
var Stack = require("be406a659df3db4e");
var Stepper = require("c42acd6decb22ee8");
var StepperStep = require("f8b04f6f0fa065be");
var StepperCompleted = require("e10f371a419a9e40");
var Switch = require("5bb9e250a1cda07d");
var SwitchGroup = require("47d8039a54ac9646");
var Table = require("f505cc1d3496e4f6");
var Table_components = require("896769b7017048b9");
var TableScrollContainer = require("64403d17ee4531e9");
var TableOfContents = require("ef4c0f617a8254bc");
var Tabs = require("bb1bbc27d508f31f");
var TabsList = require("9d0120249be0378b");
var TabsTab = require("261cebc315623dbd");
var TabsPanel = require("cf51a1fb505ca210");
var TagsInput = require("63b0063f98adf14a");
var Text = require("75a596c1f451a436");
var Textarea = require("75a357b538d5d4aa");
var TextInput = require("4fe4f650e45d4c32");
var ThemeIcon = require("2d51618b298b88c3");
var Timeline = require("cb1fb8a92dc91041");
var TimelineItem = require("84e47fe58072ca6e");
var Title = require("95749ddb595512aa");
var Tooltip = require("cb34e3e205cab7b8");
var TooltipGroup = require("457c92b98eb2f359");
var TooltipFloating = require("41192d28e8d96bb5");
var transitions = require("4f5f6822472244c2");
var Transition = require("24ea2d2e578ea862");
var getTransitionProps = require("41533386d18ec4fc");
var Tree = require("47e975a27efc72ee");
var useTree = require("5e3bed6de2b7b7a6");
var TypographyStylesProvider = require("fe71d634fe14a0cc");
Object.defineProperty(exports, "RemoveScroll", {
    enumerable: true,
    get: function get() {
        return reactRemoveScroll.RemoveScroll;
    }
});
exports.keys = keys.keys;
exports.deepMerge = deepMerge.deepMerge;
exports.camelToKebabCase = camelToKebabCase.camelToKebabCase;
exports.px = px.px;
exports.em = rem.em;
exports.rem = rem.rem;
exports.filterProps = filterProps.filterProps;
exports.isNumberLike = isNumberLike.isNumberLike;
exports.isElement = isElement.isElement;
exports.createSafeContext = createSafeContext.createSafeContext;
exports.createOptionalContext = createOptionalContext.createOptionalContext;
exports.getSafeId = getSafeId.getSafeId;
exports.createScopedKeydownHandler = createScopedKeydownHandler.createScopedKeydownHandler;
exports.findElementAncestor = findElementAncestor.findElementAncestor;
exports.getDefaultZIndex = getDefaultZIndex.getDefaultZIndex;
exports.closeOnEscape = closeOnEscape.closeOnEscape;
exports.noop = noop.noop;
exports.getFontSize = getSize.getFontSize;
exports.getLineHeight = getSize.getLineHeight;
exports.getRadius = getSize.getRadius;
exports.getShadow = getSize.getShadow;
exports.getSize = getSize.getSize;
exports.getSpacing = getSize.getSpacing;
exports.createEventHandler = createEventHandler.createEventHandler;
exports.getBreakpointValue = getBreakpointValue.getBreakpointValue;
exports.getSortedBreakpoints = getSortedBreakpoints.getSortedBreakpoints;
exports.getBaseValue = getBaseValue.getBaseValue;
exports.getContextItemIndex = getContextItemIndex.getContextItemIndex;
exports.useHovered = useHovered.useHovered;
exports.createUseExternalEvents = createUseExternalEvents.createUseExternalEvents;
exports.getEnv = getEnv.getEnv;
exports.memoize = memoize.memoize;
exports.findClosestNumber = findClosestNumber.findClosestNumber;
exports.getRefProp = getRefProp.getRefProp;
exports.createVarsResolver = createVarsResolver.createVarsResolver;
exports.resolveClassNames = resolveClassNames.resolveClassNames;
exports.resolveStyles = resolveStyles.resolveStyles;
exports.useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi;
exports.FOCUS_CLASS_NAMES = getGlobalClassNames.FOCUS_CLASS_NAMES;
exports.useStyles = useStyles.useStyles;
exports.localStorageColorSchemeManager = localStorageManager.localStorageColorSchemeManager;
exports.isMantineColorScheme = isMantineColorScheme.isMantineColorScheme;
exports.getPrimaryShade = getPrimaryShade.getPrimaryShade;
exports.parseThemeColor = parseThemeColor.parseThemeColor;
exports.getThemeColor = getThemeColor.getThemeColor;
exports.defaultVariantColorsResolver = defaultVariantColorsResolver.defaultVariantColorsResolver;
exports.getGradient = getGradient.getGradient;
exports.toRgba = toRgba.toRgba;
exports.alpha = rgba.alpha;
exports.rgba = rgba.rgba;
exports.darken = darken.darken;
exports.lighten = lighten.lighten;
exports.isLightColor = luminance.isLightColor;
exports.luminance = luminance.luminance;
exports.getContrastColor = getContrastColor.getContrastColor;
exports.getPrimaryContrastColor = getContrastColor.getPrimaryContrastColor;
exports.getAutoContrastValue = getAutoContrastValue.getAutoContrastValue;
exports.colorsTuple = colorsTuple.colorsTuple;
exports.useMantineColorScheme = useMantineColorScheme.useMantineColorScheme;
exports.useProviderColorScheme = useProviderColorScheme.useProviderColorScheme;
exports.useComputedColorScheme = useComputedColorScheme.useComputedColorScheme;
exports.ColorSchemeScript = ColorSchemeScript.ColorSchemeScript;
exports.DEFAULT_THEME = defaultTheme.DEFAULT_THEME;
exports.mergeMantineTheme = mergeMantineTheme.mergeMantineTheme;
exports.validateMantineTheme = mergeMantineTheme.validateMantineTheme;
exports.HeadlessMantineProvider = MantineProvider.HeadlessMantineProvider;
exports.MantineProvider = MantineProvider.MantineProvider;
exports.MantineContext = Mantine_context.MantineContext;
exports.useMantineClassNamesPrefix = Mantine_context.useMantineClassNamesPrefix;
exports.useMantineContext = Mantine_context.useMantineContext;
exports.useMantineCssVariablesResolver = Mantine_context.useMantineCssVariablesResolver;
exports.useMantineEnv = Mantine_context.useMantineEnv;
exports.useMantineIsHeadless = Mantine_context.useMantineIsHeadless;
exports.useMantineStyleNonce = Mantine_context.useMantineStyleNonce;
exports.useMantineStylesTransform = Mantine_context.useMantineStylesTransform;
exports.useMantineSxTransform = Mantine_context.useMantineSxTransform;
exports.useMantineWithStaticClasses = Mantine_context.useMantineWithStaticClasses;
exports.MantineThemeContext = MantineThemeProvider.MantineThemeContext;
exports.MantineThemeProvider = MantineThemeProvider.MantineThemeProvider;
exports.useMantineTheme = MantineThemeProvider.useMantineTheme;
exports.useSafeMantineTheme = MantineThemeProvider.useSafeMantineTheme;
exports.useProps = useProps.useProps;
exports.convertCssVariables = convertCssVariables.convertCssVariables;
exports.createTheme = createTheme.createTheme;
exports.mergeThemeOverrides = mergeThemeOverrides.mergeThemeOverrides;
exports.defaultCssVariablesResolver = defaultCssVariablesResolver.defaultCssVariablesResolver;
exports.getCSSColorVariables = getCssColorVariables.getCSSColorVariables;
exports.isVirtualColor = virtualColor.isVirtualColor;
exports.virtualColor = virtualColor.virtualColor;
exports.useMatches = useMatches.useMatches;
exports.mantineHtmlProps = mantineHtmlProps.mantineHtmlProps;
exports.InlineStyles = InlineStyles.InlineStyles;
exports.stylesToString = stylesToString.stylesToString;
exports.extractStyleProps = extractStyleProps.extractStyleProps;
exports.STYlE_PROPS_DATA = stylePropsData.STYlE_PROPS_DATA;
exports.parseStyleProps = parseStyleProps.parseStyleProps;
exports.useRandomClassName = useRandomClassname.useRandomClassName;
exports.getStyleObject = getStyleObject.getStyleObject;
exports.Box = Box.Box;
exports.factory = factory.factory;
exports.getWithProps = factory.getWithProps;
exports.polymorphicFactory = polymorphicFactory.polymorphicFactory;
exports.createPolymorphicComponent = createPolymorphicComponent.createPolymorphicComponent;
exports.DirectionContext = DirectionProvider.DirectionContext;
exports.DirectionProvider = DirectionProvider.DirectionProvider;
exports.useDirection = DirectionProvider.useDirection;
exports.Collapse = Collapse.Collapse;
exports.ScrollArea = ScrollArea.ScrollArea;
exports.ScrollAreaAutosize = ScrollArea.ScrollAreaAutosize;
exports.UnstyledButton = UnstyledButton.UnstyledButton;
exports.VisuallyHidden = VisuallyHidden.VisuallyHidden;
exports.Paper = Paper.Paper;
exports.Popover = Popover.Popover;
exports.PopoverDropdown = PopoverDropdown.PopoverDropdown;
exports.PopoverTarget = PopoverTarget.PopoverTarget;
exports.ActionIcon = ActionIcon.ActionIcon;
exports.ActionIconGroup = ActionIconGroup.ActionIconGroup;
exports.ActionIconGroupSection = ActionIconGroupSection.ActionIconGroupSection;
exports.CloseIcon = CloseIcon.CloseIcon;
exports.CloseButton = CloseButton.CloseButton;
exports.Group = Group.Group;
exports.Loader = Loader.Loader;
exports.defaultLoaders = Loader.defaultLoaders;
exports.Overlay = Overlay.Overlay;
exports.ModalBase = ModalBase.ModalBase;
exports.ModalBaseBody = ModalBaseBody.ModalBaseBody;
exports.ModalBaseCloseButton = ModalBaseCloseButton.ModalBaseCloseButton;
exports.ModalBaseContent = ModalBaseContent.ModalBaseContent;
exports.ModalBaseHeader = ModalBaseHeader.ModalBaseHeader;
exports.ModalBaseOverlay = ModalBaseOverlay.ModalBaseOverlay;
exports.ModalBaseTitle = ModalBaseTitle.ModalBaseTitle;
exports.NativeScrollArea = NativeScrollArea.NativeScrollArea;
exports.Input = Input.Input;
exports.InputWrapper = InputWrapper.InputWrapper;
exports.InputDescription = InputDescription.InputDescription;
exports.InputError = InputError.InputError;
exports.InputLabel = InputLabel.InputLabel;
exports.InputPlaceholder = InputPlaceholder.InputPlaceholder;
exports.InputClearButton = InputClearButton.InputClearButton;
exports.useInputProps = useInputProps.useInputProps;
exports.useInputWrapperContext = InputWrapper_context.useInputWrapperContext;
exports.InputBase = InputBase.InputBase;
exports.FLEX_STYLE_PROPS_DATA = flexProps.FLEX_STYLE_PROPS_DATA;
exports.Flex = Flex.Flex;
exports.FloatingIndicator = FloatingIndicator.FloatingIndicator;
exports.Accordion = Accordion.Accordion;
exports.AccordionChevron = AccordionChevron.AccordionChevron;
exports.AccordionItem = AccordionItem.AccordionItem;
exports.AccordionPanel = AccordionPanel.AccordionPanel;
exports.AccordionControl = AccordionControl.AccordionControl;
exports.Affix = Affix.Affix;
exports.Alert = Alert.Alert;
exports.Anchor = Anchor.Anchor;
exports.AngleSlider = AngleSlider.AngleSlider;
exports.AppShell = AppShell.AppShell;
exports.AppShellAside = AppShellAside.AppShellAside;
exports.AppShellFooter = AppShellFooter.AppShellFooter;
exports.AppShellHeader = AppShellHeader.AppShellHeader;
exports.AppShellNavbar = AppShellNavbar.AppShellNavbar;
exports.AppShellSection = AppShellSection.AppShellSection;
exports.AppShellMain = AppShellMain.AppShellMain;
exports.AspectRatio = AspectRatio.AspectRatio;
exports.Autocomplete = Autocomplete.Autocomplete;
exports.Avatar = Avatar.Avatar;
exports.AvatarGroup = AvatarGroup.AvatarGroup;
exports.BackgroundImage = BackgroundImage.BackgroundImage;
exports.Badge = Badge.Badge;
exports.Blockquote = Blockquote.Blockquote;
exports.Breadcrumbs = Breadcrumbs.Breadcrumbs;
exports.Burger = Burger.Burger;
exports.Button = Button.Button;
exports.ButtonGroup = ButtonGroup.ButtonGroup;
exports.ButtonGroupSection = ButtonGroupSection.ButtonGroupSection;
exports.Card = Card.Card;
exports.CardSection = CardSection.CardSection;
exports.Center = Center.Center;
exports.Checkbox = Checkbox.Checkbox;
exports.CheckboxGroup = CheckboxGroup.CheckboxGroup;
exports.CheckIcon = CheckIcon.CheckIcon;
exports.CheckboxIndicator = CheckboxIndicator.CheckboxIndicator;
exports.CheckboxCard = CheckboxCard.CheckboxCard;
exports.useCheckboxCardContext = CheckboxCard_context.useCheckboxCardContext;
exports.useCheckboxGroupContext = CheckboxGroup_context.useCheckboxGroupContext;
exports.Chip = Chip.Chip;
exports.ChipGroup = ChipGroup.ChipGroup;
exports.Code = Code.Code;
exports.ColorPicker = ColorPicker.ColorPicker;
exports.AlphaSlider = AlphaSlider.AlphaSlider;
exports.HueSlider = HueSlider.HueSlider;
exports.convertHsvaTo = converters.convertHsvaTo;
exports.isColorValid = parsers.isColorValid;
exports.parseColor = parsers.parseColor;
exports.ColorInput = ColorInput.ColorInput;
exports.ColorSwatch = ColorSwatch.ColorSwatch;
exports.getParsedComboboxData = getParsedComboboxData.getParsedComboboxData;
exports.getLabelsLockup = getOptionsLockup.getLabelsLockup;
exports.getOptionsLockup = getOptionsLockup.getOptionsLockup;
exports.ComboboxChevron = ComboboxChevron.ComboboxChevron;
exports.Combobox = Combobox.Combobox;
exports.ComboboxDropdown = ComboboxDropdown.ComboboxDropdown;
exports.ComboboxOptions = ComboboxOptions.ComboboxOptions;
exports.ComboboxOption = ComboboxOption.ComboboxOption;
exports.ComboboxTarget = ComboboxTarget.ComboboxTarget;
exports.ComboboxSearch = ComboboxSearch.ComboboxSearch;
exports.ComboboxEmpty = ComboboxEmpty.ComboboxEmpty;
exports.ComboboxFooter = ComboboxFooter.ComboboxFooter;
exports.ComboboxHeader = ComboboxHeader.ComboboxHeader;
exports.ComboboxEventsTarget = ComboboxEventsTarget.ComboboxEventsTarget;
exports.ComboboxDropdownTarget = ComboboxDropdownTarget.ComboboxDropdownTarget;
exports.ComboboxGroup = ComboboxGroup.ComboboxGroup;
exports.ComboboxClearButton = ComboboxClearButton.ComboboxClearButton;
exports.ComboboxHiddenInput = ComboboxHiddenInput.ComboboxHiddenInput;
exports.OptionsDropdown = OptionsDropdown.OptionsDropdown;
exports.useCombobox = useCombobox.useCombobox;
exports.useVirtualizedCombobox = useVirtualizedCombobox.useVirtualizedCombobox;
exports.useComboboxTargetProps = useComboboxTargetProps.useComboboxTargetProps;
exports.isOptionsGroup = isOptionsGroup.isOptionsGroup;
exports.defaultOptionsFilter = defaultOptionsFilter.defaultOptionsFilter;
exports.Container = Container.Container;
exports.CopyButton = CopyButton.CopyButton;
exports.Dialog = Dialog.Dialog;
exports.Divider = Divider.Divider;
exports.Drawer = Drawer.Drawer;
exports.DrawerRoot = DrawerRoot.DrawerRoot;
exports.DrawerBody = DrawerBody.DrawerBody;
exports.DrawerCloseButton = DrawerCloseButton.DrawerCloseButton;
exports.DrawerContent = DrawerContent.DrawerContent;
exports.DrawerHeader = DrawerHeader.DrawerHeader;
exports.DrawerOverlay = DrawerOverlay.DrawerOverlay;
exports.DrawerTitle = DrawerTitle.DrawerTitle;
exports.DrawerStack = DrawerStack.DrawerStack;
exports.useDrawerStackContext = DrawerStack.useDrawerStackContext;
exports.Fieldset = Fieldset.Fieldset;
exports.FileButton = FileButton.FileButton;
exports.FileInput = FileInput.FileInput;
exports.useDelayedHover = useDelayedHover.useDelayedHover;
exports.useFloatingAutoUpdate = useFloatingAutoUpdate.useFloatingAutoUpdate;
exports.getFloatingPosition = getFloatingPosition.getFloatingPosition;
exports.FloatingArrow = FloatingArrow.FloatingArrow;
exports.FocusTrap = FocusTrap.FocusTrap;
exports.FocusTrapInitialFocus = FocusTrap.FocusTrapInitialFocus;
exports.Grid = Grid.Grid;
exports.GridCol = GridCol.GridCol;
exports.Highlight = Highlight.Highlight;
exports.HoverCard = HoverCard.HoverCard;
exports.HoverCardDropdown = HoverCardDropdown.HoverCardDropdown;
exports.HoverCardTarget = HoverCardTarget.HoverCardTarget;
exports.Image = Image.Image;
exports.Indicator = Indicator.Indicator;
exports.JsonInput = JsonInput.JsonInput;
exports.Kbd = Kbd.Kbd;
exports.List = List.List;
exports.ListItem = ListItem.ListItem;
exports.LoadingOverlay = LoadingOverlay.LoadingOverlay;
exports.Mark = Mark.Mark;
exports.Menu = Menu.Menu;
exports.MenuDivider = MenuDivider.MenuDivider;
exports.MenuItem = MenuItem.MenuItem;
exports.MenuLabel = MenuLabel.MenuLabel;
exports.MenuDropdown = MenuDropdown.MenuDropdown;
exports.MenuTarget = MenuTarget.MenuTarget;
exports.Modal = Modal.Modal;
exports.ModalRoot = ModalRoot.ModalRoot;
exports.ModalBody = ModalBody.ModalBody;
exports.ModalCloseButton = ModalCloseButton.ModalCloseButton;
exports.ModalContent = ModalContent.ModalContent;
exports.ModalHeader = ModalHeader.ModalHeader;
exports.ModalOverlay = ModalOverlay.ModalOverlay;
exports.ModalTitle = ModalTitle.ModalTitle;
exports.ModalStack = ModalStack.ModalStack;
exports.useModalStackContext = ModalStack.useModalStackContext;
exports.useDrawersStack = useModalsStack.useDrawersStack;
exports.useModalsStack = useModalsStack.useModalsStack;
exports.MultiSelect = MultiSelect.MultiSelect;
exports.NativeSelect = NativeSelect.NativeSelect;
exports.NavLink = NavLink.NavLink;
exports.Notification = Notification.Notification;
exports.NumberFormatter = NumberFormatter.NumberFormatter;
exports.NumberInput = NumberInput.NumberInput;
exports.Pagination = Pagination.Pagination;
exports.PaginationControl = PaginationControl.PaginationControl;
exports.PaginationDots = PaginationDots.PaginationDots;
exports.PaginationFirst = PaginationEdges.PaginationFirst;
exports.PaginationLast = PaginationEdges.PaginationLast;
exports.PaginationNext = PaginationEdges.PaginationNext;
exports.PaginationPrevious = PaginationEdges.PaginationPrevious;
exports.PaginationItems = PaginationItems.PaginationItems;
exports.PaginationRoot = PaginationRoot.PaginationRoot;
exports.PasswordInput = PasswordInput.PasswordInput;
exports.Pill = Pill.Pill;
exports.PillGroup = PillGroup.PillGroup;
exports.PillsInput = PillsInput.PillsInput;
exports.PillsInputField = PillsInputField.PillsInputField;
exports.PinInput = PinInput.PinInput;
exports.Portal = Portal.Portal;
exports.OptionalPortal = OptionalPortal.OptionalPortal;
exports.Progress = Progress.Progress;
exports.ProgressLabel = ProgressLabel.ProgressLabel;
exports.ProgressRoot = ProgressRoot.ProgressRoot;
exports.ProgressSection = ProgressSection.ProgressSection;
exports.Radio = Radio.Radio;
exports.RadioGroup = RadioGroup.RadioGroup;
exports.RadioIcon = RadioIcon.RadioIcon;
exports.RadioCard = RadioCard.RadioCard;
exports.useRadioCardContext = RadioCard_context.useRadioCardContext;
exports.RadioIndicator = RadioIndicator.RadioIndicator;
exports.Rating = Rating.Rating;
exports.RingProgress = RingProgress.RingProgress;
exports.SegmentedControl = SegmentedControl.SegmentedControl;
exports.Select = Select.Select;
exports.SemiCircleProgress = SemiCircleProgress.SemiCircleProgress;
exports.SimpleGrid = SimpleGrid.SimpleGrid;
exports.Skeleton = Skeleton.Skeleton;
exports.Slider = Slider.Slider;
exports.RangeSlider = RangeSlider.RangeSlider;
exports.Space = Space.Space;
exports.Spoiler = Spoiler.Spoiler;
exports.Stack = Stack.Stack;
exports.Stepper = Stepper.Stepper;
exports.StepperStep = StepperStep.StepperStep;
exports.StepperCompleted = StepperCompleted.StepperCompleted;
exports.Switch = Switch.Switch;
exports.SwitchGroup = SwitchGroup.SwitchGroup;
exports.Table = Table.Table;
exports.TableCaption = Table_components.TableCaption;
exports.TableTbody = Table_components.TableTbody;
exports.TableTd = Table_components.TableTd;
exports.TableTfoot = Table_components.TableTfoot;
exports.TableTh = Table_components.TableTh;
exports.TableThead = Table_components.TableThead;
exports.TableTr = Table_components.TableTr;
exports.TableScrollContainer = TableScrollContainer.TableScrollContainer;
exports.TableOfContents = TableOfContents.TableOfContents;
exports.Tabs = Tabs.Tabs;
exports.TabsList = TabsList.TabsList;
exports.TabsTab = TabsTab.TabsTab;
exports.TabsPanel = TabsPanel.TabsPanel;
exports.TagsInput = TagsInput.TagsInput;
exports.Text = Text.Text;
exports.Textarea = Textarea.Textarea;
exports.TextInput = TextInput.TextInput;
exports.ThemeIcon = ThemeIcon.ThemeIcon;
exports.Timeline = Timeline.Timeline;
exports.TimelineItem = TimelineItem.TimelineItem;
exports.Title = Title.Title;
exports.Tooltip = Tooltip.Tooltip;
exports.TooltipGroup = TooltipGroup.TooltipGroup;
exports.TooltipFloating = TooltipFloating.TooltipFloating;
exports.MANTINE_TRANSITIONS = transitions.transitions;
exports.Transition = Transition.Transition;
exports.getTransitionProps = getTransitionProps.getTransitionProps;
exports.Tree = Tree.Tree;
exports.getTreeExpandedState = useTree.getTreeExpandedState;
exports.useTree = useTree.useTree;
exports.TypographyStylesProvider = TypographyStylesProvider.TypographyStylesProvider; //# sourceMappingURL=index.cjs.map

},{"d74bb5bc9a85aac1":"2ufGf","7b254950b9d254cc":"kvYzO","1e331ec65be3c231":"aXRyU","ea715a757b99b401":"57PxO","c25f48167623a47c":"dXm4f","aa3f1ee1629b2602":"ebAaL","d9d07573261a0799":"2Jst9","f3f5ede1739995f3":"6knSJ","a60357884690482f":"193o0","bab650a68f94ea27":"8srze","6798fe3554ea6fa1":"7cMAR","d4c6630e633e9a0f":"dvoq6","b676f1651d308404":"5jFxz","110a6013d18cab16":"cC16z","29c19aa94c30e22c":"4gavl","f23e8030781321fd":"aOjoS","2ad1348077c4e3":"2dVWr","5f70873e029f33b9":"kEFEY","8612e35eb078526c":"9qSGJ","5441632baee1b67b":"fjWYA","623fb1f62d443062":"lwwF0","772207fe81ba72b2":"4aQII","3242dafacfcad102":"b3zfW","ffcc5facc241d99d":"79GsF","8979423dc1b94599":"c06go","e29c89e0a20badbb":"dcxYe","f0d4691202fda8fe":"6dk3K","fb70dfc37a7d946f":"2EcxD","3648d2ae9ea4658":"e829F","8b10d29c2697e4c2":"hIQE6","51d6a9cd4241b2eb":"kjN8X","21a26b6edc0b372a":"2cTj2","4f2a58fe797651a9":"d30sL","514a9116dd8ea7b5":"iKrc2","2a5304a047c3c096":"d0sAY","ad976ae0e957c651":"gu5h1","b170f06c512ab2b8":"bOcAc","818a357df313fbc2":"fKUzT","2972d38cf1554d27":"ctp80","5fae84dc9e11c32f":"eeaIN","7fe450bfad711223":"gQVTf","beb58bfbdf03d225":"cx5bg","ffc340219aaa849a":"8dGkg","e97a79df6b133882":"aIray","b70b19de704a5c0e":"ibGxK","c865dc68009ce470":"cEHAd","bb6fe25b0e75757f":"dBjYG","8684e08b8c7f0809":"ez6cW","ebea444811f7c282":"cN4dA","1d89631227cbb7e1":"0wiSU","8b44922bf706de3d":"7Rjy0","542313c2bde7fe1":"4Xpxx","b6b4ec3f4b082c52":"htFAa","403d1aa3ed101d0a":"2aQv3","f040488ad8e778d1":"6AMGA","2d1481c0961043e3":"dyWMV","8d10f3554ef75610":"erSvz","3a827cf5e2cde4b8":"2FdJg","5c11eeb95cd8a72":"kqQOF","67b2cfd982a9ec4c":"iivvn","d8d5b82e0aba39e8":"lg3xs","72c87ef5e974569e":"hKxwc","55b065956fcaada6":"7RbQQ","e3a04bd4e2e8b623":"axjje","77c0b7933b34f5c5":"8YP4O","b7207fb74c61116e":"kGiQC","a80bbd21e5eedd93":"6TI0O","dc21c2fa1615a927":"ipE8t","c4b7396eceac19b6":"7FWcz","49f3a36eebd4f5a7":"3CHN8","453f579b633dc5e":"OgGrn","238aa1de7943e973":"6L93n","d390a13a6da49601":"4seZw","dd11ee38dc11373a":"6Bevs","9ca1a68ba926e3fc":"2rhHN","76b4676ee9765a19":"bvL2d","940bbd0357ea0f17":"gkGXc","1e0cfa3f3c33e973":"guLFz","d7a08be9f63f9f48":"iYAEL","7c7d897f98a15fea":"ifmiy","30ce75ade59c2d70":"2onWA","e39ff5aae0fd6df3":"eaAXD","fc8f10b3036d83c2":"ctZfT","6d090f58ad94397e":"cArqr","b465d57df88b85e3":"eOPpk","a9e2081d7a04c0fa":"amEW4","164e2ffc7647ea71":"4oc3k","cec00ce2dfcd821c":"b7S6t","abf097e0b0ef6cf1":"iz4SD","53bae168e191f2db":"9tz8j","21ab77df8639af89":"hLZtr","7dd567863320e2cb":"5bt1k","aad179558a569c03":"h6AYi","650143e999baf2da":"4ZuRG","8ca31fde80104d2d":"iEuvx","38c68c8dfff47e11":"hxcgl","9c47a8c5bff9b1b7":"9e5lu","ef5aea8dc375ce26":"PGvLq","eb686ba3de37ddb6":"8i8nh","ec0d86a06d693734":"ifiLz","c2628a601f57c224":"8qmr0","5b6e1f1d2ec13141":"fsdDM","636915bf7a94c06c":"fj3f7","2d0eacb777133ad":"5DnfR","a700b18772475632":"d55zN","348f1bc0c63d0bbb":"dkUgf","1371b0f53a735639":"j4uTK","3f3116dbb8d0c123":"7nO1x","32df5518b4b01d29":"3Bda4","c79c217309d22e82":"gQBOr","792cf076a4219745":"lRBdM","1a969d70ab0080b0":"hxtex","9e85cfe1d64f0b9c":"4OEkb","8baee7339341a877":"lQt5D","fbbbbd67daf49521":"jbA6w","c217a80f07b6174f":"5SlCU","1537aa53754a973c":"lRoV6","fb2a87fdfe606ca4":"kzplm","c80ae3b62928c168":"lMDPy","c4be96c7ad3ab460":"01exi","2b33791cc465ab31":"ewd1d","f5c95d850e591645":"6psP4","a3cfcdf3dbc0c612":"HYAZd","fd62470cc9790b60":"fZ73h","4284b31501bc8080":"luRvr","caa85cf0529a2f42":"acy77","314b0ec896ee168d":"dG7Dv","ab9c918abd776e2f":"gqxo3","37ed88297a5a9dda":"4Xhux","fa5cc1a760290399":"gWmhx","5ff750d6c9f0381f":"9L3ZV","7d84de56e9a71b82":"l3VpA","b39a5d55da116db3":"2nCsm","9708fc66caa9b165":"6ncqX","31a24caf647ffef3":"i8srR","910a206a6348bbd7":"HYJQq","1baa7087c64fb70c":"3yuDB","b7aaf4823336ca17":"1Mx4G","67d060e5ac970568":"ltl7Q","c2e1f0d9c2a52313":"iIBj2","3c7fd6b4609f6538":"woUye","6d4b49952ff927dc":"birrb","4c1941ebb6ca59d6":"iYU71","566a253e5cf92c47":"jW2gs","2b26f38606b9047c":"3CofV","4d64cc35308c00c0":"cppYV","4b49e86b60232f16":"lTXKB","2544f5eab1aa93e2":"fDPNb","645fdbfe1535010c":"iqIUR","166653f339ce6bcd":"ey93w","4a554ddcbb672db9":"01RS9","d73925c78656a2b6":"fysam","7dd03985033a653d":"ahwnY","3bf7ba3c13521364":"jBkf8","9d833c5fac2acb16":"jQ0Qw","1c5440f5f324a9dc":"1sCYn","5f8be18f94b5174f":"4CZwL","c070e00941014d60":"jl1qd","934127a5d4f85e12":"9ofTH","9fe4367c193d70e4":"7R7jd","5b8e8ed496bc6c30":"jcxTp","692f8d5eeb633628":"ijPsx","302be0ee6146c21f":"7kml4","97490a63e62cdeab":"6uVVj","dafc695117901d6a":"dhpny","ea2c5efdace20377":"kA5X0","6a422477baf33cb3":"71QDZ","c848c9d2c9565086":"jSlFr","c68d4fd529f3d6d6":"6nIYy","6a352d793ee1a3a5":"d1kVk","de91e12855700672":"4ROIf","602bbb35f49b249e":"alBok","35845ea3449ac7e8":"h5QT5","7f882847bc7cfb54":"8rZez","451ad6cf1211dea9":"74J2w","efc42b26efa16503":"iyoTe","ce0b40ea220d3af6":"3ZaWl","f73af4e667be4636":"9a8Lj","b0a5c643c1f1ed6a":"8omXP","f54565415512c284":"ceCGy","a279428f30471606":"1dzCw","a3a447cdd47f62ce":"4Z9pV","3d1d1a0d99ee4ea8":"8RMJf","8d4718a23b7cc6a4":"17zEV","df0b30f574900091":"W6tOq","81cd23a430ce6fda":"hvsg5","9bd9c78d78fe886e":"9tqgj","4d13fb15d739a97b":"2yhqd","ddae22c171fb53bf":"a1fPD","5bd75d84233bb149":"22BxA","21bde815d04f9d00":"aCHLX","c26af61f3b246333":"gDzef","8e5a968d2d719706":"bOQ6D","bd85d028da5e71de":"h20rI","550d8e2008876f4a":"lAkdZ","b4328ed02dfbf4a8":"jyfp0","2158525718737d0a":"ETHac","13d6db6cc483b575":"8gNzB","800f93ece6c22719":"8IHOY","b32270d92d0886b7":"9A9ix","fbe946856692171e":"1oTM5","455383411dc283c7":"ey4tq","1f16bdfd1ac2a0f6":"3WPU8","6de3f4193df10813":"eTxzQ","bc4a23d52fa97a5b":"ti1Nx","34db9316e52043be":"hFhuj","12334423b540e56f":"j8BHA","2631b2ee368d7255":"1B14J","8363c6eca9e33177":"kAWqL","490f530d1d71b38d":"keIAJ","e2180d8f329081ff":"a96NW","96f50251817bb6b":"aGhvE","3de0da9051f35a8d":"bbQP4","8a1d5b89825606c1":"drTJJ","b10110fc12f26c16":"el2IJ","bba45314afe9ff95":"a0Lst","132b405a15690185":"iD8oQ","976c3214db845324":"hJiXo","ac455c6bc6e123d0":"4uFWe","4e9bfadc10dbca37":"k1dMl","ef81c6c241d979":"9l0W5","555dc3eca36d0c6d":"57MG8","84a7ab05b18baf2a":"dL8fN","91f46d0c33960810":"9o1Kf","13f1315d3fcbd1d":"6M4sH","6287f91be122d570":"bgnKj","aef27e88747ec9aa":"hKwNX","40947de7f7c020a9":"lSTOB","2039090f01ecbfa8":"c7g7f","fbe5c0c3ecc6ba89":"djjcQ","5a8c544bc01bb027":"4ez60","a65f4b31246073e2":"6AcuU","81488d4cfb299ea2":"9FnFM","421108b307669fc3":"a3Vb1","f99b1d0ed1e8b303":"ioorp","f7dd0c530c9155b9":"c7QR6","fd8eab6a7404288c":"1kFS2","c1804914ac005da6":"8Cbau","df5fd175e0e89baa":"csVD5","1e441fe9a3c6880d":"1NR44","c0bbe12b7238ecfb":"gXL0L","488d01daa740ac25":"h6MVW","4772b46f61ce7c69":"lTdE7","4f109eb1c46a78d3":"4d1Xl","cbfc4d535b3a357e":"eGI6W","b5f9a8447f74cf53":"jkJAc","8f68c8738939df5b":"cA6JI","4eabc826578775c8":"2ChBF","4ca68d2f44923468":"lziOM","ebaab3dbf38f7ed":"5KiRn","c7c27d0de8f22651":"kPyys","469002692db9cfb9":"jZi48","79e0cdb6e78490de":"gZ7hp","ccc5c7b716946db5":"liYbF","6f0fe7b24a3f32f":"gMUmS","1fb0cbd7b2069766":"2ObFu","13988138ff75ecbd":"5QihN","1876846a79c20c08":"h9XOU","ea00fa5d4a1b91a0":"6YZdR","b1f319d1415df98":"3Y9Li","459a72ac2e6e1ca7":"cKKzS","a0605e66d802ce30":"jGGoF","d7bc053fff304fa":"aVLPV","82d15c6e16f54d91":"biD1g","23a2702d33fb1d76":"kpDwF","2add3621c269c744":"8Awvq","3e41a0de3a2cf845":"bnRAI","fea03f92a95bc9a":"kiVsz","ef65386218e20bde":"9CAYv","e51b49e9193c22f":"27y4h","1b8fa0142c355a89":"jdz2m","cf1d84abfc32072a":"1g8WP","dc152ba4354d733e":"bnWlC","2f2ec480405dd79b":"lyqpE","4bf95e9d625217d2":"eoj6F","c8aa26c248d1d449":"3XvO6","176e5dcf2ef02ee0":"4wrzI","8bebf51c7e83fe6e":"hzFg0","c6356c4921cdb10d":"jqz04","c0d686f12d0d7aea":"9fiZu","d0084e91b0d5e886":"fqNDH","be406a659df3db4e":"ablEp","c42acd6decb22ee8":"ak1g1","f8b04f6f0fa065be":"htG7v","e10f371a419a9e40":"dShc2","5bb9e250a1cda07d":"bEK92","47d8039a54ac9646":"8tdZI","f505cc1d3496e4f6":"2O5iK","896769b7017048b9":"5HgeT","64403d17ee4531e9":"lk5Ln","ef4c0f617a8254bc":"80381","bb1bbc27d508f31f":"416JA","9d0120249be0378b":"7yyfs","261cebc315623dbd":"cFpnp","cf51a1fb505ca210":"ckWt9","63b0063f98adf14a":"4oBME","75a596c1f451a436":"gXc4D","75a357b538d5d4aa":"02LRX","4fe4f650e45d4c32":"1rijw","2d51618b298b88c3":"aC1AO","cb1fb8a92dc91041":"gPp7R","84e47fe58072ca6e":"iWvPF","95749ddb595512aa":"6s3RB","cb34e3e205cab7b8":"bSefP","457c92b98eb2f359":"dymYJ","41192d28e8d96bb5":"ebd04","4f5f6822472244c2":"fgD9I","24ea2d2e578ea862":"2T0Xr","41533386d18ec4fc":"byBew","47e975a27efc72ee":"58qz2","5e3bed6de2b7b7a6":"9eQXa","fe71d634fe14a0cc":"j6JlX"}],"2ufGf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScroll", function() {
    return 0, _combinationDefault.default;
});
var _combination = require("./Combination");
var _combinationDefault = parcelHelpers.interopDefault(_combination);

},{"./Combination":"29bYH","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"29bYH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _ui = require("./UI");
var _sidecar = require("./sidecar");
var _sidecarDefault = parcelHelpers.interopDefault(_sidecar);
var ReactRemoveScroll = _react.forwardRef(function(props, ref) {
    return _react.createElement((0, _ui.RemoveScroll), (0, _tslib.__assign)({}, props, {
        ref: ref,
        sideCar: (0, _sidecarDefault.default)
    }));
});
ReactRemoveScroll.classNames = (0, _ui.RemoveScroll).classNames;
exports.default = ReactRemoveScroll;

},{"tslib":"fPQ7a","react":"9MtAM","./UI":"99LGv","./sidecar":"8e3Mj","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"99LGv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScroll", function() {
    return RemoveScroll;
});
var _tslib = require("tslib");
var _react = require("react");
var _constants = require("react-remove-scroll-bar/constants");
var _useCallbackRef = require("use-callback-ref");
var _medium = require("./medium");
var nothing = function nothing() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var RemoveScroll = _react.forwardRef(function(props, parentRef) {
    var ref = _react.useRef(null);
    var _a = _react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, _tslib.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, _useCallbackRef.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), callbacks);
    return _react.createElement(_react.Fragment, null, enabled && _react.createElement(SideCar, {
        sideCar: (0, _medium.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? _react.cloneElement(_react.Children.only(children), (0, _tslib.__assign)((0, _tslib.__assign)({}, containerProps), {
        ref: containerRef
    })) : _react.createElement(Container, (0, _tslib.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
RemoveScroll.classNames = {
    fullWidth: (0, _constants.fullWidthClassName),
    zeroRight: (0, _constants.zeroRightClassName)
};

},{"tslib":"fPQ7a","react":"9MtAM","react-remove-scroll-bar/constants":"lpjhX","use-callback-ref":"c2BdV","./medium":"i2xya","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"lpjhX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroRightClassName", function() {
    return zeroRightClassName;
});
parcelHelpers.export(exports, "fullWidthClassName", function() {
    return fullWidthClassName;
});
parcelHelpers.export(exports, "noScrollbarsClassName", function() {
    return noScrollbarsClassName;
});
parcelHelpers.export(exports, "removedBarSizeVariable", function() {
    return removedBarSizeVariable;
});
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"c2BdV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", function() {
    return 0, _assignRef.assignRef;
});
// callback ref
parcelHelpers.export(exports, "useCallbackRef", function() {
    return 0, _useRef.useCallbackRef;
});
parcelHelpers.export(exports, "createCallbackRef", function() {
    return 0, _createRef.createCallbackRef;
});
// merge ref
parcelHelpers.export(exports, "mergeRefs", function() {
    return 0, _mergeRef.mergeRefs;
});
parcelHelpers.export(exports, "useMergeRefs", function() {
    return 0, _useMergeRef.useMergeRefs;
});
// transform ref
parcelHelpers.export(exports, "useTransformRef", function() {
    return 0, _useTransformRef.useTransformRef;
});
parcelHelpers.export(exports, "transformRef", function() {
    return 0, _transformRef.transformRef;
});
// refToCallback
parcelHelpers.export(exports, "refToCallback", function() {
    return 0, _refToCallback.refToCallback;
});
parcelHelpers.export(exports, "useRefToCallback", function() {
    return 0, _refToCallback.useRefToCallback;
});
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var _createRef = require("./createRef");
var _mergeRef = require("./mergeRef");
var _useMergeRef = require("./useMergeRef");
var _useTransformRef = require("./useTransformRef");
var _transformRef = require("./transformRef");
var _refToCallback = require("./refToCallback");

},{"./assignRef":false,"./useRef":false,"./createRef":false,"./mergeRef":false,"./useMergeRef":"6Vina","./useTransformRef":false,"./transformRef":false,"./refToCallback":false,"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"fep78":[function(require,module,exports) {
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", function() {
    return assignRef;
});
function assignRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"gK19m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */ parcelHelpers.export(exports, "useCallbackRef", function() {
    return useCallbackRef;
});
var _react = require("react");
function useCallbackRef(initialValue, callback) {
    var ref = (0, _react.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

},{"react":"9MtAM","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"6Vina":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ parcelHelpers.export(exports, "useMergeRefs", function() {
    return useMergeRefs;
});
var _react = require("react");
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? _react.useLayoutEffect : _react.useEffect;
var currentValues = new WeakMap();
function useMergeRefs(refs, defaultValue) {
    var callbackRef = (0, _useRef.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, _assignRef.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function() {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, current_1);
            });
        }
        currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

},{"react":"9MtAM","./assignRef":"fep78","./useRef":"gK19m","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"i2xya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "effectCar", function() {
    return effectCar;
});
var _useSidecar = require("use-sidecar");
var effectCar = (0, _useSidecar.createSidecarMedium)();

},{"use-sidecar":"48O2I","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"48O2I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sidecar", function() {
    return 0, _hoc.sidecar;
});
parcelHelpers.export(exports, "useSidecar", function() {
    return 0, _hook.useSidecar;
});
parcelHelpers.export(exports, "setConfig", function() {
    return 0, _config.setConfig;
});
parcelHelpers.export(exports, "createMedium", function() {
    return 0, _medium.createMedium;
});
parcelHelpers.export(exports, "createSidecarMedium", function() {
    return 0, _medium.createSidecarMedium;
});
parcelHelpers.export(exports, "renderCar", function() {
    return 0, _renderProp.renderCar;
});
parcelHelpers.export(exports, "exportSidecar", function() {
    return 0, _exports.exportSidecar;
});
var _hoc = require("./hoc");
var _hook = require("./hook");
var _config = require("./config");
var _medium = require("./medium");
var _renderProp = require("./renderProp");
var _exports = require("./exports");

},{"./hoc":false,"./hook":false,"./config":false,"./medium":"6NmWK","./renderProp":false,"./exports":"7ypPt","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"6NmWK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMedium", function() {
    return createMedium;
});
// eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "createSidecarMedium", function() {
    return createSidecarMedium;
});
var _tslib = require("tslib");
function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function read() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function useMedium(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function assignSyncMedium(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function push(x) {
                    return cb(x);
                },
                filter: function filter() {
                    return buffer;
                }
            };
        },
        assignMedium: function assignMedium(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function executeQueue() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function cycle() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function push(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function filter(_filter) {
                    pendingQueue = pendingQueue.filter(_filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) options = {};
    var medium = innerCreateMedium(null);
    medium.options = (0, _tslib.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

},{"tslib":"fPQ7a","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"7ypPt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportSidecar", function() {
    return exportSidecar;
});
var _tslib = require("tslib");
var _react = require("react");
var SideCar = function SideCar(_a) {
    var sideCar = _a.sideCar, rest = (0, _tslib.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return _react.createElement(Target, (0, _tslib.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

},{"tslib":"fPQ7a","react":"9MtAM","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"8e3Mj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useSidecar = require("use-sidecar");
var _sideEffect = require("./SideEffect");
var _medium = require("./medium");
exports.default = (0, _useSidecar.exportSidecar)((0, _medium.effectCar), (0, _sideEffect.RemoveScrollSideCar));

},{"use-sidecar":"48O2I","./SideEffect":"2AjWL","./medium":"i2xya","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"2AjWL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTouchXY", function() {
    return getTouchXY;
});
parcelHelpers.export(exports, "getDeltaXY", function() {
    return getDeltaXY;
});
parcelHelpers.export(exports, "RemoveScrollSideCar", function() {
    return RemoveScrollSideCar;
});
var _tslib = require("tslib");
var _react = require("react");
var _reactRemoveScrollBar = require("react-remove-scroll-bar");
var _reactStyleSingleton = require("react-style-singleton");
var _aggresiveCapture = require("./aggresiveCapture");
var _handleScroll = require("./handleScroll");
var getTouchXY = function getTouchXY(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var getDeltaXY = function getDeltaXY(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function deltaCompare(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function generateStyle(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = _react.useRef([]);
    var touchStartRef = _react.useRef([
        0,
        0
    ]);
    var activeAxis = _react.useRef();
    var id = _react.useState(idCounter++)[0];
    var Style = _react.useState((0, _reactStyleSingleton.styleSingleton))[0];
    var lastProps = _react.useRef(props);
    _react.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    _react.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, _tslib.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = _react.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, _handleScroll.handleScroll)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = _react.useCallback(function(_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = _react.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = _react.useCallback(function(event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = _react.useCallback(function(event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = _react.useCallback(function(event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    _react.useEffect(function() {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener("touchmove", shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener("touchstart", scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        return function() {
            lockStack = lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener("touchmove", shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener("touchstart", scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return _react.createElement(_react.Fragment, null, inert ? _react.createElement(Style, {
        styles: generateStyle(id)
    }) : null, removeScrollBar ? _react.createElement((0, _reactRemoveScrollBar.RemoveScrollBar), {
        gapMode: props.gapMode
    }) : null);
}
function getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

},{"tslib":"fPQ7a","react":"9MtAM","react-remove-scroll-bar":"ko3B2","react-style-singleton":"bwKMS","./aggresiveCapture":"3tgxj","./handleScroll":"bpQGL","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"ko3B2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScrollBar", function() {
    return 0, _component.RemoveScrollBar;
});
parcelHelpers.export(exports, "zeroRightClassName", function() {
    return 0, _constants.zeroRightClassName;
});
parcelHelpers.export(exports, "fullWidthClassName", function() {
    return 0, _constants.fullWidthClassName;
});
parcelHelpers.export(exports, "noScrollbarsClassName", function() {
    return 0, _constants.noScrollbarsClassName;
});
parcelHelpers.export(exports, "removedBarSizeVariable", function() {
    return 0, _constants.removedBarSizeVariable;
});
parcelHelpers.export(exports, "getGapWidth", function() {
    return 0, _utils.getGapWidth;
});
var _component = require("./component");
var _constants = require("./constants");
var _utils = require("./utils");

},{"./component":"bWGxI","./constants":"lpjhX","./utils":"jiBhL","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"bWGxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lockAttribute", function() {
    return lockAttribute;
});
parcelHelpers.export(exports, "useLockAttribute", function() {
    return useLockAttribute;
});
parcelHelpers.export(exports, "RemoveScrollBar", function() {
    return RemoveScrollBar;
});
var _react = require("react");
var _reactStyleSingleton = require("react-style-singleton");
var _constants = require("./constants");
var _utils = require("./utils");
var Style = (0, _reactStyleSingleton.styleSingleton)();
var lockAttribute = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function getStyles(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, _constants.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " .").concat((0, _constants.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat((0, _constants.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function getCurrentUseCounter() {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function useLockAttribute() {
    _react.useEffect(function() {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute(lockAttribute);
            else document.body.setAttribute(lockAttribute, newCounter.toString());
        };
    }, []);
};
var RemoveScrollBar = function RemoveScrollBar(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = _react.useMemo(function() {
        return (0, _utils.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return _react.createElement(Style, {
        styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};

},{"react":"9MtAM","react-style-singleton":"bwKMS","./constants":"lpjhX","./utils":"jiBhL","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"bwKMS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", function() {
    return 0, _component.styleSingleton;
});
parcelHelpers.export(exports, "stylesheetSingleton", function() {
    return 0, _singleton.stylesheetSingleton;
});
parcelHelpers.export(exports, "styleHookSingleton", function() {
    return 0, _hook.styleHookSingleton;
});
var _component = require("./component");
var _singleton = require("./singleton");
var _hook = require("./hook");

},{"./component":"h5vcD","./singleton":"eWRzJ","./hook":"jj7eZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"h5vcD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", function() {
    return styleSingleton;
});
var _hook = require("./hook");
var styleSingleton = function styleSingleton() {
    var useStyle = (0, _hook.styleHookSingleton)();
    var Sheet = function Sheet(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

},{"./hook":"jj7eZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"jj7eZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleHookSingleton", function() {
    return styleHookSingleton;
});
var _react = require("react");
var _singleton = require("./singleton");
var styleHookSingleton = function styleHookSingleton() {
    var sheet = (0, _singleton.stylesheetSingleton)();
    return function(styles, isDynamic) {
        _react.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

},{"react":"9MtAM","./singleton":"eWRzJ","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"eWRzJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stylesheetSingleton", function() {
    return stylesheetSingleton;
});
var _getNonce = require("get-nonce");
function makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, _getNonce.getNonce)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function stylesheetSingleton() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function add(style) {
            if (counter == 0) {
                if (stylesheet = makeStyleTag()) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function remove() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

},{"get-nonce":"CNkOM","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"CNkOM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setNonce", function() {
    return setNonce;
});
parcelHelpers.export(exports, "getNonce", function() {
    return getNonce;
});
var currentNonce;
var setNonce = function setNonce(nonce) {
    currentNonce = nonce;
};
var getNonce = function getNonce() {
    if (currentNonce) return currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"jiBhL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroGap", function() {
    return zeroGap;
});
parcelHelpers.export(exports, "getGapWidth", function() {
    return getGapWidth;
});
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var parse = function parse(x) {
    return parseInt(x || "", 10) || 0;
};
var getOffset = function getOffset(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        parse(left),
        parse(top),
        parse(right)
    ];
};
var getGapWidth = function getGapWidth(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return zeroGap;
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"3tgxj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonPassive", function() {
    return nonPassive;
});
var passiveSupported = false;
if (typeof window !== "undefined") try {
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", options, options);
    // @ts-ignore
    window.removeEventListener("test", options, options);
} catch (err) {
    passiveSupported = false;
}
var nonPassive = passiveSupported ? {
    passive: false
} : false;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"bpQGL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locationCouldBeScrolled", function() {
    return locationCouldBeScrolled;
});
parcelHelpers.export(exports, "handleScroll", function() {
    return handleScroll;
});
var alwaysContainsScroll = function alwaysContainsScroll(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function elementCanBeScrolled(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var elementCouldBeVScrolled = function elementCouldBeVScrolled(node) {
    return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function elementCouldBeHScrolled(node) {
    return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function locationCouldBeScrolled(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var getVScrollVariables = function getVScrollVariables(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var getHScrollVariables = function getHScrollVariables(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var elementCouldBeScrolled = function elementCouldBeScrolled(axis, node) {
    return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function getScrollVariables(axis, node) {
    return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function getDirectionFactor(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function handleScroll(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"kvYzO":[function(require,module,exports) {
"use client";
"use strict";
function keys(object) {
    return Object.keys(object);
}
exports.keys = keys; //# sourceMappingURL=keys.cjs.map

},{}],"aXRyU":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use strict";
function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
function deepMerge(target, source) {
    var result = (0, _objectSpread._)({}, target);
    var _source = source;
    if (isObject(target) && isObject(source)) Object.keys(source).forEach(function(key) {
        if (isObject(_source[key])) {
            if (!(key in target)) result[key] = _source[key];
            else result[key] = deepMerge(result[key], _source[key]);
        } else result[key] = _source[key];
    });
    return result;
}
exports.deepMerge = deepMerge; //# sourceMappingURL=deep-merge.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN"}],"57PxO":[function(require,module,exports) {
"use client";
"use strict";
function camelToKebabCase(value) {
    return value.replace(/[A-Z]/g, function(letter) {
        return `-${letter.toLowerCase()}`;
    });
}
exports.camelToKebabCase = camelToKebabCase; //# sourceMappingURL=camel-to-kebab-case.cjs.map

},{}],"dXm4f":[function(require,module,exports) {
"use strict";
function getTransformedScaledValue(value) {
    var _value_match;
    if (typeof value !== "string" || !value.includes("var(--mantine-scale)")) return value;
    return (_value_match = value.match(/^calc\((.*?)\)$/)) === null || _value_match === void 0 ? void 0 : _value_match[1].split("*")[0].trim();
}
function px(value) {
    var transformedValue = getTransformedScaledValue(value);
    if (typeof transformedValue === "number") return transformedValue;
    if (typeof transformedValue === "string") {
        if (transformedValue.includes("calc") || transformedValue.includes("var")) return transformedValue;
        if (transformedValue.includes("px")) return Number(transformedValue.replace("px", ""));
        if (transformedValue.includes("rem")) return Number(transformedValue.replace("rem", "")) * 16;
        if (transformedValue.includes("em")) return Number(transformedValue.replace("em", "")) * 16;
        return Number(transformedValue);
    }
    return NaN;
}
exports.px = px; //# sourceMappingURL=px.cjs.map

},{}],"ebAaL":[function(require,module,exports) {
"use strict";
function scaleRem(remValue) {
    if (remValue === "0rem") return "0rem";
    return `calc(${remValue} * var(--mantine-scale))`;
}
function createConverter(units) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_shouldScale = _ref.shouldScale, shouldScale = _ref_shouldScale === void 0 ? false : _ref_shouldScale;
    function converter(value) {
        if (value === 0 || value === "0") return `0${units}`;
        if (typeof value === "number") {
            var val = `${value / 16}${units}`;
            return shouldScale ? scaleRem(val) : val;
        }
        if (typeof value === "string") {
            if (value === "") return value;
            if (value.startsWith("calc(") || value.startsWith("clamp(") || value.includes("rgba(")) return value;
            if (value.includes(",")) return value.split(",").map(function(val) {
                return converter(val);
            }).join(",");
            if (value.includes(" ")) return value.split(" ").map(function(val) {
                return converter(val);
            }).join(" ");
            if (value.includes(units)) return shouldScale ? scaleRem(value) : value;
            var replaced = value.replace("px", "");
            if (!Number.isNaN(Number(replaced))) {
                var val1 = `${Number(replaced) / 16}${units}`;
                return shouldScale ? scaleRem(val1) : val1;
            }
        }
        return value;
    }
    return converter;
}
var rem = createConverter("rem", {
    shouldScale: true
});
var em = createConverter("em");
exports.em = em;
exports.rem = rem; //# sourceMappingURL=rem.cjs.map

},{}],"2Jst9":[function(require,module,exports) {
"use client";
"use strict";
function filterProps(props) {
    return Object.keys(props).reduce(function(acc, key) {
        if (props[key] !== void 0) acc[key] = props[key];
        return acc;
    }, {});
}
exports.filterProps = filterProps; //# sourceMappingURL=filter-props.cjs.map

},{}],"6knSJ":[function(require,module,exports) {
"use client";
"use strict";
function isNumberLike(value) {
    if (typeof value === "number") return true;
    if (typeof value === "string") {
        if (value.startsWith("calc(") || value.startsWith("var(") || value.includes(" ") && value.trim() !== "") return true;
        var cssUnitsRegex = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
        var values = value.trim().split(/\s+/);
        return values.every(function(val) {
            return cssUnitsRegex.test(val);
        });
    }
    return false;
}
exports.isNumberLike = isNumberLike; //# sourceMappingURL=is-number-like.cjs.map

},{}],"193o0":[function(require,module,exports) {
"use client";
"use strict";
var React = require("29d31ee1ce1e47c0");
function isElement(value) {
    if (Array.isArray(value) || value === null) return false;
    if (typeof value === "object") {
        if (value.type === React.Fragment) return false;
        return true;
    }
    return false;
}
exports.isElement = isElement; //# sourceMappingURL=is-element.cjs.map

},{"29d31ee1ce1e47c0":"9MtAM"}],"8srze":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("3df4e41f9752d5c5");
var React = require("6620d17ed969451e");
function createSafeContext(errorMessage) {
    var Context = React.createContext(null);
    var useSafeContext = function() {
        var ctx = React.useContext(Context);
        if (ctx === null) throw new Error(errorMessage);
        return ctx;
    };
    var Provider = function(param) {
        var children = param.children, value = param.value;
        return /* @__PURE__ */ jsxRuntime.jsx(Context.Provider, {
            value,
            children
        });
    };
    return [
        Provider,
        useSafeContext
    ];
}
exports.createSafeContext = createSafeContext; //# sourceMappingURL=create-safe-context.cjs.map

},{"3df4e41f9752d5c5":"iKGFf","6620d17ed969451e":"9MtAM"}],"7cMAR":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("790da82f6381b5bd");
var React = require("11783322250d0f40");
function createOptionalContext() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var Context = React.createContext(initialValue);
    var useOptionalContext = function() {
        return React.useContext(Context);
    };
    var Provider = function(param) {
        var children = param.children, value = param.value;
        return /* @__PURE__ */ jsxRuntime.jsx(Context.Provider, {
            value,
            children
        });
    };
    return [
        Provider,
        useOptionalContext
    ];
}
exports.createOptionalContext = createOptionalContext; //# sourceMappingURL=create-optional-context.cjs.map

},{"790da82f6381b5bd":"iKGFf","11783322250d0f40":"9MtAM"}],"dvoq6":[function(require,module,exports) {
"use client";
"use strict";
function getSafeId(uid, errorMessage) {
    return function(value) {
        if (typeof value !== "string" || value.trim().length === 0) throw new Error(errorMessage);
        return `${uid}-${value}`;
    };
}
exports.getSafeId = getSafeId; //# sourceMappingURL=get-safe-id.cjs.map

},{}],"5jFxz":[function(require,module,exports) {
"use client";
"use strict";
var findElementAncestor = require("3e8d2764376a90f5");
function getPreviousIndex(current, elements, loop) {
    for(var i = current - 1; i >= 0; i -= 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(var i1 = elements.length - 1; i1 > -1; i1 -= 1){
        if (!elements[i1].disabled) return i1;
    }
    return current;
}
function getNextIndex(current, elements, loop) {
    for(var i = current + 1; i < elements.length; i += 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(var i1 = 0; i1 < elements.length; i1 += 1){
        if (!elements[i1].disabled) return i1;
    }
    return current;
}
function onSameLevel(target, sibling, parentSelector) {
    return findElementAncestor.findElementAncestor(target, parentSelector) === findElementAncestor.findElementAncestor(sibling, parentSelector);
}
function createScopedKeydownHandler(param) {
    var parentSelector = param.parentSelector, siblingSelector = param.siblingSelector, onKeyDown = param.onKeyDown, _param_loop = param.loop, loop = _param_loop === void 0 ? true : _param_loop, _param_activateOnFocus = param.activateOnFocus, activateOnFocus = _param_activateOnFocus === void 0 ? false : _param_activateOnFocus, _param_dir = param.dir, dir = _param_dir === void 0 ? "rtl" : _param_dir, orientation = param.orientation;
    return function(event) {
        var _findElementAncestor_findElementAncestor;
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        var elements = Array.from(((_findElementAncestor_findElementAncestor = findElementAncestor.findElementAncestor(event.currentTarget, parentSelector)) === null || _findElementAncestor_findElementAncestor === void 0 ? void 0 : _findElementAncestor_findElementAncestor.querySelectorAll(siblingSelector)) || []).filter(function(node) {
            return onSameLevel(event.currentTarget, node, parentSelector);
        });
        var current = elements.findIndex(function(el) {
            return event.currentTarget === el;
        });
        var _nextIndex = getNextIndex(current, elements, loop);
        var _previousIndex = getPreviousIndex(current, elements, loop);
        var nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
        var previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
        switch(event.key){
            case "ArrowRight":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[nextIndex].focus();
                    activateOnFocus && elements[nextIndex].click();
                }
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[previousIndex].focus();
                    activateOnFocus && elements[previousIndex].click();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_previousIndex].focus();
                    activateOnFocus && elements[_previousIndex].click();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_nextIndex].focus();
                    activateOnFocus && elements[_nextIndex].click();
                }
                break;
            case "Home":
                event.stopPropagation();
                event.preventDefault();
                !elements[0].disabled && elements[0].focus();
                break;
            case "End":
                {
                    event.stopPropagation();
                    event.preventDefault();
                    var last = elements.length - 1;
                    !elements[last].disabled && elements[last].focus();
                    break;
                }
        }
    };
}
exports.createScopedKeydownHandler = createScopedKeydownHandler; //# sourceMappingURL=create-scoped-keydown-handler.cjs.map

},{"3e8d2764376a90f5":"cC16z"}],"cC16z":[function(require,module,exports) {
"use client";
"use strict";
function findElementAncestor(element, selector) {
    var _element = element;
    while((_element = _element.parentElement) && !_element.matches(selector));
    return _element;
}
exports.findElementAncestor = findElementAncestor; //# sourceMappingURL=find-element-ancestor.cjs.map

},{}],"4gavl":[function(require,module,exports) {
"use client";
"use strict";
var elevations = {
    app: 100,
    modal: 200,
    popover: 300,
    overlay: 400,
    max: 9999
};
function getDefaultZIndex(level) {
    return elevations[level];
}
exports.getDefaultZIndex = getDefaultZIndex; //# sourceMappingURL=get-default-z-index.cjs.map

},{}],"aOjoS":[function(require,module,exports) {
"use client";
"use strict";
var noop = require("7d0dd7ab9970b9c3");
function closeOnEscape(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        active: true
    };
    if (typeof callback !== "function" || !options.active) return options.onKeyDown || noop.noop;
    return function(event) {
        if (event.key === "Escape") {
            var _options_onTrigger;
            callback(event);
            (_options_onTrigger = options.onTrigger) === null || _options_onTrigger === void 0 ? void 0 : _options_onTrigger.call(options);
        }
    };
}
exports.closeOnEscape = closeOnEscape; //# sourceMappingURL=close-on-escape.cjs.map

},{"7d0dd7ab9970b9c3":"2dVWr"}],"2dVWr":[function(require,module,exports) {
"use client";
"use strict";
var noop = function() {};
exports.noop = noop; //# sourceMappingURL=noop.cjs.map

},{}],"kEFEY":[function(require,module,exports) {
"use client";
"use strict";
var isNumberLike = require("27e90413dc4e42cb");
var rem = require("394498de8cb85c33");
function getSize(size) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "size", convertToRem = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (size === void 0) return void 0;
    return isNumberLike.isNumberLike(size) ? convertToRem ? rem.rem(size) : size : `var(--${prefix}-${size})`;
}
function getSpacing(size) {
    return getSize(size, "mantine-spacing");
}
function getRadius(size) {
    if (size === void 0) return "var(--mantine-radius-default)";
    return getSize(size, "mantine-radius");
}
function getFontSize(size) {
    return getSize(size, "mantine-font-size");
}
function getLineHeight(size) {
    return getSize(size, "mantine-line-height", false);
}
function getShadow(size) {
    if (!size) return void 0;
    return getSize(size, "mantine-shadow", false);
}
exports.getFontSize = getFontSize;
exports.getLineHeight = getLineHeight;
exports.getRadius = getRadius;
exports.getShadow = getShadow;
exports.getSize = getSize;
exports.getSpacing = getSpacing; //# sourceMappingURL=get-size.cjs.map

},{"27e90413dc4e42cb":"6knSJ","394498de8cb85c33":"ebAaL"}],"9qSGJ":[function(require,module,exports) {
"use client";
"use strict";
function createEventHandler(parentEventHandler, eventHandler) {
    return function(event) {
        parentEventHandler === null || parentEventHandler === void 0 ? void 0 : parentEventHandler(event);
        eventHandler === null || eventHandler === void 0 ? void 0 : eventHandler(event);
    };
}
exports.createEventHandler = createEventHandler; //# sourceMappingURL=create-event-handler.cjs.map

},{}],"fjWYA":[function(require,module,exports) {
"use client";
"use strict";
var px = require("c8ed3afae5df7d05");
function getBreakpointValue(breakpoint, breakpoints) {
    if (breakpoint in breakpoints) return px.px(breakpoints[breakpoint]);
    return px.px(breakpoint);
}
exports.getBreakpointValue = getBreakpointValue; //# sourceMappingURL=get-breakpoint-value.cjs.map

},{"c8ed3afae5df7d05":"dXm4f"}],"lwwF0":[function(require,module,exports) {
"use client";
"use strict";
var getBreakpointValue = require("d2a150f2206914f0");
function getSortedBreakpoints(values, breakpoints) {
    var convertedBreakpoints = values.map(function(breakpoint) {
        return {
            value: breakpoint,
            px: getBreakpointValue.getBreakpointValue(breakpoint, breakpoints)
        };
    });
    convertedBreakpoints.sort(function(a, b) {
        return a.px - b.px;
    });
    return convertedBreakpoints;
}
exports.getSortedBreakpoints = getSortedBreakpoints; //# sourceMappingURL=get-sorted-breakpoints.cjs.map

},{"d2a150f2206914f0":"fjWYA"}],"4aQII":[function(require,module,exports) {
"use client";
"use strict";
function getBaseValue(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) return value.base;
        return void 0;
    }
    return value;
}
exports.getBaseValue = getBaseValue; //# sourceMappingURL=get-base-value.cjs.map

},{}],"b3zfW":[function(require,module,exports) {
"use client";
"use strict";
var findElementAncestor = require("79db8938e7d07df");
function getContextItemIndex(elementSelector, parentSelector, node) {
    var _findElementAncestor_findElementAncestor;
    if (!node) return null;
    return Array.from(((_findElementAncestor_findElementAncestor = findElementAncestor.findElementAncestor(node, parentSelector)) === null || _findElementAncestor_findElementAncestor === void 0 ? void 0 : _findElementAncestor_findElementAncestor.querySelectorAll(elementSelector)) || []).findIndex(function(element) {
        return element === node;
    });
}
exports.getContextItemIndex = getContextItemIndex; //# sourceMappingURL=get-context-item-index.cjs.map

},{"79db8938e7d07df":"cC16z"}],"79GsF":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("bfe41f107b04db8c");
function useHovered() {
    var _React_useState = (0, _slicedToArray._)(React.useState(-1), 2), hovered = _React_useState[0], setHovered = _React_useState[1];
    var resetHovered = function() {
        return setHovered(-1);
    };
    return [
        hovered,
        {
            setHovered,
            resetHovered
        }
    ];
}
exports.useHovered = useHovered; //# sourceMappingURL=use-hovered.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","bfe41f107b04db8c":"9MtAM"}],"c06go":[function(require,module,exports) {
"use client";
"use strict";
var hooks = require("27773c927ba87be");
function dispatchEvent(type, detail) {
    window.dispatchEvent(new CustomEvent(type, {
        detail
    }));
}
function createUseExternalEvents(prefix) {
    function _useExternalEvents(events) {
        var handlers = Object.keys(events).reduce(function(acc, eventKey) {
            acc[`${prefix}:${eventKey}`] = function(event) {
                return events[eventKey](event.detail);
            };
            return acc;
        }, {});
        hooks.useIsomorphicEffect(function() {
            Object.keys(handlers).forEach(function(eventKey) {
                window.removeEventListener(eventKey, handlers[eventKey]);
                window.addEventListener(eventKey, handlers[eventKey]);
            });
            return function() {
                return Object.keys(handlers).forEach(function(eventKey) {
                    window.removeEventListener(eventKey, handlers[eventKey]);
                });
            };
        }, [
            handlers
        ]);
    }
    function createEvent(event) {
        return function() {
            for(var _len = arguments.length, payload = new Array(_len), _key = 0; _key < _len; _key++){
                payload[_key] = arguments[_key];
            }
            return dispatchEvent(`${prefix}:${String(event)}`, payload[0]);
        };
    }
    return [
        _useExternalEvents,
        createEvent
    ];
}
exports.createUseExternalEvents = createUseExternalEvents; //# sourceMappingURL=create-use-external-events.cjs.map

},{"27773c927ba87be":"9HEEB"}],"9HEEB":[function(require,module,exports) {
"use strict";
var clamp = require("b732c1a00641b224");
var lowerFirst = require("6326a94298d6d5f4");
var randomId = require("387cef5dc6d4f532");
var range = require("98640ee04366d950");
var shallowEqual = require("6884fe6bc189196e");
var upperFirst = require("7eab1935477bb4db");
var useCallbackRef = require("49ccd70dbfad8d8c");
var useDebouncedCallback = require("268a81fcf6573fb0");
var useClickOutside = require("b04cfe1a18929cfd");
var useClipboard = require("f5da398f99c85aff");
var useColorScheme = require("786fac24833264e0");
var useCounter = require("cc13f9efd3fc81a4");
var useDebouncedState = require("949a673fece4cd5d");
var useDebouncedValue = require("7a8df6df841e650b");
var useDocumentTitle = require("7a9b24acc601a4fa");
var useDocumentVisibility = require("7684ec6837fc17d7");
var useFocusReturn = require("bbeb1ecc721cef39");
var useDidUpdate = require("8ab1e7b7d96c446c");
var useFocusTrap = require("7d0686a38dfa839f");
var useForceUpdate = require("e95d3034f6e30173");
var useId = require("7a70db6121c60604");
var useIdle = require("321a2860e7c1aac8");
var useInterval = require("673ab9a8e8b0af92");
var useIsomorphicEffect = require("d79f2919fd09fbc9");
var useListState = require("1b57e8894ddb894d");
var useLocalStorage = require("cbf8e8398dc79e33");
var useSessionStorage = require("5cd53902d0fc5818");
var useMediaQuery = require("2f911de97bce1df4");
var useMergedRef = require("1068930199ed59fe");
var useMouse = require("ee05641b8afabcce");
var useMove = require("22d75d5274b103be");
var usePagination = require("f1d0026a70425779");
var useQueue = require("43840e4df154fdd");
var usePageLeave = require("c1b39101616bbb2c");
var useReducedMotion = require("2181c8749c09f0fe");
var useScrollIntoView = require("a6e5686671d357af");
var useResizeObserver = require("c630963cce38fdf7");
var useShallowEffect = require("40dbddfecb60b13");
var useToggle = require("16c77c0941e959e4");
var useUncontrolled = require("d6229e3b4c3c06d8");
var useViewportSize = require("1ae10b4e5b70cf26");
var useWindowEvent = require("a3e48bf550c9720e");
var useWindowScroll = require("707beec5a6f50799");
var useIntersection = require("6b57b75e32891abf");
var useHash = require("70308463bfcc3f9d");
var useHotkeys = require("d3a4b68df6763867");
var useFullscreen = require("371394dd6721d936");
var useLogger = require("3b13eabb4208ba67");
var useHover = require("65fa02e1b0555641");
var useValidatedState = require("8ff9bf84e70aa2c7");
var useOs = require("6b31a83ae7c5714e");
var useSetState = require("57d02a8907ee7020");
var useInputState = require("de0090c3c5838dd3");
var useEventListener = require("7b2ccb7ab88ed86e");
var useDisclosure = require("7ffa26ca7c02263");
var useFocusWithin = require("a5e886dfafe84ef2");
var useNetwork = require("521bdf75f569d298");
var useTimeout = require("34ea93279075f010");
var useTextSelection = require("dbbb6f645b1678c5");
var usePrevious = require("ec28d62c8ab0e85d");
var useFavicon = require("aea0bd287e45dbbb");
var useHeadroom = require("36410d79906e1958");
var useEyeDropper = require("23293cef07982da4");
var useInViewport = require("b40300ec8069b6fc");
var useMutationObserver = require("1f4227c0575de25f");
var useMounted = require("11063ef72ed96584");
var useStateHistory = require("66e5b9570b012099");
var useMap = require("947eeb574a48c320");
var useSet = require("1d41ebff46345ca");
var useThrottledCallback = require("630a4c4ab9cf573d");
var useThrottledState = require("b3b1442f28c98e76");
var useThrottledValue = require("ed9e8cb6206481c6");
var useIsFirstRender = require("afc3668c6d12f15c");
var useOrientation = require("1812cf56ff006ae8");
var useFetch = require("18c65c3c582aa35e");
var useRadialMove = require("eb35c949ddbc1874");
var useScrollSpy = require("316e917f048bc990");
var useFileDialog = require("25a5169817543e64");
var parseHotkey = require("e228cf7e7c751595");
exports.clamp = clamp.clamp;
exports.lowerFirst = lowerFirst.lowerFirst;
exports.randomId = randomId.randomId;
exports.range = range.range;
exports.shallowEqual = shallowEqual.shallowEqual;
exports.upperFirst = upperFirst.upperFirst;
exports.useCallbackRef = useCallbackRef.useCallbackRef;
exports.useDebouncedCallback = useDebouncedCallback.useDebouncedCallback;
exports.useClickOutside = useClickOutside.useClickOutside;
exports.useClipboard = useClipboard.useClipboard;
exports.useColorScheme = useColorScheme.useColorScheme;
exports.useCounter = useCounter.useCounter;
exports.useDebouncedState = useDebouncedState.useDebouncedState;
exports.useDebouncedValue = useDebouncedValue.useDebouncedValue;
exports.useDocumentTitle = useDocumentTitle.useDocumentTitle;
exports.useDocumentVisibility = useDocumentVisibility.useDocumentVisibility;
exports.useFocusReturn = useFocusReturn.useFocusReturn;
exports.useDidUpdate = useDidUpdate.useDidUpdate;
exports.useFocusTrap = useFocusTrap.useFocusTrap;
exports.useForceUpdate = useForceUpdate.useForceUpdate;
exports.useId = useId.useId;
exports.useIdle = useIdle.useIdle;
exports.useInterval = useInterval.useInterval;
exports.useIsomorphicEffect = useIsomorphicEffect.useIsomorphicEffect;
exports.useListState = useListState.useListState;
exports.readLocalStorageValue = useLocalStorage.readLocalStorageValue;
exports.useLocalStorage = useLocalStorage.useLocalStorage;
exports.readSessionStorageValue = useSessionStorage.readSessionStorageValue;
exports.useSessionStorage = useSessionStorage.useSessionStorage;
exports.useMediaQuery = useMediaQuery.useMediaQuery;
exports.assignRef = useMergedRef.assignRef;
exports.mergeRefs = useMergedRef.mergeRefs;
exports.useMergedRef = useMergedRef.useMergedRef;
exports.useMouse = useMouse.useMouse;
exports.clampUseMovePosition = useMove.clampUseMovePosition;
exports.useMove = useMove.useMove;
exports.usePagination = usePagination.usePagination;
exports.useQueue = useQueue.useQueue;
exports.usePageLeave = usePageLeave.usePageLeave;
exports.useReducedMotion = useReducedMotion.useReducedMotion;
exports.useScrollIntoView = useScrollIntoView.useScrollIntoView;
exports.useElementSize = useResizeObserver.useElementSize;
exports.useResizeObserver = useResizeObserver.useResizeObserver;
exports.useShallowEffect = useShallowEffect.useShallowEffect;
exports.useToggle = useToggle.useToggle;
exports.useUncontrolled = useUncontrolled.useUncontrolled;
exports.useViewportSize = useViewportSize.useViewportSize;
exports.useWindowEvent = useWindowEvent.useWindowEvent;
exports.useWindowScroll = useWindowScroll.useWindowScroll;
exports.useIntersection = useIntersection.useIntersection;
exports.useHash = useHash.useHash;
exports.useHotkeys = useHotkeys.useHotkeys;
exports.useFullscreen = useFullscreen.useFullscreen;
exports.useLogger = useLogger.useLogger;
exports.useHover = useHover.useHover;
exports.useValidatedState = useValidatedState.useValidatedState;
exports.useOs = useOs.useOs;
exports.useSetState = useSetState.useSetState;
exports.useInputState = useInputState.useInputState;
exports.useEventListener = useEventListener.useEventListener;
exports.useDisclosure = useDisclosure.useDisclosure;
exports.useFocusWithin = useFocusWithin.useFocusWithin;
exports.useNetwork = useNetwork.useNetwork;
exports.useTimeout = useTimeout.useTimeout;
exports.useTextSelection = useTextSelection.useTextSelection;
exports.usePrevious = usePrevious.usePrevious;
exports.useFavicon = useFavicon.useFavicon;
exports.useHeadroom = useHeadroom.useHeadroom;
exports.useEyeDropper = useEyeDropper.useEyeDropper;
exports.useInViewport = useInViewport.useInViewport;
exports.useMutationObserver = useMutationObserver.useMutationObserver;
exports.useMounted = useMounted.useMounted;
exports.useStateHistory = useStateHistory.useStateHistory;
exports.useMap = useMap.useMap;
exports.useSet = useSet.useSet;
exports.useThrottledCallback = useThrottledCallback.useThrottledCallback;
exports.useThrottledState = useThrottledState.useThrottledState;
exports.useThrottledValue = useThrottledValue.useThrottledValue;
exports.useIsFirstRender = useIsFirstRender.useIsFirstRender;
exports.useOrientation = useOrientation.useOrientation;
exports.useFetch = useFetch.useFetch;
exports.normalizeRadialValue = useRadialMove.normalizeRadialValue;
exports.useRadialMove = useRadialMove.useRadialMove;
exports.useScrollSpy = useScrollSpy.useScrollSpy;
exports.useFileDialog = useFileDialog.useFileDialog;
exports.getHotkeyHandler = parseHotkey.getHotkeyHandler; //# sourceMappingURL=index.cjs.map

},{"b732c1a00641b224":"dyyig","6326a94298d6d5f4":"4BRNj","387cef5dc6d4f532":"csqjH","98640ee04366d950":"gEEJp","6884fe6bc189196e":"bSsVQ","7eab1935477bb4db":"hHTXZ","49ccd70dbfad8d8c":"5hNe3","268a81fcf6573fb0":"1Bpmz","b04cfe1a18929cfd":"3LhLw","f5da398f99c85aff":"vCCIS","786fac24833264e0":"e2nDl","cc13f9efd3fc81a4":"9GpVL","949a673fece4cd5d":"a4EIO","7a8df6df841e650b":"afWXc","7a9b24acc601a4fa":"9GGn2","7684ec6837fc17d7":"kNZpc","bbeb1ecc721cef39":"77AGg","8ab1e7b7d96c446c":"6kFLu","7d0686a38dfa839f":"eZyXK","e95d3034f6e30173":"i8RNg","7a70db6121c60604":"gcJFc","321a2860e7c1aac8":"2BPQZ","673ab9a8e8b0af92":"hTPu6","d79f2919fd09fbc9":"hEZes","1b57e8894ddb894d":"j5sO9","cbf8e8398dc79e33":"h8AQO","5cd53902d0fc5818":"79ieG","2f911de97bce1df4":"4d5kZ","1068930199ed59fe":"8fgqK","ee05641b8afabcce":"f8zO2","22d75d5274b103be":"9GwOu","f1d0026a70425779":"7oJut","43840e4df154fdd":"iKzBK","c1b39101616bbb2c":"934ka","2181c8749c09f0fe":"1SXoj","a6e5686671d357af":"gkTyC","c630963cce38fdf7":"1Vlw3","40dbddfecb60b13":"8QkBF","16c77c0941e959e4":"8JDKK","d6229e3b4c3c06d8":"VbK7f","1ae10b4e5b70cf26":"6D6gB","a3e48bf550c9720e":"3gP2S","707beec5a6f50799":"6PU4b","6b57b75e32891abf":"2yM9D","70308463bfcc3f9d":"4JjEY","d3a4b68df6763867":"kBqBN","371394dd6721d936":"g1D8V","3b13eabb4208ba67":"ivAdX","65fa02e1b0555641":"kljlx","8ff9bf84e70aa2c7":"80E1o","6b31a83ae7c5714e":"bmQpj","57d02a8907ee7020":"2tmAh","de0090c3c5838dd3":"b29iI","7b2ccb7ab88ed86e":"039Fz","7ffa26ca7c02263":"9XF1k","a5e886dfafe84ef2":"9cHDh","521bdf75f569d298":"6sWMZ","34ea93279075f010":"jcOil","dbbb6f645b1678c5":"hqmQm","ec28d62c8ab0e85d":"9o9lY","aea0bd287e45dbbb":"ikLfP","36410d79906e1958":"eFi7d","23293cef07982da4":"2smM7","b40300ec8069b6fc":"8CcKN","1f4227c0575de25f":"lQiUo","11063ef72ed96584":"UAZLU","66e5b9570b012099":"50UyU","947eeb574a48c320":"14aYX","1d41ebff46345ca":"zR2VZ","630a4c4ab9cf573d":"b5LJB","b3b1442f28c98e76":"2ultT","ed9e8cb6206481c6":"9hZCz","afc3668c6d12f15c":"bAL6A","1812cf56ff006ae8":"ayKxa","18c65c3c582aa35e":"cLznf","eb35c949ddbc1874":"blExe","316e917f048bc990":"d3hr3","25a5169817543e64":"2Q6TQ","e228cf7e7c751595":"7F5XT"}],"dyyig":[function(require,module,exports) {
"use client";
"use strict";
function clamp(value, min, max) {
    if (min === void 0 && max === void 0) return value;
    if (min !== void 0 && max === void 0) return Math.max(value, min);
    if (min === void 0 && max !== void 0) return Math.min(value, max);
    return Math.min(Math.max(value, min), max);
}
exports.clamp = clamp; //# sourceMappingURL=clamp.cjs.map

},{}],"4BRNj":[function(require,module,exports) {
"use client";
"use strict";
function lowerFirst(value) {
    return typeof value !== "string" ? "" : value.charAt(0).toLowerCase() + value.slice(1);
}
exports.lowerFirst = lowerFirst; //# sourceMappingURL=lower-first.cjs.map

},{}],"csqjH":[function(require,module,exports) {
"use client";
"use strict";
function randomId() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "mantine-";
    return `${prefix}${Math.random().toString(36).slice(2, 11)}`;
}
exports.randomId = randomId; //# sourceMappingURL=random-id.cjs.map

},{}],"gEEJp":[function(require,module,exports) {
"use client";
"use strict";
function range(start, end) {
    var length = Math.abs(end - start) + 1;
    var reversed = start > end;
    if (!reversed) return Array.from({
        length
    }, function(_, index) {
        return index + start;
    });
    return Array.from({
        length
    }, function(_, index) {
        return start - index;
    });
}
exports.range = range; //# sourceMappingURL=range.cjs.map

},{}],"bSsVQ":[function(require,module,exports) {
"use client";
"use strict";
function shallowEqual(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    var keys = Object.keys(a);
    var length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for(var i = 0; i < length; i += 1){
        var key = keys[i];
        if (!(key in b)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
exports.shallowEqual = shallowEqual; //# sourceMappingURL=shallow-equal.cjs.map

},{}],"hHTXZ":[function(require,module,exports) {
"use client";
"use strict";
function upperFirst(value) {
    return typeof value !== "string" ? "" : value.charAt(0).toUpperCase() + value.slice(1);
}
exports.upperFirst = upperFirst; //# sourceMappingURL=upper-first.cjs.map

},{}],"5hNe3":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("70fac7af0ded7244");
function useCallbackRef(callback) {
    var callbackRef = React.useRef(callback);
    React.useEffect(function() {
        callbackRef.current = callback;
    });
    return React.useMemo(function() {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _callbackRef_current;
            var _callbackRef_current1;
            return (_callbackRef_current1 = callbackRef.current) === null || _callbackRef_current1 === void 0 ? void 0 : (_callbackRef_current = _callbackRef_current1).call.apply(_callbackRef_current, [
                callbackRef
            ].concat((0, _toConsumableArray._)(args)));
        };
    }, []);
}
exports.useCallbackRef = useCallbackRef; //# sourceMappingURL=use-callback-ref.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","70fac7af0ded7244":"9MtAM"}],"1Bpmz":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("4b79914ecd329c84");
var useCallbackRef = require("3ef3e646574e888c");
function useDebouncedCallback(callback, options) {
    var delay = typeof options === "number" ? options : options.delay;
    var flushOnUnmount = typeof options === "number" ? false : options.flushOnUnmount;
    var handleCallback = useCallbackRef.useCallbackRef(callback);
    var debounceTimerRef = React.useRef(0);
    var flushRef = React.useRef(function() {});
    var lastCallback = Object.assign(React.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(debounceTimerRef.current);
        var flush = function() {
            if (debounceTimerRef.current !== 0) {
                debounceTimerRef.current = 0;
                handleCallback.apply(void 0, (0, _toConsumableArray._)(args));
            }
        };
        flushRef.current = flush;
        lastCallback.flush = flush;
        debounceTimerRef.current = window.setTimeout(flush, delay);
    }, [
        handleCallback,
        delay
    ]), {
        flush: flushRef.current
    });
    React.useEffect(function() {
        return function() {
            window.clearTimeout(debounceTimerRef.current);
            if (flushOnUnmount) lastCallback.flush();
        };
    }, [
        lastCallback,
        flushOnUnmount
    ]);
    return lastCallback;
}
exports.useDebouncedCallback = useDebouncedCallback; //# sourceMappingURL=use-debounced-callback.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","4b79914ecd329c84":"9MtAM","3ef3e646574e888c":"5hNe3"}],"3LhLw":[function(require,module,exports) {
"use client";
"use strict";
var React = require("83d6c9fd804ad27");
var DEFAULT_EVENTS = [
    "mousedown",
    "touchstart"
];
function useClickOutside(handler, events, nodes) {
    var ref = React.useRef(null);
    React.useEffect(function() {
        var listener = function(event) {
            var target = (event !== null && event !== void 0 ? event : {}).target;
            if (Array.isArray(nodes)) {
                var shouldIgnore = (target === null || target === void 0 ? void 0 : target.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(target) && target.tagName !== "HTML";
                var shouldTrigger = nodes.every(function(node) {
                    return !!node && !event.composedPath().includes(node);
                });
                shouldTrigger && !shouldIgnore && handler();
            } else if (ref.current && !ref.current.contains(target)) handler();
        };
        (events || DEFAULT_EVENTS).forEach(function(fn) {
            return document.addEventListener(fn, listener);
        });
        return function() {
            (events || DEFAULT_EVENTS).forEach(function(fn) {
                return document.removeEventListener(fn, listener);
            });
        };
    }, [
        ref,
        handler,
        nodes
    ]);
    return ref;
}
exports.useClickOutside = useClickOutside; //# sourceMappingURL=use-click-outside.cjs.map

},{"83d6c9fd804ad27":"9MtAM"}],"vCCIS":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("105d2e0ca4cfa5e8");
function useClipboard() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_timeout = _ref.timeout, timeout = _ref_timeout === void 0 ? 2e3 : _ref_timeout;
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(false), 2), copied = _React_useState1[0], setCopied = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState(null), 2), copyTimeout = _React_useState2[0], setCopyTimeout = _React_useState2[1];
    var handleCopyResult = function(value) {
        window.clearTimeout(copyTimeout);
        setCopyTimeout(window.setTimeout(function() {
            return setCopied(false);
        }, timeout));
        setCopied(value);
    };
    var copy = function(valueToCopy) {
        if ("clipboard" in navigator) navigator.clipboard.writeText(valueToCopy).then(function() {
            return handleCopyResult(true);
        }).catch(function(err) {
            return setError(err);
        });
        else setError(new Error("useClipboard: navigator.clipboard is not supported"));
    };
    var reset = function() {
        setCopied(false);
        setError(null);
        window.clearTimeout(copyTimeout);
    };
    return {
        copy,
        reset,
        error,
        copied
    };
}
exports.useClipboard = useClipboard; //# sourceMappingURL=use-clipboard.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","105d2e0ca4cfa5e8":"9MtAM"}],"e2nDl":[function(require,module,exports) {
"use client";
"use strict";
var useMediaQuery = require("1b5caed100e96ead");
function useColorScheme(initialValue, options) {
    return useMediaQuery.useMediaQuery("(prefers-color-scheme: dark)", initialValue === "dark", options) ? "dark" : "light";
}
exports.useColorScheme = useColorScheme; //# sourceMappingURL=use-color-scheme.cjs.map

},{"1b5caed100e96ead":"4d5kZ"}],"4d5kZ":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("2b3948199da73faf");
function attachMediaListener(query, callback) {
    try {
        query.addEventListener("change", callback);
        return function() {
            return query.removeEventListener("change", callback);
        };
    } catch (e) {
        query.addListener(callback);
        return function() {
            return query.removeListener(callback);
        };
    }
}
function getInitialValue(query, initialValue) {
    if (typeof window !== "undefined" && "matchMedia" in window) return window.matchMedia(query).matches;
    return false;
}
function useMediaQuery(query, initialValue) {
    var getInitialValueInEffect = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        getInitialValueInEffect: true
    }).getInitialValueInEffect;
    var _React_useState = (0, _slicedToArray._)(React.useState(getInitialValueInEffect ? initialValue : getInitialValue(query)), 2), matches = _React_useState[0], setMatches = _React_useState[1];
    var queryRef = React.useRef(null);
    React.useEffect(function() {
        if ("matchMedia" in window) {
            queryRef.current = window.matchMedia(query);
            setMatches(queryRef.current.matches);
            return attachMediaListener(queryRef.current, function(event) {
                return setMatches(event.matches);
            });
        }
        return void 0;
    }, [
        query
    ]);
    return matches;
}
exports.useMediaQuery = useMediaQuery; //# sourceMappingURL=use-media-query.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","2b3948199da73faf":"9MtAM"}],"9GpVL":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("1869d9907d424275");
var clamp = require("e4e7eaf5a3d93785");
var DEFAULT_OPTIONS = {
    min: -Infinity,
    max: Infinity
};
function useCounter() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, options = arguments.length > 1 ? arguments[1] : void 0;
    var _$_object_spread = (0, _objectSpread._)({}, DEFAULT_OPTIONS, options), min = _$_object_spread.min, max = _$_object_spread.max;
    var _React_useState = (0, _slicedToArray._)(React.useState(clamp.clamp(initialValue, min, max)), 2), count = _React_useState[0], setCount = _React_useState[1];
    var increment = function() {
        return setCount(function(current) {
            return clamp.clamp(current + 1, min, max);
        });
    };
    var decrement = function() {
        return setCount(function(current) {
            return clamp.clamp(current - 1, min, max);
        });
    };
    var set = function(value) {
        return setCount(clamp.clamp(value, min, max));
    };
    var reset = function() {
        return setCount(clamp.clamp(initialValue, min, max));
    };
    return [
        count,
        {
            increment,
            decrement,
            set,
            reset
        }
    ];
}
exports.useCounter = useCounter; //# sourceMappingURL=use-counter.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_sliced_to_array":"lAYt5","1869d9907d424275":"9MtAM","e4e7eaf5a3d93785":"dyyig"}],"a4EIO":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("fb39ad5773fa3f9b");
function useDebouncedState(defaultValue, wait) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        leading: false
    };
    var _React_useState = (0, _slicedToArray._)(React.useState(defaultValue), 2), value = _React_useState[0], setValue = _React_useState[1];
    var timeoutRef = React.useRef(null);
    var leadingRef = React.useRef(true);
    var clearTimeout = function() {
        return window.clearTimeout(timeoutRef.current);
    };
    React.useEffect(function() {
        return clearTimeout;
    }, []);
    var debouncedSetValue = React.useCallback(function(newValue) {
        clearTimeout();
        if (leadingRef.current && options.leading) setValue(newValue);
        else timeoutRef.current = window.setTimeout(function() {
            leadingRef.current = true;
            setValue(newValue);
        }, wait);
        leadingRef.current = false;
    }, [
        options.leading
    ]);
    return [
        value,
        debouncedSetValue
    ];
}
exports.useDebouncedState = useDebouncedState; //# sourceMappingURL=use-debounced-state.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","fb39ad5773fa3f9b":"9MtAM"}],"afWXc":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("4c8d549dbe24aea9");
function useDebouncedValue(value, wait) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        leading: false
    };
    var _React_useState = (0, _slicedToArray._)(React.useState(value), 2), _value = _React_useState[0], setValue = _React_useState[1];
    var mountedRef = React.useRef(false);
    var timeoutRef = React.useRef(null);
    var cooldownRef = React.useRef(false);
    var cancel = function() {
        return window.clearTimeout(timeoutRef.current);
    };
    React.useEffect(function() {
        if (mountedRef.current) {
            if (!cooldownRef.current && options.leading) {
                cooldownRef.current = true;
                setValue(value);
            } else {
                cancel();
                timeoutRef.current = window.setTimeout(function() {
                    cooldownRef.current = false;
                    setValue(value);
                }, wait);
            }
        }
    }, [
        value,
        options.leading,
        wait
    ]);
    React.useEffect(function() {
        mountedRef.current = true;
        return cancel;
    }, []);
    return [
        _value,
        cancel
    ];
}
exports.useDebouncedValue = useDebouncedValue; //# sourceMappingURL=use-debounced-value.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","4c8d549dbe24aea9":"9MtAM"}],"9GGn2":[function(require,module,exports) {
"use client";
"use strict";
var useIsomorphicEffect = require("d842e501251ac045");
function useDocumentTitle(title) {
    useIsomorphicEffect.useIsomorphicEffect(function() {
        if (typeof title === "string" && title.trim().length > 0) document.title = title.trim();
    }, [
        title
    ]);
}
exports.useDocumentTitle = useDocumentTitle; //# sourceMappingURL=use-document-title.cjs.map

},{"d842e501251ac045":"hEZes"}],"hEZes":[function(require,module,exports) {
"use client";
"use strict";
var React = require("69708070750b649b");
var useIsomorphicEffect = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
exports.useIsomorphicEffect = useIsomorphicEffect; //# sourceMappingURL=use-isomorphic-effect.cjs.map

},{"69708070750b649b":"9MtAM"}],"kNZpc":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("8db8bf29bf6d7347");
function useDocumentVisibility() {
    var _React_useState = (0, _slicedToArray._)(React.useState("visible"), 2), documentVisibility = _React_useState[0], setDocumentVisibility = _React_useState[1];
    React.useEffect(function() {
        var listener = function() {
            return setDocumentVisibility(document.visibilityState);
        };
        document.addEventListener("visibilitychange", listener);
        return function() {
            return document.removeEventListener("visibilitychange", listener);
        };
    }, []);
    return documentVisibility;
}
exports.useDocumentVisibility = useDocumentVisibility; //# sourceMappingURL=use-document-visibility.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","8db8bf29bf6d7347":"9MtAM"}],"77AGg":[function(require,module,exports) {
"use client";
"use strict";
var React = require("9cc6a54b355a3b11");
var useDidUpdate = require("59804d282893fee");
function useFocusReturn(param) {
    var opened = param.opened, _param_shouldReturnFocus = param.shouldReturnFocus, shouldReturnFocus = _param_shouldReturnFocus === void 0 ? true : _param_shouldReturnFocus;
    var lastActiveElement = React.useRef(null);
    var returnFocus = function() {
        var _lastActiveElement_current;
        if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") (_lastActiveElement_current = lastActiveElement.current) === null || _lastActiveElement_current === void 0 ? void 0 : _lastActiveElement_current.focus({
            preventScroll: true
        });
    };
    useDidUpdate.useDidUpdate(function() {
        var timeout = -1;
        var clearFocusTimeout = function(event) {
            if (event.key === "Tab") window.clearTimeout(timeout);
        };
        document.addEventListener("keydown", clearFocusTimeout);
        if (opened) lastActiveElement.current = document.activeElement;
        else if (shouldReturnFocus) timeout = window.setTimeout(returnFocus, 10);
        return function() {
            window.clearTimeout(timeout);
            document.removeEventListener("keydown", clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}
exports.useFocusReturn = useFocusReturn; //# sourceMappingURL=use-focus-return.cjs.map

},{"9cc6a54b355a3b11":"9MtAM","59804d282893fee":"6kFLu"}],"6kFLu":[function(require,module,exports) {
"use client";
"use strict";
var React = require("d8642cd51b3e0d51");
function useDidUpdate(fn, dependencies) {
    var mounted = React.useRef(false);
    React.useEffect(function() {
        return function() {
            mounted.current = false;
        };
    }, []);
    React.useEffect(function() {
        if (mounted.current) return fn();
        mounted.current = true;
        return void 0;
    }, dependencies);
}
exports.useDidUpdate = useDidUpdate; //# sourceMappingURL=use-did-update.cjs.map

},{"d8642cd51b3e0d51":"9MtAM"}],"eZyXK":[function(require,module,exports) {
"use client";
"use strict";
var React = require("300b30139a5ebc08");
var scopeTab = require("aa57f612c01cc864");
var tabbable = require("fd393359236f1437");
function useFocusTrap() {
    var active = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var ref = React.useRef(null);
    var focusNode = function(node) {
        var focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
            var children = Array.from(node.querySelectorAll(tabbable.FOCUS_SELECTOR));
            focusElement = children.find(tabbable.tabbable) || children.find(tabbable.focusable) || null;
            if (!focusElement && tabbable.focusable(node)) focusElement = node;
        }
        if (focusElement) focusElement.focus({
            preventScroll: true
        });
    };
    var setRef = React.useCallback(function(node) {
        if (!active) return;
        if (node === null) return;
        if (ref.current === node) return;
        if (node) {
            setTimeout(function() {
                if (node.getRootNode()) focusNode(node);
            });
            ref.current = node;
        } else ref.current = null;
    }, [
        active
    ]);
    React.useEffect(function() {
        if (!active) return void 0;
        ref.current && setTimeout(function() {
            return focusNode(ref.current);
        });
        var handleKeyDown = function(event) {
            if (event.key === "Tab" && ref.current) scopeTab.scopeTab(ref.current, event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        active
    ]);
    return setRef;
}
exports.useFocusTrap = useFocusTrap; //# sourceMappingURL=use-focus-trap.cjs.map

},{"300b30139a5ebc08":"9MtAM","aa57f612c01cc864":"jWHIH","fd393359236f1437":"lN4xd"}],"jWHIH":[function(require,module,exports) {
"use client";
"use strict";
var tabbable = require("355be4e6bd97e04e");
function scopeTab(node, event) {
    var tabbable$1 = tabbable.findTabbableDescendants(node);
    if (!tabbable$1.length) {
        event.preventDefault();
        return;
    }
    var finalTabbable = tabbable$1[event.shiftKey ? 0 : tabbable$1.length - 1];
    var root = node.getRootNode();
    var leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
    var activeElement = root.activeElement;
    var activeElementIsRadio = activeElement.tagName === "INPUT" && activeElement.getAttribute("type") === "radio";
    if (activeElementIsRadio) {
        var activeRadioGroup = tabbable$1.filter(function(element) {
            return element.getAttribute("type") === "radio" && element.getAttribute("name") === activeElement.getAttribute("name");
        });
        leavingFinalTabbable = activeRadioGroup.includes(finalTabbable);
    }
    if (!leavingFinalTabbable) return;
    event.preventDefault();
    var target = tabbable$1[event.shiftKey ? tabbable$1.length - 1 : 0];
    if (target) target.focus();
}
exports.scopeTab = scopeTab; //# sourceMappingURL=scope-tab.cjs.map

},{"355be4e6bd97e04e":"lN4xd"}],"lN4xd":[function(require,module,exports) {
"use client";
"use strict";
var TABBABLE_NODES = /input|select|textarea|button|object/;
var FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function hidden(element) {
    return element.style.display === "none";
}
function visible(element) {
    var isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
    if (isHidden) return false;
    var parentElement = element;
    while(parentElement){
        if (parentElement === document.body || parentElement.nodeType === 11) break;
        if (hidden(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function getElementTabIndex(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = void 0;
    return parseInt(tabIndex, 10);
}
function focusable(element) {
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
    var res = // @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition
    TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
function tabbable(element) {
    var tabIndex = getElementTabIndex(element);
    var isTabIndexNaN = Number.isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
    return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}
exports.FOCUS_SELECTOR = FOCUS_SELECTOR;
exports.findTabbableDescendants = findTabbableDescendants;
exports.focusable = focusable;
exports.tabbable = tabbable; //# sourceMappingURL=tabbable.cjs.map

},{}],"i8RNg":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("3202129f30bd7b7d");
var reducer = function(value) {
    return (value + 1) % 1e6;
};
function useForceUpdate() {
    var _React_useReducer = (0, _slicedToArray._)(React.useReducer(reducer, 0), 2), update = _React_useReducer[1];
    return update;
}
exports.useForceUpdate = useForceUpdate; //# sourceMappingURL=use-force-update.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","3202129f30bd7b7d":"9MtAM"}],"gcJFc":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("35a7843d1647ff48");
var useIsomorphicEffect = require("1ab7204bc3fef901");
var randomId = require("79f601b8d073a3b2");
var useReactId = require("cc74e47d24fd54e");
function useId(staticId) {
    var reactId = useReactId.useReactId();
    var _React_useState = (0, _slicedToArray._)(React.useState(reactId), 2), uuid = _React_useState[0], setUuid = _React_useState[1];
    useIsomorphicEffect.useIsomorphicEffect(function() {
        setUuid(randomId.randomId());
    }, []);
    if (typeof staticId === "string") return staticId;
    if (typeof window === "undefined") return reactId;
    return uuid;
}
exports.useId = useId; //# sourceMappingURL=use-id.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","35a7843d1647ff48":"9MtAM","1ab7204bc3fef901":"hEZes","79f601b8d073a3b2":"csqjH","cc74e47d24fd54e":"hTswh"}],"hTswh":[function(require,module,exports) {
"use client";
"use strict";
var React = require("69000ea96297f4ec");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var React__default = /*#__PURE__*/ _interopDefault(React);
var __useId = React__default.default["useId".toString()] || function() {
    return void 0;
};
function useReactId() {
    var id = __useId();
    return id ? `mantine-${id.replace(/:/g, "")}` : "";
}
exports.useReactId = useReactId; //# sourceMappingURL=use-react-id.cjs.map

},{"69000ea96297f4ec":"9MtAM"}],"2BPQZ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("ede79d60ed33c286");
var DEFAULT_EVENTS = [
    "keydown",
    "mousemove",
    "touchmove",
    "click",
    "scroll",
    "wheel"
];
var DEFAULT_OPTIONS = {
    events: DEFAULT_EVENTS,
    initialState: true
};
function useIdle(timeout, options) {
    var _$_object_spread = (0, _objectSpread._)({}, DEFAULT_OPTIONS, options), events = _$_object_spread.events, initialState = _$_object_spread.initialState;
    var _React_useState = (0, _slicedToArray._)(React.useState(initialState), 2), idle = _React_useState[0], setIdle = _React_useState[1];
    var timer = React.useRef(-1);
    React.useEffect(function() {
        var handleEvents = function() {
            setIdle(false);
            if (timer.current) window.clearTimeout(timer.current);
            timer.current = window.setTimeout(function() {
                setIdle(true);
            }, timeout);
        };
        events.forEach(function(event) {
            return document.addEventListener(event, handleEvents);
        });
        timer.current = window.setTimeout(function() {
            setIdle(true);
        }, timeout);
        return function() {
            events.forEach(function(event) {
                return document.removeEventListener(event, handleEvents);
            });
        };
    }, [
        timeout
    ]);
    return idle;
}
exports.useIdle = useIdle; //# sourceMappingURL=use-idle.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_sliced_to_array":"lAYt5","ede79d60ed33c286":"9MtAM"}],"hTPu6":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("b500ae6507ee3058");
function useInterval(fn, interval) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_autoInvoke = _ref.autoInvoke, autoInvoke = _ref_autoInvoke === void 0 ? false : _ref_autoInvoke;
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), active = _React_useState[0], setActive = _React_useState[1];
    var intervalRef = React.useRef(null);
    var fnRef = React.useRef(null);
    var start = function() {
        setActive(function(old) {
            if (!old && (!intervalRef.current || intervalRef.current === -1)) intervalRef.current = window.setInterval(fnRef.current, interval);
            return true;
        });
    };
    var stop = function() {
        setActive(false);
        window.clearInterval(intervalRef.current || -1);
        intervalRef.current = -1;
    };
    var toggle = function() {
        if (active) stop();
        else start();
    };
    React.useEffect(function() {
        fnRef.current = fn;
        active && start();
        return stop;
    }, [
        fn,
        active,
        interval
    ]);
    React.useEffect(function() {
        if (autoInvoke) start();
    }, []);
    return {
        start,
        stop,
        toggle,
        active
    };
}
exports.useInterval = useInterval; //# sourceMappingURL=use-interval.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","b500ae6507ee3058":"9MtAM"}],"j5sO9":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("c77df3a03c7c2a5f");
function useListState() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _React_useState = (0, _slicedToArray._)(React.useState(initialValue), 2), state = _React_useState[0], setState = _React_useState[1];
    var append = function() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        return setState(function(current) {
            return (0, _toConsumableArray._)(current).concat((0, _toConsumableArray._)(items));
        });
    };
    var prepend = function() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        return setState(function(current) {
            return (0, _toConsumableArray._)(items).concat((0, _toConsumableArray._)(current));
        });
    };
    var insert = function(index) {
        for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            items[_key - 1] = arguments[_key];
        }
        return setState(function(current) {
            return (0, _toConsumableArray._)(current.slice(0, index)).concat((0, _toConsumableArray._)(items), (0, _toConsumableArray._)(current.slice(index)));
        });
    };
    var apply = function(fn) {
        return setState(function(current) {
            return current.map(function(item, index) {
                return fn(item, index);
            });
        });
    };
    var remove = function() {
        for(var _len = arguments.length, indices = new Array(_len), _key = 0; _key < _len; _key++){
            indices[_key] = arguments[_key];
        }
        return setState(function(current) {
            return current.filter(function(_, index) {
                return !indices.includes(index);
            });
        });
    };
    var pop = function() {
        return setState(function(current) {
            var cloned = (0, _toConsumableArray._)(current);
            cloned.pop();
            return cloned;
        });
    };
    var shift = function() {
        return setState(function(current) {
            var cloned = (0, _toConsumableArray._)(current);
            cloned.shift();
            return cloned;
        });
    };
    var reorder = function(param) {
        var from = param.from, to = param.to;
        return setState(function(current) {
            var cloned = (0, _toConsumableArray._)(current);
            var item = current[from];
            cloned.splice(from, 1);
            cloned.splice(to, 0, item);
            return cloned;
        });
    };
    var swap = function(param) {
        var from = param.from, to = param.to;
        return setState(function(current) {
            var cloned = (0, _toConsumableArray._)(current);
            var fromItem = cloned[from];
            var toItem = cloned[to];
            cloned.splice(to, 1, fromItem);
            cloned.splice(from, 1, toItem);
            return cloned;
        });
    };
    var setItem = function(index, item) {
        return setState(function(current) {
            var cloned = (0, _toConsumableArray._)(current);
            cloned[index] = item;
            return cloned;
        });
    };
    var setItemProp = function(index, prop, value) {
        return setState(function(current) {
            var cloned = (0, _toConsumableArray._)(current);
            cloned[index] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, cloned[index]), {
                [prop]: value
            });
            return cloned;
        });
    };
    var applyWhere = function(condition, fn) {
        return setState(function(current) {
            return current.map(function(item, index) {
                return condition(item, index) ? fn(item, index) : item;
            });
        });
    };
    var filter = function(fn) {
        setState(function(current) {
            return current.filter(fn);
        });
    };
    return [
        state,
        {
            setState,
            append,
            prepend,
            insert,
            pop,
            shift,
            apply,
            applyWhere,
            remove,
            reorder,
            swap,
            setItem,
            setItemProp,
            filter
        }
    ];
}
exports.useListState = useListState; //# sourceMappingURL=use-list-state.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","c77df3a03c7c2a5f":"9MtAM"}],"h8AQO":[function(require,module,exports) {
"use client";
"use strict";
var createStorage = require("b5bd75c675807b24");
function useLocalStorage(props) {
    return createStorage.createStorage("localStorage", "use-local-storage")(props);
}
var readLocalStorageValue = createStorage.readValue("localStorage");
exports.readLocalStorageValue = readLocalStorageValue;
exports.useLocalStorage = useLocalStorage; //# sourceMappingURL=use-local-storage.cjs.map

},{"b5bd75c675807b24":"95vy8"}],"95vy8":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("61253d0664d2b240");
var useWindowEvent = require("29018cf849fe7dc6");
function serializeJSON(value) {
    var hookName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "use-local-storage";
    try {
        return JSON.stringify(value);
    } catch (error) {
        throw new Error(`@mantine/hooks ${hookName}: Failed to serialize the value`);
    }
}
function deserializeJSON(value) {
    try {
        return value && JSON.parse(value);
    } catch (e) {
        return value;
    }
}
function createStorageHandler(type) {
    var getItem = function(key) {
        try {
            return window[type].getItem(key);
        } catch (error) {
            console.warn("use-local-storage: Failed to get value from storage, localStorage is blocked");
            return null;
        }
    };
    var setItem = function(key, value) {
        try {
            window[type].setItem(key, value);
        } catch (error) {
            console.warn("use-local-storage: Failed to set value to storage, localStorage is blocked");
        }
    };
    var removeItem = function(key) {
        try {
            window[type].removeItem(key);
        } catch (error) {
            console.warn("use-local-storage: Failed to remove value from storage, localStorage is blocked");
        }
    };
    return {
        getItem,
        setItem,
        removeItem
    };
}
function createStorage(type, hookName) {
    var eventName = type === "localStorage" ? "mantine-local-storage" : "mantine-session-storage";
    var _createStorageHandler = createStorageHandler(type), getItem = _createStorageHandler.getItem, setItem = _createStorageHandler.setItem, removeItem = _createStorageHandler.removeItem;
    return function useStorage(param) {
        var key = param.key, defaultValue = param.defaultValue, _param_getInitialValueInEffect = param.getInitialValueInEffect, getInitialValueInEffect = _param_getInitialValueInEffect === void 0 ? true : _param_getInitialValueInEffect, _param_sync = param.sync, sync = _param_sync === void 0 ? true : _param_sync, _param_deserialize = param.deserialize, deserialize = _param_deserialize === void 0 ? deserializeJSON : _param_deserialize, _param_serialize = param.serialize, serialize = _param_serialize === void 0 ? function(value) {
            return serializeJSON(value, hookName);
        } : _param_serialize;
        var readStorageValue = React.useCallback(function(skipStorage) {
            var storageBlockedOrSkipped;
            try {
                storageBlockedOrSkipped = typeof window === "undefined" || !(type in window) || window[type] === null || !!skipStorage;
            } catch (_e) {
                storageBlockedOrSkipped = true;
            }
            if (storageBlockedOrSkipped) return defaultValue;
            var storageValue = getItem(key);
            return storageValue !== null ? deserialize(storageValue) : defaultValue;
        }, [
            key,
            defaultValue
        ]);
        var _React_useState = (0, _slicedToArray._)(React.useState(readStorageValue(getInitialValueInEffect)), 2), value = _React_useState[0], setValue = _React_useState[1];
        var setStorageValue = React.useCallback(function(val) {
            if (val instanceof Function) setValue(function(current) {
                var result = val(current);
                setItem(key, serialize(result));
                window.dispatchEvent(new CustomEvent(eventName, {
                    detail: {
                        key,
                        value: val(current)
                    }
                }));
                return result;
            });
            else {
                setItem(key, serialize(val));
                window.dispatchEvent(new CustomEvent(eventName, {
                    detail: {
                        key,
                        value: val
                    }
                }));
                setValue(val);
            }
        }, [
            key
        ]);
        var removeStorageValue = React.useCallback(function() {
            removeItem(key);
            window.dispatchEvent(new CustomEvent(eventName, {
                detail: {
                    key,
                    value: defaultValue
                }
            }));
        }, []);
        useWindowEvent.useWindowEvent("storage", function(event) {
            var _event_newValue;
            if (sync) {
                if (event.storageArea === window[type] && event.key === key) setValue(deserialize((_event_newValue = event.newValue) !== null && _event_newValue !== void 0 ? _event_newValue : void 0));
            }
        });
        useWindowEvent.useWindowEvent(eventName, function(event) {
            if (sync) {
                if (event.detail.key === key) setValue(event.detail.value);
            }
        });
        React.useEffect(function() {
            if (defaultValue !== void 0 && value === void 0) setStorageValue(defaultValue);
        }, [
            defaultValue,
            value,
            setStorageValue
        ]);
        React.useEffect(function() {
            var val = readStorageValue();
            val !== void 0 && setStorageValue(val);
        }, [
            key
        ]);
        return [
            value === void 0 ? defaultValue : value,
            setStorageValue,
            removeStorageValue
        ];
    };
}
function readValue(type) {
    var getItem = createStorageHandler(type).getItem;
    return function read(param) {
        var key = param.key, defaultValue = param.defaultValue, _param_deserialize = param.deserialize, deserialize = _param_deserialize === void 0 ? deserializeJSON : _param_deserialize;
        var storageBlockedOrSkipped;
        try {
            storageBlockedOrSkipped = typeof window === "undefined" || !(type in window) || window[type] === null;
        } catch (_e) {
            storageBlockedOrSkipped = true;
        }
        if (storageBlockedOrSkipped) return defaultValue;
        var storageValue = getItem(key);
        return storageValue !== null ? deserialize(storageValue) : defaultValue;
    };
}
exports.createStorage = createStorage;
exports.readValue = readValue; //# sourceMappingURL=create-storage.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","61253d0664d2b240":"9MtAM","29018cf849fe7dc6":"3gP2S"}],"3gP2S":[function(require,module,exports) {
"use client";
"use strict";
var React = require("728ec9461448adf7");
function useWindowEvent(type, listener, options) {
    React.useEffect(function() {
        window.addEventListener(type, listener, options);
        return function() {
            return window.removeEventListener(type, listener, options);
        };
    }, [
        type,
        listener
    ]);
}
exports.useWindowEvent = useWindowEvent; //# sourceMappingURL=use-window-event.cjs.map

},{"728ec9461448adf7":"9MtAM"}],"79ieG":[function(require,module,exports) {
"use client";
"use strict";
var createStorage = require("615fc800ec00bb3d");
function useSessionStorage(props) {
    return createStorage.createStorage("sessionStorage", "use-session-storage")(props);
}
var readSessionStorageValue = createStorage.readValue("sessionStorage");
exports.readSessionStorageValue = readSessionStorageValue;
exports.useSessionStorage = useSessionStorage; //# sourceMappingURL=use-session-storage.cjs.map

},{"615fc800ec00bb3d":"95vy8"}],"8fgqK":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("dbcdb03778f6dc28");
function assignRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (typeof ref === "object" && ref !== null && "current" in ref) ref.current = value;
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    var cleanupMap = /* @__PURE__ */ new Map();
    return function(node) {
        refs.forEach(function(ref) {
            var cleanup = assignRef(ref, node);
            if (cleanup) cleanupMap.set(ref, cleanup);
        });
        if (cleanupMap.size > 0) return function() {
            refs.forEach(function(ref) {
                var cleanup = cleanupMap.get(ref);
                if (cleanup) cleanup();
                else assignRef(ref, null);
            });
            cleanupMap.clear();
        };
    };
}
function useMergedRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return React.useCallback(mergeRefs.apply(void 0, (0, _toConsumableArray._)(refs)), refs);
}
exports.assignRef = assignRef;
exports.mergeRefs = mergeRefs;
exports.useMergedRef = useMergedRef; //# sourceMappingURL=use-merged-ref.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","dbcdb03778f6dc28":"9MtAM"}],"f8zO2":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("2225edfc16946877");
function useMouse() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        resetOnExit: false
    };
    var _React_useState = (0, _slicedToArray._)(React.useState({
        x: 0,
        y: 0
    }), 2), position = _React_useState[0], setPosition = _React_useState[1];
    var ref = React.useRef(null);
    var setMousePosition = function(event) {
        if (ref.current) {
            var rect = event.currentTarget.getBoundingClientRect();
            var x = Math.max(0, Math.round(event.pageX - rect.left - (window.pageXOffset || window.scrollX)));
            var y = Math.max(0, Math.round(event.pageY - rect.top - (window.pageYOffset || window.scrollY)));
            setPosition({
                x,
                y
            });
        } else setPosition({
            x: event.clientX,
            y: event.clientY
        });
    };
    var resetMousePosition = function() {
        return setPosition({
            x: 0,
            y: 0
        });
    };
    React.useEffect(function() {
        var element = (ref === null || ref === void 0 ? void 0 : ref.current) ? ref.current : document;
        element.addEventListener("mousemove", setMousePosition);
        if (options.resetOnExit) element.addEventListener("mouseleave", resetMousePosition);
        return function() {
            element.removeEventListener("mousemove", setMousePosition);
            if (options.resetOnExit) element.removeEventListener("mouseleave", resetMousePosition);
        };
    }, [
        ref.current
    ]);
    return (0, _objectSpread._)({
        ref
    }, position);
}
exports.useMouse = useMouse; //# sourceMappingURL=use-mouse.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_sliced_to_array":"lAYt5","2225edfc16946877":"9MtAM"}],"9GwOu":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("22b5b1e8c6e7dc89");
var clamp = require("f4adec9f06e02ac1");
function clampUseMovePosition(position) {
    return {
        x: clamp.clamp(position.x, 0, 1),
        y: clamp.clamp(position.y, 0, 1)
    };
}
function useMove(onChange, handlers) {
    var dir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "ltr";
    var ref = React.useRef(null);
    var mounted = React.useRef(false);
    var isSliding = React.useRef(false);
    var frame = React.useRef(0);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), active = _React_useState[0], setActive = _React_useState[1];
    React.useEffect(function() {
        mounted.current = true;
    }, []);
    React.useEffect(function() {
        var node = ref.current;
        var onScrub = function(param) {
            var x = param.x, y = param.y;
            cancelAnimationFrame(frame.current);
            frame.current = requestAnimationFrame(function() {
                if (mounted.current && node) {
                    node.style.userSelect = "none";
                    var rect = node.getBoundingClientRect();
                    if (rect.width && rect.height) {
                        var _x = clamp.clamp((x - rect.left) / rect.width, 0, 1);
                        onChange({
                            x: dir === "ltr" ? _x : 1 - _x,
                            y: clamp.clamp((y - rect.top) / rect.height, 0, 1)
                        });
                    }
                }
            });
        };
        var bindEvents = function() {
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", stopScrubbing);
            document.addEventListener("touchmove", onTouchMove);
            document.addEventListener("touchend", stopScrubbing);
        };
        var unbindEvents = function() {
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", stopScrubbing);
            document.removeEventListener("touchmove", onTouchMove);
            document.removeEventListener("touchend", stopScrubbing);
        };
        var startScrubbing = function() {
            if (!isSliding.current && mounted.current) {
                isSliding.current = true;
                typeof (handlers === null || handlers === void 0 ? void 0 : handlers.onScrubStart) === "function" && handlers.onScrubStart();
                setActive(true);
                bindEvents();
            }
        };
        var stopScrubbing = function() {
            if (isSliding.current && mounted.current) {
                isSliding.current = false;
                setActive(false);
                unbindEvents();
                setTimeout(function() {
                    typeof (handlers === null || handlers === void 0 ? void 0 : handlers.onScrubEnd) === "function" && handlers.onScrubEnd();
                }, 0);
            }
        };
        var onMouseDown = function(event) {
            startScrubbing();
            event.preventDefault();
            onMouseMove(event);
        };
        var onMouseMove = function(event) {
            return onScrub({
                x: event.clientX,
                y: event.clientY
            });
        };
        var onTouchStart = function(event) {
            if (event.cancelable) event.preventDefault();
            startScrubbing();
            onTouchMove(event);
        };
        var onTouchMove = function(event) {
            if (event.cancelable) event.preventDefault();
            onScrub({
                x: event.changedTouches[0].clientX,
                y: event.changedTouches[0].clientY
            });
        };
        node === null || node === void 0 ? void 0 : node.addEventListener("mousedown", onMouseDown);
        node === null || node === void 0 ? void 0 : node.addEventListener("touchstart", onTouchStart, {
            passive: false
        });
        return function() {
            if (node) {
                node.removeEventListener("mousedown", onMouseDown);
                node.removeEventListener("touchstart", onTouchStart);
            }
        };
    }, [
        dir,
        onChange
    ]);
    return {
        ref,
        active
    };
}
exports.clampUseMovePosition = clampUseMovePosition;
exports.useMove = useMove; //# sourceMappingURL=use-move.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","22b5b1e8c6e7dc89":"9MtAM","f4adec9f06e02ac1":"dyyig"}],"7oJut":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("2114349d7fd123e2");
var useUncontrolled = require("d715f59730dc0b80");
function range(start, end) {
    var length = end - start + 1;
    return Array.from({
        length
    }, function(_, index) {
        return index + start;
    });
}
var DOTS = "dots";
function usePagination(param) {
    var total = param.total, _param_siblings = param.siblings, siblings = _param_siblings === void 0 ? 1 : _param_siblings, _param_boundaries = param.boundaries, boundaries = _param_boundaries === void 0 ? 1 : _param_boundaries, page = param.page, _param_initialPage = param.initialPage, initialPage = _param_initialPage === void 0 ? 1 : _param_initialPage, onChange = param.onChange;
    var _total = Math.max(Math.trunc(total), 0);
    var _useUncontrolled_useUncontrolled = (0, _slicedToArray._)(useUncontrolled.useUncontrolled({
        value: page,
        onChange,
        defaultValue: initialPage,
        finalValue: initialPage
    }), 2), activePage = _useUncontrolled_useUncontrolled[0], setActivePage = _useUncontrolled_useUncontrolled[1];
    var setPage = function(pageNumber) {
        if (pageNumber <= 0) setActivePage(1);
        else if (pageNumber > _total) setActivePage(_total);
        else setActivePage(pageNumber);
    };
    var next = function() {
        return setPage(activePage + 1);
    };
    var previous = function() {
        return setPage(activePage - 1);
    };
    var first = function() {
        return setPage(1);
    };
    var last = function() {
        return setPage(_total);
    };
    var paginationRange = React.useMemo(function() {
        var totalPageNumbers = siblings * 2 + 3 + boundaries * 2;
        if (totalPageNumbers >= _total) return range(1, _total);
        var leftSiblingIndex = Math.max(activePage - siblings, boundaries);
        var rightSiblingIndex = Math.min(activePage + siblings, _total - boundaries);
        var shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
        var shouldShowRightDots = rightSiblingIndex < _total - (boundaries + 1);
        if (!shouldShowLeftDots && shouldShowRightDots) {
            var leftItemCount = siblings * 2 + boundaries + 2;
            return (0, _toConsumableArray._)(range(1, leftItemCount)).concat([
                DOTS
            ], (0, _toConsumableArray._)(range(_total - (boundaries - 1), _total)));
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            var rightItemCount = boundaries + 1 + 2 * siblings;
            return (0, _toConsumableArray._)(range(1, boundaries)).concat([
                DOTS
            ], (0, _toConsumableArray._)(range(_total - rightItemCount, _total)));
        }
        return (0, _toConsumableArray._)(range(1, boundaries)).concat([
            DOTS
        ], (0, _toConsumableArray._)(range(leftSiblingIndex, rightSiblingIndex)), [
            DOTS
        ], (0, _toConsumableArray._)(range(_total - boundaries + 1, _total)));
    }, [
        _total,
        siblings,
        activePage
    ]);
    return {
        range: paginationRange,
        active: activePage,
        setPage,
        next,
        previous,
        first,
        last
    };
}
exports.DOTS = DOTS;
exports.usePagination = usePagination; //# sourceMappingURL=use-pagination.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","2114349d7fd123e2":"9MtAM","d715f59730dc0b80":"VbK7f"}],"VbK7f":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("b7342308f29facb3");
function useUncontrolled(param) {
    var value = param.value, defaultValue = param.defaultValue, finalValue = param.finalValue, _param_onChange = param.onChange, onChange = _param_onChange === void 0 ? function() {} : _param_onChange;
    var _React_useState = (0, _slicedToArray._)(React.useState(defaultValue !== void 0 ? defaultValue : finalValue), 2), uncontrolledValue = _React_useState[0], setUncontrolledValue = _React_useState[1];
    var handleUncontrolledChange = function(val) {
        for(var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            payload[_key - 1] = arguments[_key];
        }
        setUncontrolledValue(val);
        onChange === null || onChange === void 0 ? void 0 : onChange.apply(void 0, [
            val
        ].concat((0, _toConsumableArray._)(payload)));
    };
    if (value !== void 0) return [
        value,
        onChange,
        true
    ];
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
}
exports.useUncontrolled = useUncontrolled; //# sourceMappingURL=use-uncontrolled.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","b7342308f29facb3":"9MtAM"}],"iKzBK":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("db447ef5be380bb7");
function useQueue(param) {
    var _param_initialValues = param.initialValues, initialValues = _param_initialValues === void 0 ? [] : _param_initialValues, limit = param.limit;
    var _React_useState = (0, _slicedToArray._)(React.useState({
        state: initialValues.slice(0, limit),
        queue: initialValues.slice(limit)
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    var add = function() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        return setState(function(current) {
            var results = (0, _toConsumableArray._)(current.state).concat((0, _toConsumableArray._)(current.queue), (0, _toConsumableArray._)(items));
            return {
                state: results.slice(0, limit),
                queue: results.slice(limit)
            };
        });
    };
    var update = function(fn) {
        return setState(function(current) {
            var results = fn((0, _toConsumableArray._)(current.state).concat((0, _toConsumableArray._)(current.queue)));
            return {
                state: results.slice(0, limit),
                queue: results.slice(limit)
            };
        });
    };
    var cleanQueue = function() {
        return setState(function(current) {
            return {
                state: current.state,
                queue: []
            };
        });
    };
    return {
        state: state.state,
        queue: state.queue,
        add,
        update,
        cleanQueue
    };
}
exports.useQueue = useQueue; //# sourceMappingURL=use-queue.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","db447ef5be380bb7":"9MtAM"}],"934ka":[function(require,module,exports) {
"use client";
"use strict";
var React = require("c7101fc88e5e2505");
function usePageLeave(onPageLeave) {
    React.useEffect(function() {
        document.documentElement.addEventListener("mouseleave", onPageLeave);
        return function() {
            return document.documentElement.removeEventListener("mouseleave", onPageLeave);
        };
    }, []);
}
exports.usePageLeave = usePageLeave; //# sourceMappingURL=use-page-leave.cjs.map

},{"c7101fc88e5e2505":"9MtAM"}],"1SXoj":[function(require,module,exports) {
"use client";
"use strict";
var useMediaQuery = require("590aaa16c567d991");
function useReducedMotion(initialValue, options) {
    return useMediaQuery.useMediaQuery("(prefers-reduced-motion: reduce)", initialValue, options);
}
exports.useReducedMotion = useReducedMotion; //# sourceMappingURL=use-reduced-motion.cjs.map

},{"590aaa16c567d991":"4d5kZ"}],"gkTyC":[function(require,module,exports) {
"use client";
"use strict";
var React = require("dcf64513966321f8");
var useReducedMotion = require("4d48ec5119ab4975");
var useWindowEvent = require("12ed16e64a957fa");
var easeInOutQuad = require("ec68d048b0ff9785");
var getRelativePosition = require("f6f2fef0538e0d90");
var getScrollStart = require("ffe7456301b1997c");
var setScrollParam = require("a86d1395b3379639");
function useScrollIntoView() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 1250 : _ref_duration, _ref_axis = _ref.axis, axis = _ref_axis === void 0 ? "y" : _ref_axis, onScrollFinish = _ref.onScrollFinish, _ref_easing = _ref.easing, easing = _ref_easing === void 0 ? easeInOutQuad.easeInOutQuad : _ref_easing, _ref_offset = _ref.offset, offset = _ref_offset === void 0 ? 0 : _ref_offset, _ref_cancelable = _ref.cancelable, cancelable = _ref_cancelable === void 0 ? true : _ref_cancelable, _ref_isList = _ref.isList, isList = _ref_isList === void 0 ? false : _ref_isList;
    var frameID = React.useRef(0);
    var startTime = React.useRef(0);
    var shouldStop = React.useRef(false);
    var scrollableRef = React.useRef(null);
    var targetRef = React.useRef(null);
    var reducedMotion = useReducedMotion.useReducedMotion();
    var cancel = function() {
        if (frameID.current) cancelAnimationFrame(frameID.current);
    };
    var scrollIntoView = React.useCallback(function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_alignment = _ref.alignment, alignment = _ref_alignment === void 0 ? "start" : _ref_alignment;
        shouldStop.current = false;
        if (frameID.current) cancel();
        var _getScrollStart_getScrollStart;
        var start = (_getScrollStart_getScrollStart = getScrollStart.getScrollStart({
            parent: scrollableRef.current,
            axis
        })) !== null && _getScrollStart_getScrollStart !== void 0 ? _getScrollStart_getScrollStart : 0;
        var change = getRelativePosition.getRelativePosition({
            parent: scrollableRef.current,
            target: targetRef.current,
            axis,
            alignment,
            offset,
            isList
        }) - (scrollableRef.current ? 0 : start);
        function animateScroll() {
            if (startTime.current === 0) startTime.current = performance.now();
            var now = performance.now();
            var elapsed = now - startTime.current;
            var t = reducedMotion || duration === 0 ? 1 : elapsed / duration;
            var distance = start + change * easing(t);
            setScrollParam.setScrollParam({
                parent: scrollableRef.current,
                axis,
                distance
            });
            if (!shouldStop.current && t < 1) frameID.current = requestAnimationFrame(animateScroll);
            else {
                typeof onScrollFinish === "function" && onScrollFinish();
                startTime.current = 0;
                frameID.current = 0;
                cancel();
            }
        }
        animateScroll();
    }, [
        axis,
        duration,
        easing,
        isList,
        offset,
        onScrollFinish,
        reducedMotion
    ]);
    var handleStop = function() {
        if (cancelable) shouldStop.current = true;
    };
    useWindowEvent.useWindowEvent("wheel", handleStop, {
        passive: true
    });
    useWindowEvent.useWindowEvent("touchmove", handleStop, {
        passive: true
    });
    React.useEffect(function() {
        return cancel;
    }, []);
    return {
        scrollableRef,
        targetRef,
        scrollIntoView,
        cancel
    };
}
exports.useScrollIntoView = useScrollIntoView; //# sourceMappingURL=use-scroll-into-view.cjs.map

},{"dcf64513966321f8":"9MtAM","4d48ec5119ab4975":"1SXoj","12ed16e64a957fa":"3gP2S","ec68d048b0ff9785":"kIy7x","f6f2fef0538e0d90":"4l5mb","ffe7456301b1997c":"8pDTr","a86d1395b3379639":"gsdpp"}],"kIy7x":[function(require,module,exports) {
"use client";
"use strict";
var easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
exports.easeInOutQuad = easeInOutQuad; //# sourceMappingURL=ease-in-out-quad.cjs.map

},{}],"4l5mb":[function(require,module,exports) {
"use client";
"use strict";
var getRelativePosition = function(param) {
    var axis = param.axis, target = param.target, parent = param.parent, alignment = param.alignment, offset = param.offset, isList = param.isList;
    if (!target || !parent && typeof document === "undefined") return 0;
    var isCustomParent = !!parent;
    var parentElement = parent || document.body;
    var parentPosition = parentElement.getBoundingClientRect();
    var targetPosition = target.getBoundingClientRect();
    var getDiff = function(property) {
        return targetPosition[property] - parentPosition[property];
    };
    if (axis === "y") {
        var diff = getDiff("top");
        if (diff === 0) return 0;
        if (alignment === "start") {
            var distance = diff - offset;
            var shouldScroll = distance <= targetPosition.height * (isList ? 0 : 1) || !isList;
            return shouldScroll ? distance : 0;
        }
        var parentHeight = isCustomParent ? parentPosition.height : window.innerHeight;
        if (alignment === "end") {
            var distance1 = diff + offset - parentHeight + targetPosition.height;
            var shouldScroll1 = distance1 >= -targetPosition.height * (isList ? 0 : 1) || !isList;
            return shouldScroll1 ? distance1 : 0;
        }
        if (alignment === "center") return diff - parentHeight / 2 + targetPosition.height / 2;
        return 0;
    }
    if (axis === "x") {
        var diff1 = getDiff("left");
        if (diff1 === 0) return 0;
        if (alignment === "start") {
            var distance2 = diff1 - offset;
            var shouldScroll2 = distance2 <= targetPosition.width || !isList;
            return shouldScroll2 ? distance2 : 0;
        }
        var parentWidth = isCustomParent ? parentPosition.width : window.innerWidth;
        if (alignment === "end") {
            var distance3 = diff1 + offset - parentWidth + targetPosition.width;
            var shouldScroll3 = distance3 >= -targetPosition.width || !isList;
            return shouldScroll3 ? distance3 : 0;
        }
        if (alignment === "center") return diff1 - parentWidth / 2 + targetPosition.width / 2;
        return 0;
    }
    return 0;
};
exports.getRelativePosition = getRelativePosition; //# sourceMappingURL=get-relative-position.cjs.map

},{}],"8pDTr":[function(require,module,exports) {
"use client";
"use strict";
var getScrollStart = function(param) {
    var axis = param.axis, parent = param.parent;
    if (!parent && typeof document === "undefined") return 0;
    var method = axis === "y" ? "scrollTop" : "scrollLeft";
    if (parent) return parent[method];
    var body = document.body, documentElement = document.documentElement;
    return body[method] + documentElement[method];
};
exports.getScrollStart = getScrollStart; //# sourceMappingURL=get-scroll-start.cjs.map

},{}],"gsdpp":[function(require,module,exports) {
"use client";
"use strict";
var setScrollParam = function(param) {
    var axis = param.axis, parent = param.parent, distance = param.distance;
    if (!parent && typeof document === "undefined") return;
    var method = axis === "y" ? "scrollTop" : "scrollLeft";
    if (parent) parent[method] = distance;
    else {
        var body = document.body, documentElement = document.documentElement;
        body[method] = distance;
        documentElement[method] = distance;
    }
};
exports.setScrollParam = setScrollParam; //# sourceMappingURL=set-scroll-param.cjs.map

},{}],"1Vlw3":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("ce2c494fe72a0c5a");
var defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function useResizeObserver(options) {
    var frameID = React.useRef(0);
    var ref = React.useRef(null);
    var _React_useState = (0, _slicedToArray._)(React.useState(defaultState), 2), rect = _React_useState[0], setRect = _React_useState[1];
    var observer = React.useMemo(function() {
        return typeof window !== "undefined" ? new ResizeObserver(function(entries) {
            var entry = entries[0];
            if (entry) {
                cancelAnimationFrame(frameID.current);
                frameID.current = requestAnimationFrame(function() {
                    if (ref.current) {
                        var _entry_borderBoxSize, _entry_contentBoxSize;
                        var boxSize = ((_entry_borderBoxSize = entry.borderBoxSize) === null || _entry_borderBoxSize === void 0 ? void 0 : _entry_borderBoxSize[0]) || ((_entry_contentBoxSize = entry.contentBoxSize) === null || _entry_contentBoxSize === void 0 ? void 0 : _entry_contentBoxSize[0]);
                        if (boxSize) {
                            var width = boxSize.inlineSize;
                            var height = boxSize.blockSize;
                            setRect({
                                width,
                                height,
                                x: entry.contentRect.x,
                                y: entry.contentRect.y,
                                top: entry.contentRect.top,
                                left: entry.contentRect.left,
                                bottom: entry.contentRect.bottom,
                                right: entry.contentRect.right
                            });
                        } else setRect(entry.contentRect);
                    }
                });
            }
        }) : null;
    }, []);
    React.useEffect(function() {
        if (ref.current) observer === null || observer === void 0 ? void 0 : observer.observe(ref.current, options);
        return function() {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            if (frameID.current) cancelAnimationFrame(frameID.current);
        };
    }, [
        ref.current
    ]);
    return [
        ref,
        rect
    ];
}
function useElementSize(options) {
    var _useResizeObserver = (0, _slicedToArray._)(useResizeObserver(options), 2), ref = _useResizeObserver[0], _useResizeObserver_ = _useResizeObserver[1], width = _useResizeObserver_.width, height = _useResizeObserver_.height;
    return {
        ref,
        width,
        height
    };
}
exports.useElementSize = useElementSize;
exports.useResizeObserver = useResizeObserver; //# sourceMappingURL=use-resize-observer.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","ce2c494fe72a0c5a":"9MtAM"}],"8QkBF":[function(require,module,exports) {
"use client";
"use strict";
var React = require("7677d0583f0f38d6");
var shallowEqual = require("d1386d86e969269f");
function shallowCompare(prevValue, currValue) {
    if (!prevValue || !currValue) return false;
    if (prevValue === currValue) return true;
    if (prevValue.length !== currValue.length) return false;
    for(var i = 0; i < prevValue.length; i += 1){
        if (!shallowEqual.shallowEqual(prevValue[i], currValue[i])) return false;
    }
    return true;
}
function useShallowCompare(dependencies) {
    var ref = React.useRef([]);
    var updateRef = React.useRef(0);
    if (!shallowCompare(ref.current, dependencies)) {
        ref.current = dependencies;
        updateRef.current += 1;
    }
    return [
        updateRef.current
    ];
}
function useShallowEffect(cb, dependencies) {
    React.useEffect(cb, useShallowCompare(dependencies));
}
exports.useShallowEffect = useShallowEffect; //# sourceMappingURL=use-shallow-effect.cjs.map

},{"7677d0583f0f38d6":"9MtAM","d1386d86e969269f":"bSsVQ"}],"8JDKK":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("45eda587e438451e");
function useToggle() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        false,
        true
    ];
    var _React_useReducer = (0, _slicedToArray._)(React.useReducer(function(state, action) {
        var value = action instanceof Function ? action(state[0]) : action;
        var index = Math.abs(state.indexOf(value));
        return state.slice(index).concat(state.slice(0, index));
    }, options), 2), _React_useReducer_ = (0, _slicedToArray._)(_React_useReducer[0], 1), option = _React_useReducer_[0], toggle = _React_useReducer[1];
    return [
        option,
        toggle
    ];
}
exports.useToggle = useToggle; //# sourceMappingURL=use-toggle.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","45eda587e438451e":"9MtAM"}],"6D6gB":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("5728ffa154294705");
var useWindowEvent = require("6b08ae9c64805271");
var eventListerOptions = {
    passive: true
};
function useViewportSize() {
    var _React_useState = (0, _slicedToArray._)(React.useState({
        width: 0,
        height: 0
    }), 2), windowSize = _React_useState[0], setWindowSize = _React_useState[1];
    var setSize = React.useCallback(function() {
        setWindowSize({
            width: window.innerWidth || 0,
            height: window.innerHeight || 0
        });
    }, []);
    useWindowEvent.useWindowEvent("resize", setSize, eventListerOptions);
    useWindowEvent.useWindowEvent("orientationchange", setSize, eventListerOptions);
    React.useEffect(setSize, []);
    return windowSize;
}
exports.useViewportSize = useViewportSize; //# sourceMappingURL=use-viewport-size.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","5728ffa154294705":"9MtAM","6b08ae9c64805271":"3gP2S"}],"6PU4b":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("8e720a01b7c6bc31");
var useWindowEvent = require("bf89f8c0169dfdb2");
function getScrollPosition() {
    return typeof window !== "undefined" ? {
        x: window.pageXOffset,
        y: window.pageYOffset
    } : {
        x: 0,
        y: 0
    };
}
function scrollTo(param) {
    var x = param.x, y = param.y;
    if (typeof window !== "undefined") {
        var scrollOptions = {
            behavior: "smooth"
        };
        if (typeof x === "number") scrollOptions.left = x;
        if (typeof y === "number") scrollOptions.top = y;
        window.scrollTo(scrollOptions);
    }
}
function useWindowScroll() {
    var _React_useState = (0, _slicedToArray._)(React.useState({
        x: 0,
        y: 0
    }), 2), position = _React_useState[0], setPosition = _React_useState[1];
    useWindowEvent.useWindowEvent("scroll", function() {
        return setPosition(getScrollPosition());
    });
    useWindowEvent.useWindowEvent("resize", function() {
        return setPosition(getScrollPosition());
    });
    React.useEffect(function() {
        setPosition(getScrollPosition());
    }, []);
    return [
        position,
        scrollTo
    ];
}
exports.useWindowScroll = useWindowScroll; //# sourceMappingURL=use-window-scroll.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","8e720a01b7c6bc31":"9MtAM","bf89f8c0169dfdb2":"3gP2S"}],"2yM9D":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("fbfc2fcd87d068ea");
function useIntersection(options) {
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), entry = _React_useState[0], setEntry = _React_useState[1];
    var observer = React.useRef(null);
    var ref = React.useCallback(function(element) {
        if (observer.current) {
            observer.current.disconnect();
            observer.current = null;
        }
        if (element === null) {
            setEntry(null);
            return;
        }
        observer.current = new IntersectionObserver(function(param) {
            var _param = (0, _slicedToArray._)(param, 1), _entry = _param[0];
            setEntry(_entry);
        }, options);
        observer.current.observe(element);
    }, [
        options === null || options === void 0 ? void 0 : options.rootMargin,
        options === null || options === void 0 ? void 0 : options.root,
        options === null || options === void 0 ? void 0 : options.threshold
    ]);
    return {
        ref,
        entry
    };
}
exports.useIntersection = useIntersection; //# sourceMappingURL=use-intersection.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","fbfc2fcd87d068ea":"9MtAM"}],"4JjEY":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("c53c264fb3583c5c");
var useWindowEvent = require("9c3fd18519864a3f");
function useHash() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_getInitialValueInEffect = _ref.getInitialValueInEffect, getInitialValueInEffect = _ref_getInitialValueInEffect === void 0 ? true : _ref_getInitialValueInEffect;
    var _React_useState = (0, _slicedToArray._)(React.useState(getInitialValueInEffect ? "" : window.location.hash || ""), 2), hash = _React_useState[0], setHash = _React_useState[1];
    var setHashHandler = function(value) {
        var valueWithHash = value.startsWith("#") ? value : `#${value}`;
        window.location.hash = valueWithHash;
        setHash(valueWithHash);
    };
    useWindowEvent.useWindowEvent("hashchange", function() {
        var newHash = window.location.hash;
        if (hash !== newHash) setHash(newHash);
    });
    React.useEffect(function() {
        if (getInitialValueInEffect) setHash(window.location.hash);
    }, []);
    return [
        hash,
        setHashHandler
    ];
}
exports.useHash = useHash; //# sourceMappingURL=use-hash.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","c53c264fb3583c5c":"9MtAM","9c3fd18519864a3f":"3gP2S"}],"kBqBN":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("c7d4809336a4901");
var parseHotkey = require("e5cdcafe002d92f4");
function shouldFireEvent(event, tagsToIgnore) {
    var triggerOnContentEditable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (event.target instanceof HTMLElement) {
        if (triggerOnContentEditable) return !tagsToIgnore.includes(event.target.tagName);
        return !event.target.isContentEditable && !tagsToIgnore.includes(event.target.tagName);
    }
    return true;
}
function useHotkeys(hotkeys) {
    var tagsToIgnore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        "INPUT",
        "TEXTAREA",
        "SELECT"
    ], triggerOnContentEditable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    React.useEffect(function() {
        var keydownListener = function(event) {
            hotkeys.forEach(function(param) {
                var _param = (0, _slicedToArray._)(param, 3), hotkey = _param[0], handler = _param[1], tmp = _param[2], options = tmp === void 0 ? {
                    preventDefault: true,
                    usePhysicalKeys: false
                } : tmp;
                if (parseHotkey.getHotkeyMatcher(hotkey, options.usePhysicalKeys)(event) && shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable)) {
                    if (options.preventDefault) event.preventDefault();
                    handler(event);
                }
            });
        };
        document.documentElement.addEventListener("keydown", keydownListener);
        return function() {
            return document.documentElement.removeEventListener("keydown", keydownListener);
        };
    }, [
        hotkeys
    ]);
}
exports.getHotkeyHandler = parseHotkey.getHotkeyHandler;
exports.useHotkeys = useHotkeys; //# sourceMappingURL=use-hotkeys.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","c7d4809336a4901":"9MtAM","e5cdcafe002d92f4":"7F5XT"}],"7F5XT":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var keyNameMap = {
    " ": "space",
    ArrowLeft: "arrowleft",
    ArrowRight: "arrowright",
    ArrowUp: "arrowup",
    ArrowDown: "arrowdown",
    Escape: "esc",
    Esc: "esc",
    Enter: "enter",
    Tab: "tab",
    Backspace: "backspace",
    Delete: "delete",
    Insert: "insert",
    Home: "home",
    End: "end",
    PageUp: "pageup",
    PageDown: "pagedown",
    "+": "plus",
    "-": "minus",
    "*": "asterisk",
    "/": "slash"
};
function normalizeKey(key) {
    var lowerKey = key.replace("Key", "").toLowerCase();
    return keyNameMap[key] || lowerKey;
}
function parseHotkey(hotkey) {
    var keys = hotkey.toLowerCase().split("+").map(function(part) {
        return part.trim();
    });
    var modifiers = {
        alt: keys.includes("alt"),
        ctrl: keys.includes("ctrl"),
        meta: keys.includes("meta"),
        mod: keys.includes("mod"),
        shift: keys.includes("shift"),
        plus: keys.includes("[plus]")
    };
    var reservedKeys = [
        "alt",
        "ctrl",
        "meta",
        "shift",
        "mod"
    ];
    var freeKey = keys.find(function(key) {
        return !reservedKeys.includes(key);
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, modifiers), {
        key: freeKey === "[plus]" ? "+" : freeKey
    });
}
function isExactHotkey(hotkey, event, usePhysicalKeys) {
    var alt = hotkey.alt, ctrl = hotkey.ctrl, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, key = hotkey.key;
    var altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey, pressedKey = event.key, pressedCode = event.code;
    if (alt !== altKey) return false;
    if (mod) {
        if (!ctrlKey && !metaKey) return false;
    } else {
        if (ctrl !== ctrlKey) return false;
        if (meta !== metaKey) return false;
    }
    if (shift !== shiftKey) return false;
    if (key && (usePhysicalKeys ? normalizeKey(pressedCode) === normalizeKey(key) : normalizeKey(pressedKey !== null && pressedKey !== void 0 ? pressedKey : pressedCode) === normalizeKey(key))) return true;
    return false;
}
function getHotkeyMatcher(hotkey, usePhysicalKeys) {
    return function(event) {
        return isExactHotkey(parseHotkey(hotkey), event, usePhysicalKeys);
    };
}
function getHotkeyHandler(hotkeys) {
    return function(event) {
        var _event = "nativeEvent" in event ? event.nativeEvent : event;
        hotkeys.forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 3), hotkey = _param[0], handler = _param[1], tmp = _param[2], options = tmp === void 0 ? {
                preventDefault: true,
                usePhysicalKeys: false
            } : tmp;
            if (getHotkeyMatcher(hotkey, options.usePhysicalKeys)(_event)) {
                if (options.preventDefault) event.preventDefault();
                handler(_event);
            }
        });
    };
}
exports.getHotkeyHandler = getHotkeyHandler;
exports.getHotkeyMatcher = getHotkeyMatcher;
exports.parseHotkey = parseHotkey; //# sourceMappingURL=parse-hotkey.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5"}],"g1D8V":[function(require,module,exports) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use client";
"use strict";
var React = require("d83db944f270c667");
function getFullscreenElement() {
    var _document = window.document;
    var fullscreenElement = _document.fullscreenElement || _document.webkitFullscreenElement || _document.mozFullScreenElement || _document.msFullscreenElement;
    return fullscreenElement;
}
function exitFullscreen() {
    var _document = window.document;
    if (typeof _document.exitFullscreen === "function") return _document.exitFullscreen();
    if (typeof _document.msExitFullscreen === "function") return _document.msExitFullscreen();
    if (typeof _document.webkitExitFullscreen === "function") return _document.webkitExitFullscreen();
    if (typeof _document.mozCancelFullScreen === "function") return _document.mozCancelFullScreen();
    return null;
}
function enterFullScreen(element) {
    var _element_requestFullscreen, _element_msRequestFullscreen, _element_webkitEnterFullscreen, _element_webkitRequestFullscreen, _element_mozRequestFullscreen;
    var _element = element;
    return ((_element_requestFullscreen = _element.requestFullscreen) === null || _element_requestFullscreen === void 0 ? void 0 : _element_requestFullscreen.call(_element)) || ((_element_msRequestFullscreen = _element.msRequestFullscreen) === null || _element_msRequestFullscreen === void 0 ? void 0 : _element_msRequestFullscreen.call(_element)) || ((_element_webkitEnterFullscreen = _element.webkitEnterFullscreen) === null || _element_webkitEnterFullscreen === void 0 ? void 0 : _element_webkitEnterFullscreen.call(_element)) || ((_element_webkitRequestFullscreen = _element.webkitRequestFullscreen) === null || _element_webkitRequestFullscreen === void 0 ? void 0 : _element_webkitRequestFullscreen.call(_element)) || ((_element_mozRequestFullscreen = _element.mozRequestFullscreen) === null || _element_mozRequestFullscreen === void 0 ? void 0 : _element_mozRequestFullscreen.call(_element));
}
var prefixes = [
    "",
    "webkit",
    "moz",
    "ms"
];
function addEvents(element, param) {
    var onFullScreen = param.onFullScreen, onError = param.onError;
    prefixes.forEach(function(prefix) {
        element.addEventListener(`${prefix}fullscreenchange`, onFullScreen);
        element.addEventListener(`${prefix}fullscreenerror`, onError);
    });
    return function() {
        prefixes.forEach(function(prefix) {
            element.removeEventListener(`${prefix}fullscreenchange`, onFullScreen);
            element.removeEventListener(`${prefix}fullscreenerror`, onError);
        });
    };
}
function useFullscreen() {
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), fullscreen = _React_useState[0], setFullscreen = _React_useState[1];
    var _ref = React.useRef(null);
    var handleFullscreenChange = React.useCallback(function(event) {
        setFullscreen(event.target === getFullscreenElement());
    }, [
        setFullscreen
    ]);
    var handleFullscreenError = React.useCallback(function(event) {
        setFullscreen(false);
        console.error(`[@mantine/hooks] use-fullscreen: Error attempting full-screen mode method: ${event} (${event.target})`);
    }, [
        setFullscreen
    ]);
    var toggle = React.useCallback(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!getFullscreenElement()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        enterFullScreen(_ref.current)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        exitFullscreen()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), []);
    var ref = React.useCallback(function(element) {
        if (element === null) _ref.current = window.document.documentElement;
        else _ref.current = element;
    }, []);
    React.useEffect(function() {
        if (!_ref.current && window.document) {
            _ref.current = window.document.documentElement;
            return addEvents(_ref.current, {
                onFullScreen: handleFullscreenChange,
                onError: handleFullscreenError
            });
        }
        if (_ref.current) return addEvents(_ref.current, {
            onFullScreen: handleFullscreenChange,
            onError: handleFullscreenError
        });
        return void 0;
    }, [
        _ref.current
    ]);
    return {
        ref,
        toggle,
        fullscreen
    };
}
exports.useFullscreen = useFullscreen; //# sourceMappingURL=use-fullscreen.cjs.map

},{"@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_ts_generator":"dn4mF","d83db944f270c667":"9MtAM"}],"ivAdX":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("5000d38a67cd4733");
var useDidUpdate = require("7f9e2412fef5c8af");
function useLogger(componentName, props) {
    React.useEffect(function() {
        var _console;
        (_console = console).log.apply(_console, [
            `${componentName} mounted`
        ].concat((0, _toConsumableArray._)(props)));
        return function() {
            return console.log(`${componentName} unmounted`);
        };
    }, []);
    useDidUpdate.useDidUpdate(function() {
        var _console;
        (_console = console).log.apply(_console, [
            `${componentName} updated`
        ].concat((0, _toConsumableArray._)(props)));
    }, props);
    return null;
}
exports.useLogger = useLogger; //# sourceMappingURL=use-logger.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","5000d38a67cd4733":"9MtAM","7f9e2412fef5c8af":"6kFLu"}],"kljlx":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("9624480e52a39625");
function useHover() {
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), hovered = _React_useState[0], setHovered = _React_useState[1];
    var ref = React.useRef(null);
    var onMouseEnter = React.useCallback(function() {
        return setHovered(true);
    }, []);
    var onMouseLeave = React.useCallback(function() {
        return setHovered(false);
    }, []);
    React.useEffect(function() {
        var node = ref.current;
        if (node) {
            node.addEventListener("mouseenter", onMouseEnter);
            node.addEventListener("mouseleave", onMouseLeave);
            return function() {
                node === null || node === void 0 ? void 0 : node.removeEventListener("mouseenter", onMouseEnter);
                node === null || node === void 0 ? void 0 : node.removeEventListener("mouseleave", onMouseLeave);
            };
        }
        return void 0;
    }, [
        ref.current
    ]);
    return {
        ref,
        hovered
    };
}
exports.useHover = useHover; //# sourceMappingURL=use-hover.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","9624480e52a39625":"9MtAM"}],"80E1o":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("406b84354860842e");
function useValidatedState(initialValue, validation, initialValidationState) {
    var _React_useState = (0, _slicedToArray._)(React.useState(initialValue), 2), value = _React_useState[0], setValue = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(validation(initialValue) ? initialValue : void 0), 2), lastValidValue = _React_useState1[0], setLastValidValue = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState(typeof initialValidationState === "boolean" ? initialValidationState : validation(initialValue)), 2), valid = _React_useState2[0], setValid = _React_useState2[1];
    var onChange = function(val) {
        if (validation(val)) {
            setLastValidValue(val);
            setValid(true);
        } else setValid(false);
        setValue(val);
    };
    return [
        {
            value,
            lastValidValue,
            valid
        },
        onChange
    ];
}
exports.useValidatedState = useValidatedState; //# sourceMappingURL=use-validated-state.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","406b84354860842e":"9MtAM"}],"bmQpj":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("44a552f0efb3a9a2");
var useIsomorphicEffect = require("9faa1373ad59f28d");
function isMacOS(userAgent) {
    var macosPattern = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;
    return macosPattern.test(userAgent);
}
function isIOS(userAgent) {
    var iosPattern = /(iPhone)|(iPad)|(iPod)/i;
    return iosPattern.test(userAgent);
}
function isWindows(userAgent) {
    var windowsPattern = /(Win32)|(Win64)|(Windows)|(WinCE)/i;
    return windowsPattern.test(userAgent);
}
function isAndroid(userAgent) {
    var androidPattern = /Android/i;
    return androidPattern.test(userAgent);
}
function isLinux(userAgent) {
    var linuxPattern = /Linux/i;
    return linuxPattern.test(userAgent);
}
function getOS() {
    if (typeof window === "undefined") return "undetermined";
    var userAgent = window.navigator.userAgent;
    if (isIOS(userAgent) || isMacOS(userAgent) && "ontouchend" in document) return "ios";
    if (isMacOS(userAgent)) return "macos";
    if (isWindows(userAgent)) return "windows";
    if (isAndroid(userAgent)) return "android";
    if (isLinux(userAgent)) return "linux";
    return "undetermined";
}
function useOs() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        getValueInEffect: true
    };
    var _React_useState = (0, _slicedToArray._)(React.useState(options.getValueInEffect ? "undetermined" : getOS()), 2), value = _React_useState[0], setValue = _React_useState[1];
    useIsomorphicEffect.useIsomorphicEffect(function() {
        if (options.getValueInEffect) setValue(getOS);
    }, []);
    return value;
}
exports.useOs = useOs; //# sourceMappingURL=use-os.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","44a552f0efb3a9a2":"9MtAM","9faa1373ad59f28d":"hEZes"}],"2tmAh":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("dbb209aed64b8f37");
function useSetState(initialState) {
    var _React_useState = (0, _slicedToArray._)(React.useState(initialState), 2), state = _React_useState[0], setState = _React_useState[1];
    var _setState = React.useCallback(function(statePartial) {
        return setState(function(current) {
            return (0, _objectSpread._)({}, current, typeof statePartial === "function" ? statePartial(current) : statePartial);
        });
    }, []);
    return [
        state,
        _setState
    ];
}
exports.useSetState = useSetState; //# sourceMappingURL=use-set-state.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_sliced_to_array":"lAYt5","dbb209aed64b8f37":"9MtAM"}],"b29iI":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("490d194e359d3223");
function getInputOnChange(setValue) {
    return function(val) {
        if (!val) setValue(val);
        else if (typeof val === "function") setValue(val);
        else if (typeof val === "object" && "nativeEvent" in val) {
            var currentTarget = val.currentTarget;
            if (currentTarget.type === "checkbox") setValue(currentTarget.checked);
            else setValue(currentTarget.value);
        } else setValue(val);
    };
}
function useInputState(initialState) {
    var _React_useState = (0, _slicedToArray._)(React.useState(initialState), 2), value = _React_useState[0], setValue = _React_useState[1];
    return [
        value,
        getInputOnChange(setValue)
    ];
}
exports.getInputOnChange = getInputOnChange;
exports.useInputState = useInputState; //# sourceMappingURL=use-input-state.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","490d194e359d3223":"9MtAM"}],"039Fz":[function(require,module,exports) {
"use client";
"use strict";
var React = require("c2e91301f1c3052a");
function useEventListener(type, listener, options) {
    var ref = React.useRef(null);
    React.useEffect(function() {
        var node = ref.current;
        if (node) {
            node.addEventListener(type, listener, options);
            return function() {
                return node === null || node === void 0 ? void 0 : node.removeEventListener(type, listener, options);
            };
        }
        return void 0;
    }, [
        listener,
        options
    ]);
    return ref;
}
exports.useEventListener = useEventListener; //# sourceMappingURL=use-event-listener.cjs.map

},{"c2e91301f1c3052a":"9MtAM"}],"9XF1k":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("d4558923b4769a03");
function useDisclosure() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, callbacks = arguments.length > 1 ? arguments[1] : void 0;
    var _ref = callbacks || {}, onOpen = _ref.onOpen, onClose = _ref.onClose;
    var _React_useState = (0, _slicedToArray._)(React.useState(initialState), 2), opened = _React_useState[0], setOpened = _React_useState[1];
    var open = React.useCallback(function() {
        setOpened(function(isOpened) {
            if (!isOpened) {
                onOpen === null || onOpen === void 0 ? void 0 : onOpen();
                return true;
            }
            return isOpened;
        });
    }, [
        onOpen
    ]);
    var close = React.useCallback(function() {
        setOpened(function(isOpened) {
            if (isOpened) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                return false;
            }
            return isOpened;
        });
    }, [
        onClose
    ]);
    var toggle = React.useCallback(function() {
        opened ? close() : open();
    }, [
        close,
        open,
        opened
    ]);
    return [
        opened,
        {
            open,
            close,
            toggle
        }
    ];
}
exports.useDisclosure = useDisclosure; //# sourceMappingURL=use-disclosure.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","d4558923b4769a03":"9MtAM"}],"9cHDh":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("4f25873b20d43733");
function containsRelatedTarget(event) {
    if (event.currentTarget instanceof HTMLElement && event.relatedTarget instanceof HTMLElement) return event.currentTarget.contains(event.relatedTarget);
    return false;
}
function useFocusWithin() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, onBlur = _ref.onBlur, onFocus = _ref.onFocus;
    var ref = React.useRef(null);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), focused = _React_useState[0], setFocused = _React_useState[1];
    var focusedRef = React.useRef(false);
    var _setFocused = function(value) {
        setFocused(value);
        focusedRef.current = value;
    };
    var handleFocusIn = function(event) {
        if (!focusedRef.current) {
            _setFocused(true);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        }
    };
    var handleFocusOut = function(event) {
        if (focusedRef.current && !containsRelatedTarget(event)) {
            _setFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        }
    };
    React.useEffect(function() {
        var node = ref.current;
        if (node) {
            node.addEventListener("focusin", handleFocusIn);
            node.addEventListener("focusout", handleFocusOut);
            return function() {
                node === null || node === void 0 ? void 0 : node.removeEventListener("focusin", handleFocusIn);
                node === null || node === void 0 ? void 0 : node.removeEventListener("focusout", handleFocusOut);
            };
        }
        return void 0;
    }, [
        handleFocusIn,
        handleFocusOut
    ]);
    return {
        ref,
        focused
    };
}
exports.useFocusWithin = useFocusWithin; //# sourceMappingURL=use-focus-within.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","4f25873b20d43733":"9MtAM"}],"6sWMZ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("f32445bf510fabbd");
var useWindowEvent = require("d8b14fb133d548f");
function getConnection() {
    if (typeof navigator === "undefined") return {};
    var _navigator = navigator;
    var connection = _navigator.connection || _navigator.mozConnection || _navigator.webkitConnection;
    if (!connection) return {};
    return {
        downlink: connection === null || connection === void 0 ? void 0 : connection.downlink,
        downlinkMax: connection === null || connection === void 0 ? void 0 : connection.downlinkMax,
        effectiveType: connection === null || connection === void 0 ? void 0 : connection.effectiveType,
        rtt: connection === null || connection === void 0 ? void 0 : connection.rtt,
        saveData: connection === null || connection === void 0 ? void 0 : connection.saveData,
        type: connection === null || connection === void 0 ? void 0 : connection.type
    };
}
function useNetwork() {
    var _React_useState = (0, _slicedToArray._)(React.useState({
        online: true
    }), 2), status = _React_useState[0], setStatus = _React_useState[1];
    var handleConnectionChange = React.useCallback(function() {
        return setStatus(function(current) {
            return (0, _objectSpread._)({}, current, getConnection());
        });
    }, []);
    useWindowEvent.useWindowEvent("online", function() {
        return setStatus((0, _objectSpread._)({
            online: true
        }, getConnection()));
    });
    useWindowEvent.useWindowEvent("offline", function() {
        return setStatus((0, _objectSpread._)({
            online: false
        }, getConnection()));
    });
    React.useEffect(function() {
        var _navigator = navigator;
        if (_navigator.connection) {
            setStatus((0, _objectSpread._)({
                online: _navigator.onLine
            }, getConnection()));
            _navigator.connection.addEventListener("change", handleConnectionChange);
            return function() {
                return _navigator.connection.removeEventListener("change", handleConnectionChange);
            };
        }
        if (typeof _navigator.onLine === "boolean") setStatus(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                online: _navigator.onLine
            });
        });
        return void 0;
    }, []);
    return status;
}
exports.useNetwork = useNetwork; //# sourceMappingURL=use-network.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","f32445bf510fabbd":"9MtAM","d8b14fb133d548f":"3gP2S"}],"jcOil":[function(require,module,exports) {
"use client";
"use strict";
var React = require("a090264eb362156f");
function useTimeout(callback, delay) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        autoInvoke: false
    };
    var timeoutRef = React.useRef(null);
    var start = React.useCallback(function() {
        for(var _len = arguments.length, callbackParams = new Array(_len), _key = 0; _key < _len; _key++){
            callbackParams[_key] = arguments[_key];
        }
        if (!timeoutRef.current) timeoutRef.current = window.setTimeout(function() {
            callback(callbackParams);
            timeoutRef.current = null;
        }, delay);
    }, [
        delay
    ]);
    var clear = React.useCallback(function() {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    React.useEffect(function() {
        if (options.autoInvoke) start();
        return clear;
    }, [
        clear,
        start
    ]);
    return {
        start,
        clear
    };
}
exports.useTimeout = useTimeout; //# sourceMappingURL=use-timeout.cjs.map

},{"a090264eb362156f":"9MtAM"}],"hqmQm":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("a537200da8f88949");
var useForceUpdate = require("1fd7782d9a27b3ff");
function useTextSelection() {
    var forceUpdate = useForceUpdate.useForceUpdate();
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), selection = _React_useState[0], setSelection = _React_useState[1];
    var handleSelectionChange = function() {
        setSelection(document.getSelection());
        forceUpdate();
    };
    React.useEffect(function() {
        setSelection(document.getSelection());
        document.addEventListener("selectionchange", handleSelectionChange);
        return function() {
            return document.removeEventListener("selectionchange", handleSelectionChange);
        };
    }, []);
    return selection;
}
exports.useTextSelection = useTextSelection; //# sourceMappingURL=use-text-selection.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","a537200da8f88949":"9MtAM","1fd7782d9a27b3ff":"i8RNg"}],"9o9lY":[function(require,module,exports) {
"use client";
"use strict";
var React = require("9eb070eb2d6896d2");
function usePrevious(value) {
    var ref = React.useRef(void 0);
    React.useEffect(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
exports.usePrevious = usePrevious; //# sourceMappingURL=use-previous.cjs.map

},{"9eb070eb2d6896d2":"9MtAM"}],"ikLfP":[function(require,module,exports) {
"use client";
"use strict";
var React = require("63c6269127678431");
var useIsomorphicEffect = require("17af952121d58eae");
var MIME_TYPES = {
    ico: "image/x-icon",
    png: "image/png",
    svg: "image/svg+xml",
    gif: "image/gif"
};
function useFavicon(url) {
    var link = React.useRef(null);
    useIsomorphicEffect.useIsomorphicEffect(function() {
        if (!url) return;
        if (!link.current) {
            var existingElements = document.querySelectorAll('link[rel*="icon"]');
            existingElements.forEach(function(element2) {
                return document.head.removeChild(element2);
            });
            var element = document.createElement("link");
            element.rel = "shortcut icon";
            link.current = element;
            document.querySelector("head").appendChild(element);
        }
        var splittedUrl = url.split(".");
        link.current.setAttribute("type", MIME_TYPES[splittedUrl[splittedUrl.length - 1].toLowerCase()]);
        link.current.setAttribute("href", url);
    }, [
        url
    ]);
}
exports.useFavicon = useFavicon; //# sourceMappingURL=use-favicon.cjs.map

},{"63c6269127678431":"9MtAM","17af952121d58eae":"hEZes"}],"eFi7d":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("59921a8bc36ebd77");
var useIsomorphicEffect = require("63ffc3d70728de6f");
var useWindowScroll = require("7c262845a1c3297");
var isFixed = function(current, fixedAt) {
    return current <= fixedAt;
};
var isPinnedOrReleased = function(current, fixedAt, isCurrentlyPinnedRef, isScrollingUp, onPin, onRelease) {
    var isInFixedPosition = isFixed(current, fixedAt);
    if (isInFixedPosition && !isCurrentlyPinnedRef.current) {
        isCurrentlyPinnedRef.current = true;
        onPin === null || onPin === void 0 ? void 0 : onPin();
    } else if (!isInFixedPosition && isScrollingUp && !isCurrentlyPinnedRef.current) {
        isCurrentlyPinnedRef.current = true;
        onPin === null || onPin === void 0 ? void 0 : onPin();
    } else if (!isInFixedPosition && isCurrentlyPinnedRef.current) {
        isCurrentlyPinnedRef.current = false;
        onRelease === null || onRelease === void 0 ? void 0 : onRelease();
    }
};
var useScrollDirection = function() {
    var _React_useState = (0, _slicedToArray._)(React.useState(0), 2), lastScrollTop = _React_useState[0], setLastScrollTop = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(false), 2), isScrollingUp = _React_useState1[0], setIsScrollingUp = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState(false), 2), isResizing = _React_useState2[0], setIsResizing = _React_useState2[1];
    React.useEffect(function() {
        var resizeTimer;
        var onResize = function() {
            setIsResizing(true);
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                setIsResizing(false);
            }, 300);
        };
        var onScroll = function() {
            if (isResizing) return;
            var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsScrollingUp(currentScrollTop < lastScrollTop);
            setLastScrollTop(currentScrollTop);
        };
        window.addEventListener("scroll", onScroll);
        window.addEventListener("resize", onResize);
        return function() {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onResize);
        };
    }, [
        lastScrollTop,
        isResizing
    ]);
    return isScrollingUp;
};
function useHeadroom() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_fixedAt = _ref.fixedAt, fixedAt = _ref_fixedAt === void 0 ? 0 : _ref_fixedAt, onPin = _ref.onPin, onFix = _ref.onFix, onRelease = _ref.onRelease;
    var isCurrentlyPinnedRef = React.useRef(false);
    var isScrollingUp = useScrollDirection();
    var _useWindowScroll_useWindowScroll = (0, _slicedToArray._)(useWindowScroll.useWindowScroll(), 1), _useWindowScroll_useWindowScroll_ = _useWindowScroll_useWindowScroll[0], scrollPosition = _useWindowScroll_useWindowScroll_.y;
    useIsomorphicEffect.useIsomorphicEffect(function() {
        isPinnedOrReleased(scrollPosition, fixedAt, isCurrentlyPinnedRef, isScrollingUp, onPin, onRelease);
    }, [
        scrollPosition
    ]);
    useIsomorphicEffect.useIsomorphicEffect(function() {
        if (isFixed(scrollPosition, fixedAt)) onFix === null || onFix === void 0 ? void 0 : onFix();
    }, [
        scrollPosition,
        fixedAt,
        onFix
    ]);
    if (isFixed(scrollPosition, fixedAt) || isScrollingUp) return true;
    return false;
}
exports.isFixed = isFixed;
exports.isPinnedOrReleased = isPinnedOrReleased;
exports.useHeadroom = useHeadroom;
exports.useScrollDirection = useScrollDirection; //# sourceMappingURL=use-headroom.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","59921a8bc36ebd77":"9MtAM","63ffc3d70728de6f":"hEZes","7c262845a1c3297":"6PU4b"}],"2smM7":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("72acf18834d184bf");
var useIsomorphicEffect = require("541a747bc3cd49b9");
function isOpera() {
    return navigator.userAgent.includes("OPR");
}
function useEyeDropper() {
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), supported = _React_useState[0], setSupported = _React_useState[1];
    useIsomorphicEffect.useIsomorphicEffect(function() {
        setSupported(typeof window !== "undefined" && !isOpera() && "EyeDropper" in window);
    }, []);
    var open = React.useCallback(function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (supported) {
            var eyeDropper = new window.EyeDropper();
            return eyeDropper.open(options);
        }
        return Promise.resolve(void 0);
    }, [
        supported
    ]);
    return {
        supported,
        open
    };
}
exports.useEyeDropper = useEyeDropper; //# sourceMappingURL=use-eye-dropper.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","72acf18834d184bf":"9MtAM","541a747bc3cd49b9":"hEZes"}],"8CcKN":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("b173c16f862153da");
function useInViewport() {
    var observer = React.useRef(null);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), inViewport = _React_useState[0], setInViewport = _React_useState[1];
    var ref = React.useCallback(function(node) {
        if (typeof IntersectionObserver !== "undefined") {
            var _observer_current, _observer_current1;
            if (node && !observer.current) observer.current = new IntersectionObserver(function(entries) {
                return setInViewport(entries.some(function(entry) {
                    return entry.isIntersecting;
                }));
            });
            else (_observer_current = observer.current) === null || _observer_current === void 0 ? void 0 : _observer_current.disconnect();
            if (node) (_observer_current1 = observer.current) === null || _observer_current1 === void 0 ? void 0 : _observer_current1.observe(node);
            else setInViewport(false);
        }
    }, []);
    return {
        ref,
        inViewport
    };
}
exports.useInViewport = useInViewport; //# sourceMappingURL=use-in-viewport.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","b173c16f862153da":"9MtAM"}],"lQiUo":[function(require,module,exports) {
"use client";
"use strict";
var React = require("6350feab9a90710a");
function useMutationObserver(callback, options, target) {
    var observer = React.useRef(null);
    var ref = React.useRef(null);
    React.useEffect(function() {
        var targetElement = typeof target === "function" ? target() : target;
        if (targetElement || ref.current) {
            observer.current = new MutationObserver(callback);
            observer.current.observe(targetElement || ref.current, options);
        }
        return function() {
            var _observer_current;
            (_observer_current = observer.current) === null || _observer_current === void 0 ? void 0 : _observer_current.disconnect();
        };
    }, [
        callback,
        options
    ]);
    return ref;
}
exports.useMutationObserver = useMutationObserver; //# sourceMappingURL=use-mutation-observer.cjs.map

},{"6350feab9a90710a":"9MtAM"}],"UAZLU":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("75d57dc0b86cc75b");
function useMounted() {
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), mounted = _React_useState[0], setMounted = _React_useState[1];
    React.useEffect(function() {
        return setMounted(true);
    }, []);
    return mounted;
}
exports.useMounted = useMounted; //# sourceMappingURL=use-mounted.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","75d57dc0b86cc75b":"9MtAM"}],"50UyU":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("3b6fa67e1d7d5dc");
function useStateHistory(initialValue) {
    var _React_useState = (0, _slicedToArray._)(React.useState({
        history: [
            initialValue
        ],
        current: 0
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    var set = React.useCallback(function(val) {
        return setState(function(currentState) {
            var nextState = (0, _toConsumableArray._)(currentState.history.slice(0, currentState.current + 1)).concat([
                val
            ]);
            return {
                history: nextState,
                current: nextState.length - 1
            };
        });
    }, []);
    var back = React.useCallback(function() {
        var steps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        return setState(function(currentState) {
            return {
                history: currentState.history,
                current: Math.max(0, currentState.current - steps)
            };
        });
    }, []);
    var forward = React.useCallback(function() {
        var steps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        return setState(function(currentState) {
            return {
                history: currentState.history,
                current: Math.min(currentState.history.length - 1, currentState.current + steps)
            };
        });
    }, []);
    var reset = React.useCallback(function() {
        setState({
            history: [
                initialValue
            ],
            current: 0
        });
    }, [
        initialValue
    ]);
    var handlers = React.useMemo(function() {
        return {
            back,
            forward,
            reset,
            set
        };
    }, [
        back,
        forward,
        reset,
        set
    ]);
    return [
        state.history[state.current],
        handlers,
        state
    ];
}
exports.useStateHistory = useStateHistory; //# sourceMappingURL=use-state-history.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","3b6fa67e1d7d5dc":"9MtAM"}],"14aYX":[function(require,module,exports) {
"use client";
"use strict";
var React = require("8d7c45d665f7d574");
var useForceUpdate = require("79ef458497851157");
function useMap(initialState) {
    var mapRef = React.useRef(new Map(initialState));
    var forceUpdate = useForceUpdate.useForceUpdate();
    mapRef.current.set = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Map.prototype.set.apply(mapRef.current, args);
        forceUpdate();
        return mapRef.current;
    };
    mapRef.current.clear = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Map.prototype.clear.apply(mapRef.current, args);
        forceUpdate();
    };
    mapRef.current.delete = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var res = Map.prototype.delete.apply(mapRef.current, args);
        forceUpdate();
        return res;
    };
    return mapRef.current;
}
exports.useMap = useMap; //# sourceMappingURL=use-map.cjs.map

},{"8d7c45d665f7d574":"9MtAM","79ef458497851157":"i8RNg"}],"zR2VZ":[function(require,module,exports) {
"use client";
"use strict";
var React = require("653df227e3173573");
var useForceUpdate = require("5eea62fae3f38362");
function useSet(values) {
    var setRef = React.useRef(new Set(values));
    var forceUpdate = useForceUpdate.useForceUpdate();
    setRef.current.add = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var res = Set.prototype.add.apply(setRef.current, args);
        forceUpdate();
        return res;
    };
    setRef.current.clear = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Set.prototype.clear.apply(setRef.current, args);
        forceUpdate();
    };
    setRef.current.delete = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var res = Set.prototype.delete.apply(setRef.current, args);
        forceUpdate();
        return res;
    };
    return setRef.current;
}
exports.useSet = useSet; //# sourceMappingURL=use-set.cjs.map

},{"653df227e3173573":"9MtAM","5eea62fae3f38362":"i8RNg"}],"b5LJB":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("f225946d202321cb");
var useCallbackRef = require("4479b88fe9e4890");
function useThrottledCallbackWithClearTimeout(callback, wait) {
    var handleCallback = useCallbackRef.useCallbackRef(callback);
    var latestInArgsRef = React.useRef(null);
    var latestOutArgsRef = React.useRef(null);
    var active = React.useRef(true);
    var waitRef = React.useRef(wait);
    var timeoutRef = React.useRef(-1);
    var clearTimeout = function() {
        return window.clearTimeout(timeoutRef.current);
    };
    var callThrottledCallback = React.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        handleCallback.apply(void 0, (0, _toConsumableArray._)(args));
        latestInArgsRef.current = args;
        latestOutArgsRef.current = args;
        active.current = false;
    }, [
        handleCallback
    ]);
    var timerCallback = React.useCallback(function() {
        if (latestInArgsRef.current && latestInArgsRef.current !== latestOutArgsRef.current) {
            callThrottledCallback.apply(void 0, (0, _toConsumableArray._)(latestInArgsRef.current));
            timeoutRef.current = window.setTimeout(timerCallback, waitRef.current);
        } else active.current = true;
    }, [
        callThrottledCallback
    ]);
    var throttled = React.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (active.current) {
            callThrottledCallback.apply(void 0, (0, _toConsumableArray._)(args));
            timeoutRef.current = window.setTimeout(timerCallback, waitRef.current);
        } else latestInArgsRef.current = args;
    }, [
        callThrottledCallback,
        timerCallback
    ]);
    React.useEffect(function() {
        waitRef.current = wait;
    }, [
        wait
    ]);
    return [
        throttled,
        clearTimeout
    ];
}
function useThrottledCallback(callback, wait) {
    return useThrottledCallbackWithClearTimeout(callback, wait)[0];
}
exports.useThrottledCallback = useThrottledCallback;
exports.useThrottledCallbackWithClearTimeout = useThrottledCallbackWithClearTimeout; //# sourceMappingURL=use-throttled-callback.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","f225946d202321cb":"9MtAM","4479b88fe9e4890":"5hNe3"}],"2ultT":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("c5c33a751fe5f135");
var useThrottledCallback = require("133df2a97d8b2ec7");
function useThrottledState(defaultValue, wait) {
    var _React_useState = (0, _slicedToArray._)(React.useState(defaultValue), 2), value = _React_useState[0], setValue = _React_useState[1];
    var _useThrottledCallback_useThrottledCallbackWithClearTimeout = (0, _slicedToArray._)(useThrottledCallback.useThrottledCallbackWithClearTimeout(setValue, wait), 2), setThrottledValue = _useThrottledCallback_useThrottledCallbackWithClearTimeout[0], clearTimeout = _useThrottledCallback_useThrottledCallbackWithClearTimeout[1];
    React.useEffect(function() {
        return clearTimeout;
    }, []);
    return [
        value,
        setThrottledValue
    ];
}
exports.useThrottledState = useThrottledState; //# sourceMappingURL=use-throttled-state.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","c5c33a751fe5f135":"9MtAM","133df2a97d8b2ec7":"b5LJB"}],"9hZCz":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("8d4da9e82e90efd8");
var useThrottledCallback = require("511ee8a2e60af870");
function useThrottledValue(value, wait) {
    var _React_useState = (0, _slicedToArray._)(React.useState(value), 2), throttledValue = _React_useState[0], setThrottledValue = _React_useState[1];
    var valueRef = React.useRef(value);
    var _useThrottledCallback_useThrottledCallbackWithClearTimeout = (0, _slicedToArray._)(useThrottledCallback.useThrottledCallbackWithClearTimeout(setThrottledValue, wait), 2), throttledSetValue = _useThrottledCallback_useThrottledCallbackWithClearTimeout[0], clearTimeout = _useThrottledCallback_useThrottledCallbackWithClearTimeout[1];
    React.useEffect(function() {
        if (value !== valueRef.current) {
            valueRef.current = value;
            throttledSetValue(value);
        }
    }, [
        throttledSetValue,
        value
    ]);
    React.useEffect(function() {
        return clearTimeout;
    }, []);
    return throttledValue;
}
exports.useThrottledValue = useThrottledValue; //# sourceMappingURL=use-throttled-value.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","8d4da9e82e90efd8":"9MtAM","511ee8a2e60af870":"b5LJB"}],"bAL6A":[function(require,module,exports) {
"use client";
"use strict";
var React = require("c5c0dd817fa4585a");
function useIsFirstRender() {
    var renderRef = React.useRef(true);
    if (renderRef.current === true) {
        renderRef.current = false;
        return true;
    }
    return renderRef.current;
}
exports.useIsFirstRender = useIsFirstRender; //# sourceMappingURL=use-is-first-render.cjs.map

},{"c5c0dd817fa4585a":"9MtAM"}],"ayKxa":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("2cd7da9a713e98d5");
var useIsomorphicEffect = require("67f1fd1b8bb4972e");
function getInitialValue(initialValue, getInitialValueInEffect) {
    var _window_screen_orientation, _window_screen_orientation1;
    if (getInitialValueInEffect) return initialValue;
    var _window_screen_orientation_angle, _window_screen_orientation_type;
    if (typeof window !== "undefined" && "screen" in window) return {
        angle: (_window_screen_orientation_angle = (_window_screen_orientation = window.screen.orientation) === null || _window_screen_orientation === void 0 ? void 0 : _window_screen_orientation.angle) !== null && _window_screen_orientation_angle !== void 0 ? _window_screen_orientation_angle : initialValue.angle,
        type: (_window_screen_orientation_type = (_window_screen_orientation1 = window.screen.orientation) === null || _window_screen_orientation1 === void 0 ? void 0 : _window_screen_orientation1.type) !== null && _window_screen_orientation_type !== void 0 ? _window_screen_orientation_type : initialValue.type
    };
    return initialValue;
}
function useOrientation() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_defaultAngle = _ref.defaultAngle, defaultAngle = _ref_defaultAngle === void 0 ? 0 : _ref_defaultAngle, _ref_defaultType = _ref.defaultType, defaultType = _ref_defaultType === void 0 ? "landscape-primary" : _ref_defaultType, _ref_getInitialValueInEffect = _ref.getInitialValueInEffect, getInitialValueInEffect = _ref_getInitialValueInEffect === void 0 ? true : _ref_getInitialValueInEffect;
    var _React_useState = (0, _slicedToArray._)(React.useState(getInitialValue({
        angle: defaultAngle,
        type: defaultType
    }, getInitialValueInEffect)), 2), orientation = _React_useState[0], setOrientation = _React_useState[1];
    var handleOrientationChange = function(event) {
        var target = event.currentTarget;
        setOrientation({
            angle: (target === null || target === void 0 ? void 0 : target.angle) || 0,
            type: (target === null || target === void 0 ? void 0 : target.type) || "landscape-primary"
        });
    };
    useIsomorphicEffect.useIsomorphicEffect(function() {
        var _window_screen_orientation;
        (_window_screen_orientation = window.screen.orientation) === null || _window_screen_orientation === void 0 ? void 0 : _window_screen_orientation.addEventListener("change", handleOrientationChange);
        return function() {
            var _window_screen_orientation;
            return (_window_screen_orientation = window.screen.orientation) === null || _window_screen_orientation === void 0 ? void 0 : _window_screen_orientation.removeEventListener("change", handleOrientationChange);
        };
    }, []);
    return orientation;
}
exports.useOrientation = useOrientation; //# sourceMappingURL=use-orientation.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","2cd7da9a713e98d5":"9MtAM","67f1fd1b8bb4972e":"hEZes"}],"cLznf":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("e36f75f19bfe5be5");
function useFetch(url) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _param_autoInvoke = _param.autoInvoke, autoInvoke = _param_autoInvoke === void 0 ? true : _param_autoInvoke, options = (0, _objectWithoutProperties._)(_param, [
        "autoInvoke"
    ]);
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), data = _React_useState[0], setData = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(false), 2), loading = _React_useState1[0], setLoading = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState(null), 2), error = _React_useState2[0], setError = _React_useState2[1];
    var controller = React.useRef(null);
    var refetch = React.useCallback(function() {
        if (!url) return;
        if (controller.current) controller.current.abort();
        controller.current = new AbortController();
        setLoading(true);
        return fetch(url, (0, _objectSpread._)({
            signal: controller.current.signal
        }, options)).then(function(res) {
            return res.json();
        }).then(function(res) {
            setData(res);
            setLoading(false);
            return res;
        }).catch(function(err) {
            setLoading(false);
            if (err.name !== "AbortError") setError(err);
            return err;
        });
    }, [
        url
    ]);
    var abort = React.useCallback(function() {
        var _controller_current;
        if (controller.current) (_controller_current = controller.current) === null || _controller_current === void 0 ? void 0 : _controller_current.abort("");
    }, []);
    React.useEffect(function() {
        if (autoInvoke) refetch();
        return function() {
            if (controller.current) controller.current.abort("");
        };
    }, [
        refetch,
        autoInvoke
    ]);
    return {
        data,
        loading,
        error,
        refetch,
        abort
    };
}
exports.useFetch = useFetch; //# sourceMappingURL=use-fetch.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","e36f75f19bfe5be5":"9MtAM"}],"blExe":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("277be4ff3dd17735");
var clamp = require("e34a8ca042dd4b98");
function radiansToDegrees(radians) {
    return radians * (180 / Math.PI);
}
function getElementCenter(element) {
    var rect = element.getBoundingClientRect();
    return [
        rect.left + rect.width / 2,
        rect.top + rect.height / 2
    ];
}
function getAngle(coordinates, element) {
    var center = getElementCenter(element);
    var x = coordinates[0] - center[0];
    var y = coordinates[1] - center[1];
    var deg = radiansToDegrees(Math.atan2(x, y)) + 180;
    return 360 - deg;
}
function toFixed(value, digits) {
    return parseFloat(value.toFixed(digits));
}
function getDigitsAfterDot(value) {
    var _value_toString_split_;
    return ((_value_toString_split_ = value.toString().split(".")[1]) === null || _value_toString_split_ === void 0 ? void 0 : _value_toString_split_.length) || 0;
}
function normalizeRadialValue(degree, step) {
    var clamped = clamp.clamp(degree, 0, 360);
    var high = Math.ceil(clamped / step);
    var low = Math.round(clamped / step);
    return toFixed(high >= clamped / step ? high * step === 360 ? 0 : high * step : low * step, getDigitsAfterDot(step));
}
function useRadialMove(onChange) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_step = _ref.step, step = _ref_step === void 0 ? 0.01 : _ref_step, onChangeEnd = _ref.onChangeEnd, onScrubStart = _ref.onScrubStart, onScrubEnd = _ref.onScrubEnd;
    var ref = React.useRef(null);
    var mounted = React.useRef(false);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), active = _React_useState[0], setActive = _React_useState[1];
    React.useEffect(function() {
        mounted.current = true;
    }, []);
    React.useEffect(function() {
        var node = ref.current;
        var update = function(event) {
            var done = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (node) {
                node.style.userSelect = "none";
                var deg = getAngle([
                    event.clientX,
                    event.clientY
                ], node);
                var newValue = normalizeRadialValue(deg, step || 1);
                onChange(newValue);
                done && (onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(newValue));
            }
        };
        var beginTracking = function() {
            onScrubStart === null || onScrubStart === void 0 ? void 0 : onScrubStart();
            setActive(true);
            document.addEventListener("mousemove", handleMouseMove, false);
            document.addEventListener("mouseup", handleMouseUp, false);
            document.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
            document.addEventListener("touchend", handleTouchEnd, false);
        };
        var endTracking = function() {
            onScrubEnd === null || onScrubEnd === void 0 ? void 0 : onScrubEnd();
            setActive(false);
            document.removeEventListener("mousemove", handleMouseMove, false);
            document.removeEventListener("mouseup", handleMouseUp, false);
            document.removeEventListener("touchmove", handleTouchMove, false);
            document.removeEventListener("touchend", handleTouchEnd, false);
        };
        var onMouseDown = function(event) {
            beginTracking();
            update(event);
        };
        var handleMouseMove = function(event) {
            update(event);
        };
        var handleMouseUp = function(event) {
            update(event, true);
            endTracking();
        };
        var handleTouchMove = function(event) {
            event.preventDefault();
            update(event.touches[0]);
        };
        var handleTouchEnd = function(event) {
            update(event.changedTouches[0], true);
            endTracking();
        };
        var handleTouchStart = function(event) {
            event.preventDefault();
            beginTracking();
            update(event.touches[0]);
        };
        node === null || node === void 0 ? void 0 : node.addEventListener("mousedown", onMouseDown);
        node === null || node === void 0 ? void 0 : node.addEventListener("touchstart", handleTouchStart, {
            passive: false
        });
        return function() {
            if (node) {
                node.removeEventListener("mousedown", onMouseDown);
                node.removeEventListener("touchstart", handleTouchStart);
            }
        };
    }, [
        onChange
    ]);
    return {
        ref,
        active
    };
}
exports.normalizeRadialValue = normalizeRadialValue;
exports.useRadialMove = useRadialMove; //# sourceMappingURL=use-radial-move.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","277be4ff3dd17735":"9MtAM","e34a8ca042dd4b98":"dyyig"}],"d3hr3":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("989e618b133ba7cb");
var randomId = require("c5c77f93997836b3");
function getHeadingsData(headings, getDepth, getValue) {
    var _loop = function(i) {
        var heading = headings[i];
        result.push({
            depth: getDepth(heading),
            value: getValue(heading),
            id: heading.id || randomId.randomId(),
            getNode: function() {
                return heading.id ? document.getElementById(heading.id) : heading;
            }
        });
    };
    var result = [];
    for(var i = 0; i < headings.length; i += 1)_loop(i);
    return result;
}
function getActiveElement(rects) {
    if (rects.length === 0) return -1;
    var closest = rects.reduce(function(acc, item, index) {
        if (Math.abs(acc.position) < Math.abs(item.y)) return acc;
        return {
            index,
            position: item.y
        };
    }, {
        index: 0,
        position: rects[0].y
    });
    return closest.index;
}
function getDefaultDepth(element) {
    return Number(element.tagName[1]);
}
function getDefaultValue(element) {
    return element.textContent || "";
}
function useScrollSpy() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_selector = _ref.selector, selector = _ref_selector === void 0 ? "h1, h2, h3, h4, h5, h6" : _ref_selector, _ref_getDepth = _ref.getDepth, getDepth = _ref_getDepth === void 0 ? getDefaultDepth : _ref_getDepth, _ref_getValue = _ref.getValue, getValue = _ref_getValue === void 0 ? getDefaultValue : _ref_getValue;
    var _React_useState = (0, _slicedToArray._)(React.useState(-1), 2), active = _React_useState[0], setActive = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(false), 2), initialized = _React_useState1[0], setInitialized = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState([]), 2), data = _React_useState2[0], setData = _React_useState2[1];
    var headingsRef = React.useRef([]);
    var handleScroll = function() {
        setActive(getActiveElement(headingsRef.current.map(function(d) {
            return d.getNode().getBoundingClientRect();
        })));
    };
    var initialize = function() {
        var headings = getHeadingsData(Array.from(document.querySelectorAll(selector)), getDepth, getValue);
        headingsRef.current = headings;
        setInitialized(true);
        setData(headings);
        setActive(getActiveElement(headings.map(function(d) {
            return d.getNode().getBoundingClientRect();
        })));
    };
    React.useEffect(function() {
        initialize();
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return {
        reinitialize: initialize,
        active,
        initialized,
        data
    };
}
exports.useScrollSpy = useScrollSpy; //# sourceMappingURL=use-scroll-spy.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","989e618b133ba7cb":"9MtAM","c5c77f93997836b3":"csqjH"}],"2Q6TQ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("5394314b5e35638f");
var useIsomorphicEffect = require("61e111abf5bba0c3");
var defaultOptions = {
    multiple: true,
    accept: "*"
};
function getInitialFilesList(files) {
    if (!files) return null;
    if (files instanceof FileList) return files;
    var result = new DataTransfer();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var file = _step.value;
            result.items.add(file);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result.files;
}
function createInput(options) {
    if (typeof document === "undefined") return null;
    var input = document.createElement("input");
    input.type = "file";
    if (options.accept) input.accept = options.accept;
    if (options.multiple) input.multiple = options.multiple;
    if (options.capture) input.capture = options.capture;
    if (options.directory) input.webkitdirectory = options.directory;
    input.style.display = "none";
    return input;
}
function useFileDialog() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var options = (0, _objectSpread._)({}, defaultOptions, input);
    var _React_useState = (0, _slicedToArray._)(React.useState(getInitialFilesList(options.initialFiles)), 2), files = _React_useState[0], setFiles = _React_useState[1];
    var inputRef = React.useRef(null);
    var handleChange = React.useCallback(function(event) {
        var target = event.target;
        if (target === null || target === void 0 ? void 0 : target.files) {
            var _options_onChange;
            setFiles(target.files);
            (_options_onChange = options.onChange) === null || _options_onChange === void 0 ? void 0 : _options_onChange.call(options, target.files);
        }
    }, [
        options.onChange
    ]);
    var createAndSetupInput = React.useCallback(function() {
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.remove();
        inputRef.current = createInput(options);
        if (inputRef.current) {
            inputRef.current.addEventListener("change", handleChange, {
                once: true
            });
            document.body.appendChild(inputRef.current);
        }
    }, [
        options,
        handleChange
    ]);
    useIsomorphicEffect.useIsomorphicEffect(function() {
        createAndSetupInput();
        return function() {
            var _inputRef_current;
            return (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.remove();
        };
    }, []);
    var reset = React.useCallback(function() {
        var _options_onChange;
        setFiles(null);
        (_options_onChange = options.onChange) === null || _options_onChange === void 0 ? void 0 : _options_onChange.call(options, null);
    }, [
        options.onChange
    ]);
    var open = React.useCallback(function() {
        var _inputRef_current;
        if (options.resetOnOpen) reset();
        createAndSetupInput();
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.click();
    }, [
        options.resetOnOpen,
        reset,
        createAndSetupInput
    ]);
    return {
        files,
        open,
        reset
    };
}
exports.useFileDialog = useFileDialog; //# sourceMappingURL=use-file-dialog.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_sliced_to_array":"lAYt5","5394314b5e35638f":"9MtAM","61e111abf5bba0c3":"hEZes"}],"dcxYe":[function(require,module,exports) {
var process = require("e9000225e122236d");
"use client";
"use strict";
function getEnv() {
    if (typeof process !== "undefined" && process.env && "production") return "production";
    return "development";
}
exports.getEnv = getEnv; //# sourceMappingURL=get-env.cjs.map

},{"e9000225e122236d":"hn3Ta"}],"hn3Ta":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"6dk3K":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function memoize(func) {
    var cache = /* @__PURE__ */ new Map();
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var key = JSON.stringify(args);
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(void 0, (0, _toConsumableArray._)(args));
        cache.set(key, result);
        return result;
    };
}
exports.memoize = memoize; //# sourceMappingURL=memoize.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"2EcxD":[function(require,module,exports) {
"use client";
"use strict";
function findClosestNumber(value, numbers) {
    if (numbers.length === 0) return value;
    return numbers.reduce(function(prev, curr) {
        return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
    });
}
exports.findClosestNumber = findClosestNumber; //# sourceMappingURL=find-closest-number.cjs.map

},{}],"e829F":[function(require,module,exports) {
"use client";
"use strict";
var React = require("3f137125ba17b698");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var React__default = /*#__PURE__*/ _interopDefault(React);
function getRefProp(element) {
    var _element_props;
    var version = React__default.default.version;
    if (typeof React__default.default.version !== "string") return element === null || element === void 0 ? void 0 : element.ref;
    if (version.startsWith("18.")) return element === null || element === void 0 ? void 0 : element.ref;
    return element === null || element === void 0 ? void 0 : (_element_props = element.props) === null || _element_props === void 0 ? void 0 : _element_props.ref;
}
exports.getRefProp = getRefProp; //# sourceMappingURL=get-ref-prop.cjs.map

},{"3f137125ba17b698":"9MtAM"}],"hIQE6":[function(require,module,exports) {
"use client";
"use strict";
function createVarsResolver(resolver) {
    return resolver;
}
exports.createVarsResolver = createVarsResolver; //# sourceMappingURL=create-vars-resolver.cjs.map

},{}],"kjN8X":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var cx = require("f99b985c20e1d03");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var EMPTY_CLASS_NAMES = {};
function mergeClassNames(objects) {
    var merged = {};
    objects.forEach(function(obj) {
        Object.entries(obj).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
            if (merged[key]) merged[key] = cx__default.default(merged[key], value);
            else merged[key] = value;
        });
    });
    return merged;
}
function resolveClassNames(param) {
    var theme = param.theme, classNames = param.classNames, props = param.props, stylesCtx = param.stylesCtx;
    var arrayClassNames = Array.isArray(classNames) ? classNames : [
        classNames
    ];
    var resolvedClassNames = arrayClassNames.map(function(item) {
        return typeof item === "function" ? item(theme, props, stylesCtx) : item || EMPTY_CLASS_NAMES;
    });
    return mergeClassNames(resolvedClassNames);
}
exports.resolveClassNames = resolveClassNames; //# sourceMappingURL=resolve-class-names.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","f99b985c20e1d03":"8QFOC"}],"8QFOC":[function(require,module,exports) {
function r(e) {
    var o, t, f = "";
    if ("string" == typeof e || "number" == typeof e) f += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var n = e.length;
            for(o = 0; o < n; o++)e[o] && (t = r(e[o])) && (f && (f += " "), f += t);
        } else for(t in e)e[t] && (f && (f += " "), f += t);
    }
    return f;
}
function e() {
    for(var _$e, o, t = 0, f = "", n = arguments.length; t < n; t++)(_$e = arguments[t]) && (o = r(_$e)) && (f && (f += " "), f += o);
    return f;
}
module.exports = e, module.exports.clsx = e;

},{}],"2cTj2":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
function resolveStyles(param) {
    var theme = param.theme, styles = param.styles, props = param.props, stylesCtx = param.stylesCtx;
    var arrayStyles = Array.isArray(styles) ? styles : [
        styles
    ];
    return arrayStyles.reduce(function(acc, style) {
        if (typeof style === "function") return (0, _objectSpread._)({}, acc, style(theme, props, stylesCtx));
        return (0, _objectSpread._)({}, acc, style);
    }, {});
}
exports.resolveStyles = resolveStyles; //# sourceMappingURL=resolve-styles.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN"}],"d30sL":[function(require,module,exports) {
"use client";
"use strict";
require("7eefbc4c17d234fc");
require("d3b7f6c10d0d0469");
require("576fc1834dedd192");
require("3cb91d304b8949e5");
require("303bbb6e8cfe66e4");
require("ed446f61ed5683ef");
var MantineThemeProvider = require("e48398c9d46dd47e");
require("b50abc0838d8f33b");
var resolveClassNames = require("91894b4c2dbcec17");
var resolveStyles = require("8362835d33c6fb3f");
function useResolvedStylesApi(param) {
    var classNames = param.classNames, styles = param.styles, props = param.props, stylesCtx = param.stylesCtx;
    var theme = MantineThemeProvider.useMantineTheme();
    return {
        resolvedClassNames: resolveClassNames.resolveClassNames({
            theme,
            classNames,
            props,
            stylesCtx: stylesCtx || void 0
        }),
        resolvedStyles: resolveStyles.resolveStyles({
            theme,
            styles,
            props,
            stylesCtx: stylesCtx || void 0
        })
    };
}
exports.useResolvedStylesApi = useResolvedStylesApi; //# sourceMappingURL=use-resolved-styles-api.cjs.map

},{"7eefbc4c17d234fc":"9MtAM","d3b7f6c10d0d0469":"iKGFf","576fc1834dedd192":"9HEEB","3cb91d304b8949e5":"2FdJg","303bbb6e8cfe66e4":"6AMGA","ed446f61ed5683ef":"erSvz","e48398c9d46dd47e":"kqQOF","b50abc0838d8f33b":"8YP4O","91894b4c2dbcec17":"kjN8X","8362835d33c6fb3f":"2cTj2"}],"2FdJg":[function(require,module,exports) {
"use client";
"use strict";
var React = require("924cdc03a2d628ae");
var MantineContext = React.createContext(null);
function useMantineContext() {
    var ctx = React.useContext(MantineContext);
    if (!ctx) throw new Error("[@mantine/core] MantineProvider was not found in tree");
    return ctx;
}
function useMantineCssVariablesResolver() {
    return useMantineContext().cssVariablesResolver;
}
function useMantineClassNamesPrefix() {
    return useMantineContext().classNamesPrefix;
}
function useMantineStyleNonce() {
    return useMantineContext().getStyleNonce;
}
function useMantineWithStaticClasses() {
    return useMantineContext().withStaticClasses;
}
function useMantineIsHeadless() {
    return useMantineContext().headless;
}
function useMantineSxTransform() {
    var _useMantineContext_stylesTransform;
    return (_useMantineContext_stylesTransform = useMantineContext().stylesTransform) === null || _useMantineContext_stylesTransform === void 0 ? void 0 : _useMantineContext_stylesTransform.sx;
}
function useMantineStylesTransform() {
    var _useMantineContext_stylesTransform;
    return (_useMantineContext_stylesTransform = useMantineContext().stylesTransform) === null || _useMantineContext_stylesTransform === void 0 ? void 0 : _useMantineContext_stylesTransform.styles;
}
function useMantineEnv() {
    return useMantineContext().env || "default";
}
exports.MantineContext = MantineContext;
exports.useMantineClassNamesPrefix = useMantineClassNamesPrefix;
exports.useMantineContext = useMantineContext;
exports.useMantineCssVariablesResolver = useMantineCssVariablesResolver;
exports.useMantineEnv = useMantineEnv;
exports.useMantineIsHeadless = useMantineIsHeadless;
exports.useMantineStyleNonce = useMantineStyleNonce;
exports.useMantineStylesTransform = useMantineStylesTransform;
exports.useMantineSxTransform = useMantineSxTransform;
exports.useMantineWithStaticClasses = useMantineWithStaticClasses; //# sourceMappingURL=Mantine.context.cjs.map

},{"924cdc03a2d628ae":"9MtAM"}],"6AMGA":[function(require,module,exports) {
"use strict";
var rem = require("9d71edc796b7a574");
require("66bfc24e8ab160cd");
require("1fe1900422b45abc");
require("454c61a894515f59");
var defaultVariantColorsResolver = require("989442a31daf6a8a");
var defaultColors = require("3ea9921210f49bf2");
var DEFAULT_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji";
var DEFAULT_THEME = {
    scale: 1,
    fontSmoothing: true,
    focusRing: "auto",
    white: "#fff",
    black: "#000",
    colors: defaultColors.DEFAULT_COLORS,
    primaryShade: {
        light: 6,
        dark: 8
    },
    primaryColor: "blue",
    variantColorResolver: defaultVariantColorsResolver.defaultVariantColorsResolver,
    autoContrast: false,
    luminanceThreshold: 0.3,
    fontFamily: DEFAULT_FONT_FAMILY,
    fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
    respectReducedMotion: false,
    cursorType: "default",
    defaultGradient: {
        from: "blue",
        to: "cyan",
        deg: 45
    },
    defaultRadius: "sm",
    activeClassName: "mantine-active",
    focusClassName: "",
    headings: {
        fontFamily: DEFAULT_FONT_FAMILY,
        fontWeight: "700",
        textWrap: "wrap",
        sizes: {
            h1: {
                fontSize: rem.rem(34),
                lineHeight: "1.3"
            },
            h2: {
                fontSize: rem.rem(26),
                lineHeight: "1.35"
            },
            h3: {
                fontSize: rem.rem(22),
                lineHeight: "1.4"
            },
            h4: {
                fontSize: rem.rem(18),
                lineHeight: "1.45"
            },
            h5: {
                fontSize: rem.rem(16),
                lineHeight: "1.5"
            },
            h6: {
                fontSize: rem.rem(14),
                lineHeight: "1.5"
            }
        }
    },
    fontSizes: {
        xs: rem.rem(12),
        sm: rem.rem(14),
        md: rem.rem(16),
        lg: rem.rem(18),
        xl: rem.rem(20)
    },
    lineHeights: {
        xs: "1.4",
        sm: "1.45",
        md: "1.55",
        lg: "1.6",
        xl: "1.65"
    },
    radius: {
        xs: rem.rem(2),
        sm: rem.rem(4),
        md: rem.rem(8),
        lg: rem.rem(16),
        xl: rem.rem(32)
    },
    spacing: {
        xs: rem.rem(10),
        sm: rem.rem(12),
        md: rem.rem(16),
        lg: rem.rem(20),
        xl: rem.rem(32)
    },
    breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em"
    },
    shadows: {
        xs: `0 ${rem.rem(1)} ${rem.rem(3)} rgba(0, 0, 0, 0.05), 0 ${rem.rem(1)} ${rem.rem(2)} rgba(0, 0, 0, 0.1)`,
        sm: `0 ${rem.rem(1)} ${rem.rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem.rem(10)} ${rem.rem(15)} ${rem.rem(-5)}, rgba(0, 0, 0, 0.04) 0 ${rem.rem(7)} ${rem.rem(7)} ${rem.rem(-5)}`,
        md: `0 ${rem.rem(1)} ${rem.rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem.rem(20)} ${rem.rem(25)} ${rem.rem(-5)}, rgba(0, 0, 0, 0.04) 0 ${rem.rem(10)} ${rem.rem(10)} ${rem.rem(-5)}`,
        lg: `0 ${rem.rem(1)} ${rem.rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem.rem(28)} ${rem.rem(23)} ${rem.rem(-7)}, rgba(0, 0, 0, 0.04) 0 ${rem.rem(12)} ${rem.rem(12)} ${rem.rem(-7)}`,
        xl: `0 ${rem.rem(1)} ${rem.rem(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${rem.rem(36)} ${rem.rem(28)} ${rem.rem(-7)}, rgba(0, 0, 0, 0.04) 0 ${rem.rem(17)} ${rem.rem(17)} ${rem.rem(-7)}`
    },
    other: {},
    components: {}
};
exports.DEFAULT_THEME = DEFAULT_THEME; //# sourceMappingURL=default-theme.cjs.map

},{"9d71edc796b7a574":"ebAaL","66bfc24e8ab160cd":"9MtAM","1fe1900422b45abc":"iKGFf","454c61a894515f59":"9HEEB","989442a31daf6a8a":"gQVTf","3ea9921210f49bf2":"82tAM"}],"gQVTf":[function(require,module,exports) {
"use client";
"use strict";
var rem = require("a2ce1b3222abcbaa");
require("bc7f50fc598ec812");
require("8f69058e9a563c34");
require("8721467af9e8a9ea");
var darken = require("c48d477c393623c5");
var getGradient = require("f37cbdb5b146f75d");
var parseThemeColor = require("248208b26edee771");
var rgba = require("69cb7bde9882cc78");
var defaultVariantColorsResolver = function(param) {
    var color = param.color, theme = param.theme, variant = param.variant, gradient = param.gradient, autoContrast = param.autoContrast;
    var parsed = parseThemeColor.parseThemeColor({
        color,
        theme
    });
    var _autoContrast = typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
    if (variant === "filled") {
        var textColor = _autoContrast ? parsed.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)" : "var(--mantine-color-white)";
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-filled)`,
                hover: `var(--mantine-color-${color}-filled-hover)`,
                color: textColor,
                border: `${rem.rem(1)} solid transparent`
            };
            return {
                background: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                hover: `var(--mantine-color-${parsed.color}-${parsed.shade === 9 ? 8 : parsed.shade + 1})`,
                color: textColor,
                border: `${rem.rem(1)} solid transparent`
            };
        }
        return {
            background: color,
            hover: darken.darken(color, 0.1),
            color: textColor,
            border: `${rem.rem(1)} solid transparent`
        };
    }
    if (variant === "light") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-light)`,
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${rem.rem(1)} solid transparent`
            };
            var parsedColor = theme.colors[parsed.color][parsed.shade];
            return {
                background: rgba.rgba(parsedColor, 0.1),
                hover: rgba.rgba(parsedColor, 0.12),
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${rem.rem(1)} solid transparent`
            };
        }
        return {
            background: rgba.rgba(color, 0.1),
            hover: rgba.rgba(color, 0.12),
            color,
            border: `${rem.rem(1)} solid transparent`
        };
    }
    if (variant === "outline") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-outline-hover)`,
                color: `var(--mantine-color-${color}-outline)`,
                border: `${rem.rem(1)} solid var(--mantine-color-${color}-outline)`
            };
            return {
                background: "transparent",
                hover: rgba.rgba(theme.colors[parsed.color][parsed.shade], 0.05),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${rem.rem(1)} solid var(--mantine-color-${parsed.color}-${parsed.shade})`
            };
        }
        return {
            background: "transparent",
            hover: rgba.rgba(color, 0.05),
            color,
            border: `${rem.rem(1)} solid ${color}`
        };
    }
    if (variant === "subtle") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${rem.rem(1)} solid transparent`
            };
            var parsedColor1 = theme.colors[parsed.color][parsed.shade];
            return {
                background: "transparent",
                hover: rgba.rgba(parsedColor1, 0.12),
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${rem.rem(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: rgba.rgba(color, 0.12),
            color,
            border: `${rem.rem(1)} solid transparent`
        };
    }
    if (variant === "transparent") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${rem.rem(1)} solid transparent`
            };
            return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${rem.rem(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: "transparent",
            color,
            border: `${rem.rem(1)} solid transparent`
        };
    }
    if (variant === "white") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "var(--mantine-color-white)",
                hover: darken.darken(theme.white, 0.01),
                color: `var(--mantine-color-${color}-filled)`,
                border: `${rem.rem(1)} solid transparent`
            };
            return {
                background: "var(--mantine-color-white)",
                hover: darken.darken(theme.white, 0.01),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${rem.rem(1)} solid transparent`
            };
        }
        return {
            background: "var(--mantine-color-white)",
            hover: darken.darken(theme.white, 0.01),
            color,
            border: `${rem.rem(1)} solid transparent`
        };
    }
    if (variant === "gradient") return {
        background: getGradient.getGradient(gradient, theme),
        hover: getGradient.getGradient(gradient, theme),
        color: "var(--mantine-color-white)",
        border: "none"
    };
    if (variant === "default") return {
        background: "var(--mantine-color-default)",
        hover: "var(--mantine-color-default-hover)",
        color: "var(--mantine-color-default-color)",
        border: `${rem.rem(1)} solid var(--mantine-color-default-border)`
    };
    return {};
};
exports.defaultVariantColorsResolver = defaultVariantColorsResolver; //# sourceMappingURL=default-variant-colors-resolver.cjs.map

},{"a2ce1b3222abcbaa":"ebAaL","bc7f50fc598ec812":"9MtAM","8f69058e9a563c34":"iKGFf","8721467af9e8a9ea":"9HEEB","c48d477c393623c5":"ibGxK","f37cbdb5b146f75d":"cx5bg","248208b26edee771":"ctp80","69cb7bde9882cc78":"aIray"}],"ibGxK":[function(require,module,exports) {
"use strict";
var toRgba = require("6f677a4cbbd2a2dd");
function darken(color, alpha) {
    if (color.startsWith("var(")) return `color-mix(in srgb, ${color}, black ${alpha * 100}%)`;
    var _toRgba_toRgba = toRgba.toRgba(color), r = _toRgba_toRgba.r, g = _toRgba_toRgba.g, b = _toRgba_toRgba.b, a = _toRgba_toRgba.a;
    var f = 1 - alpha;
    var dark = function(input) {
        return Math.round(input * f);
    };
    return `rgba(${dark(r)}, ${dark(g)}, ${dark(b)}, ${a})`;
}
exports.darken = darken; //# sourceMappingURL=darken.cjs.map

},{"6f677a4cbbd2a2dd":"8dGkg"}],"8dGkg":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
function isHexColor(hex) {
    var HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i;
    return HEX_REGEXP.test(hex);
}
function hexToRgba(color) {
    var hexString = color.replace("#", "");
    if (hexString.length === 3) {
        var shorthandHex = hexString.split("");
        hexString = [
            shorthandHex[0],
            shorthandHex[0],
            shorthandHex[1],
            shorthandHex[1],
            shorthandHex[2],
            shorthandHex[2]
        ].join("");
    }
    if (hexString.length === 8) {
        var alpha = parseInt(hexString.slice(6, 8), 16) / 255;
        return {
            r: parseInt(hexString.slice(0, 2), 16),
            g: parseInt(hexString.slice(2, 4), 16),
            b: parseInt(hexString.slice(4, 6), 16),
            a: alpha
        };
    }
    var parsed = parseInt(hexString, 16);
    var r = parsed >> 16 & 255;
    var g = parsed >> 8 & 255;
    var b = parsed & 255;
    return {
        r,
        g,
        b,
        a: 1
    };
}
function rgbStringToRgba(color) {
    var _color_replace_split_map = (0, _slicedToArray._)(color.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number), 4), r = _color_replace_split_map[0], g = _color_replace_split_map[1], b = _color_replace_split_map[2], a = _color_replace_split_map[3];
    return {
        r,
        g,
        b,
        a: a || 1
    };
}
function hslStringToRgba(hslaString) {
    var hslaRegex = /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i;
    var matches = hslaString.match(hslaRegex);
    if (!matches) return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
    var h = parseInt(matches[1], 10);
    var s = parseInt(matches[2], 10) / 100;
    var l = parseInt(matches[3], 10) / 100;
    var a = matches[5] ? parseFloat(matches[5]) : void 0;
    var chroma = (1 - Math.abs(2 * l - 1)) * s;
    var huePrime = h / 60;
    var x = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var m = l - chroma / 2;
    var r;
    var g;
    var b;
    if (huePrime >= 0 && huePrime < 1) {
        r = chroma;
        g = x;
        b = 0;
    } else if (huePrime >= 1 && huePrime < 2) {
        r = x;
        g = chroma;
        b = 0;
    } else if (huePrime >= 2 && huePrime < 3) {
        r = 0;
        g = chroma;
        b = x;
    } else if (huePrime >= 3 && huePrime < 4) {
        r = 0;
        g = x;
        b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        r = x;
        g = 0;
        b = chroma;
    } else {
        r = chroma;
        g = 0;
        b = x;
    }
    return {
        r: Math.round((r + m) * 255),
        g: Math.round((g + m) * 255),
        b: Math.round((b + m) * 255),
        a: a || 1
    };
}
function toRgba(color) {
    if (isHexColor(color)) return hexToRgba(color);
    if (color.startsWith("rgb")) return rgbStringToRgba(color);
    if (color.startsWith("hsl")) return hslStringToRgba(color);
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
}
exports.toRgba = toRgba; //# sourceMappingURL=to-rgba.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5"}],"cx5bg":[function(require,module,exports) {
"use client";
"use strict";
var getThemeColor = require("e2b1dbbb8cdf6921");
function getGradient(gradient, theme) {
    var _gradient_deg, _ref;
    var merged = {
        from: (gradient === null || gradient === void 0 ? void 0 : gradient.from) || theme.defaultGradient.from,
        to: (gradient === null || gradient === void 0 ? void 0 : gradient.to) || theme.defaultGradient.to,
        deg: (_ref = (_gradient_deg = gradient === null || gradient === void 0 ? void 0 : gradient.deg) !== null && _gradient_deg !== void 0 ? _gradient_deg : theme.defaultGradient.deg) !== null && _ref !== void 0 ? _ref : 0
    };
    var fromColor = getThemeColor.getThemeColor(merged.from, theme);
    var toColor = getThemeColor.getThemeColor(merged.to, theme);
    return `linear-gradient(${merged.deg}deg, ${fromColor} 0%, ${toColor} 100%)`;
}
exports.getGradient = getGradient; //# sourceMappingURL=get-gradient.cjs.map

},{"e2b1dbbb8cdf6921":"eeaIN"}],"eeaIN":[function(require,module,exports) {
"use client";
"use strict";
var parseThemeColor = require("a424995290e1b22e");
function getThemeColor(color, theme) {
    var parsed = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme
    });
    return parsed.variable ? `var(${parsed.variable})` : color;
}
exports.getThemeColor = getThemeColor; //# sourceMappingURL=get-theme-color.cjs.map

},{"a424995290e1b22e":"ctp80"}],"ctp80":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var getPrimaryShade = require("b5f7a5533945e0f6");
var luminance = require("ab9b704622a90bae");
function parseThemeColor(param) {
    var color = param.color, theme = param.theme, colorScheme = param.colorScheme;
    if (typeof color !== "string") throw new Error(`[@mantine/core] Failed to parse color. Expected color to be a string, instead got ${typeof color}`);
    if (color === "bright") return {
        color,
        value: colorScheme === "dark" ? theme.white : theme.black,
        shade: void 0,
        isThemeColor: false,
        isLight: luminance.isLightColor(colorScheme === "dark" ? theme.white : theme.black, theme.luminanceThreshold),
        variable: "--mantine-color-bright"
    };
    if (color === "dimmed") return {
        color,
        value: colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
        shade: void 0,
        isThemeColor: false,
        isLight: luminance.isLightColor(colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6], theme.luminanceThreshold),
        variable: "--mantine-color-dimmed"
    };
    if (color === "white" || color === "black") return {
        color,
        value: color === "white" ? theme.white : theme.black,
        shade: void 0,
        isThemeColor: false,
        isLight: luminance.isLightColor(color === "white" ? theme.white : theme.black, theme.luminanceThreshold),
        variable: `--mantine-color-${color}`
    };
    var _color_split = (0, _slicedToArray._)(color.split("."), 2), _color = _color_split[0], shade = _color_split[1];
    var colorShade = shade ? Number(shade) : void 0;
    var isThemeColor = _color in theme.colors;
    if (isThemeColor) {
        var colorValue = colorShade !== void 0 ? theme.colors[_color][colorShade] : theme.colors[_color][getPrimaryShade.getPrimaryShade(theme, colorScheme || "light")];
        return {
            color: _color,
            value: colorValue,
            shade: colorShade,
            isThemeColor,
            isLight: luminance.isLightColor(colorValue, theme.luminanceThreshold),
            variable: shade ? `--mantine-color-${_color}-${colorShade}` : `--mantine-color-${_color}-filled`
        };
    }
    return {
        color,
        value: color,
        isThemeColor,
        isLight: luminance.isLightColor(color, theme.luminanceThreshold),
        shade: colorShade,
        variable: void 0
    };
}
exports.parseThemeColor = parseThemeColor; //# sourceMappingURL=parse-theme-color.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","b5f7a5533945e0f6":"fKUzT","ab9b704622a90bae":"dBjYG"}],"fKUzT":[function(require,module,exports) {
"use client";
"use strict";
function getPrimaryShade(theme, colorScheme) {
    if (typeof theme.primaryShade === "number") return theme.primaryShade;
    if (colorScheme === "dark") return theme.primaryShade.dark;
    return theme.primaryShade.light;
}
exports.getPrimaryShade = getPrimaryShade; //# sourceMappingURL=get-primary-shade.cjs.map

},{}],"dBjYG":[function(require,module,exports) {
"use strict";
var toRgba = require("b31b4889d7175b9d");
function gammaCorrect(c) {
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}
function getLightnessFromOklch(oklchColor) {
    var match = oklchColor.match(/oklch\((.*?)%\s/);
    return match ? parseFloat(match[1]) : null;
}
function luminance(color) {
    if (color.startsWith("oklch(")) return (getLightnessFromOklch(color) || 0) / 100;
    var _toRgba_toRgba = toRgba.toRgba(color), r = _toRgba_toRgba.r, g = _toRgba_toRgba.g, b = _toRgba_toRgba.b;
    var sR = r / 255;
    var sG = g / 255;
    var sB = b / 255;
    var rLinear = gammaCorrect(sR);
    var gLinear = gammaCorrect(sG);
    var bLinear = gammaCorrect(sB);
    return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
}
function isLightColor(color) {
    var luminanceThreshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.179;
    if (color.startsWith("var(")) return false;
    return luminance(color) > luminanceThreshold;
}
exports.isLightColor = isLightColor;
exports.luminance = luminance; //# sourceMappingURL=luminance.cjs.map

},{"b31b4889d7175b9d":"8dGkg"}],"aIray":[function(require,module,exports) {
"use strict";
var toRgba = require("994d05fe655e325e");
function rgba(color, alpha2) {
    if (typeof color !== "string" || alpha2 > 1 || alpha2 < 0) return "rgba(0, 0, 0, 1)";
    if (color.startsWith("var(")) {
        var mixPercentage = (1 - alpha2) * 100;
        return `color-mix(in srgb, ${color}, transparent ${mixPercentage}%)`;
    }
    if (color.startsWith("oklch")) {
        if (color.includes("/")) return color.replace(/\/\s*[\d.]+\s*\)/, `/ ${alpha2})`);
        return color.replace(")", ` / ${alpha2})`);
    }
    var _toRgba_toRgba = toRgba.toRgba(color), r = _toRgba_toRgba.r, g = _toRgba_toRgba.g, b = _toRgba_toRgba.b;
    return `rgba(${r}, ${g}, ${b}, ${alpha2})`;
}
var alpha = rgba;
exports.alpha = alpha;
exports.rgba = rgba; //# sourceMappingURL=rgba.cjs.map

},{"994d05fe655e325e":"8dGkg"}],"82tAM":[function(require,module,exports) {
"use strict";
var DEFAULT_COLORS = {
    dark: [
        "#C9C9C9",
        "#b8b8b8",
        "#828282",
        "#696969",
        "#424242",
        "#3b3b3b",
        "#2e2e2e",
        "#242424",
        "#1f1f1f",
        "#141414"
    ],
    gray: [
        "#f8f9fa",
        "#f1f3f5",
        "#e9ecef",
        "#dee2e6",
        "#ced4da",
        "#adb5bd",
        "#868e96",
        "#495057",
        "#343a40",
        "#212529"
    ],
    red: [
        "#fff5f5",
        "#ffe3e3",
        "#ffc9c9",
        "#ffa8a8",
        "#ff8787",
        "#ff6b6b",
        "#fa5252",
        "#f03e3e",
        "#e03131",
        "#c92a2a"
    ],
    pink: [
        "#fff0f6",
        "#ffdeeb",
        "#fcc2d7",
        "#faa2c1",
        "#f783ac",
        "#f06595",
        "#e64980",
        "#d6336c",
        "#c2255c",
        "#a61e4d"
    ],
    grape: [
        "#f8f0fc",
        "#f3d9fa",
        "#eebefa",
        "#e599f7",
        "#da77f2",
        "#cc5de8",
        "#be4bdb",
        "#ae3ec9",
        "#9c36b5",
        "#862e9c"
    ],
    violet: [
        "#f3f0ff",
        "#e5dbff",
        "#d0bfff",
        "#b197fc",
        "#9775fa",
        "#845ef7",
        "#7950f2",
        "#7048e8",
        "#6741d9",
        "#5f3dc4"
    ],
    indigo: [
        "#edf2ff",
        "#dbe4ff",
        "#bac8ff",
        "#91a7ff",
        "#748ffc",
        "#5c7cfa",
        "#4c6ef5",
        "#4263eb",
        "#3b5bdb",
        "#364fc7"
    ],
    blue: [
        "#e7f5ff",
        "#d0ebff",
        "#a5d8ff",
        "#74c0fc",
        "#4dabf7",
        "#339af0",
        "#228be6",
        "#1c7ed6",
        "#1971c2",
        "#1864ab"
    ],
    cyan: [
        "#e3fafc",
        "#c5f6fa",
        "#99e9f2",
        "#66d9e8",
        "#3bc9db",
        "#22b8cf",
        "#15aabf",
        "#1098ad",
        "#0c8599",
        "#0b7285"
    ],
    teal: [
        "#e6fcf5",
        "#c3fae8",
        "#96f2d7",
        "#63e6be",
        "#38d9a9",
        "#20c997",
        "#12b886",
        "#0ca678",
        "#099268",
        "#087f5b"
    ],
    green: [
        "#ebfbee",
        "#d3f9d8",
        "#b2f2bb",
        "#8ce99a",
        "#69db7c",
        "#51cf66",
        "#40c057",
        "#37b24d",
        "#2f9e44",
        "#2b8a3e"
    ],
    lime: [
        "#f4fce3",
        "#e9fac8",
        "#d8f5a2",
        "#c0eb75",
        "#a9e34b",
        "#94d82d",
        "#82c91e",
        "#74b816",
        "#66a80f",
        "#5c940d"
    ],
    yellow: [
        "#fff9db",
        "#fff3bf",
        "#ffec99",
        "#ffe066",
        "#ffd43b",
        "#fcc419",
        "#fab005",
        "#f59f00",
        "#f08c00",
        "#e67700"
    ],
    orange: [
        "#fff4e6",
        "#ffe8cc",
        "#ffd8a8",
        "#ffc078",
        "#ffa94d",
        "#ff922b",
        "#fd7e14",
        "#f76707",
        "#e8590c",
        "#d9480f"
    ]
};
exports.DEFAULT_COLORS = DEFAULT_COLORS; //# sourceMappingURL=default-colors.cjs.map

},{}],"erSvz":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("4df9d7363f699886");
var localStorageManager = require("1e3af741dbd39019");
var Mantine_context = require("7ab33f8b7e26650a");
var MantineClasses = require("e9aa128cc4a22389");
var MantineCssVariables = require("ae387065d9b6ecb7");
require("76b350a814322a09");
require("cc7b48809dc58369");
var MantineThemeProvider = require("c79d66b2beb86778");
var suppressNextjsWarning = require("eb9c36274a72f2fc");
var useProviderColorScheme = require("c0c3a75abc067f6e");
var useRespectReduceMotion = require("d938330114d7bf2d");
suppressNextjsWarning.suppressNextjsWarning();
function MantineProvider(param) {
    var theme = param.theme, children = param.children, getStyleNonce = param.getStyleNonce, _param_withStaticClasses = param.withStaticClasses, withStaticClasses = _param_withStaticClasses === void 0 ? true : _param_withStaticClasses, _param_withGlobalClasses = param.withGlobalClasses, withGlobalClasses = _param_withGlobalClasses === void 0 ? true : _param_withGlobalClasses, _param_deduplicateCssVariables = param.deduplicateCssVariables, deduplicateCssVariables = _param_deduplicateCssVariables === void 0 ? true : _param_deduplicateCssVariables, _param_withCssVariables = param.withCssVariables, withCssVariables = _param_withCssVariables === void 0 ? true : _param_withCssVariables, _param_cssVariablesSelector = param.cssVariablesSelector, cssVariablesSelector = _param_cssVariablesSelector === void 0 ? ":root" : _param_cssVariablesSelector, _param_classNamesPrefix = param.classNamesPrefix, classNamesPrefix = _param_classNamesPrefix === void 0 ? "mantine" : _param_classNamesPrefix, _param_colorSchemeManager = param.colorSchemeManager, colorSchemeManager = _param_colorSchemeManager === void 0 ? localStorageManager.localStorageColorSchemeManager() : _param_colorSchemeManager, _param_defaultColorScheme = param.defaultColorScheme, defaultColorScheme = _param_defaultColorScheme === void 0 ? "light" : _param_defaultColorScheme, _param_getRootElement = param.getRootElement, getRootElement = _param_getRootElement === void 0 ? function() {
        return document.documentElement;
    } : _param_getRootElement, cssVariablesResolver = param.cssVariablesResolver, forceColorScheme = param.forceColorScheme, stylesTransform = param.stylesTransform, env = param.env;
    var _useProviderColorScheme_useProviderColorScheme = useProviderColorScheme.useProviderColorScheme({
        defaultColorScheme,
        forceColorScheme,
        manager: colorSchemeManager,
        getRootElement
    }), colorScheme = _useProviderColorScheme_useProviderColorScheme.colorScheme, setColorScheme = _useProviderColorScheme_useProviderColorScheme.setColorScheme, clearColorScheme = _useProviderColorScheme_useProviderColorScheme.clearColorScheme;
    useRespectReduceMotion.useRespectReduceMotion({
        respectReducedMotion: (theme === null || theme === void 0 ? void 0 : theme.respectReducedMotion) || false,
        getRootElement
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Mantine_context.MantineContext.Provider, {
        value: {
            colorScheme,
            setColorScheme,
            clearColorScheme,
            getRootElement,
            classNamesPrefix,
            getStyleNonce,
            cssVariablesResolver,
            cssVariablesSelector,
            withStaticClasses,
            stylesTransform,
            env
        },
        children: /* @__PURE__ */ jsxRuntime.jsxs(MantineThemeProvider.MantineThemeProvider, {
            theme,
            children: [
                withCssVariables && /* @__PURE__ */ jsxRuntime.jsx(MantineCssVariables.MantineCssVariables, {
                    cssVariablesSelector,
                    deduplicateCssVariables
                }),
                withGlobalClasses && /* @__PURE__ */ jsxRuntime.jsx(MantineClasses.MantineClasses, {}),
                children
            ]
        })
    });
}
MantineProvider.displayName = "@mantine/core/MantineProvider";
function HeadlessMantineProvider(param) {
    var children = param.children, theme = param.theme;
    return /* @__PURE__ */ jsxRuntime.jsx(Mantine_context.MantineContext.Provider, {
        value: {
            colorScheme: "auto",
            setColorScheme: function() {},
            clearColorScheme: function() {},
            getRootElement: function() {
                return document.documentElement;
            },
            classNamesPrefix: "mantine",
            cssVariablesSelector: ":root",
            withStaticClasses: false,
            headless: true
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(MantineThemeProvider.MantineThemeProvider, {
            theme,
            children
        })
    });
}
HeadlessMantineProvider.displayName = "@mantine/core/HeadlessMantineProvider";
exports.HeadlessMantineProvider = HeadlessMantineProvider;
exports.MantineProvider = MantineProvider; //# sourceMappingURL=MantineProvider.cjs.map

},{"4df9d7363f699886":"iKGFf","1e3af741dbd39019":"gu5h1","7ab33f8b7e26650a":"2FdJg","e9aa128cc4a22389":"kORTe","ae387065d9b6ecb7":"8YP4O","76b350a814322a09":"9MtAM","cc7b48809dc58369":"9HEEB","c79d66b2beb86778":"kqQOF","eb9c36274a72f2fc":"cATD0","c0c3a75abc067f6e":"4Xpxx","d938330114d7bf2d":"aC2RN"}],"gu5h1":[function(require,module,exports) {
"use client";
"use strict";
var isMantineColorScheme = require("f1205fbd4eec7a05");
function localStorageColorSchemeManager() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_key = _ref.key, key = _ref_key === void 0 ? "mantine-color-scheme-value" : _ref_key;
    var handleStorageEvent;
    return {
        get: function(defaultValue) {
            if (typeof window === "undefined") return defaultValue;
            try {
                var storedColorScheme = window.localStorage.getItem(key);
                return isMantineColorScheme.isMantineColorScheme(storedColorScheme) ? storedColorScheme : defaultValue;
            } catch (e) {
                return defaultValue;
            }
        },
        set: function(value) {
            try {
                window.localStorage.setItem(key, value);
            } catch (error) {
                console.warn("[@mantine/core] Local storage color scheme manager was unable to save color scheme.", error);
            }
        },
        subscribe: function(onUpdate) {
            handleStorageEvent = function(event) {
                if (event.storageArea === window.localStorage && event.key === key) isMantineColorScheme.isMantineColorScheme(event.newValue) && onUpdate(event.newValue);
            };
            window.addEventListener("storage", handleStorageEvent);
        },
        unsubscribe: function() {
            window.removeEventListener("storage", handleStorageEvent);
        },
        clear: function() {
            window.localStorage.removeItem(key);
        }
    };
}
exports.localStorageColorSchemeManager = localStorageColorSchemeManager; //# sourceMappingURL=local-storage-manager.cjs.map

},{"f1205fbd4eec7a05":"bOcAc"}],"bOcAc":[function(require,module,exports) {
"use client";
"use strict";
function isMantineColorScheme(value) {
    return value === "auto" || value === "dark" || value === "light";
}
exports.isMantineColorScheme = isMantineColorScheme; //# sourceMappingURL=is-mantine-color-scheme.cjs.map

},{}],"kORTe":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("47f24119ce302115");
var keys = require("de30ea647987cbeb");
var px = require("834c08dabf762059");
var rem = require("d442e3f393a469fa");
require("bfb5bd054583213f");
require("a84bb7cdcb6bc3ca");
var Mantine_context = require("eed21909b86378f8");
var MantineThemeProvider = require("fa02805ead436b65");
function MantineClasses() {
    var theme = MantineThemeProvider.useMantineTheme();
    var nonce = Mantine_context.useMantineStyleNonce();
    var classes = keys.keys(theme.breakpoints).reduce(function(acc, breakpoint) {
        var isPxBreakpoint = theme.breakpoints[breakpoint].includes("px");
        var pxValue = px.px(theme.breakpoints[breakpoint]);
        var maxWidthBreakpoint = isPxBreakpoint ? `${pxValue - 0.1}px` : rem.em(pxValue - 0.1);
        var minWidthBreakpoint = isPxBreakpoint ? `${pxValue}px` : rem.em(pxValue);
        return `${acc}@media (max-width: ${maxWidthBreakpoint}) {.mantine-visible-from-${breakpoint} {display: none !important;}}@media (min-width: ${minWidthBreakpoint}) {.mantine-hidden-from-${breakpoint} {display: none !important;}}`;
    }, "");
    return /* @__PURE__ */ jsxRuntime.jsx("style", {
        "data-mantine-styles": "classes",
        nonce: nonce === null || nonce === void 0 ? void 0 : nonce(),
        dangerouslySetInnerHTML: {
            __html: classes
        }
    });
}
exports.MantineClasses = MantineClasses; //# sourceMappingURL=MantineClasses.cjs.map

},{"47f24119ce302115":"iKGFf","de30ea647987cbeb":"kvYzO","834c08dabf762059":"dXm4f","d442e3f393a469fa":"ebAaL","bfb5bd054583213f":"9MtAM","a84bb7cdcb6bc3ca":"9HEEB","eed21909b86378f8":"2FdJg","fa02805ead436b65":"kqQOF"}],"kqQOF":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("19094a4789bada87");
var React = require("aaa8267d2354fc5d");
var defaultTheme = require("ee7d34470da0601e");
var mergeMantineTheme = require("72c0aa5b69c2654d");
var MantineThemeContext = React.createContext(null);
var useSafeMantineTheme = function() {
    return React.useContext(MantineThemeContext) || defaultTheme.DEFAULT_THEME;
};
function useMantineTheme() {
    var ctx = React.useContext(MantineThemeContext);
    if (!ctx) throw new Error("@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app");
    return ctx;
}
function MantineThemeProvider(param) {
    var theme = param.theme, children = param.children, _param_inherit = param.inherit, inherit = _param_inherit === void 0 ? true : _param_inherit;
    var parentTheme = useSafeMantineTheme();
    var mergedTheme = React.useMemo(function() {
        return mergeMantineTheme.mergeMantineTheme(inherit ? parentTheme : defaultTheme.DEFAULT_THEME, theme);
    }, [
        theme,
        parentTheme,
        inherit
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(MantineThemeContext.Provider, {
        value: mergedTheme,
        children
    });
}
MantineThemeProvider.displayName = "@mantine/core/MantineThemeProvider";
exports.MantineThemeContext = MantineThemeContext;
exports.MantineThemeProvider = MantineThemeProvider;
exports.useMantineTheme = useMantineTheme;
exports.useSafeMantineTheme = useSafeMantineTheme; //# sourceMappingURL=MantineThemeProvider.cjs.map

},{"19094a4789bada87":"iKGFf","aaa8267d2354fc5d":"9MtAM","ee7d34470da0601e":"6AMGA","72c0aa5b69c2654d":"dyWMV"}],"dyWMV":[function(require,module,exports) {
"use strict";
var deepMerge = require("8d71f6a3798eb06f");
require("d8996348214997bc");
require("49d6cbbb25610e2f");
require("d34007f63ee08a8");
var INVALID_PRIMARY_COLOR_ERROR = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color";
var INVALID_PRIMARY_SHADE_ERROR = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function isValidPrimaryShade(shade) {
    if (shade < 0 || shade > 9) return false;
    return parseInt(shade.toString(), 10) === shade;
}
function validateMantineTheme(theme) {
    if (!(theme.primaryColor in theme.colors)) throw new Error(INVALID_PRIMARY_COLOR_ERROR);
    if (typeof theme.primaryShade === "object") {
        if (!isValidPrimaryShade(theme.primaryShade.dark) || !isValidPrimaryShade(theme.primaryShade.light)) throw new Error(INVALID_PRIMARY_SHADE_ERROR);
    }
    if (typeof theme.primaryShade === "number" && !isValidPrimaryShade(theme.primaryShade)) throw new Error(INVALID_PRIMARY_SHADE_ERROR);
}
function mergeMantineTheme(currentTheme, themeOverride) {
    var _themeOverride_headings;
    if (!themeOverride) {
        validateMantineTheme(currentTheme);
        return currentTheme;
    }
    var result = deepMerge.deepMerge(currentTheme, themeOverride);
    if (themeOverride.fontFamily && !((_themeOverride_headings = themeOverride.headings) === null || _themeOverride_headings === void 0 ? void 0 : _themeOverride_headings.fontFamily)) result.headings.fontFamily = themeOverride.fontFamily;
    validateMantineTheme(result);
    return result;
}
exports.INVALID_PRIMARY_COLOR_ERROR = INVALID_PRIMARY_COLOR_ERROR;
exports.INVALID_PRIMARY_SHADE_ERROR = INVALID_PRIMARY_SHADE_ERROR;
exports.mergeMantineTheme = mergeMantineTheme;
exports.validateMantineTheme = validateMantineTheme; //# sourceMappingURL=merge-mantine-theme.cjs.map

},{"8d71f6a3798eb06f":"aXRyU","d8996348214997bc":"9MtAM","49d6cbbb25610e2f":"iKGFf","d34007f63ee08a8":"9HEEB"}],"8YP4O":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("538bbd0f98c90b47");
var convertCssVariables = require("9a6de7aa9d01b713");
var Mantine_context = require("d2869fdaf6934adc");
var MantineThemeProvider = require("4d69d136c4d6dd95");
var getMergedVariables = require("92a3e844c00b31a8");
var removeDefaultVariables = require("aebf7bbb2f916aef");
function getColorSchemeCssVariables(selector) {
    return `
  ${selector}[data-mantine-color-scheme="dark"] { --mantine-color-scheme: dark; }
  ${selector}[data-mantine-color-scheme="light"] { --mantine-color-scheme: light; }
`;
}
function MantineCssVariables(param) {
    var cssVariablesSelector = param.cssVariablesSelector, deduplicateCssVariables = param.deduplicateCssVariables;
    var theme = MantineThemeProvider.useMantineTheme();
    var nonce = Mantine_context.useMantineStyleNonce();
    var generator = Mantine_context.useMantineCssVariablesResolver();
    var mergedVariables = getMergedVariables.getMergedVariables({
        theme,
        generator
    });
    var shouldCleanVariables = cssVariablesSelector === ":root" && deduplicateCssVariables;
    var cleanedVariables = shouldCleanVariables ? removeDefaultVariables.removeDefaultVariables(mergedVariables) : mergedVariables;
    var css = convertCssVariables.convertCssVariables(cleanedVariables, cssVariablesSelector);
    if (css) return /* @__PURE__ */ jsxRuntime.jsx("style", {
        "data-mantine-styles": true,
        nonce: nonce === null || nonce === void 0 ? void 0 : nonce(),
        dangerouslySetInnerHTML: {
            __html: `${css}${shouldCleanVariables ? "" : getColorSchemeCssVariables(cssVariablesSelector)}`
        }
    });
    return null;
}
MantineCssVariables.displayName = "@mantine/CssVariables";
exports.MantineCssVariables = MantineCssVariables; //# sourceMappingURL=MantineCssVariables.cjs.map

},{"538bbd0f98c90b47":"iKGFf","9a6de7aa9d01b713":"lg3xs","d2869fdaf6934adc":"2FdJg","4d69d136c4d6dd95":"kqQOF","92a3e844c00b31a8":"aCDaP","aebf7bbb2f916aef":"hpF9M"}],"lg3xs":[function(require,module,exports) {
"use client";
"use strict";
var cssVariablesObjectToString = require("70b5a295a00c4aee");
var wrapWithSelector = require("b37d9bcbba507f7e");
function convertCssVariables(input, selector) {
    var sharedVariables = cssVariablesObjectToString.cssVariablesObjectToString(input.variables);
    var shared = sharedVariables ? wrapWithSelector.wrapWithSelector(selector, sharedVariables) : "";
    var dark = cssVariablesObjectToString.cssVariablesObjectToString(input.dark);
    var light = cssVariablesObjectToString.cssVariablesObjectToString(input.light);
    var darkForced = dark ? selector === ":host" ? wrapWithSelector.wrapWithSelector(`${selector}([data-mantine-color-scheme="dark"])`, dark) : wrapWithSelector.wrapWithSelector(`${selector}[data-mantine-color-scheme="dark"]`, dark) : "";
    var lightForced = light ? selector === ":host" ? wrapWithSelector.wrapWithSelector(`${selector}([data-mantine-color-scheme="light"])`, light) : wrapWithSelector.wrapWithSelector(`${selector}[data-mantine-color-scheme="light"]`, light) : "";
    return `${shared}${darkForced}${lightForced}`;
}
exports.convertCssVariables = convertCssVariables; //# sourceMappingURL=convert-css-variables.cjs.map

},{"70b5a295a00c4aee":"52li1","b37d9bcbba507f7e":"dZMDx"}],"52li1":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
function cssVariablesObjectToString(variables) {
    return Object.entries(variables).map(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), name = _param[0], value = _param[1];
        return `${name}: ${value};`;
    }).join("");
}
exports.cssVariablesObjectToString = cssVariablesObjectToString; //# sourceMappingURL=css-variables-object-to-string.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5"}],"dZMDx":[function(require,module,exports) {
"use client";
"use strict";
function wrapWithSelector(selectors, code) {
    var _selectors = Array.isArray(selectors) ? selectors : [
        selectors
    ];
    return _selectors.reduce(function(acc, selector) {
        return `${selector}{${acc}}`;
    }, code);
}
exports.wrapWithSelector = wrapWithSelector; //# sourceMappingURL=wrap-with-selector.cjs.map

},{}],"aCDaP":[function(require,module,exports) {
"use client";
"use strict";
var deepMerge = require("7129329907cf6c81");
require("a6ee132e758235cd");
require("107dc47fb8f4fb7c");
require("abbf8e249c9826a1");
var defaultCssVariablesResolver = require("1d40d9d52ea764ba");
function getMergedVariables(param) {
    var theme = param.theme, generator = param.generator;
    var defaultResolver = defaultCssVariablesResolver.defaultCssVariablesResolver(theme);
    var providerGenerator = generator === null || generator === void 0 ? void 0 : generator(theme);
    return providerGenerator ? deepMerge.deepMerge(defaultResolver, providerGenerator) : defaultResolver;
}
exports.getMergedVariables = getMergedVariables; //# sourceMappingURL=get-merged-variables.cjs.map

},{"7129329907cf6c81":"aXRyU","a6ee132e758235cd":"9MtAM","107dc47fb8f4fb7c":"iKGFf","abbf8e249c9826a1":"9HEEB","1d40d9d52ea764ba":"axjje"}],"axjje":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("b4cf1f061cd40dd7");
var rem = require("50dac987a6ddaab0");
require("a7ab5967d4e67efa");
require("ded88cb8d3802a62");
require("6fd63235b095a54b");
var getPrimaryShade = require("b41f6e74baee71e3");
var getContrastColor = require("a1e9c582a2b0b562");
var getCssColorVariables = require("35d49ed67ec08aa1");
var virtualColor = require("6b9d17c10a3f4f19");
function assignSizeVariables(variables, sizes, name) {
    keys.keys(sizes).forEach(function(size) {
        return Object.assign(variables, {
            [`--mantine-${name}-${size}`]: sizes[size]
        });
    });
}
var defaultCssVariablesResolver = function(theme) {
    var lightPrimaryShade = getPrimaryShade.getPrimaryShade(theme, "light");
    var defaultRadius = theme.defaultRadius in theme.radius ? theme.radius[theme.defaultRadius] : rem.rem(theme.defaultRadius);
    var result = {
        variables: {
            "--mantine-scale": theme.scale.toString(),
            "--mantine-cursor-type": theme.cursorType,
            "--mantine-color-scheme": "light dark",
            "--mantine-webkit-font-smoothing": theme.fontSmoothing ? "antialiased" : "unset",
            "--mantine-moz-font-smoothing": theme.fontSmoothing ? "grayscale" : "unset",
            "--mantine-color-white": theme.white,
            "--mantine-color-black": theme.black,
            "--mantine-line-height": theme.lineHeights.md,
            "--mantine-font-family": theme.fontFamily,
            "--mantine-font-family-monospace": theme.fontFamilyMonospace,
            "--mantine-font-family-headings": theme.headings.fontFamily,
            "--mantine-heading-font-weight": theme.headings.fontWeight,
            "--mantine-heading-text-wrap": theme.headings.textWrap,
            "--mantine-radius-default": defaultRadius,
            // Primary colors
            "--mantine-primary-color-filled": `var(--mantine-color-${theme.primaryColor}-filled)`,
            "--mantine-primary-color-filled-hover": `var(--mantine-color-${theme.primaryColor}-filled-hover)`,
            "--mantine-primary-color-light": `var(--mantine-color-${theme.primaryColor}-light)`,
            "--mantine-primary-color-light-hover": `var(--mantine-color-${theme.primaryColor}-light-hover)`,
            "--mantine-primary-color-light-color": `var(--mantine-color-${theme.primaryColor}-light-color)`
        },
        light: {
            "--mantine-primary-color-contrast": getContrastColor.getPrimaryContrastColor(theme, "light"),
            "--mantine-color-bright": "var(--mantine-color-black)",
            "--mantine-color-text": theme.black,
            "--mantine-color-body": theme.white,
            "--mantine-color-error": "var(--mantine-color-red-6)",
            "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
            "--mantine-color-anchor": `var(--mantine-color-${theme.primaryColor}-${lightPrimaryShade})`,
            "--mantine-color-default": "var(--mantine-color-white)",
            "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
            "--mantine-color-default-color": "var(--mantine-color-black)",
            "--mantine-color-default-border": "var(--mantine-color-gray-4)",
            "--mantine-color-dimmed": "var(--mantine-color-gray-6)"
        },
        dark: {
            "--mantine-primary-color-contrast": getContrastColor.getPrimaryContrastColor(theme, "dark"),
            "--mantine-color-bright": "var(--mantine-color-white)",
            "--mantine-color-text": "var(--mantine-color-dark-0)",
            "--mantine-color-body": "var(--mantine-color-dark-7)",
            "--mantine-color-error": "var(--mantine-color-red-8)",
            "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
            "--mantine-color-anchor": `var(--mantine-color-${theme.primaryColor}-4)`,
            "--mantine-color-default": "var(--mantine-color-dark-6)",
            "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
            "--mantine-color-default-color": "var(--mantine-color-white)",
            "--mantine-color-default-border": "var(--mantine-color-dark-4)",
            "--mantine-color-dimmed": "var(--mantine-color-dark-2)"
        }
    };
    assignSizeVariables(result.variables, theme.breakpoints, "breakpoint");
    assignSizeVariables(result.variables, theme.spacing, "spacing");
    assignSizeVariables(result.variables, theme.fontSizes, "font-size");
    assignSizeVariables(result.variables, theme.lineHeights, "line-height");
    assignSizeVariables(result.variables, theme.shadows, "shadow");
    assignSizeVariables(result.variables, theme.radius, "radius");
    theme.colors[theme.primaryColor].forEach(function(_, index) {
        result.variables[`--mantine-primary-color-${index}`] = `var(--mantine-color-${theme.primaryColor}-${index})`;
    });
    keys.keys(theme.colors).forEach(function(color) {
        var value = theme.colors[color];
        if (virtualColor.isVirtualColor(value)) {
            Object.assign(result.light, getCssColorVariables.getCSSColorVariables({
                theme,
                name: value.name,
                color: value.light,
                colorScheme: "light",
                withColorValues: true
            }));
            Object.assign(result.dark, getCssColorVariables.getCSSColorVariables({
                theme,
                name: value.name,
                color: value.dark,
                colorScheme: "dark",
                withColorValues: true
            }));
            return;
        }
        value.forEach(function(shade, index) {
            result.variables[`--mantine-color-${color}-${index}`] = shade;
        });
        Object.assign(result.light, getCssColorVariables.getCSSColorVariables({
            theme,
            color,
            colorScheme: "light",
            withColorValues: false
        }));
        Object.assign(result.dark, getCssColorVariables.getCSSColorVariables({
            theme,
            color,
            colorScheme: "dark",
            withColorValues: false
        }));
    });
    var headings = theme.headings.sizes;
    keys.keys(headings).forEach(function(heading) {
        result.variables[`--mantine-${heading}-font-size`] = headings[heading].fontSize;
        result.variables[`--mantine-${heading}-line-height`] = headings[heading].lineHeight;
        result.variables[`--mantine-${heading}-font-weight`] = headings[heading].fontWeight || theme.headings.fontWeight;
    });
    return result;
};
exports.defaultCssVariablesResolver = defaultCssVariablesResolver; //# sourceMappingURL=default-css-variables-resolver.cjs.map

},{"b4cf1f061cd40dd7":"kvYzO","50dac987a6ddaab0":"ebAaL","a7ab5967d4e67efa":"9MtAM","ded88cb8d3802a62":"iKGFf","6fd63235b095a54b":"9HEEB","b41f6e74baee71e3":"fKUzT","a1e9c582a2b0b562":"ez6cW","35d49ed67ec08aa1":"kGiQC","6b9d17c10a3f4f19":"6TI0O"}],"ez6cW":[function(require,module,exports) {
"use client";
"use strict";
var getPrimaryShade = require("7b35b85951355c7b");
var parseThemeColor = require("3a5a1809f5b1a66c");
function getContrastColor(param) {
    var color = param.color, theme = param.theme, autoContrast = param.autoContrast;
    var _autoContrast = typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
    if (!_autoContrast) return "var(--mantine-color-white)";
    var parsed = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme
    });
    return parsed.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
}
function getPrimaryContrastColor(theme, colorScheme) {
    return getContrastColor({
        color: theme.colors[theme.primaryColor][getPrimaryShade.getPrimaryShade(theme, colorScheme)],
        theme,
        autoContrast: null
    });
}
exports.getContrastColor = getContrastColor;
exports.getPrimaryContrastColor = getPrimaryContrastColor; //# sourceMappingURL=get-contrast-color.cjs.map

},{"7b35b85951355c7b":"fKUzT","3a5a1809f5b1a66c":"ctp80"}],"kGiQC":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var getPrimaryShade = require("20bd0e74bbfc2376");
require("3b6b1e9d1550e4aa");
require("545b11db0a25fd51");
require("5a530b747ba1a484");
var rgba = require("c4993f9e0e071371");
function getCSSColorVariables(param) {
    var theme = param.theme, color = param.color, colorScheme = param.colorScheme, _param_name = param.name, name = _param_name === void 0 ? color : _param_name, _param_withColorValues = param.withColorValues, withColorValues = _param_withColorValues === void 0 ? true : _param_withColorValues;
    if (!theme.colors[color]) return {};
    if (colorScheme === "light") {
        var primaryShade2 = getPrimaryShade.getPrimaryShade(theme, "light");
        var dynamicVariables2 = {
            [`--mantine-color-${name}-text`]: `var(--mantine-color-${name}-filled)`,
            [`--mantine-color-${name}-filled`]: `var(--mantine-color-${name}-${primaryShade2})`,
            [`--mantine-color-${name}-filled-hover`]: `var(--mantine-color-${name}-${primaryShade2 === 9 ? 8 : primaryShade2 + 1})`,
            [`--mantine-color-${name}-light`]: rgba.alpha(theme.colors[color][primaryShade2], 0.1),
            [`--mantine-color-${name}-light-hover`]: rgba.alpha(theme.colors[color][primaryShade2], 0.12),
            [`--mantine-color-${name}-light-color`]: `var(--mantine-color-${name}-${primaryShade2})`,
            [`--mantine-color-${name}-outline`]: `var(--mantine-color-${name}-${primaryShade2})`,
            [`--mantine-color-${name}-outline-hover`]: rgba.alpha(theme.colors[color][primaryShade2], 0.05)
        };
        if (!withColorValues) return dynamicVariables2;
        return (0, _objectSpread._)({
            [`--mantine-color-${name}-0`]: theme.colors[color][0],
            [`--mantine-color-${name}-1`]: theme.colors[color][1],
            [`--mantine-color-${name}-2`]: theme.colors[color][2],
            [`--mantine-color-${name}-3`]: theme.colors[color][3],
            [`--mantine-color-${name}-4`]: theme.colors[color][4],
            [`--mantine-color-${name}-5`]: theme.colors[color][5],
            [`--mantine-color-${name}-6`]: theme.colors[color][6],
            [`--mantine-color-${name}-7`]: theme.colors[color][7],
            [`--mantine-color-${name}-8`]: theme.colors[color][8],
            [`--mantine-color-${name}-9`]: theme.colors[color][9]
        }, dynamicVariables2);
    }
    var primaryShade = getPrimaryShade.getPrimaryShade(theme, "dark");
    var dynamicVariables = {
        [`--mantine-color-${name}-text`]: `var(--mantine-color-${name}-4)`,
        [`--mantine-color-${name}-filled`]: `var(--mantine-color-${name}-${primaryShade})`,
        [`--mantine-color-${name}-filled-hover`]: `var(--mantine-color-${name}-${primaryShade === 9 ? 8 : primaryShade + 1})`,
        [`--mantine-color-${name}-light`]: rgba.alpha(theme.colors[color][Math.max(0, primaryShade - 2)], 0.15),
        [`--mantine-color-${name}-light-hover`]: rgba.alpha(theme.colors[color][Math.max(0, primaryShade - 2)], 0.2),
        [`--mantine-color-${name}-light-color`]: `var(--mantine-color-${name}-${Math.max(primaryShade - 5, 0)})`,
        [`--mantine-color-${name}-outline`]: `var(--mantine-color-${name}-${Math.max(primaryShade - 4, 0)})`,
        [`--mantine-color-${name}-outline-hover`]: rgba.alpha(theme.colors[color][Math.max(primaryShade - 4, 0)], 0.05)
    };
    if (!withColorValues) return dynamicVariables;
    return (0, _objectSpread._)({
        [`--mantine-color-${name}-0`]: theme.colors[color][0],
        [`--mantine-color-${name}-1`]: theme.colors[color][1],
        [`--mantine-color-${name}-2`]: theme.colors[color][2],
        [`--mantine-color-${name}-3`]: theme.colors[color][3],
        [`--mantine-color-${name}-4`]: theme.colors[color][4],
        [`--mantine-color-${name}-5`]: theme.colors[color][5],
        [`--mantine-color-${name}-6`]: theme.colors[color][6],
        [`--mantine-color-${name}-7`]: theme.colors[color][7],
        [`--mantine-color-${name}-8`]: theme.colors[color][8],
        [`--mantine-color-${name}-9`]: theme.colors[color][9]
    }, dynamicVariables);
}
exports.getCSSColorVariables = getCSSColorVariables; //# sourceMappingURL=get-css-color-variables.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","20bd0e74bbfc2376":"fKUzT","3b6b1e9d1550e4aa":"9MtAM","545b11db0a25fd51":"iKGFf","5a530b747ba1a484":"9HEEB","c4993f9e0e071371":"aIray"}],"6TI0O":[function(require,module,exports) {
"use strict";
require("3b0183a375fc18ae");
require("6b81d14054c66634");
require("102bdbce1d713ac6");
var colorsTuple = require("eb1c80c4008ca765");
function virtualColor(input) {
    var result = colorsTuple.colorsTuple(Array.from({
        length: 10
    }).map(function(_, i) {
        return `var(--mantine-color-${input.name}-${i})`;
    }));
    Object.defineProperty(result, "mantine-virtual-color", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: true
    });
    Object.defineProperty(result, "dark", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.dark
    });
    Object.defineProperty(result, "light", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.light
    });
    Object.defineProperty(result, "name", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.name
    });
    return result;
}
function isVirtualColor(value) {
    return !!value && typeof value === "object" && "mantine-virtual-color" in value;
}
exports.isVirtualColor = isVirtualColor;
exports.virtualColor = virtualColor; //# sourceMappingURL=virtual-color.cjs.map

},{"3b0183a375fc18ae":"9MtAM","6b81d14054c66634":"iKGFf","102bdbce1d713ac6":"9HEEB","eb1c80c4008ca765":"0wiSU"}],"0wiSU":[function(require,module,exports) {
"use strict";
function colorsTuple(input) {
    if (Array.isArray(input)) return input;
    return Array(10).fill(input);
}
exports.colorsTuple = colorsTuple; //# sourceMappingURL=colors-tuple.cjs.map

},{}],"hpF9M":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("94338be98f7bee5d");
require("96e715988fdd406");
require("583014e8c59faff6");
require("a200e2b94c2db5a3");
var defaultTheme = require("a9138d5324753a57");
var defaultCssVariablesResolver = require("63db21ece30a2df0");
var defaultCssVariables = defaultCssVariablesResolver.defaultCssVariablesResolver(defaultTheme.DEFAULT_THEME);
function removeDefaultVariables(input) {
    var cleaned = {
        variables: {},
        light: {},
        dark: {}
    };
    keys.keys(input.variables).forEach(function(key) {
        if (defaultCssVariables.variables[key] !== input.variables[key]) cleaned.variables[key] = input.variables[key];
    });
    keys.keys(input.light).forEach(function(key) {
        if (defaultCssVariables.light[key] !== input.light[key]) cleaned.light[key] = input.light[key];
    });
    keys.keys(input.dark).forEach(function(key) {
        if (defaultCssVariables.dark[key] !== input.dark[key]) cleaned.dark[key] = input.dark[key];
    });
    return cleaned;
}
exports.removeDefaultVariables = removeDefaultVariables; //# sourceMappingURL=remove-default-variables.cjs.map

},{"94338be98f7bee5d":"kvYzO","96e715988fdd406":"9MtAM","583014e8c59faff6":"iKGFf","a200e2b94c2db5a3":"9HEEB","a9138d5324753a57":"6AMGA","63db21ece30a2df0":"axjje"}],"cATD0":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function suppressNextjsWarning() {
    var originalError = console.error;
    console.error = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (args.length > 1 && typeof args[0] === "string" && args[0].toLowerCase().includes("extra attributes from the server") && typeof args[1] === "string" && args[1].toLowerCase().includes("data-mantine-color-scheme")) ;
        else originalError.apply(void 0, (0, _toConsumableArray._)(args));
    };
}
exports.suppressNextjsWarning = suppressNextjsWarning; //# sourceMappingURL=suppress-nextjs-warning.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"4Xpxx":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("6635e6117289313");
var hooks = require("8dd13c96518f9199");
function setColorSchemeAttribute(colorScheme, getRootElement) {
    var _window_matchMedia, _getRootElement;
    var hasDarkColorScheme = typeof window !== "undefined" && "matchMedia" in window && ((_window_matchMedia = window.matchMedia("(prefers-color-scheme: dark)")) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.matches);
    var computedColorScheme = colorScheme !== "auto" ? colorScheme : hasDarkColorScheme ? "dark" : "light";
    (_getRootElement = getRootElement()) === null || _getRootElement === void 0 ? void 0 : _getRootElement.setAttribute("data-mantine-color-scheme", computedColorScheme);
}
function useProviderColorScheme(param) {
    var manager = param.manager, defaultColorScheme = param.defaultColorScheme, getRootElement = param.getRootElement, forceColorScheme = param.forceColorScheme;
    var media = React.useRef(null);
    var _React_useState = (0, _slicedToArray._)(React.useState(function() {
        return manager.get(defaultColorScheme);
    }), 2), value = _React_useState[0], setValue = _React_useState[1];
    var colorSchemeValue = forceColorScheme || value;
    var setColorScheme = React.useCallback(function(colorScheme) {
        if (!forceColorScheme) {
            setColorSchemeAttribute(colorScheme, getRootElement);
            setValue(colorScheme);
            manager.set(colorScheme);
        }
    }, [
        manager.set,
        colorSchemeValue,
        forceColorScheme
    ]);
    var clearColorScheme = React.useCallback(function() {
        setValue(defaultColorScheme);
        setColorSchemeAttribute(defaultColorScheme, getRootElement);
        manager.clear();
    }, [
        manager.clear,
        defaultColorScheme
    ]);
    React.useEffect(function() {
        manager.subscribe(setColorScheme);
        return manager.unsubscribe;
    }, [
        manager.subscribe,
        manager.unsubscribe
    ]);
    hooks.useIsomorphicEffect(function() {
        setColorSchemeAttribute(manager.get(defaultColorScheme), getRootElement);
    }, []);
    React.useEffect(function() {
        var _media_current;
        if (forceColorScheme) {
            setColorSchemeAttribute(forceColorScheme, getRootElement);
            return function() {};
        }
        if (forceColorScheme === void 0) setColorSchemeAttribute(value, getRootElement);
        if (typeof window !== "undefined" && "matchMedia" in window) media.current = window.matchMedia("(prefers-color-scheme: dark)");
        var listener = function(event) {
            if (value === "auto") setColorSchemeAttribute(event.matches ? "dark" : "light", getRootElement);
        };
        (_media_current = media.current) === null || _media_current === void 0 ? void 0 : _media_current.addEventListener("change", listener);
        return function() {
            var _media_current;
            return (_media_current = media.current) === null || _media_current === void 0 ? void 0 : _media_current.removeEventListener("change", listener);
        };
    }, [
        value,
        forceColorScheme
    ]);
    return {
        colorScheme: colorSchemeValue,
        setColorScheme,
        clearColorScheme
    };
}
exports.useProviderColorScheme = useProviderColorScheme; //# sourceMappingURL=use-provider-color-scheme.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","6635e6117289313":"9MtAM","8dd13c96518f9199":"9HEEB"}],"aC2RN":[function(require,module,exports) {
"use client";
"use strict";
var hooks = require("2c0639092ee270eb");
function useRespectReduceMotion(param) {
    var respectReducedMotion = param.respectReducedMotion, getRootElement = param.getRootElement;
    hooks.useIsomorphicEffect(function() {
        var _getRootElement;
        if (respectReducedMotion) (_getRootElement = getRootElement()) === null || _getRootElement === void 0 ? void 0 : _getRootElement.setAttribute("data-respect-reduced-motion", "true");
    }, [
        respectReducedMotion
    ]);
}
exports.useRespectReduceMotion = useRespectReduceMotion; //# sourceMappingURL=use-respect-reduce-motion.cjs.map

},{"2c0639092ee270eb":"9HEEB"}],"iKrc2":[function(require,module,exports) {
"use client";
"use strict";
var cx = require("fd1677fe11ca26fb");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var FOCUS_CLASS_NAMES = {
    always: "mantine-focus-always",
    auto: "mantine-focus-auto",
    never: "mantine-focus-never"
};
function getGlobalClassNames(param) {
    var theme = param.theme, options = param.options, unstyled = param.unstyled;
    return cx__default.default((options === null || options === void 0 ? void 0 : options.focusable) && !unstyled && (theme.focusClassName || FOCUS_CLASS_NAMES[theme.focusRing]), (options === null || options === void 0 ? void 0 : options.active) && !unstyled && theme.activeClassName);
}
exports.FOCUS_CLASS_NAMES = FOCUS_CLASS_NAMES;
exports.getGlobalClassNames = getGlobalClassNames; //# sourceMappingURL=get-global-class-names.cjs.map

},{"fd1677fe11ca26fb":"8QFOC"}],"d0sAY":[function(require,module,exports) {
"use client";
"use strict";
require("f475fefd74f84421");
require("32ad11a1f67e874d");
require("f8ac44ea6d8eaf84");
var Mantine_context = require("b59837109f2e2b27");
require("bf0df0e8cb976a38");
require("20555565d1a247e7");
var MantineThemeProvider = require("a85940fc068d9a85");
require("8b8e65c69c49dde2");
var getClassName = require("5dc75f261c7a55c2");
var getStyle = require("42cec98ec0d6241f");
var useTransformedStyles = require("4d70623860455115");
function useStyles(param) {
    var name = param.name, classes = param.classes, props = param.props, stylesCtx = param.stylesCtx, className = param.className, style = param.style, _param_rootSelector = param.rootSelector, rootSelector = _param_rootSelector === void 0 ? "root" : _param_rootSelector, unstyled = param.unstyled, classNames = param.classNames, styles = param.styles, vars = param.vars, varsResolver = param.varsResolver;
    var theme = MantineThemeProvider.useMantineTheme();
    var classNamesPrefix = Mantine_context.useMantineClassNamesPrefix();
    var withStaticClasses = Mantine_context.useMantineWithStaticClasses();
    var headless = Mantine_context.useMantineIsHeadless();
    var themeName = (Array.isArray(name) ? name : [
        name
    ]).filter(function(n) {
        return n;
    });
    var _useTransformedStyles_useStylesTransform = useTransformedStyles.useStylesTransform({
        props,
        stylesCtx,
        themeName
    }), withStylesTransform = _useTransformedStyles_useStylesTransform.withStylesTransform, getTransformedStyles = _useTransformedStyles_useStylesTransform.getTransformedStyles;
    return function(selector, options) {
        return {
            className: getClassName.getClassName({
                theme,
                options,
                themeName,
                selector,
                classNamesPrefix,
                classNames,
                classes,
                unstyled,
                className,
                rootSelector,
                props,
                stylesCtx,
                withStaticClasses,
                headless,
                transformedStyles: getTransformedStyles([
                    options === null || options === void 0 ? void 0 : options.styles,
                    styles
                ])
            }),
            style: getStyle.getStyle({
                theme,
                themeName,
                selector,
                options,
                props,
                stylesCtx,
                rootSelector,
                styles,
                style,
                vars,
                varsResolver,
                headless,
                withStylesTransform
            })
        };
    };
}
exports.useStyles = useStyles; //# sourceMappingURL=use-styles.cjs.map

},{"f475fefd74f84421":"9MtAM","32ad11a1f67e874d":"iKGFf","f8ac44ea6d8eaf84":"9HEEB","b59837109f2e2b27":"2FdJg","bf0df0e8cb976a38":"6AMGA","20555565d1a247e7":"erSvz","a85940fc068d9a85":"kqQOF","8b8e65c69c49dde2":"8YP4O","5dc75f261c7a55c2":"gWO7G","42cec98ec0d6241f":"5e5OZ","4d70623860455115":"kzcy4"}],"gWO7G":[function(require,module,exports) {
"use client";
"use strict";
var cx = require("55c1bc146076bc86");
var getGlobalClassNames = require("62da3db8cfa793f5");
var getOptionsClassNames = require("300e335c5c692b78");
var getResolvedClassNames = require("f7224218d91b9efc");
var getRootClassName = require("e502960524001795");
var getSelectorClassName = require("af89e4a1a449d084");
var getStaticClassNames = require("4bc4c63cad29b32c");
var getThemeClassNames = require("6b733b0bf2b41b83");
var getVariantClassName = require("7272850de1b3486e");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
function getClassName(param) {
    var theme = param.theme, options = param.options, themeName = param.themeName, selector = param.selector, classNamesPrefix = param.classNamesPrefix, classNames = param.classNames, classes = param.classes, unstyled = param.unstyled, className = param.className, rootSelector = param.rootSelector, props = param.props, stylesCtx = param.stylesCtx, withStaticClasses = param.withStaticClasses, headless = param.headless, transformedStyles = param.transformedStyles;
    return cx__default.default(getGlobalClassNames.getGlobalClassNames({
        theme,
        options,
        unstyled: unstyled || headless
    }), getThemeClassNames.getThemeClassNames({
        theme,
        themeName,
        selector,
        props,
        stylesCtx
    }), getVariantClassName.getVariantClassName({
        options,
        classes,
        selector,
        unstyled
    }), getResolvedClassNames.getResolvedClassNames({
        selector,
        stylesCtx,
        theme,
        classNames,
        props
    }), getResolvedClassNames.getResolvedClassNames({
        selector,
        stylesCtx,
        theme,
        classNames: transformedStyles,
        props
    }), getOptionsClassNames.getOptionsClassNames({
        selector,
        stylesCtx,
        options,
        props,
        theme
    }), getRootClassName.getRootClassName({
        rootSelector,
        selector,
        className
    }), getSelectorClassName.getSelectorClassName({
        selector,
        classes,
        unstyled: unstyled || headless
    }), withStaticClasses && !headless && getStaticClassNames.getStaticClassNames({
        themeName,
        classNamesPrefix,
        selector,
        withStaticClass: options === null || options === void 0 ? void 0 : options.withStaticClass
    }), options === null || options === void 0 ? void 0 : options.className);
}
exports.getClassName = getClassName; //# sourceMappingURL=get-class-name.cjs.map

},{"55c1bc146076bc86":"8QFOC","62da3db8cfa793f5":"iKrc2","300e335c5c692b78":"iBfST","f7224218d91b9efc":"5adgu","e502960524001795":"kbsga","af89e4a1a449d084":"jcAcV","4bc4c63cad29b32c":"2iCMP","6b733b0bf2b41b83":"44iL7","7272850de1b3486e":"o5JoX"}],"iBfST":[function(require,module,exports) {
"use client";
"use strict";
var resolveClassNames = require("f7a9b7bcf06d71f1");
function getOptionsClassNames(param) {
    var selector = param.selector, stylesCtx = param.stylesCtx, options = param.options, props = param.props, theme = param.theme;
    return resolveClassNames.resolveClassNames({
        theme,
        classNames: options === null || options === void 0 ? void 0 : options.classNames,
        props: (options === null || options === void 0 ? void 0 : options.props) || props,
        stylesCtx
    })[selector];
}
exports.getOptionsClassNames = getOptionsClassNames; //# sourceMappingURL=get-options-class-names.cjs.map

},{"f7a9b7bcf06d71f1":"kjN8X"}],"5adgu":[function(require,module,exports) {
"use client";
"use strict";
var resolveClassNames = require("fa4d687dee970faa");
function getResolvedClassNames(param) {
    var selector = param.selector, stylesCtx = param.stylesCtx, theme = param.theme, classNames = param.classNames, props = param.props;
    return resolveClassNames.resolveClassNames({
        theme,
        classNames,
        props,
        stylesCtx
    })[selector];
}
exports.getResolvedClassNames = getResolvedClassNames; //# sourceMappingURL=get-resolved-class-names.cjs.map

},{"fa4d687dee970faa":"kjN8X"}],"kbsga":[function(require,module,exports) {
"use client";
"use strict";
function getRootClassName(param) {
    var rootSelector = param.rootSelector, selector = param.selector, className = param.className;
    return rootSelector === selector ? className : void 0;
}
exports.getRootClassName = getRootClassName; //# sourceMappingURL=get-root-class-name.cjs.map

},{}],"jcAcV":[function(require,module,exports) {
"use client";
"use strict";
function getSelectorClassName(param) {
    var selector = param.selector, classes = param.classes, unstyled = param.unstyled;
    return unstyled ? void 0 : classes[selector];
}
exports.getSelectorClassName = getSelectorClassName; //# sourceMappingURL=get-selector-class-name.cjs.map

},{}],"2iCMP":[function(require,module,exports) {
"use client";
"use strict";
function getStaticClassNames(param) {
    var themeName = param.themeName, classNamesPrefix = param.classNamesPrefix, selector = param.selector, withStaticClass = param.withStaticClass;
    if (withStaticClass === false) return [];
    return themeName.map(function(n) {
        return `${classNamesPrefix}-${n}-${selector}`;
    });
}
exports.getStaticClassNames = getStaticClassNames; //# sourceMappingURL=get-static-class-names.cjs.map

},{}],"44iL7":[function(require,module,exports) {
"use client";
"use strict";
var resolveClassNames = require("56da7afd318bfed9");
function getThemeClassNames(param) {
    var themeName = param.themeName, theme = param.theme, selector = param.selector, props = param.props, stylesCtx = param.stylesCtx;
    return themeName.map(function(n) {
        var _resolveClassNames_resolveClassNames, _theme_components_n;
        return (_resolveClassNames_resolveClassNames = resolveClassNames.resolveClassNames({
            theme,
            classNames: (_theme_components_n = theme.components[n]) === null || _theme_components_n === void 0 ? void 0 : _theme_components_n.classNames,
            props,
            stylesCtx
        })) === null || _resolveClassNames_resolveClassNames === void 0 ? void 0 : _resolveClassNames_resolveClassNames[selector];
    });
}
exports.getThemeClassNames = getThemeClassNames; //# sourceMappingURL=get-theme-class-names.cjs.map

},{"56da7afd318bfed9":"kjN8X"}],"o5JoX":[function(require,module,exports) {
"use client";
"use strict";
function getVariantClassName(param) {
    var options = param.options, classes = param.classes, selector = param.selector, unstyled = param.unstyled;
    return (options === null || options === void 0 ? void 0 : options.variant) && !unstyled ? classes[`${selector}--${options.variant}`] : void 0;
}
exports.getVariantClassName = getVariantClassName; //# sourceMappingURL=get-variant-class-name.cjs.map

},{}],"5e5OZ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var getThemeStyles = require("e3b74233999e08de");
var resolveStyle = require("e4a881f6151fafe");
var resolveStyles = require("9d5f81469859fc40");
var resolveVars = require("db08dff2379afecf");
function getStyle(param) {
    var theme = param.theme, themeName = param.themeName, selector = param.selector, options = param.options, props = param.props, stylesCtx = param.stylesCtx, rootSelector = param.rootSelector, styles = param.styles, style = param.style, vars = param.vars, varsResolver = param.varsResolver, headless = param.headless, withStylesTransform = param.withStylesTransform;
    return (0, _objectSpread._)({}, !withStylesTransform && getThemeStyles.getThemeStyles({
        theme,
        themeName,
        props,
        stylesCtx,
        selector
    }), !withStylesTransform && resolveStyles.resolveStyles({
        theme,
        styles,
        props,
        stylesCtx
    })[selector], !withStylesTransform && resolveStyles.resolveStyles({
        theme,
        styles: options === null || options === void 0 ? void 0 : options.styles,
        props: (options === null || options === void 0 ? void 0 : options.props) || props,
        stylesCtx
    })[selector], resolveVars.resolveVars({
        theme,
        props,
        stylesCtx,
        vars,
        varsResolver,
        selector,
        themeName,
        headless
    }), rootSelector === selector ? resolveStyle.resolveStyle({
        style,
        theme
    }) : null, resolveStyle.resolveStyle({
        style: options === null || options === void 0 ? void 0 : options.style,
        theme
    }));
}
exports.getStyle = getStyle; //# sourceMappingURL=get-style.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","e3b74233999e08de":"2FMhu","e4a881f6151fafe":"a2GHj","9d5f81469859fc40":"2cTj2","db08dff2379afecf":"9t49g"}],"2FMhu":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var resolveStyles = require("58f3b716fe2a33d6");
function getThemeStyles(param) {
    var theme = param.theme, themeName = param.themeName, props = param.props, stylesCtx = param.stylesCtx, selector = param.selector;
    return themeName.map(function(n) {
        var _theme_components_n;
        return resolveStyles.resolveStyles({
            theme,
            styles: (_theme_components_n = theme.components[n]) === null || _theme_components_n === void 0 ? void 0 : _theme_components_n.styles,
            props,
            stylesCtx
        })[selector];
    }).reduce(function(acc, val) {
        return (0, _objectSpread._)({}, acc, val);
    }, {});
}
exports.getThemeStyles = getThemeStyles; //# sourceMappingURL=get-theme-styles.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","58f3b716fe2a33d6":"2cTj2"}],"a2GHj":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function resolveStyle(param) {
    var style = param.style, theme = param.theme;
    if (Array.isArray(style)) return (0, _toConsumableArray._)(style).reduce(function(acc, item) {
        return (0, _objectSpread._)({}, acc, resolveStyle({
            style: item,
            theme
        }));
    }, {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}
exports.resolveStyle = resolveStyle; //# sourceMappingURL=resolve-style.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_to_consumable_array":"jg7I9"}],"9t49g":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var mergeVars = require("608bec2fca649b02");
function resolveVars(param) {
    var vars = param.vars, varsResolver = param.varsResolver, theme = param.theme, props = param.props, stylesCtx = param.stylesCtx, selector = param.selector, themeName = param.themeName, headless = param.headless;
    var _mergeVars_mergeVars;
    return (_mergeVars_mergeVars = mergeVars.mergeVars([
        headless ? {} : varsResolver === null || varsResolver === void 0 ? void 0 : varsResolver(theme, props, stylesCtx)
    ].concat((0, _toConsumableArray._)(themeName.map(function(name) {
        var _theme_components_name_vars, _theme_components_name, _theme_components;
        return (_theme_components = theme.components) === null || _theme_components === void 0 ? void 0 : (_theme_components_name = _theme_components[name]) === null || _theme_components_name === void 0 ? void 0 : (_theme_components_name_vars = _theme_components_name.vars) === null || _theme_components_name_vars === void 0 ? void 0 : _theme_components_name_vars.call(_theme_components_name, theme, props, stylesCtx);
    })), [
        vars === null || vars === void 0 ? void 0 : vars(theme, props, stylesCtx)
    ]))) === null || _mergeVars_mergeVars === void 0 ? void 0 : _mergeVars_mergeVars[selector];
}
exports.resolveVars = resolveVars; //# sourceMappingURL=resolve-vars.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","608bec2fca649b02":"cErvz"}],"cErvz":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var filterProps = require("5f24e2eaa2ac02a0");
require("c365ca3ef5a9c792");
require("ce48411690042311");
require("5b7169f7ae02e303");
function mergeVars(vars) {
    return vars.reduce(function(acc, current) {
        if (current) Object.keys(current).forEach(function(key) {
            acc[key] = (0, _objectSpread._)({}, acc[key], filterProps.filterProps(current[key]));
        });
        return acc;
    }, {});
}
exports.mergeVars = mergeVars; //# sourceMappingURL=merge-vars.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","5f24e2eaa2ac02a0":"2Jst9","c365ca3ef5a9c792":"9MtAM","ce48411690042311":"iKGFf","5b7169f7ae02e303":"9HEEB"}],"kzcy4":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
require("1fae5dd8bdc92b1f");
require("2fdb86175f741bd5");
require("2ad78e0aeae4774b");
var Mantine_context = require("8bace91f309ead3c");
require("17b4104c333e557");
require("70110d50ffd34dae");
var MantineThemeProvider = require("db219673f26b777c");
require("c561ed83634fa67c");
function useStylesTransform(param) {
    var props = param.props, stylesCtx = param.stylesCtx, themeName = param.themeName;
    var _Mantine_context_useMantineStylesTransform;
    var theme = MantineThemeProvider.useMantineTheme();
    var stylesTransform = (_Mantine_context_useMantineStylesTransform = Mantine_context.useMantineStylesTransform()) === null || _Mantine_context_useMantineStylesTransform === void 0 ? void 0 : _Mantine_context_useMantineStylesTransform();
    var getTransformedStyles = function(styles) {
        if (!stylesTransform) return [];
        var transformedStyles = styles.map(function(style) {
            return stylesTransform(style, {
                props,
                theme,
                ctx: stylesCtx
            });
        });
        return (0, _toConsumableArray._)(transformedStyles).concat((0, _toConsumableArray._)(themeName.map(function(n) {
            var _theme_components_n;
            return stylesTransform((_theme_components_n = theme.components[n]) === null || _theme_components_n === void 0 ? void 0 : _theme_components_n.styles, {
                props,
                theme,
                ctx: stylesCtx
            });
        }))).filter(Boolean);
    };
    return {
        getTransformedStyles,
        withStylesTransform: !!stylesTransform
    };
}
exports.useStylesTransform = useStylesTransform; //# sourceMappingURL=use-transformed-styles.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","1fae5dd8bdc92b1f":"9MtAM","2fdb86175f741bd5":"iKGFf","2ad78e0aeae4774b":"9HEEB","8bace91f309ead3c":"2FdJg","17b4104c333e557":"6AMGA","70110d50ffd34dae":"erSvz","db219673f26b777c":"kqQOF","c561ed83634fa67c":"8YP4O"}],"cEHAd":[function(require,module,exports) {
"use strict";
var toRgba = require("b0e4407318d08ed2");
function lighten(color, alpha) {
    if (color.startsWith("var(")) return `color-mix(in srgb, ${color}, white ${alpha * 100}%)`;
    var _toRgba_toRgba = toRgba.toRgba(color), r = _toRgba_toRgba.r, g = _toRgba_toRgba.g, b = _toRgba_toRgba.b, a = _toRgba_toRgba.a;
    var light = function(input) {
        return Math.round(input + (255 - input) * alpha);
    };
    return `rgba(${light(r)}, ${light(g)}, ${light(b)}, ${a})`;
}
exports.lighten = lighten; //# sourceMappingURL=lighten.cjs.map

},{"b0e4407318d08ed2":"8dGkg"}],"cN4dA":[function(require,module,exports) {
"use client";
"use strict";
function getAutoContrastValue(autoContrast, theme) {
    return typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
}
exports.getAutoContrastValue = getAutoContrastValue; //# sourceMappingURL=get-auto-contrast-value.cjs.map

},{}],"7Rjy0":[function(require,module,exports) {
"use client";
"use strict";
var React = require("8f71201d5d86b612");
var hooks = require("fe13371b9fe59b63");
require("26983f2b8af6a253");
var noop = require("3d569f01669c2b4f");
var Mantine_context = require("e22ee75b2133543f");
function disableTransition(nonce) {
    var style = document.createElement("style");
    style.setAttribute("data-mantine-styles", "inline");
    style.innerHTML = "*, *::before, *::after {transition: none !important;}";
    style.setAttribute("data-mantine-disable-transition", "true");
    nonce && style.setAttribute("nonce", nonce);
    document.head.appendChild(style);
    var clear = function() {
        return document.querySelectorAll("[data-mantine-disable-transition]").forEach(function(element) {
            return element.remove();
        });
    };
    return clear;
}
function useMantineColorScheme() {
    var keepTransitions = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).keepTransitions;
    var clearStylesRef = React.useRef(noop.noop);
    var timeoutRef = React.useRef(-1);
    var ctx = React.useContext(Mantine_context.MantineContext);
    var nonce = Mantine_context.useMantineStyleNonce();
    var nonceValue = React.useRef(nonce === null || nonce === void 0 ? void 0 : nonce());
    if (!ctx) throw new Error("[@mantine/core] MantineProvider was not found in tree");
    var setColorScheme = function(value) {
        ctx.setColorScheme(value);
        clearStylesRef.current = keepTransitions ? function() {} : disableTransition(nonceValue.current);
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            var _clearStylesRef_current;
            (_clearStylesRef_current = clearStylesRef.current) === null || _clearStylesRef_current === void 0 ? void 0 : _clearStylesRef_current.call(clearStylesRef);
        }, 10);
    };
    var clearColorScheme = function() {
        ctx.clearColorScheme();
        clearStylesRef.current = keepTransitions ? function() {} : disableTransition(nonceValue.current);
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            var _clearStylesRef_current;
            (_clearStylesRef_current = clearStylesRef.current) === null || _clearStylesRef_current === void 0 ? void 0 : _clearStylesRef_current.call(clearStylesRef);
        }, 10);
    };
    var osColorScheme = hooks.useColorScheme("light", {
        getInitialValueInEffect: false
    });
    var computedColorScheme = ctx.colorScheme === "auto" ? osColorScheme : ctx.colorScheme;
    var toggleColorScheme = React.useCallback(function() {
        return setColorScheme(computedColorScheme === "light" ? "dark" : "light");
    }, [
        setColorScheme,
        computedColorScheme
    ]);
    React.useEffect(function() {
        return function() {
            var _clearStylesRef_current;
            (_clearStylesRef_current = clearStylesRef.current) === null || _clearStylesRef_current === void 0 ? void 0 : _clearStylesRef_current.call(clearStylesRef);
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    return {
        colorScheme: ctx.colorScheme,
        setColorScheme,
        clearColorScheme,
        toggleColorScheme
    };
}
exports.useMantineColorScheme = useMantineColorScheme; //# sourceMappingURL=use-mantine-color-scheme.cjs.map

},{"8f71201d5d86b612":"9MtAM","fe13371b9fe59b63":"9HEEB","26983f2b8af6a253":"iKGFf","3d569f01669c2b4f":"2dVWr","e22ee75b2133543f":"2FdJg"}],"htFAa":[function(require,module,exports) {
"use client";
"use strict";
var hooks = require("33c30ccc4d464490");
var useMantineColorScheme = require("56f32f9d1147d266");
function useComputedColorScheme(defaultValue) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        getInitialValueInEffect: true
    };
    var osColorScheme = hooks.useColorScheme(defaultValue, options);
    var colorScheme = useMantineColorScheme.useMantineColorScheme().colorScheme;
    return colorScheme === "auto" ? osColorScheme : colorScheme;
}
exports.useComputedColorScheme = useComputedColorScheme; //# sourceMappingURL=use-computed-color-scheme.cjs.map

},{"33c30ccc4d464490":"9HEEB","56f32f9d1147d266":"7Rjy0"}],"2aQv3":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("fcd3f9bbed7f486a");
var getScript = function(param) {
    var defaultColorScheme = param.defaultColorScheme, localStorageKey = param.localStorageKey, forceColorScheme = param.forceColorScheme;
    return forceColorScheme ? `document.documentElement.setAttribute("data-mantine-color-scheme", '${forceColorScheme}');` : `try {
  var _colorScheme = window.localStorage.getItem("${localStorageKey}");
  var colorScheme = _colorScheme === "light" || _colorScheme === "dark" || _colorScheme === "auto" ? _colorScheme : "${defaultColorScheme}";
  var computedColorScheme = colorScheme !== "auto" ? colorScheme : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  document.documentElement.setAttribute("data-mantine-color-scheme", computedColorScheme);
} catch (e) {}
`;
};
function ColorSchemeScript(_param) {
    var _param_defaultColorScheme = _param.defaultColorScheme, defaultColorScheme = _param_defaultColorScheme === void 0 ? "light" : _param_defaultColorScheme, _param_localStorageKey = _param.localStorageKey, localStorageKey = _param_localStorageKey === void 0 ? "mantine-color-scheme-value" : _param_localStorageKey, forceColorScheme = _param.forceColorScheme, others = (0, _objectWithoutProperties._)(_param, [
        "defaultColorScheme",
        "localStorageKey",
        "forceColorScheme"
    ]);
    var _defaultColorScheme = [
        "light",
        "dark",
        "auto"
    ].includes(defaultColorScheme) ? defaultColorScheme : "light";
    return /* @__PURE__ */ jsxRuntime.jsx("script", (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        "data-mantine-script": true,
        dangerouslySetInnerHTML: {
            __html: getScript({
                defaultColorScheme: _defaultColorScheme,
                localStorageKey,
                forceColorScheme
            })
        }
    }));
}
exports.ColorSchemeScript = ColorSchemeScript; //# sourceMappingURL=ColorSchemeScript.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","fcd3f9bbed7f486a":"iKGFf"}],"iivvn":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var filterProps = require("fcba01de7bb7ba35");
require("417a0e115d573357");
require("9fe616f7e960b0b");
require("1354a1e4336a30b3");
var MantineThemeProvider = require("bb032c036e237e64");
function useProps(component, defaultProps, props) {
    var _theme_components_component;
    var theme = MantineThemeProvider.useMantineTheme();
    var contextPropsPayload = (_theme_components_component = theme.components[component]) === null || _theme_components_component === void 0 ? void 0 : _theme_components_component.defaultProps;
    var contextProps = typeof contextPropsPayload === "function" ? contextPropsPayload(theme) : contextPropsPayload;
    return (0, _objectSpread._)({}, defaultProps, contextProps, filterProps.filterProps(props));
}
exports.useProps = useProps; //# sourceMappingURL=use-props.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","fcba01de7bb7ba35":"2Jst9","417a0e115d573357":"9MtAM","9fe616f7e960b0b":"iKGFf","1354a1e4336a30b3":"9HEEB","bb032c036e237e64":"kqQOF"}],"hKxwc":[function(require,module,exports) {
"use strict";
function createTheme(theme) {
    return theme;
}
exports.createTheme = createTheme; //# sourceMappingURL=create-theme.cjs.map

},{}],"7RbQQ":[function(require,module,exports) {
"use client";
"use strict";
var deepMerge = require("7f047095c4f50af0");
require("55926df1fbdd8465");
require("307665adb547d877");
require("b6cb4b17aa3bf20a");
function mergeThemeOverrides() {
    for(var _len = arguments.length, overrides = new Array(_len), _key = 0; _key < _len; _key++){
        overrides[_key] = arguments[_key];
    }
    return overrides.reduce(function(acc, override) {
        return deepMerge.deepMerge(acc, override);
    }, {});
}
exports.mergeThemeOverrides = mergeThemeOverrides; //# sourceMappingURL=merge-theme-overrides.cjs.map

},{"7f047095c4f50af0":"aXRyU","55926df1fbdd8465":"9MtAM","307665adb547d877":"iKGFf","b6cb4b17aa3bf20a":"9HEEB"}],"ipE8t":[function(require,module,exports) {
"use client";
"use strict";
var hooks = require("636d0803b4dd1801");
var MantineThemeProvider = require("15c7de4104c19465");
var BREAKPOINTS = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
function getFirstMatchingValue(value, biggestMatch) {
    if (!biggestMatch) return value.base;
    var index = BREAKPOINTS.indexOf(biggestMatch);
    while(index >= 0){
        if (BREAKPOINTS[index] in value) return value[BREAKPOINTS[index]];
        index -= 1;
    }
    return value.base;
}
function getFirstMatchingBreakpoint(matches) {
    return matches.findLastIndex(function(v) {
        return v;
    });
}
function useMatches(payload, options) {
    var theme = MantineThemeProvider.useMantineTheme();
    var xsMatches = hooks.useMediaQuery(`(min-width: ${theme.breakpoints.xs})`, false, options);
    var smMatches = hooks.useMediaQuery(`(min-width: ${theme.breakpoints.sm})`, false, options);
    var mdMatches = hooks.useMediaQuery(`(min-width: ${theme.breakpoints.md})`, false, options);
    var lgMatches = hooks.useMediaQuery(`(min-width: ${theme.breakpoints.lg})`, false, options);
    var xlMatches = hooks.useMediaQuery(`(min-width: ${theme.breakpoints.xl})`, false, options);
    var breakpoints = [
        xsMatches,
        smMatches,
        mdMatches,
        lgMatches,
        xlMatches
    ];
    var firstMatchingBreakpointIndex = getFirstMatchingBreakpoint(breakpoints);
    return getFirstMatchingValue(payload, BREAKPOINTS[firstMatchingBreakpointIndex]);
}
exports.useMatches = useMatches; //# sourceMappingURL=use-matches.cjs.map

},{"636d0803b4dd1801":"9HEEB","15c7de4104c19465":"kqQOF"}],"7FWcz":[function(require,module,exports) {
"use strict";
var mantineHtmlProps = {
    suppressHydrationWarning: true,
    "data-mantine-color-scheme": "light"
};
exports.mantineHtmlProps = mantineHtmlProps; //# sourceMappingURL=mantine-html-props.cjs.map

},{}],"3CHN8":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("5ba1188b3965ead3");
require("f046b1963ce0591e");
require("554c2a8548c08dce");
var Mantine_context = require("109237dfdcf130fa");
require("546d6f280c9e10be");
require("298c8986d0c18d21");
require("1257bce8e547e028");
require("72a12566b967f80d");
var stylesToString = require("e38a12b5c644a6a9");
function InlineStyles(props) {
    var nonce = Mantine_context.useMantineStyleNonce();
    return /* @__PURE__ */ jsxRuntime.jsx("style", {
        "data-mantine-styles": "inline",
        nonce: nonce === null || nonce === void 0 ? void 0 : nonce(),
        dangerouslySetInnerHTML: {
            __html: stylesToString.stylesToString(props)
        }
    });
}
exports.InlineStyles = InlineStyles; //# sourceMappingURL=InlineStyles.cjs.map

},{"5ba1188b3965ead3":"iKGFf","f046b1963ce0591e":"9MtAM","554c2a8548c08dce":"9HEEB","109237dfdcf130fa":"2FdJg","546d6f280c9e10be":"6AMGA","298c8986d0c18d21":"erSvz","1257bce8e547e028":"kqQOF","72a12566b967f80d":"8YP4O","e38a12b5c644a6a9":"OgGrn"}],"OgGrn":[function(require,module,exports) {
"use client";
"use strict";
var cssObjectToString = require("fc6a731b5312a0aa");
function stylesToString(param) {
    var selector = param.selector, styles = param.styles, media = param.media, container = param.container;
    var baseStyles = styles ? cssObjectToString.cssObjectToString(styles) : "";
    var mediaQueryStyles = !Array.isArray(media) ? [] : media.map(function(item) {
        return `@media${item.query}{${selector}{${cssObjectToString.cssObjectToString(item.styles)}}}`;
    });
    var containerStyles = !Array.isArray(container) ? [] : container.map(function(item) {
        return `@container ${item.query}{${selector}{${cssObjectToString.cssObjectToString(item.styles)}}}`;
    });
    return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}${containerStyles.join("")}`.trim();
}
exports.stylesToString = stylesToString; //# sourceMappingURL=styles-to-string.cjs.map

},{"fc6a731b5312a0aa":"anBFw"}],"anBFw":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("9b4d49a927835eaf");
var camelToKebabCase = require("d44066b9d296fb88");
require("dfe30ec181dc4bf5");
require("b19f1b35146b6d19");
require("edd6e46d97b46d9d");
function cssObjectToString(css) {
    return keys.keys(css).reduce(function(acc, rule) {
        return css[rule] !== void 0 ? `${acc}${camelToKebabCase.camelToKebabCase(rule)}:${css[rule]};` : acc;
    }, "").trim();
}
exports.cssObjectToString = cssObjectToString; //# sourceMappingURL=css-object-to-string.cjs.map

},{"9b4d49a927835eaf":"kvYzO","d44066b9d296fb88":"57PxO","dfe30ec181dc4bf5":"9MtAM","b19f1b35146b6d19":"iKGFf","edd6e46d97b46d9d":"9HEEB"}],"6L93n":[function(require,module,exports) {
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var filterProps = require("7754fe665f10adb8");
require("bc452436b3e6b583");
require("b6e62c111e89107f");
require("418bf8fd78fa477c");
function extractStyleProps(others) {
    var m = others.m, mx = others.mx, my = others.my, mt = others.mt, mb = others.mb, ml = others.ml, mr = others.mr, me = others.me, ms = others.ms, p = others.p, px = others.px, py = others.py, pt = others.pt, pb = others.pb, pl = others.pl, pr = others.pr, pe = others.pe, ps = others.ps, bd = others.bd, bg = others.bg, c = others.c, opacity = others.opacity, ff = others.ff, fz = others.fz, fw = others.fw, lts = others.lts, ta = others.ta, lh = others.lh, fs = others.fs, tt = others.tt, td = others.td, w = others.w, miw = others.miw, maw = others.maw, h = others.h, mih = others.mih, mah = others.mah, bgsz = others.bgsz, bgp = others.bgp, bgr = others.bgr, bga = others.bga, pos = others.pos, top = others.top, left = others.left, bottom = others.bottom, right = others.right, inset = others.inset, display = others.display, flex = others.flex, hiddenFrom = others.hiddenFrom, visibleFrom = others.visibleFrom, lightHidden = others.lightHidden, darkHidden = others.darkHidden, sx = others.sx, rest = (0, _objectWithoutProperties._)(others, [
        "m",
        "mx",
        "my",
        "mt",
        "mb",
        "ml",
        "mr",
        "me",
        "ms",
        "p",
        "px",
        "py",
        "pt",
        "pb",
        "pl",
        "pr",
        "pe",
        "ps",
        "bd",
        "bg",
        "c",
        "opacity",
        "ff",
        "fz",
        "fw",
        "lts",
        "ta",
        "lh",
        "fs",
        "tt",
        "td",
        "w",
        "miw",
        "maw",
        "h",
        "mih",
        "mah",
        "bgsz",
        "bgp",
        "bgr",
        "bga",
        "pos",
        "top",
        "left",
        "bottom",
        "right",
        "inset",
        "display",
        "flex",
        "hiddenFrom",
        "visibleFrom",
        "lightHidden",
        "darkHidden",
        "sx"
    ]);
    var styleProps = filterProps.filterProps({
        m,
        mx,
        my,
        mt,
        mb,
        ml,
        mr,
        me,
        ms,
        p,
        px,
        py,
        pt,
        pb,
        pl,
        pr,
        pe,
        ps,
        bd,
        bg,
        c,
        opacity,
        ff,
        fz,
        fw,
        lts,
        ta,
        lh,
        fs,
        tt,
        td,
        w,
        miw,
        maw,
        h,
        mih,
        mah,
        bgsz,
        bgp,
        bgr,
        bga,
        pos,
        top,
        left,
        bottom,
        right,
        inset,
        display,
        flex,
        hiddenFrom,
        visibleFrom,
        lightHidden,
        darkHidden,
        sx
    });
    return {
        styleProps,
        rest
    };
}
exports.extractStyleProps = extractStyleProps; //# sourceMappingURL=extract-style-props.cjs.map

},{"@swc/helpers/_/_object_without_properties":"4Ofw8","7754fe665f10adb8":"2Jst9","bc452436b3e6b583":"9MtAM","b6e62c111e89107f":"iKGFf","418bf8fd78fa477c":"9HEEB"}],"4seZw":[function(require,module,exports) {
"use client";
"use strict";
var STYlE_PROPS_DATA = {
    m: {
        type: "spacing",
        property: "margin"
    },
    mt: {
        type: "spacing",
        property: "marginTop"
    },
    mb: {
        type: "spacing",
        property: "marginBottom"
    },
    ml: {
        type: "spacing",
        property: "marginLeft"
    },
    mr: {
        type: "spacing",
        property: "marginRight"
    },
    ms: {
        type: "spacing",
        property: "marginInlineStart"
    },
    me: {
        type: "spacing",
        property: "marginInlineEnd"
    },
    mx: {
        type: "spacing",
        property: "marginInline"
    },
    my: {
        type: "spacing",
        property: "marginBlock"
    },
    p: {
        type: "spacing",
        property: "padding"
    },
    pt: {
        type: "spacing",
        property: "paddingTop"
    },
    pb: {
        type: "spacing",
        property: "paddingBottom"
    },
    pl: {
        type: "spacing",
        property: "paddingLeft"
    },
    pr: {
        type: "spacing",
        property: "paddingRight"
    },
    ps: {
        type: "spacing",
        property: "paddingInlineStart"
    },
    pe: {
        type: "spacing",
        property: "paddingInlineEnd"
    },
    px: {
        type: "spacing",
        property: "paddingInline"
    },
    py: {
        type: "spacing",
        property: "paddingBlock"
    },
    bd: {
        type: "border",
        property: "border"
    },
    bg: {
        type: "color",
        property: "background"
    },
    c: {
        type: "textColor",
        property: "color"
    },
    opacity: {
        type: "identity",
        property: "opacity"
    },
    ff: {
        type: "fontFamily",
        property: "fontFamily"
    },
    fz: {
        type: "fontSize",
        property: "fontSize"
    },
    fw: {
        type: "identity",
        property: "fontWeight"
    },
    lts: {
        type: "size",
        property: "letterSpacing"
    },
    ta: {
        type: "identity",
        property: "textAlign"
    },
    lh: {
        type: "lineHeight",
        property: "lineHeight"
    },
    fs: {
        type: "identity",
        property: "fontStyle"
    },
    tt: {
        type: "identity",
        property: "textTransform"
    },
    td: {
        type: "identity",
        property: "textDecoration"
    },
    w: {
        type: "spacing",
        property: "width"
    },
    miw: {
        type: "spacing",
        property: "minWidth"
    },
    maw: {
        type: "spacing",
        property: "maxWidth"
    },
    h: {
        type: "spacing",
        property: "height"
    },
    mih: {
        type: "spacing",
        property: "minHeight"
    },
    mah: {
        type: "spacing",
        property: "maxHeight"
    },
    bgsz: {
        type: "size",
        property: "backgroundSize"
    },
    bgp: {
        type: "identity",
        property: "backgroundPosition"
    },
    bgr: {
        type: "identity",
        property: "backgroundRepeat"
    },
    bga: {
        type: "identity",
        property: "backgroundAttachment"
    },
    pos: {
        type: "identity",
        property: "position"
    },
    top: {
        type: "size",
        property: "top"
    },
    left: {
        type: "size",
        property: "left"
    },
    bottom: {
        type: "size",
        property: "bottom"
    },
    right: {
        type: "size",
        property: "right"
    },
    inset: {
        type: "size",
        property: "inset"
    },
    display: {
        type: "identity",
        property: "display"
    },
    flex: {
        type: "identity",
        property: "flex"
    }
};
exports.STYlE_PROPS_DATA = STYlE_PROPS_DATA; //# sourceMappingURL=style-props-data.cjs.map

},{}],"6Bevs":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var keys = require("738b4ef7291dd1df");
require("d20abc7d6b6b9e3a");
require("720d6e3e9862b9fc");
require("6a02ed0e1ebba083");
var index = require("8da54c712ddfe067");
var sortMediaQueries = require("9d044328358e4c30");
function hasResponsiveStyles(styleProp) {
    if (typeof styleProp !== "object" || styleProp === null) return false;
    var breakpoints = Object.keys(styleProp);
    if (breakpoints.length === 1 && breakpoints[0] === "base") return false;
    return true;
}
function getBaseValue(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) return value.base;
        return void 0;
    }
    return value;
}
function getBreakpointKeys(value) {
    if (typeof value === "object" && value !== null) return keys.keys(value).filter(function(key) {
        return key !== "base";
    });
    return [];
}
function getBreakpointValue(value, breakpoint) {
    if (typeof value === "object" && value !== null && breakpoint in value) return value[breakpoint];
    return value;
}
function parseStyleProps(param) {
    var styleProps = param.styleProps, data = param.data, theme = param.theme;
    return sortMediaQueries.sortMediaQueries(keys.keys(styleProps).reduce(function(acc, styleProp) {
        if (styleProp === "hiddenFrom" || styleProp === "visibleFrom" || styleProp === "sx") return acc;
        var propertyData = data[styleProp];
        var properties = Array.isArray(propertyData.property) ? propertyData.property : [
            propertyData.property
        ];
        var baseValue = getBaseValue(styleProps[styleProp]);
        if (!hasResponsiveStyles(styleProps[styleProp])) {
            properties.forEach(function(property) {
                acc.inlineStyles[property] = index.resolvers[propertyData.type](baseValue, theme);
            });
            return acc;
        }
        acc.hasResponsiveStyles = true;
        var breakpoints = getBreakpointKeys(styleProps[styleProp]);
        properties.forEach(function(property) {
            if (baseValue) acc.styles[property] = index.resolvers[propertyData.type](baseValue, theme);
            breakpoints.forEach(function(breakpoint) {
                var bp = `(min-width: ${theme.breakpoints[breakpoint]})`;
                acc.media[bp] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc.media[bp]), {
                    [property]: index.resolvers[propertyData.type](getBreakpointValue(styleProps[styleProp], breakpoint), theme)
                });
            });
        });
        return acc;
    }, {
        hasResponsiveStyles: false,
        styles: {},
        inlineStyles: {},
        media: {}
    }));
}
exports.parseStyleProps = parseStyleProps; //# sourceMappingURL=parse-style-props.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","738b4ef7291dd1df":"kvYzO","d20abc7d6b6b9e3a":"9MtAM","720d6e3e9862b9fc":"iKGFf","6a02ed0e1ebba083":"9HEEB","8da54c712ddfe067":"2oKrl","9d044328358e4c30":"1wXV8"}],"2oKrl":[function(require,module,exports) {
"use client";
"use strict";
var borderResolver = require("22f74265969319fa");
var colorResolver = require("856304fa057f9d04");
var fontFamilyResolver = require("1b822357b8ba026c");
var fontSizeResolver = require("5958f1f6205fefce");
var identityResolver = require("c8161ce9bc1cee5a");
var lineHeightResolver = require("687da805b2a3ca3");
var sizeResolver = require("b234f7f6f49a93a2");
var spacingResolver = require("d87e34c5a2479db1");
var resolvers = {
    color: colorResolver.colorResolver,
    textColor: colorResolver.textColorResolver,
    fontSize: fontSizeResolver.fontSizeResolver,
    spacing: spacingResolver.spacingResolver,
    identity: identityResolver.identityResolver,
    size: sizeResolver.sizeResolver,
    lineHeight: lineHeightResolver.lineHeightResolver,
    fontFamily: fontFamilyResolver.fontFamilyResolver,
    border: borderResolver.borderResolver
};
exports.resolvers = resolvers; //# sourceMappingURL=index.cjs.map

},{"22f74265969319fa":"2a52A","856304fa057f9d04":"5FwZh","1b822357b8ba026c":"3d96A","5958f1f6205fefce":"hyPM8","c8161ce9bc1cee5a":"iP32y","687da805b2a3ca3":"2mS4q","b234f7f6f49a93a2":"9FTXh","d87e34c5a2479db1":"c05qI"}],"2a52A":[function(require,module,exports) {
var _toArray = require("@swc/helpers/_/_to_array");
"use client";
"use strict";
var rem = require("20160f73b5123d2f");
require("fcf379e20b4d056c");
require("54d26bc0f593ebce");
require("32a9eee479d5287a");
var colorResolver = require("c8b887ad1df7dfd3");
function borderResolver(value, theme) {
    if (typeof value === "number") return rem.rem(value);
    if (typeof value === "string") {
        var _value_split_filter = (0, _toArray._)(value.split(" ").filter(function(val) {
            return val.trim() !== "";
        })), size = _value_split_filter[0], style = _value_split_filter[1], colorTuple = _value_split_filter.slice(2);
        var result = `${rem.rem(size)}`;
        style && (result += ` ${style}`);
        colorTuple.length > 0 && (result += ` ${colorResolver.colorResolver(colorTuple.join(" "), theme)}`);
        return result.trim();
    }
    return value;
}
exports.borderResolver = borderResolver; //# sourceMappingURL=border-resolver.cjs.map

},{"@swc/helpers/_/_to_array":"cdUIS","20160f73b5123d2f":"ebAaL","fcf379e20b4d056c":"9MtAM","54d26bc0f593ebce":"iKGFf","32a9eee479d5287a":"9HEEB","c8b887ad1df7dfd3":"5FwZh"}],"5FwZh":[function(require,module,exports) {
"use client";
"use strict";
var parseThemeColor = require("c0163e919f3e7f16");
require("46c7a338dd782aaa");
require("596eb15498fafce9");
require("a0bb811ac5adf021");
require("6a7ae1a1ac4f14d8");
require("fcbe9bc227ad679e");
require("7c33e947bfc73f62");
require("c89e5596afea8545");
require("e73bfb065341e187");
function colorResolver(color, theme) {
    var parsedColor = parseThemeColor.parseThemeColor({
        color,
        theme
    });
    if (parsedColor.color === "dimmed") return "var(--mantine-color-dimmed)";
    if (parsedColor.color === "bright") return "var(--mantine-color-bright)";
    return parsedColor.variable ? `var(${parsedColor.variable})` : parsedColor.color;
}
function textColorResolver(color, theme) {
    var parsedColor = parseThemeColor.parseThemeColor({
        color,
        theme
    });
    if (parsedColor.isThemeColor && parsedColor.shade === void 0) return `var(--mantine-color-${parsedColor.color}-text)`;
    return colorResolver(color, theme);
}
exports.colorResolver = colorResolver;
exports.textColorResolver = textColorResolver; //# sourceMappingURL=color-resolver.cjs.map

},{"c0163e919f3e7f16":"ctp80","46c7a338dd782aaa":"9MtAM","596eb15498fafce9":"iKGFf","a0bb811ac5adf021":"9HEEB","6a7ae1a1ac4f14d8":"2FdJg","fcbe9bc227ad679e":"6AMGA","7c33e947bfc73f62":"erSvz","c89e5596afea8545":"kqQOF","e73bfb065341e187":"8YP4O"}],"3d96A":[function(require,module,exports) {
"use client";
"use strict";
var values = {
    text: "var(--mantine-font-family)",
    mono: "var(--mantine-font-family-monospace)",
    monospace: "var(--mantine-font-family-monospace)",
    heading: "var(--mantine-font-family-headings)",
    headings: "var(--mantine-font-family-headings)"
};
function fontFamilyResolver(fontFamily) {
    if (typeof fontFamily === "string" && fontFamily in values) return values[fontFamily];
    return fontFamily;
}
exports.fontFamilyResolver = fontFamilyResolver; //# sourceMappingURL=font-family-resolver.cjs.map

},{}],"hyPM8":[function(require,module,exports) {
"use client";
"use strict";
var rem = require("be8b5fae62bc18d2");
require("3b2e5c6c90a852bd");
require("cc5f3dcd20794cf5");
require("6e86de5a9f7e01a2");
var headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function fontSizeResolver(value, theme) {
    if (typeof value === "string" && value in theme.fontSizes) return `var(--mantine-font-size-${value})`;
    if (typeof value === "string" && headings.includes(value)) return `var(--mantine-${value}-font-size)`;
    if (typeof value === "number") return rem.rem(value);
    if (typeof value === "string") return rem.rem(value);
    return value;
}
exports.fontSizeResolver = fontSizeResolver; //# sourceMappingURL=font-size-resolver.cjs.map

},{"be8b5fae62bc18d2":"ebAaL","3b2e5c6c90a852bd":"9MtAM","cc5f3dcd20794cf5":"iKGFf","6e86de5a9f7e01a2":"9HEEB"}],"iP32y":[function(require,module,exports) {
"use client";
"use strict";
function identityResolver(value) {
    return value;
}
exports.identityResolver = identityResolver; //# sourceMappingURL=identity-resolver.cjs.map

},{}],"2mS4q":[function(require,module,exports) {
"use client";
"use strict";
var headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function lineHeightResolver(value, theme) {
    if (typeof value === "string" && value in theme.lineHeights) return `var(--mantine-line-height-${value})`;
    if (typeof value === "string" && headings.includes(value)) return `var(--mantine-${value}-line-height)`;
    return value;
}
exports.lineHeightResolver = lineHeightResolver; //# sourceMappingURL=line-height-resolver.cjs.map

},{}],"9FTXh":[function(require,module,exports) {
"use client";
"use strict";
var rem = require("67575c4e4f9f60f4");
require("797c7c9a4f345de2");
require("4417cad9e2a5fedd");
require("fcbf3f291f82c707");
function sizeResolver(value) {
    if (typeof value === "number") return rem.rem(value);
    return value;
}
exports.sizeResolver = sizeResolver; //# sourceMappingURL=size-resolver.cjs.map

},{"67575c4e4f9f60f4":"ebAaL","797c7c9a4f345de2":"9MtAM","4417cad9e2a5fedd":"iKGFf","fcbf3f291f82c707":"9HEEB"}],"c05qI":[function(require,module,exports) {
"use client";
"use strict";
var rem = require("671028a93e1ae205");
require("4ceffc9690ce68aa");
require("9789421c9d225792");
require("c113038f0cadb070");
function spacingResolver(value, theme) {
    if (typeof value === "number") return rem.rem(value);
    if (typeof value === "string") {
        var mod = value.replace("-", "");
        if (!(mod in theme.spacing)) return rem.rem(value);
        var variable = `--mantine-spacing-${mod}`;
        return value.startsWith("-") ? `calc(var(${variable}) * -1)` : `var(${variable})`;
    }
    return value;
}
exports.spacingResolver = spacingResolver; //# sourceMappingURL=spacing-resolver.cjs.map

},{"671028a93e1ae205":"ebAaL","4ceffc9690ce68aa":"9MtAM","9789421c9d225792":"iKGFf","c113038f0cadb070":"9HEEB"}],"1wXV8":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
function replaceMediaQuery(query) {
    return query.replace("(min-width: ", "").replace("em)", "");
}
function sortMediaQueries(_param) {
    var media = _param.media, props = (0, _objectWithoutProperties._)(_param, [
        "media"
    ]);
    var breakpoints = Object.keys(media);
    var sortedMedia = breakpoints.sort(function(a, b) {
        return Number(replaceMediaQuery(a)) - Number(replaceMediaQuery(b));
    }).map(function(query) {
        return {
            query,
            styles: media[query]
        };
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        media: sortedMedia
    });
}
exports.sortMediaQueries = sortMediaQueries; //# sourceMappingURL=sort-media-queries.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8"}],"2rhHN":[function(require,module,exports) {
"use client";
"use strict";
var React = require("24d77becbdf6e7d6");
function useRandomClassName() {
    var id = React.useId().replace(/:/g, "");
    return `__m__-${id}`;
}
exports.useRandomClassName = useRandomClassName; //# sourceMappingURL=use-random-classname.cjs.map

},{"24d77becbdf6e7d6":"9MtAM"}],"bvL2d":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function getStyleObject(style, theme) {
    if (Array.isArray(style)) return (0, _toConsumableArray._)(style).reduce(function(acc, item) {
        return (0, _objectSpread._)({}, acc, getStyleObject(item, theme));
    }, {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}
exports.getStyleObject = getStyleObject; //# sourceMappingURL=get-style-object.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_to_consumable_array":"jg7I9"}],"gkGXc":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2ae61b7d626bccc4");
var React = require("bb4008b53a205581");
var cx = require("35770ade95f5a3d6");
var createPolymorphicComponent = require("1d24e3208b145fa");
var InlineStyles = require("ba41bf53ac4176d7");
var isNumberLike = require("31b50beafab95fba");
require("1465e2541cb6540e");
var Mantine_context = require("4f08bc97e2320dd5");
require("321d242165550c8a");
require("a02caccdd36c88ab");
var MantineThemeProvider = require("7f4df48547fca93d");
require("225238f2887aca88");
var getBoxMod = require("496d1049444dbf19");
var getBoxStyle = require("c0f1688853cf79ec");
var extractStyleProps = require("6700bec73b2b54c");
var stylePropsData = require("5d01e8bdaf5f372f");
var parseStyleProps = require("ef8212b86e62432a");
var useRandomClassname = require("26b6b27af2662f4e");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var _Box = React.forwardRef(function(_param, ref) {
    var component = _param.component, style = _param.style, __vars = _param.__vars, className = _param.className, variant = _param.variant, mod = _param.mod, size = _param.size, hiddenFrom = _param.hiddenFrom, visibleFrom = _param.visibleFrom, lightHidden = _param.lightHidden, darkHidden = _param.darkHidden, renderRoot = _param.renderRoot, __size = _param.__size, others = (0, _objectWithoutProperties._)(_param, [
        "component",
        "style",
        "__vars",
        "className",
        "variant",
        "mod",
        "size",
        "hiddenFrom",
        "visibleFrom",
        "lightHidden",
        "darkHidden",
        "renderRoot",
        "__size"
    ]);
    var _useSxTransform;
    var theme = MantineThemeProvider.useMantineTheme();
    var Element = component || "div";
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var useSxTransform = Mantine_context.useMantineSxTransform();
    var transformedSx = useSxTransform === null || useSxTransform === void 0 ? void 0 : (_useSxTransform = useSxTransform()) === null || _useSxTransform === void 0 ? void 0 : _useSxTransform(styleProps.sx);
    var responsiveClassName = useRandomClassname.useRandomClassName();
    var parsedStyleProps = parseStyleProps.parseStyleProps({
        styleProps,
        theme,
        data: stylePropsData.STYlE_PROPS_DATA
    });
    var props = (0, _objectSpread._)({
        ref,
        style: getBoxStyle.getBoxStyle({
            theme,
            style,
            vars: __vars,
            styleProps: parsedStyleProps.inlineStyles
        }),
        className: cx__default.default(className, transformedSx, {
            [responsiveClassName]: parsedStyleProps.hasResponsiveStyles,
            "mantine-light-hidden": lightHidden,
            "mantine-dark-hidden": darkHidden,
            [`mantine-hidden-from-${hiddenFrom}`]: hiddenFrom,
            [`mantine-visible-from-${visibleFrom}`]: visibleFrom
        }),
        "data-variant": variant,
        "data-size": isNumberLike.isNumberLike(size) ? void 0 : size || void 0,
        size: __size
    }, getBoxMod.getBoxMod(mod), rest);
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ jsxRuntime.jsx(InlineStyles.InlineStyles, {
                selector: `.${responsiveClassName}`,
                styles: parsedStyleProps.styles,
                media: parsedStyleProps.media
            }),
            typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ jsxRuntime.jsx(Element, (0, _objectSpread._)({}, props))
        ]
    });
});
_Box.displayName = "@mantine/core/Box";
var Box = createPolymorphicComponent.createPolymorphicComponent(_Box);
exports.Box = Box; //# sourceMappingURL=Box.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","2ae61b7d626bccc4":"iKGFf","bb4008b53a205581":"9MtAM","35770ade95f5a3d6":"8QFOC","1d24e3208b145fa":"ifmiy","ba41bf53ac4176d7":"3CHN8","31b50beafab95fba":"6knSJ","1465e2541cb6540e":"9HEEB","4f08bc97e2320dd5":"2FdJg","321d242165550c8a":"6AMGA","a02caccdd36c88ab":"erSvz","7f4df48547fca93d":"kqQOF","225238f2887aca88":"8YP4O","496d1049444dbf19":"74lFD","c0f1688853cf79ec":"hOsvx","6700bec73b2b54c":"6L93n","5d01e8bdaf5f372f":"4seZw","ef8212b86e62432a":"6Bevs","26b6b27af2662f4e":"2rhHN"}],"ifmiy":[function(require,module,exports) {
"use strict";
function createPolymorphicComponent(component) {
    return component;
}
exports.createPolymorphicComponent = createPolymorphicComponent; //# sourceMappingURL=create-polymorphic-component.cjs.map

},{}],"74lFD":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function transformModKey(key) {
    return key.startsWith("data-") ? key : `data-${key}`;
}
function getMod(props) {
    return Object.keys(props).reduce(function(acc, key) {
        var value = props[key];
        if (value === void 0 || value === "" || value === false || value === null) return acc;
        acc[transformModKey(key)] = props[key];
        return acc;
    }, {});
}
function getBoxMod(mod) {
    if (!mod) return null;
    if (typeof mod === "string") return {
        [transformModKey(mod)]: true
    };
    if (Array.isArray(mod)) return (0, _toConsumableArray._)(mod).reduce(function(acc, value) {
        return (0, _objectSpread._)({}, acc, getBoxMod(value));
    }, {});
    return getMod(mod);
}
exports.getBoxMod = getBoxMod;
exports.getMod = getMod; //# sourceMappingURL=get-box-mod.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_to_consumable_array":"jg7I9"}],"hOsvx":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function mergeStyles(styles, theme) {
    if (Array.isArray(styles)) return (0, _toConsumableArray._)(styles).reduce(function(acc, item) {
        return (0, _objectSpread._)({}, acc, mergeStyles(item, theme));
    }, {});
    if (typeof styles === "function") return styles(theme);
    if (styles == null) return {};
    return styles;
}
function getBoxStyle(param) {
    var theme = param.theme, style = param.style, vars = param.vars, styleProps = param.styleProps;
    var _style = mergeStyles(style, theme);
    var _vars = mergeStyles(vars, theme);
    return (0, _objectSpread._)({}, _style, _vars, styleProps);
}
exports.getBoxStyle = getBoxStyle; //# sourceMappingURL=get-box-style.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_to_consumable_array":"jg7I9"}],"guLFz":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("9dc3162e135e745c");
var React = require("6e33c99d63abdb18");
function identity(value) {
    return value;
}
function getWithProps(Component) {
    var _Component = Component;
    return function(fixedProps) {
        var Extended = React.forwardRef(function(props, ref) {
            return /* @__PURE__ */ jsxRuntime.jsx(_Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, fixedProps, props), {
                ref
            }));
        });
        Extended.extend = _Component.extend;
        Extended.displayName = `WithProps(${_Component.displayName})`;
        return Extended;
    };
}
function factory(ui) {
    var Component = React.forwardRef(ui);
    Component.extend = identity;
    Component.withProps = function(fixedProps) {
        var Extended = React.forwardRef(function(props, ref) {
            return /* @__PURE__ */ jsxRuntime.jsx(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, fixedProps, props), {
                ref
            }));
        });
        Extended.extend = Component.extend;
        Extended.displayName = `WithProps(${Component.displayName})`;
        return Extended;
    };
    return Component;
}
exports.factory = factory;
exports.getWithProps = getWithProps;
exports.identity = identity; //# sourceMappingURL=factory.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","9dc3162e135e745c":"iKGFf","6e33c99d63abdb18":"9MtAM"}],"iYAEL":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("ef07da0063c00592");
var React = require("385ad20dd3310d61");
var factory = require("4b93c5f4c2c8c60a");
function polymorphicFactory(ui) {
    var Component = React.forwardRef(ui);
    Component.withProps = function(fixedProps) {
        var Extended = React.forwardRef(function(props, ref) {
            return /* @__PURE__ */ jsxRuntime.jsx(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, fixedProps, props), {
                ref
            }));
        });
        Extended.extend = Component.extend;
        Extended.displayName = `WithProps(${Component.displayName})`;
        return Extended;
    };
    Component.extend = factory.identity;
    return Component;
}
exports.polymorphicFactory = polymorphicFactory; //# sourceMappingURL=polymorphic-factory.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","ef07da0063c00592":"iKGFf","385ad20dd3310d61":"9MtAM","4b93c5f4c2c8c60a":"guLFz"}],"2onWA":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("3ff6ebad386a9739");
var React = require("fa1018528aa3e9c3");
var hooks = require("22c54f94c9b4dd58");
var DirectionContext = React.createContext({
    dir: "ltr",
    toggleDirection: function() {},
    setDirection: function() {}
});
function useDirection() {
    return React.useContext(DirectionContext);
}
function DirectionProvider(param) {
    var children = param.children, _param_initialDirection = param.initialDirection, initialDirection = _param_initialDirection === void 0 ? "ltr" : _param_initialDirection, _param_detectDirection = param.detectDirection, detectDirection = _param_detectDirection === void 0 ? true : _param_detectDirection;
    var _React_useState = (0, _slicedToArray._)(React.useState(initialDirection), 2), dir = _React_useState[0], setDir = _React_useState[1];
    var setDirection = function(direction) {
        setDir(direction);
        document.documentElement.setAttribute("dir", direction);
    };
    var toggleDirection = function() {
        return setDirection(dir === "ltr" ? "rtl" : "ltr");
    };
    hooks.useIsomorphicEffect(function() {
        if (detectDirection) {
            var direction = document.documentElement.getAttribute("dir");
            if (direction === "rtl" || direction === "ltr") setDirection(direction);
        }
    }, []);
    return /* @__PURE__ */ jsxRuntime.jsx(DirectionContext.Provider, {
        value: {
            dir,
            toggleDirection,
            setDirection
        },
        children
    });
}
exports.DirectionContext = DirectionContext;
exports.DirectionProvider = DirectionProvider;
exports.useDirection = useDirection; //# sourceMappingURL=DirectionProvider.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","3ff6ebad386a9739":"iKGFf","fa1018528aa3e9c3":"9MtAM","22c54f94c9b4dd58":"9HEEB"}],"eaAXD":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("77705237d82ac7a4");
var hooks = require("f7d6e1f41e0cb190");
require("a7e3e8035b92bdeb");
require("c9114d733ca12286");
require("12fb7a53c0afd900");
require("a1f3046a37b7fce8");
require("c661e135ed373a6c");
var MantineThemeProvider = require("fa47ea6f9df13989");
var useProps = require("84670f748175aa90");
require("914092f400b8064f");
var getStyleObject = require("94c00146029eb5f7");
var Box = require("15fee7d9e24c1414");
var factory = require("834b0e5ae7cdf40");
require("20319a2ae590d6bd");
var useCollapse = require("58575f5b4b7edec4");
var defaultProps = {
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    animateOpacity: true
};
var Collapse = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("Collapse", defaultProps, props), children = _useProps_useProps.children, opened = _useProps_useProps.in, transitionDuration = _useProps_useProps.transitionDuration, transitionTimingFunction = _useProps_useProps.transitionTimingFunction, style = _useProps_useProps.style, onTransitionEnd = _useProps_useProps.onTransitionEnd, animateOpacity = _useProps_useProps.animateOpacity, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "in",
        "transitionDuration",
        "transitionTimingFunction",
        "style",
        "onTransitionEnd",
        "animateOpacity"
    ]);
    var theme = MantineThemeProvider.useMantineTheme();
    var shouldReduceMotion = hooks.useReducedMotion();
    var reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    var duration = reduceMotion ? 0 : transitionDuration;
    var getCollapseProps = useCollapse.useCollapse({
        opened,
        transitionDuration: duration,
        transitionTimingFunction,
        onTransitionEnd
    });
    if (duration === 0) return opened ? /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        children
    })) : null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getCollapseProps((0, _objectSpread._)({
        style: (0, _objectSpread._)({
            opacity: opened || !animateOpacity ? 1 : 0,
            transition: animateOpacity ? `opacity ${duration}ms ${transitionTimingFunction}` : "none"
        }, getStyleObject.getStyleObject(style, theme)),
        ref
    }, others))), {
        children
    }));
});
Collapse.displayName = "@mantine/core/Collapse";
exports.Collapse = Collapse; //# sourceMappingURL=Collapse.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","77705237d82ac7a4":"iKGFf","f7d6e1f41e0cb190":"9HEEB","a7e3e8035b92bdeb":"9MtAM","c9114d733ca12286":"8QFOC","12fb7a53c0afd900":"2FdJg","a1f3046a37b7fce8":"6AMGA","c661e135ed373a6c":"erSvz","fa47ea6f9df13989":"kqQOF","84670f748175aa90":"iivvn","914092f400b8064f":"8YP4O","94c00146029eb5f7":"bvL2d","15fee7d9e24c1414":"gkGXc","834b0e5ae7cdf40":"guLFz","20319a2ae590d6bd":"2onWA","58575f5b4b7edec4":"axh1V"}],"axh1V":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("1efb46c54fa9449c");
var ReactDOM = require("27bc56094ad27ace");
var hooks = require("ae74f81c2fb2fbf1");
function getAutoHeightDuration(height) {
    if (!height || typeof height === "string") return 0;
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function getElementHeight(el) {
    return (el === null || el === void 0 ? void 0 : el.current) ? el.current.scrollHeight : "auto";
}
var raf = typeof window !== "undefined" && window.requestAnimationFrame;
function useCollapse(param) {
    var transitionDuration = param.transitionDuration, _param_transitionTimingFunction = param.transitionTimingFunction, transitionTimingFunction = _param_transitionTimingFunction === void 0 ? "ease" : _param_transitionTimingFunction, _param_onTransitionEnd = param.onTransitionEnd, onTransitionEnd = _param_onTransitionEnd === void 0 ? function() {} : _param_onTransitionEnd, opened = param.opened;
    var el = React.useRef(null);
    var collapsedHeight = 0;
    var collapsedStyles = {
        display: "none",
        height: 0,
        overflow: "hidden"
    };
    var _React_useState = (0, _slicedToArray._)(React.useState(opened ? {} : collapsedStyles), 2), styles = _React_useState[0], setStylesRaw = _React_useState[1];
    var setStyles = function(newStyles) {
        ReactDOM.flushSync(function() {
            return setStylesRaw(newStyles);
        });
    };
    var mergeStyles = function(newStyles) {
        setStyles(function(oldStyles) {
            return (0, _objectSpread._)({}, oldStyles, newStyles);
        });
    };
    function getTransitionStyles(height) {
        var _duration = transitionDuration || getAutoHeightDuration(height);
        return {
            transition: `height ${_duration}ms ${transitionTimingFunction}, opacity ${_duration}ms ${transitionTimingFunction}`
        };
    }
    hooks.useDidUpdate(function() {
        if (typeof raf === "function") {
            if (opened) raf(function() {
                mergeStyles({
                    willChange: "height",
                    display: "block",
                    overflow: "hidden"
                });
                raf(function() {
                    var height = getElementHeight(el);
                    mergeStyles((0, _objectSpreadProps._)((0, _objectSpread._)({}, getTransitionStyles(height)), {
                        height
                    }));
                });
            });
            else raf(function() {
                var height = getElementHeight(el);
                mergeStyles((0, _objectSpreadProps._)((0, _objectSpread._)({}, getTransitionStyles(height)), {
                    willChange: "height",
                    height
                }));
                raf(function() {
                    return mergeStyles({
                        height: collapsedHeight,
                        overflow: "hidden"
                    });
                });
            });
        }
    }, [
        opened
    ]);
    var handleTransitionEnd = function(e) {
        if (e.target !== el.current || e.propertyName !== "height") return;
        if (opened) {
            var height = getElementHeight(el);
            if (height === styles.height) setStyles({});
            else mergeStyles({
                height
            });
            onTransitionEnd();
        } else if (styles.height === collapsedHeight) {
            setStyles(collapsedStyles);
            onTransitionEnd();
        }
    };
    function getCollapseProps() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _param_style = _param.style, style = _param_style === void 0 ? {} : _param_style, _param_refKey = _param.refKey, refKey = _param_refKey === void 0 ? "ref" : _param_refKey, rest = (0, _objectWithoutProperties._)(_param, [
            "style",
            "refKey"
        ]);
        var theirRef = rest[refKey];
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            "aria-hidden": !opened
        }, rest), {
            [refKey]: hooks.mergeRefs(el, theirRef),
            onTransitionEnd: handleTransitionEnd,
            style: (0, _objectSpread._)({
                boxSizing: "border-box"
            }, style, styles)
        });
    }
    return getCollapseProps;
}
exports.getElementHeight = getElementHeight;
exports.useCollapse = useCollapse; //# sourceMappingURL=use-collapse.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","1efb46c54fa9449c":"9MtAM","27bc56094ad27ace":"5Yfvl","ae74f81c2fb2fbf1":"9HEEB"}],"ctZfT":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("97aba4fcb964cf14");
var React = require("75c5c3d045ad40af");
var react = require("fadea883e5a747dd");
var rem = require("30e90d0a49abafa");
require("e03702fc7726369");
var createVarsResolver = require("aa9a5f3bf40e6991");
require("50629482329d250d");
require("b3ad924911aeeb28");
require("d7c7286f8b17d711");
require("b7795d02566e3635");
require("a3a173cf9e54ff9c");
var useProps = require("8ef99c9a2a02f7da");
require("71d06f56ec440cfc");
var useStyles = require("5a395acdd9554e82");
var Box = require("ac8a49701991ce88");
var factory = require("776988eb809f8abf");
require("a186590843c9dc29");
var ScrollAreaCorner = require("f0f2538b09671393");
var ScrollAreaRoot = require("93a91fed4eb34256");
var ScrollAreaScrollbar = require("83ee3b61854c99ed");
var ScrollAreaThumb = require("8070f1b486004698");
var ScrollAreaViewport = require("d2287a7205ed5b6f");
var ScrollArea_module = require("373a959d1374f10c");
var defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover",
    scrollbars: "xy"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var scrollbarSize = param.scrollbarSize, overscrollBehavior = param.overscrollBehavior;
    return {
        root: {
            "--scrollarea-scrollbar-size": rem.rem(scrollbarSize),
            "--scrollarea-over-scroll-behavior": overscrollBehavior
        }
    };
});
var ScrollArea = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ScrollArea", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, scrollbarSize = props.scrollbarSize, vars = props.vars, type = props.type, scrollHideDelay = props.scrollHideDelay, viewportProps = props.viewportProps, viewportRef = props.viewportRef, onScrollPositionChange = props.onScrollPositionChange, children = props.children, offsetScrollbars = props.offsetScrollbars, scrollbars = props.scrollbars, onBottomReached = props.onBottomReached, onTopReached = props.onTopReached, overscrollBehavior = props.overscrollBehavior, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "scrollbarSize",
        "vars",
        "type",
        "scrollHideDelay",
        "viewportProps",
        "viewportRef",
        "onScrollPositionChange",
        "children",
        "offsetScrollbars",
        "scrollbars",
        "onBottomReached",
        "onTopReached",
        "overscrollBehavior"
    ]);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), scrollbarHovered = _React_useState[0], setScrollbarHovered = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(false), 2), verticalThumbVisible = _React_useState1[0], setVerticalThumbVisible = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState(false), 2), horizontalThumbVisible = _React_useState2[0], setHorizontalThumbVisible = _React_useState2[1];
    var getStyles = useStyles.useStyles({
        name: "ScrollArea",
        props,
        classes: ScrollArea_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var localViewportRef = React.useRef(null);
    var combinedViewportRef = react.useMergeRefs([
        viewportRef,
        localViewportRef
    ]);
    React.useEffect(function() {
        if (!localViewportRef.current) return;
        if (offsetScrollbars !== "present") return;
        var element = localViewportRef.current;
        var observer = new ResizeObserver(function() {
            var scrollHeight = element.scrollHeight, clientHeight = element.clientHeight, scrollWidth = element.scrollWidth, clientWidth = element.clientWidth;
            setVerticalThumbVisible(scrollHeight > clientHeight);
            setHorizontalThumbVisible(scrollWidth > clientWidth);
        });
        observer.observe(element);
        return function() {
            return observer.disconnect();
        };
    }, [
        localViewportRef,
        offsetScrollbars
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs(ScrollAreaRoot.ScrollAreaRoot, (0, _objectSpreadProps._)((0, _objectSpread._)({
        type: type === "never" ? "always" : type,
        scrollHideDelay,
        ref,
        scrollbars
    }, getStyles("root"), others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaViewport.ScrollAreaViewport, (0, _objectSpreadProps._)((0, _objectSpread._)({}, viewportProps, getStyles("viewport", {
                style: viewportProps === null || viewportProps === void 0 ? void 0 : viewportProps.style
            })), {
                ref: combinedViewportRef,
                "data-offset-scrollbars": offsetScrollbars === true ? "xy" : offsetScrollbars || void 0,
                "data-scrollbars": scrollbars || void 0,
                "data-horizontal-hidden": offsetScrollbars === "present" && !horizontalThumbVisible ? "true" : void 0,
                "data-vertical-hidden": offsetScrollbars === "present" && !verticalThumbVisible ? "true" : void 0,
                onScroll: function(e) {
                    var _viewportProps_onScroll;
                    viewportProps === null || viewportProps === void 0 ? void 0 : (_viewportProps_onScroll = viewportProps.onScroll) === null || _viewportProps_onScroll === void 0 ? void 0 : _viewportProps_onScroll.call(viewportProps, e);
                    onScrollPositionChange === null || onScrollPositionChange === void 0 ? void 0 : onScrollPositionChange({
                        x: e.currentTarget.scrollLeft,
                        y: e.currentTarget.scrollTop
                    });
                    var _e_currentTarget = e.currentTarget, scrollTop = _e_currentTarget.scrollTop, scrollHeight = _e_currentTarget.scrollHeight, clientHeight = _e_currentTarget.clientHeight;
                    if (scrollTop - (scrollHeight - clientHeight) >= 0) onBottomReached === null || onBottomReached === void 0 ? void 0 : onBottomReached();
                    if (scrollTop === 0) onTopReached === null || onTopReached === void 0 ? void 0 : onTopReached();
                },
                children
            })),
            (scrollbars === "xy" || scrollbars === "x") && /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbar.ScrollAreaScrollbar, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("scrollbar")), {
                orientation: "horizontal",
                "data-hidden": type === "never" || offsetScrollbars === "present" && !horizontalThumbVisible ? true : void 0,
                forceMount: true,
                onMouseEnter: function() {
                    return setScrollbarHovered(true);
                },
                onMouseLeave: function() {
                    return setScrollbarHovered(false);
                },
                children: /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaThumb.ScrollAreaThumb, (0, _objectSpread._)({}, getStyles("thumb")))
            })),
            (scrollbars === "xy" || scrollbars === "y") && /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbar.ScrollAreaScrollbar, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("scrollbar")), {
                orientation: "vertical",
                "data-hidden": type === "never" || offsetScrollbars === "present" && !verticalThumbVisible ? true : void 0,
                forceMount: true,
                onMouseEnter: function() {
                    return setScrollbarHovered(true);
                },
                onMouseLeave: function() {
                    return setScrollbarHovered(false);
                },
                children: /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaThumb.ScrollAreaThumb, (0, _objectSpread._)({}, getStyles("thumb")))
            })),
            /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaCorner.ScrollAreaCorner, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("corner")), {
                "data-hovered": scrollbarHovered || void 0,
                "data-hidden": type === "never" || void 0
            }))
        ]
    }));
});
ScrollArea.displayName = "@mantine/core/ScrollArea";
var ScrollAreaAutosize = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ScrollAreaAutosize", defaultProps, props), children = _useProps_useProps.children, classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, scrollbarSize = _useProps_useProps.scrollbarSize, scrollHideDelay = _useProps_useProps.scrollHideDelay, type = _useProps_useProps.type, dir = _useProps_useProps.dir, offsetScrollbars = _useProps_useProps.offsetScrollbars, viewportRef = _useProps_useProps.viewportRef, onScrollPositionChange = _useProps_useProps.onScrollPositionChange, unstyled = _useProps_useProps.unstyled, variant = _useProps_useProps.variant, viewportProps = _useProps_useProps.viewportProps, scrollbars = _useProps_useProps.scrollbars, style = _useProps_useProps.style, vars = _useProps_useProps.vars, onBottomReached = _useProps_useProps.onBottomReached, onTopReached = _useProps_useProps.onTopReached, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "classNames",
        "styles",
        "scrollbarSize",
        "scrollHideDelay",
        "type",
        "dir",
        "offsetScrollbars",
        "viewportRef",
        "onScrollPositionChange",
        "unstyled",
        "variant",
        "viewportProps",
        "scrollbars",
        "style",
        "vars",
        "onBottomReached",
        "onTopReached"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref,
        style: [
            {
                display: "flex",
                overflow: "auto"
            },
            style
        ],
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, {
            style: {
                display: "flex",
                flexDirection: "column",
                flex: 1
            },
            children: /* @__PURE__ */ jsxRuntime.jsx(ScrollArea, {
                classNames,
                styles,
                scrollHideDelay,
                scrollbarSize,
                type,
                dir,
                offsetScrollbars,
                viewportRef,
                onScrollPositionChange,
                unstyled,
                variant,
                viewportProps,
                vars,
                scrollbars,
                onBottomReached,
                onTopReached,
                children
            })
        })
    }));
});
ScrollArea.classes = ScrollArea_module;
ScrollAreaAutosize.displayName = "@mantine/core/ScrollAreaAutosize";
ScrollAreaAutosize.classes = ScrollArea_module;
ScrollArea.Autosize = ScrollAreaAutosize;
exports.ScrollArea = ScrollArea;
exports.ScrollAreaAutosize = ScrollAreaAutosize; //# sourceMappingURL=ScrollArea.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","97aba4fcb964cf14":"iKGFf","75c5c3d045ad40af":"9MtAM","fadea883e5a747dd":"jrkk4","30e90d0a49abafa":"ebAaL","e03702fc7726369":"9HEEB","aa9a5f3bf40e6991":"hIQE6","50629482329d250d":"8QFOC","b3ad924911aeeb28":"2FdJg","d7c7286f8b17d711":"6AMGA","b7795d02566e3635":"erSvz","a3a173cf9e54ff9c":"kqQOF","8ef99c9a2a02f7da":"iivvn","71d06f56ec440cfc":"8YP4O","5a395acdd9554e82":"d0sAY","ac8a49701991ce88":"gkGXc","776988eb809f8abf":"guLFz","a186590843c9dc29":"2onWA","f0f2538b09671393":"6m3LL","93a91fed4eb34256":"6OuSB","83ee3b61854c99ed":"jiuB1","8070f1b486004698":"dBsKu","d2287a7205ed5b6f":"lK4gs","373a959d1374f10c":"eB8nn"}],"jrkk4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrow", function() {
    return 0, _reactDom1.arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return 0, _reactDom1.autoPlacement;
});
parcelHelpers.export(exports, "autoUpdate", function() {
    return 0, _reactDom1.autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return 0, _reactDom1.computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _reactDom1.detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return 0, _reactDom1.flip;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _reactDom1.getOverflowAncestors;
});
parcelHelpers.export(exports, "hide", function() {
    return 0, _reactDom1.hide;
});
parcelHelpers.export(exports, "inline", function() {
    return 0, _reactDom1.inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return 0, _reactDom1.limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return 0, _reactDom1.offset;
});
parcelHelpers.export(exports, "platform", function() {
    return 0, _reactDom1.platform;
});
parcelHelpers.export(exports, "shift", function() {
    return 0, _reactDom1.shift;
});
parcelHelpers.export(exports, "size", function() {
    return 0, _reactDom1.size;
});
parcelHelpers.export(exports, "Composite", function() {
    return Composite;
});
parcelHelpers.export(exports, "CompositeItem", function() {
    return CompositeItem;
});
parcelHelpers.export(exports, "FloatingArrow", function() {
    return FloatingArrow;
});
parcelHelpers.export(exports, "FloatingDelayGroup", function() {
    return FloatingDelayGroup;
});
parcelHelpers.export(exports, "FloatingFocusManager", function() {
    return FloatingFocusManager;
});
parcelHelpers.export(exports, "FloatingList", function() {
    return FloatingList;
});
parcelHelpers.export(exports, "FloatingNode", function() {
    return FloatingNode;
});
parcelHelpers.export(exports, "FloatingOverlay", function() {
    return FloatingOverlay;
});
parcelHelpers.export(exports, "FloatingPortal", function() {
    return FloatingPortal;
});
parcelHelpers.export(exports, "FloatingTree", function() {
    return FloatingTree;
});
parcelHelpers.export(exports, "inner", function() {
    return inner;
});
parcelHelpers.export(exports, "safePolygon", function() {
    return safePolygon;
});
parcelHelpers.export(exports, "useClick", function() {
    return useClick;
});
parcelHelpers.export(exports, "useClientPoint", function() {
    return useClientPoint;
});
parcelHelpers.export(exports, "useDelayGroup", function() {
    return useDelayGroup;
});
parcelHelpers.export(exports, "useDelayGroupContext", function() {
    return useDelayGroupContext;
});
parcelHelpers.export(exports, "useDismiss", function() {
    return useDismiss;
});
parcelHelpers.export(exports, "useFloating", function() {
    return useFloating;
});
parcelHelpers.export(exports, "useFloatingNodeId", function() {
    return useFloatingNodeId;
});
parcelHelpers.export(exports, "useFloatingParentNodeId", function() {
    return useFloatingParentNodeId;
});
parcelHelpers.export(exports, "useFloatingPortalNode", function() {
    return useFloatingPortalNode;
});
parcelHelpers.export(exports, "useFloatingRootContext", function() {
    return useFloatingRootContext;
});
parcelHelpers.export(exports, "useFloatingTree", function() {
    return useFloatingTree;
});
parcelHelpers.export(exports, "useFocus", function() {
    return useFocus;
});
parcelHelpers.export(exports, "useHover", function() {
    return useHover;
});
parcelHelpers.export(exports, "useId", function() {
    return useId;
});
parcelHelpers.export(exports, "useInnerOffset", function() {
    return useInnerOffset;
});
parcelHelpers.export(exports, "useInteractions", function() {
    return useInteractions;
});
parcelHelpers.export(exports, "useListItem", function() {
    return useListItem;
});
parcelHelpers.export(exports, "useListNavigation", function() {
    return useListNavigation;
});
parcelHelpers.export(exports, "useMergeRefs", function() {
    return useMergeRefs;
});
parcelHelpers.export(exports, "useRole", function() {
    return useRole;
});
parcelHelpers.export(exports, "useTransitionStatus", function() {
    return useTransitionStatus;
});
parcelHelpers.export(exports, "useTransitionStyles", function() {
    return useTransitionStyles;
});
parcelHelpers.export(exports, "useTypeahead", function() {
    return useTypeahead;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _toPropertyKey = require("@swc/helpers/_/_to_property_key");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _react = require("react");
var _utils = require("@floating-ui/react/utils");
var _utils1 = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
var _tabbable = require("tabbable");
var _reactDom = require("react-dom");
var _reactDom1 = require("@floating-ui/react-dom");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function useMergeRefs(refs) {
    return _react.useMemo(function() {
        if (refs.every(function(ref) {
            return ref == null;
        })) return null;
        return function(value) {
            refs.forEach(function(ref) {
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
var SafeReact = (0, _objectSpread._)({}, _react);
var useInsertionEffect = SafeReact.useInsertionEffect;
var useSafeInsertionEffect = useInsertionEffect || function(fn) {
    return fn();
};
function useEffectEvent(callback) {
    var ref = _react.useRef(function() {});
    useSafeInsertionEffect(function() {
        ref.current = callback;
    });
    return _react.useCallback(function() {
        var _ref;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : (_ref = ref).current.apply(_ref, (0, _toConsumableArray._)(args));
    }, []);
}
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
function isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
    return findNonDisabledIndex(listRef, {
        disabledIndices
    });
}
function getMaxIndex(listRef, disabledIndices) {
    return findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices
    });
}
function findNonDisabledIndex(listRef, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_startingIndex = _ref.startingIndex, startingIndex = _ref_startingIndex === void 0 ? -1 : _ref_startingIndex, _ref_decrement = _ref.decrement, decrement = _ref_decrement === void 0 ? false : _ref_decrement, disabledIndices = _ref.disabledIndices, _ref_amount = _ref.amount, amount = _ref_amount === void 0 ? 1 : _ref_amount;
    var list = listRef.current;
    var index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && isDisabled(list, index, disabledIndices));
    return index;
}
function getGridNavigatedIndex(elementsRef, _ref) {
    var event = _ref.event, orientation = _ref.orientation, loop = _ref.loop, rtl = _ref.rtl, cols = _ref.cols, disabledIndices = _ref.disabledIndices, minIndex = _ref.minIndex, maxIndex = _ref.maxIndex, prevIndex = _ref.prevIndex, tmp = _ref.stopEvent, stop = tmp === void 0 ? false : tmp;
    var nextIndex = prevIndex;
    if (event.key === ARROW_UP) {
        stop && (0, _utils.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                var col = prevIndex % cols;
                var maxCol = maxIndex % cols;
                var offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if (isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === ARROW_DOWN) {
        stop && (0, _utils.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices
            });
        }
        if (isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        var prevRow = (0, _utils1.floor)(prevIndex / cols);
        if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
            stop && (0, _utils.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices
                });
                if (loop && isDifferentRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
            });
            if (isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
            stop && (0, _utils.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices
                });
                if (loop && isDifferentRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices
            });
            if (isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        var lastRow = (0, _utils1.floor)(maxIndex / cols) === prevRow;
        if (isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function buildCellMap(sizes, cols, dense) {
    var cellMap = [];
    var startIndex = 0;
    sizes.forEach(function(_ref2, index) {
        var _loop = function() {
            var targetCells = [];
            for(var i = 0; i < width; i++)for(var j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every(function(cell) {
                return cellMap[cell] == null;
            })) {
                targetCells.forEach(function(cell) {
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        };
        var width = _ref2.width, height = _ref2.height;
        var itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced)_loop();
    });
    // convert into a non-sparse array
    return (0, _toConsumableArray._)(cellMap);
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    var firstCellIndex = cellMap.indexOf(index);
    var sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function getCellIndices(indices, cellMap) {
    return cellMap.flatMap(function(index, cellIndex) {
        return indices.includes(index) ? [
            cellIndex
        ] : [];
    });
}
function isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    var element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
var index = typeof document !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function sortByDocumentPosition(a, b) {
    var position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = map1.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value !== map2.get(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
var FloatingListContext = /*#__PURE__*/ _react.createContext({
    register: function() {},
    unregister: function() {},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function FloatingList(props) {
    var children = props.children, elementsRef = props.elementsRef, labelsRef = props.labelsRef;
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return new Map();
    }), 2), map = _React_useState[0], setMap = _React_useState[1];
    var register = _react.useCallback(function(node) {
        setMap(function(prevMap) {
            return new Map(prevMap).set(node, null);
        });
    }, []);
    var unregister = _react.useCallback(function(node) {
        setMap(function(prevMap) {
            var map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    index(function() {
        var newMap = new Map(map);
        var nodes = Array.from(newMap.keys()).sort(sortByDocumentPosition);
        nodes.forEach(function(node, index) {
            newMap.set(node, index);
        });
        if (!areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ _react.createElement(FloatingListContext.Provider, {
        value: _react.useMemo(function() {
            return {
                register,
                unregister,
                map,
                elementsRef,
                labelsRef
            };
        }, [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function useListItem(props) {
    if (props === void 0) props = {};
    var label = props.label;
    var _React_useContext = _react.useContext(FloatingListContext), register = _React_useContext.register, unregister = _React_useContext.unregister, map = _React_useContext.map, elementsRef = _React_useContext.elementsRef, labelsRef = _React_useContext.labelsRef;
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), index$1 = _React_useState[0], setIndex = _React_useState[1];
    var componentRef = _react.useRef(null);
    var ref = _react.useCallback(function(node) {
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                var isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    index(function() {
        var node = componentRef.current;
        if (node) {
            register(node);
            return function() {
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    index(function() {
        var index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return _react.useMemo(function() {
        return {
            ref,
            index: index$1 == null ? -1 : index$1
        };
    }, [
        index$1,
        ref
    ]);
}
function renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ _react.cloneElement(render, computedProps);
    return /*#__PURE__*/ _react.createElement("div", computedProps);
}
var CompositeContext = /*#__PURE__*/ _react.createContext({
    activeIndex: 0,
    onNavigate: function() {}
});
var horizontalKeys = [
    ARROW_LEFT,
    ARROW_RIGHT
];
var verticalKeys = [
    ARROW_UP,
    ARROW_DOWN
];
var allKeys = (0, _toConsumableArray._)(horizontalKeys).concat((0, _toConsumableArray._)(verticalKeys));
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ var Composite = /*#__PURE__*/ _react.forwardRef(function Composite(props, forwardedRef) {
    var render = props.render, _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? "both" : _props_orientation, _props_loop = props.loop, loop = _props_loop === void 0 ? true : _props_loop, _props_rtl = props.rtl, rtl = _props_rtl === void 0 ? false : _props_rtl, _props_cols = props.cols, cols = _props_cols === void 0 ? 1 : _props_cols, disabledIndices = props.disabledIndices, externalActiveIndex = props.activeIndex, externalSetActiveIndex = props.onNavigate, itemSizes = props.itemSizes, _props_dense = props.dense, dense = _props_dense === void 0 ? false : _props_dense, domProps = (0, _objectWithoutProperties._)(props, [
        "render",
        "orientation",
        "loop",
        "rtl",
        "cols",
        "disabledIndices",
        "activeIndex",
        "onNavigate",
        "itemSizes",
        "dense"
    ]);
    var _React_useState = (0, _slicedToArray._)(_react.useState(0), 2), internalActiveIndex = _React_useState[0], internalSetActiveIndex = _React_useState[1];
    var activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    var onNavigate = useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    var elementsRef = _react.useRef([]);
    var renderElementProps = render && typeof render !== "function" ? render.props : {};
    var contextValue = _react.useMemo(function() {
        return {
            activeIndex,
            onNavigate
        };
    }, [
        activeIndex,
        onNavigate
    ]);
    var isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!allKeys.includes(event.key)) return;
        var nextIndex = activeIndex;
        var minIndex = getMinIndex(elementsRef, disabledIndices);
        var maxIndex = getMaxIndex(elementsRef, disabledIndices);
        var horizontalEndKey = rtl ? ARROW_LEFT : ARROW_RIGHT;
        var horizontalStartKey = rtl ? ARROW_RIGHT : ARROW_LEFT;
        if (isGrid) {
            var sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, function() {
                return {
                    width: 1,
                    height: 1
                };
            });
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            var cellMap = buildCellMap(sizes, cols, dense);
            var minGridIndex = cellMap.findIndex(function(index) {
                return index != null && !isDisabled(elementsRef.current, index, disabledIndices);
            });
            // last enabled index
            var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                return index != null && !isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex;
            }, -1);
            var maybeNextIndex = cellMap[getGridNavigatedIndex({
                current: cellMap.map(function(itemIndex) {
                    return itemIndex ? elementsRef.current[itemIndex] : null;
                })
            }, {
                event,
                orientation,
                loop,
                rtl,
                cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: getCellIndices((0, _toConsumableArray._)(disabledIndices || elementsRef.current.map(function(_, index) {
                    return isDisabled(elementsRef.current, index) ? index : undefined;
                })).concat([
                    undefined
                ]), cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === ARROW_DOWN ? "bl" : event.key === horizontalEndKey ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        var toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                ARROW_DOWN
            ]
        }[orientation];
        var toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                ARROW_UP
            ],
            both: [
                horizontalStartKey,
                ARROW_UP
            ]
        }[orientation];
        var preventedKeys = isGrid ? allKeys : ({
            horizontal: horizontalKeys,
            vertical: verticalKeys,
            both: allKeys
        })[orientation];
        if (nextIndex === activeIndex && (0, _toConsumableArray._)(toEndKeys).concat((0, _toConsumableArray._)(toStartKeys)).includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    var computedProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, domProps, renderElementProps), {
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    });
    return /*#__PURE__*/ _react.createElement(CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ _react.createElement(FloatingList, {
        elementsRef: elementsRef
    }, renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ var CompositeItem = /*#__PURE__*/ _react.forwardRef(function CompositeItem(props, forwardedRef) {
    var render = props.render, domProps = (0, _objectWithoutProperties._)(props, [
        "render"
    ]);
    var renderElementProps = render && typeof render !== "function" ? render.props : {};
    var _React_useContext = _react.useContext(CompositeContext), activeIndex = _React_useContext.activeIndex, onNavigate = _React_useContext.onNavigate;
    var _useListItem = useListItem(), ref = _useListItem.ref, index = _useListItem.index;
    var mergedRef = useMergeRefs([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    var isActive = activeIndex === index;
    var computedProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, domProps, renderElementProps), {
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    });
    return renderJsx(render, computedProps);
});
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var serverHandoffComplete = false;
var count = 0;
var genId = function() {
    return(// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++);
};
function useFloatingId() {
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return serverHandoffComplete ? genId() : undefined;
    }), 2), id = _React_useState[0], setId = _React_useState[1];
    index(function() {
        if (id == null) setId(genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    _react.useEffect(function() {
        serverHandoffComplete = true;
    }, []);
    return id;
}
var useReactId = SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ var useId = useReactId || useFloatingId;
var devMessageSet;
function warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    var message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    var message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ var FloatingArrow = /*#__PURE__*/ _react.forwardRef(function FloatingArrow(props, ref) {
    var _props_context = props.context, placement = _props_context.placement, floating = _props_context.elements.floating, _props_context_middlewareData = _props_context.middlewareData, arrow = _props_context_middlewareData.arrow, shift = _props_context_middlewareData.shift, _props_width = props.width, width = _props_width === void 0 ? 14 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 7 : _props_height, _props_tipRadius = props.tipRadius, tipRadius = _props_tipRadius === void 0 ? 0 : _props_tipRadius, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 0 : _props_strokeWidth, staticOffset = props.staticOffset, stroke = props.stroke, d = props.d, tmp = props.style, transform = (tmp === void 0 ? {} : tmp).transform, restStyle = (0, _objectWithoutProperties._)(props.style, [
        "transform"
    ]), rest = (0, _objectWithoutProperties._)(props, [
        "context",
        "width",
        "height",
        "tipRadius",
        "strokeWidth",
        "staticOffset",
        "stroke",
        "d",
        "style"
    ]);
    var clipPathId = useId();
    var _React_useState = (0, _slicedToArray._)(_react.useState(false), 2), isRTL = _React_useState[0], setIsRTL = _React_useState[1];
    // https://github.com/floating-ui/floating-ui/issues/2932
    index(function() {
        if (!floating) return;
        var isRTL = (0, _dom.getComputedStyle)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    var _placement_split = (0, _slicedToArray._)(placement.split("-"), 2), side = _placement_split[0], alignment = _placement_split[1];
    var isVerticalSide = side === "top" || side === "bottom";
    var computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    var computedStrokeWidth = strokeWidth * 2;
    var halfStrokeWidth = computedStrokeWidth / 2;
    var svgX = width / 2 * (tipRadius / -8 + 1);
    var svgY = height / 2 * tipRadius / 4;
    var isCustomShape = !!d;
    var yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    var xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    var arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    var arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    var dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    var rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ _react.createElement("svg", _extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: (0, _objectSpread._)({
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter(function(t) {
                return !!t;
            }).join(" ")
        }, restStyle)
    }), computedStrokeWidth > 0 && /*#__PURE__*/ _react.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ _react.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ _react.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ _react.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function createPubSub() {
    var map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach(function(handler) {
                return handler(data);
            });
        },
        on (event, listener) {
            map.set(event, (0, _toConsumableArray._)(map.get(event) || []).concat([
                listener
            ]));
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(function(l) {
                return l !== listener;
            })) || []);
        }
    };
}
var FloatingNodeContext = /*#__PURE__*/ _react.createContext(null);
var FloatingTreeContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ var useFloatingParentNodeId = function() {
    var _React$useContext;
    return ((_React$useContext = _react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ var useFloatingTree = function() {
    return _react.useContext(FloatingTreeContext);
};
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function useFloatingNodeId(customParentId) {
    var id = useId();
    var tree = useFloatingTree();
    var reactParentId = useFloatingParentNodeId();
    var parentId = customParentId || reactParentId;
    index(function() {
        var node = {
            id,
            parentId
        };
        tree == null || tree.addNode(node);
        return function() {
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function FloatingNode(props) {
    var children = props.children, id = props.id;
    var parentId = useFloatingParentNodeId();
    return /*#__PURE__*/ _react.createElement(FloatingNodeContext.Provider, {
        value: _react.useMemo(function() {
            return {
                id,
                parentId
            };
        }, [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function FloatingTree(props) {
    var children = props.children;
    var nodesRef = _react.useRef([]);
    var addNode = _react.useCallback(function(node) {
        nodesRef.current = (0, _toConsumableArray._)(nodesRef.current).concat([
            node
        ]);
    }, []);
    var removeNode = _react.useCallback(function(node) {
        nodesRef.current = nodesRef.current.filter(function(n) {
            return n !== node;
        });
    }, []);
    var events = _react.useState(function() {
        return createPubSub();
    })[0];
    return /*#__PURE__*/ _react.createElement(FloatingTreeContext.Provider, {
        value: _react.useMemo(function() {
            return {
                nodesRef,
                addNode,
                removeNode,
                events
            };
        }, [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function createAttribute(name) {
    return "data-floating-ui-" + name;
}
function useLatestRef(value) {
    var ref = (0, _react.useRef)(value);
    index(function() {
        ref.current = value;
    });
    return ref;
}
var safePolygonIdentifier = /*#__PURE__*/ createAttribute("safe-polygon");
function getDelay(value, prop, pointerType) {
    if (pointerType && !(0, _utils.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function useHover(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, dataRef = context.dataRef, events = context.events, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_delay = props.delay, delay = _props_delay === void 0 ? 0 : _props_delay, _props_handleClose = props.handleClose, handleClose = _props_handleClose === void 0 ? null : _props_handleClose, _props_mouseOnly = props.mouseOnly, mouseOnly = _props_mouseOnly === void 0 ? false : _props_mouseOnly, _props_restMs = props.restMs, restMs = _props_restMs === void 0 ? 0 : _props_restMs, _props_move = props.move, move = _props_move === void 0 ? true : _props_move;
    var tree = useFloatingTree();
    var parentId = useFloatingParentNodeId();
    var handleCloseRef = useLatestRef(handleClose);
    var delayRef = useLatestRef(delay);
    var openRef = useLatestRef(open);
    var pointerTypeRef = _react.useRef();
    var timeoutRef = _react.useRef(-1);
    var handlerRef = _react.useRef();
    var restTimeoutRef = _react.useRef(-1);
    var blockMouseMoveRef = _react.useRef(true);
    var performedPointerEventsMutationRef = _react.useRef(false);
    var unbindMouseMoveRef = _react.useRef(function() {});
    var restTimeoutPendingRef = _react.useRef(false);
    var isHoverOpen = _react.useCallback(function() {
        var _dataRef$current$open;
        var type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    _react.useEffect(function() {
        var onOpenChange = function onOpenChange(_ref) {
            var open = _ref.open;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        };
        if (!enabled) return;
        events.on("openchange", onOpenChange);
        return function() {
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    _react.useEffect(function() {
        var onLeave = function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        };
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        var html = (0, _utils.getDocument)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return function() {
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    var closeWithDelay = _react.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        var closeDelay = getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(function() {
                return onOpenChange(false, event, reason);
            }, closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    var cleanupMouseMoveHandler = useEffectEvent(function() {
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    var clearPointerEvents = useEffectEvent(function() {
        if (performedPointerEventsMutationRef.current) {
            var body = (0, _utils.getDocument)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute(safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    var isClickLikeOpenEvent = useEffectEvent(function() {
        return dataRef.current.openEvent ? [
            "click",
            "mousedown"
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    _react.useEffect(function() {
        var onMouseEnter = function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, _utils.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !getDelay(delayRef.current, "open")) return;
            var openDelay = getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(function() {
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else if (!open) onOpenChange(true, event, "hover");
        };
        var onMouseLeave = function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            var doc = (0, _utils.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current((0, _objectSpreadProps._)((0, _objectSpread._)({}, dataRef.current.floatingContext), {
                    tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, "safe-polygon");
                    }
                }));
                var handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = function() {
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            var shouldClose = pointerTypeRef.current === "touch" ? !(0, _utils.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        };
        var onScrollMouseLeave = // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current((0, _objectSpreadProps._)((0, _objectSpread._)({}, dataRef.current.floatingContext), {
                tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            }))(event);
        };
        if (!enabled) return;
        if ((0, _dom.isElement)(elements.domReference)) {
            var _elements$floating;
            var ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return function() {
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    index(function() {
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            var floatingEl = elements.floating;
            if ((0, _dom.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                var body = (0, _utils.getDocument)(elements.floating).body;
                body.setAttribute(safePolygonIdentifier, "");
                var ref = elements.domReference;
                var parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find(function(node) {
                    return node.id === parentId;
                })) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return function() {
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    index(function() {
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    _react.useEffect(function() {
        return function() {
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    var reference = _react.useMemo(function() {
        var setPointerRef = function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        };
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                var nativeEvent = event.nativeEvent;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, _utils.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && Math.pow(event.movementX, 2) + Math.pow(event.movementY, 2) < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    var floating = _react.useMemo(function() {
        return {
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        };
    }, [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference,
            floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
var NOOP = function() {};
var FloatingDelayGroupContext = /*#__PURE__*/ _react.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: NOOP,
    setState: NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ var useDelayGroupContext = function() {
    return _react.useContext(FloatingDelayGroupContext);
};
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function FloatingDelayGroup(props) {
    var children = props.children, delay = props.delay, _props_timeoutMs = props.timeoutMs, timeoutMs = _props_timeoutMs === void 0 ? 0 : _props_timeoutMs;
    var _React_useReducer = (0, _slicedToArray._)(_react.useReducer(function(prev, next) {
        return (0, _objectSpread._)({}, prev, next);
    }, {
        delay,
        timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    }), 2), state = _React_useReducer[0], setState = _React_useReducer[1];
    var initialCurrentIdRef = _react.useRef(null);
    var setCurrentId = _react.useCallback(function(currentId) {
        setState({
            currentId
        });
    }, []);
    index(function() {
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ _react.createElement(FloatingDelayGroupContext.Provider, {
        value: _react.useMemo(function() {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                setState,
                setCurrentId
            });
        }, [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function useDelayGroup(context, options) {
    if (options === void 0) options = {};
    var open = context.open, onOpenChange = context.onOpenChange, floatingId = context.floatingId;
    var optionId = options.id, _options_enabled = options.enabled, enabled = _options_enabled === void 0 ? true : _options_enabled;
    var id = optionId != null ? optionId : floatingId;
    var groupContext = useDelayGroupContext();
    var currentId = groupContext.currentId, setCurrentId = groupContext.setCurrentId, initialDelay = groupContext.initialDelay, setState = groupContext.setState, timeoutMs = groupContext.timeoutMs;
    index(function() {
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    index(function() {
        var unset = function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        };
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                var timeout = window.setTimeout(unset, timeoutMs);
                return function() {
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    index(function() {
        if (!enabled) return;
        if (setCurrentId === NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
var rafId = 0;
function enqueueFocus(el, options) {
    if (options === void 0) options = {};
    var _options_preventScroll = options.preventScroll, preventScroll = _options_preventScroll === void 0 ? false : _options_preventScroll, _options_cancelPrevious = options.cancelPrevious, cancelPrevious = _options_cancelPrevious === void 0 ? true : _options_cancelPrevious, _options_sync = options.sync, sync = _options_sync === void 0 ? false : _options_sync;
    cancelPrevious && cancelAnimationFrame(rafId);
    var exec = function() {
        return el == null ? void 0 : el.focus({
            preventScroll
        });
    };
    if (sync) exec();
    else rafId = requestAnimationFrame(exec);
}
function getAncestors(nodes, id) {
    var _nodes$find;
    var allAncestors = [];
    var currentParentId = (_nodes$find = nodes.find(function(node) {
        return node.id === id;
    })) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        var currentNode = nodes.find(function(node) {
            return node.id === currentParentId;
        });
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function getChildren(nodes, id) {
    var allChildren = nodes.filter(function(node) {
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    var currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter(function(node) {
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(function(n) {
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function getDeepestNode(nodes, id) {
    var deepestNodeId;
    var maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        var children = getChildren(nodes, nodeId);
        children.forEach(function(child) {
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find(function(node) {
        return node.id === deepestNodeId;
    });
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
var counterMap = /*#__PURE__*/ new WeakMap();
var uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
var markerMap = {};
var lockCount$1 = 0;
var supportsInert = function() {
    return typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
};
var unwrapHost = function(node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctElements = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter(function(x) {
        return x != null;
    });
};
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    var markerName = "data-floating-ui-inert";
    var controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    var avoidElements = correctElements(body, uncorrectedAvoidElements);
    var elementsToKeep = new Set();
    var elementsToStop = new Set(avoidElements);
    var hiddenElements = [];
    if (!markerMap[markerName]) markerMap[markerName] = new WeakMap();
    var markerCounter = markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, function(node) {
            if ((0, _dom.getNodeName)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    lockCount$1++;
    return function() {
        hiddenElements.forEach(function(element) {
            var counterValue = (counterMap.get(element) || 0) - 1;
            var markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        lockCount$1--;
        if (!lockCount$1) {
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledElementsSet = new WeakSet();
            markerMap = {};
        }
    };
}
function markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    var body = (0, _utils.getDocument)(avoidElements[0]).body;
    return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
var getTabbableOptions = function() {
    return {
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    };
};
function getTabbableIn(container, direction) {
    var allTabbable = (0, _tabbable.tabbable)(container, getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    var activeIndex = allTabbable.indexOf((0, _utils.activeElement)((0, _utils.getDocument)(container)));
    var nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function getNextTabbable() {
    return getTabbableIn(document.body, "next");
}
function getPreviousTabbable() {
    return getTabbableIn(document.body, "prev");
}
function isOutsideEvent(event, container) {
    var containerElement = container || event.currentTarget;
    var relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, _utils.contains)(containerElement, relatedTarget);
}
function disableFocusInside(container) {
    var tabbableElements = (0, _tabbable.tabbable)(container, getTabbableOptions());
    tabbableElements.forEach(function(element) {
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function enableFocusInside(container) {
    var elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach(function(element) {
        var tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
var HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
var timeoutId;
function setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout(timeoutId);
    }
}
var FocusGuard = /*#__PURE__*/ _react.forwardRef(function FocusGuard(props, ref) {
    var _React_useState = (0, _slicedToArray._)(_react.useState(), 2), role = _React_useState[0], setRole = _React_useState[1];
    index(function() {
        if ((0, _utils.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", setActiveElementOnTab);
        return function() {
            document.removeEventListener("keydown", setActiveElementOnTab);
        };
    }, []);
    var restProps = {
        ref,
        tabIndex: 0,
        // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [createAttribute("focus-guard")]: "",
        style: HIDDEN_STYLES
    };
    return /*#__PURE__*/ _react.createElement("span", _extends({}, props, restProps));
});
var PortalContext = /*#__PURE__*/ _react.createContext(null);
var attr = /*#__PURE__*/ createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function useFloatingPortalNode(props) {
    if (props === void 0) props = {};
    var id = props.id, root = props.root;
    var uniqueId = useId();
    var portalContext = usePortalContext();
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), portalNode = _React_useState[0], setPortalNode = _React_useState[1];
    var portalNodeRef = _react.useRef(null);
    index(function() {
        return function() {
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(function() {
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    index(function() {
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        var existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        var subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute(attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    index(function() {
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        var container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, _dom.isElement)(container)) container = container.current;
        container = container || document.body;
        var idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        var subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute(attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function FloatingPortal(props) {
    var children = props.children, id = props.id, root = props.root, _props_preserveTabOrder = props.preserveTabOrder, preserveTabOrder = _props_preserveTabOrder === void 0 ? true : _props_preserveTabOrder;
    var portalNode = useFloatingPortalNode({
        id,
        root
    });
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), focusManagerState = _React_useState[0], setFocusManagerState = _React_useState[1];
    var beforeOutsideRef = _react.useRef(null);
    var afterOutsideRef = _react.useRef(null);
    var beforeInsideRef = _react.useRef(null);
    var afterInsideRef = _react.useRef(null);
    var modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    var open = focusManagerState == null ? void 0 : focusManagerState.open;
    var shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    _react.useEffect(function() {
        var onFocus = // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && isOutsideEvent(event)) {
                var focusing = event.type === "focusin";
                var manageFocus = focusing ? enableFocusInside : disableFocusInside;
                manageFocus(portalNode);
            }
        };
        if (!portalNode || !preserveTabOrder || modal) return;
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return function() {
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    _react.useEffect(function() {
        if (!portalNode) return;
        if (open) return;
        enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ _react.createElement(PortalContext.Provider, {
        value: _react.useMemo(function() {
            return {
                preserveTabOrder,
                beforeOutsideRef,
                afterOutsideRef,
                beforeInsideRef,
                afterInsideRef,
                portalNode,
                setFocusManagerState
            };
        }, [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: function(event) {
            if (isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                var prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ _react.createElement("span", {
        "aria-owns": portalNode.id,
        style: HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ _reactDom.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: function(event) {
            if (isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                var nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
            }
        }
    }));
}
var usePortalContext = function() {
    return _react.useContext(PortalContext);
};
var FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
var LIST_LIMIT = 20;
var previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
    previouslyFocusedElements = previouslyFocusedElements.filter(function(el) {
        return el.isConnected;
    });
    var tabbableEl = element;
    if (!tabbableEl || (0, _dom.getNodeName)(tabbableEl) === "body") return;
    if (!(0, _tabbable.isTabbable)(tabbableEl, getTabbableOptions())) {
        var tabbableChild = (0, _tabbable.tabbable)(tabbableEl, getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    previouslyFocusedElements.push(tabbableEl);
    if (previouslyFocusedElements.length > LIST_LIMIT) previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
}
function getPreviouslyFocusedElement() {
    return previouslyFocusedElements.slice().reverse().find(function(el) {
        return el.isConnected;
    });
}
var VisuallyHiddenDismiss = /*#__PURE__*/ _react.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ _react.createElement("button", _extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function FloatingFocusManager(props) {
    var context = props.context, children = props.children, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_order = props.order, order = _props_order === void 0 ? [
        "content"
    ] : _props_order, tmp = props.guards, _guards = tmp === void 0 ? true : tmp, _props_initialFocus = props.initialFocus, initialFocus = _props_initialFocus === void 0 ? 0 : _props_initialFocus, _props_returnFocus = props.returnFocus, returnFocus = _props_returnFocus === void 0 ? true : _props_returnFocus, _props_restoreFocus = props.restoreFocus, restoreFocus = _props_restoreFocus === void 0 ? false : _props_restoreFocus, _props_modal = props.modal, modal = _props_modal === void 0 ? true : _props_modal, _props_visuallyHiddenDismiss = props.visuallyHiddenDismiss, visuallyHiddenDismiss = _props_visuallyHiddenDismiss === void 0 ? false : _props_visuallyHiddenDismiss, _props_closeOnFocusOut = props.closeOnFocusOut, closeOnFocusOut = _props_closeOnFocusOut === void 0 ? true : _props_closeOnFocusOut;
    var open = context.open, refs = context.refs, nodeId = context.nodeId, onOpenChange = context.onOpenChange, events = context.events, dataRef = context.dataRef, floatingId = context.floatingId, _context_elements = context.elements, domReference = _context_elements.domReference, floating = _context_elements.floating;
    var ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    var isUntrappedTypeableCombobox = (0, _utils.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    var guards = supportsInert() ? _guards : true;
    var orderRef = useLatestRef(order);
    var initialFocusRef = useLatestRef(initialFocus);
    var returnFocusRef = useLatestRef(returnFocus);
    var tree = useFloatingTree();
    var portalContext = usePortalContext();
    var startDismissButtonRef = _react.useRef(null);
    var endDismissButtonRef = _react.useRef(null);
    var preventReturnFocusRef = _react.useRef(false);
    var isPointerDownRef = _react.useRef(false);
    var tabbableIndexRef = _react.useRef(-1);
    var isInsidePortal = portalContext != null;
    var floatingFocusElement = getFloatingFocusElement(floating);
    var getTabbableContent = useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, _tabbable.tabbable)(container, getTabbableOptions()) : [];
    });
    var getTabbableElements = useEffectEvent(function(container) {
        var content = getTabbableContent(container);
        return orderRef.current.map(function(type) {
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    _react.useEffect(function() {
        var onKeyDown = function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, _utils.contains)(floatingFocusElement, (0, _utils.activeElement)((0, _utils.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, _utils.stopEvent)(event);
                var els = getTabbableElements();
                var target = (0, _utils.getTarget)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, _utils.stopEvent)(event);
                    if (event.shiftKey) enqueueFocus(els[els.length - 1]);
                    else enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, _utils.stopEvent)(event);
                    enqueueFocus(els[0]);
                }
            }
        };
        if (disabled) return;
        if (!modal) return;
        var doc = (0, _utils.getDocument)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return function() {
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    _react.useEffect(function() {
        var handleFocusIn = function handleFocusIn(event) {
            var target = (0, _utils.getTarget)(event);
            var tabbableContent = getTabbableContent();
            var tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        };
        if (disabled) return;
        if (!floating) return;
        floating.addEventListener("focusin", handleFocusIn);
        return function() {
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    _react.useEffect(function() {
        var handlePointerDown = // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(function() {
                isPointerDownRef.current = false;
            });
        };
        var handleFocusOutside = function handleFocusOutside(event) {
            var relatedTarget = event.relatedTarget;
            queueMicrotask(function() {
                var movedToUnrelatedNode = !((0, _utils.contains)(domReference, relatedTarget) || (0, _utils.contains)(floating, relatedTarget) || (0, _utils.contains)(relatedTarget, floating) || (0, _utils.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute("focus-guard")) || tree && (getChildren(tree.nodesRef.current, nodeId).find(function(node) {
                    var _node$context, _node$context2;
                    return (0, _utils.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, _utils.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || getAncestors(tree.nodesRef.current, nodeId).find(function(node) {
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, _utils.activeElement)((0, _utils.getDocument)(floatingFocusElement)) === (0, _utils.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, _dom.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    var prevTabbableIndex = tabbableIndexRef.current;
                    var tabbableContent = getTabbableContent();
                    var nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, _dom.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        };
        if (disabled) return;
        if (!closeOnFocusOut) return;
        if (floating && (0, _dom.isHTMLElement)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return function() {
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    _react.useEffect(function() {
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        var portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute("portal") + "]")) || []);
        if (floating) {
            var insideElements = [
                floating
            ].concat((0, _toConsumableArray._)(portalNodes), [
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ]).filter(function(x) {
                return x != null;
            });
            var cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
            return function() {
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    index(function() {
        if (disabled || !(0, _dom.isHTMLElement)(floatingFocusElement)) return;
        var doc = (0, _utils.getDocument)(floatingFocusElement);
        var previouslyFocusedElement = (0, _utils.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(function() {
            var focusableElements = getTabbableElements(floatingFocusElement);
            var initialFocusValue = initialFocusRef.current;
            var elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            var focusAlreadyInsideFloatingEl = (0, _utils.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    index(function() {
        var onOpenChange = // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            var open = _ref.open, reason = _ref.reason, event = _ref.event, nested = _ref.nested;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, _utils.isVirtualClick)(event) || (0, _utils.isVirtualPointerEvent)(event));
        };
        var getReturnElement = function getReturnElement() {
            if (typeof returnFocusRef.current === "boolean") return getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        };
        if (disabled || !floatingFocusElement) return;
        var preventReturnFocusScroll = false;
        var doc = (0, _utils.getDocument)(floatingFocusElement);
        var previouslyFocusedElement = (0, _utils.activeElement)(doc);
        var contextData = dataRef.current;
        var openEvent = contextData.openEvent;
        addPreviouslyFocusedElement(previouslyFocusedElement);
        events.on("openchange", onOpenChange);
        var fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        return function() {
            events.off("openchange", onOpenChange);
            var activeEl = (0, _utils.activeElement)(doc);
            var isFocusInsideFloatingTree = (0, _utils.contains)(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some(function(node) {
                var _node$context5;
                return (0, _utils.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            var shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) addPreviouslyFocusedElement(refs.domReference.current);
            var returnElement = getReturnElement();
            queueMicrotask(function() {
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, _dom.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    _react.useEffect(function() {
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(function() {
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    index(function() {
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal,
            closeOnFocusOut,
            open,
            onOpenChange,
            refs
        });
        return function() {
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    index(function() {
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        var handleMutation = function() {
            var tabIndex = floatingFocusElement.getAttribute("tabindex");
            var tabbableContent = getTabbableContent();
            var activeEl = (0, _utils.activeElement)((0, _utils.getDocument)(floating));
            var tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        var observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return function() {
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ _react.createElement(VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: function(event) {
                return onOpenChange(false, event.nativeEvent);
            }
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    var shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, shouldRenderGuards && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: function(event) {
            if (modal) {
                var els = getTabbableElements();
                enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if (isOutsideEvent(event, portalContext.portalNode)) {
                    var nextTabbable = getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ _react.createElement(FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: function(event) {
            if (modal) enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if (isOutsideEvent(event, portalContext.portalNode)) {
                    var prevTabbable = getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
var lockCount = 0;
function enableScrollLock() {
    var isIOS = /iP(hone|ad|od)|iOS/.test((0, _utils.getPlatform)());
    var bodyStyle = document.body.style;
    // RTL <body> scrollbar
    var scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    var paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    var scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    var scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        var offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        var offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0"
        });
    }
    return function() {
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
var cleanup = function() {};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ var FloatingOverlay = /*#__PURE__*/ _react.forwardRef(function FloatingOverlay(props, ref) {
    var _props_lockScroll = props.lockScroll, lockScroll = _props_lockScroll === void 0 ? false : _props_lockScroll, rest = (0, _objectWithoutProperties._)(props, [
        "lockScroll"
    ]);
    index(function() {
        if (!lockScroll) return;
        lockCount++;
        if (lockCount === 1) cleanup = enableScrollLock();
        return function() {
            lockCount--;
            if (lockCount === 0) cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ _react.createElement("div", _extends({
        ref: ref
    }, rest, {
        style: (0, _objectSpread._)({
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, rest.style)
    }));
});
function isButtonTarget(event) {
    return (0, _dom.isHTMLElement)(event.target) && event.target.tagName === "BUTTON";
}
function isSpaceIgnored(element) {
    return (0, _utils.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function useClick(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, dataRef = context.dataRef, domReference = context.elements.domReference;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, tmp = props.event, eventOption = tmp === void 0 ? "click" : tmp, _props_toggle = props.toggle, toggle = _props_toggle === void 0 ? true : _props_toggle, _props_ignoreMouse = props.ignoreMouse, ignoreMouse = _props_ignoreMouse === void 0 ? false : _props_ignoreMouse, _props_keyboardHandlers = props.keyboardHandlers, keyboardHandlers = _props_keyboardHandlers === void 0 ? true : _props_keyboardHandlers, _props_stickIfOpen = props.stickIfOpen, stickIfOpen = _props_stickIfOpen === void 0 ? true : _props_stickIfOpen;
    var pointerTypeRef = _react.useRef();
    var didKeyDownRef = _react.useRef(false);
    var reference = _react.useMemo(function() {
        return {
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                var pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, _utils.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                var pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, _utils.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) return;
                if (event.key === " " && !isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        };
    }, [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
function createVirtualElement(domElement, data) {
    var offsetX = null;
    var offsetY = null;
    var isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            var domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            var isXAxis = data.axis === "x" || data.axis === "both";
            var isYAxis = data.axis === "y" || data.axis === "both";
            var canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            var width = domRect.width;
            var height = domRect.height;
            var x = domRect.x;
            var y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width,
                height,
                x,
                y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function useClientPoint(context, props) {
    if (props === void 0) props = {};
    var open = context.open, dataRef = context.dataRef, _context_elements = context.elements, floating = _context_elements.floating, domReference = _context_elements.domReference, refs = context.refs;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_axis = props.axis, axis = _props_axis === void 0 ? "both" : _props_axis, _props_x = props.x, x = _props_x === void 0 ? null : _props_x, _props_y = props.y, y = _props_y === void 0 ? null : _props_y;
    var initialRef = _react.useRef(false);
    var cleanupListenerRef = _react.useRef(null);
    var _React_useState = (0, _slicedToArray._)(_react.useState(), 2), pointerType = _React_useState[0], setPointerType = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState([]), 2), reactive = _React_useState1[0], setReactive = _React_useState1[1];
    var setReference = useEffectEvent(function(x, y) {
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference(createVirtualElement(domReference, {
            x,
            y,
            axis,
            dataRef,
            pointerType
        }));
    });
    var handleReferenceEnterOrMove = useEffectEvent(function(event) {
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    var openCheck = (0, _utils.isMouseLikePointerType)(pointerType) ? floating : open;
    var addListener = _react.useCallback(function() {
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        var win = (0, _dom.getWindow)(floating);
        function handleMouseMove(event) {
            var target = (0, _utils.getTarget)(event);
            if (!(0, _utils.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            var cleanup = function() {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    _react.useEffect(function() {
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    _react.useEffect(function() {
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    _react.useEffect(function() {
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    index(function() {
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    var reference = _react.useMemo(function() {
        var setPointerTypeRef = function setPointerTypeRef(_ref) {
            var pointerType = _ref.pointerType;
            setPointerType(pointerType);
        };
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
var bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
var captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
var normalizeProp = function(normalizable) {
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function useDismiss(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, elements = context.elements, dataRef = context.dataRef;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_escapeKey = props.escapeKey, escapeKey = _props_escapeKey === void 0 ? true : _props_escapeKey, tmp = props.outsidePress, unstable_outsidePress = tmp === void 0 ? true : tmp, _props_outsidePressEvent = props.outsidePressEvent, outsidePressEvent = _props_outsidePressEvent === void 0 ? "pointerdown" : _props_outsidePressEvent, _props_referencePress = props.referencePress, referencePress = _props_referencePress === void 0 ? false : _props_referencePress, _props_referencePressEvent = props.referencePressEvent, referencePressEvent = _props_referencePressEvent === void 0 ? "pointerdown" : _props_referencePressEvent, _props_ancestorScroll = props.ancestorScroll, ancestorScroll = _props_ancestorScroll === void 0 ? false : _props_ancestorScroll, bubbles = props.bubbles, capture = props.capture;
    var tree = useFloatingTree();
    var outsidePressFn = useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : function() {
        return false;
    });
    var outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    var insideReactTreeRef = _react.useRef(false);
    var endedOrStartedInsideRef = _react.useRef(false);
    var _normalizeProp = normalizeProp(bubbles), escapeKeyBubbles = _normalizeProp.escapeKey, outsidePressBubbles = _normalizeProp.outsidePress;
    var _normalizeProp1 = normalizeProp(capture), escapeKeyCapture = _normalizeProp1.escapeKey, outsidePressCapture = _normalizeProp1.outsidePress;
    var isComposingRef = _react.useRef(false);
    var closeOnEscapeKeyDown = useEffectEvent(function(event) {
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        var nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        var children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                var shouldDismiss = true;
                children.forEach(function(child) {
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, _utils.isReactEvent)(event) ? event.nativeEvent : event, "escape-key");
    });
    var closeOnEscapeKeyDownCapture = useEffectEvent(function(event) {
        var _getTarget2;
        var callback = function() {
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, _utils.getTarget)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, _utils.getTarget)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    var closeOnPressOutside = useEffectEvent(function(event) {
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        var endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        var target = (0, _utils.getTarget)(event);
        var inertSelector = "[" + createAttribute("inert") + "]";
        var markers = (0, _utils.getDocument)(elements.floating).querySelectorAll(inertSelector);
        var targetRootAncestor = (0, _dom.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, _dom.isLastTraversableNode)(targetRootAncestor)){
            var nextParent = (0, _dom.getParentNode)(targetRootAncestor);
            if ((0, _dom.isLastTraversableNode)(nextParent) || !(0, _dom.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, _dom.isElement)(target) && !(0, _utils.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, _utils.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every(function(marker) {
            return !(0, _utils.contains)(targetRootAncestor, marker);
        })) return;
        // Check if the click occurred on the scrollbar
        if ((0, _dom.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            var canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            var canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            var xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                var isRTL = (0, _dom.getComputedStyle)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        var nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        var targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(function(node) {
            var _node$context;
            return (0, _utils.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, _utils.isEventTargetWithin)(event, elements.floating) || (0, _utils.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        var children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            var shouldDismiss = true;
            children.forEach(function(child) {
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    var closeOnPressOutsideCapture = useEffectEvent(function(event) {
        var _getTarget4;
        var callback = function() {
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, _utils.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, _utils.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    _react.useEffect(function() {
        var onScroll = function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        };
        var handleCompositionStart = function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        };
        var handleCompositionEnd = function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(function() {
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, _dom.isWebKit)() ? 5 : 0);
        };
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        var compositionTimeout = -1;
        var doc = (0, _utils.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        var ancestors = [];
        if (ancestorScroll) {
            if ((0, _dom.isElement)(elements.domReference)) ancestors = (0, _reactDom1.getOverflowAncestors)(elements.domReference);
            if ((0, _dom.isElement)(elements.floating)) ancestors = ancestors.concat((0, _reactDom1.getOverflowAncestors)(elements.floating));
            if (!(0, _dom.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, _reactDom1.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter(function(ancestor) {
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach(function(ancestor) {
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return function() {
            if (escapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach(function(ancestor) {
                ancestor.removeEventListener("scroll", onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    _react.useEffect(function() {
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    var reference = _react.useMemo(function() {
        return {
            onKeyDown: closeOnEscapeKeyDown,
            [bubbleHandlerKeys[referencePressEvent]]: function(event) {
                if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
            }
        };
    }, [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    var floating = _react.useMemo(function() {
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [captureHandlerKeys[outsidePressEvent]]: function() {
                insideReactTreeRef.current = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference,
            floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
function useFloatingRootContext(options) {
    var _options_open = options.open, open = _options_open === void 0 ? false : _options_open, onOpenChangeProp = options.onOpenChange, elementsProp = options.elements;
    var floatingId = useId();
    var dataRef = _react.useRef({});
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return createPubSub();
    }), 1), events = _React_useState[0];
    var nested = useFloatingParentNodeId() != null;
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(elementsProp.reference), 2), positionReference = _React_useState1[0], setPositionReference = _React_useState1[1];
    var onOpenChange = useEffectEvent(function(open, event, reason) {
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open,
            event,
            reason,
            nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    var refs = _react.useMemo(function() {
        return {
            setPositionReference
        };
    }, []);
    var elements = _react.useMemo(function() {
        return {
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        };
    }, [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return _react.useMemo(function() {
        return {
            dataRef,
            open,
            onOpenChange,
            elements,
            events,
            floatingId,
            refs
        };
    }, [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    var nodeId = options.nodeId;
    var internalRootContext = useFloatingRootContext((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        elements: (0, _objectSpread._)({
            reference: null,
            floating: null
        }, options.elements)
    }));
    var rootContext = options.rootContext || internalRootContext;
    var computedElements = rootContext.elements;
    var _React_useState = (0, _slicedToArray._)(_react.useState(null), 2), _domReference = _React_useState[0], setDomReference = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(null), 2), positionReference = _React_useState1[0], _setPositionReference = _React_useState1[1];
    var optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    var domReference = optionDomReference || _domReference;
    var domReferenceRef = _react.useRef(null);
    var tree = useFloatingTree();
    index(function() {
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    var position = (0, _reactDom1.useFloating)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        elements: (0, _objectSpread._)({}, computedElements, positionReference && {
            reference: positionReference
        })
    }));
    var setPositionReference = _react.useCallback(function(node) {
        var computedPositionReference = (0, _dom.isElement)(node) ? {
            getBoundingClientRect: function() {
                return node.getBoundingClientRect();
            },
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    var setReference = _react.useCallback(function(node) {
        if ((0, _dom.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, _dom.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, _dom.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    var refs = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position.refs), {
            setReference,
            setPositionReference,
            domReference: domReferenceRef
        });
    }, [
        position.refs,
        setReference,
        setPositionReference
    ]);
    var elements = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position.elements), {
            domReference: domReference
        });
    }, [
        position.elements,
        domReference
    ]);
    var context = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position, rootContext), {
            refs,
            elements,
            nodeId
        });
    }, [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    index(function() {
        rootContext.dataRef.current.floatingContext = context;
        var node = tree == null ? void 0 : tree.nodesRef.current.find(function(node) {
            return node.id === nodeId;
        });
        if (node) node.context = context;
    });
    return _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
            context,
            refs,
            elements
        });
    }, [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function useFocus(context, props) {
    if (props === void 0) props = {};
    var open = context.open, onOpenChange = context.onOpenChange, events = context.events, dataRef = context.dataRef, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_visibleOnly = props.visibleOnly, visibleOnly = _props_visibleOnly === void 0 ? true : _props_visibleOnly;
    var blockFocusRef = _react.useRef(false);
    var timeoutRef = _react.useRef();
    var keyboardModalityRef = _react.useRef(true);
    _react.useEffect(function() {
        var onBlur = // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, _dom.isHTMLElement)(elements.domReference) && elements.domReference === (0, _utils.activeElement)((0, _utils.getDocument)(elements.domReference))) blockFocusRef.current = true;
        };
        var onKeyDown = function onKeyDown() {
            keyboardModalityRef.current = true;
        };
        if (!enabled) return;
        var win = (0, _dom.getWindow)(elements.domReference);
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return function() {
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    _react.useEffect(function() {
        var onOpenChange = function onOpenChange(_ref) {
            var reason = _ref.reason;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        };
        if (!enabled) return;
        events.on("openchange", onOpenChange);
        return function() {
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    _react.useEffect(function() {
        return function() {
            clearTimeout(timeoutRef.current);
        };
    }, []);
    var reference = _react.useMemo(function() {
        return {
            onPointerDown (event) {
                if ((0, _utils.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                var target = (0, _utils.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, _dom.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, _utils.isSafari)() && (0, _utils.isMac)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, _utils.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                var relatedTarget = event.relatedTarget;
                var nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                var movedToFocusGuard = (0, _dom.isElement)(relatedTarget) && relatedTarget.hasAttribute(createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(function() {
                    var _dataRef$current$floa;
                    var activeEl = (0, _utils.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, _utils.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, _utils.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        };
    }, [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference
        } : {};
    }, [
        enabled,
        reference
    ]);
}
var ACTIVE_KEY = "active";
var SELECTED_KEY = "selected";
function mergeProps(userProps, propsList, elementKey) {
    var map = new Map();
    var isItem = elementKey === "item";
    var domUserProps = userProps;
    if (isItem && userProps) {
        var _ = userProps[ACTIVE_KEY], __ = userProps[SELECTED_KEY], validProps = (0, _objectWithoutProperties._)(userProps, [
            ACTIVE_KEY,
            SELECTED_KEY
        ].map((0, _toPropertyKey._)));
        domUserProps = validProps;
    }
    return (0, _objectSpread._)({}, elementKey === "floating" && {
        tabIndex: -1,
        [FOCUSABLE_ATTRIBUTE]: ""
    }, domUserProps, propsList.map(function(value) {
        var propsOrGetProps = value ? value[elementKey] : null;
        if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
        return propsOrGetProps;
    }).concat(userProps).reduce(function(acc, props) {
        if (!props) return acc;
        Object.entries(props).forEach(function(_ref) {
            var _$_ref = (0, _slicedToArray._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            if (isItem && [
                ACTIVE_KEY,
                SELECTED_KEY
            ].includes(key)) return;
            if (key.indexOf("on") === 0) {
                if (!map.has(key)) map.set(key, []);
                if (typeof value === "function") {
                    var _map$get;
                    (_map$get = map.get(key)) == null || _map$get.push(value);
                    acc[key] = function() {
                        var _map$get2;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(function(fn) {
                            return fn.apply(void 0, (0, _toConsumableArray._)(args));
                        }).find(function(val) {
                            return val !== undefined;
                        });
                    };
                }
            } else acc[key] = value;
        });
        return acc;
    }, {}));
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function useInteractions(propsList) {
    if (propsList === void 0) propsList = [];
    var referenceDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.reference;
    });
    var floatingDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.floating;
    });
    var itemDeps = propsList.map(function(key) {
        return key == null ? void 0 : key.item;
    });
    var getReferenceProps = _react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "reference");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    var getFloatingProps = _react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "floating");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    var getItemProps = _react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "item");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return _react.useMemo(function() {
        return {
            getReferenceProps,
            getFloatingProps,
            getItemProps
        };
    }, [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
var isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function isMainOrientationKey(key, orientation) {
    var vertical = key === ARROW_UP || key === ARROW_DOWN;
    var horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
    var vertical = key === ARROW_DOWN;
    var horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
    var vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    var horizontal = key === ARROW_DOWN;
    return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
    var vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
    var horizontal = key === ARROW_UP;
    return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function useListNavigation(context, props) {
    var open = context.open, onOpenChange = context.onOpenChange, elements = context.elements;
    var listRef = props.listRef, activeIndex = props.activeIndex, tmp = props.onNavigate, unstable_onNavigate = tmp === void 0 ? function() {} : tmp, _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_selectedIndex = props.selectedIndex, selectedIndex = _props_selectedIndex === void 0 ? null : _props_selectedIndex, _props_allowEscape = props.allowEscape, allowEscape = _props_allowEscape === void 0 ? false : _props_allowEscape, _props_loop = props.loop, loop = _props_loop === void 0 ? false : _props_loop, _props_nested = props.nested, nested = _props_nested === void 0 ? false : _props_nested, _props_rtl = props.rtl, rtl = _props_rtl === void 0 ? false : _props_rtl, _props_virtual = props.virtual, virtual = _props_virtual === void 0 ? false : _props_virtual, _props_focusItemOnOpen = props.focusItemOnOpen, focusItemOnOpen = _props_focusItemOnOpen === void 0 ? "auto" : _props_focusItemOnOpen, _props_focusItemOnHover = props.focusItemOnHover, focusItemOnHover = _props_focusItemOnHover === void 0 ? true : _props_focusItemOnHover, _props_openOnArrowKeyDown = props.openOnArrowKeyDown, openOnArrowKeyDown = _props_openOnArrowKeyDown === void 0 ? true : _props_openOnArrowKeyDown, disabledIndices = props.disabledIndices, _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? "vertical" : _props_orientation, _props_cols = props.cols, cols = _props_cols === void 0 ? 1 : _props_cols, _props_scrollItemIntoView = props.scrollItemIntoView, scrollItemIntoView = _props_scrollItemIntoView === void 0 ? true : _props_scrollItemIntoView, virtualItemRef = props.virtualItemRef, itemSizes = props.itemSizes, _props_dense = props.dense, dense = _props_dense === void 0 ? false : _props_dense;
    var floatingFocusElement = getFloatingFocusElement(elements.floating);
    var floatingFocusElementRef = useLatestRef(floatingFocusElement);
    var parentId = useFloatingParentNodeId();
    var tree = useFloatingTree();
    var onNavigate = useEffectEvent(unstable_onNavigate);
    var typeableComboboxReference = (0, _utils.isTypeableCombobox)(elements.domReference);
    var focusItemOnOpenRef = _react.useRef(focusItemOnOpen);
    var indexRef = _react.useRef(selectedIndex != null ? selectedIndex : -1);
    var keyRef = _react.useRef(null);
    var isPointerModalityRef = _react.useRef(true);
    var previousOnNavigateRef = _react.useRef(onNavigate);
    var previousMountedRef = _react.useRef(!!elements.floating);
    var previousOpenRef = _react.useRef(open);
    var forceSyncFocus = _react.useRef(false);
    var forceScrollIntoViewRef = _react.useRef(false);
    var disabledIndicesRef = useLatestRef(disabledIndices);
    var latestOpenRef = useLatestRef(open);
    var scrollItemIntoViewRef = useLatestRef(scrollItemIntoView);
    var selectedIndexRef = useLatestRef(selectedIndex);
    var _React_useState = (0, _slicedToArray._)(_react.useState(), 2), activeId = _React_useState[0], setActiveId = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(), 2), virtualId = _React_useState1[0], setVirtualId = _React_useState1[1];
    var focusItem = useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, _utils.isMac)() && (0, _utils.isSafari)() ? isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        var initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(function() {
            var waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            var scrollIntoViewOptions = scrollItemIntoViewRef.current;
            var shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    index(function() {
        document.createElement("div").focus({
            get preventScroll () {
                isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    index(function() {
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    index(function() {
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    var runs = 0;
                    var waitForListPopulated = function() {
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                var scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    index(function() {
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        var nodes = tree.nodesRef.current;
        var parent = (_nodes$find = nodes.find(function(node) {
            return node.id === parentId;
        })) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        var activeEl = (0, _utils.activeElement)((0, _utils.getDocument)(elements.floating));
        var treeContainsActiveEl = nodes.some(function(node) {
            return node.context && (0, _utils.contains)(node.context.elements.floating, activeEl);
        });
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    index(function() {
        var handleVirtualFocus = function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        };
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        tree.events.on("virtualfocus", handleVirtualFocus);
        return function() {
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    index(function() {
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    index(function() {
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    index(function() {
        previousOpenRef.current = open;
    }, [
        open
    ]);
    var hasActiveIndex = activeIndex != null;
    var item = _react.useMemo(function() {
        var syncCurrentTarget = function syncCurrentTarget(currentTarget) {
            if (!open) return;
            var index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        };
        var _$props = (0, _objectSpread._)({
            onFocus (_ref) {
                var currentTarget = _ref.currentTarget;
                syncCurrentTarget(currentTarget);
            },
            onClick: function(_ref2) {
                var currentTarget = _ref2.currentTarget;
                return currentTarget.focus({
                    preventScroll: true
                });
            }
        }, focusItemOnHover && {
            onMouseMove (_ref3) {
                var currentTarget = _ref3.currentTarget;
                syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                var pointerType = _ref4.pointerType;
                if (!isPointerModalityRef.current || pointerType === "touch") return;
                indexRef.current = -1;
                focusItem(listRef, indexRef);
                onNavigate(null);
                if (!virtual) enqueueFocus(floatingFocusElementRef.current, {
                    preventScroll: true
                });
            }
        });
        return _$props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    var commonOnKeyDown = useEffectEvent(function(event) {
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, _utils.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, _dom.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit("virtualfocus", elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        var currentIndex = indexRef.current;
        var minIndex = getMinIndex(listRef, disabledIndices);
        var maxIndex = getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === "Home") {
                (0, _utils.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === "End") {
                (0, _utils.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            var sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, function() {
                return {
                    width: 1,
                    height: 1
                };
            });
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            var cellMap = buildCellMap(sizes, cols, dense);
            var minGridIndex = cellMap.findIndex(function(index) {
                return index != null && !isDisabled(listRef.current, index, disabledIndices);
            });
            // last enabled index
            var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                return index != null && !isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex;
            }, -1);
            var index = cellMap[getGridNavigatedIndex({
                current: cellMap.map(function(itemIndex) {
                    return itemIndex != null ? listRef.current[itemIndex] : null;
                })
            }, {
                event,
                orientation,
                loop,
                rtl,
                cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: getCellIndices((0, _toConsumableArray._)(disabledIndices || listRef.current.map(function(_, index) {
                    return isDisabled(listRef.current, index) ? index : undefined;
                })).concat([
                    undefined
                ]), cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === ARROW_DOWN ? "bl" : event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT) ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === "both") return;
        }
        if (isMainOrientationKey(event.key, orientation)) {
            (0, _utils.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, _utils.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices
            });
            else indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices
            }));
            if (isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    var ariaActiveDescendantProp = _react.useMemo(function() {
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    var floating = _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            "aria-orientation": orientation === "both" ? undefined : orientation
        }, !(0, _utils.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp), {
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        });
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    var reference = _react.useMemo(function() {
        var checkVirtualMouse = function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, _utils.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        };
        var checkVirtualPointer = function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, _utils.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        };
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaActiveDescendantProp), {
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                var isArrowKey = event.key.startsWith("Arrow");
                var isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event.key);
                var isMoveKey = isArrowKey || isHomeOrEndKey;
                var isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
                var isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
                var isMainKey = isMainOrientationKey(event.key, orientation);
                var isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    var rootNode = tree == null ? void 0 : tree.nodesRef.current.find(function(node) {
                        return node.parentId == null;
                    });
                    var deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        var eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            var isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            var dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find(function(item) {
                                return (item == null ? void 0 : item.id) === activeId;
                            }) : null;
                            if (dispatchItem) {
                                (0, _utils.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, _utils.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, _utils.stopEvent)(event);
                        if (open) {
                            indexRef.current = getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, _utils.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        });
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference,
            floating,
            item
        } : {};
    }, [
        enabled,
        reference,
        floating,
        item
    ]);
}
var componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function useRole(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    var open = context.open, floatingId = context.floatingId;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_role = props.role, role = _props_role === void 0 ? "dialog" : _props_role;
    var ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    var referenceId = useId();
    var parentId = useFloatingParentNodeId();
    var isNested = parentId != null;
    var reference = _react.useMemo(function() {
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return (0, _objectSpread._)({
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined
        }, ariaRole === "listbox" && {
            role: "combobox"
        }, ariaRole === "menu" && {
            id: referenceId
        }, ariaRole === "menu" && isNested && {
            role: "menuitem"
        }, role === "select" && {
            "aria-autocomplete": "none"
        }, role === "combobox" && {
            "aria-autocomplete": "list"
        });
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    var floating = _react.useMemo(function() {
        var floatingProps = (0, _objectSpread._)({
            id: floatingId
        }, ariaRole && {
            role: ariaRole
        });
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return (0, _objectSpread._)({}, floatingProps, ariaRole === "menu" && {
            "aria-labelledby": referenceId
        });
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    var item = _react.useCallback(function(_ref) {
        var active = _ref.active, selected = _ref.selected;
        var commonProps = (0, _objectSpread._)({
            role: "option"
        }, active && {
            id: floatingId + "-option"
        });
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
                    "aria-selected": active && selected
                });
            case "combobox":
                return (0, _objectSpread._)({}, commonProps, active && {
                    "aria-selected": true
                });
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference,
            floating,
            item
        } : {};
    }, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
var camelCaseToKebabCase = function(str) {
    return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function($, ofs) {
        return (ofs ? "-" : "") + $.toLowerCase();
    });
};
function execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
    var _React_useState = (0, _slicedToArray._)(_react.useState(open), 2), isMounted = _React_useState[0], setIsMounted = _React_useState[1];
    if (open && !isMounted) setIsMounted(true);
    _react.useEffect(function() {
        if (!open && isMounted) {
            var timeout = setTimeout(function() {
                return setIsMounted(false);
            }, durationMs);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function useTransitionStatus(context, props) {
    if (props === void 0) props = {};
    var open = context.open, floating = context.elements.floating;
    var _props_duration = props.duration, duration = _props_duration === void 0 ? 250 : _props_duration;
    var isNumberDuration = typeof duration === "number";
    var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    var _React_useState = (0, _slicedToArray._)(_react.useState("unmounted"), 2), status = _React_useState[0], setStatus = _React_useState[1];
    var isMounted = useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    index(function() {
        if (!floating) return;
        if (open) {
            setStatus("initial");
            var frame = requestAnimationFrame(function() {
                setStatus("open");
            });
            return function() {
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted,
        status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function useTransitionStyles(context, props) {
    if (props === void 0) props = {};
    var tmp = props.initial, unstable_initial = tmp === void 0 ? {
        opacity: 0
    } : tmp, unstable_open = props.open, unstable_close = props.close, unstable_common = props.common, _props_duration = props.duration, duration = _props_duration === void 0 ? 250 : _props_duration;
    var placement = context.placement;
    var side = placement.split("-")[0];
    var fnArgs = _react.useMemo(function() {
        return {
            side,
            placement
        };
    }, [
        side,
        placement
    ]);
    var isNumberDuration = typeof duration === "number";
    var openDuration = (isNumberDuration ? duration : duration.open) || 0;
    var closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return (0, _objectSpread._)({}, execWithArgsOrReturn(unstable_common, fnArgs), execWithArgsOrReturn(unstable_initial, fnArgs));
    }), 2), styles = _React_useState[0], setStyles = _React_useState[1];
    var _useTransitionStatus = useTransitionStatus(context, {
        duration
    }), isMounted = _useTransitionStatus.isMounted, status = _useTransitionStatus.status;
    var initialRef = useLatestRef(unstable_initial);
    var openRef = useLatestRef(unstable_open);
    var closeRef = useLatestRef(unstable_close);
    var commonRef = useLatestRef(unstable_common);
    index(function() {
        var initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
        var closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
        var commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
        var openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce(function(acc, key) {
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles(function(styles) {
            return (0, _objectSpread._)({
                transitionProperty: styles.transitionProperty
            }, commonStyles, initialStyles);
        });
        if (status === "open") setStyles((0, _objectSpread._)({
            transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms"
        }, commonStyles, openStyles));
        if (status === "close") {
            var styles = closeStyles || initialStyles;
            setStyles((0, _objectSpread._)({
                transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms"
            }, commonStyles, styles));
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted,
        styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function useTypeahead(context, props) {
    var _ref;
    var open = context.open, dataRef = context.dataRef;
    var listRef = props.listRef, activeIndex = props.activeIndex, unstable_onMatch = props.onMatch, unstable_onTypingChange = props.onTypingChange, _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, _props_findMatch = props.findMatch, findMatch = _props_findMatch === void 0 ? null : _props_findMatch, _props_resetMs = props.resetMs, resetMs = _props_resetMs === void 0 ? 750 : _props_resetMs, _props_ignoreKeys = props.ignoreKeys, ignoreKeys = _props_ignoreKeys === void 0 ? [] : _props_ignoreKeys, _props_selectedIndex = props.selectedIndex, selectedIndex = _props_selectedIndex === void 0 ? null : _props_selectedIndex;
    var timeoutIdRef = _react.useRef();
    var stringRef = _react.useRef("");
    var prevIndexRef = _react.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    var matchIndexRef = _react.useRef(null);
    var onMatch = useEffectEvent(unstable_onMatch);
    var onTypingChange = useEffectEvent(unstable_onTypingChange);
    var findMatchRef = useLatestRef(findMatch);
    var ignoreKeysRef = useLatestRef(ignoreKeys);
    index(function() {
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    index(function() {
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    var setTypingChange = useEffectEvent(function(value) {
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    var onKeyDown = useEffectEvent(function(event) {
        var getMatchingIndex = function getMatchingIndex(list, orderedList, string) {
            var str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find(function(text) {
                return (text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0;
            });
            return str ? list.indexOf(str) : -1;
        };
        var listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, _utils.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, _utils.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        var allowRapidSuccessionOfFirstLetter = listContent.every(function(text) {
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(function() {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        var prevIndex = prevIndexRef.current;
        var index = getMatchingIndex(listContent, (0, _toConsumableArray._)(listContent.slice((prevIndex || 0) + 1)).concat((0, _toConsumableArray._)(listContent.slice(0, (prevIndex || 0) + 1))), stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    var reference = _react.useMemo(function() {
        return {
            onKeyDown
        };
    }, [
        onKeyDown
    ]);
    var floating = _react.useMemo(function() {
        return {
            onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            reference,
            floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
function getArgsWithCustomFloatingHeight(state, height) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        rects: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.rects), {
            floating: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.rects.floating), {
                height
            })
        })
    });
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ var inner = function(props) {
    return {
        name: "inner",
        options: props,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var _evaluate, listRef, overflowRef, onFallbackChange, tmp, innerOffset, _evaluate_index, index, _evaluate_minItemsVisible, minItemsVisible, _evaluate_referenceOverflowThreshold, referenceOverflowThreshold, scrollRef, detectOverflowOptions, rects, floating, item, scrollEl, clientTop, floatingIsBordered, scrollElIsBordered, floatingIsScrollEl, nextArgs, _tmp, overflow, refOverflow, diffY, nextY, isScrollable, rounder, maxHeight, shouldFallback;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _evaluate = (0, _utils1.evaluate)(props, state), listRef = _evaluate.listRef, overflowRef = _evaluate.overflowRef, onFallbackChange = _evaluate.onFallbackChange, tmp = _evaluate.offset, innerOffset = tmp === void 0 ? 0 : tmp, _evaluate_index = _evaluate.index, index = _evaluate_index === void 0 ? 0 : _evaluate_index, _evaluate_minItemsVisible = _evaluate.minItemsVisible, minItemsVisible = _evaluate_minItemsVisible === void 0 ? 4 : _evaluate_minItemsVisible, _evaluate_referenceOverflowThreshold = _evaluate.referenceOverflowThreshold, referenceOverflowThreshold = _evaluate_referenceOverflowThreshold === void 0 ? 0 : _evaluate_referenceOverflowThreshold, scrollRef = _evaluate.scrollRef, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "listRef",
                                "overflowRef",
                                "onFallbackChange",
                                "offset",
                                "index",
                                "minItemsVisible",
                                "referenceOverflowThreshold",
                                "scrollRef"
                            ]);
                            rects = state.rects, floating = state.elements.floating;
                            item = listRef.current[index];
                            scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
                            // Valid combinations:
                            // 1. Floating element is the scrollRef and has a border (default)
                            // 2. Floating element is not the scrollRef, floating element has a border
                            // 3. Floating element is not the scrollRef, scrollRef has a border
                            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
                            // allowed as VoiceOver doesn't work.
                            clientTop = floating.clientTop || scrollEl.clientTop;
                            floatingIsBordered = floating.clientTop !== 0;
                            scrollElIsBordered = scrollEl.clientTop !== 0;
                            floatingIsScrollEl = floating === scrollEl;
                            if (!item) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                {},
                                state
                            ];
                            return [
                                4,
                                (0, _reactDom1.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
                            ];
                        case 1:
                            nextArgs = (0, _objectSpread._).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            return [
                                4,
                                (0, _reactDom1.detectOverflow)(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            return [
                                4,
                                (0, _reactDom1.detectOverflow)(nextArgs, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 3:
                            refOverflow = _state.sent();
                            diffY = (0, _utils1.max)(0, overflow.top);
                            nextY = nextArgs.y + diffY;
                            isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
                            rounder = isScrollable ? function(v) {
                                return v;
                            } : (0, _utils1.round);
                            maxHeight = rounder((0, _utils1.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, _utils1.max)(0, overflow.bottom)));
                            scrollEl.style.maxHeight = maxHeight + "px";
                            scrollEl.scrollTop = diffY;
                            // There is not enough space, fallback to standard anchored positioning
                            if (onFallbackChange) {
                                shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, _utils1.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                                _reactDom.flushSync(function() {
                                    return onFallbackChange(shouldFallback);
                                });
                            }
                            if (!overflowRef) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                (0, _reactDom1.detectOverflow)(getArgsWithCustomFloatingHeight((0, _objectSpreadProps._)((0, _objectSpread._)({}, nextArgs), {
                                    y: nextY
                                }), scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions)
                            ];
                        case 4:
                            overflowRef.current = _state.sent();
                            _state.label = 5;
                        case 5:
                            return [
                                2,
                                {
                                    y: nextY
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function useInnerOffset(context, props) {
    var open = context.open, elements = context.elements;
    var _props_enabled = props.enabled, enabled = _props_enabled === void 0 ? true : _props_enabled, overflowRef = props.overflowRef, scrollRef = props.scrollRef, unstable_onChange = props.onChange;
    var onChange = useEffectEvent(unstable_onChange);
    var controlledScrollingRef = _react.useRef(false);
    var prevScrollTopRef = _react.useRef(null);
    var initialOverflowRef = _react.useRef(null);
    _react.useEffect(function() {
        var onWheel = function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            var dY = e.deltaY;
            var isAtTop = overflowRef.current.top >= -0.5;
            var isAtBottom = overflowRef.current.bottom >= -0.5;
            var remainingScroll = el.scrollHeight - el.clientHeight;
            var sign = dY < 0 ? -1 : 1;
            var method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                _reactDom.flushSync(function() {
                    onChange(function(d) {
                        return d + Math[method](dY, remainingScroll * sign);
                    });
                });
            } else if (/firefox/i.test((0, _utils.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        };
        if (!enabled) return;
        var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(function() {
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = (0, _objectSpread._)({}, overflowRef.current);
            });
            return function() {
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    var floating = _react.useMemo(function() {
        return {
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                var el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    var scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) _reactDom.flushSync(function() {
                        return onChange(function(d) {
                            return d + scrollDiff;
                        });
                    });
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(function() {
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        };
    }, [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return _react.useMemo(function() {
        return enabled ? {
            floating
        } : {};
    }, [
        enabled,
        floating
    ]);
}
function isPointInPolygon(point, polygon) {
    var _point = (0, _slicedToArray._)(point, 2), x = _point[0], y = _point[1];
    var isInside = false;
    var length = polygon.length;
    for(var i = 0, j = length - 1; i < length; j = i++){
        var _ref = (0, _slicedToArray._)(polygon[i] || [
            0,
            0
        ], 2), xi = _ref[0], yi = _ref[1];
        var _ref1 = (0, _slicedToArray._)(polygon[j] || [
            0,
            0
        ], 2), xj = _ref1[0], yj = _ref1[1];
        var intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function safePolygon(options) {
    if (options === void 0) options = {};
    var _options_buffer = options.buffer, buffer = _options_buffer === void 0 ? 0.5 : _options_buffer, _options_blockPointerEvents = options.blockPointerEvents, blockPointerEvents = _options_blockPointerEvents === void 0 ? false : _options_blockPointerEvents, _options_requireIntent = options.requireIntent, requireIntent = _options_requireIntent === void 0 ? true : _options_requireIntent;
    var timeoutId;
    var hasLanded = false;
    var lastX = null;
    var lastY = null;
    var lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        var currentTime = performance.now();
        var elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        var deltaX = x - lastX;
        var deltaY = y - lastY;
        var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        var speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    var fn = function(_ref) {
        var x = _ref.x, y = _ref.y, placement = _ref.placement, elements = _ref.elements, onClose = _ref.onClose, nodeId = _ref.nodeId, tree = _ref.tree;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            var clientX = event.clientX, clientY = event.clientY;
            var clientPoint = [
                clientX,
                clientY
            ];
            var target = (0, _utils.getTarget)(event);
            var isLeave = event.type === "mouseleave";
            var isOverFloatingEl = (0, _utils.contains)(elements.floating, target);
            var isOverReferenceEl = (0, _utils.contains)(elements.domReference, target);
            var refRect = elements.domReference.getBoundingClientRect();
            var rect = elements.floating.getBoundingClientRect();
            var side = placement.split("-")[0];
            var cursorLeaveFromRight = x > rect.right - rect.width / 2;
            var cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            var isOverReferenceRect = isInside(clientPoint, refRect);
            var isFloatingWider = rect.width > refRect.width;
            var isFloatingTaller = rect.height > refRect.height;
            var left = (isFloatingWider ? refRect : rect).left;
            var right = (isFloatingWider ? refRect : rect).right;
            var top = (isFloatingTaller ? refRect : rect).top;
            var bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, _dom.isElement)(event.relatedTarget) && (0, _utils.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && getChildren(tree.nodesRef.current, nodeId).some(function(_ref2) {
                var context = _ref2.context;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            var rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                var _$_ref3 = (0, _slicedToArray._)(_ref3, 2), x = _$_ref3[0], y = _$_ref3[1];
                switch(side){
                    case "top":
                        {
                            var cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            var cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            var commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo
                            ].concat((0, _toConsumableArray._)(commonPoints));
                        }
                    case "bottom":
                        {
                            var cursorPointOne1 = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            var cursorPointTwo1 = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            var commonPoints1 = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne1,
                                cursorPointTwo1
                            ].concat((0, _toConsumableArray._)(commonPoints1));
                        }
                    case "left":
                        {
                            var cursorPointOne2 = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var cursorPointTwo2 = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var commonPoints2 = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return (0, _toConsumableArray._)(commonPoints2).concat([
                                cursorPointOne2,
                                cursorPointTwo2
                            ]);
                        }
                    case "right":
                        {
                            var cursorPointOne3 = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var cursorPointTwo3 = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            var commonPoints3 = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne3,
                                cursorPointTwo3
                            ].concat((0, _toConsumableArray._)(commonPoints3));
                        }
                }
            }
            if (isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                var cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                var cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents
    };
    return fn;
}

},{"@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_to_property_key":"9PpA5","@swc/helpers/_/_ts_generator":"dn4mF","react":"9MtAM","@floating-ui/react/utils":"4vbXT","@floating-ui/utils":"ta1AP","@floating-ui/utils/dom":"54fku","tabbable":"go1Cm","react-dom":"5Yfvl","@floating-ui/react-dom":"i367d","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"9PpA5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_property_key;
});
var _toPrimitiveJs = require("./_to_primitive.js");
var _typeOfJs = require("./_type_of.js");
function _to_property_key(arg) {
    var key = (0, _toPrimitiveJs._)(arg, "string");
    return (0, _typeOfJs._)(key) === "symbol" ? key : String(key);
}

},{"./_to_primitive.js":"fwnCw","./_type_of.js":"Pf63v","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"fwnCw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_primitive;
});
var _typeOfJs = require("./_type_of.js");
function _to_primitive(input, hint) {
    if ((0, _typeOfJs._)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeOfJs._)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

},{"./_type_of.js":"Pf63v","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"4vbXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPEABLE_SELECTOR", function() {
    return TYPEABLE_SELECTOR;
});
parcelHelpers.export(exports, "activeElement", function() {
    return activeElement;
});
parcelHelpers.export(exports, "contains", function() {
    return contains;
});
parcelHelpers.export(exports, "getDocument", function() {
    return getDocument;
});
parcelHelpers.export(exports, "getPlatform", function() {
    return getPlatform;
});
parcelHelpers.export(exports, "getTarget", function() {
    return getTarget;
});
parcelHelpers.export(exports, "getUserAgent", function() {
    return getUserAgent;
});
parcelHelpers.export(exports, "isAndroid", function() {
    return isAndroid;
});
parcelHelpers.export(exports, "isEventTargetWithin", function() {
    return isEventTargetWithin;
});
parcelHelpers.export(exports, "isJSDOM", function() {
    return isJSDOM;
});
parcelHelpers.export(exports, "isMac", function() {
    return isMac;
});
parcelHelpers.export(exports, "isMouseLikePointerType", function() {
    return isMouseLikePointerType;
});
parcelHelpers.export(exports, "isReactEvent", function() {
    return isReactEvent;
});
parcelHelpers.export(exports, "isRootElement", function() {
    return isRootElement;
});
parcelHelpers.export(exports, "isSafari", function() {
    return isSafari;
});
parcelHelpers.export(exports, "isTypeableCombobox", function() {
    return isTypeableCombobox;
});
parcelHelpers.export(exports, "isTypeableElement", function() {
    return isTypeableElement;
});
parcelHelpers.export(exports, "isVirtualClick", function() {
    return isVirtualClick;
});
parcelHelpers.export(exports, "isVirtualPointerEvent", function() {
    return isVirtualPointerEvent;
});
parcelHelpers.export(exports, "stopEvent", function() {
    return stopEvent;
});
var _dom = require("@floating-ui/utils/dom");
function activeElement(doc) {
    var activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function contains(parent, child) {
    if (!parent || !child) return false;
    var rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, _dom.isShadowRoot)(rootNode)) {
        var next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function getPlatform() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function getUserAgent() {
    var uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map(function(_ref) {
        var brand = _ref.brand, version = _ref.version;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if (isAndroid() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
    if (isJSDOM()) return false;
    return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function isSafari() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function isAndroid() {
    var re = /android/i;
    return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
    return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
    return getUserAgent().includes("jsdom/");
}
function isMouseLikePointerType(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    var values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function isReactEvent(event) {
    return "nativeEvent" in event;
}
function isRootElement(element) {
    return element.matches("html,body");
}
function getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    var e = event;
    return e.target != null && node.contains(e.target);
}
function getTarget(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
var TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
    return (0, _dom.isHTMLElement)(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
function isTypeableCombobox(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && isTypeableElement(element);
}

},{"@floating-ui/utils/dom":"54fku","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"54fku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", function() {
    return getComputedStyle;
});
parcelHelpers.export(exports, "getContainingBlock", function() {
    return getContainingBlock;
});
parcelHelpers.export(exports, "getDocumentElement", function() {
    return getDocumentElement;
});
parcelHelpers.export(exports, "getFrameElement", function() {
    return getFrameElement;
});
parcelHelpers.export(exports, "getNearestOverflowAncestor", function() {
    return getNearestOverflowAncestor;
});
parcelHelpers.export(exports, "getNodeName", function() {
    return getNodeName;
});
parcelHelpers.export(exports, "getNodeScroll", function() {
    return getNodeScroll;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return getOverflowAncestors;
});
parcelHelpers.export(exports, "getParentNode", function() {
    return getParentNode;
});
parcelHelpers.export(exports, "getWindow", function() {
    return getWindow;
});
parcelHelpers.export(exports, "isContainingBlock", function() {
    return isContainingBlock;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
parcelHelpers.export(exports, "isLastTraversableNode", function() {
    return isLastTraversableNode;
});
parcelHelpers.export(exports, "isNode", function() {
    return isNode;
});
parcelHelpers.export(exports, "isOverflowElement", function() {
    return isOverflowElement;
});
parcelHelpers.export(exports, "isShadowRoot", function() {
    return isShadowRoot;
});
parcelHelpers.export(exports, "isTableElement", function() {
    return isTableElement;
});
parcelHelpers.export(exports, "isTopLayer", function() {
    return isTopLayer;
});
parcelHelpers.export(exports, "isWebKit", function() {
    return isWebKit;
});
function hasWindow() {
    return typeof window !== "undefined";
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY, display = _getComputedStyle.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes(getNodeName(element));
}
function isTopLayer(element) {
    return [
        ":popover-open",
        ":modal"
    ].some(function(selector) {
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function isContainingBlock(elementOrCss) {
    var webkit = isWebKit();
    var css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective"
    ].some(function(value) {
        return css[value] ? css[value] !== "none" : false;
    }) || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "translate",
        "scale",
        "rotate",
        "perspective",
        "filter"
    ].some(function(value) {
        return (css.willChange || "").includes(value);
    }) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some(function(value) {
        return (css.contain || "").includes(value);
    });
}
function getContainingBlock(element) {
    var currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    var parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = getNearestOverflowAncestor(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = getWindow(scrollableAncestor);
    if (isBody) {
        var frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"ta1AP":[function(require,module,exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", function() {
    return alignments;
});
parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
parcelHelpers.export(exports, "createCoords", function() {
    return createCoords;
});
parcelHelpers.export(exports, "evaluate", function() {
    return evaluate;
});
parcelHelpers.export(exports, "expandPaddingObject", function() {
    return expandPaddingObject;
});
parcelHelpers.export(exports, "floor", function() {
    return floor;
});
parcelHelpers.export(exports, "getAlignment", function() {
    return getAlignment;
});
parcelHelpers.export(exports, "getAlignmentAxis", function() {
    return getAlignmentAxis;
});
parcelHelpers.export(exports, "getAlignmentSides", function() {
    return getAlignmentSides;
});
parcelHelpers.export(exports, "getAxisLength", function() {
    return getAxisLength;
});
parcelHelpers.export(exports, "getExpandedPlacements", function() {
    return getExpandedPlacements;
});
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", function() {
    return getOppositeAlignmentPlacement;
});
parcelHelpers.export(exports, "getOppositeAxis", function() {
    return getOppositeAxis;
});
parcelHelpers.export(exports, "getOppositeAxisPlacements", function() {
    return getOppositeAxisPlacements;
});
parcelHelpers.export(exports, "getOppositePlacement", function() {
    return getOppositePlacement;
});
parcelHelpers.export(exports, "getPaddingObject", function() {
    return getPaddingObject;
});
parcelHelpers.export(exports, "getSide", function() {
    return getSide;
});
parcelHelpers.export(exports, "getSideAxis", function() {
    return getSideAxis;
});
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "rectToClientRect", function() {
    return rectToClientRect;
});
parcelHelpers.export(exports, "round", function() {
    return round;
});
parcelHelpers.export(exports, "sides", function() {
    return sides;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var sides = [
    "top",
    "right",
    "bottom",
    "left"
];
var alignments = [
    "start",
    "end"
];
var placements = /*#__PURE__*/ sides.reduce(function(acc, side) {
    return acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]);
}, []);
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = function(v) {
    return {
        x: v,
        y: v
    };
};
var oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
var oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = getAlignment(placement);
    var alignmentAxis = getAlignmentAxis(placement);
    var length = getAxisLength(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    var oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, function(alignment) {
        return oppositeAlignmentMap[alignment];
    });
}
function getSideList(side, isStart, rtl) {
    var lr = [
        "left",
        "right"
    ];
    var rl = [
        "right",
        "left"
    ];
    var tb = [
        "top",
        "bottom"
    ];
    var bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    var alignment = getAlignment(placement);
    var list = getSideList(getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(side) {
        return oppositeSideMap[side];
    });
}
function expandPaddingObject(padding) {
    return (0, _objectSpread._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@swc/helpers/_/_object_spread":"lezcN","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"go1Cm":[function(require,module,exports) {
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusable", function() {
    return focusable;
});
parcelHelpers.export(exports, "getTabIndex", function() {
    return getTabIndex;
});
parcelHelpers.export(exports, "isFocusable", function() {
    return isFocusable;
});
parcelHelpers.export(exports, "isTabbable", function() {
    return isTabbable;
});
parcelHelpers.export(exports, "tabbable", function() {
    return tabbable;
});
var candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var candidateSelector = /* #__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if (isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var getTabIndex = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) return 0;
    return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"i367d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoUpdate", function() {
    return 0, _dom.autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return 0, _dom.computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _dom.detectOverflow;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _dom.getOverflowAncestors;
});
parcelHelpers.export(exports, "platform", function() {
    return 0, _dom.platform;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
parcelHelpers.export(exports, "useFloating", function() {
    return useFloating;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _dom = require("@floating-ui/dom");
var _react = require("react");
var _reactDom = require("react-dom");
var index = typeof document !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    var length;
    var i;
    var keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function getDPR(element) {
    if (typeof window === "undefined") return 1;
    var win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    var dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    var ref = _react.useRef(value);
    index(function() {
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    var _options_placement = options.placement, placement = _options_placement === void 0 ? "bottom" : _options_placement, _options_strategy = options.strategy, strategy = _options_strategy === void 0 ? "absolute" : _options_strategy, _options_middleware = options.middleware, middleware = _options_middleware === void 0 ? [] : _options_middleware, platform = options.platform, tmp = options.elements, _ref = tmp === void 0 ? {} : tmp, externalReference = _ref.reference, externalFloating = _ref.floating, _options_transform = options.transform, transform = _options_transform === void 0 ? true : _options_transform, whileElementsMounted = options.whileElementsMounted, open = options.open;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        x: 0,
        y: 0,
        strategy,
        placement,
        middlewareData: {},
        isPositioned: false
    }), 2), data = _React_useState[0], setData = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(middleware), 2), latestMiddleware = _React_useState1[0], setLatestMiddleware = _React_useState1[1];
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    var _React_useState2 = (0, _slicedToArray._)(_react.useState(null), 2), _reference = _React_useState2[0], _setReference = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)(_react.useState(null), 2), _floating = _React_useState3[0], _setFloating = _React_useState3[1];
    var setReference = _react.useCallback(function(node) {
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    var setFloating = _react.useCallback(function(node) {
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    var referenceEl = externalReference || _reference;
    var floatingEl = externalFloating || _floating;
    var referenceRef = _react.useRef(null);
    var floatingRef = _react.useRef(null);
    var dataRef = _react.useRef(data);
    var hasWhileElementsMounted = whileElementsMounted != null;
    var whileElementsMountedRef = useLatestRef(whileElementsMounted);
    var platformRef = useLatestRef(platform);
    var openRef = useLatestRef(open);
    var update = _react.useCallback(function() {
        if (!referenceRef.current || !floatingRef.current) return;
        var config = {
            placement,
            strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, _dom.computePosition)(referenceRef.current, floatingRef.current, config).then(function(data) {
            var fullData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            });
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                _reactDom.flushSync(function() {
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    index(function() {
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData(function(data) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                    isPositioned: false
                });
            });
        }
    }, [
        open
    ]);
    var isMountedRef = _react.useRef(false);
    index(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    index(function() {
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    var refs = _react.useMemo(function() {
        return {
            reference: referenceRef,
            floating: floatingRef,
            setReference,
            setFloating
        };
    }, [
        setReference,
        setFloating
    ]);
    var elements = _react.useMemo(function() {
        return {
            reference: referenceEl,
            floating: floatingEl
        };
    }, [
        referenceEl,
        floatingEl
    ]);
    var floatingStyles = _react.useMemo(function() {
        var initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        var x = roundByDPR(elements.floating, data.x);
        var y = roundByDPR(elements.floating, data.y);
        if (transform) return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, initialStyles), {
            transform: "translate(" + x + "px, " + y + "px)"
        }), getDPR(elements.floating) >= 1.5 && {
            willChange: "transform"
        });
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return _react.useMemo(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
            update,
            refs,
            elements,
            floatingStyles
        });
    }, [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow$1 = function(options) {
    var isRef = function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    };
    return {
        name: "arrow",
        options,
        fn (state) {
            var _ref = typeof options === "function" ? options(state) : options, element = _ref.element, padding = _ref.padding;
            if (element && isRef(element)) {
                if (element.current != null) return (0, _dom.arrow)({
                    element: element.current,
                    padding
                }).fn(state);
                return {};
            }
            if (element) return (0, _dom.arrow)({
                element,
                padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.offset)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.shift)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.limitShift)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.flip)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.size)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.autoPlacement)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.hide)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _dom.inline)(options)), {
        options: [
            options,
            deps
        ]
    });
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = function(options, deps) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, arrow$1(options)), {
        options: [
            options,
            deps
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","@floating-ui/dom":"9VyOr","react":"9MtAM","react-dom":"5Yfvl","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"9VyOr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _dom.getOverflowAncestors;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "autoUpdate", function() {
    return autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "platform", function() {
    return platform;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    var css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = (0, _dom.isHTMLElement)(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    var domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    var y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
var noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    var win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = unwrapElement(element);
    var scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    var visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement) {
        var win = (0, _dom.getWindow)(domElement);
        var offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        var currentWin = win;
        var currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            var iframeScale = getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = (0, _dom.getComputedStyle)(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    var leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    var htmlRect = documentElement.getBoundingClientRect();
    var x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect));
    var y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var elements = _ref.elements, rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isFixed = strategy === "fixed";
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = (0, _utils.createCoords)(1);
    var offsets = (0, _utils.createCoords)(0);
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            var offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    var html = (0, _dom.getDocumentElement)(element);
    var scroll = (0, _dom.getNodeScroll)(element);
    var body = element.ownerDocument.body;
    var width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + getWindowScrollBarX(element);
    var y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === "rtl") x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
function getViewportRect(element, strategy) {
    var win = (0, _dom.getWindow)(element);
    var html = (0, _dom.getDocumentElement)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    var clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    var parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = (0, _dom.getOverflowAncestors)(element, [], false).filter(function(el) {
        return (0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== "body";
    });
    var currentContainingBlockComputedStyle = null;
    var elementIsFixed = (0, _dom.getComputedStyle)(element).position === "fixed";
    var currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        var computedStyle = (0, _dom.getComputedStyle)(currentNode);
        var currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        var shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === "clippingAncestors" ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, _toConsumableArray._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstClippingAncestor = clippingAncestors[0];
    var clippingRect = clippingAncestors.reduce(function(accRect, clippingAncestor) {
        var rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    var _getCssDimensions = getCssDimensions(element), width = _getCssDimensions.width, height = _getCssDimensions.height;
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var isFixed = strategy === "fixed";
    var rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = getWindowScrollBarX(documentElement);
    }
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    var x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    var y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    var rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    var win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        var svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    var offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
var getElementRects = function() {
    var _ref = (0, _asyncToGenerator._)(function(data) {
        var getOffsetParentFn, getDimensionsFn, floatingDimensions, _tmp, _tmp1;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getOffsetParentFn = this.getOffsetParent || getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    return [
                        4,
                        getDimensionsFn(data.floating)
                    ];
                case 1:
                    floatingDimensions = _state.sent();
                    _tmp = {};
                    _tmp1 = [
                        data.reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(data.floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.reference = getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                            _state.sent(),
                            data.strategy
                        ])), _tmp.floating = {
                            x: 0,
                            y: 0,
                            width: floatingDimensions.width,
                            height: floatingDimensions.height
                        }, _tmp)
                    ];
            }
        });
    });
    return function getElementRects(data) {
        return _ref.apply(this, arguments);
    };
}();
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === "rtl";
}
var platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    var io = null;
    var timeoutId;
    var root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var elementRectForRootMargin = element.getBoundingClientRect();
        var left = elementRectForRootMargin.left, top = elementRectForRootMargin.top, width = elementRectForRootMargin.width, height = elementRectForRootMargin.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = (0, _utils.floor)(top);
        var insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        var insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        var insetLeft = (0, _utils.floor)(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === "function" : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === "function" : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, _toConsumableArray._)(referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : []).concat((0, _toConsumableArray._)((0, _dom.getOverflowAncestors)(floating))) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    var cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, _slicedToArray._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        var _resizeObserver2;
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ var detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ var computePosition = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = (0, _objectSpread._)({
        platform
    }, options);
    var platformWithCache = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, _core.computePosition)(reference, floating, (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

},{"@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_ts_generator":"dn4mF","@floating-ui/core":"5X4If","@floating-ui/utils":"ta1AP","@floating-ui/utils/dom":"54fku","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"5X4If":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", function() {
    return 0, _utils.rectToClientRect;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = (0, _utils.getSideAxis)(placement);
    var alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    var alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    var side = (0, _utils.getSide)(placement);
    var isVertical = sideAxis === "y";
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var computePosition = function() {
    var _ref = (0, _asyncToGenerator._)(function(reference, floating, config) {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware_i, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? "bottom" : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? "absolute" : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    validMiddleware = middleware.filter(Boolean);
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference,
                            floating,
                            strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    middlewareData = {};
                    resetCount = 0;
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < validMiddleware.length)) return [
                        3,
                        11
                    ];
                    _validMiddleware_i = validMiddleware[i], name = _validMiddleware_i.name, fn = _validMiddleware_i.fn;
                    return [
                        4,
                        fn({
                            x,
                            y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy,
                            middlewareData,
                            rects,
                            platform,
                            elements: {
                                reference,
                                floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, middlewareData), {
                        [name]: (0, _objectSpread._)({}, middlewareData[name], data)
                    });
                    if (!(reset && resetCount <= 50)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!(typeof reset === "object")) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference,
                            floating,
                            strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    _state.label = 10;
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x,
                            y,
                            placement: statefulPlacement,
                            strategy,
                            middlewareData
                        }
                    ];
            }
        });
    });
    return function computePosition(reference, floating, config) {
        return _ref.apply(this, arguments);
    };
}();
function detectOverflow(state, options) {
    return _detectOverflow.apply(this, arguments);
}
function _detectOverflow() {
    _detectOverflow = /**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ (0, _asyncToGenerator._)(function(state, options) {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = (0, _utils.evaluate)(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? "clippingAncestors" : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? "viewport" : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? "floating" : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = (0, _utils.getPaddingObject)(padding);
                    altContext = elementContext === "floating" ? "reference" : "floating";
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === "floating" ? {
                        x,
                        y,
                        width: rects.floating.width,
                        height: rects.floating.height
                    } : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    if (!_state.sent()) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent() || {
                        x: 1,
                        y: 1
                    };
                    return [
                        3,
                        11
                    ];
                case 10:
                    _tmp3 = {
                        x: 1,
                        y: 1
                    };
                    _state.label = 11;
                case 11:
                    offsetScale = _tmp3;
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            elements,
                            rect,
                            offsetParent,
                            strategy
                        })
                    ];
                case 12:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        14
                    ];
                case 13:
                    _tmp4 = rect;
                    _state.label = 14;
                case 14:
                    elementClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    });
    return _detectOverflow.apply(this, arguments);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = function(options) {
    return {
        name: "arrow",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, rects, platform, elements, middlewareData, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, min$1, max, center, offset, shouldAddOffset, alignmentOffset;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            // Since `element` is required, we don't Partial<> the type.
                            _ref = (0, _utils.evaluate)(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            coords = {
                                x,
                                y
                            };
                            axis = (0, _utils.getAlignmentAxis)(placement);
                            length = (0, _utils.getAxisLength)(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === "y";
                            minProp = isYAxis ? "top" : "left";
                            maxProp = isYAxis ? "bottom" : "right";
                            clientProp = isYAxis ? "clientHeight" : "clientWidth";
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            // If the padding is large enough that it causes the arrow to no longer be
                            // centered, modify the padding so that it is centered.
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
                            // Make sure the arrow doesn't overflow the floating element if the center
                            // point is outside the floating element's bounds.
                            min$1 = minPadding;
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = (0, _utils.clamp)(min$1, center, max);
                            // If the reference is small enough that the arrow's padding causes it to
                            // to point to nothing for an aligned placement, adjust the offset of the
                            // floating element itself. To ensure `shift()` continues to take action,
                            // a single reset is performed when this is true.
                            shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                            return [
                                2,
                                {
                                    [axis]: coords[axis] + alignmentOffset,
                                    data: (0, _objectSpread._)({
                                        [axis]: offset,
                                        centerOffset: center - offset - alignmentOffset
                                    }, shouldAddOffset && {
                                        alignmentOffset
                                    }),
                                    reset: shouldAddOffset
                                }
                            ];
                    }
                });
            })();
        }
    };
};
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) === alignment;
    })).concat((0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return (0, _utils.getSide)(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements$1, overflow, currentIndex, currentPlacement, alignmentSides, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? (0, _utils.placements) : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements$1[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            alignmentSides = (0, _utils.getAlignmentSides).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements$1[0]
                                    }
                                }
                            ];
                            currentOverflows = [
                                overflow[(0, _utils.getSide)(currentPlacement)],
                                overflow[alignmentSides[0]],
                                overflow[alignmentSides[1]]
                            ];
                            allOverflows = (0, _toConsumableArray._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements$1[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = (0, _utils.getAlignment)(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, initialSideAxis, isBasePlacement, rtl, fallbackPlacements, hasFallbackAxisSideDirection, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$filter2, placement1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? "bestFit" : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? "none" : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            // If a reset by the arrow was caused due to an alignment offset being
                            // added, we should skip any logic now since `flip()` has already done its
                            // work.
                            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = (0, _utils.getSide)(placement);
                            initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
                            isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                (0, _utils.getOppositePlacement)(initialPlacement)
                            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
                            hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
                            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, _toConsumableArray._)((0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, _toConsumableArray._)(fallbackPlacements));
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0, _toConsumableArray._)(overflowsData).concat([
                                {
                                    placement,
                                    overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) // Try next placement and re-run the lifecycle.
                                return [
                                    2,
                                    {
                                        data: {
                                            index: nextIndex,
                                            overflows: overflowsData
                                        },
                                        reset: {
                                            placement: nextPlacement
                                        }
                                    }
                                ];
                                // First, find the candidates that fit on the mainAxis side of overflow,
                                // then find the placement that fits the best on the main crossAxis side.
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case "bestFit":
                                        {
                                            ;
                                            placement1 = (_overflowsData$filter2 = overflowsData.filter(function(d) {
                                                if (hasFallbackAxisSideDirection) {
                                                    var currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                                    // reading directions favoring greater width.
                                                    currentSideAxis === "y";
                                                }
                                                return true;
                                            }).map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$filter2[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case "initialPlacement":
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var rects, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? "referenceHidden" : _evaluate_strategy, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case "referenceHidden":
                                    return [
                                        3,
                                        1
                                    ];
                                case "escaped":
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function getBoundingRect(rects) {
    var minX = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return (0, _utils.rectToClientRect)(getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ((0, _utils.getSideAxis)(placement) === "y") {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = (0, _utils.getSide)(placement) === "top";
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            var width = right - left;
                            var height = bottom - top;
                            return {
                                top,
                                bottom,
                                left,
                                right,
                                width,
                                height,
                                x: left,
                                y: top
                            };
                        }
                        var isLeftSide = (0, _utils.getSide)(placement) === "left";
                        var maxRight = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        var left1 = minLeft;
                        var right1 = maxRight;
                        var width1 = right1 - left1;
                        var height1 = bottom1 - top1;
                        return {
                            top: top1,
                            bottom: bottom1,
                            left: left1,
                            right: right1,
                            width: width1,
                            height: height1,
                            x: left1,
                            y: top1
                        };
                    }
                    return fallback;
                }
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                            // ClientRect's bounds, despite the event listener being triggered. A
                            // padding of 2 seems to handle this issue.
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            clientRects = getRectsByLine(nativeClientRects);
                            fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function convertValueToCoords(state, options) {
    return _convertValueToCoords.apply(this, arguments);
}
function _convertValueToCoords() {
    _convertValueToCoords = // For type backwards-compatibility, the `OffsetOptions` type was also
    // Derivable.
    (0, _asyncToGenerator._)(function(state, options) {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = (0, _utils.getSide)(placement);
                    alignment = (0, _utils.getAlignment)(placement);
                    isVertical = (0, _utils.getSideAxis)(placement) === "y";
                    mainAxisMulti = [
                        "left",
                        "top"
                    ].includes(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = (0, _utils.evaluate)(options, state);
                    // eslint-disable-next-line prefer-const
                    _ref = typeof rawValue === "number" ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : {
                        mainAxis: rawValue.mainAxis || 0,
                        crossAxis: rawValue.crossAxis || 0,
                        alignmentAxis: rawValue.alignmentAxis
                    }, mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    });
    return _convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
                            return [
                                4,
                                convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            // If the placement is the same and the arrow caused an alignment offset
                            // then we don't need to change the positioning coordinates.
                            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, diffCoords), {
                                        placement
                                    })
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, min, max, minSide1, maxSide1, min1, max1, limitedCoords;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x,
                                        y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x,
                                y
                            };
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
                            mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            if (checkMainAxis) {
                                minSide = mainAxis === "y" ? "top" : "left";
                                maxSide = mainAxis === "y" ? "bottom" : "right";
                                min = mainAxisCoord + overflow[minSide];
                                max = mainAxisCoord - overflow[maxSide];
                                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
                            }
                            if (checkCrossAxis) {
                                minSide1 = crossAxis === "y" ? "top" : "left";
                                maxSide1 = crossAxis === "y" ? "bottom" : "right";
                                min1 = crossAxisCoord + overflow[minSide1];
                                max1 = crossAxisCoord - overflow[maxSide1];
                                crossAxisCoord = (0, _utils.clamp)(min1, crossAxisCoord, max1);
                            }
                            limitedCoords = limiter.fn((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                                [mainAxis]: mainAxisCoord,
                                [crossAxis]: crossAxisCoord
                            }));
                            return [
                                2,
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y,
                                        enabled: {
                                            [mainAxis]: checkMainAxis,
                                            [crossAxis]: checkCrossAxis
                                        }
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = (0, _utils.evaluate)(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x,
                y
            };
            var crossAxis = (0, _utils.getSideAxis)(placement);
            var mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = (0, _utils.evaluate)(offset, state);
            var computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, _objectSpread._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                var len = mainAxis === "y" ? "height" : "width";
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === "y" ? "width" : "height";
                var isOriginSide = [
                    "top",
                    "left"
                ].includes((0, _utils.getSide)(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = function size(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options,
        fn (state) {
            return (0, _asyncToGenerator._)(function() {
                var _state$middlewareData, _state$middlewareData2, placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects_floating, width, height, heightSide, widthSide, maximumClippingHeight, maximumClippingWidth, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, xMin, xMax, yMin, yMax, nextDimensions;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = (0, _utils.getSide)(placement);
                            alignment = (0, _utils.getAlignment)(placement);
                            isYAxis = (0, _utils.getSideAxis)(placement) === "y";
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === "top" || side === "bottom")) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? "start" : "end") ? "left" : "right";
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === "end" ? "top" : "bottom";
                            _state.label = 4;
                        case 4:
                            maximumClippingHeight = height - overflow.top - overflow.bottom;
                            maximumClippingWidth = width - overflow.left - overflow.right;
                            overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
                            overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
                            noShift = !state.middlewareData.shift;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                            if (noShift && !alignment) {
                                xMin = (0, _utils.max)(overflow.left, 0);
                                xMax = (0, _utils.max)(overflow.right, 0);
                                yMin = (0, _utils.max)(overflow.top, 0);
                                yMax = (0, _utils.max)(overflow.bottom, 0);
                                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
                            }
                            return [
                                4,
                                apply((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                                    availableWidth,
                                    availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};

},{"@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_ts_generator":"dn4mF","@floating-ui/utils":"ta1AP","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"6m3LL":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("bed4fe62409d1872");
var React = require("d682f5234662ea97");
var ScrollArea_context = require("52e549124948bb52");
var useResizeObserver = require("b099eb2fe19357ce");
var Corner = React.forwardRef(function(props, ref) {
    var style = props.style, others = (0, _objectWithoutProperties._)(props, [
        "style"
    ]);
    var ctx = ScrollArea_context.useScrollAreaContext();
    var _React_useState = (0, _slicedToArray._)(React.useState(0), 2), width = _React_useState[0], setWidth = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(0), 2), height = _React_useState1[0], setHeight = _React_useState1[1];
    var hasSize = Boolean(width && height);
    useResizeObserver.useResizeObserver(ctx.scrollbarX, function() {
        var _ctx_scrollbarX;
        var h = ((_ctx_scrollbarX = ctx.scrollbarX) === null || _ctx_scrollbarX === void 0 ? void 0 : _ctx_scrollbarX.offsetHeight) || 0;
        ctx.onCornerHeightChange(h);
        setHeight(h);
    });
    useResizeObserver.useResizeObserver(ctx.scrollbarY, function() {
        var _ctx_scrollbarY;
        var w = ((_ctx_scrollbarY = ctx.scrollbarY) === null || _ctx_scrollbarY === void 0 ? void 0 : _ctx_scrollbarY.offsetWidth) || 0;
        ctx.onCornerWidthChange(w);
        setWidth(w);
    });
    return hasSize ? /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref,
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            width,
            height
        })
    })) : null;
});
var ScrollAreaCorner = React.forwardRef(function(props, ref) {
    var ctx = ScrollArea_context.useScrollAreaContext();
    var hasBothScrollbarsVisible = Boolean(ctx.scrollbarX && ctx.scrollbarY);
    var hasCorner = ctx.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ jsxRuntime.jsx(Corner, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref
    })) : null;
});
exports.Corner = Corner;
exports.ScrollAreaCorner = ScrollAreaCorner; //# sourceMappingURL=ScrollAreaCorner.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","bed4fe62409d1872":"iKGFf","d682f5234662ea97":"9MtAM","52e549124948bb52":"i5QZF","b099eb2fe19357ce":"4xpiJ"}],"i5QZF":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("c73c2ae391668044");
var createSafeContext = require("c46c9adeb5d21363");
require("ff29ada68b451d66");
require("76233969976e9301");
require("d0da266de14e5bc2");
require("e51431d32985bd16");
require("6d5a7095354f23ba");
require("ed003397e8a8aa90");
require("f1f8968899081e55");
require("f5654fcba4964e2a");
require("76c655aa6958fc9");
require("89cd7e0f9042e163");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("ScrollArea.Root component was not found in tree"), 2), ScrollAreaProvider = _createSafeContext_createSafeContext[0], useScrollAreaContext = _createSafeContext_createSafeContext[1];
exports.ScrollAreaProvider = ScrollAreaProvider;
exports.useScrollAreaContext = useScrollAreaContext; //# sourceMappingURL=ScrollArea.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","c73c2ae391668044":"9MtAM","c46c9adeb5d21363":"8srze","ff29ada68b451d66":"iKGFf","76233969976e9301":"9HEEB","d0da266de14e5bc2":"8QFOC","e51431d32985bd16":"2FdJg","6d5a7095354f23ba":"6AMGA","ed003397e8a8aa90":"erSvz","f1f8968899081e55":"kqQOF","f5654fcba4964e2a":"8YP4O","76c655aa6958fc9":"gkGXc","89cd7e0f9042e163":"2onWA"}],"4xpiJ":[function(require,module,exports) {
"use client";
"use strict";
var hooks = require("4f5f8f33301676b4");
function useResizeObserver(element, onResize) {
    var handleResize = hooks.useCallbackRef(onResize);
    hooks.useIsomorphicEffect(function() {
        var rAF = 0;
        if (element) {
            var resizeObserver = new ResizeObserver(function() {
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return function() {
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
        return void 0;
    }, [
        element,
        handleResize
    ]);
}
exports.useResizeObserver = useResizeObserver; //# sourceMappingURL=use-resize-observer.cjs.map

},{"4f5f8f33301676b4":"9HEEB"}],"6OuSB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("8ce5d5d2432bbaf1");
var React = require("c2542b5933f4a60a");
var hooks = require("add481b5224d37dc");
require("1070525fccbaabeb");
require("9f7e47ecc070e8c2");
require("7f8b008af3d08f2");
require("45aadbbff877a858");
require("6b0622925204a28a");
var useProps = require("2ee959cc8725fa8f");
require("4cea8aa3f9bee39b");
var Box = require("9ec4764b01c08d72");
require("a77b6c9daa2822da");
var ScrollArea_context = require("7d3ab4f5026bf7a6");
var defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover"
};
var ScrollAreaRoot = React.forwardRef(function(_props, ref) {
    var props = useProps.useProps("ScrollAreaRoot", defaultProps, _props);
    var type = props.type, scrollHideDelay = props.scrollHideDelay, scrollbars = props.scrollbars, others = (0, _objectWithoutProperties._)(props, [
        "type",
        "scrollHideDelay",
        "scrollbars"
    ]);
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), scrollArea = _React_useState[0], setScrollArea = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(null), 2), viewport = _React_useState1[0], setViewport = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState(null), 2), content = _React_useState2[0], setContent = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)(React.useState(null), 2), scrollbarX = _React_useState3[0], setScrollbarX = _React_useState3[1];
    var _React_useState4 = (0, _slicedToArray._)(React.useState(null), 2), scrollbarY = _React_useState4[0], setScrollbarY = _React_useState4[1];
    var _React_useState5 = (0, _slicedToArray._)(React.useState(0), 2), cornerWidth = _React_useState5[0], setCornerWidth = _React_useState5[1];
    var _React_useState6 = (0, _slicedToArray._)(React.useState(0), 2), cornerHeight = _React_useState6[0], setCornerHeight = _React_useState6[1];
    var _React_useState7 = (0, _slicedToArray._)(React.useState(false), 2), scrollbarXEnabled = _React_useState7[0], setScrollbarXEnabled = _React_useState7[1];
    var _React_useState8 = (0, _slicedToArray._)(React.useState(false), 2), scrollbarYEnabled = _React_useState8[0], setScrollbarYEnabled = _React_useState8[1];
    var rootRef = hooks.useMergedRef(ref, function(node) {
        return setScrollArea(node);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(ScrollArea_context.ScrollAreaProvider, {
        value: {
            type,
            scrollHideDelay,
            scrollArea,
            viewport,
            onViewportChange: setViewport,
            content,
            onContentChange: setContent,
            scrollbarX,
            onScrollbarXChange: setScrollbarX,
            scrollbarXEnabled,
            onScrollbarXEnabledChange: setScrollbarXEnabled,
            scrollbarY,
            onScrollbarYChange: setScrollbarY,
            scrollbarYEnabled,
            onScrollbarYEnabledChange: setScrollbarYEnabled,
            onCornerWidthChange: setCornerWidth,
            onCornerHeightChange: setCornerHeight
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
            ref: rootRef,
            __vars: {
                "--sa-corner-width": scrollbars !== "xy" ? "0px" : `${cornerWidth}px`,
                "--sa-corner-height": scrollbars !== "xy" ? "0px" : `${cornerHeight}px`
            }
        }))
    });
});
ScrollAreaRoot.displayName = "@mantine/core/ScrollAreaRoot";
exports.ScrollAreaRoot = ScrollAreaRoot; //# sourceMappingURL=ScrollAreaRoot.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","8ce5d5d2432bbaf1":"iKGFf","c2542b5933f4a60a":"9MtAM","add481b5224d37dc":"9HEEB","1070525fccbaabeb":"8QFOC","9f7e47ecc070e8c2":"2FdJg","7f8b008af3d08f2":"6AMGA","45aadbbff877a858":"erSvz","6b0622925204a28a":"kqQOF","2ee959cc8725fa8f":"iivvn","4cea8aa3f9bee39b":"8YP4O","9ec4764b01c08d72":"gkGXc","a77b6c9daa2822da":"2onWA","7d3ab4f5026bf7a6":"i5QZF"}],"jiuB1":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("829764636eaeb45b");
var React = require("8d0459a38b7d63c0");
var ScrollArea_context = require("83b301c4332bca1");
var ScrollAreaScrollbarAuto = require("7cc5fdf5eae60047");
var ScrollAreaScrollbarHover = require("a6c74769ec22618c");
var ScrollAreaScrollbarScroll = require("4ed5d07eaf23d143");
var ScrollAreaScrollbarVisible = require("e3bc919a0dd4aa56");
var ScrollAreaScrollbar = React.forwardRef(function(props, forwardedRef) {
    var forceMount = props.forceMount, scrollbarProps = (0, _objectWithoutProperties._)(props, [
        "forceMount"
    ]);
    var context = ScrollArea_context.useScrollAreaContext();
    var onScrollbarXEnabledChange = context.onScrollbarXEnabledChange, onScrollbarYEnabledChange = context.onScrollbarYEnabledChange;
    var isHorizontal = props.orientation === "horizontal";
    React.useEffect(function() {
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return function() {
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === "hover" ? /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbarHover.ScrollAreaScrollbarHover, (0, _objectSpreadProps._)((0, _objectSpread._)({}, scrollbarProps), {
        ref: forwardedRef,
        forceMount
    })) : context.type === "scroll" ? /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbarScroll.ScrollAreaScrollbarScroll, (0, _objectSpreadProps._)((0, _objectSpread._)({}, scrollbarProps), {
        ref: forwardedRef,
        forceMount
    })) : context.type === "auto" ? /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbarAuto.ScrollAreaScrollbarAuto, (0, _objectSpreadProps._)((0, _objectSpread._)({}, scrollbarProps), {
        ref: forwardedRef,
        forceMount
    })) : context.type === "always" ? /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbarVisible.ScrollAreaScrollbarVisible, (0, _objectSpreadProps._)((0, _objectSpread._)({}, scrollbarProps), {
        ref: forwardedRef
    })) : null;
});
ScrollAreaScrollbar.displayName = "@mantine/core/ScrollAreaScrollbar";
exports.ScrollAreaScrollbar = ScrollAreaScrollbar; //# sourceMappingURL=ScrollAreaScrollbar.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","829764636eaeb45b":"iKGFf","8d0459a38b7d63c0":"9MtAM","83b301c4332bca1":"i5QZF","7cc5fdf5eae60047":"lusse","a6c74769ec22618c":"ibRbZ","4ed5d07eaf23d143":"avnae","e3bc919a0dd4aa56":"lDv19"}],"lusse":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("c580062a661442c8");
var React = require("3a1f8b1e9b177f07");
var hooks = require("19481e1b8cb8c332");
var ScrollArea_context = require("a978e083900cc5a0");
var useResizeObserver = require("f243d05a935bde0b");
var ScrollAreaScrollbarVisible = require("5520c0567a2bd395");
var ScrollAreaScrollbarAuto = React.forwardRef(function(props, ref) {
    var context = ScrollArea_context.useScrollAreaContext();
    var forceMount = props.forceMount, scrollbarProps = (0, _objectWithoutProperties._)(props, [
        "forceMount"
    ]);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), visible = _React_useState[0], setVisible = _React_useState[1];
    var isHorizontal = props.orientation === "horizontal";
    var handleResize = hooks.useDebouncedCallback(function() {
        if (context.viewport) {
            var isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            var isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    useResizeObserver.useResizeObserver(context.viewport, handleResize);
    useResizeObserver.useResizeObserver(context.content, handleResize);
    if (forceMount || visible) return /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbarVisible.ScrollAreaScrollbarVisible, (0, _objectSpreadProps._)((0, _objectSpread._)({
        "data-state": visible ? "visible" : "hidden"
    }, scrollbarProps), {
        ref
    }));
    return null;
});
ScrollAreaScrollbarAuto.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
exports.ScrollAreaScrollbarAuto = ScrollAreaScrollbarAuto; //# sourceMappingURL=ScrollAreaScrollbarAuto.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","c580062a661442c8":"iKGFf","3a1f8b1e9b177f07":"9MtAM","19481e1b8cb8c332":"9HEEB","a978e083900cc5a0":"i5QZF","f243d05a935bde0b":"4xpiJ","5520c0567a2bd395":"lDv19"}],"lDv19":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("f34c40582333f760");
var React = require("fb055b978d8753a6");
require("cdbe2667cbdc7911");
require("2afc2cf8f85f5ee");
require("465df81e32a19bdd");
require("a428a76b6fac5975");
require("6868126369a89d80");
require("29a43f285b8b32db");
require("49510717d4a2b8e8");
require("79ca2e8df89cfe15");
var DirectionProvider = require("ec71e8f0b195c20");
var ScrollArea_context = require("36b206a09d3a2b8f");
var getThumbRatio = require("74afda74aaffbb58");
var getThumbOffsetFromScroll = require("3ae879deb500703b");
var getScrollPositionFromPointer = require("235fb2dad64af0d7");
var ScrollbarX = require("6a36360733e1436");
var ScrollbarY = require("2c8b7f102b1ae55f");
var ScrollAreaScrollbarVisible = React.forwardRef(function(props, forwardedRef) {
    var _props_orientation = props.orientation, orientation = _props_orientation === void 0 ? "vertical" : _props_orientation, scrollbarProps = (0, _objectWithoutProperties._)(props, [
        "orientation"
    ]);
    var dir = DirectionProvider.useDirection().dir;
    var context = ScrollArea_context.useScrollAreaContext();
    var thumbRef = React.useRef(null);
    var pointerOffsetRef = React.useRef(0);
    var _React_useState = (0, _slicedToArray._)(React.useState({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    }), 2), sizes = _React_useState[0], setSizes = _React_useState[1];
    var thumbRatio = getThumbRatio.getThumbRatio(sizes.viewport, sizes.content);
    var commonProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, scrollbarProps), {
        sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: function(thumb) {
            thumbRef.current = thumb;
        },
        onThumbPointerUp: function() {
            pointerOffsetRef.current = 0;
        },
        onThumbPointerDown: function(pointerPos) {
            pointerOffsetRef.current = pointerPos;
        }
    });
    var getScrollPosition = function(pointerPos, direction) {
        return getScrollPositionFromPointer.getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, direction);
    };
    if (orientation === "horizontal") return /* @__PURE__ */ jsxRuntime.jsx(ScrollbarX.ScrollAreaScrollbarX, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
        ref: forwardedRef,
        onThumbPositionChange: function() {
            if (context.viewport && thumbRef.current) {
                var scrollPos = context.viewport.scrollLeft;
                var offset = getThumbOffsetFromScroll.getThumbOffsetFromScroll(scrollPos, sizes, dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: function(scrollPos) {
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: function(pointerPos) {
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, dir);
        }
    }));
    if (orientation === "vertical") return /* @__PURE__ */ jsxRuntime.jsx(ScrollbarY.ScrollAreaScrollbarY, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
        ref: forwardedRef,
        onThumbPositionChange: function() {
            if (context.viewport && thumbRef.current) {
                var scrollPos = context.viewport.scrollTop;
                var offset = getThumbOffsetFromScroll.getThumbOffsetFromScroll(scrollPos, sizes);
                if (sizes.scrollbar.size === 0) thumbRef.current.style.setProperty("--thumb-opacity", "0");
                else thumbRef.current.style.setProperty("--thumb-opacity", "1");
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: function(scrollPos) {
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: function(pointerPos) {
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    }));
    return null;
});
ScrollAreaScrollbarVisible.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
exports.ScrollAreaScrollbarVisible = ScrollAreaScrollbarVisible; //# sourceMappingURL=ScrollAreaScrollbarVisible.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","f34c40582333f760":"iKGFf","fb055b978d8753a6":"9MtAM","cdbe2667cbdc7911":"9HEEB","2afc2cf8f85f5ee":"8QFOC","465df81e32a19bdd":"2FdJg","a428a76b6fac5975":"6AMGA","6868126369a89d80":"erSvz","29a43f285b8b32db":"kqQOF","49510717d4a2b8e8":"8YP4O","79ca2e8df89cfe15":"gkGXc","ec71e8f0b195c20":"2onWA","36b206a09d3a2b8f":"i5QZF","74afda74aaffbb58":"coFXm","3ae879deb500703b":"1UbkB","235fb2dad64af0d7":"40xk9","6a36360733e1436":"d0J5V","2c8b7f102b1ae55f":"bXQjN"}],"coFXm":[function(require,module,exports) {
"use client";
"use strict";
function getThumbRatio(viewportSize, contentSize) {
    var ratio = viewportSize / contentSize;
    return Number.isNaN(ratio) ? 0 : ratio;
}
exports.getThumbRatio = getThumbRatio; //# sourceMappingURL=get-thumb-ratio.cjs.map

},{}],"1UbkB":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var getThumbSize = require("9ff44d78f5df20ca");
var linearScale = require("91f584bf4e99e7f6");
function clamp(value, param) {
    var _param = (0, _slicedToArray._)(param, 2), min = _param[0], max = _param[1];
    return Math.min(max, Math.max(min, value));
}
function getThumbOffsetFromScroll(scrollPos, sizes) {
    var dir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "ltr";
    var thumbSizePx = getThumbSize.getThumbSize(sizes);
    var scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    var scrollbar = sizes.scrollbar.size - scrollbarPadding;
    var maxScrollPos = sizes.content - sizes.viewport;
    var maxThumbPos = scrollbar - thumbSizePx;
    var scrollClampRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    var scrollWithoutMomentum = clamp(scrollPos, scrollClampRange);
    var interpolate = linearScale.linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
}
exports.getThumbOffsetFromScroll = getThumbOffsetFromScroll; //# sourceMappingURL=get-thumb-offset-from-scroll.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","9ff44d78f5df20ca":"3jukv","91f584bf4e99e7f6":"ham5h"}],"3jukv":[function(require,module,exports) {
"use client";
"use strict";
var getThumbRatio = require("911f8229933b1326");
function getThumbSize(sizes) {
    var ratio = getThumbRatio.getThumbRatio(sizes.viewport, sizes.content);
    var scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    var thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}
exports.getThumbSize = getThumbSize; //# sourceMappingURL=get-thumb-size.cjs.map

},{"911f8229933b1326":"coFXm"}],"ham5h":[function(require,module,exports) {
"use client";
"use strict";
function linearScale(input, output) {
    return function(value) {
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        var ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
exports.linearScale = linearScale; //# sourceMappingURL=linear-scale.cjs.map

},{}],"40xk9":[function(require,module,exports) {
"use client";
"use strict";
var getThumbSize = require("bcec0a1ed6803235");
var linearScale = require("7f79458e03967648");
function getScrollPositionFromPointer(pointerPos, pointerOffset, sizes) {
    var dir = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "ltr";
    var thumbSizePx = getThumbSize.getThumbSize(sizes);
    var thumbCenter = thumbSizePx / 2;
    var offset = pointerOffset || thumbCenter;
    var thumbOffsetFromEnd = thumbSizePx - offset;
    var minPointerPos = sizes.scrollbar.paddingStart + offset;
    var maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    var maxScrollPos = sizes.content - sizes.viewport;
    var scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    var interpolate = linearScale.linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
exports.getScrollPositionFromPointer = getScrollPositionFromPointer; //# sourceMappingURL=get-scroll-position-from-pointer.cjs.map

},{"bcec0a1ed6803235":"3jukv","7f79458e03967648":"ham5h"}],"d0J5V":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("6037e7250ad5151");
var React = require("142328644ece8f9b");
var hooks = require("d2762b18cd1f391a");
var ScrollArea_context = require("2693b7de81fa022f");
var isScrollingWithinScrollbarBounds = require("167f9367c8872f85");
var getThumbSize = require("368da56f8b65baed");
var toInt = require("d6ea8edefaaef4b4");
var Scrollbar = require("94364f3a3c001aff");
var ScrollAreaScrollbarX = React.forwardRef(function(props, forwardedRef) {
    var sizes = props.sizes, onSizesChange = props.onSizesChange, style = props.style, others = (0, _objectWithoutProperties._)(props, [
        "sizes",
        "onSizesChange",
        "style"
    ]);
    var ctx = ScrollArea_context.useScrollAreaContext();
    var _React_useState = (0, _slicedToArray._)(React.useState(), 2), computedStyle = _React_useState[0], setComputedStyle = _React_useState[1];
    var ref = React.useRef(null);
    var composeRefs = hooks.useMergedRef(forwardedRef, ref, ctx.onScrollbarXChange);
    React.useEffect(function() {
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Scrollbar.Scrollbar, (0, _objectSpreadProps._)((0, _objectSpread._)({
        "data-orientation": "horizontal"
    }, others), {
        ref: composeRefs,
        sizes,
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            ["--sa-thumb-width"]: `${getThumbSize.getThumbSize(sizes)}px`
        }),
        onThumbPointerDown: function(pointerPos) {
            return props.onThumbPointerDown(pointerPos.x);
        },
        onDragScroll: function(pointerPos) {
            return props.onDragScroll(pointerPos.x);
        },
        onWheelScroll: function(event, maxScrollPos) {
            if (ctx.viewport) {
                var scrollPos = ctx.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos);
                if (isScrollingWithinScrollbarBounds.isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: function() {
            if (ref.current && ctx.viewport && computedStyle) onSizesChange({
                content: ctx.viewport.scrollWidth,
                viewport: ctx.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: toInt.toInt(computedStyle.paddingLeft),
                    paddingEnd: toInt.toInt(computedStyle.paddingRight)
                }
            });
        }
    }));
});
ScrollAreaScrollbarX.displayName = "@mantine/core/ScrollAreaScrollbarX";
exports.ScrollAreaScrollbarX = ScrollAreaScrollbarX; //# sourceMappingURL=ScrollbarX.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","6037e7250ad5151":"iKGFf","142328644ece8f9b":"9MtAM","d2762b18cd1f391a":"9HEEB","2693b7de81fa022f":"i5QZF","167f9367c8872f85":"6wuE2","368da56f8b65baed":"3jukv","d6ea8edefaaef4b4":"hiBkr","94364f3a3c001aff":"2TuIZ"}],"6wuE2":[function(require,module,exports) {
"use client";
"use strict";
function isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}
exports.isScrollingWithinScrollbarBounds = isScrollingWithinScrollbarBounds; //# sourceMappingURL=is-scrolling-within-scrollbar-bounds.cjs.map

},{}],"hiBkr":[function(require,module,exports) {
"use client";
"use strict";
function toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
exports.toInt = toInt; //# sourceMappingURL=to-int.cjs.map

},{}],"2TuIZ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("fb776246cbf3eb64");
var React = require("b03e206c0b335cce");
var hooks = require("5e7b10f2acadb507");
var ScrollArea_context = require("2e4725aa572fe5e8");
var useResizeObserver = require("7af60abada152cff");
var composeEventHandlers = require("197027aa0b1ed793");
var Scrollbar_context = require("d86cc444e028b49f");
var Scrollbar = React.forwardRef(function(props, forwardedRef) {
    var sizes = props.sizes, hasThumb = props.hasThumb, onThumbChange = props.onThumbChange, onThumbPointerUp = props.onThumbPointerUp, onThumbPointerDown = props.onThumbPointerDown, onThumbPositionChange = props.onThumbPositionChange, onDragScroll = props.onDragScroll, onWheelScroll = props.onWheelScroll, onResize = props.onResize, scrollbarProps = (0, _objectWithoutProperties._)(props, [
        "sizes",
        "hasThumb",
        "onThumbChange",
        "onThumbPointerUp",
        "onThumbPointerDown",
        "onThumbPositionChange",
        "onDragScroll",
        "onWheelScroll",
        "onResize"
    ]);
    var context = ScrollArea_context.useScrollAreaContext();
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), scrollbar = _React_useState[0], setScrollbar = _React_useState[1];
    var composeRefs = hooks.useMergedRef(forwardedRef, function(node) {
        return setScrollbar(node);
    });
    var rectRef = React.useRef(null);
    var prevWebkitUserSelectRef = React.useRef("");
    var viewport = context.viewport;
    var maxScrollPos = sizes.content - sizes.viewport;
    var handleWheelScroll = hooks.useCallbackRef(onWheelScroll);
    var handleThumbPositionChange = hooks.useCallbackRef(onThumbPositionChange);
    var handleResize = hooks.useDebouncedCallback(onResize, 10);
    var handleDragScroll = function(event) {
        if (rectRef.current) {
            var x = event.clientX - rectRef.current.left;
            var y = event.clientY - rectRef.current.top;
            onDragScroll({
                x,
                y
            });
        }
    };
    React.useEffect(function() {
        var handleWheel = function(event) {
            var element = event.target;
            var isScrollbarWheel = scrollbar === null || scrollbar === void 0 ? void 0 : scrollbar.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return function() {
            return document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
        };
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    React.useEffect(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    useResizeObserver.useResizeObserver(scrollbar, handleResize);
    useResizeObserver.useResizeObserver(context.content, handleResize);
    return /* @__PURE__ */ jsxRuntime.jsx(Scrollbar_context.ScrollbarProvider, {
        value: {
            scrollbar,
            hasThumb,
            onThumbChange: hooks.useCallbackRef(onThumbChange),
            onThumbPointerUp: hooks.useCallbackRef(onThumbPointerUp),
            onThumbPositionChange: handleThumbPositionChange,
            onThumbPointerDown: hooks.useCallbackRef(onThumbPointerDown)
        },
        children: /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, scrollbarProps), {
            ref: composeRefs,
            "data-mantine-scrollbar": true,
            style: (0, _objectSpread._)({
                position: "absolute"
            }, scrollbarProps.style),
            onPointerDown: composeEventHandlers.composeEventHandlers(props.onPointerDown, function(event) {
                event.preventDefault();
                var mainPointer = 0;
                if (event.button === mainPointer) {
                    var element = event.target;
                    element.setPointerCapture(event.pointerId);
                    rectRef.current = scrollbar.getBoundingClientRect();
                    prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                    document.body.style.webkitUserSelect = "none";
                    handleDragScroll(event);
                }
            }),
            onPointerMove: composeEventHandlers.composeEventHandlers(props.onPointerMove, handleDragScroll),
            onPointerUp: composeEventHandlers.composeEventHandlers(props.onPointerUp, function(event) {
                var element = event.target;
                if (element.hasPointerCapture(event.pointerId)) {
                    event.preventDefault();
                    element.releasePointerCapture(event.pointerId);
                }
            }),
            onLostPointerCapture: function() {
                document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
                rectRef.current = null;
            }
        }))
    });
});
exports.Scrollbar = Scrollbar; //# sourceMappingURL=Scrollbar.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","fb776246cbf3eb64":"iKGFf","b03e206c0b335cce":"9MtAM","5e7b10f2acadb507":"9HEEB","2e4725aa572fe5e8":"i5QZF","7af60abada152cff":"4xpiJ","197027aa0b1ed793":"8P9jr","d86cc444e028b49f":"PHGtZ"}],"8P9jr":[function(require,module,exports) {
"use client";
"use strict";
function composeEventHandlers(originalEventHandler, ourEventHandler) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_checkForDefaultPrevented = _ref.checkForDefaultPrevented, checkForDefaultPrevented = _ref_checkForDefaultPrevented === void 0 ? true : _ref_checkForDefaultPrevented;
    return function(event) {
        originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}
exports.composeEventHandlers = composeEventHandlers; //# sourceMappingURL=compose-event-handlers.cjs.map

},{}],"PHGtZ":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("481c1c6c688e1337");
var createSafeContext = require("c768ea83e736f31d");
require("1dde052d4a45a704");
require("3c08267880e5a141");
require("657d254b738de8d0");
require("ec0faec38554a4e3");
require("45fcd236f7201739");
require("bb51bcf4d1038924");
require("350667da64fb87f4");
require("22a58b06ec631420");
require("eb797914c93d15da");
require("97612e0bd44fb3c2");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("ScrollAreaScrollbar was not found in tree"), 2), ScrollbarProvider = _createSafeContext_createSafeContext[0], useScrollbarContext = _createSafeContext_createSafeContext[1];
exports.ScrollbarProvider = ScrollbarProvider;
exports.useScrollbarContext = useScrollbarContext; //# sourceMappingURL=Scrollbar.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","481c1c6c688e1337":"9MtAM","c768ea83e736f31d":"8srze","1dde052d4a45a704":"iKGFf","3c08267880e5a141":"9HEEB","657d254b738de8d0":"8QFOC","ec0faec38554a4e3":"2FdJg","45fcd236f7201739":"6AMGA","bb51bcf4d1038924":"erSvz","350667da64fb87f4":"kqQOF","22a58b06ec631420":"8YP4O","eb797914c93d15da":"gkGXc","97612e0bd44fb3c2":"2onWA"}],"bXQjN":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("8e18f5eb3ea389c3");
var React = require("758aa2c34ec3969e");
var hooks = require("fd5018b2cde9f90");
var ScrollArea_context = require("3d4f4a70610366eb");
var isScrollingWithinScrollbarBounds = require("b27b922e550fb44");
var getThumbSize = require("c03b794b3310623a");
var toInt = require("eb02d380c827a60f");
var Scrollbar = require("5648ef50c8d255b3");
var ScrollAreaScrollbarY = React.forwardRef(function(props, forwardedRef) {
    var sizes = props.sizes, onSizesChange = props.onSizesChange, style = props.style, others = (0, _objectWithoutProperties._)(props, [
        "sizes",
        "onSizesChange",
        "style"
    ]);
    var context = ScrollArea_context.useScrollAreaContext();
    var _React_useState = (0, _slicedToArray._)(React.useState(), 2), computedStyle = _React_useState[0], setComputedStyle = _React_useState[1];
    var ref = React.useRef(null);
    var composeRefs = hooks.useMergedRef(forwardedRef, ref, context.onScrollbarYChange);
    React.useEffect(function() {
        if (ref.current) setComputedStyle(window.getComputedStyle(ref.current));
    }, []);
    return /* @__PURE__ */ jsxRuntime.jsx(Scrollbar.Scrollbar, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        "data-orientation": "vertical",
        ref: composeRefs,
        sizes,
        style: (0, _objectSpread._)({
            ["--sa-thumb-height"]: `${getThumbSize.getThumbSize(sizes)}px`
        }, style),
        onThumbPointerDown: function(pointerPos) {
            return props.onThumbPointerDown(pointerPos.y);
        },
        onDragScroll: function(pointerPos) {
            return props.onDragScroll(pointerPos.y);
        },
        onWheelScroll: function(event, maxScrollPos) {
            if (context.viewport) {
                var scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos);
                if (isScrollingWithinScrollbarBounds.isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: function() {
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: toInt.toInt(computedStyle.paddingTop),
                    paddingEnd: toInt.toInt(computedStyle.paddingBottom)
                }
            });
        }
    }));
});
ScrollAreaScrollbarY.displayName = "@mantine/core/ScrollAreaScrollbarY";
exports.ScrollAreaScrollbarY = ScrollAreaScrollbarY; //# sourceMappingURL=ScrollbarY.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","8e18f5eb3ea389c3":"iKGFf","758aa2c34ec3969e":"9MtAM","fd5018b2cde9f90":"9HEEB","3d4f4a70610366eb":"i5QZF","b27b922e550fb44":"6wuE2","c03b794b3310623a":"3jukv","eb02d380c827a60f":"hiBkr","5648ef50c8d255b3":"2TuIZ"}],"ibRbZ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("82fc0d8e0d8446fa");
var React = require("abc408455dbc03d1");
var ScrollArea_context = require("8bec10e8e84c84fd");
var ScrollAreaScrollbarAuto = require("ec794fa799ea6647");
var ScrollAreaScrollbarHover = React.forwardRef(function(props, ref) {
    var forceMount = props.forceMount, scrollbarProps = (0, _objectWithoutProperties._)(props, [
        "forceMount"
    ]);
    var context = ScrollArea_context.useScrollAreaContext();
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), visible = _React_useState[0], setVisible = _React_useState[1];
    React.useEffect(function() {
        var scrollArea = context.scrollArea;
        var hideTimer = 0;
        if (scrollArea) {
            var handlePointerEnter = function() {
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            var handlePointerLeave = function() {
                hideTimer = window.setTimeout(function() {
                    return setVisible(false);
                }, context.scrollHideDelay);
            };
            scrollArea.addEventListener("pointerenter", handlePointerEnter);
            scrollArea.addEventListener("pointerleave", handlePointerLeave);
            return function() {
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener("pointerenter", handlePointerEnter);
                scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
        return void 0;
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    if (forceMount || visible) return /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbarAuto.ScrollAreaScrollbarAuto, (0, _objectSpreadProps._)((0, _objectSpread._)({
        "data-state": visible ? "visible" : "hidden"
    }, scrollbarProps), {
        ref
    }));
    return null;
});
ScrollAreaScrollbarHover.displayName = "@mantine/core/ScrollAreaScrollbarHover";
exports.ScrollAreaScrollbarHover = ScrollAreaScrollbarHover; //# sourceMappingURL=ScrollAreaScrollbarHover.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","82fc0d8e0d8446fa":"iKGFf","abc408455dbc03d1":"9MtAM","8bec10e8e84c84fd":"i5QZF","ec794fa799ea6647":"lusse"}],"avnae":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("d8cb0f4edc10862c");
var React = require("7ecb57e7a1c2f867");
var hooks = require("63906a42e4bab1e2");
var ScrollArea_context = require("46feab3a63303967");
var composeEventHandlers = require("add45687a94a5ff5");
var ScrollAreaScrollbarVisible = require("23397afc469c5050");
var ScrollAreaScrollbarScroll = React.forwardRef(function(props, red) {
    var forceMount = props.forceMount, scrollbarProps = (0, _objectWithoutProperties._)(props, [
        "forceMount"
    ]);
    var context = ScrollArea_context.useScrollAreaContext();
    var isHorizontal = props.orientation === "horizontal";
    var _React_useState = (0, _slicedToArray._)(React.useState("hidden"), 2), state = _React_useState[0], setState = _React_useState[1];
    var debounceScrollEnd = hooks.useDebouncedCallback(function() {
        return setState("idle");
    }, 100);
    React.useEffect(function() {
        if (state === "idle") {
            var hideTimer = window.setTimeout(function() {
                return setState("hidden");
            }, context.scrollHideDelay);
            return function() {
                return window.clearTimeout(hideTimer);
            };
        }
        return void 0;
    }, [
        state,
        context.scrollHideDelay
    ]);
    React.useEffect(function() {
        var viewport = context.viewport;
        var scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            var prevScrollPos = viewport[scrollDirection];
            var handleScroll = function() {
                var scrollPos = viewport[scrollDirection];
                var hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    setState("scrolling");
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener("scroll", handleScroll);
            return function() {
                return viewport.removeEventListener("scroll", handleScroll);
            };
        }
        return void 0;
    }, [
        context.viewport,
        isHorizontal,
        debounceScrollEnd
    ]);
    if (forceMount || state !== "hidden") return /* @__PURE__ */ jsxRuntime.jsx(ScrollAreaScrollbarVisible.ScrollAreaScrollbarVisible, (0, _objectSpreadProps._)((0, _objectSpread._)({
        "data-state": state === "hidden" ? "hidden" : "visible"
    }, scrollbarProps), {
        ref: red,
        onPointerEnter: composeEventHandlers.composeEventHandlers(props.onPointerEnter, function() {
            return setState("interacting");
        }),
        onPointerLeave: composeEventHandlers.composeEventHandlers(props.onPointerLeave, function() {
            return setState("idle");
        })
    }));
    return null;
});
exports.ScrollAreaScrollbarScroll = ScrollAreaScrollbarScroll; //# sourceMappingURL=ScrollAreaScrollbarScroll.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","d8cb0f4edc10862c":"iKGFf","7ecb57e7a1c2f867":"9MtAM","63906a42e4bab1e2":"9HEEB","46feab3a63303967":"i5QZF","add45687a94a5ff5":"8P9jr","23397afc469c5050":"lDv19"}],"dBsKu":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("d453a2f62a907996");
var React = require("1a845eac2246d1bc");
var hooks = require("16e924684f122645");
var ScrollArea_context = require("b35aa57f225c32f4");
var Scrollbar_context = require("1cd0982975df9e8f");
var composeEventHandlers = require("35804c0004962852");
var addUnlinkedScrollListener = require("41a63b848646a38f");
var Thumb = React.forwardRef(function(props, forwardedRef) {
    var style = props.style, others = (0, _objectWithoutProperties._)(props, [
        "style"
    ]);
    var scrollAreaContext = ScrollArea_context.useScrollAreaContext();
    var scrollbarContext = Scrollbar_context.useScrollbarContext();
    var onThumbPositionChange = scrollbarContext.onThumbPositionChange;
    var composedRef = hooks.useMergedRef(forwardedRef, function(node) {
        return scrollbarContext.onThumbChange(node);
    });
    var removeUnlinkedScrollListenerRef = React.useRef(void 0);
    var debounceScrollEnd = hooks.useDebouncedCallback(function() {
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = void 0;
        }
    }, 100);
    React.useEffect(function() {
        var viewport = scrollAreaContext.viewport;
        if (viewport) {
            var handleScroll = function() {
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    var listener = addUnlinkedScrollListener.addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener("scroll", handleScroll);
            return function() {
                return viewport.removeEventListener("scroll", handleScroll);
            };
        }
        return void 0;
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden"
    }, others), {
        ref: composedRef,
        style: (0, _objectSpread._)({
            width: "var(--sa-thumb-width)",
            height: "var(--sa-thumb-height)"
        }, style),
        onPointerDownCapture: composeEventHandlers.composeEventHandlers(props.onPointerDownCapture, function(event) {
            var thumb = event.target;
            var thumbRect = thumb.getBoundingClientRect();
            var x = event.clientX - thumbRect.left;
            var y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x,
                y
            });
        }),
        onPointerUp: composeEventHandlers.composeEventHandlers(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    }));
});
Thumb.displayName = "@mantine/core/ScrollAreaThumb";
var ScrollAreaThumb = React.forwardRef(function(props, forwardedRef) {
    var forceMount = props.forceMount, thumbProps = (0, _objectWithoutProperties._)(props, [
        "forceMount"
    ]);
    var scrollbarContext = Scrollbar_context.useScrollbarContext();
    if (forceMount || scrollbarContext.hasThumb) return /* @__PURE__ */ jsxRuntime.jsx(Thumb, (0, _objectSpread._)({
        ref: forwardedRef
    }, thumbProps));
    return null;
});
ScrollAreaThumb.displayName = "@mantine/core/ScrollAreaThumb";
exports.ScrollAreaThumb = ScrollAreaThumb;
exports.Thumb = Thumb; //# sourceMappingURL=ScrollAreaThumb.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","d453a2f62a907996":"iKGFf","1a845eac2246d1bc":"9MtAM","16e924684f122645":"9HEEB","b35aa57f225c32f4":"i5QZF","1cd0982975df9e8f":"PHGtZ","35804c0004962852":"8P9jr","41a63b848646a38f":"cZTlN"}],"cZTlN":[function(require,module,exports) {
"use client";
"use strict";
function addUnlinkedScrollListener(node) {
    var handler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    var rAF = 0;
    (function loop() {
        var position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        var isHorizontalScroll = prevPosition.left !== position.left;
        var isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return function() {
        return window.cancelAnimationFrame(rAF);
    };
}
exports.addUnlinkedScrollListener = addUnlinkedScrollListener; //# sourceMappingURL=add-unlinked-scroll-listener.cjs.map

},{}],"lK4gs":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("18362cba0ac9bfd0");
var React = require("b21e4a8e8ec54d05");
var hooks = require("6af0763411d0dba4");
require("2e984bf020fb4971");
require("79e33db2f576f4dd");
require("6dcb568ba9dcfb47");
require("d6caa8650ca47133");
require("ca72ec6ab9827aa8");
require("b2837ce2db4138a5");
var Box = require("6208898b83ea12a");
require("65c79e8e518b0f84");
var ScrollArea_context = require("bb208d353e954070");
var ScrollAreaViewport = React.forwardRef(function(_param, ref) {
    var children = _param.children, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "children",
        "style"
    ]);
    var ctx = ScrollArea_context.useScrollAreaContext();
    var rootRef = hooks.useMergedRef(ref, ctx.onViewportChange);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref: rootRef,
        style: (0, _objectSpread._)({
            overflowX: ctx.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: ctx.scrollbarYEnabled ? "scroll" : "hidden"
        }, style),
        children: /* @__PURE__ */ jsxRuntime.jsx("div", {
            style: {
                minWidth: "100%"
            },
            ref: ctx.onContentChange,
            children
        })
    }));
});
ScrollAreaViewport.displayName = "@mantine/core/ScrollAreaViewport";
exports.ScrollAreaViewport = ScrollAreaViewport; //# sourceMappingURL=ScrollAreaViewport.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","18362cba0ac9bfd0":"iKGFf","b21e4a8e8ec54d05":"9MtAM","6af0763411d0dba4":"9HEEB","2e984bf020fb4971":"8QFOC","79e33db2f576f4dd":"2FdJg","6dcb568ba9dcfb47":"6AMGA","d6caa8650ca47133":"erSvz","ca72ec6ab9827aa8":"kqQOF","b2837ce2db4138a5":"8YP4O","6208898b83ea12a":"gkGXc","65c79e8e518b0f84":"2onWA","bb208d353e954070":"i5QZF"}],"eB8nn":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_d57069b5",
    "viewport": "m_c0783ff9",
    "viewportInner": "m_f8f631dd",
    "scrollbar": "m_c44ba933",
    "thumb": "m_d8b5e363",
    "corner": "m_21657268"
};
module.exports = classes; //# sourceMappingURL=ScrollArea.module.css.cjs.map

},{}],"cArqr":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("728b3e04c1adc08c");
require("60aa75c41c70f02f");
require("a838072b903c13b9");
require("3c39f50193068b5e");
require("68de3b3a5ee708fc");
require("3b6477271a27170c");
require("db155a9d895212a7");
require("282cccfde27e6865");
var useProps = require("d1d8ac6287bae0e0");
require("d147e52c10a6b52a");
var useStyles = require("5a89452d964d541d");
var Box = require("1ea448c63aca6a6c");
var polymorphicFactory = require("958c93437b40a889");
require("23d035c728f67718");
var UnstyledButton_module = require("a2304a5c5c1f0bd0");
var defaultProps = {
    __staticSelector: "UnstyledButton"
};
var UnstyledButton = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("UnstyledButton", defaultProps, _props);
    var className = props.className, _props_component = props.component, component = _props_component === void 0 ? "button" : _props_component, __staticSelector = props.__staticSelector, unstyled = props.unstyled, classNames = props.classNames, styles = props.styles, style = props.style, others = (0, _objectWithoutProperties._)(props, [
        "className",
        "component",
        "__staticSelector",
        "unstyled",
        "classNames",
        "styles",
        "style"
    ]);
    var getStyles = useStyles.useStyles({
        name: __staticSelector,
        props,
        classes: UnstyledButton_module,
        className,
        style,
        classNames,
        styles,
        unstyled
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root", {
        focusable: true
    })), {
        component,
        ref,
        type: component === "button" ? "button" : void 0
    }), others));
});
UnstyledButton.classes = UnstyledButton_module;
UnstyledButton.displayName = "@mantine/core/UnstyledButton";
exports.UnstyledButton = UnstyledButton; //# sourceMappingURL=UnstyledButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","728b3e04c1adc08c":"iKGFf","60aa75c41c70f02f":"9MtAM","a838072b903c13b9":"9HEEB","3c39f50193068b5e":"8QFOC","68de3b3a5ee708fc":"2FdJg","3b6477271a27170c":"6AMGA","db155a9d895212a7":"erSvz","282cccfde27e6865":"kqQOF","d1d8ac6287bae0e0":"iivvn","d147e52c10a6b52a":"8YP4O","5a89452d964d541d":"d0sAY","1ea448c63aca6a6c":"gkGXc","958c93437b40a889":"iYAEL","23d035c728f67718":"2onWA","a2304a5c5c1f0bd0":"9iZPF"}],"9iZPF":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_87cf2631"
};
module.exports = classes; //# sourceMappingURL=UnstyledButton.module.css.cjs.map

},{}],"eOPpk":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("4b6210cc8b3f3d0");
require("cb74e9a19269ec4a");
require("4b37bd0d658348dd");
require("b33920b4f359cbbe");
require("d7bd650449dde556");
require("8aa395257a50d954");
require("db4ea2ff8e5b05c6");
require("bcb2704d20c43839");
var useProps = require("d0dce86818758a01");
require("c4b9645c354c1c4");
var useStyles = require("270b99a0aedac46d");
var Box = require("c2cfb5a560c232cb");
var factory = require("ac504073a6d55f8a");
require("42bc17c6439225a4");
var VisuallyHidden_module = require("5f6bdd882ee2076e");
var defaultProps = {};
var VisuallyHidden = factory.factory(function(_props, ref) {
    var props = useProps.useProps("VisuallyHidden", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars"
    ]);
    var getStyles = useStyles.useStyles({
        name: "VisuallyHidden",
        classes: VisuallyHidden_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        component: "span",
        ref
    }, getStyles("root"), others));
});
VisuallyHidden.classes = VisuallyHidden_module;
VisuallyHidden.displayName = "@mantine/core/VisuallyHidden";
exports.VisuallyHidden = VisuallyHidden; //# sourceMappingURL=VisuallyHidden.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","4b6210cc8b3f3d0":"iKGFf","cb74e9a19269ec4a":"9MtAM","4b37bd0d658348dd":"9HEEB","b33920b4f359cbbe":"8QFOC","d7bd650449dde556":"2FdJg","8aa395257a50d954":"6AMGA","db4ea2ff8e5b05c6":"erSvz","bcb2704d20c43839":"kqQOF","d0dce86818758a01":"iivvn","c4b9645c354c1c4":"8YP4O","270b99a0aedac46d":"d0sAY","c2cfb5a560c232cb":"gkGXc","ac504073a6d55f8a":"guLFz","42bc17c6439225a4":"2onWA","5f6bdd882ee2076e":"2qWuq"}],"2qWuq":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_515a97f8"
};
module.exports = classes; //# sourceMappingURL=VisuallyHidden.module.css.cjs.map

},{}],"amEW4":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("d1d9a0cf7d5fc99f");
require("902b9d8d00a3a950");
var getSize = require("7506f3f03715083");
require("ea465747dad3350e");
var createVarsResolver = require("1c599e1456b3aa87");
require("4a002de4dd30d924");
require("557d13781d15c3df");
require("d49e38370408004b");
require("38356574eea176cb");
require("2e0809dd67dedc83");
var useProps = require("bb3edfc8715b9ff1");
require("489535bdf5d17819");
var useStyles = require("c6481ff24d67b7b6");
var Box = require("2f4bf33b5f92a34c");
var polymorphicFactory = require("4383944d04dc9aef");
require("fd0a990bb000f3f4");
var Paper_module = require("9415afc6cb5a9501");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius, shadow = param.shadow;
    return {
        root: {
            "--paper-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--paper-shadow": getSize.getShadow(shadow)
        }
    };
});
var Paper = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Paper", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, withBorder = props.withBorder, vars = props.vars, radius = props.radius, shadow = props.shadow, variant = props.variant, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "withBorder",
        "vars",
        "radius",
        "shadow",
        "variant",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Paper",
        props,
        classes: Paper_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        mod: [
            {
                "data-with-border": withBorder
            },
            mod
        ]
    }, getStyles("root")), {
        variant
    }), others));
});
Paper.classes = Paper_module;
Paper.displayName = "@mantine/core/Paper";
exports.Paper = Paper; //# sourceMappingURL=Paper.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","d1d9a0cf7d5fc99f":"iKGFf","902b9d8d00a3a950":"9MtAM","7506f3f03715083":"kEFEY","ea465747dad3350e":"9HEEB","1c599e1456b3aa87":"hIQE6","4a002de4dd30d924":"8QFOC","557d13781d15c3df":"2FdJg","d49e38370408004b":"6AMGA","38356574eea176cb":"erSvz","2e0809dd67dedc83":"kqQOF","bb3edfc8715b9ff1":"iivvn","489535bdf5d17819":"8YP4O","c6481ff24d67b7b6":"d0sAY","2f4bf33b5f92a34c":"gkGXc","4383944d04dc9aef":"iYAEL","fd0a990bb000f3f4":"2onWA","9415afc6cb5a9501":"1yalK"}],"1yalK":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_1b7284a3"
};
module.exports = classes; //# sourceMappingURL=Paper.module.css.cjs.map

},{}],"4oc3k":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("c526dfce4ad86796");
var React = require("bc28d0b24ba845ba");
var hooks = require("c76533972f6bc9d5");
var getDefaultZIndex = require("ba4f8757f5b1e1e2");
var getSize = require("c3aef665970b9f2e");
var createVarsResolver = require("30ec130bea03f42e");
require("c40c6b2f7e7cd7ec");
var useResolvedStylesApi = require("114958c50265f0d7");
var useStyles = require("936ff82f4c38a823");
require("105849ffb095f68f");
require("db18defb25b9a96b");
require("4872736e8c583453");
require("e6746076014c92e0");
var useProps = require("d04ccecb334460dc");
require("40c8ec6a37576e2a");
require("f385edd622d69da8");
var DirectionProvider = require("94c90591ef227a29");
require("daf27f339fc617f7");
var getFloatingPosition = require("3c9b67d314975457");
require("8833291f81c13550");
var Overlay = require("650e8af4391a7f50");
require("51b2ab654167270d");
var OptionalPortal = require("73e52d0ade0ef4e7");
var Transition = require("59dc36b2aefa608a");
var Popover_context = require("2da071a2af309601");
var PopoverDropdown = require("b3d01c912acfdfbb");
var PopoverTarget = require("4ccb00fc214ae0bf");
var usePopover = require("b4092a56878a6946");
var Popover_module = require("c5b75358f94a0109");
var defaultProps = {
    position: "bottom",
    offset: 8,
    positionDependencies: [],
    transitionProps: {
        transition: "fade",
        duration: 150
    },
    middlewares: {
        flip: true,
        shift: true,
        inline: false
    },
    arrowSize: 7,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    closeOnClickOutside: true,
    withinPortal: true,
    closeOnEscape: true,
    trapFocus: false,
    withRoles: true,
    returnFocus: false,
    withOverlay: false,
    clickOutsideEvents: [
        "mousedown",
        "touchstart"
    ],
    zIndex: getDefaultZIndex.getDefaultZIndex("popover"),
    __staticSelector: "Popover",
    width: "max-content"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius, shadow = param.shadow;
    return {
        dropdown: {
            "--popover-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--popover-shadow": getSize.getShadow(shadow)
        }
    };
});
function Popover(_props) {
    var _popover_floating_middlewareData_arrow, _popover_floating_middlewareData, _popover_floating, _popover_floating_middlewareData_arrow1, _popover_floating_middlewareData1, _popover_floating1;
    var props = useProps.useProps("Popover", defaultProps, _props);
    var children = props.children, position = props.position, offset = props.offset, onPositionChange = props.onPositionChange, positionDependencies = props.positionDependencies, opened = props.opened, transitionProps = props.transitionProps, onExitTransitionEnd = props.onExitTransitionEnd, onEnterTransitionEnd = props.onEnterTransitionEnd, width = props.width, middlewares = props.middlewares, withArrow = props.withArrow, arrowSize = props.arrowSize, arrowOffset = props.arrowOffset, arrowRadius = props.arrowRadius, arrowPosition = props.arrowPosition, unstyled = props.unstyled, classNames = props.classNames, styles = props.styles, closeOnClickOutside = props.closeOnClickOutside, withinPortal = props.withinPortal, portalProps = props.portalProps, closeOnEscape = props.closeOnEscape, clickOutsideEvents = props.clickOutsideEvents, trapFocus = props.trapFocus, onClose = props.onClose, onDismiss = props.onDismiss, onOpen = props.onOpen, onChange = props.onChange, zIndex = props.zIndex, radius = props.radius, shadow = props.shadow, id = props.id, defaultOpened = props.defaultOpened, __staticSelector = props.__staticSelector, withRoles = props.withRoles, disabled = props.disabled, returnFocus = props.returnFocus, variant = props.variant, keepMounted = props.keepMounted, vars = props.vars, floatingStrategy = props.floatingStrategy, withOverlay = props.withOverlay, overlayProps = props.overlayProps, others = (0, _objectWithoutProperties._)(props, [
        "children",
        "position",
        "offset",
        "onPositionChange",
        "positionDependencies",
        "opened",
        "transitionProps",
        "onExitTransitionEnd",
        "onEnterTransitionEnd",
        "width",
        "middlewares",
        "withArrow",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "unstyled",
        "classNames",
        "styles",
        "closeOnClickOutside",
        "withinPortal",
        "portalProps",
        "closeOnEscape",
        "clickOutsideEvents",
        "trapFocus",
        "onClose",
        "onDismiss",
        "onOpen",
        "onChange",
        "zIndex",
        "radius",
        "shadow",
        "id",
        "defaultOpened",
        "__staticSelector",
        "withRoles",
        "disabled",
        "returnFocus",
        "variant",
        "keepMounted",
        "vars",
        "floatingStrategy",
        "withOverlay",
        "overlayProps"
    ]);
    var getStyles = useStyles.useStyles({
        name: __staticSelector,
        props,
        classes: Popover_module,
        classNames,
        styles,
        unstyled,
        rootSelector: "dropdown",
        vars,
        varsResolver
    });
    var resolvedStyles = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }).resolvedStyles;
    var arrowRef = React.useRef(null);
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), targetNode = _React_useState[0], setTargetNode = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(null), 2), dropdownNode = _React_useState1[0], setDropdownNode = _React_useState1[1];
    var dir = DirectionProvider.useDirection().dir;
    var uid = hooks.useId(id);
    var popover = usePopover.usePopover({
        middlewares,
        width,
        position: getFloatingPosition.getFloatingPosition(dir, position),
        offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
        arrowRef,
        arrowOffset,
        onPositionChange,
        positionDependencies,
        opened,
        defaultOpened,
        onChange,
        onOpen,
        onClose,
        onDismiss,
        strategy: floatingStrategy
    });
    hooks.useClickOutside(function() {
        if (closeOnClickOutside) {
            popover.onClose();
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        }
    }, clickOutsideEvents, [
        targetNode,
        dropdownNode
    ]);
    var reference = React.useCallback(function(node) {
        setTargetNode(node);
        popover.floating.refs.setReference(node);
    }, [
        popover.floating.refs.setReference
    ]);
    var floating = React.useCallback(function(node) {
        setDropdownNode(node);
        popover.floating.refs.setFloating(node);
    }, [
        popover.floating.refs.setFloating
    ]);
    var onExited = React.useCallback(function() {
        var _transitionProps_onExited;
        transitionProps === null || transitionProps === void 0 ? void 0 : (_transitionProps_onExited = transitionProps.onExited) === null || _transitionProps_onExited === void 0 ? void 0 : _transitionProps_onExited.call(transitionProps);
        onExitTransitionEnd === null || onExitTransitionEnd === void 0 ? void 0 : onExitTransitionEnd();
    }, [
        transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.onExited,
        onExitTransitionEnd
    ]);
    var onEntered = React.useCallback(function() {
        var _transitionProps_onEntered;
        transitionProps === null || transitionProps === void 0 ? void 0 : (_transitionProps_onEntered = transitionProps.onEntered) === null || _transitionProps_onEntered === void 0 ? void 0 : _transitionProps_onEntered.call(transitionProps);
        onEnterTransitionEnd === null || onEnterTransitionEnd === void 0 ? void 0 : onEnterTransitionEnd();
    }, [
        transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.onEntered,
        onEnterTransitionEnd
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs(Popover_context.PopoverContextProvider, {
        value: {
            returnFocus,
            disabled,
            controlled: popover.controlled,
            reference,
            floating,
            x: popover.floating.x,
            y: popover.floating.y,
            arrowX: (_popover_floating = popover.floating) === null || _popover_floating === void 0 ? void 0 : (_popover_floating_middlewareData = _popover_floating.middlewareData) === null || _popover_floating_middlewareData === void 0 ? void 0 : (_popover_floating_middlewareData_arrow = _popover_floating_middlewareData.arrow) === null || _popover_floating_middlewareData_arrow === void 0 ? void 0 : _popover_floating_middlewareData_arrow.x,
            arrowY: (_popover_floating1 = popover.floating) === null || _popover_floating1 === void 0 ? void 0 : (_popover_floating_middlewareData1 = _popover_floating1.middlewareData) === null || _popover_floating_middlewareData1 === void 0 ? void 0 : (_popover_floating_middlewareData_arrow1 = _popover_floating_middlewareData1.arrow) === null || _popover_floating_middlewareData_arrow1 === void 0 ? void 0 : _popover_floating_middlewareData_arrow1.y,
            opened: popover.opened,
            arrowRef,
            transitionProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, transitionProps), {
                onExited,
                onEntered
            }),
            width,
            withArrow,
            arrowSize,
            arrowOffset,
            arrowRadius,
            arrowPosition,
            placement: popover.floating.placement,
            trapFocus,
            withinPortal,
            portalProps,
            zIndex,
            radius,
            shadow,
            closeOnEscape,
            onDismiss,
            onClose: popover.onClose,
            onToggle: popover.onToggle,
            getTargetId: function() {
                return `${uid}-target`;
            },
            getDropdownId: function() {
                return `${uid}-dropdown`;
            },
            withRoles,
            targetProps: others,
            __staticSelector,
            classNames,
            styles,
            unstyled,
            variant,
            keepMounted,
            getStyles,
            resolvedStyles,
            floatingStrategy
        },
        children: [
            children,
            withOverlay && /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, {
                transition: "fade",
                mounted: popover.opened,
                duration: (transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.duration) || 250,
                exitDuration: (transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.exitDuration) || 250,
                children: function(transitionStyles) {
                    return /* @__PURE__ */ jsxRuntime.jsx(OptionalPortal.OptionalPortal, {
                        withinPortal,
                        children: /* @__PURE__ */ jsxRuntime.jsx(Overlay.Overlay, (0, _objectSpread._)({}, overlayProps, getStyles("overlay", {
                            className: overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.className,
                            style: [
                                transitionStyles,
                                overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.style
                            ]
                        })))
                    });
                }
            })
        ]
    });
}
Popover.Target = PopoverTarget.PopoverTarget;
Popover.Dropdown = PopoverDropdown.PopoverDropdown;
Popover.displayName = "@mantine/core/Popover";
Popover.extend = function(input) {
    return input;
};
exports.Popover = Popover; //# sourceMappingURL=Popover.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","c526dfce4ad86796":"iKGFf","bc28d0b24ba845ba":"9MtAM","c76533972f6bc9d5":"9HEEB","ba4f8757f5b1e1e2":"4gavl","c3aef665970b9f2e":"kEFEY","30ec130bea03f42e":"hIQE6","c40c6b2f7e7cd7ec":"8QFOC","114958c50265f0d7":"d30sL","936ff82f4c38a823":"d0sAY","105849ffb095f68f":"2FdJg","db18defb25b9a96b":"6AMGA","4872736e8c583453":"erSvz","e6746076014c92e0":"kqQOF","d04ccecb334460dc":"iivvn","40c8ec6a37576e2a":"8YP4O","f385edd622d69da8":"gkGXc","94c90591ef227a29":"2onWA","daf27f339fc617f7":"jrkk4","3c9b67d314975457":"1B14J","8833291f81c13550":"kAWqL","650e8af4391a7f50":"9e5lu","51b2ab654167270d":"6YZdR","73e52d0ade0ef4e7":"3Y9Li","59dc36b2aefa608a":"2T0Xr","2da071a2af309601":"1wVSd","b3d01c912acfdfbb":"b7S6t","4ccb00fc214ae0bf":"iz4SD","b4092a56878a6946":"ki31H","c5b75358f94a0109":"lR0hj"}],"1B14J":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
function getFloatingPosition(dir, position) {
    if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
        var _position_split = (0, _slicedToArray._)(position.split("-"), 2), side = _position_split[0], placement = _position_split[1];
        var flippedPosition = side === "right" ? "left" : "right";
        return placement === void 0 ? flippedPosition : `${flippedPosition}-${placement}`;
    }
    return position;
}
exports.getFloatingPosition = getFloatingPosition; //# sourceMappingURL=get-floating-position.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5"}],"kAWqL":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2c8d52d37b34d048");
var React = require("7eaf10f2ddc8d911");
require("828df27fa6353e7c");
require("e45af0e9663af26a");
require("3d368ae5684229ac");
require("3f5b9d228aa4ef63");
require("655de49f9cc34260");
require("a892207a5656e6f2");
require("825c4d3086ffd61d");
require("2f5c17e78e4d4777");
var DirectionProvider = require("5466c2bc396661ce");
var getArrowPositionStyles = require("2430cc1fe2b5efaa");
var FloatingArrow = React.forwardRef(function(_param, ref) {
    var position = _param.position, arrowSize = _param.arrowSize, arrowOffset = _param.arrowOffset, arrowRadius = _param.arrowRadius, arrowPosition = _param.arrowPosition, visible = _param.visible, arrowX = _param.arrowX, arrowY = _param.arrowY, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "position",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "visible",
        "arrowX",
        "arrowY",
        "style"
    ]);
    var dir = DirectionProvider.useDirection().dir;
    if (!visible) return null;
    return /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref,
        style: (0, _objectSpread._)({}, style, getArrowPositionStyles.getArrowPositionStyles({
            position,
            arrowSize,
            arrowOffset,
            arrowRadius,
            arrowPosition,
            dir,
            arrowX,
            arrowY
        }))
    }));
});
FloatingArrow.displayName = "@mantine/core/FloatingArrow";
exports.FloatingArrow = FloatingArrow; //# sourceMappingURL=FloatingArrow.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","2c8d52d37b34d048":"iKGFf","7eaf10f2ddc8d911":"9MtAM","828df27fa6353e7c":"9HEEB","e45af0e9663af26a":"8QFOC","3d368ae5684229ac":"2FdJg","3f5b9d228aa4ef63":"6AMGA","655de49f9cc34260":"erSvz","a892207a5656e6f2":"kqQOF","825c4d3086ffd61d":"8YP4O","2f5c17e78e4d4777":"gkGXc","5466c2bc396661ce":"2onWA","2430cc1fe2b5efaa":"5Ph8B"}],"5Ph8B":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") return {
        top: arrowY
    };
    if (placement === "end") return {
        bottom: arrowOffset
    };
    if (placement === "start") return {
        top: arrowOffset
    };
    return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") return {
        left: arrowX
    };
    if (placement === "end") return {
        [dir === "ltr" ? "right" : "left"]: arrowOffset
    };
    if (placement === "start") return {
        [dir === "ltr" ? "left" : "right"]: arrowOffset
    };
    return {};
}
var radiusByFloatingSide = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function getArrowPositionStyles(param) {
    var position = param.position, arrowSize = param.arrowSize, arrowOffset = param.arrowOffset, arrowRadius = param.arrowRadius, arrowPosition = param.arrowPosition, arrowX = param.arrowX, arrowY = param.arrowY, dir = param.dir;
    var _position_split = (0, _slicedToArray._)(position.split("-"), 2), side = _position_split[0], tmp = _position_split[1], placement = tmp === void 0 ? "center" : tmp;
    var baseStyles = {
        width: arrowSize,
        height: arrowSize,
        transform: "rotate(45deg)",
        position: "absolute",
        [radiusByFloatingSide[side]]: arrowRadius
    };
    var arrowPlacement = -arrowSize / 2;
    if (side === "left") return (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseStyles, horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
        right: arrowPlacement,
        borderLeftColor: "transparent",
        borderBottomColor: "transparent",
        clipPath: "polygon(100% 0, 0 0, 100% 100%)"
    });
    if (side === "right") return (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseStyles, horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
        left: arrowPlacement,
        borderRightColor: "transparent",
        borderTopColor: "transparent",
        clipPath: "polygon(0 100%, 0 0, 100% 100%)"
    });
    if (side === "top") return (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseStyles, verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
        bottom: arrowPlacement,
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        clipPath: "polygon(0 100%, 100% 100%, 100% 0)"
    });
    if (side === "bottom") return (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseStyles, verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
        top: arrowPlacement,
        borderBottomColor: "transparent",
        borderRightColor: "transparent",
        clipPath: "polygon(0 100%, 0 0, 100% 0)"
    });
    return {};
}
exports.getArrowPositionStyles = getArrowPositionStyles; //# sourceMappingURL=get-arrow-position-styles.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5"}],"9e5lu":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a2cdd5a0b4c5e22f");
var rem = require("5b1bd6c09876fc6");
require("e6a08a26f4f565dd");
var getDefaultZIndex = require("d4f26a8c21437a96");
var getSize = require("6679b92058d0ab37");
require("4b990bee313d6ef");
var createVarsResolver = require("f7203dd85496aef1");
require("27433cb912e4ecc");
var rgba = require("97d2ee09fa81b192");
require("71f3456c04b00862");
require("dc6a4487114b3a7d");
require("e2af6fe000e5392");
require("360785be759d5ef5");
var useProps = require("237e119787454dd3");
require("8c02c08e17aa952c");
var useStyles = require("f383b92bee557de7");
var Box = require("81f30ce149ca404");
var polymorphicFactory = require("5a4ae1d8c9a5e364");
require("5b780a31aa7d0552");
var Overlay_module = require("7221ef765c880f3a");
var defaultProps = {
    zIndex: getDefaultZIndex.getDefaultZIndex("modal")
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var gradient = param.gradient, color = param.color, backgroundOpacity = param.backgroundOpacity, blur = param.blur, radius = param.radius, zIndex = param.zIndex;
    return {
        root: {
            "--overlay-bg": gradient || (color !== void 0 || backgroundOpacity !== void 0) && rgba.rgba(color || "#000", backgroundOpacity !== null && backgroundOpacity !== void 0 ? backgroundOpacity : 0.6) || void 0,
            "--overlay-filter": blur ? `blur(${rem.rem(blur)})` : void 0,
            "--overlay-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--overlay-z-index": zIndex === null || zIndex === void 0 ? void 0 : zIndex.toString()
        }
    };
});
var Overlay = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Overlay", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, fixed = props.fixed, center = props.center, children = props.children, radius = props.radius, zIndex = props.zIndex, gradient = props.gradient, blur = props.blur, color = props.color, backgroundOpacity = props.backgroundOpacity, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "fixed",
        "center",
        "children",
        "radius",
        "zIndex",
        "gradient",
        "blur",
        "color",
        "backgroundOpacity",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Overlay",
        props,
        classes: Overlay_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("root")), {
        mod: [
            {
                center,
                fixed
            },
            mod
        ]
    }), others), {
        children
    }));
});
Overlay.classes = Overlay_module;
Overlay.displayName = "@mantine/core/Overlay";
exports.Overlay = Overlay; //# sourceMappingURL=Overlay.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","a2cdd5a0b4c5e22f":"iKGFf","5b1bd6c09876fc6":"ebAaL","e6a08a26f4f565dd":"9MtAM","d4f26a8c21437a96":"4gavl","6679b92058d0ab37":"kEFEY","4b990bee313d6ef":"9HEEB","f7203dd85496aef1":"hIQE6","27433cb912e4ecc":"8QFOC","97d2ee09fa81b192":"aIray","71f3456c04b00862":"2FdJg","dc6a4487114b3a7d":"6AMGA","e2af6fe000e5392":"erSvz","360785be759d5ef5":"kqQOF","237e119787454dd3":"iivvn","8c02c08e17aa952c":"8YP4O","f383b92bee557de7":"d0sAY","81f30ce149ca404":"gkGXc","5a4ae1d8c9a5e364":"iYAEL","5b780a31aa7d0552":"2onWA","7221ef765c880f3a":"630Pg"}],"630Pg":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_9814e45f"
};
module.exports = classes; //# sourceMappingURL=Overlay.module.css.cjs.map

},{}],"6YZdR":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("3fa8ec9b6df54532");
var React = require("1756f72b2bc54afa");
var ReactDOM = require("5b2d8bf3aa7e2d8e");
var hooks = require("1d7ae3e11ff17872");
require("3333b8b3a4b01e42");
require("5f7e03f214b99231");
require("8b37773b21de7afc");
require("6e31d76a6dde798a");
require("9e159099df8f5396");
var useProps = require("4dc994ca1ecddb69");
require("ae5cc427fb559ac3");
require("c9ce274dea7171df");
var factory = require("23144ee9bd071abf");
require("f35afe0b973b8e23");
function createPortalNode(props) {
    var _node_classList;
    var node = document.createElement("div");
    node.setAttribute("data-portal", "true");
    typeof props.className === "string" && (_node_classList = node.classList).add.apply(_node_classList, (0, _toConsumableArray._)(props.className.split(" ").filter(Boolean)));
    typeof props.style === "object" && Object.assign(node.style, props.style);
    typeof props.id === "string" && node.setAttribute("id", props.id);
    return node;
}
function getTargetNode(_param) {
    var target = _param.target, reuseTargetNode = _param.reuseTargetNode, others = (0, _objectWithoutProperties._)(_param, [
        "target",
        "reuseTargetNode"
    ]);
    if (target) {
        if (typeof target === "string") return document.querySelector(target) || createPortalNode(others);
        return target;
    }
    if (reuseTargetNode) {
        var existingNode = document.querySelector("[data-mantine-shared-portal-node]");
        if (existingNode) return existingNode;
        var node = createPortalNode(others);
        node.setAttribute("data-mantine-shared-portal-node", "true");
        document.body.appendChild(node);
        return node;
    }
    return createPortalNode(others);
}
var defaultProps = {};
var Portal = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("Portal", defaultProps, props), children = _useProps_useProps.children, target = _useProps_useProps.target, reuseTargetNode = _useProps_useProps.reuseTargetNode, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "target",
        "reuseTargetNode"
    ]);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), mounted = _React_useState[0], setMounted = _React_useState[1];
    var nodeRef = React.useRef(null);
    hooks.useIsomorphicEffect(function() {
        setMounted(true);
        nodeRef.current = getTargetNode((0, _objectSpread._)({
            target,
            reuseTargetNode
        }, others));
        hooks.assignRef(ref, nodeRef.current);
        if (!target && !reuseTargetNode && nodeRef.current) document.body.appendChild(nodeRef.current);
        return function() {
            if (!target && !reuseTargetNode && nodeRef.current) document.body.removeChild(nodeRef.current);
        };
    }, [
        target
    ]);
    if (!mounted || !nodeRef.current) return null;
    return ReactDOM.createPortal(/* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children
    }), nodeRef.current);
});
Portal.displayName = "@mantine/core/Portal";
exports.Portal = Portal; //# sourceMappingURL=Portal.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","3fa8ec9b6df54532":"iKGFf","1756f72b2bc54afa":"9MtAM","5b2d8bf3aa7e2d8e":"5Yfvl","1d7ae3e11ff17872":"9HEEB","3333b8b3a4b01e42":"8QFOC","5f7e03f214b99231":"2FdJg","8b37773b21de7afc":"6AMGA","6e31d76a6dde798a":"erSvz","9e159099df8f5396":"kqQOF","4dc994ca1ecddb69":"iivvn","ae5cc427fb559ac3":"8YP4O","c9ce274dea7171df":"gkGXc","23144ee9bd071abf":"guLFz","f35afe0b973b8e23":"2onWA"}],"3Y9Li":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("7530fd42e348bc8a");
require("83bb054d2dd851bf");
require("c5907af31f3e21ff");
require("e94fe251956fa54f");
var Mantine_context = require("137eebcca691c6d3");
require("e6567596e405401d");
require("19b9fef6355734a3");
require("53939b466b8132d");
require("9240df4a9ce44003");
require("3d61aa9e0fe65746");
var factory = require("596dfa924ab7e720");
require("d356cdeae6bbe43e");
var Portal = require("1cab6a1b0ea954a3");
var OptionalPortal = factory.factory(function(_param, ref) {
    var _param_withinPortal = _param.withinPortal, withinPortal = _param_withinPortal === void 0 ? true : _param_withinPortal, children = _param.children, others = (0, _objectWithoutProperties._)(_param, [
        "withinPortal",
        "children"
    ]);
    var env = Mantine_context.useMantineEnv();
    if (env === "test" || !withinPortal) return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Portal.Portal, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, others), {
        children
    }));
});
OptionalPortal.displayName = "@mantine/core/OptionalPortal";
exports.OptionalPortal = OptionalPortal; //# sourceMappingURL=OptionalPortal.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","7530fd42e348bc8a":"iKGFf","83bb054d2dd851bf":"9MtAM","c5907af31f3e21ff":"9HEEB","e94fe251956fa54f":"8QFOC","137eebcca691c6d3":"2FdJg","e6567596e405401d":"6AMGA","19b9fef6355734a3":"erSvz","53939b466b8132d":"kqQOF","9240df4a9ce44003":"8YP4O","3d61aa9e0fe65746":"gkGXc","596dfa924ab7e720":"guLFz","d356cdeae6bbe43e":"2onWA","1cab6a1b0ea954a3":"6YZdR"}],"2T0Xr":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("828e31cc0fc9ff5c");
require("d6145fd944f443e5");
require("e933b760081cfccf");
require("efe526976ddfc9ef");
var Mantine_context = require("c6467a7cb7450a20");
require("1c7b614123ee706c");
require("8a4720a1049173f8");
require("b2352513dad18114");
require("1b05af3597ad1364");
require("ac88250da8c87ffc");
require("ca521adadc357b1d");
var getTransitionStyles = require("8a6589f587608709");
var useTransition = require("33cd7ed2d9598e9f");
function Transition(param) {
    var keepMounted = param.keepMounted, _param_transition = param.transition, transition = _param_transition === void 0 ? "fade" : _param_transition, _param_duration = param.duration, duration = _param_duration === void 0 ? 250 : _param_duration, _param_exitDuration = param.exitDuration, exitDuration = _param_exitDuration === void 0 ? duration : _param_exitDuration, mounted = param.mounted, children = param.children, _param_timingFunction = param.timingFunction, timingFunction = _param_timingFunction === void 0 ? "ease" : _param_timingFunction, onExit = param.onExit, onEntered = param.onEntered, onEnter = param.onEnter, onExited = param.onExited, enterDelay = param.enterDelay, exitDelay = param.exitDelay;
    var env = Mantine_context.useMantineEnv();
    var _useTransition_useTransition = useTransition.useTransition({
        mounted,
        exitDuration,
        duration,
        timingFunction,
        onExit,
        onEntered,
        onEnter,
        onExited,
        enterDelay,
        exitDelay
    }), transitionDuration = _useTransition_useTransition.transitionDuration, transitionStatus = _useTransition_useTransition.transitionStatus, transitionTimingFunction = _useTransition_useTransition.transitionTimingFunction;
    if (transitionDuration === 0 || env === "test") return mounted ? /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: children({})
    }) : keepMounted ? children({
        display: "none"
    }) : null;
    return transitionStatus === "exited" ? keepMounted ? children({
        display: "none"
    }) : null : /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: children(getTransitionStyles.getTransitionStyles({
            transition,
            duration: transitionDuration,
            state: transitionStatus,
            timingFunction: transitionTimingFunction
        }))
    });
}
Transition.displayName = "@mantine/core/Transition";
exports.Transition = Transition; //# sourceMappingURL=Transition.cjs.map

},{"828e31cc0fc9ff5c":"iKGFf","d6145fd944f443e5":"9MtAM","e933b760081cfccf":"9HEEB","efe526976ddfc9ef":"8QFOC","c6467a7cb7450a20":"2FdJg","1c7b614123ee706c":"6AMGA","8a4720a1049173f8":"erSvz","b2352513dad18114":"kqQOF","1b05af3597ad1364":"8YP4O","ac88250da8c87ffc":"gkGXc","ca521adadc357b1d":"2onWA","8a6589f587608709":"dfRSC","33cd7ed2d9598e9f":"dGqKC"}],"dfRSC":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var transitions = require("9e6eac40134865ad");
var transitionStatuses = {
    entering: "in",
    entered: "in",
    exiting: "out",
    exited: "out",
    "pre-exiting": "out",
    "pre-entering": "out"
};
function getTransitionStyles(param) {
    var transition = param.transition, state = param.state, duration = param.duration, timingFunction = param.timingFunction;
    var shared = {
        WebkitBackfaceVisibility: "hidden",
        willChange: "transform, opacity",
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: timingFunction
    };
    if (typeof transition === "string") {
        if (!(transition in transitions.transitions)) return {};
        return (0, _objectSpread._)({
            transitionProperty: transitions.transitions[transition].transitionProperty
        }, shared, transitions.transitions[transition].common, transitions.transitions[transition][transitionStatuses[state]]);
    }
    return (0, _objectSpread._)({
        transitionProperty: transition.transitionProperty
    }, shared, transition.common, transition[transitionStatuses[state]]);
}
exports.getTransitionStyles = getTransitionStyles; //# sourceMappingURL=get-transition-styles.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","9e6eac40134865ad":"fgD9I"}],"fgD9I":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var popIn = function(from) {
    return {
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: `scale(.9) translateY(${from === "bottom" ? 10 : -10}px)`
        },
        transitionProperty: "transform, opacity"
    };
};
var transitions = {
    fade: {
        in: {
            opacity: 1
        },
        out: {
            opacity: 0
        },
        transitionProperty: "opacity"
    },
    "fade-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-30px)"
        },
        transitionProperty: "opacity, transform"
    },
    scale: {
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: "scale(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-y": {
        in: {
            opacity: 1,
            transform: "scaleY(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleY(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-x": {
        in: {
            opacity: 1,
            transform: "scaleX(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleX(0)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-up": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-20px) skew(-10deg, -5deg)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-down": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) skew(-10deg, -5deg)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-left": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) rotate(-5deg)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-right": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) rotate(5deg)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-100%)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(100%)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(100%)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-100%)"
        },
        common: {
            transformOrigin: "right"
        },
        transitionProperty: "transform, opacity"
    },
    pop: (0, _objectSpreadProps._)((0, _objectSpread._)({}, popIn("bottom")), {
        common: {
            transformOrigin: "center center"
        }
    }),
    "pop-bottom-left": (0, _objectSpreadProps._)((0, _objectSpread._)({}, popIn("bottom")), {
        common: {
            transformOrigin: "bottom left"
        }
    }),
    "pop-bottom-right": (0, _objectSpreadProps._)((0, _objectSpread._)({}, popIn("bottom")), {
        common: {
            transformOrigin: "bottom right"
        }
    }),
    "pop-top-left": (0, _objectSpreadProps._)((0, _objectSpread._)({}, popIn("top")), {
        common: {
            transformOrigin: "top left"
        }
    }),
    "pop-top-right": (0, _objectSpreadProps._)((0, _objectSpread._)({}, popIn("top")), {
        common: {
            transformOrigin: "top right"
        }
    })
};
exports.transitions = transitions; //# sourceMappingURL=transitions.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH"}],"dGqKC":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("4dacb15348cbaca2");
var ReactDOM = require("a37d2f69c9fcde79");
var hooks = require("ca1aaf39131247bd");
require("dd54634e595a12e4");
require("a467f30aec9532cc");
require("9ca99a3dda1ad5be");
require("221d55343d3d1768");
require("a1ad9c29bbc375cc");
var MantineThemeProvider = require("fa9a53c0efffd11a");
require("ff11e36fbed42812");
require("bf884a48f02c09ff");
require("ccdf04a3d452e7b8");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var ReactDOM__default = /*#__PURE__*/ _interopDefault(ReactDOM);
function useTransition(param) {
    var duration = param.duration, exitDuration = param.exitDuration, timingFunction = param.timingFunction, mounted = param.mounted, onEnter = param.onEnter, onExit = param.onExit, onEntered = param.onEntered, onExited = param.onExited, enterDelay = param.enterDelay, exitDelay = param.exitDelay;
    var theme = MantineThemeProvider.useMantineTheme();
    var shouldReduceMotion = hooks.useReducedMotion();
    var reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    var _React_useState = (0, _slicedToArray._)(React.useState(reduceMotion ? 0 : duration), 2), transitionDuration = _React_useState[0], setTransitionDuration = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(mounted ? "entered" : "exited"), 2), transitionStatus = _React_useState1[0], setStatus = _React_useState1[1];
    var transitionTimeoutRef = React.useRef(-1);
    var delayTimeoutRef = React.useRef(-1);
    var rafRef = React.useRef(-1);
    var handleStateChange = function(shouldMount) {
        var preHandler = shouldMount ? onEnter : onExit;
        var handler = shouldMount ? onEntered : onExited;
        window.clearTimeout(transitionTimeoutRef.current);
        var newTransitionDuration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
        setTransitionDuration(newTransitionDuration);
        if (newTransitionDuration === 0) {
            typeof preHandler === "function" && preHandler();
            typeof handler === "function" && handler();
            setStatus(shouldMount ? "entered" : "exited");
        } else rafRef.current = requestAnimationFrame(function() {
            ReactDOM__default.default.flushSync(function() {
                setStatus(shouldMount ? "pre-entering" : "pre-exiting");
            });
            rafRef.current = requestAnimationFrame(function() {
                typeof preHandler === "function" && preHandler();
                setStatus(shouldMount ? "entering" : "exiting");
                transitionTimeoutRef.current = window.setTimeout(function() {
                    typeof handler === "function" && handler();
                    setStatus(shouldMount ? "entered" : "exited");
                }, newTransitionDuration);
            });
        });
    };
    var handleTransitionWithDelay = function(shouldMount) {
        window.clearTimeout(delayTimeoutRef.current);
        var delay = shouldMount ? enterDelay : exitDelay;
        if (typeof delay !== "number") {
            handleStateChange(shouldMount);
            return;
        }
        delayTimeoutRef.current = window.setTimeout(function() {
            handleStateChange(shouldMount);
        }, shouldMount ? enterDelay : exitDelay);
    };
    hooks.useDidUpdate(function() {
        handleTransitionWithDelay(mounted);
    }, [
        mounted
    ]);
    React.useEffect(function() {
        return function() {
            window.clearTimeout(transitionTimeoutRef.current);
            cancelAnimationFrame(rafRef.current);
        };
    }, []);
    return {
        transitionDuration,
        transitionStatus,
        transitionTimingFunction: timingFunction || "ease"
    };
}
exports.useTransition = useTransition; //# sourceMappingURL=use-transition.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","4dacb15348cbaca2":"9MtAM","a37d2f69c9fcde79":"5Yfvl","ca1aaf39131247bd":"9HEEB","dd54634e595a12e4":"iKGFf","a467f30aec9532cc":"8QFOC","9ca99a3dda1ad5be":"2FdJg","221d55343d3d1768":"6AMGA","a1ad9c29bbc375cc":"erSvz","fa9a53c0efffd11a":"kqQOF","ff11e36fbed42812":"8YP4O","bf884a48f02c09ff":"gkGXc","ccdf04a3d452e7b8":"2onWA"}],"1wVSd":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("39dda57c1ebc854d");
var createSafeContext = require("361382c3f58a2739");
require("b53f4a82270d3e2e");
require("b47b70e270d21d05");
require("e4579c734d2e1d3f");
require("eadbd8cd6f65a353");
require("da5813bbd4e141f6");
require("85b39a9f97e1e14f");
require("9225781140f64478");
require("97354b4bae4a0640");
require("cd81edb97556bdc");
require("ce15d43bc3da1b68");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Popover component was not found in the tree"), 2), PopoverContextProvider = _createSafeContext_createSafeContext[0], usePopoverContext = _createSafeContext_createSafeContext[1];
exports.PopoverContextProvider = PopoverContextProvider;
exports.usePopoverContext = usePopoverContext; //# sourceMappingURL=Popover.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","39dda57c1ebc854d":"9MtAM","361382c3f58a2739":"8srze","b53f4a82270d3e2e":"iKGFf","b47b70e270d21d05":"9HEEB","e4579c734d2e1d3f":"8QFOC","eadbd8cd6f65a353":"2FdJg","da5813bbd4e141f6":"6AMGA","85b39a9f97e1e14f":"erSvz","9225781140f64478":"kqQOF","97354b4bae4a0640":"8YP4O","cd81edb97556bdc":"gkGXc","ce15d43bc3da1b68":"2onWA"}],"b7S6t":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c5e2667eec5ed92a");
var hooks = require("fd461d8183af1e21");
var rem = require("ff5c68a3de02aaba");
require("a7a6d605ee4ba44c");
var closeOnEscape = require("c89a5c337f70f5ae");
require("32294cf2b5a25b1b");
require("ecef7aba2cfb8c");
require("31d8357069425933");
require("611a4771c3df2063");
require("10f732357cd74835");
var useProps = require("9b71c6a929cb0606");
require("ddc9ddd6a1cbb996");
var Box = require("d7869788ef034125");
var factory = require("6153fa85d0172e9a");
require("3406a8174bec7d4a");
require("98bb5ae1d069aff8");
var FloatingArrow = require("fd8fc0d25a2fea40");
var FocusTrap = require("16859397375a9b4");
require("b8003b3f6f7fbb2");
var OptionalPortal = require("97ca60421a385213");
var Transition = require("925dfa28e3bda924");
var Popover_context = require("46511d88aa05e2e7");
var Popover_module = require("f49194a184a6dec");
var defaultProps = {};
var PopoverDropdown = factory.factory(function(_props, ref) {
    var _ctx_transitionProps, _ctx_transitionProps1, _ctx_transitionProps2, _ctx_transitionProps3;
    var props = useProps.useProps("PopoverDropdown", defaultProps, _props);
    var className = props.className, style = props.style, vars = props.vars, children = props.children, onKeyDownCapture = props.onKeyDownCapture, variant = props.variant, classNames = props.classNames, styles = props.styles, others = (0, _objectWithoutProperties._)(props, [
        "className",
        "style",
        "vars",
        "children",
        "onKeyDownCapture",
        "variant",
        "classNames",
        "styles"
    ]);
    var ctx = Popover_context.usePopoverContext();
    var returnFocus = hooks.useFocusReturn({
        opened: ctx.opened,
        shouldReturnFocus: ctx.returnFocus
    });
    var accessibleProps = ctx.withRoles ? {
        "aria-labelledby": ctx.getTargetId(),
        id: ctx.getDropdownId(),
        role: "dialog",
        tabIndex: -1
    } : {};
    var mergedRef = hooks.useMergedRef(ref, ctx.floating);
    if (ctx.disabled) return null;
    var _ctx_transitionProps_duration;
    return /* @__PURE__ */ jsxRuntime.jsx(OptionalPortal.OptionalPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.portalProps), {
        withinPortal: ctx.withinPortal,
        children: /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, (0, _objectSpreadProps._)((0, _objectSpread._)({
            mounted: ctx.opened
        }, ctx.transitionProps), {
            transition: ((_ctx_transitionProps = ctx.transitionProps) === null || _ctx_transitionProps === void 0 ? void 0 : _ctx_transitionProps.transition) || "fade",
            duration: (_ctx_transitionProps_duration = (_ctx_transitionProps1 = ctx.transitionProps) === null || _ctx_transitionProps1 === void 0 ? void 0 : _ctx_transitionProps1.duration) !== null && _ctx_transitionProps_duration !== void 0 ? _ctx_transitionProps_duration : 150,
            keepMounted: ctx.keepMounted,
            exitDuration: typeof ((_ctx_transitionProps2 = ctx.transitionProps) === null || _ctx_transitionProps2 === void 0 ? void 0 : _ctx_transitionProps2.exitDuration) === "number" ? ctx.transitionProps.exitDuration : (_ctx_transitionProps3 = ctx.transitionProps) === null || _ctx_transitionProps3 === void 0 ? void 0 : _ctx_transitionProps3.duration,
            children: function(transitionStyles) /* @__PURE__ */ {
                var _ctx_y, _ctx_x;
                return jsxRuntime.jsx(FocusTrap.FocusTrap, {
                    active: ctx.trapFocus && ctx.opened,
                    innerRef: mergedRef,
                    children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, accessibleProps, others), {
                        variant,
                        onKeyDownCapture: closeOnEscape.closeOnEscape(function() {
                            var _ctx_onClose, _ctx_onDismiss;
                            (_ctx_onClose = ctx.onClose) === null || _ctx_onClose === void 0 ? void 0 : _ctx_onClose.call(ctx);
                            (_ctx_onDismiss = ctx.onDismiss) === null || _ctx_onDismiss === void 0 ? void 0 : _ctx_onDismiss.call(ctx);
                        }, {
                            active: ctx.closeOnEscape,
                            onTrigger: returnFocus,
                            onKeyDown: onKeyDownCapture
                        }),
                        "data-position": ctx.placement,
                        "data-fixed": ctx.floatingStrategy === "fixed" || void 0
                    }), ctx.getStyles("dropdown", {
                        className,
                        props,
                        classNames,
                        styles,
                        style: [
                            (0, _objectSpreadProps._)((0, _objectSpread._)({}, transitionStyles), {
                                zIndex: ctx.zIndex,
                                top: (_ctx_y = ctx.y) !== null && _ctx_y !== void 0 ? _ctx_y : 0,
                                left: (_ctx_x = ctx.x) !== null && _ctx_x !== void 0 ? _ctx_x : 0,
                                width: ctx.width === "target" ? void 0 : rem.rem(ctx.width)
                            }),
                            ctx.resolvedStyles.dropdown,
                            styles === null || styles === void 0 ? void 0 : styles.dropdown,
                            style
                        ]
                    })), {
                        children: [
                            children,
                            /* @__PURE__ */ jsxRuntime.jsx(FloatingArrow.FloatingArrow, (0, _objectSpread._)({
                                ref: ctx.arrowRef,
                                arrowX: ctx.arrowX,
                                arrowY: ctx.arrowY,
                                visible: ctx.withArrow,
                                position: ctx.placement,
                                arrowSize: ctx.arrowSize,
                                arrowRadius: ctx.arrowRadius,
                                arrowOffset: ctx.arrowOffset,
                                arrowPosition: ctx.arrowPosition
                            }, ctx.getStyles("arrow", {
                                props,
                                classNames,
                                styles
                            })))
                        ]
                    }))
                });
            }
        }))
    }));
});
PopoverDropdown.classes = Popover_module;
PopoverDropdown.displayName = "@mantine/core/PopoverDropdown";
exports.PopoverDropdown = PopoverDropdown; //# sourceMappingURL=PopoverDropdown.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c5e2667eec5ed92a":"iKGFf","fd461d8183af1e21":"9HEEB","ff5c68a3de02aaba":"ebAaL","a7a6d605ee4ba44c":"9MtAM","c89a5c337f70f5ae":"aOjoS","32294cf2b5a25b1b":"8QFOC","ecef7aba2cfb8c":"2FdJg","31d8357069425933":"6AMGA","611a4771c3df2063":"erSvz","10f732357cd74835":"kqQOF","9b71c6a929cb0606":"iivvn","ddc9ddd6a1cbb996":"8YP4O","d7869788ef034125":"gkGXc","6153fa85d0172e9a":"guLFz","3406a8174bec7d4a":"2onWA","98bb5ae1d069aff8":"jrkk4","fd8fc0d25a2fea40":"kAWqL","16859397375a9b4":"keIAJ","b8003b3f6f7fbb2":"6YZdR","97ca60421a385213":"3Y9Li","925dfa28e3bda924":"2T0Xr","46511d88aa05e2e7":"1wVSd","f49194a184a6dec":"lR0hj"}],"keIAJ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var jsxRuntime = require("413724212f6aa9a1");
var React = require("eefdc4ac9bd6613b");
var hooks = require("9c8c3f2c27ff6678");
var isElement = require("4df3077965c7f40b");
require("ff0cd057369af6ae");
require("e5acced1c8ad5a8");
require("34199dff85210e91");
require("82aa2ad2dfe9a062");
require("d9478da7a60d6a4c");
require("7b58d2c677d15de3");
require("a8b4d2ae0398ce33");
require("c229262aadfac9b9");
var VisuallyHidden = require("ce9b6eb791fd0522");
function FocusTrap(param) {
    var children = param.children, _param_active = param.active, active = _param_active === void 0 ? true : _param_active, _param_refProp = param.refProp, refProp = _param_refProp === void 0 ? "ref" : _param_refProp, innerRef = param.innerRef;
    var focusTrapRef = hooks.useFocusTrap(active);
    var ref = hooks.useMergedRef(focusTrapRef, innerRef);
    if (!isElement.isElement(children)) return children;
    return React.cloneElement(children, {
        [refProp]: ref
    });
}
function FocusTrapInitialFocus(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(VisuallyHidden.VisuallyHidden, (0, _objectSpread._)({
        tabIndex: -1,
        "data-autofocus": true
    }, props));
}
FocusTrap.displayName = "@mantine/core/FocusTrap";
FocusTrapInitialFocus.displayName = "@mantine/core/FocusTrapInitialFocus";
FocusTrap.InitialFocus = FocusTrapInitialFocus;
exports.FocusTrap = FocusTrap;
exports.FocusTrapInitialFocus = FocusTrapInitialFocus; //# sourceMappingURL=FocusTrap.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","413724212f6aa9a1":"iKGFf","eefdc4ac9bd6613b":"9MtAM","9c8c3f2c27ff6678":"9HEEB","4df3077965c7f40b":"193o0","ff0cd057369af6ae":"8QFOC","e5acced1c8ad5a8":"2FdJg","34199dff85210e91":"6AMGA","82aa2ad2dfe9a062":"erSvz","d9478da7a60d6a4c":"kqQOF","7b58d2c677d15de3":"8YP4O","a8b4d2ae0398ce33":"gkGXc","c229262aadfac9b9":"2onWA","ce9b6eb791fd0522":"eOPpk"}],"lR0hj":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "dropdown": "m_38a85659",
    "arrow": "m_a31dc6c1",
    "overlay": "m_3d7bc908"
};
module.exports = classes; //# sourceMappingURL=Popover.module.css.cjs.map

},{}],"iz4SD":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var React = require("47c410f1b92ff9c9");
var cx = require("78cb432b21b57166");
var hooks = require("dd418b40722ad2c5");
var isElement = require("adbdb13e3d4b4d86");
require("df614ef21a79f3b8");
var getRefProp = require("7c059f0412fb3694");
require("509982c775081ecd");
require("3a67e77153fea7a1");
require("9c5400d38e01b7a2");
require("a320a51ff3fc6f16");
var useProps = require("c523c8cde1b8f41d");
require("d821c223e0b32888");
require("79599a8b717d8b51");
var factory = require("a1e467c47861c5dd");
require("444d3b03699c779b");
var Popover_context = require("3ef7afbf7598eaf6");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var defaultProps = {
    refProp: "ref",
    popupType: "dialog"
};
var PopoverTarget = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("PopoverTarget", defaultProps, props), children = _useProps_useProps.children, refProp = _useProps_useProps.refProp, popupType = _useProps_useProps.popupType, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "refProp",
        "popupType"
    ]);
    if (!isElement.isElement(children)) throw new Error("Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    var forwardedProps = others;
    var ctx = Popover_context.usePopoverContext();
    var targetRef = hooks.useMergedRef(ctx.reference, getRefProp.getRefProp(children), ref);
    var accessibleProps = ctx.withRoles ? {
        "aria-haspopup": popupType,
        "aria-expanded": ctx.opened,
        "aria-controls": ctx.getDropdownId(),
        id: ctx.getTargetId()
    } : {};
    return React.cloneElement(children, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, forwardedProps, accessibleProps, ctx.targetProps), {
        className: cx__default.default(ctx.targetProps.className, forwardedProps.className, children.props.className),
        [refProp]: targetRef
    }), !ctx.controlled ? {
        onClick: ctx.onToggle
    } : null));
});
PopoverTarget.displayName = "@mantine/core/PopoverTarget";
exports.PopoverTarget = PopoverTarget; //# sourceMappingURL=PopoverTarget.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","47c410f1b92ff9c9":"9MtAM","78cb432b21b57166":"8QFOC","dd418b40722ad2c5":"9HEEB","adbdb13e3d4b4d86":"193o0","df614ef21a79f3b8":"iKGFf","7c059f0412fb3694":"e829F","509982c775081ecd":"2FdJg","3a67e77153fea7a1":"6AMGA","9c5400d38e01b7a2":"erSvz","a320a51ff3fc6f16":"kqQOF","c523c8cde1b8f41d":"iivvn","d821c223e0b32888":"8YP4O","79599a8b717d8b51":"gkGXc","a1e467c47861c5dd":"guLFz","444d3b03699c779b":"2onWA","3ef7afbf7598eaf6":"1wVSd"}],"ki31H":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("96ac239ec345e76d");
var react = require("94bb8b880536ede9");
var hooks = require("c39b439f687261d6");
var useFloatingAutoUpdate = require("9242eb90421ad717");
require("dcff27d05c77457d");
function getDefaultMiddlewares(middlewares) {
    if (middlewares === void 0) return {
        shift: true,
        flip: true
    };
    var result = (0, _objectSpread._)({}, middlewares);
    if (middlewares.shift === void 0) result.shift = true;
    if (middlewares.flip === void 0) result.flip = true;
    return result;
}
function getPopoverMiddlewares(options, getFloating) {
    var middlewaresOptions = getDefaultMiddlewares(options.middlewares);
    var middlewares = [
        react.offset(options.offset)
    ];
    if (middlewaresOptions.shift) middlewares.push(react.shift(typeof middlewaresOptions.shift === "boolean" ? {
        limiter: react.limitShift(),
        padding: 5
    } : (0, _objectSpread._)({
        limiter: react.limitShift(),
        padding: 5
    }, middlewaresOptions.shift)));
    if (middlewaresOptions.flip) middlewares.push(typeof middlewaresOptions.flip === "boolean" ? react.flip() : react.flip(middlewaresOptions.flip));
    if (middlewaresOptions.inline) middlewares.push(typeof middlewaresOptions.inline === "boolean" ? react.inline() : react.inline(middlewaresOptions.inline));
    middlewares.push(react.arrow({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    if (middlewaresOptions.size || options.width === "target") middlewares.push(react.size((0, _objectSpreadProps._)((0, _objectSpread._)({}, typeof middlewaresOptions.size === "boolean" ? {} : middlewaresOptions.size), {
        apply (_param) {
            var rects = _param.rects, availableWidth = _param.availableWidth, availableHeight = _param.availableHeight, rest = (0, _objectWithoutProperties._)(_param, [
                "rects",
                "availableWidth",
                "availableHeight"
            ]);
            var _floating_refs_floating_current;
            var floating = getFloating();
            var _floating_refs_floating_current_style;
            var styles = (_floating_refs_floating_current_style = (_floating_refs_floating_current = floating.refs.floating.current) === null || _floating_refs_floating_current === void 0 ? void 0 : _floating_refs_floating_current.style) !== null && _floating_refs_floating_current_style !== void 0 ? _floating_refs_floating_current_style : {};
            if (middlewaresOptions.size) {
                if (typeof middlewaresOptions.size === "object" && !!middlewaresOptions.size.apply) middlewaresOptions.size.apply((0, _objectSpread._)({
                    rects,
                    availableWidth,
                    availableHeight
                }, rest));
                else Object.assign(styles, {
                    maxWidth: `${availableWidth}px`,
                    maxHeight: `${availableHeight}px`
                });
            }
            if (options.width === "target") Object.assign(styles, {
                width: `${rects.reference.width}px`
            });
        }
    })));
    return middlewares;
}
function usePopover(options) {
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    }), 2), _opened = _hooks_useUncontrolled[0], setOpened = _hooks_useUncontrolled[1];
    var previouslyOpened = React.useRef(_opened);
    var onClose = function() {
        if (_opened) setOpened(false);
    };
    var onToggle = function() {
        return setOpened(!_opened);
    };
    var floating = react.useFloating({
        strategy: options.strategy,
        placement: options.position,
        middleware: getPopoverMiddlewares(options, function() {
            return floating;
        })
    });
    useFloatingAutoUpdate.useFloatingAutoUpdate({
        opened: _opened,
        position: options.position,
        positionDependencies: options.positionDependencies || [],
        floating
    });
    hooks.useDidUpdate(function() {
        var _options_onPositionChange;
        (_options_onPositionChange = options.onPositionChange) === null || _options_onPositionChange === void 0 ? void 0 : _options_onPositionChange.call(options, floating.placement);
    }, [
        floating.placement
    ]);
    hooks.useDidUpdate(function() {
        if (_opened !== previouslyOpened.current) {
            var _options_onClose, _options_onOpen;
            if (!_opened) (_options_onClose = options.onClose) === null || _options_onClose === void 0 ? void 0 : _options_onClose.call(options);
            else (_options_onOpen = options.onOpen) === null || _options_onOpen === void 0 ? void 0 : _options_onOpen.call(options);
        }
        previouslyOpened.current = _opened;
    }, [
        _opened,
        options.onClose,
        options.onOpen
    ]);
    return {
        floating,
        controlled: typeof options.opened === "boolean",
        opened: _opened,
        onClose,
        onToggle
    };
}
exports.usePopover = usePopover; //# sourceMappingURL=use-popover.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","96ac239ec345e76d":"9MtAM","94bb8b880536ede9":"jrkk4","c39b439f687261d6":"9HEEB","9242eb90421ad717":"j8BHA","dcff27d05c77457d":"kAWqL"}],"j8BHA":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("a3898631182949ae");
var react = require("17367af83af1ef17");
var hooks = require("401a24b1fa07bd55");
function useFloatingAutoUpdate(param) {
    var opened = param.opened, floating = param.floating, position = param.position, positionDependencies = param.positionDependencies;
    var _React_useState = (0, _slicedToArray._)(React.useState(0), 2), delayedUpdate = _React_useState[0], setDelayedUpdate = _React_useState[1];
    React.useEffect(function() {
        if (floating.refs.reference.current && floating.refs.floating.current && opened) return react.autoUpdate(floating.refs.reference.current, floating.refs.floating.current, floating.update);
        return void 0;
    }, [
        floating.refs.reference.current,
        floating.refs.floating.current,
        opened,
        delayedUpdate,
        position
    ]);
    hooks.useDidUpdate(function() {
        floating.update();
    }, positionDependencies);
    hooks.useDidUpdate(function() {
        setDelayedUpdate(function(c) {
            return c + 1;
        });
    }, [
        opened
    ]);
}
exports.useFloatingAutoUpdate = useFloatingAutoUpdate; //# sourceMappingURL=use-floating-auto-update.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","a3898631182949ae":"9MtAM","17367af83af1ef17":"jrkk4","401a24b1fa07bd55":"9HEEB"}],"9tz8j":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("967c95b4469bb7a2");
require("7df07009596c8f5d");
var getSize = require("c22f7a5a8786bda8");
require("23d5932043c334a7");
var createVarsResolver = require("e182d9055963e6c6");
require("62d6885eed644d");
require("59a2500939c7db5c");
require("1a73cd2b358b2f74");
require("d0175ad0bb5f203");
require("74572007ac6c1703");
var useProps = require("892036d3f12af6a4");
require("190f424ab5fd58c1");
var useStyles = require("b30983d3bb5401c8");
var Box = require("5b85576cd07ae8c8");
var polymorphicFactory = require("29c12d0b15a65972");
require("30d026ab9d6dcbbb");
var Loader = require("833ef58c1d85cee4");
var Transition = require("8ab84aaaa11ba149");
var UnstyledButton = require("a1765aa3d17b9569");
var ActionIconGroup = require("de81a934f147582");
var ActionIconGroupSection = require("bb093bf385fcb8c5");
var ActionIcon_module = require("5de9646d81be248c");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, radius = param.radius, variant = param.variant, gradient = param.gradient, color = param.color, autoContrast = param.autoContrast;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--ai-size": getSize.getSize(size, "ai-size"),
            "--ai-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--ai-bg": color || variant ? colors.background : void 0,
            "--ai-hover": color || variant ? colors.hover : void 0,
            "--ai-hover-color": color || variant ? colors.hoverColor : void 0,
            "--ai-color": colors.color,
            "--ai-bd": color || variant ? colors.border : void 0
        }
    };
});
var ActionIcon = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("ActionIcon", defaultProps, _props);
    var className = props.className, unstyled = props.unstyled, variant = props.variant, classNames = props.classNames, styles = props.styles, style = props.style, loading = props.loading, loaderProps = props.loaderProps, size = props.size, color = props.color, radius = props.radius, __staticSelector = props.__staticSelector, gradient = props.gradient, vars = props.vars, children = props.children, disabled = props.disabled, dataDisabled = props["data-disabled"], autoContrast = props.autoContrast, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "className",
        "unstyled",
        "variant",
        "classNames",
        "styles",
        "style",
        "loading",
        "loaderProps",
        "size",
        "color",
        "radius",
        "__staticSelector",
        "gradient",
        "vars",
        "children",
        "disabled",
        "data-disabled",
        "autoContrast",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: [
            "ActionIcon",
            __staticSelector
        ],
        props,
        className,
        style,
        classes: ActionIcon_module,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root", {
        active: !disabled && !loading && !dataDisabled
    }), others), {
        unstyled,
        variant,
        size,
        disabled: disabled || loading,
        ref,
        mod: [
            {
                loading,
                disabled: disabled || dataDisabled
            },
            mod
        ],
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, {
                mounted: !!loading,
                transition: "slide-down",
                duration: 150,
                children: function(transitionStyles) {
                    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "span"
                    }, getStyles("loader", {
                        style: transitionStyles
                    })), {
                        "aria-hidden": true,
                        children: /* @__PURE__ */ jsxRuntime.jsx(Loader.Loader, (0, _objectSpread._)({
                            color: "var(--ai-color)",
                            size: "calc(var(--ai-size) * 0.55)"
                        }, loaderProps))
                    }));
                }
            }),
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                component: "span",
                mod: {
                    loading
                }
            }, getStyles("icon")), {
                children
            }))
        ]
    }));
});
ActionIcon.classes = ActionIcon_module;
ActionIcon.displayName = "@mantine/core/ActionIcon";
ActionIcon.Group = ActionIconGroup.ActionIconGroup;
ActionIcon.GroupSection = ActionIconGroupSection.ActionIconGroupSection;
exports.ActionIcon = ActionIcon; //# sourceMappingURL=ActionIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","967c95b4469bb7a2":"iKGFf","7df07009596c8f5d":"9MtAM","c22f7a5a8786bda8":"kEFEY","23d5932043c334a7":"9HEEB","e182d9055963e6c6":"hIQE6","62d6885eed644d":"8QFOC","59a2500939c7db5c":"2FdJg","1a73cd2b358b2f74":"6AMGA","d0175ad0bb5f203":"erSvz","74572007ac6c1703":"kqQOF","892036d3f12af6a4":"iivvn","190f424ab5fd58c1":"8YP4O","b30983d3bb5401c8":"d0sAY","5b85576cd07ae8c8":"gkGXc","29c12d0b15a65972":"iYAEL","30d026ab9d6dcbbb":"2onWA","833ef58c1d85cee4":"hxcgl","8ab84aaaa11ba149":"2T0Xr","a1765aa3d17b9569":"cArqr","de81a934f147582":"hLZtr","bb093bf385fcb8c5":"5bt1k","5de9646d81be248c":"6eXJ4"}],"hxcgl":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("300a1727092d4e62");
require("898114a43da62c64");
var getSize = require("363b0dafe2eb0258");
require("38ef4c74305e2f95");
var createVarsResolver = require("a8769cdd0ca94e8f");
require("231d3f7d0a3abc34");
var getThemeColor = require("a31732e55717ddd");
require("29050c9da01f750a");
require("e02623dc962faffd");
require("e0a0892b3bf4dcac");
require("92fd528b84d216bc");
var useProps = require("63c5b09067ed504c");
require("149b8d680207443e");
var useStyles = require("a8d2a13c0ca8e601");
var Box = require("5bd742a1b371905c");
var factory = require("349ba429d07242bd");
require("eaf95a7753ebe099");
var Bars = require("16a094c02e9cfae7");
var Dots = require("6a5fb136d0e45ea5");
var Oval = require("1e6440f6dc8264bd");
var Loader_module = require("47aba2d517f3165b");
var defaultLoaders = {
    bars: Bars.Bars,
    oval: Oval.Oval,
    dots: Dots.Dots
};
var defaultProps = {
    loaders: defaultLoaders,
    type: "oval"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, color = param.color;
    return {
        root: {
            "--loader-size": getSize.getSize(size, "loader-size"),
            "--loader-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
        }
    };
});
var Loader = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Loader", defaultProps, _props);
    var size = props.size, color = props.color, type = props.type, vars = props.vars, className = props.className, style = props.style, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, loaders = props.loaders, variant = props.variant, children = props.children, others = (0, _objectWithoutProperties._)(props, [
        "size",
        "color",
        "type",
        "vars",
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "loaders",
        "variant",
        "children"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Loader",
        props,
        classes: Loader_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    if (children) return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        ref
    }), others), {
        children
    }));
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        ref,
        component: loaders[type],
        variant,
        size
    }), others));
});
Loader.defaultLoaders = defaultLoaders;
Loader.classes = Loader_module;
Loader.displayName = "@mantine/core/Loader";
exports.Loader = Loader;
exports.defaultLoaders = defaultLoaders; //# sourceMappingURL=Loader.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","300a1727092d4e62":"iKGFf","898114a43da62c64":"9MtAM","363b0dafe2eb0258":"kEFEY","38ef4c74305e2f95":"9HEEB","a8769cdd0ca94e8f":"hIQE6","231d3f7d0a3abc34":"8QFOC","a31732e55717ddd":"eeaIN","29050c9da01f750a":"2FdJg","e02623dc962faffd":"6AMGA","e0a0892b3bf4dcac":"erSvz","92fd528b84d216bc":"kqQOF","63c5b09067ed504c":"iivvn","149b8d680207443e":"8YP4O","a8d2a13c0ca8e601":"d0sAY","5bd742a1b371905c":"gkGXc","349ba429d07242bd":"guLFz","eaf95a7753ebe099":"2onWA","16a094c02e9cfae7":"81K5F","6a5fb136d0e45ea5":"6e1ra","1e6440f6dc8264bd":"11aac","47aba2d517f3165b":"iqP4Z"}],"81K5F":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("834f57024c7922b5");
var React = require("1f1d29d8eb01f475");
var cx = require("81a39c01c7fce545");
require("4d506b6d2b3157d6");
require("15532616c0421c01");
require("7911a57203c8c89b");
require("e55f10a2595b32ef");
require("88de7506a0dd8fb5");
require("2f21b4c54522689f");
var Box = require("63c85e3e3ef6e681");
require("198d44f3eba5b6d2");
var Loader_module = require("7f63181ee7aaf4b7");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var Bars = React.forwardRef(function(_param, ref) {
    var className = _param.className, others = (0, _objectWithoutProperties._)(_param, [
        "className"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "span",
        className: cx__default.default(Loader_module.barsLoader, className)
    }, others), {
        ref,
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("span", {
                className: Loader_module.bar
            }),
            /* @__PURE__ */ jsxRuntime.jsx("span", {
                className: Loader_module.bar
            }),
            /* @__PURE__ */ jsxRuntime.jsx("span", {
                className: Loader_module.bar
            })
        ]
    }));
});
Bars.displayName = "@mantine/core/Bars";
exports.Bars = Bars; //# sourceMappingURL=Bars.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","834f57024c7922b5":"iKGFf","1f1d29d8eb01f475":"9MtAM","81a39c01c7fce545":"8QFOC","4d506b6d2b3157d6":"9HEEB","15532616c0421c01":"2FdJg","7911a57203c8c89b":"6AMGA","e55f10a2595b32ef":"erSvz","88de7506a0dd8fb5":"kqQOF","2f21b4c54522689f":"8YP4O","63c85e3e3ef6e681":"gkGXc","198d44f3eba5b6d2":"2onWA","7f63181ee7aaf4b7":"iqP4Z"}],"iqP4Z":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_5ae2e3c",
    "barsLoader": "m_7a2bd4cd",
    "bar": "m_870bb79",
    "bars-loader-animation": "m_5d2b3b9d",
    "dotsLoader": "m_4e3f22d7",
    "dot": "m_870c4af",
    "loader-dots-animation": "m_aac34a1",
    "ovalLoader": "m_b34414df",
    "oval-loader-animation": "m_f8e89c4b"
};
module.exports = classes; //# sourceMappingURL=Loader.module.css.cjs.map

},{}],"6e1ra":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1122271198ab4212");
var React = require("85bd4e915be1a7b4");
var cx = require("c5cb2a572a0dae2d");
require("894eca08d9449d9c");
require("437898511f9bc4b7");
require("165a7747b27b3435");
require("8b218de4bc56d5b6");
require("18f251fabc1a3b69");
require("5aa8838d28eb43c3");
var Box = require("133eab3b247dcaf6");
require("41732277484303e8");
var Loader_module = require("b8a2d72a1ce0eb02");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var Dots = React.forwardRef(function(_param, ref) {
    var className = _param.className, others = (0, _objectWithoutProperties._)(_param, [
        "className"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "span",
        className: cx__default.default(Loader_module.dotsLoader, className)
    }, others), {
        ref,
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("span", {
                className: Loader_module.dot
            }),
            /* @__PURE__ */ jsxRuntime.jsx("span", {
                className: Loader_module.dot
            }),
            /* @__PURE__ */ jsxRuntime.jsx("span", {
                className: Loader_module.dot
            })
        ]
    }));
});
Dots.displayName = "@mantine/core/Dots";
exports.Dots = Dots; //# sourceMappingURL=Dots.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","1122271198ab4212":"iKGFf","85bd4e915be1a7b4":"9MtAM","c5cb2a572a0dae2d":"8QFOC","894eca08d9449d9c":"9HEEB","437898511f9bc4b7":"2FdJg","165a7747b27b3435":"6AMGA","8b218de4bc56d5b6":"erSvz","18f251fabc1a3b69":"kqQOF","5aa8838d28eb43c3":"8YP4O","133eab3b247dcaf6":"gkGXc","41732277484303e8":"2onWA","b8a2d72a1ce0eb02":"iqP4Z"}],"11aac":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("7cd4d7f47f318aa3");
var React = require("76a3ceb2ec12ca88");
var cx = require("702f644f00531231");
require("226b6cdeb87caf85");
require("44cddad304e6ec");
require("7056dd815f359303");
require("c0c78184786c1396");
require("5d3413752728ab16");
require("9d958c3df4ab6c13");
var Box = require("c5fe49e5cd123b65");
require("4919969872a71f86");
var Loader_module = require("27473d05bf1cae7c");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var Oval = React.forwardRef(function(_param, ref) {
    var className = _param.className, others = (0, _objectWithoutProperties._)(_param, [
        "className"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "span",
        className: cx__default.default(Loader_module.ovalLoader, className)
    }, others), {
        ref
    }));
});
Oval.displayName = "@mantine/core/Oval";
exports.Oval = Oval; //# sourceMappingURL=Oval.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","7cd4d7f47f318aa3":"iKGFf","76a3ceb2ec12ca88":"9MtAM","702f644f00531231":"8QFOC","226b6cdeb87caf85":"9HEEB","44cddad304e6ec":"2FdJg","7056dd815f359303":"6AMGA","c0c78184786c1396":"erSvz","5d3413752728ab16":"kqQOF","9d958c3df4ab6c13":"8YP4O","c5fe49e5cd123b65":"gkGXc","4919969872a71f86":"2onWA","27473d05bf1cae7c":"iqP4Z"}],"hLZtr":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("9de185141d076dc8");
var rem = require("ccc4471a005f1216");
require("f2ceb092de915ecf");
require("7b888d05458523a8");
var createVarsResolver = require("3f933cfd6ee19118");
require("54db2b0530057579");
require("39c0a9a8a4d02dcd");
require("5388b5cb61c00f66");
require("f2f6ffeb72cc9705");
require("f1aec365f7aa6944");
var useProps = require("fccbf4de9bbd6e86");
require("3237039d5cdf1157");
var useStyles = require("f78664192b44ab8");
var Box = require("149c7bb3c9e9c568");
var factory = require("22bc9cfe8bce7cdb");
require("f3b1e4e48bcc6b3");
var ActionIcon_module = require("43e2649137211999");
var defaultProps = {
    orientation: "horizontal"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var borderWidth = param.borderWidth;
    return {
        group: {
            "--ai-border-width": rem.rem(borderWidth)
        }
    };
});
var ActionIconGroup = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ActionIconGroup", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("ActionIconGroup", defaultProps, _props), className = _useProps_useProps.className, style = _useProps_useProps.style, classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, orientation = _useProps_useProps.orientation, vars = _useProps_useProps.vars, borderWidth = _useProps_useProps.borderWidth, variant = _useProps_useProps.variant, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "orientation",
        "vars",
        "borderWidth",
        "variant",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ActionIconGroup",
        props,
        classes: ActionIcon_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("group")), {
        ref,
        variant,
        mod: [
            {
                "data-orientation": orientation
            },
            mod
        ],
        role: "group"
    }), others));
});
ActionIconGroup.classes = ActionIcon_module;
ActionIconGroup.displayName = "@mantine/core/ActionIconGroup";
exports.ActionIconGroup = ActionIconGroup; //# sourceMappingURL=ActionIconGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","9de185141d076dc8":"iKGFf","ccc4471a005f1216":"ebAaL","f2ceb092de915ecf":"9MtAM","7b888d05458523a8":"9HEEB","3f933cfd6ee19118":"hIQE6","54db2b0530057579":"8QFOC","39c0a9a8a4d02dcd":"2FdJg","5388b5cb61c00f66":"6AMGA","f2f6ffeb72cc9705":"erSvz","f1aec365f7aa6944":"kqQOF","fccbf4de9bbd6e86":"iivvn","3237039d5cdf1157":"8YP4O","f78664192b44ab8":"d0sAY","149c7bb3c9e9c568":"gkGXc","22bc9cfe8bce7cdb":"guLFz","f3b1e4e48bcc6b3":"2onWA","43e2649137211999":"6eXJ4"}],"6eXJ4":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_8d3f4000",
    "icon": "m_8d3afb97",
    "loader": "m_302b9fb1",
    "group": "m_1a0f1b21",
    "groupSection": "m_437b6484"
};
module.exports = classes; //# sourceMappingURL=ActionIcon.module.css.cjs.map

},{}],"5bt1k":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c12b17a9cb3dd3a5");
require("fc64bbae6d9ad09e");
var getSize = require("c61ad1da6e6473d6");
require("6395d86cc7155a79");
var createVarsResolver = require("cb67572748d7b233");
require("785892214d9ea078");
require("26bb8a819adec2f6");
require("6f53d179ca915a40");
require("b949e3f7d1491006");
require("e16a7b96d5e3f405");
var useProps = require("a51fd9fbe077543d");
require("daf755aead50022f");
var useStyles = require("1ae9d5cb2936a4b6");
var Box = require("701b2a29daddca98");
var factory = require("f118b125a405e26a");
require("a9e0a2d8a5fdd526");
var ActionIcon_module = require("1e70f72081776386");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, gradient = param.gradient, variant = param.variant, autoContrast = param.autoContrast, size = param.size;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        groupSection: {
            "--section-height": getSize.getSize(size, "section-height"),
            "--section-padding-x": getSize.getSize(size, "section-padding-x"),
            "--section-fz": getSize.getFontSize(size),
            "--section-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--section-bg": color || variant ? colors.background : void 0,
            "--section-color": colors.color,
            "--section-bd": color || variant ? colors.border : void 0
        }
    };
});
var ActionIconGroupSection = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ActionIconGroupSection", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("ActionIconGroupSection", defaultProps, _props), className = _useProps_useProps.className, style = _useProps_useProps.style, classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, vars = _useProps_useProps.vars, variant = _useProps_useProps.variant, gradient = _useProps_useProps.gradient, radius = _useProps_useProps.radius, autoContrast = _useProps_useProps.autoContrast, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "variant",
        "gradient",
        "radius",
        "autoContrast"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ActionIconGroupSection",
        props,
        classes: ActionIcon_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "groupSection"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("groupSection")), {
        ref,
        variant
    }), others));
});
ActionIconGroupSection.classes = ActionIcon_module;
ActionIconGroupSection.displayName = "@mantine/core/ActionIconGroupSection";
exports.ActionIconGroupSection = ActionIconGroupSection; //# sourceMappingURL=ActionIconGroupSection.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c12b17a9cb3dd3a5":"iKGFf","fc64bbae6d9ad09e":"9MtAM","c61ad1da6e6473d6":"kEFEY","6395d86cc7155a79":"9HEEB","cb67572748d7b233":"hIQE6","785892214d9ea078":"8QFOC","26bb8a819adec2f6":"2FdJg","6f53d179ca915a40":"6AMGA","b949e3f7d1491006":"erSvz","e16a7b96d5e3f405":"kqQOF","a51fd9fbe077543d":"iivvn","daf755aead50022f":"8YP4O","1ae9d5cb2936a4b6":"d0sAY","701b2a29daddca98":"gkGXc","f118b125a405e26a":"guLFz","a9e0a2d8a5fdd526":"2onWA","1e70f72081776386":"6eXJ4"}],"h6AYi":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("91af125ce47f5bb5");
var React = require("698fc5d2ed7373b1");
var CloseIcon = React.forwardRef(function(_param, ref) {
    var _param_size = _param.size, size = _param_size === void 0 ? "var(--cb-icon-size, 70%)" : _param_size, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "size",
        "style"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            width: size,
            height: size
        }),
        ref
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    }));
});
CloseIcon.displayName = "@mantine/core/CloseIcon";
exports.CloseIcon = CloseIcon; //# sourceMappingURL=CloseIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","91af125ce47f5bb5":"iKGFf","698fc5d2ed7373b1":"9MtAM"}],"4ZuRG":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("bcbfb6b4039ef224");
var rem = require("f7424c500e6becb8");
require("b04cfd4fde51d951");
var getSize = require("62b258caf0e7fe46");
require("2d5e8423cfb0719d");
var createVarsResolver = require("a1134420b374e786");
require("5fa1c6dd5b98659b");
require("74354d6d39482800");
require("ee6f8a72ef51b159");
require("e992438b713e671d");
require("8edfe46cd7db9fdf");
var useProps = require("271dc0340ebc9e1");
require("cc797983d62c7edc");
var useStyles = require("6ca9e4a7e82f17e3");
require("b101624691a69fbd");
var polymorphicFactory = require("da9576d69ac6e4cc");
require("7bbf1a41e8bfbfd2");
var UnstyledButton = require("9cc88fadf2557c10");
var CloseIcon = require("7c3098727d903185");
var CloseButton_module = require("57fa40f66a3dd8cc");
var defaultProps = {
    variant: "subtle"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, radius = param.radius, iconSize = param.iconSize;
    return {
        root: {
            "--cb-size": getSize.getSize(size, "cb-size"),
            "--cb-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--cb-icon-size": rem.rem(iconSize)
        }
    };
});
var CloseButton = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("CloseButton", defaultProps, _props);
    var iconSize = props.iconSize, children = props.children, vars = props.vars, radius = props.radius, className = props.className, classNames = props.classNames, style = props.style, styles = props.styles, unstyled = props.unstyled, dataDisabled = props["data-disabled"], disabled = props.disabled, variant = props.variant, icon = props.icon, mod = props.mod, __staticSelector = props.__staticSelector, others = (0, _objectWithoutProperties._)(props, [
        "iconSize",
        "children",
        "vars",
        "radius",
        "className",
        "classNames",
        "style",
        "styles",
        "unstyled",
        "data-disabled",
        "disabled",
        "variant",
        "icon",
        "mod",
        "__staticSelector"
    ]);
    var getStyles = useStyles.useStyles({
        name: __staticSelector || "CloseButton",
        props,
        className,
        style,
        classes: CloseButton_module,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, others), {
        unstyled,
        variant,
        disabled,
        mod: [
            {
                disabled: disabled || dataDisabled
            },
            mod
        ]
    }), getStyles("root", {
        variant,
        active: !disabled && !dataDisabled
    })), {
        children: [
            icon || /* @__PURE__ */ jsxRuntime.jsx(CloseIcon.CloseIcon, {}),
            children
        ]
    }));
});
CloseButton.classes = CloseButton_module;
CloseButton.displayName = "@mantine/core/CloseButton";
exports.CloseButton = CloseButton; //# sourceMappingURL=CloseButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","bcbfb6b4039ef224":"iKGFf","f7424c500e6becb8":"ebAaL","b04cfd4fde51d951":"9MtAM","62b258caf0e7fe46":"kEFEY","2d5e8423cfb0719d":"9HEEB","a1134420b374e786":"hIQE6","5fa1c6dd5b98659b":"8QFOC","74354d6d39482800":"2FdJg","ee6f8a72ef51b159":"6AMGA","e992438b713e671d":"erSvz","8edfe46cd7db9fdf":"kqQOF","271dc0340ebc9e1":"iivvn","cc797983d62c7edc":"8YP4O","6ca9e4a7e82f17e3":"d0sAY","b101624691a69fbd":"gkGXc","da9576d69ac6e4cc":"iYAEL","7bbf1a41e8bfbfd2":"2onWA","9cc88fadf2557c10":"cArqr","7c3098727d903185":"h6AYi","57fa40f66a3dd8cc":"iwuvY"}],"iwuvY":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_86a44da5",
    "root--subtle": "m_220c80f2"
};
module.exports = classes; //# sourceMappingURL=CloseButton.module.css.cjs.map

},{}],"iEuvx":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f15606085219bc6e");
require("575d4b254b0cdd83");
var getSize = require("da5dc8216c8cc3ce");
require("cd800aab20128585");
var createVarsResolver = require("d45fd615bd5ad019");
require("bd33e9abe0359ad5");
require("d433740a7768edcc");
require("659da4d1334bc494");
require("1ec2a03e385fc201");
require("5306520896322e05");
var useProps = require("2b05cf954518dbf1");
require("932774fde1c388b0");
var useStyles = require("a9d703da8e19a68b");
var Box = require("56579c7f4ada8707");
var factory = require("d9248b9498d1de92");
require("9c9ad3eff0b8610d");
var filterFalsyChildren = require("7eea4e01eec5ea91");
var Group_module = require("ac336c5463401d4e");
var defaultProps = {
    preventGrowOverflow: true,
    gap: "md",
    align: "center",
    justify: "flex-start",
    wrap: "wrap"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param, param1) {
    var grow = param.grow, preventGrowOverflow = param.preventGrowOverflow, gap = param.gap, align = param.align, justify = param.justify, wrap = param.wrap, childWidth = param1.childWidth;
    return {
        root: {
            "--group-child-width": grow && preventGrowOverflow ? childWidth : void 0,
            "--group-gap": getSize.getSpacing(gap),
            "--group-align": align,
            "--group-justify": justify,
            "--group-wrap": wrap
        }
    };
});
var Group = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Group", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, children = props.children, gap = props.gap, align = props.align, justify = props.justify, wrap = props.wrap, grow = props.grow, preventGrowOverflow = props.preventGrowOverflow, vars = props.vars, variant = props.variant, __size = props.__size, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "children",
        "gap",
        "align",
        "justify",
        "wrap",
        "grow",
        "preventGrowOverflow",
        "vars",
        "variant",
        "__size",
        "mod"
    ]);
    var filteredChildren = filterFalsyChildren.filterFalsyChildren(children);
    var childrenCount = filteredChildren.length;
    var resolvedGap = getSize.getSpacing(gap !== null && gap !== void 0 ? gap : "md");
    var childWidth = `calc(${100 / childrenCount}% - (${resolvedGap} - ${resolvedGap} / ${childrenCount}))`;
    var stylesCtx = {
        childWidth
    };
    var getStyles = useStyles.useStyles({
        name: "Group",
        props,
        stylesCtx,
        className,
        style,
        classes: Group_module,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        ref,
        variant,
        mod: [
            {
                grow
            },
            mod
        ],
        size: __size
    }), others), {
        children: filteredChildren
    }));
});
Group.classes = Group_module;
Group.displayName = "@mantine/core/Group";
exports.Group = Group; //# sourceMappingURL=Group.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f15606085219bc6e":"iKGFf","575d4b254b0cdd83":"9MtAM","da5dc8216c8cc3ce":"kEFEY","cd800aab20128585":"9HEEB","d45fd615bd5ad019":"hIQE6","bd33e9abe0359ad5":"8QFOC","d433740a7768edcc":"2FdJg","659da4d1334bc494":"6AMGA","1ec2a03e385fc201":"erSvz","5306520896322e05":"kqQOF","2b05cf954518dbf1":"iivvn","932774fde1c388b0":"8YP4O","a9d703da8e19a68b":"d0sAY","56579c7f4ada8707":"gkGXc","d9248b9498d1de92":"guLFz","9c9ad3eff0b8610d":"2onWA","7eea4e01eec5ea91":"bcZFs","ac336c5463401d4e":"6PhAt"}],"bcZFs":[function(require,module,exports) {
"use client";
"use strict";
var React = require("acf0a5b77c2a0389");
function filterFalsyChildren(children) {
    return React.Children.toArray(children).filter(Boolean);
}
exports.filterFalsyChildren = filterFalsyChildren; //# sourceMappingURL=filter-falsy-children.cjs.map

},{"acf0a5b77c2a0389":"9MtAM"}],"6PhAt":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_4081bf90"
};
module.exports = classes; //# sourceMappingURL=Group.module.css.cjs.map

},{}],"PGvLq":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("8b6d184f982bc69b");
var React = require("9f96df96e864829a");
var reactRemoveScroll = require("aa897db1cf1af267");
var getDefaultZIndex = require("7a0d9f8249af40f4");
var getSize = require("d377861f377cc8b8");
require("10dcebd07d529cf4");
require("cc588dd79127d4eb");
require("3b79d4e4f7e4bd6a");
require("4df67d8135f19513");
require("9733cc5ec380d678");
require("8e270c1048cd634f");
require("ed6b5a0c80dec02");
var Box = require("bc7bedc47dc64a83");
require("801792fa2172589e");
require("840da01440ae4dc8");
var OptionalPortal = require("e9b4c17d3eb3763");
var ModalBase_context = require("53ea468014f79fb8");
var useModal = require("7427aeadfd9c4e95");
var ModalBase = React.forwardRef(function(_param, ref) {
    var keepMounted = _param.keepMounted, opened = _param.opened, onClose = _param.onClose, id = _param.id, transitionProps = _param.transitionProps, onExitTransitionEnd = _param.onExitTransitionEnd, onEnterTransitionEnd = _param.onEnterTransitionEnd, trapFocus = _param.trapFocus, closeOnEscape = _param.closeOnEscape, returnFocus = _param.returnFocus, closeOnClickOutside = _param.closeOnClickOutside, withinPortal = _param.withinPortal, portalProps = _param.portalProps, lockScroll = _param.lockScroll, children = _param.children, zIndex = _param.zIndex, shadow = _param.shadow, padding = _param.padding, __vars = _param.__vars, unstyled = _param.unstyled, removeScrollProps = _param.removeScrollProps, others = (0, _objectWithoutProperties._)(_param, [
        "keepMounted",
        "opened",
        "onClose",
        "id",
        "transitionProps",
        "onExitTransitionEnd",
        "onEnterTransitionEnd",
        "trapFocus",
        "closeOnEscape",
        "returnFocus",
        "closeOnClickOutside",
        "withinPortal",
        "portalProps",
        "lockScroll",
        "children",
        "zIndex",
        "shadow",
        "padding",
        "__vars",
        "unstyled",
        "removeScrollProps"
    ]);
    var _useModal_useModal = useModal.useModal({
        id,
        transitionProps,
        opened,
        trapFocus,
        closeOnEscape,
        onClose,
        returnFocus
    }), _id = _useModal_useModal._id, titleMounted = _useModal_useModal.titleMounted, bodyMounted = _useModal_useModal.bodyMounted, shouldLockScroll = _useModal_useModal.shouldLockScroll, setTitleMounted = _useModal_useModal.setTitleMounted, setBodyMounted = _useModal_useModal.setBodyMounted;
    var _ref = removeScrollProps || {}, removeScrollKey = _ref.key, otherRemoveScrollProps = (0, _objectWithoutProperties._)(_ref, [
        "key"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(OptionalPortal.OptionalPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, portalProps), {
        withinPortal,
        children: /* @__PURE__ */ jsxRuntime.jsx(ModalBase_context.ModalBaseProvider, {
            value: {
                opened,
                onClose,
                closeOnClickOutside,
                onExitTransitionEnd,
                onEnterTransitionEnd,
                transitionProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, transitionProps), {
                    keepMounted
                }),
                getTitleId: function() {
                    return `${_id}-title`;
                },
                getBodyId: function() {
                    return `${_id}-body`;
                },
                titleMounted,
                bodyMounted,
                setTitleMounted,
                setBodyMounted,
                trapFocus,
                closeOnEscape,
                zIndex,
                unstyled
            },
            children: /* @__PURE__ */ jsxRuntime.jsx(reactRemoveScroll.RemoveScroll, (0, _objectSpreadProps._)((0, _objectSpread._)({
                enabled: shouldLockScroll && lockScroll
            }, otherRemoveScrollProps), {
                children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    ref
                }, others), {
                    __vars: (0, _objectSpreadProps._)((0, _objectSpread._)({}, __vars), {
                        "--mb-z-index": (zIndex || getDefaultZIndex.getDefaultZIndex("modal")).toString(),
                        "--mb-shadow": getSize.getShadow(shadow),
                        "--mb-padding": getSize.getSpacing(padding)
                    }),
                    children
                }))
            }), removeScrollKey)
        })
    }));
});
ModalBase.displayName = "@mantine/core/ModalBase";
exports.ModalBase = ModalBase; //# sourceMappingURL=ModalBase.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","8b6d184f982bc69b":"iKGFf","9f96df96e864829a":"9MtAM","aa897db1cf1af267":"2ufGf","7a0d9f8249af40f4":"4gavl","d377861f377cc8b8":"kEFEY","10dcebd07d529cf4":"9HEEB","cc588dd79127d4eb":"8QFOC","3b79d4e4f7e4bd6a":"2FdJg","4df67d8135f19513":"6AMGA","9733cc5ec380d678":"erSvz","8e270c1048cd634f":"kqQOF","ed6b5a0c80dec02":"8YP4O","bc7bedc47dc64a83":"gkGXc","801792fa2172589e":"2onWA","840da01440ae4dc8":"6YZdR","e9b4c17d3eb3763":"3Y9Li","53ea468014f79fb8":"6qxdy","7427aeadfd9c4e95":"hTe4N"}],"6qxdy":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("d6792a88b3f91886");
var createSafeContext = require("e0093aebbc9a0463");
require("a49b0e152d951e14");
require("5b35198bece9c4bd");
require("6131e559c03496b9");
require("c4e3e7e60e3316");
require("79ac9e2717343de9");
require("b7a8be8a7885dcee");
require("aaa82e0bb110cfa1");
require("42c2c0321d1a6785");
require("dbb1ad900819f68c");
require("ac6e259781a75d49");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("ModalBase component was not found in tree"), 2), ModalBaseProvider = _createSafeContext_createSafeContext[0], useModalBaseContext = _createSafeContext_createSafeContext[1];
exports.ModalBaseProvider = ModalBaseProvider;
exports.useModalBaseContext = useModalBaseContext; //# sourceMappingURL=ModalBase.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","d6792a88b3f91886":"9MtAM","e0093aebbc9a0463":"8srze","a49b0e152d951e14":"iKGFf","5b35198bece9c4bd":"9HEEB","6131e559c03496b9":"8QFOC","c4e3e7e60e3316":"2FdJg","79ac9e2717343de9":"6AMGA","b7a8be8a7885dcee":"erSvz","aaa82e0bb110cfa1":"kqQOF","42c2c0321d1a6785":"8YP4O","dbb1ad900819f68c":"gkGXc","ac6e259781a75d49":"2onWA"}],"hTe4N":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("b7b806736dfe943f");
var hooks = require("35f81685d24e7971");
var useLockScroll = require("a3019791739b2e10");
function useModal(param) {
    var id = param.id, transitionProps = param.transitionProps, opened = param.opened, trapFocus = param.trapFocus, closeOnEscape = param.closeOnEscape, onClose = param.onClose, returnFocus = param.returnFocus;
    var _id = hooks.useId(id);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), titleMounted = _React_useState[0], setTitleMounted = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(false), 2), bodyMounted = _React_useState1[0], setBodyMounted = _React_useState1[1];
    var transitionDuration = typeof (transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.duration) === "number" ? transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.duration : 200;
    var shouldLockScroll = useLockScroll.useLockScroll({
        opened,
        transitionDuration
    });
    hooks.useWindowEvent("keydown", function(event) {
        if (event.key === "Escape" && closeOnEscape && !event.isComposing && opened) {
            var _event_target;
            var shouldTrigger = ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.getAttribute("data-mantine-stop-propagation")) !== "true";
            shouldTrigger && onClose();
        }
    }, {
        capture: true
    });
    hooks.useFocusReturn({
        opened,
        shouldReturnFocus: trapFocus && returnFocus
    });
    return {
        _id,
        titleMounted,
        bodyMounted,
        shouldLockScroll,
        setTitleMounted,
        setBodyMounted
    };
}
exports.useModal = useModal; //# sourceMappingURL=use-modal.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","b7b806736dfe943f":"9MtAM","35f81685d24e7971":"9HEEB","a3019791739b2e10":"1ePxD"}],"1ePxD":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("8d8a414074c6c4ae");
var hooks = require("7413572ee803a915");
function useLockScroll(param) {
    var opened = param.opened, transitionDuration = param.transitionDuration;
    var _React_useState = (0, _slicedToArray._)(React.useState(opened), 2), shouldLockScroll = _React_useState[0], setShouldLockScroll = _React_useState[1];
    var timeout = React.useRef(-1);
    var reduceMotion = hooks.useReducedMotion();
    var _transitionDuration = reduceMotion ? 0 : transitionDuration;
    React.useEffect(function() {
        if (opened) {
            setShouldLockScroll(true);
            window.clearTimeout(timeout.current);
        } else if (_transitionDuration === 0) setShouldLockScroll(false);
        else timeout.current = window.setTimeout(function() {
            return setShouldLockScroll(false);
        }, _transitionDuration);
        return function() {
            return window.clearTimeout(timeout.current);
        };
    }, [
        opened,
        _transitionDuration
    ]);
    return shouldLockScroll;
}
exports.useLockScroll = useLockScroll; //# sourceMappingURL=use-lock-scroll.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","8d8a414074c6c4ae":"9MtAM","7413572ee803a915":"9HEEB"}],"8i8nh":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("6f512aa54d79da1d");
var React = require("6ff128df13aabe39");
var cx = require("113447497fb7f1ea");
require("a7bd1719dd0b0593");
require("2bd5aba3a9a9274e");
require("a6fe5d56f3c73bd6");
require("e2ce373cd172da89");
require("7f5110fef16dd84e");
require("12eb2881213c4d27");
var Box = require("c341f669d2b51550");
require("2e2b77d971dd8cd8");
var ModalBase_context = require("39dcc41b272b30a4");
var useModalBodyId = require("59daf58351bbf8ac");
var ModalBase_module = require("22fdb920653dd362");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var ModalBaseBody = React.forwardRef(function(_param, ref) {
    var className = _param.className, others = (0, _objectWithoutProperties._)(_param, [
        "className"
    ]);
    var bodyId = useModalBodyId.useModalBodyId();
    var ctx = ModalBase_context.useModalBaseContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, others), {
        id: bodyId,
        className: cx__default.default({
            [ModalBase_module.body]: !ctx.unstyled
        }, className)
    }));
});
ModalBaseBody.displayName = "@mantine/core/ModalBaseBody";
exports.ModalBaseBody = ModalBaseBody; //# sourceMappingURL=ModalBaseBody.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","6f512aa54d79da1d":"iKGFf","6ff128df13aabe39":"9MtAM","113447497fb7f1ea":"8QFOC","a7bd1719dd0b0593":"9HEEB","2bd5aba3a9a9274e":"2FdJg","a6fe5d56f3c73bd6":"6AMGA","e2ce373cd172da89":"erSvz","7f5110fef16dd84e":"kqQOF","12eb2881213c4d27":"8YP4O","c341f669d2b51550":"gkGXc","2e2b77d971dd8cd8":"2onWA","39dcc41b272b30a4":"6qxdy","59daf58351bbf8ac":"gzdiE","22fdb920653dd362":"iSCjA"}],"gzdiE":[function(require,module,exports) {
"use client";
"use strict";
var React = require("9dfa8cee23343154");
var ModalBase_context = require("3aa209c44f9d29b8");
function useModalBodyId() {
    var ctx = ModalBase_context.useModalBaseContext();
    React.useEffect(function() {
        ctx.setBodyMounted(true);
        return function() {
            return ctx.setBodyMounted(false);
        };
    }, []);
    return ctx.getBodyId();
}
exports.useModalBodyId = useModalBodyId; //# sourceMappingURL=use-modal-body-id.cjs.map

},{"9dfa8cee23343154":"9MtAM","3aa209c44f9d29b8":"6qxdy"}],"iSCjA":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "title": "m_615af6c9",
    "header": "m_b5489c3c",
    "inner": "m_60c222c7",
    "content": "m_fd1ab0aa",
    "close": "m_606cb269",
    "body": "m_5df29311"
};
module.exports = classes; //# sourceMappingURL=ModalBase.module.css.cjs.map

},{}],"ifiLz":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c6ca620a7a8375de");
var React = require("f45e11f210f21908");
var cx = require("3f39d13b37f8b1af");
require("e45467c736dfe08a");
var CloseButton = require("3d8f4b31b92de196");
var ModalBase_context = require("dae94829dfc468f");
var ModalBase_module = require("624a4a79b7d88561");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var ModalBaseCloseButton = React.forwardRef(function(_param, ref) {
    var className = _param.className, onClick = _param.onClick, others = (0, _objectWithoutProperties._)(_param, [
        "className",
        "onClick"
    ]);
    var ctx = ModalBase_context.useModalBaseContext();
    return /* @__PURE__ */ jsxRuntime.jsx(CloseButton.CloseButton, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, others), {
        onClick: function(event) {
            ctx.onClose();
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        },
        className: cx__default.default({
            [ModalBase_module.close]: !ctx.unstyled
        }, className),
        unstyled: ctx.unstyled
    }));
});
ModalBaseCloseButton.displayName = "@mantine/core/ModalBaseCloseButton";
exports.ModalBaseCloseButton = ModalBaseCloseButton; //# sourceMappingURL=ModalBaseCloseButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c6ca620a7a8375de":"iKGFf","f45e11f210f21908":"9MtAM","3f39d13b37f8b1af":"8QFOC","e45467c736dfe08a":"h6AYi","3d8f4b31b92de196":"4ZuRG","dae94829dfc468f":"6qxdy","624a4a79b7d88561":"iSCjA"}],"8qmr0":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("880f827683976fc3");
var React = require("1a785129bd8b53da");
var cx = require("bffb070b13b204b8");
var FocusTrap = require("cd7b884351473ae3");
var Paper = require("2ed77c797e94be79");
var Transition = require("94ea2ab8e47185c0");
var ModalBase_context = require("faec4ab3761cc55e");
var ModalBase_module = require("ea47dfa23d22242b");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var ModalBaseContent = React.forwardRef(function(_param, ref) {
    var transitionProps = _param.transitionProps, className = _param.className, innerProps = _param.innerProps, onKeyDown = _param.onKeyDown, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "transitionProps",
        "className",
        "innerProps",
        "onKeyDown",
        "style"
    ]);
    var ctx = ModalBase_context.useModalBaseContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        mounted: ctx.opened,
        transition: "pop"
    }, ctx.transitionProps), {
        onExited: function() {
            var _ctx_onExitTransitionEnd, _ctx_transitionProps_onExited, _ctx_transitionProps;
            (_ctx_onExitTransitionEnd = ctx.onExitTransitionEnd) === null || _ctx_onExitTransitionEnd === void 0 ? void 0 : _ctx_onExitTransitionEnd.call(ctx);
            (_ctx_transitionProps = ctx.transitionProps) === null || _ctx_transitionProps === void 0 ? void 0 : (_ctx_transitionProps_onExited = _ctx_transitionProps.onExited) === null || _ctx_transitionProps_onExited === void 0 ? void 0 : _ctx_transitionProps_onExited.call(_ctx_transitionProps);
        },
        onEntered: function() {
            var _ctx_onEnterTransitionEnd, _ctx_transitionProps_onEntered, _ctx_transitionProps;
            (_ctx_onEnterTransitionEnd = ctx.onEnterTransitionEnd) === null || _ctx_onEnterTransitionEnd === void 0 ? void 0 : _ctx_onEnterTransitionEnd.call(ctx);
            (_ctx_transitionProps = ctx.transitionProps) === null || _ctx_transitionProps === void 0 ? void 0 : (_ctx_transitionProps_onEntered = _ctx_transitionProps.onEntered) === null || _ctx_transitionProps_onEntered === void 0 ? void 0 : _ctx_transitionProps_onEntered.call(_ctx_transitionProps);
        }
    }), transitionProps), {
        children: function(transitionStyles) {
            return /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, innerProps), {
                className: cx__default.default({
                    [ModalBase_module.inner]: !ctx.unstyled
                }, innerProps.className),
                children: /* @__PURE__ */ jsxRuntime.jsx(FocusTrap.FocusTrap, {
                    active: ctx.opened && ctx.trapFocus,
                    innerRef: ref,
                    children: /* @__PURE__ */ jsxRuntime.jsx(Paper.Paper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
                        component: "section",
                        role: "dialog",
                        tabIndex: -1,
                        "aria-modal": true,
                        "aria-describedby": ctx.bodyMounted ? ctx.getBodyId() : void 0,
                        "aria-labelledby": ctx.titleMounted ? ctx.getTitleId() : void 0,
                        style: [
                            style,
                            transitionStyles
                        ],
                        className: cx__default.default({
                            [ModalBase_module.content]: !ctx.unstyled
                        }, className),
                        unstyled: ctx.unstyled,
                        children: others.children
                    }))
                })
            }));
        }
    }));
});
ModalBaseContent.displayName = "@mantine/core/ModalBaseContent";
exports.ModalBaseContent = ModalBaseContent; //# sourceMappingURL=ModalBaseContent.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","880f827683976fc3":"iKGFf","1a785129bd8b53da":"9MtAM","bffb070b13b204b8":"8QFOC","cd7b884351473ae3":"keIAJ","2ed77c797e94be79":"amEW4","94ea2ab8e47185c0":"2T0Xr","faec4ab3761cc55e":"6qxdy","ea47dfa23d22242b":"iSCjA"}],"fsdDM":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("d09c24b9bddffde6");
var React = require("5dcace05ec171827");
var cx = require("2a5a6984aeeca9fa");
require("690997414eaf0be4");
require("27f3d975a8b62b3d");
require("c71349bd3feac756");
require("3da49662a26f65ab");
require("e14a9eb83d13aad0");
require("91afe13728fc58b6");
var Box = require("9e818f0498a7da2d");
require("adfd163877baf93");
var ModalBase_context = require("78ef3326da29b502");
var ModalBase_module = require("8566c7795175489c");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var ModalBaseHeader = React.forwardRef(function(_param, ref) {
    var className = _param.className, others = (0, _objectWithoutProperties._)(_param, [
        "className"
    ]);
    var ctx = ModalBase_context.useModalBaseContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        component: "header",
        ref,
        className: cx__default.default({
            [ModalBase_module.header]: !ctx.unstyled
        }, className)
    }, others));
});
ModalBaseHeader.displayName = "@mantine/core/ModalBaseHeader";
exports.ModalBaseHeader = ModalBaseHeader; //# sourceMappingURL=ModalBaseHeader.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","d09c24b9bddffde6":"iKGFf","5dcace05ec171827":"9MtAM","2a5a6984aeeca9fa":"8QFOC","690997414eaf0be4":"9HEEB","27f3d975a8b62b3d":"2FdJg","c71349bd3feac756":"6AMGA","3da49662a26f65ab":"erSvz","e14a9eb83d13aad0":"kqQOF","91afe13728fc58b6":"8YP4O","9e818f0498a7da2d":"gkGXc","adfd163877baf93":"2onWA","78ef3326da29b502":"6qxdy","8566c7795175489c":"iSCjA"}],"fj3f7":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("d770091235ce5ef2");
var React = require("8341596c51ef70e");
var Overlay = require("ff2ae4980f9c1af7");
var Transition = require("ea4c46605514bc59");
var ModalBase_context = require("d7f8425e75e5cf3f");
var useModalTransition = require("a208b661d02ce4f4");
var ModalBaseOverlay = React.forwardRef(function(_param, ref) {
    var onClick = _param.onClick, transitionProps = _param.transitionProps, style = _param.style, visible = _param.visible, others = (0, _objectWithoutProperties._)(_param, [
        "onClick",
        "transitionProps",
        "style",
        "visible"
    ]);
    var ctx = ModalBase_context.useModalBaseContext();
    var transition = useModalTransition.useModalTransition(transitionProps);
    return /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, (0, _objectSpreadProps._)((0, _objectSpread._)({
        mounted: visible !== void 0 ? visible : ctx.opened
    }, transition), {
        transition: "fade",
        children: function(transitionStyles) {
            return /* @__PURE__ */ jsxRuntime.jsx(Overlay.Overlay, (0, _objectSpread._)({
                ref,
                fixed: true,
                style: [
                    style,
                    transitionStyles
                ],
                zIndex: ctx.zIndex,
                unstyled: ctx.unstyled,
                onClick: function(event) {
                    onClick === null || onClick === void 0 ? void 0 : onClick(event);
                    ctx.closeOnClickOutside && ctx.onClose();
                }
            }, others));
        }
    }));
});
ModalBaseOverlay.displayName = "@mantine/core/ModalBaseOverlay";
exports.ModalBaseOverlay = ModalBaseOverlay; //# sourceMappingURL=ModalBaseOverlay.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","d770091235ce5ef2":"iKGFf","8341596c51ef70e":"9MtAM","ff2ae4980f9c1af7":"9e5lu","ea4c46605514bc59":"2T0Xr","d7f8425e75e5cf3f":"6qxdy","a208b661d02ce4f4":"bUZJG"}],"bUZJG":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var ModalBase_context = require("1bcb29f2695edaff");
var DEFAULT_TRANSITION = {
    duration: 200,
    timingFunction: "ease",
    transition: "fade"
};
function useModalTransition(transitionOverride) {
    var ctx = ModalBase_context.useModalBaseContext();
    return (0, _objectSpread._)({}, DEFAULT_TRANSITION, ctx.transitionProps, transitionOverride);
}
exports.useModalTransition = useModalTransition; //# sourceMappingURL=use-modal-transition.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","1bcb29f2695edaff":"6qxdy"}],"5DnfR":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("22fd3e5bdb076d7b");
var React = require("4de499c3ebeadfb0");
var cx = require("1d5dc473116f42db");
require("46b8e2d686b5941c");
require("9b91f37b49ae3b63");
require("72b06fde316fadc0");
require("538e06369ad95635");
require("7e36fdc4f3a0195f");
require("73342f39a47e7ba1");
var Box = require("ecb67f82a714c73b");
require("9c3b5bf5e791f72");
var ModalBase_context = require("58072cb0cdc0c272");
var useModalTitleId = require("70c1bc4e453dde1d");
var ModalBase_module = require("37763270a7a44367");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var ModalBaseTitle = React.forwardRef(function(_param, ref) {
    var className = _param.className, others = (0, _objectWithoutProperties._)(_param, [
        "className"
    ]);
    var id = useModalTitleId.useModalTitle();
    var ctx = ModalBase_context.useModalBaseContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "h2",
        ref,
        className: cx__default.default({
            [ModalBase_module.title]: !ctx.unstyled
        }, className)
    }, others), {
        id
    }));
});
ModalBaseTitle.displayName = "@mantine/core/ModalBaseTitle";
exports.ModalBaseTitle = ModalBaseTitle; //# sourceMappingURL=ModalBaseTitle.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","22fd3e5bdb076d7b":"iKGFf","4de499c3ebeadfb0":"9MtAM","1d5dc473116f42db":"8QFOC","46b8e2d686b5941c":"9HEEB","9b91f37b49ae3b63":"2FdJg","72b06fde316fadc0":"6AMGA","538e06369ad95635":"erSvz","7e36fdc4f3a0195f":"kqQOF","73342f39a47e7ba1":"8YP4O","ecb67f82a714c73b":"gkGXc","9c3b5bf5e791f72":"2onWA","58072cb0cdc0c272":"6qxdy","70c1bc4e453dde1d":"1QOiq","37763270a7a44367":"iSCjA"}],"1QOiq":[function(require,module,exports) {
"use client";
"use strict";
var React = require("6dd484df64079a92");
var ModalBase_context = require("536dc4cf21552390");
function useModalTitle() {
    var ctx = ModalBase_context.useModalBaseContext();
    React.useEffect(function() {
        ctx.setTitleMounted(true);
        return function() {
            return ctx.setTitleMounted(false);
        };
    }, []);
    return ctx.getTitleId();
}
exports.useModalTitle = useModalTitle; //# sourceMappingURL=use-modal-title-id.cjs.map

},{"6dd484df64079a92":"9MtAM","536dc4cf21552390":"6qxdy"}],"d55zN":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("db0e83262b7fb1ae");
function NativeScrollArea(param) {
    var children = param.children;
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children
    });
}
exports.NativeScrollArea = NativeScrollArea; //# sourceMappingURL=NativeScrollArea.cjs.map

},{"db0e83262b7fb1ae":"iKGFf"}],"dkUgf":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3597689d1be5ac75");
var rem = require("bbaa9e1f8b22a4ae");
require("42afddc8fac6b7b2");
var getSize = require("ed3fb8ef5ea29aaf");
require("a653a12be57944e8");
var createVarsResolver = require("d28bfdaa6d3b85e");
require("bd4e656df75f32e4");
require("4ac45b56f8067e29");
require("6b6e065359c3383e");
require("adc68bd0b675e6cf");
require("2c44ac0c6b063612");
var useProps = require("d58f2619371fafcd");
require("4590ee81e3c70ae3");
var useStyles = require("a35474d25d616a22");
var extractStyleProps = require("a4b905b5d81b353e");
var Box = require("71ad1c2f3625df8b");
var polymorphicFactory = require("6f8bfc9c9645a16d");
require("6c26a93a00751ca9");
var Input_context = require("54e1e8161d53ead3");
var InputClearButton = require("43efd44da134a31f");
var InputDescription = require("ef19937ae0dc56e2");
var InputError = require("2e041aff08617dc");
var InputLabel = require("5b8de5c2a43af54e");
var InputPlaceholder = require("7b39826a9e4a2082");
var InputWrapper_context = require("7ff2ff223e1aef7");
var InputWrapper = require("d7dd3df0be27aa80");
var Input_module = require("142d8744f1069b0f");
var defaultProps = {
    variant: "default",
    leftSectionPointerEvents: "none",
    rightSectionPointerEvents: "none",
    withAria: true,
    withErrorStyles: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, props, ctx) {
    return {
        wrapper: {
            "--input-margin-top": ctx.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-margin-bottom": ctx.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-height": getSize.getSize(props.size, "input-height"),
            "--input-fz": getSize.getFontSize(props.size),
            "--input-radius": props.radius === void 0 ? void 0 : getSize.getRadius(props.radius),
            "--input-left-section-width": props.leftSectionWidth !== void 0 ? rem.rem(props.leftSectionWidth) : void 0,
            "--input-right-section-width": props.rightSectionWidth !== void 0 ? rem.rem(props.rightSectionWidth) : void 0,
            "--input-padding-y": props.multiline ? getSize.getSize(props.size, "input-padding-y") : void 0,
            "--input-left-section-pointer-events": props.leftSectionPointerEvents,
            "--input-right-section-pointer-events": props.rightSectionPointerEvents
        }
    };
});
var Input = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Input", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, required = props.required, __staticSelector = props.__staticSelector, __stylesApiProps = props.__stylesApiProps, size = props.size, wrapperProps = props.wrapperProps, error = props.error, disabled = props.disabled, leftSection = props.leftSection, leftSectionProps = props.leftSectionProps, leftSectionWidth = props.leftSectionWidth, rightSection = props.rightSection, rightSectionProps = props.rightSectionProps, rightSectionWidth = props.rightSectionWidth, rightSectionPointerEvents = props.rightSectionPointerEvents, leftSectionPointerEvents = props.leftSectionPointerEvents, variant = props.variant, vars = props.vars, pointer = props.pointer, multiline = props.multiline, radius = props.radius, id = props.id, withAria = props.withAria, withErrorStyles = props.withErrorStyles, mod = props.mod, inputSize = props.inputSize, __clearSection = props.__clearSection, __clearable = props.__clearable, __defaultRightSection = props.__defaultRightSection, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "required",
        "__staticSelector",
        "__stylesApiProps",
        "size",
        "wrapperProps",
        "error",
        "disabled",
        "leftSection",
        "leftSectionProps",
        "leftSectionWidth",
        "rightSection",
        "rightSectionProps",
        "rightSectionWidth",
        "rightSectionPointerEvents",
        "leftSectionPointerEvents",
        "variant",
        "vars",
        "pointer",
        "multiline",
        "radius",
        "id",
        "withAria",
        "withErrorStyles",
        "mod",
        "inputSize",
        "__clearSection",
        "__clearable",
        "__defaultRightSection"
    ]);
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var ctx = InputWrapper_context.useInputWrapperContext();
    var stylesCtx = {
        offsetBottom: ctx === null || ctx === void 0 ? void 0 : ctx.offsetBottom,
        offsetTop: ctx === null || ctx === void 0 ? void 0 : ctx.offsetTop
    };
    var getStyles = useStyles.useStyles({
        name: [
            "Input",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: Input_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        stylesCtx,
        rootSelector: "wrapper",
        vars,
        varsResolver
    });
    var ariaAttributes = withAria ? {
        required,
        disabled,
        "aria-invalid": !!error,
        "aria-describedby": ctx === null || ctx === void 0 ? void 0 : ctx.describedBy,
        id: (ctx === null || ctx === void 0 ? void 0 : ctx.inputId) || id
    } : {};
    var _rightSection = rightSection || __clearable && __clearSection || __defaultRightSection;
    return /* @__PURE__ */ jsxRuntime.jsx(Input_context.InputContext, {
        value: {
            size: size || "sm"
        },
        children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("wrapper"), styleProps, wrapperProps), {
            mod: [
                {
                    error: !!error && withErrorStyles,
                    pointer,
                    disabled,
                    multiline,
                    "data-with-right-section": !!_rightSection,
                    "data-with-left-section": !!leftSection
                },
                mod
            ],
            variant,
            size,
            children: [
                leftSection && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, leftSectionProps), {
                    "data-position": "left"
                }), getStyles("section", {
                    className: leftSectionProps === null || leftSectionProps === void 0 ? void 0 : leftSectionProps.className,
                    style: leftSectionProps === null || leftSectionProps === void 0 ? void 0 : leftSectionProps.style
                })), {
                    children: leftSection
                })),
                /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                    component: "input"
                }, rest, ariaAttributes), {
                    ref,
                    required,
                    mod: {
                        disabled,
                        error: !!error && withErrorStyles
                    },
                    variant,
                    __size: inputSize
                }), getStyles("input"))),
                _rightSection && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, rightSectionProps), {
                    "data-position": "right"
                }), getStyles("section", {
                    className: rightSectionProps === null || rightSectionProps === void 0 ? void 0 : rightSectionProps.className,
                    style: rightSectionProps === null || rightSectionProps === void 0 ? void 0 : rightSectionProps.style
                })), {
                    children: _rightSection
                }))
            ]
        }))
    });
});
Input.classes = Input_module;
Input.Wrapper = InputWrapper.InputWrapper;
Input.Label = InputLabel.InputLabel;
Input.Error = InputError.InputError;
Input.Description = InputDescription.InputDescription;
Input.Placeholder = InputPlaceholder.InputPlaceholder;
Input.ClearButton = InputClearButton.InputClearButton;
Input.displayName = "@mantine/core/Input";
exports.Input = Input; //# sourceMappingURL=Input.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","3597689d1be5ac75":"iKGFf","bbaa9e1f8b22a4ae":"ebAaL","42afddc8fac6b7b2":"9MtAM","ed3fb8ef5ea29aaf":"kEFEY","a653a12be57944e8":"9HEEB","d28bfdaa6d3b85e":"hIQE6","bd4e656df75f32e4":"8QFOC","4ac45b56f8067e29":"2FdJg","6b6e065359c3383e":"6AMGA","adc68bd0b675e6cf":"erSvz","2c44ac0c6b063612":"kqQOF","d58f2619371fafcd":"iivvn","4590ee81e3c70ae3":"8YP4O","a35474d25d616a22":"d0sAY","a4b905b5d81b353e":"6L93n","71ad1c2f3625df8b":"gkGXc","6f8bfc9c9645a16d":"iYAEL","6c26a93a00751ca9":"2onWA","54e1e8161d53ead3":"8FhRS","43efd44da134a31f":"hxtex","ef19937ae0dc56e2":"7nO1x","2e041aff08617dc":"3Bda4","5b8de5c2a43af54e":"gQBOr","7b39826a9e4a2082":"lRBdM","7ff2ff223e1aef7":"lQt5D","d7dd3df0be27aa80":"j4uTK","142d8744f1069b0f":"2p6b3"}],"8FhRS":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("c1d511bbed4a27fe");
require("51760d11e73c1b79");
var createOptionalContext = require("6e2aac1eff3dbd92");
require("a234e63ef5b064b3");
require("2510fc09185b74c");
require("f2cdd1acb38f87f4");
require("16b679b617458dec");
require("d771529a78ec3253");
require("46199e20f61d25ca");
require("d4f637e3e67d6281");
require("ba235b76b85c7f5e");
require("b994e7b822a9b741");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext({
    size: "sm"
}), 2), InputContext = _createOptionalContext_createOptionalContext[0], useInputContext = _createOptionalContext_createOptionalContext[1];
exports.InputContext = InputContext;
exports.useInputContext = useInputContext; //# sourceMappingURL=Input.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","c1d511bbed4a27fe":"9MtAM","51760d11e73c1b79":"iKGFf","6e2aac1eff3dbd92":"7cMAR","a234e63ef5b064b3":"9HEEB","2510fc09185b74c":"8QFOC","f2cdd1acb38f87f4":"2FdJg","16b679b617458dec":"6AMGA","d771529a78ec3253":"erSvz","46199e20f61d25ca":"kqQOF","d4f637e3e67d6281":"8YP4O","ba235b76b85c7f5e":"gkGXc","b994e7b822a9b741":"2onWA"}],"hxtex":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("57c8dc27a1c2ecb6");
require("a176773b9badc5fe");
require("154672324d52cc8e");
require("21bab86a0fe3dc1e");
var useResolvedStylesApi = require("f5a762086593faab");
require("29732df3e9837b22");
require("8f0d4f20596aab07");
require("d9fe40520589ed5a");
require("cf15dab0ad20020e");
var useProps = require("b342aed32f1d9c25");
require("5165a771964d7274");
require("be94ba07600268d0");
var factory = require("964f5aa1a9a23513");
require("f05f453a1d8b70fe");
require("7378686fed453f39");
var CloseButton = require("8feebf68b7c1cab7");
var Input_context = require("340a6525d6b189ad");
var defaultProps = {};
var InputClearButton = factory.factory(function(_props, ref) {
    var props = useProps.useProps("InputClearButton", defaultProps, _props);
    var size = props.size, variant = props.variant, vars = props.vars, classNames = props.classNames, styles = props.styles, others = (0, _objectWithoutProperties._)(props, [
        "size",
        "variant",
        "vars",
        "classNames",
        "styles"
    ]);
    var ctx = Input_context.useInputContext();
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    return /* @__PURE__ */ jsxRuntime.jsx(CloseButton.CloseButton, (0, _objectSpread._)({
        variant: variant || "transparent",
        ref,
        size: size || (ctx === null || ctx === void 0 ? void 0 : ctx.size) || "sm",
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        __staticSelector: "InputClearButton"
    }, others));
});
InputClearButton.displayName = "@mantine/core/InputClearButton";
exports.InputClearButton = InputClearButton; //# sourceMappingURL=InputClearButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","57c8dc27a1c2ecb6":"iKGFf","a176773b9badc5fe":"9MtAM","154672324d52cc8e":"9HEEB","21bab86a0fe3dc1e":"8QFOC","f5a762086593faab":"d30sL","29732df3e9837b22":"2FdJg","8f0d4f20596aab07":"6AMGA","d9fe40520589ed5a":"erSvz","cf15dab0ad20020e":"kqQOF","b342aed32f1d9c25":"iivvn","5165a771964d7274":"8YP4O","be94ba07600268d0":"gkGXc","964f5aa1a9a23513":"guLFz","f05f453a1d8b70fe":"2onWA","7378686fed453f39":"h6AYi","8feebf68b7c1cab7":"4ZuRG","340a6525d6b189ad":"8FhRS"}],"7nO1x":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1d4d96f019743cee");
var rem = require("d6a73e85eca8a7d3");
require("78c124b4462fb7");
var getSize = require("cc2c3c29ce734806");
require("4561a9b97cbc4744");
var createVarsResolver = require("22b5a1c7893ed044");
require("1599bb2a0d3a2cf");
require("614d818b10620466");
require("f9c94d4dfea75102");
require("afebd5cde884627");
require("e35764e0286ca412");
var useProps = require("9f93ace0734307dd");
require("7e315bd6ac1fe190");
var useStyles = require("e75cfdb3eab8cc46");
var Box = require("5726bb212b6a865d");
var factory = require("5df928f78b11dbec");
require("ae2dd60f33d82895");
var InputWrapper_context = require("5990a01e387459ae");
var Input_module = require("6f5e6c0403730e98");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${getSize.getFontSize(size)} - ${rem.rem(2)})`
        }
    };
});
var InputDescription = factory.factory(function(_props, ref) {
    var props = useProps.useProps("InputDescription", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("InputDescription", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, vars = _useProps_useProps.vars, size = _useProps_useProps.size, __staticSelector = _useProps_useProps.__staticSelector, _useProps_useProps___inheritStyles = _useProps_useProps.__inheritStyles, __inheritStyles = _useProps_useProps___inheritStyles === void 0 ? true : _useProps_useProps___inheritStyles, variant = _useProps_useProps.variant, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "__staticSelector",
        "__inheritStyles",
        "variant"
    ]);
    var ctx = InputWrapper_context.useInputWrapperContext();
    var _getStyles = useStyles.useStyles({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props,
        classes: Input_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "description",
        vars,
        varsResolver
    });
    var getStyles = __inheritStyles && (ctx === null || ctx === void 0 ? void 0 : ctx.getStyles) || _getStyles;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        component: "p",
        ref,
        variant,
        size
    }, getStyles("description", (ctx === null || ctx === void 0 ? void 0 : ctx.getStyles) ? {
        className,
        style
    } : void 0), others));
});
InputDescription.classes = Input_module;
InputDescription.displayName = "@mantine/core/InputDescription";
exports.InputDescription = InputDescription; //# sourceMappingURL=InputDescription.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","1d4d96f019743cee":"iKGFf","d6a73e85eca8a7d3":"ebAaL","78c124b4462fb7":"9MtAM","cc2c3c29ce734806":"kEFEY","4561a9b97cbc4744":"9HEEB","22b5a1c7893ed044":"hIQE6","1599bb2a0d3a2cf":"8QFOC","614d818b10620466":"2FdJg","f9c94d4dfea75102":"6AMGA","afebd5cde884627":"erSvz","e35764e0286ca412":"kqQOF","9f93ace0734307dd":"iivvn","7e315bd6ac1fe190":"8YP4O","e75cfdb3eab8cc46":"d0sAY","5726bb212b6a865d":"gkGXc","5df928f78b11dbec":"guLFz","ae2dd60f33d82895":"2onWA","5990a01e387459ae":"lQt5D","6f5e6c0403730e98":"2p6b3"}],"lQt5D":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("6131b98a93625279");
require("b03a0139c40b24ed");
var createOptionalContext = require("9cc7187dd36562fc");
require("4eb47aec08090d86");
require("50fa9dba03b10cdc");
require("79b7de15e4280947");
require("bdabba06e787e95f");
require("ea27fb877fa70bb6");
require("5b7ba5781b2bb54a");
require("4a776d3674e570e8");
require("c1e82c87d401f78");
require("99ac48de4ff0abc3");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext({
    offsetBottom: false,
    offsetTop: false,
    describedBy: void 0,
    getStyles: null,
    inputId: void 0,
    labelId: void 0
}), 2), InputWrapperProvider = _createOptionalContext_createOptionalContext[0], useInputWrapperContext = _createOptionalContext_createOptionalContext[1];
exports.InputWrapperProvider = InputWrapperProvider;
exports.useInputWrapperContext = useInputWrapperContext; //# sourceMappingURL=InputWrapper.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","6131b98a93625279":"9MtAM","b03a0139c40b24ed":"iKGFf","9cc7187dd36562fc":"7cMAR","4eb47aec08090d86":"9HEEB","50fa9dba03b10cdc":"8QFOC","79b7de15e4280947":"2FdJg","bdabba06e787e95f":"6AMGA","ea27fb877fa70bb6":"erSvz","5b7ba5781b2bb54a":"kqQOF","4a776d3674e570e8":"8YP4O","c1e82c87d401f78":"gkGXc","99ac48de4ff0abc3":"2onWA"}],"2p6b3":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "wrapper": "m_6c018570",
    "input": "m_8fb7ebe7",
    "section": "m_82577fc2",
    "placeholder": "m_88bacfd0",
    "root": "m_46b77525",
    "label": "m_8fdc1311",
    "required": "m_78a94662",
    "error": "m_8f816625",
    "description": "m_fe47ce59"
};
module.exports = classes; //# sourceMappingURL=Input.module.css.cjs.map

},{}],"3Bda4":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("73fe5201632b5957");
var rem = require("9ca317138f289d9f");
require("5ad7089cf372c8");
var getSize = require("5aee82ca95ab299");
require("6742f7867984d4df");
var createVarsResolver = require("e3793af33b7da52b");
require("bdf0591ae270d202");
require("450a0371c068e4f4");
require("4a6aae590e024160");
require("15d9f1faa40065cd");
require("e83c4562f90384cb");
var useProps = require("5f4c82b0660efb55");
require("fd9cf7c7800f8cb0");
var useStyles = require("a80f765c7e72a63f");
var Box = require("f4961ffe349884f");
var factory = require("12f729617e1b2783");
require("f46b3a9671a5cec1");
var InputWrapper_context = require("9b1dab95e4b98b48");
var Input_module = require("a9d56a133b02e861");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${getSize.getFontSize(size)} - ${rem.rem(2)})`
        }
    };
});
var InputError = factory.factory(function(_props, ref) {
    var props = useProps.useProps("InputError", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, size = props.size, __staticSelector = props.__staticSelector, _props___inheritStyles = props.__inheritStyles, __inheritStyles = _props___inheritStyles === void 0 ? true : _props___inheritStyles, variant = props.variant, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "__staticSelector",
        "__inheritStyles",
        "variant"
    ]);
    var _getStyles = useStyles.useStyles({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props,
        classes: Input_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "error",
        vars,
        varsResolver
    });
    var ctx = InputWrapper_context.useInputWrapperContext();
    var getStyles = __inheritStyles && (ctx === null || ctx === void 0 ? void 0 : ctx.getStyles) || _getStyles;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        component: "p",
        ref,
        variant,
        size
    }, getStyles("error", (ctx === null || ctx === void 0 ? void 0 : ctx.getStyles) ? {
        className,
        style
    } : void 0), others));
});
InputError.classes = Input_module;
InputError.displayName = "@mantine/core/InputError";
exports.InputError = InputError; //# sourceMappingURL=InputError.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","73fe5201632b5957":"iKGFf","9ca317138f289d9f":"ebAaL","5ad7089cf372c8":"9MtAM","5aee82ca95ab299":"kEFEY","6742f7867984d4df":"9HEEB","e3793af33b7da52b":"hIQE6","bdf0591ae270d202":"8QFOC","450a0371c068e4f4":"2FdJg","4a6aae590e024160":"6AMGA","15d9f1faa40065cd":"erSvz","e83c4562f90384cb":"kqQOF","5f4c82b0660efb55":"iivvn","fd9cf7c7800f8cb0":"8YP4O","a80f765c7e72a63f":"d0sAY","f4961ffe349884f":"gkGXc","12f729617e1b2783":"guLFz","f46b3a9671a5cec1":"2onWA","9b1dab95e4b98b48":"lQt5D","a9d56a133b02e861":"2p6b3"}],"gQBOr":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b3abb3183730208a");
require("e15724c1494f4ede");
var getSize = require("7dd730f32f3c5a07");
require("29a66cdcde9cd56e");
var createVarsResolver = require("5a48497ac41c4134");
require("5139b3fb83cb2647");
require("2118a3546e811d4");
require("cd1b5d3640d990af");
require("18fc55a2745f54b0");
require("68a15212b6fea518");
var useProps = require("ace7a2e004661eb6");
require("dd7025c722a14e2a");
var useStyles = require("703ff22c91f137ca");
var Box = require("4a153460f88654db");
var factory = require("ff4e9cb499269597");
require("57e8e8d8aa6f1095");
var InputWrapper_context = require("10c299a8a6f2d0cf");
var Input_module = require("2e6567bdde728106");
var defaultProps = {
    labelElement: "label"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        label: {
            "--input-label-size": getSize.getFontSize(size),
            "--input-asterisk-color": void 0
        }
    };
});
var InputLabel = factory.factory(function(_props, ref) {
    var props = useProps.useProps("InputLabel", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("InputLabel", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, vars = _useProps_useProps.vars, labelElement = _useProps_useProps.labelElement, size = _useProps_useProps.size, required = _useProps_useProps.required, htmlFor = _useProps_useProps.htmlFor, onMouseDown = _useProps_useProps.onMouseDown, children = _useProps_useProps.children, __staticSelector = _useProps_useProps.__staticSelector, variant = _useProps_useProps.variant, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "labelElement",
        "size",
        "required",
        "htmlFor",
        "onMouseDown",
        "children",
        "__staticSelector",
        "variant",
        "mod"
    ]);
    var _getStyles = useStyles.useStyles({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props,
        classes: Input_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "label",
        vars,
        varsResolver
    });
    var ctx = InputWrapper_context.useInputWrapperContext();
    var getStyles = (ctx === null || ctx === void 0 ? void 0 : ctx.getStyles) || _getStyles;
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label", (ctx === null || ctx === void 0 ? void 0 : ctx.getStyles) ? {
        className,
        style
    } : void 0)), {
        component: labelElement,
        variant,
        size,
        ref,
        htmlFor: labelElement === "label" ? htmlFor : void 0,
        mod: [
            {
                required
            },
            mod
        ],
        onMouseDown: function(event) {
            onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    }), others), {
        children: [
            children,
            required && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("required")), {
                "aria-hidden": true,
                children: " *"
            }))
        ]
    }));
});
InputLabel.classes = Input_module;
InputLabel.displayName = "@mantine/core/InputLabel";
exports.InputLabel = InputLabel; //# sourceMappingURL=InputLabel.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","b3abb3183730208a":"iKGFf","e15724c1494f4ede":"9MtAM","7dd730f32f3c5a07":"kEFEY","29a66cdcde9cd56e":"9HEEB","5a48497ac41c4134":"hIQE6","5139b3fb83cb2647":"8QFOC","2118a3546e811d4":"2FdJg","cd1b5d3640d990af":"6AMGA","18fc55a2745f54b0":"erSvz","68a15212b6fea518":"kqQOF","ace7a2e004661eb6":"iivvn","dd7025c722a14e2a":"8YP4O","703ff22c91f137ca":"d0sAY","4a153460f88654db":"gkGXc","ff4e9cb499269597":"guLFz","57e8e8d8aa6f1095":"2onWA","10c299a8a6f2d0cf":"lQt5D","2e6567bdde728106":"2p6b3"}],"lRBdM":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("d8c0611a7facdfa6");
require("5cd471515da9fd16");
require("69ea68d2b40acaed");
require("24c6816ff1b893d");
require("4509ed361ee0c959");
require("445daf14b69f2fd4");
require("414781a5f5175519");
require("15fe1acebaf32fbd");
var useProps = require("b9f780caa954a6e5");
require("6408e8cae8921b2");
var useStyles = require("316507dfeaa1db99");
var Box = require("99405223078bda48");
var factory = require("27309f6e8a482b9b");
require("6d2e8c1a0f1fdff3");
var Input_module = require("8fbdda69ea4146b1");
var defaultProps = {};
var InputPlaceholder = factory.factory(function(_props, ref) {
    var props = useProps.useProps("InputPlaceholder", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("InputPlaceholder", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, vars = _useProps_useProps.vars, __staticSelector = _useProps_useProps.__staticSelector, variant = _useProps_useProps.variant, error = _useProps_useProps.error, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "__staticSelector",
        "variant",
        "error",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: [
            "InputPlaceholder",
            __staticSelector
        ],
        props,
        classes: Input_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "placeholder"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("placeholder")), {
        mod: [
            {
                error: !!error
            },
            mod
        ],
        component: "span",
        variant,
        ref
    }), others));
});
InputPlaceholder.classes = Input_module;
InputPlaceholder.displayName = "@mantine/core/InputPlaceholder";
exports.InputPlaceholder = InputPlaceholder; //# sourceMappingURL=InputPlaceholder.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","d8c0611a7facdfa6":"iKGFf","5cd471515da9fd16":"9MtAM","69ea68d2b40acaed":"9HEEB","24c6816ff1b893d":"8QFOC","4509ed361ee0c959":"2FdJg","445daf14b69f2fd4":"6AMGA","414781a5f5175519":"erSvz","15fe1acebaf32fbd":"kqQOF","b9f780caa954a6e5":"iivvn","6408e8cae8921b2":"8YP4O","316507dfeaa1db99":"d0sAY","99405223078bda48":"gkGXc","27309f6e8a482b9b":"guLFz","6d2e8c1a0f1fdff3":"2onWA","8fbdda69ea4146b1":"2p6b3"}],"j4uTK":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("9c06a26f45757fc1");
var React = require("c17ba46f1df6de3f");
var hooks = require("50174871922d329");
var rem = require("ec87e49a81f06831");
var getSize = require("aeba9ef1678a61f4");
var createVarsResolver = require("8ba4fe0e143a8f80");
require("1863eb2af9d57401");
require("77fb2ac5bb453cc6");
require("dc4f25867f3f99de");
require("786bd94da9fb3ce5");
require("7c696b8c152dab75");
var useProps = require("be172551dcdf29e5");
require("df2ca08d15beabed");
var useStyles = require("f14f57ad0fcb3261");
var Box = require("67b5a772aab34601");
var factory = require("38f7d06ed34a9200");
require("4c294ad2098a74f2");
var InputDescription = require("a1f1701f62f2d879");
var InputError = require("2f4247aadd61a986");
var InputLabel = require("4baaee414651d185");
var InputWrapper_context = require("1c481c2740e4fcc");
var getInputOffsets = require("b19c749a5cc31d1a");
var Input_module = require("94285782168e22f4");
var defaultProps = {
    labelElement: "label",
    inputContainer: function(children) {
        return children;
    },
    inputWrapperOrder: [
        "label",
        "description",
        "input",
        "error"
    ]
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        label: {
            "--input-label-size": getSize.getFontSize(size),
            "--input-asterisk-color": void 0
        },
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${getSize.getFontSize(size)} - ${rem.rem(2)})`
        },
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${getSize.getFontSize(size)} - ${rem.rem(2)})`
        }
    };
});
var InputWrapper = factory.factory(function(_props, ref) {
    var props = useProps.useProps("InputWrapper", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, size = props.size, variant = props.variant, __staticSelector = props.__staticSelector, inputContainer = props.inputContainer, inputWrapperOrder = props.inputWrapperOrder, label = props.label, error = props.error, description = props.description, labelProps = props.labelProps, descriptionProps = props.descriptionProps, errorProps = props.errorProps, labelElement = props.labelElement, children = props.children, withAsterisk = props.withAsterisk, id = props.id, required = props.required, __stylesApiProps = props.__stylesApiProps, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "variant",
        "__staticSelector",
        "inputContainer",
        "inputWrapperOrder",
        "label",
        "error",
        "description",
        "labelProps",
        "descriptionProps",
        "errorProps",
        "labelElement",
        "children",
        "withAsterisk",
        "id",
        "required",
        "__stylesApiProps",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: Input_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var sharedProps = {
        size,
        variant,
        __staticSelector
    };
    var idBase = hooks.useId(id);
    var isRequired = typeof withAsterisk === "boolean" ? withAsterisk : required;
    var errorId = (errorProps === null || errorProps === void 0 ? void 0 : errorProps.id) || `${idBase}-error`;
    var descriptionId = (descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.id) || `${idBase}-description`;
    var inputId = idBase;
    var hasError = !!error && typeof error !== "boolean";
    var hasDescription = !!description;
    var _describedBy = `${hasError ? errorId : ""} ${hasDescription ? descriptionId : ""}`;
    var describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
    var labelId = (labelProps === null || labelProps === void 0 ? void 0 : labelProps.id) || `${idBase}-label`;
    var _label = label && /* @__PURE__ */ jsxRuntime.jsx(InputLabel.InputLabel, (0, _objectSpreadProps._)((0, _objectSpread._)({
        labelElement,
        id: labelId,
        htmlFor: inputId,
        required: isRequired
    }, sharedProps, labelProps), {
        children: label
    }), "label");
    var _description = hasDescription && /* @__PURE__ */ jsxRuntime.jsx(InputDescription.InputDescription, (0, _objectSpreadProps._)((0, _objectSpread._)({}, descriptionProps, sharedProps), {
        size: (descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.size) || sharedProps.size,
        id: (descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.id) || descriptionId,
        children: description
    }), "description");
    var _input = /* @__PURE__ */ jsxRuntime.jsx(React.Fragment, {
        children: inputContainer(children)
    }, "input");
    var _error = hasError && /* @__PURE__ */ React.createElement(InputError.InputError, (0, _objectSpreadProps._)((0, _objectSpread._)({}, errorProps, sharedProps), {
        size: (errorProps === null || errorProps === void 0 ? void 0 : errorProps.size) || sharedProps.size,
        key: "error",
        id: (errorProps === null || errorProps === void 0 ? void 0 : errorProps.id) || errorId
    }), error);
    var content = inputWrapperOrder.map(function(part) {
        switch(part){
            case "label":
                return _label;
            case "input":
                return _input;
            case "description":
                return _description;
            case "error":
                return _error;
            default:
                return null;
        }
    });
    return /* @__PURE__ */ jsxRuntime.jsx(InputWrapper_context.InputWrapperProvider, {
        value: (0, _objectSpread._)({
            getStyles,
            describedBy,
            inputId,
            labelId
        }, getInputOffsets.getInputOffsets(inputWrapperOrder, {
            hasDescription,
            hasError
        })),
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref,
            variant,
            size,
            mod: [
                {
                    error: !!error
                },
                mod
            ]
        }, getStyles("root"), others), {
            children: content
        }))
    });
});
InputWrapper.classes = Input_module;
InputWrapper.displayName = "@mantine/core/InputWrapper";
exports.InputWrapper = InputWrapper; //# sourceMappingURL=InputWrapper.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","9c06a26f45757fc1":"iKGFf","c17ba46f1df6de3f":"9MtAM","50174871922d329":"9HEEB","ec87e49a81f06831":"ebAaL","aeba9ef1678a61f4":"kEFEY","8ba4fe0e143a8f80":"hIQE6","1863eb2af9d57401":"8QFOC","77fb2ac5bb453cc6":"2FdJg","dc4f25867f3f99de":"6AMGA","786bd94da9fb3ce5":"erSvz","7c696b8c152dab75":"kqQOF","be172551dcdf29e5":"iivvn","df2ca08d15beabed":"8YP4O","f14f57ad0fcb3261":"d0sAY","67b5a772aab34601":"gkGXc","38f7d06ed34a9200":"guLFz","4c294ad2098a74f2":"2onWA","a1f1701f62f2d879":"7nO1x","2f4247aadd61a986":"3Bda4","4baaee414651d185":"gQBOr","1c481c2740e4fcc":"lQt5D","b19c749a5cc31d1a":"6UiKj","94285782168e22f4":"2p6b3"}],"6UiKj":[function(require,module,exports) {
"use client";
"use strict";
function getInputOffsets(inputWrapperOrder, param) {
    var hasDescription = param.hasDescription, hasError = param.hasError;
    var inputIndex = inputWrapperOrder.findIndex(function(part) {
        return part === "input";
    });
    var aboveInput = inputWrapperOrder.slice(0, inputIndex);
    var belowInput = inputWrapperOrder.slice(inputIndex + 1);
    var offsetTop = hasDescription && aboveInput.includes("description") || hasError && aboveInput.includes("error");
    var offsetBottom = hasDescription && belowInput.includes("description") || hasError && belowInput.includes("error");
    return {
        offsetBottom,
        offsetTop
    };
}
exports.getInputOffsets = getInputOffsets; //# sourceMappingURL=get-input-offsets.cjs.map

},{}],"4OEkb":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
require("f4e4611713026c8");
require("19eaaea982129c00");
require("38fb73b1c79c097");
require("20b6bbd6d092b7c3");
require("ed52f84a91e2c505");
require("4b47a81024ff6d80");
require("79b85a155e18e82");
require("268581f7ad69ffeb");
var useProps = require("f356484493ffed22");
require("f509d917701497c");
var extractStyleProps = require("e3495555206b602b");
require("9e5439063e9f85db");
require("4a75744dc5b377e3");
function useInputProps(component, defaultProps, _props) {
    var props = useProps.useProps(component, defaultProps, _props);
    var label = props.label, description = props.description, error = props.error, required = props.required, classNames = props.classNames, styles = props.styles, className = props.className, unstyled = props.unstyled, __staticSelector = props.__staticSelector, __stylesApiProps = props.__stylesApiProps, errorProps = props.errorProps, labelProps = props.labelProps, descriptionProps = props.descriptionProps, _wrapperProps = props.wrapperProps, id = props.id, size = props.size, style = props.style, inputContainer = props.inputContainer, inputWrapperOrder = props.inputWrapperOrder, withAsterisk = props.withAsterisk, variant = props.variant, vars = props.vars, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "label",
        "description",
        "error",
        "required",
        "classNames",
        "styles",
        "className",
        "unstyled",
        "__staticSelector",
        "__stylesApiProps",
        "errorProps",
        "labelProps",
        "descriptionProps",
        "wrapperProps",
        "id",
        "size",
        "style",
        "inputContainer",
        "inputWrapperOrder",
        "withAsterisk",
        "variant",
        "vars",
        "mod"
    ]);
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var wrapperProps = (0, _objectSpread._)({
        label,
        description,
        error,
        required,
        classNames,
        className,
        __staticSelector,
        __stylesApiProps: __stylesApiProps || props,
        errorProps,
        labelProps,
        descriptionProps,
        unstyled,
        styles,
        size,
        style,
        inputContainer,
        inputWrapperOrder,
        withAsterisk,
        variant,
        id,
        mod
    }, _wrapperProps);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        classNames,
        styles,
        unstyled,
        wrapperProps: (0, _objectSpread._)({}, wrapperProps, styleProps),
        inputProps: {
            required,
            classNames,
            styles,
            unstyled,
            size,
            __staticSelector,
            __stylesApiProps: __stylesApiProps || props,
            error,
            variant,
            id
        }
    });
}
exports.useInputProps = useInputProps; //# sourceMappingURL=use-input-props.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f4e4611713026c8":"9MtAM","19eaaea982129c00":"iKGFf","38fb73b1c79c097":"9HEEB","20b6bbd6d092b7c3":"8QFOC","ed52f84a91e2c505":"2FdJg","4b47a81024ff6d80":"6AMGA","79b85a155e18e82":"erSvz","268581f7ad69ffeb":"kqQOF","f356484493ffed22":"iivvn","f509d917701497c":"8YP4O","e3495555206b602b":"6L93n","9e5439063e9f85db":"gkGXc","4a75744dc5b377e3":"2onWA"}],"jbA6w":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("ee17296db433cd7c");
require("3487676eb775f5ba");
require("313d3b5fd4a9f209");
require("3b2e8f939857ac5c");
require("80e8a818a0b17afe");
require("7d1c56b0e0d9b008");
require("b249c887b50c8ef6");
require("cd4c79c4c6af20db");
require("819b9009f3ef13cd");
require("dc96265bba32c4c0");
var polymorphicFactory = require("f13c083bd97eabc7");
require("6a94eedbfec701e0");
var Input = require("d39c47aad0346fc1");
require("9f86fb20cf07a1ea");
require("b12c54513fda69a8");
require("22e23d2d53e86874");
require("779aaad6974abfe7");
require("619b1630e67745e5");
require("cf50c4e034b0a7e6");
var useInputProps = require("a6641e33bbaf54ce");
require("fb2c8fad0b3683f");
var defaultProps = {
    __staticSelector: "InputBase",
    withAria: true
};
var InputBase = polymorphicFactory.polymorphicFactory(function(props, ref) {
    var _useInputProps_useInputProps = useInputProps.useInputProps("InputBase", defaultProps, props), inputProps = _useInputProps_useInputProps.inputProps, wrapperProps = _useInputProps_useInputProps.wrapperProps, others = (0, _objectWithoutProperties._)(_useInputProps_useInputProps, [
        "inputProps",
        "wrapperProps"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Wrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, wrapperProps), {
        children: /* @__PURE__ */ jsxRuntime.jsx(Input.Input, (0, _objectSpreadProps._)((0, _objectSpread._)({}, inputProps, others), {
            ref
        }))
    }));
});
InputBase.classes = (0, _objectSpread._)({}, Input.Input.classes, Input.Input.Wrapper.classes);
InputBase.displayName = "@mantine/core/InputBase";
exports.InputBase = InputBase; //# sourceMappingURL=InputBase.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","ee17296db433cd7c":"iKGFf","3487676eb775f5ba":"9MtAM","313d3b5fd4a9f209":"9HEEB","3b2e8f939857ac5c":"8QFOC","80e8a818a0b17afe":"2FdJg","7d1c56b0e0d9b008":"6AMGA","b249c887b50c8ef6":"erSvz","cd4c79c4c6af20db":"kqQOF","819b9009f3ef13cd":"8YP4O","dc96265bba32c4c0":"gkGXc","f13c083bd97eabc7":"iYAEL","6a94eedbfec701e0":"2onWA","d39c47aad0346fc1":"dkUgf","9f86fb20cf07a1ea":"j4uTK","b12c54513fda69a8":"7nO1x","22e23d2d53e86874":"3Bda4","779aaad6974abfe7":"gQBOr","619b1630e67745e5":"lRBdM","cf50c4e034b0a7e6":"hxtex","a6641e33bbaf54ce":"4OEkb","fb2c8fad0b3683f":"lQt5D"}],"5SlCU":[function(require,module,exports) {
"use client";
"use strict";
var FLEX_STYLE_PROPS_DATA = {
    gap: {
        type: "spacing",
        property: "gap"
    },
    rowGap: {
        type: "spacing",
        property: "rowGap"
    },
    columnGap: {
        type: "spacing",
        property: "columnGap"
    },
    align: {
        type: "identity",
        property: "alignItems"
    },
    justify: {
        type: "identity",
        property: "justifyContent"
    },
    wrap: {
        type: "identity",
        property: "flexWrap"
    },
    direction: {
        type: "identity",
        property: "flexDirection"
    }
};
exports.FLEX_STYLE_PROPS_DATA = FLEX_STYLE_PROPS_DATA; //# sourceMappingURL=flex-props.cjs.map

},{}],"lRoV6":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("db4cad339c6d8a95");
var filterProps = require("29b6d57d3337f8fe");
require("7ba11315a6041");
require("226327f56acece49");
require("dfc1918ee2f7ee92");
require("87b97bb9c830825f");
require("14d19836a8ce95ae");
require("181b3c0a2b2abdd");
var MantineThemeProvider = require("fcd2fe0a09f8c27b");
var useProps = require("bb88dec10e31482a");
require("d2e998f1f4d2da34");
var useStyles = require("d73154a6b8cdde74");
var InlineStyles = require("6c49d595114d0dee");
var parseStyleProps = require("3c43e3cca24b6c24");
var useRandomClassname = require("a8690054dd56558a");
var Box = require("6a95329259a62ea4");
var polymorphicFactory = require("3584fdc0c6dc35d8");
require("7eecbe0d345cfdd2");
var flexProps = require("327a22dc59427e20");
var Flex_module = require("de67dac361384222");
var defaultProps = {};
var Flex = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Flex", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, gap = props.gap, rowGap = props.rowGap, columnGap = props.columnGap, align = props.align, justify = props.justify, wrap = props.wrap, direction = props.direction, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "gap",
        "rowGap",
        "columnGap",
        "align",
        "justify",
        "wrap",
        "direction"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Flex",
        classes: Flex_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars
    });
    var theme = MantineThemeProvider.useMantineTheme();
    var responsiveClassName = useRandomClassname.useRandomClassName();
    var parsedStyleProps = parseStyleProps.parseStyleProps({
        styleProps: {
            gap,
            rowGap,
            columnGap,
            align,
            justify,
            wrap,
            direction
        },
        theme,
        data: flexProps.FLEX_STYLE_PROPS_DATA
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ jsxRuntime.jsx(InlineStyles.InlineStyles, {
                selector: `.${responsiveClassName}`,
                styles: parsedStyleProps.styles,
                media: parsedStyleProps.media
            }),
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
                ref
            }, getStyles("root", {
                className: responsiveClassName,
                style: filterProps.filterProps(parsedStyleProps.inlineStyles)
            }), others))
        ]
    });
});
Flex.classes = Flex_module;
Flex.displayName = "@mantine/core/Flex";
exports.Flex = Flex; //# sourceMappingURL=Flex.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","db4cad339c6d8a95":"iKGFf","29b6d57d3337f8fe":"2Jst9","7ba11315a6041":"9MtAM","226327f56acece49":"9HEEB","dfc1918ee2f7ee92":"8QFOC","87b97bb9c830825f":"2FdJg","14d19836a8ce95ae":"6AMGA","181b3c0a2b2abdd":"erSvz","fcd2fe0a09f8c27b":"kqQOF","bb88dec10e31482a":"iivvn","d2e998f1f4d2da34":"8YP4O","d73154a6b8cdde74":"d0sAY","6c49d595114d0dee":"3CHN8","3c43e3cca24b6c24":"6Bevs","a8690054dd56558a":"2rhHN","6a95329259a62ea4":"gkGXc","3584fdc0c6dc35d8":"iYAEL","7eecbe0d345cfdd2":"2onWA","327a22dc59427e20":"5SlCU","de67dac361384222":"125o3"}],"125o3":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_8bffd616"
};
module.exports = classes; //# sourceMappingURL=Flex.module.css.cjs.map

},{}],"kzplm":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3f5ad7930adc8833");
var React = require("6745653c1c44da6b");
var hooks = require("50a79a37332596c7");
var createVarsResolver = require("c91e655a66861eaf");
require("433b053ce8dc67ca");
require("8d5b4ae1982d98d7");
require("3e2a0de1de93066");
require("9f51147279918bd2");
require("a7f461bd0f131cb8");
var useProps = require("c04e8a9c6a461013");
require("276e780b579b89e2");
var useStyles = require("9ba94deeefac0ede");
var Box = require("81eb173133d72626");
var factory = require("c155d1b02564adac");
require("1594d393decd81ed");
var useFloatingIndicator = require("e5523a9817ed25e0");
var FloatingIndicator_module = require("a7f0461137b40020");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_theme, param) {
    var transitionDuration = param.transitionDuration;
    return {
        root: {
            "--transition-duration": typeof transitionDuration === "number" ? `${transitionDuration}ms` : transitionDuration
        }
    };
});
var FloatingIndicator = factory.factory(function(_props, ref) {
    var props = useProps.useProps("FloatingIndicator", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, target = props.target, parent = props.parent, transitionDuration = props.transitionDuration, mod = props.mod, displayAfterTransitionEnd = props.displayAfterTransitionEnd, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "target",
        "parent",
        "transitionDuration",
        "mod",
        "displayAfterTransitionEnd"
    ]);
    var getStyles = useStyles.useStyles({
        name: "FloatingIndicator",
        classes: FloatingIndicator_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var innerRef = React.useRef(null);
    var _useFloatingIndicator_useFloatingIndicator = useFloatingIndicator.useFloatingIndicator({
        target,
        parent,
        ref: innerRef,
        displayAfterTransitionEnd
    }), initialized = _useFloatingIndicator_useFloatingIndicator.initialized, hidden = _useFloatingIndicator_useFloatingIndicator.hidden;
    var mergedRef = hooks.useMergedRef(ref, innerRef);
    if (!target || !parent) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref: mergedRef,
        mod: [
            {
                initialized,
                hidden
            },
            mod
        ]
    }, getStyles("root"), others));
});
FloatingIndicator.displayName = "@mantine/core/FloatingIndicator";
FloatingIndicator.classes = FloatingIndicator_module;
exports.FloatingIndicator = FloatingIndicator; //# sourceMappingURL=FloatingIndicator.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","3f5ad7930adc8833":"iKGFf","6745653c1c44da6b":"9MtAM","50a79a37332596c7":"9HEEB","c91e655a66861eaf":"hIQE6","433b053ce8dc67ca":"8QFOC","8d5b4ae1982d98d7":"2FdJg","3e2a0de1de93066":"6AMGA","9f51147279918bd2":"erSvz","a7f461bd0f131cb8":"kqQOF","c04e8a9c6a461013":"iivvn","276e780b579b89e2":"8YP4O","9ba94deeefac0ede":"d0sAY","81eb173133d72626":"gkGXc","c155d1b02564adac":"guLFz","1594d393decd81ed":"2onWA","e5523a9817ed25e0":"90gty","a7f0461137b40020":"3sx8u"}],"90gty":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("36e4a64eb79f835");
var hooks = require("8e57ea2b5080c281");
require("91b3c55204fffad9");
var getEnv = require("e34c271f59906091");
require("831cb6bb485030a0");
require("e5e1261356cb3486");
require("c72fb0fdb8b5e1b7");
require("763750ac35878053");
require("eef6f8be634c0c86");
require("8496064f8c3370d8");
require("cd788636dabe750d");
require("1aa08f32da234a52");
var toInt = require("7227b17c928df646");
function isParent(parentElement, childElement) {
    if (!childElement || !parentElement) return false;
    var parent = childElement.parentNode;
    while(parent != null){
        if (parent === parentElement) return true;
        parent = parent.parentNode;
    }
    return false;
}
function useFloatingIndicator(param) {
    var target = param.target, parent = param.parent, ref = param.ref, displayAfterTransitionEnd = param.displayAfterTransitionEnd;
    var transitionTimeout = React.useRef(-1);
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), initialized = _React_useState[0], setInitialized = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(typeof displayAfterTransitionEnd === "boolean" ? displayAfterTransitionEnd : false), 2), hidden = _React_useState1[0], setHidden = _React_useState1[1];
    var updatePosition = function() {
        if (!target || !parent || !ref.current) return;
        var targetRect = target.getBoundingClientRect();
        var parentRect = parent.getBoundingClientRect();
        var targetComputedStyle = window.getComputedStyle(target);
        var parentComputedStyle = window.getComputedStyle(parent);
        var borderTopWidth = toInt.toInt(targetComputedStyle.borderTopWidth) + toInt.toInt(parentComputedStyle.borderTopWidth);
        var borderLeftWidth = toInt.toInt(targetComputedStyle.borderLeftWidth) + toInt.toInt(parentComputedStyle.borderLeftWidth);
        var position = {
            top: targetRect.top - parentRect.top - borderTopWidth,
            left: targetRect.left - parentRect.left - borderLeftWidth,
            width: targetRect.width,
            height: targetRect.height
        };
        ref.current.style.transform = `translateY(${position.top}px) translateX(${position.left}px)`;
        ref.current.style.width = `${position.width}px`;
        ref.current.style.height = `${position.height}px`;
    };
    var updatePositionWithoutAnimation = function() {
        window.clearTimeout(transitionTimeout.current);
        if (ref.current) ref.current.style.transitionDuration = "0ms";
        updatePosition();
        transitionTimeout.current = window.setTimeout(function() {
            if (ref.current) ref.current.style.transitionDuration = "";
        }, 30);
    };
    var targetResizeObserver = React.useRef(null);
    var parentResizeObserver = React.useRef(null);
    React.useEffect(function() {
        updatePosition();
        if (target) {
            targetResizeObserver.current = new ResizeObserver(updatePositionWithoutAnimation);
            targetResizeObserver.current.observe(target);
            if (parent) {
                parentResizeObserver.current = new ResizeObserver(updatePositionWithoutAnimation);
                parentResizeObserver.current.observe(parent);
            }
            return function() {
                var _targetResizeObserver_current, _parentResizeObserver_current;
                (_targetResizeObserver_current = targetResizeObserver.current) === null || _targetResizeObserver_current === void 0 ? void 0 : _targetResizeObserver_current.disconnect();
                (_parentResizeObserver_current = parentResizeObserver.current) === null || _parentResizeObserver_current === void 0 ? void 0 : _parentResizeObserver_current.disconnect();
            };
        }
        return void 0;
    }, [
        parent,
        target
    ]);
    React.useEffect(function() {
        if (parent) {
            var handleTransitionEnd = function(event) {
                if (isParent(event.target, parent)) {
                    updatePositionWithoutAnimation();
                    setHidden(false);
                }
            };
            parent.addEventListener("transitionend", handleTransitionEnd);
            return function() {
                parent.removeEventListener("transitionend", handleTransitionEnd);
            };
        }
        return void 0;
    }, [
        parent
    ]);
    hooks.useTimeout(function() {
        if (getEnv.getEnv() !== "test") setInitialized(true);
    }, 20, {
        autoInvoke: true
    });
    hooks.useMutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === "attributes" && mutation.attributeName === "dir") updatePositionWithoutAnimation();
        });
    }, {
        attributes: true,
        attributeFilter: [
            "dir"
        ]
    }, function() {
        return document.documentElement;
    });
    return {
        initialized,
        hidden
    };
}
exports.useFloatingIndicator = useFloatingIndicator; //# sourceMappingURL=use-floating-indicator.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","36e4a64eb79f835":"9MtAM","8e57ea2b5080c281":"9HEEB","91b3c55204fffad9":"iKGFf","e34c271f59906091":"dcxYe","831cb6bb485030a0":"8QFOC","e5e1261356cb3486":"2FdJg","c72fb0fdb8b5e1b7":"6AMGA","763750ac35878053":"erSvz","eef6f8be634c0c86":"kqQOF","8496064f8c3370d8":"8YP4O","cd788636dabe750d":"gkGXc","1aa08f32da234a52":"2onWA","7227b17c928df646":"hiBkr"}],"3sx8u":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_96b553a6"
};
module.exports = classes; //# sourceMappingURL=FloatingIndicator.module.css.cjs.map

},{}],"lMDPy":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("28e9560592ebee76");
var hooks = require("550eb15e38edcf4c");
var rem = require("82d7ee87c043f8ed");
require("aae0a1a045dc44a5");
var getSafeId = require("d74f8b62bd817283");
var getSize = require("842cf99635080348");
var createVarsResolver = require("2351b846fe5a4699");
require("b6b509140004d548");
require("e69166cb8928629c");
require("5409eee7ec2e9264");
require("120f9aea7105df2e");
require("79ddc5fb6ffd556f");
var useProps = require("4ea557af4f8630de");
require("89c51a96500d26c");
var useStyles = require("bc2196da68572a13");
var Box = require("fc10435f9de33e00");
var factory = require("cac4dfee9a790e5");
require("5e4e85628e8d3d13");
var Accordion_context = require("52d7f0c3c0d38768");
var AccordionChevron = require("f59c41ac6695482b");
var AccordionControl = require("c69820c9a622feb0");
var AccordionItem = require("acc2491d90ac7096");
var AccordionPanel = require("2f0d872aa7a8bbd2");
var Accordion_module = require("cfb60cd327f3cc25");
var defaultProps = {
    multiple: false,
    disableChevronRotation: false,
    chevronPosition: "right",
    variant: "default",
    chevron: /* @__PURE__ */ jsxRuntime.jsx(AccordionChevron.AccordionChevron, {})
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var transitionDuration = param.transitionDuration, chevronSize = param.chevronSize, radius = param.radius;
    return {
        root: {
            "--accordion-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--accordion-chevron-size": chevronSize === void 0 ? void 0 : rem.rem(chevronSize),
            "--accordion-radius": radius === void 0 ? void 0 : getSize.getRadius(radius)
        }
    };
});
function Accordion(_props) {
    var props = useProps.useProps("Accordion", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, multiple = props.multiple, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, id = props.id, loop = props.loop, transitionDuration = props.transitionDuration, disableChevronRotation = props.disableChevronRotation, chevronPosition = props.chevronPosition, chevronSize = props.chevronSize, order = props.order, chevron = props.chevron, variant = props.variant, radius = props.radius, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "multiple",
        "value",
        "defaultValue",
        "onChange",
        "id",
        "loop",
        "transitionDuration",
        "disableChevronRotation",
        "chevronPosition",
        "chevronSize",
        "order",
        "chevron",
        "variant",
        "radius"
    ]);
    var uid = hooks.useId(id);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: multiple ? [] : null,
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], handleChange = _hooks_useUncontrolled[1];
    var isItemActive = function(itemValue) {
        return Array.isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
    };
    var handleItemChange = function(itemValue) {
        var nextValue = Array.isArray(_value) ? _value.includes(itemValue) ? _value.filter(function(selectedValue) {
            return selectedValue !== itemValue;
        }) : (0, _toConsumableArray._)(_value).concat([
            itemValue
        ]) : itemValue === _value ? null : itemValue;
        handleChange(nextValue);
    };
    var getStyles = useStyles.useStyles({
        name: "Accordion",
        classes: Accordion_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Accordion_context.AccordionProvider, {
        value: {
            isItemActive,
            onChange: handleItemChange,
            getControlId: getSafeId.getSafeId(`${uid}-control`, "Accordion.Item component was rendered with invalid value or without value"),
            getRegionId: getSafeId.getSafeId(`${uid}-panel`, "Accordion.Item component was rendered with invalid value or without value"),
            transitionDuration,
            disableChevronRotation,
            chevronPosition,
            order,
            chevron,
            loop,
            getStyles,
            variant,
            unstyled
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
            id: uid
        }), others), {
            variant,
            "data-accordion": true,
            children
        }))
    });
}
var extendAccordion = function(c) {
    return c;
};
Accordion.extend = extendAccordion;
Accordion.withProps = factory.getWithProps(Accordion);
Accordion.classes = Accordion_module;
Accordion.displayName = "@mantine/core/Accordion";
Accordion.Item = AccordionItem.AccordionItem;
Accordion.Panel = AccordionPanel.AccordionPanel;
Accordion.Control = AccordionControl.AccordionControl;
Accordion.Chevron = AccordionChevron.AccordionChevron;
exports.Accordion = Accordion; //# sourceMappingURL=Accordion.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","28e9560592ebee76":"iKGFf","550eb15e38edcf4c":"9HEEB","82d7ee87c043f8ed":"ebAaL","aae0a1a045dc44a5":"9MtAM","d74f8b62bd817283":"dvoq6","842cf99635080348":"kEFEY","2351b846fe5a4699":"hIQE6","b6b509140004d548":"8QFOC","e69166cb8928629c":"2FdJg","5409eee7ec2e9264":"6AMGA","120f9aea7105df2e":"erSvz","79ddc5fb6ffd556f":"kqQOF","4ea557af4f8630de":"iivvn","89c51a96500d26c":"8YP4O","bc2196da68572a13":"d0sAY","fc10435f9de33e00":"gkGXc","cac4dfee9a790e5":"guLFz","5e4e85628e8d3d13":"2onWA","52d7f0c3c0d38768":"ayyUD","f59c41ac6695482b":"01exi","c69820c9a622feb0":"HYAZd","acc2491d90ac7096":"ewd1d","2f0d872aa7a8bbd2":"6psP4","cfb60cd327f3cc25":"lmMWT"}],"ayyUD":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("a6f5f599d1cdd8c2");
var createSafeContext = require("19d6cfce46866bff");
require("6a71e5d5ea814c2b");
require("8039b8d8598bdc8a");
require("35976e5ff52100");
require("7551d04e00da2bc2");
require("42f0e617828b66b7");
require("f8c4b53236045f1c");
require("9a06fc752daa2a0f");
require("5956251ed0f25373");
require("f9c9f4b5eff8e620");
require("e03ab17bf902d3ae");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Accordion component was not found in the tree"), 2), AccordionProvider = _createSafeContext_createSafeContext[0], useAccordionContext = _createSafeContext_createSafeContext[1];
exports.AccordionProvider = AccordionProvider;
exports.useAccordionContext = useAccordionContext; //# sourceMappingURL=Accordion.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","a6f5f599d1cdd8c2":"9MtAM","19d6cfce46866bff":"8srze","6a71e5d5ea814c2b":"iKGFf","8039b8d8598bdc8a":"9HEEB","35976e5ff52100":"8QFOC","7551d04e00da2bc2":"2FdJg","42f0e617828b66b7":"6AMGA","f8c4b53236045f1c":"erSvz","9a06fc752daa2a0f":"kqQOF","5956251ed0f25373":"8YP4O","f9c9f4b5eff8e620":"gkGXc","e03ab17bf902d3ae":"2onWA"}],"01exi":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f232404d1caf1e67");
var rem = require("2a6b0b30cd82651b");
require("42e3899d532db06");
require("555c272833cf875");
require("ed82fea7fc0075");
require("4659851a4e0ba0a8");
require("59113d7a56951574");
require("b1a20a8f6bc4a63c");
require("580ac329a58da614");
require("c78c0d1f28fe5a58");
require("1b7b388132e26971");
require("4a6ce1fb241db7be");
function AccordionChevron(_param) {
    var style = _param.style, _param_size = _param.size, size = _param_size === void 0 ? 16 : _param_size, others = (0, _objectWithoutProperties._)(_param, [
        "style",
        "size"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            width: rem.rem(size),
            height: rem.rem(size),
            display: "block"
        })
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    }));
}
AccordionChevron.displayName = "@mantine/core/AccordionChevron";
exports.AccordionChevron = AccordionChevron; //# sourceMappingURL=AccordionChevron.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f232404d1caf1e67":"iKGFf","2a6b0b30cd82651b":"ebAaL","42e3899d532db06":"9MtAM","555c272833cf875":"9HEEB","ed82fea7fc0075":"8QFOC","4659851a4e0ba0a8":"2FdJg","59113d7a56951574":"6AMGA","b1a20a8f6bc4a63c":"erSvz","580ac329a58da614":"kqQOF","c78c0d1f28fe5a58":"8YP4O","1b7b388132e26971":"gkGXc","4a6ce1fb241db7be":"2onWA"}],"HYAZd":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("9d9a7e3f0722f59b");
require("4e7bc4a7e168ac01");
var createScopedKeydownHandler = require("743d5e5f9049984c");
require("75922227275098af");
require("d0f386b17b88259b");
require("38b5ab721cc062bb");
require("b6d46a6c013b240d");
require("63d5c87339af36b4");
require("91bf1686cc8d9f83");
var useProps = require("7aaa62c73796728f");
require("33f1030b0d167762");
var Box = require("17eddbd68ef1c3c0");
var factory = require("5c3ee592a43b62");
require("cfe6041da53eae46");
var UnstyledButton = require("ade2420c16676e97");
var Accordion_context = require("58187292ceb4a5f9");
var AccordionItem_context = require("db31b83fdfbe71db");
var Accordion_module = require("4543a9a8bd4da980");
var defaultProps = {};
var AccordionControl = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("AccordionControl", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, chevron = _useProps_useProps.chevron, icon = _useProps_useProps.icon, onClick = _useProps_useProps.onClick, onKeyDown = _useProps_useProps.onKeyDown, children = _useProps_useProps.children, disabled = _useProps_useProps.disabled, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "chevron",
        "icon",
        "onClick",
        "onKeyDown",
        "children",
        "disabled",
        "mod"
    ]);
    var value = AccordionItem_context.useAccordionItemContext().value;
    var ctx = Accordion_context.useAccordionContext();
    var isActive = ctx.isItemActive(value);
    var shouldWrapWithHeading = typeof ctx.order === "number";
    var Heading = `h${ctx.order}`;
    var content = /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others, ctx.getStyles("control", {
        className,
        classNames,
        style,
        styles,
        variant: ctx.variant
    })), {
        unstyled: ctx.unstyled,
        mod: [
            "accordion-control",
            {
                active: isActive,
                "chevron-position": ctx.chevronPosition,
                disabled
            },
            mod
        ],
        ref,
        onClick: function(event) {
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
            ctx.onChange(value);
        },
        type: "button",
        disabled,
        "aria-expanded": isActive,
        "aria-controls": ctx.getRegionId(value),
        id: ctx.getControlId(value),
        onKeyDown: createScopedKeydownHandler.createScopedKeydownHandler({
            siblingSelector: "[data-accordion-control]",
            parentSelector: "[data-accordion]",
            activateOnFocus: false,
            loop: ctx.loop,
            orientation: "vertical",
            onKeyDown
        }),
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                component: "span",
                mod: {
                    rotate: !ctx.disableChevronRotation && isActive,
                    position: ctx.chevronPosition
                }
            }, ctx.getStyles("chevron", {
                classNames,
                styles
            })), {
                children: chevron || ctx.chevron
            })),
            /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("label", {
                classNames,
                styles
            })), {
                children
            })),
            icon && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                component: "span",
                mod: {
                    "chevron-position": ctx.chevronPosition
                }
            }, ctx.getStyles("icon", {
                classNames,
                styles
            })), {
                children: icon
            }))
        ]
    }));
    return shouldWrapWithHeading ? /* @__PURE__ */ jsxRuntime.jsx(Heading, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemTitle", {
        classNames,
        styles
    })), {
        children: content
    })) : content;
});
AccordionControl.displayName = "@mantine/core/AccordionControl";
AccordionControl.classes = Accordion_module;
exports.AccordionControl = AccordionControl; //# sourceMappingURL=AccordionControl.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","9d9a7e3f0722f59b":"iKGFf","4e7bc4a7e168ac01":"9MtAM","743d5e5f9049984c":"5jFxz","75922227275098af":"9HEEB","d0f386b17b88259b":"8QFOC","38b5ab721cc062bb":"2FdJg","b6d46a6c013b240d":"6AMGA","63d5c87339af36b4":"erSvz","91bf1686cc8d9f83":"kqQOF","7aaa62c73796728f":"iivvn","33f1030b0d167762":"8YP4O","17eddbd68ef1c3c0":"gkGXc","5c3ee592a43b62":"guLFz","cfe6041da53eae46":"2onWA","ade2420c16676e97":"cArqr","58187292ceb4a5f9":"ayyUD","db31b83fdfbe71db":"jwFFm","4543a9a8bd4da980":"lmMWT"}],"jwFFm":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("e593bd493d22a750");
var createSafeContext = require("a66c99426ef5d8ec");
require("8c4e525306ce106f");
require("279d57bcae38ab8a");
require("1944539891e232fe");
require("3234d0fe32918110");
require("1f2396a3fed18ce4");
require("e3173a1aa62636d7");
require("762a0c0e1f1bc531");
require("281d5c2de58ad51b");
require("11d01a0425ec4ff5");
require("2de0254ff8b51aed");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Accordion.Item component was not found in the tree"), 2), AccordionItemProvider = _createSafeContext_createSafeContext[0], useAccordionItemContext = _createSafeContext_createSafeContext[1];
exports.AccordionItemProvider = AccordionItemProvider;
exports.useAccordionItemContext = useAccordionItemContext; //# sourceMappingURL=AccordionItem.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","e593bd493d22a750":"9MtAM","a66c99426ef5d8ec":"8srze","8c4e525306ce106f":"iKGFf","279d57bcae38ab8a":"9HEEB","1944539891e232fe":"8QFOC","3234d0fe32918110":"2FdJg","1f2396a3fed18ce4":"6AMGA","e3173a1aa62636d7":"erSvz","762a0c0e1f1bc531":"kqQOF","281d5c2de58ad51b":"8YP4O","11d01a0425ec4ff5":"gkGXc","2de0254ff8b51aed":"2onWA"}],"lmMWT":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_9bdbb667",
    "panel": "m_df78851f",
    "content": "m_4ba554d4",
    "itemTitle": "m_8fa820a0",
    "control": "m_4ba585b8",
    "control--default": "m_6939a5e9",
    "control--contained": "m_4271d21b",
    "label": "m_df3ffa0f",
    "chevron": "m_3f35ae96",
    "icon": "m_9bd771fe",
    "item": "m_9bd7b098",
    "item--default": "m_fe19b709",
    "item--contained": "m_1f921b3b",
    "item--filled": "m_2cdf939a",
    "item--separated": "m_9f59b069"
};
module.exports = classes; //# sourceMappingURL=Accordion.module.css.cjs.map

},{}],"ewd1d":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("95fa9013b8abc3f7");
require("cc8983bf28bf8f93");
require("9e6dd63021b104fe");
require("507651088198ecf7");
require("131cbc683c511fa3");
require("71516675430c36b4");
require("f70ab6762f602d88");
require("e098c35d1b101026");
var useProps = require("9c0224c0a5cfe82b");
require("1ba29346408b5467");
var Box = require("f9b2a80b4c1657a1");
var factory = require("613345874732d84f");
require("bd1a740830f09aba");
var Accordion_context = require("25609cdfeea2a6bb");
var AccordionItem_context = require("943b66039d4c3ad0");
var Accordion_module = require("a393399f08f74509");
var defaultProps = {};
var AccordionItem = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("AccordionItem", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, value = _useProps_useProps.value, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "value",
        "mod"
    ]);
    var ctx = Accordion_context.useAccordionContext();
    return /* @__PURE__ */ jsxRuntime.jsx(AccordionItem_context.AccordionItemProvider, {
        value: {
            value
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
            ref,
            mod: [
                {
                    active: ctx.isItemActive(value)
                },
                mod
            ]
        }, ctx.getStyles("item", {
            className,
            classNames,
            styles,
            style,
            variant: ctx.variant
        }), others))
    });
});
AccordionItem.displayName = "@mantine/core/AccordionItem";
AccordionItem.classes = Accordion_module;
exports.AccordionItem = AccordionItem; //# sourceMappingURL=AccordionItem.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","95fa9013b8abc3f7":"iKGFf","cc8983bf28bf8f93":"9MtAM","9e6dd63021b104fe":"9HEEB","507651088198ecf7":"8QFOC","131cbc683c511fa3":"2FdJg","71516675430c36b4":"6AMGA","f70ab6762f602d88":"erSvz","e098c35d1b101026":"kqQOF","9c0224c0a5cfe82b":"iivvn","1ba29346408b5467":"8YP4O","f9b2a80b4c1657a1":"gkGXc","613345874732d84f":"guLFz","bd1a740830f09aba":"2onWA","25609cdfeea2a6bb":"ayyUD","943b66039d4c3ad0":"jwFFm","a393399f08f74509":"lmMWT"}],"6psP4":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("6ca9ae480ce7eced");
require("76256bd779a614b1");
require("f91cb2ef37b2b43a");
require("4daa2d8f4c5fb1d8");
require("3afa096f90f600a9");
require("b02889483c745bff");
require("c4ac1738b3561a12");
require("f4b09145a4c93a1e");
var useProps = require("47ab4e091daf450f");
require("50e90c0cd87e229a");
require("4f2798979bfee58");
var factory = require("b694ee1e48a6830");
require("dae95127d4c1a2b");
var Collapse = require("17311ab001fc69b3");
var Accordion_context = require("9d15c8ab58c22de4");
var AccordionItem_context = require("6eedae63f4c27803");
var Accordion_module = require("32c8507df018248");
var defaultProps = {};
var AccordionPanel = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("AccordionPanel", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, children = _useProps_useProps.children, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "children"
    ]);
    var value = AccordionItem_context.useAccordionItemContext().value;
    var ctx = Accordion_context.useAccordionContext();
    var _ctx_transitionDuration;
    return /* @__PURE__ */ jsxRuntime.jsx(Collapse.Collapse, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, ctx.getStyles("panel", {
        className,
        classNames,
        style,
        styles
    }), others), {
        in: ctx.isItemActive(value),
        transitionDuration: (_ctx_transitionDuration = ctx.transitionDuration) !== null && _ctx_transitionDuration !== void 0 ? _ctx_transitionDuration : 200,
        role: "region",
        id: ctx.getRegionId(value),
        "aria-labelledby": ctx.getControlId(value),
        children: /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("content", {
            classNames,
            styles
        })), {
            children
        }))
    }));
});
AccordionPanel.displayName = "@mantine/core/AccordionPanel";
AccordionPanel.classes = Accordion_module;
exports.AccordionPanel = AccordionPanel; //# sourceMappingURL=AccordionPanel.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","6ca9ae480ce7eced":"iKGFf","76256bd779a614b1":"9MtAM","f91cb2ef37b2b43a":"9HEEB","4daa2d8f4c5fb1d8":"8QFOC","3afa096f90f600a9":"2FdJg","b02889483c745bff":"6AMGA","c4ac1738b3561a12":"erSvz","f4b09145a4c93a1e":"kqQOF","47ab4e091daf450f":"iivvn","50e90c0cd87e229a":"8YP4O","4f2798979bfee58":"gkGXc","b694ee1e48a6830":"guLFz","dae95127d4c1a2b":"2onWA","17311ab001fc69b3":"eaAXD","9d15c8ab58c22de4":"ayyUD","6eedae63f4c27803":"jwFFm","32c8507df018248":"lmMWT"}],"fZ73h":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("e60a0cacbe4dc6a1");
require("7b53f3a2028d7774");
var getDefaultZIndex = require("3ed39437f7bdc4a3");
var getSize = require("804d28274ed9ced7");
require("163daa85db294f55");
var createVarsResolver = require("c2e57c284db9e373");
require("58e502b7584188ea");
require("a2a707f47bea73ad");
require("3b55c03a0b49aac1");
require("a3671f29f49dfe13");
require("9f27d6528f791b24");
var useProps = require("1e8dff2d3fe503fe");
require("2370e29b1771f8d2");
var useStyles = require("96188084d466e7fd");
var Box = require("968a2da1d31b085c");
var factory = require("2fda47573eff2335");
require("814a1c1fd6b9a9b5");
require("f0b7db89123f44d9");
var OptionalPortal = require("ed62689224cfce90");
var Affix_module = require("8dbc3c6bc566f296");
var defaultProps = {
    position: {
        bottom: 0,
        right: 0
    },
    zIndex: getDefaultZIndex.getDefaultZIndex("modal"),
    withinPortal: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var zIndex = param.zIndex, position = param.position;
    return {
        root: {
            "--affix-z-index": zIndex === null || zIndex === void 0 ? void 0 : zIndex.toString(),
            "--affix-top": getSize.getSpacing(position === null || position === void 0 ? void 0 : position.top),
            "--affix-left": getSize.getSpacing(position === null || position === void 0 ? void 0 : position.left),
            "--affix-bottom": getSize.getSpacing(position === null || position === void 0 ? void 0 : position.bottom),
            "--affix-right": getSize.getSpacing(position === null || position === void 0 ? void 0 : position.right)
        }
    };
});
var Affix = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Affix", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, portalProps = props.portalProps, zIndex = props.zIndex, withinPortal = props.withinPortal, position = props.position, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "portalProps",
        "zIndex",
        "withinPortal",
        "position"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Affix",
        classes: Affix_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(OptionalPortal.OptionalPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, portalProps), {
        withinPortal,
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
            ref
        }, getStyles("root"), others))
    }));
});
Affix.classes = Affix_module;
Affix.displayName = "@mantine/core/Affix";
exports.Affix = Affix; //# sourceMappingURL=Affix.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","e60a0cacbe4dc6a1":"iKGFf","7b53f3a2028d7774":"9MtAM","3ed39437f7bdc4a3":"4gavl","804d28274ed9ced7":"kEFEY","163daa85db294f55":"9HEEB","c2e57c284db9e373":"hIQE6","58e502b7584188ea":"8QFOC","a2a707f47bea73ad":"2FdJg","3b55c03a0b49aac1":"6AMGA","a3671f29f49dfe13":"erSvz","9f27d6528f791b24":"kqQOF","1e8dff2d3fe503fe":"iivvn","2370e29b1771f8d2":"8YP4O","96188084d466e7fd":"d0sAY","968a2da1d31b085c":"gkGXc","2fda47573eff2335":"guLFz","814a1c1fd6b9a9b5":"2onWA","f0b7db89123f44d9":"6YZdR","ed62689224cfce90":"3Y9Li","8dbc3c6bc566f296":"fMUpW"}],"fMUpW":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_7f854edf"
};
module.exports = classes; //# sourceMappingURL=Affix.module.css.cjs.map

},{}],"luRvr":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c9cdafbf2e601095");
var hooks = require("c54205729322632");
require("4678afd16952e2a1");
var getSize = require("b687ebb92558056f");
var createVarsResolver = require("bf0f5858ecdeb8be");
require("b2eb4c5a0ae44fcb");
require("b359b553134d12cf");
require("55e4bca18679a280");
require("94c92e5bf9c4e5");
require("cefeb280806c4f95");
var useProps = require("288348a19ac6852b");
require("84585339af81f1c9");
var useStyles = require("24c881c8bea6d6e4");
var Box = require("34d52cff673606e7");
var factory = require("eccc055ea5e4cb8b");
require("55837d01f3b4bdcf");
require("1ea5bb1a784f803e");
var CloseButton = require("ad90bcb1acd4fbe6");
var Alert_module = require("f535f14ed07b3b30");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, variant = param.variant, autoContrast = param.autoContrast;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        variant: variant || "light",
        autoContrast
    });
    return {
        root: {
            "--alert-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--alert-bg": color || variant ? colors.background : void 0,
            "--alert-color": colors.color,
            "--alert-bd": color || variant ? colors.border : void 0
        }
    };
});
var Alert = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Alert", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, radius = props.radius, color = props.color, title = props.title, children = props.children, id = props.id, icon = props.icon, withCloseButton = props.withCloseButton, onClose = props.onClose, closeButtonLabel = props.closeButtonLabel, variant = props.variant, autoContrast = props.autoContrast, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "radius",
        "color",
        "title",
        "children",
        "id",
        "icon",
        "withCloseButton",
        "onClose",
        "closeButtonLabel",
        "variant",
        "autoContrast"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Alert",
        classes: Alert_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var rootId = hooks.useId(id);
    var titleId = title && `${rootId}-title` || void 0;
    var bodyId = `${rootId}-body`;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        id: rootId
    }, getStyles("root", {
        variant
    })), {
        variant,
        ref
    }), others), {
        role: "alert",
        "aria-describedby": bodyId,
        "aria-labelledby": titleId,
        children: /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("wrapper")), {
            children: [
                icon && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("icon")), {
                    children: icon
                })),
                /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("body")), {
                    children: [
                        title && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("title")), {
                            "data-with-close-button": withCloseButton || void 0,
                            children: /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                id: titleId
                            }, getStyles("label")), {
                                children: title
                            }))
                        })),
                        children && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
                            id: bodyId
                        }, getStyles("message")), {
                            "data-variant": variant,
                            children
                        }))
                    ]
                })),
                withCloseButton && /* @__PURE__ */ jsxRuntime.jsx(CloseButton.CloseButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("closeButton")), {
                    onClick: onClose,
                    variant: "transparent",
                    size: 16,
                    iconSize: 16,
                    "aria-label": closeButtonLabel,
                    unstyled
                }))
            ]
        }))
    }));
});
Alert.classes = Alert_module;
Alert.displayName = "@mantine/core/Alert";
exports.Alert = Alert; //# sourceMappingURL=Alert.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c9cdafbf2e601095":"iKGFf","c54205729322632":"9HEEB","4678afd16952e2a1":"9MtAM","b687ebb92558056f":"kEFEY","bf0f5858ecdeb8be":"hIQE6","b2eb4c5a0ae44fcb":"8QFOC","b359b553134d12cf":"2FdJg","55e4bca18679a280":"6AMGA","94c92e5bf9c4e5":"erSvz","cefeb280806c4f95":"kqQOF","288348a19ac6852b":"iivvn","84585339af81f1c9":"8YP4O","24c881c8bea6d6e4":"d0sAY","34d52cff673606e7":"gkGXc","eccc055ea5e4cb8b":"guLFz","55837d01f3b4bdcf":"2onWA","1ea5bb1a784f803e":"h6AYi","ad90bcb1acd4fbe6":"4ZuRG","f535f14ed07b3b30":"8G98E"}],"8G98E":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_66836ed3",
    "wrapper": "m_a5d60502",
    "body": "m_667c2793",
    "title": "m_6a03f287",
    "label": "m_698f4f23",
    "icon": "m_667f2a6a",
    "message": "m_7fa78076",
    "closeButton": "m_87f54839"
};
module.exports = classes; //# sourceMappingURL=Alert.module.css.cjs.map

},{}],"acy77":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f7e7ad617a9dbaed");
var cx = require("423e34c247908cb5");
require("84401538848ad3cc");
require("83ca9237b3bf1d46");
require("76652b4acafffff6");
require("6097b9fa1cb3af6d");
require("3c51e8e15568b926");
require("efa7adf1949efecb");
var useProps = require("a5977aae79aea4f5");
require("529ffc0b8d584aec");
require("83c49f45d420753b");
var polymorphicFactory = require("5feaafa349334d9");
require("fc9244d452f31510");
var Text = require("e97f65bf49269031");
var Anchor_module = require("6f55cdc33666a2a7");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var defaultProps = {
    underline: "hover"
};
var Anchor = polymorphicFactory.polymorphicFactory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("Anchor", defaultProps, props), underline = _useProps_useProps.underline, className = _useProps_useProps.className, unstyled = _useProps_useProps.unstyled, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "underline",
        "className",
        "unstyled",
        "mod"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Text.Text, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "a",
        ref,
        className: cx__default.default({
            [Anchor_module.root]: !unstyled
        }, className)
    }, others), {
        mod: [
            {
                underline
            },
            mod
        ],
        __staticSelector: "Anchor",
        unstyled
    }));
});
Anchor.classes = Anchor_module;
Anchor.displayName = "@mantine/core/Anchor";
exports.Anchor = Anchor; //# sourceMappingURL=Anchor.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f7e7ad617a9dbaed":"iKGFf","423e34c247908cb5":"8QFOC","84401538848ad3cc":"9MtAM","83ca9237b3bf1d46":"9HEEB","76652b4acafffff6":"2FdJg","6097b9fa1cb3af6d":"6AMGA","3c51e8e15568b926":"erSvz","efa7adf1949efecb":"kqQOF","a5977aae79aea4f5":"iivvn","529ffc0b8d584aec":"8YP4O","83c49f45d420753b":"gkGXc","5feaafa349334d9":"iYAEL","fc9244d452f31510":"2onWA","e97f65bf49269031":"gXc4D","6f55cdc33666a2a7":"98JRm"}],"gXc4D":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("ba405b6445ec43d6");
require("b5d641a45897b11");
var getSize = require("bc8704915b64215d");
require("3ade690bb4a91ca");
var createVarsResolver = require("e7609719d7390cb0");
require("23a7bdef0fc24f73");
var getThemeColor = require("ef66941718410945");
var getGradient = require("a9e4f0643fe15322");
require("8241b5a88e730bcf");
require("8f1011c5d48c30e3");
require("73be0419861ffdfe");
require("c3f9cb6207fb7ecc");
var useProps = require("42f6d9d1c8141d52");
require("8861cfb4a9de32f6");
var useStyles = require("bc6a8a2881724555");
var Box = require("b6566846cb164fce");
var polymorphicFactory = require("c0de01f8db0a5364");
require("bffcb998b37be9ca");
var Text_module = require("f545dde86069b24d");
function getTextTruncate(truncate) {
    if (truncate === "start") return "start";
    if (truncate === "end" || truncate) return "end";
    return void 0;
}
var defaultProps = {
    inherit: false
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var variant = param.variant, lineClamp = param.lineClamp, gradient = param.gradient, size = param.size, color = param.color;
    return {
        root: {
            "--text-fz": getSize.getFontSize(size),
            "--text-lh": getSize.getLineHeight(size),
            "--text-gradient": variant === "gradient" ? getGradient.getGradient(gradient, theme) : void 0,
            "--text-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
            "--text-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
        }
    };
});
var Text = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Text", defaultProps, _props);
    var lineClamp = props.lineClamp, truncate = props.truncate, inline = props.inline, inherit = props.inherit, gradient = props.gradient, span = props.span, __staticSelector = props.__staticSelector, vars = props.vars, className = props.className, style = props.style, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, variant = props.variant, mod = props.mod, size = props.size, others = (0, _objectWithoutProperties._)(props, [
        "lineClamp",
        "truncate",
        "inline",
        "inherit",
        "gradient",
        "span",
        "__staticSelector",
        "vars",
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "variant",
        "mod",
        "size"
    ]);
    var getStyles = useStyles.useStyles({
        name: [
            "Text",
            __staticSelector
        ],
        props,
        classes: Text_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root", {
        focusable: true
    })), {
        ref,
        component: span ? "span" : "p",
        variant,
        mod: [
            {
                "data-truncate": getTextTruncate(truncate),
                "data-line-clamp": typeof lineClamp === "number",
                "data-inline": inline,
                "data-inherit": inherit
            },
            mod
        ],
        size
    }), others));
});
Text.classes = Text_module;
Text.displayName = "@mantine/core/Text";
exports.Text = Text; //# sourceMappingURL=Text.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","ba405b6445ec43d6":"iKGFf","b5d641a45897b11":"9MtAM","bc8704915b64215d":"kEFEY","3ade690bb4a91ca":"9HEEB","e7609719d7390cb0":"hIQE6","23a7bdef0fc24f73":"8QFOC","ef66941718410945":"eeaIN","a9e4f0643fe15322":"cx5bg","8241b5a88e730bcf":"2FdJg","8f1011c5d48c30e3":"6AMGA","73be0419861ffdfe":"erSvz","c3f9cb6207fb7ecc":"kqQOF","42f6d9d1c8141d52":"iivvn","8861cfb4a9de32f6":"8YP4O","bc6a8a2881724555":"d0sAY","b6566846cb164fce":"gkGXc","c0de01f8db0a5364":"iYAEL","bffcb998b37be9ca":"2onWA","f545dde86069b24d":"kPQuY"}],"kPQuY":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_b6d8b162"
};
module.exports = classes; //# sourceMappingURL=Text.module.css.cjs.map

},{}],"98JRm":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_849cf0da"
};
module.exports = classes; //# sourceMappingURL=Anchor.module.css.cjs.map

},{}],"dG7Dv":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("e633c32888b4249f");
var React = require("d9cc70981f09c1b0");
var hooks = require("d5d3c98b2b05cae1");
var rem = require("16f4b5ec02cfd896");
var findClosestNumber = require("2386a3634aa30380");
var createVarsResolver = require("665136636fb7f5da");
require("d280b0d5afcf827");
require("b57477491a8cdf07");
require("6a8926f2ac2b2153");
require("db30866a3a2ecdbe");
require("f965e6c0938c9524");
var useProps = require("4df21853d8b357dc");
require("a98258be0c07fb19");
var useStyles = require("2c9e0873a8c3b2a5");
var Box = require("d2f5dea0d1c68c36");
var factory = require("b6ce9241fec09b60");
require("a659d7c853307a5e");
var AngleSlider_module = require("8310b0535af204ea");
var defaultProps = {
    step: 1,
    withLabel: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, thumbSize = param.thumbSize;
    return {
        root: {
            "--slider-size": rem.rem(size),
            "--thumb-size": rem.rem(thumbSize)
        }
    };
});
var AngleSlider = factory.factory(function(_props, ref) {
    var props = useProps.useProps("AngleSlider", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, step = props.step, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, onMouseDown = props.onMouseDown, withLabel = props.withLabel, marks = props.marks, thumbSize = props.thumbSize, restrictToMarks = props.restrictToMarks, formatLabel = props.formatLabel, onChangeEnd = props.onChangeEnd, disabled = props.disabled, onTouchStart = props.onTouchStart, name = props.name, hiddenInputProps = props.hiddenInputProps, ariaLabel = props["aria-label"], tabIndex = props.tabIndex, onScrubStart = props.onScrubStart, onScrubEnd = props.onScrubEnd, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "step",
        "value",
        "defaultValue",
        "onChange",
        "onMouseDown",
        "withLabel",
        "marks",
        "thumbSize",
        "restrictToMarks",
        "formatLabel",
        "onChangeEnd",
        "disabled",
        "onTouchStart",
        "name",
        "hiddenInputProps",
        "aria-label",
        "tabIndex",
        "onScrubStart",
        "onScrubEnd"
    ]);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: 0,
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var update = function(val) {
        if (rootRef.current) {
            var newValue = restrictToMarks && Array.isArray(marks) ? findClosestNumber.findClosestNumber(val, marks.map(function(mark) {
                return mark.value;
            })) : val;
            setValue(newValue);
        }
    };
    var _hooks_useRadialMove = hooks.useRadialMove(update, {
        step,
        onChangeEnd,
        onScrubStart,
        onScrubEnd
    }), rootRef = _hooks_useRadialMove.ref;
    var getStyles = useStyles.useStyles({
        name: "AngleSlider",
        classes: AngleSlider_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var handleKeyDown = function(event) {
        if (disabled) return;
        if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
            var normalized = hooks.normalizeRadialValue(_value - step, step);
            setValue(normalized);
            onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(normalized);
        }
        if (event.key === "ArrowRight" || event.key === "ArrowUp") {
            var normalized1 = hooks.normalizeRadialValue(_value + step, step);
            setValue(normalized1);
            onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(normalized1);
        }
        if (event.key === "Home") {
            setValue(0);
            onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(0);
        }
        if (event.key === "End") {
            setValue(359);
            onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(359);
        }
    };
    var marksItems = marks === null || marks === void 0 ? void 0 : marks.map(function(mark, index) {
        return /* @__PURE__ */ React.createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("mark", {
            style: {
                "--angle": `${mark.value}deg`
            }
        })), {
            "data-label": mark.label || void 0,
            key: index
        }));
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: hooks.useMergedRef(ref, rootRef)
    }, getStyles("root", {
        focusable: true
    }), others), {
        children: [
            marksItems && marksItems.length > 0 && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("marks")), {
                children: marksItems
            })),
            withLabel && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label")), {
                children: typeof formatLabel === "function" ? formatLabel(_value) : _value
            })),
            /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpread._)({
                tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : disabled ? -1 : 0,
                role: "slider",
                "aria-valuemax": 360,
                "aria-valuemin": 0,
                "aria-valuenow": _value,
                onKeyDown: handleKeyDown,
                "aria-label": ariaLabel
            }, getStyles("thumb", {
                style: {
                    transform: `rotate(${_value}deg)`
                }
            }))),
            /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)({
                type: "hidden",
                name,
                value: _value
            }, hiddenInputProps))
        ]
    }));
});
AngleSlider.displayName = "@mantine/core/AngleSlider";
AngleSlider.classes = AngleSlider_module;
exports.AngleSlider = AngleSlider; //# sourceMappingURL=AngleSlider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","e633c32888b4249f":"iKGFf","d9cc70981f09c1b0":"9MtAM","d5d3c98b2b05cae1":"9HEEB","16f4b5ec02cfd896":"ebAaL","2386a3634aa30380":"2EcxD","665136636fb7f5da":"hIQE6","d280b0d5afcf827":"8QFOC","b57477491a8cdf07":"2FdJg","6a8926f2ac2b2153":"6AMGA","db30866a3a2ecdbe":"erSvz","f965e6c0938c9524":"kqQOF","4df21853d8b357dc":"iivvn","a98258be0c07fb19":"8YP4O","2c9e0873a8c3b2a5":"d0sAY","d2f5dea0d1c68c36":"gkGXc","b6ce9241fec09b60":"guLFz","a659d7c853307a5e":"2onWA","8310b0535af204ea":"9B42W"}],"9B42W":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_48204f9b",
    "marks": "m_bb9cdbad",
    "mark": "m_481dd586",
    "thumb": "m_bc02ba3d",
    "label": "m_bb8e875b"
};
module.exports = classes; //# sourceMappingURL=AngleSlider.module.css.cjs.map

},{}],"gqxo3":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("96a4909ce7742dad");
require("b41deb1eb7e43ee8");
var getDefaultZIndex = require("cfc8e960c406e4c3");
require("902bb9e5528e914b");
var createVarsResolver = require("325734f05b32618b");
require("9033121ea37acaff");
require("75c0a04fe519e8c0");
require("57c53a5aef8fbd01");
require("f5a7607512648464");
require("2834d277e1242903");
var useProps = require("23aa6ef1e9baea90");
require("b7f2e4d90b1a87f2");
var useStyles = require("58bdf15f59e68027");
var Box = require("ff4aec19a78e19");
var factory = require("98c2d387b78042ef");
require("a13fd6ca9dc7da3c");
var AppShell_context = require("72d640cf6f7eeae8");
var AppShellAside = require("8d56eb0ccb714dd3");
var AppShellFooter = require("215c843822e905bf");
var AppShellHeader = require("46d65ec5b8c87d1");
var AppShellMain = require("6b795bfca75f341");
var AppShellMediaStyles = require("5266963a63f0791b");
var AppShellNavbar = require("92c3f90f16d65718");
var AppShellSection = require("d16984d04b4a9d99");
var useResizing = require("867c1d4ab70c0c2e");
var AppShell_module = require("4f1b4865f4a87331");
var defaultProps = {
    withBorder: true,
    padding: 0,
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    zIndex: getDefaultZIndex.getDefaultZIndex("app")
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var transitionDuration = param.transitionDuration, transitionTimingFunction = param.transitionTimingFunction;
    return {
        root: {
            "--app-shell-transition-duration": `${transitionDuration}ms`,
            "--app-shell-transition-timing-function": transitionTimingFunction
        }
    };
});
var AppShell = factory.factory(function(_props, ref) {
    var props = useProps.useProps("AppShell", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, navbar = props.navbar, withBorder = props.withBorder, padding = props.padding, transitionDuration = props.transitionDuration, transitionTimingFunction = props.transitionTimingFunction, header = props.header, zIndex = props.zIndex, layout = props.layout, disabled = props.disabled, aside = props.aside, footer = props.footer, _props_offsetScrollbars = props.offsetScrollbars, offsetScrollbars = _props_offsetScrollbars === void 0 ? layout !== "alt" : _props_offsetScrollbars, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "navbar",
        "withBorder",
        "padding",
        "transitionDuration",
        "transitionTimingFunction",
        "header",
        "zIndex",
        "layout",
        "disabled",
        "aside",
        "footer",
        "offsetScrollbars",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "AppShell",
        classes: AppShell_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var resizing = useResizing.useResizing({
        disabled,
        transitionDuration
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(AppShell_context.AppShellProvider, {
        value: {
            getStyles,
            withBorder,
            zIndex,
            disabled,
            offsetScrollbars
        },
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(AppShellMediaStyles.AppShellMediaStyles, {
                navbar,
                header,
                aside,
                footer,
                padding
            }),
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                ref
            }, getStyles("root")), {
                mod: [
                    {
                        resizing,
                        layout,
                        disabled
                    },
                    mod
                ]
            }), others))
        ]
    });
});
AppShell.classes = AppShell_module;
AppShell.displayName = "@mantine/core/AppShell";
AppShell.Navbar = AppShellNavbar.AppShellNavbar;
AppShell.Header = AppShellHeader.AppShellHeader;
AppShell.Main = AppShellMain.AppShellMain;
AppShell.Aside = AppShellAside.AppShellAside;
AppShell.Footer = AppShellFooter.AppShellFooter;
AppShell.Section = AppShellSection.AppShellSection;
exports.AppShell = AppShell; //# sourceMappingURL=AppShell.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","96a4909ce7742dad":"iKGFf","b41deb1eb7e43ee8":"9MtAM","cfc8e960c406e4c3":"4gavl","902bb9e5528e914b":"9HEEB","325734f05b32618b":"hIQE6","9033121ea37acaff":"8QFOC","75c0a04fe519e8c0":"2FdJg","57c53a5aef8fbd01":"6AMGA","f5a7607512648464":"erSvz","2834d277e1242903":"kqQOF","23aa6ef1e9baea90":"iivvn","b7f2e4d90b1a87f2":"8YP4O","58bdf15f59e68027":"d0sAY","ff4aec19a78e19":"gkGXc","98c2d387b78042ef":"guLFz","a13fd6ca9dc7da3c":"2onWA","72d640cf6f7eeae8":"fB2WG","8d56eb0ccb714dd3":"4Xhux","215c843822e905bf":"gWmhx","46d65ec5b8c87d1":"9L3ZV","6b795bfca75f341":"6ncqX","5266963a63f0791b":"lGC0r","92c3f90f16d65718":"l3VpA","d16984d04b4a9d99":"2nCsm","867c1d4ab70c0c2e":"3ry9o","4f1b4865f4a87331":"gfoR2"}],"fB2WG":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("730fcd3fb7cd6f56");
var createSafeContext = require("bc36c4f25fe0a400");
require("138262d43d0922ad");
require("acf7ecef4e35cf3e");
require("21dfc14a25b95345");
require("96c47089470a3fc");
require("abde010c92af423f");
require("5c868361bc7bcd74");
require("b48541325b55c5c1");
require("df86f5519bbae684");
require("8be45e43accf9b4d");
require("bf3a7f94e156c0bf");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("AppShell was not found in tree"), 2), AppShellProvider = _createSafeContext_createSafeContext[0], useAppShellContext = _createSafeContext_createSafeContext[1];
exports.AppShellProvider = AppShellProvider;
exports.useAppShellContext = useAppShellContext; //# sourceMappingURL=AppShell.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","730fcd3fb7cd6f56":"9MtAM","bc36c4f25fe0a400":"8srze","138262d43d0922ad":"iKGFf","acf7ecef4e35cf3e":"9HEEB","21dfc14a25b95345":"8QFOC","96c47089470a3fc":"2FdJg","abde010c92af423f":"6AMGA","5c868361bc7bcd74":"erSvz","b48541325b55c5c1":"kqQOF","df86f5519bbae684":"8YP4O","8be45e43accf9b4d":"gkGXc","bf3a7f94e156c0bf":"2onWA"}],"4Xhux":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("695b7a43bfaad208");
require("cfda35edc063308c");
require("4091fb00cd7423bf");
require("129646f397a6016d");
require("6adda7567dfd44de");
require("7990c6639e51168d");
require("e2a6ecb59d63d3b3");
require("1b3b7218e9be99b9");
var useProps = require("cb8f81a24181733a");
require("f2768a0c2e063c94");
var Box = require("ffd7e8250febd0ae");
var factory = require("a1bda667fef0cf5");
require("5dd2bd121db08194");
var AppShell_context = require("56c12a8936faac4c");
var AppShell_module = require("d3bd0872f8f4ddc5");
var defaultProps = {};
var AppShellAside = factory.factory(function(_props, ref) {
    var props = useProps.useProps("AppShellAside", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, withBorder = props.withBorder, zIndex = props.zIndex, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex",
        "mod"
    ]);
    var ctx = AppShell_context.useAppShellContext();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "aside",
        ref,
        mod: [
            {
                "with-border": withBorder !== null && withBorder !== void 0 ? withBorder : ctx.withBorder
            },
            mod
        ]
    }, ctx.getStyles("aside", {
        className,
        classNames,
        styles,
        style
    }), others), {
        __vars: {
            "--app-shell-aside-z-index": `calc(${zIndex !== null && zIndex !== void 0 ? zIndex : ctx.zIndex} + 1)`
        }
    }));
});
AppShellAside.classes = AppShell_module;
AppShellAside.displayName = "@mantine/core/AppShellAside";
exports.AppShellAside = AppShellAside; //# sourceMappingURL=AppShellAside.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","695b7a43bfaad208":"iKGFf","cfda35edc063308c":"9MtAM","4091fb00cd7423bf":"9HEEB","129646f397a6016d":"8QFOC","6adda7567dfd44de":"2FdJg","7990c6639e51168d":"6AMGA","e2a6ecb59d63d3b3":"erSvz","1b3b7218e9be99b9":"kqQOF","cb8f81a24181733a":"iivvn","f2768a0c2e063c94":"8YP4O","ffd7e8250febd0ae":"gkGXc","a1bda667fef0cf5":"guLFz","5dd2bd121db08194":"2onWA","56c12a8936faac4c":"fB2WG","d3bd0872f8f4ddc5":"gfoR2"}],"gfoR2":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_89ab340",
    "navbar": "m_45252eee",
    "aside": "m_9cdde9a",
    "header": "m_3b16f56b",
    "main": "m_8983817",
    "footer": "m_3840c879",
    "section": "m_6dcfc7c7"
};
module.exports = classes; //# sourceMappingURL=AppShell.module.css.cjs.map

},{}],"gWmhx":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("5095c9b81e11b257");
var cx = require("30949993a8bc4f8c");
var reactRemoveScroll = require("4b7798289641593a");
require("336c1c75910c34e4");
require("77fdea7154bfe48d");
require("1aab2fac9ef21f2");
require("c42036bec41a8c5c");
require("4464e2f4057c634b");
require("fc1583ad78c88ac9");
var useProps = require("b9ef82ddb9826475");
require("d313bbd2eca16816");
var Box = require("21ad971e9fac45f8");
var factory = require("f3e519ec7304a207");
require("e0890591c3a830e5");
var AppShell_context = require("aff0cc30b007bfbd");
var AppShell_module = require("5da970b1e19af17c");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var defaultProps = {};
var AppShellFooter = factory.factory(function(_props, ref) {
    var _this;
    var props = useProps.useProps("AppShellFooter", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, withBorder = props.withBorder, zIndex = props.zIndex, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex",
        "mod"
    ]);
    var ctx = AppShell_context.useAppShellContext();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "footer",
        ref,
        mod: [
            {
                "with-border": withBorder !== null && withBorder !== void 0 ? withBorder : ctx.withBorder
            },
            mod
        ]
    }, ctx.getStyles("footer", {
        className: cx__default.default({
            [reactRemoveScroll.RemoveScroll.classNames.zeroRight]: ctx.offsetScrollbars
        }, className),
        classNames,
        styles,
        style
    }), others), {
        __vars: {
            "--app-shell-footer-z-index": (_this = zIndex !== null && zIndex !== void 0 ? zIndex : ctx.zIndex) === null || _this === void 0 ? void 0 : _this.toString()
        }
    }));
});
AppShellFooter.classes = AppShell_module;
AppShellFooter.displayName = "@mantine/core/AppShellFooter";
exports.AppShellFooter = AppShellFooter; //# sourceMappingURL=AppShellFooter.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","5095c9b81e11b257":"iKGFf","30949993a8bc4f8c":"8QFOC","4b7798289641593a":"2ufGf","336c1c75910c34e4":"9MtAM","77fdea7154bfe48d":"9HEEB","1aab2fac9ef21f2":"2FdJg","c42036bec41a8c5c":"6AMGA","4464e2f4057c634b":"erSvz","fc1583ad78c88ac9":"kqQOF","b9ef82ddb9826475":"iivvn","d313bbd2eca16816":"8YP4O","21ad971e9fac45f8":"gkGXc","f3e519ec7304a207":"guLFz","e0890591c3a830e5":"2onWA","aff0cc30b007bfbd":"fB2WG","5da970b1e19af17c":"gfoR2"}],"9L3ZV":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c320d352095ab23e");
var cx = require("490e677dc3e91e3a");
var reactRemoveScroll = require("4d6a0e4be9d13183");
require("7e7598022d94bc05");
require("58f87700cfd73993");
require("8d93e2a6ab9f5abd");
require("cebcddc9e1d37170");
require("17ad0e855bc89f7c");
require("ade25d11e445ac59");
var useProps = require("e2f848523fccf130");
require("2bef9c609bb05848");
var Box = require("ed1119325bd7388b");
var factory = require("51033ac69ea62e0a");
require("bab9cf56d85b8efd");
var AppShell_context = require("4222be91d5909991");
var AppShell_module = require("916dba0921331290");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var defaultProps = {};
var AppShellHeader = factory.factory(function(_props, ref) {
    var _this;
    var props = useProps.useProps("AppShellHeader", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, withBorder = props.withBorder, zIndex = props.zIndex, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex",
        "mod"
    ]);
    var ctx = AppShell_context.useAppShellContext();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "header",
        ref,
        mod: [
            {
                "with-border": withBorder !== null && withBorder !== void 0 ? withBorder : ctx.withBorder
            },
            mod
        ]
    }, ctx.getStyles("header", {
        className: cx__default.default({
            [reactRemoveScroll.RemoveScroll.classNames.zeroRight]: ctx.offsetScrollbars
        }, className),
        classNames,
        styles,
        style
    }), others), {
        __vars: {
            "--app-shell-header-z-index": (_this = zIndex !== null && zIndex !== void 0 ? zIndex : ctx.zIndex) === null || _this === void 0 ? void 0 : _this.toString()
        }
    }));
});
AppShellHeader.classes = AppShell_module;
AppShellHeader.displayName = "@mantine/core/AppShellHeader";
exports.AppShellHeader = AppShellHeader; //# sourceMappingURL=AppShellHeader.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c320d352095ab23e":"iKGFf","490e677dc3e91e3a":"8QFOC","4d6a0e4be9d13183":"2ufGf","7e7598022d94bc05":"9MtAM","58f87700cfd73993":"9HEEB","8d93e2a6ab9f5abd":"2FdJg","cebcddc9e1d37170":"6AMGA","17ad0e855bc89f7c":"erSvz","ade25d11e445ac59":"kqQOF","e2f848523fccf130":"iivvn","2bef9c609bb05848":"8YP4O","ed1119325bd7388b":"gkGXc","51033ac69ea62e0a":"guLFz","bab9cf56d85b8efd":"2onWA","4222be91d5909991":"fB2WG","916dba0921331290":"gfoR2"}],"6ncqX":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("92c6f2160c5a98f6");
require("e2bd97ca039b1702");
require("54b3e69f82645f3e");
require("920c54b5e0a82d13");
require("5b23be1293811252");
require("82ca85ef5b9663f8");
require("897e105a4461a8b8");
require("d105c8a9c7154232");
var useProps = require("df506dbad5f24ed3");
require("a67f81f376fe3112");
var Box = require("cc36ebd2a13c75fe");
var factory = require("21a50f262cee9a2");
require("4844475f80ffa3ca");
var AppShell_context = require("6c2277bdd81c6cfa");
var AppShell_module = require("c995057bc1b1a8e9");
var defaultProps = {};
var AppShellMain = factory.factory(function(_props, ref) {
    var props = useProps.useProps("AppShellMain", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = AppShell_context.useAppShellContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        component: "main",
        ref
    }, ctx.getStyles("main", {
        className,
        style,
        classNames,
        styles
    }), others));
});
AppShellMain.classes = AppShell_module;
AppShellMain.displayName = "@mantine/core/AppShellMain";
exports.AppShellMain = AppShellMain; //# sourceMappingURL=AppShellMain.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","92c6f2160c5a98f6":"iKGFf","e2bd97ca039b1702":"9MtAM","54b3e69f82645f3e":"9HEEB","920c54b5e0a82d13":"8QFOC","5b23be1293811252":"2FdJg","82ca85ef5b9663f8":"6AMGA","897e105a4461a8b8":"erSvz","d105c8a9c7154232":"kqQOF","df506dbad5f24ed3":"iivvn","a67f81f376fe3112":"8YP4O","cc36ebd2a13c75fe":"gkGXc","21a50f262cee9a2":"guLFz","4844475f80ffa3ca":"2onWA","6c2277bdd81c6cfa":"fB2WG","c995057bc1b1a8e9":"gfoR2"}],"lGC0r":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("70579841f2e2a2ec");
require("11834d973bfde875");
require("31ac6b5faa2720a8");
require("a7d1827975fba860");
var Mantine_context = require("7b48b211728aca42");
require("94129ba5c9a2be53");
require("eaf334f21ca07ae9");
var MantineThemeProvider = require("28a9db1e76016a8a");
require("cf802e09ce781bf2");
var InlineStyles = require("b3446b4978c63990");
require("2dd3086ff71b2f73");
require("c3d366666d75ddab");
var getVariables = require("2267a266b7d24d3");
function AppShellMediaStyles(param) {
    var navbar = param.navbar, header = param.header, aside = param.aside, footer = param.footer, padding = param.padding;
    var theme = MantineThemeProvider.useMantineTheme();
    var ctx = Mantine_context.useMantineContext();
    var _getVariables_getVariables = getVariables.getVariables({
        navbar,
        header,
        footer,
        aside,
        padding,
        theme
    }), media = _getVariables_getVariables.media, baseStyles = _getVariables_getVariables.baseStyles;
    return /* @__PURE__ */ jsxRuntime.jsx(InlineStyles.InlineStyles, {
        media,
        styles: baseStyles,
        selector: ctx.cssVariablesSelector
    });
}
exports.AppShellMediaStyles = AppShellMediaStyles; //# sourceMappingURL=AppShellMediaStyles.cjs.map

},{"70579841f2e2a2ec":"iKGFf","11834d973bfde875":"9MtAM","31ac6b5faa2720a8":"9HEEB","a7d1827975fba860":"8QFOC","7b48b211728aca42":"2FdJg","94129ba5c9a2be53":"6AMGA","eaf334f21ca07ae9":"erSvz","28a9db1e76016a8a":"kqQOF","cf802e09ce781bf2":"8YP4O","b3446b4978c63990":"3CHN8","2dd3086ff71b2f73":"gkGXc","c3d366666d75ddab":"2onWA","2267a266b7d24d3":"hvgnI"}],"hvgnI":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var keys = require("86a116c80254ee96");
var rem = require("9f8120a423bb1344");
require("5203bcd285a4016d");
require("e7e85b5676f448bd");
var getSortedBreakpoints = require("64cad08270bc9f05");
require("8818b38e4ac89346");
require("67c828ebbaf84b85");
require("802312c3a7fd75e6");
require("b1993fa49671213b");
require("b733087234a06818");
require("779cdb46463a718c");
require("35b94ab672d015a2");
require("2cbe71e2291cf651");
require("61aba88fbf024aa9");
var assignAsideVariables = require("9abe3787a3a9a864");
var assignFooterVariables = require("28e1765f6c81efd2");
var assignHeaderVariables = require("3bc7f8c1c47c6d43");
var assignNavbarVariables = require("344b32df4be8d73b");
var assignPaddingVariables = require("1951aaaf8ac7e04b");
function getVariables(param) {
    var navbar = param.navbar, header = param.header, footer = param.footer, aside = param.aside, padding = param.padding, theme = param.theme;
    var minMediaStyles = {};
    var maxMediaStyles = {};
    var baseStyles = {};
    assignNavbarVariables.assignNavbarVariables({
        baseStyles,
        minMediaStyles,
        maxMediaStyles,
        navbar,
        theme
    });
    assignAsideVariables.assignAsideVariables({
        baseStyles,
        minMediaStyles,
        maxMediaStyles,
        aside,
        theme
    });
    assignHeaderVariables.assignHeaderVariables({
        baseStyles,
        minMediaStyles,
        header
    });
    assignFooterVariables.assignFooterVariables({
        baseStyles,
        minMediaStyles,
        footer
    });
    assignPaddingVariables.assignPaddingVariables({
        baseStyles,
        minMediaStyles,
        padding
    });
    var minMedia = getSortedBreakpoints.getSortedBreakpoints(keys.keys(minMediaStyles), theme.breakpoints).map(function(breakpoint) {
        return {
            query: `(min-width: ${rem.em(breakpoint.px)})`,
            styles: minMediaStyles[breakpoint.value]
        };
    });
    var maxMedia = getSortedBreakpoints.getSortedBreakpoints(keys.keys(maxMediaStyles), theme.breakpoints).map(function(breakpoint) {
        return {
            query: `(max-width: ${rem.em(breakpoint.px)})`,
            styles: maxMediaStyles[breakpoint.value]
        };
    });
    var media = (0, _toConsumableArray._)(minMedia).concat((0, _toConsumableArray._)(maxMedia));
    return {
        baseStyles,
        media
    };
}
exports.getVariables = getVariables; //# sourceMappingURL=get-variables.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","86a116c80254ee96":"kvYzO","9f8120a423bb1344":"ebAaL","5203bcd285a4016d":"9MtAM","e7e85b5676f448bd":"iKGFf","64cad08270bc9f05":"lwwF0","8818b38e4ac89346":"9HEEB","67c828ebbaf84b85":"8QFOC","802312c3a7fd75e6":"2FdJg","b1993fa49671213b":"6AMGA","b733087234a06818":"erSvz","779cdb46463a718c":"kqQOF","35b94ab672d015a2":"8YP4O","2cbe71e2291cf651":"gkGXc","61aba88fbf024aa9":"2onWA","9abe3787a3a9a864":"epGAd","28e1765f6c81efd2":"91gSo","3bc7f8c1c47c6d43":"la3Cg","344b32df4be8d73b":"8mjUh","1951aaaf8ac7e04b":"aI57g"}],"epGAd":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("b1136cc4381e24ef");
var rem = require("97534268f44ad165");
require("aff1d7472fd1a14e");
require("1d5b3d493989d8f7");
var getBreakpointValue = require("201417d5c0817795");
require("56399b4fbd031a35");
require("edb36af74a0609f9");
require("4e80f235dd89732f");
require("f26153fda58c41fc");
require("a7a0cda9cf8c2f72");
require("588c17034fe06fdd");
require("fb87aa977a347cf0");
require("ec38637790e62cc0");
require("b8c402a04440b4eb");
var getBaseSize = require("2b04cf086ce1b0c2");
var isPrimitiveSize = require("3561fe6bd093966f");
var isResponsiveSize = require("1c573b78944d1ed8");
function assignAsideVariables(param) {
    var baseStyles = param.baseStyles, minMediaStyles = param.minMediaStyles, maxMediaStyles = param.maxMediaStyles, aside = param.aside, theme = param.theme;
    var _aside_collapsed, _aside_collapsed1, _aside_collapsed2;
    var asideWidth = aside === null || aside === void 0 ? void 0 : aside.width;
    var collapsedAsideTransform = "translateX(var(--app-shell-aside-width))";
    var collapsedAsideTransformRtl = "translateX(calc(var(--app-shell-aside-width) * -1))";
    if ((aside === null || aside === void 0 ? void 0 : aside.breakpoint) && !(aside === null || aside === void 0 ? void 0 : (_aside_collapsed = aside.collapsed) === null || _aside_collapsed === void 0 ? void 0 : _aside_collapsed.mobile)) {
        maxMediaStyles[aside === null || aside === void 0 ? void 0 : aside.breakpoint] = maxMediaStyles[aside === null || aside === void 0 ? void 0 : aside.breakpoint] || {};
        maxMediaStyles[aside === null || aside === void 0 ? void 0 : aside.breakpoint]["--app-shell-aside-width"] = "100%";
        maxMediaStyles[aside === null || aside === void 0 ? void 0 : aside.breakpoint]["--app-shell-aside-offset"] = "0px";
    }
    if (isPrimitiveSize.isPrimitiveSize(asideWidth)) {
        var baseSize = rem.rem(getBaseSize.getBaseSize(asideWidth));
        baseStyles["--app-shell-aside-width"] = baseSize;
        baseStyles["--app-shell-aside-offset"] = baseSize;
    }
    if (isResponsiveSize.isResponsiveSize(asideWidth)) {
        if (typeof asideWidth.base !== "undefined") {
            baseStyles["--app-shell-aside-width"] = rem.rem(asideWidth.base);
            baseStyles["--app-shell-aside-offset"] = rem.rem(asideWidth.base);
        }
        keys.keys(asideWidth).forEach(function(key) {
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-aside-width"] = rem.rem(asideWidth[key]);
                minMediaStyles[key]["--app-shell-aside-offset"] = rem.rem(asideWidth[key]);
            }
        });
    }
    if (aside === null || aside === void 0 ? void 0 : (_aside_collapsed1 = aside.collapsed) === null || _aside_collapsed1 === void 0 ? void 0 : _aside_collapsed1.desktop) {
        var breakpointValue = aside.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-aside-transform"] = collapsedAsideTransform;
        minMediaStyles[breakpointValue]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
        minMediaStyles[breakpointValue]["--app-shell-aside-offset"] = "0px !important";
    }
    if (aside === null || aside === void 0 ? void 0 : (_aside_collapsed2 = aside.collapsed) === null || _aside_collapsed2 === void 0 ? void 0 : _aside_collapsed2.mobile) {
        var breakpointValue1 = getBreakpointValue.getBreakpointValue(aside.breakpoint, theme.breakpoints) - 0.1;
        maxMediaStyles[breakpointValue1] = maxMediaStyles[breakpointValue1] || {};
        maxMediaStyles[breakpointValue1]["--app-shell-aside-width"] = "100%";
        maxMediaStyles[breakpointValue1]["--app-shell-aside-offset"] = "0px";
        maxMediaStyles[breakpointValue1]["--app-shell-aside-transform"] = collapsedAsideTransform;
        maxMediaStyles[breakpointValue1]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
    }
}
exports.assignAsideVariables = assignAsideVariables; //# sourceMappingURL=assign-aside-variables.cjs.map

},{"b1136cc4381e24ef":"kvYzO","97534268f44ad165":"ebAaL","aff1d7472fd1a14e":"9MtAM","1d5b3d493989d8f7":"iKGFf","201417d5c0817795":"fjWYA","56399b4fbd031a35":"9HEEB","edb36af74a0609f9":"8QFOC","4e80f235dd89732f":"2FdJg","f26153fda58c41fc":"6AMGA","a7a0cda9cf8c2f72":"erSvz","588c17034fe06fdd":"kqQOF","fb87aa977a347cf0":"8YP4O","ec38637790e62cc0":"gkGXc","b8c402a04440b4eb":"2onWA","2b04cf086ce1b0c2":"Yu0nJ","3561fe6bd093966f":"bDTtt","1c573b78944d1ed8":"kvvyN"}],"Yu0nJ":[function(require,module,exports) {
"use client";
"use strict";
function getBaseSize(size) {
    if (typeof size === "object") return size.base;
    return size;
}
exports.getBaseSize = getBaseSize; //# sourceMappingURL=get-base-size.cjs.map

},{}],"bDTtt":[function(require,module,exports) {
"use client";
"use strict";
function isPrimitiveSize(size) {
    var isBaseSize = typeof size === "object" && size !== null && typeof size.base !== "undefined" && Object.keys(size).length === 1;
    return typeof size === "number" || typeof size === "string" || isBaseSize;
}
exports.isPrimitiveSize = isPrimitiveSize; //# sourceMappingURL=is-primitive-size.cjs.map

},{}],"kvvyN":[function(require,module,exports) {
"use client";
"use strict";
function isResponsiveSize(size) {
    if (typeof size !== "object" || size === null) return false;
    if (Object.keys(size).length === 1 && "base" in size) return false;
    return true;
}
exports.isResponsiveSize = isResponsiveSize; //# sourceMappingURL=is-responsive-size.cjs.map

},{}],"91gSo":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("37d541a6b790c801");
var rem = require("343752dbf4dd0469");
require("9cefffcb66d98716");
require("d59f88804f2d19c8");
require("5bf117a416ea8d51");
require("9b4c662bcae9eb39");
require("93bd06376e84f789");
require("161e5958366c6c0f");
require("28246d60411b009");
require("7b6c3c46afbffb11");
require("c927fc13605755f1");
require("a4b92444af916a55");
require("827147b968258698");
var getBaseSize = require("148722c52b8fe291");
var isPrimitiveSize = require("d2497684f496af7f");
var isResponsiveSize = require("e7bfd9ad733f0fae");
function assignFooterVariables(param) {
    var baseStyles = param.baseStyles, minMediaStyles = param.minMediaStyles, footer = param.footer;
    var footerHeight = footer === null || footer === void 0 ? void 0 : footer.height;
    var collapsedFooterTransform = "translateY(var(--app-shell-footer-height))";
    var _footer_offset;
    var shouldOffset = (_footer_offset = footer === null || footer === void 0 ? void 0 : footer.offset) !== null && _footer_offset !== void 0 ? _footer_offset : true;
    if (isPrimitiveSize.isPrimitiveSize(footerHeight)) {
        var baseSize = rem.rem(getBaseSize.getBaseSize(footerHeight));
        baseStyles["--app-shell-footer-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-footer-offset"] = baseSize;
    }
    if (isResponsiveSize.isResponsiveSize(footerHeight)) {
        if (typeof footerHeight.base !== "undefined") {
            baseStyles["--app-shell-footer-height"] = rem.rem(footerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-footer-offset"] = rem.rem(footerHeight.base);
        }
        keys.keys(footerHeight).forEach(function(key) {
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-footer-height"] = rem.rem(footerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-footer-offset"] = rem.rem(footerHeight[key]);
            }
        });
    }
    if (footer === null || footer === void 0 ? void 0 : footer.collapsed) {
        baseStyles["--app-shell-footer-transform"] = collapsedFooterTransform;
        baseStyles["--app-shell-footer-offset"] = "0px !important";
    }
}
exports.assignFooterVariables = assignFooterVariables; //# sourceMappingURL=assign-footer-variables.cjs.map

},{"37d541a6b790c801":"kvYzO","343752dbf4dd0469":"ebAaL","9cefffcb66d98716":"9MtAM","d59f88804f2d19c8":"iKGFf","5bf117a416ea8d51":"9HEEB","9b4c662bcae9eb39":"8QFOC","93bd06376e84f789":"2FdJg","161e5958366c6c0f":"6AMGA","28246d60411b009":"erSvz","7b6c3c46afbffb11":"kqQOF","c927fc13605755f1":"8YP4O","a4b92444af916a55":"gkGXc","827147b968258698":"2onWA","148722c52b8fe291":"Yu0nJ","d2497684f496af7f":"bDTtt","e7bfd9ad733f0fae":"kvvyN"}],"la3Cg":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("a327cc1507a585a2");
var rem = require("e1cb89cf660200dc");
require("b6c016ab071f37da");
require("3c3e4324eb4c1526");
require("d737cd1935e5af81");
require("350cb4268b2d0bab");
require("8a67474e663fccc5");
require("9ed197bd88739f37");
require("e5e03c742077f466");
require("b139e9b6d255ef79");
require("3eb312d101d0a1bd");
require("c19f72cf0ed8a452");
require("e76f045d91963ac0");
var getBaseSize = require("c426451951e7c56");
var isPrimitiveSize = require("38dd6a4dce727e18");
var isResponsiveSize = require("1d27e94a4b944f0c");
function assignHeaderVariables(param) {
    var baseStyles = param.baseStyles, minMediaStyles = param.minMediaStyles, header = param.header;
    var headerHeight = header === null || header === void 0 ? void 0 : header.height;
    var collapsedHeaderTransform = "translateY(calc(var(--app-shell-header-height) * -1))";
    var _header_offset;
    var shouldOffset = (_header_offset = header === null || header === void 0 ? void 0 : header.offset) !== null && _header_offset !== void 0 ? _header_offset : true;
    if (isPrimitiveSize.isPrimitiveSize(headerHeight)) {
        var baseSize = rem.rem(getBaseSize.getBaseSize(headerHeight));
        baseStyles["--app-shell-header-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-header-offset"] = baseSize;
    }
    if (isResponsiveSize.isResponsiveSize(headerHeight)) {
        if (typeof headerHeight.base !== "undefined") {
            baseStyles["--app-shell-header-height"] = rem.rem(headerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-header-offset"] = rem.rem(headerHeight.base);
        }
        keys.keys(headerHeight).forEach(function(key) {
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-header-height"] = rem.rem(headerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-header-offset"] = rem.rem(headerHeight[key]);
            }
        });
    }
    if (header === null || header === void 0 ? void 0 : header.collapsed) {
        baseStyles["--app-shell-header-transform"] = collapsedHeaderTransform;
        baseStyles["--app-shell-header-offset"] = "0px !important";
    }
}
exports.assignHeaderVariables = assignHeaderVariables; //# sourceMappingURL=assign-header-variables.cjs.map

},{"a327cc1507a585a2":"kvYzO","e1cb89cf660200dc":"ebAaL","b6c016ab071f37da":"9MtAM","3c3e4324eb4c1526":"iKGFf","d737cd1935e5af81":"9HEEB","350cb4268b2d0bab":"8QFOC","8a67474e663fccc5":"2FdJg","9ed197bd88739f37":"6AMGA","e5e03c742077f466":"erSvz","b139e9b6d255ef79":"kqQOF","3eb312d101d0a1bd":"8YP4O","c19f72cf0ed8a452":"gkGXc","e76f045d91963ac0":"2onWA","c426451951e7c56":"Yu0nJ","38dd6a4dce727e18":"bDTtt","1d27e94a4b944f0c":"kvvyN"}],"8mjUh":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("f9329fe1ec2caeef");
var rem = require("33c0511261d7a686");
require("156cef0ec01a8284");
require("927894094945d5ba");
var getBreakpointValue = require("ab00fb5e52520a43");
require("78c80969ee16e90e");
require("a8c9236b93acce76");
require("111b16bdb91ed291");
require("a0b38780270fe507");
require("a2a4f995778d652c");
require("38bb741131a1218d");
require("96bbb93318b9716a");
require("a0423a3c7ca98261");
require("f84d5e52a5b6aed1");
var getBaseSize = require("93873c35ef36ab49");
var isPrimitiveSize = require("36a40cc0f0de704c");
var isResponsiveSize = require("69d5a5d6dcd4c0fa");
function assignNavbarVariables(param) {
    var baseStyles = param.baseStyles, minMediaStyles = param.minMediaStyles, maxMediaStyles = param.maxMediaStyles, navbar = param.navbar, theme = param.theme;
    var _navbar_collapsed, _navbar_collapsed1, _navbar_collapsed2;
    var navbarWidth = navbar === null || navbar === void 0 ? void 0 : navbar.width;
    var collapsedNavbarTransform = "translateX(calc(var(--app-shell-navbar-width) * -1))";
    var collapsedNavbarTransformRtl = "translateX(var(--app-shell-navbar-width))";
    if ((navbar === null || navbar === void 0 ? void 0 : navbar.breakpoint) && !(navbar === null || navbar === void 0 ? void 0 : (_navbar_collapsed = navbar.collapsed) === null || _navbar_collapsed === void 0 ? void 0 : _navbar_collapsed.mobile)) {
        maxMediaStyles[navbar === null || navbar === void 0 ? void 0 : navbar.breakpoint] = maxMediaStyles[navbar === null || navbar === void 0 ? void 0 : navbar.breakpoint] || {};
        maxMediaStyles[navbar === null || navbar === void 0 ? void 0 : navbar.breakpoint]["--app-shell-navbar-width"] = "100%";
        maxMediaStyles[navbar === null || navbar === void 0 ? void 0 : navbar.breakpoint]["--app-shell-navbar-offset"] = "0px";
    }
    if (isPrimitiveSize.isPrimitiveSize(navbarWidth)) {
        var baseSize = rem.rem(getBaseSize.getBaseSize(navbarWidth));
        baseStyles["--app-shell-navbar-width"] = baseSize;
        baseStyles["--app-shell-navbar-offset"] = baseSize;
    }
    if (isResponsiveSize.isResponsiveSize(navbarWidth)) {
        if (typeof navbarWidth.base !== "undefined") {
            baseStyles["--app-shell-navbar-width"] = rem.rem(navbarWidth.base);
            baseStyles["--app-shell-navbar-offset"] = rem.rem(navbarWidth.base);
        }
        keys.keys(navbarWidth).forEach(function(key) {
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-navbar-width"] = rem.rem(navbarWidth[key]);
                minMediaStyles[key]["--app-shell-navbar-offset"] = rem.rem(navbarWidth[key]);
            }
        });
    }
    if (navbar === null || navbar === void 0 ? void 0 : (_navbar_collapsed1 = navbar.collapsed) === null || _navbar_collapsed1 === void 0 ? void 0 : _navbar_collapsed1.desktop) {
        var breakpointValue = navbar.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
        minMediaStyles[breakpointValue]["--app-shell-navbar-offset"] = "0px !important";
    }
    if (navbar === null || navbar === void 0 ? void 0 : (_navbar_collapsed2 = navbar.collapsed) === null || _navbar_collapsed2 === void 0 ? void 0 : _navbar_collapsed2.mobile) {
        var breakpointValue1 = getBreakpointValue.getBreakpointValue(navbar.breakpoint, theme.breakpoints) - 0.1;
        maxMediaStyles[breakpointValue1] = maxMediaStyles[breakpointValue1] || {};
        maxMediaStyles[breakpointValue1]["--app-shell-navbar-width"] = "100%";
        maxMediaStyles[breakpointValue1]["--app-shell-navbar-offset"] = "0px";
        maxMediaStyles[breakpointValue1]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        maxMediaStyles[breakpointValue1]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
    }
}
exports.assignNavbarVariables = assignNavbarVariables; //# sourceMappingURL=assign-navbar-variables.cjs.map

},{"f9329fe1ec2caeef":"kvYzO","33c0511261d7a686":"ebAaL","156cef0ec01a8284":"9MtAM","927894094945d5ba":"iKGFf","ab00fb5e52520a43":"fjWYA","78c80969ee16e90e":"9HEEB","a8c9236b93acce76":"8QFOC","111b16bdb91ed291":"2FdJg","a0b38780270fe507":"6AMGA","a2a4f995778d652c":"erSvz","38bb741131a1218d":"kqQOF","96bbb93318b9716a":"8YP4O","a0423a3c7ca98261":"gkGXc","f84d5e52a5b6aed1":"2onWA","93873c35ef36ab49":"Yu0nJ","36a40cc0f0de704c":"bDTtt","69d5a5d6dcd4c0fa":"kvvyN"}],"aI57g":[function(require,module,exports) {
"use client";
"use strict";
var keys = require("6f30b817fe3b8495");
require("1e5394cadb733734");
require("1c90c5e2fd45d335");
require("eec080e045515d3f");
require("7ab3b2e992b669dd");
require("89627c03e6aa0422");
require("754dd9e874ac515b");
require("82450abef8d06155");
require("c94bbe105a8f8a5b");
require("83de0cca77d49273");
require("341bd801fa1d7ebe");
require("a45e9414d7ef052b");
var getBaseSize = require("f7e3a256e1a3ab51");
var getPaddingValue = require("385b5ec8a760103b");
var isPrimitiveSize = require("3c954e225b1d4b22");
var isResponsiveSize = require("9a6068f66a9a8bc8");
function assignPaddingVariables(param) {
    var padding = param.padding, baseStyles = param.baseStyles, minMediaStyles = param.minMediaStyles;
    if (isPrimitiveSize.isPrimitiveSize(padding)) baseStyles["--app-shell-padding"] = getPaddingValue.getPaddingValue(getBaseSize.getBaseSize(padding));
    if (isResponsiveSize.isResponsiveSize(padding)) {
        if (padding.base) baseStyles["--app-shell-padding"] = getPaddingValue.getPaddingValue(padding.base);
        keys.keys(padding).forEach(function(key) {
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-padding"] = getPaddingValue.getPaddingValue(padding[key]);
            }
        });
    }
}
exports.assignPaddingVariables = assignPaddingVariables; //# sourceMappingURL=assign-padding-variables.cjs.map

},{"6f30b817fe3b8495":"kvYzO","1e5394cadb733734":"9MtAM","1c90c5e2fd45d335":"iKGFf","eec080e045515d3f":"9HEEB","7ab3b2e992b669dd":"8QFOC","89627c03e6aa0422":"2FdJg","754dd9e874ac515b":"6AMGA","82450abef8d06155":"erSvz","c94bbe105a8f8a5b":"kqQOF","83de0cca77d49273":"8YP4O","341bd801fa1d7ebe":"gkGXc","a45e9414d7ef052b":"2onWA","f7e3a256e1a3ab51":"Yu0nJ","385b5ec8a760103b":"1iLBm","3c954e225b1d4b22":"bDTtt","9a6068f66a9a8bc8":"kvvyN"}],"1iLBm":[function(require,module,exports) {
"use client";
"use strict";
require("5881f3b7b29da903");
require("4222f526c274dd60");
var getSize = require("6c3563e07138620e");
require("5d20e65620a6c8");
require("649646bd1f795402");
require("5097b7e66b2c68b8");
require("af486f6c4e1bdfa3");
require("3d6af1dcdc1b4680");
require("440fd3caef64323e");
require("c1191b7c0f6d3728");
require("3e65bbaa01068621");
require("7016d6ace5c544c4");
function getPaddingValue(padding) {
    return Number(padding) === 0 ? "0px" : getSize.getSpacing(padding);
}
exports.getPaddingValue = getPaddingValue; //# sourceMappingURL=get-padding-value.cjs.map

},{"5881f3b7b29da903":"9MtAM","4222f526c274dd60":"iKGFf","6c3563e07138620e":"kEFEY","5d20e65620a6c8":"9HEEB","649646bd1f795402":"8QFOC","5097b7e66b2c68b8":"2FdJg","af486f6c4e1bdfa3":"6AMGA","3d6af1dcdc1b4680":"erSvz","440fd3caef64323e":"kqQOF","c1191b7c0f6d3728":"8YP4O","3e65bbaa01068621":"gkGXc","7016d6ace5c544c4":"2onWA"}],"l3VpA":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3f3a3cd6d683617b");
require("9221cdeb5827a9e1");
require("12848cd4003c31ef");
require("c383403210803cfd");
require("aa2e8a20fb7a2b1c");
require("b26a303c018a45c3");
require("1f0cc4f7a8b7aac1");
require("3a537116a23a8de6");
var useProps = require("5576ea133f75208c");
require("bb0c80e99be88417");
var Box = require("fc79360e4031d50e");
var factory = require("2073358e535dadc8");
require("ebcaf78b70649b1c");
var AppShell_context = require("1da8a7f877c1cdb9");
var AppShell_module = require("56fc89d528908219");
var defaultProps = {};
var AppShellNavbar = factory.factory(function(_props, ref) {
    var props = useProps.useProps("AppShellNavbar", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, withBorder = props.withBorder, zIndex = props.zIndex, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "withBorder",
        "zIndex",
        "mod"
    ]);
    var ctx = AppShell_context.useAppShellContext();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "nav",
        ref,
        mod: [
            {
                "with-border": withBorder !== null && withBorder !== void 0 ? withBorder : ctx.withBorder
            },
            mod
        ]
    }, ctx.getStyles("navbar", {
        className,
        classNames,
        styles,
        style
    }), others), {
        __vars: {
            "--app-shell-navbar-z-index": `calc(${zIndex !== null && zIndex !== void 0 ? zIndex : ctx.zIndex} + 1)`
        }
    }));
});
AppShellNavbar.classes = AppShell_module;
AppShellNavbar.displayName = "@mantine/core/AppShellNavbar";
exports.AppShellNavbar = AppShellNavbar; //# sourceMappingURL=AppShellNavbar.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","3f3a3cd6d683617b":"iKGFf","9221cdeb5827a9e1":"9MtAM","12848cd4003c31ef":"9HEEB","c383403210803cfd":"8QFOC","aa2e8a20fb7a2b1c":"2FdJg","b26a303c018a45c3":"6AMGA","1f0cc4f7a8b7aac1":"erSvz","3a537116a23a8de6":"kqQOF","5576ea133f75208c":"iivvn","bb0c80e99be88417":"8YP4O","fc79360e4031d50e":"gkGXc","2073358e535dadc8":"guLFz","ebcaf78b70649b1c":"2onWA","1da8a7f877c1cdb9":"fB2WG","56fc89d528908219":"gfoR2"}],"2nCsm":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c6eaa6796b77da52");
require("87fc2cf0ba2cdd27");
require("27b09b2b4ec5ba0e");
require("a85860dc22e164e1");
require("e3d2d4fb8d333256");
require("196638128769d1f5");
require("1d08e3507c422997");
require("bf861fdbc9825e5d");
var useProps = require("551d70b8ea5cbf18");
require("319d47576e313bff");
var Box = require("c81c97880bbd6270");
var polymorphicFactory = require("a45cd8720bd0617c");
require("777401f6081baa2c");
var AppShell_context = require("1eb95d6b8b609046");
var AppShell_module = require("d17cc499a140f0fe");
var defaultProps = {};
var AppShellSection = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("AppShellSection", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, grow = props.grow, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "grow",
        "mod"
    ]);
    var ctx = AppShell_context.useAppShellContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref,
        mod: [
            {
                grow
            },
            mod
        ]
    }, ctx.getStyles("section", {
        className,
        style,
        classNames,
        styles
    }), others));
});
AppShellSection.classes = AppShell_module;
AppShellSection.displayName = "@mantine/core/AppShellSection";
exports.AppShellSection = AppShellSection; //# sourceMappingURL=AppShellSection.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","c6eaa6796b77da52":"iKGFf","87fc2cf0ba2cdd27":"9MtAM","27b09b2b4ec5ba0e":"9HEEB","a85860dc22e164e1":"8QFOC","e3d2d4fb8d333256":"2FdJg","196638128769d1f5":"6AMGA","1d08e3507c422997":"erSvz","bf861fdbc9825e5d":"kqQOF","551d70b8ea5cbf18":"iivvn","319d47576e313bff":"8YP4O","c81c97880bbd6270":"gkGXc","a45cd8720bd0617c":"iYAEL","777401f6081baa2c":"2onWA","1eb95d6b8b609046":"fB2WG","d17cc499a140f0fe":"gfoR2"}],"3ry9o":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("5532cf1c6b0ed88d");
var hooks = require("4f3ad790a115cd9e");
function useResizing(param) {
    var transitionDuration = param.transitionDuration, disabled = param.disabled;
    var _React_useState = (0, _slicedToArray._)(React.useState(true), 2), resizing = _React_useState[0], setResizing = _React_useState[1];
    var resizingTimeout = React.useRef(-1);
    var disabledTimeout = React.useRef(-1);
    hooks.useWindowEvent("resize", function() {
        setResizing(true);
        clearTimeout(resizingTimeout.current);
        resizingTimeout.current = window.setTimeout(function() {
            return React.startTransition(function() {
                setResizing(false);
            });
        }, 200);
    });
    hooks.useIsomorphicEffect(function() {
        setResizing(true);
        clearTimeout(disabledTimeout.current);
        disabledTimeout.current = window.setTimeout(function() {
            return React.startTransition(function() {
                setResizing(false);
            });
        }, transitionDuration || 0);
    }, [
        disabled,
        transitionDuration
    ]);
    return resizing;
}
exports.useResizing = useResizing; //# sourceMappingURL=use-resizing.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","5532cf1c6b0ed88d":"9MtAM","4f3ad790a115cd9e":"9HEEB"}],"i8srR":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("5fac5a527e722e38");
require("40e01a8fe9bb69ce");
require("f8734f87db29a080");
var createVarsResolver = require("22465ae2cc6aed0a");
require("63ba383fa19fd2a9");
require("ba50d11d901af87b");
require("301b5ce740536548");
require("ad4f13a7fd9de7ed");
require("e044bb184357121d");
var useProps = require("80cd283dc40c79c0");
require("8d4be8ef95b7daa8");
var useStyles = require("2be17990b12ead80");
var Box = require("d61ec08e253323eb");
var factory = require("fd573d033498bc12");
require("cd4267e5647da423");
var AspectRatio_module = require("ad85a040027b2266");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var ratio = param.ratio;
    return {
        root: {
            "--ar-ratio": ratio === null || ratio === void 0 ? void 0 : ratio.toString()
        }
    };
});
var AspectRatio = factory.factory(function(_props, ref) {
    var props = useProps.useProps("AspectRatio", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, ratio = props.ratio, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "ratio"
    ]);
    var getStyles = useStyles.useStyles({
        name: "AspectRatio",
        classes: AspectRatio_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref
    }, getStyles("root"), others));
});
AspectRatio.classes = AspectRatio_module;
AspectRatio.displayName = "@mantine/core/AspectRatio";
exports.AspectRatio = AspectRatio; //# sourceMappingURL=AspectRatio.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","5fac5a527e722e38":"iKGFf","40e01a8fe9bb69ce":"9MtAM","f8734f87db29a080":"9HEEB","22465ae2cc6aed0a":"hIQE6","63ba383fa19fd2a9":"8QFOC","ba50d11d901af87b":"2FdJg","301b5ce740536548":"6AMGA","ad4f13a7fd9de7ed":"erSvz","e044bb184357121d":"kqQOF","80cd283dc40c79c0":"iivvn","8d4be8ef95b7daa8":"8YP4O","2be17990b12ead80":"d0sAY","d61ec08e253323eb":"gkGXc","fd573d033498bc12":"guLFz","cd4267e5647da423":"2onWA","ad85a040027b2266":"l6xdT"}],"l6xdT":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_71ac47fc"
};
module.exports = classes; //# sourceMappingURL=AspectRatio.module.css.cjs.map

},{}],"HYJQq":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("2405e9a88b4cf991");
var React = require("fca7dd58a4099041");
var hooks = require("31abe56d450c5a12");
require("a32f9a4fe9abccd9");
var useResolvedStylesApi = require("71269e47da733441");
require("a1b142c9b5178845");
require("93a5a6bcee5ef2c5");
require("34b2523654a575b7");
require("af52e757fa899ae");
var useProps = require("c3d1bd24869dfcf0");
require("3099eb2bcc832f25");
require("78c9beb55b066046");
var factory = require("72ecbf465c2961b9");
require("dc365f8a66a93b09");
var getParsedComboboxData = require("a026cb26dfbf755b");
var getOptionsLockup = require("492d99fb1c317175");
require("38d72f987d241042");
var Combobox = require("f1059087a169fd80");
require("3fac28df3b13cf19");
require("42d49ed226b2b723");
require("7fed1d1d507b1dd9");
require("1058e6d0e4ba2611");
require("523f9c2089fd7d83");
require("ed2896dafa324402");
require("36c1a1f2179a0a0e");
require("3c42196b93e22b1c");
require("8702914be7ef2650");
require("915376d3757aec78");
require("dd1c27e482711b98");
require("4e7e85c4b51bc2bf");
require("3ad88bd923e6d0b2");
var OptionsDropdown = require("7141b93ea1435aaa");
var useCombobox = require("a94195d189a4af6f");
require("d3c2ef4336df21ef");
var InputBase = require("d96047404e976933");
var defaultProps = {};
var Autocomplete = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Autocomplete", defaultProps, _props);
    var classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, vars = props.vars, dropdownOpened = props.dropdownOpened, defaultDropdownOpened = props.defaultDropdownOpened, onDropdownClose = props.onDropdownClose, onDropdownOpen = props.onDropdownOpen, onFocus = props.onFocus, onBlur = props.onBlur, onClick = props.onClick, onChange = props.onChange, data = props.data, value = props.value, defaultValue = props.defaultValue, selectFirstOptionOnChange = props.selectFirstOptionOnChange, onOptionSubmit = props.onOptionSubmit, comboboxProps = props.comboboxProps, readOnly = props.readOnly, disabled = props.disabled, filter = props.filter, limit = props.limit, withScrollArea = props.withScrollArea, maxDropdownHeight = props.maxDropdownHeight, size = props.size, id = props.id, renderOption = props.renderOption, autoComplete = props.autoComplete, scrollAreaProps = props.scrollAreaProps, onClear = props.onClear, clearButtonProps = props.clearButtonProps, error = props.error, clearable = props.clearable, rightSection = props.rightSection, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "dropdownOpened",
        "defaultDropdownOpened",
        "onDropdownClose",
        "onDropdownOpen",
        "onFocus",
        "onBlur",
        "onClick",
        "onChange",
        "data",
        "value",
        "defaultValue",
        "selectFirstOptionOnChange",
        "onOptionSubmit",
        "comboboxProps",
        "readOnly",
        "disabled",
        "filter",
        "limit",
        "withScrollArea",
        "maxDropdownHeight",
        "size",
        "id",
        "renderOption",
        "autoComplete",
        "scrollAreaProps",
        "onClear",
        "clearButtonProps",
        "error",
        "clearable",
        "rightSection"
    ]);
    var _id = hooks.useId(id);
    var parsedData = getParsedComboboxData.getParsedComboboxData(data);
    var optionsLockup = getOptionsLockup.getOptionsLockup(parsedData);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: "",
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var combobox = useCombobox.useCombobox({
        opened: dropdownOpened,
        defaultOpened: defaultDropdownOpened,
        onDropdownOpen,
        onDropdownClose: function() {
            onDropdownClose === null || onDropdownClose === void 0 ? void 0 : onDropdownClose();
            combobox.resetSelectedOption();
        }
    });
    var handleValueChange = function(value2) {
        setValue(value2);
        combobox.resetSelectedOption();
    };
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        props,
        styles,
        classNames
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    React.useEffect(function() {
        if (selectFirstOptionOnChange) combobox.selectFirstOption();
    }, [
        selectFirstOptionOnChange,
        _value
    ]);
    var clearButton = /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.ClearButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, clearButtonProps), {
        onClear: function() {
            handleValueChange("");
            onClear === null || onClear === void 0 ? void 0 : onClear();
        }
    }));
    return /* @__PURE__ */ jsxRuntime.jsxs(Combobox.Combobox, (0, _objectSpreadProps._)((0, _objectSpread._)({
        store: combobox,
        __staticSelector: "Autocomplete",
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled,
        readOnly,
        onOptionSubmit: function(val) {
            onOptionSubmit === null || onOptionSubmit === void 0 ? void 0 : onOptionSubmit(val);
            handleValueChange(optionsLockup[val].label);
            combobox.closeDropdown();
        },
        size
    }, comboboxProps), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Target, {
                autoComplete,
                children: /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    ref
                }, others), {
                    size,
                    __staticSelector: "Autocomplete",
                    __clearSection: clearButton,
                    __clearable: clearable && !!_value && !disabled && !readOnly,
                    rightSection,
                    disabled,
                    readOnly,
                    value: _value,
                    error,
                    onChange: function(event) {
                        handleValueChange(event.currentTarget.value);
                        combobox.openDropdown();
                        selectFirstOptionOnChange && combobox.selectFirstOption();
                    },
                    onFocus: function(event) {
                        combobox.openDropdown();
                        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                    },
                    onBlur: function(event) {
                        combobox.closeDropdown();
                        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                    },
                    onClick: function(event) {
                        combobox.openDropdown();
                        onClick === null || onClick === void 0 ? void 0 : onClick(event);
                    },
                    classNames: resolvedClassNames,
                    styles: resolvedStyles,
                    unstyled,
                    id: _id
                }))
            }),
            /* @__PURE__ */ jsxRuntime.jsx(OptionsDropdown.OptionsDropdown, {
                data: parsedData,
                hidden: readOnly || disabled,
                filter,
                search: _value,
                limit,
                hiddenWhenEmpty: true,
                withScrollArea,
                maxDropdownHeight,
                unstyled,
                labelId: others.label ? `${_id}-label` : void 0,
                "aria-label": others.label ? void 0 : others["aria-label"],
                renderOption,
                scrollAreaProps
            })
        ]
    }));
});
Autocomplete.classes = (0, _objectSpread._)({}, InputBase.InputBase.classes, Combobox.Combobox.classes);
Autocomplete.displayName = "@mantine/core/Autocomplete";
exports.Autocomplete = Autocomplete; //# sourceMappingURL=Autocomplete.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","2405e9a88b4cf991":"iKGFf","fca7dd58a4099041":"9MtAM","31abe56d450c5a12":"9HEEB","a32f9a4fe9abccd9":"8QFOC","71269e47da733441":"d30sL","a1b142c9b5178845":"2FdJg","93a5a6bcee5ef2c5":"6AMGA","34b2523654a575b7":"erSvz","af52e757fa899ae":"kqQOF","c3d1bd24869dfcf0":"iivvn","3099eb2bcc832f25":"8YP4O","78c9beb55b066046":"gkGXc","72ecbf465c2961b9":"guLFz","dc365f8a66a93b09":"2onWA","a026cb26dfbf755b":"71QDZ","492d99fb1c317175":"jSlFr","38d72f987d241042":"6nIYy","f1059087a169fd80":"d1kVk","3fac28df3b13cf19":"4ROIf","42d49ed226b2b723":"alBok","7fed1d1d507b1dd9":"h5QT5","1058e6d0e4ba2611":"8rZez","523f9c2089fd7d83":"74J2w","ed2896dafa324402":"iyoTe","36c1a1f2179a0a0e":"3ZaWl","3c42196b93e22b1c":"9a8Lj","8702914be7ef2650":"8omXP","915376d3757aec78":"ceCGy","dd1c27e482711b98":"1dzCw","4e7e85c4b51bc2bf":"4Z9pV","3ad88bd923e6d0b2":"8RMJf","7141b93ea1435aaa":"17zEV","a94195d189a4af6f":"W6tOq","d3c2ef4336df21ef":"etJ5t","d96047404e976933":"jbA6w"}],"71QDZ":[function(require,module,exports) {
"use client";
"use strict";
function parseItem(item) {
    if (typeof item === "string") return {
        value: item,
        label: item
    };
    if ("value" in item && !("label" in item)) return {
        value: item.value,
        label: item.value,
        disabled: item.disabled
    };
    if (typeof item === "number") return {
        value: item.toString(),
        label: item.toString()
    };
    if ("group" in item) return {
        group: item.group,
        items: item.items.map(function(i) {
            return parseItem(i);
        })
    };
    return item;
}
function getParsedComboboxData(data) {
    if (!data) return [];
    return data.map(function(item) {
        return parseItem(item);
    });
}
exports.getParsedComboboxData = getParsedComboboxData; //# sourceMappingURL=get-parsed-combobox-data.cjs.map

},{}],"jSlFr":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
function getOptionsLockup(options) {
    return options.reduce(function(acc, item) {
        if ("group" in item) return (0, _objectSpread._)({}, acc, getOptionsLockup(item.items));
        acc[item.value] = item;
        return acc;
    }, {});
}
function getLabelsLockup(options) {
    return options.reduce(function(acc, item) {
        if ("group" in item) return (0, _objectSpread._)({}, acc, getLabelsLockup(item.items));
        acc[item.label] = item;
        return acc;
    }, {});
}
exports.getLabelsLockup = getLabelsLockup;
exports.getOptionsLockup = getOptionsLockup; //# sourceMappingURL=get-options-lockup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN"}],"6nIYy":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f7ee5eb517a9a392");
require("b1786d41870bc7db");
var getSize = require("1d43fa06e4d7dcb7");
require("f9b922a43a550b9f");
var createVarsResolver = require("73efe7f228035536");
require("c823d830af000310");
var getThemeColor = require("54dbddb671efd9fb");
require("2e1257f740925797");
require("f63b5b2b2342ffc5");
require("a38a04d790636105");
require("f145294ba28d5b18");
var useProps = require("65535e3bc8854f65");
require("1b484b688606935e");
var useStyles = require("5df3240a3bd384cd");
var Box = require("ac5468a171f49102");
var factory = require("1d3ed4d5ac6dfe87");
require("8b7bfa5dbbf66de6");
var Combobox_module = require("8562b1ead3ad7742");
var defaultProps = {
    error: null
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, color = param.color;
    return {
        chevron: {
            "--combobox-chevron-size": getSize.getSize(size, "combobox-chevron-size"),
            "--combobox-chevron-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
        }
    };
});
var ComboboxChevron = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ComboboxChevron", defaultProps, _props);
    var size = props.size, error = props.error, style = props.style, className = props.className, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, vars = props.vars, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "size",
        "error",
        "style",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ComboboxChevron",
        classes: Combobox_module,
        props,
        style,
        className,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "chevron"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "svg"
    }, others, getStyles("chevron")), {
        size,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        mod: [
            "combobox-chevron",
            {
                error
            },
            mod
        ],
        ref,
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    }));
});
ComboboxChevron.classes = Combobox_module;
ComboboxChevron.displayName = "@mantine/core/ComboboxChevron";
exports.ComboboxChevron = ComboboxChevron; //# sourceMappingURL=ComboboxChevron.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f7ee5eb517a9a392":"iKGFf","b1786d41870bc7db":"9MtAM","1d43fa06e4d7dcb7":"kEFEY","f9b922a43a550b9f":"9HEEB","73efe7f228035536":"hIQE6","c823d830af000310":"8QFOC","54dbddb671efd9fb":"eeaIN","2e1257f740925797":"2FdJg","f63b5b2b2342ffc5":"6AMGA","a38a04d790636105":"erSvz","f145294ba28d5b18":"kqQOF","65535e3bc8854f65":"iivvn","1b484b688606935e":"8YP4O","5df3240a3bd384cd":"d0sAY","ac5468a171f49102":"gkGXc","1d3ed4d5ac6dfe87":"guLFz","8b7bfa5dbbf66de6":"2onWA","8562b1ead3ad7742":"ae332"}],"ae332":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "dropdown": "m_88b62a41",
    "search": "m_985517d8",
    "options": "m_b2821a6e",
    "option": "m_92253aa5",
    "empty": "m_2530cd1d",
    "header": "m_858f94bd",
    "footer": "m_82b967cb",
    "group": "m_254f3e4f",
    "groupLabel": "m_2bb2e9e5",
    "chevron": "m_2943220b",
    "optionsDropdownOption": "m_390b5f4",
    "optionsDropdownCheckIcon": "m_8ee53fc2"
};
module.exports = classes; //# sourceMappingURL=Combobox.module.css.cjs.map

},{}],"d1kVk":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("cc652b151519fc95");
var rem = require("8bf82dff24491d5e");
require("dc90367388240456");
var getSize = require("f94c03f93a7b794d");
require("482d65df1a4a3141");
var createVarsResolver = require("e3bb15da6e9dbae6");
require("adc502c1976f2c00");
require("2c5502fb0d5f3304");
require("6c7af5971ace78b1");
require("2be34856de54e41e");
require("62b46daccdccd035");
var useProps = require("f2ae685ee779eb0b");
require("2fd469af7d1a6025");
var useStyles = require("8dd6b9cd4d00a729");
require("c7282842c4028305");
require("fc97d5c94b22fda9");
var Popover = require("4276e8260cac5748");
require("32f43ed82359e0bd");
require("9ff6600e3f18acf7");
var Combobox_context = require("c00df420088e5058");
var ComboboxChevron = require("f7f17402c3d8c96");
var ComboboxClearButton = require("d55e6e7111773abe");
var ComboboxDropdown = require("6be7335d93552330");
var ComboboxDropdownTarget = require("747cfd2a7d194f17");
var ComboboxEmpty = require("9cb458dcaeb5b00b");
var ComboboxEventsTarget = require("e6857d6c9e42b0dc");
var ComboboxFooter = require("132a99b03f881769");
var ComboboxGroup = require("a025d5b9e5d5d37c");
var ComboboxHeader = require("7dae180cd6b34d91");
var ComboboxHiddenInput = require("d98cef7dcaa1b98");
var ComboboxOption = require("35b13602f3055bc0");
var ComboboxOptions = require("db7008123cbeec4a");
var ComboboxSearch = require("da02815e4f9844ed");
var ComboboxTarget = require("6b133fd6cb107dbd");
var useCombobox = require("17287a672cc32134");
var Combobox_module = require("6d55363392a5d528");
var defaultProps = {
    keepMounted: true,
    withinPortal: true,
    resetSelectionOnOptionHover: false,
    width: "target",
    transitionProps: {
        transition: "fade",
        duration: 0
    }
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, dropdownPadding = param.dropdownPadding;
    return {
        options: {
            "--combobox-option-fz": getSize.getFontSize(size),
            "--combobox-option-padding": getSize.getSize(size, "combobox-option-padding")
        },
        dropdown: {
            "--combobox-padding": dropdownPadding === void 0 ? void 0 : rem.rem(dropdownPadding),
            "--combobox-option-fz": getSize.getFontSize(size),
            "--combobox-option-padding": getSize.getSize(size, "combobox-option-padding")
        }
    };
});
function Combobox(_props) {
    var props = useProps.useProps("Combobox", defaultProps, _props);
    var classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, children = props.children, controlledStore = props.store, vars = props.vars, onOptionSubmit = props.onOptionSubmit, onClose = props.onClose, size = props.size, dropdownPadding = props.dropdownPadding, resetSelectionOnOptionHover = props.resetSelectionOnOptionHover, __staticSelector = props.__staticSelector, readOnly = props.readOnly, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "styles",
        "unstyled",
        "children",
        "store",
        "vars",
        "onOptionSubmit",
        "onClose",
        "size",
        "dropdownPadding",
        "resetSelectionOnOptionHover",
        "__staticSelector",
        "readOnly"
    ]);
    var uncontrolledStore = useCombobox.useCombobox();
    var store = controlledStore || uncontrolledStore;
    var getStyles = useStyles.useStyles({
        name: __staticSelector || "Combobox",
        classes: Combobox_module,
        props,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var onDropdownClose = function() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        store.closeDropdown();
    };
    return /* @__PURE__ */ jsxRuntime.jsx(Combobox_context.ComboboxProvider, {
        value: {
            getStyles,
            store,
            onOptionSubmit,
            size,
            resetSelectionOnOptionHover,
            readOnly
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover, (0, _objectSpreadProps._)((0, _objectSpread._)({
            opened: store.dropdownOpened
        }, others), {
            onChange: function(_opened) {
                return !_opened && onDropdownClose();
            },
            withRoles: false,
            unstyled,
            children
        }))
    });
}
var extendCombobox = function(c) {
    return c;
};
Combobox.extend = extendCombobox;
Combobox.classes = Combobox_module;
Combobox.displayName = "@mantine/core/Combobox";
Combobox.Target = ComboboxTarget.ComboboxTarget;
Combobox.Dropdown = ComboboxDropdown.ComboboxDropdown;
Combobox.Options = ComboboxOptions.ComboboxOptions;
Combobox.Option = ComboboxOption.ComboboxOption;
Combobox.Search = ComboboxSearch.ComboboxSearch;
Combobox.Empty = ComboboxEmpty.ComboboxEmpty;
Combobox.Chevron = ComboboxChevron.ComboboxChevron;
Combobox.Footer = ComboboxFooter.ComboboxFooter;
Combobox.Header = ComboboxHeader.ComboboxHeader;
Combobox.EventsTarget = ComboboxEventsTarget.ComboboxEventsTarget;
Combobox.DropdownTarget = ComboboxDropdownTarget.ComboboxDropdownTarget;
Combobox.Group = ComboboxGroup.ComboboxGroup;
Combobox.ClearButton = ComboboxClearButton.ComboboxClearButton;
Combobox.HiddenInput = ComboboxHiddenInput.ComboboxHiddenInput;
exports.Combobox = Combobox; //# sourceMappingURL=Combobox.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","cc652b151519fc95":"iKGFf","8bf82dff24491d5e":"ebAaL","dc90367388240456":"9MtAM","f94c03f93a7b794d":"kEFEY","482d65df1a4a3141":"9HEEB","e3bb15da6e9dbae6":"hIQE6","adc502c1976f2c00":"8QFOC","2c5502fb0d5f3304":"2FdJg","6c7af5971ace78b1":"6AMGA","2be34856de54e41e":"erSvz","62b46daccdccd035":"kqQOF","f2ae685ee779eb0b":"iivvn","2fd469af7d1a6025":"8YP4O","8dd6b9cd4d00a729":"d0sAY","c7282842c4028305":"gkGXc","fc97d5c94b22fda9":"2onWA","4276e8260cac5748":"4oc3k","32f43ed82359e0bd":"b7S6t","9ff6600e3f18acf7":"iz4SD","c00df420088e5058":"etJ5t","f7f17402c3d8c96":"6nIYy","d55e6e7111773abe":"4Z9pV","6be7335d93552330":"4ROIf","747cfd2a7d194f17":"ceCGy","9cb458dcaeb5b00b":"iyoTe","e6857d6c9e42b0dc":"8omXP","132a99b03f881769":"3ZaWl","a025d5b9e5d5d37c":"1dzCw","7dae180cd6b34d91":"9a8Lj","d98cef7dcaa1b98":"8RMJf","35b13602f3055bc0":"h5QT5","db7008123cbeec4a":"alBok","da02815e4f9844ed":"74J2w","6b133fd6cb107dbd":"8rZez","17287a672cc32134":"W6tOq","6d55363392a5d528":"ae332"}],"etJ5t":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("e73e61ddefb47791");
var createSafeContext = require("73378208251c9bcf");
require("50f78eaa80610ed7");
require("65474179600c5d29");
require("826504959bdb0bd8");
require("d7c081957cd13927");
require("aefbdaee5b785a64");
require("7d1bed0cc94b0b9f");
require("8a6f30b35786255e");
require("c4ae6a0e4d9c03e7");
require("1aea2ffcea883a73");
require("a9c8e3fe8d7528a5");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Combobox component was not found in tree"), 2), ComboboxProvider = _createSafeContext_createSafeContext[0], useComboboxContext = _createSafeContext_createSafeContext[1];
exports.ComboboxProvider = ComboboxProvider;
exports.useComboboxContext = useComboboxContext; //# sourceMappingURL=Combobox.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","e73e61ddefb47791":"9MtAM","73378208251c9bcf":"8srze","50f78eaa80610ed7":"iKGFf","65474179600c5d29":"9HEEB","826504959bdb0bd8":"8QFOC","d7c081957cd13927":"2FdJg","aefbdaee5b785a64":"6AMGA","7d1bed0cc94b0b9f":"erSvz","8a6f30b35786255e":"kqQOF","c4ae6a0e4d9c03e7":"8YP4O","1aea2ffcea883a73":"gkGXc","a9c8e3fe8d7528a5":"2onWA"}],"4Z9pV":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("5ea09c0672f2a420");
var React = require("35c815d905f77325");
var Input = require("160c8c048dfb3729");
require("324ffa80d7d12738");
require("52d5c6ff0559eb42");
require("a69ff8552547045");
require("9fec8bc0277eba90");
require("243440ccb9f45e76");
require("d9e936834633c469");
require("93f05458bb79f546");
require("3d46bc66b1cf5346");
require("d7803d23e4351448");
require("14fdd87a5e474086");
require("e1673b1a751a5afc");
require("b489724789112138");
require("14cb34cf42153c50");
require("7519c62caa06458e");
require("82114410c363118e");
require("95fe69f67758d639");
var ComboboxClearButton = React.forwardRef(function(_param, ref) {
    var size = _param.size, onMouseDown = _param.onMouseDown, onClick = _param.onClick, onClear = _param.onClear, others = (0, _objectWithoutProperties._)(_param, [
        "size",
        "onMouseDown",
        "onClick",
        "onClear"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Input.Input.ClearButton, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        tabIndex: -1,
        "aria-hidden": true
    }, others), {
        onMouseDown: function(event) {
            event.preventDefault();
            onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
        },
        onClick: function(event) {
            onClear();
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        }
    }));
});
ComboboxClearButton.displayName = "@mantine/core/ComboboxClearButton";
exports.ComboboxClearButton = ComboboxClearButton; //# sourceMappingURL=ComboboxClearButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","5ea09c0672f2a420":"iKGFf","35c815d905f77325":"9MtAM","160c8c048dfb3729":"dkUgf","324ffa80d7d12738":"j4uTK","52d5c6ff0559eb42":"7nO1x","a69ff8552547045":"3Bda4","9fec8bc0277eba90":"gQBOr","243440ccb9f45e76":"lRBdM","d9e936834633c469":"hxtex","93f05458bb79f546":"9HEEB","3d46bc66b1cf5346":"8QFOC","d7803d23e4351448":"2FdJg","14fdd87a5e474086":"6AMGA","e1673b1a751a5afc":"erSvz","b489724789112138":"kqQOF","14cb34cf42153c50":"8YP4O","7519c62caa06458e":"gkGXc","82114410c363118e":"2onWA","95fe69f67758d639":"lQt5D"}],"4ROIf":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("de594f1672da672f");
require("e7665f153a17ed6f");
require("6abb175da7ac980d");
require("cfd596430ba0c625");
require("d84081e1c898730a");
require("8baf0379d93d1bbd");
require("2c0cb7d7de4177d3");
require("1656008207c7f2da");
var useProps = require("2f0eba8bbcfa24ee");
require("fae0522fdf19d60");
require("1131a8ee13792fff");
var factory = require("80fbae29a790cc41");
require("eb917769e2445223");
var Popover = require("ecf3cadd0859b0ff");
require("f9627dfb4b7265a9");
require("aeb6be35534c700f");
var Combobox_context = require("2e4dfab753cb455");
var Combobox_module = require("943dd821d38b945c");
var defaultProps = {};
var ComboboxDropdown = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxDropdown", defaultProps, props), classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, className = _useProps_useProps.className, style = _useProps_useProps.style, hidden = _useProps_useProps.hidden, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "styles",
        "className",
        "style",
        "hidden"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Dropdown, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref,
        role: "presentation",
        "data-hidden": hidden || void 0
    }), ctx.getStyles("dropdown", {
        className,
        style,
        classNames,
        styles
    })));
});
ComboboxDropdown.classes = Combobox_module;
ComboboxDropdown.displayName = "@mantine/core/ComboboxDropdown";
exports.ComboboxDropdown = ComboboxDropdown; //# sourceMappingURL=ComboboxDropdown.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","de594f1672da672f":"iKGFf","e7665f153a17ed6f":"9MtAM","6abb175da7ac980d":"9HEEB","cfd596430ba0c625":"8QFOC","d84081e1c898730a":"2FdJg","8baf0379d93d1bbd":"6AMGA","2c0cb7d7de4177d3":"erSvz","1656008207c7f2da":"kqQOF","2f0eba8bbcfa24ee":"iivvn","fae0522fdf19d60":"8YP4O","1131a8ee13792fff":"gkGXc","80fbae29a790cc41":"guLFz","eb917769e2445223":"2onWA","ecf3cadd0859b0ff":"4oc3k","f9627dfb4b7265a9":"b7S6t","aeb6be35534c700f":"iz4SD","2e4dfab753cb455":"etJ5t","943dd821d38b945c":"ae332"}],"ceCGy":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("457540e7591c05de");
var isElement = require("9e149ccef11b2018");
require("9d5190ecc9a918af");
require("6c20a62dde49c7d2");
require("38ab63aa1a15ca3c");
require("9961b6bfba82935b");
require("cf6cd9f3ce6558ae");
require("3f9d025728a926c0");
require("f8c34198a3865705");
var useProps = require("b5825227c91ca5a4");
require("ff40055a049a1767");
require("991628b7b3079e3a");
var factory = require("4008faf66db3d7dc");
require("f522de8a42e9587a");
var Popover = require("c96c6263b586ff8b");
require("c1ebff363cf52b63");
require("808d5a6347d0e866");
var Combobox_context = require("fd53c1dbb7375333");
var defaultProps = {
    refProp: "ref"
};
var ComboboxDropdownTarget = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxDropdownTarget", defaultProps, props), children = _useProps_useProps.children, refProp = _useProps_useProps.refProp;
    Combobox_context.useComboboxContext();
    if (!isElement.isElement(children)) throw new Error("Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    return /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Target, {
        ref,
        refProp,
        children
    });
});
ComboboxDropdownTarget.displayName = "@mantine/core/ComboboxDropdownTarget";
exports.ComboboxDropdownTarget = ComboboxDropdownTarget; //# sourceMappingURL=ComboboxDropdownTarget.cjs.map

},{"457540e7591c05de":"iKGFf","9e149ccef11b2018":"193o0","9d5190ecc9a918af":"9MtAM","6c20a62dde49c7d2":"9HEEB","38ab63aa1a15ca3c":"8QFOC","9961b6bfba82935b":"2FdJg","cf6cd9f3ce6558ae":"6AMGA","3f9d025728a926c0":"erSvz","f8c34198a3865705":"kqQOF","b5825227c91ca5a4":"iivvn","ff40055a049a1767":"8YP4O","991628b7b3079e3a":"gkGXc","4008faf66db3d7dc":"guLFz","f522de8a42e9587a":"2onWA","c96c6263b586ff8b":"4oc3k","c1ebff363cf52b63":"b7S6t","808d5a6347d0e866":"iz4SD","fd53c1dbb7375333":"etJ5t"}],"iyoTe":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("91d0f7e81db7c546");
require("656b3f1a47965c65");
require("36f314d77057e13d");
require("f5dd7847a6189348");
require("e5bc7708bbff9a2a");
require("139ef44e8f6c01e6");
require("55e07ed850d81595");
require("9561c6badb7b5c31");
var useProps = require("3f0cbb063b84cca4");
require("9c35305bceceb3d7");
var Box = require("e31cec0f0c85e26a");
var factory = require("8701d5aba2efe534");
require("f0ab8eac6f6b1ece");
var Combobox_context = require("46e1bc140d401087");
var Combobox_module = require("692dc75d2bab2b74");
var defaultProps = {};
var ComboboxEmpty = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxEmpty", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("empty", {
        className,
        classNames,
        styles,
        style
    }), others));
});
ComboboxEmpty.classes = Combobox_module;
ComboboxEmpty.displayName = "@mantine/core/ComboboxEmpty";
exports.ComboboxEmpty = ComboboxEmpty; //# sourceMappingURL=ComboboxEmpty.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","91d0f7e81db7c546":"iKGFf","656b3f1a47965c65":"9MtAM","36f314d77057e13d":"9HEEB","f5dd7847a6189348":"8QFOC","e5bc7708bbff9a2a":"2FdJg","139ef44e8f6c01e6":"6AMGA","55e07ed850d81595":"erSvz","9561c6badb7b5c31":"kqQOF","3f0cbb063b84cca4":"iivvn","9c35305bceceb3d7":"8YP4O","e31cec0f0c85e26a":"gkGXc","8701d5aba2efe534":"guLFz","f0ab8eac6f6b1ece":"2onWA","46e1bc140d401087":"etJ5t","692dc75d2bab2b74":"ae332"}],"8omXP":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var React = require("c1248f89c5ea43cb");
var hooks = require("704ccdf2618d668e");
var isElement = require("7b038ccdaddef922");
require("390ac3caf61de9d3");
var getRefProp = require("fbc8fcb7b7963eca");
require("7a503af44296e465");
require("a5ffc79ce9a7d167");
require("354d1ac2da51e615");
require("a7276028b8b85d5a");
require("904ae97446118e67");
var useProps = require("3d1d280dc4749068");
require("d92bf02339232147");
require("cb4e576403f1e5fb");
var factory = require("c53d63819115cea4");
require("eb9d4586e2628580");
var Combobox_context = require("ace3e1c5625193c5");
var useComboboxTargetProps = require("878dc98166653b36");
var defaultProps = {
    refProp: "ref",
    targetType: "input",
    withKeyboardNavigation: true,
    withAriaAttributes: true,
    withExpandedAttribute: false,
    autoComplete: "off"
};
var ComboboxEventsTarget = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxEventsTarget", defaultProps, props), children = _useProps_useProps.children, refProp = _useProps_useProps.refProp, withKeyboardNavigation = _useProps_useProps.withKeyboardNavigation, withAriaAttributes = _useProps_useProps.withAriaAttributes, withExpandedAttribute = _useProps_useProps.withExpandedAttribute, targetType = _useProps_useProps.targetType, autoComplete = _useProps_useProps.autoComplete, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "refProp",
        "withKeyboardNavigation",
        "withAriaAttributes",
        "withExpandedAttribute",
        "targetType",
        "autoComplete"
    ]);
    if (!isElement.isElement(children)) throw new Error("Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    var ctx = Combobox_context.useComboboxContext();
    var targetProps = useComboboxTargetProps.useComboboxTargetProps({
        targetType,
        withAriaAttributes,
        withKeyboardNavigation,
        withExpandedAttribute,
        onKeyDown: children.props.onKeyDown,
        autoComplete
    });
    return React.cloneElement(children, (0, _objectSpreadProps._)((0, _objectSpread._)({}, targetProps, others), {
        [refProp]: hooks.useMergedRef(ref, ctx.store.targetRef, getRefProp.getRefProp(children))
    }));
});
ComboboxEventsTarget.displayName = "@mantine/core/ComboboxEventsTarget";
exports.ComboboxEventsTarget = ComboboxEventsTarget; //# sourceMappingURL=ComboboxEventsTarget.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c1248f89c5ea43cb":"9MtAM","704ccdf2618d668e":"9HEEB","7b038ccdaddef922":"193o0","390ac3caf61de9d3":"iKGFf","fbc8fcb7b7963eca":"e829F","7a503af44296e465":"8QFOC","a5ffc79ce9a7d167":"2FdJg","354d1ac2da51e615":"6AMGA","a7276028b8b85d5a":"erSvz","904ae97446118e67":"kqQOF","3d1d280dc4749068":"iivvn","d92bf02339232147":"8YP4O","cb4e576403f1e5fb":"gkGXc","c53d63819115cea4":"guLFz","eb9d4586e2628580":"2onWA","ace3e1c5625193c5":"etJ5t","878dc98166653b36":"9tqgj"}],"9tqgj":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("a9c0b25ee33863b9");
var Combobox_context = require("4ec7051cc6d317c8");
function useComboboxTargetProps(param) {
    var onKeyDown = param.onKeyDown, withKeyboardNavigation = param.withKeyboardNavigation, withAriaAttributes = param.withAriaAttributes, withExpandedAttribute = param.withExpandedAttribute, targetType = param.targetType, autoComplete = param.autoComplete;
    var ctx = Combobox_context.useComboboxContext();
    var _React_useState = (0, _slicedToArray._)(React.useState(null), 2), selectedOptionId = _React_useState[0], setSelectedOptionId = _React_useState[1];
    var handleKeyDown = function(event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (ctx.readOnly) return;
        if (withKeyboardNavigation) {
            if (event.nativeEvent.isComposing) return;
            if (event.nativeEvent.code === "ArrowDown") {
                event.preventDefault();
                if (!ctx.store.dropdownOpened) {
                    ctx.store.openDropdown("keyboard");
                    setSelectedOptionId(ctx.store.selectActiveOption());
                    ctx.store.updateSelectedOptionIndex("selected", {
                        scrollIntoView: true
                    });
                } else setSelectedOptionId(ctx.store.selectNextOption());
            }
            if (event.nativeEvent.code === "ArrowUp") {
                event.preventDefault();
                if (!ctx.store.dropdownOpened) {
                    ctx.store.openDropdown("keyboard");
                    setSelectedOptionId(ctx.store.selectActiveOption());
                    ctx.store.updateSelectedOptionIndex("selected", {
                        scrollIntoView: true
                    });
                } else setSelectedOptionId(ctx.store.selectPreviousOption());
            }
            if (event.nativeEvent.code === "Enter" || event.nativeEvent.code === "NumpadEnter") {
                if (event.nativeEvent.keyCode === 229) return;
                var selectedOptionIndex = ctx.store.getSelectedOptionIndex();
                if (ctx.store.dropdownOpened && selectedOptionIndex !== -1) {
                    event.preventDefault();
                    ctx.store.clickSelectedOption();
                } else if (targetType === "button") {
                    event.preventDefault();
                    ctx.store.openDropdown("keyboard");
                }
            }
            if (event.key === "Escape") ctx.store.closeDropdown("keyboard");
            if (event.nativeEvent.code === "Space") {
                if (targetType === "button") {
                    event.preventDefault();
                    ctx.store.toggleDropdown("keyboard");
                }
            }
        }
    };
    var ariaAttributes = withAriaAttributes ? {
        "aria-haspopup": "listbox",
        "aria-expanded": withExpandedAttribute && !!(ctx.store.listId && ctx.store.dropdownOpened) || void 0,
        "aria-controls": ctx.store.dropdownOpened ? ctx.store.listId : void 0,
        "aria-activedescendant": ctx.store.dropdownOpened ? selectedOptionId || void 0 : void 0,
        autoComplete,
        "data-expanded": ctx.store.dropdownOpened || void 0,
        "data-mantine-stop-propagation": ctx.store.dropdownOpened || void 0
    } : {};
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, ariaAttributes), {
        onKeyDown: handleKeyDown
    });
}
exports.useComboboxTargetProps = useComboboxTargetProps; //# sourceMappingURL=use-combobox-target-props.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","a9c0b25ee33863b9":"9MtAM","4ec7051cc6d317c8":"etJ5t"}],"3ZaWl":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a0ae940ad990225d");
require("4ec08b67417b1c03");
require("ad39d50218c79db7");
require("88a8770f61e2d080");
require("bf17c54336eb55ea");
require("b50b1103d245693c");
require("826197b912d70fef");
require("482d1489547a0984");
var useProps = require("9a9e28c99eeef07b");
require("1de94c86ec6d7ddf");
var Box = require("cf98ef3a805e9f27");
var factory = require("cd657d31c270fef1");
require("3ee67a40162a1ebe");
var Combobox_context = require("8ab2d57febf498b8");
var Combobox_module = require("91c1a00272517fb9");
var defaultProps = {};
var ComboboxFooter = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxFooter", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, ctx.getStyles("footer", {
        className,
        classNames,
        style,
        styles
    }), others), {
        onMouseDown: function(event) {
            event.preventDefault();
        }
    }));
});
ComboboxFooter.classes = Combobox_module;
ComboboxFooter.displayName = "@mantine/core/ComboboxFooter";
exports.ComboboxFooter = ComboboxFooter; //# sourceMappingURL=ComboboxFooter.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","a0ae940ad990225d":"iKGFf","4ec08b67417b1c03":"9MtAM","ad39d50218c79db7":"9HEEB","88a8770f61e2d080":"8QFOC","bf17c54336eb55ea":"2FdJg","b50b1103d245693c":"6AMGA","826197b912d70fef":"erSvz","482d1489547a0984":"kqQOF","9a9e28c99eeef07b":"iivvn","1de94c86ec6d7ddf":"8YP4O","cf98ef3a805e9f27":"gkGXc","cd657d31c270fef1":"guLFz","3ee67a40162a1ebe":"2onWA","8ab2d57febf498b8":"etJ5t","91c1a00272517fb9":"ae332"}],"1dzCw":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b5b3caaeac65028c");
require("6df46adc0ca00461");
require("f202d12ee71bd72");
require("c92e93021defd795");
require("22569e28299f478c");
require("ea926c080a2840ad");
require("92e97064c20789df");
require("b89aaae4e84ccfc1");
var useProps = require("18cea969867167ba");
require("77209d90d5f7d5f4");
var Box = require("830725e12975fdd7");
var factory = require("c5e0a002677cf98");
require("f65f51ac1a690cc0");
var Combobox_context = require("9e5b8d6a548f7e1e");
var Combobox_module = require("525f70efce746111");
var defaultProps = {};
var ComboboxGroup = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxGroup", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, children = _useProps_useProps.children, label = _useProps_useProps.label, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "children",
        "label"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, ctx.getStyles("group", {
        className,
        classNames,
        style,
        styles
    }), others), {
        children: [
            label && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("groupLabel", {
                classNames,
                styles
            })), {
                children: label
            })),
            children
        ]
    }));
});
ComboboxGroup.classes = Combobox_module;
ComboboxGroup.displayName = "@mantine/core/ComboboxGroup";
exports.ComboboxGroup = ComboboxGroup; //# sourceMappingURL=ComboboxGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","b5b3caaeac65028c":"iKGFf","6df46adc0ca00461":"9MtAM","f202d12ee71bd72":"9HEEB","c92e93021defd795":"8QFOC","22569e28299f478c":"2FdJg","ea926c080a2840ad":"6AMGA","92e97064c20789df":"erSvz","b89aaae4e84ccfc1":"kqQOF","18cea969867167ba":"iivvn","77209d90d5f7d5f4":"8YP4O","830725e12975fdd7":"gkGXc","c5e0a002677cf98":"guLFz","f65f51ac1a690cc0":"2onWA","9e5b8d6a548f7e1e":"etJ5t","525f70efce746111":"ae332"}],"9a8Lj":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("73b37aeadf83b50e");
require("95852a8c2d5460b");
require("2c375bdc0967cd99");
require("8f4bd6359762fc00");
require("d7046274a85f6f82");
require("42b2f131f441f235");
require("7b42fe837e7455bd");
require("13154bb29ff7e71f");
var useProps = require("1682c1463dcddae5");
require("7dae69feb0f5744e");
var Box = require("929b581286dcdf3b");
var factory = require("b070e8eb21569129");
require("5deeffe7a3595cf1");
var Combobox_context = require("78523896ec745690");
var Combobox_module = require("3f5e163b201198dc");
var defaultProps = {};
var ComboboxHeader = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxHeader", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, ctx.getStyles("header", {
        className,
        classNames,
        style,
        styles
    }), others), {
        onMouseDown: function(event) {
            event.preventDefault();
        }
    }));
});
ComboboxHeader.classes = Combobox_module;
ComboboxHeader.displayName = "@mantine/core/ComboboxHeader";
exports.ComboboxHeader = ComboboxHeader; //# sourceMappingURL=ComboboxHeader.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","73b37aeadf83b50e":"iKGFf","95852a8c2d5460b":"9MtAM","2c375bdc0967cd99":"9HEEB","8f4bd6359762fc00":"8QFOC","d7046274a85f6f82":"2FdJg","42b2f131f441f235":"6AMGA","7b42fe837e7455bd":"erSvz","13154bb29ff7e71f":"kqQOF","1682c1463dcddae5":"iivvn","7dae69feb0f5744e":"8YP4O","929b581286dcdf3b":"gkGXc","b070e8eb21569129":"guLFz","5deeffe7a3595cf1":"2onWA","78523896ec745690":"etJ5t","3f5e163b201198dc":"ae332"}],"8RMJf":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("588a5cd674ecb85d");
function ComboboxHiddenInput(_param) {
    var value = _param.value, _param_valuesDivider = _param.valuesDivider, valuesDivider = _param_valuesDivider === void 0 ? "," : _param_valuesDivider, others = (0, _objectWithoutProperties._)(_param, [
        "value",
        "valuesDivider"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)({
        type: "hidden",
        value: Array.isArray(value) ? value.join(valuesDivider) : value || ""
    }, others));
}
ComboboxHiddenInput.displayName = "@mantine/core/ComboboxHiddenInput";
exports.ComboboxHiddenInput = ComboboxHiddenInput; //# sourceMappingURL=ComboboxHiddenInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","588a5cd674ecb85d":"iKGFf"}],"h5QT5":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("62506aa41570e8d7");
var React = require("cded509e4d5ed73d");
require("4bee6994ea8a6661");
require("94d6e564ebd834e0");
require("8802b7852573e7cc");
require("bd5b1d1b904c67b8");
require("f5841820f1eeb54");
require("3b4ce79bc3254de7");
var useProps = require("d9bc08bcda26c0a2");
require("928d51bf3538e887");
var Box = require("74f234646ec72152");
var factory = require("b0dbff0d2bcc69d");
require("23819bd0eb6d85d5");
var Combobox_context = require("4458134f9139b58f");
var Combobox_module = require("d1f593f675568f11");
var defaultProps = {};
var ComboboxOption = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ComboboxOption", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, onClick = props.onClick, id = props.id, active = props.active, onMouseDown = props.onMouseDown, onMouseOver = props.onMouseOver, disabled = props.disabled, selected = props.selected, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "onClick",
        "id",
        "active",
        "onMouseDown",
        "onMouseOver",
        "disabled",
        "selected",
        "mod"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    var uuid = React.useId();
    var _id = id || uuid;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("option", {
        className,
        classNames,
        styles,
        style
    }), others), {
        ref,
        id: _id,
        mod: [
            "combobox-option",
            {
                "combobox-active": active,
                "combobox-disabled": disabled,
                "combobox-selected": selected
            },
            mod
        ],
        role: "option",
        onClick: function(event) {
            if (!disabled) {
                var _ctx_onOptionSubmit;
                (_ctx_onOptionSubmit = ctx.onOptionSubmit) === null || _ctx_onOptionSubmit === void 0 ? void 0 : _ctx_onOptionSubmit.call(ctx, props.value, props);
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
            } else event.preventDefault();
        },
        onMouseDown: function(event) {
            event.preventDefault();
            onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
        },
        onMouseOver: function(event) {
            if (ctx.resetSelectionOnOptionHover) ctx.store.resetSelectedOption();
            onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(event);
        }
    }));
});
ComboboxOption.classes = Combobox_module;
ComboboxOption.displayName = "@mantine/core/ComboboxOption";
exports.ComboboxOption = ComboboxOption; //# sourceMappingURL=ComboboxOption.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","62506aa41570e8d7":"iKGFf","cded509e4d5ed73d":"9MtAM","4bee6994ea8a6661":"9HEEB","94d6e564ebd834e0":"8QFOC","8802b7852573e7cc":"2FdJg","bd5b1d1b904c67b8":"6AMGA","f5841820f1eeb54":"erSvz","3b4ce79bc3254de7":"kqQOF","d9bc08bcda26c0a2":"iivvn","928d51bf3538e887":"8YP4O","74f234646ec72152":"gkGXc","b0dbff0d2bcc69d":"guLFz","23819bd0eb6d85d5":"2onWA","4458134f9139b58f":"etJ5t","d1f593f675568f11":"ae332"}],"alBok":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("19188c4d32de0b72");
var React = require("315bf3f41395aa83");
var hooks = require("2f3133350ba6b0ee");
require("1167edf43df2daa5");
require("1dd8067c5436368a");
require("7f26b6c22aba5861");
require("6c6d47ad4abe251d");
require("e67120ed3d6b5bd5");
var useProps = require("d8af08804df0744d");
require("66671ef0a2cf0818");
var Box = require("a29d44821c2edc62");
var factory = require("3c758c32d3636077");
require("f7aebf90e34d02");
var Combobox_context = require("3e6634f9569de885");
var Combobox_module = require("b2ab71d4b709bc15");
var defaultProps = {};
var ComboboxOptions = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ComboboxOptions", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, id = props.id, onMouseDown = props.onMouseDown, labelledBy = props.labelledBy, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "id",
        "onMouseDown",
        "labelledBy"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    var _id = hooks.useId(id);
    React.useEffect(function() {
        ctx.store.setListId(_id);
    }, [
        _id
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, ctx.getStyles("options", {
        className,
        style,
        classNames,
        styles
    }), others), {
        id: _id,
        role: "listbox",
        "aria-labelledby": labelledBy,
        onMouseDown: function(event) {
            event.preventDefault();
            onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
        }
    }));
});
ComboboxOptions.classes = Combobox_module;
ComboboxOptions.displayName = "@mantine/core/ComboboxOptions";
exports.ComboboxOptions = ComboboxOptions; //# sourceMappingURL=ComboboxOptions.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","19188c4d32de0b72":"iKGFf","315bf3f41395aa83":"9MtAM","2f3133350ba6b0ee":"9HEEB","1167edf43df2daa5":"8QFOC","1dd8067c5436368a":"2FdJg","7f26b6c22aba5861":"6AMGA","6c6d47ad4abe251d":"erSvz","e67120ed3d6b5bd5":"kqQOF","d8af08804df0744d":"iivvn","66671ef0a2cf0818":"8YP4O","a29d44821c2edc62":"gkGXc","3c758c32d3636077":"guLFz","f7aebf90e34d02":"2onWA","3e6634f9569de885":"etJ5t","b2ab71d4b709bc15":"ae332"}],"74J2w":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a373ec4ddcf9cbb4");
var hooks = require("57c2141d4f4f9dcd");
require("f930eb3989c61f5");
require("575a1de3f846e225");
require("4a062acfeaea59e3");
require("b3fcda57b32381c3");
require("82a60c19df2d26db");
require("83d480ca3cd42cf7");
var useProps = require("fe2c7518355ef7c2");
require("9339cac729e73a47");
require("563d156929efc5cc");
var factory = require("c6b0b91f1acf2540");
require("abfff0a37250b7bc");
var Input = require("b33de40961ffb731");
var Combobox_context = require("959e57c1a5edb283");
var useComboboxTargetProps = require("39594d6cb080b1d1");
var Combobox_module = require("49be5a9ee4210060");
var defaultProps = {
    withAriaAttributes: true,
    withKeyboardNavigation: true
};
var ComboboxSearch = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ComboboxSearch", defaultProps, _props);
    var classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, vars = props.vars, withAriaAttributes = props.withAriaAttributes, onKeyDown = props.onKeyDown, withKeyboardNavigation = props.withKeyboardNavigation, size = props.size, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "withAriaAttributes",
        "onKeyDown",
        "withKeyboardNavigation",
        "size"
    ]);
    var ctx = Combobox_context.useComboboxContext();
    var _styles = ctx.getStyles("search");
    var targetProps = useComboboxTargetProps.useComboboxTargetProps({
        targetType: "input",
        withAriaAttributes,
        withKeyboardNavigation,
        withExpandedAttribute: false,
        onKeyDown,
        autoComplete: "off"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Input.Input, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: hooks.useMergedRef(ref, ctx.store.searchRef),
        classNames: [
            {
                input: _styles.className
            },
            classNames
        ],
        styles: [
            {
                input: _styles.style
            },
            styles
        ],
        size: size || ctx.size
    }, targetProps, others), {
        __staticSelector: "Combobox"
    }));
});
ComboboxSearch.classes = Combobox_module;
ComboboxSearch.displayName = "@mantine/core/ComboboxSearch";
exports.ComboboxSearch = ComboboxSearch; //# sourceMappingURL=ComboboxSearch.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","a373ec4ddcf9cbb4":"iKGFf","57c2141d4f4f9dcd":"9HEEB","f930eb3989c61f5":"9MtAM","575a1de3f846e225":"8QFOC","4a062acfeaea59e3":"2FdJg","b3fcda57b32381c3":"6AMGA","82a60c19df2d26db":"erSvz","83d480ca3cd42cf7":"kqQOF","fe2c7518355ef7c2":"iivvn","9339cac729e73a47":"8YP4O","563d156929efc5cc":"gkGXc","c6b0b91f1acf2540":"guLFz","abfff0a37250b7bc":"2onWA","b33de40961ffb731":"dkUgf","959e57c1a5edb283":"etJ5t","39594d6cb080b1d1":"9tqgj","49be5a9ee4210060":"ae332"}],"8rZez":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("ac0fba72723f8f28");
var React = require("c9f6714f35eb95c5");
var hooks = require("6a6925137bba619a");
var isElement = require("bafc7828dc66e1fd");
require("5e1b95220b8a5fae");
require("3e3aba1d261c8a03");
require("ddd16c11448aefbc");
require("e8c9056731b4b72");
require("c5a75e1e98e5cc08");
var useProps = require("b0d5a9170608587f");
require("6262f2a31a54a2b9");
require("16e8352c3ef8b3b2");
var factory = require("783a85f65aa02c5c");
require("daca8864ef90e0f8");
var Popover = require("f90b6ec23007649f");
require("d529b59af4323c83");
require("273e5d50b0b5e16f");
var Combobox_context = require("264d63d0d56e140");
var useComboboxTargetProps = require("54a3f351d8a787d5");
var defaultProps = {
    refProp: "ref",
    targetType: "input",
    withKeyboardNavigation: true,
    withAriaAttributes: true,
    withExpandedAttribute: false,
    autoComplete: "off"
};
var ComboboxTarget = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ComboboxTarget", defaultProps, props), children = _useProps_useProps.children, refProp = _useProps_useProps.refProp, withKeyboardNavigation = _useProps_useProps.withKeyboardNavigation, withAriaAttributes = _useProps_useProps.withAriaAttributes, withExpandedAttribute = _useProps_useProps.withExpandedAttribute, targetType = _useProps_useProps.targetType, autoComplete = _useProps_useProps.autoComplete, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "refProp",
        "withKeyboardNavigation",
        "withAriaAttributes",
        "withExpandedAttribute",
        "targetType",
        "autoComplete"
    ]);
    if (!isElement.isElement(children)) throw new Error("Combobox.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    var ctx = Combobox_context.useComboboxContext();
    var targetProps = useComboboxTargetProps.useComboboxTargetProps({
        targetType,
        withAriaAttributes,
        withKeyboardNavigation,
        withExpandedAttribute,
        onKeyDown: children.props.onKeyDown,
        autoComplete
    });
    var clonedElement = React.cloneElement(children, (0, _objectSpread._)({}, targetProps, others));
    return /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Target, {
        ref: hooks.useMergedRef(ref, ctx.store.targetRef),
        children: clonedElement
    });
});
ComboboxTarget.displayName = "@mantine/core/ComboboxTarget";
exports.ComboboxTarget = ComboboxTarget; //# sourceMappingURL=ComboboxTarget.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","ac0fba72723f8f28":"iKGFf","c9f6714f35eb95c5":"9MtAM","6a6925137bba619a":"9HEEB","bafc7828dc66e1fd":"193o0","5e1b95220b8a5fae":"8QFOC","3e3aba1d261c8a03":"2FdJg","ddd16c11448aefbc":"6AMGA","e8c9056731b4b72":"erSvz","c5a75e1e98e5cc08":"kqQOF","b0d5a9170608587f":"iivvn","6262f2a31a54a2b9":"8YP4O","16e8352c3ef8b3b2":"gkGXc","783a85f65aa02c5c":"guLFz","daca8864ef90e0f8":"2onWA","f90b6ec23007649f":"4oc3k","d529b59af4323c83":"b7S6t","273e5d50b0b5e16f":"iz4SD","264d63d0d56e140":"etJ5t","54a3f351d8a787d5":"9tqgj"}],"W6tOq":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("eb84b7ab518a9c82");
var hooks = require("82747da87b9143ab");
var getIndex = require("ea718f23f04065f9");
function useCombobox() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, defaultOpened = _ref.defaultOpened, opened = _ref.opened, onOpenedChange = _ref.onOpenedChange, onDropdownClose = _ref.onDropdownClose, onDropdownOpen = _ref.onDropdownOpen, _ref_loop = _ref.loop, loop = _ref_loop === void 0 ? true : _ref_loop, _ref_scrollBehavior = _ref.scrollBehavior, scrollBehavior = _ref_scrollBehavior === void 0 ? "instant" : _ref_scrollBehavior;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onOpenedChange
    }), 2), dropdownOpened = _hooks_useUncontrolled[0], setDropdownOpened = _hooks_useUncontrolled[1];
    var listId = React.useRef(null);
    var selectedOptionIndex = React.useRef(-1);
    var searchRef = React.useRef(null);
    var targetRef = React.useRef(null);
    var focusSearchTimeout = React.useRef(-1);
    var focusTargetTimeout = React.useRef(-1);
    var selectedIndexUpdateTimeout = React.useRef(-1);
    var openDropdown = React.useCallback(function() {
        var eventSource = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "unknown";
        if (!dropdownOpened) {
            setDropdownOpened(true);
            onDropdownOpen === null || onDropdownOpen === void 0 ? void 0 : onDropdownOpen(eventSource);
        }
    }, [
        setDropdownOpened,
        onDropdownOpen,
        dropdownOpened
    ]);
    var closeDropdown = React.useCallback(function() {
        var eventSource = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "unknown";
        if (dropdownOpened) {
            setDropdownOpened(false);
            onDropdownClose === null || onDropdownClose === void 0 ? void 0 : onDropdownClose(eventSource);
        }
    }, [
        setDropdownOpened,
        onDropdownClose,
        dropdownOpened
    ]);
    var toggleDropdown = React.useCallback(function() {
        var eventSource = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "unknown";
        if (dropdownOpened) closeDropdown(eventSource);
        else openDropdown(eventSource);
    }, [
        closeDropdown,
        openDropdown,
        dropdownOpened
    ]);
    var clearSelectedItem = React.useCallback(function() {
        var selected = document.querySelector(`#${listId.current} [data-combobox-selected]`);
        selected === null || selected === void 0 ? void 0 : selected.removeAttribute("data-combobox-selected");
        selected === null || selected === void 0 ? void 0 : selected.removeAttribute("aria-selected");
    }, []);
    var selectOption = React.useCallback(function(index) {
        var list = document.getElementById(listId.current);
        var items = list === null || list === void 0 ? void 0 : list.querySelectorAll("[data-combobox-option]");
        if (!items) return null;
        var nextIndex = index >= items.length ? 0 : index < 0 ? items.length - 1 : index;
        selectedOptionIndex.current = nextIndex;
        if ((items === null || items === void 0 ? void 0 : items[nextIndex]) && !items[nextIndex].hasAttribute("data-combobox-disabled")) {
            clearSelectedItem();
            items[nextIndex].setAttribute("data-combobox-selected", "true");
            items[nextIndex].setAttribute("aria-selected", "true");
            items[nextIndex].scrollIntoView({
                block: "nearest",
                behavior: scrollBehavior
            });
            return items[nextIndex].id;
        }
        return null;
    }, [
        scrollBehavior,
        clearSelectedItem
    ]);
    var selectActiveOption = React.useCallback(function() {
        var activeOption = document.querySelector(`#${listId.current} [data-combobox-active]`);
        if (activeOption) {
            var items = document.querySelectorAll(`#${listId.current} [data-combobox-option]`);
            var index = Array.from(items).findIndex(function(option) {
                return option === activeOption;
            });
            return selectOption(index);
        }
        return selectOption(0);
    }, [
        selectOption
    ]);
    var selectNextOption = React.useCallback(function() {
        return selectOption(getIndex.getNextIndex(selectedOptionIndex.current, document.querySelectorAll(`#${listId.current} [data-combobox-option]`), loop));
    }, [
        selectOption,
        loop
    ]);
    var selectPreviousOption = React.useCallback(function() {
        return selectOption(getIndex.getPreviousIndex(selectedOptionIndex.current, document.querySelectorAll(`#${listId.current} [data-combobox-option]`), loop));
    }, [
        selectOption,
        loop
    ]);
    var selectFirstOption = React.useCallback(function() {
        return selectOption(getIndex.getFirstIndex(document.querySelectorAll(`#${listId.current} [data-combobox-option]`)));
    }, [
        selectOption
    ]);
    var updateSelectedOptionIndex = React.useCallback(function() {
        var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "selected", options = arguments.length > 1 ? arguments[1] : void 0;
        selectedIndexUpdateTimeout.current = window.setTimeout(function() {
            var _items_index;
            var items = document.querySelectorAll(`#${listId.current} [data-combobox-option]`);
            var index = Array.from(items).findIndex(function(option) {
                return option.hasAttribute(`data-combobox-${target}`);
            });
            selectedOptionIndex.current = index;
            if (options === null || options === void 0 ? void 0 : options.scrollIntoView) (_items_index = items[index]) === null || _items_index === void 0 ? void 0 : _items_index.scrollIntoView({
                block: "nearest",
                behavior: scrollBehavior
            });
        }, 0);
    }, []);
    var resetSelectedOption = React.useCallback(function() {
        selectedOptionIndex.current = -1;
        clearSelectedItem();
    }, [
        clearSelectedItem
    ]);
    var clickSelectedOption = React.useCallback(function() {
        var items = document.querySelectorAll(`#${listId.current} [data-combobox-option]`);
        var item = items === null || items === void 0 ? void 0 : items[selectedOptionIndex.current];
        item === null || item === void 0 ? void 0 : item.click();
    }, []);
    var setListId = React.useCallback(function(id) {
        listId.current = id;
    }, []);
    var focusSearchInput = React.useCallback(function() {
        focusSearchTimeout.current = window.setTimeout(function() {
            return searchRef.current.focus();
        }, 0);
    }, []);
    var focusTarget = React.useCallback(function() {
        focusTargetTimeout.current = window.setTimeout(function() {
            return targetRef.current.focus();
        }, 0);
    }, []);
    var getSelectedOptionIndex = React.useCallback(function() {
        return selectedOptionIndex.current;
    }, []);
    React.useEffect(function() {
        return function() {
            window.clearTimeout(focusSearchTimeout.current);
            window.clearTimeout(focusTargetTimeout.current);
            window.clearTimeout(selectedIndexUpdateTimeout.current);
        };
    }, []);
    return {
        dropdownOpened,
        openDropdown,
        closeDropdown,
        toggleDropdown,
        selectedOptionIndex: selectedOptionIndex.current,
        getSelectedOptionIndex,
        selectOption,
        selectFirstOption,
        selectActiveOption,
        selectNextOption,
        selectPreviousOption,
        resetSelectedOption,
        updateSelectedOptionIndex,
        listId: listId.current,
        setListId,
        clickSelectedOption,
        searchRef,
        focusSearchInput,
        targetRef,
        focusTarget
    };
}
exports.useCombobox = useCombobox; //# sourceMappingURL=use-combobox.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","eb84b7ab518a9c82":"9MtAM","82747da87b9143ab":"9HEEB","ea718f23f04065f9":"czgRv"}],"czgRv":[function(require,module,exports) {
"use client";
"use strict";
function getPreviousIndex(currentIndex, elements, loop) {
    for(var i = currentIndex - 1; i >= 0; i -= 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    if (loop) for(var i1 = elements.length - 1; i1 > -1; i1 -= 1){
        if (!elements[i1].hasAttribute("data-combobox-disabled")) return i1;
    }
    return currentIndex;
}
function getNextIndex(currentIndex, elements, loop) {
    for(var i = currentIndex + 1; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    if (loop) for(var i1 = 0; i1 < elements.length; i1 += 1){
        if (!elements[i1].hasAttribute("data-combobox-disabled")) return i1;
    }
    return currentIndex;
}
function getFirstIndex(elements) {
    for(var i = 0; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    return -1;
}
exports.getFirstIndex = getFirstIndex;
exports.getNextIndex = getNextIndex;
exports.getPreviousIndex = getPreviousIndex; //# sourceMappingURL=get-index.cjs.map

},{}],"17zEV":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("c89d5efc4ad55bdf");
var cx = require("d13e2a1cb43df104");
require("3b49212079581087");
require("f40eb43c35109e6");
var CheckIcon = require("da5a72c967669ba8");
require("d45d75d5fce63ecd");
require("52c1438d4c332898");
require("3c28ad0a977d44c8");
require("57a4595bda20e535");
var ScrollArea = require("f0f2bcb803a570");
var Combobox = require("587742f9b133e1c2");
var defaultOptionsFilter = require("1632c15c4bd46c2");
var isEmptyComboboxData = require("3ddb46ee7c47f047");
var isOptionsGroup = require("36a8d33c13be08eb");
var validateOptions = require("3993611215088a99");
var Combobox_module = require("5c74b65b558419b1");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
function isValueChecked(value, optionValue) {
    return Array.isArray(value) ? value.includes(optionValue) : value === optionValue;
}
function Option(param) {
    var data = param.data, withCheckIcon = param.withCheckIcon, value = param.value, checkIconPosition = param.checkIconPosition, unstyled = param.unstyled, renderOption = param.renderOption;
    if (!isOptionsGroup.isOptionsGroup(data)) {
        var checked = isValueChecked(value, data.value);
        var check = withCheckIcon && checked && /* @__PURE__ */ jsxRuntime.jsx(CheckIcon.CheckIcon, {
            className: Combobox_module.optionsDropdownCheckIcon
        });
        var defaultContent = /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                checkIconPosition === "left" && check,
                /* @__PURE__ */ jsxRuntime.jsx("span", {
                    children: data.label
                }),
                checkIconPosition === "right" && check
            ]
        });
        return /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Option, {
            value: data.value,
            disabled: data.disabled,
            className: cx__default.default({
                [Combobox_module.optionsDropdownOption]: !unstyled
            }),
            "data-reverse": checkIconPosition === "right" || void 0,
            "data-checked": checked || void 0,
            "aria-selected": checked,
            active: checked,
            children: typeof renderOption === "function" ? renderOption({
                option: data,
                checked
            }) : defaultContent
        });
    }
    var options = data.items.map(function(item) {
        return /* @__PURE__ */ jsxRuntime.jsx(Option, {
            data: item,
            value,
            unstyled,
            withCheckIcon,
            checkIconPosition,
            renderOption
        }, item.value);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Group, {
        label: data.group,
        children: options
    });
}
function OptionsDropdown(param) {
    var data = param.data, hidden = param.hidden, hiddenWhenEmpty = param.hiddenWhenEmpty, filter = param.filter, search = param.search, limit = param.limit, maxDropdownHeight = param.maxDropdownHeight, _param_withScrollArea = param.withScrollArea, withScrollArea = _param_withScrollArea === void 0 ? true : _param_withScrollArea, _param_filterOptions = param.filterOptions, filterOptions = _param_filterOptions === void 0 ? true : _param_filterOptions, _param_withCheckIcon = param.withCheckIcon, withCheckIcon = _param_withCheckIcon === void 0 ? false : _param_withCheckIcon, value = param.value, checkIconPosition = param.checkIconPosition, nothingFoundMessage = param.nothingFoundMessage, unstyled = param.unstyled, labelId = param.labelId, renderOption = param.renderOption, scrollAreaProps = param.scrollAreaProps, ariaLabel = param["aria-label"];
    validateOptions.validateOptions(data);
    var shouldFilter = typeof search === "string";
    var filteredData = shouldFilter ? (filter || defaultOptionsFilter.defaultOptionsFilter)({
        options: data,
        search: filterOptions ? search : "",
        limit: limit !== null && limit !== void 0 ? limit : Infinity
    }) : data;
    var isEmpty = isEmptyComboboxData.isEmptyComboboxData(filteredData);
    var options = filteredData.map(function(item) {
        return /* @__PURE__ */ jsxRuntime.jsx(Option, {
            data: item,
            withCheckIcon,
            value,
            checkIconPosition,
            unstyled,
            renderOption
        }, isOptionsGroup.isOptionsGroup(item) ? item.group : item.value);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Dropdown, {
        hidden: hidden || hiddenWhenEmpty && isEmpty,
        "data-composed": true,
        children: /* @__PURE__ */ jsxRuntime.jsxs(Combobox.Combobox.Options, {
            labelledBy: labelId,
            "aria-label": ariaLabel,
            children: [
                withScrollArea ? /* @__PURE__ */ jsxRuntime.jsx(ScrollArea.ScrollArea.Autosize, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    mah: maxDropdownHeight !== null && maxDropdownHeight !== void 0 ? maxDropdownHeight : 220,
                    type: "scroll",
                    scrollbarSize: "var(--combobox-padding)",
                    offsetScrollbars: "y"
                }, scrollAreaProps), {
                    children: options
                })) : options,
                isEmpty && nothingFoundMessage && /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Empty, {
                    children: nothingFoundMessage
                })
            ]
        })
    });
}
exports.OptionsDropdown = OptionsDropdown; //# sourceMappingURL=OptionsDropdown.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","c89d5efc4ad55bdf":"iKGFf","d13e2a1cb43df104":"8QFOC","3b49212079581087":"ey93w","f40eb43c35109e6":"01RS9","da5a72c967669ba8":"fysam","d45d75d5fce63ecd":"ahwnY","52c1438d4c332898":"jBkf8","3c28ad0a977d44c8":"jQ0Qw","57a4595bda20e535":"1sCYn","f0f2bcb803a570":"ctZfT","587742f9b133e1c2":"d1kVk","1632c15c4bd46c2":"a1fPD","3ddb46ee7c47f047":"kkEF4","36a8d33c13be08eb":"2yhqd","3993611215088a99":"aASAf","5c74b65b558419b1":"ae332"}],"ey93w":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("991509f59da0cf83");
var React = require("2a2946141ab5a160");
var hooks = require("1a008de6d1a8ef00");
var getSize = require("4d5104dfcb1af2d9");
var createVarsResolver = require("e6218d1389c7a8bc");
require("1fb4860ea31b7c83");
var parseThemeColor = require("91138b5cd1b99ec9");
var getThemeColor = require("237489cf15189046");
var getContrastColor = require("7c0cc937070eb217");
var getAutoContrastValue = require("2b264a07ba1de517");
require("fc4b24cc6ad16ab7");
require("49efdb0068de51dc");
require("341f2b1e83d1386a");
require("9a420014fcabcbc6");
var useProps = require("c6baf6667f834c33");
require("8f29ccbde1b5a4ca");
var useStyles = require("60b42c17aaa56fab");
var extractStyleProps = require("2d3d8453f0b73f0b");
var Box = require("e0725f37366fc46f");
var factory = require("82b0858c5fa7e827");
require("dc3c1a1826457886");
var InlineInput = require("ee0b3d82a44d34b1");
var CheckboxCard = require("efa797a3ee847c4d");
var CheckboxGroup_context = require("5582b89e95cf29d7");
var CheckboxGroup = require("66420f5e9f379c60");
var CheckboxIndicator = require("c0d30ae14cdaa811");
var CheckIcon = require("7d0a7aa5b6532426");
var Checkbox_module = require("c0f386013fb593b7");
var defaultProps = {
    labelPosition: "right",
    icon: CheckIcon.CheckboxIcon
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, size = param.size, iconColor = param.iconColor, variant = param.variant, autoContrast = param.autoContrast;
    var parsedColor = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme
    });
    var outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
    return {
        root: {
            "--checkbox-size": getSize.getSize(size, "checkbox-size"),
            "--checkbox-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--checkbox-color": variant === "outline" ? outlineColor : getThemeColor.getThemeColor(color, theme),
            "--checkbox-icon-color": iconColor ? getThemeColor.getThemeColor(iconColor, theme) : getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
var Checkbox = factory.factory(function(_props, forwardedRef) {
    var props = useProps.useProps("Checkbox", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, color = props.color, label = props.label, id = props.id, size = props.size, radius = props.radius, wrapperProps = props.wrapperProps, checked = props.checked, labelPosition = props.labelPosition, description = props.description, error = props.error, disabled = props.disabled, variant = props.variant, indeterminate = props.indeterminate, icon = props.icon, rootRef = props.rootRef, iconColor = props.iconColor, onChange = props.onChange, autoContrast = props.autoContrast, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "label",
        "id",
        "size",
        "radius",
        "wrapperProps",
        "checked",
        "labelPosition",
        "description",
        "error",
        "disabled",
        "variant",
        "indeterminate",
        "icon",
        "rootRef",
        "iconColor",
        "onChange",
        "autoContrast",
        "mod"
    ]);
    var ctx = CheckboxGroup_context.useCheckboxGroupContext();
    var _size = size || (ctx === null || ctx === void 0 ? void 0 : ctx.size);
    var Icon = icon;
    var getStyles = useStyles.useStyles({
        name: "Checkbox",
        props,
        classes: Checkbox_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var uuid = hooks.useId(id);
    var contextProps = ctx ? {
        checked: ctx.value.includes(rest.value),
        onChange: function(event) {
            ctx.onChange(event);
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        }
    } : {};
    var fallbackRef = React.useRef(null);
    var ref = forwardedRef || fallbackRef;
    React.useEffect(function() {
        if (ref && "current" in ref && ref.current) ref.current.indeterminate = indeterminate || false;
    }, [
        indeterminate,
        ref
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(InlineInput.InlineInput, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        __staticSelector: "Checkbox",
        __stylesApiProps: props,
        id: uuid,
        size: _size,
        labelPosition,
        label,
        description,
        error,
        disabled,
        classNames,
        styles,
        unstyled,
        "data-checked": contextProps.checked || checked || void 0,
        variant,
        ref: rootRef,
        mod
    }), styleProps, wrapperProps), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("inner")), {
            mod: {
                "data-label-position": labelPosition
            },
            children: [
                /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                    component: "input",
                    id: uuid,
                    ref,
                    checked,
                    disabled,
                    mod: {
                        error: !!error,
                        indeterminate
                    }
                }, getStyles("input", {
                    focusable: true,
                    variant
                })), {
                    onChange
                }), rest, contextProps), {
                    type: "checkbox"
                })),
                /* @__PURE__ */ jsxRuntime.jsx(Icon, (0, _objectSpread._)({
                    indeterminate
                }, getStyles("icon")))
            ]
        }))
    }));
});
Checkbox.classes = (0, _objectSpread._)({}, Checkbox_module, InlineInput.InlineInputClasses);
Checkbox.displayName = "@mantine/core/Checkbox";
Checkbox.Group = CheckboxGroup.CheckboxGroup;
Checkbox.Indicator = CheckboxIndicator.CheckboxIndicator;
Checkbox.Card = CheckboxCard.CheckboxCard;
exports.Checkbox = Checkbox; //# sourceMappingURL=Checkbox.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","991509f59da0cf83":"iKGFf","2a2946141ab5a160":"9MtAM","1a008de6d1a8ef00":"9HEEB","4d5104dfcb1af2d9":"kEFEY","e6218d1389c7a8bc":"hIQE6","1fb4860ea31b7c83":"8QFOC","91138b5cd1b99ec9":"ctp80","237489cf15189046":"eeaIN","7c0cc937070eb217":"ez6cW","2b264a07ba1de517":"cN4dA","fc4b24cc6ad16ab7":"2FdJg","49efdb0068de51dc":"6AMGA","341f2b1e83d1386a":"erSvz","9a420014fcabcbc6":"kqQOF","c6baf6667f834c33":"iivvn","8f29ccbde1b5a4ca":"8YP4O","60b42c17aaa56fab":"d0sAY","2d3d8453f0b73f0b":"6L93n","e0725f37366fc46f":"gkGXc","82b0858c5fa7e827":"guLFz","dc3c1a1826457886":"2onWA","ee0b3d82a44d34b1":"b2ROK","efa797a3ee847c4d":"jBkf8","5582b89e95cf29d7":"1sCYn","66420f5e9f379c60":"01RS9","c0d30ae14cdaa811":"ahwnY","7d0a7aa5b6532426":"fysam","c0f386013fb593b7":"27jht"}],"b2ROK":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3258d3b5caf017dd");
var React = require("6442ec1236c2a400");
var getSize = require("d7b280dc33b93f2a");
require("fe56b7587a94cad7");
require("c46b3c2ff79d0f94");
require("91cebe17bfbe45f3");
require("7b297d4f84bda660");
require("6f50e2295a1dcb3a");
require("160265b39e442551");
require("c9500dec4afa2986");
var useStyles = require("6280b0ffabd473c4");
var Box = require("f61db69f0317b178");
require("d29678cfbe42adf8");
var Input = require("f45449bea8352c02");
require("4ea732cb32a6f9fe");
require("e6ee6f7ccf7d7219");
require("d3ad86769edbefe7");
require("2b77969302acfa78");
require("8cf92a1e317001ed");
require("5fa4f39ec35793bd");
require("b3b7a29d9ac4b538");
var InlineInput_module = require("2a54605b455a0879");
var InlineInputClasses = InlineInput_module;
var InlineInput = React.forwardRef(function(_param, ref) {
    var __staticSelector = _param.__staticSelector, __stylesApiProps = _param.__stylesApiProps, className = _param.className, classNames = _param.classNames, styles = _param.styles, unstyled = _param.unstyled, children = _param.children, label = _param.label, description = _param.description, id = _param.id, disabled = _param.disabled, error = _param.error, size = _param.size, _param_labelPosition = _param.labelPosition, labelPosition = _param_labelPosition === void 0 ? "left" : _param_labelPosition, _param_bodyElement = _param.bodyElement, bodyElement = _param_bodyElement === void 0 ? "div" : _param_bodyElement, _param_labelElement = _param.labelElement, labelElement = _param_labelElement === void 0 ? "label" : _param_labelElement, variant = _param.variant, style = _param.style, vars = _param.vars, mod = _param.mod, others = (0, _objectWithoutProperties._)(_param, [
        "__staticSelector",
        "__stylesApiProps",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "children",
        "label",
        "description",
        "id",
        "disabled",
        "error",
        "size",
        "labelPosition",
        "bodyElement",
        "labelElement",
        "variant",
        "style",
        "vars",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: __staticSelector,
        props: __stylesApiProps,
        className,
        style,
        classes: InlineInput_module,
        classNames,
        styles,
        unstyled
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        ref,
        __vars: {
            "--label-fz": getSize.getFontSize(size),
            "--label-lh": getSize.getSize(size, "label-lh")
        },
        mod: [
            {
                "label-position": labelPosition
            },
            mod
        ],
        variant,
        size
    }), others), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
            component: bodyElement,
            htmlFor: bodyElement === "label" ? id : void 0
        }, getStyles("body")), {
            children: [
                children,
                /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("labelWrapper")), {
                    "data-disabled": disabled || void 0,
                    children: [
                        label && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                            component: labelElement,
                            htmlFor: labelElement === "label" ? id : void 0
                        }, getStyles("label")), {
                            "data-disabled": disabled || void 0,
                            children: label
                        })),
                        description && /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Description, (0, _objectSpreadProps._)((0, _objectSpread._)({
                            size,
                            __inheritStyles: false
                        }, getStyles("description")), {
                            children: description
                        })),
                        error && typeof error !== "boolean" && /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Error, (0, _objectSpreadProps._)((0, _objectSpread._)({
                            size,
                            __inheritStyles: false
                        }, getStyles("error")), {
                            children: error
                        }))
                    ]
                }))
            ]
        }))
    }));
});
InlineInput.displayName = "@mantine/core/InlineInput";
exports.InlineInput = InlineInput;
exports.InlineInputClasses = InlineInputClasses; //# sourceMappingURL=InlineInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","3258d3b5caf017dd":"iKGFf","6442ec1236c2a400":"9MtAM","d7b280dc33b93f2a":"kEFEY","fe56b7587a94cad7":"9HEEB","c46b3c2ff79d0f94":"8QFOC","91cebe17bfbe45f3":"2FdJg","7b297d4f84bda660":"6AMGA","6f50e2295a1dcb3a":"erSvz","160265b39e442551":"kqQOF","c9500dec4afa2986":"8YP4O","6280b0ffabd473c4":"d0sAY","f61db69f0317b178":"gkGXc","d29678cfbe42adf8":"2onWA","f45449bea8352c02":"dkUgf","4ea732cb32a6f9fe":"j4uTK","e6ee6f7ccf7d7219":"7nO1x","d3ad86769edbefe7":"3Bda4","2b77969302acfa78":"gQBOr","8cf92a1e317001ed":"lRBdM","5fa4f39ec35793bd":"hxtex","b3b7a29d9ac4b538":"lQt5D","2a54605b455a0879":"4O3YL"}],"4O3YL":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_5f75b09e",
    "body": "m_5f6e695e",
    "labelWrapper": "m_d3ea56bb",
    "label": "m_8ee546b8",
    "description": "m_328f68c0",
    "error": "m_8e8a99cc"
};
module.exports = classes; //# sourceMappingURL=InlineInput.module.css.cjs.map

},{}],"jBkf8":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("babc4acdda462eda");
var hooks = require("3df27c5e907590d1");
require("38b3c362da479666");
var getSize = require("e93970a7752d45e5");
var createVarsResolver = require("2c2aed899a3d2729");
require("755bcce342a24c59");
require("87684cd93574f8a7");
require("ec1df3001d295399");
require("d74b2037212a5cb1");
require("383eceedcc22f959");
var useProps = require("84426dc28ab274bc");
require("621c171a098c2ed7");
var useStyles = require("eda13ac9f588f92d");
require("a4bf9940329d12e8");
var factory = require("9efb2bcd1e03b7bc");
require("363c6bb679ad9eda");
var UnstyledButton = require("49dd50a776536f6f");
var CheckboxGroup_context = require("dd6f715804df2ad5");
var CheckboxCard_context = require("1389c2c295fc2c60");
var CheckboxCard_module = require("e1f454b928b907d3");
var defaultProps = {
    withBorder: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius;
    return {
        card: {
            "--card-radius": getSize.getRadius(radius)
        }
    };
});
var CheckboxCard = factory.factory(function(_props, ref) {
    var props = useProps.useProps("CheckboxCard", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, checked = props.checked, mod = props.mod, withBorder = props.withBorder, value = props.value, onClick = props.onClick, defaultChecked = props.defaultChecked, onChange = props.onChange, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "checked",
        "mod",
        "withBorder",
        "value",
        "onClick",
        "defaultChecked",
        "onChange"
    ]);
    var getStyles = useStyles.useStyles({
        name: "CheckboxCard",
        classes: CheckboxCard_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "card"
    });
    var ctx = CheckboxGroup_context.useCheckboxGroupContext();
    var _checked = typeof checked === "boolean" ? checked : ctx ? ctx.value.includes(value || "") : void 0;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: _checked,
        defaultValue: defaultChecked,
        finalValue: false,
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    return /* @__PURE__ */ jsxRuntime.jsx(CheckboxCard_context.CheckboxCardProvider, {
        value: {
            checked: _value
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref,
            mod: [
                {
                    "with-border": withBorder,
                    checked: _value
                },
                mod
            ]
        }, getStyles("card"), others), {
            role: "checkbox",
            "aria-checked": _value,
            onClick: function(event) {
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
                ctx === null || ctx === void 0 ? void 0 : ctx.onChange(value || "");
                setValue(!_value);
            }
        }))
    });
});
CheckboxCard.displayName = "@mantine/core/CheckboxCard";
CheckboxCard.classes = CheckboxCard_module;
exports.CheckboxCard = CheckboxCard; //# sourceMappingURL=CheckboxCard.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","babc4acdda462eda":"iKGFf","3df27c5e907590d1":"9HEEB","38b3c362da479666":"9MtAM","e93970a7752d45e5":"kEFEY","2c2aed899a3d2729":"hIQE6","755bcce342a24c59":"8QFOC","87684cd93574f8a7":"2FdJg","ec1df3001d295399":"6AMGA","d74b2037212a5cb1":"erSvz","383eceedcc22f959":"kqQOF","84426dc28ab274bc":"iivvn","621c171a098c2ed7":"8YP4O","eda13ac9f588f92d":"d0sAY","a4bf9940329d12e8":"gkGXc","9efb2bcd1e03b7bc":"guLFz","363c6bb679ad9eda":"2onWA","49dd50a776536f6f":"cArqr","dd6f715804df2ad5":"1sCYn","1389c2c295fc2c60":"jQ0Qw","e1f454b928b907d3":"1aZOX"}],"1sCYn":[function(require,module,exports) {
"use client";
"use strict";
var React = require("b1ecd8d87d75f5c");
var CheckboxGroupContext = React.createContext(null);
var CheckboxGroupProvider = CheckboxGroupContext.Provider;
var useCheckboxGroupContext = function() {
    return React.useContext(CheckboxGroupContext);
};
exports.CheckboxGroupProvider = CheckboxGroupProvider;
exports.useCheckboxGroupContext = useCheckboxGroupContext; //# sourceMappingURL=CheckboxGroup.context.cjs.map

},{"b1ecd8d87d75f5c":"9MtAM"}],"jQ0Qw":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("dd450a1782a56aa6");
require("2b8e6043f6457d5");
var createOptionalContext = require("6c5bcba1d5a0bea");
require("fa7d106eacf7d905");
require("87c7a9bf6e22bb13");
require("5cd6ddd9a5614f9b");
require("5d1ebf955b808fb2");
require("7066dfdf04489889");
require("58adb5914e4f6faf");
require("b5a636522420df16");
require("dfa5974d7d4ac20b");
require("9cb852b20da82e82");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), CheckboxCardProvider = _createOptionalContext_createOptionalContext[0], useCheckboxCardContext = _createOptionalContext_createOptionalContext[1];
exports.CheckboxCardProvider = CheckboxCardProvider;
exports.useCheckboxCardContext = useCheckboxCardContext; //# sourceMappingURL=CheckboxCard.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","dd450a1782a56aa6":"9MtAM","2b8e6043f6457d5":"iKGFf","6c5bcba1d5a0bea":"7cMAR","fa7d106eacf7d905":"9HEEB","87c7a9bf6e22bb13":"8QFOC","5cd6ddd9a5614f9b":"2FdJg","5d1ebf955b808fb2":"6AMGA","7066dfdf04489889":"erSvz","58adb5914e4f6faf":"kqQOF","b5a636522420df16":"8YP4O","dfa5974d7d4ac20b":"gkGXc","9cb852b20da82e82":"2onWA"}],"1aZOX":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "card": "m_26775b0a"
};
module.exports = classes; //# sourceMappingURL=CheckboxCard.module.css.cjs.map

},{}],"01RS9":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("58c5cd9359bdac4a");
var hooks = require("2420bb087f841f82");
require("f969776f06286707");
require("e7f9801b29684717");
require("6a4b0c586ce4ea04");
require("cf09cd510eef2491");
require("817502a9218433b7");
require("fda56ac64a1903ab");
var useProps = require("41f6010d1a71d224");
require("991706a5bbb94da1");
require("1aeec611ea454f2c");
var factory = require("9772b840ba130a4d");
require("2ef04e63250a31a5");
var Input = require("38a4b6e9bd9dcaa8");
require("d2c0b5417dfb8a62");
require("383cf784da0238cd");
require("fd66b780665dbee8");
require("3aca5f05b44b8c7a");
require("ff8f458ce091a67c");
require("3202a2ea95d81187");
require("38ac5bfb436ce7f3");
var InputsGroupFieldset = require("6b995080a021c015");
var CheckboxGroup_context = require("3bf09cd75c1f2ecc");
var defaultProps = {};
var CheckboxGroup = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("CheckboxGroup", defaultProps, props), value = _useProps_useProps.value, defaultValue = _useProps_useProps.defaultValue, onChange = _useProps_useProps.onChange, size = _useProps_useProps.size, wrapperProps = _useProps_useProps.wrapperProps, children = _useProps_useProps.children, readOnly = _useProps_useProps.readOnly, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "value",
        "defaultValue",
        "onChange",
        "size",
        "wrapperProps",
        "children",
        "readOnly"
    ]);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: [],
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var handleChange = function(event) {
        var itemValue = typeof event === "string" ? event : event.currentTarget.value;
        !readOnly && setValue(_value.includes(itemValue) ? _value.filter(function(item) {
            return item !== itemValue;
        }) : (0, _toConsumableArray._)(_value).concat([
            itemValue
        ]));
    };
    return /* @__PURE__ */ jsxRuntime.jsx(CheckboxGroup_context.CheckboxGroupProvider, {
        value: {
            value: _value,
            onChange: handleChange,
            size
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Wrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({
            size,
            ref
        }, wrapperProps, others), {
            labelElement: "div",
            __staticSelector: "CheckboxGroup",
            children: /* @__PURE__ */ jsxRuntime.jsx(InputsGroupFieldset.InputsGroupFieldset, {
                role: "group",
                children
            })
        }))
    });
});
CheckboxGroup.classes = Input.Input.Wrapper.classes;
CheckboxGroup.displayName = "@mantine/core/CheckboxGroup";
exports.CheckboxGroup = CheckboxGroup; //# sourceMappingURL=CheckboxGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","58c5cd9359bdac4a":"iKGFf","2420bb087f841f82":"9HEEB","f969776f06286707":"9MtAM","e7f9801b29684717":"8QFOC","6a4b0c586ce4ea04":"2FdJg","cf09cd510eef2491":"6AMGA","817502a9218433b7":"erSvz","fda56ac64a1903ab":"kqQOF","41f6010d1a71d224":"iivvn","991706a5bbb94da1":"8YP4O","1aeec611ea454f2c":"gkGXc","9772b840ba130a4d":"guLFz","2ef04e63250a31a5":"2onWA","38a4b6e9bd9dcaa8":"dkUgf","d2c0b5417dfb8a62":"j4uTK","383cf784da0238cd":"7nO1x","fd66b780665dbee8":"3Bda4","3aca5f05b44b8c7a":"gQBOr","ff8f458ce091a67c":"lRBdM","3202a2ea95d81187":"hxtex","38ac5bfb436ce7f3":"lQt5D","6b995080a021c015":"j4N9U","3bf09cd75c1f2ecc":"1sCYn"}],"j4N9U":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("bf42212fb12fae9f");
require("a81394a715230af4");
require("9be48fd02ff9ea2");
require("a0dd87fa4d62afc7");
require("dbf56b9457283277");
require("e8190276b2056c78");
require("1f051797abad6542");
require("d666fff78dee269d");
require("8263b7b84c5a5144");
require("ffa40f639f4f32c6");
require("e83a262008d397cc");
require("10e2c8eb900665ab");
require("a3d9f8e81a6fe089");
require("a4575b6d1873081e");
require("7a6e03992ee6355d");
require("79a37d178a252f40");
require("341bb142277477cc");
require("95b527e924481492");
var InputWrapper_context = require("1222a62096c8bdc");
function InputsGroupFieldset(param) {
    var children = param.children, role = param.role;
    var ctx = InputWrapper_context.useInputWrapperContext();
    if (!ctx) return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children
    });
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
        role,
        "aria-labelledby": ctx.labelId,
        "aria-describedby": ctx.describedBy,
        children
    });
}
exports.InputsGroupFieldset = InputsGroupFieldset; //# sourceMappingURL=InputsGroupFieldset.cjs.map

},{"bf42212fb12fae9f":"iKGFf","a81394a715230af4":"dkUgf","9be48fd02ff9ea2":"j4uTK","a0dd87fa4d62afc7":"7nO1x","dbf56b9457283277":"3Bda4","e8190276b2056c78":"gQBOr","1f051797abad6542":"lRBdM","d666fff78dee269d":"hxtex","8263b7b84c5a5144":"9MtAM","ffa40f639f4f32c6":"9HEEB","e83a262008d397cc":"8QFOC","10e2c8eb900665ab":"2FdJg","a3d9f8e81a6fe089":"6AMGA","a4575b6d1873081e":"erSvz","7a6e03992ee6355d":"kqQOF","79a37d178a252f40":"8YP4O","341bb142277477cc":"gkGXc","95b527e924481492":"2onWA","1222a62096c8bdc":"lQt5D"}],"ahwnY":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("632b2b2e2cdbeba6");
require("6b490a8d9377bc24");
var getSize = require("2ba25862266dba33");
require("95a86e2c580c6cd5");
var createVarsResolver = require("a8b25c745586a004");
require("df0d26f64ed91803");
var parseThemeColor = require("a731d81745e22c25");
var getThemeColor = require("29fa7ee476ef623f");
var getContrastColor = require("7e7b6677590de5d3");
var getAutoContrastValue = require("d4f4b7d70ef4de42");
require("75d24076441ecc06");
require("1bc89e63003c05f");
require("db0a2a44f72a2f83");
require("4c51e73a83092496");
var useProps = require("5d2602aa15dfe1f8");
require("59819fbd053194f");
var useStyles = require("5ff166b5ea070113");
var Box = require("7da2a01781dc5121");
var factory = require("867359611d01abe5");
require("4cba1db72f00356c");
var CheckboxCard_context = require("b10a535e529fa9a4");
var CheckIcon = require("d8d7563d8790e47e");
var CheckboxIndicator_module = require("f63615076d20e2db");
var defaultProps = {
    icon: CheckIcon.CheckboxIcon
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, size = param.size, iconColor = param.iconColor, variant = param.variant, autoContrast = param.autoContrast;
    var parsedColor = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme
    });
    var outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
    return {
        indicator: {
            "--checkbox-size": getSize.getSize(size, "checkbox-size"),
            "--checkbox-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--checkbox-color": variant === "outline" ? outlineColor : getThemeColor.getThemeColor(color, theme),
            "--checkbox-icon-color": iconColor ? getThemeColor.getThemeColor(iconColor, theme) : getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
var CheckboxIndicator = factory.factory(function(_props, ref) {
    var props = useProps.useProps("CheckboxIndicator", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, icon = props.icon, indeterminate = props.indeterminate, radius = props.radius, color = props.color, iconColor = props.iconColor, autoContrast = props.autoContrast, checked = props.checked, mod = props.mod, variant = props.variant, disabled = props.disabled, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "icon",
        "indeterminate",
        "radius",
        "color",
        "iconColor",
        "autoContrast",
        "checked",
        "mod",
        "variant",
        "disabled"
    ]);
    var Icon = icon;
    var getStyles = useStyles.useStyles({
        name: "CheckboxIndicator",
        classes: CheckboxIndicator_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "indicator"
    });
    var ctx = CheckboxCard_context.useCheckboxCardContext();
    var _checked = typeof checked === "boolean" || typeof indeterminate === "boolean" ? checked || indeterminate : (ctx === null || ctx === void 0 ? void 0 : ctx.checked) || false;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("indicator", {
        variant
    })), {
        variant,
        mod: [
            {
                checked: _checked,
                disabled
            },
            mod
        ]
    }), others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(Icon, (0, _objectSpread._)({
            indeterminate
        }, getStyles("icon")))
    }));
});
CheckboxIndicator.displayName = "@mantine/core/CheckboxIndicator";
CheckboxIndicator.classes = CheckboxIndicator_module;
exports.CheckboxIndicator = CheckboxIndicator; //# sourceMappingURL=CheckboxIndicator.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","632b2b2e2cdbeba6":"iKGFf","6b490a8d9377bc24":"9MtAM","2ba25862266dba33":"kEFEY","95a86e2c580c6cd5":"9HEEB","a8b25c745586a004":"hIQE6","df0d26f64ed91803":"8QFOC","a731d81745e22c25":"ctp80","29fa7ee476ef623f":"eeaIN","7e7b6677590de5d3":"ez6cW","d4f4b7d70ef4de42":"cN4dA","75d24076441ecc06":"2FdJg","1bc89e63003c05f":"6AMGA","db0a2a44f72a2f83":"erSvz","4c51e73a83092496":"kqQOF","5d2602aa15dfe1f8":"iivvn","59819fbd053194f":"8YP4O","5ff166b5ea070113":"d0sAY","7da2a01781dc5121":"gkGXc","867359611d01abe5":"guLFz","4cba1db72f00356c":"2onWA","b10a535e529fa9a4":"jQ0Qw","d8d7563d8790e47e":"fysam","f63615076d20e2db":"9XygQ"}],"fysam":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("14dbf86ba502ad7a");
var rem = require("b06846ec1d013df9");
require("8830cf33967a57e2");
require("e9adf613734b0c5d");
require("f9a68948dfc11e57");
require("b97f33fd4cacb6da");
require("f9bda4dbdd839037");
require("8e5cc9e34495a91e");
require("4f02553f7d019e49");
require("a7291ffbf76fc0cd");
require("85856d6a421b4efd");
require("27029b36f5690ceb");
function CheckIcon(_param) {
    var size = _param.size, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "size",
        "style"
    ]);
    var _style = size !== void 0 ? (0, _objectSpread._)({
        width: rem.rem(size),
        height: rem.rem(size)
    }, style) : style;
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: _style,
        "aria-hidden": true
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    }));
}
function CheckboxIcon(_param) {
    var indeterminate = _param.indeterminate, others = (0, _objectWithoutProperties._)(_param, [
        "indeterminate"
    ]);
    if (indeterminate) return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 6",
        "aria-hidden": true
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("rect", {
            width: "32",
            height: "6",
            fill: "currentColor",
            rx: "3"
        })
    }));
    return /* @__PURE__ */ jsxRuntime.jsx(CheckIcon, (0, _objectSpread._)({}, others));
}
exports.CheckIcon = CheckIcon;
exports.CheckboxIcon = CheckboxIcon; //# sourceMappingURL=CheckIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","14dbf86ba502ad7a":"iKGFf","b06846ec1d013df9":"ebAaL","8830cf33967a57e2":"9MtAM","e9adf613734b0c5d":"9HEEB","f9a68948dfc11e57":"8QFOC","b97f33fd4cacb6da":"2FdJg","f9bda4dbdd839037":"6AMGA","8e5cc9e34495a91e":"erSvz","4f02553f7d019e49":"kqQOF","a7291ffbf76fc0cd":"8YP4O","85856d6a421b4efd":"gkGXc","27029b36f5690ceb":"2onWA"}],"9XygQ":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "indicator": "m_5e5256ee",
    "icon": "m_1b1c543a",
    "indicator--outline": "m_76e20374"
};
module.exports = classes; //# sourceMappingURL=CheckboxIndicator.module.css.cjs.map

},{}],"27jht":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_bf2d988c",
    "inner": "m_26062bec",
    "input": "m_26063560",
    "icon": "m_bf295423",
    "input--outline": "m_215c4542"
};
module.exports = classes; //# sourceMappingURL=Checkbox.module.css.cjs.map

},{}],"a1fPD":[function(require,module,exports) {
"use client";
"use strict";
var isOptionsGroup = require("a79b48cb4b815883");
function defaultOptionsFilter(param) {
    var options = param.options, search = param.search, limit = param.limit;
    var parsedSearch = search.trim().toLowerCase();
    var result = [];
    for(var i = 0; i < options.length; i += 1){
        var item = options[i];
        if (result.length === limit) return result;
        if (isOptionsGroup.isOptionsGroup(item)) result.push({
            group: item.group,
            items: defaultOptionsFilter({
                options: item.items,
                search,
                limit: limit - result.length
            })
        });
        if (!isOptionsGroup.isOptionsGroup(item)) {
            if (item.label.toLowerCase().includes(parsedSearch)) result.push(item);
        }
    }
    return result;
}
exports.defaultOptionsFilter = defaultOptionsFilter; //# sourceMappingURL=default-options-filter.cjs.map

},{"a79b48cb4b815883":"2yhqd"}],"2yhqd":[function(require,module,exports) {
"use client";
"use strict";
function isOptionsGroup(item) {
    return "group" in item;
}
exports.isOptionsGroup = isOptionsGroup; //# sourceMappingURL=is-options-group.cjs.map

},{}],"kkEF4":[function(require,module,exports) {
"use client";
"use strict";
function isEmptyComboboxData(data) {
    if (data.length === 0) return true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (!("group" in item)) return false;
            if (item.items.length > 0) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
exports.isEmptyComboboxData = isEmptyComboboxData; //# sourceMappingURL=is-empty-combobox-data.cjs.map

},{}],"aASAf":[function(require,module,exports) {
"use client";
"use strict";
var isOptionsGroup = require("acd2d8d919e0204a");
function validateOptions(options) {
    var valuesSet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Set();
    if (!Array.isArray(options)) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var option = _step.value;
            if (isOptionsGroup.isOptionsGroup(option)) validateOptions(option.items, valuesSet);
            else {
                if (typeof option.value === "undefined") throw new Error("[@mantine/core] Each option must have value property");
                if (typeof option.value !== "string") throw new Error(`[@mantine/core] Option value must be a string, other data formats are not supported, got ${typeof option.value}`);
                if (valuesSet.has(option.value)) throw new Error(`[@mantine/core] Duplicate options are not supported. Option with value "${option.value}" was provided more than once`);
                valuesSet.add(option.value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
exports.validateOptions = validateOptions; //# sourceMappingURL=validate-options.cjs.map

},{"acd2d8d919e0204a":"2yhqd"}],"3yuDB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("6d51c927001f947c");
var React = require("9b736c45ad855a5f");
var getSize = require("c18f6d84354daddb");
require("59416cedf0c1a737");
var createVarsResolver = require("c1cbeb8afc1af365");
require("279714454970e1c8");
require("c17664f5f1600ac7");
require("dc595ae295905ce5");
require("5d62372f491c7cba");
require("24df0cdeba1bbdcc");
var useProps = require("12d1b02987ebe6bf");
require("a77dee097525aea2");
var useStyles = require("30bd7ef2fe74cbcc");
var Box = require("b077432eaaf7fe70");
var polymorphicFactory = require("75d85d76da164dbd");
require("6b53eee6c4af5a5e");
var AvatarGroup = require("eb6649c0506866f8");
var AvatarGroup_context = require("58561f92c42b61ce");
var AvatarPlaceholderIcon = require("55a28e797c15e35c");
var getInitialsColor = require("390ae108a80e1fea");
var getInitials = require("fa46839a9945d7d5");
var Avatar_module = require("cc6ca46c1cb415ea");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, radius = param.radius, variant = param.variant, gradient = param.gradient, color = param.color, autoContrast = param.autoContrast, name = param.name, allowedInitialsColors = param.allowedInitialsColors;
    var _color = color === "initials" && typeof name === "string" ? getInitialsColor.getInitialsColor(name, allowedInitialsColors) : color;
    var colors = theme.variantColorResolver({
        color: _color || "gray",
        theme,
        gradient,
        variant: variant || "light",
        autoContrast
    });
    return {
        root: {
            "--avatar-size": getSize.getSize(size, "avatar-size"),
            "--avatar-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--avatar-bg": _color || variant ? colors.background : void 0,
            "--avatar-color": _color || variant ? colors.color : void 0,
            "--avatar-bd": _color || variant ? colors.border : void 0
        }
    };
});
var Avatar = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Avatar", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, src = props.src, alt = props.alt, radius = props.radius, color = props.color, gradient = props.gradient, imageProps = props.imageProps, children = props.children, autoContrast = props.autoContrast, mod = props.mod, name = props.name, allowedInitialsColors = props.allowedInitialsColors, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "src",
        "alt",
        "radius",
        "color",
        "gradient",
        "imageProps",
        "children",
        "autoContrast",
        "mod",
        "name",
        "allowedInitialsColors"
    ]);
    var ctx = AvatarGroup_context.useAvatarGroupContext();
    var _React_useState = (0, _slicedToArray._)(React.useState(!src), 2), error = _React_useState[0], setError = _React_useState[1];
    var getStyles = useStyles.useStyles({
        name: "Avatar",
        props,
        classes: Avatar_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    React.useEffect(function() {
        return setError(!src);
    }, [
        src
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        mod: [
            {
                "within-group": ctx.withinGroup
            },
            mod
        ],
        ref
    }), others), {
        children: error ? /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("placeholder")), {
            title: alt,
            children: children || typeof name === "string" && getInitials.getInitials(name) || /* @__PURE__ */ jsxRuntime.jsx(AvatarPlaceholderIcon.AvatarPlaceholderIcon, {})
        })) : /* @__PURE__ */ jsxRuntime.jsx("img", (0, _objectSpreadProps._)((0, _objectSpread._)({}, imageProps, getStyles("image")), {
            src,
            alt,
            onError: function(event) {
                var _imageProps_onError;
                setError(true);
                imageProps === null || imageProps === void 0 ? void 0 : (_imageProps_onError = imageProps.onError) === null || _imageProps_onError === void 0 ? void 0 : _imageProps_onError.call(imageProps, event);
            }
        }))
    }));
});
Avatar.classes = Avatar_module;
Avatar.displayName = "@mantine/core/Avatar";
Avatar.Group = AvatarGroup.AvatarGroup;
exports.Avatar = Avatar; //# sourceMappingURL=Avatar.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","6d51c927001f947c":"iKGFf","9b736c45ad855a5f":"9MtAM","c18f6d84354daddb":"kEFEY","59416cedf0c1a737":"9HEEB","c1cbeb8afc1af365":"hIQE6","279714454970e1c8":"8QFOC","c17664f5f1600ac7":"2FdJg","dc595ae295905ce5":"6AMGA","5d62372f491c7cba":"erSvz","24df0cdeba1bbdcc":"kqQOF","12d1b02987ebe6bf":"iivvn","a77dee097525aea2":"8YP4O","30bd7ef2fe74cbcc":"d0sAY","b077432eaaf7fe70":"gkGXc","75d85d76da164dbd":"iYAEL","6b53eee6c4af5a5e":"2onWA","eb6649c0506866f8":"1Mx4G","58561f92c42b61ce":"dkjFn","55a28e797c15e35c":"fNj65","390ae108a80e1fea":"jxB2Y","fa46839a9945d7d5":"7ZVJd","cc6ca46c1cb415ea":"dXb1d"}],"1Mx4G":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("386ef808bffd9c9b");
require("22f7c2e5ace7b724");
var getSize = require("9a6d48c81402e3a1");
require("4de60ce9c6a89880");
var createVarsResolver = require("eb59bbf3998e1f96");
require("8736703c01f6c55");
require("643bfe6a2531d2fc");
require("a83d55a5a5a7c874");
require("77f9cf583b7bb56e");
require("931b7d38a27cf636");
var useProps = require("ca263eb701b2b952");
require("a73c352a8070266e");
var useStyles = require("3c13be3e2de4d1fb");
var Box = require("f2eb5a46032d09a2");
var factory = require("6f6b02e898b5359a");
require("95ac89429cc01779");
var AvatarGroup_context = require("e43a7fb3ccce4c72");
var Avatar_module = require("93714ce928e68e8d");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var spacing = param.spacing;
    return {
        group: {
            "--ag-spacing": getSize.getSpacing(spacing)
        }
    };
});
var AvatarGroup = factory.factory(function(_props, ref) {
    var props = useProps.useProps("AvatarGroup", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, spacing = props.spacing, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "spacing"
    ]);
    var getStyles = useStyles.useStyles({
        name: "AvatarGroup",
        classes: Avatar_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(AvatarGroup_context.AvatarGroupProvider, {
        value: true,
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
            ref
        }, getStyles("group"), others))
    });
});
AvatarGroup.classes = Avatar_module;
AvatarGroup.displayName = "@mantine/core/AvatarGroup";
exports.AvatarGroup = AvatarGroup; //# sourceMappingURL=AvatarGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","386ef808bffd9c9b":"iKGFf","22f7c2e5ace7b724":"9MtAM","9a6d48c81402e3a1":"kEFEY","4de60ce9c6a89880":"9HEEB","eb59bbf3998e1f96":"hIQE6","8736703c01f6c55":"8QFOC","643bfe6a2531d2fc":"2FdJg","a83d55a5a5a7c874":"6AMGA","77f9cf583b7bb56e":"erSvz","931b7d38a27cf636":"kqQOF","ca263eb701b2b952":"iivvn","a73c352a8070266e":"8YP4O","3c13be3e2de4d1fb":"d0sAY","f2eb5a46032d09a2":"gkGXc","6f6b02e898b5359a":"guLFz","95ac89429cc01779":"2onWA","e43a7fb3ccce4c72":"dkjFn","93714ce928e68e8d":"dXb1d"}],"dkjFn":[function(require,module,exports) {
"use client";
"use strict";
var React = require("2fd5ec206761a941");
var AvatarGroupContext = React.createContext(null);
var AvatarGroupProvider = AvatarGroupContext.Provider;
function useAvatarGroupContext() {
    var ctx = React.useContext(AvatarGroupContext);
    return {
        withinGroup: !!ctx
    };
}
exports.AvatarGroupProvider = AvatarGroupProvider;
exports.useAvatarGroupContext = useAvatarGroupContext; //# sourceMappingURL=AvatarGroup.context.cjs.map

},{"2fd5ec206761a941":"9MtAM"}],"dXb1d":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "group": "m_11def92b",
    "root": "m_f85678b6",
    "image": "m_11f8ac07",
    "placeholder": "m_104cd71f"
};
module.exports = classes; //# sourceMappingURL=Avatar.module.css.cjs.map

},{}],"fNj65":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("91c82890d5e159bc");
function AvatarPlaceholderIcon(props) {
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        "data-avatar-placeholder-icon": true,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    }));
}
exports.AvatarPlaceholderIcon = AvatarPlaceholderIcon; //# sourceMappingURL=AvatarPlaceholderIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","91c82890d5e159bc":"iKGFf"}],"jxB2Y":[function(require,module,exports) {
"use client";
"use strict";
function hashCode(input) {
    var hash = 0;
    for(var i = 0; i < input.length; i += 1){
        var char = input.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0;
    }
    return hash;
}
var defaultColors = [
    "blue",
    "cyan",
    "grape",
    "green",
    "indigo",
    "lime",
    "orange",
    "pink",
    "red",
    "teal",
    "violet"
];
function getInitialsColor(name) {
    var colors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultColors;
    var hash = hashCode(name);
    var index = Math.abs(hash) % colors.length;
    return colors[index];
}
exports.getInitialsColor = getInitialsColor; //# sourceMappingURL=get-initials-color.cjs.map

},{}],"7ZVJd":[function(require,module,exports) {
"use client";
"use strict";
function getInitials(name) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var splitted = name.split(" ");
    if (splitted.length === 1) return name.slice(0, limit).toUpperCase();
    return splitted.map(function(word) {
        return word[0];
    }).slice(0, limit).join("").toUpperCase();
}
exports.getInitials = getInitials; //# sourceMappingURL=get-initials.cjs.map

},{}],"ltl7Q":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("81d8f9c9ed5540fd");
require("63ab4bfdc0ebfe2d");
var getSize = require("1f974d11fd42323b");
require("5953f412ef05b8fc");
var createVarsResolver = require("b33e8ba8dd3ab90c");
require("d8da4b7f6633b32a");
require("2039b472d098bf07");
require("daad94685e4db9c9");
require("38db1892aaf83ed7");
require("1eba4e2fc72b4c48");
var useProps = require("c4e871f06592ec9e");
require("91e7f760b430d5c8");
var useStyles = require("8ac3db14bf4af073");
var Box = require("e2459cf90df884a4");
var polymorphicFactory = require("50a83b1692ae3bcd");
require("c37f3b88fe5169f5");
var BackgroundImage_module = require("b55e2bb4ee8a5320");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius;
    return {
        root: {
            "--bi-radius": radius === void 0 ? void 0 : getSize.getRadius(radius)
        }
    };
});
var BackgroundImage = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("BackgroundImage", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, radius = props.radius, src = props.src, variant = props.variant, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "radius",
        "src",
        "variant"
    ]);
    var getStyles = useStyles.useStyles({
        name: "BackgroundImage",
        props,
        classes: BackgroundImage_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref,
        variant
    }, getStyles("root", {
        style: {
            backgroundImage: `url(${src})`
        }
    }), others));
});
BackgroundImage.classes = BackgroundImage_module;
BackgroundImage.displayName = "@mantine/core/BackgroundImage";
exports.BackgroundImage = BackgroundImage; //# sourceMappingURL=BackgroundImage.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","81d8f9c9ed5540fd":"iKGFf","63ab4bfdc0ebfe2d":"9MtAM","1f974d11fd42323b":"kEFEY","5953f412ef05b8fc":"9HEEB","b33e8ba8dd3ab90c":"hIQE6","d8da4b7f6633b32a":"8QFOC","2039b472d098bf07":"2FdJg","daad94685e4db9c9":"6AMGA","38db1892aaf83ed7":"erSvz","1eba4e2fc72b4c48":"kqQOF","c4e871f06592ec9e":"iivvn","91e7f760b430d5c8":"8YP4O","8ac3db14bf4af073":"d0sAY","e2459cf90df884a4":"gkGXc","50a83b1692ae3bcd":"iYAEL","c37f3b88fe5169f5":"2onWA","b55e2bb4ee8a5320":"jXnaW"}],"jXnaW":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_2ce0de02"
};
module.exports = classes; //# sourceMappingURL=BackgroundImage.module.css.cjs.map

},{}],"iIBj2":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("d454a7295a89f111");
require("3dddbee9361b302d");
var getSize = require("461876e9c2a0524e");
require("d670ad7d07b281ac");
var createVarsResolver = require("e5cddf7f890d6d80");
require("4976465f47e32e2f");
var getThemeColor = require("ac40588b55af449f");
require("eb324ec4ea4d95e");
require("4115122c4dc89e61");
require("bf6941d65ab36c7e");
require("b2cc7b87ec4434de");
var useProps = require("7fb0793e7f4588e8");
require("85ebcd0e83b2d98f");
var useStyles = require("72cd7fd16af522e6");
var Box = require("754fe14765e24cae");
var polymorphicFactory = require("738ea0925031f344");
require("e6f9cbb27bca69c8");
var Badge_module = require("dc2c53d21b75d4d9");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, gradient = param.gradient, variant = param.variant, size = param.size, autoContrast = param.autoContrast;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--badge-height": getSize.getSize(size, "badge-height"),
            "--badge-padding-x": getSize.getSize(size, "badge-padding-x"),
            "--badge-fz": getSize.getSize(size, "badge-fz"),
            "--badge-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--badge-bg": color || variant ? colors.background : void 0,
            "--badge-color": color || variant ? colors.color : void 0,
            "--badge-bd": color || variant ? colors.border : void 0,
            "--badge-dot-color": variant === "dot" ? getThemeColor.getThemeColor(color, theme) : void 0
        }
    };
});
var Badge = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Badge", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, radius = props.radius, color = props.color, gradient = props.gradient, leftSection = props.leftSection, rightSection = props.rightSection, children = props.children, variant = props.variant, fullWidth = props.fullWidth, autoContrast = props.autoContrast, circle = props.circle, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "radius",
        "color",
        "gradient",
        "leftSection",
        "rightSection",
        "children",
        "variant",
        "fullWidth",
        "autoContrast",
        "circle",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Badge",
        props,
        classes: Badge_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        variant,
        mod: [
            {
                block: fullWidth,
                circle,
                "with-right-section": !!rightSection,
                "with-left-section": !!leftSection
            },
            mod
        ]
    }, getStyles("root", {
        variant
    })), {
        ref
    }), others), {
        children: [
            leftSection && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("section")), {
                "data-position": "left",
                children: leftSection
            })),
            /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label")), {
                children
            })),
            rightSection && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("section")), {
                "data-position": "right",
                children: rightSection
            }))
        ]
    }));
});
Badge.classes = Badge_module;
Badge.displayName = "@mantine/core/Badge";
exports.Badge = Badge; //# sourceMappingURL=Badge.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","d454a7295a89f111":"iKGFf","3dddbee9361b302d":"9MtAM","461876e9c2a0524e":"kEFEY","d670ad7d07b281ac":"9HEEB","e5cddf7f890d6d80":"hIQE6","4976465f47e32e2f":"8QFOC","ac40588b55af449f":"eeaIN","eb324ec4ea4d95e":"2FdJg","4115122c4dc89e61":"6AMGA","bf6941d65ab36c7e":"erSvz","b2cc7b87ec4434de":"kqQOF","7fb0793e7f4588e8":"iivvn","85ebcd0e83b2d98f":"8YP4O","72cd7fd16af522e6":"d0sAY","754fe14765e24cae":"gkGXc","738ea0925031f344":"iYAEL","e6f9cbb27bca69c8":"2onWA","dc2c53d21b75d4d9":"fdW4d"}],"fdW4d":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_347db0ec",
    "root--dot": "m_fbd81e3d",
    "label": "m_5add502a",
    "section": "m_91fdda9b"
};
module.exports = classes; //# sourceMappingURL=Badge.module.css.cjs.map

},{}],"woUye":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("ab40538a5f40fb56");
var rem = require("7704a872aa2d8405");
require("424790f177ce8965");
var getSize = require("b2ff0477f613196c");
require("9d3ab88ce8deb888");
var createVarsResolver = require("ae2330647ffeb97e");
require("6973c0473b4c8b");
var parseThemeColor = require("3c48b864f8cdcb6d");
var getThemeColor = require("3ca0c3f923f9689b");
var rgba = require("8a82a676af6b6416");
require("90c0755911697800");
require("e534a4176feb8369");
require("d587624167c2f075");
require("61105f464179151c");
var useProps = require("35789bff1fc24575");
require("2f7fa7f027246163");
var useStyles = require("18d5381defb9c38b");
var Box = require("c6873d367e36e7b2");
var factory = require("85b50d739ed11316");
require("690b747688387fb6");
var Blockquote_module = require("12b5dfb08a32abcb");
var defaultProps = {
    iconSize: 48
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color, iconSize = param.iconSize, radius = param.radius;
    var darkParsed = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme,
        colorScheme: "dark"
    });
    var lightParsed = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme,
        colorScheme: "light"
    });
    return {
        root: {
            "--bq-bg-light": rgba.rgba(lightParsed.value, 0.07),
            "--bq-bg-dark": rgba.rgba(darkParsed.value, 0.06),
            "--bq-bd": getThemeColor.getThemeColor(color, theme),
            "--bq-icon-size": rem.rem(iconSize),
            "--bq-radius": getSize.getRadius(radius)
        }
    };
});
var Blockquote = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Blockquote", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, icon = props.icon, iconSize = props.iconSize, cite = props.cite, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "icon",
        "iconSize",
        "cite"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Blockquote",
        classes: Blockquote_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "blockquote",
        ref
    }, getStyles("root"), others), {
        children: [
            icon && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("icon")), {
                children: icon
            })),
            children,
            cite && /* @__PURE__ */ jsxRuntime.jsx("cite", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("cite")), {
                children: cite
            }))
        ]
    }));
});
Blockquote.classes = Blockquote_module;
Blockquote.displayName = "@mantine/core/Blockquote";
exports.Blockquote = Blockquote; //# sourceMappingURL=Blockquote.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","ab40538a5f40fb56":"iKGFf","7704a872aa2d8405":"ebAaL","424790f177ce8965":"9MtAM","b2ff0477f613196c":"kEFEY","9d3ab88ce8deb888":"9HEEB","ae2330647ffeb97e":"hIQE6","6973c0473b4c8b":"8QFOC","3c48b864f8cdcb6d":"ctp80","3ca0c3f923f9689b":"eeaIN","8a82a676af6b6416":"aIray","90c0755911697800":"2FdJg","e534a4176feb8369":"6AMGA","d587624167c2f075":"erSvz","61105f464179151c":"kqQOF","35789bff1fc24575":"iivvn","2f7fa7f027246163":"8YP4O","18d5381defb9c38b":"d0sAY","c6873d367e36e7b2":"gkGXc","85b50d739ed11316":"guLFz","690b747688387fb6":"2onWA","12b5dfb08a32abcb":"5HaDr"}],"5HaDr":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_ddec01c0",
    "icon": "m_dde7bd57",
    "cite": "m_dde51a35"
};
module.exports = classes; //# sourceMappingURL=Blockquote.module.css.cjs.map

},{}],"birrb":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b66e7590231f8d64");
var React = require("1dff427a4e5a4279");
var isElement = require("adc98e6a89521ed6");
var getSize = require("54ec4e3bb1243128");
require("e609879e96afc9a8");
var createVarsResolver = require("12c9bf1965b5bbd");
require("81fd694009c01c89");
require("14d091eb36344f7e");
require("a8aa0d339be7bfb9");
require("4750c7546a2f9f6e");
require("ed6021353e495bef");
var useProps = require("9fc5a9ea75ef1671");
require("8ec45407fb8d4af6");
var useStyles = require("ff3c6bda56dcf9f9");
var Box = require("80bfea0790a95c40");
var factory = require("925b0e8c3ade2f49");
require("4b9b490d7c221c00");
var Breadcrumbs_module = require("99eddd9c99d844ef");
var defaultProps = {
    separator: "/"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var separatorMargin = param.separatorMargin;
    return {
        root: {
            "--bc-separator-margin": getSize.getSpacing(separatorMargin)
        }
    };
});
var Breadcrumbs = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Breadcrumbs", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, separator = props.separator, separatorMargin = props.separatorMargin, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "separator",
        "separatorMargin"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Breadcrumbs",
        classes: Breadcrumbs_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var items = React.Children.toArray(children).reduce(function(acc, child, index, array) {
        var _child_props;
        var item = isElement.isElement(child) ? React.cloneElement(child, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("breadcrumb", {
            className: (_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.className
        })), {
            key: index
        })) : /* @__PURE__ */ React.createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("breadcrumb")), {
            key: index
        }), child);
        acc.push(item);
        if (index !== array.length - 1) acc.push(/* @__PURE__ */ React.createElement(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("separator")), {
            key: `separator-${index}`
        }), separator));
        return acc;
    }, []);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("root"), others), {
        children: items
    }));
});
Breadcrumbs.classes = Breadcrumbs_module;
Breadcrumbs.displayName = "@mantine/core/Breadcrumbs";
exports.Breadcrumbs = Breadcrumbs; //# sourceMappingURL=Breadcrumbs.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","b66e7590231f8d64":"iKGFf","1dff427a4e5a4279":"9MtAM","adc98e6a89521ed6":"193o0","54ec4e3bb1243128":"kEFEY","e609879e96afc9a8":"9HEEB","12c9bf1965b5bbd":"hIQE6","81fd694009c01c89":"8QFOC","14d091eb36344f7e":"2FdJg","a8aa0d339be7bfb9":"6AMGA","4750c7546a2f9f6e":"erSvz","ed6021353e495bef":"kqQOF","9fc5a9ea75ef1671":"iivvn","8ec45407fb8d4af6":"8YP4O","ff3c6bda56dcf9f9":"d0sAY","80bfea0790a95c40":"gkGXc","925b0e8c3ade2f49":"guLFz","4b9b490d7c221c00":"2onWA","99eddd9c99d844ef":"bHIfG"}],"bHIfG":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_8b3717df",
    "breadcrumb": "m_f678d540",
    "separator": "m_3b8f2208"
};
module.exports = classes; //# sourceMappingURL=Breadcrumbs.module.css.cjs.map

},{}],"iYU71":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1ceb209c6bb1a52c");
var rem = require("6a34a760700f8c63");
require("d574b2e5fa006e68");
var getSize = require("fa1cf8efae1c9501");
require("8b0e747226a611c8");
var createVarsResolver = require("92e1e26879c45557");
require("a81ac31054b25dae");
var getThemeColor = require("e3104435c93e0a08");
require("55dca6a55846175b");
require("fbdffa8f92b93d3e");
require("b00931ffe6d3462e");
require("cb6924af9117993a");
var useProps = require("bcbd6f880475ba73");
require("ca9df7e164e4e122");
var useStyles = require("97edcf9f98d811f3");
var Box = require("85b3b5c9c0dc22af");
var factory = require("ed49e8d79a8a9890");
require("456c2889a0e881a0");
var UnstyledButton = require("b14297d8a05d6cf8");
var Burger_module = require("c36b6958a9e2f246");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color, size = param.size, lineSize = param.lineSize, transitionDuration = param.transitionDuration, transitionTimingFunction = param.transitionTimingFunction;
    return {
        root: {
            "--burger-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--burger-size": getSize.getSize(size, "burger-size"),
            "--burger-line-size": lineSize ? rem.rem(lineSize) : void 0,
            "--burger-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--burger-transition-timing-function": transitionTimingFunction
        }
    };
});
var Burger = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Burger", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, opened = props.opened, children = props.children, transitionDuration = props.transitionDuration, transitionTimingFunction = props.transitionTimingFunction, lineSize = props.lineSize, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "opened",
        "children",
        "transitionDuration",
        "transitionTimingFunction",
        "lineSize"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Burger",
        classes: Burger_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        ref
    }), others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
                mod: [
                    "reduce-motion",
                    {
                        opened
                    }
                ]
            }, getStyles("burger"))),
            children
        ]
    }));
});
Burger.classes = Burger_module;
Burger.displayName = "@mantine/core/Burger";
exports.Burger = Burger; //# sourceMappingURL=Burger.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","1ceb209c6bb1a52c":"iKGFf","6a34a760700f8c63":"ebAaL","d574b2e5fa006e68":"9MtAM","fa1cf8efae1c9501":"kEFEY","8b0e747226a611c8":"9HEEB","92e1e26879c45557":"hIQE6","a81ac31054b25dae":"8QFOC","e3104435c93e0a08":"eeaIN","55dca6a55846175b":"2FdJg","fbdffa8f92b93d3e":"6AMGA","b00931ffe6d3462e":"erSvz","cb6924af9117993a":"kqQOF","bcbd6f880475ba73":"iivvn","ca9df7e164e4e122":"8YP4O","97edcf9f98d811f3":"d0sAY","85b3b5c9c0dc22af":"gkGXc","ed49e8d79a8a9890":"guLFz","456c2889a0e881a0":"2onWA","b14297d8a05d6cf8":"cArqr","c36b6958a9e2f246":"iSUxa"}],"iSUxa":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_fea6bf1a",
    "burger": "m_d4fb9cad"
};
module.exports = classes; //# sourceMappingURL=Burger.module.css.cjs.map

},{}],"jW2gs":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c54971dd0d0a92f0");
var rem = require("95022738e1153146");
require("a9e12ee9ed6b8cfe");
var getSize = require("25bd1d9b95bdb072");
require("4c6b22286d5c7d8c");
var createVarsResolver = require("a0722204a3a3f5d");
require("4297a16752c21dd9");
require("d235437ba77e4e03");
require("1bd5d37dba8b95ed");
require("f025b3f0d41f8ead");
require("5a46f1f30924aae1");
var useProps = require("8a901f51fb177f93");
require("170ba4c95904b31d");
var useStyles = require("a8e49546129ce1b7");
var Box = require("20f6fa17d943e930");
var polymorphicFactory = require("7ac211156a4b0b8d");
require("51e91686be8bccf9");
var Loader = require("22c1ad4a3c05e47d");
var Transition = require("26a46a8cc582e0c2");
var UnstyledButton = require("bded0fd7828df29a");
var ButtonGroup = require("ce99c0da217d7ad");
var ButtonGroupSection = require("a8f00228773df74");
var Button_module = require("46c046f3836bedc4");
var loaderTransition = {
    in: {
        opacity: 1,
        transform: `translate(-50%, calc(-50% + ${rem.rem(1)}))`
    },
    out: {
        opacity: 0,
        transform: "translate(-50%, -200%)"
    },
    common: {
        transformOrigin: "center"
    },
    transitionProperty: "transform, opacity"
};
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, gradient = param.gradient, variant = param.variant, size = param.size, justify = param.justify, autoContrast = param.autoContrast;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--button-justify": justify,
            "--button-height": getSize.getSize(size, "button-height"),
            "--button-padding-x": getSize.getSize(size, "button-padding-x"),
            "--button-fz": (size === null || size === void 0 ? void 0 : size.includes("compact")) ? getSize.getFontSize(size.replace("compact-", "")) : getSize.getFontSize(size),
            "--button-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--button-bg": color || variant ? colors.background : void 0,
            "--button-hover": color || variant ? colors.hover : void 0,
            "--button-color": colors.color,
            "--button-bd": color || variant ? colors.border : void 0,
            "--button-hover-color": color || variant ? colors.hoverColor : void 0
        }
    };
});
var Button = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Button", defaultProps, _props);
    var style = props.style, vars = props.vars, className = props.className, color = props.color, disabled = props.disabled, children = props.children, leftSection = props.leftSection, rightSection = props.rightSection, fullWidth = props.fullWidth, variant = props.variant, radius = props.radius, loading = props.loading, loaderProps = props.loaderProps, gradient = props.gradient, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, dataDisabled = props["data-disabled"], autoContrast = props.autoContrast, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "style",
        "vars",
        "className",
        "color",
        "disabled",
        "children",
        "leftSection",
        "rightSection",
        "fullWidth",
        "variant",
        "radius",
        "loading",
        "loaderProps",
        "gradient",
        "classNames",
        "styles",
        "unstyled",
        "data-disabled",
        "autoContrast",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Button",
        props,
        classes: Button_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var hasLeftSection = !!leftSection;
    var hasRightSection = !!rightSection;
    return /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("root", {
        active: !disabled && !loading && !dataDisabled
    })), {
        unstyled,
        variant,
        disabled: disabled || loading,
        mod: [
            {
                disabled: disabled || dataDisabled,
                loading,
                block: fullWidth,
                "with-left-section": hasLeftSection,
                "with-right-section": hasRightSection
            },
            mod
        ]
    }), others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, {
                mounted: !!loading,
                transition: loaderTransition,
                duration: 150,
                children: function(transitionStyles) {
                    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "span"
                    }, getStyles("loader", {
                        style: transitionStyles
                    })), {
                        "aria-hidden": true,
                        children: /* @__PURE__ */ jsxRuntime.jsx(Loader.Loader, (0, _objectSpread._)({
                            color: "var(--button-color)",
                            size: "calc(var(--button-height) / 1.8)"
                        }, loaderProps))
                    }));
                }
            }),
            /* @__PURE__ */ jsxRuntime.jsxs("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("inner")), {
                children: [
                    leftSection && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "span"
                    }, getStyles("section")), {
                        mod: {
                            position: "left"
                        },
                        children: leftSection
                    })),
                    /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "span",
                        mod: {
                            loading
                        }
                    }, getStyles("label")), {
                        children
                    })),
                    rightSection && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "span"
                    }, getStyles("section")), {
                        mod: {
                            position: "right"
                        },
                        children: rightSection
                    }))
                ]
            }))
        ]
    }));
});
Button.classes = Button_module;
Button.displayName = "@mantine/core/Button";
Button.Group = ButtonGroup.ButtonGroup;
Button.GroupSection = ButtonGroupSection.ButtonGroupSection;
exports.Button = Button; //# sourceMappingURL=Button.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c54971dd0d0a92f0":"iKGFf","95022738e1153146":"ebAaL","a9e12ee9ed6b8cfe":"9MtAM","25bd1d9b95bdb072":"kEFEY","4c6b22286d5c7d8c":"9HEEB","a0722204a3a3f5d":"hIQE6","4297a16752c21dd9":"8QFOC","d235437ba77e4e03":"2FdJg","1bd5d37dba8b95ed":"6AMGA","f025b3f0d41f8ead":"erSvz","5a46f1f30924aae1":"kqQOF","8a901f51fb177f93":"iivvn","170ba4c95904b31d":"8YP4O","a8e49546129ce1b7":"d0sAY","20f6fa17d943e930":"gkGXc","7ac211156a4b0b8d":"iYAEL","51e91686be8bccf9":"2onWA","22c1ad4a3c05e47d":"hxcgl","26a46a8cc582e0c2":"2T0Xr","bded0fd7828df29a":"cArqr","ce99c0da217d7ad":"3CofV","a8f00228773df74":"cppYV","46c046f3836bedc4":"2obrx"}],"3CofV":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("988a74ece8ad9f7");
var rem = require("94e64332d1398187");
require("9f5210cf6b097e20");
require("62b50b16d7e31624");
var createVarsResolver = require("f965b8481d283d7d");
require("2afc30ff72abca58");
require("d4fa74ae34f6bc92");
require("b84efb68d0570eec");
require("fb84ed0db4f8ee71");
require("ccf7533c543e89a8");
var useProps = require("b8d65d0619ef4c1");
require("67c164eb231e344f");
var useStyles = require("fffea52aee6c17ba");
var Box = require("abed007fee83076d");
var factory = require("1cc4e43703738021");
require("7fd219ea20269b79");
var Button_module = require("30b08a90e11551c7");
var defaultProps = {
    orientation: "horizontal"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var borderWidth = param.borderWidth;
    return {
        group: {
            "--button-border-width": rem.rem(borderWidth)
        }
    };
});
var ButtonGroup = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ButtonGroup", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("ButtonGroup", defaultProps, _props), className = _useProps_useProps.className, style = _useProps_useProps.style, classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, orientation = _useProps_useProps.orientation, vars = _useProps_useProps.vars, borderWidth = _useProps_useProps.borderWidth, variant = _useProps_useProps.variant, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "orientation",
        "vars",
        "borderWidth",
        "variant",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ButtonGroup",
        props,
        classes: Button_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("group")), {
        ref,
        variant,
        mod: [
            {
                "data-orientation": orientation
            },
            mod
        ],
        role: "group"
    }), others));
});
ButtonGroup.classes = Button_module;
ButtonGroup.displayName = "@mantine/core/ButtonGroup";
exports.ButtonGroup = ButtonGroup; //# sourceMappingURL=ButtonGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","988a74ece8ad9f7":"iKGFf","94e64332d1398187":"ebAaL","9f5210cf6b097e20":"9MtAM","62b50b16d7e31624":"9HEEB","f965b8481d283d7d":"hIQE6","2afc30ff72abca58":"8QFOC","d4fa74ae34f6bc92":"2FdJg","b84efb68d0570eec":"6AMGA","fb84ed0db4f8ee71":"erSvz","ccf7533c543e89a8":"kqQOF","b8d65d0619ef4c1":"iivvn","67c164eb231e344f":"8YP4O","fffea52aee6c17ba":"d0sAY","abed007fee83076d":"gkGXc","1cc4e43703738021":"guLFz","7fd219ea20269b79":"2onWA","30b08a90e11551c7":"2obrx"}],"2obrx":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_77c9d27d",
    "inner": "m_80f1301b",
    "label": "m_811560b9",
    "section": "m_a74036a",
    "loader": "m_a25b86ee",
    "group": "m_80d6d844",
    "groupSection": "m_70be2a01"
};
module.exports = classes; //# sourceMappingURL=Button.module.css.cjs.map

},{}],"cppYV":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("8d59aca6af579abb");
require("171386e3443fdb80");
var getSize = require("f58e3d860549ec2b");
require("dca352ed0a573e2a");
var createVarsResolver = require("e1c5830777d356a4");
require("8c09c55fe2decd4a");
require("3f99a8660f7cdea0");
require("44f1b3062ace924f");
require("440f7f5326f71e68");
require("b610bd33f38630f6");
var useProps = require("538bb2eba5bb48e9");
require("b6c777cee346e39e");
var useStyles = require("59b20a4e17a00403");
var Box = require("1acede1d9bddd929");
var factory = require("8ad3fed4adb23a6a");
require("e125448d552db3ff");
var Button_module = require("509cc227db2fa98");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, gradient = param.gradient, variant = param.variant, autoContrast = param.autoContrast, size = param.size;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        groupSection: {
            "--section-height": getSize.getSize(size, "section-height"),
            "--section-padding-x": getSize.getSize(size, "section-padding-x"),
            "--section-fz": (size === null || size === void 0 ? void 0 : size.includes("compact")) ? getSize.getFontSize(size.replace("compact-", "")) : getSize.getFontSize(size),
            "--section-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--section-bg": color || variant ? colors.background : void 0,
            "--section-color": colors.color,
            "--section-bd": color || variant ? colors.border : void 0
        }
    };
});
var ButtonGroupSection = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ButtonGroupSection", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("ButtonGroupSection", defaultProps, _props), className = _useProps_useProps.className, style = _useProps_useProps.style, classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, vars = _useProps_useProps.vars, variant = _useProps_useProps.variant, gradient = _useProps_useProps.gradient, radius = _useProps_useProps.radius, autoContrast = _useProps_useProps.autoContrast, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "className",
        "style",
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "variant",
        "gradient",
        "radius",
        "autoContrast"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ButtonGroupSection",
        props,
        classes: Button_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "groupSection"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("groupSection")), {
        ref,
        variant
    }), others));
});
ButtonGroupSection.classes = Button_module;
ButtonGroupSection.displayName = "@mantine/core/ButtonGroupSection";
exports.ButtonGroupSection = ButtonGroupSection; //# sourceMappingURL=ButtonGroupSection.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","8d59aca6af579abb":"iKGFf","171386e3443fdb80":"9MtAM","f58e3d860549ec2b":"kEFEY","dca352ed0a573e2a":"9HEEB","e1c5830777d356a4":"hIQE6","8c09c55fe2decd4a":"8QFOC","3f99a8660f7cdea0":"2FdJg","44f1b3062ace924f":"6AMGA","440f7f5326f71e68":"erSvz","b610bd33f38630f6":"kqQOF","538bb2eba5bb48e9":"iivvn","b6c777cee346e39e":"8YP4O","59b20a4e17a00403":"d0sAY","1acede1d9bddd929":"gkGXc","8ad3fed4adb23a6a":"guLFz","e125448d552db3ff":"2onWA","509cc227db2fa98":"2obrx"}],"lTXKB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2703edc61b44de37");
var React = require("c532c2080b18cdad");
var getSize = require("4ec56122e97e52b4");
require("f405a765c13f9547");
var createVarsResolver = require("1d42c7b7693dabf");
require("5e4ab83f30a32970");
require("6517088c9af5c573");
require("3d3fa933e46ea821");
require("e847cc66ca90eeaa");
require("21fd18c9f1c663db");
var useProps = require("126e080dd5d5dc3f");
require("e5a1d03b26d4447b");
var useStyles = require("5947c0933fd8111d");
require("ee10e27c2418f14a");
var polymorphicFactory = require("a03a8ce044c6b4ea");
require("c9e69b7139404cdc");
var Paper = require("658a30001264d343");
var Card_context = require("3e6f4380906904f8");
var CardSection = require("99da71907bd1a90a");
var Card_module = require("a2c1f8876879c2d7");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var padding = param.padding;
    return {
        root: {
            "--card-padding": getSize.getSpacing(padding)
        }
    };
});
var Card = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Card", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, padding = props.padding, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "padding"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Card",
        props,
        classes: Card_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _children = React.Children.toArray(children);
    var content = _children.map(function(child, index) {
        if (typeof child === "object" && child && "type" in child && child.type === CardSection.CardSection) return React.cloneElement(child, {
            "data-first-section": index === 0 || void 0,
            "data-last-section": index === _children.length - 1 || void 0
        });
        return child;
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Card_context.CardProvider, {
        value: {
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Paper.Paper, (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref,
            unstyled
        }, getStyles("root"), others), {
            children: content
        }))
    });
});
Card.classes = Card_module;
Card.displayName = "@mantine/core/Card";
Card.Section = CardSection.CardSection;
exports.Card = Card; //# sourceMappingURL=Card.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","2703edc61b44de37":"iKGFf","c532c2080b18cdad":"9MtAM","4ec56122e97e52b4":"kEFEY","f405a765c13f9547":"9HEEB","1d42c7b7693dabf":"hIQE6","5e4ab83f30a32970":"8QFOC","6517088c9af5c573":"2FdJg","3d3fa933e46ea821":"6AMGA","e847cc66ca90eeaa":"erSvz","21fd18c9f1c663db":"kqQOF","126e080dd5d5dc3f":"iivvn","e5a1d03b26d4447b":"8YP4O","5947c0933fd8111d":"d0sAY","ee10e27c2418f14a":"gkGXc","a03a8ce044c6b4ea":"iYAEL","c9e69b7139404cdc":"2onWA","658a30001264d343":"amEW4","3e6f4380906904f8":"faUSv","99da71907bd1a90a":"fDPNb","a2c1f8876879c2d7":"ik2Q3"}],"faUSv":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("6629b67bc933cf1c");
var createSafeContext = require("1ed3c349ba559a38");
require("22e2c592f256eb49");
require("599a4e3e121a1c6f");
require("1aa03e16eea08f73");
require("760c0c671d6106da");
require("4e518a920a1d797a");
require("ecbc0b8aadd558e7");
require("12c9462baaefb00f");
require("74e160b43062c78f");
require("6d999f9595f07957");
require("47aec58dec67a415");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Card component was not found in tree"), 2), CardProvider = _createSafeContext_createSafeContext[0], useCardContext = _createSafeContext_createSafeContext[1];
exports.CardProvider = CardProvider;
exports.useCardContext = useCardContext; //# sourceMappingURL=Card.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","6629b67bc933cf1c":"9MtAM","1ed3c349ba559a38":"8srze","22e2c592f256eb49":"iKGFf","599a4e3e121a1c6f":"9HEEB","1aa03e16eea08f73":"8QFOC","760c0c671d6106da":"2FdJg","4e518a920a1d797a":"6AMGA","ecbc0b8aadd558e7":"erSvz","12c9462baaefb00f":"kqQOF","74e160b43062c78f":"8YP4O","6d999f9595f07957":"gkGXc","47aec58dec67a415":"2onWA"}],"fDPNb":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c33dda861a08862b");
require("ab7bf5862a7a5949");
require("e96088c059d1d640");
require("f7f133e10d1d6903");
require("a0ab875e7feeb49e");
require("87451ef7a21d418f");
require("1306dfc065bae75b");
require("8cf6629e5291089");
var useProps = require("e235dc0541fc62f7");
require("f23dd327fae0a39a");
var Box = require("25b09d7fe627b183");
var polymorphicFactory = require("6c2c73a22b52978f");
require("6573cb8114514513");
var Card_context = require("932387acb3ca50e7");
var Card_module = require("def70ab9a92b7d30");
var defaultProps = {};
var CardSection = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("CardSection", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, withBorder = props.withBorder, inheritPadding = props.inheritPadding, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "withBorder",
        "inheritPadding",
        "mod"
    ]);
    var ctx = Card_context.useCardContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref,
        mod: [
            {
                "with-border": withBorder,
                "inherit-padding": inheritPadding
            },
            mod
        ]
    }, ctx.getStyles("section", {
        className,
        style,
        styles,
        classNames
    }), others));
});
CardSection.classes = Card_module;
CardSection.displayName = "@mantine/core/CardSection";
exports.CardSection = CardSection; //# sourceMappingURL=CardSection.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","c33dda861a08862b":"iKGFf","ab7bf5862a7a5949":"9MtAM","e96088c059d1d640":"9HEEB","f7f133e10d1d6903":"8QFOC","a0ab875e7feeb49e":"2FdJg","87451ef7a21d418f":"6AMGA","1306dfc065bae75b":"erSvz","8cf6629e5291089":"kqQOF","e235dc0541fc62f7":"iivvn","f23dd327fae0a39a":"8YP4O","25b09d7fe627b183":"gkGXc","6c2c73a22b52978f":"iYAEL","6573cb8114514513":"2onWA","932387acb3ca50e7":"faUSv","def70ab9a92b7d30":"ik2Q3"}],"ik2Q3":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_e615b15f",
    "section": "m_599a2148"
};
module.exports = classes; //# sourceMappingURL=Card.module.css.cjs.map

},{}],"iqIUR":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("6d4619ff8378883d");
require("5c11b177af81548a");
require("b534f40baac58b11");
require("c4d1b6812b32f31d");
require("789775d9ad9c8d3");
require("3c63e2c80dac4bcb");
require("491125ed401d1031");
require("8f04bb0611a46b66");
var useProps = require("42457485c22b4ed8");
require("c02f64a768ebcdca");
var useStyles = require("d1d17d8448599521");
var Box = require("43a5a21212802c23");
var polymorphicFactory = require("1266351c05e4d6c3");
require("76b2570420a484e0");
var Center_module = require("4d8a47e3d68431a7");
var defaultProps = {};
var Center = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Center", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, inline = props.inline, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "inline",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Center",
        props,
        classes: Center_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref,
        mod: [
            {
                inline
            },
            mod
        ]
    }, getStyles("root"), others));
});
Center.classes = Center_module;
Center.displayName = "@mantine/core/Center";
exports.Center = Center; //# sourceMappingURL=Center.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","6d4619ff8378883d":"iKGFf","5c11b177af81548a":"9MtAM","b534f40baac58b11":"9HEEB","c4d1b6812b32f31d":"8QFOC","789775d9ad9c8d3":"2FdJg","3c63e2c80dac4bcb":"6AMGA","491125ed401d1031":"erSvz","8f04bb0611a46b66":"kqQOF","42457485c22b4ed8":"iivvn","c02f64a768ebcdca":"8YP4O","d1d17d8448599521":"d0sAY","43a5a21212802c23":"gkGXc","1266351c05e4d6c3":"iYAEL","76b2570420a484e0":"2onWA","4d8a47e3d68431a7":"7GXFA"}],"7GXFA":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_4451eb3a"
};
module.exports = classes; //# sourceMappingURL=Center.module.css.cjs.map

},{}],"4CZwL":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("aa43466e5d7cc748");
var hooks = require("a1a197c43327e903");
require("d5de3c27a947a485");
var getSize = require("ba86a5171b0b02aa");
var createVarsResolver = require("a881fe78e55d9a3a");
require("390d916ea336768f");
require("5b7904ebba183f62");
require("bd4285f254728186");
require("4ff2769747047778");
require("2897bb060966dee1");
var useProps = require("a4c4cdf6018b2d4c");
require("22cb25ebba25f940");
var useStyles = require("7172c60f1569e220");
var extractStyleProps = require("7cb5f0ddc1e86252");
var Box = require("e40547a6eebf54ad");
var factory = require("b38554e16e567d85");
require("5b63507607286ce");
require("a1113447d95ef4b5");
require("5934c29e8fa6b876");
var CheckIcon = require("7201d8e508afdd6f");
require("d23fe26050651ae0");
require("5606aea20ccc76ba");
require("868e6b101cf0c4ab");
require("ddb5970a5b0eae7b");
var ChipGroup_context = require("30c60efea08c03b");
var ChipGroup = require("3323601551a1118b");
var Chip_module = require("c9d672bf1b7da421");
var defaultProps = {
    type: "checkbox"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, radius = param.radius, variant = param.variant, color = param.color, autoContrast = param.autoContrast;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--chip-fz": getSize.getFontSize(size),
            "--chip-size": getSize.getSize(size, "chip-size"),
            "--chip-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--chip-checked-padding": getSize.getSize(size, "chip-checked-padding"),
            "--chip-padding": getSize.getSize(size, "chip-padding"),
            "--chip-icon-size": getSize.getSize(size, "chip-icon-size"),
            "--chip-bg": color || variant ? colors.background : void 0,
            "--chip-hover": color || variant ? colors.hover : void 0,
            "--chip-color": color || variant ? colors.color : void 0,
            "--chip-bd": color || variant ? colors.border : void 0,
            "--chip-spacing": getSize.getSize(size, "chip-spacing")
        }
    };
});
var Chip = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Chip", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, id = props.id, checked = props.checked, defaultChecked = props.defaultChecked, onChange = props.onChange, value = props.value, wrapperProps = props.wrapperProps, type = props.type, disabled = props.disabled, children = props.children, size = props.size, variant = props.variant, icon = props.icon, rootRef = props.rootRef, autoContrast = props.autoContrast, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "id",
        "checked",
        "defaultChecked",
        "onChange",
        "value",
        "wrapperProps",
        "type",
        "disabled",
        "children",
        "size",
        "variant",
        "icon",
        "rootRef",
        "autoContrast",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Chip",
        classes: Chip_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var ctx = ChipGroup_context.useChipGroupContext();
    var uuid = hooks.useId(id);
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: checked,
        defaultValue: defaultChecked,
        finalValue: false,
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var contextProps = ctx ? {
        checked: ctx.isChipSelected(value),
        onChange: function(event) {
            ctx.onChange(event);
            onChange === null || onChange === void 0 ? void 0 : onChange(event.currentTarget.checked);
        },
        type: ctx.multiple ? "checkbox" : "radio"
    } : {};
    var _checked = contextProps.checked || _value;
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        size,
        variant,
        ref: rootRef,
        mod
    }, getStyles("root"), styleProps, wrapperProps), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                type
            }, getStyles("input")), {
                checked: _checked,
                onChange: function(event) {
                    return setValue(event.currentTarget.checked);
                },
                id: uuid,
                disabled,
                ref,
                value
            }), contextProps, rest)),
            /* @__PURE__ */ jsxRuntime.jsxs("label", (0, _objectSpreadProps._)((0, _objectSpread._)({
                htmlFor: uuid,
                "data-checked": _checked || void 0,
                "data-disabled": disabled || void 0
            }, getStyles("label", {
                variant: variant || "filled"
            })), {
                children: [
                    _checked && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("iconWrapper")), {
                        children: icon || /* @__PURE__ */ jsxRuntime.jsx(CheckIcon.CheckIcon, (0, _objectSpread._)({}, getStyles("checkIcon")))
                    })),
                    /* @__PURE__ */ jsxRuntime.jsx("span", {
                        children
                    })
                ]
            }))
        ]
    }));
});
Chip.classes = Chip_module;
Chip.displayName = "@mantine/core/Chip";
Chip.Group = ChipGroup.ChipGroup;
exports.Chip = Chip; //# sourceMappingURL=Chip.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","aa43466e5d7cc748":"iKGFf","a1a197c43327e903":"9HEEB","d5de3c27a947a485":"9MtAM","ba86a5171b0b02aa":"kEFEY","a881fe78e55d9a3a":"hIQE6","390d916ea336768f":"8QFOC","5b7904ebba183f62":"2FdJg","bd4285f254728186":"6AMGA","4ff2769747047778":"erSvz","2897bb060966dee1":"kqQOF","a4c4cdf6018b2d4c":"iivvn","22cb25ebba25f940":"8YP4O","7172c60f1569e220":"d0sAY","7cb5f0ddc1e86252":"6L93n","e40547a6eebf54ad":"gkGXc","b38554e16e567d85":"guLFz","5b63507607286ce":"2onWA","a1113447d95ef4b5":"ey93w","5934c29e8fa6b876":"01RS9","7201d8e508afdd6f":"fysam","d23fe26050651ae0":"ahwnY","5606aea20ccc76ba":"jBkf8","868e6b101cf0c4ab":"jQ0Qw","ddb5970a5b0eae7b":"1sCYn","30c60efea08c03b":"3hhF5","3323601551a1118b":"jl1qd","c9d672bf1b7da421":"hdsNB"}],"3hhF5":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("ae81cd23c4dc26e9");
require("8bac5378ef382119");
var createOptionalContext = require("bea353b1562263d3");
require("984794a4afe89b5d");
require("b22ae4cf03a62e9d");
require("d83327f6f73cb3f2");
require("c09bdb2023daf8d0");
require("6a78a0331e6d963a");
require("396c33d34c4f57c1");
require("86583950ff8ae93");
require("fe0be50b92c79a61");
require("50b3dff1bbfc2779");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), ChipGroupProvider = _createOptionalContext_createOptionalContext[0], useChipGroupContext = _createOptionalContext_createOptionalContext[1];
exports.ChipGroupProvider = ChipGroupProvider;
exports.useChipGroupContext = useChipGroupContext; //# sourceMappingURL=ChipGroup.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","ae81cd23c4dc26e9":"9MtAM","8bac5378ef382119":"iKGFf","bea353b1562263d3":"7cMAR","984794a4afe89b5d":"9HEEB","b22ae4cf03a62e9d":"8QFOC","d83327f6f73cb3f2":"2FdJg","c09bdb2023daf8d0":"6AMGA","6a78a0331e6d963a":"erSvz","396c33d34c4f57c1":"kqQOF","86583950ff8ae93":"8YP4O","fe0be50b92c79a61":"gkGXc","50b3dff1bbfc2779":"2onWA"}],"jl1qd":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("995101235d758b89");
var hooks = require("41defd82f08f9c70");
require("33464b3a449dbd5c");
require("840a6c3d2a116033");
require("2235844ffc02c8d5");
require("5849430a098db9fa");
require("438af051b2538e71");
require("12075b6104e963a2");
var useProps = require("294a8536266931b9");
require("485e6d88d10ead65");
require("4367cb41042381cf");
require("f918199ddd768438");
var ChipGroup_context = require("453e3d3c2ef9a47");
var defaultProps = {};
function ChipGroup(props) {
    var _useProps_useProps = useProps.useProps("ChipGroup", defaultProps, props), value = _useProps_useProps.value, defaultValue = _useProps_useProps.defaultValue, onChange = _useProps_useProps.onChange, multiple = _useProps_useProps.multiple, children = _useProps_useProps.children;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: multiple ? [] : null,
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var isChipSelected = function(val) {
        return Array.isArray(_value) ? _value.includes(val) : val === _value;
    };
    var handleChange = function(event) {
        var val = event.currentTarget.value;
        if (Array.isArray(_value)) setValue(_value.includes(val) ? _value.filter(function(v) {
            return v !== val;
        }) : (0, _toConsumableArray._)(_value).concat([
            val
        ]));
        else setValue(val);
    };
    return /* @__PURE__ */ jsxRuntime.jsx(ChipGroup_context.ChipGroupProvider, {
        value: {
            isChipSelected,
            onChange: handleChange,
            multiple
        },
        children
    });
}
ChipGroup.displayName = "@mantine/core/ChipGroup";
exports.ChipGroup = ChipGroup; //# sourceMappingURL=ChipGroup.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","995101235d758b89":"iKGFf","41defd82f08f9c70":"9HEEB","33464b3a449dbd5c":"9MtAM","840a6c3d2a116033":"8QFOC","2235844ffc02c8d5":"2FdJg","5849430a098db9fa":"6AMGA","438af051b2538e71":"erSvz","12075b6104e963a2":"kqQOF","294a8536266931b9":"iivvn","485e6d88d10ead65":"8YP4O","4367cb41042381cf":"gkGXc","f918199ddd768438":"2onWA","453e3d3c2ef9a47":"3hhF5"}],"hdsNB":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f59ffda3",
    "label": "m_be049a53",
    "label--outline": "m_3904c1af",
    "label--filled": "m_fa109255",
    "label--light": "m_f7e165c3",
    "iconWrapper": "m_9ac86df9",
    "checkIcon": "m_d6d72580",
    "input": "m_bde07329"
};
module.exports = classes; //# sourceMappingURL=Chip.module.css.cjs.map

},{}],"9ofTH":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("4b52a23051a4e9e3");
require("917bc53dfcfe8604");
require("2682fbc24963a7e6");
var createVarsResolver = require("d30274a9a0865e52");
require("7b4cc3a193adb1fa");
var getThemeColor = require("6356c4bdb80edfe3");
require("e702f84174054f4d");
require("ed7007d9c68a2911");
require("5a0cf76a76184dee");
require("f36eafb8ec0df3d9");
var useProps = require("caf9ca346a6922d6");
require("8975adba75fab5ce");
var useStyles = require("ca9aed4f3c082207");
var Box = require("9e720a479afee1b5");
var factory = require("7ebe201bf96b7da5");
require("4aee909d9b54bcf4");
var Code_module = require("143ff9098e782293");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color;
    return {
        root: {
            "--code-bg": color ? getThemeColor.getThemeColor(color, theme) : void 0
        }
    };
});
var Code = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Code", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, color = props.color, block = props.block, variant = props.variant, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "block",
        "variant",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Code",
        props,
        classes: Code_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: block ? "pre" : "code",
        variant,
        ref,
        mod: [
            {
                block
            },
            mod
        ]
    }, getStyles("root"), others), {
        dir: "ltr"
    }));
});
Code.classes = Code_module;
Code.displayName = "@mantine/core/Code";
exports.Code = Code; //# sourceMappingURL=Code.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","4b52a23051a4e9e3":"iKGFf","917bc53dfcfe8604":"9MtAM","2682fbc24963a7e6":"9HEEB","d30274a9a0865e52":"hIQE6","7b4cc3a193adb1fa":"8QFOC","6356c4bdb80edfe3":"eeaIN","e702f84174054f4d":"2FdJg","ed7007d9c68a2911":"6AMGA","5a0cf76a76184dee":"erSvz","f36eafb8ec0df3d9":"kqQOF","caf9ca346a6922d6":"iivvn","8975adba75fab5ce":"8YP4O","ca9aed4f3c082207":"d0sAY","9e720a479afee1b5":"gkGXc","7ebe201bf96b7da5":"guLFz","4aee909d9b54bcf4":"2onWA","143ff9098e782293":"7LzLF"}],"7LzLF":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_b183c0a2"
};
module.exports = classes; //# sourceMappingURL=Code.module.css.cjs.map

},{}],"7R7jd":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("89c91e258c5a66c2");
var React = require("d30a5599fa1c3d97");
var hooks = require("d7eddcfbf0a2a7b8");
var getSize = require("8b478da30a80f199");
var createVarsResolver = require("6bb63377acb93767");
require("cd213ff2f144f1e5");
require("f2c6b2deaf768669");
require("c902e8f00b78aa55");
require("83e1dac3c2e9ea1d");
require("5f4169a65e662f51");
var useProps = require("d15c3a38d252fd80");
require("43ea6b26547221b6");
var useStyles = require("223f9258fcb54a1c");
var Box = require("52e1f8fb6155856a");
var factory = require("33efd1c7cc6f7be9");
require("c9b59668eb5a39ab");
var ColorSwatch = require("aaf3cb063fd728f9");
var AlphaSlider = require("65dc887d3a6cc15b");
var ColorPicker_context = require("2a3d71f986e1fba0");
var converters = require("be1dc054235aa144");
var parsers = require("bc51a003da497ad0");
var HueSlider = require("2f706bf205a8fda9");
var Saturation = require("8b14442da4018dfe");
var Swatches = require("17887ded72341a85");
var ColorPicker_module = require("a1a836c2522de86a");
var defaultProps = {
    swatchesPerRow: 7,
    withPicker: true,
    focusable: true,
    size: "md",
    __staticSelector: "ColorPicker"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, swatchesPerRow = param.swatchesPerRow;
    return {
        wrapper: {
            "--cp-preview-size": getSize.getSize(size, "cp-preview-size"),
            "--cp-width": getSize.getSize(size, "cp-width"),
            "--cp-body-spacing": getSize.getSpacing(size),
            "--cp-swatch-size": `${100 / swatchesPerRow}%`,
            "--cp-thumb-size": getSize.getSize(size, "cp-thumb-size"),
            "--cp-saturation-height": getSize.getSize(size, "cp-saturation-height")
        }
    };
});
var ColorPicker = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ColorPicker", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, format = props.format, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, onChangeEnd = props.onChangeEnd, withPicker = props.withPicker, size = props.size, saturationLabel = props.saturationLabel, hueLabel = props.hueLabel, alphaLabel = props.alphaLabel, focusable = props.focusable, swatches = props.swatches, swatchesPerRow = props.swatchesPerRow, fullWidth = props.fullWidth, onColorSwatchClick = props.onColorSwatchClick, __staticSelector = props.__staticSelector, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "format",
        "value",
        "defaultValue",
        "onChange",
        "onChangeEnd",
        "withPicker",
        "size",
        "saturationLabel",
        "hueLabel",
        "alphaLabel",
        "focusable",
        "swatches",
        "swatchesPerRow",
        "fullWidth",
        "onColorSwatchClick",
        "__staticSelector",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: __staticSelector,
        props,
        classes: ColorPicker_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "wrapper",
        vars,
        varsResolver
    });
    var formatRef = React.useRef(format);
    var valueRef = React.useRef("");
    var scrubTimeoutRef = React.useRef(-1);
    var isScrubbingRef = React.useRef(false);
    var withAlpha = format === "hexa" || format === "rgba" || format === "hsla";
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: "#FFFFFF",
        onChange
    }), 3), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1], controlled = _hooks_useUncontrolled[2];
    var _React_useState = (0, _slicedToArray._)(React.useState(parsers.parseColor(_value)), 2), parsed = _React_useState[0], setParsed = _React_useState[1];
    var startScrubbing = function() {
        window.clearTimeout(scrubTimeoutRef.current);
        isScrubbingRef.current = true;
    };
    var stopScrubbing = function() {
        window.clearTimeout(scrubTimeoutRef.current);
        scrubTimeoutRef.current = window.setTimeout(function() {
            isScrubbingRef.current = false;
        }, 200);
    };
    var handleChange = function(color) {
        setParsed(function(current) {
            var next = (0, _objectSpread._)({}, current, color);
            valueRef.current = converters.convertHsvaTo(formatRef.current, next);
            return next;
        });
        setValue(valueRef.current);
    };
    hooks.useDidUpdate(function() {
        if (parsers.isColorValid(value) && !isScrubbingRef.current) setParsed(parsers.parseColor(value));
    }, [
        value
    ]);
    hooks.useDidUpdate(function() {
        formatRef.current = format;
        setValue(converters.convertHsvaTo(format, parsed));
    }, [
        format
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(ColorPicker_context.ColorPickerProvider, {
        value: {
            getStyles,
            unstyled
        },
        children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            ref
        }, getStyles("wrapper")), {
            size,
            mod: [
                {
                    "full-width": fullWidth
                },
                mod
            ]
        }), others), {
            children: [
                withPicker && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
                    children: [
                        /* @__PURE__ */ jsxRuntime.jsx(Saturation.Saturation, {
                            value: parsed,
                            onChange: handleChange,
                            onChangeEnd: function(param) {
                                var s = param.s, v = param.v;
                                return onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(converters.convertHsvaTo(formatRef.current, (0, _objectSpreadProps._)((0, _objectSpread._)({}, parsed), {
                                    s,
                                    v
                                })));
                            },
                            color: _value,
                            size,
                            focusable,
                            saturationLabel,
                            onScrubStart: startScrubbing,
                            onScrubEnd: stopScrubbing
                        }),
                        /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("body")), {
                            children: [
                                /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("sliders")), {
                                    children: [
                                        /* @__PURE__ */ jsxRuntime.jsx(HueSlider.HueSlider, {
                                            value: parsed.h,
                                            onChange: function(h) {
                                                return handleChange({
                                                    h
                                                });
                                            },
                                            onChangeEnd: function(h) {
                                                return onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(converters.convertHsvaTo(formatRef.current, (0, _objectSpreadProps._)((0, _objectSpread._)({}, parsed), {
                                                    h
                                                })));
                                            },
                                            size,
                                            focusable,
                                            "aria-label": hueLabel,
                                            onScrubStart: startScrubbing,
                                            onScrubEnd: stopScrubbing
                                        }),
                                        withAlpha && /* @__PURE__ */ jsxRuntime.jsx(AlphaSlider.AlphaSlider, {
                                            value: parsed.a,
                                            onChange: function(a) {
                                                return handleChange({
                                                    a
                                                });
                                            },
                                            onChangeEnd: function(a) {
                                                onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(converters.convertHsvaTo(formatRef.current, (0, _objectSpreadProps._)((0, _objectSpread._)({}, parsed), {
                                                    a
                                                })));
                                            },
                                            size,
                                            color: converters.convertHsvaTo("hex", parsed),
                                            focusable,
                                            "aria-label": alphaLabel,
                                            onScrubStart: startScrubbing,
                                            onScrubEnd: stopScrubbing
                                        })
                                    ]
                                })),
                                withAlpha && /* @__PURE__ */ jsxRuntime.jsx(ColorSwatch.ColorSwatch, (0, _objectSpread._)({
                                    color: _value,
                                    radius: "sm",
                                    size: "var(--cp-preview-size)"
                                }, getStyles("preview")))
                            ]
                        }))
                    ]
                }),
                Array.isArray(swatches) && /* @__PURE__ */ jsxRuntime.jsx(Swatches.Swatches, {
                    data: swatches,
                    swatchesPerRow,
                    focusable,
                    setValue,
                    onChangeEnd: function(color) {
                        var convertedColor = converters.convertHsvaTo(format, parsers.parseColor(color));
                        onColorSwatchClick === null || onColorSwatchClick === void 0 ? void 0 : onColorSwatchClick(convertedColor);
                        onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(convertedColor);
                        if (!controlled) setParsed(parsers.parseColor(color));
                    }
                })
            ]
        }))
    });
});
ColorPicker.classes = ColorPicker_module;
ColorPicker.displayName = "@mantine/core/ColorPicker";
exports.ColorPicker = ColorPicker; //# sourceMappingURL=ColorPicker.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","89c91e258c5a66c2":"iKGFf","d30a5599fa1c3d97":"9MtAM","d7eddcfbf0a2a7b8":"9HEEB","8b478da30a80f199":"kEFEY","6bb63377acb93767":"hIQE6","cd213ff2f144f1e5":"8QFOC","f2c6b2deaf768669":"2FdJg","c902e8f00b78aa55":"6AMGA","83e1dac3c2e9ea1d":"erSvz","5f4169a65e662f51":"kqQOF","d15c3a38d252fd80":"iivvn","43ea6b26547221b6":"8YP4O","223f9258fcb54a1c":"d0sAY","52e1f8fb6155856a":"gkGXc","33efd1c7cc6f7be9":"guLFz","c9b59668eb5a39ab":"2onWA","aaf3cb063fd728f9":"kA5X0","65dc887d3a6cc15b":"jcxTp","2a3d71f986e1fba0":"hU08M","be1dc054235aa144":"7kml4","bc51a003da497ad0":"6uVVj","2f706bf205a8fda9":"ijPsx","8b14442da4018dfe":"9wbt4","17887ded72341a85":"6ThFc","a1a836c2522de86a":"Tmeux"}],"kA5X0":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2e1c969e76a47da4");
var rem = require("7618000bef52c668");
require("eabedd98bb28a1c5");
var getSize = require("fe611f838e9cc5b4");
require("2028de9b586a24ff");
var createVarsResolver = require("1cc82a3b932ccf32");
require("af07c2512a30d7ce");
require("3e314f111003d90b");
require("fa025e74cf6cb593");
require("cd75865d99b78a8");
require("272cd0f88381bdc4");
var useProps = require("95d8ee53f7d56aa");
require("cca115dffbca4012");
var useStyles = require("e31a4e27661041fb");
var Box = require("1ee7e2ad4c6ff9c6");
var polymorphicFactory = require("61c7301683aab1c1");
require("f415df4fc32260d2");
var ColorSwatch_module = require("ccfbe2c70e67180a");
var defaultProps = {
    withShadow: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius, size = param.size;
    return {
        root: {
            "--cs-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--cs-size": rem.rem(size)
        }
    };
});
var ColorSwatch = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("ColorSwatch", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("ColorSwatch", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, vars = _useProps_useProps.vars, color = _useProps_useProps.color, size = _useProps_useProps.size, radius = _useProps_useProps.radius, withShadow = _useProps_useProps.withShadow, children = _useProps_useProps.children, variant = _useProps_useProps.variant, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "size",
        "radius",
        "withShadow",
        "children",
        "variant"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ColorSwatch",
        props,
        classes: ColorSwatch_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        variant,
        size
    }, getStyles("root", {
        focusable: true
    }), others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpread._)({}, getStyles("alphaOverlay"))),
            withShadow && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpread._)({}, getStyles("shadowOverlay"))),
            /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpread._)({}, getStyles("colorOverlay", {
                style: {
                    backgroundColor: color
                }
            }))),
            /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("childrenOverlay")), {
                children
            }))
        ]
    }));
});
ColorSwatch.classes = ColorSwatch_module;
ColorSwatch.displayName = "@mantine/core/ColorSwatch";
exports.ColorSwatch = ColorSwatch; //# sourceMappingURL=ColorSwatch.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","2e1c969e76a47da4":"iKGFf","7618000bef52c668":"ebAaL","eabedd98bb28a1c5":"9MtAM","fe611f838e9cc5b4":"kEFEY","2028de9b586a24ff":"9HEEB","1cc82a3b932ccf32":"hIQE6","af07c2512a30d7ce":"8QFOC","3e314f111003d90b":"2FdJg","fa025e74cf6cb593":"6AMGA","cd75865d99b78a8":"erSvz","272cd0f88381bdc4":"kqQOF","95d8ee53f7d56aa":"iivvn","cca115dffbca4012":"8YP4O","e31a4e27661041fb":"d0sAY","1ee7e2ad4c6ff9c6":"gkGXc","61c7301683aab1c1":"iYAEL","f415df4fc32260d2":"2onWA","ccfbe2c70e67180a":"5ggAN"}],"5ggAN":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_de3d2490",
    "colorOverlay": "m_862f3d1b",
    "shadowOverlay": "m_98ae7f22",
    "alphaOverlay": "m_95709ac0",
    "childrenOverlay": "m_93e74e3"
};
module.exports = classes; //# sourceMappingURL=ColorSwatch.module.css.cjs.map

},{}],"jcxTp":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("597b25db319eac49");
var React = require("b427173e0065f201");
var rem = require("89dc723e858f1dbb");
require("4fe579641694f502");
require("6ed974aae6117727");
require("cadee3b0b2b5a145");
require("46d120c70ad57a0f");
require("7d15fcf58ade29f6");
require("c3b8ddf7e350053f");
var useProps = require("26c936dd41491a11");
require("d9f3c8127bd5f04e");
require("93c9ffb410354b38");
require("6bf144b50d315d21");
var ColorSlider = require("9617671b20e6b30a");
var parsers = require("ddf89b11bba9c5cc");
var defaultProps = {};
var AlphaSlider = React.forwardRef(function(props, ref) {
    var _useProps_useProps = useProps.useProps("AlphaSlider", defaultProps, props), value = _useProps_useProps.value, onChange = _useProps_useProps.onChange, onChangeEnd = _useProps_useProps.onChangeEnd, color = _useProps_useProps.color, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "value",
        "onChange",
        "onChangeEnd",
        "color"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(ColorSlider.ColorSlider, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref,
        value,
        onChange: function(val) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(parsers.round(val, 2));
        },
        onChangeEnd: function(val) {
            return onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(parsers.round(val, 2));
        },
        maxValue: 1,
        round: false,
        "data-alpha": true,
        overlays: [
            {
                backgroundImage: "linear-gradient(45deg, var(--slider-checkers) 25%, transparent 25%), linear-gradient(-45deg, var(--slider-checkers) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, var(--slider-checkers) 75%), linear-gradient(-45deg, var(--mantine-color-body) 75%, var(--slider-checkers) 75%)",
                backgroundSize: `${rem.rem(8)} ${rem.rem(8)}`,
                backgroundPosition: `0 0, 0 ${rem.rem(4)}, ${rem.rem(4)} ${rem.rem(-4)}, ${rem.rem(-4)} 0`
            },
            {
                backgroundImage: `linear-gradient(90deg, transparent, ${color})`
            },
            {
                boxShadow: `rgba(0, 0, 0, .1) 0 0 0 ${rem.rem(1)} inset, rgb(0, 0, 0, .15) 0 0 ${rem.rem(4)} inset`
            }
        ]
    }));
});
AlphaSlider.displayName = "@mantine/core/AlphaSlider";
exports.AlphaSlider = AlphaSlider; //# sourceMappingURL=AlphaSlider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","597b25db319eac49":"iKGFf","b427173e0065f201":"9MtAM","89dc723e858f1dbb":"ebAaL","4fe579641694f502":"9HEEB","6ed974aae6117727":"8QFOC","cadee3b0b2b5a145":"2FdJg","46d120c70ad57a0f":"6AMGA","7d15fcf58ade29f6":"erSvz","c3b8ddf7e350053f":"kqQOF","26c936dd41491a11":"iivvn","d9f3c8127bd5f04e":"8YP4O","93c9ffb410354b38":"gkGXc","6bf144b50d315d21":"2onWA","9617671b20e6b30a":"1emKU","ddf89b11bba9c5cc":"6uVVj"}],"1emKU":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("a0324c1a7f8b2d38");
var React = require("989efda5ec20e7b2");
var hooks = require("5a70d192c6605ab");
var rem = require("90285c3eb6aee331");
require("ec9b73fe55678430");
require("6b464cc2cd2efda8");
require("83abf3e753c92a10");
require("c7efcc3bc0746e04");
var MantineThemeProvider = require("44253b773d052d6c");
var useProps = require("3ccc2498b4973640");
require("dd8334180a54042f");
var useStyles = require("12acfdf1b7a69b4");
var Box = require("3df9fa65f7e02a50");
var factory = require("15980b655fc5f228");
require("1c5f3aef5fd3425d");
var ColorPicker_context = require("28110feea151a22");
var Thumb = require("55c0ff14c2320c81");
var ColorPicker_module = require("7ad9e9a7f9e03645");
var defaultProps = {};
var ColorSlider = factory.factory(function(_props, ref) {
    var _ColorPicker_context_useColorPickerContext;
    var props = useProps.useProps("ColorSlider", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, onChange = props.onChange, onChangeEnd = props.onChangeEnd, maxValue = props.maxValue, round = props.round, _props_size = props.size, size = _props_size === void 0 ? "md" : _props_size, _props_focusable = props.focusable, focusable = _props_focusable === void 0 ? true : _props_focusable, value = props.value, overlays = props.overlays, _props_thumbColor = props.thumbColor, thumbColor = _props_thumbColor === void 0 ? "transparent" : _props_thumbColor, onScrubStart = props.onScrubStart, onScrubEnd = props.onScrubEnd, _props___staticSelector = props.__staticSelector, __staticSelector = _props___staticSelector === void 0 ? "ColorPicker" : _props___staticSelector, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "onChange",
        "onChangeEnd",
        "maxValue",
        "round",
        "size",
        "focusable",
        "value",
        "overlays",
        "thumbColor",
        "onScrubStart",
        "onScrubEnd",
        "__staticSelector"
    ]);
    var _getStyles = useStyles.useStyles({
        name: __staticSelector,
        classes: ColorPicker_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled
    });
    var ctxGetStyles = (_ColorPicker_context_useColorPickerContext = ColorPicker_context.useColorPickerContext()) === null || _ColorPicker_context_useColorPickerContext === void 0 ? void 0 : _ColorPicker_context_useColorPickerContext.getStyles;
    var getStyles = ctxGetStyles || _getStyles;
    var theme = MantineThemeProvider.useMantineTheme();
    var _React_useState = (0, _slicedToArray._)(React.useState({
        y: 0,
        x: value / maxValue
    }), 2), position = _React_useState[0], setPosition = _React_useState[1];
    var positionRef = React.useRef(position);
    var getChangeValue = function(val) {
        return round ? Math.round(val * maxValue) : val * maxValue;
    };
    var _hooks_useMove = hooks.useMove(function(param) {
        var x = param.x, y = param.y;
        positionRef.current = {
            x,
            y
        };
        onChange === null || onChange === void 0 ? void 0 : onChange(getChangeValue(x));
    }, {
        onScrubEnd: function() {
            var x = positionRef.current.x;
            onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(getChangeValue(x));
            onScrubEnd === null || onScrubEnd === void 0 ? void 0 : onScrubEnd();
        },
        onScrubStart
    }), sliderRef = _hooks_useMove.ref;
    hooks.useDidUpdate(function() {
        setPosition({
            y: 0,
            x: value / maxValue
        });
    }, [
        value
    ]);
    var handleArrow = function(event, pos) {
        event.preventDefault();
        var _position = hooks.clampUseMovePosition(pos);
        onChange === null || onChange === void 0 ? void 0 : onChange(getChangeValue(_position.x));
        onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(getChangeValue(_position.x));
    };
    var handleKeyDown = function(event) {
        switch(event.key){
            case "ArrowRight":
                handleArrow(event, {
                    x: position.x + 0.05,
                    y: position.y
                });
                break;
            case "ArrowLeft":
                handleArrow(event, {
                    x: position.x - 0.05,
                    y: position.y
                });
                break;
        }
    };
    var layers = overlays.map(function(overlay, index) {
        return /* @__PURE__ */ React.createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("sliderOverlay")), {
            style: overlay,
            key: index
        }));
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref: hooks.useMergedRef(sliderRef, ref)
    }), getStyles("slider")), {
        role: "slider",
        "aria-valuenow": value,
        "aria-valuemax": maxValue,
        "aria-valuemin": 0,
        tabIndex: focusable ? 0 : -1,
        onKeyDown: handleKeyDown,
        "data-focus-ring": theme.focusRing,
        __vars: {
            "--cp-thumb-size": `var(--cp-thumb-size-${size})`
        },
        children: [
            layers,
            /* @__PURE__ */ jsxRuntime.jsx(Thumb.Thumb, (0, _objectSpread._)({
                position
            }, getStyles("thumb", {
                style: {
                    top: rem.rem(1),
                    background: thumbColor
                }
            })))
        ]
    }));
});
ColorSlider.displayName = "@mantine/core/ColorSlider";
exports.ColorSlider = ColorSlider; //# sourceMappingURL=ColorSlider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","a0324c1a7f8b2d38":"iKGFf","989efda5ec20e7b2":"9MtAM","5a70d192c6605ab":"9HEEB","90285c3eb6aee331":"ebAaL","ec9b73fe55678430":"8QFOC","6b464cc2cd2efda8":"2FdJg","83abf3e753c92a10":"6AMGA","c7efcc3bc0746e04":"erSvz","44253b773d052d6c":"kqQOF","3ccc2498b4973640":"iivvn","dd8334180a54042f":"8YP4O","12acfdf1b7a69b4":"d0sAY","3df9fa65f7e02a50":"gkGXc","15980b655fc5f228":"guLFz","1c5f3aef5fd3425d":"2onWA","28110feea151a22":"hU08M","55c0ff14c2320c81":"5AePV","7ad9e9a7f9e03645":"Tmeux"}],"hU08M":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("91fe39d1c1125085");
require("2b8ac4b027ac0d7d");
var createOptionalContext = require("b526b90c73888ba6");
require("52b4fa987b36f56d");
require("8f1202cbd502744f");
require("5a5f471b67a19895");
require("f6b750477e842bac");
require("c50b7d532809a946");
require("ce0d7792a88cf91e");
require("c5ff5fb1eef56da5");
require("932414eb23abf77f");
require("cc775168008d4bd5");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(null), 2), ColorPickerProvider = _createOptionalContext_createOptionalContext[0], useColorPickerContext = _createOptionalContext_createOptionalContext[1];
exports.ColorPickerProvider = ColorPickerProvider;
exports.useColorPickerContext = useColorPickerContext; //# sourceMappingURL=ColorPicker.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","91fe39d1c1125085":"9MtAM","2b8ac4b027ac0d7d":"iKGFf","b526b90c73888ba6":"7cMAR","52b4fa987b36f56d":"9HEEB","8f1202cbd502744f":"8QFOC","5a5f471b67a19895":"2FdJg","f6b750477e842bac":"6AMGA","c50b7d532809a946":"erSvz","ce0d7792a88cf91e":"kqQOF","c5ff5fb1eef56da5":"8YP4O","932414eb23abf77f":"gkGXc","cc775168008d4bd5":"2onWA"}],"5AePV":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("82d41eadb5e8d3cc");
var React = require("bf190dda39dda098");
require("6a0be0d4ee227da5");
require("58ae7e5a9b8617b2");
require("ef537c92c7b2ed04");
require("8868bdd949762960");
require("96ac80ba190578ee");
require("da2c8cdc9a950363");
require("be3499b18a6cb938");
var Box = require("ae2b5cf3a08f9c30");
require("c9d9599ab41617ef");
var Thumb = React.forwardRef(function(_param, ref) {
    var position = _param.position, others = (0, _objectWithoutProperties._)(_param, [
        "position"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref,
        __vars: {
            "--thumb-y-offset": `${position.y * 100}%`,
            "--thumb-x-offset": `${position.x * 100}%`
        }
    }, others));
});
Thumb.displayName = "@mantine/core/ColorPickerThumb";
exports.Thumb = Thumb; //# sourceMappingURL=Thumb.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","82d41eadb5e8d3cc":"iKGFf","bf190dda39dda098":"9MtAM","6a0be0d4ee227da5":"9HEEB","58ae7e5a9b8617b2":"8QFOC","ef537c92c7b2ed04":"2FdJg","8868bdd949762960":"6AMGA","96ac80ba190578ee":"erSvz","da2c8cdc9a950363":"kqQOF","be3499b18a6cb938":"8YP4O","ae2b5cf3a08f9c30":"gkGXc","c9d9599ab41617ef":"2onWA"}],"Tmeux":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "wrapper": "m_fee9c77",
    "preview": "m_9dddfbac",
    "body": "m_bffecc3e",
    "sliders": "m_3283bb96",
    "thumb": "m_40d572ba",
    "swatch": "m_d8ee6fd8",
    "swatches": "m_5711e686",
    "saturation": "m_202a296e",
    "saturationOverlay": "m_11b3db02",
    "slider": "m_d856d47d",
    "sliderOverlay": "m_8f327113"
};
module.exports = classes; //# sourceMappingURL=ColorPicker.module.css.cjs.map

},{}],"6uVVj":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
function round(number) {
    var digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, base = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Math.pow(10, digits);
    return Math.round(base * number) / base;
}
function hslaToHsva(param) {
    var h = param.h, s = param.s, l = param.l, a = param.a;
    var ss = s * ((l < 50 ? l : 100 - l) / 100);
    return {
        h,
        s: ss > 0 ? 2 * ss / (l + ss) * 100 : 0,
        v: l + ss,
        a
    };
}
var angleUnits = {
    grad: 0.9,
    turn: 360,
    rad: 360 / (Math.PI * 2)
};
function parseHue(value) {
    var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "deg";
    return Number(value) * (angleUnits[unit] || 1);
}
var HSL_REGEXP = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
function parseHsla(color) {
    var match = HSL_REGEXP.exec(color);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return hslaToHsva({
        h: parseHue(match[1], match[2]),
        s: Number(match[3]),
        l: Number(match[4]),
        a: match[5] === void 0 ? 1 : Number(match[5]) / (match[6] ? 100 : 1)
    });
}
function rgbaToHsva(param) {
    var r = param.r, g = param.g, b = param.b, a = param.a;
    var max = Math.max(r, g, b);
    var delta = max - Math.min(r, g, b);
    var hh = delta ? max === r ? (g - b) / delta : max === g ? 2 + (b - r) / delta : 4 + (r - g) / delta : 0;
    return {
        h: round(60 * (hh < 0 ? hh + 6 : hh), 3),
        s: round(max ? delta / max * 100 : 0, 3),
        v: round(max / 255 * 100, 3),
        a
    };
}
function parseHex(color) {
    var hex = color[0] === "#" ? color.slice(1) : color;
    if (hex.length === 3) return rgbaToHsva({
        r: parseInt(hex[0] + hex[0], 16),
        g: parseInt(hex[1] + hex[1], 16),
        b: parseInt(hex[2] + hex[2], 16),
        a: 1
    });
    return rgbaToHsva({
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16),
        a: 1
    });
}
function parseHexa(color) {
    var hex = color[0] === "#" ? color.slice(1) : color;
    var roundA = function(a2) {
        return round(parseInt(a2, 16) / 255, 3);
    };
    if (hex.length === 4) {
        var withoutOpacity2 = hex.slice(0, 3);
        var a2 = roundA(hex[3] + hex[3]);
        var hsvaColor2 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, parseHex(withoutOpacity2)), {
            a: a2
        });
        return hsvaColor2;
    }
    var withoutOpacity = hex.slice(0, 6);
    var a = roundA(hex.slice(6, 8));
    var hsvaColor = (0, _objectSpreadProps._)((0, _objectSpread._)({}, parseHex(withoutOpacity)), {
        a
    });
    return hsvaColor;
}
var RGB_REGEXP = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
function parseRgba(color) {
    var match = RGB_REGEXP.exec(color);
    if (!match) return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    return rgbaToHsva({
        r: Number(match[1]) / (match[2] ? 100 / 255 : 1),
        g: Number(match[3]) / (match[4] ? 100 / 255 : 1),
        b: Number(match[5]) / (match[6] ? 100 / 255 : 1),
        a: match[7] === void 0 ? 1 : Number(match[7]) / (match[8] ? 100 : 1)
    });
}
var VALIDATION_REGEXP = {
    hex: /^#?([0-9A-F]{3}){1,2}$/i,
    hexa: /^#?([0-9A-F]{4}){1,2}$/i,
    rgb: /^rgb\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
    rgba: /^rgba\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i,
    hsl: /hsl\(\s*(\d+)\s*,\s*(\d+(?:\.\d+)?%)\s*,\s*(\d+(?:\.\d+)?%)\)/i,
    hsla: /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/i
};
var CONVERTERS = {
    hex: parseHex,
    hexa: parseHexa,
    rgb: parseRgba,
    rgba: parseRgba,
    hsl: parseHsla,
    hsla: parseHsla
};
function isColorValid(color) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(VALIDATION_REGEXP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), regexp = _step_value[1];
            if (regexp.test(color)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function parseColor(color) {
    if (typeof color !== "string") return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
    if (color === "transparent") return {
        h: 0,
        s: 0,
        v: 0,
        a: 0
    };
    var trimmed = color.trim();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(VALIDATION_REGEXP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), rule = _step_value[0], regexp = _step_value[1];
            if (regexp.test(trimmed)) return CONVERTERS[rule](trimmed);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}
exports.isColorValid = isColorValid;
exports.parseColor = parseColor;
exports.parseHex = parseHex;
exports.parseHexa = parseHexa;
exports.parseHsla = parseHsla;
exports.parseHue = parseHue;
exports.parseRgba = parseRgba;
exports.round = round; //# sourceMappingURL=parsers.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5"}],"7kml4":[function(require,module,exports) {
"use client";
"use strict";
var parsers = require("9f6380ed34773a3b");
function hsvaToRgbaObject(param) {
    var h = param.h, s = param.s, v = param.v, a = param.a;
    var _h = h / 360 * 6;
    var _s = s / 100;
    var _v = v / 100;
    var hh = Math.floor(_h);
    var l = _v * (1 - _s);
    var c = _v * (1 - (_h - hh) * _s);
    var d = _v * (1 - (1 - _h + hh) * _s);
    var module = hh % 6;
    return {
        r: parsers.round([
            _v,
            c,
            l,
            l,
            d,
            _v
        ][module] * 255),
        g: parsers.round([
            d,
            _v,
            _v,
            c,
            l,
            l
        ][module] * 255),
        b: parsers.round([
            l,
            l,
            d,
            _v,
            _v,
            c
        ][module] * 255),
        a: parsers.round(a, 2)
    };
}
function hsvaToRgba(color, includeAlpha) {
    var _hsvaToRgbaObject = hsvaToRgbaObject(color), r = _hsvaToRgbaObject.r, g = _hsvaToRgbaObject.g, b = _hsvaToRgbaObject.b, a = _hsvaToRgbaObject.a;
    if (!includeAlpha) return `rgb(${r}, ${g}, ${b})`;
    return `rgba(${r}, ${g}, ${b}, ${parsers.round(a, 2)})`;
}
function hsvaToHsl(param, includeAlpha) {
    var h = param.h, s = param.s, v = param.v, a = param.a;
    var hh = (200 - s) * v / 100;
    var result = {
        h: Math.round(h),
        s: Math.round(hh > 0 && hh < 200 ? s * v / 100 / (hh <= 100 ? hh : 200 - hh) * 100 : 0),
        l: Math.round(hh / 2)
    };
    if (!includeAlpha) return `hsl(${result.h}, ${result.s}%, ${result.l}%)`;
    return `hsla(${result.h}, ${result.s}%, ${result.l}%, ${parsers.round(a, 2)})`;
}
function formatHexPart(number) {
    var hex = number.toString(16);
    return hex.length < 2 ? `0${hex}` : hex;
}
function hsvaToHex(color) {
    var _hsvaToRgbaObject = hsvaToRgbaObject(color), r = _hsvaToRgbaObject.r, g = _hsvaToRgbaObject.g, b = _hsvaToRgbaObject.b;
    return `#${formatHexPart(r)}${formatHexPart(g)}${formatHexPart(b)}`;
}
function hsvaToHexa(color) {
    var a = Math.round(color.a * 255);
    return `${hsvaToHex(color)}${formatHexPart(a)}`;
}
var CONVERTERS = {
    hex: hsvaToHex,
    hexa: function(color) {
        return hsvaToHexa(color);
    },
    rgb: function(color) {
        return hsvaToRgba(color, false);
    },
    rgba: function(color) {
        return hsvaToRgba(color, true);
    },
    hsl: function(color) {
        return hsvaToHsl(color, false);
    },
    hsla: function(color) {
        return hsvaToHsl(color, true);
    }
};
function convertHsvaTo(format, color) {
    if (!color) return "#000000";
    if (!(format in CONVERTERS)) return CONVERTERS.hex(color);
    return CONVERTERS[format](color);
}
exports.convertHsvaTo = convertHsvaTo;
exports.hsvaToHex = hsvaToHex;
exports.hsvaToHexa = hsvaToHexa;
exports.hsvaToHsl = hsvaToHsl;
exports.hsvaToRgba = hsvaToRgba;
exports.hsvaToRgbaObject = hsvaToRgbaObject; //# sourceMappingURL=converters.cjs.map

},{"9f6380ed34773a3b":"6uVVj"}],"ijPsx":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("be3464218ac8975e");
var React = require("1ff1d24132f2e45a");
var rem = require("2d3bb8723f3541b8");
require("b01d91dfc4f10be4");
require("92c3f4a67dea0238");
require("dead6dfebc19108b");
require("6d67f2edd2e0839");
require("ea1075d5b48180d6");
require("362fac62f2304d31");
var useProps = require("8f822981810afcd0");
require("aa736eb106a22ef8");
require("526bef9427d91be7");
require("315a05e5d2968e8a");
var ColorSlider = require("cfd01e19c9c108d2");
var HueSlider = React.forwardRef(function(props, ref) {
    var _useProps_useProps = useProps.useProps("HueSlider", {}, props), value = _useProps_useProps.value, onChange = _useProps_useProps.onChange, onChangeEnd = _useProps_useProps.onChangeEnd, color = _useProps_useProps.color, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "value",
        "onChange",
        "onChangeEnd",
        "color"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(ColorSlider.ColorSlider, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        ref,
        value,
        onChange,
        onChangeEnd,
        maxValue: 360,
        thumbColor: `hsl(${value}, 100%, 50%)`,
        round: true,
        "data-hue": true,
        overlays: [
            {
                backgroundImage: "linear-gradient(to right,hsl(0,100%,50%),hsl(60,100%,50%),hsl(120,100%,50%),hsl(170,100%,50%),hsl(240,100%,50%),hsl(300,100%,50%),hsl(360,100%,50%))"
            },
            {
                boxShadow: `rgba(0, 0, 0, .1) 0 0 0 ${rem.rem(1)} inset, rgb(0, 0, 0, .15) 0 0 ${rem.rem(4)} inset`
            }
        ]
    }));
});
HueSlider.displayName = "@mantine/core/HueSlider";
exports.HueSlider = HueSlider; //# sourceMappingURL=HueSlider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","be3464218ac8975e":"iKGFf","1ff1d24132f2e45a":"9MtAM","2d3bb8723f3541b8":"ebAaL","b01d91dfc4f10be4":"9HEEB","92c3f4a67dea0238":"8QFOC","dead6dfebc19108b":"2FdJg","6d67f2edd2e0839":"6AMGA","ea1075d5b48180d6":"erSvz","362fac62f2304d31":"kqQOF","8f822981810afcd0":"iivvn","aa736eb106a22ef8":"8YP4O","526bef9427d91be7":"gkGXc","315a05e5d2968e8a":"2onWA","cfd01e19c9c108d2":"1emKU"}],"9wbt4":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("c46f044467dc1b6d");
var React = require("3a322404e5c8e022");
var hooks = require("17d1e999d60db58a");
require("5e5668709f2af199");
require("a648d3748d612079");
require("df669c324455dc25");
require("b45d12da90cc1b");
require("c9dee90622797d6c");
require("5f207d51127af80a");
var Box = require("e0a876bb9e021c33");
require("f6f9560cc78db8fa");
var ColorPicker_context = require("9195b54c4022ec51");
var converters = require("a0a7b274876d616d");
var Thumb = require("cfec9fb7d423c758");
function Saturation(_param) {
    var className = _param.className, onChange = _param.onChange, onChangeEnd = _param.onChangeEnd, value = _param.value, saturationLabel = _param.saturationLabel, _param_focusable = _param.focusable, focusable = _param_focusable === void 0 ? true : _param_focusable, size = _param.size, color = _param.color, onScrubStart = _param.onScrubStart, onScrubEnd = _param.onScrubEnd, others = (0, _objectWithoutProperties._)(_param, [
        "className",
        "onChange",
        "onChangeEnd",
        "value",
        "saturationLabel",
        "focusable",
        "size",
        "color",
        "onScrubStart",
        "onScrubEnd"
    ]);
    var getStyles = ColorPicker_context.useColorPickerContext().getStyles;
    var _React_useState = (0, _slicedToArray._)(React.useState({
        x: value.s / 100,
        y: 1 - value.v / 100
    }), 2), position = _React_useState[0], setPosition = _React_useState[1];
    var positionRef = React.useRef(position);
    var ref = hooks.useMove(function(param) {
        var x = param.x, y = param.y;
        positionRef.current = {
            x,
            y
        };
        onChange({
            s: Math.round(x * 100),
            v: Math.round((1 - y) * 100)
        });
    }, {
        onScrubEnd: function() {
            var _positionRef_current = positionRef.current, x = _positionRef_current.x, y = _positionRef_current.y;
            onChangeEnd({
                s: Math.round(x * 100),
                v: Math.round((1 - y) * 100)
            });
            onScrubEnd === null || onScrubEnd === void 0 ? void 0 : onScrubEnd();
        },
        onScrubStart
    }).ref;
    React.useEffect(function() {
        setPosition({
            x: value.s / 100,
            y: 1 - value.v / 100
        });
    }, [
        value.s,
        value.v
    ]);
    var handleArrow = function(event, pos) {
        event.preventDefault();
        var _position = hooks.clampUseMovePosition(pos);
        onChange({
            s: Math.round(_position.x * 100),
            v: Math.round((1 - _position.y) * 100)
        });
        onChangeEnd({
            s: Math.round(_position.x * 100),
            v: Math.round((1 - _position.y) * 100)
        });
    };
    var handleKeyDown = function(event) {
        switch(event.key){
            case "ArrowUp":
                handleArrow(event, {
                    y: position.y - 0.05,
                    x: position.x
                });
                break;
            case "ArrowDown":
                handleArrow(event, {
                    y: position.y + 0.05,
                    x: position.x
                });
                break;
            case "ArrowRight":
                handleArrow(event, {
                    x: position.x + 0.05,
                    y: position.y
                });
                break;
            case "ArrowLeft":
                handleArrow(event, {
                    x: position.x - 0.05,
                    y: position.y
                });
                break;
        }
    };
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("saturation")), {
        ref
    }), others), {
        role: "slider",
        "aria-label": saturationLabel,
        "aria-valuenow": position.x,
        "aria-valuetext": converters.convertHsvaTo("rgba", value),
        tabIndex: focusable ? 0 : -1,
        onKeyDown: handleKeyDown,
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpread._)({}, getStyles("saturationOverlay", {
                style: {
                    backgroundColor: `hsl(${value.h}, 100%, 50%)`
                }
            }))),
            /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpread._)({}, getStyles("saturationOverlay", {
                style: {
                    backgroundImage: "linear-gradient(90deg, #fff, transparent)"
                }
            }))),
            /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpread._)({}, getStyles("saturationOverlay", {
                style: {
                    backgroundImage: "linear-gradient(0deg, #000, transparent)"
                }
            }))),
            /* @__PURE__ */ jsxRuntime.jsx(Thumb.Thumb, (0, _objectSpread._)({
                position
            }, getStyles("thumb", {
                style: {
                    backgroundColor: color
                }
            })))
        ]
    }));
}
Saturation.displayName = "@mantine/core/Saturation";
exports.Saturation = Saturation; //# sourceMappingURL=Saturation.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","c46f044467dc1b6d":"iKGFf","3a322404e5c8e022":"9MtAM","17d1e999d60db58a":"9HEEB","5e5668709f2af199":"8QFOC","a648d3748d612079":"2FdJg","df669c324455dc25":"6AMGA","b45d12da90cc1b":"erSvz","c9dee90622797d6c":"kqQOF","5f207d51127af80a":"8YP4O","e0a876bb9e021c33":"gkGXc","f6f9560cc78db8fa":"2onWA","9195b54c4022ec51":"hU08M","a0a7b274876d616d":"7kml4","cfec9fb7d423c758":"5AePV"}],"6ThFc":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("bdb73319f36f2e96");
var React = require("2f4c9674148ae820");
require("d03c82d6afe06786");
require("eb9b441e3eba3cb1");
require("46f29f5cca3edbed");
require("1b6d8dcc16e37e9c");
require("8b25e4f8cce56999");
require("308e416ca5766099");
require("ebe227439703d9f5");
var Box = require("73a35317432b342");
require("3ed1f4c5db098a73");
var ColorSwatch = require("f618bfb9f9e89622");
var ColorPicker_context = require("c8601f17d0869ce5");
var Swatches = React.forwardRef(function(_param, ref) {
    var className = _param.className, datatype = _param.datatype, setValue = _param.setValue, onChangeEnd = _param.onChangeEnd, size = _param.size, focusable = _param.focusable, data = _param.data, swatchesPerRow = _param.swatchesPerRow, others = (0, _objectWithoutProperties._)(_param, [
        "className",
        "datatype",
        "setValue",
        "onChangeEnd",
        "size",
        "focusable",
        "data",
        "swatchesPerRow"
    ]);
    var ctx = ColorPicker_context.useColorPickerContext();
    var colors = data.map(function(color, index) {
        return /* @__PURE__ */ React.createElement(ColorSwatch.ColorSwatch, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("swatch")), {
            unstyled: ctx.unstyled,
            component: "button",
            type: "button",
            color,
            key: index,
            radius: "sm",
            onClick: function() {
                setValue(color);
                onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(color);
            },
            "aria-label": color,
            tabIndex: focusable ? 0 : -1,
            "data-swatch": true
        }));
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("swatches")), {
        ref
    }), others), {
        children: colors
    }));
});
Swatches.displayName = "@mantine/core/Swatches";
exports.Swatches = Swatches; //# sourceMappingURL=Swatches.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","bdb73319f36f2e96":"iKGFf","2f4c9674148ae820":"9MtAM","d03c82d6afe06786":"9HEEB","eb9b441e3eba3cb1":"8QFOC","46f29f5cca3edbed":"2FdJg","1b6d8dcc16e37e9c":"6AMGA","8b25e4f8cce56999":"erSvz","308e416ca5766099":"kqQOF","ebe227439703d9f5":"8YP4O","73a35317432b342":"gkGXc","3ed1f4c5db098a73":"2onWA","f618bfb9f9e89622":"kA5X0","c8601f17d0869ce5":"hU08M"}],"dhpny":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("83faa91d83fa8155");
var React = require("f0d04e62a6c1f289");
var hooks = require("5ca27aa9681ba0c");
var getSize = require("d13611cddb8fdd1d");
var createVarsResolver = require("376fa94d103b9c14");
require("edcbea29a77748ad");
var useResolvedStylesApi = require("14e6660539000a19");
var useStyles = require("28643c6ea4e34935");
require("95530839a38015d2");
require("7637f58f5ac28aaa");
require("cefee4d6c5b75d1a");
require("b624432190cce792");
var useProps = require("e425666ec0073d19");
require("be7bb4f3939aaa9b");
require("3648f0c727da6ba1");
var factory = require("76114ec55cee344c");
require("b0ff98556ca6c028");
var ActionIcon = require("45f7d56ba1e7f9d5");
require("782a09849cb790c1");
require("7d6bb56b3c4c63ec");
var ColorPicker = require("9fcb04d5b4c55c80");
require("564aef4857e45d47");
require("7240295b2a4dede1");
var converters = require("2eaf7de0f57974ff");
var parsers = require("bf6cec4584f26003");
var ColorSwatch = require("b3237de76bece077");
var Input = require("38ebea7552d69e18");
require("b25ddf339e0d9c86");
require("71d47b6c4c489bac");
require("de389adf92d0abf8");
require("c08c7fa8e871d7f9");
require("4928bb7a4b981ce0");
require("984f281ad9375791");
var useInputProps = require("d1e5958bb16a9484");
require("3a966b95e257bd82");
var InputBase = require("1813c641a60a5d1e");
var Popover = require("97bc233dcdbfafa");
require("f13e2d1109f5882c");
require("8a40ac7676bd1a54");
var EyeDropperIcon = require("6b649080b8ea05e6");
var ColorInput_module = require("f15ab884aa5f2bd3");
var defaultProps = {
    format: "hex",
    fixOnBlur: true,
    withPreview: true,
    swatchesPerRow: 7,
    withPicker: true,
    popoverProps: {
        transitionProps: {
            transition: "fade",
            duration: 0
        }
    },
    withEyeDropper: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        eyeDropperIcon: {
            "--ci-eye-dropper-icon-size": getSize.getSize(size, "ci-eye-dropper-icon-size")
        },
        colorPreview: {
            "--ci-preview-size": getSize.getSize(size, "ci-preview-size")
        }
    };
});
var ColorInput = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ColorInput", defaultProps, _props);
    var _useInputProps_useInputProps = useInputProps.useInputProps("ColorInput", defaultProps, _props), classNames = _useInputProps_useInputProps.classNames, styles = _useInputProps_useInputProps.styles, unstyled = _useInputProps_useInputProps.unstyled, disallowInput = _useInputProps_useInputProps.disallowInput, fixOnBlur = _useInputProps_useInputProps.fixOnBlur, popoverProps = _useInputProps_useInputProps.popoverProps, withPreview = _useInputProps_useInputProps.withPreview, withEyeDropper = _useInputProps_useInputProps.withEyeDropper, eyeDropperIcon = _useInputProps_useInputProps.eyeDropperIcon, closeOnColorSwatchClick = _useInputProps_useInputProps.closeOnColorSwatchClick, eyeDropperButtonProps = _useInputProps_useInputProps.eyeDropperButtonProps, value = _useInputProps_useInputProps.value, defaultValue = _useInputProps_useInputProps.defaultValue, onChange = _useInputProps_useInputProps.onChange, onChangeEnd = _useInputProps_useInputProps.onChangeEnd, onClick = _useInputProps_useInputProps.onClick, onFocus = _useInputProps_useInputProps.onFocus, onBlur = _useInputProps_useInputProps.onBlur, inputProps = _useInputProps_useInputProps.inputProps, format = _useInputProps_useInputProps.format, wrapperProps = _useInputProps_useInputProps.wrapperProps, readOnly = _useInputProps_useInputProps.readOnly, withPicker = _useInputProps_useInputProps.withPicker, swatches = _useInputProps_useInputProps.swatches, disabled = _useInputProps_useInputProps.disabled, leftSection = _useInputProps_useInputProps.leftSection, rightSection = _useInputProps_useInputProps.rightSection, swatchesPerRow = _useInputProps_useInputProps.swatchesPerRow, others = (0, _objectWithoutProperties._)(_useInputProps_useInputProps, [
        "classNames",
        "styles",
        "unstyled",
        "disallowInput",
        "fixOnBlur",
        "popoverProps",
        "withPreview",
        "withEyeDropper",
        "eyeDropperIcon",
        "closeOnColorSwatchClick",
        "eyeDropperButtonProps",
        "value",
        "defaultValue",
        "onChange",
        "onChangeEnd",
        "onClick",
        "onFocus",
        "onBlur",
        "inputProps",
        "format",
        "wrapperProps",
        "readOnly",
        "withPicker",
        "swatches",
        "disabled",
        "leftSection",
        "rightSection",
        "swatchesPerRow"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ColorInput",
        props,
        classes: ColorInput_module,
        classNames,
        styles,
        unstyled,
        rootSelector: "wrapper",
        vars: props.vars,
        varsResolver
    });
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), dropdownOpened = _React_useState[0], setDropdownOpened = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(""), 2), lastValidValue = _React_useState1[0], setLastValidValue = _React_useState1[1];
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: "",
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var _hooks_useEyeDropper = hooks.useEyeDropper(), eyeDropperSupported = _hooks_useEyeDropper.supported, openEyeDropper = _hooks_useEyeDropper.open;
    var eyeDropper = /* @__PURE__ */ jsxRuntime.jsx(ActionIcon.ActionIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, eyeDropperButtonProps, getStyles("eyeDropperButton", {
        className: eyeDropperButtonProps === null || eyeDropperButtonProps === void 0 ? void 0 : eyeDropperButtonProps.className,
        style: eyeDropperButtonProps === null || eyeDropperButtonProps === void 0 ? void 0 : eyeDropperButtonProps.style
    })), {
        variant: "subtle",
        color: "gray",
        size: inputProps.size,
        unstyled,
        onClick: function() {
            return openEyeDropper().then(function(payload) {
                if (payload === null || payload === void 0 ? void 0 : payload.sRGBHex) {
                    var color = converters.convertHsvaTo(format, parsers.parseColor(payload.sRGBHex));
                    setValue(color);
                    onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(color);
                }
            }).catch(function() {});
        },
        children: eyeDropperIcon || /* @__PURE__ */ jsxRuntime.jsx(EyeDropperIcon.EyeDropperIcon, (0, _objectSpread._)({}, getStyles("eyeDropperIcon")))
    }));
    var handleInputFocus = function(event) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        setDropdownOpened(true);
    };
    var handleInputBlur = function(event) {
        fixOnBlur && setValue(lastValidValue);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        setDropdownOpened(false);
    };
    var handleInputClick = function(event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        setDropdownOpened(true);
    };
    React.useEffect(function() {
        if (parsers.isColorValid(_value) || _value.trim() === "") setLastValidValue(_value);
    }, [
        _value
    ]);
    hooks.useDidUpdate(function() {
        if (parsers.isColorValid(_value)) setValue(converters.convertHsvaTo(format, parsers.parseColor(_value)));
    }, [
        format
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Wrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, wrapperProps), {
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        __staticSelector: "ColorInput",
        children: /* @__PURE__ */ jsxRuntime.jsxs(Popover.Popover, (0, _objectSpreadProps._)((0, _objectSpread._)({
            __staticSelector: "ColorInput",
            position: "bottom-start",
            offset: 5,
            opened: dropdownOpened
        }, popoverProps), {
            classNames: resolvedClassNames,
            styles: resolvedStyles,
            unstyled,
            withRoles: false,
            disabled: readOnly || withPicker === false && (!Array.isArray(swatches) || swatches.length === 0),
            children: [
                /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Target, {
                    children: /* @__PURE__ */ jsxRuntime.jsx(Input.Input, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        autoComplete: "off"
                    }, others, inputProps), {
                        classNames: resolvedClassNames,
                        styles: resolvedStyles,
                        disabled,
                        ref,
                        __staticSelector: "ColorInput",
                        onFocus: handleInputFocus,
                        onBlur: handleInputBlur,
                        onClick: handleInputClick,
                        spellCheck: false,
                        value: _value,
                        onChange: function(event) {
                            var inputValue = event.currentTarget.value;
                            setValue(inputValue);
                            if (parsers.isColorValid(inputValue)) onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(converters.convertHsvaTo(format, parsers.parseColor(inputValue)));
                        },
                        leftSection: leftSection || (withPreview ? /* @__PURE__ */ jsxRuntime.jsx(ColorSwatch.ColorSwatch, (0, _objectSpread._)({
                            color: parsers.isColorValid(_value) ? _value : "#fff",
                            size: "var(--ci-preview-size)"
                        }, getStyles("colorPreview"))) : null),
                        readOnly: disallowInput || readOnly,
                        pointer: disallowInput,
                        unstyled,
                        rightSection: rightSection || (withEyeDropper && !disabled && !readOnly && eyeDropperSupported ? eyeDropper : null)
                    }))
                }),
                /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Dropdown, {
                    onMouseDown: function(event) {
                        return event.preventDefault();
                    },
                    className: ColorInput_module.dropdown,
                    children: /* @__PURE__ */ jsxRuntime.jsx(ColorPicker.ColorPicker, {
                        __staticSelector: "ColorInput",
                        value: _value,
                        onChange: setValue,
                        onChangeEnd,
                        format,
                        swatches,
                        swatchesPerRow,
                        withPicker,
                        size: inputProps.size,
                        focusable: false,
                        unstyled,
                        styles: resolvedStyles,
                        classNames: resolvedClassNames,
                        onColorSwatchClick: function() {
                            return closeOnColorSwatchClick && setDropdownOpened(false);
                        }
                    })
                })
            ]
        }))
    }));
});
ColorInput.classes = InputBase.InputBase.classes;
ColorInput.displayName = "@mantine/core/ColorInput";
exports.ColorInput = ColorInput; //# sourceMappingURL=ColorInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","83faa91d83fa8155":"iKGFf","f0d04e62a6c1f289":"9MtAM","5ca27aa9681ba0c":"9HEEB","d13611cddb8fdd1d":"kEFEY","376fa94d103b9c14":"hIQE6","edcbea29a77748ad":"8QFOC","14e6660539000a19":"d30sL","28643c6ea4e34935":"d0sAY","95530839a38015d2":"2FdJg","7637f58f5ac28aaa":"6AMGA","cefee4d6c5b75d1a":"erSvz","b624432190cce792":"kqQOF","e425666ec0073d19":"iivvn","be7bb4f3939aaa9b":"8YP4O","3648f0c727da6ba1":"gkGXc","76114ec55cee344c":"guLFz","b0ff98556ca6c028":"2onWA","45f7d56ba1e7f9d5":"9tz8j","782a09849cb790c1":"hLZtr","7d6bb56b3c4c63ec":"5bt1k","9fcb04d5b4c55c80":"7R7jd","564aef4857e45d47":"jcxTp","7240295b2a4dede1":"ijPsx","2eaf7de0f57974ff":"7kml4","bf6cec4584f26003":"6uVVj","b3237de76bece077":"kA5X0","38ebea7552d69e18":"dkUgf","b25ddf339e0d9c86":"j4uTK","71d47b6c4c489bac":"7nO1x","de389adf92d0abf8":"3Bda4","c08c7fa8e871d7f9":"gQBOr","4928bb7a4b981ce0":"lRBdM","984f281ad9375791":"hxtex","d1e5958bb16a9484":"4OEkb","3a966b95e257bd82":"lQt5D","1813c641a60a5d1e":"jbA6w","97bc233dcdbfafa":"4oc3k","f13e2d1109f5882c":"b7S6t","8a40ac7676bd1a54":"iz4SD","6b649080b8ea05e6":"8xsxR","f15ab884aa5f2bd3":"5UOzW"}],"8xsxR":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f0859a7e25c202f7");
function EyeDropperIcon(_param) {
    var style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "style"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        xmlns: "http://www.w3.org/2000/svg",
        style: (0, _objectSpread._)({
            width: "var(--ci-eye-dropper-icon-size)",
            height: "var(--ci-eye-dropper-icon-size)"
        }, style),
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /* @__PURE__ */ jsxRuntime.jsx("path", {
                d: "M11 7l6 6"
            }),
            /* @__PURE__ */ jsxRuntime.jsx("path", {
                d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"
            })
        ]
    }));
}
exports.EyeDropperIcon = EyeDropperIcon; //# sourceMappingURL=EyeDropperIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f0859a7e25c202f7":"iKGFf"}],"5UOzW":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "eyeDropperIcon": "m_b077c2bc",
    "colorPreview": "m_c5ccdcab",
    "dropdown": "m_5ece2cd7"
};
module.exports = classes; //# sourceMappingURL=ColorInput.module.css.cjs.map

},{}],"hvsg5":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("24aebd7e18232deb");
var hooks = require("3727028cebf0e563");
var getVirtualizedIndex = require("c49dc784e2899070");
function useVirtualizedCombobox() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        totalOptionsCount: 0,
        getOptionId: function() {
            return null;
        },
        selectedOptionIndex: 1,
        setSelectedOptionIndex: function() {},
        onSelectedOptionSubmit: function() {}
    }, defaultOpened = _ref.defaultOpened, opened = _ref.opened, onOpenedChange = _ref.onOpenedChange, onDropdownClose = _ref.onDropdownClose, onDropdownOpen = _ref.onDropdownOpen, _ref_loop = _ref.loop, loop = _ref_loop === void 0 ? true : _ref_loop, totalOptionsCount = _ref.totalOptionsCount, _ref_isOptionDisabled = _ref.isOptionDisabled, isOptionDisabled = _ref_isOptionDisabled === void 0 ? function() {
        return false;
    } : _ref_isOptionDisabled, getOptionId = _ref.getOptionId, selectedOptionIndex = _ref.selectedOptionIndex, setSelectedOptionIndex = _ref.setSelectedOptionIndex, activeOptionIndex = _ref.activeOptionIndex, onSelectedOptionSubmit = _ref.onSelectedOptionSubmit;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onOpenedChange
    }), 2), dropdownOpened = _hooks_useUncontrolled[0], setDropdownOpened = _hooks_useUncontrolled[1];
    var listId = React.useRef(null);
    var searchRef = React.useRef(null);
    var targetRef = React.useRef(null);
    var focusSearchTimeout = React.useRef(-1);
    var focusTargetTimeout = React.useRef(-1);
    var openDropdown = function() {
        if (!dropdownOpened) {
            setDropdownOpened(true);
            onDropdownOpen === null || onDropdownOpen === void 0 ? void 0 : onDropdownOpen();
        }
    };
    var closeDropdown = function() {
        if (dropdownOpened) {
            setDropdownOpened(false);
            onDropdownClose === null || onDropdownClose === void 0 ? void 0 : onDropdownClose();
        }
    };
    var toggleDropdown = function() {
        if (dropdownOpened) closeDropdown();
        else openDropdown();
    };
    var selectOption = function(index) {
        var nextIndex = index >= totalOptionsCount ? 0 : index < 0 ? totalOptionsCount - 1 : index;
        setSelectedOptionIndex(nextIndex);
        return getOptionId(nextIndex);
    };
    var selectActiveOption = function() {
        return selectOption(activeOptionIndex !== null && activeOptionIndex !== void 0 ? activeOptionIndex : 0);
    };
    var selectNextOption = function() {
        return selectOption(getVirtualizedIndex.getNextIndex({
            currentIndex: selectedOptionIndex,
            isOptionDisabled,
            totalOptionsCount,
            loop
        }));
    };
    var selectPreviousOption = function() {
        return selectOption(getVirtualizedIndex.getPreviousIndex({
            currentIndex: selectedOptionIndex,
            isOptionDisabled,
            totalOptionsCount,
            loop
        }));
    };
    var selectFirstOption = function() {
        return selectOption(getVirtualizedIndex.getFirstIndex({
            isOptionDisabled,
            totalOptionsCount
        }));
    };
    var resetSelectedOption = function() {
        setSelectedOptionIndex(-1);
    };
    var clickSelectedOption = function() {
        onSelectedOptionSubmit === null || onSelectedOptionSubmit === void 0 ? void 0 : onSelectedOptionSubmit(selectedOptionIndex);
    };
    var setListId = function(id) {
        listId.current = id;
    };
    var focusSearchInput = function() {
        focusSearchTimeout.current = window.setTimeout(function() {
            return searchRef.current.focus();
        }, 0);
    };
    var focusTarget = function() {
        focusTargetTimeout.current = window.setTimeout(function() {
            return targetRef.current.focus();
        }, 0);
    };
    React.useEffect(function() {
        return function() {
            window.clearTimeout(focusSearchTimeout.current);
            window.clearTimeout(focusTargetTimeout.current);
        };
    }, []);
    var getSelectedOptionIndex = React.useCallback(function() {
        return selectedOptionIndex;
    }, []);
    return {
        dropdownOpened,
        openDropdown,
        closeDropdown,
        toggleDropdown,
        selectedOptionIndex,
        getSelectedOptionIndex,
        selectOption,
        selectFirstOption,
        selectActiveOption,
        selectNextOption,
        selectPreviousOption,
        resetSelectedOption,
        updateSelectedOptionIndex: function() {},
        listId: listId.current,
        setListId,
        clickSelectedOption,
        searchRef,
        focusSearchInput,
        targetRef,
        focusTarget
    };
}
exports.useVirtualizedCombobox = useVirtualizedCombobox; //# sourceMappingURL=use-virtualized-combobox.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","24aebd7e18232deb":"9MtAM","3727028cebf0e563":"9HEEB","c49dc784e2899070":"hd7gj"}],"hd7gj":[function(require,module,exports) {
"use client";
"use strict";
function getPreviousIndex(param) {
    var currentIndex = param.currentIndex, isOptionDisabled = param.isOptionDisabled, totalOptionsCount = param.totalOptionsCount, loop = param.loop;
    for(var i = currentIndex - 1; i >= 0; i -= 1){
        if (!isOptionDisabled(i)) return i;
    }
    if (loop) for(var i1 = totalOptionsCount - 1; i1 > -1; i1 -= 1){
        if (!isOptionDisabled(i1)) return i1;
    }
    return currentIndex;
}
function getNextIndex(param) {
    var currentIndex = param.currentIndex, isOptionDisabled = param.isOptionDisabled, totalOptionsCount = param.totalOptionsCount, loop = param.loop;
    for(var i = currentIndex + 1; i < totalOptionsCount; i += 1){
        if (!isOptionDisabled(i)) return i;
    }
    if (loop) for(var i1 = 0; i1 < totalOptionsCount; i1 += 1){
        if (!isOptionDisabled(i1)) return i1;
    }
    return currentIndex;
}
function getFirstIndex(param) {
    var totalOptionsCount = param.totalOptionsCount, isOptionDisabled = param.isOptionDisabled;
    for(var i = 0; i < totalOptionsCount; i += 1){
        if (!isOptionDisabled(i)) return i;
    }
    return -1;
}
exports.getFirstIndex = getFirstIndex;
exports.getNextIndex = getNextIndex;
exports.getPreviousIndex = getPreviousIndex; //# sourceMappingURL=get-virtualized-index.cjs.map

},{}],"22BxA":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f1e1c06f5667752e");
require("74cfdf9acdc3902c");
var getSize = require("853316544873e503");
require("2e2e310fc3aeefe4");
var createVarsResolver = require("f9de5e10b5522852");
require("d637a5b7eabb906e");
require("a3949b4daa584d6");
require("752b7109ace69eba");
require("e45996813e6ec56c");
require("a1f9b15f977e7ea9");
var useProps = require("4c812553a9668678");
require("1c90547f53b54535");
var useStyles = require("6aaabd934ab3eb00");
var Box = require("73931bc733636eac");
var factory = require("6bc599476ae07d0b");
require("7623672b082e0ca4");
var Container_module = require("ae4b9599cf357236");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, fluid = param.fluid;
    return {
        root: {
            "--container-size": fluid ? void 0 : getSize.getSize(size, "container-size")
        }
    };
});
var Container = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Container", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, fluid = props.fluid, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "fluid",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Container",
        classes: Container_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref,
        mod: [
            {
                fluid
            },
            mod
        ]
    }, getStyles("root"), others));
});
Container.classes = Container_module;
Container.displayName = "@mantine/core/Container";
exports.Container = Container; //# sourceMappingURL=Container.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","f1e1c06f5667752e":"iKGFf","74cfdf9acdc3902c":"9MtAM","853316544873e503":"kEFEY","2e2e310fc3aeefe4":"9HEEB","f9de5e10b5522852":"hIQE6","d637a5b7eabb906e":"8QFOC","a3949b4daa584d6":"2FdJg","752b7109ace69eba":"6AMGA","e45996813e6ec56c":"erSvz","a1f9b15f977e7ea9":"kqQOF","4c812553a9668678":"iivvn","1c90547f53b54535":"8YP4O","6aaabd934ab3eb00":"d0sAY","73931bc733636eac":"gkGXc","6bc599476ae07d0b":"guLFz","7623672b082e0ca4":"2onWA","ae4b9599cf357236":"lwQgP"}],"lwQgP":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_7485cace"
};
module.exports = classes; //# sourceMappingURL=Container.module.css.cjs.map

},{}],"aCHLX":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("872f63e1f9074915");
var hooks = require("37844b22878f8e47");
require("ab4406af04a2ed37");
require("a402abe689c106c");
require("6976c968eae2a40c");
require("e789b42f9f336dc9");
require("370f99332b3fabe4");
require("933942d3f05f5706");
var useProps = require("4c30b612937b1bda");
require("3c9fea5309b5fb45");
require("2d33843bbf3fb8d8");
require("21ff21431b15f5af");
var defaultProps = {
    timeout: 1e3
};
function CopyButton(props) {
    var _useProps_useProps = useProps.useProps("CopyButton", defaultProps, props), children = _useProps_useProps.children, timeout = _useProps_useProps.timeout, value = _useProps_useProps.value, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "timeout",
        "value"
    ]);
    var clipboard = hooks.useClipboard({
        timeout
    });
    var copy = function() {
        return clipboard.copy(value);
    };
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: children((0, _objectSpread._)({
            copy,
            copied: clipboard.copied
        }, others))
    });
}
CopyButton.displayName = "@mantine/core/CopyButton";
exports.CopyButton = CopyButton; //# sourceMappingURL=CopyButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","872f63e1f9074915":"iKGFf","37844b22878f8e47":"9HEEB","ab4406af04a2ed37":"9MtAM","a402abe689c106c":"8QFOC","6976c968eae2a40c":"2FdJg","e789b42f9f336dc9":"6AMGA","370f99332b3fabe4":"erSvz","933942d3f05f5706":"kqQOF","4c30b612937b1bda":"iivvn","3c9fea5309b5fb45":"8YP4O","2d33843bbf3fb8d8":"gkGXc","21ff21431b15f5af":"2onWA"}],"gDzef":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1ec5db73c62b6d75");
require("2122a9572025250b");
var getSize = require("ee8762154491b96");
require("eb377c569a7a1a9d");
var createVarsResolver = require("ee1869df62bf9fa6");
require("75c490fb2aaee7f9");
require("322ed92d12712513");
require("4bb629dd26df4949");
require("660444c5484b06c6");
require("1e71c9ce8eed52d5");
var useProps = require("779d73f3b45071c6");
require("5d1a8cb42aa4533f");
var useStyles = require("8490e29617664281");
require("43aa70336ed59eed");
var factory = require("91169a485ff58f8e");
require("32139ac4eb66b802");
var Affix = require("6c3ed645af7d65e");
require("44c0db0ad66ab85b");
var CloseButton = require("6d5edeac2fc97c43");
var Paper = require("c8ee4cde4c14e3f6");
var Transition = require("e194f849041a0f57");
var Dialog_module = require("7e2a529b9cd6e1");
var defaultProps = {
    shadow: "md",
    p: "md",
    withBorder: false,
    transitionProps: {
        transition: "pop-top-right",
        duration: 200
    },
    position: {
        bottom: 30,
        right: 30
    }
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        root: {
            "--dialog-size": getSize.getSize(size, "dialog-size")
        }
    };
});
var Dialog = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Dialog", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, zIndex = props.zIndex, position = props.position, keepMounted = props.keepMounted, opened = props.opened, transitionProps = props.transitionProps, withCloseButton = props.withCloseButton, withinPortal = props.withinPortal, children = props.children, onClose = props.onClose, portalProps = props.portalProps, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "zIndex",
        "position",
        "keepMounted",
        "opened",
        "transitionProps",
        "withCloseButton",
        "withinPortal",
        "children",
        "onClose",
        "portalProps"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Dialog",
        classes: Dialog_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Affix.Affix, {
        zIndex,
        position,
        ref,
        withinPortal,
        portalProps,
        unstyled,
        children: /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, (0, _objectSpreadProps._)((0, _objectSpread._)({
            keepMounted,
            mounted: opened
        }, transitionProps), {
            children: function(transitionStyles) {
                return /* @__PURE__ */ jsxRuntime.jsxs(Paper.Paper, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    unstyled
                }, getStyles("root", {
                    style: transitionStyles
                }), others), {
                    children: [
                        withCloseButton && /* @__PURE__ */ jsxRuntime.jsx(CloseButton.CloseButton, (0, _objectSpread._)({
                            onClick: onClose,
                            unstyled
                        }, getStyles("closeButton"))),
                        children
                    ]
                }));
            }
        }))
    });
});
Dialog.classes = Dialog_module;
Dialog.displayName = "@mantine/core/Dialog";
exports.Dialog = Dialog; //# sourceMappingURL=Dialog.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","1ec5db73c62b6d75":"iKGFf","2122a9572025250b":"9MtAM","ee8762154491b96":"kEFEY","eb377c569a7a1a9d":"9HEEB","ee1869df62bf9fa6":"hIQE6","75c490fb2aaee7f9":"8QFOC","322ed92d12712513":"2FdJg","4bb629dd26df4949":"6AMGA","660444c5484b06c6":"erSvz","1e71c9ce8eed52d5":"kqQOF","779d73f3b45071c6":"iivvn","5d1a8cb42aa4533f":"8YP4O","8490e29617664281":"d0sAY","43aa70336ed59eed":"gkGXc","91169a485ff58f8e":"guLFz","32139ac4eb66b802":"2onWA","6c3ed645af7d65e":"fZ73h","44c0db0ad66ab85b":"h6AYi","6d5edeac2fc97c43":"4ZuRG","c8ee4cde4c14e3f6":"amEW4","e194f849041a0f57":"2T0Xr","7e2a529b9cd6e1":"jOu4d"}],"jOu4d":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_e2125a27",
    "closeButton": "m_5abab665"
};
module.exports = classes; //# sourceMappingURL=Dialog.module.css.cjs.map

},{}],"bOQ6D":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3a369f7288c2386f");
require("c9e2004faa5dcde7");
var getSize = require("40ecf2247dedc39b");
require("e980a3dae0fb33e4");
var createVarsResolver = require("d2e58ff99837cd62");
require("1835de7dc3a075a8");
var getThemeColor = require("211f604333575a26");
require("d9a4977b865676eb");
require("c4160de572a93b32");
require("dcb864704666c876");
require("e07338ceb89ef184");
var useProps = require("514de1af5c66696c");
require("aae927c56fb2e305");
var useStyles = require("3c354709e0333c78");
var Box = require("3b92a94a90fe2aab");
var factory = require("87893264bf040726");
require("242b145280737bbb");
var Divider_module = require("52eda83d64ef09f3");
var defaultProps = {
    orientation: "horizontal"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color, variant = param.variant, size = param.size;
    return {
        root: {
            "--divider-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--divider-border-style": variant,
            "--divider-size": getSize.getSize(size, "divider-size")
        }
    };
});
var Divider = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Divider", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, color = props.color, orientation = props.orientation, label = props.label, labelPosition = props.labelPosition, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "orientation",
        "label",
        "labelPosition",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Divider",
        classes: Divider_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        mod: [
            {
                orientation,
                "with-label": !!label
            },
            mod
        ]
    }, getStyles("root"), others), {
        role: "separator",
        children: label && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
            component: "span",
            mod: {
                position: labelPosition
            }
        }, getStyles("label")), {
            children: label
        }))
    }));
});
Divider.classes = Divider_module;
Divider.displayName = "@mantine/core/Divider";
exports.Divider = Divider; //# sourceMappingURL=Divider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","3a369f7288c2386f":"iKGFf","c9e2004faa5dcde7":"9MtAM","40ecf2247dedc39b":"kEFEY","e980a3dae0fb33e4":"9HEEB","d2e58ff99837cd62":"hIQE6","1835de7dc3a075a8":"8QFOC","211f604333575a26":"eeaIN","d9a4977b865676eb":"2FdJg","c4160de572a93b32":"6AMGA","dcb864704666c876":"erSvz","e07338ceb89ef184":"kqQOF","514de1af5c66696c":"iivvn","aae927c56fb2e305":"8YP4O","3c354709e0333c78":"d0sAY","3b92a94a90fe2aab":"gkGXc","87893264bf040726":"guLFz","242b145280737bbb":"2onWA","52eda83d64ef09f3":"eHG8k"}],"eHG8k":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_3eebeb36",
    "label": "m_9e365f20"
};
module.exports = classes; //# sourceMappingURL=Divider.module.css.cjs.map

},{}],"h20rI":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("5ab6ef0764cb2622");
var React = require("7b5ca775dbb1ca29");
var getDefaultZIndex = require("649dbaac8682a5c3");
require("250b5ab3ae527e07");
require("a016b130bfcaaaf6");
require("27a42dbaa1271f24");
require("314469ee3cd2603");
require("82c0533fbde874fd");
require("e86c30066744aff");
var useProps = require("55d3470dac088630");
require("dab3613297888d7f");
require("9d661bce41e06792");
var factory = require("fb58c4fd4be902c2");
require("6c7bd01c880595af");
var DrawerBody = require("b755a141ef6f1956");
var DrawerCloseButton = require("9a6fe2a0760ded42");
var DrawerContent = require("8faa0cfde738a6e1");
var DrawerHeader = require("d7bfeb3961d65dfc");
var DrawerOverlay = require("fcd8e74013709161");
var DrawerRoot = require("f4051885a689b7d6");
var DrawerStack = require("a7591f18c74f59bf");
var DrawerTitle = require("c6b607fcf847740b");
var Drawer_module = require("e8dc4fa147427bb8");
var defaultProps = {
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: getDefaultZIndex.getDefaultZIndex("modal"),
    withOverlay: true,
    withCloseButton: true
};
var Drawer = factory.factory(function(_props, ref) {
    var _useProps_useProps = useProps.useProps("Drawer", defaultProps, _props), title = _useProps_useProps.title, withOverlay = _useProps_useProps.withOverlay, overlayProps = _useProps_useProps.overlayProps, withCloseButton = _useProps_useProps.withCloseButton, closeButtonProps = _useProps_useProps.closeButtonProps, children = _useProps_useProps.children, opened = _useProps_useProps.opened, stackId = _useProps_useProps.stackId, zIndex = _useProps_useProps.zIndex, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "title",
        "withOverlay",
        "overlayProps",
        "withCloseButton",
        "closeButtonProps",
        "children",
        "opened",
        "stackId",
        "zIndex"
    ]);
    var ctx = DrawerStack.useDrawerStackContext();
    var hasHeader = !!title || withCloseButton;
    var stackProps = ctx && stackId ? {
        closeOnEscape: ctx.currentId === stackId,
        trapFocus: ctx.currentId === stackId,
        zIndex: ctx.getZIndex(stackId)
    } : {};
    var overlayVisible = withOverlay === false ? false : stackId && ctx ? ctx.currentId === stackId : opened;
    React.useEffect(function() {
        if (ctx && stackId) opened ? ctx.addModal(stackId, zIndex || getDefaultZIndex.getDefaultZIndex("modal")) : ctx.removeModal(stackId);
    }, [
        opened,
        stackId,
        zIndex
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs(DrawerRoot.DrawerRoot, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        opened,
        zIndex: ctx && stackId ? ctx.getZIndex(stackId) : zIndex
    }, others, stackProps), {
        children: [
            withOverlay && /* @__PURE__ */ jsxRuntime.jsx(DrawerOverlay.DrawerOverlay, (0, _objectSpread._)({
                visible: overlayVisible,
                transitionProps: ctx && stackId ? {
                    duration: 0
                } : void 0
            }, overlayProps)),
            /* @__PURE__ */ jsxRuntime.jsxs(DrawerContent.DrawerContent, {
                __hidden: ctx && stackId && opened ? stackId !== ctx.currentId : false,
                children: [
                    hasHeader && /* @__PURE__ */ jsxRuntime.jsxs(DrawerHeader.DrawerHeader, {
                        children: [
                            title && /* @__PURE__ */ jsxRuntime.jsx(DrawerTitle.DrawerTitle, {
                                children: title
                            }),
                            withCloseButton && /* @__PURE__ */ jsxRuntime.jsx(DrawerCloseButton.DrawerCloseButton, (0, _objectSpread._)({}, closeButtonProps))
                        ]
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(DrawerBody.DrawerBody, {
                        children
                    })
                ]
            })
        ]
    }));
});
Drawer.classes = Drawer_module;
Drawer.displayName = "@mantine/core/Drawer";
Drawer.Root = DrawerRoot.DrawerRoot;
Drawer.Overlay = DrawerOverlay.DrawerOverlay;
Drawer.Content = DrawerContent.DrawerContent;
Drawer.Body = DrawerBody.DrawerBody;
Drawer.Header = DrawerHeader.DrawerHeader;
Drawer.Title = DrawerTitle.DrawerTitle;
Drawer.CloseButton = DrawerCloseButton.DrawerCloseButton;
Drawer.Stack = DrawerStack.DrawerStack;
exports.Drawer = Drawer; //# sourceMappingURL=Drawer.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","5ab6ef0764cb2622":"iKGFf","7b5ca775dbb1ca29":"9MtAM","649dbaac8682a5c3":"4gavl","250b5ab3ae527e07":"9HEEB","a016b130bfcaaaf6":"8QFOC","27a42dbaa1271f24":"2FdJg","314469ee3cd2603":"6AMGA","82c0533fbde874fd":"erSvz","e86c30066744aff":"kqQOF","55d3470dac088630":"iivvn","dab3613297888d7f":"8YP4O","9d661bce41e06792":"gkGXc","fb58c4fd4be902c2":"guLFz","6c7bd01c880595af":"2onWA","b755a141ef6f1956":"jyfp0","9a6fe2a0760ded42":"ETHac","8faa0cfde738a6e1":"8gNzB","d7bfeb3961d65dfc":"8IHOY","fcd8e74013709161":"9A9ix","f4051885a689b7d6":"lAkdZ","a7591f18c74f59bf":"ey4tq","c6b607fcf847740b":"1oTM5","e8dc4fa147427bb8":"kPpDy"}],"jyfp0":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("27ad12a51e08f1ce");
require("b79c7035f50fa708");
require("932442a4c7b97e89");
require("3ac2246da2d97763");
require("27202a199a074201");
require("fe97b4ce6c1e1516");
require("42953506c8380a6c");
require("740118afd1ada88d");
var useProps = require("5c066235f358e33b");
require("2cec56e075dc71c6");
require("da57e5e30e99df");
var factory = require("ce24f4f347f38f01");
require("bbe7f71612a17a88");
require("d8da46f274258714");
var ModalBaseBody = require("f1707e4646a58425");
require("7a0ae80f29a1b646");
require("ae2f823cecc7749e");
require("919bd6b5af6d969a");
require("729ec9e303fb5fad");
require("f383d72e9287b8d3");
var Drawer_context = require("a8afcc8a45c2e91e");
var Drawer_module = require("4d4e4674dcab5414");
var defaultProps = {};
var DrawerBody = factory.factory(function(_props, ref) {
    var props = useProps.useProps("DrawerBody", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Drawer_context.useDrawerContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseBody.ModalBaseBody, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("body", {
        classNames,
        style,
        styles,
        className
    }), others));
});
DrawerBody.classes = Drawer_module;
DrawerBody.displayName = "@mantine/core/DrawerBody";
exports.DrawerBody = DrawerBody; //# sourceMappingURL=DrawerBody.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","27ad12a51e08f1ce":"iKGFf","b79c7035f50fa708":"9MtAM","932442a4c7b97e89":"9HEEB","3ac2246da2d97763":"8QFOC","27202a199a074201":"2FdJg","fe97b4ce6c1e1516":"6AMGA","42953506c8380a6c":"erSvz","740118afd1ada88d":"kqQOF","5c066235f358e33b":"iivvn","2cec56e075dc71c6":"8YP4O","da57e5e30e99df":"gkGXc","ce24f4f347f38f01":"guLFz","bbe7f71612a17a88":"2onWA","d8da46f274258714":"PGvLq","f1707e4646a58425":"8i8nh","7a0ae80f29a1b646":"ifiLz","ae2f823cecc7749e":"8qmr0","919bd6b5af6d969a":"fsdDM","729ec9e303fb5fad":"fj3f7","f383d72e9287b8d3":"5DnfR","a8afcc8a45c2e91e":"azcY0","4d4e4674dcab5414":"kPpDy"}],"azcY0":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("762cfb9d6f11cf6e");
var createSafeContext = require("5da657ce6fcb52a9");
require("9cecc746a2454628");
require("c82705c07742260f");
require("de711a5b5d85db53");
require("8ed780542419a7d9");
require("f788701b044c2a15");
require("91242dc9881ea68");
require("1e84505191326d3b");
require("874812610e8e424e");
require("16ec79dcee7d459");
require("691aad955343883");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Drawer component was not found in tree"), 2), DrawerProvider = _createSafeContext_createSafeContext[0], useDrawerContext = _createSafeContext_createSafeContext[1];
exports.DrawerProvider = DrawerProvider;
exports.useDrawerContext = useDrawerContext; //# sourceMappingURL=Drawer.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","762cfb9d6f11cf6e":"9MtAM","5da657ce6fcb52a9":"8srze","9cecc746a2454628":"iKGFf","c82705c07742260f":"9HEEB","de711a5b5d85db53":"8QFOC","8ed780542419a7d9":"2FdJg","f788701b044c2a15":"6AMGA","91242dc9881ea68":"erSvz","1e84505191326d3b":"kqQOF","874812610e8e424e":"8YP4O","16ec79dcee7d459":"gkGXc","691aad955343883":"2onWA"}],"kPpDy":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f11b401e",
    "header": "m_5a7c2c9",
    "content": "m_b8a05bbd",
    "inner": "m_31cd769a"
};
module.exports = classes; //# sourceMappingURL=Drawer.module.css.cjs.map

},{}],"ETHac":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("788ec164e09b0a5d");
require("56683128088c1591");
require("4ba492ee0c24329e");
require("a3dbdaa937e1b238");
require("9c843ab6d2f7e150");
require("23d2d573c29b97f1");
require("5f2cf78b92b85edf");
require("27d742272e894746");
var useProps = require("2d7201041b714d6e");
require("e8b4066ec90c75c6");
require("23bd1252ed93c41f");
var factory = require("e8ef07aac15a9f94");
require("62167f0ec0c84029");
require("69db4dd8c08f4de3");
require("8663c5ea50d86c4f");
var ModalBaseCloseButton = require("579e4d8363ba2982");
require("b1cb2d523436c6f7");
require("d5949c690f083107");
require("40629ab56a8ae661");
require("f63c08d769c0daa3");
var Drawer_context = require("c341af1ba080817a");
var Drawer_module = require("4950866566f1bccf");
var defaultProps = {};
var DrawerCloseButton = factory.factory(function(_props, ref) {
    var props = useProps.useProps("DrawerCloseButton", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Drawer_context.useDrawerContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseCloseButton.ModalBaseCloseButton, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("close", {
        classNames,
        style,
        styles,
        className
    }), others));
});
DrawerCloseButton.classes = Drawer_module;
DrawerCloseButton.displayName = "@mantine/core/DrawerCloseButton";
exports.DrawerCloseButton = DrawerCloseButton; //# sourceMappingURL=DrawerCloseButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","788ec164e09b0a5d":"iKGFf","56683128088c1591":"9MtAM","4ba492ee0c24329e":"9HEEB","a3dbdaa937e1b238":"8QFOC","9c843ab6d2f7e150":"2FdJg","23d2d573c29b97f1":"6AMGA","5f2cf78b92b85edf":"erSvz","27d742272e894746":"kqQOF","2d7201041b714d6e":"iivvn","e8b4066ec90c75c6":"8YP4O","23bd1252ed93c41f":"gkGXc","e8ef07aac15a9f94":"guLFz","62167f0ec0c84029":"2onWA","69db4dd8c08f4de3":"PGvLq","8663c5ea50d86c4f":"8i8nh","579e4d8363ba2982":"ifiLz","b1cb2d523436c6f7":"8qmr0","d5949c690f083107":"fsdDM","40629ab56a8ae661":"fj3f7","f63c08d769c0daa3":"5DnfR","c341af1ba080817a":"azcY0","4950866566f1bccf":"kPpDy"}],"8gNzB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2d0d3a82d581b2a5");
require("6a6ab817c500759b");
require("1adbdb61d0564b69");
require("ce725a18188fc087");
require("3ce59e7dced411d2");
require("d9c6965ffc7aa241");
require("9af8698b5b1850dd");
require("174cfe6e1a3d6b7a");
var useProps = require("6914164af40ba467");
require("d369183181f4ccff");
require("5dd74f9424d96dc");
var factory = require("c4bf314af8dd63bf");
require("f2348421b0c6d0e5");
require("7f7bee8e9ea1f2c9");
require("7f48dd29b157e339");
require("3e1af718fca50dbb");
var ModalBaseContent = require("9d0737e996a4f2c1");
require("e80778c1f4b44317");
require("d8cdb9268da28573");
require("28f5be045fbf8bba");
var NativeScrollArea = require("b96d47088768e650");
var Drawer_context = require("179afa8e288d8a34");
var Drawer_module = require("f9fdc1f7bb9e7cf5");
var defaultProps = {};
var DrawerContent = factory.factory(function(_props, ref) {
    var props = useProps.useProps("DrawerContent", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, children = props.children, radius = props.radius, __hidden = props.__hidden, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "children",
        "radius",
        "__hidden"
    ]);
    var ctx = Drawer_context.useDrawerContext();
    var Scroll = ctx.scrollAreaComponent || NativeScrollArea.NativeScrollArea;
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseContent.ModalBaseContent, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("content", {
        className,
        style,
        styles,
        classNames
    })), {
        innerProps: ctx.getStyles("inner", {
            className,
            style,
            styles,
            classNames
        }),
        ref
    }), others), {
        radius: radius || ctx.radius || 0,
        "data-hidden": __hidden || void 0,
        children: /* @__PURE__ */ jsxRuntime.jsx(Scroll, {
            style: {
                height: "calc(100vh - var(--drawer-offset) * 2)"
            },
            children
        })
    }));
});
DrawerContent.classes = Drawer_module;
DrawerContent.displayName = "@mantine/core/DrawerContent";
exports.DrawerContent = DrawerContent; //# sourceMappingURL=DrawerContent.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","2d0d3a82d581b2a5":"iKGFf","6a6ab817c500759b":"9MtAM","1adbdb61d0564b69":"9HEEB","ce725a18188fc087":"8QFOC","3ce59e7dced411d2":"2FdJg","d9c6965ffc7aa241":"6AMGA","9af8698b5b1850dd":"erSvz","174cfe6e1a3d6b7a":"kqQOF","6914164af40ba467":"iivvn","d369183181f4ccff":"8YP4O","5dd74f9424d96dc":"gkGXc","c4bf314af8dd63bf":"guLFz","f2348421b0c6d0e5":"2onWA","7f7bee8e9ea1f2c9":"PGvLq","7f48dd29b157e339":"8i8nh","3e1af718fca50dbb":"ifiLz","9d0737e996a4f2c1":"8qmr0","e80778c1f4b44317":"fsdDM","d8cdb9268da28573":"fj3f7","28f5be045fbf8bba":"5DnfR","b96d47088768e650":"d55zN","179afa8e288d8a34":"azcY0","f9fdc1f7bb9e7cf5":"kPpDy"}],"8IHOY":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("96b43a4fbb2ac0a5");
require("1ca6591bc05ab5c3");
require("b513a8c0003b22f9");
require("c40fb60b8f66d351");
require("6039eff2de6f8ea");
require("3375ea007b4111f9");
require("551f57aa25c40dfd");
require("e1750b2e68056e85");
var useProps = require("c85fc0378b8c7653");
require("11cae40b85c3e128");
require("7696c4bc171840d8");
var factory = require("954a09bd1a99863");
require("4a0430280e7f4945");
require("214f1f3efc1302e7");
require("4f307c3f5833ddcc");
require("7f84b2a140ca7645");
require("40b883aa1ef59017");
var ModalBaseHeader = require("df3ba3a8136838f7");
require("e76ace006aa2737b");
require("167a51182a4054e0");
var Drawer_context = require("a9f6ba2f94991aa");
var Drawer_module = require("b85ee4f529afd38c");
var defaultProps = {};
var DrawerHeader = factory.factory(function(_props, ref) {
    var props = useProps.useProps("DrawerHeader", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Drawer_context.useDrawerContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseHeader.ModalBaseHeader, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("header", {
        classNames,
        style,
        styles,
        className
    }), others));
});
DrawerHeader.classes = Drawer_module;
DrawerHeader.displayName = "@mantine/core/DrawerHeader";
exports.DrawerHeader = DrawerHeader; //# sourceMappingURL=DrawerHeader.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","96b43a4fbb2ac0a5":"iKGFf","1ca6591bc05ab5c3":"9MtAM","b513a8c0003b22f9":"9HEEB","c40fb60b8f66d351":"8QFOC","6039eff2de6f8ea":"2FdJg","3375ea007b4111f9":"6AMGA","551f57aa25c40dfd":"erSvz","e1750b2e68056e85":"kqQOF","c85fc0378b8c7653":"iivvn","11cae40b85c3e128":"8YP4O","7696c4bc171840d8":"gkGXc","954a09bd1a99863":"guLFz","4a0430280e7f4945":"2onWA","214f1f3efc1302e7":"PGvLq","4f307c3f5833ddcc":"8i8nh","7f84b2a140ca7645":"ifiLz","40b883aa1ef59017":"8qmr0","df3ba3a8136838f7":"fsdDM","e76ace006aa2737b":"fj3f7","167a51182a4054e0":"5DnfR","a9f6ba2f94991aa":"azcY0","b85ee4f529afd38c":"kPpDy"}],"9A9ix":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f65fa639ae52f2fb");
require("6fdff30fe6e8a470");
require("1efc3b711ef2566f");
require("1b9440351f3709de");
require("b3d73089cbb5f126");
require("7417251b22c2a18");
require("36a76aa03bde6182");
require("382da06c06b1bdf7");
var useProps = require("19ac669e6db5e748");
require("2c41c0e0d55064db");
require("77689c3fbab2a770");
var factory = require("49003c6237c25ea5");
require("2c502290f19479dd");
require("e44b9e8caa3bb6e");
require("99d461a333b983d9");
require("b01c20706b6edb47");
require("5a8328293de9a660");
require("cd3d43d1913e9d9a");
var ModalBaseOverlay = require("df7df4da6c8dbb04");
require("5644a51b39c0931");
var Drawer_context = require("e9119d249ade1eb1");
var Drawer_module = require("2dfdf5933e96f578");
var defaultProps = {};
var DrawerOverlay = factory.factory(function(_props, ref) {
    var props = useProps.useProps("DrawerOverlay", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Drawer_context.useDrawerContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseOverlay.ModalBaseOverlay, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("overlay", {
        classNames,
        style,
        styles,
        className
    }), others));
});
DrawerOverlay.classes = Drawer_module;
DrawerOverlay.displayName = "@mantine/core/DrawerOverlay";
exports.DrawerOverlay = DrawerOverlay; //# sourceMappingURL=DrawerOverlay.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","f65fa639ae52f2fb":"iKGFf","6fdff30fe6e8a470":"9MtAM","1efc3b711ef2566f":"9HEEB","1b9440351f3709de":"8QFOC","b3d73089cbb5f126":"2FdJg","7417251b22c2a18":"6AMGA","36a76aa03bde6182":"erSvz","382da06c06b1bdf7":"kqQOF","19ac669e6db5e748":"iivvn","2c41c0e0d55064db":"8YP4O","77689c3fbab2a770":"gkGXc","49003c6237c25ea5":"guLFz","2c502290f19479dd":"2onWA","e44b9e8caa3bb6e":"PGvLq","99d461a333b983d9":"8i8nh","b01c20706b6edb47":"ifiLz","5a8328293de9a660":"8qmr0","cd3d43d1913e9d9a":"fsdDM","df7df4da6c8dbb04":"fj3f7","5644a51b39c0931":"5DnfR","e9119d249ade1eb1":"azcY0","2dfdf5933e96f578":"kPpDy"}],"lAkdZ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("62ed66add0410574");
var rem = require("771ec6885529464d");
require("7476a2e457ead883");
var getDefaultZIndex = require("8842d803fa66db42");
var getSize = require("939693402c56f886");
require("33b3b0843e6e3ecb");
var createVarsResolver = require("b3317ea5e7179994");
require("a366084f08dde978");
require("c52a99dde5b17f2d");
require("f6bc07b28f1d58d0");
require("4b515a1968c3d4a2");
require("7bb90affbf0e8309");
var useProps = require("1a4017166b0722fd");
require("84ccb8a582d33732");
var useStyles = require("36fa34512ea7b013");
require("dba152eee38c9bfc");
var factory = require("54fdfa66fc37fcb8");
var DirectionProvider = require("6b4fc23b92be2990");
var ModalBase = require("e46bce8063e7102b");
require("4a8da1efdb565695");
require("3aaa175ce05e9702");
require("14cc69799ab3e83d");
require("5075d780d8f0c69a");
require("54cc3b1f29f7966a");
require("8e765ab6c8ceecf");
var ScrollArea = require("f2a18ca1d675fb50");
var Drawer_context = require("9b37389735e526c5");
var Drawer_module = require("3eca0e939a0b449a");
function getDrawerAlign(position) {
    switch(position){
        case "top":
            return "flex-start";
        case "bottom":
            return "flex-end";
        default:
            return void 0;
    }
}
function getDrawerFlex(position) {
    if (position === "top" || position === "bottom") return "0 0 calc(100% - var(--drawer-offset, 0rem) * 2)";
    return void 0;
}
var transitions = {
    top: "slide-down",
    bottom: "slide-up",
    left: "slide-right",
    right: "slide-left"
};
var rtlTransitions = {
    top: "slide-down",
    bottom: "slide-up",
    right: "slide-right",
    left: "slide-left"
};
var defaultProps = {
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: getDefaultZIndex.getDefaultZIndex("modal"),
    position: "left"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var position = param.position, size = param.size, offset = param.offset;
    return {
        root: {
            "--drawer-size": getSize.getSize(size, "drawer-size"),
            "--drawer-flex": getDrawerFlex(position),
            "--drawer-height": position === "left" || position === "right" ? void 0 : "var(--drawer-size)",
            "--drawer-align": getDrawerAlign(position),
            "--drawer-justify": position === "right" ? "flex-end" : void 0,
            "--drawer-offset": rem.rem(offset)
        }
    };
});
var DrawerRoot = factory.factory(function(_props, ref) {
    var props = useProps.useProps("DrawerRoot", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, scrollAreaComponent = props.scrollAreaComponent, position = props.position, transitionProps = props.transitionProps, radius = props.radius, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "scrollAreaComponent",
        "position",
        "transitionProps",
        "radius"
    ]);
    var dir = DirectionProvider.useDirection().dir;
    var getStyles = useStyles.useStyles({
        name: "Drawer",
        classes: Drawer_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var drawerTransition = (dir === "rtl" ? rtlTransitions : transitions)[position];
    return /* @__PURE__ */ jsxRuntime.jsx(Drawer_context.DrawerProvider, {
        value: {
            scrollAreaComponent,
            getStyles,
            radius
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(ModalBase.ModalBase, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            ref
        }, getStyles("root")), {
            transitionProps: (0, _objectSpread._)({
                transition: drawerTransition
            }, transitionProps),
            "data-offset-scrollbars": scrollAreaComponent === ScrollArea.ScrollArea.Autosize || void 0,
            unstyled
        }), others))
    });
});
DrawerRoot.classes = Drawer_module;
DrawerRoot.displayName = "@mantine/core/DrawerRoot";
exports.DrawerRoot = DrawerRoot; //# sourceMappingURL=DrawerRoot.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","62ed66add0410574":"iKGFf","771ec6885529464d":"ebAaL","7476a2e457ead883":"9MtAM","8842d803fa66db42":"4gavl","939693402c56f886":"kEFEY","33b3b0843e6e3ecb":"9HEEB","b3317ea5e7179994":"hIQE6","a366084f08dde978":"8QFOC","c52a99dde5b17f2d":"2FdJg","f6bc07b28f1d58d0":"6AMGA","4b515a1968c3d4a2":"erSvz","7bb90affbf0e8309":"kqQOF","1a4017166b0722fd":"iivvn","84ccb8a582d33732":"8YP4O","36fa34512ea7b013":"d0sAY","dba152eee38c9bfc":"gkGXc","54fdfa66fc37fcb8":"guLFz","6b4fc23b92be2990":"2onWA","e46bce8063e7102b":"PGvLq","4a8da1efdb565695":"8i8nh","3aaa175ce05e9702":"ifiLz","14cc69799ab3e83d":"8qmr0","5075d780d8f0c69a":"fsdDM","54cc3b1f29f7966a":"fj3f7","8e765ab6c8ceecf":"5DnfR","f2a18ca1d675fb50":"ctZfT","9b37389735e526c5":"azcY0","3eca0e939a0b449a":"kPpDy"}],"ey4tq":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("b0d8838cc5cf35f0");
var React = require("3c68caa8e8a59683");
var createOptionalContext = require("a7521ce8142921c2");
var getDefaultZIndex = require("58df4c28d5813cac");
require("1f02e100e4e06c05");
require("2551c4e15e3e7cf2");
require("c7252bf8324ec900");
require("bfa573b87703e7dd");
require("5d79dbd45014ea04");
require("ff5b66df018ef8c9");
require("50c82c76c88e54e3");
require("7332dcd69d894c14");
require("46312504a9a158f3");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), DrawerStackProvider = _createOptionalContext_createOptionalContext[0], useDrawerStackContext = _createOptionalContext_createOptionalContext[1];
function DrawerStack(param) {
    var children = param.children;
    var _React_useState = (0, _slicedToArray._)(React.useState([]), 2), stack = _React_useState[0], setStack = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(getDefaultZIndex.getDefaultZIndex("modal")), 2), maxZIndex = _React_useState1[0], setMaxZIndex = _React_useState1[1];
    return /* @__PURE__ */ jsxRuntime.jsx(DrawerStackProvider, {
        value: {
            stack,
            addModal: function(id, zIndex) {
                setStack(function(current) {
                    return (0, _toConsumableArray._)(/* @__PURE__ */ new Set((0, _toConsumableArray._)(current).concat([
                        id
                    ])));
                });
                setMaxZIndex(function(current) {
                    return typeof zIndex === "number" && typeof current === "number" ? Math.max(current, zIndex) : current;
                });
            },
            removeModal: function(id) {
                return setStack(function(current) {
                    return current.filter(function(currentId) {
                        return currentId !== id;
                    });
                });
            },
            getZIndex: function(id) {
                return `calc(${maxZIndex} + ${stack.indexOf(id)} + 1)`;
            },
            currentId: stack[stack.length - 1],
            maxZIndex
        },
        children
    });
}
DrawerStack.displayName = "@mantine/core/DrawerStack";
exports.DrawerStack = DrawerStack;
exports.useDrawerStackContext = useDrawerStackContext; //# sourceMappingURL=DrawerStack.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","b0d8838cc5cf35f0":"iKGFf","3c68caa8e8a59683":"9MtAM","a7521ce8142921c2":"7cMAR","58df4c28d5813cac":"4gavl","1f02e100e4e06c05":"9HEEB","2551c4e15e3e7cf2":"8QFOC","c7252bf8324ec900":"2FdJg","bfa573b87703e7dd":"6AMGA","5d79dbd45014ea04":"erSvz","ff5b66df018ef8c9":"kqQOF","50c82c76c88e54e3":"8YP4O","7332dcd69d894c14":"gkGXc","46312504a9a158f3":"2onWA"}],"1oTM5":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b96b33c6be4041e0");
require("fd94ec85f6294d45");
require("db7d13e016728eda");
require("4cad06f3ad51f53c");
require("155862520d6131b1");
require("347b9f61b572a2fc");
require("f077a9ec40378d8c");
require("59353cc11772a19c");
var useProps = require("4cbb64aa835df36d");
require("4f306858c78e06fd");
require("ce8f27cefa626693");
var factory = require("a142bbf52af2afd2");
require("e88866573efca464");
require("567dcdbb000754e");
require("54cdd43c086c8557");
require("13a0d32f842ff288");
require("4fb3f29a011f044d");
require("4b16dd043695ce13");
require("d9b7ba8a36d2c09");
var ModalBaseTitle = require("9fadbed858c0d75b");
var Drawer_context = require("de9eb0e135923bbf");
var Drawer_module = require("3790d6f6c29668c8");
var defaultProps = {};
var DrawerTitle = factory.factory(function(_props, ref) {
    var props = useProps.useProps("DrawerTitle", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Drawer_context.useDrawerContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseTitle.ModalBaseTitle, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("title", {
        classNames,
        style,
        styles,
        className
    }), others));
});
DrawerTitle.classes = Drawer_module;
DrawerTitle.displayName = "@mantine/core/DrawerTitle";
exports.DrawerTitle = DrawerTitle; //# sourceMappingURL=DrawerTitle.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","b96b33c6be4041e0":"iKGFf","fd94ec85f6294d45":"9MtAM","db7d13e016728eda":"9HEEB","4cad06f3ad51f53c":"8QFOC","155862520d6131b1":"2FdJg","347b9f61b572a2fc":"6AMGA","f077a9ec40378d8c":"erSvz","59353cc11772a19c":"kqQOF","4cbb64aa835df36d":"iivvn","4f306858c78e06fd":"8YP4O","ce8f27cefa626693":"gkGXc","a142bbf52af2afd2":"guLFz","e88866573efca464":"2onWA","567dcdbb000754e":"PGvLq","54cdd43c086c8557":"8i8nh","13a0d32f842ff288":"ifiLz","4fb3f29a011f044d":"8qmr0","4b16dd043695ce13":"fsdDM","d9b7ba8a36d2c09":"fj3f7","9fadbed858c0d75b":"5DnfR","de9eb0e135923bbf":"azcY0","3790d6f6c29668c8":"kPpDy"}],"3WPU8":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("605fc04ec48300fe");
require("c74f0e6a13b923c8");
var getSize = require("2ef1ed8fb8aea2a8");
require("4bea3f262b73b86e");
var createVarsResolver = require("4de828907b2de42");
require("a2afba87a582bcf1");
require("b1c7360390112619");
require("b28eba11d2464763");
require("3429197b3d02f73e");
require("7421a569bec8ea56");
var useProps = require("afff66ab5e1be9f3");
require("b60904ab64afb3d5");
var useStyles = require("34ca415b43effd06");
var Box = require("2a9e50339d106236");
var factory = require("2d04736ab0587111");
require("96a983ad1e73551a");
var Fieldset_module = require("4eb7f980dd6b29d8");
var defaultProps = {
    variant: "default"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius;
    return {
        root: {
            "--fieldset-radius": radius === void 0 ? void 0 : getSize.getRadius(radius)
        }
    };
});
var Fieldset = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Fieldset", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, legend = props.legend, variant = props.variant, children = props.children, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "legend",
        "variant",
        "children"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Fieldset",
        classes: Fieldset_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "fieldset",
        ref,
        variant
    }, getStyles("root", {
        variant
    }), others), {
        children: [
            legend && /* @__PURE__ */ jsxRuntime.jsx("legend", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("legend", {
                variant
            })), {
                children: legend
            })),
            children
        ]
    }));
});
Fieldset.classes = Fieldset_module;
Fieldset.displayName = "@mantine/core/Fieldset";
exports.Fieldset = Fieldset; //# sourceMappingURL=Fieldset.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","605fc04ec48300fe":"iKGFf","c74f0e6a13b923c8":"9MtAM","2ef1ed8fb8aea2a8":"kEFEY","4bea3f262b73b86e":"9HEEB","4de828907b2de42":"hIQE6","a2afba87a582bcf1":"8QFOC","b1c7360390112619":"2FdJg","b28eba11d2464763":"6AMGA","3429197b3d02f73e":"erSvz","7421a569bec8ea56":"kqQOF","afff66ab5e1be9f3":"iivvn","b60904ab64afb3d5":"8YP4O","34ca415b43effd06":"d0sAY","2a9e50339d106236":"gkGXc","2d04736ab0587111":"guLFz","96a983ad1e73551a":"2onWA","4eb7f980dd6b29d8":"b6oWB"}],"b6oWB":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_e9408a47",
    "root--default": "m_84c9523a",
    "root--filled": "m_ef274e49",
    "root--unstyled": "m_eda993d3",
    "legend": "m_90794832",
    "legend--unstyled": "m_74ca27fe"
};
module.exports = classes; //# sourceMappingURL=Fieldset.module.css.cjs.map

},{}],"eTxzQ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("e3eafaa4c155b0fc");
var React = require("b1bd236b249ea50d");
var hooks = require("87545831404f767a");
require("8c22d733c5c2c2e2");
require("5c3e67adf68210fc");
require("13ca09dc08f91cc7");
require("7cd225e9198267f7");
require("17004f99d44d06d1");
var useProps = require("4f413fb5ac5c7a31");
require("863103dc26f1f5a9");
require("d901e74270f178bc");
require("3962dd662a9c085e");
var defaultProps = {
    multiple: false
};
var FileButton = React.forwardRef(function(props, ref) {
    var _useProps_useProps = useProps.useProps("FileButton", defaultProps, props), onChange = _useProps_useProps.onChange, children = _useProps_useProps.children, multiple = _useProps_useProps.multiple, accept = _useProps_useProps.accept, name = _useProps_useProps.name, form = _useProps_useProps.form, resetRef = _useProps_useProps.resetRef, disabled = _useProps_useProps.disabled, capture = _useProps_useProps.capture, inputProps = _useProps_useProps.inputProps, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "onChange",
        "children",
        "multiple",
        "accept",
        "name",
        "form",
        "resetRef",
        "disabled",
        "capture",
        "inputProps"
    ]);
    var inputRef = React.useRef(null);
    var onClick = function() {
        var _inputRef_current;
        !disabled && ((_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.click());
    };
    var handleChange = function(event) {
        if (multiple) onChange(Array.from(event.currentTarget.files));
        else onChange(event.currentTarget.files[0] || null);
    };
    var reset = function() {
        if (inputRef.current) inputRef.current.value = "";
    };
    hooks.assignRef(resetRef, reset);
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            children((0, _objectSpread._)({
                onClick
            }, others)),
            /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)({
                style: {
                    display: "none"
                },
                type: "file",
                accept,
                multiple,
                onChange: handleChange,
                ref: hooks.useMergedRef(ref, inputRef),
                name,
                form,
                capture
            }, inputProps))
        ]
    });
});
FileButton.displayName = "@mantine/core/FileButton";
exports.FileButton = FileButton; //# sourceMappingURL=FileButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","e3eafaa4c155b0fc":"iKGFf","b1bd236b249ea50d":"9MtAM","87545831404f767a":"9HEEB","8c22d733c5c2c2e2":"8QFOC","5c3e67adf68210fc":"2FdJg","13ca09dc08f91cc7":"6AMGA","7cd225e9198267f7":"erSvz","17004f99d44d06d1":"kqQOF","4f413fb5ac5c7a31":"iivvn","863103dc26f1f5a9":"8YP4O","d901e74270f178bc":"gkGXc","3962dd662a9c085e":"2onWA"}],"ti1Nx":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("215b4a4c837d8d26");
var React = require("9c80a4f3a4194f3d");
var hooks = require("148727204ef92430");
require("47b41df1e42150aa");
var useResolvedStylesApi = require("8da26d42719548b8");
require("6bdcbd81393edd46");
require("733af48c27aae77e");
require("6a8d9f0ca0315fff");
require("471d961fa8b0cb29");
var useProps = require("82f1fcdcfd0b6556");
require("34e16357e07e0968");
require("939e9752021501c3");
var factory = require("968c294d42ab5671");
require("18b06c2937e17f5c");
require("63c72ce53bbbda67");
var CloseButton = require("c861bbc3b8967a05");
var FileButton = require("3c411f8d6d4d5de9");
var Input = require("21e5945954850029");
require("7dc67069d677af4f");
require("a2fe2051402727c6");
require("cafcdbd98e20d004");
require("3fbf94228c0b9857");
require("14d3ce45078d971b");
require("5ab9d276f2ab86dc");
require("7aa4e279f6a876b");
var InputBase = require("2811a233657d8d1e");
var DefaultValue = function(param) {
    var value = param.value;
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        children: Array.isArray(value) ? value.map(function(file) {
            return file.name;
        }).join(", ") : value === null || value === void 0 ? void 0 : value.name
    });
};
var defaultProps = {
    valueComponent: DefaultValue
};
var _FileInput = factory.factory(function(_props, ref) {
    var props = useProps.useProps("FileInput", defaultProps, _props);
    var unstyled = props.unstyled, vars = props.vars, onChange = props.onChange, value = props.value, defaultValue = props.defaultValue, multiple = props.multiple, accept = props.accept, name = props.name, form = props.form, valueComponent = props.valueComponent, clearable = props.clearable, clearButtonProps = props.clearButtonProps, readOnly = props.readOnly, capture = props.capture, fileInputProps = props.fileInputProps, rightSection = props.rightSection, size = props.size, placeholder = props.placeholder, component = props.component, resetRefProp = props.resetRef, classNames = props.classNames, styles = props.styles, others = (0, _objectWithoutProperties._)(props, [
        "unstyled",
        "vars",
        "onChange",
        "value",
        "defaultValue",
        "multiple",
        "accept",
        "name",
        "form",
        "valueComponent",
        "clearable",
        "clearButtonProps",
        "readOnly",
        "capture",
        "fileInputProps",
        "rightSection",
        "size",
        "placeholder",
        "component",
        "resetRef",
        "classNames",
        "styles"
    ]);
    var resetRef = React.useRef(null);
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        onChange,
        finalValue: multiple ? [] : null
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var hasValue = Array.isArray(_value) ? _value.length !== 0 : _value !== null;
    var _rightSection = rightSection || (clearable && hasValue && !readOnly ? /* @__PURE__ */ jsxRuntime.jsx(CloseButton.CloseButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, clearButtonProps), {
        variant: "subtle",
        onClick: function() {
            return setValue(multiple ? [] : null);
        },
        size,
        unstyled
    })) : null);
    React.useEffect(function() {
        var _resetRef_current;
        if (Array.isArray(_value) && _value.length === 0 || _value === null) (_resetRef_current = resetRef.current) === null || _resetRef_current === void 0 ? void 0 : _resetRef_current.call(resetRef);
    }, [
        _value
    ]);
    var ValueComponent = valueComponent;
    return /* @__PURE__ */ jsxRuntime.jsx(FileButton.FileButton, {
        onChange: setValue,
        multiple,
        accept,
        name,
        form,
        resetRef: hooks.useMergedRef(resetRef, resetRefProp),
        disabled: readOnly,
        capture,
        inputProps: fileInputProps,
        children: function(fileButtonProps) {
            return /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpreadProps._)((0, _objectSpread._)({
                component: component || "button",
                ref,
                rightSection: _rightSection
            }, fileButtonProps, others), {
                __staticSelector: "FileInput",
                multiline: true,
                type: "button",
                pointer: true,
                __stylesApiProps: props,
                unstyled,
                size,
                classNames,
                styles,
                children: !hasValue ? /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Placeholder, {
                    __staticSelector: "FileInput",
                    classNames: resolvedClassNames,
                    styles: resolvedStyles,
                    children: placeholder
                }) : /* @__PURE__ */ jsxRuntime.jsx(ValueComponent, {
                    value: _value
                })
            }));
        }
    });
});
_FileInput.classes = InputBase.InputBase.classes;
_FileInput.displayName = "@mantine/core/FileInput";
var FileInput = _FileInput;
exports.FileInput = FileInput; //# sourceMappingURL=FileInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","215b4a4c837d8d26":"iKGFf","9c80a4f3a4194f3d":"9MtAM","148727204ef92430":"9HEEB","47b41df1e42150aa":"8QFOC","8da26d42719548b8":"d30sL","6bdcbd81393edd46":"2FdJg","733af48c27aae77e":"6AMGA","6a8d9f0ca0315fff":"erSvz","471d961fa8b0cb29":"kqQOF","82f1fcdcfd0b6556":"iivvn","34e16357e07e0968":"8YP4O","939e9752021501c3":"gkGXc","968c294d42ab5671":"guLFz","18b06c2937e17f5c":"2onWA","63c72ce53bbbda67":"h6AYi","c861bbc3b8967a05":"4ZuRG","3c411f8d6d4d5de9":"eTxzQ","21e5945954850029":"dkUgf","7dc67069d677af4f":"j4uTK","a2fe2051402727c6":"7nO1x","cafcdbd98e20d004":"3Bda4","3fbf94228c0b9857":"gQBOr","14d3ce45078d971b":"lRBdM","5ab9d276f2ab86dc":"hxtex","7aa4e279f6a876b":"lQt5D","2811a233657d8d1e":"jbA6w"}],"hFhuj":[function(require,module,exports) {
"use client";
"use strict";
var React = require("fdb614288edad33c");
function useDelayedHover(param) {
    var open = param.open, close = param.close, openDelay = param.openDelay, closeDelay = param.closeDelay;
    var openTimeout = React.useRef(-1);
    var closeTimeout = React.useRef(-1);
    var clearTimeouts = function() {
        window.clearTimeout(openTimeout.current);
        window.clearTimeout(closeTimeout.current);
    };
    var openDropdown = function() {
        clearTimeouts();
        if (openDelay === 0 || openDelay === void 0) open();
        else openTimeout.current = window.setTimeout(open, openDelay);
    };
    var closeDropdown = function() {
        clearTimeouts();
        if (closeDelay === 0 || closeDelay === void 0) close();
        else closeTimeout.current = window.setTimeout(close, closeDelay);
    };
    React.useEffect(function() {
        return clearTimeouts;
    }, []);
    return {
        openDropdown,
        closeDropdown
    };
}
exports.useDelayedHover = useDelayedHover; //# sourceMappingURL=use-delayed-hover.cjs.map

},{"fdb614288edad33c":"9MtAM"}],"a96NW":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("4238ef2dd8b68f86");
require("9590b6ded1f48e5b");
require("5685277b2c038b5d");
var createVarsResolver = require("25e09ae4a98c1577");
require("2fa24376aba446f4");
require("24a1561cdab16ce1");
require("c6c77dc3d907aeef");
require("809083a140b23a72");
require("ac3e77accde34ce4");
var useProps = require("fcdce4a45280aa44");
require("2c5411c6a7990b13");
var useStyles = require("60b78e135a372f1a");
var useRandomClassname = require("935ab845e83aa87d");
var Box = require("541dfe81634b1999");
var factory = require("9586ec36d77c0885");
require("fc55b5a850a526a5");
var Grid_context = require("c7e7b8b1580082c7");
var GridCol = require("6d8c6af0e41ead5e");
var GridVariables = require("253ebbeed47718ef");
var Grid_module = require("3fc54f92b5c59e4");
var defaultProps = {
    gutter: "md",
    grow: false,
    columns: 12
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var justify = param.justify, align = param.align, overflow = param.overflow;
    return {
        root: {
            "--grid-justify": justify,
            "--grid-align": align,
            "--grid-overflow": overflow
        }
    };
});
var Grid = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Grid", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, grow = props.grow, gutter = props.gutter, columns = props.columns, align = props.align, justify = props.justify, children = props.children, breakpoints = props.breakpoints, type = props.type, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "grow",
        "gutter",
        "columns",
        "align",
        "justify",
        "children",
        "breakpoints",
        "type"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Grid",
        classes: Grid_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var responsiveClassName = useRandomClassname.useRandomClassName();
    if (type === "container" && breakpoints) return /* @__PURE__ */ jsxRuntime.jsxs(Grid_context.GridProvider, {
        value: {
            getStyles,
            grow,
            columns: columns || 12,
            breakpoints,
            type
        },
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(GridVariables.GridVariables, (0, _objectSpread._)({
                selector: `.${responsiveClassName}`
            }, props)),
            /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("container")), {
                children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    ref
                }, getStyles("root", {
                    className: responsiveClassName
                }), others), {
                    children: /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("inner")), {
                        children
                    }))
                }))
            }))
        ]
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Grid_context.GridProvider, {
        value: {
            getStyles,
            grow,
            columns: columns || 12,
            breakpoints,
            type
        },
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(GridVariables.GridVariables, (0, _objectSpread._)({
                selector: `.${responsiveClassName}`
            }, props)),
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                ref
            }, getStyles("root", {
                className: responsiveClassName
            }), others), {
                children: /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("inner")), {
                    children
                }))
            }))
        ]
    });
});
Grid.classes = Grid_module;
Grid.displayName = "@mantine/core/Grid";
Grid.Col = GridCol.GridCol;
exports.Grid = Grid; //# sourceMappingURL=Grid.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","4238ef2dd8b68f86":"iKGFf","9590b6ded1f48e5b":"9MtAM","5685277b2c038b5d":"9HEEB","25e09ae4a98c1577":"hIQE6","2fa24376aba446f4":"8QFOC","24a1561cdab16ce1":"2FdJg","c6c77dc3d907aeef":"6AMGA","809083a140b23a72":"erSvz","ac3e77accde34ce4":"kqQOF","fcdce4a45280aa44":"iivvn","2c5411c6a7990b13":"8YP4O","60b78e135a372f1a":"d0sAY","935ab845e83aa87d":"2rhHN","541dfe81634b1999":"gkGXc","9586ec36d77c0885":"guLFz","fc55b5a850a526a5":"2onWA","c7e7b8b1580082c7":"6Y6U4","6d8c6af0e41ead5e":"aGhvE","253ebbeed47718ef":"1cTA2","3fc54f92b5c59e4":"7jZ29"}],"6Y6U4":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("59d4afabd0aff8ca");
var createSafeContext = require("4f65c4756bb5e68b");
require("aebbfd92280711fc");
require("97c91b781bfecd7d");
require("c1731c7b54a1f99f");
require("ee196b675451d60d");
require("abc73d8473231f3");
require("1a7b6beeebcef0ef");
require("6e950ddd7106b405");
require("6de839d900c2c166");
require("49b5964a5f220493");
require("a858220945d7a2dc");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Grid component was not found in tree"), 2), GridProvider = _createSafeContext_createSafeContext[0], useGridContext = _createSafeContext_createSafeContext[1];
exports.GridProvider = GridProvider;
exports.useGridContext = useGridContext; //# sourceMappingURL=Grid.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","59d4afabd0aff8ca":"9MtAM","4f65c4756bb5e68b":"8srze","aebbfd92280711fc":"iKGFf","97c91b781bfecd7d":"9HEEB","c1731c7b54a1f99f":"8QFOC","ee196b675451d60d":"2FdJg","abc73d8473231f3":"6AMGA","1a7b6beeebcef0ef":"erSvz","6e950ddd7106b405":"kqQOF","6de839d900c2c166":"8YP4O","49b5964a5f220493":"gkGXc","a858220945d7a2dc":"2onWA"}],"aGhvE":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("fb3044e22edd7c7a");
var cx = require("9e043f9edab834b6");
require("4352a912c72017e0");
require("ee17e42d87c04530");
require("597622675268dccd");
require("5cc9cd6c36ad74e1");
require("a7aac339de985ed3");
require("a3d5928ccd8f0538");
var useProps = require("a9a15048ffc3b089");
require("642c1832ad20e5cb");
var useRandomClassname = require("fdad9b03800edf98");
var Box = require("69e92dab9b6d2e83");
var factory = require("11b06486f2b0ed2a");
require("4f20dffa95823111");
var Grid_context = require("bd5e7993d773abf1");
var GridColVariables = require("fa4f324d754c0589");
var Grid_module = require("1146604829439a22");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var defaultProps = {
    span: 12
};
var GridCol = factory.factory(function(_props, ref) {
    var props = useProps.useProps("GridCol", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, span = props.span, order = props.order, offset = props.offset, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "span",
        "order",
        "offset"
    ]);
    var ctx = Grid_context.useGridContext();
    var responsiveClassName = useRandomClassname.useRandomClassName();
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(GridColVariables.GridColVariables, {
                selector: `.${responsiveClassName}`,
                span,
                order,
                offset
            }),
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
                ref
            }, ctx.getStyles("col", {
                className: cx__default.default(className, responsiveClassName),
                style,
                classNames,
                styles
            }), others))
        ]
    });
});
GridCol.classes = Grid_module;
GridCol.displayName = "@mantine/core/GridCol";
exports.GridCol = GridCol; //# sourceMappingURL=GridCol.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","fb3044e22edd7c7a":"iKGFf","9e043f9edab834b6":"8QFOC","4352a912c72017e0":"9MtAM","ee17e42d87c04530":"9HEEB","597622675268dccd":"2FdJg","5cc9cd6c36ad74e1":"6AMGA","a7aac339de985ed3":"erSvz","a3d5928ccd8f0538":"kqQOF","a9a15048ffc3b089":"iivvn","642c1832ad20e5cb":"8YP4O","fdad9b03800edf98":"2rhHN","69e92dab9b6d2e83":"gkGXc","11b06486f2b0ed2a":"guLFz","4f20dffa95823111":"2onWA","bd5e7993d773abf1":"6Y6U4","fa4f324d754c0589":"fceEw","1146604829439a22":"7jZ29"}],"fceEw":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("25d9ffc13414bf6a");
var keys = require("fed9d59a0e81c978");
var filterProps = require("3df899fef8ca6420");
require("be3e6a15970971ad");
var getSortedBreakpoints = require("1d2fc19e59d96233");
var getBaseValue = require("bddebf9e52366b29");
require("cf799ffaea9208f8");
require("19fc0221b6359ee5");
require("3220f550a4dfd45f");
require("49e390b682a6c614");
require("89f2ccdc3fcc9578");
var MantineThemeProvider = require("1d04ccb94836e48f");
require("c717bc6648d82b5");
var InlineStyles = require("864b93a199e6debb");
require("ed5e82b8ea6aca70");
require("723555037e99b614");
var Grid_context = require("b5d69441719e966c");
var getColumnFlexBasis = function(colSpan, columns) {
    if (colSpan === "content") return "auto";
    if (colSpan === "auto") return "0rem";
    return colSpan ? `${100 / (columns / colSpan)}%` : void 0;
};
var getColumnMaxWidth = function(colSpan, columns, grow) {
    if (grow || colSpan === "auto") return "100%";
    if (colSpan === "content") return "unset";
    return getColumnFlexBasis(colSpan, columns);
};
var getColumnFlexGrow = function(colSpan, grow) {
    if (!colSpan) return void 0;
    return colSpan === "auto" || grow ? "1" : "auto";
};
var getColumnOffset = function(offset, columns) {
    return offset === 0 ? "0" : offset ? `${100 / (columns / offset)}%` : void 0;
};
function GridColVariables(param) {
    var span = param.span, order = param.order, offset = param.offset, selector = param.selector;
    var _getBaseValue_getBaseValue;
    var theme = MantineThemeProvider.useMantineTheme();
    var ctx = Grid_context.useGridContext();
    var _breakpoints = ctx.breakpoints || theme.breakpoints;
    var baseValue = getBaseValue.getBaseValue(span);
    var baseSpan = baseValue === void 0 ? 12 : getBaseValue.getBaseValue(span);
    var baseStyles = filterProps.filterProps({
        "--col-order": (_getBaseValue_getBaseValue = getBaseValue.getBaseValue(order)) === null || _getBaseValue_getBaseValue === void 0 ? void 0 : _getBaseValue_getBaseValue.toString(),
        "--col-flex-grow": getColumnFlexGrow(baseSpan, ctx.grow),
        "--col-flex-basis": getColumnFlexBasis(baseSpan, ctx.columns),
        "--col-width": baseSpan === "content" ? "auto" : void 0,
        "--col-max-width": getColumnMaxWidth(baseSpan, ctx.columns, ctx.grow),
        "--col-offset": getColumnOffset(getBaseValue.getBaseValue(offset), ctx.columns)
    });
    var queries = keys.keys(_breakpoints).reduce(function(acc, breakpoint) {
        var _order_breakpoint;
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof order === "object" && order[breakpoint] !== void 0) acc[breakpoint]["--col-order"] = (_order_breakpoint = order[breakpoint]) === null || _order_breakpoint === void 0 ? void 0 : _order_breakpoint.toString();
        if (typeof span === "object" && span[breakpoint] !== void 0) {
            acc[breakpoint]["--col-flex-grow"] = getColumnFlexGrow(span[breakpoint], ctx.grow);
            acc[breakpoint]["--col-flex-basis"] = getColumnFlexBasis(span[breakpoint], ctx.columns);
            acc[breakpoint]["--col-width"] = span[breakpoint] === "content" ? "auto" : void 0;
            acc[breakpoint]["--col-max-width"] = getColumnMaxWidth(span[breakpoint], ctx.columns, ctx.grow);
        }
        if (typeof offset === "object" && offset[breakpoint] !== void 0) acc[breakpoint]["--col-offset"] = getColumnOffset(offset[breakpoint], ctx.columns);
        return acc;
    }, {});
    var sortedBreakpoints = getSortedBreakpoints.getSortedBreakpoints(keys.keys(queries), _breakpoints).filter(function(breakpoint) {
        return keys.keys(queries[breakpoint.value]).length > 0;
    });
    var values = sortedBreakpoints.map(function(breakpoint) {
        return {
            query: ctx.type === "container" ? `mantine-grid (min-width: ${_breakpoints[breakpoint.value]})` : `(min-width: ${_breakpoints[breakpoint.value]})`,
            styles: queries[breakpoint.value]
        };
    });
    return /* @__PURE__ */ jsxRuntime.jsx(InlineStyles.InlineStyles, {
        styles: baseStyles,
        media: ctx.type === "container" ? void 0 : values,
        container: ctx.type === "container" ? values : void 0,
        selector
    });
}
exports.GridColVariables = GridColVariables; //# sourceMappingURL=GridColVariables.cjs.map

},{"25d9ffc13414bf6a":"iKGFf","fed9d59a0e81c978":"kvYzO","3df899fef8ca6420":"2Jst9","be3e6a15970971ad":"9MtAM","1d2fc19e59d96233":"lwwF0","bddebf9e52366b29":"4aQII","cf799ffaea9208f8":"9HEEB","19fc0221b6359ee5":"8QFOC","3220f550a4dfd45f":"2FdJg","49e390b682a6c614":"6AMGA","89f2ccdc3fcc9578":"erSvz","1d04ccb94836e48f":"kqQOF","c717bc6648d82b5":"8YP4O","864b93a199e6debb":"3CHN8","ed5e82b8ea6aca70":"gkGXc","723555037e99b614":"2onWA","b5d69441719e966c":"6Y6U4"}],"7jZ29":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "container": "m_8478a6da",
    "root": "m_410352e9",
    "inner": "m_dee7bd2f",
    "col": "m_96bdd299"
};
module.exports = classes; //# sourceMappingURL=Grid.module.css.cjs.map

},{}],"1cTA2":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("76a8e881efee779a");
var keys = require("23fe516ce394cf64");
var filterProps = require("eb5d9e62cdb61a69");
require("be0c0f45756936e0");
var getSize = require("af297799bae3af59");
var getSortedBreakpoints = require("80ccb5b02915eafc");
var getBaseValue = require("679e6dea66a0425e");
require("77c77fcbaeb8bfcc");
require("bf5e254368caf31d");
require("76fbfa17e453a3c0");
require("6164556dd7ac85b2");
require("db1b24a7030bc497");
var MantineThemeProvider = require("9655c89fe6c52d64");
require("13b0c7688ba96b3f");
var InlineStyles = require("ff5fb69a56c6cfc3");
require("11735fd9dd1e6245");
require("e1f1007bf777b3c4");
function GridVariables(param) {
    var gutter = param.gutter, selector = param.selector, breakpoints = param.breakpoints, type = param.type;
    var theme = MantineThemeProvider.useMantineTheme();
    var _breakpoints = breakpoints || theme.breakpoints;
    var baseStyles = filterProps.filterProps({
        "--grid-gutter": getSize.getSpacing(getBaseValue.getBaseValue(gutter))
    });
    var queries = keys.keys(_breakpoints).reduce(function(acc, breakpoint) {
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof gutter === "object" && gutter[breakpoint] !== void 0) acc[breakpoint]["--grid-gutter"] = getSize.getSpacing(gutter[breakpoint]);
        return acc;
    }, {});
    var sortedBreakpoints = getSortedBreakpoints.getSortedBreakpoints(keys.keys(queries), _breakpoints).filter(function(breakpoint) {
        return keys.keys(queries[breakpoint.value]).length > 0;
    });
    var values = sortedBreakpoints.map(function(breakpoint) {
        return {
            query: type === "container" ? `mantine-grid (min-width: ${_breakpoints[breakpoint.value]})` : `(min-width: ${_breakpoints[breakpoint.value]})`,
            styles: queries[breakpoint.value]
        };
    });
    return /* @__PURE__ */ jsxRuntime.jsx(InlineStyles.InlineStyles, {
        styles: baseStyles,
        media: type === "container" ? void 0 : values,
        container: type === "container" ? values : void 0,
        selector
    });
}
exports.GridVariables = GridVariables; //# sourceMappingURL=GridVariables.cjs.map

},{"76a8e881efee779a":"iKGFf","23fe516ce394cf64":"kvYzO","eb5d9e62cdb61a69":"2Jst9","be0c0f45756936e0":"9MtAM","af297799bae3af59":"kEFEY","80ccb5b02915eafc":"lwwF0","679e6dea66a0425e":"4aQII","77c77fcbaeb8bfcc":"9HEEB","bf5e254368caf31d":"8QFOC","76fbfa17e453a3c0":"2FdJg","6164556dd7ac85b2":"6AMGA","db1b24a7030bc497":"erSvz","9655c89fe6c52d64":"kqQOF","13b0c7688ba96b3f":"8YP4O","ff5fb69a56c6cfc3":"3CHN8","11735fd9dd1e6245":"gkGXc","e1f1007bf777b3c4":"2onWA"}],"bbQP4":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("9260823b2934c2be");
require("825a6875b2c7ee17");
require("bbb0ef6577f30ccb");
require("b0e8a4ea0f1c414f");
require("f0704d3e1c62826a");
require("e02a596de341837b");
require("bd0218447ba9c269");
require("1ea6e695d71ba1db");
var useProps = require("16a2aeaad4c80bf2");
require("a7aaefa18b748d17");
require("aa0997fe8882e26c");
var polymorphicFactory = require("cfeb3f07c79c4e9d");
require("144e636630998843");
var Mark = require("c0887992dee1e237");
var Text = require("3b27bb51c17dca2f");
var highlighter = require("fa69581fc5a003b6");
var defaultProps = {};
var Highlight = polymorphicFactory.polymorphicFactory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("Highlight", defaultProps, props), unstyled = _useProps_useProps.unstyled, children = _useProps_useProps.children, highlight = _useProps_useProps.highlight, highlightStyles = _useProps_useProps.highlightStyles, color = _useProps_useProps.color, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "unstyled",
        "children",
        "highlight",
        "highlightStyles",
        "color"
    ]);
    var highlightChunks = highlighter.highlighter(children, highlight);
    return /* @__PURE__ */ jsxRuntime.jsx(Text.Text, (0, _objectSpreadProps._)((0, _objectSpread._)({
        unstyled,
        ref
    }, others), {
        __staticSelector: "Highlight",
        children: highlightChunks.map(function(param, i) {
            var chunk = param.chunk, highlighted = param.highlighted;
            return highlighted ? /* @__PURE__ */ jsxRuntime.jsx(Mark.Mark, {
                unstyled,
                color,
                style: highlightStyles,
                "data-highlight": chunk,
                children: chunk
            }, i) : /* @__PURE__ */ jsxRuntime.jsx("span", {
                children: chunk
            }, i);
        })
    }));
});
Highlight.classes = Text.Text.classes;
Highlight.displayName = "@mantine/core/Highlight";
exports.Highlight = Highlight; //# sourceMappingURL=Highlight.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","9260823b2934c2be":"iKGFf","825a6875b2c7ee17":"9MtAM","bbb0ef6577f30ccb":"9HEEB","b0e8a4ea0f1c414f":"8QFOC","f0704d3e1c62826a":"2FdJg","e02a596de341837b":"6AMGA","bd0218447ba9c269":"erSvz","1ea6e695d71ba1db":"kqQOF","16a2aeaad4c80bf2":"iivvn","a7aaefa18b748d17":"8YP4O","aa0997fe8882e26c":"gkGXc","cfeb3f07c79c4e9d":"iYAEL","144e636630998843":"2onWA","c0887992dee1e237":"9o1Kf","3b27bb51c17dca2f":"gXc4D","fa69581fc5a003b6":"1T3Nl"}],"9o1Kf":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1a96614c173c4466");
require("150dca4245f300ba");
require("efa3f4b76f252e76");
var createVarsResolver = require("9866a76b36452a31");
require("2f71dadb0dc54edb");
require("6375b11b96f9f7cf");
require("bfccfef76b46359a");
require("7b7049a661a296ef");
require("d95d56ac89a3d05f");
var useProps = require("47c634a0919fb7c0");
require("c19c9ca1df24a1b6");
var useStyles = require("749871ae428d5ec5");
var Box = require("d81c8da767f3c09b");
var factory = require("ddec9fc4a043e4fb");
require("327d1607262b085");
var getMarkColor = require("e64f08c4b48a9ff2");
var Mark_module = require("68c2035d1fd226");
var defaultProps = {
    color: "yellow"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color;
    return {
        root: {
            "--mark-bg-dark": getMarkColor.getMarkColor({
                color,
                theme,
                defaultShade: 5
            }),
            "--mark-bg-light": getMarkColor.getMarkColor({
                color,
                theme,
                defaultShade: 2
            })
        }
    };
});
var Mark = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Mark", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, color = props.color, variant = props.variant, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "variant"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Mark",
        props,
        className,
        style,
        classes: Mark_module,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        component: "mark",
        ref,
        variant
    }, getStyles("root"), others));
});
Mark.classes = Mark_module;
Mark.displayName = "@mantine/core/Mark";
exports.Mark = Mark; //# sourceMappingURL=Mark.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","1a96614c173c4466":"iKGFf","150dca4245f300ba":"9MtAM","efa3f4b76f252e76":"9HEEB","9866a76b36452a31":"hIQE6","2f71dadb0dc54edb":"8QFOC","6375b11b96f9f7cf":"2FdJg","bfccfef76b46359a":"6AMGA","7b7049a661a296ef":"erSvz","d95d56ac89a3d05f":"kqQOF","47c634a0919fb7c0":"iivvn","c19c9ca1df24a1b6":"8YP4O","749871ae428d5ec5":"d0sAY","d81c8da767f3c09b":"gkGXc","ddec9fc4a043e4fb":"guLFz","327d1607262b085":"2onWA","e64f08c4b48a9ff2":"23Edc","68c2035d1fd226":"jPiMH"}],"23Edc":[function(require,module,exports) {
"use client";
"use strict";
require("435ef63ea510cda9");
require("286b56ae17e6883b");
require("aab68b637078c26d");
require("fd46b9d3d57ec00b");
var parseThemeColor = require("c51d9a93018f3fc6");
require("7130fac6cf8d1d40");
require("5b9e150d3773f347");
require("505f8a4c391a8970");
require("3f42824070ccedb3");
require("d84acbf6917d268e");
require("ee997ff7dd123b1f");
require("34b4f6b79a9bb4d2");
function getMarkColor(param) {
    var color = param.color, theme = param.theme, defaultShade = param.defaultShade;
    var parsed = parseThemeColor.parseThemeColor({
        color,
        theme
    });
    if (!parsed.isThemeColor) return color;
    if (parsed.shade === void 0) return `var(--mantine-color-${parsed.color}-${defaultShade})`;
    return `var(${parsed.variable})`;
}
exports.getMarkColor = getMarkColor; //# sourceMappingURL=get-mark-color.cjs.map

},{"435ef63ea510cda9":"9MtAM","286b56ae17e6883b":"iKGFf","aab68b637078c26d":"9HEEB","fd46b9d3d57ec00b":"8QFOC","c51d9a93018f3fc6":"ctp80","7130fac6cf8d1d40":"2FdJg","5b9e150d3773f347":"6AMGA","505f8a4c391a8970":"erSvz","3f42824070ccedb3":"kqQOF","d84acbf6917d268e":"8YP4O","ee997ff7dd123b1f":"gkGXc","34b4f6b79a9bb4d2":"2onWA"}],"jPiMH":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_bcb3f3c2"
};
module.exports = classes; //# sourceMappingURL=Mark.module.css.cjs.map

},{}],"1T3Nl":[function(require,module,exports) {
"use client";
"use strict";
function escapeRegex(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&");
}
function highlighter(value, _highlight) {
    if (_highlight == null) return [
        {
            chunk: value,
            highlighted: false
        }
    ];
    var highlight = Array.isArray(_highlight) ? _highlight.map(escapeRegex) : escapeRegex(_highlight);
    var shouldHighlight = Array.isArray(highlight) ? highlight.filter(function(part) {
        return part.trim().length > 0;
    }).length > 0 : highlight.trim() !== "";
    if (!shouldHighlight) return [
        {
            chunk: value,
            highlighted: false
        }
    ];
    var matcher = typeof highlight === "string" ? highlight.trim() : highlight.filter(function(part) {
        return part.trim().length !== 0;
    }).map(function(part) {
        return part.trim();
    }).sort(function(a, b) {
        return b.length - a.length;
    }).join("|");
    var re = new RegExp(`(${matcher})`, "gi");
    var chunks = value.split(re).map(function(part) {
        return {
            chunk: part,
            highlighted: re.test(part)
        };
    }).filter(function(param) {
        var chunk = param.chunk;
        return chunk;
    });
    return chunks;
}
exports.highlighter = highlighter; //# sourceMappingURL=highlighter.cjs.map

},{}],"drTJJ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("40b47a0ba773d72e");
var hooks = require("c4773b98d7e71043");
require("961b4f43553b90de");
require("d6030328c660af6");
require("78073f49131b9c9a");
require("31871e5c336650ff");
require("6bcca06367efe846");
require("80efd3b48712c5e0");
var useProps = require("d034094f3f02e739");
require("d754b72fab525199");
require("6921645c4bc27b49");
require("f5a8d9b026e811fb");
var useDelayedHover = require("dd6168a9ed65637b");
require("9072b3562138efaf");
require("b026146be879a3db");
var Popover = require("68a2a2150b825178");
require("4cdfe00e7b4927f");
require("15ec70e85b7de690");
var HoverCard_context = require("7f036e9f9fa99d22");
var HoverCardDropdown = require("8e76d018b6452fdd");
var HoverCardTarget = require("7b9210a3d0e3d9f3");
var defaultProps = {
    openDelay: 0,
    closeDelay: 150,
    initiallyOpened: false
};
function HoverCard(props) {
    var _useProps_useProps = useProps.useProps("HoverCard", defaultProps, props), children = _useProps_useProps.children, onOpen = _useProps_useProps.onOpen, onClose = _useProps_useProps.onClose, openDelay = _useProps_useProps.openDelay, closeDelay = _useProps_useProps.closeDelay, initiallyOpened = _useProps_useProps.initiallyOpened, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "onOpen",
        "onClose",
        "openDelay",
        "closeDelay",
        "initiallyOpened"
    ]);
    var _hooks_useDisclosure = (0, _slicedToArray._)(hooks.useDisclosure(initiallyOpened, {
        onClose,
        onOpen
    }), 2), opened = _hooks_useDisclosure[0], _hooks_useDisclosure_ = _hooks_useDisclosure[1], open = _hooks_useDisclosure_.open, close = _hooks_useDisclosure_.close;
    var _useDelayedHover_useDelayedHover = useDelayedHover.useDelayedHover({
        open,
        close,
        openDelay,
        closeDelay
    }), openDropdown = _useDelayedHover_useDelayedHover.openDropdown, closeDropdown = _useDelayedHover_useDelayedHover.closeDropdown;
    return /* @__PURE__ */ jsxRuntime.jsx(HoverCard_context.HoverCardContextProvider, {
        value: {
            openDropdown,
            closeDropdown
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
            opened,
            __staticSelector: "HoverCard",
            children
        }))
    });
}
HoverCard.displayName = "@mantine/core/HoverCard";
HoverCard.Target = HoverCardTarget.HoverCardTarget;
HoverCard.Dropdown = HoverCardDropdown.HoverCardDropdown;
HoverCard.extend = function(input) {
    return input;
};
exports.HoverCard = HoverCard; //# sourceMappingURL=HoverCard.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","40b47a0ba773d72e":"iKGFf","c4773b98d7e71043":"9HEEB","961b4f43553b90de":"9MtAM","d6030328c660af6":"8QFOC","78073f49131b9c9a":"2FdJg","31871e5c336650ff":"6AMGA","6bcca06367efe846":"erSvz","80efd3b48712c5e0":"kqQOF","d034094f3f02e739":"iivvn","d754b72fab525199":"8YP4O","6921645c4bc27b49":"gkGXc","f5a8d9b026e811fb":"2onWA","dd6168a9ed65637b":"hFhuj","9072b3562138efaf":"jrkk4","b026146be879a3db":"kAWqL","68a2a2150b825178":"4oc3k","4cdfe00e7b4927f":"b7S6t","15ec70e85b7de690":"iz4SD","7f036e9f9fa99d22":"27EDM","8e76d018b6452fdd":"el2IJ","7b9210a3d0e3d9f3":"a0Lst"}],"27EDM":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("ac46f115c0578c2d");
var createSafeContext = require("c38ddb8dd0f7d321");
require("73ba13b8c8f7c1ee");
require("b1cc946a080d614e");
require("83ef9d639ba53dc3");
require("9e5e0dcffd87f62");
require("112ba2d292c145fa");
require("22eb1c07c189b248");
require("1534aaeac0424bae");
require("c39e40e9cb6b8deb");
require("131c5ec8207a3599");
require("ac325a7af889d5b7");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("HoverCard component was not found in the tree"), 2), HoverCardContextProvider = _createSafeContext_createSafeContext[0], useHoverCardContext = _createSafeContext_createSafeContext[1];
exports.HoverCardContextProvider = HoverCardContextProvider;
exports.useHoverCardContext = useHoverCardContext; //# sourceMappingURL=HoverCard.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","ac46f115c0578c2d":"9MtAM","c38ddb8dd0f7d321":"8srze","73ba13b8c8f7c1ee":"iKGFf","b1cc946a080d614e":"9HEEB","83ef9d639ba53dc3":"8QFOC","9e5e0dcffd87f62":"2FdJg","112ba2d292c145fa":"6AMGA","22eb1c07c189b248":"erSvz","1534aaeac0424bae":"kqQOF","c39e40e9cb6b8deb":"8YP4O","131c5ec8207a3599":"gkGXc","ac325a7af889d5b7":"2onWA"}],"el2IJ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a8ab103d2f483a7c");
require("9d8424a270d299da");
var createEventHandler = require("c48a9c818078104f");
require("8e8d17b79983086f");
require("7d18aa41d68aa205");
require("701de7bf36565a90");
require("9f0b7211d7df2022");
require("d8c2b5723cb121a7");
require("62668b23b2d0deac");
var useProps = require("a1ed36502b59b96b");
require("e2946bc8972de63f");
require("8fff7afaf6c327d");
require("c3c53d3cfd34e587");
var Popover = require("d4d4208be1ea672e");
require("15450972e1f597e9");
require("e50c72c8625b7ed2");
var HoverCard_context = require("2a217d5a251f9864");
var defaultProps = {};
function HoverCardDropdown(props) {
    var _useProps_useProps = useProps.useProps("HoverCardDropdown", defaultProps, props), children = _useProps_useProps.children, onMouseEnter = _useProps_useProps.onMouseEnter, onMouseLeave = _useProps_useProps.onMouseLeave, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "onMouseEnter",
        "onMouseLeave"
    ]);
    var ctx = HoverCard_context.useHoverCardContext();
    var handleMouseEnter = createEventHandler.createEventHandler(onMouseEnter, ctx.openDropdown);
    var handleMouseLeave = createEventHandler.createEventHandler(onMouseLeave, ctx.closeDropdown);
    return /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Dropdown, (0, _objectSpreadProps._)((0, _objectSpread._)({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }, others), {
        children
    }));
}
HoverCardDropdown.displayName = "@mantine/core/HoverCardDropdown";
exports.HoverCardDropdown = HoverCardDropdown; //# sourceMappingURL=HoverCardDropdown.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","a8ab103d2f483a7c":"iKGFf","9d8424a270d299da":"9MtAM","c48a9c818078104f":"9qSGJ","8e8d17b79983086f":"9HEEB","7d18aa41d68aa205":"8QFOC","701de7bf36565a90":"2FdJg","9f0b7211d7df2022":"6AMGA","d8c2b5723cb121a7":"erSvz","62668b23b2d0deac":"kqQOF","a1ed36502b59b96b":"iivvn","e2946bc8972de63f":"8YP4O","8fff7afaf6c327d":"gkGXc","c3c53d3cfd34e587":"2onWA","d4d4208be1ea672e":"4oc3k","15450972e1f597e9":"b7S6t","e50c72c8625b7ed2":"iz4SD","2a217d5a251f9864":"27EDM"}],"a0Lst":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("5396aedfd34471f3");
var React = require("f96958973e598370");
var isElement = require("b8a7330abd406421");
var createEventHandler = require("fe6969099e837968");
require("6ccacb74a82efc91");
require("4f72fc3a9b861cfc");
require("3a50fe18dd3b3485");
require("972327b5ff58cb4a");
require("c859f9811496288b");
require("9346ff4e2632d514");
var useProps = require("3733eac85fcc5bd");
require("87974adba278c099");
require("8c810e9d358b3f03");
require("97e9f36dbc50aa83");
var Popover = require("44f891b89c7d206b");
require("b39ab0f4e79cc551");
require("10dc565ec8081f75");
var HoverCard_context = require("376aa710f0571781");
var defaultProps = {
    refProp: "ref"
};
var HoverCardTarget = React.forwardRef(function(props, ref) {
    var _useProps_useProps = useProps.useProps("HoverCardTarget", defaultProps, props), children = _useProps_useProps.children, refProp = _useProps_useProps.refProp, eventPropsWrapperName = _useProps_useProps.eventPropsWrapperName, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "refProp",
        "eventPropsWrapperName"
    ]);
    if (!isElement.isElement(children)) throw new Error("HoverCard.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    var ctx = HoverCard_context.useHoverCardContext();
    var onMouseEnter = createEventHandler.createEventHandler(children.props.onMouseEnter, ctx.openDropdown);
    var onMouseLeave = createEventHandler.createEventHandler(children.props.onMouseLeave, ctx.closeDropdown);
    var eventListeners = {
        onMouseEnter,
        onMouseLeave
    };
    return /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Target, (0, _objectSpreadProps._)((0, _objectSpread._)({
        refProp,
        ref
    }, others), {
        children: React.cloneElement(children, eventPropsWrapperName ? {
            [eventPropsWrapperName]: eventListeners
        } : eventListeners)
    }));
});
HoverCardTarget.displayName = "@mantine/core/HoverCardTarget";
exports.HoverCardTarget = HoverCardTarget; //# sourceMappingURL=HoverCardTarget.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","5396aedfd34471f3":"iKGFf","f96958973e598370":"9MtAM","b8a7330abd406421":"193o0","fe6969099e837968":"9qSGJ","6ccacb74a82efc91":"9HEEB","4f72fc3a9b861cfc":"8QFOC","3a50fe18dd3b3485":"2FdJg","972327b5ff58cb4a":"6AMGA","c859f9811496288b":"erSvz","9346ff4e2632d514":"kqQOF","3733eac85fcc5bd":"iivvn","87974adba278c099":"8YP4O","8c810e9d358b3f03":"gkGXc","97e9f36dbc50aa83":"2onWA","44f891b89c7d206b":"4oc3k","b39ab0f4e79cc551":"b7S6t","10dc565ec8081f75":"iz4SD","376aa710f0571781":"27EDM"}],"iD8oQ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("f4d8ba4a1a266bde");
var React = require("48ebfe5363b72e49");
var getSize = require("ecbe1d73678e50ba");
require("e6b34c4311a1bacc");
var createVarsResolver = require("e4af97e504168eec");
require("85c0672e69cefe84");
require("8d0bb66b96001113");
require("b5be3856124a3c9");
require("b0d7cec1c6f839a9");
require("f6367d3daeef2d61");
var useProps = require("5330390d0c19de66");
require("1ae0875ff4ab6569");
var useStyles = require("4c4e5aa22a090a75");
var Box = require("712caae2f79ca125");
var polymorphicFactory = require("552168357b1c9eea");
require("4961c32798555198");
var Image_module = require("9a623a386fd20e56");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius, fit = param.fit;
    return {
        root: {
            "--image-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--image-object-fit": fit
        }
    };
});
var Image = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("Image", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, onError = props.onError, src = props.src, radius = props.radius, fit = props.fit, fallbackSrc = props.fallbackSrc, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "onError",
        "src",
        "radius",
        "fit",
        "fallbackSrc",
        "mod"
    ]);
    var _React_useState = (0, _slicedToArray._)(React.useState(!src), 2), error = _React_useState[0], setError = _React_useState[1];
    React.useEffect(function() {
        return setError(!src);
    }, [
        src
    ]);
    var getStyles = useStyles.useStyles({
        name: "Image",
        classes: Image_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    if (error && fallbackSrc) return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "img",
        ref,
        src: fallbackSrc
    }, getStyles("root")), {
        onError,
        mod: [
            "fallback",
            mod
        ]
    }), others));
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "img",
        ref
    }, getStyles("root")), {
        src,
        onError: function(event) {
            onError === null || onError === void 0 ? void 0 : onError(event);
            setError(true);
        },
        mod
    }), others));
});
Image.classes = Image_module;
Image.displayName = "@mantine/core/Image";
exports.Image = Image; //# sourceMappingURL=Image.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","f4d8ba4a1a266bde":"iKGFf","48ebfe5363b72e49":"9MtAM","ecbe1d73678e50ba":"kEFEY","e6b34c4311a1bacc":"9HEEB","e4af97e504168eec":"hIQE6","85c0672e69cefe84":"8QFOC","8d0bb66b96001113":"2FdJg","b5be3856124a3c9":"6AMGA","b0d7cec1c6f839a9":"erSvz","f6367d3daeef2d61":"kqQOF","5330390d0c19de66":"iivvn","1ae0875ff4ab6569":"8YP4O","4c4e5aa22a090a75":"d0sAY","712caae2f79ca125":"gkGXc","552168357b1c9eea":"iYAEL","4961c32798555198":"2onWA","9a623a386fd20e56":"8b9tF"}],"8b9tF":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_9e117634"
};
module.exports = classes; //# sourceMappingURL=Image.module.css.cjs.map

},{}],"hJiXo":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("12986bbd592c20fc");
var rem = require("3d025bfc0b3d1d0");
require("58b17f4f1a81e7a0");
var getSize = require("5e48be397f53dcc9");
require("bd2315d6c8ce002d");
var createVarsResolver = require("ead92a43f0e7a62d");
require("9507b3f10ccc87");
var getThemeColor = require("9e50fa21e049dc3f");
var getContrastColor = require("526b38614f4ff5fe");
var getAutoContrastValue = require("4beab62f5e34f492");
require("a36805fae51e9276");
require("e2a6b37c4d751f69");
require("9bb6f1abab57855");
require("f3c477262f217f1c");
var useProps = require("ea295e2e74f63993");
require("b6f7b9d98fa4cae");
var useStyles = require("ae974a65f05b48c7");
var Box = require("3698f8d7bb793eca");
var factory = require("564a866e4158c281");
require("87057b02accc2101");
var getPositionVariables = require("8f9ef384c8fd8d89");
var Indicator_module = require("bda9bc548227228e");
var defaultProps = {
    position: "top-end",
    offset: 0,
    inline: false,
    withBorder: false,
    disabled: false,
    processing: false
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color, position = param.position, offset = param.offset, size = param.size, radius = param.radius, zIndex = param.zIndex, autoContrast = param.autoContrast;
    return {
        root: (0, _objectSpread._)({
            "--indicator-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--indicator-text-color": getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0,
            "--indicator-size": rem.rem(size),
            "--indicator-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--indicator-z-index": zIndex === null || zIndex === void 0 ? void 0 : zIndex.toString()
        }, getPositionVariables.getPositionVariables(position, offset))
    };
});
var Indicator = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Indicator", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, position = props.position, offset = props.offset, inline = props.inline, label = props.label, radius = props.radius, color = props.color, withBorder = props.withBorder, disabled = props.disabled, processing = props.processing, zIndex = props.zIndex, autoContrast = props.autoContrast, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "position",
        "offset",
        "inline",
        "label",
        "radius",
        "color",
        "withBorder",
        "disabled",
        "processing",
        "zIndex",
        "autoContrast",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Indicator",
        classes: Indicator_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("root")), {
        mod: [
            {
                inline
            },
            mod
        ]
    }), others), {
        children: [
            !disabled && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                mod: {
                    "with-label": !!label,
                    "with-border": withBorder,
                    processing
                }
            }, getStyles("indicator")), {
                children: label
            })),
            children
        ]
    }));
});
Indicator.classes = Indicator_module;
Indicator.displayName = "@mantine/core/Indicator";
exports.Indicator = Indicator; //# sourceMappingURL=Indicator.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","12986bbd592c20fc":"iKGFf","3d025bfc0b3d1d0":"ebAaL","58b17f4f1a81e7a0":"9MtAM","5e48be397f53dcc9":"kEFEY","bd2315d6c8ce002d":"9HEEB","ead92a43f0e7a62d":"hIQE6","9507b3f10ccc87":"8QFOC","9e50fa21e049dc3f":"eeaIN","526b38614f4ff5fe":"ez6cW","4beab62f5e34f492":"cN4dA","a36805fae51e9276":"2FdJg","e2a6b37c4d751f69":"6AMGA","9bb6f1abab57855":"erSvz","f3c477262f217f1c":"kqQOF","ea295e2e74f63993":"iivvn","b6f7b9d98fa4cae":"8YP4O","ae974a65f05b48c7":"d0sAY","3698f8d7bb793eca":"gkGXc","564a866e4158c281":"guLFz","87057b02accc2101":"2onWA","8f9ef384c8fd8d89":"3mygc","bda9bc548227228e":"ifnCF"}],"3mygc":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var rem = require("2b96ba8ef0f94c02");
require("2ccdbe165f4f9c6a");
require("c2c2624c1b582e9d");
require("4914986921dd97e7");
require("f304b1863849c585");
require("1844bd0ba0400872");
require("aaeb1f80c3089fcc");
require("d3df0a653fd946b4");
require("c47054c80fd21e58");
require("11f84277e295b59a");
require("3b0d6526f5d2963");
require("553402c0382d72b5");
function getPositionVariables() {
    var _position = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "top-end", offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var variables = {
        "--indicator-top": void 0,
        "--indicator-bottom": void 0,
        "--indicator-left": void 0,
        "--indicator-right": void 0,
        "--indicator-translate-x": void 0,
        "--indicator-translate-y": void 0
    };
    var _offset = rem.rem(offset);
    var _position_split = (0, _slicedToArray._)(_position.split("-"), 2), position = _position_split[0], placement = _position_split[1];
    if (position === "top") {
        variables["--indicator-top"] = _offset;
        variables["--indicator-translate-y"] = "-50%";
    }
    if (position === "middle") {
        variables["--indicator-top"] = "50%";
        variables["--indicator-translate-y"] = "-50%";
    }
    if (position === "bottom") {
        variables["--indicator-bottom"] = _offset;
        variables["--indicator-translate-y"] = "50%";
    }
    if (placement === "start") {
        variables["--indicator-left"] = _offset;
        variables["--indicator-translate-x"] = "-50%";
    }
    if (placement === "center") {
        variables["--indicator-left"] = "50%";
        variables["--indicator-translate-x"] = "-50%";
    }
    if (placement === "end") {
        variables["--indicator-right"] = _offset;
        variables["--indicator-translate-x"] = "50%";
    }
    return variables;
}
exports.getPositionVariables = getPositionVariables; //# sourceMappingURL=get-position-variables.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","2b96ba8ef0f94c02":"ebAaL","2ccdbe165f4f9c6a":"9MtAM","c2c2624c1b582e9d":"iKGFf","4914986921dd97e7":"9HEEB","f304b1863849c585":"8QFOC","1844bd0ba0400872":"2FdJg","aaeb1f80c3089fcc":"6AMGA","d3df0a653fd946b4":"erSvz","c47054c80fd21e58":"kqQOF","11f84277e295b59a":"8YP4O","3b0d6526f5d2963":"gkGXc","553402c0382d72b5":"2onWA"}],"ifnCF":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_e5262200",
    "indicator": "m_760d1fb1",
    "processing": "m_885901b1"
};
module.exports = classes; //# sourceMappingURL=Indicator.module.css.cjs.map

},{}],"4uFWe":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("497b4a633055f09e");
var React = require("4bbf991788ef1b09");
var hooks = require("4f8c28e93c778b8c");
require("1c75154c208557db");
require("b90c4069348adcaa");
require("2fa569782a8decf0");
require("aefc03cb687d0a67");
require("4396d155a56cc99c");
var useProps = require("dfb1ce7d1e42e5c3");
require("56b4d0f861a81698");
require("77bd24f2864962f5");
var factory = require("e646636a3704f51");
require("1772567c58a8683d");
var InputBase = require("dde40d302445ddfc");
var Textarea = require("e166cffde932ff97");
var validateJson = require("7051615961e6325a");
var defaultProps = {
    serialize: JSON.stringify,
    deserialize: JSON.parse
};
var JsonInput = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("JsonInput", defaultProps, props), value = _useProps_useProps.value, defaultValue = _useProps_useProps.defaultValue, onChange = _useProps_useProps.onChange, formatOnBlur = _useProps_useProps.formatOnBlur, validationError = _useProps_useProps.validationError, serialize = _useProps_useProps.serialize, deserialize = _useProps_useProps.deserialize, onFocus = _useProps_useProps.onFocus, onBlur = _useProps_useProps.onBlur, readOnly = _useProps_useProps.readOnly, error = _useProps_useProps.error, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "value",
        "defaultValue",
        "onChange",
        "formatOnBlur",
        "validationError",
        "serialize",
        "deserialize",
        "onFocus",
        "onBlur",
        "readOnly",
        "error"
    ]);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: "",
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var _React_useState = (0, _slicedToArray._)(React.useState(validateJson.validateJson(_value, deserialize)), 2), valid = _React_useState[0], setValid = _React_useState[1];
    var handleFocus = function(event) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        setValid(true);
    };
    var handleBlur = function(event) {
        typeof onBlur === "function" && onBlur(event);
        var isValid = validateJson.validateJson(event.currentTarget.value, deserialize);
        formatOnBlur && !readOnly && isValid && event.currentTarget.value.trim() !== "" && setValue(serialize(deserialize(event.currentTarget.value), null, 2));
        setValid(isValid);
    };
    return /* @__PURE__ */ jsxRuntime.jsx(Textarea.Textarea, (0, _objectSpreadProps._)((0, _objectSpread._)({
        value: _value,
        onChange: function(event) {
            return setValue(event.currentTarget.value);
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref,
        readOnly
    }, others), {
        autoComplete: "off",
        __staticSelector: "JsonInput",
        error: valid ? error : validationError || true,
        "data-monospace": true
    }));
});
JsonInput.classes = InputBase.InputBase.classes;
JsonInput.displayName = "@mantine/core/JsonInput";
exports.JsonInput = JsonInput; //# sourceMappingURL=JsonInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","497b4a633055f09e":"iKGFf","4bbf991788ef1b09":"9MtAM","4f8c28e93c778b8c":"9HEEB","1c75154c208557db":"8QFOC","b90c4069348adcaa":"2FdJg","2fa569782a8decf0":"6AMGA","aefc03cb687d0a67":"erSvz","4396d155a56cc99c":"kqQOF","dfb1ce7d1e42e5c3":"iivvn","56b4d0f861a81698":"8YP4O","77bd24f2864962f5":"gkGXc","e646636a3704f51":"guLFz","1772567c58a8683d":"2onWA","dde40d302445ddfc":"jbA6w","e166cffde932ff97":"02LRX","7051615961e6325a":"4aFIt"}],"02LRX":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("426dce9f7aab8b46");
var TextareaAutosize = require("9e2ee27638bbb13b");
require("1fe7d9755414c9a2");
require("601734da188542fe");
var getEnv = require("d4c2978e092f93e1");
require("77017fad9ad352a5");
require("f05038644131a7d0");
require("1e7d75e2b938276d");
require("d724903abe63f3af");
require("e5abf9f5dbf47d07");
var useProps = require("44fdfcad0642379b");
require("d14355057a099da4");
require("f239142f5750a970");
var factory = require("a511797020a65d5c");
require("43a66e15f7fd3111");
var InputBase = require("f03ea0e8cf3fba8d");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var TextareaAutosize__default = /*#__PURE__*/ _interopDefault(TextareaAutosize);
var defaultProps = {};
var Textarea = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("Textarea", defaultProps, props), autosize = _useProps_useProps.autosize, maxRows = _useProps_useProps.maxRows, minRows = _useProps_useProps.minRows, __staticSelector = _useProps_useProps.__staticSelector, resize = _useProps_useProps.resize, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "autosize",
        "maxRows",
        "minRows",
        "__staticSelector",
        "resize"
    ]);
    var shouldAutosize = autosize && getEnv.getEnv() !== "test";
    var autosizeProps = shouldAutosize ? {
        maxRows,
        minRows
    } : {};
    return /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        component: shouldAutosize ? TextareaAutosize__default.default : "textarea",
        ref
    }, others), {
        __staticSelector: __staticSelector || "Textarea",
        multiline: true,
        "data-no-overflow": autosize && maxRows === void 0 || void 0,
        __vars: {
            "--input-resize": resize
        }
    }), autosizeProps));
});
Textarea.classes = InputBase.InputBase.classes;
Textarea.displayName = "@mantine/core/Textarea";
exports.Textarea = Textarea; //# sourceMappingURL=Textarea.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","426dce9f7aab8b46":"iKGFf","9e2ee27638bbb13b":"huceQ","1fe7d9755414c9a2":"9MtAM","601734da188542fe":"9HEEB","d4c2978e092f93e1":"dcxYe","77017fad9ad352a5":"8QFOC","f05038644131a7d0":"2FdJg","1e7d75e2b938276d":"6AMGA","d724903abe63f3af":"erSvz","e5abf9f5dbf47d07":"kqQOF","44fdfcad0642379b":"iivvn","d14355057a099da4":"8YP4O","f239142f5750a970":"gkGXc","a511797020a65d5c":"guLFz","43a66e15f7fd3111":"2onWA","f03ea0e8cf3fba8d":"jbA6w"}],"huceQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return index;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useLatest = require("use-latest");
var _useLatestDefault = parcelHelpers.interopDefault(_useLatest);
var _useComposedRef = require("use-composed-ref");
var _useComposedRefDefault = parcelHelpers.interopDefault(_useComposedRef);
var HIDDEN_TEXTAREA_STYLE = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0",
    display: "block"
};
var forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], "important");
    });
};
var forceHiddenStyles$1 = forceHiddenStyles;
var hiddenTextarea = null;
var getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
    // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement("textarea");
        hiddenTextarea.setAttribute("tabindex", "-1");
        hiddenTextarea.setAttribute("aria-hidden", "true");
        forceHiddenStyles$1(hiddenTextarea);
    }
    if (hiddenTextarea.parentNode === null) document.body.appendChild(hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        hiddenTextarea.style[key] = sizingStyle[key];
    });
    forceHiddenStyles$1(hiddenTextarea);
    hiddenTextarea.value = value;
    var height = getHeight(hiddenTextarea, sizingData);
    // Double set and calc due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1795904
    hiddenTextarea.value = value;
    height = getHeight(hiddenTextarea, sizingData);
    // measure height of a textarea with a single row
    hiddenTextarea.value = "x";
    var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var noop = function noop() {};
var pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var SIZING_STYLE = [
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRightWidth",
    "borderTopWidth",
    "boxSizing",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    // non-standard
    "tabSize",
    "textIndent",
    // non-standard
    "textRendering",
    "textTransform",
    "width",
    "wordBreak",
    "wordSpacing",
    "scrollbarGutter"
];
var isIE = !!document.documentElement.currentStyle;
var getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = pick(SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing;
    // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === "") return null;
    // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if (isIE && boxSizing === "border-box") sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + "px";
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var getSizingData$1 = getSizingData;
function useListener(target, type, listener) {
    var latestListener = (0, _useLatestDefault.default)(listener);
    _react.useLayoutEffect(function() {
        var handler = function handler(ev) {
            return latestListener.current(ev);
        };
        // might happen if document.fonts is not defined, for instance
        if (!target) return;
        target.addEventListener(type, handler);
        return function() {
            return target.removeEventListener(type, handler);
        };
    }, []);
}
var useFormResetListener = function useFormResetListener(libRef, listener) {
    useListener(document.body, "reset", function(ev) {
        if (libRef.current.form === ev.target) listener(ev);
    });
};
var useWindowResizeListener = function useWindowResizeListener(listener) {
    useListener(window, "resize", listener);
};
var useFontsLoadedListener = function useFontsLoadedListener(listener) {
    useListener(document.fonts, "loadingdone", listener);
};
var _excluded = [
    "cacheMeasurements",
    "maxRows",
    "minRows",
    "onChange",
    "onHeightChange"
];
var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    var isControlled = props.value !== undefined;
    var libRef = _react.useRef(null);
    var ref = (0, _useComposedRefDefault.default)(libRef, userRef);
    var heightRef = _react.useRef(0);
    var measurementsCacheRef = _react.useRef();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData$1(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || "x", minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty("height", height + "px", "important");
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    _react.useLayoutEffect(resizeTextarea);
    useFormResetListener(libRef, function() {
        if (!isControlled) {
            var currentValue = libRef.current.value;
            requestAnimationFrame(function() {
                var node = libRef.current;
                if (node && currentValue !== node.value) resizeTextarea();
            });
        }
    });
    useWindowResizeListener(resizeTextarea);
    useFontsLoadedListener(resizeTextarea);
    return /*#__PURE__*/ _react.createElement("textarea", (0, _extendsDefault.default)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var index = /* #__PURE__ */ _react.forwardRef(TextareaAutosize);

},{"@babel/runtime/helpers/esm/extends":"04V7M","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"iXcFm","react":"9MtAM","use-latest":"e6vfM","use-composed-ref":"lnNjj","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"04V7M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _extends;
});
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"iXcFm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutPropertiesLoose;
});
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"e6vfM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useLatest;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var useLatest = function useLatest(value) {
    var ref = (0, _reactDefault.default).useRef(value);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        ref.current = value;
    });
    return ref;
};

},{"react":"9MtAM","use-isomorphic-layout-effect":"1y1vQ","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"1y1vQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return index;
});
var _react = require("react");
var index = (0, _react.useLayoutEffect);

},{"react":"9MtAM","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"lnNjj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useComposedRef;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// basically Exclude<React.ClassAttributes<T>["ref"], string>
var updateRef = function updateRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    ref.current = value;
};
var useComposedRef = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, _reactDefault.default).useRef();
    return (0, _reactDefault.default).useCallback(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        updateRef(userRef, instance);
    }, [
        userRef
    ]);
};

},{"react":"9MtAM","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"4aFIt":[function(require,module,exports) {
"use client";
"use strict";
function validateJson(value, deserialize) {
    if (typeof value === "string" && value.trim().length === 0) return true;
    try {
        deserialize(value);
        return true;
    } catch (e) {
        return false;
    }
}
exports.validateJson = validateJson; //# sourceMappingURL=validate-json.cjs.map

},{}],"k1dMl":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("e5a3692a5c30933d");
require("3ac14452cfb12f25");
var getSize = require("4a5c97a17bb8fe60");
require("29a52c388d74b28c");
var createVarsResolver = require("64d3d8a071b64859");
require("9e1c774900fc6893");
require("2be9cfc175f5b4d3");
require("1cad4eb8c8b9982");
require("adb12c149da1ab11");
require("508af781ad03beab");
var useProps = require("8e472e2249804a4");
require("9ee1819b7900328d");
var useStyles = require("57c474a6662714c4");
var Box = require("5073d30ba09f23c8");
var factory = require("197a074c5a18f0bc");
require("7e4b3451d5e7ba2");
var Kbd_module = require("3647136786487e3c");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        root: {
            "--kbd-fz": getSize.getSize(size, "kbd-fz"),
            "--kbd-padding": getSize.getSize(size, "kbd-padding")
        }
    };
});
var Kbd = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Kbd", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Kbd",
        classes: Kbd_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        component: "kbd",
        ref
    }, getStyles("root"), others));
});
Kbd.classes = Kbd_module;
Kbd.displayName = "@mantine/core/Kbd";
exports.Kbd = Kbd; //# sourceMappingURL=Kbd.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","e5a3692a5c30933d":"iKGFf","3ac14452cfb12f25":"9MtAM","4a5c97a17bb8fe60":"kEFEY","29a52c388d74b28c":"9HEEB","64d3d8a071b64859":"hIQE6","9e1c774900fc6893":"8QFOC","2be9cfc175f5b4d3":"2FdJg","1cad4eb8c8b9982":"6AMGA","adb12c149da1ab11":"erSvz","508af781ad03beab":"kqQOF","8e472e2249804a4":"iivvn","9ee1819b7900328d":"8YP4O","57c474a6662714c4":"d0sAY","5073d30ba09f23c8":"gkGXc","197a074c5a18f0bc":"guLFz","7e4b3451d5e7ba2":"2onWA","3647136786487e3c":"gssXF"}],"gssXF":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_dc6f14e2"
};
module.exports = classes; //# sourceMappingURL=Kbd.module.css.cjs.map

},{}],"9l0W5":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("76afef5de9cacc51");
require("d05348f918790976");
var getSize = require("e57bfd39a5189f66");
require("aa9160dcf66fec27");
var createVarsResolver = require("196b7a0eb310a0b6");
require("7330e7f5abaa2c0d");
require("fd20309781e184a0");
require("33ae17cb496a43d8");
require("93bbadac89e83fb1");
require("e49a0ce451a7fc07");
var useProps = require("1f1bcab09c82f8ae");
require("13a69ad1f27a75f1");
var useStyles = require("e4ae22266152d552");
var Box = require("3e6b3a3a8f8a050f");
var factory = require("325a581700bbbf95");
require("e1bc3e29d8d92bea");
var List_context = require("d3ca3ee1670052a9");
var ListItem = require("9589f1d5b3d1bf60");
var List_module = require("459b3f83ea8490f7");
var defaultProps = {
    type: "unordered"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, spacing = param.spacing;
    return {
        root: {
            "--list-fz": getSize.getFontSize(size),
            "--list-lh": getSize.getLineHeight(size),
            "--list-spacing": getSize.getSpacing(spacing)
        }
    };
});
var List = factory.factory(function(_props, ref) {
    var props = useProps.useProps("List", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, type = props.type, withPadding = props.withPadding, icon = props.icon, spacing = props.spacing, center = props.center, listStyleType = props.listStyleType, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "type",
        "withPadding",
        "icon",
        "spacing",
        "center",
        "listStyleType",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "List",
        classes: List_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(List_context.ListProvider, {
        value: {
            center,
            icon,
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root", {
            style: {
                listStyleType
            }
        })), {
            component: type === "unordered" ? "ul" : "ol",
            mod: [
                {
                    "with-padding": withPadding
                },
                mod
            ],
            ref
        }), others), {
            children
        }))
    });
});
List.classes = List_module;
List.displayName = "@mantine/core/List";
List.Item = ListItem.ListItem;
exports.List = List; //# sourceMappingURL=List.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","76afef5de9cacc51":"iKGFf","d05348f918790976":"9MtAM","e57bfd39a5189f66":"kEFEY","aa9160dcf66fec27":"9HEEB","196b7a0eb310a0b6":"hIQE6","7330e7f5abaa2c0d":"8QFOC","fd20309781e184a0":"2FdJg","33ae17cb496a43d8":"6AMGA","93bbadac89e83fb1":"erSvz","e49a0ce451a7fc07":"kqQOF","1f1bcab09c82f8ae":"iivvn","13a69ad1f27a75f1":"8YP4O","e4ae22266152d552":"d0sAY","3e6b3a3a8f8a050f":"gkGXc","325a581700bbbf95":"guLFz","e1bc3e29d8d92bea":"2onWA","d3ca3ee1670052a9":"bD8ZC","9589f1d5b3d1bf60":"57MG8","459b3f83ea8490f7":"jpVhr"}],"bD8ZC":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("bf571a40d40480a9");
var createSafeContext = require("3853725e61d355b7");
require("25779fb78a99e000");
require("892efe6deb75b7bd");
require("c96c7632629a9d6f");
require("5926bbe7dc223647");
require("c215899ea0f5a5c6");
require("48ed903d21392c82");
require("a5c5595eb3aa1568");
require("9fe8f1c408d906b2");
require("8b96f8e0e6b9c9d");
require("f4776b91e6128bd9");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("List component was not found in tree"), 2), ListProvider = _createSafeContext_createSafeContext[0], useListContext = _createSafeContext_createSafeContext[1];
exports.ListProvider = ListProvider;
exports.useListContext = useListContext; //# sourceMappingURL=List.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","bf571a40d40480a9":"9MtAM","3853725e61d355b7":"8srze","25779fb78a99e000":"iKGFf","892efe6deb75b7bd":"9HEEB","c96c7632629a9d6f":"8QFOC","5926bbe7dc223647":"2FdJg","c215899ea0f5a5c6":"6AMGA","48ed903d21392c82":"erSvz","a5c5595eb3aa1568":"kqQOF","9fe8f1c408d906b2":"8YP4O","8b96f8e0e6b9c9d":"gkGXc","f4776b91e6128bd9":"2onWA"}],"57MG8":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f76ac9a142068b26");
require("dc1c5f7d2cd2c5c2");
require("1bdb20ec176a8a96");
require("413d3f71d1b94d30");
require("bb9a13971258508b");
require("3594080e9c8ea1f9");
require("3a9b0bd8479923ae");
require("c4da28ae63c301dc");
var useProps = require("3153dff739b7a0a8");
require("31af9ec7d53f173f");
var Box = require("bccdccee8bdc6b2d");
var factory = require("172bf236af6b9b19");
require("6d518dddaddafdad");
var List_context = require("864d866681cdce72");
var List_module = require("a5f66016e80629d4");
var defaultProps = {};
var ListItem = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ListItem", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, icon = props.icon, children = props.children, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "icon",
        "children",
        "mod"
    ]);
    var ctx = List_context.useListContext();
    var _icon = icon || ctx.icon;
    var stylesApiProps = {
        classNames,
        styles
    };
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("item", (0, _objectSpreadProps._)((0, _objectSpread._)({}, stylesApiProps), {
        className,
        style
    }))), {
        component: "li",
        mod: [
            {
                "with-icon": !!_icon,
                centered: ctx.center
            },
            mod
        ],
        ref
    }), others), {
        children: /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemWrapper", stylesApiProps)), {
            children: [
                _icon && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemIcon", stylesApiProps)), {
                    children: _icon
                })),
                /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemLabel", stylesApiProps)), {
                    children
                }))
            ]
        }))
    }));
});
ListItem.classes = List_module;
ListItem.displayName = "@mantine/core/ListItem";
exports.ListItem = ListItem; //# sourceMappingURL=ListItem.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f76ac9a142068b26":"iKGFf","dc1c5f7d2cd2c5c2":"9MtAM","1bdb20ec176a8a96":"9HEEB","413d3f71d1b94d30":"8QFOC","bb9a13971258508b":"2FdJg","3594080e9c8ea1f9":"6AMGA","3a9b0bd8479923ae":"erSvz","c4da28ae63c301dc":"kqQOF","3153dff739b7a0a8":"iivvn","31af9ec7d53f173f":"8YP4O","bccdccee8bdc6b2d":"gkGXc","172bf236af6b9b19":"guLFz","6d518dddaddafdad":"2onWA","864d866681cdce72":"bD8ZC","a5f66016e80629d4":"jpVhr"}],"jpVhr":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_abbac491",
    "item": "m_abb6bec2",
    "itemWrapper": "m_75cd9f71",
    "itemIcon": "m_60f83e5b"
};
module.exports = classes; //# sourceMappingURL=List.module.css.cjs.map

},{}],"dL8fN":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("40a3c8db2fd83a46");
require("15b947b1d539abb4");
var getDefaultZIndex = require("eb3fe138142def80");
require("e5489b58bc768b01");
var createVarsResolver = require("b74693196228606");
require("dcc8b2ce17c5090c");
require("f55c4b2d123fc438");
require("3978b9552ce2490f");
require("13c41e5d63ec4cf7");
var MantineThemeProvider = require("f6d5f7ee29f752e3");
var useProps = require("ff21eabb1bda10dd");
require("e453deacf624aa9b");
var useStyles = require("53d3d926d03eb5b3");
var Box = require("246a84883b462f2f");
var factory = require("b4df2e60fc97259d");
require("35601d9ba7008ebd");
var Loader = require("746e635d63ba45b6");
var Overlay = require("18bb192398b6d943");
var Transition = require("83da701f85ce300a");
var LoadingOverlay_module = require("19d24db596fc06b7");
var defaultProps = {
    transitionProps: {
        transition: "fade",
        duration: 0
    },
    overlayProps: {
        backgroundOpacity: 0.75
    },
    zIndex: getDefaultZIndex.getDefaultZIndex("overlay")
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var zIndex = param.zIndex;
    return {
        root: {
            "--lo-z-index": zIndex === null || zIndex === void 0 ? void 0 : zIndex.toString()
        }
    };
});
var LoadingOverlay = factory.factory(function(_props, ref) {
    var props = useProps.useProps("LoadingOverlay", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, transitionProps = props.transitionProps, loaderProps = props.loaderProps, overlayProps = props.overlayProps, visible = props.visible, zIndex = props.zIndex, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "transitionProps",
        "loaderProps",
        "overlayProps",
        "visible",
        "zIndex"
    ]);
    var theme = MantineThemeProvider.useMantineTheme();
    var getStyles = useStyles.useStyles({
        name: "LoadingOverlay",
        classes: LoadingOverlay_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _overlayProps = (0, _objectSpread._)({}, defaultProps.overlayProps, overlayProps);
    return /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, (0, _objectSpreadProps._)((0, _objectSpread._)({
        transition: "fade"
    }, transitionProps), {
        mounted: !!visible,
        children: function(transitionStyles) {
            return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root", {
                style: transitionStyles
            })), {
                ref
            }), others), {
                children: [
                    /* @__PURE__ */ jsxRuntime.jsx(Loader.Loader, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("loader")), {
                        unstyled
                    }), loaderProps)),
                    /* @__PURE__ */ jsxRuntime.jsx(Overlay.Overlay, (0, _objectSpreadProps._)((0, _objectSpread._)({}, _overlayProps, getStyles("overlay")), {
                        darkHidden: true,
                        unstyled,
                        color: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.color) || theme.white
                    })),
                    /* @__PURE__ */ jsxRuntime.jsx(Overlay.Overlay, (0, _objectSpreadProps._)((0, _objectSpread._)({}, _overlayProps, getStyles("overlay")), {
                        lightHidden: true,
                        unstyled,
                        color: (overlayProps === null || overlayProps === void 0 ? void 0 : overlayProps.color) || theme.colors.dark[5]
                    }))
                ]
            }));
        }
    }));
});
LoadingOverlay.classes = LoadingOverlay_module;
LoadingOverlay.displayName = "@mantine/core/LoadingOverlay";
exports.LoadingOverlay = LoadingOverlay; //# sourceMappingURL=LoadingOverlay.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","40a3c8db2fd83a46":"iKGFf","15b947b1d539abb4":"9MtAM","eb3fe138142def80":"4gavl","e5489b58bc768b01":"9HEEB","b74693196228606":"hIQE6","dcc8b2ce17c5090c":"8QFOC","f55c4b2d123fc438":"2FdJg","3978b9552ce2490f":"6AMGA","13c41e5d63ec4cf7":"erSvz","f6d5f7ee29f752e3":"kqQOF","ff21eabb1bda10dd":"iivvn","e453deacf624aa9b":"8YP4O","53d3d926d03eb5b3":"d0sAY","246a84883b462f2f":"gkGXc","b4df2e60fc97259d":"guLFz","35601d9ba7008ebd":"2onWA","746e635d63ba45b6":"hxcgl","18bb192398b6d943":"9e5lu","83da701f85ce300a":"2T0Xr","19d24db596fc06b7":"7nUiz"}],"7nUiz":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_6e45937b",
    "loader": "m_e8eb006c",
    "overlay": "m_df587f17"
};
module.exports = classes; //# sourceMappingURL=LoadingOverlay.module.css.cjs.map

},{}],"6M4sH":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("e9243590da34947a");
var React = require("f808fc5c9884816e");
var hooks = require("86bc3a6e2d454dcb");
var getContextItemIndex = require("152cfaa760890454");
var useHovered = require("6b86255844297c44");
require("ff7f7101ad7c3e1e");
var useResolvedStylesApi = require("b3a2957b68a905b4");
var useStyles = require("f489d89f07320953");
require("dcba2122e1bee102");
require("cc309208ac6f83a6");
require("ddb47dcaed8dbc7b");
require("4103b213ca3d7830");
var useProps = require("6babac418fb086c2");
require("3bdf5a22d8ec8ee9");
require("a3e935b3459ec32f");
var factory = require("747779d8ffab518f");
require("2ff905093e75205");
var useDelayedHover = require("44a9d8069e79d12f");
require("513a5667b03c865");
require("eef6e0f10ba5514e");
var Popover = require("38cd864c99515d41");
require("75354a193c91ce64");
require("35c775ca05844708");
var Menu_context = require("d61f24f122ea5d7b");
var MenuDivider = require("61a7b23f825bc016");
var MenuDropdown = require("c3a2b340dca2c74b");
var MenuItem = require("971d8f9175ee1f2e");
var MenuLabel = require("70bf9a120b6001dd");
var MenuTarget = require("8ccad067344dda3");
var Menu_module = require("a8a45dc515d02cab");
var defaultProps = {
    trapFocus: true,
    closeOnItemClick: true,
    withInitialFocusPlaceholder: true,
    clickOutsideEvents: [
        "mousedown",
        "touchstart",
        "keydown"
    ],
    loop: true,
    trigger: "click",
    openDelay: 0,
    closeDelay: 100,
    menuItemTabIndex: -1
};
function Menu(_props) {
    var props = useProps.useProps("Menu", defaultProps, _props);
    var children = props.children, onOpen = props.onOpen, onClose = props.onClose, opened = props.opened, defaultOpened = props.defaultOpened, trapFocus = props.trapFocus, onChange = props.onChange, closeOnItemClick = props.closeOnItemClick, loop = props.loop, closeOnEscape = props.closeOnEscape, trigger = props.trigger, openDelay = props.openDelay, closeDelay = props.closeDelay, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, variant = props.variant, vars = props.vars, menuItemTabIndex = props.menuItemTabIndex, keepMounted = props.keepMounted, withInitialFocusPlaceholder = props.withInitialFocusPlaceholder, others = (0, _objectWithoutProperties._)(props, [
        "children",
        "onOpen",
        "onClose",
        "opened",
        "defaultOpened",
        "trapFocus",
        "onChange",
        "closeOnItemClick",
        "loop",
        "closeOnEscape",
        "trigger",
        "openDelay",
        "closeDelay",
        "classNames",
        "styles",
        "unstyled",
        "variant",
        "vars",
        "menuItemTabIndex",
        "keepMounted",
        "withInitialFocusPlaceholder"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Menu",
        classes: Menu_module,
        props,
        classNames,
        styles,
        unstyled
    });
    var _useHovered_useHovered = (0, _slicedToArray._)(useHovered.useHovered(), 2), hovered = _useHovered_useHovered[0], _useHovered_useHovered_ = _useHovered_useHovered[1], setHovered = _useHovered_useHovered_.setHovered, resetHovered = _useHovered_useHovered_.resetHovered;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange
    }), 2), _opened = _hooks_useUncontrolled[0], setOpened = _hooks_useUncontrolled[1];
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), openedViaClick = _React_useState[0], setOpenedViaClick = _React_useState[1];
    var close = function() {
        setOpened(false);
        setOpenedViaClick(false);
        _opened && (onClose === null || onClose === void 0 ? void 0 : onClose());
    };
    var open = function() {
        setOpened(true);
        !_opened && (onOpen === null || onOpen === void 0 ? void 0 : onOpen());
    };
    var toggleDropdown = function() {
        _opened ? close() : open();
    };
    var _useDelayedHover_useDelayedHover = useDelayedHover.useDelayedHover({
        open,
        close,
        closeDelay,
        openDelay
    }), openDropdown = _useDelayedHover_useDelayedHover.openDropdown, closeDropdown = _useDelayedHover_useDelayedHover.closeDropdown;
    var getItemIndex = function(node) {
        return getContextItemIndex.getContextItemIndex("[data-menu-item]", "[data-menu-dropdown]", node);
    };
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    hooks.useDidUpdate(function() {
        resetHovered();
    }, [
        _opened
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Menu_context.MenuContextProvider, {
        value: {
            getStyles,
            opened: _opened,
            toggleDropdown,
            getItemIndex,
            hovered,
            setHovered,
            openedViaClick,
            setOpenedViaClick,
            closeOnItemClick,
            closeDropdown: trigger === "click" ? close : closeDropdown,
            openDropdown: trigger === "click" ? open : openDropdown,
            closeDropdownImmediately: close,
            loop,
            trigger,
            unstyled,
            menuItemTabIndex,
            withInitialFocusPlaceholder
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
            opened: _opened,
            onChange: toggleDropdown,
            defaultOpened,
            trapFocus: keepMounted ? false : trapFocus,
            closeOnEscape,
            __staticSelector: "Menu",
            classNames: resolvedClassNames,
            styles: resolvedStyles,
            unstyled,
            variant,
            keepMounted,
            children
        }))
    });
}
Menu.extend = function(input) {
    return input;
};
Menu.withProps = factory.getWithProps(Menu);
Menu.classes = Menu_module;
Menu.displayName = "@mantine/core/Menu";
Menu.Item = MenuItem.MenuItem;
Menu.Label = MenuLabel.MenuLabel;
Menu.Dropdown = MenuDropdown.MenuDropdown;
Menu.Target = MenuTarget.MenuTarget;
Menu.Divider = MenuDivider.MenuDivider;
exports.Menu = Menu; //# sourceMappingURL=Menu.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","e9243590da34947a":"iKGFf","f808fc5c9884816e":"9MtAM","86bc3a6e2d454dcb":"9HEEB","152cfaa760890454":"b3zfW","6b86255844297c44":"79GsF","ff7f7101ad7c3e1e":"8QFOC","b3a2957b68a905b4":"d30sL","f489d89f07320953":"d0sAY","dcba2122e1bee102":"2FdJg","cc309208ac6f83a6":"6AMGA","ddb47dcaed8dbc7b":"erSvz","4103b213ca3d7830":"kqQOF","6babac418fb086c2":"iivvn","3bdf5a22d8ec8ee9":"8YP4O","a3e935b3459ec32f":"gkGXc","747779d8ffab518f":"guLFz","2ff905093e75205":"2onWA","44a9d8069e79d12f":"hFhuj","513a5667b03c865":"jrkk4","eef6e0f10ba5514e":"kAWqL","38cd864c99515d41":"4oc3k","75354a193c91ce64":"b7S6t","35c775ca05844708":"iz4SD","d61f24f122ea5d7b":"8sWe9","61a7b23f825bc016":"bgnKj","c3a2b340dca2c74b":"c7g7f","971d8f9175ee1f2e":"hKwNX","70bf9a120b6001dd":"lSTOB","8ccad067344dda3":"djjcQ","a8a45dc515d02cab":"clwfV"}],"8sWe9":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("c6667fa1456bf928");
var createSafeContext = require("f85634fd6360e8bc");
require("19496b99df79de04");
require("caafcf92347d1f27");
require("ef487015045fe65");
require("d60cc7ddd16a7109");
require("d4b9bd9bb1d1c65e");
require("e46969dc322ffeea");
require("83a676ed50125553");
require("eb1589c56b16e953");
require("9fb6ccb30b387154");
require("52dd0b70d14ada46");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Menu component was not found in the tree"), 2), MenuContextProvider = _createSafeContext_createSafeContext[0], useMenuContext = _createSafeContext_createSafeContext[1];
exports.MenuContextProvider = MenuContextProvider;
exports.useMenuContext = useMenuContext; //# sourceMappingURL=Menu.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","c6667fa1456bf928":"9MtAM","f85634fd6360e8bc":"8srze","19496b99df79de04":"iKGFf","caafcf92347d1f27":"9HEEB","ef487015045fe65":"8QFOC","d60cc7ddd16a7109":"2FdJg","d4b9bd9bb1d1c65e":"6AMGA","e46969dc322ffeea":"erSvz","83a676ed50125553":"kqQOF","eb1589c56b16e953":"8YP4O","9fb6ccb30b387154":"gkGXc","52dd0b70d14ada46":"2onWA"}],"bgnKj":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c906776f30e6d58c");
require("8e0f4897b7cb31e9");
require("724f24f5fac440cc");
require("4f6b18d7a45f3949");
require("2efb1392bef73e4");
require("8e6d6008439f45fc");
require("a0b49dad11da9b6f");
require("f438231370afd2bd");
var useProps = require("9a4f6ce0abd0617a");
require("eee2a79b046a0b43");
var Box = require("349b369ee9619644");
var factory = require("9c1e67ffed4a71c9");
require("a8eb12b6d20f0097");
var Menu_context = require("dcfe77340e427e23");
var Menu_module = require("6695049b49cc21fc");
var defaultProps = {};
var MenuDivider = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("MenuDivider", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Menu_context.useMenuContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("divider", {
        className,
        style,
        styles,
        classNames
    }), others));
});
MenuDivider.classes = Menu_module;
MenuDivider.displayName = "@mantine/core/MenuDivider";
exports.MenuDivider = MenuDivider; //# sourceMappingURL=MenuDivider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","c906776f30e6d58c":"iKGFf","8e0f4897b7cb31e9":"9MtAM","724f24f5fac440cc":"9HEEB","4f6b18d7a45f3949":"8QFOC","2efb1392bef73e4":"2FdJg","8e6d6008439f45fc":"6AMGA","a0b49dad11da9b6f":"erSvz","f438231370afd2bd":"kqQOF","9a4f6ce0abd0617a":"iivvn","eee2a79b046a0b43":"8YP4O","349b369ee9619644":"gkGXc","9c1e67ffed4a71c9":"guLFz","a8eb12b6d20f0097":"2onWA","dcfe77340e427e23":"8sWe9","6695049b49cc21fc":"clwfV"}],"clwfV":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "dropdown": "m_dc9b7c9f",
    "label": "m_9bfac126",
    "divider": "m_efdf90cb",
    "item": "m_99ac2aa1",
    "itemLabel": "m_5476e0d3",
    "itemSection": "m_8b75e504"
};
module.exports = classes; //# sourceMappingURL=Menu.module.css.cjs.map

},{}],"c7g7f":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("ac986b26280e7f95");
var React = require("94f42166f971ac61");
var hooks = require("3d78619e3eeb3aca");
var createEventHandler = require("b286fb5c69cea6e5");
require("3ca8a6efcfb3bee7");
require("fcc4ecbf1bd3bd40");
require("d381757baf5237cb");
require("8972d79162868ff8");
require("ad6efef2fe0c5b21");
var useProps = require("c4c8bf2f0962e0bb");
require("9079cd03f8617f99");
require("b55ddc6966b5244a");
var factory = require("b892d398b0f38f04");
require("2a36a017d10d9d10");
var Popover = require("c9c015bb0ac63908");
require("d9acdd4b757253fe");
require("d406c50859dbd750");
var Menu_context = require("a9b625e3bf2978be");
var Menu_module = require("5ddabb0421d03015");
var defaultProps = {};
var MenuDropdown = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("MenuDropdown", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, onMouseEnter = _useProps_useProps.onMouseEnter, onMouseLeave = _useProps_useProps.onMouseLeave, onKeyDown = _useProps_useProps.onKeyDown, children = _useProps_useProps.children, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "onMouseEnter",
        "onMouseLeave",
        "onKeyDown",
        "children"
    ]);
    var wrapperRef = React.useRef(null);
    var ctx = Menu_context.useMenuContext();
    var handleKeyDown = createEventHandler.createEventHandler(onKeyDown, function(event) {
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            var _wrapperRef_current_querySelectorAll_, _wrapperRef_current;
            event.preventDefault();
            (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : (_wrapperRef_current_querySelectorAll_ = _wrapperRef_current.querySelectorAll("[data-menu-item]:not(:disabled)")[0]) === null || _wrapperRef_current_querySelectorAll_ === void 0 ? void 0 : _wrapperRef_current_querySelectorAll_.focus();
        }
    });
    var handleMouseEnter = createEventHandler.createEventHandler(onMouseEnter, function() {
        return (ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown();
    });
    var handleMouseLeave = createEventHandler.createEventHandler(onMouseLeave, function() {
        return (ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.closeDropdown();
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Popover.Popover.Dropdown, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        role: "menu",
        "aria-orientation": "vertical",
        ref: hooks.useMergedRef(ref, wrapperRef)
    }), ctx.getStyles("dropdown", {
        className,
        style,
        styles,
        classNames,
        withStaticClass: false
    })), {
        tabIndex: -1,
        "data-menu-dropdown": true,
        onKeyDown: handleKeyDown,
        children: [
            ctx.withInitialFocusPlaceholder && /* @__PURE__ */ jsxRuntime.jsx("div", {
                tabIndex: -1,
                "data-autofocus": true,
                "data-mantine-stop-propagation": true,
                style: {
                    outline: 0
                }
            }),
            children
        ]
    }));
});
MenuDropdown.classes = Menu_module;
MenuDropdown.displayName = "@mantine/core/MenuDropdown";
exports.MenuDropdown = MenuDropdown; //# sourceMappingURL=MenuDropdown.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","ac986b26280e7f95":"iKGFf","94f42166f971ac61":"9MtAM","3d78619e3eeb3aca":"9HEEB","b286fb5c69cea6e5":"9qSGJ","3ca8a6efcfb3bee7":"8QFOC","fcc4ecbf1bd3bd40":"2FdJg","d381757baf5237cb":"6AMGA","8972d79162868ff8":"erSvz","ad6efef2fe0c5b21":"kqQOF","c4c8bf2f0962e0bb":"iivvn","9079cd03f8617f99":"8YP4O","b55ddc6966b5244a":"gkGXc","b892d398b0f38f04":"guLFz","2a36a017d10d9d10":"2onWA","c9c015bb0ac63908":"4oc3k","d9acdd4b757253fe":"b7S6t","d406c50859dbd750":"iz4SD","a9b625e3bf2978be":"8sWe9","5ddabb0421d03015":"clwfV"}],"hKwNX":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("ffbdda00c5a58d83");
var React = require("84bc126fff279e32");
var hooks = require("4fd4fb69e78cbdf0");
var createScopedKeydownHandler = require("75ba18394b0d49a8");
var createEventHandler = require("dec9df2cc33ca1de");
require("e4084bcef412bed7");
var parseThemeColor = require("3515af8bf0494655");
require("8b7dc263f79ae193");
require("d90a50f9e60e602b");
require("9faeee144dbe01f7");
var MantineThemeProvider = require("ddb97be8443b30dc");
var useProps = require("7f586cbb6bf230c4");
require("3934c92258362370");
require("a0f93b6be2827fc6");
var polymorphicFactory = require("6e2ba9f361ef9d6a");
var DirectionProvider = require("5ce66319103e706a");
var UnstyledButton = require("c59a244bfee4f2c9");
var Menu_context = require("994ac68c5e03fa2a");
var Menu_module = require("cd643cb6960989c2");
var defaultProps = {};
var MenuItem = polymorphicFactory.polymorphicFactory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("MenuItem", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, color = _useProps_useProps.color, closeMenuOnClick = _useProps_useProps.closeMenuOnClick, leftSection = _useProps_useProps.leftSection, rightSection = _useProps_useProps.rightSection, children = _useProps_useProps.children, disabled = _useProps_useProps.disabled, dataDisabled = _useProps_useProps["data-disabled"], others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "color",
        "closeMenuOnClick",
        "leftSection",
        "rightSection",
        "children",
        "disabled",
        "data-disabled"
    ]);
    var ctx = Menu_context.useMenuContext();
    var theme = MantineThemeProvider.useMantineTheme();
    var dir = DirectionProvider.useDirection().dir;
    var itemRef = React.useRef(null);
    var itemIndex = ctx.getItemIndex(itemRef.current);
    var _others = others;
    var handleMouseLeave = createEventHandler.createEventHandler(_others.onMouseLeave, function() {
        return ctx.setHovered(-1);
    });
    var handleMouseEnter = createEventHandler.createEventHandler(_others.onMouseEnter, function() {
        return ctx.setHovered(ctx.getItemIndex(itemRef.current));
    });
    var handleClick = createEventHandler.createEventHandler(_others.onClick, function() {
        if (dataDisabled) return;
        if (typeof closeMenuOnClick === "boolean") closeMenuOnClick && ctx.closeDropdownImmediately();
        else ctx.closeOnItemClick && ctx.closeDropdownImmediately();
    });
    var handleFocus = createEventHandler.createEventHandler(_others.onFocus, function() {
        return ctx.setHovered(ctx.getItemIndex(itemRef.current));
    });
    var colors = color ? theme.variantColorResolver({
        color,
        theme,
        variant: "light"
    }) : void 0;
    var parsedThemeColor = color ? parseThemeColor.parseThemeColor({
        color,
        theme
    }) : null;
    return /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
        unstyled: ctx.unstyled,
        tabIndex: ctx.menuItemTabIndex,
        onFocus: handleFocus
    }), ctx.getStyles("item", {
        className,
        style,
        styles,
        classNames
    })), {
        ref: hooks.useMergedRef(itemRef, ref),
        role: "menuitem",
        disabled,
        "data-menu-item": true,
        "data-disabled": disabled || dataDisabled || void 0,
        "data-hovered": ctx.hovered === itemIndex ? true : void 0,
        "data-mantine-stop-propagation": true,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick,
        onKeyDown: createScopedKeydownHandler.createScopedKeydownHandler({
            siblingSelector: "[data-menu-item]:not([data-disabled])",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir,
            orientation: "vertical",
            onKeyDown: _others.onKeyDown
        }),
        __vars: {
            "--menu-item-color": (parsedThemeColor === null || parsedThemeColor === void 0 ? void 0 : parsedThemeColor.isThemeColor) && (parsedThemeColor === null || parsedThemeColor === void 0 ? void 0 : parsedThemeColor.shade) === void 0 ? `var(--mantine-color-${parsedThemeColor.color}-6)` : colors === null || colors === void 0 ? void 0 : colors.color,
            "--menu-item-hover": colors === null || colors === void 0 ? void 0 : colors.hover
        },
        children: [
            leftSection && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemSection", {
                styles,
                classNames
            })), {
                "data-position": "left",
                children: leftSection
            })),
            children && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemLabel", {
                styles,
                classNames
            })), {
                children
            })),
            rightSection && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemSection", {
                styles,
                classNames
            })), {
                "data-position": "right",
                children: rightSection
            }))
        ]
    }));
});
MenuItem.classes = Menu_module;
MenuItem.displayName = "@mantine/core/MenuItem";
exports.MenuItem = MenuItem; //# sourceMappingURL=MenuItem.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","ffbdda00c5a58d83":"iKGFf","84bc126fff279e32":"9MtAM","4fd4fb69e78cbdf0":"9HEEB","75ba18394b0d49a8":"5jFxz","dec9df2cc33ca1de":"9qSGJ","e4084bcef412bed7":"8QFOC","3515af8bf0494655":"ctp80","8b7dc263f79ae193":"2FdJg","d90a50f9e60e602b":"6AMGA","9faeee144dbe01f7":"erSvz","ddb97be8443b30dc":"kqQOF","7f586cbb6bf230c4":"iivvn","3934c92258362370":"8YP4O","a0f93b6be2827fc6":"gkGXc","6e2ba9f361ef9d6a":"iYAEL","5ce66319103e706a":"2onWA","c59a244bfee4f2c9":"cArqr","994ac68c5e03fa2a":"8sWe9","cd643cb6960989c2":"clwfV"}],"lSTOB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c2dc98a3d6a8d8c8");
require("f8007348e3aee8dc");
require("4a5a2b864117d77e");
require("49e7786bd7d50e34");
require("6a9d55aaadd193");
require("2620a8b10c16c105");
require("4b3a45362898de4a");
require("c59a907735cb106b");
var useProps = require("e5494a0c630a094c");
require("7e4286ab6b04f219");
var Box = require("60eb55385394c54e");
var factory = require("9dae88972143e08b");
require("e13d28f586394348");
var Menu_context = require("488f8b9f3221956c");
var Menu_module = require("68d566944f041ea6");
var defaultProps = {};
var MenuLabel = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("MenuLabel", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Menu_context.useMenuContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("label", {
        className,
        style,
        styles,
        classNames
    }), others));
});
MenuLabel.classes = Menu_module;
MenuLabel.displayName = "@mantine/core/MenuLabel";
exports.MenuLabel = MenuLabel; //# sourceMappingURL=MenuLabel.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","c2dc98a3d6a8d8c8":"iKGFf","f8007348e3aee8dc":"9MtAM","4a5a2b864117d77e":"9HEEB","49e7786bd7d50e34":"8QFOC","6a9d55aaadd193":"2FdJg","2620a8b10c16c105":"6AMGA","4b3a45362898de4a":"erSvz","c59a907735cb106b":"kqQOF","e5494a0c630a094c":"iivvn","7e4286ab6b04f219":"8YP4O","60eb55385394c54e":"gkGXc","9dae88972143e08b":"guLFz","e13d28f586394348":"2onWA","488f8b9f3221956c":"8sWe9","68d566944f041ea6":"clwfV"}],"djjcQ":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("72185206ec60513a");
var React = require("6b90ced39748c152");
var isElement = require("f1b3ce871cb907ac");
var createEventHandler = require("1abbe8491cccb11b");
require("de8f2298429ec03d");
require("d3cce32144e38ff9");
require("9c4d4002ea4771ab");
require("388de03fa4c64fcb");
require("9437624a69fa9555");
require("9c2bfb164fd53aba");
var useProps = require("3a7c0836cf80faa2");
require("a45f774a5adace11");
require("7de806b28a3491e7");
require("bb7e5c8c719cd985");
var Popover = require("4c734b90a92b69a4");
require("431a077b83b99210");
require("921bde2457195734");
var Menu_context = require("b82fd710b9e26109");
var defaultProps = {
    refProp: "ref"
};
var MenuTarget = React.forwardRef(function(props, ref) {
    var _useProps_useProps = useProps.useProps("MenuTarget", defaultProps, props), children = _useProps_useProps.children, refProp = _useProps_useProps.refProp, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "refProp"
    ]);
    if (!isElement.isElement(children)) throw new Error("Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    var ctx = Menu_context.useMenuContext();
    var _childrenProps = children.props;
    var onClick = createEventHandler.createEventHandler(_childrenProps.onClick, function() {
        if (ctx.trigger === "click") ctx.toggleDropdown();
        else if (ctx.trigger === "click-hover") {
            ctx.setOpenedViaClick(true);
            if (!ctx.opened) ctx.openDropdown();
        }
    });
    var onMouseEnter = createEventHandler.createEventHandler(_childrenProps.onMouseEnter, function() {
        return (ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown();
    });
    var onMouseLeave = createEventHandler.createEventHandler(_childrenProps.onMouseLeave, function() {
        if (ctx.trigger === "hover") ctx.closeDropdown();
        else if (ctx.trigger === "click-hover" && !ctx.openedViaClick) ctx.closeDropdown();
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Popover.Popover.Target, (0, _objectSpreadProps._)((0, _objectSpread._)({
        refProp,
        popupType: "menu",
        ref
    }, others), {
        children: React.cloneElement(children, {
            onClick,
            onMouseEnter,
            onMouseLeave,
            "data-expanded": ctx.opened ? true : void 0
        })
    }));
});
MenuTarget.displayName = "@mantine/core/MenuTarget";
exports.MenuTarget = MenuTarget; //# sourceMappingURL=MenuTarget.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","72185206ec60513a":"iKGFf","6b90ced39748c152":"9MtAM","f1b3ce871cb907ac":"193o0","1abbe8491cccb11b":"9qSGJ","de8f2298429ec03d":"9HEEB","d3cce32144e38ff9":"8QFOC","9c4d4002ea4771ab":"2FdJg","388de03fa4c64fcb":"6AMGA","9437624a69fa9555":"erSvz","9c2bfb164fd53aba":"kqQOF","3a7c0836cf80faa2":"iivvn","a45f774a5adace11":"8YP4O","7de806b28a3491e7":"gkGXc","bb7e5c8c719cd985":"2onWA","4c734b90a92b69a4":"4oc3k","431a077b83b99210":"b7S6t","921bde2457195734":"iz4SD","b82fd710b9e26109":"8sWe9"}],"4ez60":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("9d214cf41ce3ad71");
var React = require("aac7a7d24af8f332");
var getDefaultZIndex = require("547d27e4e3c35359");
require("315a6f93af0e8e61");
require("5e7fd563128a466f");
require("34be3fdcd17d2850");
require("6709e7c50982f97f");
require("d302bf33d9ed0782");
require("6e667ee5ffb96b74");
var useProps = require("905a98b14bdafd50");
require("8a03b7daf22c197d");
require("5c4c1fcdeb6cd42d");
var factory = require("241fa6fa404193e3");
require("db0885dbae360a02");
var ModalBody = require("2c3a3baf0f9ef11e");
var ModalCloseButton = require("64e33ed24d531c16");
var ModalContent = require("c0008a38e5598ea0");
var ModalHeader = require("d70408d0151b4298");
var ModalOverlay = require("fa9d8cc278ffcfae");
var ModalRoot = require("c74c389ab2a03c89");
var ModalStack = require("a16ced064d391872");
var ModalTitle = require("1003a7d2dd3fb4f9");
var Modal_module = require("85e9c09f40751846");
var defaultProps = {
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: getDefaultZIndex.getDefaultZIndex("modal"),
    transitionProps: {
        duration: 200,
        transition: "fade-down"
    },
    withOverlay: true,
    withCloseButton: true
};
var Modal = factory.factory(function(_props, ref) {
    var _useProps_useProps = useProps.useProps("Modal", defaultProps, _props), title = _useProps_useProps.title, withOverlay = _useProps_useProps.withOverlay, overlayProps = _useProps_useProps.overlayProps, withCloseButton = _useProps_useProps.withCloseButton, closeButtonProps = _useProps_useProps.closeButtonProps, children = _useProps_useProps.children, radius = _useProps_useProps.radius, opened = _useProps_useProps.opened, stackId = _useProps_useProps.stackId, zIndex = _useProps_useProps.zIndex, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "title",
        "withOverlay",
        "overlayProps",
        "withCloseButton",
        "closeButtonProps",
        "children",
        "radius",
        "opened",
        "stackId",
        "zIndex"
    ]);
    var ctx = ModalStack.useModalStackContext();
    var hasHeader = !!title || withCloseButton;
    var stackProps = ctx && stackId ? {
        closeOnEscape: ctx.currentId === stackId,
        trapFocus: ctx.currentId === stackId,
        zIndex: ctx.getZIndex(stackId)
    } : {};
    var overlayVisible = withOverlay === false ? false : stackId && ctx ? ctx.currentId === stackId : opened;
    React.useEffect(function() {
        if (ctx && stackId) opened ? ctx.addModal(stackId, zIndex || getDefaultZIndex.getDefaultZIndex("modal")) : ctx.removeModal(stackId);
    }, [
        opened,
        stackId,
        zIndex
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs(ModalRoot.ModalRoot, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        radius,
        opened,
        zIndex: ctx && stackId ? ctx.getZIndex(stackId) : zIndex
    }, others, stackProps), {
        children: [
            withOverlay && /* @__PURE__ */ jsxRuntime.jsx(ModalOverlay.ModalOverlay, (0, _objectSpread._)({
                visible: overlayVisible,
                transitionProps: ctx && stackId ? {
                    duration: 0
                } : void 0
            }, overlayProps)),
            /* @__PURE__ */ jsxRuntime.jsxs(ModalContent.ModalContent, {
                radius,
                __hidden: ctx && stackId && opened ? stackId !== ctx.currentId : false,
                children: [
                    hasHeader && /* @__PURE__ */ jsxRuntime.jsxs(ModalHeader.ModalHeader, {
                        children: [
                            title && /* @__PURE__ */ jsxRuntime.jsx(ModalTitle.ModalTitle, {
                                children: title
                            }),
                            withCloseButton && /* @__PURE__ */ jsxRuntime.jsx(ModalCloseButton.ModalCloseButton, (0, _objectSpread._)({}, closeButtonProps))
                        ]
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(ModalBody.ModalBody, {
                        children
                    })
                ]
            })
        ]
    }));
});
Modal.classes = Modal_module;
Modal.displayName = "@mantine/core/Modal";
Modal.Root = ModalRoot.ModalRoot;
Modal.Overlay = ModalOverlay.ModalOverlay;
Modal.Content = ModalContent.ModalContent;
Modal.Body = ModalBody.ModalBody;
Modal.Header = ModalHeader.ModalHeader;
Modal.Title = ModalTitle.ModalTitle;
Modal.CloseButton = ModalCloseButton.ModalCloseButton;
Modal.Stack = ModalStack.ModalStack;
exports.Modal = Modal; //# sourceMappingURL=Modal.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","9d214cf41ce3ad71":"iKGFf","aac7a7d24af8f332":"9MtAM","547d27e4e3c35359":"4gavl","315a6f93af0e8e61":"9HEEB","5e7fd563128a466f":"8QFOC","34be3fdcd17d2850":"2FdJg","6709e7c50982f97f":"6AMGA","d302bf33d9ed0782":"erSvz","6e667ee5ffb96b74":"kqQOF","905a98b14bdafd50":"iivvn","8a03b7daf22c197d":"8YP4O","5c4c1fcdeb6cd42d":"gkGXc","241fa6fa404193e3":"guLFz","db0885dbae360a02":"2onWA","2c3a3baf0f9ef11e":"9FnFM","64e33ed24d531c16":"a3Vb1","c0008a38e5598ea0":"ioorp","d70408d0151b4298":"c7QR6","fa9d8cc278ffcfae":"1kFS2","c74c389ab2a03c89":"6AcuU","a16ced064d391872":"csVD5","1003a7d2dd3fb4f9":"8Cbau","85e9c09f40751846":"kEtle"}],"9FnFM":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b6d4db1ff41dcfcc");
require("a821ea04d3f76821");
require("2b5ed75f8376d050");
require("3a828ef620f914de");
require("a8991d2c27efaf18");
require("3c9185293981d2f9");
require("6fece80af05446ad");
require("58a27d0b213c32c6");
var useProps = require("a724c7a491447d20");
require("bff561988a9a3a95");
require("fcf10bf42bee8bb6");
var factory = require("d3a75636c272f58e");
require("6ccb0b6b096d2a63");
require("840083ac788389dc");
var ModalBaseBody = require("1c6d4d31c2128c02");
require("aa41617944fa0585");
require("77f8b79c68f699ba");
require("42a3bcc7030edf29");
require("5c268e7ae5aca5fc");
require("b0e6bc1936c1e288");
var Modal_context = require("efecef1097c0fd52");
var Modal_module = require("8084b26783ac9542");
var defaultProps = {};
var ModalBody = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ModalBody", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Modal_context.useModalContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseBody.ModalBaseBody, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("body", {
        classNames,
        style,
        styles,
        className
    }), others));
});
ModalBody.classes = Modal_module;
ModalBody.displayName = "@mantine/core/ModalBody";
exports.ModalBody = ModalBody; //# sourceMappingURL=ModalBody.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","b6d4db1ff41dcfcc":"iKGFf","a821ea04d3f76821":"9MtAM","2b5ed75f8376d050":"9HEEB","3a828ef620f914de":"8QFOC","a8991d2c27efaf18":"2FdJg","3c9185293981d2f9":"6AMGA","6fece80af05446ad":"erSvz","58a27d0b213c32c6":"kqQOF","a724c7a491447d20":"iivvn","bff561988a9a3a95":"8YP4O","fcf10bf42bee8bb6":"gkGXc","d3a75636c272f58e":"guLFz","6ccb0b6b096d2a63":"2onWA","840083ac788389dc":"PGvLq","1c6d4d31c2128c02":"8i8nh","aa41617944fa0585":"ifiLz","77f8b79c68f699ba":"8qmr0","42a3bcc7030edf29":"fsdDM","5c268e7ae5aca5fc":"fj3f7","b0e6bc1936c1e288":"5DnfR","efecef1097c0fd52":"icVkk","8084b26783ac9542":"kEtle"}],"icVkk":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("4beb24659fcb0612");
var createSafeContext = require("e010535bf9e656d7");
require("74de5f105e5a245d");
require("ff13b47c32f79aeb");
require("217cfb7969bf683c");
require("36643747ee32c795");
require("6621918f993728c9");
require("9242f476746d840c");
require("ce775ac719e7d56e");
require("232f420b564f69fb");
require("cce6c3fc3ee9d9e0");
require("56b01ee16be6adef");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Modal component was not found in tree"), 2), ModalProvider = _createSafeContext_createSafeContext[0], useModalContext = _createSafeContext_createSafeContext[1];
exports.ModalProvider = ModalProvider;
exports.useModalContext = useModalContext; //# sourceMappingURL=Modal.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","4beb24659fcb0612":"9MtAM","e010535bf9e656d7":"8srze","74de5f105e5a245d":"iKGFf","ff13b47c32f79aeb":"9HEEB","217cfb7969bf683c":"8QFOC","36643747ee32c795":"2FdJg","6621918f993728c9":"6AMGA","9242f476746d840c":"erSvz","ce775ac719e7d56e":"kqQOF","232f420b564f69fb":"8YP4O","cce6c3fc3ee9d9e0":"gkGXc","56b01ee16be6adef":"2onWA"}],"kEtle":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_9df02822",
    "content": "m_54c44539",
    "inner": "m_1f958f16",
    "header": "m_d0e2b9cd"
};
module.exports = classes; //# sourceMappingURL=Modal.module.css.cjs.map

},{}],"a3Vb1":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3c0cf0a212319b36");
require("f3463cc4dd8fc5eb");
require("14266c4aff418188");
require("22f43b1d903168");
require("8b2acb3b14a85681");
require("1ec1cb82040e9482");
require("21f18c2fb0c3d13f");
require("9b20cfaf970b80c3");
var useProps = require("ce8e25f3d382ad44");
require("7427d01057da7e89");
require("b508156fb5cc9ef6");
var factory = require("e80661bcd1e23505");
require("f5510b0c0459c73c");
require("1af70dcbb926f41a");
require("a6014165caf14f93");
var ModalBaseCloseButton = require("1aac909d6dd2e2a1");
require("2ac23a061a77ec94");
require("3c14dc806a378bff");
require("baf421bffda1c305");
require("970f518d0641575a");
var Modal_context = require("a30d0364c36f1643");
var Modal_module = require("54a352e0bffebc61");
var defaultProps = {};
var ModalCloseButton = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ModalCloseButton", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Modal_context.useModalContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseCloseButton.ModalBaseCloseButton, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("close", {
        classNames,
        style,
        styles,
        className
    }), others));
});
ModalCloseButton.classes = Modal_module;
ModalCloseButton.displayName = "@mantine/core/ModalCloseButton";
exports.ModalCloseButton = ModalCloseButton; //# sourceMappingURL=ModalCloseButton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","3c0cf0a212319b36":"iKGFf","f3463cc4dd8fc5eb":"9MtAM","14266c4aff418188":"9HEEB","22f43b1d903168":"8QFOC","8b2acb3b14a85681":"2FdJg","1ec1cb82040e9482":"6AMGA","21f18c2fb0c3d13f":"erSvz","9b20cfaf970b80c3":"kqQOF","ce8e25f3d382ad44":"iivvn","7427d01057da7e89":"8YP4O","b508156fb5cc9ef6":"gkGXc","e80661bcd1e23505":"guLFz","f5510b0c0459c73c":"2onWA","1af70dcbb926f41a":"PGvLq","a6014165caf14f93":"8i8nh","1aac909d6dd2e2a1":"ifiLz","2ac23a061a77ec94":"8qmr0","3c14dc806a378bff":"fsdDM","baf421bffda1c305":"fj3f7","970f518d0641575a":"5DnfR","a30d0364c36f1643":"icVkk","54a352e0bffebc61":"kEtle"}],"ioorp":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a4a9566e714ce5a4");
var rem = require("f7ccbb6e2a22e05b");
require("46b64c0aaf75d50e");
require("a56fa222f820243");
require("48bdff37cb6d285f");
require("9713127ddf45c08d");
require("86d86712bd2a1355");
require("101fc140c22be9a9");
require("46b25a0204c62b70");
var useProps = require("19904e8a78af8c95");
require("a3ffa94e61a586e6");
require("fb57755f76cb511c");
var factory = require("2dd2d91fa0c16254");
require("87c947864fb18d2e");
require("95b1395801dcd250");
require("8fcbe71405f22a73");
require("41e633481da715a3");
var ModalBaseContent = require("2c6083ac8d293212");
require("4a90fc8361eb3781");
require("dc4e839c36a12277");
require("aab2929053e7039d");
var NativeScrollArea = require("2f194070c0d27460");
var Modal_context = require("c00b4b2b2692b789");
var Modal_module = require("635901ee484f4998");
var defaultProps = {};
var ModalContent = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ModalContent", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, children = props.children, __hidden = props.__hidden, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "children",
        "__hidden"
    ]);
    var ctx = Modal_context.useModalContext();
    var Scroll = ctx.scrollAreaComponent || NativeScrollArea.NativeScrollArea;
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseContent.ModalBaseContent, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("content", {
        className,
        style,
        styles,
        classNames
    })), {
        innerProps: ctx.getStyles("inner", {
            className,
            style,
            styles,
            classNames
        }),
        "data-full-screen": ctx.fullScreen || void 0,
        "data-modal-content": true,
        "data-hidden": __hidden || void 0,
        ref
    }), others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(Scroll, {
            style: {
                maxHeight: ctx.fullScreen ? "100dvh" : `calc(100dvh - (${rem.rem(ctx.yOffset)} * 2))`
            },
            children
        })
    }));
});
ModalContent.classes = Modal_module;
ModalContent.displayName = "@mantine/core/ModalContent";
exports.ModalContent = ModalContent; //# sourceMappingURL=ModalContent.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","a4a9566e714ce5a4":"iKGFf","f7ccbb6e2a22e05b":"ebAaL","46b64c0aaf75d50e":"9MtAM","a56fa222f820243":"9HEEB","48bdff37cb6d285f":"8QFOC","9713127ddf45c08d":"2FdJg","86d86712bd2a1355":"6AMGA","101fc140c22be9a9":"erSvz","46b25a0204c62b70":"kqQOF","19904e8a78af8c95":"iivvn","a3ffa94e61a586e6":"8YP4O","fb57755f76cb511c":"gkGXc","2dd2d91fa0c16254":"guLFz","87c947864fb18d2e":"2onWA","95b1395801dcd250":"PGvLq","8fcbe71405f22a73":"8i8nh","41e633481da715a3":"ifiLz","2c6083ac8d293212":"8qmr0","4a90fc8361eb3781":"fsdDM","dc4e839c36a12277":"fj3f7","aab2929053e7039d":"5DnfR","2f194070c0d27460":"d55zN","c00b4b2b2692b789":"icVkk","635901ee484f4998":"kEtle"}],"c7QR6":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("770a0a4de9ce78b0");
require("770a9ec4c4bf92d1");
require("a06c2341394c2173");
require("5d819c3ee6adefcb");
require("97d1762480125ce4");
require("a003147706d484b2");
require("d6c1cb40ca4eea58");
require("3fb958c6b1bd2c7b");
var useProps = require("bb40e22dd2afbcea");
require("92c5d5b40a5457c1");
require("49c0f24dcb7fa2fc");
var factory = require("209d4f527d437b7b");
require("be2ebf27da49813a");
require("1abef3678f970341");
require("8bc88bd32b3d5731");
require("768f432b4fca31a1");
require("5289649ba00f7c49");
var ModalBaseHeader = require("cdd09852e27aada5");
require("7296594fb56daf50");
require("aecc05a006937a5f");
var Modal_context = require("f954aea15649957d");
var Modal_module = require("285297a4d13f792f");
var defaultProps = {};
var ModalHeader = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ModalHeader", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Modal_context.useModalContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseHeader.ModalBaseHeader, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("header", {
        classNames,
        style,
        styles,
        className
    }), others));
});
ModalHeader.classes = Modal_module;
ModalHeader.displayName = "@mantine/core/ModalHeader";
exports.ModalHeader = ModalHeader; //# sourceMappingURL=ModalHeader.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","770a0a4de9ce78b0":"iKGFf","770a9ec4c4bf92d1":"9MtAM","a06c2341394c2173":"9HEEB","5d819c3ee6adefcb":"8QFOC","97d1762480125ce4":"2FdJg","a003147706d484b2":"6AMGA","d6c1cb40ca4eea58":"erSvz","3fb958c6b1bd2c7b":"kqQOF","bb40e22dd2afbcea":"iivvn","92c5d5b40a5457c1":"8YP4O","49c0f24dcb7fa2fc":"gkGXc","209d4f527d437b7b":"guLFz","be2ebf27da49813a":"2onWA","1abef3678f970341":"PGvLq","8bc88bd32b3d5731":"8i8nh","768f432b4fca31a1":"ifiLz","5289649ba00f7c49":"8qmr0","cdd09852e27aada5":"fsdDM","7296594fb56daf50":"fj3f7","aecc05a006937a5f":"5DnfR","f954aea15649957d":"icVkk","285297a4d13f792f":"kEtle"}],"1kFS2":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a884525657bce0e9");
require("4c759a7cd62cc740");
require("3ebc8994a60ce098");
require("3395ab1043e73e77");
require("e4d60a2c4c2a921d");
require("f0b629b451e559d5");
require("428e63a042414e4b");
require("2fb2bb52814a713a");
var useProps = require("81e9c4c9649ed495");
require("4cade6f7f2f39206");
require("2d84b4726ec2d8cc");
var factory = require("97566962c890b7cb");
require("1b595a3ab1809927");
require("bebf3c37ac0f2ed9");
require("fa52b09ae54b4046");
require("935d818676fece69");
require("9335d930f1a945f6");
require("c1c0799d8428154e");
var ModalBaseOverlay = require("6d334099dd9ca9eb");
require("e0ea42a762477ea4");
var Modal_context = require("c1712b83a654d84c");
var Modal_module = require("c822d70d98b40815");
var defaultProps = {};
var ModalOverlay = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ModalOverlay", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Modal_context.useModalContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseOverlay.ModalBaseOverlay, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("overlay", {
        classNames,
        style,
        styles,
        className
    }), others));
});
ModalOverlay.classes = Modal_module;
ModalOverlay.displayName = "@mantine/core/ModalOverlay";
exports.ModalOverlay = ModalOverlay; //# sourceMappingURL=ModalOverlay.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","a884525657bce0e9":"iKGFf","4c759a7cd62cc740":"9MtAM","3ebc8994a60ce098":"9HEEB","3395ab1043e73e77":"8QFOC","e4d60a2c4c2a921d":"2FdJg","f0b629b451e559d5":"6AMGA","428e63a042414e4b":"erSvz","2fb2bb52814a713a":"kqQOF","81e9c4c9649ed495":"iivvn","4cade6f7f2f39206":"8YP4O","2d84b4726ec2d8cc":"gkGXc","97566962c890b7cb":"guLFz","1b595a3ab1809927":"2onWA","bebf3c37ac0f2ed9":"PGvLq","fa52b09ae54b4046":"8i8nh","935d818676fece69":"ifiLz","9335d930f1a945f6":"8qmr0","c1c0799d8428154e":"fsdDM","6d334099dd9ca9eb":"fj3f7","e0ea42a762477ea4":"5DnfR","c1712b83a654d84c":"icVkk","c822d70d98b40815":"kEtle"}],"6AcuU":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2f5a52381789398a");
var rem = require("4a033a9306badac");
require("f48d5288611f2cc9");
var getDefaultZIndex = require("b89903aa75d8e5fb");
var getSize = require("bc613b5a7a40eeb7");
require("3a7c07b7c11e341a");
var createVarsResolver = require("bb32c5eaad852160");
require("85bf158d4c5e4e21");
require("2e411542b6efbbb3");
require("f8e569c11eec9430");
require("821f4c642718e947");
require("92fc949d3b0b806d");
var useProps = require("41f624032c317ce9");
require("c48eb00f434b1194");
var useStyles = require("d3ab61ccc6cc2bda");
require("a6196f7d23258a61");
var factory = require("8793d9f46ab79d2f");
require("7f3806c6c392cbef");
var ModalBase = require("107c94d751e82936");
require("42bef56099b25820");
require("198e847b33604cb4");
require("a2224b91246bf3cf");
require("e0e13a0216e2b45c");
require("ff93ca676422f94c");
require("5b28dcb41cab0933");
var ScrollArea = require("6eff58dcb72b17b7");
var Modal_context = require("91e86295e894ec65");
var Modal_module = require("b994018d5bd4ed5d");
var defaultProps = {
    __staticSelector: "Modal",
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: getDefaultZIndex.getDefaultZIndex("modal"),
    transitionProps: {
        duration: 200,
        transition: "fade-down"
    },
    yOffset: "5dvh"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius, size = param.size, yOffset = param.yOffset, xOffset = param.xOffset;
    return {
        root: {
            "--modal-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--modal-size": getSize.getSize(size, "modal-size"),
            "--modal-y-offset": rem.rem(yOffset),
            "--modal-x-offset": rem.rem(xOffset)
        }
    };
});
var ModalRoot = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ModalRoot", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, yOffset = props.yOffset, scrollAreaComponent = props.scrollAreaComponent, radius = props.radius, fullScreen = props.fullScreen, centered = props.centered, xOffset = props.xOffset, __staticSelector = props.__staticSelector, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "yOffset",
        "scrollAreaComponent",
        "radius",
        "fullScreen",
        "centered",
        "xOffset",
        "__staticSelector"
    ]);
    var getStyles = useStyles.useStyles({
        name: __staticSelector,
        classes: Modal_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Modal_context.ModalProvider, {
        value: {
            yOffset,
            scrollAreaComponent,
            getStyles,
            fullScreen
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(ModalBase.ModalBase, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            ref
        }, getStyles("root")), {
            "data-full-screen": fullScreen || void 0,
            "data-centered": centered || void 0,
            "data-offset-scrollbars": scrollAreaComponent === ScrollArea.ScrollArea.Autosize || void 0,
            unstyled
        }), others))
    });
});
ModalRoot.classes = Modal_module;
ModalRoot.displayName = "@mantine/core/ModalRoot";
exports.ModalRoot = ModalRoot; //# sourceMappingURL=ModalRoot.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","2f5a52381789398a":"iKGFf","4a033a9306badac":"ebAaL","f48d5288611f2cc9":"9MtAM","b89903aa75d8e5fb":"4gavl","bc613b5a7a40eeb7":"kEFEY","3a7c07b7c11e341a":"9HEEB","bb32c5eaad852160":"hIQE6","85bf158d4c5e4e21":"8QFOC","2e411542b6efbbb3":"2FdJg","f8e569c11eec9430":"6AMGA","821f4c642718e947":"erSvz","92fc949d3b0b806d":"kqQOF","41f624032c317ce9":"iivvn","c48eb00f434b1194":"8YP4O","d3ab61ccc6cc2bda":"d0sAY","a6196f7d23258a61":"gkGXc","8793d9f46ab79d2f":"guLFz","7f3806c6c392cbef":"2onWA","107c94d751e82936":"PGvLq","42bef56099b25820":"8i8nh","198e847b33604cb4":"ifiLz","a2224b91246bf3cf":"8qmr0","e0e13a0216e2b45c":"fsdDM","ff93ca676422f94c":"fj3f7","5b28dcb41cab0933":"5DnfR","6eff58dcb72b17b7":"ctZfT","91e86295e894ec65":"icVkk","b994018d5bd4ed5d":"kEtle"}],"csVD5":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("53c8211f1c757181");
var React = require("91a267bb4beb4f15");
var createOptionalContext = require("3c2903bdb2ba7604");
var getDefaultZIndex = require("6f53e8d92842db41");
require("90ccb37deb8212f7");
require("717ea14ef89cf07c");
require("b9b831d6cf1db3c6");
require("5bc492de2fbc413");
require("81c46e51f6e0fc9e");
require("78d8485d3ab2bb3d");
require("b53e556661f5f0cb");
require("9c8767e6f53881a1");
require("d3e4c707715716ae");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), ModalStackProvider = _createOptionalContext_createOptionalContext[0], useModalStackContext = _createOptionalContext_createOptionalContext[1];
function ModalStack(param) {
    var children = param.children;
    var _React_useState = (0, _slicedToArray._)(React.useState([]), 2), stack = _React_useState[0], setStack = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(getDefaultZIndex.getDefaultZIndex("modal")), 2), maxZIndex = _React_useState1[0], setMaxZIndex = _React_useState1[1];
    return /* @__PURE__ */ jsxRuntime.jsx(ModalStackProvider, {
        value: {
            stack,
            addModal: function(id, zIndex) {
                setStack(function(current) {
                    return (0, _toConsumableArray._)(/* @__PURE__ */ new Set((0, _toConsumableArray._)(current).concat([
                        id
                    ])));
                });
                setMaxZIndex(function(current) {
                    return typeof zIndex === "number" && typeof current === "number" ? Math.max(current, zIndex) : current;
                });
            },
            removeModal: function(id) {
                return setStack(function(current) {
                    return current.filter(function(currentId) {
                        return currentId !== id;
                    });
                });
            },
            getZIndex: function(id) {
                return `calc(${maxZIndex} + ${stack.indexOf(id)} + 1)`;
            },
            currentId: stack[stack.length - 1],
            maxZIndex
        },
        children
    });
}
ModalStack.displayName = "@mantine/core/ModalStack";
exports.ModalStack = ModalStack;
exports.useModalStackContext = useModalStackContext; //# sourceMappingURL=ModalStack.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","53c8211f1c757181":"iKGFf","91a267bb4beb4f15":"9MtAM","3c2903bdb2ba7604":"7cMAR","6f53e8d92842db41":"4gavl","90ccb37deb8212f7":"9HEEB","717ea14ef89cf07c":"8QFOC","b9b831d6cf1db3c6":"2FdJg","5bc492de2fbc413":"6AMGA","81c46e51f6e0fc9e":"erSvz","78d8485d3ab2bb3d":"kqQOF","b53e556661f5f0cb":"8YP4O","9c8767e6f53881a1":"gkGXc","d3e4c707715716ae":"2onWA"}],"8Cbau":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1cdd3027d64e663f");
require("e35f483c25ad4630");
require("8629b937356896bb");
require("dd398a786fcceade");
require("30adc731fffed1ca");
require("fdf525fcb6e2119e");
require("975711ea20322214");
require("d6c11c190729329c");
var useProps = require("7f521c301175cf15");
require("b5310e07e8016d4");
require("1916c0c543b8dd4");
var factory = require("7a31375db8cedf6e");
require("4d03b6d262d748f8");
require("e2a3c70414f9ef37");
require("33c4f40727cde6dd");
require("8f6ef199b4f022ef");
require("bc2b24f370e156f0");
require("969b58fee710263f");
require("5a8aeaef316a2127");
var ModalBaseTitle = require("95aa1bc96659315d");
var Modal_context = require("82feb777cb44e0b7");
var Modal_module = require("3102615cb3b54609");
var defaultProps = {};
var ModalTitle = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ModalTitle", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Modal_context.useModalContext();
    return /* @__PURE__ */ jsxRuntime.jsx(ModalBaseTitle.ModalBaseTitle, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("title", {
        classNames,
        style,
        styles,
        className
    }), others));
});
ModalTitle.classes = Modal_module;
ModalTitle.displayName = "@mantine/core/ModalTitle";
exports.ModalTitle = ModalTitle; //# sourceMappingURL=ModalTitle.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","1cdd3027d64e663f":"iKGFf","e35f483c25ad4630":"9MtAM","8629b937356896bb":"9HEEB","dd398a786fcceade":"8QFOC","30adc731fffed1ca":"2FdJg","fdf525fcb6e2119e":"6AMGA","975711ea20322214":"erSvz","d6c11c190729329c":"kqQOF","7f521c301175cf15":"iivvn","b5310e07e8016d4":"8YP4O","1916c0c543b8dd4":"gkGXc","7a31375db8cedf6e":"guLFz","4d03b6d262d748f8":"2onWA","e2a3c70414f9ef37":"PGvLq","33c4f40727cde6dd":"8i8nh","8f6ef199b4f022ef":"ifiLz","bc2b24f370e156f0":"8qmr0","969b58fee710263f":"fsdDM","5a8aeaef316a2127":"fj3f7","95aa1bc96659315d":"5DnfR","82feb777cb44e0b7":"icVkk","3102615cb3b54609":"kEtle"}],"1NR44":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("3ee930b9bebecca9");
function useModalsStack(modals) {
    var initialState = modals.reduce(function(acc, modal) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
            [modal]: false
        });
    }, {});
    var _React_useState = (0, _slicedToArray._)(React.useState(initialState), 2), state = _React_useState[0], setState = _React_useState[1];
    var open = React.useCallback(function(modal) {
        setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                [modal]: true
            });
        });
    }, []);
    var close = React.useCallback(function(modal) {
        return setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                [modal]: false
            });
        });
    }, []);
    var toggle = React.useCallback(function(modal) {
        return setState(function(current) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                [modal]: !current[modal]
            });
        });
    }, []);
    var closeAll = React.useCallback(function() {
        return setState(initialState);
    }, []);
    var register = React.useCallback(function(modal) {
        return {
            opened: state[modal],
            onClose: function() {
                return close(modal);
            },
            stackId: modal
        };
    }, [
        state
    ]);
    return {
        state,
        open,
        close,
        closeAll,
        toggle,
        register
    };
}
var useDrawersStack = useModalsStack;
exports.useDrawersStack = useDrawersStack;
exports.useModalsStack = useModalsStack; //# sourceMappingURL=use-modals-stack.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","3ee930b9bebecca9":"9MtAM"}],"gXL0L":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("3882d43e35a48129");
var React = require("ed55bdddd7d03ccb");
var hooks = require("684bff3a5e72253d");
require("7732968a0f01627e");
var useResolvedStylesApi = require("c7065338fcb1245f");
var useStyles = require("dc436bdf336143b0");
require("b26cbd97e5ab7941");
require("c19255f9db1ebf15");
require("d0a845fcbb986d3d");
require("3552b4712af47063");
var useProps = require("5028f990fbae56de");
require("54bfa1bc9bfe54cf");
var extractStyleProps = require("5d2cc07adc031dd9");
require("e3f6fe332365d30b");
var factory = require("665566fdb7079826");
require("850bd41491bf829d");
var getParsedComboboxData = require("f22575d8f561e31f");
var getOptionsLockup = require("248a998a83b80da5");
require("92452aa7cfb63305");
var Combobox = require("6bd068bf5385a509");
require("c3284003506d5b18");
require("39c549786927a2d0");
require("4f07cbe2e93b39be");
require("a7b3d4579cbd1960");
require("6a9e534b9db6faf9");
require("1c8003e25ece282");
require("81545b622c25769b");
require("1e0b32beb752730a");
require("830b6f4f29af8df3");
require("fc5b815e70934939");
require("b35d220a5205d6aa");
require("e7529fadc36fef69");
require("73598ee2b686d2e1");
var OptionsDropdown = require("3c8032235b08560f");
var useCombobox = require("b8e95b236eb01cbe");
require("ded45c71429316d5");
var InputBase = require("d576ed1270b7052b");
var Pill = require("7cd2fd350038da5b");
require("93078ce5d31862c6");
var PillsInput = require("52629af265d32f65");
require("e6c14ea0f97f716a");
var filterPickedValues = require("8cb1b2f9b17a783");
var defaultProps = {
    maxValues: Infinity,
    withCheckIcon: true,
    checkIconPosition: "left",
    hiddenInputValuesDivider: ","
};
var MultiSelect = factory.factory(function(_props, ref) {
    var props = useProps.useProps("MultiSelect", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, size = props.size, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, onKeyDown = props.onKeyDown, variant = props.variant, data = props.data, dropdownOpened = props.dropdownOpened, defaultDropdownOpened = props.defaultDropdownOpened, onDropdownOpen = props.onDropdownOpen, onDropdownClose = props.onDropdownClose, selectFirstOptionOnChange = props.selectFirstOptionOnChange, onOptionSubmit = props.onOptionSubmit, comboboxProps = props.comboboxProps, filter = props.filter, limit = props.limit, withScrollArea = props.withScrollArea, maxDropdownHeight = props.maxDropdownHeight, searchValue = props.searchValue, defaultSearchValue = props.defaultSearchValue, onSearchChange = props.onSearchChange, readOnly = props.readOnly, disabled = props.disabled, onFocus = props.onFocus, onBlur = props.onBlur, onPaste = props.onPaste, radius = props.radius, rightSection = props.rightSection, rightSectionWidth = props.rightSectionWidth, rightSectionPointerEvents = props.rightSectionPointerEvents, rightSectionProps = props.rightSectionProps, leftSection = props.leftSection, leftSectionWidth = props.leftSectionWidth, leftSectionPointerEvents = props.leftSectionPointerEvents, leftSectionProps = props.leftSectionProps, inputContainer = props.inputContainer, inputWrapperOrder = props.inputWrapperOrder, withAsterisk = props.withAsterisk, labelProps = props.labelProps, descriptionProps = props.descriptionProps, errorProps = props.errorProps, wrapperProps = props.wrapperProps, description = props.description, label = props.label, error = props.error, maxValues = props.maxValues, searchable = props.searchable, nothingFoundMessage = props.nothingFoundMessage, withCheckIcon = props.withCheckIcon, checkIconPosition = props.checkIconPosition, hidePickedOptions = props.hidePickedOptions, withErrorStyles = props.withErrorStyles, name = props.name, form = props.form, id = props.id, clearable = props.clearable, clearButtonProps = props.clearButtonProps, hiddenInputProps = props.hiddenInputProps, placeholder = props.placeholder, hiddenInputValuesDivider = props.hiddenInputValuesDivider, required = props.required, mod = props.mod, renderOption = props.renderOption, onRemove = props.onRemove, onClear = props.onClear, scrollAreaProps = props.scrollAreaProps, chevronColor = props.chevronColor, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "value",
        "defaultValue",
        "onChange",
        "onKeyDown",
        "variant",
        "data",
        "dropdownOpened",
        "defaultDropdownOpened",
        "onDropdownOpen",
        "onDropdownClose",
        "selectFirstOptionOnChange",
        "onOptionSubmit",
        "comboboxProps",
        "filter",
        "limit",
        "withScrollArea",
        "maxDropdownHeight",
        "searchValue",
        "defaultSearchValue",
        "onSearchChange",
        "readOnly",
        "disabled",
        "onFocus",
        "onBlur",
        "onPaste",
        "radius",
        "rightSection",
        "rightSectionWidth",
        "rightSectionPointerEvents",
        "rightSectionProps",
        "leftSection",
        "leftSectionWidth",
        "leftSectionPointerEvents",
        "leftSectionProps",
        "inputContainer",
        "inputWrapperOrder",
        "withAsterisk",
        "labelProps",
        "descriptionProps",
        "errorProps",
        "wrapperProps",
        "description",
        "label",
        "error",
        "maxValues",
        "searchable",
        "nothingFoundMessage",
        "withCheckIcon",
        "checkIconPosition",
        "hidePickedOptions",
        "withErrorStyles",
        "name",
        "form",
        "id",
        "clearable",
        "clearButtonProps",
        "hiddenInputProps",
        "placeholder",
        "hiddenInputValuesDivider",
        "required",
        "mod",
        "renderOption",
        "onRemove",
        "onClear",
        "scrollAreaProps",
        "chevronColor"
    ]);
    var _id = hooks.useId(id);
    var parsedData = getParsedComboboxData.getParsedComboboxData(data);
    var optionsLockup = getOptionsLockup.getOptionsLockup(parsedData);
    var combobox = useCombobox.useCombobox({
        opened: dropdownOpened,
        defaultOpened: defaultDropdownOpened,
        onDropdownOpen,
        onDropdownClose: function() {
            onDropdownClose === null || onDropdownClose === void 0 ? void 0 : onDropdownClose();
            combobox.resetSelectedOption();
        }
    });
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, _extractStyleProps_extractStyleProps_rest = _extractStyleProps_extractStyleProps.rest, type = _extractStyleProps_extractStyleProps_rest.type, autoComplete = _extractStyleProps_extractStyleProps_rest.autoComplete, rest = (0, _objectWithoutProperties._)(_extractStyleProps_extractStyleProps.rest, [
        "type",
        "autoComplete"
    ]);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: [],
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var _hooks_useUncontrolled1 = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: searchValue,
        defaultValue: defaultSearchValue,
        finalValue: "",
        onChange: onSearchChange
    }), 2), _searchValue = _hooks_useUncontrolled1[0], setSearchValue = _hooks_useUncontrolled1[1];
    var handleSearchChange = function(value2) {
        setSearchValue(value2);
        combobox.resetSelectedOption();
    };
    var getStyles = useStyles.useStyles({
        name: "MultiSelect",
        classes: {},
        props,
        classNames,
        styles,
        unstyled
    });
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        props,
        styles,
        classNames
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    var handleInputKeydown = function(event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (event.key === " " && !searchable) {
            event.preventDefault();
            combobox.toggleDropdown();
        }
        if (event.key === "Backspace" && _searchValue.length === 0 && _value.length > 0) {
            onRemove === null || onRemove === void 0 ? void 0 : onRemove(_value[_value.length - 1]);
            setValue(_value.slice(0, _value.length - 1));
        }
    };
    var values = _value.map(function(item, index) {
        var _optionsLockup_item, _optionsLockup_item1;
        return /* @__PURE__ */ jsxRuntime.jsx(Pill.Pill, (0, _objectSpreadProps._)((0, _objectSpread._)({
            withRemoveButton: !readOnly && !((_optionsLockup_item = optionsLockup[item]) === null || _optionsLockup_item === void 0 ? void 0 : _optionsLockup_item.disabled),
            onRemove: function() {
                setValue(_value.filter(function(i) {
                    return item !== i;
                }));
                onRemove === null || onRemove === void 0 ? void 0 : onRemove(item);
            },
            unstyled,
            disabled
        }, getStyles("pill")), {
            children: ((_optionsLockup_item1 = optionsLockup[item]) === null || _optionsLockup_item1 === void 0 ? void 0 : _optionsLockup_item1.label) || item
        }), `${item}-${index}`);
    });
    React.useEffect(function() {
        if (selectFirstOptionOnChange) combobox.selectFirstOption();
    }, [
        selectFirstOptionOnChange,
        _searchValue
    ]);
    var clearButton = /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.ClearButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, clearButtonProps), {
        onClear: function() {
            onClear === null || onClear === void 0 ? void 0 : onClear();
            setValue([]);
            handleSearchChange("");
        }
    }));
    var filteredData = filterPickedValues.filterPickedValues({
        data: parsedData,
        value: _value
    });
    var _clearable = clearable && _value.length > 0 && !disabled && !readOnly;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsxs(Combobox.Combobox, (0, _objectSpreadProps._)((0, _objectSpread._)({
                store: combobox,
                classNames: resolvedClassNames,
                styles: resolvedStyles,
                unstyled,
                size,
                readOnly,
                __staticSelector: "MultiSelect",
                onOptionSubmit: function(val) {
                    onOptionSubmit === null || onOptionSubmit === void 0 ? void 0 : onOptionSubmit(val);
                    handleSearchChange("");
                    combobox.updateSelectedOptionIndex("selected");
                    if (_value.includes(optionsLockup[val].value)) {
                        setValue(_value.filter(function(v) {
                            return v !== optionsLockup[val].value;
                        }));
                        onRemove === null || onRemove === void 0 ? void 0 : onRemove(optionsLockup[val].value);
                    } else if (_value.length < maxValues) setValue((0, _toConsumableArray._)(_value).concat([
                        optionsLockup[val].value
                    ]));
                }
            }, comboboxProps), {
                children: [
                    /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.DropdownTarget, {
                        children: /* @__PURE__ */ jsxRuntime.jsx(PillsInput.PillsInput, (0, _objectSpreadProps._)((0, _objectSpread._)({}, styleProps), {
                            __staticSelector: "MultiSelect",
                            classNames: resolvedClassNames,
                            styles: resolvedStyles,
                            unstyled,
                            size,
                            className,
                            style,
                            variant,
                            disabled,
                            radius,
                            __defaultRightSection: /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Chevron, {
                                size,
                                error,
                                unstyled,
                                color: chevronColor
                            }),
                            __clearSection: clearButton,
                            __clearable: _clearable,
                            rightSection,
                            rightSectionPointerEvents: rightSectionPointerEvents || (clearButton ? "all" : "none"),
                            rightSectionWidth,
                            rightSectionProps,
                            leftSection,
                            leftSectionWidth,
                            leftSectionPointerEvents,
                            leftSectionProps,
                            inputContainer,
                            inputWrapperOrder,
                            withAsterisk,
                            labelProps,
                            descriptionProps,
                            errorProps,
                            wrapperProps,
                            description,
                            label,
                            error,
                            withErrorStyles,
                            __stylesApiProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                                rightSectionPointerEvents: rightSectionPointerEvents || (_clearable ? "all" : "none"),
                                multiline: true
                            }),
                            pointer: !searchable,
                            onClick: function() {
                                return searchable ? combobox.openDropdown() : combobox.toggleDropdown();
                            },
                            "data-expanded": combobox.dropdownOpened || void 0,
                            id: _id,
                            required,
                            mod,
                            children: /* @__PURE__ */ jsxRuntime.jsxs(Pill.Pill.Group, (0, _objectSpreadProps._)((0, _objectSpread._)({
                                disabled,
                                unstyled
                            }, getStyles("pillsList")), {
                                children: [
                                    values,
                                    /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.EventsTarget, {
                                        autoComplete,
                                        children: /* @__PURE__ */ jsxRuntime.jsx(PillsInput.PillsInput.Field, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
                                            ref,
                                            id: _id,
                                            placeholder,
                                            type: !searchable && !placeholder ? "hidden" : "visible"
                                        }), getStyles("inputField")), {
                                            unstyled,
                                            onFocus: function(event) {
                                                onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                                                searchable && combobox.openDropdown();
                                            },
                                            onBlur: function(event) {
                                                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                                                combobox.closeDropdown();
                                                handleSearchChange("");
                                            },
                                            onKeyDown: handleInputKeydown,
                                            value: _searchValue,
                                            onChange: function(event) {
                                                handleSearchChange(event.currentTarget.value);
                                                searchable && combobox.openDropdown();
                                                selectFirstOptionOnChange && combobox.selectFirstOption();
                                            },
                                            disabled,
                                            readOnly: readOnly || !searchable,
                                            pointer: !searchable
                                        }))
                                    })
                                ]
                            }))
                        }))
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(OptionsDropdown.OptionsDropdown, {
                        data: hidePickedOptions ? filteredData : parsedData,
                        hidden: readOnly || disabled,
                        filter,
                        search: _searchValue,
                        limit,
                        hiddenWhenEmpty: !nothingFoundMessage,
                        withScrollArea,
                        maxDropdownHeight,
                        filterOptions: searchable,
                        value: _value,
                        checkIconPosition,
                        withCheckIcon,
                        nothingFoundMessage,
                        unstyled,
                        labelId: label ? `${_id}-label` : void 0,
                        "aria-label": label ? void 0 : others["aria-label"],
                        renderOption,
                        scrollAreaProps
                    })
                ]
            })),
            /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.HiddenInput, (0, _objectSpread._)({
                name,
                valuesDivider: hiddenInputValuesDivider,
                value: _value,
                form,
                disabled
            }, hiddenInputProps))
        ]
    });
});
MultiSelect.classes = (0, _objectSpread._)({}, InputBase.InputBase.classes, Combobox.Combobox.classes);
MultiSelect.displayName = "@mantine/core/MultiSelect";
exports.MultiSelect = MultiSelect; //# sourceMappingURL=MultiSelect.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","3882d43e35a48129":"iKGFf","ed55bdddd7d03ccb":"9MtAM","684bff3a5e72253d":"9HEEB","7732968a0f01627e":"8QFOC","c7065338fcb1245f":"d30sL","dc436bdf336143b0":"d0sAY","b26cbd97e5ab7941":"2FdJg","c19255f9db1ebf15":"6AMGA","d0a845fcbb986d3d":"erSvz","3552b4712af47063":"kqQOF","5028f990fbae56de":"iivvn","54bfa1bc9bfe54cf":"8YP4O","5d2cc07adc031dd9":"6L93n","e3f6fe332365d30b":"gkGXc","665566fdb7079826":"guLFz","850bd41491bf829d":"2onWA","f22575d8f561e31f":"71QDZ","248a998a83b80da5":"jSlFr","92452aa7cfb63305":"6nIYy","6bd068bf5385a509":"d1kVk","c3284003506d5b18":"4ROIf","39c549786927a2d0":"alBok","4f07cbe2e93b39be":"h5QT5","a7b3d4579cbd1960":"8rZez","6a9e534b9db6faf9":"74J2w","1c8003e25ece282":"iyoTe","81545b622c25769b":"3ZaWl","1e0b32beb752730a":"9a8Lj","830b6f4f29af8df3":"8omXP","fc5b815e70934939":"ceCGy","b35d220a5205d6aa":"1dzCw","e7529fadc36fef69":"4Z9pV","73598ee2b686d2e1":"8RMJf","3c8032235b08560f":"17zEV","b8e95b236eb01cbe":"W6tOq","ded45c71429316d5":"etJ5t","d576ed1270b7052b":"jbA6w","7cd2fd350038da5b":"liYbF","93078ce5d31862c6":"gMUmS","52629af265d32f65":"2ObFu","e6c14ea0f97f716a":"5QihN","8cb1b2f9b17a783":"4Kab5"}],"liYbF":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("10a83f64e9d9ce8d");
require("77fc7fb59812cfa1");
var getSize = require("acada0486574d5ad");
require("2286b3ef2aea8f44");
var createVarsResolver = require("1e3c3111cfefd02e");
require("e73f582c1dc13c49");
require("24e97be61786205d");
require("168adbaa1597edfe");
require("aa2df1921b7d9bcf");
require("b2a50700ce5a4949");
var useProps = require("8be82a271e34e135");
require("9ff090c314b20165");
var useStyles = require("7b70f6b1cdb7a531");
var Box = require("a347451a930e397");
var factory = require("87d8ac7aaed17eb1");
require("66c1e89d55ccb6ef");
require("c7c6e7a78f655105");
var CloseButton = require("46f6fe321f8b4566");
var PillsInput_context = require("ac5a6401e7453768");
var PillGroup_context = require("1caa3c540e458a67");
var PillGroup = require("d4a50c1db55c62a6");
var Pill_module = require("9b98040cb1b7915d");
var defaultProps = {
    variant: "default"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param, param1) {
    var radius = param.radius, size = param1.size;
    return {
        root: {
            "--pill-fz": getSize.getSize(size, "pill-fz"),
            "--pill-height": getSize.getSize(size, "pill-height"),
            "--pill-radius": radius === void 0 ? void 0 : getSize.getRadius(radius)
        }
    };
});
var Pill = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Pill", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, variant = props.variant, children = props.children, withRemoveButton = props.withRemoveButton, onRemove = props.onRemove, removeButtonProps = props.removeButtonProps, radius = props.radius, size = props.size, disabled = props.disabled, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "variant",
        "children",
        "withRemoveButton",
        "onRemove",
        "removeButtonProps",
        "radius",
        "size",
        "disabled",
        "mod"
    ]);
    var ctx = PillGroup_context.usePillGroupContext();
    var pillsInputCtx = PillsInput_context.usePillsInputContext();
    var _size = size || (ctx === null || ctx === void 0 ? void 0 : ctx.size) || void 0;
    var _variant = (pillsInputCtx === null || pillsInputCtx === void 0 ? void 0 : pillsInputCtx.variant) === "filled" ? "contrast" : variant || "default";
    var getStyles = useStyles.useStyles({
        name: "Pill",
        classes: Pill_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        stylesCtx: {
            size: _size
        }
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "span",
        ref,
        variant: _variant,
        size: _size
    }, getStyles("root", {
        variant: _variant
    })), {
        mod: [
            {
                "with-remove": withRemoveButton && !disabled,
                disabled: disabled || (ctx === null || ctx === void 0 ? void 0 : ctx.disabled)
            },
            mod
        ]
    }), others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label")), {
                children
            })),
            withRemoveButton && /* @__PURE__ */ jsxRuntime.jsx(CloseButton.CloseButton, (0, _objectSpreadProps._)((0, _objectSpread._)({
                variant: "transparent",
                radius,
                tabIndex: -1,
                "aria-hidden": true,
                unstyled
            }, removeButtonProps, getStyles("remove", {
                className: removeButtonProps === null || removeButtonProps === void 0 ? void 0 : removeButtonProps.className,
                style: removeButtonProps === null || removeButtonProps === void 0 ? void 0 : removeButtonProps.style
            })), {
                onMouseDown: function(event) {
                    var _removeButtonProps_onMouseDown;
                    event.preventDefault();
                    event.stopPropagation();
                    removeButtonProps === null || removeButtonProps === void 0 ? void 0 : (_removeButtonProps_onMouseDown = removeButtonProps.onMouseDown) === null || _removeButtonProps_onMouseDown === void 0 ? void 0 : _removeButtonProps_onMouseDown.call(removeButtonProps, event);
                },
                onClick: function(event) {
                    var _removeButtonProps_onClick;
                    event.stopPropagation();
                    onRemove === null || onRemove === void 0 ? void 0 : onRemove();
                    removeButtonProps === null || removeButtonProps === void 0 ? void 0 : (_removeButtonProps_onClick = removeButtonProps.onClick) === null || _removeButtonProps_onClick === void 0 ? void 0 : _removeButtonProps_onClick.call(removeButtonProps, event);
                }
            }))
        ]
    }));
});
Pill.classes = Pill_module;
Pill.displayName = "@mantine/core/Pill";
Pill.Group = PillGroup.PillGroup;
exports.Pill = Pill; //# sourceMappingURL=Pill.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","10a83f64e9d9ce8d":"iKGFf","77fc7fb59812cfa1":"9MtAM","acada0486574d5ad":"kEFEY","2286b3ef2aea8f44":"9HEEB","1e3c3111cfefd02e":"hIQE6","e73f582c1dc13c49":"8QFOC","24e97be61786205d":"2FdJg","168adbaa1597edfe":"6AMGA","aa2df1921b7d9bcf":"erSvz","b2a50700ce5a4949":"kqQOF","8be82a271e34e135":"iivvn","9ff090c314b20165":"8YP4O","7b70f6b1cdb7a531":"d0sAY","a347451a930e397":"gkGXc","87d8ac7aaed17eb1":"guLFz","66c1e89d55ccb6ef":"2onWA","c7c6e7a78f655105":"h6AYi","46f6fe321f8b4566":"4ZuRG","ac5a6401e7453768":"gK5sK","1caa3c540e458a67":"kWfDi","d4a50c1db55c62a6":"gMUmS","9b98040cb1b7915d":"6N6wU"}],"gK5sK":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("b4476216fd6caf67");
require("70567a3f76b1f12b");
var createOptionalContext = require("219cc936b416f9fd");
require("37ea8f433d25dba6");
require("f84874eb3fbc859d");
require("a1289e85d0e6831");
require("fbfc49b82f83895d");
require("151b8c2e93b3656c");
require("5bd3a97d99dd8e6f");
require("5b9f899ddfa06923");
require("e1a7901b90c142fb");
require("985a61b25c2daa08");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), PillsInputProvider = _createOptionalContext_createOptionalContext[0], usePillsInputContext = _createOptionalContext_createOptionalContext[1];
exports.PillsInputProvider = PillsInputProvider;
exports.usePillsInputContext = usePillsInputContext; //# sourceMappingURL=PillsInput.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","b4476216fd6caf67":"9MtAM","70567a3f76b1f12b":"iKGFf","219cc936b416f9fd":"7cMAR","37ea8f433d25dba6":"9HEEB","f84874eb3fbc859d":"8QFOC","a1289e85d0e6831":"2FdJg","fbfc49b82f83895d":"6AMGA","151b8c2e93b3656c":"erSvz","5bd3a97d99dd8e6f":"kqQOF","5b9f899ddfa06923":"8YP4O","e1a7901b90c142fb":"gkGXc","985a61b25c2daa08":"2onWA"}],"kWfDi":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("becfb3d291143ba5");
require("259d0628f9579c00");
var createOptionalContext = require("ba6dbdd1d67ed96e");
require("6248f0c306fc95aa");
require("f9ce5dcf8649e289");
require("d1cdf062c968199b");
require("28a7bfd1ae036083");
require("66780de9fd6922");
require("ec98fb1a0b85006f");
require("ef281847fbb02161");
require("a631a94375371765");
require("b97d4308f457b082");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), PillGroupProvider = _createOptionalContext_createOptionalContext[0], usePillGroupContext = _createOptionalContext_createOptionalContext[1];
exports.PillGroupProvider = PillGroupProvider;
exports.usePillGroupContext = usePillGroupContext; //# sourceMappingURL=PillGroup.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","becfb3d291143ba5":"9MtAM","259d0628f9579c00":"iKGFf","ba6dbdd1d67ed96e":"7cMAR","6248f0c306fc95aa":"9HEEB","f9ce5dcf8649e289":"8QFOC","d1cdf062c968199b":"2FdJg","28a7bfd1ae036083":"6AMGA","66780de9fd6922":"erSvz","ec98fb1a0b85006f":"kqQOF","ef281847fbb02161":"8YP4O","a631a94375371765":"gkGXc","b97d4308f457b082":"2onWA"}],"gMUmS":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("5c5783633180d64");
require("ee4e173bbdd90a8d");
var getSize = require("2dba4769253f1197");
require("584fb1149f6c49d4");
var createVarsResolver = require("b0a1d0af7ad54290");
require("72c5872953384116");
require("6198dc49106e1c3c");
require("911348011ee95736");
require("50f59c2106342dd3");
require("1695193b239188f0");
var useProps = require("dbe08d852c586f1b");
require("8c28f0cb63cda731");
var useStyles = require("48f6e3b6a1e0d326");
var Box = require("3cbce79569993813");
var factory = require("2dd58865fb181a27");
require("b51a88bf58f8a088");
var PillsInput_context = require("caea1b0afa52e92f");
var PillGroup_context = require("401cbd63e405f824");
var Pill_module = require("2834b2f2eef50175");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param, param1) {
    var gap = param.gap, size = param1.size;
    return {
        group: {
            "--pg-gap": gap !== void 0 ? getSize.getSize(gap) : getSize.getSize(size, "pg-gap")
        }
    };
});
var PillGroup = factory.factory(function(_props, ref) {
    var props = useProps.useProps("PillGroup", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, size = props.size, disabled = props.disabled, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "disabled"
    ]);
    var pillsInputCtx = PillsInput_context.usePillsInputContext();
    var _size = (pillsInputCtx === null || pillsInputCtx === void 0 ? void 0 : pillsInputCtx.size) || size || void 0;
    var getStyles = useStyles.useStyles({
        name: "PillGroup",
        classes: Pill_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        stylesCtx: {
            size: _size
        },
        rootSelector: "group"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(PillGroup_context.PillGroupProvider, {
        value: {
            size: _size,
            disabled
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
            ref,
            size: _size
        }, getStyles("group"), others))
    });
});
PillGroup.classes = Pill_module;
PillGroup.displayName = "@mantine/core/PillGroup";
exports.PillGroup = PillGroup; //# sourceMappingURL=PillGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","5c5783633180d64":"iKGFf","ee4e173bbdd90a8d":"9MtAM","2dba4769253f1197":"kEFEY","584fb1149f6c49d4":"9HEEB","b0a1d0af7ad54290":"hIQE6","72c5872953384116":"8QFOC","6198dc49106e1c3c":"2FdJg","911348011ee95736":"6AMGA","50f59c2106342dd3":"erSvz","1695193b239188f0":"kqQOF","dbe08d852c586f1b":"iivvn","8c28f0cb63cda731":"8YP4O","48f6e3b6a1e0d326":"d0sAY","3cbce79569993813":"gkGXc","2dd58865fb181a27":"guLFz","b51a88bf58f8a088":"2onWA","caea1b0afa52e92f":"gK5sK","401cbd63e405f824":"kWfDi","2834b2f2eef50175":"6N6wU"}],"6N6wU":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_7cda1cd6",
    "root--default": "m_44da308b",
    "root--contrast": "m_e3a01f8",
    "label": "m_1e0e6180",
    "remove": "m_ae386778",
    "group": "m_1dcfd90b"
};
module.exports = classes; //# sourceMappingURL=Pill.module.css.cjs.map

},{}],"2ObFu":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("43ec6efeb6355676");
var React = require("e095a732f2f39812");
require("42a84eda5f7f49ce");
require("b942b2b910e32560");
require("10bb60b16218fc49");
require("803b8ddaf5942026");
require("f160dd891640c4d3");
require("dfda45c0c87996ca");
var useProps = require("ef36e123cb51d6fa");
require("7b44b4f1c81b7e62");
require("daee537cb020acab");
var factory = require("fdd148948399d807");
require("5a3ffefaa93fcc86");
var InputBase = require("9a6d860216d447e2");
var PillsInput_context = require("22c1c4315ed0213c");
var PillsInputField = require("fe1ebb4e5bbdc946");
var defaultProps = {};
var PillsInput = factory.factory(function(_props, ref) {
    var props = useProps.useProps("PillsInput", defaultProps, _props);
    var children = props.children, onMouseDown = props.onMouseDown, onClick = props.onClick, size = props.size, disabled = props.disabled, __staticSelector = props.__staticSelector, error = props.error, variant = props.variant, others = (0, _objectWithoutProperties._)(props, [
        "children",
        "onMouseDown",
        "onClick",
        "size",
        "disabled",
        "__staticSelector",
        "error",
        "variant"
    ]);
    var fieldRef = React.useRef(null);
    return /* @__PURE__ */ jsxRuntime.jsx(PillsInput_context.PillsInputProvider, {
        value: {
            fieldRef,
            size,
            disabled,
            hasError: !!error,
            variant
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpreadProps._)((0, _objectSpread._)({
            size,
            error,
            variant,
            component: "div",
            ref,
            onMouseDown: function(event) {
                var _fieldRef_current;
                event.preventDefault();
                onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
                (_fieldRef_current = fieldRef.current) === null || _fieldRef_current === void 0 ? void 0 : _fieldRef_current.focus();
            },
            onClick: function(event) {
                event.preventDefault();
                var fieldset = event.currentTarget.closest("fieldset");
                if (!(fieldset === null || fieldset === void 0 ? void 0 : fieldset.disabled)) {
                    var _fieldRef_current;
                    (_fieldRef_current = fieldRef.current) === null || _fieldRef_current === void 0 ? void 0 : _fieldRef_current.focus();
                    onClick === null || onClick === void 0 ? void 0 : onClick(event);
                }
            }
        }, others), {
            multiline: true,
            disabled,
            __staticSelector: __staticSelector || "PillsInput",
            withAria: false,
            children
        }))
    });
});
PillsInput.displayName = "@mantine/core/PillsInput";
PillsInput.Field = PillsInputField.PillsInputField;
exports.PillsInput = PillsInput; //# sourceMappingURL=PillsInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","43ec6efeb6355676":"iKGFf","e095a732f2f39812":"9MtAM","42a84eda5f7f49ce":"9HEEB","b942b2b910e32560":"8QFOC","10bb60b16218fc49":"2FdJg","803b8ddaf5942026":"6AMGA","f160dd891640c4d3":"erSvz","dfda45c0c87996ca":"kqQOF","ef36e123cb51d6fa":"iivvn","7b44b4f1c81b7e62":"8YP4O","daee537cb020acab":"gkGXc","fdd148948399d807":"guLFz","5a3ffefaa93fcc86":"2onWA","9a6d860216d447e2":"jbA6w","22c1c4315ed0213c":"gK5sK","fe1ebb4e5bbdc946":"5QihN"}],"5QihN":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("7a320a213966deb3");
var hooks = require("e2c4e2d0230a1a00");
require("b9338a5133f78693");
require("5e77698efab8ea14");
require("f1ab71f819a4ebe3");
require("7f7c6c39b486a091");
require("d7085d7450432f42");
require("745fe72a737c17ac");
var useProps = require("5ddb995de5202d03");
require("da8667417b0c24f8");
var useStyles = require("b0c7a0eec41aebf3");
var Box = require("d536854037c5d882");
var factory = require("38329ecce0a7f8db");
require("fb2ec7dc74b6ac67");
require("e972f08157f00dde");
require("4570953b11e00611");
require("f352b90b9cd388e2");
require("5b18c14f7b2a5c0d");
require("c041ac85e4b175ea");
require("d289cdbcadef36e6");
require("4fb2f24ad940b3");
var InputWrapper_context = require("8a1d932d2712644e");
var PillsInput_context = require("9fb28d212598dcab");
var PillsInput_module = require("5605659eed3d381");
var defaultProps = {
    type: "visible"
};
var PillsInputField = factory.factory(function(_props, ref) {
    var props = useProps.useProps("PillsInputField", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, type = props.type, disabled = props.disabled, id = props.id, pointer = props.pointer, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "type",
        "disabled",
        "id",
        "pointer",
        "mod"
    ]);
    var ctx = PillsInput_context.usePillsInputContext();
    var inputWrapperCtx = InputWrapper_context.useInputWrapperContext();
    var getStyles = useStyles.useStyles({
        name: "PillsInputField",
        classes: PillsInput_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "field"
    });
    var _disabled = disabled || (ctx === null || ctx === void 0 ? void 0 : ctx.disabled);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "input",
        ref: hooks.useMergedRef(ref, ctx === null || ctx === void 0 ? void 0 : ctx.fieldRef),
        "data-type": type,
        disabled: _disabled,
        mod: [
            {
                disabled: _disabled,
                pointer
            },
            mod
        ]
    }, getStyles("field"), others), {
        id: (inputWrapperCtx === null || inputWrapperCtx === void 0 ? void 0 : inputWrapperCtx.inputId) || id,
        "aria-invalid": ctx === null || ctx === void 0 ? void 0 : ctx.hasError,
        "aria-describedby": inputWrapperCtx === null || inputWrapperCtx === void 0 ? void 0 : inputWrapperCtx.describedBy,
        type: "text",
        onMouseDown: function(event) {
            return !pointer && event.stopPropagation();
        }
    }));
});
PillsInputField.classes = PillsInput_module;
PillsInputField.displayName = "@mantine/core/PillsInputField";
exports.PillsInputField = PillsInputField; //# sourceMappingURL=PillsInputField.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","7a320a213966deb3":"iKGFf","e2c4e2d0230a1a00":"9HEEB","b9338a5133f78693":"9MtAM","5e77698efab8ea14":"8QFOC","f1ab71f819a4ebe3":"2FdJg","7f7c6c39b486a091":"6AMGA","d7085d7450432f42":"erSvz","745fe72a737c17ac":"kqQOF","5ddb995de5202d03":"iivvn","da8667417b0c24f8":"8YP4O","b0c7a0eec41aebf3":"d0sAY","d536854037c5d882":"gkGXc","38329ecce0a7f8db":"guLFz","fb2ec7dc74b6ac67":"2onWA","e972f08157f00dde":"dkUgf","4570953b11e00611":"j4uTK","f352b90b9cd388e2":"7nO1x","5b18c14f7b2a5c0d":"3Bda4","c041ac85e4b175ea":"gQBOr","d289cdbcadef36e6":"lRBdM","4fb2f24ad940b3":"hxtex","8a1d932d2712644e":"lQt5D","9fb28d212598dcab":"gK5sK","5605659eed3d381":"ezDbw"}],"ezDbw":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "field": "m_45c4369d"
};
module.exports = classes; //# sourceMappingURL=PillsInput.module.css.cjs.map

},{}],"4Kab5":[function(require,module,exports) {
"use client";
"use strict";
require("e6f82c15e3ed0e74");
require("661969e5eb0c6810");
require("e313858e4221ac94");
require("c616a6050de67874");
require("f526a432bfb73f7d");
require("8594f54f69f5847");
require("d864f5e9e8ef54b3");
require("bdf361aee5a25bea");
require("b0a59348d05bddf4");
require("7a9001708d19a5b2");
require("347a4c4889c25940");
require("2a734b171500e707");
require("7a461b92722f1951");
require("bf85610065f7b7d2");
require("ebd9c6a820e44ed3");
require("199efdd32ccaf1f9");
require("a81ad8192760014e");
require("d46687a3f758970f");
require("935f7faac2b29e");
require("ed03f76d73cf6b41");
require("314304d1de804cbd");
require("f9386f14f94ee8ec");
require("3e6cc14465c6ece9");
require("cc06a6a27333aad5");
require("46bf4b285b217019");
require("11e1e72190bf96d4");
require("153b3f665392fe21");
require("45b67ce40b2f6f65");
require("a15027a1cc35f018");
require("ea3d77a1d5469cf5");
require("a6fb545a65334d90");
require("bc719d6f17062603");
require("5561fdd6760716a7");
var isOptionsGroup = require("250968069bf2812d");
require("4fd1e18c068718eb");
function filterPickedValues(param) {
    var data = param.data, value = param.value;
    var normalizedValue = value.map(function(item) {
        return item.trim().toLowerCase();
    });
    var filtered = data.reduce(function(acc, item) {
        if (isOptionsGroup.isOptionsGroup(item)) acc.push({
            group: item.group,
            items: item.items.filter(function(option) {
                return normalizedValue.indexOf(option.value.toLowerCase().trim()) === -1;
            })
        });
        else if (normalizedValue.indexOf(item.value.toLowerCase().trim()) === -1) acc.push(item);
        return acc;
    }, []);
    return filtered;
}
exports.filterPickedValues = filterPickedValues; //# sourceMappingURL=filter-picked-values.cjs.map

},{"e6f82c15e3ed0e74":"6nIYy","661969e5eb0c6810":"d1kVk","e313858e4221ac94":"4ROIf","c616a6050de67874":"alBok","f526a432bfb73f7d":"h5QT5","8594f54f69f5847":"8rZez","d864f5e9e8ef54b3":"74J2w","bdf361aee5a25bea":"iyoTe","b0a59348d05bddf4":"3ZaWl","7a9001708d19a5b2":"9a8Lj","347a4c4889c25940":"8omXP","2a734b171500e707":"ceCGy","7a461b92722f1951":"1dzCw","bf85610065f7b7d2":"4Z9pV","ebd9c6a820e44ed3":"8RMJf","199efdd32ccaf1f9":"iKGFf","a81ad8192760014e":"8QFOC","d46687a3f758970f":"ey93w","935f7faac2b29e":"01RS9","ed03f76d73cf6b41":"9MtAM","314304d1de804cbd":"9HEEB","f9386f14f94ee8ec":"2FdJg","3e6cc14465c6ece9":"6AMGA","cc06a6a27333aad5":"erSvz","46bf4b285b217019":"kqQOF","11e1e72190bf96d4":"8YP4O","153b3f665392fe21":"gkGXc","45b67ce40b2f6f65":"2onWA","a15027a1cc35f018":"ahwnY","ea3d77a1d5469cf5":"jBkf8","a6fb545a65334d90":"jQ0Qw","bc719d6f17062603":"1sCYn","5561fdd6760716a7":"ctZfT","250968069bf2812d":"2yhqd","4fd1e18c068718eb":"etJ5t"}],"h6MVW":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f60d2b3457be0b9b");
require("a2975126e2401053");
require("57773c0ae6de5c5a");
require("4435b465df15f03b");
require("badd322245be5a40");
require("3afe97c64b2515ae");
require("5e124c1953d5d6c0");
require("93aceef3f1982119");
var useProps = require("72200750b3b7cc07");
require("3902b1866d11de7c");
require("f96cc50eef1b815d");
var factory = require("8c0350af49ecfc73");
require("d1cc7f168f2bb45d");
var getParsedComboboxData = require("ede2dc996f9951ee");
var ComboboxChevron = require("c35f984e05633e3c");
require("1f864ee308e90baa");
require("4c0aa969055750e6");
require("aa9f920a4d94b0b7");
require("1d0ec02ce7d1d9ae");
require("2836f2ca02eaffb2");
require("3b03d7a9bf52920b");
require("8ea430d515b43432");
require("5b0c46a3cce6ba0a");
require("b4d58caff84fa14f");
require("c8ee5f3dca5f5fa1");
require("2000df523f1cabbc");
require("9f541f33fd0a906b");
require("afa26617b71c78b1");
require("7323407128eade77");
require("5867f06261d9d997");
require("81c9a1e4e1656dda");
require("71622c54a0f099d3");
require("7b93856728160bfa");
require("33afdd0afc3acb83");
require("e40f1832c4911a5f");
require("d24f5a8c6822e37a");
require("5fb71ca6bebd69b7");
var InputBase = require("796aa7b39dce2c6e");
var NativeSelectOption = require("d687c6dd4beb9dc1");
var defaultProps = {
    rightSectionPointerEvents: "none"
};
var NativeSelect = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("NativeSelect", defaultProps, props), data = _useProps_useProps.data, children = _useProps_useProps.children, size = _useProps_useProps.size, error = _useProps_useProps.error, rightSection = _useProps_useProps.rightSection, unstyled = _useProps_useProps.unstyled, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "data",
        "children",
        "size",
        "error",
        "rightSection",
        "unstyled"
    ]);
    var options = getParsedComboboxData.getParsedComboboxData(data).map(function(item, index) {
        return /* @__PURE__ */ jsxRuntime.jsx(NativeSelectOption.NativeSelectOption, {
            data: item
        }, index);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "select",
        ref
    }, others), {
        __staticSelector: "NativeSelect",
        size,
        pointer: true,
        error,
        unstyled,
        rightSection: rightSection || /* @__PURE__ */ jsxRuntime.jsx(ComboboxChevron.ComboboxChevron, {
            size,
            error,
            unstyled
        }),
        children: children || options
    }));
});
NativeSelect.classes = InputBase.InputBase.classes;
NativeSelect.displayName = "@mantine/core/NativeSelect";
exports.NativeSelect = NativeSelect; //# sourceMappingURL=NativeSelect.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f60d2b3457be0b9b":"iKGFf","a2975126e2401053":"9MtAM","57773c0ae6de5c5a":"9HEEB","4435b465df15f03b":"8QFOC","badd322245be5a40":"2FdJg","3afe97c64b2515ae":"6AMGA","5e124c1953d5d6c0":"erSvz","93aceef3f1982119":"kqQOF","72200750b3b7cc07":"iivvn","3902b1866d11de7c":"8YP4O","f96cc50eef1b815d":"gkGXc","8c0350af49ecfc73":"guLFz","d1cc7f168f2bb45d":"2onWA","ede2dc996f9951ee":"71QDZ","c35f984e05633e3c":"6nIYy","1f864ee308e90baa":"d1kVk","4c0aa969055750e6":"4ROIf","aa9f920a4d94b0b7":"alBok","1d0ec02ce7d1d9ae":"h5QT5","2836f2ca02eaffb2":"8rZez","3b03d7a9bf52920b":"74J2w","8ea430d515b43432":"iyoTe","5b0c46a3cce6ba0a":"3ZaWl","b4d58caff84fa14f":"9a8Lj","c8ee5f3dca5f5fa1":"8omXP","2000df523f1cabbc":"ceCGy","9f541f33fd0a906b":"1dzCw","afa26617b71c78b1":"4Z9pV","7323407128eade77":"8RMJf","5867f06261d9d997":"ey93w","81c9a1e4e1656dda":"01RS9","71622c54a0f099d3":"ahwnY","7b93856728160bfa":"jBkf8","33afdd0afc3acb83":"jQ0Qw","e40f1832c4911a5f":"1sCYn","d24f5a8c6822e37a":"ctZfT","5fb71ca6bebd69b7":"etJ5t","796aa7b39dce2c6e":"jbA6w","d687c6dd4beb9dc1":"8neWj"}],"8neWj":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b126827a1b5ab6eb");
function isGroup(input) {
    return "group" in input;
}
function NativeSelectOption(param) {
    var data = param.data;
    if (isGroup(data)) {
        var items = data.items.map(function(item) {
            return /* @__PURE__ */ jsxRuntime.jsx(NativeSelectOption, {
                data: item
            }, item.value);
        });
        return /* @__PURE__ */ jsxRuntime.jsx("optgroup", {
            label: data.group,
            children: items
        });
    }
    var value = data.value, label = data.label, others = (0, _objectWithoutProperties._)(data, [
        "value",
        "label"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("option", (0, _objectSpreadProps._)((0, _objectSpread._)({
        value: data.value
    }, others), {
        children: data.label
    }), data.value);
}
NativeSelectOption.displayName = "@mantine/core/NativeSelectOption";
exports.NativeSelectOption = NativeSelectOption; //# sourceMappingURL=NativeSelectOption.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","b126827a1b5ab6eb":"iKGFf"}],"lTdE7":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("99c7de5e3c144d41");
var hooks = require("7bc642e26be25113");
require("59d99211717e4ecb");
var getSize = require("b9bee273002ec789");
var createVarsResolver = require("1452c9d11d06d264");
require("15e66220dc078b8e");
require("83b9fcd67ccb11be");
require("53996d18829a2fd");
require("90d5aeb5db4737c0");
require("922777b6a20bb783");
var useProps = require("4aa234cb82530638");
require("d68fa94d911938ea");
var useStyles = require("dd929410bae88c7b");
var Box = require("a783d691268ad7f");
var polymorphicFactory = require("6c78cb11ea05941");
require("633536b0bef5c823");
require("a1de95dc6e73532f");
var AccordionChevron = require("7ebfb76ef3f9c97a");
require("15a8d5d62aaac597");
require("fa3215749a10f552");
require("3d0f83d638a795d6");
var Collapse = require("dbe17249fcab659b");
var UnstyledButton = require("79f122023c5fc295");
var NavLink_module = require("7617ef44b17fa570");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var variant = param.variant, color = param.color, childrenOffset = param.childrenOffset, autoContrast = param.autoContrast;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        variant: variant || "light",
        autoContrast
    });
    return {
        root: {
            "--nl-bg": color || variant ? colors.background : void 0,
            "--nl-hover": color || variant ? colors.hover : void 0,
            "--nl-color": color || variant ? colors.color : void 0
        },
        children: {
            "--nl-offset": getSize.getSpacing(childrenOffset)
        }
    };
});
var NavLink = polymorphicFactory.polymorphicFactory(function(_props, ref) {
    var props = useProps.useProps("NavLink", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, opened = props.opened, defaultOpened = props.defaultOpened, onChange = props.onChange, children = props.children, onClick = props.onClick, active = props.active, disabled = props.disabled, leftSection = props.leftSection, rightSection = props.rightSection, label = props.label, description = props.description, disableRightSectionRotation = props.disableRightSectionRotation, noWrap = props.noWrap, childrenOffset = props.childrenOffset, onKeyDown = props.onKeyDown, autoContrast = props.autoContrast, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "opened",
        "defaultOpened",
        "onChange",
        "children",
        "onClick",
        "active",
        "disabled",
        "leftSection",
        "rightSection",
        "label",
        "description",
        "disableRightSectionRotation",
        "noWrap",
        "childrenOffset",
        "onKeyDown",
        "autoContrast",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "NavLink",
        props,
        classes: NavLink_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange
    }), 2), _opened = _hooks_useUncontrolled[0], setOpened = _hooks_useUncontrolled[1];
    var withChildren = !!children;
    var handleClick = function(event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        if (withChildren) {
            event.preventDefault();
            setOpened(!_opened);
        }
    };
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
                component: "a",
                ref,
                onClick: handleClick,
                onKeyDown: function(event) {
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
                    if (event.nativeEvent.code === "Space" && withChildren) {
                        event.preventDefault();
                        setOpened(!_opened);
                    }
                },
                unstyled,
                mod: [
                    {
                        disabled,
                        active,
                        expanded: _opened
                    },
                    mod
                ]
            }), others), {
                children: [
                    leftSection && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "span"
                    }, getStyles("section")), {
                        mod: {
                            position: "left"
                        },
                        children: leftSection
                    })),
                    /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("body")), {
                        mod: {
                            "no-wrap": noWrap
                        },
                        children: [
                            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                                component: "span"
                            }, getStyles("label")), {
                                children: label
                            })),
                            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                                component: "span",
                                mod: {
                                    active
                                }
                            }, getStyles("description")), {
                                children: description
                            }))
                        ]
                    })),
                    (withChildren || rightSection !== void 0) && /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("section")), {
                        component: "span",
                        mod: {
                            rotate: _opened && !disableRightSectionRotation,
                            position: "right"
                        },
                        children: withChildren ? rightSection !== void 0 ? rightSection : /* @__PURE__ */ jsxRuntime.jsx(AccordionChevron.AccordionChevron, (0, _objectSpread._)({}, getStyles("chevron"))) : rightSection
                    }))
                ]
            })),
            withChildren && /* @__PURE__ */ jsxRuntime.jsx(Collapse.Collapse, (0, _objectSpreadProps._)((0, _objectSpread._)({
                in: _opened
            }, getStyles("collapse")), {
                children: /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("children")), {
                    children
                }))
            }))
        ]
    });
});
NavLink.classes = NavLink_module;
NavLink.displayName = "@mantine/core/NavLink";
exports.NavLink = NavLink; //# sourceMappingURL=NavLink.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","99c7de5e3c144d41":"iKGFf","7bc642e26be25113":"9HEEB","59d99211717e4ecb":"9MtAM","b9bee273002ec789":"kEFEY","1452c9d11d06d264":"hIQE6","15e66220dc078b8e":"8QFOC","83b9fcd67ccb11be":"2FdJg","53996d18829a2fd":"6AMGA","90d5aeb5db4737c0":"erSvz","922777b6a20bb783":"kqQOF","4aa234cb82530638":"iivvn","d68fa94d911938ea":"8YP4O","dd929410bae88c7b":"d0sAY","a783d691268ad7f":"gkGXc","6c78cb11ea05941":"iYAEL","633536b0bef5c823":"2onWA","a1de95dc6e73532f":"lMDPy","7ebfb76ef3f9c97a":"01exi","15a8d5d62aaac597":"ewd1d","fa3215749a10f552":"6psP4","3d0f83d638a795d6":"HYAZd","dbe17249fcab659b":"eaAXD","79f122023c5fc295":"cArqr","7617ef44b17fa570":"bQdQ2"}],"bQdQ2":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f0824112",
    "description": "m_57492dcc",
    "section": "m_690090b5",
    "label": "m_1f6ac4c4",
    "body": "m_f07af9d2",
    "children": "m_e17b862f",
    "chevron": "m_1fd8a00b"
};
module.exports = classes; //# sourceMappingURL=NavLink.module.css.cjs.map

},{}],"4d1Xl":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("bc024f268fae7731");
require("ea38c5843d1ff703");
var getSize = require("9e2a6920e857a859");
require("2525a14527baa26d");
var createVarsResolver = require("aa181c52aa564ca6");
require("1b0ea85ac4d9df7f");
var getThemeColor = require("48c11dde6732a547");
require("b2fdc8ddbc8d4b01");
require("f171ea953eceeda5");
require("e856608ad23e023d");
require("d2c66e4ab3e5e013");
var useProps = require("35ab2fcf00c35e37");
require("42f2e05d1b2ed742");
var useStyles = require("6870497777ba8713");
var Box = require("745d9bd03b685160");
var factory = require("43d45e10279af545");
require("6bc7d7a27cafcab5");
require("12cc521728b06fc1");
var CloseButton = require("6194fb77e33e1d1");
var Loader = require("6243fc0241b139a8");
var Notification_module = require("a1cdd93d116e3f");
var defaultProps = {
    withCloseButton: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color;
    return {
        root: {
            "--notification-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--notification-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
        }
    };
});
var Notification = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Notification", defaultProps, _props);
    var className = props.className, color = props.color, radius = props.radius, loading = props.loading, withCloseButton = props.withCloseButton, withBorder = props.withBorder, title = props.title, icon = props.icon, children = props.children, onClose = props.onClose, closeButtonProps = props.closeButtonProps, classNames = props.classNames, style = props.style, styles = props.styles, unstyled = props.unstyled, variant = props.variant, vars = props.vars, mod = props.mod, loaderProps = props.loaderProps, role = props.role, others = (0, _objectWithoutProperties._)(props, [
        "className",
        "color",
        "radius",
        "loading",
        "withCloseButton",
        "withBorder",
        "title",
        "icon",
        "children",
        "onClose",
        "closeButtonProps",
        "classNames",
        "style",
        "styles",
        "unstyled",
        "variant",
        "vars",
        "mod",
        "loaderProps",
        "role"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Notification",
        classes: Notification_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        mod: [
            {
                "data-with-icon": !!icon || loading,
                "data-with-border": withBorder
            },
            mod
        ],
        ref,
        variant,
        role: role || "alert"
    }), others), {
        children: [
            icon && !loading && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("icon")), {
                children: icon
            })),
            loading && /* @__PURE__ */ jsxRuntime.jsx(Loader.Loader, (0, _objectSpread._)({
                size: 28,
                color
            }, loaderProps, getStyles("loader"))),
            /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("body")), {
                children: [
                    title && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("title")), {
                        children: title
                    })),
                    /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("description")), {
                        mod: {
                            "data-with-title": !!title
                        },
                        children
                    }))
                ]
            })),
            withCloseButton && /* @__PURE__ */ jsxRuntime.jsx(CloseButton.CloseButton, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                iconSize: 16,
                color: "gray"
            }, closeButtonProps), {
                unstyled,
                onClick: onClose
            }), getStyles("closeButton")))
        ]
    }));
});
Notification.classes = Notification_module;
Notification.displayName = "@mantine/core/Notification";
exports.Notification = Notification; //# sourceMappingURL=Notification.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","bc024f268fae7731":"iKGFf","ea38c5843d1ff703":"9MtAM","9e2a6920e857a859":"kEFEY","2525a14527baa26d":"9HEEB","aa181c52aa564ca6":"hIQE6","1b0ea85ac4d9df7f":"8QFOC","48c11dde6732a547":"eeaIN","b2fdc8ddbc8d4b01":"2FdJg","f171ea953eceeda5":"6AMGA","e856608ad23e023d":"erSvz","d2c66e4ab3e5e013":"kqQOF","35ab2fcf00c35e37":"iivvn","42f2e05d1b2ed742":"8YP4O","6870497777ba8713":"d0sAY","745d9bd03b685160":"gkGXc","43d45e10279af545":"guLFz","6bc7d7a27cafcab5":"2onWA","12cc521728b06fc1":"h6AYi","6194fb77e33e1d1":"4ZuRG","6243fc0241b139a8":"hxcgl","a1cdd93d116e3f":"13cX1"}],"13cX1":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_a513464",
    "icon": "m_a4ceffb",
    "loader": "m_b0920b15",
    "body": "m_a49ed24",
    "title": "m_3feedf16",
    "description": "m_3d733a3a",
    "closeButton": "m_919a4d88"
};
module.exports = classes; //# sourceMappingURL=Notification.module.css.cjs.map

},{}],"eGI6W":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("45de8f7ef46501ff");
var reactNumberFormat = require("d78948a92c43bfda");
require("7aab4665823af2ef");
require("12c8ba96041ad5e4");
require("3ae685b65b4a92dd");
require("7f36e713628655c9");
require("9d390f49188b6e92");
require("ad6d2010bdd3d26e");
require("6f41db61d3dcc187");
var useProps = require("23f5fed909d0fc2c");
require("b920c2d4b3eb2bf2");
require("9da94c315cbadac2");
require("d03d5c17501ad807");
var defaultProps = {};
function NumberFormatter(_props) {
    var props = useProps.useProps("NumberFormatter", defaultProps, _props);
    var value = props.value, defaultValue = props.defaultValue, others = (0, _objectWithoutProperties._)(props, [
        "value",
        "defaultValue"
    ]);
    if (value === void 0) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(reactNumberFormat.NumericFormat, (0, _objectSpread._)({
        displayType: "text",
        value
    }, others));
}
var extendNumberFormatter = function(c) {
    return c;
};
NumberFormatter.extend = extendNumberFormatter;
NumberFormatter.displayName = "@mantine/core/NumberFormatter";
exports.NumberFormatter = NumberFormatter; //# sourceMappingURL=NumberFormatter.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","45de8f7ef46501ff":"iKGFf","d78948a92c43bfda":"iqzVA","7aab4665823af2ef":"9MtAM","12c8ba96041ad5e4":"9HEEB","3ae685b65b4a92dd":"8QFOC","7f36e713628655c9":"2FdJg","9d390f49188b6e92":"6AMGA","ad6d2010bdd3d26e":"erSvz","6f41db61d3dcc187":"kqQOF","23f5fed909d0fc2c":"iivvn","b920c2d4b3eb2bf2":"8YP4O","9da94c315cbadac2":"gkGXc","d03d5c17501ad807":"2onWA"}],"iqzVA":[function(require,module,exports) {
/**
 * react-number-format - 5.4.3
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2024 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFormatBase", function() {
    return NumberFormatBase;
});
parcelHelpers.export(exports, "NumericFormat", function() {
    return NumericFormat;
});
parcelHelpers.export(exports, "PatternFormat", function() {
    return PatternFormat;
});
parcelHelpers.export(exports, "getNumericCaretBoundary", function() {
    return getCaretBoundary;
});
parcelHelpers.export(exports, "getPatternCaretBoundary", function() {
    return getCaretBoundary$1;
});
parcelHelpers.export(exports, "numericFormatter", function() {
    return format;
});
parcelHelpers.export(exports, "patternFormatter", function() {
    return format$1;
});
parcelHelpers.export(exports, "removeNumericFormat", function() {
    return removeFormatting;
});
parcelHelpers.export(exports, "removePatternFormat", function() {
    return removeFormatting$1;
});
parcelHelpers.export(exports, "useNumericFormat", function() {
    return useNumericFormat;
});
parcelHelpers.export(exports, "usePatternFormat", function() {
    return usePatternFormat;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var SourceType;
(function(SourceType) {
    SourceType["event"] = "event";
    SourceType["props"] = "prop";
})(SourceType || (SourceType = {}));
// basic noop function
function noop() {}
function memoizeOnce(cb) {
    var lastArgs;
    var lastValue = undefined;
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        if (lastArgs && args.length === lastArgs.length && args.every(function(value, index) {
            return value === lastArgs[index];
        })) return lastValue;
        lastArgs = args;
        lastValue = cb.apply(void 0, args);
        return lastValue;
    };
}
function charIsNumber(char) {
    return !!(char || "").match(/\d/);
}
function isNil(val) {
    return val === null || val === undefined;
}
function isNanValue(val) {
    return typeof val === "number" && isNaN(val);
}
function isNotValidValue(val) {
    return isNil(val) || isNanValue(val) || typeof val === "number" && !isFinite(val);
}
function escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function getThousandsGroupRegex(thousandsGroupStyle) {
    switch(thousandsGroupStyle){
        case "lakh":
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case "wan":
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case "thousand":
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, "$1" + thousandSeparator);
}
function usePersistentCallback(cb) {
    var callbackRef = (0, _react.useRef)(cb);
    // keep the callback ref upto date
    callbackRef.current = cb;
    /**
     * initialize a persistent callback which never changes
     * through out the component lifecycle
     */ var persistentCbRef = (0, _react.useRef)(function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return callbackRef.current.apply(callbackRef, args);
    });
    return persistentCbRef.current;
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr, allowNegative) {
    if (allowNegative === void 0) allowNegative = true;
    var hasNegation = numStr[0] === "-";
    var addNegation = hasNegation && allowNegative;
    numStr = numStr.replace("-", "");
    var parts = numStr.split(".");
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || "";
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNegation: hasNegation,
        addNegation: addNegation
    };
}
function fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === "-";
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split(".");
    var beforeDecimal = parts[0].replace(/^0+/, "") || "0";
    var afterDecimal = parts[1] || "";
    return "" + (isNegative ? "-" : "") + beforeDecimal + (afterDecimal ? "." + afterDecimal : "");
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */ function limitToScale(numStr, scale, fixedDecimalScale) {
    var str = "";
    var filler = fixedDecimalScale ? "0" : "";
    for(var i = 0; i <= scale - 1; i++)str += numStr[i] || filler;
    return str;
}
function repeat(str, count) {
    return Array(count + 1).join(str);
}
function toNumericString(num) {
    var _num = num + ""; // typecast number to string
    // store the sign and remove it from the number.
    var sign = _num[0] === "-" ? "-" : "";
    if (sign) _num = _num.substring(1);
    // split the number into cofficient and exponent
    var ref = _num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent) return sign + coefficient;
    coefficient = coefficient.replace(".", "");
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */ var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = "0." + repeat("0", Math.abs(decimalIndex)) + coefficient;
    else if (decimalIndex >= coffiecientLn) // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat("0", decimalIndex - coffiecientLn);
    else // else add decimal point at proper index
    coefficient = (coefficient.substring(0, decimalIndex) || "0") + "." + coefficient.substring(decimalIndex);
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */ function roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if ([
        "",
        "-"
    ].indexOf(numStr) !== -1) return numStr;
    var shouldHaveDecimalSeparator = (numStr.indexOf(".") !== -1 || fixedDecimalScale) && scale;
    var ref = splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNegation = ref.hasNegation;
    var floatValue = parseFloat("0." + (afterDecimal || "0"));
    var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split(".");
    var intPart = beforeDecimal;
    // if we have cary over from rounding decimal part, add that on before decimal
    if (beforeDecimal && Number(roundedDecimalParts[0])) intPart = beforeDecimal.split("").reverse().reduce(function(roundedStr, current, idx) {
        if (roundedStr.length > idx) return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = limitToScale(roundedDecimalParts[1] || "", scale, fixedDecimalScale);
    var negation = hasNegation ? "-" : "";
    var decimalSeparator = shouldHaveDecimalSeparator ? "." : "";
    return "" + negation + intPart + decimalSeparator + decimalPart;
}
/** set the caret positon in an input field **/ function setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        /* @ts-ignore */ if (el.createTextRange) {
            /* @ts-ignore */ var range = el.createTextRange();
            range.move("character", caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
 * TODO: remove dependency of findChangeRange, findChangedRangeFromCaretPositions is better way to find what is changed
 * currently this is mostly required by test and isCharacterSame util
 * Given previous value and newValue it returns the index
 * start - end to which values have changed.
 * This function makes assumption about only consecutive
 * characters are changed which is correct assumption for caret input.
 */ var findChangeRange = memoizeOnce(function(prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while(prevValue[i] === newValue[i] && i < prevLength)i++;
    //check what has been changed from last
    while(prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i)j++;
    return {
        from: {
            start: i,
            end: prevLength - j
        },
        to: {
            start: i,
            end: newLength - j
        }
    };
});
var findChangedRangeFromCaretPositions = function findChangedRangeFromCaretPositions(lastCaretPositions, currentCaretPosition) {
    var startPosition = Math.min(lastCaretPositions.selectionStart, currentCaretPosition);
    return {
        from: {
            start: startPosition,
            end: lastCaretPositions.selectionEnd
        },
        to: {
            start: startPosition,
            end: currentCaretPosition
        }
    };
};
/*
  Returns a number whose value is limited to the given range
*/ function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function geInputCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/ return Math.max(el.selectionStart, el.selectionEnd);
}
function addInputMode() {
    return typeof navigator !== "undefined" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function getDefaultChangeMeta(value) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: value.length
        },
        lastValue: ""
    };
}
function getMaskAtIndex(mask, index) {
    if (mask === void 0) mask = " ";
    if (typeof mask === "string") return mask;
    return mask[index] || " ";
}
function defaultIsCharacterSame(ref) {
    var currentValue = ref.currentValue;
    var formattedValue = ref.formattedValue;
    var currentValueIndex = ref.currentValueIndex;
    var formattedValueIndex = ref.formattedValueIndex;
    return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, /**
 * format function can change the character, the caret engine relies on mapping old value and new value
 * In such case if character is changed, parent can tell which chars are equivalent
 * Some example, all allowedDecimalCharacters are updated to decimalCharacters, 2nd case if user is coverting
 * number to different numeric system.
 */ isCharacterSame) {
    if (isCharacterSame === void 0) isCharacterSame = defaultIsCharacterSame;
    /**
     * if something got inserted on empty value, add the formatted character before the current value,
     * This is to avoid the case where typed character is present on format characters
     */ var firstAllowedPosition = boundary.findIndex(function(b) {
        return b;
    });
    var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
    if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
        lastFormattedValue = prefixFormat;
        curValue = prefixFormat + curValue;
        curCaretPos = curCaretPos + prefixFormat.length;
    }
    var curValLn = curValue.length;
    var formattedValueLn = newFormattedValue.length;
    // create index map
    var addedIndexMap = {};
    var indexMap = new Array(curValLn);
    for(var i = 0; i < curValLn; i++){
        indexMap[i] = -1;
        for(var j = 0, jLn = formattedValueLn; j < jLn; j++){
            var isCharSame = isCharacterSame({
                currentValue: curValue,
                lastValue: lastFormattedValue,
                formattedValue: newFormattedValue,
                currentValueIndex: i,
                formattedValueIndex: j
            });
            if (isCharSame && addedIndexMap[j] !== true) {
                indexMap[i] = j;
                addedIndexMap[j] = true;
                break;
            }
        }
    }
    /**
     * For current caret position find closest characters (left and right side)
     * which are properly mapped to formatted value.
     * The idea is that the new caret position will exist always in the boundary of
     * that mapped index
     */ var pos = curCaretPos;
    while(pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos])))pos++;
    // if the caret position is on last keep the endIndex as last for formatted value
    var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
    pos = curCaretPos - 1;
    while(pos > 0 && indexMap[pos] === -1)pos--;
    var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
    /**
     * case where a char is added on suffix and removed from middle, example 2sq345 becoming $2,345 sq
     * there is still a mapping but the order of start index and end index is changed
     */ if (startIndex > endIndex) return endIndex;
    /**
     * given the current caret position if it closer to startIndex
     * keep the new caret position on start index or keep it closer to endIndex
     */ return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
/* This keeps the caret within typing area so people can't type in between prefix or suffix or format characters */ function getCaretPosInBoundary(value, caretPos, boundary, direction) {
    var valLn = value.length;
    // clamp caret position to [0, value.length]
    caretPos = clamp(caretPos, 0, valLn);
    if (direction === "left") {
        while(caretPos >= 0 && !boundary[caretPos])caretPos--;
        // if we don't find any suitable caret position on left, set it on first allowed position
        if (caretPos === -1) caretPos = boundary.indexOf(true);
    } else {
        while(caretPos <= valLn && !boundary[caretPos])caretPos++;
        // if we don't find any suitable caret position on right, set it on last allowed position
        if (caretPos > valLn) caretPos = boundary.lastIndexOf(true);
    }
    // if we still don't find caret position, set it at the end of value
    if (caretPos === -1) caretPos = valLn;
    return caretPos;
}
function caretUnknownFormatBoundary(formattedValue) {
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    boundaryAry[i] = Boolean(charIsNumber(formattedValue[i]) || charIsNumber(formattedValue[i - 1]));
    return boundaryAry;
}
function useInternalValues(value, defaultValue, valueIsNumericString, format, removeFormatting, onValueChange) {
    if (onValueChange === void 0) onValueChange = noop;
    var getValues = usePersistentCallback(function(value, valueIsNumericString) {
        var formattedValue, numAsString;
        if (isNotValidValue(value)) {
            numAsString = "";
            formattedValue = "";
        } else if (typeof value === "number" || valueIsNumericString) {
            numAsString = typeof value === "number" ? toNumericString(value) : value;
            formattedValue = format(numAsString);
        } else {
            numAsString = removeFormatting(value, undefined);
            formattedValue = format(numAsString);
        }
        return {
            formattedValue: formattedValue,
            numAsString: numAsString
        };
    });
    var ref = (0, _react.useState)(function() {
        return getValues(isNil(value) ? defaultValue : value, valueIsNumericString);
    });
    var values = ref[0];
    var setValues = ref[1];
    var _onValueChange = function _onValueChange(newValues, sourceInfo) {
        if (newValues.formattedValue !== values.formattedValue) setValues({
            formattedValue: newValues.formattedValue,
            numAsString: newValues.value
        });
        // call parent on value change if only if formatted value is changed
        onValueChange(newValues, sourceInfo);
    };
    // if value is switch from controlled to uncontrolled, use the internal state's value to format with new props
    var _value = value;
    var _valueIsNumericString = valueIsNumericString;
    if (isNil(value)) {
        _value = values.numAsString;
        _valueIsNumericString = true;
    }
    var newValues = getValues(_value, _valueIsNumericString);
    (0, _react.useMemo)(function() {
        setValues(newValues);
    }, [
        newValues.formattedValue
    ]);
    return [
        values,
        _onValueChange
    ];
}
function defaultRemoveFormatting(value) {
    return value.replace(/[^0-9]/g, "");
}
function defaultFormat(value) {
    return value;
}
function NumberFormatBase(props) {
    var type = props.type;
    if (type === void 0) type = "text";
    var displayType = props.displayType;
    if (displayType === void 0) displayType = "input";
    var customInput = props.customInput;
    var renderText = props.renderText;
    var getInputRef = props.getInputRef;
    var format = props.format;
    if (format === void 0) format = defaultFormat;
    var removeFormatting = props.removeFormatting;
    if (removeFormatting === void 0) removeFormatting = defaultRemoveFormatting;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var isAllowed = props.isAllowed;
    var onChange = props.onChange;
    if (onChange === void 0) onChange = noop;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = noop;
    var onMouseUp = props.onMouseUp;
    if (onMouseUp === void 0) onMouseUp = noop;
    var onFocus = props.onFocus;
    if (onFocus === void 0) onFocus = noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = noop;
    var propValue = props.value;
    var getCaretBoundary = props.getCaretBoundary;
    if (getCaretBoundary === void 0) getCaretBoundary = caretUnknownFormatBoundary;
    var isValidInputCharacter = props.isValidInputCharacter;
    if (isValidInputCharacter === void 0) isValidInputCharacter = charIsNumber;
    var isCharacterSame = props.isCharacterSame;
    var otherProps = __rest(props, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]);
    var ref = useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format, removeFormatting, onValueChange);
    var ref_0 = ref[0];
    var formattedValue = ref_0.formattedValue;
    var numAsString = ref_0.numAsString;
    var onFormattedValueChange = ref[1];
    var caretPositionBeforeChange = (0, _react.useRef)();
    var lastUpdatedValue = (0, _react.useRef)({
        formattedValue: formattedValue,
        numAsString: numAsString
    });
    var _onValueChange = function _onValueChange(values, source) {
        lastUpdatedValue.current = {
            formattedValue: values.formattedValue,
            numAsString: values.value
        };
        onFormattedValueChange(values, source);
    };
    var ref$1 = (0, _react.useState)(false);
    var mounted = ref$1[0];
    var setMounted = ref$1[1];
    var focusedElm = (0, _react.useRef)(null);
    var timeout = (0, _react.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, _react.useEffect)(function() {
        setMounted(true);
        return function() {
            clearTimeout(timeout.current.setCaretTimeout);
            clearTimeout(timeout.current.focusTimeout);
        };
    }, []);
    var _format = format;
    var getValueObject = function getValueObject(formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue
        };
    };
    var setPatchedCaretPosition = function setPatchedCaretPosition(el, caretPos, currentValue) {
        // don't reset the caret position when the whole input content is selected
        if (el.selectionStart === 0 && el.selectionEnd === el.value.length) return;
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */ setCaretPosition(el, caretPos);
        timeout.current.setCaretTimeout = setTimeout(function() {
            if (el.value === currentValue && el.selectionStart !== caretPos) setCaretPosition(el, caretPos);
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */ var correctCaretPosition = function correctCaretPosition(value, caretPos, direction) {
        return getCaretPosInBoundary(value, caretPos, getCaretBoundary(value), direction);
    };
    var getNewCaretPosition = function getNewCaretPosition(inputValue, newFormattedValue, caretPos) {
        var caretBoundary = getCaretBoundary(newFormattedValue);
        var updatedCaretPos = getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
        //correct caret position if its outside of editable area
        updatedCaretPos = getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
        return updatedCaretPos;
    };
    var updateValueAndCaretPosition = function updateValueAndCaretPosition(params) {
        var newFormattedValue = params.formattedValue;
        if (newFormattedValue === void 0) newFormattedValue = "";
        var input = params.input;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos;
        if (input) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = geInputCaretPosition(input);
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */ input.value = newFormattedValue;
            //get the caret position
            caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition);
            //set caret position imperatively
            if (caretPos !== undefined) setPatchedCaretPosition(input, caretPos, newFormattedValue);
        }
        if (newFormattedValue !== formattedValue) // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
        _onValueChange(getValueObject(newFormattedValue, numAsString), {
            event: event,
            source: source
        });
    };
    /**
     * if the formatted value is not synced to parent, or if the formatted value is different from last synced value sync it
     * if the formatting props is removed, in which case last formatted value will be different from the numeric string value
     * in such case we need to inform the parent.
     */ (0, _react.useEffect)(function() {
        var ref = lastUpdatedValue.current;
        var lastFormattedValue = ref.formattedValue;
        var lastNumAsString = ref.numAsString;
        if (formattedValue !== lastFormattedValue || numAsString !== lastNumAsString) _onValueChange(getValueObject(formattedValue, numAsString), {
            event: undefined,
            source: SourceType.props
        });
    }, [
        formattedValue,
        numAsString
    ]);
    // also if formatted value is changed from the props, we need to update the caret position
    // keep the last caret position if element is focused
    var currentCaretPosition = focusedElm.current ? geInputCaretPosition(focusedElm.current) : undefined;
    // needed to prevent warning with useLayoutEffect on server
    var useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
    useIsomorphicLayoutEffect(function() {
        var input = focusedElm.current;
        if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
            var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
            /**
             * set the value imperatively, as we set the caret position as well imperatively.
             * This is to keep value and caret position in sync
             */ input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
        }
    }, [
        formattedValue
    ]);
    var formatInputValue = function formatInputValue(inputValue, event, source) {
        var input = event.target;
        var changeRange = caretPositionBeforeChange.current ? findChangedRangeFromCaretPositions(caretPositionBeforeChange.current, input.selectionEnd) : findChangeRange(formattedValue, inputValue);
        var changeMeta = Object.assign(Object.assign({}, changeRange), {
            lastValue: formattedValue
        });
        var _numAsString = removeFormatting(inputValue, changeMeta);
        var _formattedValue = _format(_numAsString);
        // formatting can remove some of the number chars, so we need to fine number string again
        _numAsString = removeFormatting(_formattedValue, undefined);
        if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
            //reset the caret position
            var input$1 = event.target;
            var currentCaretPosition = geInputCaretPosition(input$1);
            var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition);
            input$1.value = formattedValue;
            setPatchedCaretPosition(input$1, caretPos, formattedValue);
            return false;
        }
        updateValueAndCaretPosition({
            formattedValue: _formattedValue,
            numAsString: _numAsString,
            inputValue: inputValue,
            event: event,
            source: source,
            input: event.target
        });
        return true;
    };
    var setCaretPositionInfoBeforeChange = function setCaretPositionInfoBeforeChange(el, endOffset) {
        if (endOffset === void 0) endOffset = 0;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        caretPositionBeforeChange.current = {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd + endOffset
        };
    };
    var _onChange = function _onChange(e) {
        var el = e.target;
        var inputValue = el.value;
        var changed = formatInputValue(inputValue, e, SourceType.event);
        if (changed) onChange(e);
        // reset the position, as we have already handled the caret position
        caretPositionBeforeChange.current = undefined;
    };
    var _onKeyDown = function _onKeyDown(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = "";
        var expectedCaretPosition;
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === "ArrowLeft" || key === "Backspace") expectedCaretPosition = Math.max(selectionStart - 1, 0);
        else if (key === "ArrowRight") expectedCaretPosition = Math.min(selectionStart + 1, value.length);
        else if (key === "Delete") expectedCaretPosition = selectionStart;
        // if key is delete and text is not selected keep the end offset to 1, as it deletes one character
        // this is required as selection is not changed on delete case, which changes the change range calculation
        var endOffset = 0;
        if (key === "Delete" && selectionStart === selectionEnd) endOffset = 1;
        var isArrowKey = key === "ArrowLeft" || key === "ArrowRight";
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        // also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || selectionStart !== selectionEnd && !isArrowKey) {
            onKeyDown(e);
            // keep information of what was the caret position before keyDown
            // set it after onKeyDown, in case parent updates the position manually
            setCaretPositionInfoBeforeChange(el, endOffset);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        if (isArrowKey) {
            var direction = key === "ArrowLeft" ? "left" : "right";
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
            // arrow left or right only moves the caret, so no need to handle the event, if we are handling it manually
            if (newCaretPosition !== expectedCaretPosition) e.preventDefault();
        } else if (key === "Delete" && !isValidInputCharacter(value[expectedCaretPosition])) // in case of delete go to closest caret boundary on the right side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, "right");
        else if (key === "Backspace" && !isValidInputCharacter(value[expectedCaretPosition])) // in case of backspace go to closest caret boundary on the left side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, "left");
        if (newCaretPosition !== expectedCaretPosition) setPatchedCaretPosition(el, newCaretPosition, value);
        onKeyDown(e);
        setCaretPositionInfoBeforeChange(el, endOffset);
    };
    /** required to handle the caret position when click anywhere within the input **/ var _onMouseUp = function _onMouseUp(e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
         */ var correctCaretPositionIfRequired = function correctCaretPositionIfRequired() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = "";
            if (selectionStart === selectionEnd) {
                var caretPosition = correctCaretPosition(value, selectionStart);
                if (caretPosition !== selectionStart) setPatchedCaretPosition(el, caretPosition, value);
            }
        };
        correctCaretPositionIfRequired();
        // try to correct after selection has updated by browser
        // this case is required when user clicks on some position while a text is selected on input
        requestAnimationFrame(function() {
            correctCaretPositionIfRequired();
        });
        onMouseUp(e);
        setCaretPositionInfoBeforeChange(el);
    };
    var _onFocus = function _onFocus(e) {
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        if (e.persist) e.persist();
        var el = e.target;
        var currentTarget = e.currentTarget;
        focusedElm.current = el;
        timeout.current.focusTimeout = setTimeout(function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = "";
            var caretPosition = correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) setPatchedCaretPosition(el, caretPosition, value);
            onFocus(Object.assign(Object.assign({}, e), {
                currentTarget: currentTarget
            }));
        }, 0);
    };
    var _onBlur = function _onBlur(e) {
        focusedElm.current = null;
        clearTimeout(timeout.current.focusTimeout);
        clearTimeout(timeout.current.setCaretTimeout);
        onBlur(e);
    };
    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode() ? "numeric" : undefined;
    var inputProps = Object.assign({
        inputMode: inputMode
    }, otherProps, {
        type: type,
        value: formattedValue,
        onChange: _onChange,
        onKeyDown: _onKeyDown,
        onMouseUp: _onMouseUp,
        onFocus: _onFocus,
        onBlur: _onBlur
    });
    if (displayType === "text") return renderText ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, renderText(formattedValue, otherProps) || null) : (0, _reactDefault.default).createElement("span", Object.assign({}, otherProps, {
        ref: getInputRef
    }), formattedValue);
    else if (customInput) {
        var CustomInput = customInput;
        /* @ts-ignore */ return (0, _reactDefault.default).createElement(CustomInput, Object.assign({}, inputProps, {
            ref: getInputRef
        }));
    }
    return (0, _reactDefault.default).createElement("input", Object.assign({}, inputProps, {
        ref: getInputRef
    }));
}
function format(numStr, props) {
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var suffix = props.suffix;
    if (suffix === void 0) suffix = "";
    var allowNegative = props.allowNegative;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    if (thousandsGroupStyle === void 0) thousandsGroupStyle = "thousand";
    // don't apply formatting on empty string or '-'
    if (numStr === "" || numStr === "-") return numStr;
    var ref = getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    /**
     * Keep the decimal separator
     * when decimalScale is not defined or non zero and the numStr has decimal in it
     * Or if decimalScale is > 0 and fixeDecimalScale is true (even if numStr has no decimal)
     */ var hasDecimalSeparator = decimalScale !== 0 && numStr.indexOf(".") !== -1 || decimalScale && fixedDecimalScale;
    var ref$1 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$1.beforeDecimal;
    var afterDecimal = ref$1.afterDecimal;
    var addNegation = ref$1.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined
    if (decimalScale !== undefined) afterDecimal = limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
    if (thousandSeparator) beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    //add prefix and suffix when there is a number present
    if (prefix) beforeDecimal = prefix + beforeDecimal;
    if (suffix) afterDecimal = afterDecimal + suffix;
    //restore negation sign
    if (addNegation) beforeDecimal = "-" + beforeDecimal;
    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || "") + afterDecimal;
    return numStr;
}
function getSeparators(props) {
    var decimalSeparator = props.decimalSeparator;
    if (decimalSeparator === void 0) decimalSeparator = ".";
    var thousandSeparator = props.thousandSeparator;
    var allowedDecimalSeparators = props.allowedDecimalSeparators;
    if (thousandSeparator === true) thousandSeparator = ",";
    if (!allowedDecimalSeparators) allowedDecimalSeparators = [
        decimalSeparator,
        "."
    ];
    return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        allowedDecimalSeparators: allowedDecimalSeparators
    };
}
function handleNegation(value, allowNegative) {
    if (value === void 0) value = "";
    var negationRegex = new RegExp("(-)");
    var doubleNegationRegex = new RegExp("(-)(.)*(-)");
    // Check number has '-' value
    var hasNegation = negationRegex.test(value);
    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);
    //remove negation
    value = value.replace(/-/g, "");
    if (hasNegation && !removeNegation && allowNegative) value = "-" + value;
    return value;
}
function getNumberRegex(decimalSeparator, global) {
    return new RegExp("(^-)|[0-9]|" + escapeRegExp(decimalSeparator), global ? "g" : undefined);
}
function isNumericString(val, prefix, suffix) {
    // for empty value we can always treat it as numeric string
    if (val === "") return true;
    return !(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === "string" && !isNaN(Number(val));
}
function removeFormatting(value, changeMeta, props) {
    var assign;
    if (changeMeta === void 0) changeMeta = getDefaultChangeMeta(value);
    var allowNegative = props.allowNegative;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var suffix = props.suffix;
    if (suffix === void 0) suffix = "";
    var decimalScale = props.decimalScale;
    var from = changeMeta.from;
    var to = changeMeta.to;
    var start = to.start;
    var end = to.end;
    var ref = getSeparators(props);
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var decimalSeparator = ref.decimalSeparator;
    var isBeforeDecimalSeparator = value[end] === decimalSeparator;
    /**
     * If only a number is added on empty input which matches with the prefix or suffix,
     * then don't remove it, just return the same
     */ if (charIsNumber(value) && (value === prefix || value === suffix) && changeMeta.lastValue === "") return value;
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */ if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
        var separator = decimalScale === 0 ? "" : decimalSeparator;
        value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
    }
    var stripNegation = function stripNegation(value, start, end) {
        /**
         * if prefix starts with - we don't allow negative number to avoid confusion
         * if suffix starts with - and the value length is same as suffix length, then the - sign is from the suffix
         * In other cases, if the value starts with - then it is a negation
         */ var hasNegation = false;
        var hasDoubleNegation = false;
        if (prefix.startsWith("-")) hasNegation = false;
        else if (value.startsWith("--")) {
            hasNegation = false;
            hasDoubleNegation = true;
        } else if (suffix.startsWith("-") && value.length === suffix.length) hasNegation = false;
        else if (value[0] === "-") hasNegation = true;
        var charsToRemove = hasNegation ? 1 : 0;
        if (hasDoubleNegation) charsToRemove = 2;
        // remove negation/double negation from start to simplify prefix logic as negation comes before prefix
        if (charsToRemove) {
            value = value.substring(charsToRemove);
            // account for the removal of the negation for start and end index
            start -= charsToRemove;
            end -= charsToRemove;
        }
        return {
            value: value,
            start: start,
            end: end,
            hasNegation: hasNegation
        };
    };
    var toMetadata = stripNegation(value, start, end);
    var hasNegation = toMetadata.hasNegation;
    assign = toMetadata, value = assign.value, start = assign.start, end = assign.end;
    var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
    var fromStart = ref$1.start;
    var fromEnd = ref$1.end;
    var lastValue = ref$1.value;
    // if only prefix and suffix part is updated reset the value to last value
    // if the changed range is from suffix in the updated value, and the the suffix starts with the same characters, allow the change
    var updatedSuffixPart = value.substring(start, end);
    if (value.length && lastValue.length && (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) && !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) value = lastValue;
    /**
     * remove prefix
     * Remove whole prefix part if its present on the value
     * If the prefix is partially deleted (in which case change start index will be less the prefix length)
     * Remove only partial part of prefix.
     */ var startIndex = 0;
    if (value.startsWith(prefix)) startIndex += prefix.length;
    else if (start < prefix.length) startIndex = start;
    value = value.substring(startIndex);
    // account for deleted prefix for end
    end -= startIndex;
    /**
     * Remove suffix
     * Remove whole suffix part if its present on the value
     * If the suffix is partially deleted (in which case change end index will be greater than the suffixStartIndex)
     * remove the partial part of suffix
     */ var endIndex = value.length;
    var suffixStartIndex = value.length - suffix.length;
    if (value.endsWith(suffix)) endIndex = suffixStartIndex;
    else if (end > suffixStartIndex) endIndex = end;
    else if (end > value.length - suffix.length) endIndex = end;
    value = value.substring(0, endIndex);
    // add the negation back and handle for double negation
    value = handleNegation(hasNegation ? "-" + value : value, allowNegative);
    // remove non numeric characters
    value = (value.match(getNumberRegex(decimalSeparator, true)) || []).join("");
    // replace the decimalSeparator with ., and only keep the first separator, ignore following ones
    var firstIndex = value.indexOf(decimalSeparator);
    value = value.replace(new RegExp(escapeRegExp(decimalSeparator), "g"), function(match, index) {
        return index === firstIndex ? "." : "";
    });
    //check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    var ref$2 = splitDecimal(value, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //clear only if something got deleted before decimal (cursor is before decimal)
    if (to.end - to.start < from.end - from.start && beforeDecimal === "" && isBeforeDecimalSeparator && !parseFloat(afterDecimal)) value = addNegation ? "-" : "";
    return value;
}
function getCaretBoundary(formattedValue, props) {
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var suffix = props.suffix;
    if (suffix === void 0) suffix = "";
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hasNegation = formattedValue[0] === "-";
    // fill for prefix and negation
    boundaryAry.fill(false, 0, prefix.length + (hasNegation ? 1 : 0));
    // fill for suffix
    var valLn = formattedValue.length;
    boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
    return boundaryAry;
}
function validateAndUpdateProps(props) {
    var ref = getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    // eslint-disable-next-line prefer-const
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var allowNegative = props.allowNegative;
    if (allowNegative === void 0) allowNegative = true;
    if (thousandSeparator === decimalSeparator) throw new Error("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n        decimalSeparator: ' + decimalSeparator + " (default value for decimalSeparator is .)\n     ");
    if (prefix.startsWith("-") && allowNegative) {
        // TODO: throw error in next major version
        console.error("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    ");
        allowNegative = false;
    }
    return Object.assign(Object.assign({}, props), {
        allowNegative: allowNegative
    });
}
function useNumericFormat(props) {
    // validate props
    props = validateAndUpdateProps(props);
    var _decimalSeparator = props.decimalSeparator;
    var _allowedDecimalSeparators = props.allowedDecimalSeparators;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    var suffix = props.suffix;
    var allowNegative = props.allowNegative;
    var allowLeadingZeros = props.allowLeadingZeros;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = noop;
    var thousandSeparator = props.thousandSeparator;
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = "";
    var defaultValue = props.defaultValue;
    var value = props.value;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var restProps = __rest(props, [
        "decimalSeparator",
        "allowedDecimalSeparators",
        "thousandsGroupStyle",
        "suffix",
        "allowNegative",
        "allowLeadingZeros",
        "onKeyDown",
        "onBlur",
        "thousandSeparator",
        "decimalScale",
        "fixedDecimalScale",
        "prefix",
        "defaultValue",
        "value",
        "valueIsNumericString",
        "onValueChange"
    ]);
    // get derived decimalSeparator and allowedDecimalSeparators
    var ref = getSeparators(props);
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var _format = function _format(numStr) {
        return format(numStr, props);
    };
    var _removeFormatting = function _removeFormatting(inputValue, changeMeta) {
        return removeFormatting(inputValue, changeMeta, props);
    };
    var _value = isNil(value) ? defaultValue : value;
    // try to figure out isValueNumericString based on format prop and value
    var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : isNumericString(_value, prefix, suffix);
    if (!isNil(value)) _valueIsNumericString = _valueIsNumericString || typeof value === "number";
    else if (!isNil(defaultValue)) _valueIsNumericString = _valueIsNumericString || typeof defaultValue === "number";
    var roundIncomingValueToPrecision = function roundIncomingValueToPrecision(value) {
        if (isNotValidValue(value)) return value;
        if (typeof value === "number") value = toNumericString(value);
        /**
         * only round numeric or float string values coming through props,
         * we don't need to do it for onChange events, as we want to prevent typing there
         */ if (_valueIsNumericString && typeof decimalScale === "number") return roundToPrecision(value, decimalScale, Boolean(fixedDecimalScale));
        return value;
    };
    var ref$1 = useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
    var ref$1_0 = ref$1[0];
    var numAsString = ref$1_0.numAsString;
    var formattedValue = ref$1_0.formattedValue;
    var _onValueChange = ref$1[1];
    var _onKeyDown = function _onKeyDown(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = "";
        // if user tries to delete partial prefix then ignore it
        if ((key === "Backspace" || key === "Delete") && selectionEnd < prefix.length) {
            e.preventDefault();
            return;
        }
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // if user hits backspace, while the cursor is before prefix, and the input has negation, remove the negation
        if (key === "Backspace" && value[0] === "-" && selectionStart === prefix.length + 1 && allowNegative) // bring the cursor to after negation
        setCaretPosition(el, 1);
        // don't allow user to delete decimal separator when decimalScale and fixedDecimalScale is set
        if (decimalScale && fixedDecimalScale) {
            if (key === "Backspace" && value[selectionStart - 1] === decimalSeparator) {
                setCaretPosition(el, selectionStart - 1);
                e.preventDefault();
            } else if (key === "Delete" && value[selectionStart] === decimalSeparator) e.preventDefault();
        }
        // if user presses the allowed decimal separator before the separator, move the cursor after the separator
        if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value[selectionStart] === decimalSeparator) setCaretPosition(el, selectionStart + 1);
        var _thousandSeparator = thousandSeparator === true ? "," : thousandSeparator;
        // move cursor when delete or backspace is pressed before/after thousand separator
        if (key === "Backspace" && value[selectionStart - 1] === _thousandSeparator) setCaretPosition(el, selectionStart - 1);
        if (key === "Delete" && value[selectionStart] === _thousandSeparator) setCaretPosition(el, selectionStart + 1);
        onKeyDown(e);
    };
    var _onBlur = function _onBlur(e) {
        var _value = numAsString;
        // if there no no numeric value, clear the input
        if (!_value.match(/\d/g)) _value = "";
        // clear leading 0s
        if (!allowLeadingZeros) _value = fixLeadingZero(_value);
        // apply fixedDecimalScale on blur event
        if (fixedDecimalScale && decimalScale) _value = roundToPrecision(_value, decimalScale, fixedDecimalScale);
        if (_value !== numAsString) {
            var formattedValue = format(_value, props);
            _onValueChange({
                formattedValue: formattedValue,
                value: _value,
                floatValue: parseFloat(_value)
            }, {
                event: e,
                source: SourceType.event
            });
        }
        onBlur(e);
    };
    var isValidInputCharacter = function isValidInputCharacter(inputChar) {
        if (inputChar === decimalSeparator) return true;
        return charIsNumber(inputChar);
    };
    var isCharacterSame = function isCharacterSame(ref) {
        var currentValue = ref.currentValue;
        var lastValue = ref.lastValue;
        var formattedValue = ref.formattedValue;
        var currentValueIndex = ref.currentValueIndex;
        var formattedValueIndex = ref.formattedValueIndex;
        var curChar = currentValue[currentValueIndex];
        var newChar = formattedValue[formattedValueIndex];
        /**
         * NOTE: as thousand separator and allowedDecimalSeparators can be same, we need to check on
         * typed range if we have typed any character from allowedDecimalSeparators, in that case we
         * consider different characters like , and . same within the range of updated value.
         */ var typedRange = findChangeRange(lastValue, currentValue);
        var to = typedRange.to;
        // handle corner case where if we user types a decimal separator with fixedDecimalScale
        // and pass back float value the cursor jumps. #851
        var getDecimalSeparatorIndex = function getDecimalSeparatorIndex(value) {
            return _removeFormatting(value).indexOf(".") + prefix.length;
        };
        if (value === 0 && fixedDecimalScale && decimalScale && currentValue[to.start] === decimalSeparator && getDecimalSeparatorIndex(currentValue) < currentValueIndex && getDecimalSeparatorIndex(formattedValue) > formattedValueIndex) return false;
        if (currentValueIndex >= to.start && currentValueIndex < to.end && allowedDecimalSeparators && allowedDecimalSeparators.includes(curChar) && newChar === decimalSeparator) return true;
        return curChar === newChar;
    };
    return Object.assign(Object.assign({}, restProps), {
        value: formattedValue,
        valueIsNumericString: false,
        isValidInputCharacter: isValidInputCharacter,
        isCharacterSame: isCharacterSame,
        onValueChange: _onValueChange,
        format: _format,
        removeFormatting: _removeFormatting,
        getCaretBoundary: function getCaretBoundary1(formattedValue) {
            return getCaretBoundary(formattedValue, props);
        },
        onKeyDown: _onKeyDown,
        onBlur: _onBlur
    });
}
function NumericFormat(props) {
    var numericFormatProps = useNumericFormat(props);
    return (0, _reactDefault.default).createElement(NumberFormatBase, Object.assign({}, numericFormatProps));
}
function format$1(numStr, props) {
    var format = props.format;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    if (numStr === "" && !allowEmptyFormatting) return "";
    var hashCount = 0;
    var formattedNumberAry = format.split("");
    for(var i = 0, ln = format.length; i < ln; i++)if (format[i] === patternChar) {
        formattedNumberAry[i] = numStr[hashCount] || getMaskAtIndex(mask, hashCount);
        hashCount += 1;
    }
    return formattedNumberAry.join("");
}
function removeFormatting$1(value, changeMeta, props) {
    if (changeMeta === void 0) changeMeta = getDefaultChangeMeta(value);
    var format = props.format;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    var from = changeMeta.from;
    var to = changeMeta.to;
    var lastValue = changeMeta.lastValue;
    if (lastValue === void 0) lastValue = "";
    var isNumericSlot = function isNumericSlot(caretPos) {
        return format[caretPos] === patternChar;
    };
    var removeFormatChar = function removeFormatChar(string, startIndex) {
        var str = "";
        for(var i = 0; i < string.length; i++)if (isNumericSlot(startIndex + i) && charIsNumber(string[i])) str += string[i];
        return str;
    };
    var extractNumbers = function extractNumbers(str) {
        return str.replace(/[^0-9]/g, "");
    };
    // if format doesn't have any number, remove all the non numeric characters
    if (!format.match(/\d/)) return extractNumbers(value);
    /**
     * if user paste the whole formatted text in an empty input or doing select all and paste, check if matches to the pattern
     * and remove the format characters, if there is a mismatch on the pattern, do plane number extract
     */ if ((lastValue === "" || from.end - from.start === lastValue.length) && value.length === format.length) {
        var str = "";
        for(var i = 0; i < value.length; i++){
            if (isNumericSlot(i)) {
                if (charIsNumber(value[i])) str += value[i];
            } else if (value[i] !== format[i]) // if there is a mismatch on the pattern, do plane number extract
            return extractNumbers(value);
        }
        return str;
    }
    /**
     * For partial change,
     * where ever there is a change on the input, we can break the number in three parts
     * 1st: left part which is unchanged
     * 2nd: middle part which is changed
     * 3rd: right part which is unchanged
     *
     * The first and third section will be same as last value, only the middle part will change
     * We can consider on the change part all the new characters are non format characters.
     * And on the first and last section it can have partial format characters.
     *
     * We pick first and last section from the lastValue (as that has 1-1 mapping with format)
     * and middle one from the update value.
     */ var firstSection = lastValue.substring(0, from.start);
    var middleSection = value.substring(to.start, to.end);
    var lastSection = lastValue.substring(from.end);
    return "" + removeFormatChar(firstSection, 0) + extractNumbers(middleSection) + removeFormatChar(lastSection, from.end);
}
function getCaretBoundary$1(formattedValue, props) {
    var format = props.format;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hashCount = 0;
    var firstEmptySlot = -1;
    var maskAndIndexMap = {};
    format.split("").forEach(function(char, index) {
        var maskAtIndex = undefined;
        if (char === patternChar) {
            hashCount++;
            maskAtIndex = getMaskAtIndex(mask, hashCount - 1);
            if (firstEmptySlot === -1 && formattedValue[index] === maskAtIndex) firstEmptySlot = index;
        }
        maskAndIndexMap[index] = maskAtIndex;
    });
    var isPosAllowed = function isPosAllowed(pos) {
        // the position is allowed if the position is not masked and valid number area
        return format[pos] === patternChar && formattedValue[pos] !== maskAndIndexMap[pos];
    };
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    // Note: on pattern based format its denoted by patternCharacter
    // we should also allow user to put cursor on first empty slot
    boundaryAry[i] = i === firstEmptySlot || isPosAllowed(i) || isPosAllowed(i - 1);
    // the first patternChar position is always allowed
    boundaryAry[format.indexOf(patternChar)] = true;
    return boundaryAry;
}
function validateProps(props) {
    var mask = props.mask;
    if (mask) {
        var maskAsStr = mask === "string" ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) throw new Error("Mask " + mask + " should not contain numeric character;");
    }
}
function isNumericString$1(val, format) {
    //we can treat empty string as numeric string
    if (val === "") return true;
    return !(format === null || format === void 0 ? void 0 : format.match(/\d/)) && typeof val === "string" && (!!val.match(/^\d+$/) || val === "");
}
function usePatternFormat(props) {
    var mask = props.mask;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var formatProp = props.format;
    var inputMode = props.inputMode;
    if (inputMode === void 0) inputMode = "numeric";
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = noop;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = "#";
    var value = props.value;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var restProps = __rest(props, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    // validate props
    validateProps(props);
    var _getCaretBoundary = function _getCaretBoundary(formattedValue) {
        return getCaretBoundary$1(formattedValue, props);
    };
    var _onKeyDown = function _onKeyDown(e) {
        var key = e.key;
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // bring the cursor to closest numeric section
        var caretPos = selectionStart;
        // if backspace is pressed after the format characters, bring it to numeric section
        // if delete is pressed before the format characters, bring it to numeric section
        if (key === "Backspace" || key === "Delete") {
            var direction = "right";
            if (key === "Backspace") {
                while(caretPos > 0 && formatProp[caretPos - 1] !== patternChar)caretPos--;
                direction = "left";
            } else {
                var formatLn = formatProp.length;
                while(caretPos < formatLn && formatProp[caretPos] !== patternChar)caretPos++;
                direction = "right";
            }
            caretPos = getCaretPosInBoundary(value, caretPos, _getCaretBoundary(value), direction);
        } else if (formatProp[caretPos] !== patternChar && key !== "ArrowLeft" && key !== "ArrowRight") // if user is typing on format character position, bring user to next allowed caret position
        caretPos = getCaretPosInBoundary(value, caretPos + 1, _getCaretBoundary(value), "right");
        // if we changing caret position, set the caret position
        if (caretPos !== selectionStart) setCaretPosition(el, caretPos);
        onKeyDown(e);
    };
    // try to figure out isValueNumericString based on format prop and value
    var _value = isNil(value) ? defaultValue : value;
    var isValueNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : isNumericString$1(_value, formatProp);
    var _props = Object.assign(Object.assign({}, props), {
        valueIsNumericString: isValueNumericString
    });
    return Object.assign(Object.assign({}, restProps), {
        value: value,
        defaultValue: defaultValue,
        valueIsNumericString: isValueNumericString,
        inputMode: inputMode,
        format: function format(numStr) {
            return format$1(numStr, _props);
        },
        removeFormatting: function removeFormatting(inputValue, changeMeta) {
            return removeFormatting$1(inputValue, changeMeta, _props);
        },
        getCaretBoundary: _getCaretBoundary,
        onKeyDown: _onKeyDown
    });
}
function PatternFormat(props) {
    var patternFormatProps = usePatternFormat(props);
    return (0, _reactDefault.default).createElement(NumberFormatBase, Object.assign({}, patternFormatProps));
}

},{"react":"9MtAM","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"jkJAc":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("af94a611e4c15687");
var React = require("7432b0a840210974");
var cx = require("44827933034767d3");
var reactNumberFormat = require("72aae71cb3290fd");
var hooks = require("4508e7fb9ed14a78");
var noop = require("306761652db67ef6");
var getSize = require("3b22600765fa0492");
var createVarsResolver = require("90b5ec24737002ca");
var useResolvedStylesApi = require("e547909408a1c98d");
var useStyles = require("db6f66455a809583");
require("fea112fee371389a");
require("c0f9a4c30ef9957");
require("750465247efbe709");
require("b51a9b14f1e9ac17");
var useProps = require("f51d723e541c56a");
require("d81e780477aa4d23");
require("60db8abb3a023efc");
var factory = require("ecd828ce75ae07bf");
require("c3908f021682da95");
var InputBase = require("c068afdbeec1f7e9");
var UnstyledButton = require("74bbf044f9cd190f");
var NumberInputChevron = require("bd200db7f1615086");
var NumberInput_module = require("22132d32961f5c10");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var leadingDecimalZeroPattern = /^(0\.0*|-0(\.0*)?)$/;
var leadingZerosPattern = /^-?0\d+(\.\d+)?\.?$/;
function isNumberString(value) {
    return typeof value === "string" && value !== "" && !Number.isNaN(Number(value));
}
function canIncrement(value) {
    if (typeof value === "number") return value < Number.MAX_SAFE_INTEGER;
    return value === "" || isNumberString(value) && Number(value) < Number.MAX_SAFE_INTEGER;
}
function getDecimalPlaces(inputValue) {
    return inputValue.toString().replace(".", "").length;
}
function isValidNumber(floatValue, value) {
    return (typeof floatValue === "number" ? floatValue < Number.MAX_SAFE_INTEGER : !Number.isNaN(Number(floatValue))) && !Number.isNaN(floatValue) && getDecimalPlaces(value) < 14 && value !== "";
}
function isInRange(value, min, max) {
    if (value === void 0) return true;
    var minValid = min === void 0 || value >= min;
    var maxValid = max === void 0 || value <= max;
    return minValid && maxValid;
}
var defaultProps = {
    step: 1,
    clampBehavior: "blur",
    allowDecimal: true,
    allowNegative: true,
    withKeyboardEvents: true,
    allowLeadingZeros: true,
    trimLeadingZeroesOnBlur: true,
    startValue: 0
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        controls: {
            "--ni-chevron-size": getSize.getSize(size, "ni-chevron-size")
        }
    };
});
function clampAndSanitizeInput(sanitizedValue, max, min) {
    var replaced = sanitizedValue.toString().replace(/^0+/, "");
    var parsedValue = parseFloat(replaced);
    if (Number.isNaN(parsedValue)) return replaced;
    else if (parsedValue > Number.MAX_SAFE_INTEGER) return max !== void 0 ? String(max) : replaced;
    return hooks.clamp(parsedValue, min, max);
}
var NumberInput = factory.factory(function(_props, ref) {
    var props = useProps.useProps("NumberInput", defaultProps, _props);
    var className = props.className, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, vars = props.vars, onChange = props.onChange, onValueChange = props.onValueChange, value = props.value, defaultValue = props.defaultValue, max = props.max, min = props.min, step = props.step, hideControls = props.hideControls, rightSection = props.rightSection, isAllowed = props.isAllowed, clampBehavior = props.clampBehavior, onBlur = props.onBlur, allowDecimal = props.allowDecimal, decimalScale = props.decimalScale, onKeyDown = props.onKeyDown, onKeyDownCapture = props.onKeyDownCapture, handlersRef = props.handlersRef, startValue = props.startValue, disabled = props.disabled, rightSectionPointerEvents = props.rightSectionPointerEvents, allowNegative = props.allowNegative, readOnly = props.readOnly, size = props.size, rightSectionWidth = props.rightSectionWidth, stepHoldInterval = props.stepHoldInterval, stepHoldDelay = props.stepHoldDelay, allowLeadingZeros = props.allowLeadingZeros, withKeyboardEvents = props.withKeyboardEvents, trimLeadingZeroesOnBlur = props.trimLeadingZeroesOnBlur, others = (0, _objectWithoutProperties._)(props, [
        "className",
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "onChange",
        "onValueChange",
        "value",
        "defaultValue",
        "max",
        "min",
        "step",
        "hideControls",
        "rightSection",
        "isAllowed",
        "clampBehavior",
        "onBlur",
        "allowDecimal",
        "decimalScale",
        "onKeyDown",
        "onKeyDownCapture",
        "handlersRef",
        "startValue",
        "disabled",
        "rightSectionPointerEvents",
        "allowNegative",
        "readOnly",
        "size",
        "rightSectionWidth",
        "stepHoldInterval",
        "stepHoldDelay",
        "allowLeadingZeros",
        "withKeyboardEvents",
        "trimLeadingZeroesOnBlur"
    ]);
    var getStyles = useStyles.useStyles({
        name: "NumberInput",
        classes: NumberInput_module,
        props,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: "",
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var shouldUseStepInterval = stepHoldDelay !== void 0 && stepHoldInterval !== void 0;
    var inputRef = React.useRef(null);
    var onStepTimeoutRef = React.useRef(null);
    var stepCountRef = React.useRef(0);
    var handleValueChange = function(payload, event) {
        if (event.source === "event") setValue(isValidNumber(payload.floatValue, payload.value) && !leadingDecimalZeroPattern.test(payload.value) && !(allowLeadingZeros ? leadingZerosPattern.test(payload.value) : false) ? payload.floatValue : payload.value);
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(payload, event);
    };
    var getDecimalPlaces2 = function(inputValue) {
        var match = String(inputValue).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) return 0;
        return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
    };
    var adjustCursor = function(position) {
        if (inputRef.current && typeof position !== "undefined") inputRef.current.setSelectionRange(position, position);
    };
    var incrementRef = React.useRef(noop.noop);
    incrementRef.current = function() {
        if (!canIncrement(_value)) return;
        var val;
        var currentValuePrecision = getDecimalPlaces2(_value);
        var stepPrecision = getDecimalPlaces2(step);
        var maxPrecision = Math.max(currentValuePrecision, stepPrecision);
        var factor = Math.pow(10, maxPrecision);
        if (!isNumberString(_value) && (typeof _value !== "number" || Number.isNaN(_value))) val = hooks.clamp(startValue, min, max);
        else if (max !== void 0) {
            var incrementedValue = (Math.round(Number(_value) * factor) + Math.round(step * factor)) / factor;
            val = incrementedValue <= max ? incrementedValue : max;
        } else val = (Math.round(Number(_value) * factor) + Math.round(step * factor)) / factor;
        var formattedValue = val.toFixed(maxPrecision);
        setValue(parseFloat(formattedValue));
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange({
            floatValue: parseFloat(formattedValue),
            formattedValue,
            value: formattedValue
        }, {
            source: "increment"
        });
        setTimeout(function() {
            var _inputRef_current;
            return adjustCursor((_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.value.length);
        }, 0);
    };
    var decrementRef = React.useRef(noop.noop);
    decrementRef.current = function() {
        if (!canIncrement(_value)) return;
        var val;
        var minValue = min !== void 0 ? min : !allowNegative ? 0 : Number.MIN_SAFE_INTEGER;
        var currentValuePrecision = getDecimalPlaces2(_value);
        var stepPrecision = getDecimalPlaces2(step);
        var maxPrecision = Math.max(currentValuePrecision, stepPrecision);
        var factor = Math.pow(10, maxPrecision);
        if (!isNumberString(_value) && typeof _value !== "number" || Number.isNaN(_value)) val = hooks.clamp(startValue, minValue, max);
        else {
            var decrementedValue = (Math.round(Number(_value) * factor) - Math.round(step * factor)) / factor;
            val = minValue !== void 0 && decrementedValue < minValue ? minValue : decrementedValue;
        }
        var formattedValue = val.toFixed(maxPrecision);
        setValue(parseFloat(formattedValue));
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange({
            floatValue: parseFloat(formattedValue),
            formattedValue,
            value: formattedValue
        }, {
            source: "decrement"
        });
        setTimeout(function() {
            var _inputRef_current;
            return adjustCursor((_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.value.length);
        }, 0);
    };
    var handleKeyDown = function(event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (readOnly || !withKeyboardEvents) return;
        if (event.key === "ArrowUp") {
            event.preventDefault();
            incrementRef.current();
        }
        if (event.key === "ArrowDown") {
            event.preventDefault();
            decrementRef.current();
        }
    };
    var handleKeyDownCapture = function(event) {
        onKeyDownCapture === null || onKeyDownCapture === void 0 ? void 0 : onKeyDownCapture(event);
        if (event.key === "Backspace") {
            var input = inputRef.current;
            if (input.selectionStart === 0 && input.selectionStart === input.selectionEnd) {
                event.preventDefault();
                window.setTimeout(function() {
                    return adjustCursor(0);
                }, 0);
            }
        }
    };
    var handleBlur = function(event) {
        var sanitizedValue = _value;
        if (clampBehavior === "blur" && typeof sanitizedValue === "number") sanitizedValue = hooks.clamp(sanitizedValue, min, max);
        if (trimLeadingZeroesOnBlur && typeof sanitizedValue === "string" && getDecimalPlaces2(sanitizedValue) < 15) sanitizedValue = clampAndSanitizeInput(sanitizedValue, max, min);
        if (_value !== sanitizedValue) setValue(sanitizedValue);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    hooks.assignRef(handlersRef, {
        increment: incrementRef.current,
        decrement: decrementRef.current
    });
    var onStepHandleChange = function(isIncrement) {
        if (isIncrement) incrementRef.current();
        else decrementRef.current();
        stepCountRef.current += 1;
    };
    var onStepLoop = function(isIncrement) {
        onStepHandleChange(isIncrement);
        if (shouldUseStepInterval) {
            var interval = typeof stepHoldInterval === "number" ? stepHoldInterval : stepHoldInterval(stepCountRef.current);
            onStepTimeoutRef.current = window.setTimeout(function() {
                return onStepLoop(isIncrement);
            }, interval);
        }
    };
    var onStep = function(event, isIncrement) {
        var _inputRef_current;
        event.preventDefault();
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        onStepHandleChange(isIncrement);
        if (shouldUseStepInterval) onStepTimeoutRef.current = window.setTimeout(function() {
            return onStepLoop(isIncrement);
        }, stepHoldDelay);
    };
    var onStepDone = function() {
        if (onStepTimeoutRef.current) window.clearTimeout(onStepTimeoutRef.current);
        onStepTimeoutRef.current = null;
        stepCountRef.current = 0;
    };
    var controls = /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("controls")), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("control")), {
                tabIndex: -1,
                "aria-hidden": true,
                disabled: disabled || typeof _value === "number" && max !== void 0 && _value >= max,
                mod: {
                    direction: "up"
                },
                onMouseDown: function(event) {
                    return event.preventDefault();
                },
                onPointerDown: function(event) {
                    onStep(event, true);
                },
                onPointerUp: onStepDone,
                onPointerLeave: onStepDone,
                children: /* @__PURE__ */ jsxRuntime.jsx(NumberInputChevron.NumberInputChevron, {
                    direction: "up"
                })
            })),
            /* @__PURE__ */ jsxRuntime.jsx(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("control")), {
                tabIndex: -1,
                "aria-hidden": true,
                disabled: disabled || typeof _value === "number" && min !== void 0 && _value <= min,
                mod: {
                    direction: "down"
                },
                onMouseDown: function(event) {
                    return event.preventDefault();
                },
                onPointerDown: function(event) {
                    onStep(event, false);
                },
                onPointerUp: onStepDone,
                onPointerLeave: onStepDone,
                children: /* @__PURE__ */ jsxRuntime.jsx(NumberInputChevron.NumberInputChevron, {
                    direction: "down"
                })
            }))
        ]
    }));
    return /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: reactNumberFormat.NumericFormat,
        allowNegative,
        className: cx__default.default(NumberInput_module.root, className),
        size
    }, others), {
        readOnly,
        disabled,
        value: _value,
        getInputRef: hooks.useMergedRef(ref, inputRef),
        onValueChange: handleValueChange,
        rightSection: hideControls || readOnly || !canIncrement(_value) ? rightSection : rightSection || controls,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled,
        __staticSelector: "NumberInput",
        decimalScale: allowDecimal ? decimalScale : 0,
        onKeyDown: handleKeyDown,
        onKeyDownCapture: handleKeyDownCapture,
        rightSectionPointerEvents: rightSectionPointerEvents !== null && rightSectionPointerEvents !== void 0 ? rightSectionPointerEvents : disabled ? "none" : void 0,
        rightSectionWidth: rightSectionWidth !== null && rightSectionWidth !== void 0 ? rightSectionWidth : `var(--ni-right-section-width-${size || "sm"})`,
        allowLeadingZeros,
        onBlur: handleBlur,
        isAllowed: function(val) {
            if (clampBehavior === "strict") {
                if (isAllowed) return isAllowed(val) && isInRange(val.floatValue, min, max);
                return isInRange(val.floatValue, min, max);
            }
            return isAllowed ? isAllowed(val) : true;
        }
    }));
});
NumberInput.classes = (0, _objectSpread._)({}, InputBase.InputBase.classes, NumberInput_module);
NumberInput.displayName = "@mantine/core/NumberInput";
exports.NumberInput = NumberInput; //# sourceMappingURL=NumberInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","af94a611e4c15687":"iKGFf","7432b0a840210974":"9MtAM","44827933034767d3":"8QFOC","72aae71cb3290fd":"iqzVA","4508e7fb9ed14a78":"9HEEB","306761652db67ef6":"2dVWr","3b22600765fa0492":"kEFEY","90b5ec24737002ca":"hIQE6","e547909408a1c98d":"d30sL","db6f66455a809583":"d0sAY","fea112fee371389a":"2FdJg","c0f9a4c30ef9957":"6AMGA","750465247efbe709":"erSvz","b51a9b14f1e9ac17":"kqQOF","f51d723e541c56a":"iivvn","d81e780477aa4d23":"8YP4O","60db8abb3a023efc":"gkGXc","ecd828ce75ae07bf":"guLFz","c3908f021682da95":"2onWA","c068afdbeec1f7e9":"jbA6w","74bbf044f9cd190f":"cArqr","bd200db7f1615086":"aNybc","22132d32961f5c10":"b2Ohj"}],"aNybc":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a90bda478fbcebc0");
function NumberInputChevron(_param) {
    var direction = _param.direction, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "direction",
        "style"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        style: (0, _objectSpread._)({
            width: "var(--ni-chevron-size)",
            height: "var(--ni-chevron-size)",
            transform: direction === "up" ? "rotate(180deg)" : void 0
        }, style),
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    }));
}
exports.NumberInputChevron = NumberInputChevron; //# sourceMappingURL=NumberInputChevron.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","a90bda478fbcebc0":"iKGFf"}],"b2Ohj":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_e2f5cd4e",
    "controls": "m_95e17d22",
    "control": "m_80b4b171"
};
module.exports = classes; //# sourceMappingURL=NumberInput.module.css.cjs.map

},{}],"cA6JI":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b9018be46271ea59");
require("a649ae97cc580089");
require("3d301ceccab9aff9");
require("67992438cbc7ab41");
require("17d1445c79a96041");
require("89d86547c1d42b44");
require("f2f460c101d5999e");
require("25441bcf934479e9");
var useProps = require("bcd275a21dfd2c32");
require("d021120abca6a358");
require("c7dad959a575aa89");
var factory = require("e0779e1417d5c284");
require("a166d40624557995");
var Group = require("11496f09790892a");
var PaginationControl = require("ff584a8804777774");
var PaginationDots = require("14880c973db75965");
var PaginationEdges = require("3afdb3dac7c68bbb");
var PaginationItems = require("8aa9bb4d38c6c755");
var PaginationRoot = require("35756f7c8eb41808");
var Pagination_module = require("1e4f76a16b5881b4");
var defaultProps = {
    withControls: true,
    withPages: true,
    siblings: 1,
    boundaries: 1,
    gap: 8
};
var Pagination = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Pagination", defaultProps, _props);
    var withEdges = props.withEdges, withControls = props.withControls, getControlProps = props.getControlProps, nextIcon = props.nextIcon, previousIcon = props.previousIcon, lastIcon = props.lastIcon, firstIcon = props.firstIcon, dotsIcon = props.dotsIcon, total = props.total, gap = props.gap, hideWithOnePage = props.hideWithOnePage, withPages = props.withPages, others = (0, _objectWithoutProperties._)(props, [
        "withEdges",
        "withControls",
        "getControlProps",
        "nextIcon",
        "previousIcon",
        "lastIcon",
        "firstIcon",
        "dotsIcon",
        "total",
        "gap",
        "hideWithOnePage",
        "withPages"
    ]);
    if (total <= 0 || hideWithOnePage && total === 1) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(PaginationRoot.PaginationRoot, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        total
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(Group.Group, {
            gap,
            children: [
                withEdges && /* @__PURE__ */ jsxRuntime.jsx(PaginationEdges.PaginationFirst, (0, _objectSpread._)({
                    icon: firstIcon
                }, getControlProps === null || getControlProps === void 0 ? void 0 : getControlProps("first"))),
                withControls && /* @__PURE__ */ jsxRuntime.jsx(PaginationEdges.PaginationPrevious, (0, _objectSpread._)({
                    icon: previousIcon
                }, getControlProps === null || getControlProps === void 0 ? void 0 : getControlProps("previous"))),
                withPages && /* @__PURE__ */ jsxRuntime.jsx(PaginationItems.PaginationItems, {
                    dotsIcon
                }),
                withControls && /* @__PURE__ */ jsxRuntime.jsx(PaginationEdges.PaginationNext, (0, _objectSpread._)({
                    icon: nextIcon
                }, getControlProps === null || getControlProps === void 0 ? void 0 : getControlProps("next"))),
                withEdges && /* @__PURE__ */ jsxRuntime.jsx(PaginationEdges.PaginationLast, (0, _objectSpread._)({
                    icon: lastIcon
                }, getControlProps === null || getControlProps === void 0 ? void 0 : getControlProps("last")))
            ]
        })
    }));
});
Pagination.classes = Pagination_module;
Pagination.displayName = "@mantine/core/Pagination";
Pagination.Root = PaginationRoot.PaginationRoot;
Pagination.Control = PaginationControl.PaginationControl;
Pagination.Dots = PaginationDots.PaginationDots;
Pagination.First = PaginationEdges.PaginationFirst;
Pagination.Last = PaginationEdges.PaginationLast;
Pagination.Next = PaginationEdges.PaginationNext;
Pagination.Previous = PaginationEdges.PaginationPrevious;
Pagination.Items = PaginationItems.PaginationItems;
exports.Pagination = Pagination; //# sourceMappingURL=Pagination.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","b9018be46271ea59":"iKGFf","a649ae97cc580089":"9MtAM","3d301ceccab9aff9":"9HEEB","67992438cbc7ab41":"8QFOC","17d1445c79a96041":"2FdJg","89d86547c1d42b44":"6AMGA","f2f460c101d5999e":"erSvz","25441bcf934479e9":"kqQOF","bcd275a21dfd2c32":"iivvn","d021120abca6a358":"8YP4O","c7dad959a575aa89":"gkGXc","e0779e1417d5c284":"guLFz","a166d40624557995":"2onWA","11496f09790892a":"iEuvx","ff584a8804777774":"2ChBF","14880c973db75965":"lziOM","3afdb3dac7c68bbb":"5KiRn","8aa9bb4d38c6c755":"kPyys","35756f7c8eb41808":"jZi48","1e4f76a16b5881b4":"7sTCu"}],"2ChBF":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("7d7c41c466ef015e");
require("e52faac588580af8");
require("97cad25edb752775");
require("f264d94d9ae54e51");
require("cc80ff987530cf90");
require("611dca7b355705f9");
require("e0c12fe904e5f354");
require("384f0a65813377fc");
var useProps = require("a37354919b39d38b");
require("3147cb2beb295460");
require("e077738ba739e1dc");
var factory = require("56a9b9acb87ea34c");
require("8b9cd03aee3b0d85");
var UnstyledButton = require("68e2901cd9f6707a");
var Pagination_context = require("d9e515e6ddf34a97");
var Pagination_module = require("185f115d5fc30e7d");
var defaultProps = {
    withPadding: true
};
var PaginationControl = factory.factory(function(_props, ref) {
    var props = useProps.useProps("PaginationControl", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, active = props.active, disabled = props.disabled, withPadding = props.withPadding, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "active",
        "disabled",
        "withPadding",
        "mod"
    ]);
    var ctx = Pagination_context.usePaginationContext();
    var _disabled = disabled || ctx.disabled;
    return /* @__PURE__ */ jsxRuntime.jsx(UnstyledButton.UnstyledButton, (0, _objectSpread._)({
        ref,
        disabled: _disabled,
        mod: [
            {
                active,
                disabled: _disabled,
                "with-padding": withPadding
            },
            mod
        ]
    }, ctx.getStyles("control", {
        className,
        style,
        classNames,
        styles,
        active: !_disabled
    }), others));
});
PaginationControl.classes = Pagination_module;
PaginationControl.displayName = "@mantine/core/PaginationControl";
exports.PaginationControl = PaginationControl; //# sourceMappingURL=PaginationControl.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","7d7c41c466ef015e":"iKGFf","e52faac588580af8":"9MtAM","97cad25edb752775":"9HEEB","f264d94d9ae54e51":"8QFOC","cc80ff987530cf90":"2FdJg","611dca7b355705f9":"6AMGA","e0c12fe904e5f354":"erSvz","384f0a65813377fc":"kqQOF","a37354919b39d38b":"iivvn","3147cb2beb295460":"8YP4O","e077738ba739e1dc":"gkGXc","56a9b9acb87ea34c":"guLFz","8b9cd03aee3b0d85":"2onWA","68e2901cd9f6707a":"cArqr","d9e515e6ddf34a97":"jml6F","185f115d5fc30e7d":"7sTCu"}],"jml6F":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("19a04cbc4dd23575");
var createSafeContext = require("1c888763024df72");
require("18301146a39f057b");
require("350b9fee16684294");
require("4883f1ac82daec58");
require("dfaec2062a998d0");
require("99fd885e09308325");
require("57d96b97c01f206e");
require("599f3fbe390e0300");
require("6780f955b2222f8d");
require("722164c29ed97776");
require("8d3b33f49948339");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Pagination.Root component was not found in tree"), 2), PaginationProvider = _createSafeContext_createSafeContext[0], usePaginationContext = _createSafeContext_createSafeContext[1];
exports.PaginationProvider = PaginationProvider;
exports.usePaginationContext = usePaginationContext; //# sourceMappingURL=Pagination.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","19a04cbc4dd23575":"9MtAM","1c888763024df72":"8srze","18301146a39f057b":"iKGFf","350b9fee16684294":"9HEEB","4883f1ac82daec58":"8QFOC","dfaec2062a998d0":"2FdJg","99fd885e09308325":"6AMGA","57d96b97c01f206e":"erSvz","599f3fbe390e0300":"kqQOF","6780f955b2222f8d":"8YP4O","722164c29ed97776":"gkGXc","8d3b33f49948339":"2onWA"}],"7sTCu":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_4addd315",
    "control": "m_326d024a",
    "dots": "m_4ad7767d"
};
module.exports = classes; //# sourceMappingURL=Pagination.module.css.cjs.map

},{}],"lziOM":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("52d5153be37df13d");
require("fdbb32694d493aa6");
require("b583fdb43913f9c");
require("77b7693b3515e50d");
require("bf22c19cf195d927");
require("417da23c5d80a078");
require("c461c63436baacf9");
require("489a4c095018277b");
var useProps = require("f2b398b9930c0772");
require("6eef2a8e25b56352");
var Box = require("55992d0dafde5724");
var factory = require("363f52498461ad7c");
require("fc6a23539be23fe4");
var Pagination_context = require("bb7d1613c76c57d8");
var Pagination_icons = require("830501a5d8f19280");
var Pagination_module = require("f295dbd64d7382be");
var defaultProps = {
    icon: Pagination_icons.PaginationDotsIcon
};
var PaginationDots = factory.factory(function(_props, ref) {
    var props = useProps.useProps("PaginationDots", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, icon = props.icon, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "icon"
    ]);
    var ctx = Pagination_context.usePaginationContext();
    var Icon = icon;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, ctx.getStyles("dots", {
        className,
        style,
        styles,
        classNames
    }), others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(Icon, {
            style: {
                width: "calc(var(--pagination-control-size) / 1.8)",
                height: "calc(var(--pagination-control-size) / 1.8)"
            }
        })
    }));
});
PaginationDots.classes = Pagination_module;
PaginationDots.displayName = "@mantine/core/PaginationDots";
exports.PaginationDots = PaginationDots; //# sourceMappingURL=PaginationDots.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","52d5153be37df13d":"iKGFf","fdbb32694d493aa6":"9MtAM","b583fdb43913f9c":"9HEEB","77b7693b3515e50d":"8QFOC","bf22c19cf195d927":"2FdJg","417da23c5d80a078":"6AMGA","c461c63436baacf9":"erSvz","489a4c095018277b":"kqQOF","f2b398b9930c0772":"iivvn","6eef2a8e25b56352":"8YP4O","55992d0dafde5724":"gkGXc","363f52498461ad7c":"guLFz","fc6a23539be23fe4":"2onWA","bb7d1613c76c57d8":"jml6F","830501a5d8f19280":"dtLVy","f295dbd64d7382be":"7sTCu"}],"dtLVy":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c481f0f68c3d4e46");
function PaginationIcon(_param) {
    var style = _param.style, children = _param.children, path = _param.path, others = (0, _objectWithoutProperties._)(_param, [
        "style",
        "children",
        "path"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        style: (0, _objectSpread._)({
            width: "calc(var(--pagination-control-size) / 1.8)",
            height: "calc(var(--pagination-control-size) / 1.8)"
        }, style)
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: path,
            fill: "currentColor"
        })
    }));
}
var PaginationNextIcon = function(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(PaginationIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        path: "M8.781 8l-3.3-3.3.943-.943L10.667 8l-4.243 4.243-.943-.943 3.3-3.3z"
    }));
};
var PaginationPreviousIcon = function(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(PaginationIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        path: "M7.219 8l3.3 3.3-.943.943L5.333 8l4.243-4.243.943.943-3.3 3.3z"
    }));
};
var PaginationFirstIcon = function(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(PaginationIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        path: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z"
    }));
};
var PaginationLastIcon = function(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(PaginationIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        path: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z"
    }));
};
var PaginationDotsIcon = function(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(PaginationIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        path: "M2 8c0-.733.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333C2.6 9.333 2 8.733 2 8zm9.333 0c0-.733.6-1.333 1.334-1.333C13.4 6.667 14 7.267 14 8s-.6 1.333-1.333 1.333c-.734 0-1.334-.6-1.334-1.333zM6.667 8c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333S8.733 9.333 8 9.333 6.667 8.733 6.667 8z"
    }));
};
exports.PaginationDotsIcon = PaginationDotsIcon;
exports.PaginationFirstIcon = PaginationFirstIcon;
exports.PaginationLastIcon = PaginationLastIcon;
exports.PaginationNextIcon = PaginationNextIcon;
exports.PaginationPreviousIcon = PaginationPreviousIcon; //# sourceMappingURL=Pagination.icons.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c481f0f68c3d4e46":"iKGFf"}],"5KiRn":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("83b27d5cba8ef983");
var React = require("cde57571e4b09395");
require("2554827ce862b134");
require("6bdd0da6ac823a79");
require("9d0babf9a30b0b23");
require("20d5ae2dbc9520e7");
require("cd0039c8679328c9");
require("c1a42040a50a3a97");
var useProps = require("cfd2ceab39e15224");
require("270d081999da0d6d");
require("1557de6ff11f2900");
var createPolymorphicComponent = require("6d0b1cb5253469de");
require("4dd1c8960bceeb8a");
var Pagination_context = require("ae9af1bdd5ebfc9e");
var Pagination_icons = require("465c765cfc9c1d4d");
var PaginationControl = require("2643506ba62ba815");
function createEdgeComponent(param) {
    var icon = param.icon, name = param.name, action = param.action, type = param.type;
    var defaultProps = {
        icon
    };
    var Component = React.forwardRef(function(props, ref) {
        var _useProps_useProps = useProps.useProps(name, defaultProps, props), _icon = _useProps_useProps.icon, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
            "icon"
        ]);
        var Icon = _icon;
        var ctx = Pagination_context.usePaginationContext();
        var disabled = type === "next" ? ctx.active === ctx.total : ctx.active === 1;
        return /* @__PURE__ */ jsxRuntime.jsx(PaginationControl.PaginationControl, (0, _objectSpreadProps._)((0, _objectSpread._)({
            disabled: ctx.disabled || disabled,
            ref,
            onClick: ctx[action],
            withPadding: false
        }, others), {
            children: /* @__PURE__ */ jsxRuntime.jsx(Icon, {
                className: "mantine-rotate-rtl",
                style: {
                    width: "calc(var(--pagination-control-size) / 1.8)",
                    height: "calc(var(--pagination-control-size) / 1.8)"
                }
            })
        }));
    });
    Component.displayName = `@mantine/core/${name}`;
    return createPolymorphicComponent.createPolymorphicComponent(Component);
}
var PaginationNext = createEdgeComponent({
    icon: Pagination_icons.PaginationNextIcon,
    name: "PaginationNext",
    action: "onNext",
    type: "next"
});
var PaginationPrevious = createEdgeComponent({
    icon: Pagination_icons.PaginationPreviousIcon,
    name: "PaginationPrevious",
    action: "onPrevious",
    type: "previous"
});
var PaginationFirst = createEdgeComponent({
    icon: Pagination_icons.PaginationFirstIcon,
    name: "PaginationFirst",
    action: "onFirst",
    type: "previous"
});
var PaginationLast = createEdgeComponent({
    icon: Pagination_icons.PaginationLastIcon,
    name: "PaginationLast",
    action: "onLast",
    type: "next"
});
exports.PaginationFirst = PaginationFirst;
exports.PaginationLast = PaginationLast;
exports.PaginationNext = PaginationNext;
exports.PaginationPrevious = PaginationPrevious;
exports.createEdgeComponent = createEdgeComponent; //# sourceMappingURL=PaginationEdges.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","83b27d5cba8ef983":"iKGFf","cde57571e4b09395":"9MtAM","2554827ce862b134":"9HEEB","6bdd0da6ac823a79":"8QFOC","9d0babf9a30b0b23":"2FdJg","20d5ae2dbc9520e7":"6AMGA","cd0039c8679328c9":"erSvz","c1a42040a50a3a97":"kqQOF","cfd2ceab39e15224":"iivvn","270d081999da0d6d":"8YP4O","1557de6ff11f2900":"gkGXc","6d0b1cb5253469de":"ifmiy","4dd1c8960bceeb8a":"2onWA","ae9af1bdd5ebfc9e":"jml6F","465c765cfc9c1d4d":"dtLVy","2643506ba62ba815":"2ChBF"}],"kPyys":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("78ce91323d3a4586");
var Pagination_context = require("45eeab442400423e");
var PaginationControl = require("ca9d139109b01d11");
var PaginationDots = require("2e2e28161623a12");
function PaginationItems(param) {
    var dotsIcon = param.dotsIcon;
    var ctx = Pagination_context.usePaginationContext();
    var items = ctx.range.map(function(page, index) {
        var _ctx_getItemProps, _ctx_getItemProps1, _ctx_getItemProps2;
        if (page === "dots") return /* @__PURE__ */ jsxRuntime.jsx(PaginationDots.PaginationDots, {
            icon: dotsIcon
        }, index);
        var _ctx_getItemProps_children;
        return /* @__PURE__ */ jsxRuntime.jsx(PaginationControl.PaginationControl, (0, _objectSpreadProps._)((0, _objectSpread._)({
            active: page === ctx.active,
            "aria-current": page === ctx.active ? "page" : void 0,
            onClick: function() {
                return ctx.onChange(page);
            },
            disabled: ctx.disabled
        }, (_ctx_getItemProps = ctx.getItemProps) === null || _ctx_getItemProps === void 0 ? void 0 : _ctx_getItemProps.call(ctx, page)), {
            children: (_ctx_getItemProps_children = (_ctx_getItemProps2 = ctx.getItemProps) === null || _ctx_getItemProps2 === void 0 ? void 0 : (_ctx_getItemProps1 = _ctx_getItemProps2.call(ctx, page)) === null || _ctx_getItemProps1 === void 0 ? void 0 : _ctx_getItemProps1.children) !== null && _ctx_getItemProps_children !== void 0 ? _ctx_getItemProps_children : page
        }), index);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: items
    });
}
PaginationItems.displayName = "@mantine/core/PaginationItems";
exports.PaginationItems = PaginationItems; //# sourceMappingURL=PaginationItems.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","78ce91323d3a4586":"iKGFf","45eeab442400423e":"jml6F","ca9d139109b01d11":"2ChBF","2e2e28161623a12":"lziOM"}],"jZi48":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f7df9b20685cdc72");
var hooks = require("7dd65a1679e127a2");
require("9c27737434cfe5a");
var getSize = require("c104a25d7c9691e7");
var createEventHandler = require("52d05a959e7e2948");
var createVarsResolver = require("164689bebafd68b");
require("63a7c86d8e83e22");
var getThemeColor = require("e1279726d0010e9f");
var getContrastColor = require("b96721108bc44d04");
var getAutoContrastValue = require("8e8a685e4af8a7ef");
require("579f1f93e432841a");
require("d8721fe9905c5f85");
require("d7b37a64f98b1964");
require("b8fda5a80df90cca");
var useProps = require("c7796fb1480be99");
require("a06e3d871b7b2c29");
var useStyles = require("74f896fb90e74a8c");
var Box = require("a906781740aa42ed");
var factory = require("816ca2d0259cf238");
require("938615a307e5b913");
var Pagination_context = require("268b9caca5ed7f2d");
var Pagination_module = require("b0d006c47f94e4dc");
var defaultProps = {
    siblings: 1,
    boundaries: 1
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, radius = param.radius, color = param.color, autoContrast = param.autoContrast;
    return {
        root: {
            "--pagination-control-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--pagination-control-size": getSize.getSize(size, "pagination-control-size"),
            "--pagination-control-fz": getSize.getFontSize(size),
            "--pagination-active-bg": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--pagination-active-color": getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
var PaginationRoot = factory.factory(function(_props, ref) {
    var props = useProps.useProps("PaginationRoot", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, total = props.total, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, disabled = props.disabled, siblings = props.siblings, boundaries = props.boundaries, color = props.color, radius = props.radius, onNextPage = props.onNextPage, onPreviousPage = props.onPreviousPage, onFirstPage = props.onFirstPage, onLastPage = props.onLastPage, getItemProps = props.getItemProps, autoContrast = props.autoContrast, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "total",
        "value",
        "defaultValue",
        "onChange",
        "disabled",
        "siblings",
        "boundaries",
        "color",
        "radius",
        "onNextPage",
        "onPreviousPage",
        "onFirstPage",
        "onLastPage",
        "getItemProps",
        "autoContrast"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Pagination",
        classes: Pagination_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _hooks_usePagination = hooks.usePagination({
        page: value,
        initialPage: defaultValue,
        onChange,
        total,
        siblings,
        boundaries
    }), range = _hooks_usePagination.range, setPage = _hooks_usePagination.setPage, next = _hooks_usePagination.next, previous = _hooks_usePagination.previous, active = _hooks_usePagination.active, first = _hooks_usePagination.first, last = _hooks_usePagination.last;
    var handleNextPage = createEventHandler.createEventHandler(onNextPage, next);
    var handlePreviousPage = createEventHandler.createEventHandler(onPreviousPage, previous);
    var handleFirstPage = createEventHandler.createEventHandler(onFirstPage, first);
    var handleLastPage = createEventHandler.createEventHandler(onLastPage, last);
    return /* @__PURE__ */ jsxRuntime.jsx(Pagination_context.PaginationProvider, {
        value: {
            total,
            range,
            active,
            disabled,
            getItemProps,
            onChange: setPage,
            onNext: handleNextPage,
            onPrevious: handlePreviousPage,
            onFirst: handleFirstPage,
            onLast: handleLastPage,
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
            ref
        }, getStyles("root"), others))
    });
});
PaginationRoot.classes = Pagination_module;
PaginationRoot.displayName = "@mantine/core/PaginationRoot";
exports.PaginationRoot = PaginationRoot; //# sourceMappingURL=PaginationRoot.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","f7df9b20685cdc72":"iKGFf","7dd65a1679e127a2":"9HEEB","9c27737434cfe5a":"9MtAM","c104a25d7c9691e7":"kEFEY","52d05a959e7e2948":"9qSGJ","164689bebafd68b":"hIQE6","63a7c86d8e83e22":"8QFOC","e1279726d0010e9f":"eeaIN","b96721108bc44d04":"ez6cW","8e8a685e4af8a7ef":"cN4dA","579f1f93e432841a":"2FdJg","d8721fe9905c5f85":"6AMGA","d7b37a64f98b1964":"erSvz","b8fda5a80df90cca":"kqQOF","c7796fb1480be99":"iivvn","a06e3d871b7b2c29":"8YP4O","74f896fb90e74a8c":"d0sAY","a906781740aa42ed":"gkGXc","816ca2d0259cf238":"guLFz","938615a307e5b913":"2onWA","268b9caca5ed7f2d":"jml6F","b0d006c47f94e4dc":"7sTCu"}],"gZ7hp":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("b6de9e6b496e3ebf");
var cx = require("5af37a5a7cd722ba");
var hooks = require("26e393af0cad16c");
require("1ba3cb8733e45bac");
var getSize = require("b717a7257c0fbcc1");
var createVarsResolver = require("c11c43ba56c47920");
var useResolvedStylesApi = require("b275220f201f59e3");
var useStyles = require("2cc5e709edffafe2");
require("6240ea1328b2d92c");
require("37c174b5b04f61ff");
require("bcacc374a23e885a");
require("9c45d47cd1c4715d");
var useProps = require("16799a0d6d916517");
require("b78da1e07631f7d7");
var extractStyleProps = require("8526ecba1cbd63a8");
require("b55b875a40cc2cea");
var factory = require("89157077be4d0912");
require("9d9a3a3cee7e91f1");
var ActionIcon = require("716412df9de67128");
require("923d5877763f5812");
require("5c80bf7fe96c75d3");
var Input = require("483bea4cdd1c2bfc");
require("bb63a247f9c6be79");
require("2f75e7413370bf20");
require("b7a9b436008d58bf");
require("f6167851a2344455");
require("534e6b89b4bbf6af");
require("843aba03ef9df744");
require("ceac1c1ae216762b");
var InputBase = require("f107bc2d47b68501");
var PasswordToggleIcon = require("3f079f7096cc7809");
var PasswordInput_module = require("bbfb6c0bc09b5e9");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var defaultProps = {
    visibilityToggleIcon: PasswordToggleIcon.PasswordToggleIcon
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        root: {
            "--psi-icon-size": getSize.getSize(size, "psi-icon-size"),
            "--psi-button-size": getSize.getSize(size, "psi-button-size")
        }
    };
});
var PasswordInput = factory.factory(function(_props, ref) {
    var props = useProps.useProps("PasswordInput", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, required = props.required, error = props.error, leftSection = props.leftSection, disabled = props.disabled, id = props.id, variant = props.variant, inputContainer = props.inputContainer, description = props.description, label = props.label, size = props.size, errorProps = props.errorProps, descriptionProps = props.descriptionProps, labelProps = props.labelProps, withAsterisk = props.withAsterisk, inputWrapperOrder = props.inputWrapperOrder, wrapperProps = props.wrapperProps, radius = props.radius, rightSection = props.rightSection, rightSectionWidth = props.rightSectionWidth, rightSectionPointerEvents = props.rightSectionPointerEvents, leftSectionWidth = props.leftSectionWidth, visible = props.visible, defaultVisible = props.defaultVisible, onVisibilityChange = props.onVisibilityChange, visibilityToggleIcon = props.visibilityToggleIcon, visibilityToggleButtonProps = props.visibilityToggleButtonProps, rightSectionProps = props.rightSectionProps, leftSectionProps = props.leftSectionProps, leftSectionPointerEvents = props.leftSectionPointerEvents, withErrorStyles = props.withErrorStyles, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "required",
        "error",
        "leftSection",
        "disabled",
        "id",
        "variant",
        "inputContainer",
        "description",
        "label",
        "size",
        "errorProps",
        "descriptionProps",
        "labelProps",
        "withAsterisk",
        "inputWrapperOrder",
        "wrapperProps",
        "radius",
        "rightSection",
        "rightSectionWidth",
        "rightSectionPointerEvents",
        "leftSectionWidth",
        "visible",
        "defaultVisible",
        "onVisibilityChange",
        "visibilityToggleIcon",
        "visibilityToggleButtonProps",
        "rightSectionProps",
        "leftSectionProps",
        "leftSectionPointerEvents",
        "withErrorStyles",
        "mod"
    ]);
    var uuid = hooks.useId(id);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: visible,
        defaultValue: defaultVisible,
        finalValue: false,
        onChange: onVisibilityChange
    }), 2), _visible = _hooks_useUncontrolled[0], setVisibility = _hooks_useUncontrolled[1];
    var toggleVisibility = function() {
        return setVisibility(!_visible);
    };
    var getStyles = useStyles.useStyles({
        name: "PasswordInput",
        classes: PasswordInput_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var VisibilityToggleIcon = visibilityToggleIcon;
    var _visibilityToggleButtonProps_variant;
    var visibilityToggleButton = /* @__PURE__ */ jsxRuntime.jsx(ActionIcon.ActionIcon, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("visibilityToggle")), {
        disabled,
        radius,
        "aria-hidden": !visibilityToggleButtonProps,
        tabIndex: -1
    }), visibilityToggleButtonProps), {
        variant: (_visibilityToggleButtonProps_variant = visibilityToggleButtonProps === null || visibilityToggleButtonProps === void 0 ? void 0 : visibilityToggleButtonProps.variant) !== null && _visibilityToggleButtonProps_variant !== void 0 ? _visibilityToggleButtonProps_variant : "subtle",
        color: "gray",
        unstyled,
        onTouchEnd: function(event) {
            var _visibilityToggleButtonProps_onTouchEnd;
            event.preventDefault();
            visibilityToggleButtonProps === null || visibilityToggleButtonProps === void 0 ? void 0 : (_visibilityToggleButtonProps_onTouchEnd = visibilityToggleButtonProps.onTouchEnd) === null || _visibilityToggleButtonProps_onTouchEnd === void 0 ? void 0 : _visibilityToggleButtonProps_onTouchEnd.call(visibilityToggleButtonProps, event);
            toggleVisibility();
        },
        onMouseDown: function(event) {
            var _visibilityToggleButtonProps_onMouseDown;
            event.preventDefault();
            visibilityToggleButtonProps === null || visibilityToggleButtonProps === void 0 ? void 0 : (_visibilityToggleButtonProps_onMouseDown = visibilityToggleButtonProps.onMouseDown) === null || _visibilityToggleButtonProps_onMouseDown === void 0 ? void 0 : _visibilityToggleButtonProps_onMouseDown.call(visibilityToggleButtonProps, event);
            toggleVisibility();
        },
        onKeyDown: function(event) {
            var _visibilityToggleButtonProps_onKeyDown;
            visibilityToggleButtonProps === null || visibilityToggleButtonProps === void 0 ? void 0 : (_visibilityToggleButtonProps_onKeyDown = visibilityToggleButtonProps.onKeyDown) === null || _visibilityToggleButtonProps_onKeyDown === void 0 ? void 0 : _visibilityToggleButtonProps_onKeyDown.call(visibilityToggleButtonProps, event);
            if (event.key === " ") {
                event.preventDefault();
                toggleVisibility();
            }
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(VisibilityToggleIcon, {
            reveal: _visible
        })
    }));
    return /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Wrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({
        required,
        id: uuid,
        label,
        error,
        description,
        size,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        __staticSelector: "PasswordInput",
        errorProps,
        descriptionProps,
        unstyled,
        withAsterisk,
        inputWrapperOrder,
        inputContainer,
        variant,
        labelProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, labelProps), {
            htmlFor: uuid
        }),
        mod
    }, getStyles("root"), styleProps, wrapperProps), {
        children: /* @__PURE__ */ jsxRuntime.jsx(Input.Input, {
            component: "div",
            error,
            leftSection,
            size,
            classNames: (0, _objectSpreadProps._)((0, _objectSpread._)({}, resolvedClassNames), {
                input: cx__default.default(PasswordInput_module.input, resolvedClassNames.input)
            }),
            styles: resolvedStyles,
            radius,
            disabled,
            __staticSelector: "PasswordInput",
            rightSectionWidth,
            rightSection: rightSection !== null && rightSection !== void 0 ? rightSection : visibilityToggleButton,
            variant,
            unstyled,
            leftSectionWidth,
            rightSectionPointerEvents: rightSectionPointerEvents || "all",
            rightSectionProps,
            leftSectionProps,
            leftSectionPointerEvents,
            withAria: false,
            withErrorStyles,
            children: /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                required,
                "data-invalid": !!error || void 0,
                "data-with-left-section": !!leftSection || void 0
            }, getStyles("innerInput")), {
                disabled,
                id: uuid,
                ref
            }), rest), {
                autoComplete: rest.autoComplete || "off",
                type: _visible ? "text" : "password"
            }))
        })
    }));
});
PasswordInput.classes = (0, _objectSpread._)({}, InputBase.InputBase.classes, PasswordInput_module);
PasswordInput.displayName = "@mantine/core/PasswordInput";
exports.PasswordInput = PasswordInput; //# sourceMappingURL=PasswordInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","b6de9e6b496e3ebf":"iKGFf","5af37a5a7cd722ba":"8QFOC","26e393af0cad16c":"9HEEB","1ba3cb8733e45bac":"9MtAM","b717a7257c0fbcc1":"kEFEY","c11c43ba56c47920":"hIQE6","b275220f201f59e3":"d30sL","2cc5e709edffafe2":"d0sAY","6240ea1328b2d92c":"2FdJg","37c174b5b04f61ff":"6AMGA","bcacc374a23e885a":"erSvz","9c45d47cd1c4715d":"kqQOF","16799a0d6d916517":"iivvn","b78da1e07631f7d7":"8YP4O","8526ecba1cbd63a8":"6L93n","b55b875a40cc2cea":"gkGXc","89157077be4d0912":"guLFz","9d9a3a3cee7e91f1":"2onWA","716412df9de67128":"9tz8j","923d5877763f5812":"hLZtr","5c80bf7fe96c75d3":"5bt1k","483bea4cdd1c2bfc":"dkUgf","bb63a247f9c6be79":"j4uTK","2f75e7413370bf20":"7nO1x","b7a9b436008d58bf":"3Bda4","f6167851a2344455":"gQBOr","534e6b89b4bbf6af":"lRBdM","843aba03ef9df744":"hxtex","ceac1c1ae216762b":"lQt5D","f107bc2d47b68501":"jbA6w","3f079f7096cc7809":"4Mabw","bbfb6c0bc09b5e9":"aaeNe"}],"4Mabw":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("8247618ec2821b96");
var PasswordToggleIcon = function(param) {
    var reveal = param.reveal;
    return /* @__PURE__ */ jsxRuntime.jsx("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            width: "var(--psi-icon-size)",
            height: "var(--psi-icon-size)"
        },
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: reveal ? "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" : "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
};
exports.PasswordToggleIcon = PasswordToggleIcon; //# sourceMappingURL=PasswordToggleIcon.cjs.map

},{"8247618ec2821b96":"iKGFf"}],"aaeNe":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f61ca620",
    "input": "m_ccf8da4c",
    "innerInput": "m_f2d85dd2",
    "visibilityToggle": "m_b1072d44"
};
module.exports = classes; //# sourceMappingURL=PasswordInput.module.css.cjs.map

},{}],"h9XOU":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("543b1e12cb837e6f");
var React = require("bd688c3a7398e12f");
var hooks = require("28b306208b4dcc0a");
var getSize = require("1fd4804e75edeb08");
var createVarsResolver = require("88e6ba780860632a");
require("a4a818b68e49d34e");
var useResolvedStylesApi = require("d580d718ed6f26b4");
var useStyles = require("df2874353e12519e");
require("85421baeeba0c693");
require("16dec0d4cab304f4");
require("f83020ea0d18e25e");
require("18310a2d0fd40f9b");
var useProps = require("8c5576460145a3c3");
require("3078e426f342938f");
require("a503efee3cb9fcf8");
var factory = require("6f494e5b7fcf6099");
require("e7f310b3e074c002");
var Group = require("663642925c94ddf5");
var Input = require("53059affed189950");
require("f4b854e6cc80975e");
require("2e473dfe3621a0a7");
require("35c211212b3f76c9");
require("3567b5dba8f7f4db");
require("872431d0077bb24f");
require("1ec3a88dd1797cbb");
require("c054c8f15b31ab0f");
var InputBase = require("c731863ed2d9cad9");
var createPinArray = require("2855b1765e0fdfc8");
var PinInput_module = require("b3eb20e50134ae1d");
var regex = {
    number: /^[0-9]+$/,
    alphanumeric: /^[a-zA-Z0-9]+$/i
};
var defaultProps = {
    gap: "sm",
    length: 4,
    manageFocus: true,
    oneTimeCode: true,
    placeholder: "\u25CB",
    type: "alphanumeric",
    ariaLabel: "PinInput"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size;
    return {
        root: {
            "--pin-input-size": getSize.getSize(size !== null && size !== void 0 ? size : defaultProps.size, "pin-input-size")
        }
    };
});
var PinInput = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("PinInput", defaultProps, props), name = _useProps_useProps.name, form = _useProps_useProps.form, className = _useProps_useProps.className, value = _useProps_useProps.value, defaultValue = _useProps_useProps.defaultValue, variant = _useProps_useProps.variant, gap = _useProps_useProps.gap, style = _useProps_useProps.style, size = _useProps_useProps.size, classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, length = _useProps_useProps.length, onChange = _useProps_useProps.onChange, onComplete = _useProps_useProps.onComplete, manageFocus = _useProps_useProps.manageFocus, autoFocus = _useProps_useProps.autoFocus, error = _useProps_useProps.error, radius = _useProps_useProps.radius, disabled = _useProps_useProps.disabled, oneTimeCode = _useProps_useProps.oneTimeCode, placeholder = _useProps_useProps.placeholder, type = _useProps_useProps.type, mask = _useProps_useProps.mask, readOnly = _useProps_useProps.readOnly, inputType = _useProps_useProps.inputType, inputMode = _useProps_useProps.inputMode, ariaLabel = _useProps_useProps.ariaLabel, vars = _useProps_useProps.vars, id = _useProps_useProps.id, hiddenInputProps = _useProps_useProps.hiddenInputProps, rootRef = _useProps_useProps.rootRef, getInputProps = _useProps_useProps.getInputProps, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "name",
        "form",
        "className",
        "value",
        "defaultValue",
        "variant",
        "gap",
        "style",
        "size",
        "classNames",
        "styles",
        "unstyled",
        "length",
        "onChange",
        "onComplete",
        "manageFocus",
        "autoFocus",
        "error",
        "radius",
        "disabled",
        "oneTimeCode",
        "placeholder",
        "type",
        "mask",
        "readOnly",
        "inputType",
        "inputMode",
        "ariaLabel",
        "vars",
        "id",
        "hiddenInputProps",
        "rootRef",
        "getInputProps"
    ]);
    var uuid = hooks.useId(id);
    var getStyles = useStyles.useStyles({
        name: "PinInput",
        classes: PinInput_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    var _React_useState = (0, _slicedToArray._)(React.useState(-1), 2), focusedIndex = _React_useState[0], setFocusedIndex = _React_useState[1];
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: value ? createPinArray.createPinArray(length !== null && length !== void 0 ? length : 0, value) : void 0,
        defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.split("").slice(0, length !== null && length !== void 0 ? length : 0),
        finalValue: createPinArray.createPinArray(length !== null && length !== void 0 ? length : 0, ""),
        onChange: typeof onChange === "function" ? function(val) {
            onChange(val.join("").trim());
        } : void 0
    }), 2), _value = _hooks_useUncontrolled[0], setValues = _hooks_useUncontrolled[1];
    var _valueToString = _value.join("").trim();
    var inputsRef = React.useRef([]);
    var validate = function(code) {
        var re = type instanceof RegExp ? type : type && type in regex ? regex[type] : null;
        return re === null || re === void 0 ? void 0 : re.test(code);
    };
    var focusInputField = function(dir, index, event) {
        if (!manageFocus) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            return;
        }
        if (dir === "next") {
            var nextIndex = index + 1;
            var canFocusNext = nextIndex < (length !== null && length !== void 0 ? length : 0);
            if (canFocusNext) {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                inputsRef.current[nextIndex].focus();
            }
        }
        if (dir === "prev") {
            var nextIndex1 = index - 1;
            var canFocusNext1 = nextIndex1 > -1;
            if (canFocusNext1) {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                inputsRef.current[nextIndex1].focus();
            }
        }
    };
    var setFieldValue = function(val, index) {
        var values = (0, _toConsumableArray._)(_value);
        values[index] = val;
        setValues(values);
    };
    var handleChange = function(event, index) {
        var inputValue = event.target.value;
        var nextCharOrValue = inputValue.length === 2 ? inputValue.split("")[inputValue.length - 1] : inputValue;
        var isValid = validate(nextCharOrValue);
        if (nextCharOrValue.length < 2) {
            if (isValid) {
                setFieldValue(nextCharOrValue, index);
                focusInputField("next", index);
            } else setFieldValue("", index);
        } else if (isValid) setValues(createPinArray.createPinArray(length !== null && length !== void 0 ? length : 0, inputValue));
    };
    var handleKeyDown = function(event, index) {
        var ctrlKey = event.ctrlKey, metaKey = event.metaKey, key = event.key, shiftKey = event.shiftKey, target = event.target;
        var inputValue = target.value;
        if (inputMode === "numeric") {
            var canTypeSign = key === "Backspace" || key === "Tab" || key === "Control" || key === "Delete" || ctrlKey && key === "v" || metaKey && key === "v" ? true : !Number.isNaN(Number(key));
            if (!canTypeSign) event.preventDefault();
        }
        if (key === "ArrowLeft" || shiftKey && key === "Tab") focusInputField("prev", index, event);
        else if (key === "ArrowRight" || key === "Tab" || key === " ") focusInputField("next", index, event);
        else if (key === "Delete") setFieldValue("", index);
        else if (key === "Backspace") {
            if (index !== 0) {
                setFieldValue("", index);
                if (length === index + 1) {
                    if (event.target.value === "") focusInputField("prev", index, event);
                } else focusInputField("prev", index, event);
            }
        } else if (inputValue.length > 0 && key === _value[index]) focusInputField("next", index, event);
    };
    var handleFocus = function(event, index) {
        event.target.select();
        setFocusedIndex(index);
    };
    var handleBlur = function() {
        setFocusedIndex(-1);
    };
    var handlePaste = function(event) {
        event.preventDefault();
        var copyValue = event.clipboardData.getData("text/plain").replace(/[\n\r\s]+/g, "");
        var isValid = validate(copyValue.trim());
        if (isValid) {
            var copyValueToPinArray = createPinArray.createPinArray(length !== null && length !== void 0 ? length : 0, copyValue);
            setValues(copyValueToPinArray);
            focusInputField("next", copyValueToPinArray.length - 2);
        }
    };
    React.useEffect(function() {
        if (_valueToString.length !== length) return;
        onComplete === null || onComplete === void 0 ? void 0 : onComplete(_valueToString);
    }, [
        length,
        _valueToString
    ]);
    React.useEffect(function() {
        if (length !== _value.length) setValues(createPinArray.createPinArray(length !== null && length !== void 0 ? length : 0, _value.join("")));
    }, [
        length,
        _value
    ]);
    React.useEffect(function() {
        if (value === "") setValues(createPinArray.createPinArray(length !== null && length !== void 0 ? length : 0, value));
    }, [
        value
    ]);
    React.useEffect(function() {
        if (disabled) setFocusedIndex(-1);
    }, [
        disabled
    ]);
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(Group.Group, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others, getStyles("root")), {
                ref: rootRef,
                role: "group",
                id: uuid,
                gap,
                unstyled,
                wrap: "nowrap",
                variant,
                __size: size,
                dir: "ltr",
                children: _value.map(function(char, index) {
                    return /* @__PURE__ */ React.createElement(Input.Input, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "input"
                    }, getStyles("pinInput", {
                        style: {
                            "--input-padding": "0",
                            "--input-text-align": "center"
                        }
                    })), {
                        classNames: resolvedClassNames,
                        styles: resolvedStyles,
                        size,
                        __staticSelector: "PinInput",
                        id: `${uuid}-${index + 1}`,
                        key: `${uuid}-${index}`,
                        inputMode: inputMode || (type === "number" ? "numeric" : "text"),
                        onChange: function(event) {
                            return handleChange(event, index);
                        },
                        onKeyDown: function(event) {
                            return handleKeyDown(event, index);
                        },
                        onFocus: function(event) {
                            return handleFocus(event, index);
                        },
                        onBlur: handleBlur,
                        onPaste: handlePaste,
                        type: inputType || (mask ? "password" : type === "number" ? "tel" : "text"),
                        radius,
                        error,
                        variant,
                        disabled,
                        ref: function(node) {
                            index === 0 && hooks.assignRef(ref, node);
                            inputsRef.current[index] = node;
                        },
                        autoComplete: oneTimeCode ? "one-time-code" : "off",
                        placeholder: focusedIndex === index ? "" : placeholder,
                        value: char,
                        autoFocus: autoFocus && index === 0,
                        unstyled,
                        "aria-label": ariaLabel,
                        readOnly
                    }), getInputProps === null || getInputProps === void 0 ? void 0 : getInputProps(index)));
                })
            })),
            /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)({
                type: "hidden",
                name,
                form,
                value: _valueToString
            }, hiddenInputProps))
        ]
    });
});
PinInput.classes = (0, _objectSpread._)({}, PinInput_module, InputBase.InputBase.classes);
PinInput.displayName = "@mantine/core/PinInput";
exports.PinInput = PinInput; //# sourceMappingURL=PinInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","543b1e12cb837e6f":"iKGFf","bd688c3a7398e12f":"9MtAM","28b306208b4dcc0a":"9HEEB","1fd4804e75edeb08":"kEFEY","88e6ba780860632a":"hIQE6","a4a818b68e49d34e":"8QFOC","d580d718ed6f26b4":"d30sL","df2874353e12519e":"d0sAY","85421baeeba0c693":"2FdJg","16dec0d4cab304f4":"6AMGA","f83020ea0d18e25e":"erSvz","18310a2d0fd40f9b":"kqQOF","8c5576460145a3c3":"iivvn","3078e426f342938f":"8YP4O","a503efee3cb9fcf8":"gkGXc","6f494e5b7fcf6099":"guLFz","e7f310b3e074c002":"2onWA","663642925c94ddf5":"iEuvx","53059affed189950":"dkUgf","f4b854e6cc80975e":"j4uTK","2e473dfe3621a0a7":"7nO1x","35c211212b3f76c9":"3Bda4","3567b5dba8f7f4db":"gQBOr","872431d0077bb24f":"lRBdM","1ec3a88dd1797cbb":"hxtex","c054c8f15b31ab0f":"lQt5D","c731863ed2d9cad9":"jbA6w","2855b1765e0fdfc8":"gRjc9","b3eb20e50134ae1d":"1rxui"}],"gRjc9":[function(require,module,exports) {
"use client";
"use strict";
function createPinArray(length, value) {
    if (length < 1) return [];
    var values = new Array(length).fill("");
    if (value) {
        var splitted = value.trim().split("");
        for(var i = 0; i < Math.min(length, splitted.length); i += 1)values[i] = splitted[i] === " " ? "" : splitted[i];
    }
    return values;
}
exports.createPinArray = createPinArray; //# sourceMappingURL=create-pin-array.cjs.map

},{}],"1rxui":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f1cb205a",
    "pinInput": "m_cb288ead"
};
module.exports = classes; //# sourceMappingURL=PinInput.module.css.cjs.map

},{}],"cKKzS":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c12fecff522f0222");
require("97122c5685f80228");
require("f687d2850c54edb6");
require("b7a78aa4304ac0b0");
var useResolvedStylesApi = require("291a7c335735e1cb");
require("2b4c857a4f0abb4f");
require("e3ef5659c41eb167");
require("897947909ea8034c");
require("3999345f2ee8b867");
var useProps = require("d5e34c5c80b347a5");
require("27768b6187fee5b7");
require("6731a10c461e25e3");
var factory = require("cb71397212867522");
require("431c46b752f1d4ef");
var ProgressLabel = require("7e352e9fe48e8b2a");
var ProgressRoot = require("ba67b2124c2c09f9");
var ProgressSection = require("2c57ee738eddeda8");
var Progress_module = require("722c9d74373a19a2");
var defaultProps = {};
var Progress = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Progress", defaultProps, _props);
    var value = props.value, classNames = props.classNames, styles = props.styles, vars = props.vars, color = props.color, striped = props.striped, animated = props.animated, label = props["aria-label"], others = (0, _objectWithoutProperties._)(props, [
        "value",
        "classNames",
        "styles",
        "vars",
        "color",
        "striped",
        "animated",
        "aria-label"
    ]);
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        classNames,
        styles,
        props
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    return /* @__PURE__ */ jsxRuntime.jsx(ProgressRoot.ProgressRoot, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        vars
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(ProgressSection.ProgressSection, {
            value,
            color,
            striped,
            animated,
            "aria-label": label
        })
    }));
});
Progress.classes = Progress_module;
Progress.displayName = "@mantine/core/Progress";
Progress.Section = ProgressSection.ProgressSection;
Progress.Root = ProgressRoot.ProgressRoot;
Progress.Label = ProgressLabel.ProgressLabel;
exports.Progress = Progress; //# sourceMappingURL=Progress.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c12fecff522f0222":"iKGFf","97122c5685f80228":"9MtAM","f687d2850c54edb6":"9HEEB","b7a78aa4304ac0b0":"8QFOC","291a7c335735e1cb":"d30sL","2b4c857a4f0abb4f":"2FdJg","e3ef5659c41eb167":"6AMGA","897947909ea8034c":"erSvz","3999345f2ee8b867":"kqQOF","d5e34c5c80b347a5":"iivvn","27768b6187fee5b7":"8YP4O","6731a10c461e25e3":"gkGXc","cb71397212867522":"guLFz","431c46b752f1d4ef":"2onWA","7e352e9fe48e8b2a":"jGGoF","ba67b2124c2c09f9":"aVLPV","2c57ee738eddeda8":"biD1g","722c9d74373a19a2":"aMtEM"}],"jGGoF":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("348601ebea89f5a7");
require("1974e040bcc7decb");
require("2372692ff7fa0052");
require("b65cbe6251056457");
require("392c8322552ded22");
require("12537bf610da7799");
require("59ef8aab98a500e7");
require("6e1f4784797cf921");
var useProps = require("8e468568879b2c4b");
require("2abed065e8645bab");
var Box = require("4c3874b4cb0b735b");
var factory = require("6390566357a58eee");
require("eaa657c32564e994");
var Progress_context = require("c2484f18787b69a6");
var Progress_module = require("f69c22eae2e8874f");
var defaultProps = {};
var ProgressLabel = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ProgressLabel", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars"
    ]);
    var ctx = Progress_context.useProgressContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref
    }, ctx.getStyles("label", {
        className,
        style,
        classNames,
        styles
    }), others));
});
ProgressLabel.classes = Progress_module;
ProgressLabel.displayName = "@mantine/core/ProgressLabel";
exports.ProgressLabel = ProgressLabel; //# sourceMappingURL=ProgressLabel.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","348601ebea89f5a7":"iKGFf","1974e040bcc7decb":"9MtAM","2372692ff7fa0052":"9HEEB","b65cbe6251056457":"8QFOC","392c8322552ded22":"2FdJg","12537bf610da7799":"6AMGA","59ef8aab98a500e7":"erSvz","6e1f4784797cf921":"kqQOF","8e468568879b2c4b":"iivvn","2abed065e8645bab":"8YP4O","4c3874b4cb0b735b":"gkGXc","6390566357a58eee":"guLFz","eaa657c32564e994":"2onWA","c2484f18787b69a6":"htEzB","f69c22eae2e8874f":"aMtEM"}],"htEzB":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("32fd14148f21a471");
var createSafeContext = require("9e79d5a65d504973");
require("2acf4fe95e2ba2fe");
require("98dec3507821dc2e");
require("e9c4dff478a68b00");
require("a1486fae652a83c3");
require("526eb2909d7c8403");
require("7a2c7f9f65876482");
require("916dfa9eaec2ee9d");
require("a181404cebf98ffd");
require("7ec1ee91e8bb8da1");
require("834a010eec1b75ec");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Progress.Root component was not found in tree"), 2), ProgressProvider = _createSafeContext_createSafeContext[0], useProgressContext = _createSafeContext_createSafeContext[1];
exports.ProgressProvider = ProgressProvider;
exports.useProgressContext = useProgressContext; //# sourceMappingURL=Progress.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","32fd14148f21a471":"9MtAM","9e79d5a65d504973":"8srze","2acf4fe95e2ba2fe":"iKGFf","98dec3507821dc2e":"9HEEB","e9c4dff478a68b00":"8QFOC","a1486fae652a83c3":"2FdJg","526eb2909d7c8403":"6AMGA","7a2c7f9f65876482":"erSvz","916dfa9eaec2ee9d":"kqQOF","a181404cebf98ffd":"8YP4O","7ec1ee91e8bb8da1":"gkGXc","834a010eec1b75ec":"2onWA"}],"aMtEM":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_db6d6462",
    "section": "m_2242eb65",
    "stripes-animation": "m_81a374bd",
    "label": "m_91e40b74"
};
module.exports = classes; //# sourceMappingURL=Progress.module.css.cjs.map

},{}],"aVLPV":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("8bbf5c8371cbbc9c");
require("1113a110f1499a04");
var getSize = require("df5f0b31b44cd196");
require("80d66fdc1dd0c6b8");
var createVarsResolver = require("1514e33a39e4af25");
require("e0fe10b335fa4ee6");
require("5c657dfc210caabb");
require("d541fff32a3b1b39");
require("a6a39fa6dd823ebb");
require("4067e56714fe62de");
var useProps = require("f0221e0737bcb866");
require("6d2db82ac910c2a1");
var useStyles = require("4b7a9482a71f4a7d");
var Box = require("9c8e66609cadd0a5");
var factory = require("a36f3896f0e69923");
require("ddabc6f177de1861");
var Progress_context = require("7f45c88216a5be6c");
var Progress_module = require("aaf023b248d899a8");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, radius = param.radius, transitionDuration = param.transitionDuration;
    return {
        root: {
            "--progress-size": getSize.getSize(size, "progress-size"),
            "--progress-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--progress-transition-duration": typeof transitionDuration === "number" ? `${transitionDuration}ms` : void 0
        }
    };
});
var ProgressRoot = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ProgressRoot", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, autoContrast = props.autoContrast, transitionDuration = props.transitionDuration, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "autoContrast",
        "transitionDuration"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Progress",
        classes: Progress_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Progress_context.ProgressProvider, {
        value: {
            getStyles,
            autoContrast
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
            ref
        }, getStyles("root"), others))
    });
});
ProgressRoot.classes = Progress_module;
ProgressRoot.displayName = "@mantine/core/ProgressRoot";
exports.ProgressRoot = ProgressRoot; //# sourceMappingURL=ProgressRoot.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","8bbf5c8371cbbc9c":"iKGFf","1113a110f1499a04":"9MtAM","df5f0b31b44cd196":"kEFEY","80d66fdc1dd0c6b8":"9HEEB","1514e33a39e4af25":"hIQE6","e0fe10b335fa4ee6":"8QFOC","5c657dfc210caabb":"2FdJg","d541fff32a3b1b39":"6AMGA","a6a39fa6dd823ebb":"erSvz","4067e56714fe62de":"kqQOF","f0221e0737bcb866":"iivvn","6d2db82ac910c2a1":"8YP4O","4b7a9482a71f4a7d":"d0sAY","9c8e66609cadd0a5":"gkGXc","a36f3896f0e69923":"guLFz","ddabc6f177de1861":"2onWA","7f45c88216a5be6c":"htEzB","aaf023b248d899a8":"aMtEM"}],"biD1g":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f69081a3cb609be3");
require("453c68f8b34696f9");
require("912c1c428498e3da");
require("18c59f51723cf40e");
var getThemeColor = require("b6a16ae3f84877");
var getContrastColor = require("5fa1758de5c48f70");
var getAutoContrastValue = require("e40dd215749412da");
require("1f3b413ef1453eb6");
require("440f0d839f4a04ba");
require("14db63edec9cd887");
var MantineThemeProvider = require("78fb9bffdbd837b8");
var useProps = require("819a538656aeb3");
require("94a21dbc645dd3fd");
var Box = require("e67dc7355245d0b7");
var factory = require("a0578a6a0b6c3c81");
require("5b3682a7b71c80b7");
var Progress_context = require("5478756d8e03712b");
var Progress_module = require("69f58192d934b8f4");
var defaultProps = {
    withAria: true
};
var ProgressSection = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("ProgressSection", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, value = _useProps_useProps.value, withAria = _useProps_useProps.withAria, color = _useProps_useProps.color, striped = _useProps_useProps.striped, animated = _useProps_useProps.animated, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "value",
        "withAria",
        "color",
        "striped",
        "animated",
        "mod"
    ]);
    var ctx = Progress_context.useProgressContext();
    var theme = MantineThemeProvider.useMantineTheme();
    var ariaAttributes = withAria ? {
        role: "progressbar",
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": value,
        "aria-valuetext": `${value}%`
    } : {};
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, ctx.getStyles("section", {
        className,
        classNames,
        styles,
        style
    }), others, ariaAttributes), {
        mod: [
            {
                striped: striped || animated,
                animated
            },
            mod
        ],
        __vars: {
            "--progress-section-width": `${value}%`,
            "--progress-section-color": getThemeColor.getThemeColor(color, theme),
            "--progress-label-color": getAutoContrastValue.getAutoContrastValue(ctx.autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast: ctx.autoContrast
            }) : void 0
        }
    }));
});
ProgressSection.classes = Progress_module;
ProgressSection.displayName = "@mantine/core/ProgressSection";
exports.ProgressSection = ProgressSection; //# sourceMappingURL=ProgressSection.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f69081a3cb609be3":"iKGFf","453c68f8b34696f9":"9MtAM","912c1c428498e3da":"9HEEB","18c59f51723cf40e":"8QFOC","b6a16ae3f84877":"eeaIN","5fa1758de5c48f70":"ez6cW","e40dd215749412da":"cN4dA","1f3b413ef1453eb6":"2FdJg","440f0d839f4a04ba":"6AMGA","14db63edec9cd887":"erSvz","78fb9bffdbd837b8":"kqQOF","819a538656aeb3":"iivvn","94a21dbc645dd3fd":"8YP4O","e67dc7355245d0b7":"gkGXc","a0578a6a0b6c3c81":"guLFz","5b3682a7b71c80b7":"2onWA","5478756d8e03712b":"htEzB","69f58192d934b8f4":"aMtEM"}],"kpDwF":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("78d2c1100f1c4161");
var hooks = require("a3ba0629727b16c0");
require("4b5b945deca185c");
var getSize = require("a53258c074739e38");
var createVarsResolver = require("b24318301602cabf");
require("d28ea8711a30e00a");
var parseThemeColor = require("ee0631438ea2f5dd");
var getThemeColor = require("43683599cb1349e5");
var getContrastColor = require("3686bf4561ca3a53");
var getAutoContrastValue = require("9648022119a7fc90");
require("f02f523b8049b490");
require("d6ad057c711b723d");
require("8169f106486620bf");
require("e1f7ed72860ed670");
var useProps = require("699d9fc5695c0703");
require("73926ccda515abda");
var useStyles = require("92afab1d14c9db4f");
var extractStyleProps = require("646622d5add40c6e");
var Box = require("c7defddc73121d5a");
var factory = require("127a8374b748bbfb");
require("7606edbffb8ee292");
var InlineInput = require("2677a91e90cf9ccd");
var RadioCard = require("83caafb9e953b864");
var RadioGroup_context = require("6331c63b0ec88f61");
var RadioGroup = require("19da29022c844c6c");
var RadioIcon = require("8f88f6ea5db9b8cf");
var RadioIndicator = require("7b60ece0cb28a1d5");
var Radio_module = require("9c66010b64f6d995");
var defaultProps = {
    labelPosition: "right"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, radius = param.radius, color = param.color, iconColor = param.iconColor, variant = param.variant, autoContrast = param.autoContrast;
    var parsedColor = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme
    });
    var outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
    return {
        root: {
            "--radio-size": getSize.getSize(size, "radio-size"),
            "--radio-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--radio-color": variant === "outline" ? outlineColor : getThemeColor.getThemeColor(color, theme),
            "--radio-icon-color": iconColor ? getThemeColor.getThemeColor(iconColor, theme) : getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0,
            "--radio-icon-size": getSize.getSize(size, "radio-icon-size")
        }
    };
});
var Radio = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Radio", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, id = props.id, size = props.size, label = props.label, labelPosition = props.labelPosition, description = props.description, error = props.error, radius = props.radius, color = props.color, variant = props.variant, disabled = props.disabled, wrapperProps = props.wrapperProps, tmp = props.icon, Icon = tmp === void 0 ? RadioIcon.RadioIcon : tmp, rootRef = props.rootRef, iconColor = props.iconColor, onChange = props.onChange, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "id",
        "size",
        "label",
        "labelPosition",
        "description",
        "error",
        "radius",
        "color",
        "variant",
        "disabled",
        "wrapperProps",
        "icon",
        "rootRef",
        "iconColor",
        "onChange",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Radio",
        classes: Radio_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var ctx = RadioGroup_context.useRadioGroupContext();
    var _ctx_size;
    var contextSize = (_ctx_size = ctx === null || ctx === void 0 ? void 0 : ctx.size) !== null && _ctx_size !== void 0 ? _ctx_size : size;
    var componentSize = props.size ? size : contextSize;
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var uuid = hooks.useId(id);
    var _rest_name;
    var contextProps = ctx ? {
        checked: ctx.value === rest.value,
        name: (_rest_name = rest.name) !== null && _rest_name !== void 0 ? _rest_name : ctx.name,
        onChange: function(event) {
            ctx.onChange(event);
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        }
    } : {};
    return /* @__PURE__ */ jsxRuntime.jsx(InlineInput.InlineInput, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        __staticSelector: "Radio",
        __stylesApiProps: props,
        id: uuid,
        size: componentSize,
        labelPosition,
        label,
        description,
        error,
        disabled,
        classNames,
        styles,
        unstyled,
        "data-checked": contextProps.checked || void 0,
        variant,
        ref: rootRef,
        mod
    }), styleProps, wrapperProps), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("inner")), {
            mod: {
                "label-position": labelPosition
            },
            children: [
                /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("radio", {
                    focusable: true,
                    variant
                })), {
                    onChange
                }), rest, contextProps), {
                    component: "input",
                    mod: {
                        error: !!error
                    },
                    ref,
                    id: uuid,
                    disabled,
                    type: "radio"
                })),
                /* @__PURE__ */ jsxRuntime.jsx(Icon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("icon")), {
                    "aria-hidden": true
                }))
            ]
        }))
    }));
});
Radio.classes = Radio_module;
Radio.displayName = "@mantine/core/Radio";
Radio.Group = RadioGroup.RadioGroup;
Radio.Card = RadioCard.RadioCard;
Radio.Indicator = RadioIndicator.RadioIndicator;
exports.Radio = Radio; //# sourceMappingURL=Radio.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","78d2c1100f1c4161":"iKGFf","a3ba0629727b16c0":"9HEEB","4b5b945deca185c":"9MtAM","a53258c074739e38":"kEFEY","b24318301602cabf":"hIQE6","d28ea8711a30e00a":"8QFOC","ee0631438ea2f5dd":"ctp80","43683599cb1349e5":"eeaIN","3686bf4561ca3a53":"ez6cW","9648022119a7fc90":"cN4dA","f02f523b8049b490":"2FdJg","d6ad057c711b723d":"6AMGA","8169f106486620bf":"erSvz","e1f7ed72860ed670":"kqQOF","699d9fc5695c0703":"iivvn","73926ccda515abda":"8YP4O","92afab1d14c9db4f":"d0sAY","646622d5add40c6e":"6L93n","c7defddc73121d5a":"gkGXc","127a8374b748bbfb":"guLFz","7606edbffb8ee292":"2onWA","2677a91e90cf9ccd":"b2ROK","83caafb9e953b864":"kiVsz","6331c63b0ec88f61":"fJiMI","19da29022c844c6c":"8Awvq","8f88f6ea5db9b8cf":"bnRAI","7b60ece0cb28a1d5":"27y4h","9c66010b64f6d995":"e3H15"}],"kiVsz":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("6da006bdd183e6a0");
require("dfb72f84474a7054");
var getSize = require("210e6d673f9da27d");
require("e466d3607e4aafee");
var createVarsResolver = require("274103bad6c00294");
require("5ec4820acedc4fd");
require("9d6a0e8a7c96fdea");
require("c6b2a7c2b9a9aea4");
require("113c4bd405f244ef");
require("625680fbbb608b15");
var useProps = require("970fe836c5060a8f");
require("ed5dae90e733076e");
var useStyles = require("732e5126a9c70c1e");
require("f17d054f69f84647");
var factory = require("cfd4656078fb2546");
var DirectionProvider = require("a847cfad48e4f809");
var UnstyledButton = require("94d14f9f0e5b95d1");
var RadioGroup_context = require("dc55401df542bbb9");
var RadioCard_context = require("8bfa9a4e0eeb3ec9");
var RadioCard_module = require("8855f5efa8c144f5");
var defaultProps = {
    withBorder: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var radius = param.radius;
    return {
        card: {
            "--card-radius": getSize.getRadius(radius)
        }
    };
});
var RadioCard = factory.factory(function(_props, ref) {
    var props = useProps.useProps("RadioCard", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, checked = props.checked, mod = props.mod, withBorder = props.withBorder, value = props.value, onClick = props.onClick, name = props.name, onKeyDown = props.onKeyDown, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "checked",
        "mod",
        "withBorder",
        "value",
        "onClick",
        "name",
        "onKeyDown"
    ]);
    var getStyles = useStyles.useStyles({
        name: "RadioCard",
        classes: RadioCard_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "card"
    });
    var dir = DirectionProvider.useDirection().dir;
    var ctx = RadioGroup_context.useRadioGroupContext();
    var _checked = typeof checked === "boolean" ? checked : (ctx === null || ctx === void 0 ? void 0 : ctx.value) === value || false;
    var _name = name || (ctx === null || ctx === void 0 ? void 0 : ctx.name);
    var handleKeyDown = function(event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if ([
            "ArrowDown",
            "ArrowUp",
            "ArrowLeft",
            "ArrowRight"
        ].includes(event.nativeEvent.code)) {
            event.preventDefault();
            var siblings = Array.from(document.querySelectorAll(`[role="radio"][name="${_name || "__mantine"}"]`));
            var currentIndex = siblings.findIndex(function(element) {
                return element === event.target;
            });
            var nextIndex = currentIndex + 1 >= siblings.length ? 0 : currentIndex + 1;
            var prevIndex = currentIndex - 1 < 0 ? siblings.length - 1 : currentIndex - 1;
            if (event.nativeEvent.code === "ArrowDown") {
                siblings[nextIndex].focus();
                siblings[nextIndex].click();
            }
            if (event.nativeEvent.code === "ArrowUp") {
                siblings[prevIndex].focus();
                siblings[prevIndex].click();
            }
            if (event.nativeEvent.code === "ArrowLeft") {
                siblings[dir === "ltr" ? prevIndex : nextIndex].focus();
                siblings[dir === "ltr" ? prevIndex : nextIndex].click();
            }
            if (event.nativeEvent.code === "ArrowRight") {
                siblings[dir === "ltr" ? nextIndex : prevIndex].focus();
                siblings[dir === "ltr" ? nextIndex : prevIndex].click();
            }
        }
    };
    return /* @__PURE__ */ jsxRuntime.jsx(RadioCard_context.RadioCardProvider, {
        value: {
            checked: _checked
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref,
            mod: [
                {
                    "with-border": withBorder,
                    checked: _checked
                },
                mod
            ]
        }, getStyles("card"), others), {
            role: "radio",
            "aria-checked": _checked,
            name: _name,
            onClick: function(event) {
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
                ctx === null || ctx === void 0 ? void 0 : ctx.onChange(value || "");
            },
            onKeyDown: handleKeyDown
        }))
    });
});
RadioCard.displayName = "@mantine/core/RadioCard";
RadioCard.classes = RadioCard_module;
exports.RadioCard = RadioCard; //# sourceMappingURL=RadioCard.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","6da006bdd183e6a0":"iKGFf","dfb72f84474a7054":"9MtAM","210e6d673f9da27d":"kEFEY","e466d3607e4aafee":"9HEEB","274103bad6c00294":"hIQE6","5ec4820acedc4fd":"8QFOC","9d6a0e8a7c96fdea":"2FdJg","c6b2a7c2b9a9aea4":"6AMGA","113c4bd405f244ef":"erSvz","625680fbbb608b15":"kqQOF","970fe836c5060a8f":"iivvn","ed5dae90e733076e":"8YP4O","732e5126a9c70c1e":"d0sAY","f17d054f69f84647":"gkGXc","cfd4656078fb2546":"guLFz","a847cfad48e4f809":"2onWA","94d14f9f0e5b95d1":"cArqr","dc55401df542bbb9":"fJiMI","8bfa9a4e0eeb3ec9":"9CAYv","8855f5efa8c144f5":"gB1zj"}],"fJiMI":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("d092bd249be0a1a4");
require("3fbcb2a52773f945");
var createOptionalContext = require("224c8849d1a1cd5f");
require("35cee6d8f3a3cd42");
require("e84c0d6a03062bdc");
require("8cbaef6c244ef39c");
require("37fca6d4012878a");
require("120b7e9f4334d864");
require("35ff3482434da604");
require("bd65e87e9f4c2b40");
require("c54804ded6336ff9");
require("ad4ebfbd17034bff");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), RadioGroupProvider = _createOptionalContext_createOptionalContext[0], useRadioGroupContext = _createOptionalContext_createOptionalContext[1];
exports.RadioGroupProvider = RadioGroupProvider;
exports.useRadioGroupContext = useRadioGroupContext; //# sourceMappingURL=RadioGroup.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","d092bd249be0a1a4":"9MtAM","3fbcb2a52773f945":"iKGFf","224c8849d1a1cd5f":"7cMAR","35cee6d8f3a3cd42":"9HEEB","e84c0d6a03062bdc":"8QFOC","8cbaef6c244ef39c":"2FdJg","37fca6d4012878a":"6AMGA","120b7e9f4334d864":"erSvz","35ff3482434da604":"kqQOF","bd65e87e9f4c2b40":"8YP4O","c54804ded6336ff9":"gkGXc","ad4ebfbd17034bff":"2onWA"}],"9CAYv":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("6a384e118c8a825f");
require("eb828a57d6b50033");
var createOptionalContext = require("8a9225efd08deac3");
require("be68afac2917f6ca");
require("8085f163f8d6a252");
require("b3b492dac6bc61ac");
require("a1b80dd7b359f375");
require("adf0aa1ffd8eb9c0");
require("adc7733ec4e9624e");
require("e6bae9fb276df130");
require("d0fa1437c2973c28");
require("2b2fe23a27b65fff");
var _createOptionalContext_createOptionalContext = (0, _slicedToArray._)(createOptionalContext.createOptionalContext(), 2), RadioCardProvider = _createOptionalContext_createOptionalContext[0], useRadioCardContext = _createOptionalContext_createOptionalContext[1];
exports.RadioCardProvider = RadioCardProvider;
exports.useRadioCardContext = useRadioCardContext; //# sourceMappingURL=RadioCard.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","6a384e118c8a825f":"9MtAM","eb828a57d6b50033":"iKGFf","8a9225efd08deac3":"7cMAR","be68afac2917f6ca":"9HEEB","8085f163f8d6a252":"8QFOC","b3b492dac6bc61ac":"2FdJg","a1b80dd7b359f375":"6AMGA","adf0aa1ffd8eb9c0":"erSvz","adc7733ec4e9624e":"kqQOF","e6bae9fb276df130":"8YP4O","d0fa1437c2973c28":"gkGXc","2b2fe23a27b65fff":"2onWA"}],"gB1zj":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "card": "m_9dc8ae12"
};
module.exports = classes; //# sourceMappingURL=RadioCard.module.css.cjs.map

},{}],"8Awvq":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("4044c56cb7155b5e");
var hooks = require("3644a5bb054fb621");
require("7c13ff7cb27f4043");
require("b31b5ab894d02e08");
require("9c713e338cd31bd2");
require("96ffe0d75d7941f3");
require("5e3fc789113aef4e");
require("6c3c794d63d7f72");
var useProps = require("2e8b90e9c5253444");
require("aafd92d01e0efc2");
require("c4a06716843e4c16");
var factory = require("21584cc59ee369c4");
require("8de5886ac45baeb8");
var Input = require("fc4659567530e5c0");
require("767a480b0b584a29");
require("ffff4ae0ea865738");
require("385f4ecd4fe55ca7");
require("f84301860014672c");
require("e8bb83b6b64ce403");
require("367b5985c8a62656");
require("262f272078dfbe4");
var InputsGroupFieldset = require("bc138505a581098d");
var RadioGroup_context = require("a4bc3113b8e329e2");
var defaultProps = {};
var RadioGroup = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("RadioGroup", defaultProps, props), value = _useProps_useProps.value, defaultValue = _useProps_useProps.defaultValue, onChange = _useProps_useProps.onChange, size = _useProps_useProps.size, wrapperProps = _useProps_useProps.wrapperProps, children = _useProps_useProps.children, name = _useProps_useProps.name, readOnly = _useProps_useProps.readOnly, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "value",
        "defaultValue",
        "onChange",
        "size",
        "wrapperProps",
        "children",
        "name",
        "readOnly"
    ]);
    var _name = hooks.useId(name);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: "",
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var handleChange = function(event) {
        return !readOnly && setValue(typeof event === "string" ? event : event.currentTarget.value);
    };
    return /* @__PURE__ */ jsxRuntime.jsx(RadioGroup_context.RadioGroupProvider, {
        value: {
            value: _value,
            onChange: handleChange,
            size,
            name: _name
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Wrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({
            size,
            ref
        }, wrapperProps, others), {
            labelElement: "div",
            __staticSelector: "RadioGroup",
            children: /* @__PURE__ */ jsxRuntime.jsx(InputsGroupFieldset.InputsGroupFieldset, {
                role: "radiogroup",
                children
            })
        }))
    });
});
RadioGroup.classes = Input.Input.Wrapper.classes;
RadioGroup.displayName = "@mantine/core/RadioGroup";
exports.RadioGroup = RadioGroup; //# sourceMappingURL=RadioGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","4044c56cb7155b5e":"iKGFf","3644a5bb054fb621":"9HEEB","7c13ff7cb27f4043":"9MtAM","b31b5ab894d02e08":"8QFOC","9c713e338cd31bd2":"2FdJg","96ffe0d75d7941f3":"6AMGA","5e3fc789113aef4e":"erSvz","6c3c794d63d7f72":"kqQOF","2e8b90e9c5253444":"iivvn","aafd92d01e0efc2":"8YP4O","c4a06716843e4c16":"gkGXc","21584cc59ee369c4":"guLFz","8de5886ac45baeb8":"2onWA","fc4659567530e5c0":"dkUgf","767a480b0b584a29":"j4uTK","ffff4ae0ea865738":"7nO1x","385f4ecd4fe55ca7":"3Bda4","f84301860014672c":"gQBOr","e8bb83b6b64ce403":"lRBdM","367b5985c8a62656":"hxtex","262f272078dfbe4":"lQt5D","bc138505a581098d":"j4N9U","a4bc3113b8e329e2":"fJiMI"}],"bnRAI":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("460b2b228ca39101");
var rem = require("abdfa97093120696");
require("ea9fe82f7af04f66");
require("b961edddbdb0061a");
require("bff26e5c0d4e0e9a");
require("2332eafd8e9d0ba");
require("6c6134308b80dbc7");
require("7e09b4538029fed8");
require("d75b9fb0f0cfd049");
require("16242fa7aea54d42");
require("1b5b8b22d232e9f6");
require("a75d34577593afe4");
function RadioIcon(_param) {
    var size = _param.size, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "size",
        "style"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 5 5",
        style: (0, _objectSpread._)({
            width: rem.rem(size),
            height: rem.rem(size)
        }, style),
        "aria-hidden": true
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("circle", {
            cx: "2.5",
            cy: "2.5",
            r: "2.5",
            fill: "currentColor"
        })
    }));
}
exports.RadioIcon = RadioIcon; //# sourceMappingURL=RadioIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","460b2b228ca39101":"iKGFf","abdfa97093120696":"ebAaL","ea9fe82f7af04f66":"9MtAM","b961edddbdb0061a":"9HEEB","bff26e5c0d4e0e9a":"8QFOC","2332eafd8e9d0ba":"2FdJg","6c6134308b80dbc7":"6AMGA","7e09b4538029fed8":"erSvz","d75b9fb0f0cfd049":"kqQOF","16242fa7aea54d42":"8YP4O","1b5b8b22d232e9f6":"gkGXc","a75d34577593afe4":"2onWA"}],"27y4h":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3875288259b192a");
require("e3125c9bf71fdf11");
var getSize = require("5bf4db80b77f37fa");
require("c4da5d3ff12a08ad");
var createVarsResolver = require("13b18da7ce1435fd");
require("580a422291ae1d6b");
var parseThemeColor = require("8f59dbd0f2dd4317");
var getThemeColor = require("420acb6a07908037");
var getContrastColor = require("9768da8b7fdd59b");
var getAutoContrastValue = require("35e1be91f8dca6cc");
require("40c3b8b7978e464e");
require("42ec8176ea551a3f");
require("42182914fdcb0c2d");
require("a411396c467a17eb");
var useProps = require("8a1118756834ad60");
require("d86e6ab639cd3fed");
var useStyles = require("4c6d854a53a3998a");
var Box = require("d14fdf0da40aaee2");
var factory = require("eb3a6032d0a1ae55");
require("eecd675c53acd4fe");
var RadioCard_context = require("c11c2db0f9df1f8");
var RadioIcon = require("af9c75d202a68f4f");
var RadioIndicator_module = require("1bf9215e074558fe");
var defaultProps = {
    icon: RadioIcon.RadioIcon
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, size = param.size, iconColor = param.iconColor, variant = param.variant, autoContrast = param.autoContrast;
    var parsedColor = parseThemeColor.parseThemeColor({
        color: color || theme.primaryColor,
        theme
    });
    var outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
    return {
        indicator: {
            "--radio-size": getSize.getSize(size, "radio-size"),
            "--radio-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--radio-color": variant === "outline" ? outlineColor : getThemeColor.getThemeColor(color, theme),
            "--radio-icon-size": getSize.getSize(size, "radio-icon-size"),
            "--radio-icon-color": iconColor ? getThemeColor.getThemeColor(iconColor, theme) : getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
var RadioIndicator = factory.factory(function(_props, ref) {
    var props = useProps.useProps("RadioIndicator", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, icon = props.icon, radius = props.radius, color = props.color, iconColor = props.iconColor, autoContrast = props.autoContrast, checked = props.checked, mod = props.mod, variant = props.variant, disabled = props.disabled, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "icon",
        "radius",
        "color",
        "iconColor",
        "autoContrast",
        "checked",
        "mod",
        "variant",
        "disabled"
    ]);
    var Icon = icon;
    var getStyles = useStyles.useStyles({
        name: "RadioIndicator",
        classes: RadioIndicator_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "indicator"
    });
    var ctx = RadioCard_context.useRadioCardContext();
    var _checked = typeof checked === "boolean" ? checked : (ctx === null || ctx === void 0 ? void 0 : ctx.checked) || false;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("indicator", {
        variant
    })), {
        variant,
        mod: [
            {
                checked: _checked,
                disabled
            },
            mod
        ]
    }), others), {
        children: /* @__PURE__ */ jsxRuntime.jsx(Icon, (0, _objectSpread._)({}, getStyles("icon")))
    }));
});
RadioIndicator.displayName = "@mantine/core/RadioIndicator";
RadioIndicator.classes = RadioIndicator_module;
exports.RadioIndicator = RadioIndicator; //# sourceMappingURL=RadioIndicator.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","3875288259b192a":"iKGFf","e3125c9bf71fdf11":"9MtAM","5bf4db80b77f37fa":"kEFEY","c4da5d3ff12a08ad":"9HEEB","13b18da7ce1435fd":"hIQE6","580a422291ae1d6b":"8QFOC","8f59dbd0f2dd4317":"ctp80","420acb6a07908037":"eeaIN","9768da8b7fdd59b":"ez6cW","35e1be91f8dca6cc":"cN4dA","40c3b8b7978e464e":"2FdJg","42ec8176ea551a3f":"6AMGA","42182914fdcb0c2d":"erSvz","a411396c467a17eb":"kqQOF","8a1118756834ad60":"iivvn","d86e6ab639cd3fed":"8YP4O","4c6d854a53a3998a":"d0sAY","d14fdf0da40aaee2":"gkGXc","eb3a6032d0a1ae55":"guLFz","eecd675c53acd4fe":"2onWA","c11c2db0f9df1f8":"9CAYv","af9c75d202a68f4f":"bnRAI","1bf9215e074558fe":"l6doS"}],"l6doS":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "indicator": "m_717d7ff6",
    "icon": "m_3e4da632",
    "indicator--outline": "m_2980836c"
};
module.exports = classes; //# sourceMappingURL=RadioIndicator.module.css.cjs.map

},{}],"e3H15":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f3f1af94",
    "inner": "m_89c4f5e4",
    "icon": "m_f3ed6b2b",
    "radio": "m_8a3dbb89",
    "radio--outline": "m_1bfe9d39"
};
module.exports = classes; //# sourceMappingURL=Radio.module.css.cjs.map

},{}],"jdz2m":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("e872b399267ad6c4");
var React = require("cbe855bf0e40d635");
var hooks = require("37e9a707a723e326");
var getSize = require("19c1ad87428f2358");
var createVarsResolver = require("dd1e825f55987a8d");
require("eb83f31661a8d3e6");
var getThemeColor = require("c5b83238032b1f33");
require("722b3813a35af987");
require("7eec924a85669ecb");
require("b41f5b803b39a7d9");
require("8a6bd638d63897c8");
var useProps = require("962ecf503fa651f3");
require("bea299d63b182c79");
var useStyles = require("68144d182269da36");
var Box = require("4e6f82bd70ab73ce");
var factory = require("16c6337daea7b000");
var DirectionProvider = require("dad3504892effb3");
var Rating_context = require("ee4aa7bbf4ee8a1e");
var RatingItem = require("f54d19339d913522");
var Rating_module = require("1b812c30b83e7c27");
function roundValueTo(value, to) {
    var _split_;
    var rounded = Math.round(value / to) * to;
    var precision = ((_split_ = `${to}`.split(".")[1]) === null || _split_ === void 0 ? void 0 : _split_.length) || 0;
    return Number(rounded.toFixed(precision));
}
var defaultProps = {
    size: "sm",
    getSymbolLabel: function(value) {
        return `${value}`;
    },
    count: 5,
    fractions: 1,
    color: "yellow"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, color = param.color;
    return {
        root: {
            "--rating-size": getSize.getSize(size, "rating-size"),
            "--rating-color": getThemeColor.getThemeColor(color, theme)
        }
    };
});
var Rating = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Rating", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, name = props.name, id = props.id, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, fractions = props.fractions, count = props.count, onMouseEnter = props.onMouseEnter, readOnly = props.readOnly, onMouseMove = props.onMouseMove, onHover = props.onHover, onMouseLeave = props.onMouseLeave, onTouchStart = props.onTouchStart, onTouchEnd = props.onTouchEnd, size = props.size, variant = props.variant, getSymbolLabel = props.getSymbolLabel, color = props.color, emptySymbol = props.emptySymbol, fullSymbol = props.fullSymbol, highlightSelectedOnly = props.highlightSelectedOnly, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "name",
        "id",
        "value",
        "defaultValue",
        "onChange",
        "fractions",
        "count",
        "onMouseEnter",
        "readOnly",
        "onMouseMove",
        "onHover",
        "onMouseLeave",
        "onTouchStart",
        "onTouchEnd",
        "size",
        "variant",
        "getSymbolLabel",
        "color",
        "emptySymbol",
        "fullSymbol",
        "highlightSelectedOnly"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Rating",
        classes: Rating_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var dir = DirectionProvider.useDirection().dir;
    var _name = hooks.useId(name);
    var _id = hooks.useId(id);
    var rootRef = React.useRef(null);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: 0,
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var _React_useState = (0, _slicedToArray._)(React.useState(-1), 2), hovered = _React_useState[0], setHovered = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(true), 2), isOutside = _React_useState1[0], setOutside = _React_useState1[1];
    var _fractions = Math.floor(fractions);
    var _count = Math.floor(count);
    var decimalUnit = 1 / _fractions;
    var stableValueRounded = roundValueTo(_value, decimalUnit);
    var finalValue = hovered !== -1 ? hovered : stableValueRounded;
    var getRatingFromCoordinates = function(x) {
        var _rootRef_current_getBoundingClientRect = rootRef.current.getBoundingClientRect(), left = _rootRef_current_getBoundingClientRect.left, right = _rootRef_current_getBoundingClientRect.right, width = _rootRef_current_getBoundingClientRect.width;
        var symbolWidth = width / _count;
        var hoverPosition = dir === "rtl" ? right - x : x - left;
        var hoverValue = hoverPosition / symbolWidth;
        return hooks.clamp(roundValueTo(hoverValue + decimalUnit / 2, decimalUnit), decimalUnit, _count);
    };
    var handleMouseEnter = function(event) {
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(event);
        !readOnly && setOutside(false);
    };
    var handleMouseMove = function(event) {
        onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(event);
        if (readOnly) return;
        var rounded = getRatingFromCoordinates(event.clientX);
        setHovered(rounded);
        rounded !== hovered && (onHover === null || onHover === void 0 ? void 0 : onHover(rounded));
    };
    var handleMouseLeave = function(event) {
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(event);
        if (readOnly) return;
        setHovered(-1);
        setOutside(true);
        hovered !== -1 && (onHover === null || onHover === void 0 ? void 0 : onHover(-1));
    };
    var handleTouchStart = function(event) {
        var touches = event.touches;
        if (touches.length !== 1) return;
        if (!readOnly) {
            var touch = touches[0];
            setValue(getRatingFromCoordinates(touch.clientX));
        }
        onTouchStart === null || onTouchStart === void 0 ? void 0 : onTouchStart(event);
    };
    var handleTouchEnd = function(event) {
        event.preventDefault();
        onTouchEnd === null || onTouchEnd === void 0 ? void 0 : onTouchEnd(event);
    };
    var handleItemBlur = function() {
        return isOutside && setHovered(-1);
    };
    var handleInputChange = function(event) {
        if (!readOnly) {
            if (typeof event === "number") setHovered(event);
            else setHovered(parseFloat(event.target.value));
        }
    };
    var handleChange = function(event) {
        if (!readOnly) {
            if (typeof event === "number") setValue(event);
            else setValue(parseFloat(event.target.value));
        }
    };
    var items = Array(_count).fill(0).map(function(_, index) {
        var integerValue = index + 1;
        var fractionItems = Array.from(new Array(index === 0 ? _fractions + 1 : _fractions));
        var isGroupActive = !readOnly && Math.ceil(hovered) === integerValue;
        return /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
            "data-active": isGroupActive || void 0
        }, getStyles("symbolGroup")), {
            children: fractionItems.map(function(__, fractionIndex) {
                var fractionValue = decimalUnit * (index === 0 ? fractionIndex : fractionIndex + 1);
                var symbolValue = roundValueTo(integerValue - 1 + fractionValue, decimalUnit);
                return /* @__PURE__ */ jsxRuntime.jsx(RatingItem.RatingItem, {
                    getSymbolLabel,
                    emptyIcon: emptySymbol,
                    fullIcon: fullSymbol,
                    full: highlightSelectedOnly ? symbolValue === finalValue : symbolValue <= finalValue,
                    active: symbolValue === finalValue,
                    checked: symbolValue === stableValueRounded,
                    readOnly,
                    fractionValue,
                    value: symbolValue,
                    name: _name,
                    onChange: handleChange,
                    onBlur: handleItemBlur,
                    onInputChange: handleInputChange,
                    id: `${_id}-${index}-${fractionIndex}`
                }, `${integerValue}-${symbolValue}`);
            })
        }), integerValue);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Rating_context.RatingProvider, {
        value: {
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            ref: hooks.useMergedRef(rootRef, ref)
        }, getStyles("root")), {
            onMouseMove: handleMouseMove,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onTouchStart: handleTouchStart,
            onTouchEnd: handleTouchEnd,
            variant,
            size,
            id: _id
        }), others), {
            children: items
        }))
    });
});
Rating.classes = Rating_module;
Rating.displayName = "@mantine/core/Rating";
exports.Rating = Rating; //# sourceMappingURL=Rating.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","e872b399267ad6c4":"iKGFf","cbe855bf0e40d635":"9MtAM","37e9a707a723e326":"9HEEB","19c1ad87428f2358":"kEFEY","dd1e825f55987a8d":"hIQE6","eb83f31661a8d3e6":"8QFOC","c5b83238032b1f33":"eeaIN","722b3813a35af987":"2FdJg","7eec924a85669ecb":"6AMGA","b41f5b803b39a7d9":"erSvz","8a6bd638d63897c8":"kqQOF","962ecf503fa651f3":"iivvn","bea299d63b182c79":"8YP4O","68144d182269da36":"d0sAY","4e6f82bd70ab73ce":"gkGXc","16c6337daea7b000":"guLFz","dad3504892effb3":"2onWA","ee4aa7bbf4ee8a1e":"hxO6v","f54d19339d913522":"6IFZj","1b812c30b83e7c27":"j4OsH"}],"hxO6v":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("36ff3843cd2f5088");
var createSafeContext = require("d2def8c858563650");
require("9be6516f7c3e3fa6");
require("3c46d7ddbca40839");
require("c42accf82fe69e71");
require("755c361336ff3cc2");
require("f6270c686a247cc3");
require("dae2d893b76596ea");
require("18d88995fc556d05");
require("cca91d48aa52a0");
require("304dd13eff8d714");
require("508949e578df15f5");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Rating was not found in tree"), 2), RatingProvider = _createSafeContext_createSafeContext[0], useRatingContext = _createSafeContext_createSafeContext[1];
exports.RatingProvider = RatingProvider;
exports.useRatingContext = useRatingContext; //# sourceMappingURL=Rating.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","36ff3843cd2f5088":"9MtAM","d2def8c858563650":"8srze","9be6516f7c3e3fa6":"iKGFf","3c46d7ddbca40839":"9HEEB","c42accf82fe69e71":"8QFOC","755c361336ff3cc2":"2FdJg","f6270c686a247cc3":"6AMGA","dae2d893b76596ea":"erSvz","18d88995fc556d05":"kqQOF","cca91d48aa52a0":"8YP4O","304dd13eff8d714":"gkGXc","508949e578df15f5":"2onWA"}],"6IFZj":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("e1fafd0e320443fc");
require("c47295193f8074bf");
require("a200063133f62f4c");
require("63cdf94e87da89b5");
require("c9aebae8ad952f83");
require("36ec9d70d9b695d1");
require("31bd68935853ce03");
require("db4ecadf841eab87");
require("8e659ba1d00756d7");
var Box = require("afc3502a89fa4844");
var DirectionProvider = require("eac92ac1c24d9f61");
var Rating_context = require("c8ea582dde488fdc");
var StarSymbol = require("450842aeae348314");
function RatingItem(_param) {
    var getSymbolLabel = _param.getSymbolLabel, emptyIcon = _param.emptyIcon, fullIcon = _param.fullIcon, full = _param.full, active = _param.active, value = _param.value, readOnly = _param.readOnly, fractionValue = _param.fractionValue, color = _param.color, id = _param.id, onBlur = _param.onBlur, onChange = _param.onChange, onInputChange = _param.onInputChange, style = _param.style, others = (0, _objectWithoutProperties._)(_param, [
        "getSymbolLabel",
        "emptyIcon",
        "fullIcon",
        "full",
        "active",
        "value",
        "readOnly",
        "fractionValue",
        "color",
        "id",
        "onBlur",
        "onChange",
        "onInputChange",
        "style"
    ]);
    var _this;
    var ctx = Rating_context.useRatingContext();
    var _fullIcon = typeof fullIcon === "function" ? fullIcon(value) : fullIcon;
    var _emptyIcon = typeof emptyIcon === "function" ? emptyIcon(value) : emptyIcon;
    var dir = DirectionProvider.useDirection().dir;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            !readOnly && /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("input")), {
                onKeyDown: function(event) {
                    return event.key === " " && onChange(value);
                },
                id,
                type: "radio",
                "data-active": active || void 0,
                "aria-label": getSymbolLabel === null || getSymbolLabel === void 0 ? void 0 : getSymbolLabel(value),
                value,
                onBlur,
                onChange: onInputChange
            }), others)),
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                component: readOnly ? "div" : "label"
            }, ctx.getStyles("label")), {
                "data-read-only": readOnly || void 0,
                htmlFor: id,
                onClick: function() {
                    return onChange(value);
                },
                __vars: {
                    "--rating-item-z-index": (_this = fractionValue === 1 ? void 0 : active ? 2 : 0) === null || _this === void 0 ? void 0 : _this.toString()
                },
                children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("symbolBody")), {
                    __vars: {
                        "--rating-symbol-clip-path": fractionValue === 1 ? void 0 : dir === "ltr" ? `inset(0 ${active ? 100 - fractionValue * 100 : 100}% 0 0)` : `inset(0 0 0 ${active ? 100 - fractionValue * 100 : 100}% )`
                    },
                    children: full ? _fullIcon || /* @__PURE__ */ jsxRuntime.jsx(StarSymbol.StarSymbol, {
                        type: "full"
                    }) : _emptyIcon || /* @__PURE__ */ jsxRuntime.jsx(StarSymbol.StarSymbol, {
                        type: "empty"
                    })
                }))
            }))
        ]
    });
}
RatingItem.displayName = "@mantine/core/RatingItem";
exports.RatingItem = RatingItem; //# sourceMappingURL=RatingItem.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","e1fafd0e320443fc":"iKGFf","c47295193f8074bf":"9MtAM","a200063133f62f4c":"9HEEB","63cdf94e87da89b5":"8QFOC","c9aebae8ad952f83":"2FdJg","36ec9d70d9b695d1":"6AMGA","31bd68935853ce03":"erSvz","db4ecadf841eab87":"kqQOF","8e659ba1d00756d7":"8YP4O","afc3502a89fa4844":"gkGXc","eac92ac1c24d9f61":"2onWA","c8ea582dde488fdc":"hxO6v","450842aeae348314":"kNHFv"}],"kNHFv":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("38f4bc8d5d1685b0");
var Rating_context = require("3ed6f5b41456aeb0");
var StarIcon = require("bad93b4e5cb00223");
function StarSymbol(param) {
    var type = param.type;
    var ctx = Rating_context.useRatingContext();
    return /* @__PURE__ */ jsxRuntime.jsx(StarIcon.StarIcon, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("starSymbol")), {
        "data-filled": type === "full" || void 0
    }));
}
StarSymbol.displayName = "@mantine/core/StarSymbol";
exports.StarSymbol = StarSymbol; //# sourceMappingURL=StarSymbol.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","38f4bc8d5d1685b0":"iKGFf","3ed6f5b41456aeb0":"hxO6v","bad93b4e5cb00223":"fn18Z"}],"fn18Z":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2099d9116d4512e1");
function StarIcon(props) {
    var width = props.width, height = props.height, style = props.style, others = (0, _objectWithoutProperties._)(props, [
        "width",
        "height",
        "style"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        viewBox: "0 0 24 24",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: (0, _objectSpread._)({
            width,
            height
        }, style)
    }, others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("path", {
            d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
        })
    }));
}
StarIcon.displayName = "@mantine/core/StarIcon";
exports.StarIcon = StarIcon; //# sourceMappingURL=StarIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","2099d9116d4512e1":"iKGFf"}],"j4OsH":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f8d312f2",
    "symbolGroup": "m_61734bb7",
    "starSymbol": "m_5662a89a",
    "input": "m_211007ba",
    "label": "m_21342ee4",
    "symbolBody": "m_fae05d6a"
};
module.exports = classes; //# sourceMappingURL=Rating.module.css.cjs.map

},{}],"1g8WP":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("55a00c63fe287a5");
var React = require("f295200f44d33919");
var rem = require("e76647b86d6d452f");
require("e59643b00e58515b");
var createVarsResolver = require("b916355cab5981e");
require("a2ab25cec17da0cf");
require("e02cea80e10402be");
require("9c2a7b623a1296e");
require("23994587b328bf29");
require("34aed42f1630d9b7");
var useProps = require("1b169eb3dd5f6f1d");
require("6af29b189cca4fef");
var useStyles = require("a1b440b846dbe8d7");
var Box = require("430a041f3859c5b4");
var factory = require("a27724c6094e893e");
require("c4c6273192b440fa");
var Curve = require("5e17332c135e146b");
var getCurves = require("c2f56a073e5919d6");
var RingProgress_module = require("505e23897669f1a4");
function getClampedThickness(thickness, size) {
    return Math.min(thickness || 12, (size || 120) / 4);
}
var defaultProps = {
    size: 120,
    thickness: 12
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var size = param.size, thickness = param.thickness, transitionDuration = param.transitionDuration;
    return {
        root: {
            "--rp-size": rem.rem(size),
            "--rp-label-offset": rem.rem(thickness * 2),
            "--rp-transition-duration": transitionDuration ? `${transitionDuration}ms` : void 0
        }
    };
});
var RingProgress = factory.factory(function(_props, ref) {
    var props = useProps.useProps("RingProgress", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, label = props.label, sections = props.sections, size = props.size, thickness = props.thickness, roundCaps = props.roundCaps, rootColor = props.rootColor, transitionDuration = props.transitionDuration, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "label",
        "sections",
        "size",
        "thickness",
        "roundCaps",
        "rootColor",
        "transitionDuration"
    ]);
    var getStyles = useStyles.useStyles({
        name: "RingProgress",
        classes: RingProgress_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var clampedThickness = getClampedThickness(thickness, size);
    var curves = getCurves.getCurves({
        size,
        thickness: clampedThickness,
        sections,
        renderRoundedLineCaps: roundCaps,
        rootColor
    }).map(function(param, index) {
        var data = param.data, sum = param.sum, root = param.root, lineRoundCaps = param.lineRoundCaps, offset = param.offset;
        return /* @__PURE__ */ React.createElement(Curve.Curve, (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
            key: index,
            size,
            thickness: clampedThickness,
            sum,
            offset,
            color: data === null || data === void 0 ? void 0 : data.color,
            root,
            lineRoundCaps,
            getStyles
        }));
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        size,
        ref
    }), others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("svg")), {
                children: curves
            })),
            label && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label")), {
                children: label
            }))
        ]
    }));
});
RingProgress.classes = RingProgress_module;
RingProgress.displayName = "@mantine/core/RingProgress";
exports.RingProgress = RingProgress; //# sourceMappingURL=RingProgress.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","55a00c63fe287a5":"iKGFf","f295200f44d33919":"9MtAM","e76647b86d6d452f":"ebAaL","e59643b00e58515b":"9HEEB","b916355cab5981e":"hIQE6","a2ab25cec17da0cf":"8QFOC","e02cea80e10402be":"2FdJg","9c2a7b623a1296e":"6AMGA","23994587b328bf29":"erSvz","34aed42f1630d9b7":"kqQOF","1b169eb3dd5f6f1d":"iivvn","6af29b189cca4fef":"8YP4O","a1b440b846dbe8d7":"d0sAY","430a041f3859c5b4":"gkGXc","a27724c6094e893e":"guLFz","c4c6273192b440fa":"2onWA","5e17332c135e146b":"llJyB","c2f56a073e5919d6":"8bg2D","505e23897669f1a4":"gilWJ"}],"llJyB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("e95bbd8de07fb5d3");
require("27e85ff58ff62af7");
require("7cb444d57e3a64ea");
require("efd66690aa82dbea");
var getThemeColor = require("5b117a27ea118943");
require("6a98dc40cbd31756");
require("7419aadca6ecdb80");
require("427ffa9953f550ae");
var MantineThemeProvider = require("d0daab8576e78a31");
require("af70cda3bab4f496");
var Box = require("f4799f4f2b7ca9d2");
require("93d404599a4929bd");
var Tooltip = require("6a4a25b4bdfa0072");
require("39506d36e211ab4c");
require("ea523b0968ff2a04");
var getCurveProps = require("5045985e205e5073");
function Curve(_param) {
    var size = _param.size, value = _param.value, offset = _param.offset, sum = _param.sum, thickness = _param.thickness, root = _param.root, color = _param.color, lineRoundCaps = _param.lineRoundCaps, tooltip = _param.tooltip, getStyles = _param.getStyles, display = _param.display, others = (0, _objectWithoutProperties._)(_param, [
        "size",
        "value",
        "offset",
        "sum",
        "thickness",
        "root",
        "color",
        "lineRoundCaps",
        "tooltip",
        "getStyles",
        "display"
    ]);
    var theme = MantineThemeProvider.useMantineTheme();
    return /* @__PURE__ */ jsxRuntime.jsx(Tooltip.Tooltip.Floating, {
        disabled: !tooltip,
        label: tooltip,
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            component: "circle"
        }, others, getStyles("curve")), {
            __vars: {
                "--curve-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
            },
            fill: "none",
            strokeLinecap: lineRoundCaps ? "round" : "butt"
        }), getCurveProps.getCurveProps({
            sum,
            size,
            thickness,
            value,
            offset,
            root
        })))
    });
}
Curve.displayName = "@mantine/core/Curve";
exports.Curve = Curve; //# sourceMappingURL=Curve.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","e95bbd8de07fb5d3":"iKGFf","27e85ff58ff62af7":"9MtAM","7cb444d57e3a64ea":"9HEEB","efd66690aa82dbea":"8QFOC","5b117a27ea118943":"eeaIN","6a98dc40cbd31756":"2FdJg","7419aadca6ecdb80":"6AMGA","427ffa9953f550ae":"erSvz","d0daab8576e78a31":"kqQOF","af70cda3bab4f496":"8YP4O","f4799f4f2b7ca9d2":"gkGXc","93d404599a4929bd":"2onWA","6a4a25b4bdfa0072":"bSefP","39506d36e211ab4c":"dymYJ","ea523b0968ff2a04":"ebd04","5045985e205e5073":"by57P"}],"bSefP":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("6ae46e1d71a1f4ad");
var React = require("569d95c70bcc2222");
var cx = require("75ef04f3e84ac24a");
var hooks = require("850af840d988992e");
var isElement = require("6ab154cfe62d11fb");
var getDefaultZIndex = require("e31f4cfae3992d3f");
var getSize = require("3652399d8163d85e");
var getRefProp = require("421155e62c1ecc42");
var createVarsResolver = require("5e485b430b0e5920");
var getThemeColor = require("f53ee0970bc6164f");
require("62a1d3287c9716e6");
require("923da85ad39df5a5");
require("abd4a041c68de7db");
require("8996761f282c66e7");
var useProps = require("dc2491af94e69656");
require("fc63763a67d524ab");
var useStyles = require("12bb7ae8bc0cdd3d");
var Box = require("f3402901b4ec32c9");
var factory = require("57918f0bc20352e3");
var DirectionProvider = require("984c8d6667c55344");
require("ab96afcb1d58bc3e");
var getFloatingPosition = require("dc0ab52a8e92481");
var FloatingArrow = require("5caf32c11b671ae4");
require("5576ee033c8dbefa");
var OptionalPortal = require("3093cccdab7a8548");
var Transition = require("c3c869c15433b84");
var getTransitionProps = require("ffed7b13ce916934");
var TooltipFloating = require("3b34636765eab397");
var TooltipGroup = require("64b27442e69552f8");
var useTooltip = require("b7f4422d5b69259a");
var Tooltip_module = require("a6d40dcaa2ae76d8");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var cx__default = /*#__PURE__*/ _interopDefault(cx);
var defaultProps = {
    position: "top",
    refProp: "ref",
    withinPortal: true,
    inline: false,
    defaultOpened: false,
    arrowSize: 4,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    offset: 5,
    transitionProps: {
        duration: 100,
        transition: "fade"
    },
    events: {
        hover: true,
        focus: false,
        touch: false
    },
    zIndex: getDefaultZIndex.getDefaultZIndex("popover"),
    positionDependencies: [],
    middlewares: {
        flip: true,
        shift: true,
        inline: false
    }
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color;
    return {
        tooltip: {
            "--tooltip-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--tooltip-bg": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--tooltip-color": color ? "var(--mantine-color-white)" : void 0
        }
    };
});
var Tooltip = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Tooltip", defaultProps, _props);
    var _useProps_useProps = useProps.useProps("Tooltip", defaultProps, props), children = _useProps_useProps.children, position = _useProps_useProps.position, refProp = _useProps_useProps.refProp, label = _useProps_useProps.label, openDelay = _useProps_useProps.openDelay, closeDelay = _useProps_useProps.closeDelay, onPositionChange = _useProps_useProps.onPositionChange, opened = _useProps_useProps.opened, defaultOpened = _useProps_useProps.defaultOpened, withinPortal = _useProps_useProps.withinPortal, radius = _useProps_useProps.radius, color = _useProps_useProps.color, classNames = _useProps_useProps.classNames, styles = _useProps_useProps.styles, unstyled = _useProps_useProps.unstyled, style = _useProps_useProps.style, className = _useProps_useProps.className, withArrow = _useProps_useProps.withArrow, arrowSize = _useProps_useProps.arrowSize, arrowOffset = _useProps_useProps.arrowOffset, arrowRadius = _useProps_useProps.arrowRadius, arrowPosition = _useProps_useProps.arrowPosition, offset = _useProps_useProps.offset, transitionProps = _useProps_useProps.transitionProps, multiline = _useProps_useProps.multiline, events = _useProps_useProps.events, zIndex = _useProps_useProps.zIndex, disabled = _useProps_useProps.disabled, positionDependencies = _useProps_useProps.positionDependencies, onClick = _useProps_useProps.onClick, onMouseEnter = _useProps_useProps.onMouseEnter, onMouseLeave = _useProps_useProps.onMouseLeave, inline = _useProps_useProps.inline, variant = _useProps_useProps.variant, keepMounted = _useProps_useProps.keepMounted, vars = _useProps_useProps.vars, portalProps = _useProps_useProps.portalProps, mod = _useProps_useProps.mod, floatingStrategy = _useProps_useProps.floatingStrategy, middlewares = _useProps_useProps.middlewares, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "children",
        "position",
        "refProp",
        "label",
        "openDelay",
        "closeDelay",
        "onPositionChange",
        "opened",
        "defaultOpened",
        "withinPortal",
        "radius",
        "color",
        "classNames",
        "styles",
        "unstyled",
        "style",
        "className",
        "withArrow",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "offset",
        "transitionProps",
        "multiline",
        "events",
        "zIndex",
        "disabled",
        "positionDependencies",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "inline",
        "variant",
        "keepMounted",
        "vars",
        "portalProps",
        "mod",
        "floatingStrategy",
        "middlewares"
    ]);
    var dir = DirectionProvider.useDirection().dir;
    var arrowRef = React.useRef(null);
    var tooltip = useTooltip.useTooltip({
        position: getFloatingPosition.getFloatingPosition(dir, position),
        closeDelay,
        openDelay,
        onPositionChange,
        opened,
        defaultOpened,
        events,
        arrowRef,
        arrowOffset,
        offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
        positionDependencies: (0, _toConsumableArray._)(positionDependencies).concat([
            children
        ]),
        inline,
        strategy: floatingStrategy,
        middlewares
    });
    var getStyles = useStyles.useStyles({
        name: "Tooltip",
        props,
        classes: Tooltip_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "tooltip",
        vars,
        varsResolver
    });
    if (!isElement.isElement(children)) throw new Error("[@mantine/core] Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported");
    var targetRef = hooks.useMergedRef(tooltip.reference, getRefProp.getRefProp(children), ref);
    var transition = getTransitionProps.getTransitionProps(transitionProps, {
        duration: 100,
        transition: "fade"
    });
    var _childrenProps = children.props;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(OptionalPortal.OptionalPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, portalProps), {
                withinPortal,
                children: /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, (0, _objectSpreadProps._)((0, _objectSpread._)({}, transition), {
                    keepMounted,
                    mounted: !disabled && !!tooltip.opened,
                    duration: tooltip.isGroupPhase ? 10 : transition.duration,
                    children: function(transitionStyles) /* @__PURE__ */ {
                        var _tooltip_y, _tooltip_x;
                        return jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
                            "data-fixed": floatingStrategy === "fixed" || void 0,
                            variant,
                            mod: [
                                {
                                    multiline
                                },
                                mod
                            ]
                        }), tooltip.getFloatingProps({
                            ref: tooltip.floating,
                            className: getStyles("tooltip").className,
                            style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("tooltip").style, transitionStyles), {
                                zIndex,
                                top: (_tooltip_y = tooltip.y) !== null && _tooltip_y !== void 0 ? _tooltip_y : 0,
                                left: (_tooltip_x = tooltip.x) !== null && _tooltip_x !== void 0 ? _tooltip_x : 0
                            })
                        })), {
                            children: [
                                label,
                                /* @__PURE__ */ jsxRuntime.jsx(FloatingArrow.FloatingArrow, (0, _objectSpread._)({
                                    ref: arrowRef,
                                    arrowX: tooltip.arrowX,
                                    arrowY: tooltip.arrowY,
                                    visible: withArrow,
                                    position: tooltip.placement,
                                    arrowSize,
                                    arrowOffset,
                                    arrowRadius,
                                    arrowPosition
                                }, getStyles("arrow")))
                            ]
                        }));
                    }
                }))
            })),
            React.cloneElement(children, tooltip.getReferenceProps((0, _objectSpreadProps._)((0, _objectSpread._)({
                onClick,
                onMouseEnter,
                onMouseLeave,
                onMouseMove: props.onMouseMove,
                onPointerDown: props.onPointerDown,
                onPointerEnter: props.onPointerEnter,
                className: cx__default.default(className, _childrenProps.className)
            }, _childrenProps), {
                [refProp]: targetRef
            })))
        ]
    });
});
Tooltip.classes = Tooltip_module;
Tooltip.displayName = "@mantine/core/Tooltip";
Tooltip.Floating = TooltipFloating.TooltipFloating;
Tooltip.Group = TooltipGroup.TooltipGroup;
exports.Tooltip = Tooltip; //# sourceMappingURL=Tooltip.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_to_consumable_array":"jg7I9","6ae46e1d71a1f4ad":"iKGFf","569d95c70bcc2222":"9MtAM","75ef04f3e84ac24a":"8QFOC","850af840d988992e":"9HEEB","6ab154cfe62d11fb":"193o0","e31f4cfae3992d3f":"4gavl","3652399d8163d85e":"kEFEY","421155e62c1ecc42":"e829F","5e485b430b0e5920":"hIQE6","f53ee0970bc6164f":"eeaIN","62a1d3287c9716e6":"2FdJg","923da85ad39df5a5":"6AMGA","abd4a041c68de7db":"erSvz","8996761f282c66e7":"kqQOF","dc2491af94e69656":"iivvn","fc63763a67d524ab":"8YP4O","12bb7ae8bc0cdd3d":"d0sAY","f3402901b4ec32c9":"gkGXc","57918f0bc20352e3":"guLFz","984c8d6667c55344":"2onWA","ab96afcb1d58bc3e":"jrkk4","dc0ab52a8e92481":"1B14J","5caf32c11b671ae4":"kAWqL","5576ee033c8dbefa":"6YZdR","3093cccdab7a8548":"3Y9Li","c3c869c15433b84":"2T0Xr","ffed7b13ce916934":"byBew","3b34636765eab397":"ebd04","64b27442e69552f8":"dymYJ","b7f4422d5b69259a":"bXpfD","a6d40dcaa2ae76d8":"kEwvG"}],"byBew":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use client";
"use strict";
var defaultTransition = {
    duration: 100,
    transition: "fade"
};
function getTransitionProps(transitionProps, componentTransition) {
    return (0, _objectSpread._)({}, defaultTransition, componentTransition, transitionProps);
}
exports.getTransitionProps = getTransitionProps; //# sourceMappingURL=get-transition-props.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN"}],"ebd04":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("4daa3bf8e4f5774");
var React = require("d04a1ceb10bacd28");
var hooks = require("e16114b1494edcc8");
var isElement = require("522e859692aba2f8");
var getDefaultZIndex = require("80f9fda38ab22db");
var getSize = require("e47b6b451140cde7");
var getRefProp = require("fe6551929a1ab2be");
var createVarsResolver = require("bb8e8658d2155b67");
require("46988c3af7b409c0");
var getThemeColor = require("4859c1eea85e3c01");
require("ddfb626c0ce336d9");
require("91fd549119e4906a");
require("cbdac1aa93a61d20");
var MantineThemeProvider = require("ed69e4b2c858cfb1");
var useProps = require("610c7a2afbf8db88");
require("577aa9672241b861");
var useStyles = require("54082e768f83a11b");
var getStyleObject = require("111c9810ddc52de1");
var Box = require("1d56011a0d3612f3");
var factory = require("89430fc82f519c2f");
require("91348e2cf59f8f17");
require("f8f05f4684093e21");
var OptionalPortal = require("f585ca0d8e4f3dfa");
var useFloatingTooltip = require("e59ced35d54d7a4a");
var Tooltip_module = require("4a0bae77fdebef82");
var defaultProps = {
    refProp: "ref",
    withinPortal: true,
    offset: 10,
    defaultOpened: false,
    position: "right",
    zIndex: getDefaultZIndex.getDefaultZIndex("popover")
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color;
    return {
        tooltip: {
            "--tooltip-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--tooltip-bg": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--tooltip-color": color ? "var(--mantine-color-white)" : void 0
        }
    };
});
var TooltipFloating = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TooltipFloating", defaultProps, _props);
    var children = props.children, refProp = props.refProp, withinPortal = props.withinPortal, style = props.style, className = props.className, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, radius = props.radius, color = props.color, label = props.label, offset = props.offset, position = props.position, multiline = props.multiline, zIndex = props.zIndex, disabled = props.disabled, defaultOpened = props.defaultOpened, variant = props.variant, vars = props.vars, portalProps = props.portalProps, others = (0, _objectWithoutProperties._)(props, [
        "children",
        "refProp",
        "withinPortal",
        "style",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "radius",
        "color",
        "label",
        "offset",
        "position",
        "multiline",
        "zIndex",
        "disabled",
        "defaultOpened",
        "variant",
        "vars",
        "portalProps"
    ]);
    var theme = MantineThemeProvider.useMantineTheme();
    var getStyles = useStyles.useStyles({
        name: "TooltipFloating",
        props,
        classes: Tooltip_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        rootSelector: "tooltip",
        vars,
        varsResolver
    });
    var _useFloatingTooltip_useFloatingTooltip = useFloatingTooltip.useFloatingTooltip({
        offset,
        position,
        defaultOpened
    }), handleMouseMove = _useFloatingTooltip_useFloatingTooltip.handleMouseMove, x = _useFloatingTooltip_useFloatingTooltip.x, y = _useFloatingTooltip_useFloatingTooltip.y, opened = _useFloatingTooltip_useFloatingTooltip.opened, boundaryRef = _useFloatingTooltip_useFloatingTooltip.boundaryRef, floating = _useFloatingTooltip_useFloatingTooltip.floating, setOpened = _useFloatingTooltip_useFloatingTooltip.setOpened;
    if (!isElement.isElement(children)) throw new Error("[@mantine/core] Tooltip.Floating component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported");
    var targetRef = hooks.useMergedRef(boundaryRef, getRefProp.getRefProp(children), ref);
    var _childrenProps = children.props;
    var onMouseEnter = function(event) {
        var _childrenProps_onMouseEnter;
        (_childrenProps_onMouseEnter = _childrenProps.onMouseEnter) === null || _childrenProps_onMouseEnter === void 0 ? void 0 : _childrenProps_onMouseEnter.call(_childrenProps, event);
        handleMouseMove(event);
        setOpened(true);
    };
    var onMouseLeave = function(event) {
        var _childrenProps_onMouseLeave;
        (_childrenProps_onMouseLeave = _childrenProps.onMouseLeave) === null || _childrenProps_onMouseLeave === void 0 ? void 0 : _childrenProps_onMouseLeave.call(_childrenProps, event);
        setOpened(false);
    };
    var _ref, _ref1;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(OptionalPortal.OptionalPortal, (0, _objectSpreadProps._)((0, _objectSpread._)({}, portalProps), {
                withinPortal,
                children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others, getStyles("tooltip", {
                    style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyleObject.getStyleObject(style, theme)), {
                        zIndex,
                        display: !disabled && opened ? "block" : "none",
                        top: (_ref = y && Math.round(y)) !== null && _ref !== void 0 ? _ref : "",
                        left: (_ref1 = x && Math.round(x)) !== null && _ref1 !== void 0 ? _ref1 : ""
                    })
                })), {
                    variant,
                    ref: floating,
                    mod: {
                        multiline
                    },
                    children: label
                }))
            })),
            React.cloneElement(children, (0, _objectSpreadProps._)((0, _objectSpread._)({}, _childrenProps), {
                [refProp]: targetRef,
                onMouseEnter,
                onMouseLeave
            }))
        ]
    });
});
TooltipFloating.classes = Tooltip_module;
TooltipFloating.displayName = "@mantine/core/TooltipFloating";
exports.TooltipFloating = TooltipFloating; //# sourceMappingURL=TooltipFloating.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","4daa3bf8e4f5774":"iKGFf","d04a1ceb10bacd28":"9MtAM","e16114b1494edcc8":"9HEEB","522e859692aba2f8":"193o0","80f9fda38ab22db":"4gavl","e47b6b451140cde7":"kEFEY","fe6551929a1ab2be":"e829F","bb8e8658d2155b67":"hIQE6","46988c3af7b409c0":"8QFOC","4859c1eea85e3c01":"eeaIN","ddfb626c0ce336d9":"2FdJg","91fd549119e4906a":"6AMGA","cbdac1aa93a61d20":"erSvz","ed69e4b2c858cfb1":"kqQOF","610c7a2afbf8db88":"iivvn","577aa9672241b861":"8YP4O","54082e768f83a11b":"d0sAY","111c9810ddc52de1":"bvL2d","1d56011a0d3612f3":"gkGXc","89430fc82f519c2f":"guLFz","91348e2cf59f8f17":"2onWA","f8f05f4684093e21":"6YZdR","f585ca0d8e4f3dfa":"3Y9Li","e59ced35d54d7a4a":"e1mXE","4a0bae77fdebef82":"kEwvG"}],"e1mXE":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("cf902a40f2bfe10d");
var react = require("d46acad6f185430b");
function useFloatingTooltip(param) {
    var offset = param.offset, position = param.position, defaultOpened = param.defaultOpened;
    var _React_useState = (0, _slicedToArray._)(React.useState(defaultOpened), 2), opened = _React_useState[0], setOpened = _React_useState[1];
    var boundaryRef = React.useRef(null);
    var _react_useFloating = react.useFloating({
        placement: position,
        middleware: [
            react.shift({
                crossAxis: true,
                padding: 5,
                rootBoundary: "document"
            })
        ]
    }), x = _react_useFloating.x, y = _react_useFloating.y, elements = _react_useFloating.elements, refs = _react_useFloating.refs, update = _react_useFloating.update, placement = _react_useFloating.placement;
    var horizontalOffset = placement.includes("right") ? offset : position.includes("left") ? offset * -1 : 0;
    var verticalOffset = placement.includes("bottom") ? offset : position.includes("top") ? offset * -1 : 0;
    var handleMouseMove = React.useCallback(function(param) {
        var clientX = param.clientX, clientY = param.clientY;
        refs.setPositionReference({
            getBoundingClientRect () {
                return {
                    width: 0,
                    height: 0,
                    x: clientX,
                    y: clientY,
                    left: clientX + horizontalOffset,
                    top: clientY + verticalOffset,
                    right: clientX,
                    bottom: clientY
                };
            }
        });
    }, [
        elements.reference
    ]);
    React.useEffect(function() {
        if (refs.floating.current) {
            var boundary = boundaryRef.current;
            boundary.addEventListener("mousemove", handleMouseMove);
            var parents = react.getOverflowAncestors(refs.floating.current);
            parents.forEach(function(parent) {
                parent.addEventListener("scroll", update);
            });
            return function() {
                boundary.removeEventListener("mousemove", handleMouseMove);
                parents.forEach(function(parent) {
                    parent.removeEventListener("scroll", update);
                });
            };
        }
        return void 0;
    }, [
        elements.reference,
        refs.floating.current,
        update,
        handleMouseMove,
        opened
    ]);
    return {
        handleMouseMove,
        x,
        y,
        opened,
        setOpened,
        boundaryRef,
        floating: refs.setFloating
    };
}
exports.useFloatingTooltip = useFloatingTooltip; //# sourceMappingURL=use-floating-tooltip.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","cf902a40f2bfe10d":"9MtAM","d46acad6f185430b":"jrkk4"}],"kEwvG":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "tooltip": "m_1b3c8819",
    "arrow": "m_f898399f"
};
module.exports = classes; //# sourceMappingURL=Tooltip.module.css.cjs.map

},{}],"dymYJ":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("170fe506cbe1b943");
var react = require("fcdd93a1a096b621");
require("49643218bc156f42");
require("b55375587a1ed259");
require("a41452963e684427");
require("b8bf2f4e3b70ee5");
require("50590bc309ed921c");
require("d0953314e6b6947f");
require("8f03eacac8b0b235");
var useProps = require("3a0333c94aa5e9fc");
require("9f1c6603e29d53ac");
require("b5f2f1f650ed1f56");
require("373f1375132e6b5d");
var TooltipGroup_context = require("f96c6f0ebc9c4514");
var defaultProps = {
    openDelay: 0,
    closeDelay: 0
};
function TooltipGroup(props) {
    var _useProps_useProps = useProps.useProps("TooltipGroup", defaultProps, props), openDelay = _useProps_useProps.openDelay, closeDelay = _useProps_useProps.closeDelay, children = _useProps_useProps.children;
    return /* @__PURE__ */ jsxRuntime.jsx(TooltipGroup_context.TooltipGroupProvider, {
        value: true,
        children: /* @__PURE__ */ jsxRuntime.jsx(react.FloatingDelayGroup, {
            delay: {
                open: openDelay,
                close: closeDelay
            },
            children
        })
    });
}
TooltipGroup.displayName = "@mantine/core/TooltipGroup";
TooltipGroup.extend = function(c) {
    return c;
};
exports.TooltipGroup = TooltipGroup; //# sourceMappingURL=TooltipGroup.cjs.map

},{"170fe506cbe1b943":"iKGFf","fcdd93a1a096b621":"jrkk4","49643218bc156f42":"9MtAM","b55375587a1ed259":"9HEEB","a41452963e684427":"8QFOC","b8bf2f4e3b70ee5":"2FdJg","50590bc309ed921c":"6AMGA","d0953314e6b6947f":"erSvz","8f03eacac8b0b235":"kqQOF","3a0333c94aa5e9fc":"iivvn","9f1c6603e29d53ac":"8YP4O","b5f2f1f650ed1f56":"gkGXc","373f1375132e6b5d":"2onWA","f96c6f0ebc9c4514":"3SPHx"}],"3SPHx":[function(require,module,exports) {
"use client";
"use strict";
var React = require("b839975374213bf9");
var TooltipGroupContext = React.createContext(false);
var TooltipGroupProvider = TooltipGroupContext.Provider;
var useTooltipGroupContext = function() {
    return React.useContext(TooltipGroupContext);
};
exports.TooltipGroupProvider = TooltipGroupProvider;
exports.useTooltipGroupContext = useTooltipGroupContext; //# sourceMappingURL=TooltipGroup.context.cjs.map

},{"b839975374213bf9":"9MtAM"}],"bXpfD":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var React = require("6039b2e7d359fef7");
var react = require("b6b6ebb15afd1258");
var hooks = require("36a0cf68312ad7ab");
var useFloatingAutoUpdate = require("f0c2155a267726f9");
require("48be84ab9b3d6b7c");
var TooltipGroup_context = require("729b27ff69fa781");
function getDefaultMiddlewares(middlewares) {
    if (middlewares === void 0) return {
        shift: true,
        flip: true
    };
    var result = (0, _objectSpread._)({}, middlewares);
    if (middlewares.shift === void 0) result.shift = true;
    if (middlewares.flip === void 0) result.flip = true;
    return result;
}
function getTooltipMiddlewares(settings) {
    var middlewaresOptions = getDefaultMiddlewares(settings.middlewares);
    var middlewares = [
        react.offset(settings.offset)
    ];
    if (middlewaresOptions.shift) middlewares.push(react.shift(typeof middlewaresOptions.shift === "boolean" ? {
        padding: 8
    } : (0, _objectSpread._)({
        padding: 8
    }, middlewaresOptions.shift)));
    if (middlewaresOptions.flip) middlewares.push(typeof middlewaresOptions.flip === "boolean" ? react.flip() : react.flip(middlewaresOptions.flip));
    middlewares.push(react.arrow({
        element: settings.arrowRef,
        padding: settings.arrowOffset
    }));
    if (middlewaresOptions.inline) middlewares.push(typeof middlewaresOptions.inline === "boolean" ? react.inline() : react.inline(middlewaresOptions.inline));
    else if (settings.inline) middlewares.push(react.inline());
    return middlewares;
}
function useTooltip(settings) {
    var _settings_events, _settings_events1, _settings_events2;
    var _React_useState = (0, _slicedToArray._)(React.useState(settings.defaultOpened), 2), uncontrolledOpened = _React_useState[0], setUncontrolledOpened = _React_useState[1];
    var controlled = typeof settings.opened === "boolean";
    var opened = controlled ? settings.opened : uncontrolledOpened;
    var withinGroup = TooltipGroup_context.useTooltipGroupContext();
    var uid = hooks.useId();
    var onChange = React.useCallback(function(_opened) {
        setUncontrolledOpened(_opened);
        if (_opened) setCurrentId(uid);
    }, [
        uid
    ]);
    var _react_useFloating = react.useFloating({
        strategy: settings.strategy,
        placement: settings.position,
        open: opened,
        onOpenChange: onChange,
        middleware: getTooltipMiddlewares(settings)
    }), x = _react_useFloating.x, y = _react_useFloating.y, context = _react_useFloating.context, refs = _react_useFloating.refs, update = _react_useFloating.update, placement = _react_useFloating.placement, _react_useFloating_middlewareData = _react_useFloating.middlewareData, tmp = _react_useFloating_middlewareData.arrow, _ref = tmp === void 0 ? {} : tmp, arrowX = _ref.x, arrowY = _ref.y;
    var _react_useDelayGroup = react.useDelayGroup(context, {
        id: uid
    }), groupDelay = _react_useDelayGroup.delay, currentId = _react_useDelayGroup.currentId, setCurrentId = _react_useDelayGroup.setCurrentId;
    var _react_useInteractions = react.useInteractions([
        react.useHover(context, {
            enabled: (_settings_events = settings.events) === null || _settings_events === void 0 ? void 0 : _settings_events.hover,
            delay: withinGroup ? groupDelay : {
                open: settings.openDelay,
                close: settings.closeDelay
            },
            mouseOnly: !((_settings_events1 = settings.events) === null || _settings_events1 === void 0 ? void 0 : _settings_events1.touch)
        }),
        react.useFocus(context, {
            enabled: (_settings_events2 = settings.events) === null || _settings_events2 === void 0 ? void 0 : _settings_events2.focus,
            visibleOnly: true
        }),
        react.useRole(context, {
            role: "tooltip"
        }),
        // Cannot be used with controlled tooltip, page jumps
        react.useDismiss(context, {
            enabled: typeof settings.opened === "undefined"
        })
    ]), getReferenceProps = _react_useInteractions.getReferenceProps, getFloatingProps = _react_useInteractions.getFloatingProps;
    useFloatingAutoUpdate.useFloatingAutoUpdate({
        opened,
        position: settings.position,
        positionDependencies: settings.positionDependencies,
        floating: {
            refs,
            update
        }
    });
    hooks.useDidUpdate(function() {
        var _settings_onPositionChange;
        (_settings_onPositionChange = settings.onPositionChange) === null || _settings_onPositionChange === void 0 ? void 0 : _settings_onPositionChange.call(settings, placement);
    }, [
        placement
    ]);
    var isGroupPhase = opened && currentId && currentId !== uid;
    return {
        x,
        y,
        arrowX,
        arrowY,
        reference: refs.setReference,
        floating: refs.setFloating,
        getFloatingProps,
        getReferenceProps,
        isGroupPhase,
        opened,
        placement
    };
}
exports.useTooltip = useTooltip; //# sourceMappingURL=use-tooltip.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_sliced_to_array":"lAYt5","6039b2e7d359fef7":"9MtAM","b6b6ebb15afd1258":"jrkk4","36a0cf68312ad7ab":"9HEEB","f0c2155a267726f9":"j8BHA","48be84ab9b3d6b7c":"kAWqL","729b27ff69fa781":"3SPHx"}],"by57P":[function(require,module,exports) {
"use client";
"use strict";
function getCurveProps(param) {
    var size = param.size, thickness = param.thickness, sum = param.sum, value = param.value, root = param.root, offset = param.offset;
    var radius = (size * 0.9 - thickness * 2) / 2;
    var deg = Math.PI * radius * 2 / 100;
    var strokeDasharray = root || value === void 0 ? `${(100 - sum) * deg}, ${sum * deg}` : `${value * deg}, ${(100 - value) * deg}`;
    return {
        strokeWidth: Number.isNaN(thickness) ? 12 : thickness,
        cx: size / 2 || 0,
        cy: size / 2 || 0,
        r: radius || 0,
        transform: root ? `scale(1, -1) translate(0, -${size})` : void 0,
        strokeDasharray,
        strokeDashoffset: root ? 0 : offset || 0
    };
}
exports.getCurveProps = getCurveProps; //# sourceMappingURL=get-curve-props.cjs.map

},{}],"8bg2D":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
function getCurves(param) {
    var size = param.size, thickness = param.thickness, sections = param.sections, renderRoundedLineCaps = param.renderRoundedLineCaps, rootColor = param.rootColor;
    var sum = sections.reduce(function(acc, current) {
        return acc + current.value;
    }, 0);
    var accumulated = Math.PI * ((size * 0.9 - thickness * 2) / 2) * 2;
    var offset = accumulated;
    var curves = [];
    var curvesInOrder = [];
    for(var i = 0; i < sections.length; i += 1){
        curves.push({
            sum,
            offset,
            data: sections[i],
            root: false
        });
        offset -= sections[i].value / 100 * accumulated;
    }
    curves.push({
        sum,
        offset,
        data: {
            color: rootColor
        },
        root: true
    });
    curvesInOrder.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, curves[curves.length - 1]), {
        lineRoundCaps: false
    }));
    if (curves.length > 2) {
        curvesInOrder.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, curves[0]), {
            lineRoundCaps: renderRoundedLineCaps
        }));
        curvesInOrder.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, curves[curves.length - 2]), {
            lineRoundCaps: renderRoundedLineCaps
        }));
        for(var i1 = 1; i1 <= curves.length - 3; i1 += 1)curvesInOrder.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, curves[i1]), {
            lineRoundCaps: false
        }));
    } else curvesInOrder.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, curves[0]), {
        lineRoundCaps: renderRoundedLineCaps
    }));
    return curvesInOrder;
}
exports.getCurves = getCurves; //# sourceMappingURL=get-curves.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH"}],"gilWJ":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_b32e4812",
    "svg": "m_d43b5134",
    "curve": "m_b1ca1fbf",
    "label": "m_b23f9dc4"
};
module.exports = classes; //# sourceMappingURL=RingProgress.module.css.cjs.map

},{}],"bnWlC":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("e03d88948e00545b");
var React = require("a2b1ee0cb8b287e1");
var hooks = require("bebbe3bf65209f2a");
var getSize = require("ba15ad38fc204b05");
var createVarsResolver = require("f17435356aee06a4");
require("bda2b4cdc939149c");
var getThemeColor = require("44accd9cf7454561");
var getContrastColor = require("53a2ef788ee9a712");
require("52684e723dcaa780");
require("e76544fdfecee3dc");
require("6a455513989e9036");
var MantineThemeProvider = require("11a4b4736d167f0b");
var useProps = require("dda5fd00ece8c3ed");
require("9b2cef235c33d5c0");
var useStyles = require("89be8f0f72f4870c");
var Box = require("f6c9b53a0dd05ee8");
var factory = require("bf25839d41e6d650");
require("33d7ddae9dfbbf1c");
var FloatingIndicator = require("f7478678522cd6e0");
var SegmentedControl_module = require("a77c7881ccb1fa66");
var defaultProps = {
    withItemsBorders: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, transitionDuration = param.transitionDuration, size = param.size, transitionTimingFunction = param.transitionTimingFunction;
    return {
        root: {
            "--sc-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--sc-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--sc-shadow": color ? void 0 : "var(--mantine-shadow-xs)",
            "--sc-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--sc-transition-timing-function": transitionTimingFunction,
            "--sc-padding": getSize.getSize(size, "sc-padding"),
            "--sc-font-size": getSize.getFontSize(size)
        }
    };
});
var SegmentedControl = factory.factory(function(_props, ref) {
    var _data_find, _data_;
    var props = useProps.useProps("SegmentedControl", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, data = props.data, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, size = props.size, name = props.name, disabled = props.disabled, readOnly = props.readOnly, fullWidth = props.fullWidth, orientation = props.orientation, radius = props.radius, color = props.color, transitionDuration = props.transitionDuration, transitionTimingFunction = props.transitionTimingFunction, variant = props.variant, autoContrast = props.autoContrast, withItemsBorders = props.withItemsBorders, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "data",
        "value",
        "defaultValue",
        "onChange",
        "size",
        "name",
        "disabled",
        "readOnly",
        "fullWidth",
        "orientation",
        "radius",
        "color",
        "transitionDuration",
        "transitionTimingFunction",
        "variant",
        "autoContrast",
        "withItemsBorders",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "SegmentedControl",
        props,
        classes: SegmentedControl_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var theme = MantineThemeProvider.useMantineTheme();
    var _data = data.map(function(item) {
        return typeof item === "string" ? {
            label: item,
            value: item
        } : item;
    });
    var initialized = hooks.useMounted();
    var _React_useState = (0, _slicedToArray._)(React.useState(hooks.randomId()), 2), key = _React_useState[0], setKey = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(null), 2), parent = _React_useState1[0], setParent = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState({}), 2), refs = _React_useState2[0], setRefs = _React_useState2[1];
    var setElementRef = function(element, val) {
        refs[val] = element;
        setRefs(refs);
    };
    var _data_find_value, _ref;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: Array.isArray(data) ? (_ref = (_data_find_value = (_data_find = _data.find(function(item) {
            return !item.disabled;
        })) === null || _data_find === void 0 ? void 0 : _data_find.value) !== null && _data_find_value !== void 0 ? _data_find_value : (_data_ = data[0]) === null || _data_ === void 0 ? void 0 : _data_.value) !== null && _ref !== void 0 ? _ref : null : null,
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], handleValueChange = _hooks_useUncontrolled[1];
    var uuid = hooks.useId(name);
    var controls = _data.map(function(item) {
        return /* @__PURE__ */ React.createElement(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("control")), {
            mod: {
                active: _value === item.value,
                orientation
            },
            key: item.value
        }), /* @__PURE__ */ React.createElement("input", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("input")), {
            disabled: disabled || item.disabled,
            type: "radio",
            name: uuid,
            value: item.value,
            id: `${uuid}-${item.value}`,
            checked: _value === item.value,
            onChange: function() {
                return !readOnly && handleValueChange(item.value);
            },
            "data-focus-ring": theme.focusRing,
            key: `${item.value}-input`
        })), /* @__PURE__ */ React.createElement(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
            component: "label"
        }, getStyles("label")), {
            mod: {
                active: _value === item.value && !(disabled || item.disabled),
                disabled: disabled || item.disabled,
                "read-only": readOnly
            },
            htmlFor: `${uuid}-${item.value}`,
            ref: function(node) {
                return setElementRef(node, item.value);
            },
            __vars: {
                "--sc-label-color": color !== void 0 ? getContrastColor.getContrastColor({
                    color,
                    theme,
                    autoContrast
                }) : void 0
            },
            key: `${item.value}-label`
        }), /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("innerLabel")), {
            children: item.label
        }))));
    });
    var mergedRef = hooks.useMergedRef(ref, function(node) {
        return setParent(node);
    });
    hooks.useShallowEffect(function() {
        setKey(hooks.randomId());
    }, [
        data.length
    ]);
    if (data.length === 0) return null;
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        variant,
        size,
        ref: mergedRef,
        mod: [
            {
                "full-width": fullWidth,
                orientation,
                initialized,
                "with-items-borders": withItemsBorders
            },
            mod
        ]
    }), others), {
        role: "radiogroup",
        "data-disabled": disabled,
        children: [
            typeof _value === "string" && /* @__PURE__ */ jsxRuntime.jsx(FloatingIndicator.FloatingIndicator, (0, _objectSpread._)({
                target: refs[_value],
                parent,
                component: "span",
                transitionDuration: "var(--sc-transition-duration)"
            }, getStyles("indicator")), key),
            controls
        ]
    }));
});
SegmentedControl.classes = SegmentedControl_module;
SegmentedControl.displayName = "@mantine/core/SegmentedControl";
exports.SegmentedControl = SegmentedControl; //# sourceMappingURL=SegmentedControl.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","e03d88948e00545b":"iKGFf","a2b1ee0cb8b287e1":"9MtAM","bebbe3bf65209f2a":"9HEEB","ba15ad38fc204b05":"kEFEY","f17435356aee06a4":"hIQE6","bda2b4cdc939149c":"8QFOC","44accd9cf7454561":"eeaIN","53a2ef788ee9a712":"ez6cW","52684e723dcaa780":"2FdJg","e76544fdfecee3dc":"6AMGA","6a455513989e9036":"erSvz","11a4b4736d167f0b":"kqQOF","dda5fd00ece8c3ed":"iivvn","9b2cef235c33d5c0":"8YP4O","89be8f0f72f4870c":"d0sAY","f6c9b53a0dd05ee8":"gkGXc","bf25839d41e6d650":"guLFz","33d7ddae9dfbbf1c":"2onWA","f7478678522cd6e0":"kzplm","a77c7881ccb1fa66":"1s5ok"}],"1s5ok":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_cf365364",
    "indicator": "m_9e182ccd",
    "label": "m_1738fcb2",
    "input": "m_1714d588",
    "control": "m_69686b9b",
    "innerLabel": "m_78882f40"
};
module.exports = classes; //# sourceMappingURL=SegmentedControl.module.css.cjs.map

},{}],"lyqpE":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("a76a57fff59592cc");
var React = require("f9b4748730f3c829");
var hooks = require("e2f541e3a40d1ffb");
require("6e9b0774ad8ebbbe");
var useResolvedStylesApi = require("2031387544a51339");
require("ac8e3c45c9895595");
require("d9680ca4f3fa5796");
require("dedf5ec8cdafa30");
require("35e445a063699533");
var useProps = require("9818789a4559f423");
require("53f1a47ade55858c");
require("8ba2d27a6935efa0");
var factory = require("9329a6aaac3c2034");
require("e274371d8793f34a");
var getParsedComboboxData = require("fc99b39ae4d83155");
var getOptionsLockup = require("ff4054717e388a2");
require("a7134c7100ae55fd");
var Combobox = require("325bac2a7158b536");
require("72b22817f1e5d436");
require("c99524af906bb37e");
require("56696b18a9eaa5ca");
require("4abbffbdc488199d");
require("fd032c4b954bf661");
require("b858439794d83599");
require("f2b50f8ab1f3cf31");
require("f460285eee545f61");
require("165914d460a3619c");
require("f6dc8ab95128f0a8");
require("2f33b195c7a3f336");
require("b26e952c2280c569");
require("db94d30aba941dcc");
var OptionsDropdown = require("8de087e26140d27");
var useCombobox = require("5daef0df5a94a79d");
require("d614d418060f0603");
var InputBase = require("7bebb50b427463d3");
var defaultProps = {
    searchable: false,
    withCheckIcon: true,
    allowDeselect: true,
    checkIconPosition: "left"
};
var Select = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Select", defaultProps, _props);
    var classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, vars = props.vars, dropdownOpened = props.dropdownOpened, defaultDropdownOpened = props.defaultDropdownOpened, onDropdownClose = props.onDropdownClose, onDropdownOpen = props.onDropdownOpen, onFocus = props.onFocus, onBlur = props.onBlur, onClick = props.onClick, onChange = props.onChange, data = props.data, value = props.value, defaultValue = props.defaultValue, selectFirstOptionOnChange = props.selectFirstOptionOnChange, onOptionSubmit = props.onOptionSubmit, comboboxProps = props.comboboxProps, readOnly = props.readOnly, disabled = props.disabled, filter = props.filter, limit = props.limit, withScrollArea = props.withScrollArea, maxDropdownHeight = props.maxDropdownHeight, size = props.size, searchable = props.searchable, rightSection = props.rightSection, checkIconPosition = props.checkIconPosition, withCheckIcon = props.withCheckIcon, nothingFoundMessage = props.nothingFoundMessage, name = props.name, form = props.form, searchValue = props.searchValue, defaultSearchValue = props.defaultSearchValue, onSearchChange = props.onSearchChange, allowDeselect = props.allowDeselect, error = props.error, rightSectionPointerEvents = props.rightSectionPointerEvents, id = props.id, clearable = props.clearable, clearButtonProps = props.clearButtonProps, hiddenInputProps = props.hiddenInputProps, renderOption = props.renderOption, onClear = props.onClear, autoComplete = props.autoComplete, scrollAreaProps = props.scrollAreaProps, __defaultRightSection = props.__defaultRightSection, __clearSection = props.__clearSection, __clearable = props.__clearable, chevronColor = props.chevronColor, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "styles",
        "unstyled",
        "vars",
        "dropdownOpened",
        "defaultDropdownOpened",
        "onDropdownClose",
        "onDropdownOpen",
        "onFocus",
        "onBlur",
        "onClick",
        "onChange",
        "data",
        "value",
        "defaultValue",
        "selectFirstOptionOnChange",
        "onOptionSubmit",
        "comboboxProps",
        "readOnly",
        "disabled",
        "filter",
        "limit",
        "withScrollArea",
        "maxDropdownHeight",
        "size",
        "searchable",
        "rightSection",
        "checkIconPosition",
        "withCheckIcon",
        "nothingFoundMessage",
        "name",
        "form",
        "searchValue",
        "defaultSearchValue",
        "onSearchChange",
        "allowDeselect",
        "error",
        "rightSectionPointerEvents",
        "id",
        "clearable",
        "clearButtonProps",
        "hiddenInputProps",
        "renderOption",
        "onClear",
        "autoComplete",
        "scrollAreaProps",
        "__defaultRightSection",
        "__clearSection",
        "__clearable",
        "chevronColor"
    ]);
    var parsedData = React.useMemo(function() {
        return getParsedComboboxData.getParsedComboboxData(data);
    }, [
        data
    ]);
    var optionsLockup = React.useMemo(function() {
        return getOptionsLockup.getOptionsLockup(parsedData);
    }, [
        parsedData
    ]);
    var _id = hooks.useId(id);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: null,
        onChange
    }), 3), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1], controlled = _hooks_useUncontrolled[2];
    var selectedOption = typeof _value === "string" ? optionsLockup[_value] : void 0;
    var previousSelectedOption = hooks.usePrevious(selectedOption);
    var _hooks_useUncontrolled1 = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: searchValue,
        defaultValue: defaultSearchValue,
        finalValue: selectedOption ? selectedOption.label : "",
        onChange: onSearchChange
    }), 2), search = _hooks_useUncontrolled1[0], setSearch = _hooks_useUncontrolled1[1];
    var combobox = useCombobox.useCombobox({
        opened: dropdownOpened,
        defaultOpened: defaultDropdownOpened,
        onDropdownOpen: function() {
            onDropdownOpen === null || onDropdownOpen === void 0 ? void 0 : onDropdownOpen();
            combobox.updateSelectedOptionIndex("active", {
                scrollIntoView: true
            });
        },
        onDropdownClose: function() {
            onDropdownClose === null || onDropdownClose === void 0 ? void 0 : onDropdownClose();
            combobox.resetSelectedOption();
        }
    });
    var handleSearchChange = function(value2) {
        setSearch(value2);
        combobox.resetSelectedOption();
    };
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        props,
        styles,
        classNames
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    React.useEffect(function() {
        if (selectFirstOptionOnChange) combobox.selectFirstOption();
    }, [
        selectFirstOptionOnChange,
        search
    ]);
    React.useEffect(function() {
        if (value === null) handleSearchChange("");
        if (typeof value === "string" && selectedOption && ((previousSelectedOption === null || previousSelectedOption === void 0 ? void 0 : previousSelectedOption.value) !== selectedOption.value || (previousSelectedOption === null || previousSelectedOption === void 0 ? void 0 : previousSelectedOption.label) !== selectedOption.label)) handleSearchChange(selectedOption.label);
    }, [
        value,
        selectedOption
    ]);
    React.useEffect(function() {
        var _optionsLockup__value;
        if (!controlled) handleSearchChange(typeof _value === "string" ? ((_optionsLockup__value = optionsLockup[_value]) === null || _optionsLockup__value === void 0 ? void 0 : _optionsLockup__value.label) || "" : "");
    }, [
        data,
        _value
    ]);
    var clearButton = /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.ClearButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, clearButtonProps), {
        onClear: function() {
            setValue(null, null);
            handleSearchChange("");
            onClear === null || onClear === void 0 ? void 0 : onClear();
        }
    }));
    var _clearable = clearable && !!_value && !disabled && !readOnly;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsxs(Combobox.Combobox, (0, _objectSpreadProps._)((0, _objectSpread._)({
                store: combobox,
                __staticSelector: "Select",
                classNames: resolvedClassNames,
                styles: resolvedStyles,
                unstyled,
                readOnly,
                onOptionSubmit: function(val) {
                    onOptionSubmit === null || onOptionSubmit === void 0 ? void 0 : onOptionSubmit(val);
                    var optionLockup = allowDeselect ? optionsLockup[val].value === _value ? null : optionsLockup[val] : optionsLockup[val];
                    var nextValue = optionLockup ? optionLockup.value : null;
                    nextValue !== _value && setValue(nextValue, optionLockup);
                    !controlled && handleSearchChange(typeof nextValue === "string" ? (optionLockup === null || optionLockup === void 0 ? void 0 : optionLockup.label) || "" : "");
                    combobox.closeDropdown();
                },
                size
            }, comboboxProps), {
                children: [
                    /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Target, {
                        targetType: searchable ? "input" : "button",
                        autoComplete,
                        children: /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpreadProps._)((0, _objectSpread._)({
                            id: _id,
                            ref,
                            __defaultRightSection: /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.Chevron, {
                                size,
                                error,
                                unstyled,
                                color: chevronColor
                            }),
                            __clearSection: clearButton,
                            __clearable: _clearable,
                            rightSection,
                            rightSectionPointerEvents: rightSectionPointerEvents || (_clearable ? "all" : "none")
                        }, others), {
                            size,
                            __staticSelector: "Select",
                            disabled,
                            readOnly: readOnly || !searchable,
                            value: search,
                            onChange: function(event) {
                                handleSearchChange(event.currentTarget.value);
                                combobox.openDropdown();
                                selectFirstOptionOnChange && combobox.selectFirstOption();
                            },
                            onFocus: function(event) {
                                searchable && combobox.openDropdown();
                                onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                            },
                            onBlur: function(event) {
                                var _optionsLockup__value;
                                searchable && combobox.closeDropdown();
                                handleSearchChange(_value != null ? ((_optionsLockup__value = optionsLockup[_value]) === null || _optionsLockup__value === void 0 ? void 0 : _optionsLockup__value.label) || "" : "");
                                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                            },
                            onClick: function(event) {
                                searchable ? combobox.openDropdown() : combobox.toggleDropdown();
                                onClick === null || onClick === void 0 ? void 0 : onClick(event);
                            },
                            classNames: resolvedClassNames,
                            styles: resolvedStyles,
                            unstyled,
                            pointer: !searchable,
                            error
                        }))
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(OptionsDropdown.OptionsDropdown, {
                        data: parsedData,
                        hidden: readOnly || disabled,
                        filter,
                        search,
                        limit,
                        hiddenWhenEmpty: !nothingFoundMessage,
                        withScrollArea,
                        maxDropdownHeight,
                        filterOptions: searchable && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== search,
                        value: _value,
                        checkIconPosition,
                        withCheckIcon,
                        nothingFoundMessage,
                        unstyled,
                        labelId: others.label ? `${_id}-label` : void 0,
                        "aria-label": others.label ? void 0 : others["aria-label"],
                        renderOption,
                        scrollAreaProps
                    })
                ]
            })),
            /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.HiddenInput, (0, _objectSpread._)({
                value: _value,
                name,
                form,
                disabled
            }, hiddenInputProps))
        ]
    });
});
Select.classes = (0, _objectSpread._)({}, InputBase.InputBase.classes, Combobox.Combobox.classes);
Select.displayName = "@mantine/core/Select";
exports.Select = Select; //# sourceMappingURL=Select.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","a76a57fff59592cc":"iKGFf","f9b4748730f3c829":"9MtAM","e2f541e3a40d1ffb":"9HEEB","6e9b0774ad8ebbbe":"8QFOC","2031387544a51339":"d30sL","ac8e3c45c9895595":"2FdJg","d9680ca4f3fa5796":"6AMGA","dedf5ec8cdafa30":"erSvz","35e445a063699533":"kqQOF","9818789a4559f423":"iivvn","53f1a47ade55858c":"8YP4O","8ba2d27a6935efa0":"gkGXc","9329a6aaac3c2034":"guLFz","e274371d8793f34a":"2onWA","fc99b39ae4d83155":"71QDZ","ff4054717e388a2":"jSlFr","a7134c7100ae55fd":"6nIYy","325bac2a7158b536":"d1kVk","72b22817f1e5d436":"4ROIf","c99524af906bb37e":"alBok","56696b18a9eaa5ca":"h5QT5","4abbffbdc488199d":"8rZez","fd032c4b954bf661":"74J2w","b858439794d83599":"iyoTe","f2b50f8ab1f3cf31":"3ZaWl","f460285eee545f61":"9a8Lj","165914d460a3619c":"8omXP","f6dc8ab95128f0a8":"ceCGy","2f33b195c7a3f336":"1dzCw","b26e952c2280c569":"4Z9pV","db94d30aba941dcc":"8RMJf","8de087e26140d27":"17zEV","5daef0df5a94a79d":"W6tOq","d614d418060f0603":"etJ5t","7bebb50b427463d3":"jbA6w"}],"eoj6F":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("2a6260b60aebc2c7");
var hooks = require("4d7af84a6f514bf2");
var rem = require("e23828f6ad921d11");
require("2603682115662f71");
var createVarsResolver = require("53dc5843d11ee509");
require("4700f8f239adc31a");
var getThemeColor = require("4b8ea6f381d1fa9d");
require("6671ecd850d38f7c");
require("d88bee8f624bf065");
require("18d93b1a918d0a42");
require("b2d52b285d5ce7cb");
var useProps = require("9d037df48db74aa5");
require("d25d27d29ec63f7c");
var useStyles = require("a34093949cce3030");
var Box = require("260776f49a864a69");
var factory = require("e3d0442c44feb1ce");
require("6dd570ec17cb0836");
var SemiCircleProgress_module = require("19ac9504e14358c9");
var defaultProps = {
    size: 200,
    thickness: 12,
    orientation: "up",
    fillDirection: "left-to-right",
    labelPosition: "bottom"
};
function getRotation(param) {
    var orientation = param.orientation, fillDirection = param.fillDirection;
    if (orientation === "down") {
        if (fillDirection === "right-to-left") return "rotate(180deg) rotateY(180deg)";
        return "rotate(180deg)";
    }
    if (fillDirection === "left-to-right") return "rotateY(180deg)";
    return void 0;
}
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var filledSegmentColor = param.filledSegmentColor, emptySegmentColor = param.emptySegmentColor, orientation = param.orientation, fillDirection = param.fillDirection, transitionDuration = param.transitionDuration, thickness = param.thickness;
    return {
        root: {
            "--scp-filled-segment-color": filledSegmentColor ? getThemeColor.getThemeColor(filledSegmentColor, theme) : void 0,
            "--scp-empty-segment-color": emptySegmentColor ? getThemeColor.getThemeColor(emptySegmentColor, theme) : void 0,
            "--scp-rotation": getRotation({
                orientation,
                fillDirection
            }),
            "--scp-transition-duration": transitionDuration ? `${transitionDuration}ms` : void 0,
            "--scp-thickness": rem.rem(thickness)
        }
    };
});
var SemiCircleProgress = factory.factory(function(_props, ref) {
    var props = useProps.useProps("SemiCircleProgress", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, size = props.size, thickness = props.thickness, value = props.value, orientation = props.orientation, fillDirection = props.fillDirection, filledSegmentColor = props.filledSegmentColor, emptySegmentColor = props.emptySegmentColor, transitionDuration = props.transitionDuration, label = props.label, labelPosition = props.labelPosition, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "thickness",
        "value",
        "orientation",
        "fillDirection",
        "filledSegmentColor",
        "emptySegmentColor",
        "transitionDuration",
        "label",
        "labelPosition"
    ]);
    var getStyles = useStyles.useStyles({
        name: "SemiCircleProgress",
        classes: SemiCircleProgress_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var coordinateForCircle = size / 2;
    var radius = (size - 2 * thickness) / 2;
    var circumference = Math.PI * radius;
    var semiCirclePercentage = hooks.clamp(value, 0, 100) * (circumference / 100);
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        size
    }, getStyles("root"), others), {
        children: [
            label && /* @__PURE__ */ jsxRuntime.jsx("p", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label")), {
                "data-position": labelPosition,
                "data-orientation": orientation,
                children: label
            })),
            /* @__PURE__ */ jsxRuntime.jsxs("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
                width: size,
                height: size / 2
            }, getStyles("svg")), {
                children: [
                    /* @__PURE__ */ jsxRuntime.jsx("circle", (0, _objectSpread._)({
                        cx: coordinateForCircle,
                        cy: coordinateForCircle,
                        r: radius,
                        fill: "none",
                        stroke: "var(--scp-empty-segment-color)",
                        strokeWidth: thickness,
                        strokeDasharray: circumference
                    }, getStyles("emptySegment", {
                        style: {
                            strokeDashoffset: circumference
                        }
                    }))),
                    /* @__PURE__ */ jsxRuntime.jsx("circle", (0, _objectSpread._)({
                        cx: coordinateForCircle,
                        cy: coordinateForCircle,
                        r: radius,
                        fill: "none",
                        stroke: "var(--scp-filled-segment-color)",
                        strokeWidth: thickness,
                        strokeDasharray: circumference
                    }, getStyles("filledSegment", {
                        style: {
                            strokeDashoffset: semiCirclePercentage
                        }
                    })))
                ]
            }))
        ]
    }));
});
SemiCircleProgress.displayName = "@mantine/core/SemiCircleProgress";
SemiCircleProgress.classes = SemiCircleProgress_module;
exports.SemiCircleProgress = SemiCircleProgress; //# sourceMappingURL=SemiCircleProgress.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","2a6260b60aebc2c7":"iKGFf","4d7af84a6f514bf2":"9HEEB","e23828f6ad921d11":"ebAaL","2603682115662f71":"9MtAM","53dc5843d11ee509":"hIQE6","4700f8f239adc31a":"8QFOC","4b8ea6f381d1fa9d":"eeaIN","6671ecd850d38f7c":"2FdJg","d88bee8f624bf065":"6AMGA","18d93b1a918d0a42":"erSvz","b2d52b285d5ce7cb":"kqQOF","9d037df48db74aa5":"iivvn","d25d27d29ec63f7c":"8YP4O","a34093949cce3030":"d0sAY","260776f49a864a69":"gkGXc","e3d0442c44feb1ce":"guLFz","6dd570ec17cb0836":"2onWA","19ac9504e14358c9":"jRYPw"}],"jRYPw":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_fa528724",
    "svg": "m_62e9e7e2",
    "filledSegment": "m_c573fb6f",
    "label": "m_4fa340f2"
};
module.exports = classes; //# sourceMappingURL=SemiCircleProgress.module.css.cjs.map

},{}],"3XvO6":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("64d78548741244b2");
require("10b15f9bbe798e28");
require("fcb214b38bf1b188");
require("5fd59be4d7846a95");
require("7e11ffcaf96810ae");
require("b3500db67af4cbdf");
require("b3e7a989e13f7bb2");
require("f7f74e2a4f124d17");
var useProps = require("aa8a0cf9dfa86ec5");
require("4c46b77544ff7730");
var useStyles = require("afc4d9e0b313965f");
var useRandomClassname = require("6d69ec5f472af376");
var Box = require("18697fbe0c221477");
var factory = require("a72e2cbf589544eb");
require("b56afd69ed36c167");
var SimpleGridVariables = require("604377cd28d2bc97");
var SimpleGrid_module = require("44f7f08bb670e701");
var defaultProps = {
    cols: 1,
    spacing: "md",
    type: "media"
};
var SimpleGrid = factory.factory(function(_props, ref) {
    var props = useProps.useProps("SimpleGrid", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, cols = props.cols, verticalSpacing = props.verticalSpacing, spacing = props.spacing, type = props.type, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "cols",
        "verticalSpacing",
        "spacing",
        "type"
    ]);
    var getStyles = useStyles.useStyles({
        name: "SimpleGrid",
        classes: SimpleGrid_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars
    });
    var responsiveClassName = useRandomClassname.useRandomClassName();
    if (type === "container") return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(SimpleGridVariables.SimpleGridContainerVariables, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                selector: `.${responsiveClassName}`
            })),
            /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("container")), {
                children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
                    ref
                }, getStyles("root", {
                    className: responsiveClassName
                }), others))
            }))
        ]
    });
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(SimpleGridVariables.SimpleGridMediaVariables, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                selector: `.${responsiveClassName}`
            })),
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
                ref
            }, getStyles("root", {
                className: responsiveClassName
            }), others))
        ]
    });
});
SimpleGrid.classes = SimpleGrid_module;
SimpleGrid.displayName = "@mantine/core/SimpleGrid";
exports.SimpleGrid = SimpleGrid; //# sourceMappingURL=SimpleGrid.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","64d78548741244b2":"iKGFf","10b15f9bbe798e28":"9MtAM","fcb214b38bf1b188":"9HEEB","5fd59be4d7846a95":"8QFOC","7e11ffcaf96810ae":"2FdJg","b3500db67af4cbdf":"6AMGA","b3e7a989e13f7bb2":"erSvz","f7f74e2a4f124d17":"kqQOF","aa8a0cf9dfa86ec5":"iivvn","4c46b77544ff7730":"8YP4O","afc4d9e0b313965f":"d0sAY","6d69ec5f472af376":"2rhHN","18697fbe0c221477":"gkGXc","a72e2cbf589544eb":"guLFz","b56afd69ed36c167":"2onWA","604377cd28d2bc97":"7EdC4","44f7f08bb670e701":"4Musf"}],"7EdC4":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("99f8011a48adf43b");
var keys = require("405ed06e2bd2cf1");
var px = require("cdadf050a35fd6ec");
var filterProps = require("f2990d841adb3270");
require("53165b1986f48c0b");
var getSize = require("945730c1d5e0f62f");
var getSortedBreakpoints = require("b90dc901d2a28a88");
var getBaseValue = require("9d976cb063971456");
require("c43163e08e55da66");
require("30b7a1f54a9cf7c8");
require("5ad3d8e7385b5e82");
require("41802f955a917c5c");
require("7803f0057c818db5");
var MantineThemeProvider = require("117c705f1f6661f7");
require("8b397629fec387de");
var InlineStyles = require("baf98205b2b9cef4");
require("a75e92e90d87f348");
require("28f5fee5bc5a99b6");
function SimpleGridMediaVariables(param) {
    var spacing = param.spacing, verticalSpacing = param.verticalSpacing, cols = param.cols, selector = param.selector;
    var _getBaseValue_getBaseValue;
    var theme = MantineThemeProvider.useMantineTheme();
    var _verticalSpacing = verticalSpacing === void 0 ? spacing : verticalSpacing;
    var baseStyles = filterProps.filterProps({
        "--sg-spacing-x": getSize.getSpacing(getBaseValue.getBaseValue(spacing)),
        "--sg-spacing-y": getSize.getSpacing(getBaseValue.getBaseValue(_verticalSpacing)),
        "--sg-cols": (_getBaseValue_getBaseValue = getBaseValue.getBaseValue(cols)) === null || _getBaseValue_getBaseValue === void 0 ? void 0 : _getBaseValue_getBaseValue.toString()
    });
    var queries = keys.keys(theme.breakpoints).reduce(function(acc, breakpoint) {
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof spacing === "object" && spacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-x"] = getSize.getSpacing(spacing[breakpoint]);
        if (typeof _verticalSpacing === "object" && _verticalSpacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-y"] = getSize.getSpacing(_verticalSpacing[breakpoint]);
        if (typeof cols === "object" && cols[breakpoint] !== void 0) acc[breakpoint]["--sg-cols"] = cols[breakpoint];
        return acc;
    }, {});
    var sortedBreakpoints = getSortedBreakpoints.getSortedBreakpoints(keys.keys(queries), theme.breakpoints).filter(function(breakpoint) {
        return keys.keys(queries[breakpoint.value]).length > 0;
    });
    var media = sortedBreakpoints.map(function(breakpoint) {
        return {
            query: `(min-width: ${theme.breakpoints[breakpoint.value]})`,
            styles: queries[breakpoint.value]
        };
    });
    return /* @__PURE__ */ jsxRuntime.jsx(InlineStyles.InlineStyles, {
        styles: baseStyles,
        media,
        selector
    });
}
function getBreakpoints(values) {
    if (typeof values === "object" && values !== null) return keys.keys(values);
    return [];
}
function sortBreakpoints(breakpoints) {
    return breakpoints.sort(function(a, b) {
        return px.px(a) - px.px(b);
    });
}
function getUniqueBreakpoints(param) {
    var spacing = param.spacing, verticalSpacing = param.verticalSpacing, cols = param.cols;
    var breakpoints = Array.from(/* @__PURE__ */ new Set((0, _toConsumableArray._)(getBreakpoints(spacing)).concat((0, _toConsumableArray._)(getBreakpoints(verticalSpacing)), (0, _toConsumableArray._)(getBreakpoints(cols)))));
    return sortBreakpoints(breakpoints);
}
function SimpleGridContainerVariables(param) {
    var spacing = param.spacing, verticalSpacing = param.verticalSpacing, cols = param.cols, selector = param.selector;
    var _getBaseValue_getBaseValue;
    var _verticalSpacing = verticalSpacing === void 0 ? spacing : verticalSpacing;
    var baseStyles = filterProps.filterProps({
        "--sg-spacing-x": getSize.getSpacing(getBaseValue.getBaseValue(spacing)),
        "--sg-spacing-y": getSize.getSpacing(getBaseValue.getBaseValue(_verticalSpacing)),
        "--sg-cols": (_getBaseValue_getBaseValue = getBaseValue.getBaseValue(cols)) === null || _getBaseValue_getBaseValue === void 0 ? void 0 : _getBaseValue_getBaseValue.toString()
    });
    var uniqueBreakpoints = getUniqueBreakpoints({
        spacing,
        verticalSpacing,
        cols
    });
    var queries = uniqueBreakpoints.reduce(function(acc, breakpoint) {
        if (!acc[breakpoint]) acc[breakpoint] = {};
        if (typeof spacing === "object" && spacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-x"] = getSize.getSpacing(spacing[breakpoint]);
        if (typeof _verticalSpacing === "object" && _verticalSpacing[breakpoint] !== void 0) acc[breakpoint]["--sg-spacing-y"] = getSize.getSpacing(_verticalSpacing[breakpoint]);
        if (typeof cols === "object" && cols[breakpoint] !== void 0) acc[breakpoint]["--sg-cols"] = cols[breakpoint];
        return acc;
    }, {});
    var media = uniqueBreakpoints.map(function(breakpoint) {
        return {
            query: `simple-grid (min-width: ${breakpoint})`,
            styles: queries[breakpoint]
        };
    });
    return /* @__PURE__ */ jsxRuntime.jsx(InlineStyles.InlineStyles, {
        styles: baseStyles,
        container: media,
        selector
    });
}
exports.SimpleGridContainerVariables = SimpleGridContainerVariables;
exports.SimpleGridMediaVariables = SimpleGridMediaVariables; //# sourceMappingURL=SimpleGridVariables.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9","99f8011a48adf43b":"iKGFf","405ed06e2bd2cf1":"kvYzO","cdadf050a35fd6ec":"dXm4f","f2990d841adb3270":"2Jst9","53165b1986f48c0b":"9MtAM","945730c1d5e0f62f":"kEFEY","b90dc901d2a28a88":"lwwF0","9d976cb063971456":"4aQII","c43163e08e55da66":"9HEEB","30b7a1f54a9cf7c8":"8QFOC","5ad3d8e7385b5e82":"2FdJg","41802f955a917c5c":"6AMGA","7803f0057c818db5":"erSvz","117c705f1f6661f7":"kqQOF","8b397629fec387de":"8YP4O","baf98205b2b9cef4":"3CHN8","a75e92e90d87f348":"gkGXc","28f5fee5bc5a99b6":"2onWA"}],"4Musf":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "container": "m_925c2d2c",
    "root": "m_2415a157"
};
module.exports = classes; //# sourceMappingURL=SimpleGrid.module.css.cjs.map

},{}],"4wrzI":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1f4c50b5712b5b0a");
var rem = require("f0afe942ecd5800b");
require("e0523fe7789980cb");
var getSize = require("d8ec1dce7ce466bb");
require("11504a03e2caf787");
var createVarsResolver = require("9dd3ba9c699cff58");
require("cadab51cccb6d133");
require("8db40e6ccf5c92c4");
require("2bfdc8c96d7a035a");
require("82584ea076410a5a");
require("5dce5f59571ec317");
var useProps = require("3b0d3d10575976b7");
require("a6da82727b871f29");
var useStyles = require("7ad017162549216e");
var Box = require("aa118e9cd233c0d6");
var factory = require("168e730d9d700494");
require("47557df221b0ae4c");
var Skeleton_module = require("32f9dfdebde1c329");
var defaultProps = {
    visible: true,
    animate: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var width = param.width, height = param.height, radius = param.radius, circle = param.circle;
    return {
        root: {
            "--skeleton-height": rem.rem(height),
            "--skeleton-width": circle ? rem.rem(height) : rem.rem(width),
            "--skeleton-radius": circle ? "1000px" : radius === void 0 ? void 0 : getSize.getRadius(radius)
        }
    };
});
var Skeleton = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Skeleton", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, width = props.width, height = props.height, circle = props.circle, visible = props.visible, radius = props.radius, animate = props.animate, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "width",
        "height",
        "circle",
        "visible",
        "radius",
        "animate",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Skeleton",
        classes: Skeleton_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("root")), {
        mod: [
            {
                visible,
                animate
            },
            mod
        ]
    }), others));
});
Skeleton.classes = Skeleton_module;
Skeleton.displayName = "@mantine/core/Skeleton";
exports.Skeleton = Skeleton; //# sourceMappingURL=Skeleton.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","1f4c50b5712b5b0a":"iKGFf","f0afe942ecd5800b":"ebAaL","e0523fe7789980cb":"9MtAM","d8ec1dce7ce466bb":"kEFEY","11504a03e2caf787":"9HEEB","9dd3ba9c699cff58":"hIQE6","cadab51cccb6d133":"8QFOC","8db40e6ccf5c92c4":"2FdJg","2bfdc8c96d7a035a":"6AMGA","82584ea076410a5a":"erSvz","5dce5f59571ec317":"kqQOF","3b0d3d10575976b7":"iivvn","a6da82727b871f29":"8YP4O","7ad017162549216e":"d0sAY","aa118e9cd233c0d6":"gkGXc","168e730d9d700494":"guLFz","47557df221b0ae4c":"2onWA","32f9dfdebde1c329":"i0CWU"}],"i0CWU":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_18320242",
    "skeleton-fade": "m_299c329c"
};
module.exports = classes; //# sourceMappingURL=Skeleton.module.css.cjs.map

},{}],"hzFg0":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("b02bc1986acc5752");
var React = require("d8d9c3252f2c5a07");
var hooks = require("7102544fca822cf9");
var rem = require("3507f73e55484533");
var getSize = require("e376cfed1e39bf4");
var findClosestNumber = require("801f63f34ec28378");
var createVarsResolver = require("9e574a2f0229ff4a");
require("2f9c37744602fd1a");
var getThemeColor = require("7c54bc7edb0a42b8");
require("e6520f2c373983a7");
require("18acef51c256bbae");
require("e2b89efdb3c38400");
require("3881c99c5d61b9db");
var useProps = require("7cc3261088522adb");
require("82ec71e7d7efc298");
var useStyles = require("d02552d363cf22fb");
require("ab0338ec9f455fee");
var factory = require("3353e5c1b1a14d9c");
var DirectionProvider = require("cb42a01f1caed2b6");
var Slider_context = require("f68a561f5efa329");
var SliderRoot = require("80155998e06afd89");
var Thumb = require("d167296c10481e34");
var Track = require("ad101245c017c70b");
var getChangeValue = require("1e4b932df7d3f39e");
var getGloatingValue = require("ded476a3b5ef10af");
var getPosition = require("7b4c9bc24515be59");
var getPrecision = require("cd31ee4bcf3acbf0");
var getStepMarkValue = require("273dd1762529c7ad");
var Slider_module = require("e4ee45c9ce333946");
var defaultProps = {
    radius: "xl",
    min: 0,
    max: 100,
    step: 1,
    marks: [],
    label: function(f) {
        return f;
    },
    labelTransitionProps: {
        transition: "fade",
        duration: 0
    },
    labelAlwaysOn: false,
    thumbLabel: "",
    showLabelOnHover: true,
    disabled: false,
    scale: function(v) {
        return v;
    }
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, color = param.color, thumbSize = param.thumbSize, radius = param.radius;
    return {
        root: {
            "--slider-size": getSize.getSize(size, "slider-size"),
            "--slider-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--slider-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--slider-thumb-size": thumbSize !== void 0 ? rem.rem(thumbSize) : "calc(var(--slider-size) * 2)"
        }
    };
});
var Slider = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Slider", defaultProps, _props);
    var classNames = props.classNames, styles = props.styles, value = props.value, onChange = props.onChange, onChangeEnd = props.onChangeEnd, size = props.size, min = props.min, max = props.max, step = props.step, _precision = props.precision, defaultValue = props.defaultValue, name = props.name, marks = props.marks, label = props.label, labelTransitionProps = props.labelTransitionProps, labelAlwaysOn = props.labelAlwaysOn, thumbLabel = props.thumbLabel, showLabelOnHover = props.showLabelOnHover, thumbChildren = props.thumbChildren, disabled = props.disabled, unstyled = props.unstyled, scale = props.scale, inverted = props.inverted, className = props.className, style = props.style, vars = props.vars, hiddenInputProps = props.hiddenInputProps, restrictToMarks = props.restrictToMarks, thumbProps = props.thumbProps, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "styles",
        "value",
        "onChange",
        "onChangeEnd",
        "size",
        "min",
        "max",
        "step",
        "precision",
        "defaultValue",
        "name",
        "marks",
        "label",
        "labelTransitionProps",
        "labelAlwaysOn",
        "thumbLabel",
        "showLabelOnHover",
        "thumbChildren",
        "disabled",
        "unstyled",
        "scale",
        "inverted",
        "className",
        "style",
        "vars",
        "hiddenInputProps",
        "restrictToMarks",
        "thumbProps"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Slider",
        props,
        classes: Slider_module,
        classNames,
        className,
        styles,
        style,
        vars,
        varsResolver,
        unstyled
    });
    var dir = DirectionProvider.useDirection().dir;
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), hovered = _React_useState[0], setHovered = _React_useState[1];
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: typeof value === "number" ? hooks.clamp(value, min, max) : value,
        defaultValue: typeof defaultValue === "number" ? hooks.clamp(defaultValue, min, max) : defaultValue,
        finalValue: hooks.clamp(0, min, max),
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var valueRef = React.useRef(_value);
    var onChangeEndRef = React.useRef(onChangeEnd);
    React.useEffect(function() {
        onChangeEndRef.current = onChangeEnd;
    }, [
        onChangeEnd
    ]);
    var root = React.useRef(null);
    var thumb = React.useRef(null);
    var position = getPosition.getPosition({
        value: _value,
        min,
        max
    });
    var scaledValue = scale(_value);
    var _label = typeof label === "function" ? label(scaledValue) : label;
    var precision = _precision !== null && _precision !== void 0 ? _precision : getPrecision.getPrecision(step);
    var handleChange = React.useCallback(function(param) {
        var x = param.x;
        if (!disabled) {
            var nextValue = getChangeValue.getChangeValue({
                value: x,
                min,
                max,
                step,
                precision
            });
            setValue(restrictToMarks && (marks === null || marks === void 0 ? void 0 : marks.length) ? findClosestNumber.findClosestNumber(nextValue, marks.map(function(mark) {
                return mark.value;
            })) : nextValue);
            valueRef.current = nextValue;
        }
    }, [
        disabled,
        min,
        max,
        step,
        precision,
        setValue,
        marks,
        restrictToMarks
    ]);
    var handleScrubEnd = React.useCallback(function() {
        if (!disabled && onChangeEndRef.current) {
            var finalValue = restrictToMarks && (marks === null || marks === void 0 ? void 0 : marks.length) ? findClosestNumber.findClosestNumber(valueRef.current, marks.map(function(mark) {
                return mark.value;
            })) : valueRef.current;
            onChangeEndRef.current(finalValue);
        }
    }, [
        disabled,
        marks,
        restrictToMarks
    ]);
    var _hooks_useMove = hooks.useMove(handleChange, {
        onScrubEnd: handleScrubEnd
    }, dir), container = _hooks_useMove.ref, active = _hooks_useMove.active;
    var callOnChangeEnd = React.useCallback(function(value2) {
        if (!disabled && onChangeEndRef.current) onChangeEndRef.current(value2);
    }, [
        disabled
    ]);
    var handleTrackKeydownCapture = function(event) {
        if (!disabled) switch(event.key){
            case "ArrowUp":
                {
                    var _thumb_current;
                    event.preventDefault();
                    (_thumb_current = thumb.current) === null || _thumb_current === void 0 ? void 0 : _thumb_current.focus();
                    if (restrictToMarks && marks) {
                        var nextValue2 = getStepMarkValue.getNextMarkValue(_value, marks);
                        setValue(nextValue2);
                        callOnChangeEnd(nextValue2);
                        break;
                    }
                    var nextValue = getGloatingValue.getFloatingValue(Math.min(Math.max(_value + step, min), max), precision);
                    setValue(nextValue);
                    callOnChangeEnd(nextValue);
                    break;
                }
            case "ArrowRight":
                {
                    var _thumb_current1;
                    event.preventDefault();
                    (_thumb_current1 = thumb.current) === null || _thumb_current1 === void 0 ? void 0 : _thumb_current1.focus();
                    if (restrictToMarks && marks) {
                        var nextValue21 = dir === "rtl" ? getStepMarkValue.getPreviousMarkValue(_value, marks) : getStepMarkValue.getNextMarkValue(_value, marks);
                        setValue(nextValue21);
                        callOnChangeEnd(nextValue21);
                        break;
                    }
                    var nextValue1 = getGloatingValue.getFloatingValue(Math.min(Math.max(dir === "rtl" ? _value - step : _value + step, min), max), precision);
                    setValue(nextValue1);
                    callOnChangeEnd(nextValue1);
                    break;
                }
            case "ArrowDown":
                {
                    var _thumb_current2;
                    event.preventDefault();
                    (_thumb_current2 = thumb.current) === null || _thumb_current2 === void 0 ? void 0 : _thumb_current2.focus();
                    if (restrictToMarks && marks) {
                        var nextValue22 = getStepMarkValue.getPreviousMarkValue(_value, marks);
                        setValue(nextValue22);
                        callOnChangeEnd(nextValue22);
                        break;
                    }
                    var nextValue3 = getGloatingValue.getFloatingValue(Math.min(Math.max(_value - step, min), max), precision);
                    setValue(nextValue3);
                    callOnChangeEnd(nextValue3);
                    break;
                }
            case "ArrowLeft":
                {
                    var _thumb_current3;
                    event.preventDefault();
                    (_thumb_current3 = thumb.current) === null || _thumb_current3 === void 0 ? void 0 : _thumb_current3.focus();
                    if (restrictToMarks && marks) {
                        var nextValue23 = dir === "rtl" ? getStepMarkValue.getNextMarkValue(_value, marks) : getStepMarkValue.getPreviousMarkValue(_value, marks);
                        setValue(nextValue23);
                        callOnChangeEnd(nextValue23);
                        break;
                    }
                    var nextValue4 = getGloatingValue.getFloatingValue(Math.min(Math.max(dir === "rtl" ? _value + step : _value - step, min), max), precision);
                    setValue(nextValue4);
                    callOnChangeEnd(nextValue4);
                    break;
                }
            case "Home":
                var _thumb_current4;
                event.preventDefault();
                (_thumb_current4 = thumb.current) === null || _thumb_current4 === void 0 ? void 0 : _thumb_current4.focus();
                if (restrictToMarks && marks) {
                    setValue(getStepMarkValue.getFirstMarkValue(marks));
                    callOnChangeEnd(getStepMarkValue.getFirstMarkValue(marks));
                    break;
                }
                setValue(min);
                callOnChangeEnd(min);
                break;
            case "End":
                var _thumb_current5;
                event.preventDefault();
                (_thumb_current5 = thumb.current) === null || _thumb_current5 === void 0 ? void 0 : _thumb_current5.focus();
                if (restrictToMarks && marks) {
                    setValue(getStepMarkValue.getLastMarkValue(marks));
                    callOnChangeEnd(getStepMarkValue.getLastMarkValue(marks));
                    break;
                }
                setValue(max);
                callOnChangeEnd(max);
                break;
        }
    };
    return /* @__PURE__ */ jsxRuntime.jsx(Slider_context.SliderProvider, {
        value: {
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsxs(SliderRoot.SliderRoot, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
            ref: hooks.useMergedRef(ref, root),
            onKeyDownCapture: handleTrackKeydownCapture,
            onMouseDownCapture: function() {
                var _root_current;
                return (_root_current = root.current) === null || _root_current === void 0 ? void 0 : _root_current.focus();
            },
            size,
            disabled,
            children: [
                /* @__PURE__ */ jsxRuntime.jsx(Track.Track, {
                    inverted,
                    offset: 0,
                    filled: position,
                    marks,
                    min,
                    max,
                    value: scaledValue,
                    disabled,
                    containerProps: {
                        ref: container,
                        onMouseEnter: showLabelOnHover ? function() {
                            return setHovered(true);
                        } : void 0,
                        onMouseLeave: showLabelOnHover ? function() {
                            return setHovered(false);
                        } : void 0
                    },
                    children: /* @__PURE__ */ jsxRuntime.jsx(Thumb.Thumb, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        max,
                        min,
                        value: scaledValue,
                        position,
                        dragging: active,
                        label: _label,
                        ref: thumb,
                        labelTransitionProps,
                        labelAlwaysOn,
                        thumbLabel,
                        showLabelOnHover,
                        isHovered: hovered,
                        disabled
                    }, thumbProps), {
                        children: thumbChildren
                    }))
                }),
                /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)({
                    type: "hidden",
                    name,
                    value: scaledValue
                }, hiddenInputProps))
            ]
        }))
    });
});
Slider.classes = Slider_module;
Slider.displayName = "@mantine/core/Slider";
exports.Slider = Slider; //# sourceMappingURL=Slider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","b02bc1986acc5752":"iKGFf","d8d9c3252f2c5a07":"9MtAM","7102544fca822cf9":"9HEEB","3507f73e55484533":"ebAaL","e376cfed1e39bf4":"kEFEY","801f63f34ec28378":"2EcxD","9e574a2f0229ff4a":"hIQE6","2f9c37744602fd1a":"8QFOC","7c54bc7edb0a42b8":"eeaIN","e6520f2c373983a7":"2FdJg","18acef51c256bbae":"6AMGA","e2b89efdb3c38400":"erSvz","3881c99c5d61b9db":"kqQOF","7cc3261088522adb":"iivvn","82ec71e7d7efc298":"8YP4O","d02552d363cf22fb":"d0sAY","ab0338ec9f455fee":"gkGXc","3353e5c1b1a14d9c":"guLFz","cb42a01f1caed2b6":"2onWA","f68a561f5efa329":"flnqC","80155998e06afd89":"8J2xs","d167296c10481e34":"7JH8m","ad101245c017c70b":"epukB","1e4b932df7d3f39e":"huqjq","ded476a3b5ef10af":"ewHTh","7b4c9bc24515be59":"4FUpS","cd31ee4bcf3acbf0":"9ROGq","273dd1762529c7ad":"kW27U","e4ee45c9ce333946":"j4mZv"}],"flnqC":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("6e502864ad6943d");
var createSafeContext = require("b883fcb192282996");
require("7de0ecb074bb7557");
require("300c9ad154eabecd");
require("e8a2b269bf9c5456");
require("54e704449a584f3f");
require("bbfdb7319e32b3a9");
require("656f20eb5a858ca3");
require("344e31011147d5a3");
require("4c9929e0c8ba6079");
require("9fbd0c627a352ced");
require("8a5e067fb1c93fb6");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("SliderProvider was not found in tree"), 2), SliderProvider = _createSafeContext_createSafeContext[0], useSliderContext = _createSafeContext_createSafeContext[1];
exports.SliderProvider = SliderProvider;
exports.useSliderContext = useSliderContext; //# sourceMappingURL=Slider.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","6e502864ad6943d":"9MtAM","b883fcb192282996":"8srze","7de0ecb074bb7557":"iKGFf","300c9ad154eabecd":"9HEEB","e8a2b269bf9c5456":"8QFOC","54e704449a584f3f":"2FdJg","bbfdb7319e32b3a9":"6AMGA","656f20eb5a858ca3":"erSvz","344e31011147d5a3":"kqQOF","4c9929e0c8ba6079":"8YP4O","9fbd0c627a352ced":"gkGXc","8a5e067fb1c93fb6":"2onWA"}],"8J2xs":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("94f027b04f9f2aec");
var React = require("9753b7b21f41444a");
require("7c5ab889855f1ff5");
require("6dfef3f6ff69e8fe");
require("1da1132ac307b4b3");
require("2d3f910d102b4ec8");
require("67bc9ac82dafa303");
require("65c7852a802c9264");
require("9b2e5d8caa121448");
var Box = require("5aa7af76f7d4b7d4");
require("3b08ee7b00861aec");
var Slider_context = require("6f608917a9e41678");
var SliderRoot = React.forwardRef(function(_param, ref) {
    var size = _param.size, disabled = _param.disabled, variant = _param.variant, color = _param.color, thumbSize = _param.thumbSize, radius = _param.radius, others = (0, _objectWithoutProperties._)(_param, [
        "size",
        "disabled",
        "variant",
        "color",
        "thumbSize",
        "radius"
    ]);
    var getStyles = Slider_context.useSliderContext().getStyles;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        tabIndex: -1,
        variant,
        size,
        ref
    }, getStyles("root"), others));
});
SliderRoot.displayName = "@mantine/core/SliderRoot";
exports.SliderRoot = SliderRoot; //# sourceMappingURL=SliderRoot.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","94f027b04f9f2aec":"iKGFf","9753b7b21f41444a":"9MtAM","7c5ab889855f1ff5":"9HEEB","6dfef3f6ff69e8fe":"8QFOC","1da1132ac307b4b3":"2FdJg","2d3f910d102b4ec8":"6AMGA","67bc9ac82dafa303":"erSvz","65c7852a802c9264":"kqQOF","9b2e5d8caa121448":"8YP4O","5aa7af76f7d4b7d4":"gkGXc","3b08ee7b00861aec":"2onWA","6f608917a9e41678":"flnqC"}],"7JH8m":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("1ba506af94bc7ed6");
var React = require("d5342d4a844daee5");
require("eff75bd3b78c523b");
require("818a0af1bcc5dd7b");
require("8abfc5fe110336f5");
require("796055cd2afa6a34");
require("b2ca18b2270a3d65");
require("e589fe721f7e674e");
require("dfa0b9997af73d7e");
var Box = require("2bd599a7071a0eb7");
require("ab5e8989779a07e8");
var Transition = require("e266293e9017bede");
var Slider_context = require("982f5aeb1e48d924");
var Thumb = React.forwardRef(function(param, ref) {
    var max = param.max, min = param.min, value = param.value, position = param.position, label = param.label, dragging = param.dragging, onMouseDown = param.onMouseDown, onKeyDownCapture = param.onKeyDownCapture, labelTransitionProps = param.labelTransitionProps, labelAlwaysOn = param.labelAlwaysOn, thumbLabel = param.thumbLabel, onFocus = param.onFocus, onBlur = param.onBlur, showLabelOnHover = param.showLabelOnHover, isHovered = param.isHovered, _param_children = param.children, children = _param_children === void 0 ? null : _param_children, disabled = param.disabled;
    var getStyles = Slider_context.useSliderContext().getStyles;
    var _React_useState = (0, _slicedToArray._)(React.useState(false), 2), focused = _React_useState[0], setFocused = _React_useState[1];
    var isVisible = labelAlwaysOn || dragging || focused || showLabelOnHover && isHovered;
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        tabIndex: 0,
        role: "slider",
        "aria-label": thumbLabel,
        "aria-valuemax": max,
        "aria-valuemin": min,
        "aria-valuenow": value,
        ref,
        __vars: {
            "--slider-thumb-offset": `${position}%`
        }
    }, getStyles("thumb", {
        focusable: true
    })), {
        mod: {
            dragging,
            disabled
        },
        onFocus: function(event) {
            setFocused(true);
            typeof onFocus === "function" && onFocus(event);
        },
        onBlur: function(event) {
            setFocused(false);
            typeof onBlur === "function" && onBlur(event);
        },
        onTouchStart: onMouseDown,
        onMouseDown,
        onKeyDownCapture,
        onClick: function(event) {
            return event.stopPropagation();
        },
        children: [
            children,
            /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, (0, _objectSpreadProps._)((0, _objectSpread._)({
                mounted: label != null && !!isVisible,
                transition: "fade",
                duration: 0
            }, labelTransitionProps), {
                children: function(transitionStyles) {
                    return /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label", {
                        style: transitionStyles
                    })), {
                        children: label
                    }));
                }
            }))
        ]
    }));
});
Thumb.displayName = "@mantine/core/SliderThumb";
exports.Thumb = Thumb; //# sourceMappingURL=Thumb.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","1ba506af94bc7ed6":"iKGFf","d5342d4a844daee5":"9MtAM","eff75bd3b78c523b":"9HEEB","818a0af1bcc5dd7b":"8QFOC","8abfc5fe110336f5":"2FdJg","796055cd2afa6a34":"6AMGA","b2ca18b2270a3d65":"erSvz","e589fe721f7e674e":"kqQOF","dfa0b9997af73d7e":"8YP4O","2bd599a7071a0eb7":"gkGXc","ab5e8989779a07e8":"2onWA","e266293e9017bede":"2T0Xr","982f5aeb1e48d924":"flnqC"}],"epukB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("19d167beb7b937d");
require("28df1417c1b98264");
require("48d9fa8502b5a527");
require("e4e58d9e76d72618");
require("96086df5b2f4ae51");
require("c27a6401608356f9");
require("7f24d3ec9f3e5ff8");
require("7df946354ac95ad0");
require("bd7fe75322cafa93");
var Box = require("2531503036b451c6");
require("b9dbfa355751c0d1");
var Marks = require("44905266ef59768d");
var Slider_context = require("93418ec12dc76628");
function Track(_param) {
    var filled = _param.filled, children = _param.children, offset = _param.offset, disabled = _param.disabled, marksOffset = _param.marksOffset, inverted = _param.inverted, containerProps = _param.containerProps, others = (0, _objectWithoutProperties._)(_param, [
        "filled",
        "children",
        "offset",
        "disabled",
        "marksOffset",
        "inverted",
        "containerProps"
    ]);
    var getStyles = Slider_context.useSliderContext().getStyles;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("trackContainer")), {
        mod: {
            disabled
        }
    }), containerProps), {
        children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("track")), {
            mod: {
                inverted,
                disabled
            },
            children: [
                /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
                    mod: {
                        inverted,
                        disabled
                    },
                    __vars: {
                        "--slider-bar-width": `calc(${filled}% + var(--slider-size))`,
                        "--slider-bar-offset": `calc(${offset}% - var(--slider-size))`
                    }
                }, getStyles("bar"))),
                children,
                /* @__PURE__ */ jsxRuntime.jsx(Marks.Marks, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
                    offset: marksOffset,
                    disabled,
                    inverted
                }))
            ]
        }))
    }));
}
Track.displayName = "@mantine/core/SliderTrack";
exports.Track = Track; //# sourceMappingURL=Track.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","19d167beb7b937d":"iKGFf","28df1417c1b98264":"9MtAM","48d9fa8502b5a527":"9HEEB","e4e58d9e76d72618":"8QFOC","96086df5b2f4ae51":"2FdJg","c27a6401608356f9":"6AMGA","7f24d3ec9f3e5ff8":"erSvz","7df946354ac95ad0":"kqQOF","bd7fe75322cafa93":"8YP4O","2531503036b451c6":"gkGXc","b9dbfa355751c0d1":"2onWA","44905266ef59768d":"dYJyR","93418ec12dc76628":"flnqC"}],"dYJyR":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("d98a582b79d9444d");
var React = require("bdb24ea5f0bd2be0");
require("6917457ff3e4ca48");
require("7bbb39a5546de318");
require("daa379b21259b20b");
require("d3631eb27c7ea4e4");
require("f02c4a4b966f21a7");
require("961ef16fa3e7d4ac");
require("8685e2870e3b047c");
var Box = require("5092f628b90951c3");
require("dd1e4c37251381bf");
var Slider_context = require("ce2fd27cef919614");
var getPosition = require("b1f5265f66d54155");
var isMarkFilled = require("3c47f19d4cd505e3");
function Marks(param) {
    var marks = param.marks, min = param.min, max = param.max, disabled = param.disabled, value = param.value, offset = param.offset, inverted = param.inverted;
    var getStyles = Slider_context.useSliderContext().getStyles;
    if (!marks) return null;
    var items = marks.map(function(mark, index) {
        return /* @__PURE__ */ React.createElement(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("markWrapper")), {
            __vars: {
                "--mark-offset": `${getPosition.getPosition({
                    value: mark.value,
                    min,
                    max
                })}%`
            },
            key: index
        }), /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("mark")), {
            mod: {
                filled: isMarkFilled.isMarkFilled({
                    mark,
                    value,
                    offset,
                    inverted
                }),
                disabled
            }
        })), mark.label && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("markLabel")), {
            children: mark.label
        })));
    });
    return /* @__PURE__ */ jsxRuntime.jsx("div", {
        children: items
    });
}
Marks.displayName = "@mantine/core/SliderMarks";
exports.Marks = Marks; //# sourceMappingURL=Marks.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","d98a582b79d9444d":"iKGFf","bdb24ea5f0bd2be0":"9MtAM","6917457ff3e4ca48":"9HEEB","7bbb39a5546de318":"8QFOC","daa379b21259b20b":"2FdJg","d3631eb27c7ea4e4":"6AMGA","f02c4a4b966f21a7":"erSvz","961ef16fa3e7d4ac":"kqQOF","8685e2870e3b047c":"8YP4O","5092f628b90951c3":"gkGXc","dd1e4c37251381bf":"2onWA","ce2fd27cef919614":"flnqC","b1f5265f66d54155":"4FUpS","3c47f19d4cd505e3":"03hZ2"}],"4FUpS":[function(require,module,exports) {
"use client";
"use strict";
function getPosition(param) {
    var value = param.value, min = param.min, max = param.max;
    var position = (value - min) / (max - min) * 100;
    return Math.min(Math.max(position, 0), 100);
}
exports.getPosition = getPosition; //# sourceMappingURL=get-position.cjs.map

},{}],"03hZ2":[function(require,module,exports) {
"use client";
"use strict";
function isMarkFilled(param) {
    var mark = param.mark, offset = param.offset, value = param.value, _param_inverted = param.inverted, inverted = _param_inverted === void 0 ? false : _param_inverted;
    return inverted ? typeof offset === "number" ? mark.value <= offset || mark.value >= value : mark.value >= value : typeof offset === "number" ? mark.value >= offset && mark.value <= value : mark.value <= value;
}
exports.isMarkFilled = isMarkFilled; //# sourceMappingURL=is-mark-filled.cjs.map

},{}],"huqjq":[function(require,module,exports) {
"use client";
"use strict";
function getChangeValue(param) {
    var value = param.value, containerWidth = param.containerWidth, min = param.min, max = param.max, step = param.step, precision = param.precision;
    var left = !containerWidth ? value : Math.min(Math.max(value, 0), containerWidth) / containerWidth;
    var dx = left * (max - min);
    var nextValue = (dx !== 0 ? Math.round(dx / step) * step : 0) + min;
    var nextValueWithinStep = Math.max(nextValue, min);
    if (precision !== void 0) return Number(nextValueWithinStep.toFixed(precision));
    return nextValueWithinStep;
}
exports.getChangeValue = getChangeValue; //# sourceMappingURL=get-change-value.cjs.map

},{}],"ewHTh":[function(require,module,exports) {
"use client";
"use strict";
function getFloatingValue(value, precision) {
    return parseFloat(value.toFixed(precision));
}
exports.getFloatingValue = getFloatingValue; //# sourceMappingURL=get-gloating-value.cjs.map

},{}],"9ROGq":[function(require,module,exports) {
"use client";
"use strict";
function getPrecision(step) {
    if (!step) return 0;
    var split = step.toString().split(".");
    return split.length > 1 ? split[1].length : 0;
}
exports.getPrecision = getPrecision; //# sourceMappingURL=get-precision.cjs.map

},{}],"kW27U":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function getNextMarkValue(currentValue, marks) {
    var sortedMarks = (0, _toConsumableArray._)(marks).sort(function(a, b) {
        return a.value - b.value;
    });
    var nextMark = sortedMarks.find(function(mark) {
        return mark.value > currentValue;
    });
    return nextMark ? nextMark.value : currentValue;
}
function getPreviousMarkValue(currentValue, marks) {
    var sortedMarks = (0, _toConsumableArray._)(marks).sort(function(a, b) {
        return b.value - a.value;
    });
    var previousMark = sortedMarks.find(function(mark) {
        return mark.value < currentValue;
    });
    return previousMark ? previousMark.value : currentValue;
}
function getFirstMarkValue(marks) {
    var sortedMarks = (0, _toConsumableArray._)(marks).sort(function(a, b) {
        return a.value - b.value;
    });
    return sortedMarks.length > 0 ? sortedMarks[0].value : 0;
}
function getLastMarkValue(marks) {
    var sortedMarks = (0, _toConsumableArray._)(marks).sort(function(a, b) {
        return a.value - b.value;
    });
    return sortedMarks.length > 0 ? sortedMarks[sortedMarks.length - 1].value : 100;
}
exports.getFirstMarkValue = getFirstMarkValue;
exports.getLastMarkValue = getLastMarkValue;
exports.getNextMarkValue = getNextMarkValue;
exports.getPreviousMarkValue = getPreviousMarkValue; //# sourceMappingURL=get-step-mark-value.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"j4mZv":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_dd36362e",
    "label": "m_c9357328",
    "thumb": "m_c9a9a60a",
    "trackContainer": "m_a8645c2",
    "track": "m_c9ade57f",
    "bar": "m_38aeed47",
    "markWrapper": "m_b7b0423a",
    "mark": "m_dd33bc19",
    "markLabel": "m_68c77a5b"
};
module.exports = classes; //# sourceMappingURL=Slider.module.css.cjs.map

},{}],"jqz04":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("c070225cd5502758");
var React = require("d6e627c44a81b343");
var hooks = require("3041dedbc030f68c");
var rem = require("ddb5cc2952898e07");
var getSize = require("74eaf1aa9d705c95");
var findClosestNumber = require("b44854af014f1f35");
var createVarsResolver = require("15b10ae592db8bb1");
require("158ece76416f92ca");
var getThemeColor = require("9d007d155b6d98c8");
require("ac0435ed3febfd49");
require("41be0423a44103ed");
require("429acde1b91e222f");
require("556277404b1bc855");
var useProps = require("7792110df0caa36f");
require("ec38182d3cc8ac91");
var useStyles = require("1cbdbdbb6c697c0c");
require("c6655858cdde6050");
var factory = require("7ae9ceae332a97ad");
var DirectionProvider = require("e2eb19e2197e6dc7");
var Slider_context = require("f244e3ffe7ec7677");
var SliderRoot = require("f66621aff3d7349a");
var Thumb = require("96f117e115f95a53");
var Track = require("69ecc83ecc50115");
var getChangeValue = require("2e8b686cc1b7aba9");
var getClientPosition = require("88699036bef92a4d");
var getGloatingValue = require("f01e7ac2d5b5bc95");
var getPosition = require("3a5cd06f476a4856");
var getPrecision = require("156cea2afb8c208f");
var getStepMarkValue = require("6b2e382ef3abe804");
var Slider_module = require("ce87f78253718852");
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, color = param.color, thumbSize = param.thumbSize, radius = param.radius;
    return {
        root: {
            "--slider-size": getSize.getSize(size, "slider-size"),
            "--slider-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--slider-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--slider-thumb-size": thumbSize !== void 0 ? rem.rem(thumbSize) : "calc(var(--slider-size) * 2)"
        }
    };
});
var defaultProps = {
    min: 0,
    max: 100,
    minRange: 10,
    step: 1,
    marks: [],
    label: function(f) {
        return f;
    },
    labelTransitionProps: {
        transition: "fade",
        duration: 0
    },
    labelAlwaysOn: false,
    showLabelOnHover: true,
    disabled: false,
    scale: function(v) {
        return v;
    }
};
var RangeSlider = factory.factory(function(_props, ref) {
    var handleThumbMouseDown = function handleThumbMouseDown(index) {
        thumbIndex.current = index;
    };
    var props = useProps.useProps("RangeSlider", defaultProps, _props);
    var classNames = props.classNames, styles = props.styles, value = props.value, onChange = props.onChange, onChangeEnd = props.onChangeEnd, size = props.size, min = props.min, max = props.max, minRange = props.minRange, maxRange = props.maxRange, step = props.step, _precision = props.precision, defaultValue = props.defaultValue, name = props.name, marks = props.marks, label = props.label, labelTransitionProps = props.labelTransitionProps, labelAlwaysOn = props.labelAlwaysOn, thumbFromLabel = props.thumbFromLabel, thumbToLabel = props.thumbToLabel, showLabelOnHover = props.showLabelOnHover, thumbChildren = props.thumbChildren, disabled = props.disabled, unstyled = props.unstyled, scale = props.scale, inverted = props.inverted, className = props.className, style = props.style, vars = props.vars, hiddenInputProps = props.hiddenInputProps, restrictToMarks = props.restrictToMarks, thumbProps = props.thumbProps, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "styles",
        "value",
        "onChange",
        "onChangeEnd",
        "size",
        "min",
        "max",
        "minRange",
        "maxRange",
        "step",
        "precision",
        "defaultValue",
        "name",
        "marks",
        "label",
        "labelTransitionProps",
        "labelAlwaysOn",
        "thumbFromLabel",
        "thumbToLabel",
        "showLabelOnHover",
        "thumbChildren",
        "disabled",
        "unstyled",
        "scale",
        "inverted",
        "className",
        "style",
        "vars",
        "hiddenInputProps",
        "restrictToMarks",
        "thumbProps"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Slider",
        props,
        classes: Slider_module,
        classNames,
        className,
        styles,
        style,
        vars,
        varsResolver,
        unstyled
    });
    var dir = DirectionProvider.useDirection().dir;
    var _React_useState = (0, _slicedToArray._)(React.useState(-1), 2), focused = _React_useState[0], setFocused = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(false), 2), hovered = _React_useState1[0], setHovered = _React_useState1[1];
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: [
            min,
            max
        ],
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var valueRef = React.useRef(_value);
    var thumbs = React.useRef([]);
    var root = React.useRef(null);
    var thumbIndex = React.useRef(void 0);
    var positions = [
        getPosition.getPosition({
            value: _value[0],
            min,
            max
        }),
        getPosition.getPosition({
            value: _value[1],
            min,
            max
        })
    ];
    var precision = _precision !== null && _precision !== void 0 ? _precision : getPrecision.getPrecision(step);
    var _setValue = function(val) {
        setValue(val);
        valueRef.current = val;
    };
    React.useEffect(function() {
        if (Array.isArray(value)) valueRef.current = value;
    }, Array.isArray(value) ? [
        value[0],
        value[1]
    ] : [
        null,
        null
    ]);
    var setRangedValue = function(val, index, triggerChangeEnd) {
        if (index === -1) return;
        var clone = (0, _toConsumableArray._)(valueRef.current);
        if (restrictToMarks && marks) {
            var closest = findClosestNumber.findClosestNumber(val, marks.map(function(m) {
                return m.value;
            }));
            var current = clone[index];
            clone[index] = closest;
            var otherIndex = index === 0 ? 1 : 0;
            var lastMarkValue = getStepMarkValue.getLastMarkValue(marks);
            var firstMarkValue = getStepMarkValue.getFirstMarkValue(marks);
            if (closest === lastMarkValue && clone[otherIndex] === lastMarkValue) clone[index] = current;
            else if (closest === firstMarkValue && clone[otherIndex] === firstMarkValue) clone[index] = current;
            else if (closest === clone[otherIndex]) {
                if (current > clone[otherIndex]) clone[otherIndex] = getStepMarkValue.getPreviousMarkValue(closest, marks);
                else clone[otherIndex] = getStepMarkValue.getNextMarkValue(closest, marks);
            }
        } else {
            clone[index] = val;
            if (index === 0) {
                if (val > clone[1] - (minRange - 1e-9)) clone[1] = Math.min(val + minRange, max);
                if (val > (max - (minRange - 1e-9) || min)) clone[index] = valueRef.current[index];
                if (clone[1] - val > maxRange) clone[1] = val + maxRange;
            }
            if (index === 1) {
                if (val < clone[0] + minRange) clone[0] = Math.max(val - minRange, min);
                if (val < clone[0] + minRange) clone[index] = valueRef.current[index];
                if (val - clone[0] > maxRange) clone[0] = val - maxRange;
            }
        }
        clone[0] = getGloatingValue.getFloatingValue(clone[0], precision);
        clone[1] = getGloatingValue.getFloatingValue(clone[1], precision);
        if (clone[0] > clone[1]) {
            var temp = clone[0];
            clone[0] = clone[1];
            clone[1] = temp;
        }
        _setValue(clone);
        if (triggerChangeEnd) onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(valueRef.current);
    };
    var handleChange = function(val) {
        if (!disabled) {
            var nextValue = getChangeValue.getChangeValue({
                value: val,
                min,
                max,
                step,
                precision
            });
            setRangedValue(nextValue, thumbIndex.current, false);
        }
    };
    var _hooks_useMove = hooks.useMove(function(param) {
        var x = param.x;
        return handleChange(x);
    }, {
        onScrubEnd: function() {
            return !disabled && (onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(valueRef.current));
        }
    }, dir), container = _hooks_useMove.ref, active = _hooks_useMove.active;
    var handleTrackMouseDownCapture = function(event) {
        container.current.focus();
        var rect = container.current.getBoundingClientRect();
        var changePosition = getClientPosition.getClientPosition(event.nativeEvent);
        var changeValue = getChangeValue.getChangeValue({
            value: changePosition - rect.left,
            max,
            min,
            step,
            containerWidth: rect.width
        });
        var nearestHandle = Math.abs(_value[0] - changeValue) > Math.abs(_value[1] - changeValue) ? 1 : 0;
        var _nearestHandle = dir === "ltr" ? nearestHandle : nearestHandle === 1 ? 0 : 1;
        thumbIndex.current = _nearestHandle;
    };
    var getFocusedThumbIndex = function() {
        if (focused !== 1 && focused !== 0) {
            setFocused(0);
            return 0;
        }
        return focused;
    };
    var handleTrackKeydownCapture = function(event) {
        if (!disabled) switch(event.key){
            case "ArrowUp":
                {
                    event.preventDefault();
                    var focusedIndex = getFocusedThumbIndex();
                    thumbs.current[focusedIndex].focus();
                    var nextValue = restrictToMarks && marks ? getStepMarkValue.getNextMarkValue(valueRef.current[focusedIndex], marks) : Math.min(Math.max(valueRef.current[focusedIndex] + step, min), max);
                    setRangedValue(getGloatingValue.getFloatingValue(nextValue, precision), focusedIndex, true);
                    break;
                }
            case "ArrowRight":
                {
                    event.preventDefault();
                    var focusedIndex1 = getFocusedThumbIndex();
                    thumbs.current[focusedIndex1].focus();
                    var nextValue1 = restrictToMarks && marks ? (dir === "rtl" ? getStepMarkValue.getPreviousMarkValue : getStepMarkValue.getNextMarkValue)(valueRef.current[focusedIndex1], marks) : Math.min(Math.max(dir === "rtl" ? valueRef.current[focusedIndex1] - step : valueRef.current[focusedIndex1] + step, min), max);
                    setRangedValue(getGloatingValue.getFloatingValue(nextValue1, precision), focusedIndex1, true);
                    break;
                }
            case "ArrowDown":
                {
                    event.preventDefault();
                    var focusedIndex2 = getFocusedThumbIndex();
                    thumbs.current[focusedIndex2].focus();
                    var nextValue2 = restrictToMarks && marks ? getStepMarkValue.getPreviousMarkValue(valueRef.current[focusedIndex2], marks) : Math.min(Math.max(valueRef.current[focusedIndex2] - step, min), max);
                    setRangedValue(getGloatingValue.getFloatingValue(nextValue2, precision), focusedIndex2, true);
                    break;
                }
            case "ArrowLeft":
                {
                    event.preventDefault();
                    var focusedIndex3 = getFocusedThumbIndex();
                    thumbs.current[focusedIndex3].focus();
                    var nextValue3 = restrictToMarks && marks ? (dir === "rtl" ? getStepMarkValue.getNextMarkValue : getStepMarkValue.getPreviousMarkValue)(valueRef.current[focusedIndex3], marks) : Math.min(Math.max(dir === "rtl" ? valueRef.current[focusedIndex3] + step : valueRef.current[focusedIndex3] - step, min), max);
                    setRangedValue(getGloatingValue.getFloatingValue(nextValue3, precision), focusedIndex3, true);
                    break;
                }
        }
    };
    var sharedThumbProps = {
        max,
        min,
        size,
        labelTransitionProps,
        labelAlwaysOn,
        onBlur: function() {
            return setFocused(-1);
        }
    };
    var hasArrayThumbChildren = Array.isArray(thumbChildren);
    return /* @__PURE__ */ jsxRuntime.jsx(Slider_context.SliderProvider, {
        value: {
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsxs(SliderRoot.SliderRoot, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others), {
            size,
            ref: hooks.useMergedRef(ref, root),
            disabled,
            onMouseDownCapture: function() {
                var _root_current;
                return (_root_current = root.current) === null || _root_current === void 0 ? void 0 : _root_current.focus();
            },
            onKeyDownCapture: function() {
                var _thumbs_current__parentElement, _thumbs_current_, _thumbs_current_1;
                if ((_thumbs_current_ = thumbs.current[0]) === null || _thumbs_current_ === void 0 ? void 0 : (_thumbs_current__parentElement = _thumbs_current_.parentElement) === null || _thumbs_current__parentElement === void 0 ? void 0 : _thumbs_current__parentElement.contains(document.activeElement)) return;
                (_thumbs_current_1 = thumbs.current[0]) === null || _thumbs_current_1 === void 0 ? void 0 : _thumbs_current_1.focus();
            },
            children: [
                /* @__PURE__ */ jsxRuntime.jsxs(Track.Track, {
                    offset: positions[0],
                    marksOffset: _value[0],
                    filled: positions[1] - positions[0],
                    marks,
                    inverted,
                    min,
                    max,
                    value: _value[1],
                    disabled,
                    containerProps: {
                        ref: container,
                        onMouseEnter: showLabelOnHover ? function() {
                            return setHovered(true);
                        } : void 0,
                        onMouseLeave: showLabelOnHover ? function() {
                            return setHovered(false);
                        } : void 0,
                        onTouchStartCapture: handleTrackMouseDownCapture,
                        onTouchEndCapture: function() {
                            thumbIndex.current = -1;
                        },
                        onMouseDownCapture: handleTrackMouseDownCapture,
                        onMouseUpCapture: function() {
                            thumbIndex.current = -1;
                        },
                        onKeyDownCapture: handleTrackKeydownCapture
                    },
                    children: [
                        /* @__PURE__ */ jsxRuntime.jsx(Thumb.Thumb, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, sharedThumbProps), {
                            value: scale(_value[0]),
                            position: positions[0],
                            dragging: active,
                            label: typeof label === "function" ? label(getGloatingValue.getFloatingValue(scale(_value[0]), precision)) : label,
                            ref: function(node) {
                                thumbs.current[0] = node;
                            },
                            thumbLabel: thumbFromLabel,
                            onMouseDown: function() {
                                return handleThumbMouseDown(0);
                            },
                            onFocus: function() {
                                return setFocused(0);
                            },
                            showLabelOnHover,
                            isHovered: hovered,
                            disabled
                        }), thumbProps === null || thumbProps === void 0 ? void 0 : thumbProps(0)), {
                            children: hasArrayThumbChildren ? thumbChildren[0] : thumbChildren
                        })),
                        /* @__PURE__ */ jsxRuntime.jsx(Thumb.Thumb, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, sharedThumbProps), {
                            thumbLabel: thumbToLabel,
                            value: scale(_value[1]),
                            position: positions[1],
                            dragging: active,
                            label: typeof label === "function" ? label(getGloatingValue.getFloatingValue(scale(_value[1]), precision)) : label,
                            ref: function(node) {
                                thumbs.current[1] = node;
                            },
                            onMouseDown: function() {
                                return handleThumbMouseDown(1);
                            },
                            onFocus: function() {
                                return setFocused(1);
                            },
                            showLabelOnHover,
                            isHovered: hovered,
                            disabled
                        }), thumbProps === null || thumbProps === void 0 ? void 0 : thumbProps(1)), {
                            children: hasArrayThumbChildren ? thumbChildren[1] : thumbChildren
                        }))
                    ]
                }),
                /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)({
                    type: "hidden",
                    name: `${name}_from`,
                    value: _value[0]
                }, hiddenInputProps)),
                /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)({
                    type: "hidden",
                    name: `${name}_to`,
                    value: _value[1]
                }, hiddenInputProps))
            ]
        }))
    });
});
RangeSlider.classes = Slider_module;
RangeSlider.displayName = "@mantine/core/RangeSlider";
exports.RangeSlider = RangeSlider; //# sourceMappingURL=RangeSlider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","c070225cd5502758":"iKGFf","d6e627c44a81b343":"9MtAM","3041dedbc030f68c":"9HEEB","ddb5cc2952898e07":"ebAaL","74eaf1aa9d705c95":"kEFEY","b44854af014f1f35":"2EcxD","15b10ae592db8bb1":"hIQE6","158ece76416f92ca":"8QFOC","9d007d155b6d98c8":"eeaIN","ac0435ed3febfd49":"2FdJg","41be0423a44103ed":"6AMGA","429acde1b91e222f":"erSvz","556277404b1bc855":"kqQOF","7792110df0caa36f":"iivvn","ec38182d3cc8ac91":"8YP4O","1cbdbdbb6c697c0c":"d0sAY","c6655858cdde6050":"gkGXc","7ae9ceae332a97ad":"guLFz","e2eb19e2197e6dc7":"2onWA","f244e3ffe7ec7677":"flnqC","f66621aff3d7349a":"8J2xs","96f117e115f95a53":"7JH8m","69ecc83ecc50115":"epukB","2e8b686cc1b7aba9":"huqjq","88699036bef92a4d":"f4Grg","f01e7ac2d5b5bc95":"ewHTh","3a5cd06f476a4856":"4FUpS","156cea2afb8c208f":"9ROGq","6b2e382ef3abe804":"kW27U","ce87f78253718852":"j4mZv"}],"f4Grg":[function(require,module,exports) {
"use client";
"use strict";
function getClientPosition(event) {
    if ("TouchEvent" in window && event instanceof window.TouchEvent) {
        var touch = event.touches[0];
        return touch.clientX;
    }
    return event.clientX;
}
exports.getClientPosition = getClientPosition; //# sourceMappingURL=get-client-position.cjs.map

},{}],"9fiZu":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("117a9793b952ce34");
require("e2465f2036cfa49d");
require("9ed2cae5dc9427e");
require("5822c2c1a2681fa5");
require("f2bf3f6028f1be6");
require("26500c9739fd7413");
require("6cdffa00b815a14f");
require("8173fa7bb6bce06a");
var useProps = require("cb44af310ac5fc34");
require("b8628f89fd5bda3c");
var Box = require("c9ee56226fe0e894");
var factory = require("9f9e022a62f086bc");
require("ad2914c1e7753174");
var defaultProps = {};
var Space = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("Space", defaultProps, props), w = _useProps_useProps.w, h = _useProps_useProps.h, miw = _useProps_useProps.miw, mih = _useProps_useProps.mih, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "w",
        "h",
        "miw",
        "mih"
    ]);
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, others), {
        w,
        miw: miw !== null && miw !== void 0 ? miw : w,
        h,
        mih: mih !== null && mih !== void 0 ? mih : h
    }));
});
Space.displayName = "@mantine/core/Space";
exports.Space = Space; //# sourceMappingURL=Space.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","117a9793b952ce34":"iKGFf","e2465f2036cfa49d":"9MtAM","9ed2cae5dc9427e":"9HEEB","5822c2c1a2681fa5":"8QFOC","f2bf3f6028f1be6":"2FdJg","26500c9739fd7413":"6AMGA","6cdffa00b815a14f":"erSvz","8173fa7bb6bce06a":"kqQOF","cb44af310ac5fc34":"iivvn","b8628f89fd5bda3c":"8YP4O","c9ee56226fe0e894":"gkGXc","9f9e022a62f086bc":"guLFz","ad2914c1e7753174":"2onWA"}],"fqNDH":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("6ee402c437c1c061");
var hooks = require("f1babc846a395295");
var rem = require("95813110745a799");
require("a9155af0d3e4ee6f");
var createVarsResolver = require("917425b4949c73bd");
require("4201d880cd77e8cd");
require("df22330df8aa19dd");
require("605f19549996da30");
require("87c0e705a5538c7b");
require("722944d3af7cff47");
var useProps = require("39ab57f75c9b3b60");
require("225bdbc16b8a3fd4");
var useStyles = require("94ece112667df541");
var Box = require("3c1c108a07ee07f7");
var factory = require("27e0cd734e30cf7");
require("4068957cf744853f");
var Anchor = require("923d4266b0e9b38c");
var Spoiler_module = require("fb4a4327cc6f9670");
var defaultProps = {
    maxHeight: 100,
    initialState: false
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var transitionDuration = param.transitionDuration;
    return {
        root: {
            "--spoiler-transition-duration": transitionDuration !== void 0 ? `${transitionDuration}ms` : void 0
        }
    };
});
var Spoiler = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Spoiler", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, initialState = props.initialState, maxHeight = props.maxHeight, hideLabel = props.hideLabel, showLabel = props.showLabel, children = props.children, controlRef = props.controlRef, transitionDuration = props.transitionDuration, id = props.id, expanded = props.expanded, onExpandedChange = props.onExpandedChange, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "initialState",
        "maxHeight",
        "hideLabel",
        "showLabel",
        "children",
        "controlRef",
        "transitionDuration",
        "id",
        "expanded",
        "onExpandedChange"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Spoiler",
        classes: Spoiler_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _id = hooks.useId(id);
    var regionId = `${_id}-region`;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: expanded,
        defaultValue: initialState,
        finalValue: false,
        onChange: onExpandedChange
    }), 2), show = _hooks_useUncontrolled[0], setShowState = _hooks_useUncontrolled[1];
    var _hooks_useElementSize = hooks.useElementSize(), contentRef = _hooks_useElementSize.ref, height = _hooks_useElementSize.height;
    var spoilerMoreContent = show ? hideLabel : showLabel;
    var spoiler = spoilerMoreContent !== null && maxHeight < height;
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        id: _id,
        ref,
        "data-has-spoiler": spoiler || void 0
    }), others), {
        children: [
            spoiler && /* @__PURE__ */ jsxRuntime.jsx(Anchor.Anchor, (0, _objectSpreadProps._)((0, _objectSpread._)({
                component: "button",
                type: "button",
                ref: controlRef,
                onClick: function() {
                    return setShowState(!show);
                },
                "aria-expanded": show,
                "aria-controls": regionId
            }, getStyles("control")), {
                children: spoilerMoreContent
            })),
            /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("content", {
                style: {
                    maxHeight: !show ? rem.rem(maxHeight) : height ? rem.rem(height) : void 0
                }
            })), {
                "data-reduce-motion": true,
                role: "region",
                id: regionId,
                children: /* @__PURE__ */ jsxRuntime.jsx("div", {
                    ref: contentRef,
                    children
                })
            }))
        ]
    }));
});
Spoiler.classes = Spoiler_module;
Spoiler.displayName = "@mantine/core/Spoiler";
exports.Spoiler = Spoiler; //# sourceMappingURL=Spoiler.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","6ee402c437c1c061":"iKGFf","f1babc846a395295":"9HEEB","95813110745a799":"ebAaL","a9155af0d3e4ee6f":"9MtAM","917425b4949c73bd":"hIQE6","4201d880cd77e8cd":"8QFOC","df22330df8aa19dd":"2FdJg","605f19549996da30":"6AMGA","87c0e705a5538c7b":"erSvz","722944d3af7cff47":"kqQOF","39ab57f75c9b3b60":"iivvn","225bdbc16b8a3fd4":"8YP4O","94ece112667df541":"d0sAY","3c1c108a07ee07f7":"gkGXc","27e0cd734e30cf7":"guLFz","4068957cf744853f":"2onWA","923d4266b0e9b38c":"acy77","fb4a4327cc6f9670":"ji69L"}],"ji69L":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_559cce2d",
    "content": "m_b912df4e",
    "control": "m_b9131032"
};
module.exports = classes; //# sourceMappingURL=Spoiler.module.css.cjs.map

},{}],"ablEp":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("a6d14404be456d93");
require("938ca586c09f3c5a");
var getSize = require("9d243961c8f4c157");
require("5f287c2a280ae81b");
var createVarsResolver = require("16f8762b220826ed");
require("ad902f90100596b0");
require("a8f9bf2006edc0fe");
require("31506cfa39a8a0d3");
require("f60189a365d14645");
require("33fb9e6422dc8f1e");
var useProps = require("978ca14e8847ae09");
require("fda9deac40b1667a");
var useStyles = require("b1e504158e942842");
var Box = require("657f28b1a07c55e0");
var factory = require("6fbc9ccc7cb375b4");
require("b0cbd688ed86d735");
var Stack_module = require("922751a2be9507eb");
var defaultProps = {
    gap: "md",
    align: "stretch",
    justify: "flex-start"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var gap = param.gap, align = param.align, justify = param.justify;
    return {
        root: {
            "--stack-gap": getSize.getSpacing(gap),
            "--stack-align": align,
            "--stack-justify": justify
        }
    };
});
var Stack = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Stack", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, align = props.align, justify = props.justify, gap = props.gap, variant = props.variant, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "align",
        "justify",
        "gap",
        "variant"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Stack",
        props,
        classes: Stack_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        ref
    }, getStyles("root")), {
        variant
    }), others));
});
Stack.classes = Stack_module;
Stack.displayName = "@mantine/core/Stack";
exports.Stack = Stack; //# sourceMappingURL=Stack.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","a6d14404be456d93":"iKGFf","938ca586c09f3c5a":"9MtAM","9d243961c8f4c157":"kEFEY","5f287c2a280ae81b":"9HEEB","16f8762b220826ed":"hIQE6","ad902f90100596b0":"8QFOC","a8f9bf2006edc0fe":"2FdJg","31506cfa39a8a0d3":"6AMGA","f60189a365d14645":"erSvz","33fb9e6422dc8f1e":"kqQOF","978ca14e8847ae09":"iivvn","fda9deac40b1667a":"8YP4O","b1e504158e942842":"d0sAY","657f28b1a07c55e0":"gkGXc","6fbc9ccc7cb375b4":"guLFz","b0cbd688ed86d735":"2onWA","922751a2be9507eb":"jFMbu"}],"jFMbu":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_6d731127"
};
module.exports = classes; //# sourceMappingURL=Stack.module.css.cjs.map

},{}],"ak1g1":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b54f700fe964932a");
var React = require("70c01b552d311c57");
var rem = require("4b383f9fcc28b21f");
var getSize = require("4a442b8bcf413b04");
require("866489d48f80c84d");
var createVarsResolver = require("daddde7fa847cf80");
require("3596bc107b42e5f9");
var getThemeColor = require("e685a19316ff88c5");
var getContrastColor = require("36fc56808b3434b5");
var getAutoContrastValue = require("c50738bd4a0f6040");
require("3a51d81852813da8");
require("1f5c51a8849ed378");
require("61464cfd5c6aeca5");
require("dd06d094ae75be6");
var useProps = require("dfabe554f201daeb");
require("4c121b4a20746231");
var useStyles = require("d0961c4b5ac94372");
var Box = require("9a65ff43d68cfdc7");
var factory = require("e4ca38a7d042159f");
require("2f134e5d78ed7381");
var Stepper_context = require("cde2ea266494f041");
var StepperCompleted = require("b5264b71ff8d0737");
var StepperStep = require("be233d0cc470f7bb");
var Stepper_module = require("780883bee94388a7");
var defaultProps = {
    orientation: "horizontal",
    iconPosition: "left",
    allowNextStepsSelect: true,
    wrap: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color, iconSize = param.iconSize, size = param.size, contentPadding = param.contentPadding, radius = param.radius, autoContrast = param.autoContrast;
    return {
        root: {
            "--stepper-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--stepper-icon-color": getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0,
            "--stepper-icon-size": iconSize === void 0 ? getSize.getSize(size, "stepper-icon-size") : rem.rem(iconSize),
            "--stepper-content-padding": getSize.getSpacing(contentPadding),
            "--stepper-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--stepper-fz": getSize.getFontSize(size),
            "--stepper-spacing": getSize.getSpacing(size)
        }
    };
});
var Stepper = factory.factory(function(_props, ref) {
    var _children_active_props, _children_active, _completedStep_props;
    var props = useProps.useProps("Stepper", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, onStepClick = props.onStepClick, active = props.active, icon = props.icon, completedIcon = props.completedIcon, progressIcon = props.progressIcon, color = props.color, iconSize = props.iconSize, contentPadding = props.contentPadding, orientation = props.orientation, iconPosition = props.iconPosition, size = props.size, radius = props.radius, allowNextStepsSelect = props.allowNextStepsSelect, wrap = props.wrap, autoContrast = props.autoContrast, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "onStepClick",
        "active",
        "icon",
        "completedIcon",
        "progressIcon",
        "color",
        "iconSize",
        "contentPadding",
        "orientation",
        "iconPosition",
        "size",
        "radius",
        "allowNextStepsSelect",
        "wrap",
        "autoContrast"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Stepper",
        classes: Stepper_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var convertedChildren = React.Children.toArray(children);
    var _children = convertedChildren.filter(function(child) {
        return child.type !== StepperCompleted.StepperCompleted;
    });
    var completedStep = convertedChildren.find(function(item) {
        return item.type === StepperCompleted.StepperCompleted;
    });
    var items = _children.reduce(function(acc, item, index) {
        var state = active === index ? "stepProgress" : active > index ? "stepCompleted" : "stepInactive";
        var shouldAllowSelect = function() {
            if (typeof onStepClick !== "function") return false;
            if (typeof item.props.allowStepSelect === "boolean") return item.props.allowStepSelect;
            return state === "stepCompleted" || allowNextStepsSelect;
        };
        var isStepSelectionEnabled = shouldAllowSelect();
        acc.push(React.cloneElement(item, {
            icon: item.props.icon || icon || index + 1,
            key: index,
            step: index,
            state,
            onClick: function() {
                return isStepSelectionEnabled && (onStepClick === null || onStepClick === void 0 ? void 0 : onStepClick(index));
            },
            allowStepClick: isStepSelectionEnabled,
            completedIcon: item.props.completedIcon || completedIcon,
            progressIcon: item.props.progressIcon || progressIcon,
            color: item.props.color || color,
            iconSize,
            iconPosition: item.props.iconPosition || iconPosition,
            orientation
        }));
        if (orientation === "horizontal" && index !== _children.length - 1) acc.push(/* @__PURE__ */ React.createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("separator")), {
            "data-active": index < active || void 0,
            "data-orientation": orientation,
            key: `separator-${index}`
        })));
        return acc;
    }, []);
    var stepContent = (_children_active = _children[active]) === null || _children_active === void 0 ? void 0 : (_children_active_props = _children_active.props) === null || _children_active_props === void 0 ? void 0 : _children_active_props.children;
    var completedContent = completedStep === null || completedStep === void 0 ? void 0 : (_completedStep_props = completedStep.props) === null || _completedStep_props === void 0 ? void 0 : _completedStep_props.children;
    var content = active > _children.length - 1 ? completedContent : stepContent;
    return /* @__PURE__ */ jsxRuntime.jsx(Stepper_context.StepperProvider, {
        value: {
            getStyles,
            orientation,
            iconPosition
        },
        children: /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
            ref,
            size
        }), others), {
            children: [
                /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("steps")), {
                    mod: {
                        orientation,
                        "icon-position": iconPosition,
                        wrap: wrap && orientation !== "vertical"
                    },
                    children: items
                })),
                content && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("content")), {
                    children: content
                }))
            ]
        }))
    });
});
Stepper.classes = Stepper_module;
Stepper.displayName = "@mantine/core/Stepper";
Stepper.Completed = StepperCompleted.StepperCompleted;
Stepper.Step = StepperStep.StepperStep;
exports.Stepper = Stepper; //# sourceMappingURL=Stepper.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","b54f700fe964932a":"iKGFf","70c01b552d311c57":"9MtAM","4b383f9fcc28b21f":"ebAaL","4a442b8bcf413b04":"kEFEY","866489d48f80c84d":"9HEEB","daddde7fa847cf80":"hIQE6","3596bc107b42e5f9":"8QFOC","e685a19316ff88c5":"eeaIN","36fc56808b3434b5":"ez6cW","c50738bd4a0f6040":"cN4dA","3a51d81852813da8":"2FdJg","1f5c51a8849ed378":"6AMGA","61464cfd5c6aeca5":"erSvz","dd06d094ae75be6":"kqQOF","dfabe554f201daeb":"iivvn","4c121b4a20746231":"8YP4O","d0961c4b5ac94372":"d0sAY","9a65ff43d68cfdc7":"gkGXc","e4ca38a7d042159f":"guLFz","2f134e5d78ed7381":"2onWA","cde2ea266494f041":"9MP68","b5264b71ff8d0737":"dShc2","be233d0cc470f7bb":"htG7v","780883bee94388a7":"hF5PH"}],"9MP68":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("f312e4c1a0fc6939");
var createSafeContext = require("60a7f7ae22f3ddab");
require("2b988a6086f2991b");
require("8c2cc95eee7011f4");
require("6aeb4e2ea59e63eb");
require("58f0395a43060e1a");
require("8208b376a9b2e120");
require("dbcf296f8625ec47");
require("38a42dcc32044d82");
require("fd31ee0d5baf8a59");
require("2037b8327de89cc1");
require("286615baa2a2c2ea");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Stepper component was not found in tree"), 2), StepperProvider = _createSafeContext_createSafeContext[0], useStepperContext = _createSafeContext_createSafeContext[1];
exports.StepperProvider = StepperProvider;
exports.useStepperContext = useStepperContext; //# sourceMappingURL=Stepper.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","f312e4c1a0fc6939":"9MtAM","60a7f7ae22f3ddab":"8srze","2b988a6086f2991b":"iKGFf","8c2cc95eee7011f4":"9HEEB","6aeb4e2ea59e63eb":"8QFOC","58f0395a43060e1a":"2FdJg","8208b376a9b2e120":"6AMGA","dbcf296f8625ec47":"erSvz","38a42dcc32044d82":"kqQOF","fd31ee0d5baf8a59":"8YP4O","2037b8327de89cc1":"gkGXc","286615baa2a2c2ea":"2onWA"}],"dShc2":[function(require,module,exports) {
"use client";
"use strict";
var StepperCompleted = function() {
    return null;
};
StepperCompleted.displayName = "@mantine/core/StepperCompleted";
exports.StepperCompleted = StepperCompleted; //# sourceMappingURL=StepperCompleted.cjs.map

},{}],"htG7v":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("c16d440233e7d8b5");
require("9c5fb533fff00c60");
require("644efef4e1ffaefc");
require("9884e96fd711db66");
var getThemeColor = require("f80ea5a53f479fe1");
require("980ee54e5a45ad44");
require("5cdcc74ae1f12157");
require("747943b87ce2eba3");
var MantineThemeProvider = require("bd6920cb7ed00140");
var useProps = require("9a7a0443da274e66");
require("d0760973976eeb0e");
require("23125076042e742d");
var factory = require("ac4026bd20ad860e");
require("fb71ee13e6bd5e05");
require("2a4cccf0c886acf5");
require("2da7955128634313");
var CheckIcon = require("76242112ec691495");
require("8abc5624bb4be5bf");
require("655dc2cec643a7b6");
require("25462f464aef7fba");
require("a3c65cd1f80278c8");
var Loader = require("6d2c176abf2b850c");
var Transition = require("5dcf30cdeb28cb00");
var UnstyledButton = require("1aff4883491295e7");
var Stepper_context = require("32fe201b1d657aac");
var Stepper_module = require("827d1fca737df8a8");
var getStepFragment = function(Fragment, step) {
    if (typeof Fragment === "function") return /* @__PURE__ */ jsxRuntime.jsx(Fragment, {
        step: step || 0
    });
    return Fragment;
};
var defaultProps = {
    withIcon: true,
    allowStepClick: true,
    iconPosition: "left"
};
var StepperStep = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("StepperStep", defaultProps, props), classNames = _useProps_useProps.classNames, className = _useProps_useProps.className, style = _useProps_useProps.style, styles = _useProps_useProps.styles, vars = _useProps_useProps.vars, step = _useProps_useProps.step, state = _useProps_useProps.state, color = _useProps_useProps.color, icon = _useProps_useProps.icon, completedIcon = _useProps_useProps.completedIcon, progressIcon = _useProps_useProps.progressIcon, label = _useProps_useProps.label, description = _useProps_useProps.description, withIcon = _useProps_useProps.withIcon, iconSize = _useProps_useProps.iconSize, loading = _useProps_useProps.loading, allowStepClick = _useProps_useProps.allowStepClick, allowStepSelect = _useProps_useProps.allowStepSelect, iconPosition = _useProps_useProps.iconPosition, orientation = _useProps_useProps.orientation, mod = _useProps_useProps.mod, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "step",
        "state",
        "color",
        "icon",
        "completedIcon",
        "progressIcon",
        "label",
        "description",
        "withIcon",
        "iconSize",
        "loading",
        "allowStepClick",
        "allowStepSelect",
        "iconPosition",
        "orientation",
        "mod"
    ]);
    var ctx = Stepper_context.useStepperContext();
    var theme = MantineThemeProvider.useMantineTheme();
    var stylesApi = {
        classNames,
        styles
    };
    var _icon = state === "stepCompleted" ? null : state === "stepProgress" ? progressIcon : icon;
    var dataAttributes = {
        "data-progress": state === "stepProgress" || void 0,
        "data-completed": state === "stepCompleted" || void 0
    };
    return /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("step", (0, _objectSpread._)({
        className,
        style,
        variant: ctx.orientation
    }, stylesApi))), {
        mod: [
            {
                "icon-position": iconPosition || ctx.iconPosition,
                "allow-click": allowStepClick
            },
            mod
        ],
        ref
    }), dataAttributes, others), {
        __vars: {
            "--step-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
        },
        tabIndex: allowStepClick ? 0 : -1,
        children: [
            withIcon && /* @__PURE__ */ jsxRuntime.jsxs("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("stepWrapper", stylesApi)), {
                children: [
                    /* @__PURE__ */ jsxRuntime.jsxs("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("stepIcon", stylesApi), dataAttributes), {
                        children: [
                            /* @__PURE__ */ jsxRuntime.jsx(Transition.Transition, {
                                mounted: state === "stepCompleted",
                                transition: "pop",
                                duration: 200,
                                children: function(transitionStyles) {
                                    return /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("stepCompletedIcon", (0, _objectSpread._)({
                                        style: transitionStyles
                                    }, stylesApi))), {
                                        children: loading ? /* @__PURE__ */ jsxRuntime.jsx(Loader.Loader, (0, _objectSpread._)({
                                            color: "var(--mantine-color-white)",
                                            size: "calc(var(--stepper-icon-size) / 2)"
                                        }, ctx.getStyles("stepLoader", stylesApi))) : getStepFragment(completedIcon, step) || /* @__PURE__ */ jsxRuntime.jsx(CheckIcon.CheckIcon, {
                                            size: "60%"
                                        })
                                    }));
                                }
                            }),
                            state !== "stepCompleted" ? loading ? /* @__PURE__ */ jsxRuntime.jsx(Loader.Loader, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("stepLoader", stylesApi)), {
                                size: "calc(var(--stepper-icon-size) / 2)",
                                color
                            })) : getStepFragment(_icon || icon, step) : null
                        ]
                    })),
                    orientation === "vertical" && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("verticalSeparator", stylesApi)), {
                        "data-active": state === "stepCompleted" || void 0
                    }))
                ]
            })),
            (label || description) && /* @__PURE__ */ jsxRuntime.jsxs("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("stepBody", stylesApi)), {
                "data-orientation": ctx.orientation,
                "data-icon-position": iconPosition || ctx.iconPosition,
                children: [
                    label && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("stepLabel", stylesApi)), {
                        children: getStepFragment(label, step)
                    })),
                    description && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("stepDescription", stylesApi)), {
                        children: getStepFragment(description, step)
                    }))
                ]
            }))
        ]
    }));
});
StepperStep.classes = Stepper_module;
StepperStep.displayName = "@mantine/core/StepperStep";
exports.StepperStep = StepperStep; //# sourceMappingURL=StepperStep.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","c16d440233e7d8b5":"iKGFf","9c5fb533fff00c60":"9MtAM","644efef4e1ffaefc":"9HEEB","9884e96fd711db66":"8QFOC","f80ea5a53f479fe1":"eeaIN","980ee54e5a45ad44":"2FdJg","5cdcc74ae1f12157":"6AMGA","747943b87ce2eba3":"erSvz","bd6920cb7ed00140":"kqQOF","9a7a0443da274e66":"iivvn","d0760973976eeb0e":"8YP4O","23125076042e742d":"gkGXc","ac4026bd20ad860e":"guLFz","fb71ee13e6bd5e05":"2onWA","2a4cccf0c886acf5":"ey93w","2da7955128634313":"01RS9","76242112ec691495":"fysam","8abc5624bb4be5bf":"ahwnY","655dc2cec643a7b6":"jBkf8","25462f464aef7fba":"jQ0Qw","a3c65cd1f80278c8":"1sCYn","6d2c176abf2b850c":"hxcgl","5dcf30cdeb28cb00":"2T0Xr","1aff4883491295e7":"cArqr","32fe201b1d657aac":"9MP68","827d1fca737df8a8":"hF5PH"}],"hF5PH":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_cbb4ea7e",
    "steps": "m_aaf89d0b",
    "separator": "m_2a371ac9",
    "content": "m_78da155d",
    "step": "m_cbb57068",
    "step--horizontal": "m_f56b1e2c",
    "step--vertical": "m_833edb7e",
    "verticalSeparator": "m_6496b3f3",
    "stepWrapper": "m_818e70b",
    "stepIcon": "m_1959ad01",
    "stepCompletedIcon": "m_a79331dc",
    "stepBody": "m_1956aa2a",
    "stepLabel": "m_12051f6c",
    "stepDescription": "m_164eea74"
};
module.exports = classes; //# sourceMappingURL=Stepper.module.css.cjs.map

},{}],"bEK92":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("8294077177d6aefb");
var hooks = require("6c9873a4ccf127aa");
require("8166bf1b6fa0095b");
var getSize = require("96418d20511f4c45");
var createVarsResolver = require("245c07c062dc61c6");
require("ff7cc61da47ff249");
var getThemeColor = require("d15d51ec3c8f2793");
require("3e6508d30c0cc83");
require("3ff6f45c8c992fbc");
require("94a421f0bdebc5e5");
require("a54e78fe165309bd");
var useProps = require("42fbfa52b02e456e");
require("98c857fe7b878d8b");
var useStyles = require("7a68a9beddb4d754");
var extractStyleProps = require("b134274df50481fe");
var Box = require("637a7c2e5a93437b");
var factory = require("2ce50a980441a988");
require("1a2b06e02489a265");
var InlineInput = require("1a56145aaed5ae1c");
var SwitchGroup_context = require("9028083d29d45eba");
var SwitchGroup = require("e2c5668036020995");
var Switch_module = require("b270896adc28c16");
var defaultProps = {
    labelPosition: "right"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, size = param.size;
    return {
        root: {
            "--switch-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--switch-height": getSize.getSize(size, "switch-height"),
            "--switch-width": getSize.getSize(size, "switch-width"),
            "--switch-thumb-size": getSize.getSize(size, "switch-thumb-size"),
            "--switch-label-font-size": getSize.getSize(size, "switch-label-font-size"),
            "--switch-track-label-padding": getSize.getSize(size, "switch-track-label-padding"),
            "--switch-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
        }
    };
});
var Switch = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Switch", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, color = props.color, label = props.label, offLabel = props.offLabel, onLabel = props.onLabel, id = props.id, size = props.size, radius = props.radius, wrapperProps = props.wrapperProps, thumbIcon = props.thumbIcon, checked = props.checked, defaultChecked = props.defaultChecked, onChange = props.onChange, labelPosition = props.labelPosition, description = props.description, error = props.error, disabled = props.disabled, variant = props.variant, rootRef = props.rootRef, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "label",
        "offLabel",
        "onLabel",
        "id",
        "size",
        "radius",
        "wrapperProps",
        "thumbIcon",
        "checked",
        "defaultChecked",
        "onChange",
        "labelPosition",
        "description",
        "error",
        "disabled",
        "variant",
        "rootRef",
        "mod"
    ]);
    var ctx = SwitchGroup_context.useSwitchGroupContext();
    var _size = size || (ctx === null || ctx === void 0 ? void 0 : ctx.size);
    var getStyles = useStyles.useStyles({
        name: "Switch",
        props,
        classes: Switch_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, rest = _extractStyleProps_extractStyleProps.rest;
    var uuid = hooks.useId(id);
    var contextProps = ctx ? {
        checked: ctx.value.includes(rest.value),
        onChange: ctx.onChange
    } : {};
    var _contextProps_checked;
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: (_contextProps_checked = contextProps.checked) !== null && _contextProps_checked !== void 0 ? _contextProps_checked : checked,
        defaultValue: defaultChecked,
        finalValue: false
    }), 2), _checked = _hooks_useUncontrolled[0], handleChange = _hooks_useUncontrolled[1];
    return /* @__PURE__ */ jsxRuntime.jsxs(InlineInput.InlineInput, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        __staticSelector: "Switch",
        __stylesApiProps: props,
        id: uuid,
        size: _size,
        labelPosition,
        label,
        description,
        error,
        disabled,
        bodyElement: "label",
        labelElement: "span",
        classNames,
        styles,
        unstyled,
        "data-checked": contextProps.checked || checked || void 0,
        variant,
        ref: rootRef,
        mod
    }), styleProps, wrapperProps), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx("input", (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
                disabled,
                checked: _checked,
                "data-checked": contextProps.checked || checked || void 0,
                onChange: function(event) {
                    var _contextProps_onChange;
                    ctx ? (_contextProps_onChange = contextProps.onChange) === null || _contextProps_onChange === void 0 ? void 0 : _contextProps_onChange.call(contextProps, event) : onChange === null || onChange === void 0 ? void 0 : onChange(event);
                    handleChange(event.currentTarget.checked);
                },
                id: uuid,
                ref,
                type: "checkbox",
                role: "switch"
            }), getStyles("input"))),
            /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                "aria-hidden": "true",
                mod: {
                    error,
                    "label-position": labelPosition,
                    "without-labels": !onLabel && !offLabel
                }
            }, getStyles("track")), {
                children: [
                    /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
                        component: "span",
                        mod: "reduce-motion"
                    }, getStyles("thumb")), {
                        children: thumbIcon
                    })),
                    /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("trackLabel")), {
                        children: _checked ? onLabel : offLabel
                    }))
                ]
            }))
        ]
    }));
});
Switch.classes = (0, _objectSpread._)({}, Switch_module, InlineInput.InlineInputClasses);
Switch.displayName = "@mantine/core/Switch";
Switch.Group = SwitchGroup.SwitchGroup;
exports.Switch = Switch; //# sourceMappingURL=Switch.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","8294077177d6aefb":"iKGFf","6c9873a4ccf127aa":"9HEEB","8166bf1b6fa0095b":"9MtAM","96418d20511f4c45":"kEFEY","245c07c062dc61c6":"hIQE6","ff7cc61da47ff249":"8QFOC","d15d51ec3c8f2793":"eeaIN","3e6508d30c0cc83":"2FdJg","3ff6f45c8c992fbc":"6AMGA","94a421f0bdebc5e5":"erSvz","a54e78fe165309bd":"kqQOF","42fbfa52b02e456e":"iivvn","98c857fe7b878d8b":"8YP4O","7a68a9beddb4d754":"d0sAY","b134274df50481fe":"6L93n","637a7c2e5a93437b":"gkGXc","2ce50a980441a988":"guLFz","1a2b06e02489a265":"2onWA","1a56145aaed5ae1c":"b2ROK","9028083d29d45eba":"9JlGg","e2c5668036020995":"8tdZI","b270896adc28c16":"fOoGC"}],"9JlGg":[function(require,module,exports) {
"use client";
"use strict";
var React = require("2956f23cf38b2095");
var SwitchGroupContext = React.createContext(null);
var SwitchGroupProvider = SwitchGroupContext.Provider;
var useSwitchGroupContext = function() {
    return React.useContext(SwitchGroupContext);
};
exports.SwitchGroupProvider = SwitchGroupProvider;
exports.useSwitchGroupContext = useSwitchGroupContext; //# sourceMappingURL=SwitchGroup.context.cjs.map

},{"2956f23cf38b2095":"9MtAM"}],"8tdZI":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("d21fe03f55a3c5e6");
var hooks = require("9511938f77faf0c4");
require("6ef92af563357c91");
require("12b522f4a30420fd");
require("987b5f677b08fd3f");
require("1aad5bea3ddb475f");
require("7f355f8a1995040a");
require("eb3e23d13fa882b5");
var useProps = require("c85e09b58cca652");
require("6f7cb09af433eed4");
require("1bd4a456dbcf22bc");
var factory = require("4a322018204d24bc");
require("2c26a5534c6c55f7");
var Input = require("b611b69e240ff79");
require("955dfa518aa41996");
require("cec8cd2e832c74ce");
require("f13b6b646c924813");
require("e64aaa7828c7f41d");
require("285e4e65d63c0216");
require("79fe4ee7021340b1");
require("624286d8b4ca84b0");
var InputsGroupFieldset = require("d5e4958f113af26c");
var SwitchGroup_context = require("b565afff022e2b39");
var defaultProps = {};
var SwitchGroup = factory.factory(function(props, ref) {
    var _useProps_useProps = useProps.useProps("SwitchGroup", defaultProps, props), value = _useProps_useProps.value, defaultValue = _useProps_useProps.defaultValue, onChange = _useProps_useProps.onChange, size = _useProps_useProps.size, wrapperProps = _useProps_useProps.wrapperProps, children = _useProps_useProps.children, readOnly = _useProps_useProps.readOnly, others = (0, _objectWithoutProperties._)(_useProps_useProps, [
        "value",
        "defaultValue",
        "onChange",
        "size",
        "wrapperProps",
        "children",
        "readOnly"
    ]);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: [],
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var handleChange = function(event) {
        var itemValue = event.currentTarget.value;
        !readOnly && setValue(_value.includes(itemValue) ? _value.filter(function(item) {
            return item !== itemValue;
        }) : (0, _toConsumableArray._)(_value).concat([
            itemValue
        ]));
    };
    return /* @__PURE__ */ jsxRuntime.jsx(SwitchGroup_context.SwitchGroupProvider, {
        value: {
            value: _value,
            onChange: handleChange,
            size
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Input.Input.Wrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({
            size,
            ref
        }, wrapperProps, others), {
            labelElement: "div",
            __staticSelector: "SwitchGroup",
            children: /* @__PURE__ */ jsxRuntime.jsx(InputsGroupFieldset.InputsGroupFieldset, {
                role: "group",
                children
            })
        }))
    });
});
SwitchGroup.classes = Input.Input.Wrapper.classes;
SwitchGroup.displayName = "@mantine/core/SwitchGroup";
exports.SwitchGroup = SwitchGroup; //# sourceMappingURL=SwitchGroup.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","d21fe03f55a3c5e6":"iKGFf","9511938f77faf0c4":"9HEEB","6ef92af563357c91":"9MtAM","12b522f4a30420fd":"8QFOC","987b5f677b08fd3f":"2FdJg","1aad5bea3ddb475f":"6AMGA","7f355f8a1995040a":"erSvz","eb3e23d13fa882b5":"kqQOF","c85e09b58cca652":"iivvn","6f7cb09af433eed4":"8YP4O","1bd4a456dbcf22bc":"gkGXc","4a322018204d24bc":"guLFz","2c26a5534c6c55f7":"2onWA","b611b69e240ff79":"dkUgf","955dfa518aa41996":"j4uTK","cec8cd2e832c74ce":"7nO1x","f13b6b646c924813":"3Bda4","e64aaa7828c7f41d":"gQBOr","285e4e65d63c0216":"lRBdM","79fe4ee7021340b1":"hxtex","624286d8b4ca84b0":"lQt5D","d5e4958f113af26c":"j4N9U","b565afff022e2b39":"9JlGg"}],"fOoGC":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_5f93f3bb",
    "input": "m_926b4011",
    "track": "m_9307d992",
    "thumb": "m_93039a1d",
    "trackLabel": "m_8277e082"
};
module.exports = classes; //# sourceMappingURL=Switch.module.css.cjs.map

},{}],"2O5iK":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("e21d744e77a986e8");
var rem = require("4d26bda66575be83");
require("5ec928b3b9f520c1");
var getSize = require("d4f093b6470cc50b");
require("19491c2ff92f33a7");
var createVarsResolver = require("6745f3c7a0d9661e");
require("aed49aa407e106");
var getThemeColor = require("a844cbd46f4b188e");
require("f27003b6577ad8d6");
require("92d212f68d921083");
require("7b4972e14ca2b2f1");
require("20c56f791812358e");
var useProps = require("585efd48292f19ea");
require("58712fd1049f81f2");
var useStyles = require("3f0c62f357d48f83");
var Box = require("ece5c471a0acb51e");
var factory = require("17f8d147344fcbc6");
require("c8d4c2124a4c467b");
var Table_components = require("d9393ed74bba37e3");
var Table_context = require("e8247643984ca1e7");
var TableDataRenderer = require("f6602e5daab5792b");
var TableScrollContainer = require("f2f1433675450aad");
var Table_module = require("8975bfaea5e8eb55");
var defaultProps = {
    withRowBorders: true,
    verticalSpacing: 7
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var layout = param.layout, captionSide = param.captionSide, horizontalSpacing = param.horizontalSpacing, verticalSpacing = param.verticalSpacing, borderColor = param.borderColor, stripedColor = param.stripedColor, highlightOnHoverColor = param.highlightOnHoverColor, striped = param.striped, highlightOnHover = param.highlightOnHover, stickyHeaderOffset = param.stickyHeaderOffset, stickyHeader = param.stickyHeader;
    return {
        table: {
            "--table-layout": layout,
            "--table-caption-side": captionSide,
            "--table-horizontal-spacing": getSize.getSpacing(horizontalSpacing),
            "--table-vertical-spacing": getSize.getSpacing(verticalSpacing),
            "--table-border-color": borderColor ? getThemeColor.getThemeColor(borderColor, theme) : void 0,
            "--table-striped-color": striped && stripedColor ? getThemeColor.getThemeColor(stripedColor, theme) : void 0,
            "--table-highlight-on-hover-color": highlightOnHover && highlightOnHoverColor ? getThemeColor.getThemeColor(highlightOnHoverColor, theme) : void 0,
            "--table-sticky-header-offset": stickyHeader ? rem.rem(stickyHeaderOffset) : void 0
        }
    };
});
var Table = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Table", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, horizontalSpacing = props.horizontalSpacing, verticalSpacing = props.verticalSpacing, captionSide = props.captionSide, stripedColor = props.stripedColor, highlightOnHoverColor = props.highlightOnHoverColor, striped = props.striped, highlightOnHover = props.highlightOnHover, withColumnBorders = props.withColumnBorders, withRowBorders = props.withRowBorders, withTableBorder = props.withTableBorder, borderColor = props.borderColor, layout = props.layout, variant = props.variant, data = props.data, children = props.children, stickyHeader = props.stickyHeader, stickyHeaderOffset = props.stickyHeaderOffset, mod = props.mod, tabularNums = props.tabularNums, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "horizontalSpacing",
        "verticalSpacing",
        "captionSide",
        "stripedColor",
        "highlightOnHoverColor",
        "striped",
        "highlightOnHover",
        "withColumnBorders",
        "withRowBorders",
        "withTableBorder",
        "borderColor",
        "layout",
        "variant",
        "data",
        "children",
        "stickyHeader",
        "stickyHeaderOffset",
        "mod",
        "tabularNums"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Table",
        props,
        className,
        style,
        classes: Table_module,
        classNames,
        styles,
        unstyled,
        rootSelector: "table",
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Table_context.TableProvider, {
        value: {
            getStyles,
            stickyHeader,
            striped: striped === true ? "odd" : striped || void 0,
            highlightOnHover,
            withColumnBorders,
            withRowBorders,
            captionSide: captionSide || "bottom"
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
            component: "table",
            variant,
            ref,
            mod: [
                {
                    "data-with-table-border": withTableBorder,
                    "data-tabular-nums": tabularNums
                },
                mod
            ]
        }, getStyles("table"), others), {
            children: children || !!data && /* @__PURE__ */ jsxRuntime.jsx(TableDataRenderer.TableDataRenderer, {
                data
            })
        }))
    });
});
Table.classes = Table_module;
Table.displayName = "@mantine/core/Table";
Table.Td = Table_components.TableTd;
Table.Th = Table_components.TableTh;
Table.Tr = Table_components.TableTr;
Table.Thead = Table_components.TableThead;
Table.Tbody = Table_components.TableTbody;
Table.Tfoot = Table_components.TableTfoot;
Table.Caption = Table_components.TableCaption;
Table.ScrollContainer = TableScrollContainer.TableScrollContainer;
Table.DataRenderer = TableDataRenderer.TableDataRenderer;
exports.Table = Table; //# sourceMappingURL=Table.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","e21d744e77a986e8":"iKGFf","4d26bda66575be83":"ebAaL","5ec928b3b9f520c1":"9MtAM","d4f093b6470cc50b":"kEFEY","19491c2ff92f33a7":"9HEEB","6745f3c7a0d9661e":"hIQE6","aed49aa407e106":"8QFOC","a844cbd46f4b188e":"eeaIN","f27003b6577ad8d6":"2FdJg","92d212f68d921083":"6AMGA","7b4972e14ca2b2f1":"erSvz","20c56f791812358e":"kqQOF","585efd48292f19ea":"iivvn","58712fd1049f81f2":"8YP4O","3f0c62f357d48f83":"d0sAY","ece5c471a0acb51e":"gkGXc","17f8d147344fcbc6":"guLFz","c8d4c2124a4c467b":"2onWA","d9393ed74bba37e3":"5HgeT","e8247643984ca1e7":"hFTy1","f6602e5daab5792b":"1tsbO","f2f1433675450aad":"lk5Ln","8975bfaea5e8eb55":"iM752"}],"5HgeT":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("db27f682c5d0504d");
require("e7a5dca701c2295b");
require("b8406ded668d7223");
require("60cf1ca8e03b9d3");
require("872afff033ac0b14");
require("1fc16351aef43e50");
require("acfaa86a65b4d75b");
require("1046d4d3787ceb0c");
var useProps = require("9f54fcf87719d3f1");
require("1e36e03850f38615");
var Box = require("2b4650df8fa3fd22");
var factory = require("737225b1e305e3d3");
require("3efee2aebe6553e");
var Table_context = require("4294a0b8cb41c4d");
var Table_module = require("75a9ea35edce9988");
function getDataAttributes(ctx, options) {
    if (!options) return void 0;
    var data = {};
    if (options.columnBorder && ctx.withColumnBorders) data["data-with-column-border"] = true;
    if (options.rowBorder && ctx.withRowBorders) data["data-with-row-border"] = true;
    if (options.striped && ctx.striped) data["data-striped"] = ctx.striped;
    if (options.highlightOnHover && ctx.highlightOnHover) data["data-hover"] = true;
    if (options.captionSide && ctx.captionSide) data["data-side"] = ctx.captionSide;
    if (options.stickyHeader && ctx.stickyHeader) data["data-sticky"] = true;
    return data;
}
function tableElement(element, options) {
    var name = `Table${element.charAt(0).toUpperCase()}${element.slice(1)}`;
    var Component = factory.factory(function(_props, ref) {
        var props = useProps.useProps(name, {}, _props);
        var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, others = (0, _objectWithoutProperties._)(props, [
            "classNames",
            "className",
            "style",
            "styles"
        ]);
        var ctx = Table_context.useTableContext();
        return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
            component: element,
            ref
        }, getDataAttributes(ctx, options), ctx.getStyles(element, {
            className,
            classNames,
            style,
            styles,
            props
        }), others));
    });
    Component.displayName = `@mantine/core/${name}`;
    Component.classes = Table_module;
    return Component;
}
var TableTh = tableElement("th", {
    columnBorder: true
});
var TableTd = tableElement("td", {
    columnBorder: true
});
var TableTr = tableElement("tr", {
    rowBorder: true,
    striped: true,
    highlightOnHover: true
});
var TableThead = tableElement("thead", {
    stickyHeader: true
});
var TableTbody = tableElement("tbody");
var TableTfoot = tableElement("tfoot");
var TableCaption = tableElement("caption", {
    captionSide: true
});
exports.TableCaption = TableCaption;
exports.TableTbody = TableTbody;
exports.TableTd = TableTd;
exports.TableTfoot = TableTfoot;
exports.TableTh = TableTh;
exports.TableThead = TableThead;
exports.TableTr = TableTr;
exports.tableElement = tableElement; //# sourceMappingURL=Table.components.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","db27f682c5d0504d":"iKGFf","e7a5dca701c2295b":"9MtAM","b8406ded668d7223":"9HEEB","60cf1ca8e03b9d3":"8QFOC","872afff033ac0b14":"2FdJg","1fc16351aef43e50":"6AMGA","acfaa86a65b4d75b":"erSvz","1046d4d3787ceb0c":"kqQOF","9f54fcf87719d3f1":"iivvn","1e36e03850f38615":"8YP4O","2b4650df8fa3fd22":"gkGXc","737225b1e305e3d3":"guLFz","3efee2aebe6553e":"2onWA","4294a0b8cb41c4d":"hFTy1","75a9ea35edce9988":"iM752"}],"hFTy1":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("9030680897cb6c08");
var createSafeContext = require("c0c6d990e6dde3be");
require("42b58ce3343ef3b");
require("710c12c485768edd");
require("9c87d200d99eb9d");
require("ac997eec7fc27562");
require("6044e54cfe0192d0");
require("287780e19857f679");
require("a2eec29b3b86b8f2");
require("dd6b322b3eb2f4f0");
require("9ca4b5f3b515a8d8");
require("1cd2491900dd26c5");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Table component was not found in the tree"), 2), TableProvider = _createSafeContext_createSafeContext[0], useTableContext = _createSafeContext_createSafeContext[1];
exports.TableProvider = TableProvider;
exports.useTableContext = useTableContext; //# sourceMappingURL=Table.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","9030680897cb6c08":"9MtAM","c0c6d990e6dde3be":"8srze","42b58ce3343ef3b":"iKGFf","710c12c485768edd":"9HEEB","9c87d200d99eb9d":"8QFOC","ac997eec7fc27562":"2FdJg","6044e54cfe0192d0":"6AMGA","287780e19857f679":"erSvz","a2eec29b3b86b8f2":"kqQOF","dd6b322b3eb2f4f0":"8YP4O","9ca4b5f3b515a8d8":"gkGXc","1cd2491900dd26c5":"2onWA"}],"iM752":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "table": "m_b23fa0ef",
    "th": "m_4e7aa4f3",
    "tr": "m_4e7aa4fd",
    "td": "m_4e7aa4ef",
    "tbody": "m_b2404537",
    "thead": "m_b242d975",
    "caption": "m_9e5a3ac7",
    "scrollContainer": "m_a100c15",
    "scrollContainerInner": "m_62259741"
};
module.exports = classes; //# sourceMappingURL=Table.module.css.cjs.map

},{}],"1tsbO":[function(require,module,exports) {
"use client";
"use strict";
var jsxRuntime = require("c63cf4cab3d6c923");
var Table_components = require("a459611cd1cbb01");
function TableDataRenderer(param) {
    var data = param.data;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            data.caption && /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableCaption, {
                children: data.caption
            }),
            data.head && /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableThead, {
                children: /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTr, {
                    children: data.head.map(function(item, index) {
                        return /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTh, {
                            children: item
                        }, index);
                    })
                })
            }),
            data.body && /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTbody, {
                children: data.body.map(function(row, rowIndex) {
                    return /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTr, {
                        children: row.map(function(item, index) {
                            return /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTd, {
                                children: item
                            }, index);
                        })
                    }, rowIndex);
                })
            }),
            data.foot && /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTfoot, {
                children: /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTr, {
                    children: data.foot.map(function(item, index) {
                        return /* @__PURE__ */ jsxRuntime.jsx(Table_components.TableTh, {
                            children: item
                        }, index);
                    })
                })
            })
        ]
    });
}
TableDataRenderer.displayName = "@mantine/core/TableDataRenderer";
exports.TableDataRenderer = TableDataRenderer; //# sourceMappingURL=TableDataRenderer.cjs.map

},{"c63cf4cab3d6c923":"iKGFf","a459611cd1cbb01":"5HgeT"}],"lk5Ln":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("68cd82d5e2b83ee0");
var rem = require("ab66960575f66572");
require("426e5d65dca6fb25");
require("f45c25163a51a3ac");
var createVarsResolver = require("28536cb6f8a5a257");
require("2be31e21a554b881");
require("e456c286e07874e4");
require("4d4f7d957d3d2726");
require("5e56c9bc34987988");
require("de300fb3019dd4bf");
var useProps = require("af8e939d4404f12b");
require("7ac7340179207292");
var useStyles = require("e196184069f0b53c");
var Box = require("943f1e4e09b17372");
var factory = require("1501e08f5e60f6");
require("f73793b646ab1788");
var ScrollArea = require("9358fb6968e71576");
var Table_module = require("4070ed414d1b2057");
var defaultProps = {
    type: "scrollarea"
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var minWidth = param.minWidth, maxHeight = param.maxHeight, type = param.type;
    return {
        scrollContainer: {
            "--table-min-width": rem.rem(minWidth),
            "--table-max-height": rem.rem(maxHeight),
            "--table-overflow": type === "native" ? "auto" : void 0
        }
    };
});
var TableScrollContainer = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TableScrollContainer", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, minWidth = props.minWidth, maxHeight = props.maxHeight, type = props.type, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "minWidth",
        "maxHeight",
        "type"
    ]);
    var getStyles = useStyles.useStyles({
        name: "TableScrollContainer",
        classes: Table_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "scrollContainer"
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
        component: type === "scrollarea" ? ScrollArea.ScrollArea : "div"
    }, type === "scrollarea" ? maxHeight ? {
        offsetScrollbars: "xy"
    } : {
        offsetScrollbars: "x"
    } : {}), {
        ref
    }), getStyles("scrollContainer"), others), {
        children: /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("scrollContainerInner")), {
            children
        }))
    }));
});
TableScrollContainer.classes = Table_module;
TableScrollContainer.displayName = "@mantine/core/TableScrollContainer";
exports.TableScrollContainer = TableScrollContainer; //# sourceMappingURL=TableScrollContainer.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","68cd82d5e2b83ee0":"iKGFf","ab66960575f66572":"ebAaL","426e5d65dca6fb25":"9MtAM","f45c25163a51a3ac":"9HEEB","28536cb6f8a5a257":"hIQE6","2be31e21a554b881":"8QFOC","e456c286e07874e4":"2FdJg","4d4f7d957d3d2726":"6AMGA","5e56c9bc34987988":"erSvz","de300fb3019dd4bf":"kqQOF","af8e939d4404f12b":"iivvn","7ac7340179207292":"8YP4O","e196184069f0b53c":"d0sAY","943f1e4e09b17372":"gkGXc","1501e08f5e60f6":"guLFz","f73793b646ab1788":"2onWA","9358fb6968e71576":"ctZfT","4070ed414d1b2057":"iM752"}],"80381":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("4e88fe5d6cd2bbc6");
var hooks = require("48c2211d9953279f");
var rem = require("5b6416e492a55f3b");
require("37d16b48a2b8563c");
var getSize = require("b76fb0afeb9308f");
var createVarsResolver = require("2fa1b99c4bd1fd43");
require("b10e426d08375217");
require("7455147f0705574");
require("fec09e1bff262126");
require("363adcdc9d8330b7");
require("4662e39ade92145c");
var useProps = require("d4da927542c3c142");
require("4b60ec89d0d67963");
var useStyles = require("10791eec3bb3bcb2");
var Box = require("3b4f9f4c8fa3d3dd");
var factory = require("f4f9b7e8fc2984d6");
require("7b6fd95bc8e50468");
var UnstyledButton = require("8a1e1bf9a5ec48b");
var TableOfContents_module = require("aa754a5cb771453c");
var defaultProps = {
    getControlProps: function(param) {
        var data = param.data;
        return {
            children: data.value
        };
    }
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var color = param.color, size = param.size, variant = param.variant, autoContrast = param.autoContrast, depthOffset = param.depthOffset, radius = param.radius;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--toc-bg": variant !== "none" ? colors.background : void 0,
            "--toc-color": variant !== "none" ? colors.color : void 0,
            "--toc-size": getSize.getFontSize(size),
            "--toc-depth-offset": rem.rem(depthOffset),
            "--toc-radius": getSize.getRadius(radius)
        }
    };
});
var TableOfContents = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TableOfContents", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, color = props.color, autoContrast = props.autoContrast, scrollSpyOptions = props.scrollSpyOptions, initialData = props.initialData, getControlProps = props.getControlProps, minDepthToOffset = props.minDepthToOffset, depthOffset = props.depthOffset, variant = props.variant, radius = props.radius, reinitializeRef = props.reinitializeRef, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "color",
        "autoContrast",
        "scrollSpyOptions",
        "initialData",
        "getControlProps",
        "minDepthToOffset",
        "depthOffset",
        "variant",
        "radius",
        "reinitializeRef"
    ]);
    var getStyles = useStyles.useStyles({
        name: "TableOfContents",
        classes: TableOfContents_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var idBase = hooks.useId();
    var spy = hooks.useScrollSpy(scrollSpyOptions);
    hooks.assignRef(reinitializeRef, spy.reinitialize);
    var headingsData = spy.initialized ? spy.data : initialData || [];
    var controls = headingsData.map(function(data, index) {
        var controlProps = getControlProps === null || getControlProps === void 0 ? void 0 : getControlProps({
            active: index === spy.active,
            data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                getNode: data.getNode || function() {}
            })
        });
        return /* @__PURE__ */ jsxRuntime.jsx(UnstyledButton.UnstyledButton, (0, _objectSpread._)({
            __vars: {
                "--depth-offset": `${data.depth - (minDepthToOffset || 1)}`
            },
            "data-active": index === spy.active || void 0,
            variant
        }, controlProps, getStyles("control", {
            className: controlProps === null || controlProps === void 0 ? void 0 : controlProps.className,
            style: controlProps === null || controlProps === void 0 ? void 0 : controlProps.style
        })), data.id || `${idBase}-${index}`);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref,
        variant
    }, getStyles("root"), others), {
        children: controls
    }));
});
TableOfContents.displayName = "@mantine/core/TableOfContents";
TableOfContents.classes = TableOfContents_module;
exports.TableOfContents = TableOfContents; //# sourceMappingURL=TableOfContents.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","4e88fe5d6cd2bbc6":"iKGFf","48c2211d9953279f":"9HEEB","5b6416e492a55f3b":"ebAaL","37d16b48a2b8563c":"9MtAM","b76fb0afeb9308f":"kEFEY","2fa1b99c4bd1fd43":"hIQE6","b10e426d08375217":"8QFOC","7455147f0705574":"2FdJg","fec09e1bff262126":"6AMGA","363adcdc9d8330b7":"erSvz","4662e39ade92145c":"kqQOF","d4da927542c3c142":"iivvn","4b60ec89d0d67963":"8YP4O","10791eec3bb3bcb2":"d0sAY","3b4f9f4c8fa3d3dd":"gkGXc","f4f9b7e8fc2984d6":"guLFz","7b6fd95bc8e50468":"2onWA","8a1e1bf9a5ec48b":"cArqr","aa754a5cb771453c":"g6QkE"}],"g6QkE":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_bcaa9990",
    "control": "m_375a65ef"
};
module.exports = classes; //# sourceMappingURL=TableOfContents.module.css.cjs.map

},{}],"416JA":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
var jsxRuntime = require("15246b85f90b5fd1");
var hooks = require("9e3759b8cb2a2499");
require("c53b08b62c672291");
var getSafeId = require("cd470b7c89d4dc60");
var getSize = require("ae2bc175076c8e33");
var createVarsResolver = require("a3fe2a720e29a2bc");
require("670f058d347f913f");
var getThemeColor = require("567de7c123b0424a");
var getContrastColor = require("92d769a5695b6eb8");
var getAutoContrastValue = require("e41bb82fa1023121");
require("25646bd7ea003aab");
require("bc7e3514bc6d47ae");
require("a5b7b14d8845b095");
require("fa62918a6a1ca8e2");
var useProps = require("ab03b9e14ca01dc1");
require("5314f8a9a8550d50");
var useStyles = require("4c9e2661b89efa9d");
var Box = require("8d685bf166358978");
var factory = require("aeda229b356aa139");
require("c04fd8d1d03b82a3");
var Tabs_context = require("f45e35191693a5b5");
var TabsList = require("5492fae181206b4f");
var TabsPanel = require("342866e0f0899d24");
var TabsTab = require("dcb43daa7c86d190");
var Tabs_module = require("e1c78b44a5938740");
var VALUE_ERROR = "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value";
var defaultProps = {
    keepMounted: true,
    orientation: "horizontal",
    loop: true,
    activateTabWithKeyboard: true,
    allowTabDeactivation: false,
    unstyled: false,
    inverted: false,
    variant: "default",
    placement: "left"
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var radius = param.radius, color = param.color, autoContrast = param.autoContrast;
    return {
        root: {
            "--tabs-radius": getSize.getRadius(radius),
            "--tabs-color": getThemeColor.getThemeColor(color, theme),
            "--tabs-text-color": getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
var Tabs = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Tabs", defaultProps, _props);
    var defaultValue = props.defaultValue, value = props.value, onChange = props.onChange, orientation = props.orientation, children = props.children, loop = props.loop, id = props.id, activateTabWithKeyboard = props.activateTabWithKeyboard, allowTabDeactivation = props.allowTabDeactivation, variant = props.variant, color = props.color, radius = props.radius, inverted = props.inverted, placement = props.placement, keepMounted = props.keepMounted, classNames = props.classNames, styles = props.styles, unstyled = props.unstyled, className = props.className, style = props.style, vars = props.vars, autoContrast = props.autoContrast, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "defaultValue",
        "value",
        "onChange",
        "orientation",
        "children",
        "loop",
        "id",
        "activateTabWithKeyboard",
        "allowTabDeactivation",
        "variant",
        "color",
        "radius",
        "inverted",
        "placement",
        "keepMounted",
        "classNames",
        "styles",
        "unstyled",
        "className",
        "style",
        "vars",
        "autoContrast",
        "mod"
    ]);
    var uid = hooks.useId(id);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: null,
        onChange
    }), 2), currentTab = _hooks_useUncontrolled[0], setCurrentTab = _hooks_useUncontrolled[1];
    var getStyles = useStyles.useStyles({
        name: "Tabs",
        props,
        classes: Tabs_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Tabs_context.TabsProvider, {
        value: {
            placement,
            value: currentTab,
            orientation,
            id: uid,
            loop,
            activateTabWithKeyboard,
            getTabId: getSafeId.getSafeId(`${uid}-tab`, VALUE_ERROR),
            getPanelId: getSafeId.getSafeId(`${uid}-panel`, VALUE_ERROR),
            onChange: setCurrentTab,
            allowTabDeactivation,
            variant,
            color,
            radius,
            inverted,
            keepMounted,
            unstyled,
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
            ref,
            id: uid,
            variant,
            mod: [
                {
                    orientation,
                    inverted: orientation === "horizontal" && inverted,
                    placement: orientation === "vertical" && placement
                },
                mod
            ]
        }, getStyles("root"), others), {
            children
        }))
    });
});
Tabs.classes = Tabs_module;
Tabs.displayName = "@mantine/core/Tabs";
Tabs.Tab = TabsTab.TabsTab;
Tabs.Panel = TabsPanel.TabsPanel;
Tabs.List = TabsList.TabsList;
exports.Tabs = Tabs; //# sourceMappingURL=Tabs.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","15246b85f90b5fd1":"iKGFf","9e3759b8cb2a2499":"9HEEB","c53b08b62c672291":"9MtAM","cd470b7c89d4dc60":"dvoq6","ae2bc175076c8e33":"kEFEY","a3fe2a720e29a2bc":"hIQE6","670f058d347f913f":"8QFOC","567de7c123b0424a":"eeaIN","92d769a5695b6eb8":"ez6cW","e41bb82fa1023121":"cN4dA","25646bd7ea003aab":"2FdJg","bc7e3514bc6d47ae":"6AMGA","a5b7b14d8845b095":"erSvz","fa62918a6a1ca8e2":"kqQOF","ab03b9e14ca01dc1":"iivvn","5314f8a9a8550d50":"8YP4O","4c9e2661b89efa9d":"d0sAY","8d685bf166358978":"gkGXc","aeda229b356aa139":"guLFz","c04fd8d1d03b82a3":"2onWA","f45e35191693a5b5":"fQ52O","5492fae181206b4f":"7yyfs","342866e0f0899d24":"ckWt9","dcb43daa7c86d190":"cFpnp","e1c78b44a5938740":"f6rdd"}],"fQ52O":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("d0f0ca90d0dafd53");
var createSafeContext = require("16f885be47267042");
require("adc6088e02b3c546");
require("fad18f0676d501b");
require("3a76f11318727bde");
require("96752dbae5c94aaa");
require("bfdb283ff93bd1ae");
require("ed7c219f0552e073");
require("ee2e852086d5f5d4");
require("3b6ea7953e9a311e");
require("16f77dcce1082e09");
require("b1e8012b1b2742ee");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Tabs component was not found in the tree"), 2), TabsProvider = _createSafeContext_createSafeContext[0], useTabsContext = _createSafeContext_createSafeContext[1];
exports.TabsProvider = TabsProvider;
exports.useTabsContext = useTabsContext; //# sourceMappingURL=Tabs.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","d0f0ca90d0dafd53":"9MtAM","16f885be47267042":"8srze","adc6088e02b3c546":"iKGFf","fad18f0676d501b":"9HEEB","3a76f11318727bde":"8QFOC","96752dbae5c94aaa":"2FdJg","bfdb283ff93bd1ae":"6AMGA","ed7c219f0552e073":"erSvz","ee2e852086d5f5d4":"kqQOF","3b6ea7953e9a311e":"8YP4O","16f77dcce1082e09":"gkGXc","b1e8012b1b2742ee":"2onWA"}],"7yyfs":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("1a39c133aee07807");
require("fc36a6b5b73e6062");
require("5ae442d71d3abc84");
require("86f80c68995d55df");
require("66a2a7f54726209");
require("d8c075b149eb58a6");
require("afd6a2f1370bfc51");
require("7f5e23642c785a40");
var useProps = require("4def697c56234de");
require("72ba18dabd7fffd1");
var Box = require("72eed7103778c3bd");
var factory = require("62778526e256f3b6");
require("eaed4c2bcf6494ab");
var Tabs_context = require("a2751fd7b43a53cb");
var Tabs_module = require("c09a7faa01f0b98d");
var defaultProps = {};
var TabsList = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TabsList", defaultProps, _props);
    var children = props.children, className = props.className, grow = props.grow, justify = props.justify, classNames = props.classNames, styles = props.styles, style = props.style, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "children",
        "className",
        "grow",
        "justify",
        "classNames",
        "styles",
        "style",
        "mod"
    ]);
    var ctx = Tabs_context.useTabsContext();
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others, ctx.getStyles("list", {
        className,
        style,
        classNames,
        styles,
        props,
        variant: ctx.variant
    })), {
        ref,
        role: "tablist",
        variant: ctx.variant,
        mod: [
            {
                grow,
                orientation: ctx.orientation,
                placement: ctx.orientation === "vertical" && ctx.placement,
                inverted: ctx.inverted
            },
            mod
        ],
        "aria-orientation": ctx.orientation,
        __vars: {
            "--tabs-justify": justify
        },
        children
    }));
});
TabsList.classes = Tabs_module;
TabsList.displayName = "@mantine/core/TabsList";
exports.TabsList = TabsList; //# sourceMappingURL=TabsList.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","1a39c133aee07807":"iKGFf","fc36a6b5b73e6062":"9MtAM","5ae442d71d3abc84":"9HEEB","86f80c68995d55df":"8QFOC","66a2a7f54726209":"2FdJg","d8c075b149eb58a6":"6AMGA","afd6a2f1370bfc51":"erSvz","7f5e23642c785a40":"kqQOF","4def697c56234de":"iivvn","72ba18dabd7fffd1":"8YP4O","72eed7103778c3bd":"gkGXc","62778526e256f3b6":"guLFz","eaed4c2bcf6494ab":"2onWA","a2751fd7b43a53cb":"fQ52O","c09a7faa01f0b98d":"f6rdd"}],"f6rdd":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_89d60db1",
    "list--default": "m_576c9d4",
    "list": "m_89d33d6d",
    "panel": "m_b0c91715",
    "tab": "m_4ec4dce6",
    "tabSection": "m_fc420b1f",
    "tab--default": "m_539e827b",
    "list--outline": "m_6772fbd5",
    "tab--outline": "m_b59ab47c",
    "tab--pills": "m_c3381914"
};
module.exports = classes; //# sourceMappingURL=Tabs.module.css.cjs.map

},{}],"ckWt9":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("6682a2dec1f0f4a3");
require("b7a9e0517d193075");
require("9c99e8e763aacd47");
require("8c2419a46b913f85");
require("4ebc1d5600cfeb3c");
require("d648a265bcb6b1cc");
require("9b8b5f2a65acfaa7");
require("f7ff818607b0f941");
var useProps = require("4b6f9cad5b354cf9");
require("7a0190fdc951a6f6");
var Box = require("77881609976ea678");
var factory = require("97cead689f76e703");
require("3e6b4c3c41386781");
var Tabs_context = require("d78e2ca889ec3273");
var Tabs_module = require("ea290c422e14a95");
var defaultProps = {};
var TabsPanel = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TabsPanel", defaultProps, _props);
    var children = props.children, className = props.className, value = props.value, classNames = props.classNames, styles = props.styles, style = props.style, mod = props.mod, keepMounted = props.keepMounted, others = (0, _objectWithoutProperties._)(props, [
        "children",
        "className",
        "value",
        "classNames",
        "styles",
        "style",
        "mod",
        "keepMounted"
    ]);
    var ctx = Tabs_context.useTabsContext();
    var active = ctx.value === value;
    var content = ctx.keepMounted || keepMounted ? children : active ? children : null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others, ctx.getStyles("panel", {
        className,
        classNames,
        styles,
        style: [
            style,
            !active ? {
                display: "none"
            } : void 0
        ],
        props
    })), {
        ref,
        mod: [
            {
                orientation: ctx.orientation
            },
            mod
        ],
        role: "tabpanel",
        id: ctx.getPanelId(value),
        "aria-labelledby": ctx.getTabId(value),
        children: content
    }));
});
TabsPanel.classes = Tabs_module;
TabsPanel.displayName = "@mantine/core/TabsPanel";
exports.TabsPanel = TabsPanel; //# sourceMappingURL=TabsPanel.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","6682a2dec1f0f4a3":"iKGFf","b7a9e0517d193075":"9MtAM","9c99e8e763aacd47":"9HEEB","8c2419a46b913f85":"8QFOC","4ebc1d5600cfeb3c":"2FdJg","d648a265bcb6b1cc":"6AMGA","9b8b5f2a65acfaa7":"erSvz","f7ff818607b0f941":"kqQOF","4b6f9cad5b354cf9":"iivvn","7a0190fdc951a6f6":"8YP4O","77881609976ea678":"gkGXc","97cead689f76e703":"guLFz","3e6b4c3c41386781":"2onWA","d78e2ca889ec3273":"fQ52O","ea290c422e14a95":"f6rdd"}],"cFpnp":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("f2339db1da87bd36");
require("c74de079f7b41f58");
var createScopedKeydownHandler = require("3c40cc0095da3d8f");
require("1b24948ae354e911");
require("34e3b9619c0e5d4e");
var getThemeColor = require("beb20da9c4a7895");
require("ef0ed4d9013de769");
require("e1a53a8e982dd58e");
require("298db44666f80384");
var MantineThemeProvider = require("c12e1787504a2d39");
var useProps = require("5ee1e37dfba7efff");
require("108321e864a3cc40");
require("b6d7659cc6bcb536");
var factory = require("3a154290398b008");
var DirectionProvider = require("f37b9d709c8a9c07");
var UnstyledButton = require("ff74453b4fae1dd0");
var Tabs_context = require("43309c7bb412007d");
var Tabs_module = require("12db6a4bb7bf5a25");
var defaultProps = {};
var TabsTab = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TabsTab", defaultProps, _props);
    var className = props.className, children = props.children, rightSection = props.rightSection, leftSection = props.leftSection, value = props.value, onClick = props.onClick, onKeyDown = props.onKeyDown, disabled = props.disabled, color = props.color, style = props.style, classNames = props.classNames, styles = props.styles, vars = props.vars, mod = props.mod, tabIndex = props.tabIndex, others = (0, _objectWithoutProperties._)(props, [
        "className",
        "children",
        "rightSection",
        "leftSection",
        "value",
        "onClick",
        "onKeyDown",
        "disabled",
        "color",
        "style",
        "classNames",
        "styles",
        "vars",
        "mod",
        "tabIndex"
    ]);
    var theme = MantineThemeProvider.useMantineTheme();
    var dir = DirectionProvider.useDirection().dir;
    var ctx = Tabs_context.useTabsContext();
    var active = value === ctx.value;
    var activateTab = function(event) {
        ctx.onChange(ctx.allowTabDeactivation ? value === ctx.value ? null : value : value);
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    var stylesApiProps = {
        classNames,
        styles,
        props
    };
    return /* @__PURE__ */ jsxRuntime.jsxs(UnstyledButton.UnstyledButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, others, ctx.getStyles("tab", (0, _objectSpread._)({
        className,
        style,
        variant: ctx.variant
    }, stylesApiProps))), {
        disabled,
        unstyled: ctx.unstyled,
        variant: ctx.variant,
        mod: [
            {
                active,
                disabled,
                orientation: ctx.orientation,
                inverted: ctx.inverted,
                placement: ctx.orientation === "vertical" && ctx.placement
            },
            mod
        ],
        ref,
        role: "tab",
        id: ctx.getTabId(value),
        "aria-selected": active,
        tabIndex: tabIndex !== void 0 ? tabIndex : active || ctx.value === null ? 0 : -1,
        "aria-controls": ctx.getPanelId(value),
        onClick: activateTab,
        __vars: {
            "--tabs-color": color ? getThemeColor.getThemeColor(color, theme) : void 0
        },
        onKeyDown: createScopedKeydownHandler.createScopedKeydownHandler({
            siblingSelector: '[role="tab"]',
            parentSelector: '[role="tablist"]',
            activateOnFocus: ctx.activateTabWithKeyboard,
            loop: ctx.loop,
            orientation: ctx.orientation || "horizontal",
            dir,
            onKeyDown
        }),
        children: [
            leftSection && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("tabSection", stylesApiProps)), {
                "data-position": "left",
                children: leftSection
            })),
            children && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("tabLabel", stylesApiProps)), {
                children
            })),
            rightSection && /* @__PURE__ */ jsxRuntime.jsx("span", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("tabSection", stylesApiProps)), {
                "data-position": "right",
                children: rightSection
            }))
        ]
    }));
});
TabsTab.classes = Tabs_module;
TabsTab.displayName = "@mantine/core/TabsTab";
exports.TabsTab = TabsTab; //# sourceMappingURL=TabsTab.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","f2339db1da87bd36":"iKGFf","c74de079f7b41f58":"9MtAM","3c40cc0095da3d8f":"5jFxz","1b24948ae354e911":"9HEEB","34e3b9619c0e5d4e":"8QFOC","beb20da9c4a7895":"eeaIN","ef0ed4d9013de769":"2FdJg","e1a53a8e982dd58e":"6AMGA","298db44666f80384":"erSvz","c12e1787504a2d39":"kqQOF","5ee1e37dfba7efff":"iivvn","108321e864a3cc40":"8YP4O","b6d7659cc6bcb536":"gkGXc","3a154290398b008":"guLFz","f37b9d709c8a9c07":"2onWA","ff74453b4fae1dd0":"cArqr","43309c7bb412007d":"fQ52O","12db6a4bb7bf5a25":"f6rdd"}],"4oBME":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("445bef383cdfef7");
var React = require("2f53306ac012bacb");
var hooks = require("125436dec4dccefd");
require("da79f56943a5d932");
var useResolvedStylesApi = require("36c2b1cbaa872df8");
var useStyles = require("3c1f7a2209badcde");
require("ee2a0558727792e0");
require("3296ae5b3107d68a");
require("fcbd48f13caf076a");
require("6150c5c6ac31c18e");
var useProps = require("8ab8f1ffb04517ac");
require("22c24e3e5ac92cbd");
var extractStyleProps = require("e9cc8a3bcbdbdf38");
require("e08209473f055896");
var factory = require("7eb51e6f1b9fcd02");
require("a3647071b2fb67fa");
var getParsedComboboxData = require("57d4f1020f67b3c7");
var getOptionsLockup = require("6fc13e6b4bda8750");
require("43f3242a5b1059ab");
var Combobox = require("854f6ac377b2d554");
require("c84d5234c46c91cd");
require("9ffcfc36f83f406d");
require("b260924f1e8ac20b");
require("d929abb7d28f22c2");
require("7b6568dc120074ad");
require("2c5c815ab10e0d36");
require("8cf8016f78bfd87c");
require("6a384b1c181570c7");
require("c66ede1748cdb779");
require("d77c6c63b53efa5f");
require("208b5ff12e81c08b");
require("ae71bf6a5bba10e8");
require("49e4b59c9306507a");
var OptionsDropdown = require("55d79ad170508436");
var useCombobox = require("1d4bb4659809b606");
require("3efb7adadf09b295");
var InputBase = require("4287b85e61eda40d");
var Pill = require("9ee2ea2b7e9cc558");
require("920281fb568868db");
var PillsInput = require("958a9ac0ac4d427b");
require("b02ddd8294065f2f");
var filterPickedTags = require("7c812c88d19448ca");
var getSplittedTags = require("568cbad9377a75a3");
var defaultProps = {
    maxTags: Infinity,
    allowDuplicates: false,
    acceptValueOnBlur: true,
    splitChars: [
        ","
    ],
    hiddenInputValuesDivider: ","
};
var TagsInput = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TagsInput", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, size = props.size, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, onKeyDown = props.onKeyDown, maxTags = props.maxTags, allowDuplicates = props.allowDuplicates, onDuplicate = props.onDuplicate, variant = props.variant, data = props.data, dropdownOpened = props.dropdownOpened, defaultDropdownOpened = props.defaultDropdownOpened, onDropdownOpen = props.onDropdownOpen, onDropdownClose = props.onDropdownClose, selectFirstOptionOnChange = props.selectFirstOptionOnChange, onOptionSubmit = props.onOptionSubmit, comboboxProps = props.comboboxProps, filter = props.filter, limit = props.limit, withScrollArea = props.withScrollArea, maxDropdownHeight = props.maxDropdownHeight, searchValue = props.searchValue, defaultSearchValue = props.defaultSearchValue, onSearchChange = props.onSearchChange, readOnly = props.readOnly, disabled = props.disabled, splitChars = props.splitChars, onFocus = props.onFocus, onBlur = props.onBlur, onPaste = props.onPaste, radius = props.radius, rightSection = props.rightSection, rightSectionWidth = props.rightSectionWidth, rightSectionPointerEvents = props.rightSectionPointerEvents, rightSectionProps = props.rightSectionProps, leftSection = props.leftSection, leftSectionWidth = props.leftSectionWidth, leftSectionPointerEvents = props.leftSectionPointerEvents, leftSectionProps = props.leftSectionProps, inputContainer = props.inputContainer, inputWrapperOrder = props.inputWrapperOrder, withAsterisk = props.withAsterisk, required = props.required, labelProps = props.labelProps, descriptionProps = props.descriptionProps, errorProps = props.errorProps, wrapperProps = props.wrapperProps, description = props.description, label = props.label, error = props.error, withErrorStyles = props.withErrorStyles, name = props.name, form = props.form, id = props.id, clearable = props.clearable, clearButtonProps = props.clearButtonProps, hiddenInputProps = props.hiddenInputProps, hiddenInputValuesDivider = props.hiddenInputValuesDivider, mod = props.mod, renderOption = props.renderOption, onRemove = props.onRemove, onClear = props.onClear, scrollAreaProps = props.scrollAreaProps, acceptValueOnBlur = props.acceptValueOnBlur, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "size",
        "value",
        "defaultValue",
        "onChange",
        "onKeyDown",
        "maxTags",
        "allowDuplicates",
        "onDuplicate",
        "variant",
        "data",
        "dropdownOpened",
        "defaultDropdownOpened",
        "onDropdownOpen",
        "onDropdownClose",
        "selectFirstOptionOnChange",
        "onOptionSubmit",
        "comboboxProps",
        "filter",
        "limit",
        "withScrollArea",
        "maxDropdownHeight",
        "searchValue",
        "defaultSearchValue",
        "onSearchChange",
        "readOnly",
        "disabled",
        "splitChars",
        "onFocus",
        "onBlur",
        "onPaste",
        "radius",
        "rightSection",
        "rightSectionWidth",
        "rightSectionPointerEvents",
        "rightSectionProps",
        "leftSection",
        "leftSectionWidth",
        "leftSectionPointerEvents",
        "leftSectionProps",
        "inputContainer",
        "inputWrapperOrder",
        "withAsterisk",
        "required",
        "labelProps",
        "descriptionProps",
        "errorProps",
        "wrapperProps",
        "description",
        "label",
        "error",
        "withErrorStyles",
        "name",
        "form",
        "id",
        "clearable",
        "clearButtonProps",
        "hiddenInputProps",
        "hiddenInputValuesDivider",
        "mod",
        "renderOption",
        "onRemove",
        "onClear",
        "scrollAreaProps",
        "acceptValueOnBlur"
    ]);
    var _id = hooks.useId(id);
    var parsedData = getParsedComboboxData.getParsedComboboxData(data);
    var optionsLockup = getOptionsLockup.getOptionsLockup(parsedData);
    var inputRef = React.useRef(null);
    var _ref = hooks.useMergedRef(inputRef, ref);
    var combobox = useCombobox.useCombobox({
        opened: dropdownOpened,
        defaultOpened: defaultDropdownOpened,
        onDropdownOpen,
        onDropdownClose: function() {
            onDropdownClose === null || onDropdownClose === void 0 ? void 0 : onDropdownClose();
            combobox.resetSelectedOption();
        }
    });
    var _extractStyleProps_extractStyleProps = extractStyleProps.extractStyleProps(others), styleProps = _extractStyleProps_extractStyleProps.styleProps, _extractStyleProps_extractStyleProps_rest = _extractStyleProps_extractStyleProps.rest, type = _extractStyleProps_extractStyleProps_rest.type, autoComplete = _extractStyleProps_extractStyleProps_rest.autoComplete, rest = (0, _objectWithoutProperties._)(_extractStyleProps_extractStyleProps.rest, [
        "type",
        "autoComplete"
    ]);
    var _hooks_useUncontrolled = (0, _slicedToArray._)(hooks.useUncontrolled({
        value,
        defaultValue,
        finalValue: [],
        onChange
    }), 2), _value = _hooks_useUncontrolled[0], setValue = _hooks_useUncontrolled[1];
    var _hooks_useUncontrolled1 = (0, _slicedToArray._)(hooks.useUncontrolled({
        value: searchValue,
        defaultValue: defaultSearchValue,
        finalValue: "",
        onChange: onSearchChange
    }), 2), _searchValue = _hooks_useUncontrolled1[0], setSearchValue = _hooks_useUncontrolled1[1];
    var handleSearchChange = function(value2) {
        setSearchValue(value2);
        combobox.resetSelectedOption();
    };
    var getStyles = useStyles.useStyles({
        name: "TagsInput",
        classes: {},
        props,
        classNames,
        styles,
        unstyled
    });
    var _useResolvedStylesApi_useResolvedStylesApi = useResolvedStylesApi.useResolvedStylesApi({
        props,
        styles,
        classNames
    }), resolvedClassNames = _useResolvedStylesApi_useResolvedStylesApi.resolvedClassNames, resolvedStyles = _useResolvedStylesApi_useResolvedStylesApi.resolvedStyles;
    var handleValueSelect = function(val) {
        var isDuplicate = _value.some(function(tag) {
            return tag.toLowerCase() === val.toLowerCase();
        });
        if (isDuplicate) onDuplicate === null || onDuplicate === void 0 ? void 0 : onDuplicate(val);
        if ((!isDuplicate || isDuplicate && allowDuplicates) && _value.length < maxTags) {
            onOptionSubmit === null || onOptionSubmit === void 0 ? void 0 : onOptionSubmit(val);
            handleSearchChange("");
            if (val.length > 0) setValue((0, _toConsumableArray._)(_value).concat([
                val
            ]));
        }
    };
    var handleInputKeydown = function(event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (event.isPropagationStopped()) return;
        var inputValue = _searchValue.trim();
        var length = inputValue.length;
        if (splitChars.includes(event.key) && length > 0) {
            setValue(getSplittedTags.getSplittedTags({
                splitChars,
                allowDuplicates,
                maxTags,
                value: _searchValue,
                currentTags: _value
            }));
            handleSearchChange("");
            event.preventDefault();
        }
        if (event.key === "Enter" && length > 0 && !event.nativeEvent.isComposing) {
            event.preventDefault();
            var hasActiveSelection = !!document.querySelector(`#${combobox.listId} [data-combobox-option][data-combobox-selected]`);
            if (hasActiveSelection) return;
            handleValueSelect(inputValue);
        }
        if (event.key === "Backspace" && length === 0 && _value.length > 0 && !event.nativeEvent.isComposing) {
            onRemove === null || onRemove === void 0 ? void 0 : onRemove(_value[_value.length - 1]);
            setValue(_value.slice(0, _value.length - 1));
        }
    };
    var handlePaste = function(event) {
        onPaste === null || onPaste === void 0 ? void 0 : onPaste(event);
        event.preventDefault();
        if (event.clipboardData) {
            var pastedText = event.clipboardData.getData("text/plain");
            setValue(getSplittedTags.getSplittedTags({
                splitChars,
                allowDuplicates,
                maxTags,
                value: `${_searchValue}${pastedText}`,
                currentTags: _value
            }));
            handleSearchChange("");
        }
    };
    var values = _value.map(function(item, index) {
        return /* @__PURE__ */ jsxRuntime.jsx(Pill.Pill, (0, _objectSpreadProps._)((0, _objectSpread._)({
            withRemoveButton: !readOnly,
            onRemove: function() {
                var next_value = _value.slice();
                next_value.splice(index, 1);
                setValue(next_value);
                onRemove === null || onRemove === void 0 ? void 0 : onRemove(item);
            },
            unstyled,
            disabled
        }, getStyles("pill")), {
            children: item
        }), `${item}-${index}`);
    });
    React.useEffect(function() {
        if (selectFirstOptionOnChange) combobox.selectFirstOption();
    }, [
        selectFirstOptionOnChange,
        _value,
        _searchValue
    ]);
    var clearButton = /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.ClearButton, (0, _objectSpreadProps._)((0, _objectSpread._)({}, clearButtonProps), {
        onClear: function() {
            var _inputRef_current;
            setValue([]);
            handleSearchChange("");
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            combobox.openDropdown();
            onClear === null || onClear === void 0 ? void 0 : onClear();
        }
    }));
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            /* @__PURE__ */ jsxRuntime.jsxs(Combobox.Combobox, (0, _objectSpreadProps._)((0, _objectSpread._)({
                store: combobox,
                classNames: resolvedClassNames,
                styles: resolvedStyles,
                unstyled,
                size,
                readOnly,
                __staticSelector: "TagsInput",
                onOptionSubmit: function(val) {
                    onOptionSubmit === null || onOptionSubmit === void 0 ? void 0 : onOptionSubmit(val);
                    handleSearchChange("");
                    _value.length < maxTags && setValue((0, _toConsumableArray._)(_value).concat([
                        optionsLockup[val].label
                    ]));
                    combobox.resetSelectedOption();
                }
            }, comboboxProps), {
                children: [
                    /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.DropdownTarget, {
                        children: /* @__PURE__ */ jsxRuntime.jsx(PillsInput.PillsInput, (0, _objectSpreadProps._)((0, _objectSpread._)({}, styleProps), {
                            __staticSelector: "TagsInput",
                            classNames: resolvedClassNames,
                            styles: resolvedStyles,
                            unstyled,
                            size,
                            className,
                            style,
                            variant,
                            disabled,
                            radius,
                            rightSection,
                            __clearSection: clearButton,
                            __clearable: clearable && _value.length > 0 && !disabled && !readOnly,
                            rightSectionWidth,
                            rightSectionPointerEvents,
                            rightSectionProps,
                            leftSection,
                            leftSectionWidth,
                            leftSectionPointerEvents,
                            leftSectionProps,
                            inputContainer,
                            inputWrapperOrder,
                            withAsterisk,
                            required,
                            labelProps,
                            descriptionProps,
                            errorProps,
                            wrapperProps,
                            description,
                            label,
                            error,
                            withErrorStyles,
                            __stylesApiProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                                multiline: true
                            }),
                            id: _id,
                            mod,
                            children: /* @__PURE__ */ jsxRuntime.jsxs(Pill.Pill.Group, (0, _objectSpreadProps._)((0, _objectSpread._)({
                                disabled,
                                unstyled
                            }, getStyles("pillsList")), {
                                children: [
                                    values,
                                    /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.EventsTarget, {
                                        autoComplete,
                                        children: /* @__PURE__ */ jsxRuntime.jsx(PillsInput.PillsInput.Field, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
                                            ref: _ref
                                        }), getStyles("inputField")), {
                                            unstyled,
                                            onKeyDown: handleInputKeydown,
                                            onFocus: function(event) {
                                                onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                                                combobox.openDropdown();
                                            },
                                            onBlur: function(event) {
                                                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                                                acceptValueOnBlur && handleValueSelect(_searchValue);
                                                combobox.closeDropdown();
                                            },
                                            onPaste: handlePaste,
                                            value: _searchValue,
                                            onChange: function(event) {
                                                return handleSearchChange(event.currentTarget.value);
                                            },
                                            required: required && _value.length === 0,
                                            disabled,
                                            readOnly,
                                            id: _id
                                        }))
                                    })
                                ]
                            }))
                        }))
                    }),
                    /* @__PURE__ */ jsxRuntime.jsx(OptionsDropdown.OptionsDropdown, {
                        data: filterPickedTags.filterPickedTags({
                            data: parsedData,
                            value: _value
                        }),
                        hidden: readOnly || disabled,
                        filter,
                        search: _searchValue,
                        limit,
                        hiddenWhenEmpty: true,
                        withScrollArea,
                        maxDropdownHeight,
                        unstyled,
                        labelId: label ? `${_id}-label` : void 0,
                        "aria-label": label ? void 0 : others["aria-label"],
                        renderOption,
                        scrollAreaProps
                    })
                ]
            })),
            /* @__PURE__ */ jsxRuntime.jsx(Combobox.Combobox.HiddenInput, (0, _objectSpread._)({
                name,
                form,
                value: _value,
                valuesDivider: hiddenInputValuesDivider,
                disabled
            }, hiddenInputProps))
        ]
    });
});
TagsInput.classes = (0, _objectSpread._)({}, InputBase.InputBase.classes, Combobox.Combobox.classes);
TagsInput.displayName = "@mantine/core/TagsInput";
exports.TagsInput = TagsInput; //# sourceMappingURL=TagsInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","445bef383cdfef7":"iKGFf","2f53306ac012bacb":"9MtAM","125436dec4dccefd":"9HEEB","da79f56943a5d932":"8QFOC","36c2b1cbaa872df8":"d30sL","3c1f7a2209badcde":"d0sAY","ee2a0558727792e0":"2FdJg","3296ae5b3107d68a":"6AMGA","fcbd48f13caf076a":"erSvz","6150c5c6ac31c18e":"kqQOF","8ab8f1ffb04517ac":"iivvn","22c24e3e5ac92cbd":"8YP4O","e9cc8a3bcbdbdf38":"6L93n","e08209473f055896":"gkGXc","7eb51e6f1b9fcd02":"guLFz","a3647071b2fb67fa":"2onWA","57d4f1020f67b3c7":"71QDZ","6fc13e6b4bda8750":"jSlFr","43f3242a5b1059ab":"6nIYy","854f6ac377b2d554":"d1kVk","c84d5234c46c91cd":"4ROIf","9ffcfc36f83f406d":"alBok","b260924f1e8ac20b":"h5QT5","d929abb7d28f22c2":"8rZez","7b6568dc120074ad":"74J2w","2c5c815ab10e0d36":"iyoTe","8cf8016f78bfd87c":"3ZaWl","6a384b1c181570c7":"9a8Lj","c66ede1748cdb779":"8omXP","d77c6c63b53efa5f":"ceCGy","208b5ff12e81c08b":"1dzCw","ae71bf6a5bba10e8":"4Z9pV","49e4b59c9306507a":"8RMJf","55d79ad170508436":"17zEV","1d4bb4659809b606":"W6tOq","3efb7adadf09b295":"etJ5t","4287b85e61eda40d":"jbA6w","9ee2ea2b7e9cc558":"liYbF","920281fb568868db":"gMUmS","958a9ac0ac4d427b":"2ObFu","b02ddd8294065f2f":"5QihN","7c812c88d19448ca":"woWqW","568cbad9377a75a3":"9KWnq"}],"woWqW":[function(require,module,exports) {
"use client";
"use strict";
require("c604ffca2aba52b9");
require("e4a2e79f0619cbd8");
require("dcc46b502cb7419f");
require("537cfef46d519023");
require("8db47129cec582d1");
require("662c78d8e0e84b1e");
require("6bad58dd422ad03a");
require("e45f80fb6faae058");
require("1c9fae1a60604f95");
require("b662491cd340655f");
require("86756dc3bfc4254c");
require("923cf418d3f3151d");
require("6fb2344d84b85bb9");
require("9d03e6221ec68295");
require("887ffd91e2b0aca");
require("ca1c3e116dbe984d");
require("1c9f46c30d1b0387");
require("e81c7b7544be4cea");
require("8cdb85cc3569db3d");
require("5f70fa1191978772");
require("8d593362573ee343");
require("1fc5726d627cf542");
require("fa27b4043fd0737a");
require("dbe524895e6bc373");
require("72a63eff987ba99");
require("4b60a3c3f6aee5c3");
require("3e4a0c8bb7527ff0");
require("66b43ca0620193f3");
require("64e085652440ab0d");
require("c5798246e8ac880d");
require("a9bbbac5557b15fe");
require("2de5144949443abb");
require("42898b4ed828d104");
var isOptionsGroup = require("ba45194df9e7f17f");
require("1e9e247e4c28b29c");
function filterPickedTags(param) {
    var data = param.data, value = param.value;
    var normalizedValue = value.map(function(item) {
        return item.trim().toLowerCase();
    });
    var filtered = data.reduce(function(acc, item) {
        if (isOptionsGroup.isOptionsGroup(item)) acc.push({
            group: item.group,
            items: item.items.filter(function(option) {
                return normalizedValue.indexOf(option.label.toLowerCase().trim()) === -1;
            })
        });
        else if (normalizedValue.indexOf(item.label.toLowerCase().trim()) === -1) acc.push(item);
        return acc;
    }, []);
    return filtered;
}
exports.filterPickedTags = filterPickedTags; //# sourceMappingURL=filter-picked-tags.cjs.map

},{"c604ffca2aba52b9":"6nIYy","e4a2e79f0619cbd8":"d1kVk","dcc46b502cb7419f":"4ROIf","537cfef46d519023":"alBok","8db47129cec582d1":"h5QT5","662c78d8e0e84b1e":"8rZez","6bad58dd422ad03a":"74J2w","e45f80fb6faae058":"iyoTe","1c9fae1a60604f95":"3ZaWl","b662491cd340655f":"9a8Lj","86756dc3bfc4254c":"8omXP","923cf418d3f3151d":"ceCGy","6fb2344d84b85bb9":"1dzCw","9d03e6221ec68295":"4Z9pV","887ffd91e2b0aca":"8RMJf","ca1c3e116dbe984d":"iKGFf","1c9f46c30d1b0387":"8QFOC","e81c7b7544be4cea":"ey93w","8cdb85cc3569db3d":"01RS9","5f70fa1191978772":"9MtAM","8d593362573ee343":"9HEEB","1fc5726d627cf542":"2FdJg","fa27b4043fd0737a":"6AMGA","dbe524895e6bc373":"erSvz","72a63eff987ba99":"kqQOF","4b60a3c3f6aee5c3":"8YP4O","3e4a0c8bb7527ff0":"gkGXc","66b43ca0620193f3":"2onWA","64e085652440ab0d":"ahwnY","c5798246e8ac880d":"jBkf8","a9bbbac5557b15fe":"jQ0Qw","2de5144949443abb":"1sCYn","42898b4ed828d104":"ctZfT","ba45194df9e7f17f":"2yhqd","1e9e247e4c28b29c":"etJ5t"}],"9KWnq":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function splitTags(splitChars, value) {
    if (!splitChars) return [
        value
    ];
    return value.split(new RegExp(`[${splitChars.join("")}]`)).map(function(tag) {
        return tag.trim();
    }).filter(function(tag) {
        return tag !== "";
    });
}
function getSplittedTags(param) {
    var splitChars = param.splitChars, allowDuplicates = param.allowDuplicates, maxTags = param.maxTags, value = param.value, currentTags = param.currentTags;
    var splitted = splitTags(splitChars, value);
    var merged = allowDuplicates ? (0, _toConsumableArray._)(currentTags).concat((0, _toConsumableArray._)(splitted)) : (0, _toConsumableArray._)(/* @__PURE__ */ new Set((0, _toConsumableArray._)(currentTags).concat((0, _toConsumableArray._)(splitted))));
    return maxTags ? merged.slice(0, maxTags) : merged;
}
exports.getSplittedTags = getSplittedTags; //# sourceMappingURL=get-splitted-tags.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"1rijw":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("6f9fb8e8468e2d3f");
require("6576e34c63f727f1");
require("d65d058f5b254c57");
require("ceb876f31564f32c");
require("9f1f487d003529f0");
require("4199a8d653fcdc63");
require("af66b5847761e216");
require("b7b34339934c34bc");
var useProps = require("a37ad62c43b5ceaf");
require("7d51edb6f84b06ed");
require("fdfdf45b00b15b78");
var factory = require("81b7fbd6da9b7e17");
require("fec25c7fde7b7c5b");
var InputBase = require("2050b55742526c5d");
var defaultProps = {};
var TextInput = factory.factory(function(props, ref) {
    var _props = useProps.useProps("TextInput", defaultProps, props);
    return /* @__PURE__ */ jsxRuntime.jsx(InputBase.InputBase, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "input",
        ref
    }, _props), {
        __staticSelector: "TextInput"
    }));
});
TextInput.classes = InputBase.InputBase.classes;
TextInput.displayName = "@mantine/core/TextInput";
exports.TextInput = TextInput; //# sourceMappingURL=TextInput.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","6f9fb8e8468e2d3f":"iKGFf","6576e34c63f727f1":"9MtAM","d65d058f5b254c57":"9HEEB","ceb876f31564f32c":"8QFOC","9f1f487d003529f0":"2FdJg","4199a8d653fcdc63":"6AMGA","af66b5847761e216":"erSvz","b7b34339934c34bc":"kqQOF","a37ad62c43b5ceaf":"iivvn","7d51edb6f84b06ed":"8YP4O","fdfdf45b00b15b78":"gkGXc","81b7fbd6da9b7e17":"guLFz","fec25c7fde7b7c5b":"2onWA","2050b55742526c5d":"jbA6w"}],"aC1AO":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3a4a6aa2318e87a9");
require("a96f80d0367c4172");
var getSize = require("42d482e86b00a2b7");
require("323e634ec8b57bf5");
var createVarsResolver = require("37f28412855a7b5");
require("48127f9dcf50e892");
require("4b4cc90a842eecf5");
require("3065f4691e0ff418");
require("5f5a9e169c6e853f");
require("4378aa14c9d659e5");
var useProps = require("4ea0477de0de4f59");
require("523c855ae9b2ae4b");
var useStyles = require("dc0ac3f601b670ea");
var Box = require("2f0f1c149fdf3fc9");
var factory = require("1daff58af62ec3ef");
require("b070ac4a61c2172e");
var ThemeIcon_module = require("8d3d05ab0f8cfc83");
var defaultProps = {};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var size = param.size, radius = param.radius, variant = param.variant, gradient = param.gradient, color = param.color, autoContrast = param.autoContrast;
    var colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--ti-size": getSize.getSize(size, "ti-size"),
            "--ti-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--ti-bg": color || variant ? colors.background : void 0,
            "--ti-color": color || variant ? colors.color : void 0,
            "--ti-bd": color || variant ? colors.border : void 0
        }
    };
});
var ThemeIcon = factory.factory(function(_props, ref) {
    var props = useProps.useProps("ThemeIcon", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, autoContrast = props.autoContrast, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "autoContrast"
    ]);
    var getStyles = useStyles.useStyles({
        name: "ThemeIcon",
        classes: ThemeIcon_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref
    }, getStyles("root"), others));
});
ThemeIcon.classes = ThemeIcon_module;
ThemeIcon.displayName = "@mantine/core/ThemeIcon";
exports.ThemeIcon = ThemeIcon; //# sourceMappingURL=ThemeIcon.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","3a4a6aa2318e87a9":"iKGFf","a96f80d0367c4172":"9MtAM","42d482e86b00a2b7":"kEFEY","323e634ec8b57bf5":"9HEEB","37f28412855a7b5":"hIQE6","48127f9dcf50e892":"8QFOC","4b4cc90a842eecf5":"2FdJg","3065f4691e0ff418":"6AMGA","5f5a9e169c6e853f":"erSvz","4378aa14c9d659e5":"kqQOF","4ea0477de0de4f59":"iivvn","523c855ae9b2ae4b":"8YP4O","dc0ac3f601b670ea":"d0sAY","2f0f1c149fdf3fc9":"gkGXc","1daff58af62ec3ef":"guLFz","b070ac4a61c2172e":"2onWA","8d3d05ab0f8cfc83":"lAHpv"}],"lAHpv":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_7341320d"
};
module.exports = classes; //# sourceMappingURL=ThemeIcon.module.css.cjs.map

},{}],"gPp7R":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("3b8e11074daa0b42");
var React = require("9ce5ceafbe6d6196");
var rem = require("5857db84322d2e9f");
var getSize = require("354db74e4a90f8ad");
require("d30abf650c7ded8c");
var createVarsResolver = require("3ccdedc54c25c29a");
require("cec91856bde2d7bf");
var getThemeColor = require("9c307fc06946a9b5");
var getContrastColor = require("c0dc567ecd496b64");
var getAutoContrastValue = require("d5783d66598bcec9");
require("30e53e951299eca7");
require("1528b94d7b4861a2");
require("e8f52bd786f5eb05");
require("818853f4eb97a46e");
var useProps = require("f784031913771cb6");
require("5afab50c8416637d");
var useStyles = require("a9b8b97b6ff3aa23");
var Box = require("332b2aff12920925");
var factory = require("7a0a810c3749c22b");
require("60fdddc22745faf6");
var Timeline_context = require("3e7a3ee3b409152c");
var TimelineItem = require("64db91f295eec2e6");
var Timeline_module = require("53f94cf5396d6ed7");
var defaultProps = {
    active: -1,
    align: "left",
    reverseActive: false
};
var varsResolver = createVarsResolver.createVarsResolver(function(theme, param) {
    var bulletSize = param.bulletSize, lineWidth = param.lineWidth, radius = param.radius, color = param.color, autoContrast = param.autoContrast;
    return {
        root: {
            "--tl-bullet-size": rem.rem(bulletSize),
            "--tl-line-width": rem.rem(lineWidth),
            "--tl-radius": radius === void 0 ? void 0 : getSize.getRadius(radius),
            "--tl-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--tl-icon-color": getAutoContrastValue.getAutoContrastValue(autoContrast, theme) ? getContrastColor.getContrastColor({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
var Timeline = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Timeline", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, children = props.children, active = props.active, color = props.color, radius = props.radius, bulletSize = props.bulletSize, align = props.align, lineWidth = props.lineWidth, reverseActive = props.reverseActive, mod = props.mod, autoContrast = props.autoContrast, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "children",
        "active",
        "color",
        "radius",
        "bulletSize",
        "align",
        "lineWidth",
        "reverseActive",
        "mod",
        "autoContrast"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Timeline",
        classes: Timeline_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var _children = React.Children.toArray(children);
    var items = _children.map(function(item, index) {
        var _item_props, _item_props1;
        return React.cloneElement(item, {
            unstyled,
            __align: align,
            __active: ((_item_props = item.props) === null || _item_props === void 0 ? void 0 : _item_props.active) || (reverseActive ? active >= _children.length - index - 1 : active >= index),
            __lineActive: ((_item_props1 = item.props) === null || _item_props1 === void 0 ? void 0 : _item_props1.lineActive) || (reverseActive ? active >= _children.length - index - 1 : active - 1 >= index)
        });
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Timeline_context.TimelineProvider, {
        value: {
            getStyles
        },
        children: /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
            mod: [
                {
                    align
                },
                mod
            ],
            ref
        }), others), {
            children: items
        }))
    });
});
Timeline.classes = Timeline_module;
Timeline.displayName = "@mantine/core/Timeline";
Timeline.Item = TimelineItem.TimelineItem;
exports.Timeline = Timeline; //# sourceMappingURL=Timeline.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","3b8e11074daa0b42":"iKGFf","9ce5ceafbe6d6196":"9MtAM","5857db84322d2e9f":"ebAaL","354db74e4a90f8ad":"kEFEY","d30abf650c7ded8c":"9HEEB","3ccdedc54c25c29a":"hIQE6","cec91856bde2d7bf":"8QFOC","9c307fc06946a9b5":"eeaIN","c0dc567ecd496b64":"ez6cW","d5783d66598bcec9":"cN4dA","30e53e951299eca7":"2FdJg","1528b94d7b4861a2":"6AMGA","e8f52bd786f5eb05":"erSvz","818853f4eb97a46e":"kqQOF","f784031913771cb6":"iivvn","5afab50c8416637d":"8YP4O","a9b8b97b6ff3aa23":"d0sAY","332b2aff12920925":"gkGXc","7a0a810c3749c22b":"guLFz","60fdddc22745faf6":"2onWA","3e7a3ee3b409152c":"fElQF","64db91f295eec2e6":"iWvPF","53f94cf5396d6ed7":"12xaN"}],"fElQF":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use client";
"use strict";
require("464f600b6a14a04");
var createSafeContext = require("4211255cc7e85240");
require("269a9bc9fce9c0d6");
require("72c1b343ed588145");
require("a4383fb67d554805");
require("6f1530980f911954");
require("9a39868342218cae");
require("c9736581c11845c4");
require("1cbd390135731da");
require("5b9b80635f58a70");
require("789363abe2707a01");
require("3ba278df4f08645");
var _createSafeContext_createSafeContext = (0, _slicedToArray._)(createSafeContext.createSafeContext("Timeline component was not found in tree"), 2), TimelineProvider = _createSafeContext_createSafeContext[0], useTimelineContext = _createSafeContext_createSafeContext[1];
exports.TimelineProvider = TimelineProvider;
exports.useTimelineContext = useTimelineContext; //# sourceMappingURL=Timeline.context.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","464f600b6a14a04":"9MtAM","4211255cc7e85240":"8srze","269a9bc9fce9c0d6":"iKGFf","72c1b343ed588145":"9HEEB","a4383fb67d554805":"8QFOC","6f1530980f911954":"2FdJg","9a39868342218cae":"6AMGA","c9736581c11845c4":"erSvz","1cbd390135731da":"kqQOF","5b9b80635f58a70":"8YP4O","789363abe2707a01":"gkGXc","3ba278df4f08645":"2onWA"}],"iWvPF":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("b3dea7f9346c7ddb");
require("81a6dcfb91f298f5");
var getSize = require("27c597d024bb140e");
require("60b16b71d92a5654");
require("912dcad592816fad");
var getThemeColor = require("ecfe10235daa8ba9");
require("6669715da0ed0c6");
require("6e780593ee0c3949");
require("58e7a522112bb50a");
var MantineThemeProvider = require("c86d131ed8f784c7");
var useProps = require("b7b6de4f5e8859f8");
require("a48128beff3dc927");
var Box = require("a7ef43c4f89684a4");
var factory = require("92e4d005b5019201");
require("37e6a52db071578a");
var Timeline_context = require("303d4a0fbef96618");
var Timeline_module = require("80ee2c323d6d61e6");
var defaultProps = {};
var TimelineItem = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TimelineItem", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, vars = props.vars, __active = props.__active, __align = props.__align, __lineActive = props.__lineActive, __vars = props.__vars, bullet = props.bullet, radius = props.radius, color = props.color, lineVariant = props.lineVariant, children = props.children, title = props.title, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "vars",
        "__active",
        "__align",
        "__lineActive",
        "__vars",
        "bullet",
        "radius",
        "color",
        "lineVariant",
        "children",
        "title",
        "mod"
    ]);
    var ctx = Timeline_context.useTimelineContext();
    var theme = MantineThemeProvider.useMantineTheme();
    var stylesApiProps = {
        classNames,
        styles
    };
    return /* @__PURE__ */ jsxRuntime.jsxs(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("item", (0, _objectSpreadProps._)((0, _objectSpread._)({}, stylesApiProps), {
        className,
        style
    }))), {
        mod: [
            {
                "line-active": __lineActive,
                active: __active
            },
            mod
        ],
        ref,
        __vars: {
            "--tli-radius": radius ? getSize.getRadius(radius) : void 0,
            "--tli-color": color ? getThemeColor.getThemeColor(color, theme) : void 0,
            "--tli-border-style": lineVariant || void 0
        }
    }), others), {
        children: [
            /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemBullet", stylesApiProps)), {
                mod: {
                    "with-child": !!bullet,
                    align: __align,
                    active: __active
                },
                children: bullet
            })),
            /* @__PURE__ */ jsxRuntime.jsxs("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemBody", stylesApiProps)), {
                children: [
                    title && /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemTitle", stylesApiProps)), {
                        children: title
                    })),
                    /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, ctx.getStyles("itemContent", stylesApiProps)), {
                        children
                    }))
                ]
            }))
        ]
    }));
});
TimelineItem.classes = Timeline_module;
TimelineItem.displayName = "@mantine/core/TimelineItem";
exports.TimelineItem = TimelineItem; //# sourceMappingURL=TimelineItem.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","b3dea7f9346c7ddb":"iKGFf","81a6dcfb91f298f5":"9MtAM","27c597d024bb140e":"kEFEY","60b16b71d92a5654":"9HEEB","912dcad592816fad":"8QFOC","ecfe10235daa8ba9":"eeaIN","6669715da0ed0c6":"2FdJg","6e780593ee0c3949":"6AMGA","58e7a522112bb50a":"erSvz","c86d131ed8f784c7":"kqQOF","b7b6de4f5e8859f8":"iivvn","a48128beff3dc927":"8YP4O","a7ef43c4f89684a4":"gkGXc","92e4d005b5019201":"guLFz","37e6a52db071578a":"2onWA","303d4a0fbef96618":"fElQF","80ee2c323d6d61e6":"12xaN"}],"12xaN":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_43657ece",
    "itemTitle": "m_2ebe8099",
    "item": "m_436178ff",
    "itemBullet": "m_8affcee1",
    "itemBody": "m_540e8f41"
};
module.exports = classes; //# sourceMappingURL=Timeline.module.css.cjs.map

},{}],"6s3RB":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("d754a151956e25");
require("de78e42a60a6ac9d");
require("e34c8d35e3a05456");
var createVarsResolver = require("4d94178b3d756b5d");
require("418421398fde221e");
require("565d04ff09d3f15b");
require("102804932b157b67");
require("d2113a42bb6fe9f5");
require("9b85f92baf4b8d03");
var useProps = require("fd21243831c9afa5");
require("f54c6451715300f2");
var useStyles = require("b9e28f4bb54fe92f");
var Box = require("8370551d349c5ef7");
var factory = require("ed0bb1522ec3f0e7");
require("9f82fef40cfebb89");
var getTitleSize = require("37b9cfc37c1def21");
var Title_module = require("1018ab09aeaa1438");
var defaultProps = {
    order: 1
};
var varsResolver = createVarsResolver.createVarsResolver(function(_, param) {
    var order = param.order, size = param.size, lineClamp = param.lineClamp, textWrap = param.textWrap;
    var sizeVariables = getTitleSize.getTitleSize(order, size);
    return {
        root: {
            "--title-fw": sizeVariables.fontWeight,
            "--title-lh": sizeVariables.lineHeight,
            "--title-fz": sizeVariables.fontSize,
            "--title-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
            "--title-text-wrap": textWrap
        }
    };
});
var Title = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Title", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, order = props.order, vars = props.vars, size = props.size, variant = props.variant, lineClamp = props.lineClamp, textWrap = props.textWrap, mod = props.mod, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "order",
        "vars",
        "size",
        "variant",
        "lineClamp",
        "textWrap",
        "mod"
    ]);
    var getStyles = useStyles.useStyles({
        name: "Title",
        props,
        classes: Title_module,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    if (![
        1,
        2,
        3,
        4,
        5,
        6
    ].includes(order)) return null;
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("root")), {
        component: `h${order}`,
        variant,
        ref,
        mod: [
            {
                order,
                "data-line-clamp": typeof lineClamp === "number"
            },
            mod
        ],
        size
    }), others));
});
Title.classes = Title_module;
Title.displayName = "@mantine/core/Title";
exports.Title = Title; //# sourceMappingURL=Title.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","d754a151956e25":"iKGFf","de78e42a60a6ac9d":"9MtAM","e34c8d35e3a05456":"9HEEB","4d94178b3d756b5d":"hIQE6","418421398fde221e":"8QFOC","565d04ff09d3f15b":"2FdJg","102804932b157b67":"6AMGA","d2113a42bb6fe9f5":"erSvz","9b85f92baf4b8d03":"kqQOF","fd21243831c9afa5":"iivvn","f54c6451715300f2":"8YP4O","b9e28f4bb54fe92f":"d0sAY","8370551d349c5ef7":"gkGXc","ed0bb1522ec3f0e7":"guLFz","9f82fef40cfebb89":"2onWA","37b9cfc37c1def21":"cBYk7","1018ab09aeaa1438":"k5yjw"}],"cBYk7":[function(require,module,exports) {
"use client";
"use strict";
var rem = require("65efc2e6f22489ae");
require("9e2960466e5a184d");
require("12f497e5827bc81c");
require("10a80a9d14129e86");
require("40e714c38fc35c66");
require("85888d45e4e90876");
require("a1375287555e1e8b");
require("1d16adde8ff7fc80");
require("594928fac607d9f4");
require("1c0e616954353304");
require("c07ac0eaa8347839");
require("7901666ec0dd6bb3");
var headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
var sizes = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
function getTitleSize(order, size) {
    var titleSize = size !== void 0 ? size : `h${order}`;
    if (headings.includes(titleSize)) return {
        fontSize: `var(--mantine-${titleSize}-font-size)`,
        fontWeight: `var(--mantine-${titleSize}-font-weight)`,
        lineHeight: `var(--mantine-${titleSize}-line-height)`
    };
    else if (sizes.includes(titleSize)) return {
        fontSize: `var(--mantine-font-size-${titleSize})`,
        fontWeight: `var(--mantine-h${order}-font-weight)`,
        lineHeight: `var(--mantine-h${order}-line-height)`
    };
    return {
        fontSize: rem.rem(titleSize),
        fontWeight: `var(--mantine-h${order}-font-weight)`,
        lineHeight: `var(--mantine-h${order}-line-height)`
    };
}
exports.getTitleSize = getTitleSize; //# sourceMappingURL=get-title-size.cjs.map

},{"65efc2e6f22489ae":"ebAaL","9e2960466e5a184d":"9MtAM","12f497e5827bc81c":"iKGFf","10a80a9d14129e86":"9HEEB","40e714c38fc35c66":"8QFOC","85888d45e4e90876":"2FdJg","a1375287555e1e8b":"6AMGA","1d16adde8ff7fc80":"erSvz","594928fac607d9f4":"kqQOF","1c0e616954353304":"8YP4O","c07ac0eaa8347839":"gkGXc","7901666ec0dd6bb3":"2onWA"}],"k5yjw":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_8a5d1357"
};
module.exports = classes; //# sourceMappingURL=Title.module.css.cjs.map

},{}],"58qz2":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var jsxRuntime = require("1da5d86b804420bb");
var React = require("fa28a672cfe860e1");
var hooks = require("9a36e98143613f74");
var getSize = require("b8f11d2a44ebefbf");
var createVarsResolver = require("f6a0dfe678fe5d29");
require("ef3cd53f6079da90");
require("1181ae8e00e8b57");
require("d274cecf81d2ec70");
require("11491c58a461639f");
require("6b17ea583845d1e3");
var useProps = require("f7cd24a02c426c9a");
require("4e69e16e3ff0ea31");
var useStyles = require("f72c103e9099eaea");
var Box = require("6cb14996dd6bc848");
var factory = require("9361311e085bba4a");
require("8afd75703c9cac4c");
var TreeNode = require("377aabe827f097f3");
var useTree = require("8279df1dc4d104fb");
var Tree_module = require("958ea4d48c0da8bb");
function getFlatValues(data) {
    return data.reduce(function(acc, item) {
        var _acc;
        acc.push(item.value);
        if (item.children) (_acc = acc).push.apply(_acc, (0, _toConsumableArray._)(getFlatValues(item.children)));
        return acc;
    }, []);
}
var defaultProps = {
    expandOnClick: true,
    allowRangeSelection: true,
    expandOnSpace: true
};
var varsResolver = createVarsResolver.createVarsResolver(function(_theme, param) {
    var levelOffset = param.levelOffset;
    return {
        root: {
            "--level-offset": getSize.getSpacing(levelOffset)
        }
    };
});
var Tree = factory.factory(function(_props, ref) {
    var props = useProps.useProps("Tree", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, vars = props.vars, data = props.data, expandOnClick = props.expandOnClick, tree = props.tree, renderNode = props.renderNode, selectOnClick = props.selectOnClick, clearSelectionOnOutsideClick = props.clearSelectionOnOutsideClick, allowRangeSelection = props.allowRangeSelection, expandOnSpace = props.expandOnSpace, levelOffset = props.levelOffset, checkOnSpace = props.checkOnSpace, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled",
        "vars",
        "data",
        "expandOnClick",
        "tree",
        "renderNode",
        "selectOnClick",
        "clearSelectionOnOutsideClick",
        "allowRangeSelection",
        "expandOnSpace",
        "levelOffset",
        "checkOnSpace"
    ]);
    var defaultController = useTree.useTree();
    var controller = tree || defaultController;
    var getStyles = useStyles.useStyles({
        name: "Tree",
        classes: Tree_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    var clickOutsideRef = hooks.useClickOutside(function() {
        return clearSelectionOnOutsideClick && controller.clearSelected();
    });
    var mergedRef = hooks.useMergedRef(ref, clickOutsideRef);
    var flatValues = React.useMemo(function() {
        return getFlatValues(data);
    }, [
        data
    ]);
    React.useEffect(function() {
        controller.initialize(data);
    }, [
        data
    ]);
    var nodes = data.map(function(node, index) {
        return /* @__PURE__ */ jsxRuntime.jsx(TreeNode.TreeNode, {
            node,
            getStyles,
            rootIndex: index,
            expandOnClick,
            selectOnClick,
            controller,
            renderNode,
            flatValues,
            allowRangeSelection,
            expandOnSpace,
            checkOnSpace
        }, node.value);
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpreadProps._)((0, _objectSpread._)({
        component: "ul",
        ref: mergedRef
    }, getStyles("root"), others), {
        role: "tree",
        "aria-multiselectable": controller.multiple,
        "data-tree-root": true,
        children: nodes
    }));
});
Tree.displayName = "@mantine/core/Tree";
Tree.classes = Tree_module;
exports.Tree = Tree; //# sourceMappingURL=Tree.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_to_consumable_array":"jg7I9","1da5d86b804420bb":"iKGFf","fa28a672cfe860e1":"9MtAM","9a36e98143613f74":"9HEEB","b8f11d2a44ebefbf":"kEFEY","f6a0dfe678fe5d29":"hIQE6","ef3cd53f6079da90":"8QFOC","1181ae8e00e8b57":"2FdJg","d274cecf81d2ec70":"6AMGA","11491c58a461639f":"erSvz","6b17ea583845d1e3":"kqQOF","f7cd24a02c426c9a":"iivvn","4e69e16e3ff0ea31":"8YP4O","f72c103e9099eaea":"d0sAY","6cb14996dd6bc848":"gkGXc","9361311e085bba4a":"guLFz","8afd75703c9cac4c":"2onWA","377aabe827f097f3":"99uSi","8279df1dc4d104fb":"9eQXa","958ea4d48c0da8bb":"Bgfeu"}],"99uSi":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use client";
"use strict";
var jsxRuntime = require("23c2dd8745a4fcb8");
var React = require("26adf1fc564339b5");
var findElementAncestor = require("2dd5115770ceafb0");
require("1979640d3180f2d2");
require("baad4526f4cb2c02");
require("ced545b4adba40af");
require("65fd7e249c155e85");
require("5e90ab386e734e02");
require("ac2e7cf28c47dd80");
require("9889dfebc4905506");
require("48fde388994069ad");
require("82e71a9197319639");
function getValuesRange(anchor, value, flatValues) {
    if (!anchor || !value) return [];
    var anchorIndex = flatValues.indexOf(anchor);
    var valueIndex = flatValues.indexOf(value);
    var start = Math.min(anchorIndex, valueIndex);
    var end = Math.max(anchorIndex, valueIndex);
    return flatValues.slice(start, end + 1);
}
function TreeNode(param) {
    var node = param.node, getStyles = param.getStyles, rootIndex = param.rootIndex, controller = param.controller, expandOnClick = param.expandOnClick, selectOnClick = param.selectOnClick, isSubtree = param.isSubtree, _param_level = param.level, level = _param_level === void 0 ? 1 : _param_level, renderNode = param.renderNode, flatValues = param.flatValues, allowRangeSelection = param.allowRangeSelection, expandOnSpace = param.expandOnSpace, checkOnSpace = param.checkOnSpace;
    var ref = React.useRef(null);
    var nested = (node.children || []).map(function(child) {
        return /* @__PURE__ */ jsxRuntime.jsx(TreeNode, {
            node: child,
            flatValues,
            getStyles,
            rootIndex: void 0,
            level: level + 1,
            controller,
            expandOnClick,
            isSubtree: true,
            renderNode,
            selectOnClick,
            allowRangeSelection,
            expandOnSpace,
            checkOnSpace
        }, child.value);
    });
    var handleKeyDown = function(event) {
        if (event.nativeEvent.code === "ArrowRight") {
            var _event_currentTarget_querySelector;
            event.stopPropagation();
            event.preventDefault();
            if (controller.expandedState[node.value]) (_event_currentTarget_querySelector = event.currentTarget.querySelector("[role=treeitem]")) === null || _event_currentTarget_querySelector === void 0 ? void 0 : _event_currentTarget_querySelector.focus();
            else controller.expand(node.value);
        }
        if (event.nativeEvent.code === "ArrowLeft") {
            var _findElementAncestor_findElementAncestor;
            event.stopPropagation();
            event.preventDefault();
            if (controller.expandedState[node.value] && (node.children || []).length > 0) controller.collapse(node.value);
            else if (isSubtree) (_findElementAncestor_findElementAncestor = findElementAncestor.findElementAncestor(event.currentTarget, "[role=treeitem]")) === null || _findElementAncestor_findElementAncestor === void 0 ? void 0 : _findElementAncestor_findElementAncestor.focus();
        }
        if (event.nativeEvent.code === "ArrowDown" || event.nativeEvent.code === "ArrowUp") {
            var _nodes_nextIndex;
            var root = findElementAncestor.findElementAncestor(event.currentTarget, "[data-tree-root]");
            if (!root) return;
            event.stopPropagation();
            event.preventDefault();
            var nodes = Array.from(root.querySelectorAll("[role=treeitem]"));
            var index = nodes.indexOf(event.currentTarget);
            if (index === -1) return;
            var nextIndex = event.nativeEvent.code === "ArrowDown" ? index + 1 : index - 1;
            (_nodes_nextIndex = nodes[nextIndex]) === null || _nodes_nextIndex === void 0 ? void 0 : _nodes_nextIndex.focus();
            if (event.shiftKey) {
                var selectNode = nodes[nextIndex];
                if (selectNode) controller.setSelectedState(getValuesRange(controller.anchorNode, selectNode.dataset.value, flatValues));
            }
        }
        if (event.nativeEvent.code === "Space") {
            if (expandOnSpace) {
                event.stopPropagation();
                event.preventDefault();
                controller.toggleExpanded(node.value);
            }
            if (checkOnSpace) {
                event.stopPropagation();
                event.preventDefault();
                controller.isNodeChecked(node.value) ? controller.uncheckNode(node.value) : controller.checkNode(node.value);
            }
        }
    };
    var handleNodeClick = function(event) {
        event.stopPropagation();
        if (allowRangeSelection && event.shiftKey && controller.anchorNode) {
            var _ref_current;
            controller.setSelectedState(getValuesRange(controller.anchorNode, node.value, flatValues));
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
        } else {
            var _ref_current1;
            expandOnClick && controller.toggleExpanded(node.value);
            selectOnClick && controller.select(node.value);
            (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.focus();
        }
    };
    var selected = controller.selectedState.includes(node.value);
    var elementProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("label")), {
        onClick: handleNodeClick,
        "data-selected": selected || void 0,
        "data-value": node.value,
        "data-hovered": controller.hoveredNode === node.value || void 0
    });
    return /* @__PURE__ */ jsxRuntime.jsxs("li", (0, _objectSpreadProps._)((0, _objectSpread._)({}, getStyles("node", {
        style: {
            "--label-offset": `calc(var(--level-offset) * ${level - 1})`
        }
    })), {
        role: "treeitem",
        "aria-selected": selected,
        "data-value": node.value,
        "data-selected": selected || void 0,
        "data-hovered": controller.hoveredNode === node.value || void 0,
        "data-level": level,
        tabIndex: rootIndex === 0 ? 0 : -1,
        onKeyDown: handleKeyDown,
        ref,
        onMouseOver: function(event) {
            event.stopPropagation();
            controller.setHoveredNode(node.value);
        },
        onMouseLeave: function(event) {
            event.stopPropagation();
            controller.setHoveredNode(null);
        },
        children: [
            typeof renderNode === "function" ? renderNode({
                node,
                level,
                selected,
                tree: controller,
                expanded: controller.expandedState[node.value] || false,
                hasChildren: Array.isArray(node.children) && node.children.length > 0,
                elementProps
            }) : /* @__PURE__ */ jsxRuntime.jsx("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, elementProps), {
                children: node.label
            })),
            controller.expandedState[node.value] && nested.length > 0 && /* @__PURE__ */ jsxRuntime.jsx("ul", (0, _objectSpreadProps._)((0, _objectSpread._)({
                role: "group"
            }, getStyles("subtree")), {
                "data-level": level,
                children: nested
            }))
        ]
    }));
}
TreeNode.displayName = "@mantine/core/TreeNode";
exports.TreeNode = TreeNode; //# sourceMappingURL=TreeNode.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","23c2dd8745a4fcb8":"iKGFf","26adf1fc564339b5":"9MtAM","2dd5115770ceafb0":"cC16z","1979640d3180f2d2":"9HEEB","baad4526f4cb2c02":"8QFOC","ced545b4adba40af":"2FdJg","65fd7e249c155e85":"6AMGA","5e90ab386e734e02":"erSvz","ac2e7cf28c47dd80":"kqQOF","9889dfebc4905506":"8YP4O","48fde388994069ad":"gkGXc","82e71a9197319639":"2onWA"}],"9eQXa":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
var React = require("b8015935bdfa758d");
var getAllCheckedNodes = require("4456caa6a945ab");
var getChildrenNodesValues = require("10d99b022f42d12f");
var isNodeChecked = require("9c13d35d0ac84f46");
var isNodeIndeterminate = require("e5a890358828da72");
function getInitialTreeExpandedState(initialState, data, value) {
    var acc = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    data.forEach(function(node) {
        acc[node.value] = node.value in initialState ? initialState[node.value] : node.value === value;
        if (Array.isArray(node.children)) getInitialTreeExpandedState(initialState, node.children, value, acc);
    });
    return acc;
}
function getTreeExpandedState(data, expandedNodesValues) {
    var state = getInitialTreeExpandedState({}, data, []);
    if (expandedNodesValues === "*") return Object.keys(state).reduce(function(acc, key) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
            [key]: true
        });
    }, {});
    expandedNodesValues.forEach(function(node) {
        state[node] = true;
    });
    return state;
}
function getInitialCheckedState(initialState, data) {
    var _acc;
    var acc = [];
    initialState.forEach(function(node) {
        return (_acc = acc).push.apply(_acc, (0, _toConsumableArray._)(getChildrenNodesValues.getChildrenNodesValues(node, data)));
    });
    return Array.from(new Set(acc));
}
function useTree() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_initialSelectedState = _ref.initialSelectedState, initialSelectedState = _ref_initialSelectedState === void 0 ? [] : _ref_initialSelectedState, _ref_initialCheckedState = _ref.initialCheckedState, initialCheckedState = _ref_initialCheckedState === void 0 ? [] : _ref_initialCheckedState, _ref_initialExpandedState = _ref.initialExpandedState, initialExpandedState = _ref_initialExpandedState === void 0 ? {} : _ref_initialExpandedState, _ref_multiple = _ref.multiple, multiple = _ref_multiple === void 0 ? false : _ref_multiple, onNodeCollapse = _ref.onNodeCollapse, onNodeExpand = _ref.onNodeExpand;
    var _React_useState = (0, _slicedToArray._)(React.useState([]), 2), data = _React_useState[0], setData = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(React.useState(initialExpandedState), 2), expandedState = _React_useState1[0], setExpandedState = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(React.useState(initialSelectedState), 2), selectedState = _React_useState2[0], setSelectedState = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)(React.useState(initialCheckedState), 2), checkedState = _React_useState3[0], setCheckedState = _React_useState3[1];
    var _React_useState4 = (0, _slicedToArray._)(React.useState(null), 2), anchorNode = _React_useState4[0], setAnchorNode = _React_useState4[1];
    var _React_useState5 = (0, _slicedToArray._)(React.useState(null), 2), hoveredNode = _React_useState5[0], setHoveredNode = _React_useState5[1];
    var initialize = React.useCallback(function(_data) {
        setExpandedState(function(current) {
            return getInitialTreeExpandedState(current, _data, selectedState);
        });
        setCheckedState(function(current) {
            return getInitialCheckedState(current, _data);
        });
        setData(_data);
    }, [
        selectedState,
        checkedState
    ]);
    var toggleExpanded = React.useCallback(function(value) {
        setExpandedState(function(current) {
            var nextState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                [value]: !current[value]
            });
            nextState[value] ? onNodeExpand === null || onNodeExpand === void 0 ? void 0 : onNodeExpand(value) : onNodeCollapse === null || onNodeCollapse === void 0 ? void 0 : onNodeCollapse(value);
            return nextState;
        });
    }, [
        onNodeCollapse,
        onNodeExpand
    ]);
    var collapse = React.useCallback(function(value) {
        setExpandedState(function(current) {
            if (current[value] !== false) onNodeCollapse === null || onNodeCollapse === void 0 ? void 0 : onNodeCollapse(value);
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                [value]: false
            });
        });
    }, [
        onNodeCollapse
    ]);
    var expand = React.useCallback(function(value) {
        setExpandedState(function(current) {
            if (current[value] !== true) onNodeExpand === null || onNodeExpand === void 0 ? void 0 : onNodeExpand(value);
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, current), {
                [value]: true
            });
        });
    }, [
        onNodeExpand
    ]);
    var expandAllNodes = React.useCallback(function() {
        setExpandedState(function(current) {
            var next = (0, _objectSpread._)({}, current);
            Object.keys(next).forEach(function(key) {
                next[key] = true;
            });
            return next;
        });
    }, []);
    var collapseAllNodes = React.useCallback(function() {
        setExpandedState(function(current) {
            var next = (0, _objectSpread._)({}, current);
            Object.keys(next).forEach(function(key) {
                next[key] = false;
            });
            return next;
        });
    }, []);
    var toggleSelected = React.useCallback(function(value) {
        return setSelectedState(function(current) {
            if (!multiple) {
                if (current.includes(value)) {
                    setAnchorNode(null);
                    return [];
                }
                setAnchorNode(value);
                return [
                    value
                ];
            }
            if (current.includes(value)) {
                setAnchorNode(null);
                return current.filter(function(item) {
                    return item !== value;
                });
            }
            setAnchorNode(value);
            return (0, _toConsumableArray._)(current).concat([
                value
            ]);
        });
    }, []);
    var select = React.useCallback(function(value) {
        setAnchorNode(value);
        setSelectedState(function(current) {
            return multiple ? current.includes(value) ? current : (0, _toConsumableArray._)(current).concat([
                value
            ]) : [
                value
            ];
        });
    }, []);
    var deselect = React.useCallback(function(value) {
        anchorNode === value && setAnchorNode(null);
        setSelectedState(function(current) {
            return current.filter(function(item) {
                return item !== value;
            });
        });
    }, []);
    var clearSelected = React.useCallback(function() {
        setSelectedState([]);
        setAnchorNode(null);
    }, []);
    var checkNode = React.useCallback(function(value) {
        var checkedNodes = getChildrenNodesValues.getChildrenNodesValues(value, data);
        setCheckedState(function(current) {
            return Array.from(/* @__PURE__ */ new Set((0, _toConsumableArray._)(current).concat((0, _toConsumableArray._)(checkedNodes))));
        });
    }, [
        data
    ]);
    var uncheckNode = React.useCallback(function(value) {
        var checkedNodes = getChildrenNodesValues.getChildrenNodesValues(value, data);
        setCheckedState(function(current) {
            return current.filter(function(item) {
                return !checkedNodes.includes(item);
            });
        });
    }, [
        data
    ]);
    var checkAllNodes = React.useCallback(function() {
        setCheckedState(function() {
            return getChildrenNodesValues.getAllChildrenNodes(data);
        });
    }, [
        data
    ]);
    var uncheckAllNodes = React.useCallback(function() {
        setCheckedState([]);
    }, []);
    var getCheckedNodes = function() {
        return getAllCheckedNodes.getAllCheckedNodes(data, checkedState).result;
    };
    var isNodeChecked$1 = function(value) {
        return isNodeChecked.memoizedIsNodeChecked(value, data, checkedState);
    };
    var isNodeIndeterminate$1 = function(value) {
        return isNodeIndeterminate.memoizedIsNodeIndeterminate(value, data, checkedState);
    };
    return {
        multiple,
        expandedState,
        selectedState,
        checkedState,
        anchorNode,
        initialize,
        toggleExpanded,
        collapse,
        expand,
        expandAllNodes,
        collapseAllNodes,
        setExpandedState,
        checkNode,
        uncheckNode,
        checkAllNodes,
        uncheckAllNodes,
        setCheckedState,
        toggleSelected,
        select,
        deselect,
        clearSelected,
        setSelectedState,
        hoveredNode,
        setHoveredNode,
        getCheckedNodes,
        isNodeChecked: isNodeChecked$1,
        isNodeIndeterminate: isNodeIndeterminate$1
    };
}
exports.getTreeExpandedState = getTreeExpandedState;
exports.useTree = useTree; //# sourceMappingURL=use-tree.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","b8015935bdfa758d":"9MtAM","4456caa6a945ab":"gMFq3","10d99b022f42d12f":"khLAf","9c13d35d0ac84f46":"aZXO3","e5a890358828da72":"jYvGc"}],"gMFq3":[function(require,module,exports) {
"use client";
"use strict";
function getAllCheckedNodes(data, checkedState) {
    var acc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var currentTreeChecked = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (Array.isArray(node.children) && node.children.length > 0) {
                var innerChecked = getAllCheckedNodes(node.children, checkedState, acc);
                if (innerChecked.currentTreeChecked.length === node.children.length) {
                    var isChecked = innerChecked.currentTreeChecked.every(function(item2) {
                        return item2.checked;
                    });
                    var item = {
                        checked: isChecked,
                        indeterminate: !isChecked,
                        value: node.value,
                        hasChildren: true
                    };
                    currentTreeChecked.push(item);
                    acc.push(item);
                } else if (innerChecked.currentTreeChecked.length > 0) {
                    var item1 = {
                        checked: false,
                        indeterminate: true,
                        value: node.value,
                        hasChildren: true
                    };
                    currentTreeChecked.push(item1);
                    acc.push(item1);
                }
            } else if (checkedState.includes(node.value)) {
                var item2 = {
                    checked: true,
                    indeterminate: false,
                    value: node.value,
                    hasChildren: false
                };
                currentTreeChecked.push(item2);
                acc.push(item2);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        result: acc,
        currentTreeChecked
    };
}
exports.getAllCheckedNodes = getAllCheckedNodes; //# sourceMappingURL=get-all-checked-nodes.cjs.map

},{}],"khLAf":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use client";
"use strict";
function findTreeNode(value, data) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (node.value === value) return node;
            if (Array.isArray(node.children)) {
                var childNode = findTreeNode(value, node.children);
                if (childNode) return childNode;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function getChildrenNodesValues(value, data) {
    var acc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var node = findTreeNode(value, data);
    if (!node) return acc;
    if (!Array.isArray(node.children) || node.children.length === 0) return [
        node.value
    ];
    node.children.forEach(function(child) {
        if (Array.isArray(child.children) && child.children.length > 0) getChildrenNodesValues(child.value, data, acc);
        else acc.push(child.value);
    });
    return acc;
}
function getAllChildrenNodes(data) {
    return data.reduce(function(acc, node) {
        var _acc;
        if (Array.isArray(node.children) && node.children.length > 0) (_acc = acc).push.apply(_acc, (0, _toConsumableArray._)(getAllChildrenNodes(node.children)));
        else acc.push(node.value);
        return acc;
    }, []);
}
exports.findTreeNode = findTreeNode;
exports.getAllChildrenNodes = getAllChildrenNodes;
exports.getChildrenNodesValues = getChildrenNodesValues; //# sourceMappingURL=get-children-nodes-values.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"aZXO3":[function(require,module,exports) {
"use client";
"use strict";
require("48b0528e9c4ab2e");
require("b1ac4598e30ec903");
require("77af911b2f846fea");
var memoize = require("1fd84f8ac7dec9ae");
require("200776dbe27ce00c");
require("8d47bb5981226d71");
require("ec03e6c1cc1994b7");
require("24f96c16b96ce8ae");
require("f4def6fe6ef75743");
require("683496abc9c52816");
require("c05f285a23803d0f");
require("8f54c7410cb7c8cb");
var getAllCheckedNodes = require("86e69d767bb3ef81");
function isNodeChecked(value, data, checkedState) {
    if (checkedState.length === 0) return false;
    if (checkedState.includes(value)) return true;
    var checkedNodes = getAllCheckedNodes.getAllCheckedNodes(data, checkedState).result;
    return checkedNodes.some(function(node) {
        return node.value === value && node.checked;
    });
}
var memoizedIsNodeChecked = memoize.memoize(isNodeChecked);
exports.isNodeChecked = isNodeChecked;
exports.memoizedIsNodeChecked = memoizedIsNodeChecked; //# sourceMappingURL=is-node-checked.cjs.map

},{"48b0528e9c4ab2e":"9MtAM","b1ac4598e30ec903":"iKGFf","77af911b2f846fea":"9HEEB","1fd84f8ac7dec9ae":"6dk3K","200776dbe27ce00c":"8QFOC","8d47bb5981226d71":"2FdJg","ec03e6c1cc1994b7":"6AMGA","24f96c16b96ce8ae":"erSvz","f4def6fe6ef75743":"kqQOF","683496abc9c52816":"8YP4O","c05f285a23803d0f":"gkGXc","8f54c7410cb7c8cb":"2onWA","86e69d767bb3ef81":"gMFq3"}],"jYvGc":[function(require,module,exports) {
"use client";
"use strict";
require("4bf36c7de380b58b");
require("32931a5a91d6c07d");
require("b1cc6a2a982dbbd9");
var memoize = require("af6c0606d22d80c4");
require("8a0e9e9d473b38e1");
require("7ee639c83f435dac");
require("fe69a24d6b2ce219");
require("4b1180eff03b862");
require("c3032a3f371b7a0c");
require("dd3e968e10d7cc0c");
require("9e179180e54a4949");
require("6e10981a4422a34e");
var getAllCheckedNodes = require("89bce433debdfadc");
function isNodeIndeterminate(value, data, checkedState) {
    if (checkedState.length === 0) return false;
    var checkedNodes = getAllCheckedNodes.getAllCheckedNodes(data, checkedState).result;
    return checkedNodes.some(function(node) {
        return node.value === value && node.indeterminate;
    });
}
var memoizedIsNodeIndeterminate = memoize.memoize(isNodeIndeterminate);
exports.isNodeIndeterminate = isNodeIndeterminate;
exports.memoizedIsNodeIndeterminate = memoizedIsNodeIndeterminate; //# sourceMappingURL=is-node-indeterminate.cjs.map

},{"4bf36c7de380b58b":"9MtAM","32931a5a91d6c07d":"iKGFf","b1cc6a2a982dbbd9":"9HEEB","af6c0606d22d80c4":"6dk3K","8a0e9e9d473b38e1":"8QFOC","7ee639c83f435dac":"2FdJg","fe69a24d6b2ce219":"6AMGA","4b1180eff03b862":"erSvz","c3032a3f371b7a0c":"kqQOF","dd3e968e10d7cc0c":"8YP4O","9e179180e54a4949":"gkGXc","6e10981a4422a34e":"2onWA","89bce433debdfadc":"gMFq3"}],"Bgfeu":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_f698e191",
    "subtree": "m_75f3ecf",
    "node": "m_f6970eb1",
    "label": "m_dc283425"
};
module.exports = classes; //# sourceMappingURL=Tree.module.css.cjs.map

},{}],"j6JlX":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use client";
"use strict";
var jsxRuntime = require("add240a2e2665086");
require("226c569bbc16924b");
require("f8d94b87dc14d9af");
require("a3b00fd20c415411");
require("a106e19b5801132a");
require("b145be8f8dfeaac7");
require("eae370d0e4a6e89f");
require("76b7ea08e45b3495");
var useProps = require("d16b8521f7b88af5");
require("5ffe19671e5e1339");
var useStyles = require("757f878c77099e59");
var Box = require("ff5d7f10897261e4");
var factory = require("a5a519a7542225a1");
require("2ebd792ea385590a");
var TypographyStylesProvider_module = require("1bfb18a72ed447f7");
var defaultProps = {};
var TypographyStylesProvider = factory.factory(function(_props, ref) {
    var props = useProps.useProps("TypographyStylesProvider", defaultProps, _props);
    var classNames = props.classNames, className = props.className, style = props.style, styles = props.styles, unstyled = props.unstyled, others = (0, _objectWithoutProperties._)(props, [
        "classNames",
        "className",
        "style",
        "styles",
        "unstyled"
    ]);
    var getStyles = useStyles.useStyles({
        name: "TypographyStylesProvider",
        classes: TypographyStylesProvider_module,
        props,
        className,
        style,
        classNames,
        styles,
        unstyled
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Box.Box, (0, _objectSpread._)({
        ref
    }, getStyles("root"), others));
});
TypographyStylesProvider.classes = TypographyStylesProvider_module;
TypographyStylesProvider.displayName = "@mantine/core/TypographyStylesProvider";
exports.TypographyStylesProvider = TypographyStylesProvider; //# sourceMappingURL=TypographyStylesProvider.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_without_properties":"4Ofw8","add240a2e2665086":"iKGFf","226c569bbc16924b":"9MtAM","f8d94b87dc14d9af":"9HEEB","a3b00fd20c415411":"8QFOC","a106e19b5801132a":"2FdJg","b145be8f8dfeaac7":"6AMGA","eae370d0e4a6e89f":"erSvz","76b7ea08e45b3495":"kqQOF","d16b8521f7b88af5":"iivvn","5ffe19671e5e1339":"8YP4O","757f878c77099e59":"d0sAY","ff5d7f10897261e4":"gkGXc","a5a519a7542225a1":"guLFz","2ebd792ea385590a":"2onWA","1bfb18a72ed447f7":"Hp9aX"}],"Hp9aX":[function(require,module,exports) {
"use client";
"use strict";
var classes = {
    "root": "m_d6493fad"
};
module.exports = classes; //# sourceMappingURL=TypographyStylesProvider.module.css.cjs.map

},{}],"h4000":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __reExport = function(target, mod, secondTarget) {
    return __copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default");
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    HydrationBoundary: function() {
        return import_HydrationBoundary.HydrationBoundary;
    },
    IsRestoringProvider: function() {
        return import_isRestoring.IsRestoringProvider;
    },
    QueryClientContext: function() {
        return import_QueryClientProvider.QueryClientContext;
    },
    QueryClientProvider: function() {
        return import_QueryClientProvider.QueryClientProvider;
    },
    QueryErrorResetBoundary: function() {
        return import_QueryErrorResetBoundary.QueryErrorResetBoundary;
    },
    infiniteQueryOptions: function() {
        return import_infiniteQueryOptions.infiniteQueryOptions;
    },
    queryOptions: function() {
        return import_queryOptions.queryOptions;
    },
    useInfiniteQuery: function() {
        return import_useInfiniteQuery.useInfiniteQuery;
    },
    useIsFetching: function() {
        return import_useIsFetching.useIsFetching;
    },
    useIsMutating: function() {
        return import_useMutationState.useIsMutating;
    },
    useIsRestoring: function() {
        return import_isRestoring.useIsRestoring;
    },
    useMutation: function() {
        return import_useMutation.useMutation;
    },
    useMutationState: function() {
        return import_useMutationState.useMutationState;
    },
    usePrefetchInfiniteQuery: function() {
        return import_usePrefetchInfiniteQuery.usePrefetchInfiniteQuery;
    },
    usePrefetchQuery: function() {
        return import_usePrefetchQuery.usePrefetchQuery;
    },
    useQueries: function() {
        return import_useQueries.useQueries;
    },
    useQuery: function() {
        return import_useQuery.useQuery;
    },
    useQueryClient: function() {
        return import_QueryClientProvider.useQueryClient;
    },
    useQueryErrorResetBoundary: function() {
        return import_QueryErrorResetBoundary.useQueryErrorResetBoundary;
    },
    useSuspenseInfiniteQuery: function() {
        return import_useSuspenseInfiniteQuery.useSuspenseInfiniteQuery;
    },
    useSuspenseQueries: function() {
        return import_useSuspenseQueries.useSuspenseQueries;
    },
    useSuspenseQuery: function() {
        return import_useSuspenseQuery.useSuspenseQuery;
    }
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, require("4b506337ae21583f"), module.exports);
__reExport(src_exports, require("e34c6470008d3492"), module.exports);
var import_useQueries = require("c828cec2915136b4");
var import_useQuery = require("6c1820125f53aef6");
var import_useSuspenseQuery = require("d3c9347b0162ea36");
var import_useSuspenseInfiniteQuery = require("3e6c1e0748eda602");
var import_useSuspenseQueries = require("c55404a2831679ce");
var import_usePrefetchQuery = require("24cf0a4fa00e8203");
var import_usePrefetchInfiniteQuery = require("33bf2cb7f6b96210");
var import_queryOptions = require("995dfced4afb44e0");
var import_infiniteQueryOptions = require("1417ec8abf17fc53");
var import_QueryClientProvider = require("90ce2b16e317e68a");
var import_HydrationBoundary = require("aef72c02b42328ad");
var import_QueryErrorResetBoundary = require("d15ab9dc0a1c1b65");
var import_useIsFetching = require("2de13f3d51574c7");
var import_useMutationState = require("99ed60444a9744be");
var import_useMutation = require("41cc0af658e20e60");
var import_useInfiniteQuery = require("841d7795e3b2ed56");
var import_isRestoring = require("acd69fd3408a61f6");
 //# sourceMappingURL=index.cjs.map

},{"4b506337ae21583f":"eUKlt","e34c6470008d3492":"1esvl","c828cec2915136b4":"hPR8l","6c1820125f53aef6":"42FwI","d3c9347b0162ea36":"eONya","3e6c1e0748eda602":"02mHe","c55404a2831679ce":"7FUPh","24cf0a4fa00e8203":"f4yGh","33bf2cb7f6b96210":"qhJkq","995dfced4afb44e0":"ask9M","1417ec8abf17fc53":"k3HJr","90ce2b16e317e68a":"dwevj","aef72c02b42328ad":"ag70d","d15ab9dc0a1c1b65":"5bm3s","2de13f3d51574c7":"lvSSk","99ed60444a9744be":"3MFSC","41cc0af658e20e60":"3NhHe","841d7795e3b2ed56":"lcYLI","acd69fd3408a61f6":"b96LG"}],"eUKlt":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __reExport = function(target, mod, secondTarget) {
    return __copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default");
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    CancelledError: function() {
        return import_retryer.CancelledError;
    },
    InfiniteQueryObserver: function() {
        return import_infiniteQueryObserver.InfiniteQueryObserver;
    },
    Mutation: function() {
        return import_mutation.Mutation;
    },
    MutationCache: function() {
        return import_mutationCache.MutationCache;
    },
    MutationObserver: function() {
        return import_mutationObserver.MutationObserver;
    },
    QueriesObserver: function() {
        return import_queriesObserver.QueriesObserver;
    },
    Query: function() {
        return import_query.Query;
    },
    QueryCache: function() {
        return import_queryCache.QueryCache;
    },
    QueryClient: function() {
        return import_queryClient.QueryClient;
    },
    QueryObserver: function() {
        return import_queryObserver.QueryObserver;
    },
    defaultShouldDehydrateMutation: function() {
        return import_hydration.defaultShouldDehydrateMutation;
    },
    defaultShouldDehydrateQuery: function() {
        return import_hydration.defaultShouldDehydrateQuery;
    },
    dehydrate: function() {
        return import_hydration.dehydrate;
    },
    focusManager: function() {
        return import_focusManager.focusManager;
    },
    hashKey: function() {
        return import_utils.hashKey;
    },
    hydrate: function() {
        return import_hydration.hydrate;
    },
    isCancelledError: function() {
        return import_retryer2.isCancelledError;
    },
    isServer: function() {
        return import_utils.isServer;
    },
    keepPreviousData: function() {
        return import_utils.keepPreviousData;
    },
    matchMutation: function() {
        return import_utils.matchMutation;
    },
    matchQuery: function() {
        return import_utils.matchQuery;
    },
    notifyManager: function() {
        return import_notifyManager.notifyManager;
    },
    onlineManager: function() {
        return import_onlineManager.onlineManager;
    },
    replaceEqualDeep: function() {
        return import_utils.replaceEqualDeep;
    },
    skipToken: function() {
        return import_utils.skipToken;
    }
});
module.exports = __toCommonJS(src_exports);
var import_retryer = require("eec20c398d4eade4");
var import_queryCache = require("986e4e9bc92dd5f0");
var import_queryClient = require("54ea43e5c61fcf8b");
var import_queryObserver = require("42a0438b820e9c56");
var import_queriesObserver = require("d7fbe6e7214f5d7d");
var import_infiniteQueryObserver = require("eedc8297731a0d22");
var import_mutationCache = require("3ee6c0a53aec03fc");
var import_mutationObserver = require("ebde0d8e44d45c8b");
var import_notifyManager = require("46a0a8db9d8b80dc");
var import_focusManager = require("bfcbf21abd2dde13");
var import_onlineManager = require("e36b006ff3317b4f");
var import_utils = require("dbd2af76aa98febd");
var import_retryer2 = require("eec20c398d4eade4");
var import_hydration = require("1a953b30d89a5e8c");
__reExport(src_exports, require("fd3cb9067a37d134"), module.exports);
var import_query = require("b09d5c1290f11593");
var import_mutation = require("33b08f8b08f9f298");
 //# sourceMappingURL=index.cjs.map

},{"eec20c398d4eade4":"jd4VA","986e4e9bc92dd5f0":"cSvIg","54ea43e5c61fcf8b":"7edB7","42a0438b820e9c56":"fjAKd","d7fbe6e7214f5d7d":"iYi15","eedc8297731a0d22":"hgnQW","3ee6c0a53aec03fc":"JnEA9","ebde0d8e44d45c8b":"cyFAs","46a0a8db9d8b80dc":"8XMRv","bfcbf21abd2dde13":"lQPnM","e36b006ff3317b4f":"65kuO","dbd2af76aa98febd":"l88Kk","1a953b30d89a5e8c":"evsVe","fd3cb9067a37d134":"deyew","b09d5c1290f11593":"rzJvy","33b08f8b08f9f298":"epKwd"}],"jd4VA":[function(require,module,exports) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/retryer.ts
var retryer_exports = {};
__export(retryer_exports, {
    CancelledError: function() {
        return CancelledError;
    },
    canFetch: function() {
        return canFetch;
    },
    createRetryer: function() {
        return createRetryer;
    },
    isCancelledError: function() {
        return isCancelledError;
    }
});
module.exports = __toCommonJS(retryer_exports);
var import_focusManager = require("2d91be47de9c18b3");
var import_onlineManager = require("6817db198def77b9");
var import_thenable = require("564970098a0d0dc8");
var import_utils = require("8c9b2025825738c1");
function defaultRetryDelay(failureCount) {
    return Math.min(1e3 * Math.pow(2, failureCount), 3e4);
}
function canFetch(networkMode) {
    return (networkMode !== null && networkMode !== void 0 ? networkMode : "online") === "online" ? import_onlineManager.onlineManager.isOnline() : true;
}
var CancelledError = /*#__PURE__*/ function(Error1) {
    (0, _inherits._)(CancelledError, Error1);
    var _super = (0, _createSuper._)(CancelledError);
    function CancelledError(options) {
        (0, _classCallCheck._)(this, CancelledError);
        var _this;
        _this = _super.call(this, "CancelledError");
        _this.revert = options === null || options === void 0 ? void 0 : options.revert;
        _this.silent = options === null || options === void 0 ? void 0 : options.silent;
        return _this;
    }
    return CancelledError;
}((0, _wrapNativeSuper._)(Error));
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    var isRetryCancelled = false;
    var failureCount = 0;
    var isResolved = false;
    var continueFn;
    var thenable = (0, import_thenable.pendingThenable)();
    var cancel = function(cancelOptions) {
        if (!isResolved) {
            var _config_abort;
            reject(new CancelledError(cancelOptions));
            (_config_abort = config.abort) === null || _config_abort === void 0 ? void 0 : _config_abort.call(config);
        }
    };
    var cancelRetry = function() {
        isRetryCancelled = true;
    };
    var continueRetry = function() {
        isRetryCancelled = false;
    };
    var canContinue = function() {
        return import_focusManager.focusManager.isFocused() && (config.networkMode === "always" || import_onlineManager.onlineManager.isOnline()) && config.canRun();
    };
    var canStart = function() {
        return canFetch(config.networkMode) && config.canRun();
    };
    var resolve = function(value) {
        if (!isResolved) {
            var _config_onSuccess;
            isResolved = true;
            (_config_onSuccess = config.onSuccess) === null || _config_onSuccess === void 0 ? void 0 : _config_onSuccess.call(config, value);
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            thenable.resolve(value);
        }
    };
    var reject = function(value) {
        if (!isResolved) {
            var _config_onError;
            isResolved = true;
            (_config_onError = config.onError) === null || _config_onError === void 0 ? void 0 : _config_onError.call(config, value);
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            thenable.reject(value);
        }
    };
    var pause = function() {
        return new Promise(function(continueResolve) {
            var _config_onPause;
            continueFn = function(value) {
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_config_onPause = config.onPause) === null || _config_onPause === void 0 ? void 0 : _config_onPause.call(config);
        }).then(function() {
            var _config_onContinue;
            continueFn = void 0;
            if (!isResolved) (_config_onContinue = config.onContinue) === null || _config_onContinue === void 0 ? void 0 : _config_onContinue.call(config);
        });
    };
    var run = function() {
        if (isResolved) return;
        var promiseOrValue;
        var initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise !== null && initialPromise !== void 0 ? initialPromise : config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config_onFail;
            if (isResolved) return;
            var _config_retry;
            var retry = (_config_retry = config.retry) !== null && _config_retry !== void 0 ? _config_retry : import_utils.isServer ? 0 : 3;
            var _config_retryDelay;
            var retryDelay = (_config_retryDelay = config.retryDelay) !== null && _config_retryDelay !== void 0 ? _config_retryDelay : defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_config_onFail = config.onFail) === null || _config_onFail === void 0 ? void 0 : _config_onFail.call(config, failureCount, error);
            (0, import_utils.sleep)(delay).then(function() {
                return canContinue() ? void 0 : pause();
            }).then(function() {
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel,
        continue: function() {
            continueFn === null || continueFn === void 0 ? void 0 : continueFn();
            return thenable;
        },
        cancelRetry,
        continueRetry,
        canStart,
        start: function() {
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}
 //# sourceMappingURL=retryer.cjs.map

},{"@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_wrap_native_super":"iejbF","@swc/helpers/_/_create_super":"bKhhG","2d91be47de9c18b3":"lQPnM","6817db198def77b9":"65kuO","564970098a0d0dc8":"i6xjv","8c9b2025825738c1":"l88Kk"}],"lQPnM":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _focused, _cleanup, _setup;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/focusManager.ts
var focusManager_exports = {};
__export(focusManager_exports, {
    FocusManager: function() {
        return FocusManager;
    },
    focusManager: function() {
        return focusManager;
    }
});
module.exports = __toCommonJS(focusManager_exports);
var import_subscribable = require("21cd4935ab14e118");
var import_utils = require("93e69c4b80bcab9d");
var FocusManager = (_focused = /*#__PURE__*/ new WeakMap(), _cleanup = /*#__PURE__*/ new WeakMap(), _setup = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(_import_subscribable_Subscribable) {
    (0, _inherits._)(_class, _import_subscribable_Subscribable);
    var _super = (0, _createSuper._)(_class);
    function _class() {
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _focused, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _cleanup, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _setup, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _setup, function(onFocus) {
            if (!import_utils.isServer && window.addEventListener) {
                var listener = function() {
                    return onFocus();
                };
                window.addEventListener("visibilitychange", listener, false);
                return function() {
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "onSubscribe",
            value: function onSubscribe() {
                if (!(0, _classPrivateFieldGet._)(this, _cleanup)) this.setEventListener((0, _classPrivateFieldGet._)(this, _setup));
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                var _this, _this1, _ref;
                if (!this.hasListeners()) {
                    (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                    (0, _classPrivateFieldSet._)(this, _cleanup, void 0);
                }
            }
        },
        {
            key: "setEventListener",
            value: function setEventListener(setup) {
                var _this = this;
                var _this1, _this2, _ref;
                (0, _classPrivateFieldSet._)(this, _setup, setup);
                (_this1 = (0, _classPrivateFieldGet._)(_ref = _this2 = this, _cleanup)) === null || _this1 === void 0 ? void 0 : _this1.call(_this2);
                (0, _classPrivateFieldSet._)(this, _cleanup, setup(function(focused) {
                    if (typeof focused === "boolean") _this.setFocused(focused);
                    else _this.onFocus();
                }));
            }
        },
        {
            key: "setFocused",
            value: function setFocused(focused) {
                var changed = (0, _classPrivateFieldGet._)(this, _focused) !== focused;
                if (changed) {
                    (0, _classPrivateFieldSet._)(this, _focused, focused);
                    this.onFocus();
                }
            }
        },
        {
            key: "onFocus",
            value: function onFocus() {
                var isFocused = this.isFocused();
                this.listeners.forEach(function(listener) {
                    listener(isFocused);
                });
            }
        },
        {
            key: "isFocused",
            value: function isFocused() {
                var _globalThis_document;
                if (typeof (0, _classPrivateFieldGet._)(this, _focused) === "boolean") return (0, _classPrivateFieldGet._)(this, _focused);
                return ((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.visibilityState) !== "hidden";
            }
        }
    ]);
    return _class;
}(import_subscribable.Subscribable));
var focusManager = new FocusManager();
 //# sourceMappingURL=focusManager.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_create_super":"bKhhG","21cd4935ab14e118":"7KUyg","93e69c4b80bcab9d":"l88Kk"}],"bkykZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_get;
});
var _classApplyDescriptorGetJs = require("./_class_apply_descriptor_get.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_get(receiver, privateMap) {
    var descriptor = (0, _classExtractFieldDescriptorJs._)(receiver, privateMap, "get");
    return (0, _classApplyDescriptorGetJs._)(receiver, descriptor);
}

},{"./_class_apply_descriptor_get.js":"eK8Ps","./_class_extract_field_descriptor.js":"kVIEZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"eK8Ps":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_apply_descriptor_get;
});
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"kVIEZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_extract_field_descriptor;
});
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"5Ktvm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_init;
});
var _checkPrivateRedeclarationJs = require("./_check_private_redeclaration.js");
function _class_private_field_init(obj, privateMap, value) {
    (0, _checkPrivateRedeclarationJs._)(obj, privateMap);
    privateMap.set(obj, value);
}

},{"./_check_private_redeclaration.js":"lAlYU","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"lAlYU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _check_private_redeclaration;
});
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"eupaj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_set;
});
var _classApplyDescriptorSetJs = require("./_class_apply_descriptor_set.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = (0, _classExtractFieldDescriptorJs._)(receiver, privateMap, "set");
    (0, _classApplyDescriptorSetJs._)(receiver, descriptor, value);
    return value;
}

},{"./_class_apply_descriptor_set.js":"5fUdG","./_class_extract_field_descriptor.js":"kVIEZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"5fUdG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_apply_descriptor_set;
});
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"7KUyg":[function(require,module,exports) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/subscribable.ts
var subscribable_exports = {};
__export(subscribable_exports, {
    Subscribable: function() {
        return Subscribable;
    }
});
module.exports = __toCommonJS(subscribable_exports);
var Subscribable = /*#__PURE__*/ function() {
    function Subscribable() {
        (0, _classCallCheck._)(this, Subscribable);
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    (0, _createClass._)(Subscribable, [
        {
            key: "subscribe",
            value: function subscribe(listener) {
                var _this = this;
                this.listeners.add(listener);
                this.onSubscribe();
                return function() {
                    _this.listeners.delete(listener);
                    _this.onUnsubscribe();
                };
            }
        },
        {
            key: "hasListeners",
            value: function hasListeners() {
                return this.listeners.size > 0;
            }
        },
        {
            key: "onSubscribe",
            value: function onSubscribe() {}
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {}
        }
    ]);
    return Subscribable;
}();
 //# sourceMappingURL=subscribable.cjs.map

},{"@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_create_class":"9mBzM"}],"l88Kk":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/utils.ts
var utils_exports = {};
__export(utils_exports, {
    addToEnd: function() {
        return addToEnd;
    },
    addToStart: function() {
        return addToStart;
    },
    ensureQueryFn: function() {
        return ensureQueryFn;
    },
    functionalUpdate: function() {
        return functionalUpdate;
    },
    hashKey: function() {
        return hashKey;
    },
    hashQueryKeyByOptions: function() {
        return hashQueryKeyByOptions;
    },
    isPlainArray: function() {
        return isPlainArray;
    },
    isPlainObject: function() {
        return isPlainObject;
    },
    isServer: function() {
        return isServer;
    },
    isValidTimeout: function() {
        return isValidTimeout;
    },
    keepPreviousData: function() {
        return keepPreviousData;
    },
    matchMutation: function() {
        return matchMutation;
    },
    matchQuery: function() {
        return matchQuery;
    },
    noop: function() {
        return noop;
    },
    partialMatchKey: function() {
        return partialMatchKey;
    },
    replaceData: function() {
        return replaceData;
    },
    replaceEqualDeep: function() {
        return replaceEqualDeep;
    },
    resolveEnabled: function() {
        return resolveEnabled;
    },
    resolveStaleTime: function() {
        return resolveStaleTime;
    },
    shallowEqualObjects: function() {
        return shallowEqualObjects;
    },
    skipToken: function() {
        return skipToken;
    },
    sleep: function() {
        return sleep;
    },
    timeUntilStale: function() {
        return timeUntilStale;
    }
});
module.exports = __toCommonJS(utils_exports);
var isServer = typeof window === "undefined" || "Deno" in globalThis;
function noop() {}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function resolveStaleTime(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function resolveEnabled(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function matchQuery(filters, query) {
    var _filters_type = filters.type, type = _filters_type === void 0 ? "all" : _filters_type, exact = filters.exact, fetchStatus = filters.fetchStatus, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        var isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    var exact = filters.exact, status = filters.status, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    var hashFn = (options === null || options === void 0 ? void 0 : options.queryKeyHashFn) || hashKey;
    return hashFn(queryKey);
}
function hashKey(queryKey) {
    return JSON.stringify(queryKey, function(_, val) {
        return isPlainObject(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function partialMatchKey(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !partialMatchKey(a[key], b[key]);
    });
    return false;
}
function replaceEqualDeep(a, b) {
    if (a === b) return a;
    var array = isPlainArray(a) && isPlainArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        var aItems = array ? a : Object.keys(a);
        var aSize = aItems.length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = replaceEqualDeep(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function shallowEqualObjects(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
    var ctor = o.constructor;
    if (ctor === void 0) return true;
    var prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function replaceData(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return replaceEqualDeep(prevData, data);
    }
    return data;
}
function keepPreviousData(previousData) {
    return previousData;
}
function addToEnd(items, item) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var newItems = (0, _toConsumableArray._)(items).concat([
        item
    ]);
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item) {
    var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var newItems = [
        item
    ].concat((0, _toConsumableArray._)(items));
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var skipToken = Symbol();
function ensureQueryFn(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise)) return function() {
        return fetchOptions.initialPromise;
    };
    if (!options.queryFn || options.queryFn === skipToken) return function() {
        return Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    };
    return options.queryFn;
}
 //# sourceMappingURL=utils.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"65kuO":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _online, _cleanup, _setup;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/onlineManager.ts
var onlineManager_exports = {};
__export(onlineManager_exports, {
    OnlineManager: function() {
        return OnlineManager;
    },
    onlineManager: function() {
        return onlineManager;
    }
});
module.exports = __toCommonJS(onlineManager_exports);
var import_subscribable = require("74a05e4194911d98");
var import_utils = require("8f901a41fc2cef52");
var OnlineManager = (_online = /*#__PURE__*/ new WeakMap(), _cleanup = /*#__PURE__*/ new WeakMap(), _setup = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(_import_subscribable_Subscribable) {
    (0, _inherits._)(_class, _import_subscribable_Subscribable);
    var _super = (0, _createSuper._)(_class);
    function _class() {
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _online, {
            writable: true,
            value: true
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _cleanup, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _setup, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _setup, function(onOnline) {
            if (!import_utils.isServer && window.addEventListener) {
                var onlineListener = function() {
                    return onOnline(true);
                };
                var offlineListener = function() {
                    return onOnline(false);
                };
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return function() {
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "onSubscribe",
            value: function onSubscribe() {
                if (!(0, _classPrivateFieldGet._)(this, _cleanup)) this.setEventListener((0, _classPrivateFieldGet._)(this, _setup));
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                var _this, _this1, _ref;
                if (!this.hasListeners()) {
                    (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                    (0, _classPrivateFieldSet._)(this, _cleanup, void 0);
                }
            }
        },
        {
            key: "setEventListener",
            value: function setEventListener(setup) {
                var _this, _this1, _ref;
                (0, _classPrivateFieldSet._)(this, _setup, setup);
                (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _cleanup)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                (0, _classPrivateFieldSet._)(this, _cleanup, setup(this.setOnline.bind(this)));
            }
        },
        {
            key: "setOnline",
            value: function setOnline(online) {
                var changed = (0, _classPrivateFieldGet._)(this, _online) !== online;
                if (changed) {
                    (0, _classPrivateFieldSet._)(this, _online, online);
                    this.listeners.forEach(function(listener) {
                        listener(online);
                    });
                }
            }
        },
        {
            key: "isOnline",
            value: function isOnline() {
                return (0, _classPrivateFieldGet._)(this, _online);
            }
        }
    ]);
    return _class;
}(import_subscribable.Subscribable));
var onlineManager = new OnlineManager();
 //# sourceMappingURL=onlineManager.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_create_super":"bKhhG","74a05e4194911d98":"7KUyg","8f901a41fc2cef52":"l88Kk"}],"i6xjv":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/thenable.ts
var thenable_exports = {};
__export(thenable_exports, {
    pendingThenable: function() {
        return pendingThenable;
    }
});
module.exports = __toCommonJS(thenable_exports);
function pendingThenable() {
    var resolve;
    var reject;
    var thenable = new Promise(function(_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(function() {});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = function(value) {
        finalize({
            status: "fulfilled",
            value
        });
        resolve(value);
    };
    thenable.reject = function(reason) {
        finalize({
            status: "rejected",
            reason
        });
        reject(reason);
    };
    return thenable;
}
 //# sourceMappingURL=thenable.cjs.map

},{}],"cSvIg":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _queries;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/queryCache.ts
var queryCache_exports = {};
__export(queryCache_exports, {
    QueryCache: function() {
        return QueryCache;
    }
});
module.exports = __toCommonJS(queryCache_exports);
var import_utils = require("282c125bf3e39f30");
var import_query = require("b0c661571e15979f");
var import_notifyManager = require("fbadbddcf422f398");
var import_subscribable = require("9644654a1361b384");
var QueryCache = (_queries = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(_import_subscribable_Subscribable) {
    (0, _inherits._)(_class, _import_subscribable_Subscribable);
    var _super = (0, _createSuper._)(_class);
    function _class() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _queries, {
            writable: true,
            value: void 0
        });
        _this.config = config;
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _queries, /* @__PURE__ */ new Map());
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "build",
            value: function build(client, options, state) {
                var queryKey = options.queryKey;
                var _options_queryHash;
                var queryHash = (_options_queryHash = options.queryHash) !== null && _options_queryHash !== void 0 ? _options_queryHash : (0, import_utils.hashQueryKeyByOptions)(queryKey, options);
                var query = this.get(queryHash);
                if (!query) {
                    query = new import_query.Query({
                        cache: this,
                        queryKey,
                        queryHash,
                        options: client.defaultQueryOptions(options),
                        state,
                        defaultOptions: client.getQueryDefaults(queryKey)
                    });
                    this.add(query);
                }
                return query;
            }
        },
        {
            key: "add",
            value: function add(query) {
                if (!(0, _classPrivateFieldGet._)(this, _queries).has(query.queryHash)) {
                    (0, _classPrivateFieldGet._)(this, _queries).set(query.queryHash, query);
                    this.notify({
                        type: "added",
                        query
                    });
                }
            }
        },
        {
            key: "remove",
            value: function remove(query) {
                var queryInMap = (0, _classPrivateFieldGet._)(this, _queries).get(query.queryHash);
                if (queryInMap) {
                    query.destroy();
                    if (queryInMap === query) (0, _classPrivateFieldGet._)(this, _queries).delete(query.queryHash);
                    this.notify({
                        type: "removed",
                        query
                    });
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                import_notifyManager.notifyManager.batch(function() {
                    _this.getAll().forEach(function(query) {
                        _this.remove(query);
                    });
                });
            }
        },
        {
            key: "get",
            value: function get(queryHash) {
                return (0, _classPrivateFieldGet._)(this, _queries).get(queryHash);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return (0, _toConsumableArray._)((0, _classPrivateFieldGet._)(this, _queries).values());
            }
        },
        {
            key: "find",
            value: function find(filters) {
                var defaultedFilters = (0, _objectSpread._)({
                    exact: true
                }, filters);
                return this.getAll().find(function(query) {
                    return (0, import_utils.matchQuery)(defaultedFilters, query);
                });
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var queries = this.getAll();
                return Object.keys(filters).length > 0 ? queries.filter(function(query) {
                    return (0, import_utils.matchQuery)(filters, query);
                }) : queries;
            }
        },
        {
            key: "notify",
            value: function notify(event) {
                var _this = this;
                import_notifyManager.notifyManager.batch(function() {
                    _this.listeners.forEach(function(listener) {
                        listener(event);
                    });
                });
            }
        },
        {
            key: "onFocus",
            value: function onFocus() {
                var _this = this;
                import_notifyManager.notifyManager.batch(function() {
                    _this.getAll().forEach(function(query) {
                        query.onFocus();
                    });
                });
            }
        },
        {
            key: "onOnline",
            value: function onOnline() {
                var _this = this;
                import_notifyManager.notifyManager.batch(function() {
                    _this.getAll().forEach(function(query) {
                        query.onOnline();
                    });
                });
            }
        }
    ]);
    return _class;
}(import_subscribable.Subscribable));
 //# sourceMappingURL=queryCache.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_create_super":"bKhhG","282c125bf3e39f30":"l88Kk","b0c661571e15979f":"rzJvy","fbadbddcf422f398":"8XMRv","9644654a1361b384":"7KUyg"}],"rzJvy":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _initialState, _revertState, _cache, _retryer, _defaultOptions, _abortSignalConsumed, _dispatch, _class;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/query.ts
var query_exports = {};
__export(query_exports, {
    Query: function() {
        return Query;
    },
    fetchState: function() {
        return fetchState;
    }
});
module.exports = __toCommonJS(query_exports);
var import_utils = require("27804afdad88e95f");
var import_notifyManager = require("a1d94e18c6e23949");
var import_retryer = require("769e1fc018c55753");
var import_removable = require("ce1e48f112b27010");
var Query = (_initialState = /*#__PURE__*/ new WeakMap(), _revertState = /*#__PURE__*/ new WeakMap(), _cache = /*#__PURE__*/ new WeakMap(), _retryer = /*#__PURE__*/ new WeakMap(), _defaultOptions = /*#__PURE__*/ new WeakMap(), _abortSignalConsumed = /*#__PURE__*/ new WeakMap(), _dispatch = /*#__PURE__*/ new WeakSet(), _class = /*#__PURE__*/ function(_import_removable_Removable) {
    (0, _inherits._)(_class, _import_removable_Removable);
    var _super = (0, _createSuper._)(_class);
    function _class(config) {
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _dispatch);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _initialState, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _revertState, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _cache, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _retryer, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _defaultOptions, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _abortSignalConsumed, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _abortSignalConsumed, false);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _defaultOptions, config.defaultOptions);
        _this.setOptions(config.options);
        _this.observers = [];
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _cache, config.cache);
        _this.queryKey = config.queryKey;
        _this.queryHash = config.queryHash;
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _initialState, getDefaultState(_this.options));
        var _config_state;
        _this.state = (_config_state = config.state) !== null && _config_state !== void 0 ? _config_state : (0, _classPrivateFieldGet._)((0, _assertThisInitialized._)(_this), _initialState);
        _this.scheduleGc();
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "meta",
            get: function get() {
                return this.options.meta;
            }
        },
        {
            key: "promise",
            get: function get() {
                var _$_class_private_field_get;
                return (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.promise;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = (0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(this, _defaultOptions), options);
                this.updateGcTime(this.options.gcTime);
            }
        },
        {
            key: "optionalRemove",
            value: function optionalRemove() {
                if (!this.observers.length && this.state.fetchStatus === "idle") (0, _classPrivateFieldGet._)(this, _cache).remove(this);
            }
        },
        {
            key: "setData",
            value: function setData(newData, options) {
                var data = (0, import_utils.replaceData)(this.state.data, newData, this.options);
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    data,
                    type: "success",
                    dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
                    manual: options === null || options === void 0 ? void 0 : options.manual
                });
                return data;
            }
        },
        {
            key: "setState",
            value: function setState(state, setStateOptions) {
                (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "setState",
                    state,
                    setStateOptions
                });
            }
        },
        {
            key: "cancel",
            value: function cancel(options) {
                var _$_class_private_field_get, _$_class_private_field_get1;
                var promise = (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.promise;
                (_$_class_private_field_get1 = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _$_class_private_field_get1 === void 0 ? void 0 : _$_class_private_field_get1.cancel(options);
                return promise ? promise.then(import_utils.noop).catch(import_utils.noop) : Promise.resolve();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, _get._)((0, _getPrototypeOf._)(_class.prototype), "destroy", this).call(this);
                this.cancel({
                    silent: true
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.destroy();
                this.setState((0, _classPrivateFieldGet._)(this, _initialState));
            }
        },
        {
            key: "isActive",
            value: function isActive() {
                var _this = this;
                return this.observers.some(function(observer) {
                    return (0, import_utils.resolveEnabled)(observer.options.enabled, _this) !== false;
                });
            }
        },
        {
            key: "isDisabled",
            value: function isDisabled() {
                if (this.getObserversCount() > 0) return !this.isActive();
                return this.options.queryFn === import_utils.skipToken || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
            }
        },
        {
            key: "isStale",
            value: function isStale() {
                if (this.state.isInvalidated) return true;
                if (this.getObserversCount() > 0) return this.observers.some(function(observer) {
                    return observer.getCurrentResult().isStale;
                });
                return this.state.data === void 0;
            }
        },
        {
            key: "isStaleByTime",
            value: function isStaleByTime() {
                var staleTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return this.state.isInvalidated || this.state.data === void 0 || !(0, import_utils.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
            }
        },
        {
            key: "onFocus",
            value: function onFocus() {
                var _$_class_private_field_get;
                var observer = this.observers.find(function(x) {
                    return x.shouldFetchOnWindowFocus();
                });
                observer === null || observer === void 0 ? void 0 : observer.refetch({
                    cancelRefetch: false
                });
                (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.continue();
            }
        },
        {
            key: "onOnline",
            value: function onOnline() {
                var _$_class_private_field_get;
                var observer = this.observers.find(function(x) {
                    return x.shouldFetchOnReconnect();
                });
                observer === null || observer === void 0 ? void 0 : observer.refetch({
                    cancelRefetch: false
                });
                (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.continue();
            }
        },
        {
            key: "addObserver",
            value: function addObserver(observer) {
                if (!this.observers.includes(observer)) {
                    this.observers.push(observer);
                    this.clearGcTimeout();
                    (0, _classPrivateFieldGet._)(this, _cache).notify({
                        type: "observerAdded",
                        query: this,
                        observer
                    });
                }
            }
        },
        {
            key: "removeObserver",
            value: function removeObserver(observer) {
                if (this.observers.includes(observer)) {
                    this.observers = this.observers.filter(function(x) {
                        return x !== observer;
                    });
                    if (!this.observers.length) {
                        if ((0, _classPrivateFieldGet._)(this, _retryer)) {
                            if ((0, _classPrivateFieldGet._)(this, _abortSignalConsumed)) (0, _classPrivateFieldGet._)(this, _retryer).cancel({
                                revert: true
                            });
                            else (0, _classPrivateFieldGet._)(this, _retryer).cancelRetry();
                        }
                        this.scheduleGc();
                    }
                    (0, _classPrivateFieldGet._)(this, _cache).notify({
                        type: "observerRemoved",
                        query: this,
                        observer
                    });
                }
            }
        },
        {
            key: "getObserversCount",
            value: function getObserversCount() {
                return this.observers.length;
            }
        },
        {
            key: "invalidate",
            value: function invalidate() {
                if (!this.state.isInvalidated) (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "invalidate"
                });
            }
        },
        {
            key: "fetch",
            value: function fetch(options, fetchOptions) {
                var _this = this;
                var _this_options_behavior, _context_fetchOptions, _context_fetchOptions1;
                if (this.state.fetchStatus !== "idle") {
                    if (this.state.data !== void 0 && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                        silent: true
                    });
                    else if ((0, _classPrivateFieldGet._)(this, _retryer)) {
                        (0, _classPrivateFieldGet._)(this, _retryer).continueRetry();
                        return (0, _classPrivateFieldGet._)(this, _retryer).promise;
                    }
                }
                if (options) this.setOptions(options);
                if (!this.options.queryFn) {
                    var observer = this.observers.find(function(x) {
                        return x.options.queryFn;
                    });
                    if (observer) this.setOptions(observer.options);
                }
                var abortController = new AbortController();
                var addSignalProperty = function(object) {
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: function() {
                            (0, _classPrivateFieldSet._)(_this, _abortSignalConsumed, true);
                            return abortController.signal;
                        }
                    });
                };
                var fetchFn = function() {
                    var queryFn = (0, import_utils.ensureQueryFn)(_this.options, fetchOptions);
                    var queryFnContext = {
                        queryKey: _this.queryKey,
                        meta: _this.meta
                    };
                    addSignalProperty(queryFnContext);
                    (0, _classPrivateFieldSet._)(_this, _abortSignalConsumed, false);
                    if (_this.options.persister) return _this.options.persister(queryFn, queryFnContext, _this);
                    return queryFn(queryFnContext);
                };
                var context = {
                    fetchOptions,
                    options: this.options,
                    queryKey: this.queryKey,
                    state: this.state,
                    fetchFn
                };
                addSignalProperty(context);
                (_this_options_behavior = this.options.behavior) === null || _this_options_behavior === void 0 ? void 0 : _this_options_behavior.onFetch(context, this);
                (0, _classPrivateFieldSet._)(this, _revertState, this.state);
                if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : _context_fetchOptions.meta)) (0, _classPrivateMethodGet._)(this, _dispatch, dispatch).call(this, {
                    type: "fetch",
                    meta: (_context_fetchOptions1 = context.fetchOptions) === null || _context_fetchOptions1 === void 0 ? void 0 : _context_fetchOptions1.meta
                });
                var onError = function(error) {
                    if (!((0, import_retryer.isCancelledError)(error) && error.silent)) (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                        type: "error",
                        error
                    });
                    if (!(0, import_retryer.isCancelledError)(error)) {
                        var _class_private_field_get_config_onError, _class_private_field_get_config, _class_private_field_get_config_onSettled, _class_private_field_get_config1;
                        (_class_private_field_get_config_onError = (_class_private_field_get_config = (0, _classPrivateFieldGet._)(_this, _cache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config, error, _this);
                        (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, _classPrivateFieldGet._)(_this, _cache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, _this.state.data, error, _this);
                    }
                    _this.scheduleGc();
                };
                (0, _classPrivateFieldSet._)(this, _retryer, (0, import_retryer.createRetryer)({
                    initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
                    fn: context.fetchFn,
                    abort: abortController.abort.bind(abortController),
                    onSuccess: function(data) {
                        var _class_private_field_get_config_onSuccess, _class_private_field_get_config, _class_private_field_get_config_onSettled, _class_private_field_get_config1;
                        if (data === void 0) {
                            onError(new Error(`${_this.queryHash} data is undefined`));
                            return;
                        }
                        try {
                            _this.setData(data);
                        } catch (error) {
                            onError(error);
                            return;
                        }
                        (_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, _classPrivateFieldGet._)(_this, _cache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, _this);
                        (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, _classPrivateFieldGet._)(_this, _cache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, _this.state.error, _this);
                        _this.scheduleGc();
                    },
                    onError,
                    onFail: function(failureCount, error) {
                        (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                            type: "failed",
                            failureCount,
                            error
                        });
                    },
                    onPause: function() {
                        (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                            type: "pause"
                        });
                    },
                    onContinue: function() {
                        (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                            type: "continue"
                        });
                    },
                    retry: context.options.retry,
                    retryDelay: context.options.retryDelay,
                    networkMode: context.options.networkMode,
                    canRun: function() {
                        return true;
                    }
                }));
                return (0, _classPrivateFieldGet._)(this, _retryer).start();
            }
        }
    ]);
    return _class;
}(import_removable.Removable), _class);
function fetchState(data, options) {
    return (0, _objectSpread._)({
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, import_retryer.canFetch)(options.networkMode) ? "fetching" : "paused"
    }, data === void 0 && {
        error: null,
        status: "pending"
    });
}
function getDefaultState(options) {
    var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    var hasData = data !== void 0;
    var initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt !== null && initialDataUpdatedAt !== void 0 ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}
function dispatch(action) {
    var _this = this;
    var reducer = function(state) {
        switch(action.type){
            case "failed":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                });
            case "pause":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    fetchStatus: "paused"
                });
            case "continue":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    fetchStatus: "fetching"
                });
            case "fetch":
                var _action_meta;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state, fetchState(state.data, _this.options)), {
                    fetchMeta: (_action_meta = action.meta) !== null && _action_meta !== void 0 ? _action_meta : null
                });
            case "success":
                var _action_dataUpdatedAt;
                return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action_dataUpdatedAt = action.dataUpdatedAt) !== null && _action_dataUpdatedAt !== void 0 ? _action_dataUpdatedAt : Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success"
                }), !action.manual && {
                    fetchStatus: "idle",
                    fetchFailureCount: 0,
                    fetchFailureReason: null
                });
            case "error":
                var error = action.error;
                if ((0, import_retryer.isCancelledError)(error) && error.revert && (0, _classPrivateFieldGet._)(_this, _revertState)) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(_this, _revertState)), {
                    fetchStatus: "idle"
                });
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                });
            case "invalidate":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    isInvalidated: true
                });
            case "setState":
                return (0, _objectSpread._)({}, state, action.state);
        }
    };
    this.state = reducer(this.state);
    import_notifyManager.notifyManager.batch(function() {
        _this.observers.forEach(function(observer) {
            observer.onQueryUpdate();
        });
        (0, _classPrivateFieldGet._)(_this, _cache).notify({
            query: _this,
            type: "updated",
            action
        });
    });
}
 //# sourceMappingURL=query.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_class_private_method_get":"4Hn8U","@swc/helpers/_/_class_private_method_init":"6VPza","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_get":"4WRMN","@swc/helpers/_/_get_prototype_of":"5LWub","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_create_super":"bKhhG","27804afdad88e95f":"l88Kk","a1d94e18c6e23949":"8XMRv","769e1fc018c55753":"jd4VA","ce1e48f112b27010":"6kG9F"}],"4Hn8U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_private_method_get;
});
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"6VPza":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_private_method_init;
});
var _checkPrivateRedeclarationJs = require("./_check_private_redeclaration.js");
function _class_private_method_init(obj, privateSet) {
    (0, _checkPrivateRedeclarationJs._)(obj, privateSet);
    privateSet.add(obj);
}

},{"./_check_private_redeclaration.js":"lAlYU","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"4WRMN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get;
});
var _superPropBaseJs = require("./_super_prop_base.js");
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else _get = function get(target, property, receiver) {
        var base = (0, _superPropBaseJs._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return _get(target, property, receiver || target);
}

},{"./_super_prop_base.js":"hBCTB","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"hBCTB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _super_prop_base;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, _getPrototypeOfJs._)(object);
        if (object === null) break;
    }
    return object;
}

},{"./_get_prototype_of.js":"5LWub","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"8XMRv":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/notifyManager.ts
var notifyManager_exports = {};
__export(notifyManager_exports, {
    createNotifyManager: function() {
        return createNotifyManager;
    },
    notifyManager: function() {
        return notifyManager;
    }
});
module.exports = __toCommonJS(notifyManager_exports);
function createNotifyManager() {
    var queue = [];
    var transactions = 0;
    var notifyFn = function(callback) {
        callback();
    };
    var batchNotifyFn = function(callback) {
        callback();
    };
    var scheduleFn = function(cb) {
        return setTimeout(cb, 0);
    };
    var schedule = function(callback) {
        if (transactions) queue.push(callback);
        else scheduleFn(function() {
            notifyFn(callback);
        });
    };
    var flush = function() {
        var originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(function() {
            batchNotifyFn(function() {
                originalQueue.forEach(function(callback) {
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: function(callback) {
            var result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: function(callback) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                schedule(function() {
                    callback.apply(void 0, (0, _toConsumableArray._)(args));
                });
            };
        },
        schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: function(fn) {
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: function(fn) {
            batchNotifyFn = fn;
        },
        setScheduler: function(fn) {
            scheduleFn = fn;
        }
    };
}
var notifyManager = createNotifyManager();
 //# sourceMappingURL=notifyManager.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"6kG9F":[function(require,module,exports) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _createClass = require("@swc/helpers/_/_create_class");
"use strict";
var _gcTimeout;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/removable.ts
var removable_exports = {};
__export(removable_exports, {
    Removable: function() {
        return Removable;
    }
});
module.exports = __toCommonJS(removable_exports);
var import_utils = require("136752a484065b0e");
var Removable = (_gcTimeout = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function() {
    function _class() {
        (0, _classCallCheck._)(this, _class);
        (0, _classPrivateFieldInit._)(this, _gcTimeout, {
            writable: true,
            value: void 0
        });
    }
    (0, _createClass._)(_class, [
        {
            key: "destroy",
            value: function destroy() {
                this.clearGcTimeout();
            }
        },
        {
            key: "scheduleGc",
            value: function scheduleGc() {
                var _this = this;
                this.clearGcTimeout();
                if ((0, import_utils.isValidTimeout)(this.gcTime)) (0, _classPrivateFieldSet._)(this, _gcTimeout, setTimeout(function() {
                    _this.optionalRemove();
                }, this.gcTime));
            }
        },
        {
            key: "updateGcTime",
            value: function updateGcTime(newGcTime) {
                this.gcTime = Math.max(this.gcTime || 0, newGcTime !== null && newGcTime !== void 0 ? newGcTime : import_utils.isServer ? Infinity : 300000);
            }
        },
        {
            key: "clearGcTimeout",
            value: function clearGcTimeout() {
                if ((0, _classPrivateFieldGet._)(this, _gcTimeout)) {
                    clearTimeout((0, _classPrivateFieldGet._)(this, _gcTimeout));
                    (0, _classPrivateFieldSet._)(this, _gcTimeout, void 0);
                }
            }
        }
    ]);
    return _class;
}());
 //# sourceMappingURL=removable.cjs.map

},{"@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_create_class":"9mBzM","136752a484065b0e":"l88Kk"}],"7edB7":[function(require,module,exports) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateFieldUpdate = require("@swc/helpers/_/_class_private_field_update");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var _queryCache, _mutationCache, _defaultOptions, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/queryClient.ts
var queryClient_exports = {};
__export(queryClient_exports, {
    QueryClient: function() {
        return QueryClient;
    }
});
module.exports = __toCommonJS(queryClient_exports);
var import_utils = require("1f6dfbf749f77e2a");
var import_queryCache = require("46b75cb5a70eaf22");
var import_mutationCache = require("e443cc6d06a536f6");
var import_focusManager = require("641a13a0b68ed9d5");
var import_onlineManager = require("97781f961ac785a5");
var import_notifyManager = require("2cb35a8524969dd8");
var import_infiniteQueryBehavior = require("452b151889abe45f");
var QueryClient = (_queryCache = /*#__PURE__*/ new WeakMap(), _mutationCache = /*#__PURE__*/ new WeakMap(), _defaultOptions = /*#__PURE__*/ new WeakMap(), _queryDefaults = /*#__PURE__*/ new WeakMap(), _mutationDefaults = /*#__PURE__*/ new WeakMap(), _mountCount = /*#__PURE__*/ new WeakMap(), _unsubscribeFocus = /*#__PURE__*/ new WeakMap(), _unsubscribeOnline = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function() {
    function _class() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, _class);
        (0, _classPrivateFieldInit._)(this, _queryCache, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _mutationCache, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _defaultOptions, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _queryDefaults, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _mutationDefaults, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _mountCount, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _unsubscribeFocus, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)(this, _unsubscribeOnline, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, _queryCache, config.queryCache || new import_queryCache.QueryCache());
        (0, _classPrivateFieldSet._)(this, _mutationCache, config.mutationCache || new import_mutationCache.MutationCache());
        (0, _classPrivateFieldSet._)(this, _defaultOptions, config.defaultOptions || {});
        (0, _classPrivateFieldSet._)(this, _queryDefaults, /* @__PURE__ */ new Map());
        (0, _classPrivateFieldSet._)(this, _mutationDefaults, /* @__PURE__ */ new Map());
        (0, _classPrivateFieldSet._)(this, _mountCount, 0);
    }
    (0, _createClass._)(_class, [
        {
            key: "mount",
            value: function mount() {
                (0, _classPrivateFieldUpdate._)(this, _mountCount).value++;
                if ((0, _classPrivateFieldGet._)(this, _mountCount) !== 1) return;
                var _this = this;
                (0, _classPrivateFieldSet._)(this, _unsubscribeFocus, import_focusManager.focusManager.subscribe(function() {
                    var _ref = (0, _asyncToGenerator._)(function(focused) {
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!focused) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this.resumePausedMutations()
                                    ];
                                case 1:
                                    _state.sent();
                                    (0, _classPrivateFieldGet._)(_this, _queryCache).onFocus();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(focused) {
                        return _ref.apply(this, arguments);
                    };
                }()));
                var _this1 = this;
                (0, _classPrivateFieldSet._)(this, _unsubscribeOnline, import_onlineManager.onlineManager.subscribe(function() {
                    var _ref = (0, _asyncToGenerator._)(function(online) {
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!online) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this1.resumePausedMutations()
                                    ];
                                case 1:
                                    _state.sent();
                                    (0, _classPrivateFieldGet._)(_this1, _queryCache).onOnline();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(online) {
                        return _ref.apply(this, arguments);
                    };
                }()));
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this, _this1, _ref, _this2, _this3, _ref1;
                (0, _classPrivateFieldUpdate._)(this, _mountCount).value--;
                if ((0, _classPrivateFieldGet._)(this, _mountCount) !== 0) return;
                (_this = (0, _classPrivateFieldGet._)(_ref = _this1 = this, _unsubscribeFocus)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                (0, _classPrivateFieldSet._)(this, _unsubscribeFocus, void 0);
                (_this2 = (0, _classPrivateFieldGet._)(_ref1 = _this3 = this, _unsubscribeOnline)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3);
                (0, _classPrivateFieldSet._)(this, _unsubscribeOnline, void 0);
            }
        },
        {
            key: "isFetching",
            value: function isFetching(filters) {
                return (0, _classPrivateFieldGet._)(this, _queryCache).findAll((0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
                    fetchStatus: "fetching"
                })).length;
            }
        },
        {
            key: "isMutating",
            value: function isMutating(filters) {
                return (0, _classPrivateFieldGet._)(this, _mutationCache).findAll((0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
                    status: "pending"
                })).length;
            }
        },
        {
            key: "getQueryData",
            value: function getQueryData(queryKey) {
                var _class_private_field_get_get;
                var options = this.defaultQueryOptions({
                    queryKey
                });
                return (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state.data;
            }
        },
        {
            key: "ensureQueryData",
            value: function ensureQueryData(options) {
                var cachedData = this.getQueryData(options.queryKey);
                if (cachedData === void 0) return this.fetchQuery(options);
                else {
                    var defaultedOptions = this.defaultQueryOptions(options);
                    var query = (0, _classPrivateFieldGet._)(this, _queryCache).build(this, defaultedOptions);
                    if (options.revalidateIfStale && query.isStaleByTime((0, import_utils.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
                    return Promise.resolve(cachedData);
                }
            }
        },
        {
            key: "getQueriesData",
            value: function getQueriesData(filters) {
                return (0, _classPrivateFieldGet._)(this, _queryCache).findAll(filters).map(function(param) {
                    var queryKey = param.queryKey, state = param.state;
                    var data = state.data;
                    return [
                        queryKey,
                        data
                    ];
                });
            }
        },
        {
            key: "setQueryData",
            value: function setQueryData(queryKey, updater, options) {
                var defaultedOptions = this.defaultQueryOptions({
                    queryKey
                });
                var query = (0, _classPrivateFieldGet._)(this, _queryCache).get(defaultedOptions.queryHash);
                var prevData = query === null || query === void 0 ? void 0 : query.state.data;
                var data = (0, import_utils.functionalUpdate)(updater, prevData);
                if (data === void 0) return void 0;
                return (0, _classPrivateFieldGet._)(this, _queryCache).build(this, defaultedOptions).setData(data, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    manual: true
                }));
            }
        },
        {
            key: "setQueriesData",
            value: function setQueriesData(filters, updater, options) {
                var _this = this;
                return import_notifyManager.notifyManager.batch(function() {
                    return (0, _classPrivateFieldGet._)(_this, _queryCache).findAll(filters).map(function(param) {
                        var queryKey = param.queryKey;
                        return [
                            queryKey,
                            _this.setQueryData(queryKey, updater, options)
                        ];
                    });
                });
            }
        },
        {
            key: "getQueryState",
            value: function getQueryState(queryKey) {
                var _class_private_field_get_get;
                var options = this.defaultQueryOptions({
                    queryKey
                });
                return (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _queryCache).get(options.queryHash)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.state;
            }
        },
        {
            key: "removeQueries",
            value: function removeQueries(filters) {
                var queryCache = (0, _classPrivateFieldGet._)(this, _queryCache);
                import_notifyManager.notifyManager.batch(function() {
                    queryCache.findAll(filters).forEach(function(query) {
                        queryCache.remove(query);
                    });
                });
            }
        },
        {
            key: "resetQueries",
            value: function resetQueries(filters, options) {
                var _this = this;
                var queryCache = (0, _classPrivateFieldGet._)(this, _queryCache);
                var refetchFilters = (0, _objectSpread._)({
                    type: "active"
                }, filters);
                return import_notifyManager.notifyManager.batch(function() {
                    queryCache.findAll(filters).forEach(function(query) {
                        query.reset();
                    });
                    return _this.refetchQueries(refetchFilters, options);
                });
            }
        },
        {
            key: "cancelQueries",
            value: function cancelQueries(filters) {
                var _this = this;
                var cancelOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var defaultedCancelOptions = (0, _objectSpread._)({
                    revert: true
                }, cancelOptions);
                var promises = import_notifyManager.notifyManager.batch(function() {
                    return (0, _classPrivateFieldGet._)(_this, _queryCache).findAll(filters).map(function(query) {
                        return query.cancel(defaultedCancelOptions);
                    });
                });
                return Promise.all(promises).then(import_utils.noop).catch(import_utils.noop);
            }
        },
        {
            key: "invalidateQueries",
            value: function invalidateQueries(filters) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return import_notifyManager.notifyManager.batch(function() {
                    (0, _classPrivateFieldGet._)(_this, _queryCache).findAll(filters).forEach(function(query) {
                        query.invalidate();
                    });
                    if ((filters === null || filters === void 0 ? void 0 : filters.refetchType) === "none") return Promise.resolve();
                    var _filters_refetchType, _ref;
                    var refetchFilters = (0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
                        type: (_ref = (_filters_refetchType = filters === null || filters === void 0 ? void 0 : filters.refetchType) !== null && _filters_refetchType !== void 0 ? _filters_refetchType : filters === null || filters === void 0 ? void 0 : filters.type) !== null && _ref !== void 0 ? _ref : "active"
                    });
                    return _this.refetchQueries(refetchFilters, options);
                });
            }
        },
        {
            key: "refetchQueries",
            value: function refetchQueries(filters) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _options_cancelRefetch;
                var fetchOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    cancelRefetch: (_options_cancelRefetch = options.cancelRefetch) !== null && _options_cancelRefetch !== void 0 ? _options_cancelRefetch : true
                });
                var promises = import_notifyManager.notifyManager.batch(function() {
                    return (0, _classPrivateFieldGet._)(_this, _queryCache).findAll(filters).filter(function(query) {
                        return !query.isDisabled();
                    }).map(function(query) {
                        var promise = query.fetch(void 0, fetchOptions);
                        if (!fetchOptions.throwOnError) promise = promise.catch(import_utils.noop);
                        return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
                    });
                });
                return Promise.all(promises).then(import_utils.noop);
            }
        },
        {
            key: "fetchQuery",
            value: function fetchQuery(options) {
                var defaultedOptions = this.defaultQueryOptions(options);
                if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
                var query = (0, _classPrivateFieldGet._)(this, _queryCache).build(this, defaultedOptions);
                return query.isStaleByTime((0, import_utils.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
            }
        },
        {
            key: "prefetchQuery",
            value: function prefetchQuery(options) {
                return this.fetchQuery(options).then(import_utils.noop).catch(import_utils.noop);
            }
        },
        {
            key: "fetchInfiniteQuery",
            value: function fetchInfiniteQuery(options) {
                options.behavior = (0, import_infiniteQueryBehavior.infiniteQueryBehavior)(options.pages);
                return this.fetchQuery(options);
            }
        },
        {
            key: "prefetchInfiniteQuery",
            value: function prefetchInfiniteQuery(options) {
                return this.fetchInfiniteQuery(options).then(import_utils.noop).catch(import_utils.noop);
            }
        },
        {
            key: "ensureInfiniteQueryData",
            value: function ensureInfiniteQueryData(options) {
                options.behavior = (0, import_infiniteQueryBehavior.infiniteQueryBehavior)(options.pages);
                return this.ensureQueryData(options);
            }
        },
        {
            key: "resumePausedMutations",
            value: function resumePausedMutations() {
                if (import_onlineManager.onlineManager.isOnline()) return (0, _classPrivateFieldGet._)(this, _mutationCache).resumePausedMutations();
                return Promise.resolve();
            }
        },
        {
            key: "getQueryCache",
            value: function getQueryCache() {
                return (0, _classPrivateFieldGet._)(this, _queryCache);
            }
        },
        {
            key: "getMutationCache",
            value: function getMutationCache() {
                return (0, _classPrivateFieldGet._)(this, _mutationCache);
            }
        },
        {
            key: "getDefaultOptions",
            value: function getDefaultOptions() {
                return (0, _classPrivateFieldGet._)(this, _defaultOptions);
            }
        },
        {
            key: "setDefaultOptions",
            value: function setDefaultOptions(options) {
                (0, _classPrivateFieldSet._)(this, _defaultOptions, options);
            }
        },
        {
            key: "setQueryDefaults",
            value: function setQueryDefaults(queryKey, options) {
                (0, _classPrivateFieldGet._)(this, _queryDefaults).set((0, import_utils.hashKey)(queryKey), {
                    queryKey,
                    defaultOptions: options
                });
            }
        },
        {
            key: "getQueryDefaults",
            value: function getQueryDefaults(queryKey) {
                var defaults = (0, _toConsumableArray._)((0, _classPrivateFieldGet._)(this, _queryDefaults).values());
                var result = {};
                defaults.forEach(function(queryDefault) {
                    if ((0, import_utils.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
                });
                return result;
            }
        },
        {
            key: "setMutationDefaults",
            value: function setMutationDefaults(mutationKey, options) {
                (0, _classPrivateFieldGet._)(this, _mutationDefaults).set((0, import_utils.hashKey)(mutationKey), {
                    mutationKey,
                    defaultOptions: options
                });
            }
        },
        {
            key: "getMutationDefaults",
            value: function getMutationDefaults(mutationKey) {
                var defaults = (0, _toConsumableArray._)((0, _classPrivateFieldGet._)(this, _mutationDefaults).values());
                var result = {};
                defaults.forEach(function(queryDefault) {
                    if ((0, import_utils.partialMatchKey)(mutationKey, queryDefault.mutationKey)) result = (0, _objectSpread._)({}, result, queryDefault.defaultOptions);
                });
                return result;
            }
        },
        {
            key: "defaultQueryOptions",
            value: function defaultQueryOptions(options) {
                if (options._defaulted) return options;
                var defaultedOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(this, _defaultOptions).queries, this.getQueryDefaults(options.queryKey), options), {
                    _defaulted: true
                });
                if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, import_utils.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
                if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
                if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
                if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
                if (defaultedOptions.queryFn === import_utils.skipToken) defaultedOptions.enabled = false;
                return defaultedOptions;
            }
        },
        {
            key: "defaultMutationOptions",
            value: function defaultMutationOptions(options) {
                if (options === null || options === void 0 ? void 0 : options._defaulted) return options;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _classPrivateFieldGet._)(this, _defaultOptions).mutations, (options === null || options === void 0 ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey), options), {
                    _defaulted: true
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                (0, _classPrivateFieldGet._)(this, _queryCache).clear();
                (0, _classPrivateFieldGet._)(this, _mutationCache).clear();
            }
        }
    ]);
    return _class;
}());
 //# sourceMappingURL=queryClient.cjs.map

},{"@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_class_private_field_update":"lwyyo","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_ts_generator":"dn4mF","1f6dfbf749f77e2a":"l88Kk","46b75cb5a70eaf22":"cSvIg","e443cc6d06a536f6":"JnEA9","641a13a0b68ed9d5":"lQPnM","97781f961ac785a5":"65kuO","2cb35a8524969dd8":"8XMRv","452b151889abe45f":"5ezmB"}],"lwyyo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_update;
});
var _classApplyDescriptorUpdateJs = require("./_class_apply_descriptor_update.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_update(receiver, privateMap) {
    var descriptor = (0, _classExtractFieldDescriptorJs._)(receiver, privateMap, "update");
    return (0, _classApplyDescriptorUpdateJs._)(receiver, descriptor);
}

},{"./_class_apply_descriptor_update.js":"bvUhi","./_class_extract_field_descriptor.js":"kVIEZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"bvUhi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_apply_descriptor_update;
});
function _class_apply_descriptor_update(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"JnEA9":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateFieldUpdate = require("@swc/helpers/_/_class_private_field_update");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _mutations, _mutationId;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/mutationCache.ts
var mutationCache_exports = {};
__export(mutationCache_exports, {
    MutationCache: function() {
        return MutationCache;
    }
});
module.exports = __toCommonJS(mutationCache_exports);
var import_notifyManager = require("1d9ccdb026bb8269");
var import_mutation = require("b0b8906896671571");
var import_utils = require("a47c932290b0a4e5");
var import_subscribable = require("c8f4e6f0d1be196c");
var MutationCache = (_mutations = /*#__PURE__*/ new WeakMap(), _mutationId = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function(_import_subscribable_Subscribable) {
    (0, _inherits._)(_class, _import_subscribable_Subscribable);
    var _super = (0, _createSuper._)(_class);
    function _class() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _mutations, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _mutationId, {
            writable: true,
            value: void 0
        });
        _this.config = config;
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _mutations, /* @__PURE__ */ new Map());
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _mutationId, Date.now());
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "build",
            value: function build(client, options, state) {
                var mutation = new import_mutation.Mutation({
                    mutationCache: this,
                    mutationId: ++(0, _classPrivateFieldUpdate._)(this, _mutationId).value,
                    options: client.defaultMutationOptions(options),
                    state
                });
                this.add(mutation);
                return mutation;
            }
        },
        {
            key: "add",
            value: function add(mutation) {
                var scope = scopeFor(mutation);
                var _class_private_field_get_get;
                var mutations = (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _mutations).get(scope)) !== null && _class_private_field_get_get !== void 0 ? _class_private_field_get_get : [];
                mutations.push(mutation);
                (0, _classPrivateFieldGet._)(this, _mutations).set(scope, mutations);
                this.notify({
                    type: "added",
                    mutation
                });
            }
        },
        {
            key: "remove",
            value: function remove(mutation) {
                var scope = scopeFor(mutation);
                if ((0, _classPrivateFieldGet._)(this, _mutations).has(scope)) {
                    var _class_private_field_get_get;
                    var mutations = (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _mutations).get(scope)) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.filter(function(x) {
                        return x !== mutation;
                    });
                    if (mutations) {
                        if (mutations.length === 0) (0, _classPrivateFieldGet._)(this, _mutations).delete(scope);
                        else (0, _classPrivateFieldGet._)(this, _mutations).set(scope, mutations);
                    }
                }
                this.notify({
                    type: "removed",
                    mutation
                });
            }
        },
        {
            key: "canRun",
            value: function canRun(mutation) {
                var _class_private_field_get_get;
                var firstPendingMutation = (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _mutations).get(scopeFor(mutation))) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.find(function(m) {
                    return m.state.status === "pending";
                });
                return !firstPendingMutation || firstPendingMutation === mutation;
            }
        },
        {
            key: "runNext",
            value: function runNext(mutation) {
                var _class_private_field_get_get;
                var foundMutation = (_class_private_field_get_get = (0, _classPrivateFieldGet._)(this, _mutations).get(scopeFor(mutation))) === null || _class_private_field_get_get === void 0 ? void 0 : _class_private_field_get_get.find(function(m) {
                    return m !== mutation && m.state.isPaused;
                });
                var _foundMutation_continue;
                return (_foundMutation_continue = foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) !== null && _foundMutation_continue !== void 0 ? _foundMutation_continue : Promise.resolve();
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                import_notifyManager.notifyManager.batch(function() {
                    _this.getAll().forEach(function(mutation) {
                        _this.remove(mutation);
                    });
                });
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return (0, _toConsumableArray._)((0, _classPrivateFieldGet._)(this, _mutations).values()).flat();
            }
        },
        {
            key: "find",
            value: function find(filters) {
                var defaultedFilters = (0, _objectSpread._)({
                    exact: true
                }, filters);
                return this.getAll().find(function(mutation) {
                    return (0, import_utils.matchMutation)(defaultedFilters, mutation);
                });
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var filters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return this.getAll().filter(function(mutation) {
                    return (0, import_utils.matchMutation)(filters, mutation);
                });
            }
        },
        {
            key: "notify",
            value: function notify(event) {
                var _this = this;
                import_notifyManager.notifyManager.batch(function() {
                    _this.listeners.forEach(function(listener) {
                        listener(event);
                    });
                });
            }
        },
        {
            key: "resumePausedMutations",
            value: function resumePausedMutations() {
                var pausedMutations = this.getAll().filter(function(x) {
                    return x.state.isPaused;
                });
                return import_notifyManager.notifyManager.batch(function() {
                    return Promise.all(pausedMutations.map(function(mutation) {
                        return mutation.continue().catch(import_utils.noop);
                    }));
                });
            }
        }
    ]);
    return _class;
}(import_subscribable.Subscribable));
function scopeFor(mutation) {
    var _mutation_options_scope;
    var _mutation_options_scope_id;
    return (_mutation_options_scope_id = (_mutation_options_scope = mutation.options.scope) === null || _mutation_options_scope === void 0 ? void 0 : _mutation_options_scope.id) !== null && _mutation_options_scope_id !== void 0 ? _mutation_options_scope_id : String(mutation.mutationId);
}
 //# sourceMappingURL=mutationCache.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_class_private_field_update":"lwyyo","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_create_super":"bKhhG","1d9ccdb026bb8269":"8XMRv","b0b8906896671571":"epKwd","a47c932290b0a4e5":"l88Kk","c8f4e6f0d1be196c":"7KUyg"}],"epKwd":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _createSuper = require("@swc/helpers/_/_create_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var _observers, _mutationCache, _retryer, _dispatch, _class;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/mutation.ts
var mutation_exports = {};
__export(mutation_exports, {
    Mutation: function() {
        return Mutation;
    },
    getDefaultState: function() {
        return getDefaultState;
    }
});
module.exports = __toCommonJS(mutation_exports);
var import_notifyManager = require("26c06803b11ee00b");
var import_removable = require("e924d3f28f1690c2");
var import_retryer = require("f9738c556d672a6e");
var Mutation = (_observers = /*#__PURE__*/ new WeakMap(), _mutationCache = /*#__PURE__*/ new WeakMap(), _retryer = /*#__PURE__*/ new WeakMap(), _dispatch = /*#__PURE__*/ new WeakSet(), _class = /*#__PURE__*/ function(_import_removable_Removable) {
    (0, _inherits._)(_class, _import_removable_Removable);
    var _super = (0, _createSuper._)(_class);
    function _class(config) {
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _dispatch);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _observers, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _mutationCache, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _retryer, {
            writable: true,
            value: void 0
        });
        _this.mutationId = config.mutationId;
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _mutationCache, config.mutationCache);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _observers, []);
        _this.state = config.state || getDefaultState();
        _this.setOptions(config.options);
        _this.scheduleGc();
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.updateGcTime(this.options.gcTime);
            }
        },
        {
            key: "meta",
            get: function get() {
                return this.options.meta;
            }
        },
        {
            key: "addObserver",
            value: function addObserver(observer) {
                if (!(0, _classPrivateFieldGet._)(this, _observers).includes(observer)) {
                    (0, _classPrivateFieldGet._)(this, _observers).push(observer);
                    this.clearGcTimeout();
                    (0, _classPrivateFieldGet._)(this, _mutationCache).notify({
                        type: "observerAdded",
                        mutation: this,
                        observer
                    });
                }
            }
        },
        {
            key: "removeObserver",
            value: function removeObserver(observer) {
                (0, _classPrivateFieldSet._)(this, _observers, (0, _classPrivateFieldGet._)(this, _observers).filter(function(x) {
                    return x !== observer;
                }));
                this.scheduleGc();
                (0, _classPrivateFieldGet._)(this, _mutationCache).notify({
                    type: "observerRemoved",
                    mutation: this,
                    observer
                });
            }
        },
        {
            key: "optionalRemove",
            value: function optionalRemove() {
                if (!(0, _classPrivateFieldGet._)(this, _observers).length) {
                    if (this.state.status === "pending") this.scheduleGc();
                    else (0, _classPrivateFieldGet._)(this, _mutationCache).remove(this);
                }
            }
        },
        {
            key: "continue",
            value: function _continue() {
                var _$_class_private_field_get;
                var _class_private_field_get_continue;
                return (_class_private_field_get_continue = (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _retryer)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.continue()) !== null && _class_private_field_get_continue !== void 0 ? _class_private_field_get_continue : // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
                this.execute(this.state.variables);
            }
        },
        {
            key: "execute",
            value: function execute(variables) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var _this_options_retry, restored, isPaused, _class_private_field_get_config_onSuccess, _class_private_field_get_config, _this_options_onSuccess, _this_options, _class_private_field_get_config_onSettled, _class_private_field_get_config1, _this_options_onSettled, _this_options1, _class_private_field_get_config_onMutate, _class_private_field_get_config2, _this_options_onMutate, _this_options2, context, data, error, _class_private_field_get_config_onError, _class_private_field_get_config3, _this_options_onError, _this_options3, _class_private_field_get_config_onSettled1, _class_private_field_get_config4, _this_options_onSettled1, _this_options4;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, _classPrivateFieldSet._)(_this, _retryer, (0, import_retryer.createRetryer)({
                                    fn: function() {
                                        if (!_this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                                        return _this.options.mutationFn(variables);
                                    },
                                    onFail: function(failureCount, error) {
                                        (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                                            type: "failed",
                                            failureCount,
                                            error
                                        });
                                    },
                                    onPause: function() {
                                        (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                                            type: "pause"
                                        });
                                    },
                                    onContinue: function() {
                                        (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                                            type: "continue"
                                        });
                                    },
                                    retry: (_this_options_retry = _this.options.retry) !== null && _this_options_retry !== void 0 ? _this_options_retry : 0,
                                    retryDelay: _this.options.retryDelay,
                                    networkMode: _this.options.networkMode,
                                    canRun: function() {
                                        return (0, _classPrivateFieldGet._)(_this, _mutationCache).canRun(_this);
                                    }
                                }));
                                restored = _this.state.status === "pending";
                                isPaused = !(0, _classPrivateFieldGet._)(_this, _retryer).canStart();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    18,
                                    19
                                ]);
                                if (!!restored) return [
                                    3,
                                    4
                                ];
                                (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                                    type: "pending",
                                    variables,
                                    isPaused
                                });
                                return [
                                    4,
                                    (_class_private_field_get_config_onMutate = (_class_private_field_get_config2 = (0, _classPrivateFieldGet._)(_this, _mutationCache).config).onMutate) === null || _class_private_field_get_config_onMutate === void 0 ? void 0 : _class_private_field_get_config_onMutate.call(_class_private_field_get_config2, variables, _this)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onMutate = (_this_options2 = _this.options).onMutate) === null || _this_options_onMutate === void 0 ? void 0 : _this_options_onMutate.call(_this_options2, variables)
                                ];
                            case 3:
                                context = _state.sent();
                                if (context !== _this.state.context) (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                                    type: "pending",
                                    context,
                                    variables,
                                    isPaused
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    (0, _classPrivateFieldGet._)(_this, _retryer).start()
                                ];
                            case 5:
                                data = _state.sent();
                                return [
                                    4,
                                    (_class_private_field_get_config_onSuccess = (_class_private_field_get_config = (0, _classPrivateFieldGet._)(_this, _mutationCache).config).onSuccess) === null || _class_private_field_get_config_onSuccess === void 0 ? void 0 : _class_private_field_get_config_onSuccess.call(_class_private_field_get_config, data, variables, _this.state.context, _this)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onSuccess = (_this_options = _this.options).onSuccess) === null || _this_options_onSuccess === void 0 ? void 0 : _this_options_onSuccess.call(_this_options, data, variables, _this.state.context)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    (_class_private_field_get_config_onSettled = (_class_private_field_get_config1 = (0, _classPrivateFieldGet._)(_this, _mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled === void 0 ? void 0 : _class_private_field_get_config_onSettled.call(_class_private_field_get_config1, data, null, _this.state.variables, _this.state.context, _this)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onSettled = (_this_options1 = _this.options).onSettled) === null || _this_options_onSettled === void 0 ? void 0 : _this_options_onSettled.call(_this_options1, data, null, variables, _this.state.context)
                                ];
                            case 9:
                                _state.sent();
                                (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                                    type: "success",
                                    data
                                });
                                return [
                                    2,
                                    data
                                ];
                            case 10:
                                error = _state.sent();
                                _state.label = 11;
                            case 11:
                                _state.trys.push([
                                    11,
                                    ,
                                    16,
                                    17
                                ]);
                                return [
                                    4,
                                    (_class_private_field_get_config_onError = (_class_private_field_get_config3 = (0, _classPrivateFieldGet._)(_this, _mutationCache).config).onError) === null || _class_private_field_get_config_onError === void 0 ? void 0 : _class_private_field_get_config_onError.call(_class_private_field_get_config3, error, variables, _this.state.context, _this)
                                ];
                            case 12:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onError = (_this_options3 = _this.options).onError) === null || _this_options_onError === void 0 ? void 0 : _this_options_onError.call(_this_options3, error, variables, _this.state.context)
                                ];
                            case 13:
                                _state.sent();
                                return [
                                    4,
                                    (_class_private_field_get_config_onSettled1 = (_class_private_field_get_config4 = (0, _classPrivateFieldGet._)(_this, _mutationCache).config).onSettled) === null || _class_private_field_get_config_onSettled1 === void 0 ? void 0 : _class_private_field_get_config_onSettled1.call(_class_private_field_get_config4, void 0, error, _this.state.variables, _this.state.context, _this)
                                ];
                            case 14:
                                _state.sent();
                                return [
                                    4,
                                    (_this_options_onSettled1 = (_this_options4 = _this.options).onSettled) === null || _this_options_onSettled1 === void 0 ? void 0 : _this_options_onSettled1.call(_this_options4, void 0, error, variables, _this.state.context)
                                ];
                            case 15:
                                _state.sent();
                                throw error;
                            case 16:
                                (0, _classPrivateMethodGet._)(_this, _dispatch, dispatch).call(_this, {
                                    type: "error",
                                    error
                                });
                                return [
                                    7
                                ];
                            case 17:
                                return [
                                    3,
                                    19
                                ];
                            case 18:
                                (0, _classPrivateFieldGet._)(_this, _mutationCache).runNext(_this);
                                return [
                                    7
                                ];
                            case 19:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return _class;
}(import_removable.Removable), _class);
function getDefaultState() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}
function dispatch(action) {
    var _this = this;
    var reducer = function(state) {
        switch(action.type){
            case "failed":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    failureCount: action.failureCount,
                    failureReason: action.error
                });
            case "pause":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    isPaused: true
                });
            case "continue":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    isPaused: false
                });
            case "pending":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                });
            case "success":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                });
            case "error":
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                });
        }
    };
    this.state = reducer(this.state);
    import_notifyManager.notifyManager.batch(function() {
        (0, _classPrivateFieldGet._)(_this, _observers).forEach(function(observer) {
            observer.onMutationUpdate(action);
        });
        (0, _classPrivateFieldGet._)(_this, _mutationCache).notify({
            mutation: _this,
            type: "updated",
            action
        });
    });
}
 //# sourceMappingURL=mutation.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_class_private_method_get":"4Hn8U","@swc/helpers/_/_class_private_method_init":"6VPza","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_create_super":"bKhhG","@swc/helpers/_/_ts_generator":"dn4mF","26c06803b11ee00b":"8XMRv","e924d3f28f1690c2":"6kG9F","f9738c556d672a6e":"jd4VA"}],"5ezmB":[function(require,module,exports) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/infiniteQueryBehavior.ts
var infiniteQueryBehavior_exports = {};
__export(infiniteQueryBehavior_exports, {
    hasNextPage: function() {
        return hasNextPage;
    },
    hasPreviousPage: function() {
        return hasPreviousPage;
    },
    infiniteQueryBehavior: function() {
        return infiniteQueryBehavior;
    }
});
module.exports = __toCommonJS(infiniteQueryBehavior_exports);
var import_utils = require("9c36ec60f908e484");
function infiniteQueryBehavior(pages) {
    return {
        onFetch: function(context, query) {
            var _context_fetchOptions_meta_fetchMore, _context_fetchOptions_meta, _context_fetchOptions, _context_state_data, _context_state_data1;
            var options = context.options;
            var direction = (_context_fetchOptions = context.fetchOptions) === null || _context_fetchOptions === void 0 ? void 0 : (_context_fetchOptions_meta = _context_fetchOptions.meta) === null || _context_fetchOptions_meta === void 0 ? void 0 : (_context_fetchOptions_meta_fetchMore = _context_fetchOptions_meta.fetchMore) === null || _context_fetchOptions_meta_fetchMore === void 0 ? void 0 : _context_fetchOptions_meta_fetchMore.direction;
            var oldPages = ((_context_state_data = context.state.data) === null || _context_state_data === void 0 ? void 0 : _context_state_data.pages) || [];
            var oldPageParams = ((_context_state_data1 = context.state.data) === null || _context_state_data1 === void 0 ? void 0 : _context_state_data1.pageParams) || [];
            var result = {
                pages: [],
                pageParams: []
            };
            var currentPage = 0;
            var fetchFn = function() {
                var _ref = (0, _asyncToGenerator._)(function() {
                    var cancelled, addSignalProperty, queryFn, fetchPage, previous, pageParamFn, oldData, param, remainingPages, _oldPageParams_, param1;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cancelled = false;
                                addSignalProperty = function(object) {
                                    Object.defineProperty(object, "signal", {
                                        enumerable: true,
                                        get: function() {
                                            if (context.signal.aborted) cancelled = true;
                                            else context.signal.addEventListener("abort", function() {
                                                cancelled = true;
                                            });
                                            return context.signal;
                                        }
                                    });
                                };
                                queryFn = (0, import_utils.ensureQueryFn)(context.options, context.fetchOptions);
                                fetchPage = function() {
                                    var _ref = (0, _asyncToGenerator._)(function(data, param, previous) {
                                        var queryFnContext, page, maxPages, addTo;
                                        return (0, _tsGenerator._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (cancelled) return [
                                                        2,
                                                        Promise.reject()
                                                    ];
                                                    if (param == null && data.pages.length) return [
                                                        2,
                                                        Promise.resolve(data)
                                                    ];
                                                    queryFnContext = {
                                                        queryKey: context.queryKey,
                                                        pageParam: param,
                                                        direction: previous ? "backward" : "forward",
                                                        meta: context.options.meta
                                                    };
                                                    addSignalProperty(queryFnContext);
                                                    return [
                                                        4,
                                                        queryFn(queryFnContext)
                                                    ];
                                                case 1:
                                                    page = _state.sent();
                                                    maxPages = context.options.maxPages;
                                                    addTo = previous ? import_utils.addToStart : import_utils.addToEnd;
                                                    return [
                                                        2,
                                                        {
                                                            pages: addTo(data.pages, page, maxPages),
                                                            pageParams: addTo(data.pageParams, param, maxPages)
                                                        }
                                                    ];
                                            }
                                        });
                                    });
                                    return function fetchPage(data, param, previous) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                if (!(direction && oldPages.length)) return [
                                    3,
                                    2
                                ];
                                previous = direction === "backward";
                                pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
                                oldData = {
                                    pages: oldPages,
                                    pageParams: oldPageParams
                                };
                                param = pageParamFn(options, oldData);
                                return [
                                    4,
                                    fetchPage(oldData, param, previous)
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 2:
                                remainingPages = pages !== null && pages !== void 0 ? pages : oldPages.length;
                                _state.label = 3;
                            case 3:
                                param1 = currentPage === 0 ? (_oldPageParams_ = oldPageParams[0]) !== null && _oldPageParams_ !== void 0 ? _oldPageParams_ : options.initialPageParam : getNextPageParam(options, result);
                                if (currentPage > 0 && param1 == null) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    fetchPage(result, param1)
                                ];
                            case 4:
                                result = _state.sent();
                                currentPage++;
                                _state.label = 5;
                            case 5:
                                if (currentPage < remainingPages) return [
                                    3,
                                    3
                                ];
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                });
                return function fetchFn() {
                    return _ref.apply(this, arguments);
                };
            }();
            if (context.options.persister) context.fetchFn = function() {
                var _context_options_persister, _context_options;
                return (_context_options_persister = (_context_options = context.options).persister) === null || _context_options_persister === void 0 ? void 0 : _context_options_persister.call(_context_options, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function getNextPageParam(options, param) {
    var pages = param.pages, pageParams = param.pageParams;
    var lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function getPreviousPageParam(options, param) {
    var pages = param.pages, pageParams = param.pageParams;
    var _options_getPreviousPageParam;
    return pages.length > 0 ? (_options_getPreviousPageParam = options.getPreviousPageParam) === null || _options_getPreviousPageParam === void 0 ? void 0 : _options_getPreviousPageParam.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function hasNextPage(options, data) {
    if (!data) return false;
    return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return getPreviousPageParam(options, data) != null;
}
 //# sourceMappingURL=infiniteQueryBehavior.cjs.map

},{"@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_ts_generator":"dn4mF","9c36ec60f908e484":"l88Kk"}],"fjAKd":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _createClass = require("@swc/helpers/_/_create_class");
var _extends = require("@swc/helpers/_/_extends");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectDestructuringEmpty = require("@swc/helpers/_/_object_destructuring_empty");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _client, _currentQuery, _currentQueryInitialState, _currentResult, _currentResultState, _currentResultOptions, _currentThenable, _selectError, _selectFn, _selectResult, // This property keeps track of the last query with defined data.
// It will be used to pass the previous data and query to the placeholder function between renders.
_lastQueryWithDefinedData, _staleTimeoutId, _refetchIntervalId, _currentRefetchInterval, _trackedProps, _executeFetch, _updateStaleTimeout, _computeRefetchInterval, _updateRefetchInterval, _updateTimers, _clearStaleTimeout, _clearRefetchInterval, _updateQuery, _notify, _class;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/queryObserver.ts
var queryObserver_exports = {};
__export(queryObserver_exports, {
    QueryObserver: function() {
        return QueryObserver;
    }
});
module.exports = __toCommonJS(queryObserver_exports);
var import_focusManager = require("d4b8cf9c8c55c244");
var import_notifyManager = require("3b9f0b31e9294b0a");
var import_query = require("f9e35a17c3fae06");
var import_subscribable = require("7b3f373498a97e2a");
var import_thenable = require("6c8cc526af16771b");
var import_utils = require("2213e5201117679d");
var /*#__PURE__*/ _tmp;
var QueryObserver = (_client = /*#__PURE__*/ new WeakMap(), _currentQuery = /*#__PURE__*/ new WeakMap(), _currentQueryInitialState = /*#__PURE__*/ new WeakMap(), _currentResult = /*#__PURE__*/ new WeakMap(), _currentResultState = /*#__PURE__*/ new WeakMap(), _currentResultOptions = /*#__PURE__*/ new WeakMap(), _currentThenable = /*#__PURE__*/ new WeakMap(), _selectError = /*#__PURE__*/ new WeakMap(), _selectFn = /*#__PURE__*/ new WeakMap(), _selectResult = /*#__PURE__*/ new WeakMap(), _lastQueryWithDefinedData = /*#__PURE__*/ new WeakMap(), _staleTimeoutId = /*#__PURE__*/ new WeakMap(), _refetchIntervalId = /*#__PURE__*/ new WeakMap(), _currentRefetchInterval = /*#__PURE__*/ new WeakMap(), _trackedProps = /*#__PURE__*/ new WeakMap(), _executeFetch = /*#__PURE__*/ new WeakSet(), _updateStaleTimeout = /*#__PURE__*/ new WeakSet(), _computeRefetchInterval = /*#__PURE__*/ new WeakSet(), _updateRefetchInterval = /*#__PURE__*/ new WeakSet(), _updateTimers = /*#__PURE__*/ new WeakSet(), _clearStaleTimeout = /*#__PURE__*/ new WeakSet(), _clearRefetchInterval = /*#__PURE__*/ new WeakSet(), _updateQuery = /*#__PURE__*/ new WeakSet(), _notify = /*#__PURE__*/ new WeakSet(), _tmp = function(_import_subscribable_Subscribable) {
    (0, _inherits._)(_tmp, _import_subscribable_Subscribable);
    var _super = (0, _createSuper._)(_tmp);
    function _tmp(client, options) {
        (0, _classCallCheck._)(this, _tmp);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _executeFetch);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _updateStaleTimeout);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _computeRefetchInterval);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _updateRefetchInterval);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _updateTimers);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _clearStaleTimeout);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _clearRefetchInterval);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _updateQuery);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _notify);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _client, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentQuery, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentQueryInitialState, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentResult, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentResultState, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentResultOptions, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentThenable, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _selectError, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _selectFn, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _selectResult, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _lastQueryWithDefinedData, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _staleTimeoutId, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _refetchIntervalId, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentRefetchInterval, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _trackedProps, {
            writable: true,
            value: /* @__PURE__ */ new Set()
        });
        _this.options = options;
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _client, client);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _selectError, null);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _currentThenable, (0, import_thenable.pendingThenable)());
        if (!_this.options.experimental_prefetchInRender) (0, _classPrivateFieldGet._)(_this, _currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    (0, _createClass._)(_tmp, [
        {
            key: "bindMethods",
            value: function bindMethods() {
                this.refetch = this.refetch.bind(this);
            }
        },
        {
            key: "onSubscribe",
            value: function onSubscribe() {
                if (this.listeners.size === 1) {
                    (0, _classPrivateFieldGet._)(this, _currentQuery).addObserver(this);
                    if (shouldFetchOnMount((0, _classPrivateFieldGet._)(this, _currentQuery), this.options)) (0, _classPrivateMethodGet._)(this, _executeFetch, executeFetch).call(this);
                    else this.updateResult();
                    (0, _classPrivateMethodGet._)(this, _updateTimers, updateTimers).call(this);
                }
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                if (!this.hasListeners()) this.destroy();
            }
        },
        {
            key: "shouldFetchOnReconnect",
            value: function shouldFetchOnReconnect() {
                return shouldFetchOn((0, _classPrivateFieldGet._)(this, _currentQuery), this.options, this.options.refetchOnReconnect);
            }
        },
        {
            key: "shouldFetchOnWindowFocus",
            value: function shouldFetchOnWindowFocus() {
                return shouldFetchOn((0, _classPrivateFieldGet._)(this, _currentQuery), this.options, this.options.refetchOnWindowFocus);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.listeners = /* @__PURE__ */ new Set();
                (0, _classPrivateMethodGet._)(this, _clearStaleTimeout, clearStaleTimeout).call(this);
                (0, _classPrivateMethodGet._)(this, _clearRefetchInterval, clearRefetchInterval).call(this);
                (0, _classPrivateFieldGet._)(this, _currentQuery).removeObserver(this);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options, notifyOptions) {
                var prevOptions = this.options;
                var prevQuery = (0, _classPrivateFieldGet._)(this, _currentQuery);
                this.options = (0, _classPrivateFieldGet._)(this, _client).defaultQueryOptions(options);
                if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, import_utils.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
                (0, _classPrivateMethodGet._)(this, _updateQuery, updateQuery).call(this);
                (0, _classPrivateFieldGet._)(this, _currentQuery).setOptions(this.options);
                if (prevOptions._defaulted && !(0, import_utils.shallowEqualObjects)(this.options, prevOptions)) (0, _classPrivateFieldGet._)(this, _client).getQueryCache().notify({
                    type: "observerOptionsUpdated",
                    query: (0, _classPrivateFieldGet._)(this, _currentQuery),
                    observer: this
                });
                var mounted = this.hasListeners();
                if (mounted && shouldFetchOptionally((0, _classPrivateFieldGet._)(this, _currentQuery), prevQuery, this.options, prevOptions)) (0, _classPrivateMethodGet._)(this, _executeFetch, executeFetch).call(this);
                this.updateResult(notifyOptions);
                if (mounted && ((0, _classPrivateFieldGet._)(this, _currentQuery) !== prevQuery || (0, import_utils.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== (0, import_utils.resolveEnabled)(prevOptions.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) || (0, import_utils.resolveStaleTime)(this.options.staleTime, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== (0, import_utils.resolveStaleTime)(prevOptions.staleTime, (0, _classPrivateFieldGet._)(this, _currentQuery)))) (0, _classPrivateMethodGet._)(this, _updateStaleTimeout, updateStaleTimeout).call(this);
                var nextRefetchInterval = (0, _classPrivateMethodGet._)(this, _computeRefetchInterval, computeRefetchInterval).call(this);
                if (mounted && ((0, _classPrivateFieldGet._)(this, _currentQuery) !== prevQuery || (0, import_utils.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) !== (0, import_utils.resolveEnabled)(prevOptions.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) || nextRefetchInterval !== (0, _classPrivateFieldGet._)(this, _currentRefetchInterval))) (0, _classPrivateMethodGet._)(this, _updateRefetchInterval, updateRefetchInterval).call(this, nextRefetchInterval);
            }
        },
        {
            key: "getOptimisticResult",
            value: function getOptimisticResult(options) {
                var query = (0, _classPrivateFieldGet._)(this, _client).getQueryCache().build((0, _classPrivateFieldGet._)(this, _client), options);
                var result = this.createResult(query, options);
                if (shouldAssignObserverCurrentProperties(this, result)) {
                    (0, _classPrivateFieldSet._)(this, _currentResult, result);
                    (0, _classPrivateFieldSet._)(this, _currentResultOptions, this.options);
                    (0, _classPrivateFieldSet._)(this, _currentResultState, (0, _classPrivateFieldGet._)(this, _currentQuery).state);
                }
                return result;
            }
        },
        {
            key: "getCurrentResult",
            value: function getCurrentResult() {
                return (0, _classPrivateFieldGet._)(this, _currentResult);
            }
        },
        {
            key: "trackResult",
            value: function trackResult(result, onPropTracked) {
                var _this = this;
                var trackedResult = {};
                Object.keys(result).forEach(function(key) {
                    Object.defineProperty(trackedResult, key, {
                        configurable: false,
                        enumerable: true,
                        get: function() {
                            _this.trackProp(key);
                            onPropTracked === null || onPropTracked === void 0 ? void 0 : onPropTracked(key);
                            return result[key];
                        }
                    });
                });
                return trackedResult;
            }
        },
        {
            key: "trackProp",
            value: function trackProp(key) {
                (0, _classPrivateFieldGet._)(this, _trackedProps).add(key);
            }
        },
        {
            key: "getCurrentQuery",
            value: function getCurrentQuery() {
                return (0, _classPrivateFieldGet._)(this, _currentQuery);
            }
        },
        {
            key: "refetch",
            value: function refetch() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0, _extends._)({}, (0, _objectDestructuringEmpty._)(_param));
                return this.fetch((0, _objectSpread._)({}, options));
            }
        },
        {
            key: "fetchOptimistic",
            value: function fetchOptimistic(options) {
                var _this = this;
                var defaultedOptions = (0, _classPrivateFieldGet._)(this, _client).defaultQueryOptions(options);
                var query = (0, _classPrivateFieldGet._)(this, _client).getQueryCache().build((0, _classPrivateFieldGet._)(this, _client), defaultedOptions);
                return query.fetch().then(function() {
                    return _this.createResult(query, defaultedOptions);
                });
            }
        },
        {
            key: "fetch",
            value: function fetch(fetchOptions) {
                var _this = this;
                var _fetchOptions_cancelRefetch;
                return (0, _classPrivateMethodGet._)(this, _executeFetch, executeFetch).call(this, (0, _objectSpreadProps._)((0, _objectSpread._)({}, fetchOptions), {
                    cancelRefetch: (_fetchOptions_cancelRefetch = fetchOptions.cancelRefetch) !== null && _fetchOptions_cancelRefetch !== void 0 ? _fetchOptions_cancelRefetch : true
                })).then(function() {
                    _this.updateResult();
                    return (0, _classPrivateFieldGet._)(_this, _currentResult);
                });
            }
        },
        {
            key: "createResult",
            value: function createResult(query, options) {
                var _this = this;
                var prevQuery = (0, _classPrivateFieldGet._)(this, _currentQuery);
                var prevOptions = this.options;
                var prevResult = (0, _classPrivateFieldGet._)(this, _currentResult);
                var prevResultState = (0, _classPrivateFieldGet._)(this, _currentResultState);
                var prevResultOptions = (0, _classPrivateFieldGet._)(this, _currentResultOptions);
                var queryChange = query !== prevQuery;
                var queryInitialState = queryChange ? query.state : (0, _classPrivateFieldGet._)(this, _currentQueryInitialState);
                var state = query.state;
                var newState = (0, _objectSpread._)({}, state);
                var isPlaceholderData = false;
                var data;
                if (options._optimisticResults) {
                    var mounted = this.hasListeners();
                    var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
                    var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
                    if (fetchOnMount || fetchOptionally) newState = (0, _objectSpread._)({}, newState, (0, import_query.fetchState)(state.data, query.options));
                    if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
                }
                var error = newState.error, errorUpdatedAt = newState.errorUpdatedAt, status = newState.status;
                if (options.select && newState.data !== void 0) {
                    if (prevResult && newState.data === (prevResultState === null || prevResultState === void 0 ? void 0 : prevResultState.data) && options.select === (0, _classPrivateFieldGet._)(this, _selectFn)) data = (0, _classPrivateFieldGet._)(this, _selectResult);
                    else try {
                        (0, _classPrivateFieldSet._)(this, _selectFn, options.select);
                        data = options.select(newState.data);
                        data = (0, import_utils.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, data, options);
                        (0, _classPrivateFieldSet._)(this, _selectResult, data);
                        (0, _classPrivateFieldSet._)(this, _selectError, null);
                    } catch (selectError) {
                        (0, _classPrivateFieldSet._)(this, _selectError, selectError);
                    }
                } else data = newState.data;
                if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
                    var placeholderData;
                    if ((prevResult === null || prevResult === void 0 ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions === null || prevResultOptions === void 0 ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
                    else {
                        var _$_class_private_field_get;
                        placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _lastQueryWithDefinedData)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.state.data, (0, _classPrivateFieldGet._)(this, _lastQueryWithDefinedData)) : options.placeholderData;
                        if (options.select && placeholderData !== void 0) try {
                            placeholderData = options.select(placeholderData);
                            (0, _classPrivateFieldSet._)(this, _selectError, null);
                        } catch (selectError) {
                            (0, _classPrivateFieldSet._)(this, _selectError, selectError);
                        }
                    }
                    if (placeholderData !== void 0) {
                        status = "success";
                        data = (0, import_utils.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, placeholderData, options);
                        isPlaceholderData = true;
                    }
                }
                if ((0, _classPrivateFieldGet._)(this, _selectError)) {
                    error = (0, _classPrivateFieldGet._)(this, _selectError);
                    data = (0, _classPrivateFieldGet._)(this, _selectResult);
                    errorUpdatedAt = Date.now();
                    status = "error";
                }
                var isFetching = newState.fetchStatus === "fetching";
                var isPending = status === "pending";
                var isError = status === "error";
                var isLoading = isPending && isFetching;
                var hasData = data !== void 0;
                var result = {
                    status,
                    fetchStatus: newState.fetchStatus,
                    isPending,
                    isSuccess: status === "success",
                    isError,
                    isInitialLoading: isLoading,
                    isLoading,
                    data,
                    dataUpdatedAt: newState.dataUpdatedAt,
                    error,
                    errorUpdatedAt,
                    failureCount: newState.fetchFailureCount,
                    failureReason: newState.fetchFailureReason,
                    errorUpdateCount: newState.errorUpdateCount,
                    isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
                    isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
                    isFetching,
                    isRefetching: isFetching && !isPending,
                    isLoadingError: isError && !hasData,
                    isPaused: newState.fetchStatus === "paused",
                    isPlaceholderData,
                    isRefetchError: isError && hasData,
                    isStale: isStale(query, options),
                    refetch: this.refetch,
                    promise: (0, _classPrivateFieldGet._)(this, _currentThenable)
                };
                var nextResult = result;
                if (this.options.experimental_prefetchInRender) {
                    var finalizeThenableIfPossible = function(thenable) {
                        if (nextResult.status === "error") thenable.reject(nextResult.error);
                        else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
                    };
                    var recreateThenable = function() {
                        var pending = (0, _classPrivateFieldSet._)(_this, _currentThenable, nextResult.promise = (0, import_thenable.pendingThenable)());
                        finalizeThenableIfPossible(pending);
                    };
                    var prevThenable = (0, _classPrivateFieldGet._)(this, _currentThenable);
                    switch(prevThenable.status){
                        case "pending":
                            if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                            break;
                        case "fulfilled":
                            if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                            break;
                        case "rejected":
                            if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                            break;
                    }
                }
                return nextResult;
            }
        },
        {
            key: "updateResult",
            value: function updateResult(notifyOptions) {
                var _this = this;
                var prevResult = (0, _classPrivateFieldGet._)(this, _currentResult);
                var nextResult = this.createResult((0, _classPrivateFieldGet._)(this, _currentQuery), this.options);
                (0, _classPrivateFieldSet._)(this, _currentResultState, (0, _classPrivateFieldGet._)(this, _currentQuery).state);
                (0, _classPrivateFieldSet._)(this, _currentResultOptions, this.options);
                if ((0, _classPrivateFieldGet._)(this, _currentResultState).data !== void 0) (0, _classPrivateFieldSet._)(this, _lastQueryWithDefinedData, (0, _classPrivateFieldGet._)(this, _currentQuery));
                if ((0, import_utils.shallowEqualObjects)(nextResult, prevResult)) return;
                (0, _classPrivateFieldSet._)(this, _currentResult, nextResult);
                var defaultNotifyOptions = {};
                var shouldNotifyListeners = function() {
                    if (!prevResult) return true;
                    var notifyOnChangeProps = _this.options.notifyOnChangeProps;
                    var notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
                    if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, _classPrivateFieldGet._)(_this, _trackedProps).size) return true;
                    var includedProps = new Set(notifyOnChangePropsValue !== null && notifyOnChangePropsValue !== void 0 ? notifyOnChangePropsValue : (0, _classPrivateFieldGet._)(_this, _trackedProps));
                    if (_this.options.throwOnError) includedProps.add("error");
                    return Object.keys((0, _classPrivateFieldGet._)(_this, _currentResult)).some(function(key) {
                        var typedKey = key;
                        var changed = (0, _classPrivateFieldGet._)(_this, _currentResult)[typedKey] !== prevResult[typedKey];
                        return changed && includedProps.has(typedKey);
                    });
                };
                if ((notifyOptions === null || notifyOptions === void 0 ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
                (0, _classPrivateMethodGet._)(this, _notify, notify).call(this, (0, _objectSpread._)({}, defaultNotifyOptions, notifyOptions));
            }
        },
        {
            key: "onQueryUpdate",
            value: function onQueryUpdate() {
                this.updateResult();
                if (this.hasListeners()) (0, _classPrivateMethodGet._)(this, _updateTimers, updateTimers).call(this);
            }
        }
    ]);
    return _tmp;
}(import_subscribable.Subscribable), _class = _tmp, _tmp, _class);
function shouldLoadOnMount(query, options) {
    return (0, import_utils.resolveEnabled)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if ((0, import_utils.resolveEnabled)(options.enabled, query) !== false) {
        var value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, import_utils.resolveEnabled)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return (0, import_utils.resolveEnabled)(options.enabled, query) !== false && query.isStaleByTime((0, import_utils.resolveStaleTime)(options.staleTime, query));
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, import_utils.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}
function executeFetch(fetchOptions) {
    (0, _classPrivateMethodGet._)(this, _updateQuery, updateQuery).call(this);
    var promise = (0, _classPrivateFieldGet._)(this, _currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.throwOnError)) promise = promise.catch(import_utils.noop);
    return promise;
}
function updateStaleTimeout() {
    var _this = this;
    (0, _classPrivateMethodGet._)(this, _clearStaleTimeout, clearStaleTimeout).call(this);
    var staleTime = (0, import_utils.resolveStaleTime)(this.options.staleTime, (0, _classPrivateFieldGet._)(this, _currentQuery));
    if (import_utils.isServer || (0, _classPrivateFieldGet._)(this, _currentResult).isStale || !(0, import_utils.isValidTimeout)(staleTime)) return;
    var time = (0, import_utils.timeUntilStale)((0, _classPrivateFieldGet._)(this, _currentResult).dataUpdatedAt, staleTime);
    var timeout = time + 1;
    (0, _classPrivateFieldSet._)(this, _staleTimeoutId, setTimeout(function() {
        if (!(0, _classPrivateFieldGet._)(_this, _currentResult).isStale) _this.updateResult();
    }, timeout));
}
function computeRefetchInterval() {
    var _ref;
    return (_ref = typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, _classPrivateFieldGet._)(this, _currentQuery)) : this.options.refetchInterval) !== null && _ref !== void 0 ? _ref : false;
}
function updateRefetchInterval(nextInterval) {
    var _this = this;
    (0, _classPrivateMethodGet._)(this, _clearRefetchInterval, clearRefetchInterval).call(this);
    (0, _classPrivateFieldSet._)(this, _currentRefetchInterval, nextInterval);
    if (import_utils.isServer || (0, import_utils.resolveEnabled)(this.options.enabled, (0, _classPrivateFieldGet._)(this, _currentQuery)) === false || !(0, import_utils.isValidTimeout)((0, _classPrivateFieldGet._)(this, _currentRefetchInterval)) || (0, _classPrivateFieldGet._)(this, _currentRefetchInterval) === 0) return;
    (0, _classPrivateFieldSet._)(this, _refetchIntervalId, setInterval(function() {
        if (_this.options.refetchIntervalInBackground || import_focusManager.focusManager.isFocused()) (0, _classPrivateMethodGet._)(_this, _executeFetch, executeFetch).call(_this);
    }, (0, _classPrivateFieldGet._)(this, _currentRefetchInterval)));
}
function updateTimers() {
    (0, _classPrivateMethodGet._)(this, _updateStaleTimeout, updateStaleTimeout).call(this);
    (0, _classPrivateMethodGet._)(this, _updateRefetchInterval, updateRefetchInterval).call(this, (0, _classPrivateMethodGet._)(this, _computeRefetchInterval, computeRefetchInterval).call(this));
}
function clearStaleTimeout() {
    if ((0, _classPrivateFieldGet._)(this, _staleTimeoutId)) {
        clearTimeout((0, _classPrivateFieldGet._)(this, _staleTimeoutId));
        (0, _classPrivateFieldSet._)(this, _staleTimeoutId, void 0);
    }
}
function clearRefetchInterval() {
    if ((0, _classPrivateFieldGet._)(this, _refetchIntervalId)) {
        clearInterval((0, _classPrivateFieldGet._)(this, _refetchIntervalId));
        (0, _classPrivateFieldSet._)(this, _refetchIntervalId, void 0);
    }
}
function updateQuery() {
    var query = (0, _classPrivateFieldGet._)(this, _client).getQueryCache().build((0, _classPrivateFieldGet._)(this, _client), this.options);
    if (query === (0, _classPrivateFieldGet._)(this, _currentQuery)) return;
    var prevQuery = (0, _classPrivateFieldGet._)(this, _currentQuery);
    (0, _classPrivateFieldSet._)(this, _currentQuery, query);
    (0, _classPrivateFieldSet._)(this, _currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery === null || prevQuery === void 0 ? void 0 : prevQuery.removeObserver(this);
        query.addObserver(this);
    }
}
function notify(notifyOptions) {
    var _this = this;
    import_notifyManager.notifyManager.batch(function() {
        if (notifyOptions.listeners) _this.listeners.forEach(function(listener) {
            listener((0, _classPrivateFieldGet._)(_this, _currentResult));
        });
        (0, _classPrivateFieldGet._)(_this, _client).getQueryCache().notify({
            query: (0, _classPrivateFieldGet._)(_this, _currentQuery),
            type: "observerResultsUpdated"
        });
    });
}
 //# sourceMappingURL=queryObserver.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_class_private_method_get":"4Hn8U","@swc/helpers/_/_class_private_method_init":"6VPza","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_extends":"b7eBA","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_object_destructuring_empty":"kpQ9e","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_create_super":"bKhhG","d4b8cf9c8c55c244":"lQPnM","3b9f0b31e9294b0a":"8XMRv","f9e35a17c3fae06":"rzJvy","7b3f373498a97e2a":"7KUyg","6c8cc526af16771b":"i6xjv","2213e5201117679d":"l88Kk"}],"b7eBA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _extends;
});
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"kpQ9e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_destructuring_empty;
});
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"iYi15":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _client, _result, _queries, _options, _observers, _combinedResult, _lastCombine, _lastResult, _trackResult, _combineResult, _findMatchingObservers, _onUpdate, _notify, _class;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/queriesObserver.ts
var queriesObserver_exports = {};
__export(queriesObserver_exports, {
    QueriesObserver: function() {
        return QueriesObserver;
    }
});
module.exports = __toCommonJS(queriesObserver_exports);
var import_notifyManager = require("8d6f5572b60f2f67");
var import_queryObserver = require("f4fc9e7484797dbc");
var import_subscribable = require("98d6764ae0e9be9c");
var import_utils = require("830592695b598ac9");
function difference(array1, array2) {
    return array1.filter(function(x) {
        return !array2.includes(x);
    });
}
function replaceAt(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
var QueriesObserver = (_client = /*#__PURE__*/ new WeakMap(), _result = /*#__PURE__*/ new WeakMap(), _queries = /*#__PURE__*/ new WeakMap(), _options = /*#__PURE__*/ new WeakMap(), _observers = /*#__PURE__*/ new WeakMap(), _combinedResult = /*#__PURE__*/ new WeakMap(), _lastCombine = /*#__PURE__*/ new WeakMap(), _lastResult = /*#__PURE__*/ new WeakMap(), _trackResult = /*#__PURE__*/ new WeakSet(), _combineResult = /*#__PURE__*/ new WeakSet(), _findMatchingObservers = /*#__PURE__*/ new WeakSet(), _onUpdate = /*#__PURE__*/ new WeakSet(), _notify = /*#__PURE__*/ new WeakSet(), _class = /*#__PURE__*/ function(_import_subscribable_Subscribable) {
    (0, _inherits._)(_class, _import_subscribable_Subscribable);
    var _super = (0, _createSuper._)(_class);
    function _class(client, queries, options) {
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _trackResult);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _combineResult);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _findMatchingObservers);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _onUpdate);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _notify);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _client, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _result, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _queries, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _options, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _observers, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _combinedResult, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _lastCombine, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _lastResult, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _client, client);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _options, options);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _queries, []);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _observers, []);
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _result, []);
        _this.setQueries(queries);
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "onSubscribe",
            value: function onSubscribe() {
                var _this = this;
                if (this.listeners.size === 1) (0, _classPrivateFieldGet._)(this, _observers).forEach(function(observer) {
                    observer.subscribe(function(result) {
                        (0, _classPrivateMethodGet._)(_this, _onUpdate, onUpdate).call(_this, observer, result);
                    });
                });
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                if (!this.listeners.size) this.destroy();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.listeners = /* @__PURE__ */ new Set();
                (0, _classPrivateFieldGet._)(this, _observers).forEach(function(observer) {
                    observer.destroy();
                });
            }
        },
        {
            key: "setQueries",
            value: function setQueries(queries, options, notifyOptions) {
                var _this = this;
                (0, _classPrivateFieldSet._)(this, _queries, queries);
                (0, _classPrivateFieldSet._)(this, _options, options);
                import_notifyManager.notifyManager.batch(function() {
                    var prevObservers = (0, _classPrivateFieldGet._)(_this, _observers);
                    var newObserverMatches = (0, _classPrivateMethodGet._)(_this, _findMatchingObservers, findMatchingObservers).call(_this, (0, _classPrivateFieldGet._)(_this, _queries));
                    newObserverMatches.forEach(function(match) {
                        return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
                    });
                    var newObservers = newObserverMatches.map(function(match) {
                        return match.observer;
                    });
                    var newResult = newObservers.map(function(observer) {
                        return observer.getCurrentResult();
                    });
                    var hasIndexChange = newObservers.some(function(observer, index) {
                        return observer !== prevObservers[index];
                    });
                    if (prevObservers.length === newObservers.length && !hasIndexChange) return;
                    (0, _classPrivateFieldSet._)(_this, _observers, newObservers);
                    (0, _classPrivateFieldSet._)(_this, _result, newResult);
                    if (!_this.hasListeners()) return;
                    difference(prevObservers, newObservers).forEach(function(observer) {
                        observer.destroy();
                    });
                    difference(newObservers, prevObservers).forEach(function(observer) {
                        observer.subscribe(function(result) {
                            (0, _classPrivateMethodGet._)(_this, _onUpdate, onUpdate).call(_this, observer, result);
                        });
                    });
                    (0, _classPrivateMethodGet._)(_this, _notify, notify).call(_this);
                });
            }
        },
        {
            key: "getCurrentResult",
            value: function getCurrentResult() {
                return (0, _classPrivateFieldGet._)(this, _result);
            }
        },
        {
            key: "getQueries",
            value: function getQueries() {
                return (0, _classPrivateFieldGet._)(this, _observers).map(function(observer) {
                    return observer.getCurrentQuery();
                });
            }
        },
        {
            key: "getObservers",
            value: function getObservers() {
                return (0, _classPrivateFieldGet._)(this, _observers);
            }
        },
        {
            key: "getOptimisticResult",
            value: function getOptimisticResult(queries, combine) {
                var _this = this;
                var matches = (0, _classPrivateMethodGet._)(this, _findMatchingObservers, findMatchingObservers).call(this, queries);
                var result = matches.map(function(match) {
                    return match.observer.getOptimisticResult(match.defaultedQueryOptions);
                });
                return [
                    result,
                    function(r) {
                        return (0, _classPrivateMethodGet._)(_this, _combineResult, combineResult).call(_this, r !== null && r !== void 0 ? r : result, combine);
                    },
                    function() {
                        return (0, _classPrivateMethodGet._)(_this, _trackResult, trackResult).call(_this, result, queries);
                    }
                ];
            }
        }
    ]);
    return _class;
}(import_subscribable.Subscribable), _class);
function trackResult(result, queries) {
    var matches = (0, _classPrivateMethodGet._)(this, _findMatchingObservers, findMatchingObservers).call(this, queries);
    return matches.map(function(match, index) {
        var observerResult = result[index];
        return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, function(accessedProp) {
            matches.forEach(function(m) {
                m.observer.trackProp(accessedProp);
            });
        }) : observerResult;
    });
}
function combineResult(input, combine) {
    if (combine) {
        if (!(0, _classPrivateFieldGet._)(this, _combinedResult) || (0, _classPrivateFieldGet._)(this, _result) !== (0, _classPrivateFieldGet._)(this, _lastResult) || combine !== (0, _classPrivateFieldGet._)(this, _lastCombine)) {
            (0, _classPrivateFieldSet._)(this, _lastCombine, combine);
            (0, _classPrivateFieldSet._)(this, _lastResult, (0, _classPrivateFieldGet._)(this, _result));
            (0, _classPrivateFieldSet._)(this, _combinedResult, (0, import_utils.replaceEqualDeep)((0, _classPrivateFieldGet._)(this, _combinedResult), combine(input)));
        }
        return (0, _classPrivateFieldGet._)(this, _combinedResult);
    }
    return input;
}
function findMatchingObservers(queries) {
    var _this = this;
    var prevObserversMap = new Map((0, _classPrivateFieldGet._)(this, _observers).map(function(observer) {
        return [
            observer.options.queryHash,
            observer
        ];
    }));
    var observers = [];
    queries.forEach(function(options) {
        var defaultedOptions = (0, _classPrivateFieldGet._)(_this, _client).defaultQueryOptions(options);
        var match = prevObserversMap.get(defaultedOptions.queryHash);
        if (match) observers.push({
            defaultedQueryOptions: defaultedOptions,
            observer: match
        });
        else observers.push({
            defaultedQueryOptions: defaultedOptions,
            observer: new import_queryObserver.QueryObserver((0, _classPrivateFieldGet._)(_this, _client), defaultedOptions)
        });
    });
    return observers;
}
function onUpdate(observer, result) {
    var index = (0, _classPrivateFieldGet._)(this, _observers).indexOf(observer);
    if (index !== -1) {
        (0, _classPrivateFieldSet._)(this, _result, replaceAt((0, _classPrivateFieldGet._)(this, _result), index, result));
        (0, _classPrivateMethodGet._)(this, _notify, notify).call(this);
    }
}
function notify() {
    var _this = this;
    if (this.hasListeners()) {
        var _$_class_private_field_get;
        var previousResult = (0, _classPrivateFieldGet._)(this, _combinedResult);
        var newResult = (0, _classPrivateMethodGet._)(this, _combineResult, combineResult).call(this, (0, _classPrivateMethodGet._)(this, _trackResult, trackResult).call(this, (0, _classPrivateFieldGet._)(this, _result), (0, _classPrivateFieldGet._)(this, _queries)), (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _options)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.combine);
        if (previousResult !== newResult) import_notifyManager.notifyManager.batch(function() {
            _this.listeners.forEach(function(listener) {
                listener((0, _classPrivateFieldGet._)(_this, _result));
            });
        });
    }
}
 //# sourceMappingURL=queriesObserver.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_class_private_method_get":"4Hn8U","@swc/helpers/_/_class_private_method_init":"6VPza","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_create_super":"bKhhG","8d6f5572b60f2f67":"8XMRv","f4fc9e7484797dbc":"fjAKd","98d6764ae0e9be9c":"7KUyg","830592695b598ac9":"l88Kk"}],"hgnQW":[function(require,module,exports) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/infiniteQueryObserver.ts
var infiniteQueryObserver_exports = {};
__export(infiniteQueryObserver_exports, {
    InfiniteQueryObserver: function() {
        return InfiniteQueryObserver;
    }
});
module.exports = __toCommonJS(infiniteQueryObserver_exports);
var import_queryObserver = require("f6b201f392eafd65");
var import_infiniteQueryBehavior = require("f946613059f4350d");
var InfiniteQueryObserver = /*#__PURE__*/ function(_import_queryObserver_QueryObserver) {
    (0, _inherits._)(InfiniteQueryObserver, _import_queryObserver_QueryObserver);
    var _super = (0, _createSuper._)(InfiniteQueryObserver);
    function InfiniteQueryObserver(client, options) {
        (0, _classCallCheck._)(this, InfiniteQueryObserver);
        return _super.call(this, client, options);
    }
    (0, _createClass._)(InfiniteQueryObserver, [
        {
            key: "bindMethods",
            value: function bindMethods() {
                (0, _get._)((0, _getPrototypeOf._)(InfiniteQueryObserver.prototype), "bindMethods", this).call(this);
                this.fetchNextPage = this.fetchNextPage.bind(this);
                this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options, notifyOptions) {
                (0, _get._)((0, _getPrototypeOf._)(InfiniteQueryObserver.prototype), "setOptions", this).call(this, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    behavior: (0, import_infiniteQueryBehavior.infiniteQueryBehavior)()
                }), notifyOptions);
            }
        },
        {
            key: "getOptimisticResult",
            value: function getOptimisticResult(options) {
                options.behavior = (0, import_infiniteQueryBehavior.infiniteQueryBehavior)();
                return (0, _get._)((0, _getPrototypeOf._)(InfiniteQueryObserver.prototype), "getOptimisticResult", this).call(this, options);
            }
        },
        {
            key: "fetchNextPage",
            value: function fetchNextPage(options) {
                return this.fetch((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    meta: {
                        fetchMore: {
                            direction: "forward"
                        }
                    }
                }));
            }
        },
        {
            key: "fetchPreviousPage",
            value: function fetchPreviousPage(options) {
                return this.fetch((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    meta: {
                        fetchMore: {
                            direction: "backward"
                        }
                    }
                }));
            }
        },
        {
            key: "createResult",
            value: function createResult(query, options) {
                var _state_fetchMeta_fetchMore, _state_fetchMeta;
                var state = query.state;
                var parentResult = (0, _get._)((0, _getPrototypeOf._)(InfiniteQueryObserver.prototype), "createResult", this).call(this, query, options);
                var isFetching = parentResult.isFetching, isRefetching = parentResult.isRefetching, isError = parentResult.isError, isRefetchError = parentResult.isRefetchError;
                var fetchDirection = (_state_fetchMeta = state.fetchMeta) === null || _state_fetchMeta === void 0 ? void 0 : (_state_fetchMeta_fetchMore = _state_fetchMeta.fetchMore) === null || _state_fetchMeta_fetchMore === void 0 ? void 0 : _state_fetchMeta_fetchMore.direction;
                var isFetchNextPageError = isError && fetchDirection === "forward";
                var isFetchingNextPage = isFetching && fetchDirection === "forward";
                var isFetchPreviousPageError = isError && fetchDirection === "backward";
                var isFetchingPreviousPage = isFetching && fetchDirection === "backward";
                var result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, parentResult), {
                    fetchNextPage: this.fetchNextPage,
                    fetchPreviousPage: this.fetchPreviousPage,
                    hasNextPage: (0, import_infiniteQueryBehavior.hasNextPage)(options, state.data),
                    hasPreviousPage: (0, import_infiniteQueryBehavior.hasPreviousPage)(options, state.data),
                    isFetchNextPageError,
                    isFetchingNextPage,
                    isFetchPreviousPageError,
                    isFetchingPreviousPage,
                    isRefetchError: isRefetchError && !isFetchNextPageError && !isFetchPreviousPageError,
                    isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
                });
                return result;
            }
        }
    ]);
    return InfiniteQueryObserver;
}(import_queryObserver.QueryObserver);
 //# sourceMappingURL=infiniteQueryObserver.cjs.map

},{"@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_get":"4WRMN","@swc/helpers/_/_get_prototype_of":"5LWub","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_create_super":"bKhhG","f6b201f392eafd65":"fjAKd","f946613059f4350d":"5ezmB"}],"cyFAs":[function(require,module,exports) {
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _classPrivateMethodGet = require("@swc/helpers/_/_class_private_method_get");
var _classPrivateMethodInit = require("@swc/helpers/_/_class_private_method_init");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _createSuper = require("@swc/helpers/_/_create_super");
"use strict";
var _client, _currentResult, _currentMutation, _mutateOptions, _updateResult, _notify, _class;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/mutationObserver.ts
var mutationObserver_exports = {};
__export(mutationObserver_exports, {
    MutationObserver: function() {
        return MutationObserver;
    }
});
module.exports = __toCommonJS(mutationObserver_exports);
var import_mutation = require("74ddeffc80256a45");
var import_notifyManager = require("9572e8974ce66827");
var import_subscribable = require("5cd8f587ebcc310");
var import_utils = require("c785a844bcd9de64");
var MutationObserver = (_client = /*#__PURE__*/ new WeakMap(), _currentResult = /*#__PURE__*/ new WeakMap(), _currentMutation = /*#__PURE__*/ new WeakMap(), _mutateOptions = /*#__PURE__*/ new WeakMap(), _updateResult = /*#__PURE__*/ new WeakSet(), _notify = /*#__PURE__*/ new WeakSet(), _class = /*#__PURE__*/ function(_import_subscribable_Subscribable) {
    (0, _inherits._)(_class, _import_subscribable_Subscribable);
    var _super = (0, _createSuper._)(_class);
    function _class(client, options) {
        (0, _classCallCheck._)(this, _class);
        var _this;
        _this = _super.call(this);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _updateResult);
        (0, _classPrivateMethodInit._)((0, _assertThisInitialized._)(_this), _notify);
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _client, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentResult, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _currentMutation, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldInit._)((0, _assertThisInitialized._)(_this), _mutateOptions, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)((0, _assertThisInitialized._)(_this), _client, client);
        _this.setOptions(options);
        _this.bindMethods();
        (0, _classPrivateMethodGet._)(_this, _updateResult, updateResult).call((0, _assertThisInitialized._)(_this));
        return _this;
    }
    (0, _createClass._)(_class, [
        {
            key: "bindMethods",
            value: function bindMethods() {
                this.mutate = this.mutate.bind(this);
                this.reset = this.reset.bind(this);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _$_class_private_field_get;
                var prevOptions = this.options;
                this.options = (0, _classPrivateFieldGet._)(this, _client).defaultMutationOptions(options);
                if (!(0, import_utils.shallowEqualObjects)(this.options, prevOptions)) (0, _classPrivateFieldGet._)(this, _client).getMutationCache().notify({
                    type: "observerOptionsUpdated",
                    mutation: (0, _classPrivateFieldGet._)(this, _currentMutation),
                    observer: this
                });
                if ((prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, import_utils.hashKey)(prevOptions.mutationKey) !== (0, import_utils.hashKey)(this.options.mutationKey)) this.reset();
                else if (((_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.state.status) === "pending") (0, _classPrivateFieldGet._)(this, _currentMutation).setOptions(this.options);
            }
        },
        {
            key: "onUnsubscribe",
            value: function onUnsubscribe() {
                var _$_class_private_field_get;
                if (!this.hasListeners()) (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removeObserver(this);
            }
        },
        {
            key: "onMutationUpdate",
            value: function onMutationUpdate(action) {
                (0, _classPrivateMethodGet._)(this, _updateResult, updateResult).call(this);
                (0, _classPrivateMethodGet._)(this, _notify, notify).call(this, action);
            }
        },
        {
            key: "getCurrentResult",
            value: function getCurrentResult() {
                return (0, _classPrivateFieldGet._)(this, _currentResult);
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _$_class_private_field_get;
                (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removeObserver(this);
                (0, _classPrivateFieldSet._)(this, _currentMutation, void 0);
                (0, _classPrivateMethodGet._)(this, _updateResult, updateResult).call(this);
                (0, _classPrivateMethodGet._)(this, _notify, notify).call(this);
            }
        },
        {
            key: "mutate",
            value: function mutate(variables, options) {
                var _$_class_private_field_get;
                (0, _classPrivateFieldSet._)(this, _mutateOptions, options);
                (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.removeObserver(this);
                (0, _classPrivateFieldSet._)(this, _currentMutation, (0, _classPrivateFieldGet._)(this, _client).getMutationCache().build((0, _classPrivateFieldGet._)(this, _client), this.options));
                (0, _classPrivateFieldGet._)(this, _currentMutation).addObserver(this);
                return (0, _classPrivateFieldGet._)(this, _currentMutation).execute(variables);
            }
        }
    ]);
    return _class;
}(import_subscribable.Subscribable), _class);
function updateResult() {
    var _$_class_private_field_get;
    var _class_private_field_get_state;
    var state = (_class_private_field_get_state = (_$_class_private_field_get = (0, _classPrivateFieldGet._)(this, _currentMutation)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.state) !== null && _class_private_field_get_state !== void 0 ? _class_private_field_get_state : (0, import_mutation.getDefaultState)();
    (0, _classPrivateFieldSet._)(this, _currentResult, (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    }));
}
function notify(action) {
    var _this = this;
    import_notifyManager.notifyManager.batch(function() {
        if ((0, _classPrivateFieldGet._)(_this, _mutateOptions) && _this.hasListeners()) {
            var variables = (0, _classPrivateFieldGet._)(_this, _currentResult).variables;
            var context = (0, _classPrivateFieldGet._)(_this, _currentResult).context;
            if ((action === null || action === void 0 ? void 0 : action.type) === "success") {
                var _class_private_field_get_onSuccess, _$_class_private_field_get, _class_private_field_get_onSettled, _$_class_private_field_get1;
                (_class_private_field_get_onSuccess = (_$_class_private_field_get = (0, _classPrivateFieldGet._)(_this, _mutateOptions)).onSuccess) === null || _class_private_field_get_onSuccess === void 0 ? void 0 : _class_private_field_get_onSuccess.call(_$_class_private_field_get, action.data, variables, context);
                (_class_private_field_get_onSettled = (_$_class_private_field_get1 = (0, _classPrivateFieldGet._)(_this, _mutateOptions)).onSettled) === null || _class_private_field_get_onSettled === void 0 ? void 0 : _class_private_field_get_onSettled.call(_$_class_private_field_get1, action.data, null, variables, context);
            } else if ((action === null || action === void 0 ? void 0 : action.type) === "error") {
                var _class_private_field_get_onError, _$_class_private_field_get2, _class_private_field_get_onSettled1, _$_class_private_field_get3;
                (_class_private_field_get_onError = (_$_class_private_field_get2 = (0, _classPrivateFieldGet._)(_this, _mutateOptions)).onError) === null || _class_private_field_get_onError === void 0 ? void 0 : _class_private_field_get_onError.call(_$_class_private_field_get2, action.error, variables, context);
                (_class_private_field_get_onSettled1 = (_$_class_private_field_get3 = (0, _classPrivateFieldGet._)(_this, _mutateOptions)).onSettled) === null || _class_private_field_get_onSettled1 === void 0 ? void 0 : _class_private_field_get_onSettled1.call(_$_class_private_field_get3, void 0, action.error, variables, context);
            }
        }
        _this.listeners.forEach(function(listener) {
            listener((0, _classPrivateFieldGet._)(_this, _currentResult));
        });
    });
}
 //# sourceMappingURL=mutationObserver.cjs.map

},{"@swc/helpers/_/_assert_this_initialized":"8cJza","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_class_private_field_get":"bkykZ","@swc/helpers/_/_class_private_field_init":"5Ktvm","@swc/helpers/_/_class_private_field_set":"eupaj","@swc/helpers/_/_class_private_method_get":"4Hn8U","@swc/helpers/_/_class_private_method_init":"6VPza","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_create_super":"bKhhG","74ddeffc80256a45":"epKwd","9572e8974ce66827":"8XMRv","5cd8f587ebcc310":"7KUyg","c785a844bcd9de64":"l88Kk"}],"evsVe":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/hydration.ts
var hydration_exports = {};
__export(hydration_exports, {
    defaultShouldDehydrateMutation: function() {
        return defaultShouldDehydrateMutation;
    },
    defaultShouldDehydrateQuery: function() {
        return defaultShouldDehydrateQuery;
    },
    dehydrate: function() {
        return dehydrate;
    },
    hydrate: function() {
        return hydrate;
    }
});
module.exports = __toCommonJS(hydration_exports);
function defaultTransformerFn(data) {
    return data;
}
function dehydrateMutation(mutation) {
    return (0, _objectSpread._)({
        mutationKey: mutation.options.mutationKey,
        state: mutation.state
    }, mutation.options.scope && {
        scope: mutation.options.scope
    }, mutation.meta && {
        meta: mutation.meta
    });
}
function dehydrateQuery(query, serializeData) {
    var _query_promise;
    return (0, _objectSpread._)({
        state: (0, _objectSpread._)({}, query.state, query.state.data !== void 0 && {
            data: serializeData(query.state.data)
        }),
        queryKey: query.queryKey,
        queryHash: query.queryHash
    }, query.state.status === "pending" && {
        promise: (_query_promise = query.promise) === null || _query_promise === void 0 ? void 0 : _query_promise.then(serializeData).catch(function(error) {
            if ("production" !== "production") console.error(`A query that was dehydrated as pending ended up rejecting. [${query.queryHash}]: ${error}; The error will be redacted in production builds`);
            return Promise.reject(new Error("redacted"));
        })
    }, query.meta && {
        meta: query.meta
    });
}
function defaultShouldDehydrateMutation(mutation) {
    return mutation.state.isPaused;
}
function defaultShouldDehydrateQuery(query) {
    return query.state.status === "success";
}
function dehydrate(client) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _client_getDefaultOptions_dehydrate, _client_getDefaultOptions_dehydrate1, _client_getDefaultOptions_dehydrate2;
    var _options_shouldDehydrateMutation, _ref;
    var filterMutation = (_ref = (_options_shouldDehydrateMutation = options.shouldDehydrateMutation) !== null && _options_shouldDehydrateMutation !== void 0 ? _options_shouldDehydrateMutation : (_client_getDefaultOptions_dehydrate = client.getDefaultOptions().dehydrate) === null || _client_getDefaultOptions_dehydrate === void 0 ? void 0 : _client_getDefaultOptions_dehydrate.shouldDehydrateMutation) !== null && _ref !== void 0 ? _ref : defaultShouldDehydrateMutation;
    var mutations = client.getMutationCache().getAll().flatMap(function(mutation) {
        return filterMutation(mutation) ? [
            dehydrateMutation(mutation)
        ] : [];
    });
    var _options_shouldDehydrateQuery, _ref1;
    var filterQuery = (_ref1 = (_options_shouldDehydrateQuery = options.shouldDehydrateQuery) !== null && _options_shouldDehydrateQuery !== void 0 ? _options_shouldDehydrateQuery : (_client_getDefaultOptions_dehydrate1 = client.getDefaultOptions().dehydrate) === null || _client_getDefaultOptions_dehydrate1 === void 0 ? void 0 : _client_getDefaultOptions_dehydrate1.shouldDehydrateQuery) !== null && _ref1 !== void 0 ? _ref1 : defaultShouldDehydrateQuery;
    var _options_serializeData, _ref2;
    var serializeData = (_ref2 = (_options_serializeData = options.serializeData) !== null && _options_serializeData !== void 0 ? _options_serializeData : (_client_getDefaultOptions_dehydrate2 = client.getDefaultOptions().dehydrate) === null || _client_getDefaultOptions_dehydrate2 === void 0 ? void 0 : _client_getDefaultOptions_dehydrate2.serializeData) !== null && _ref2 !== void 0 ? _ref2 : defaultTransformerFn;
    var queries = client.getQueryCache().getAll().flatMap(function(query) {
        return filterQuery(query) ? [
            dehydrateQuery(query, serializeData)
        ] : [];
    });
    return {
        mutations,
        queries
    };
}
function hydrate(client, dehydratedState, options) {
    var _options_defaultOptions, _client_getDefaultOptions_hydrate;
    if (typeof dehydratedState !== "object" || dehydratedState === null) return;
    var mutationCache = client.getMutationCache();
    var queryCache = client.getQueryCache();
    var _options_defaultOptions_deserializeData, _ref;
    var deserializeData = (_ref = (_options_defaultOptions_deserializeData = options === null || options === void 0 ? void 0 : (_options_defaultOptions = options.defaultOptions) === null || _options_defaultOptions === void 0 ? void 0 : _options_defaultOptions.deserializeData) !== null && _options_defaultOptions_deserializeData !== void 0 ? _options_defaultOptions_deserializeData : (_client_getDefaultOptions_hydrate = client.getDefaultOptions().hydrate) === null || _client_getDefaultOptions_hydrate === void 0 ? void 0 : _client_getDefaultOptions_hydrate.deserializeData) !== null && _ref !== void 0 ? _ref : defaultTransformerFn;
    var mutations = dehydratedState.mutations || [];
    var queries = dehydratedState.queries || [];
    mutations.forEach(function(_param) {
        var state = _param.state, mutationOptions = (0, _objectWithoutProperties._)(_param, [
            "state"
        ]);
        var _client_getDefaultOptions_hydrate, _options_defaultOptions;
        mutationCache.build(client, (0, _objectSpread._)({}, (_client_getDefaultOptions_hydrate = client.getDefaultOptions().hydrate) === null || _client_getDefaultOptions_hydrate === void 0 ? void 0 : _client_getDefaultOptions_hydrate.mutations, options === null || options === void 0 ? void 0 : (_options_defaultOptions = options.defaultOptions) === null || _options_defaultOptions === void 0 ? void 0 : _options_defaultOptions.mutations, mutationOptions), state);
    });
    queries.forEach(function(param) {
        var queryKey = param.queryKey, state = param.state, queryHash = param.queryHash, meta = param.meta, promise = param.promise;
        var _client_getDefaultOptions_hydrate, _options_defaultOptions;
        var query = queryCache.get(queryHash);
        var data = state.data === void 0 ? state.data : deserializeData(state.data);
        if (query) {
            if (query.state.dataUpdatedAt < state.dataUpdatedAt) {
                var _ignored = state.fetchStatus, serializedState = (0, _objectWithoutProperties._)(state, [
                    "fetchStatus"
                ]);
                query.setState((0, _objectSpreadProps._)((0, _objectSpread._)({}, serializedState), {
                    data
                }));
            }
        } else query = queryCache.build(client, (0, _objectSpreadProps._)((0, _objectSpread._)({}, (_client_getDefaultOptions_hydrate = client.getDefaultOptions().hydrate) === null || _client_getDefaultOptions_hydrate === void 0 ? void 0 : _client_getDefaultOptions_hydrate.queries, options === null || options === void 0 ? void 0 : (_options_defaultOptions = options.defaultOptions) === null || _options_defaultOptions === void 0 ? void 0 : _options_defaultOptions.queries), {
            queryKey,
            queryHash,
            meta
        }), // Reset fetch status to idle to avoid
        // query being stuck in fetching state upon hydration
        (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            data,
            fetchStatus: "idle"
        }));
        if (promise) {
            var initialPromise = Promise.resolve(promise).then(deserializeData);
            query.fetch(void 0, {
                initialPromise
            });
        }
    });
}
 //# sourceMappingURL=hydration.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8"}],"deyew":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/types.ts
var types_exports = {};
module.exports = __toCommonJS(types_exports); //# sourceMappingURL=types.cjs.map

},{}],"1esvl":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/types.ts
var types_exports = {};
module.exports = __toCommonJS(types_exports); //# sourceMappingURL=types.cjs.map

},{}],"hPR8l":[function(require,module,exports) {
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useQueries.ts
var useQueries_exports = {};
__export(useQueries_exports, {
    useQueries: function() {
        return useQueries;
    }
});
module.exports = __toCommonJS(useQueries_exports);
var React = __toESM(require("18c49e2a8176d52c"), 1);
var import_query_core = require("65a8f0ac24997cfe");
var import_QueryClientProvider = require("bc7b81cba6e63ce4");
var import_isRestoring = require("caabcf75f0d2f3da");
var import_QueryErrorResetBoundary = require("916c3153e307f4b0");
var import_errorBoundaryUtils = require("e927b7a45aa1e3af");
var import_suspense = require("ed6a0571d8e1a0f5");
var import_utils = require("7a31e9f8a77388a9");
function useQueries(_param, queryClient) {
    var queries = _param.queries, options = (0, _objectWithoutProperties._)(_param, [
        "queries"
    ]);
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    var isRestoring = (0, import_isRestoring.useIsRestoring)();
    var errorResetBoundary = (0, import_QueryErrorResetBoundary.useQueryErrorResetBoundary)();
    var defaultedQueries = React.useMemo(function() {
        return queries.map(function(opts) {
            var defaultedOptions = client.defaultQueryOptions(opts);
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        });
    }, [
        queries,
        client,
        isRestoring
    ]);
    defaultedQueries.forEach(function(query) {
        (0, import_suspense.ensureSuspenseTimers)(query);
        (0, import_errorBoundaryUtils.ensurePreventErrorBoundaryRetry)(query, errorResetBoundary);
    });
    (0, import_errorBoundaryUtils.useClearResetErrorBoundary)(errorResetBoundary);
    var _React_useState = (0, _slicedToArray._)(React.useState(function() {
        return new import_query_core.QueriesObserver(client, defaultedQueries, options);
    }), 1), observer = _React_useState[0];
    var _observer_getOptimisticResult = (0, _slicedToArray._)(observer.getOptimisticResult(defaultedQueries, options.combine), 3), optimisticResult = _observer_getOptimisticResult[0], getCombinedResult = _observer_getOptimisticResult[1], trackResult = _observer_getOptimisticResult[2];
    React.useSyncExternalStore(React.useCallback(function(onStoreChange) {
        return isRestoring ? import_utils.noop : observer.subscribe(import_query_core.notifyManager.batchCalls(onStoreChange));
    }, [
        observer,
        isRestoring
    ]), function() {
        return observer.getCurrentResult();
    }, function() {
        return observer.getCurrentResult();
    });
    React.useEffect(function() {
        observer.setQueries(defaultedQueries, options, {
            listeners: false
        });
    }, [
        defaultedQueries,
        options,
        observer
    ]);
    var shouldAtLeastOneSuspend = optimisticResult.some(function(result, index) {
        return (0, import_suspense.shouldSuspend)(defaultedQueries[index], result);
    });
    var suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap(function(result, index) {
        var opts = defaultedQueries[index];
        if (opts) {
            var queryObserver = new import_query_core.QueryObserver(client, opts);
            if ((0, import_suspense.shouldSuspend)(opts, result)) return (0, import_suspense.fetchOptimistic)(opts, queryObserver, errorResetBoundary);
            else if ((0, import_suspense.willFetch)(result, isRestoring)) (0, import_suspense.fetchOptimistic)(opts, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    var firstSingleResultWhichShouldThrow = optimisticResult.find(function(result, index) {
        var query = defaultedQueries[index];
        return query && (0, import_errorBoundaryUtils.getHasError)({
            result,
            errorResetBoundary,
            throwOnError: query.throwOnError,
            query: client.getQueryCache().get(query.queryHash)
        });
    });
    if (firstSingleResultWhichShouldThrow === null || firstSingleResultWhichShouldThrow === void 0 ? void 0 : firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return getCombinedResult(trackResult());
}
 //# sourceMappingURL=useQueries.cjs.map

},{"@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","18c49e2a8176d52c":"9MtAM","65a8f0ac24997cfe":"eUKlt","bc7b81cba6e63ce4":"dwevj","caabcf75f0d2f3da":"b96LG","916c3153e307f4b0":"5bm3s","e927b7a45aa1e3af":"03bSm","ed6a0571d8e1a0f5":"93At0","7a31e9f8a77388a9":"3RLgC"}],"dwevj":[function(require,module,exports) {
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/QueryClientProvider.tsx
var QueryClientProvider_exports = {};
__export(QueryClientProvider_exports, {
    QueryClientContext: function() {
        return QueryClientContext;
    },
    QueryClientProvider: function() {
        return QueryClientProvider;
    },
    useQueryClient: function() {
        return useQueryClient;
    }
});
module.exports = __toCommonJS(QueryClientProvider_exports);
var React = __toESM(require("d70f16b4d31447f8"), 1);
var import_jsx_runtime = require("6ad7e6d598c42fc4");
var QueryClientContext = React.createContext(void 0);
var useQueryClient = function(queryClient) {
    var client = React.useContext(QueryClientContext);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var QueryClientProvider = function(param) {
    var client = param.client, children = param.children;
    React.useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QueryClientContext.Provider, {
        value: client,
        children
    });
};
 //# sourceMappingURL=QueryClientProvider.cjs.map

},{"d70f16b4d31447f8":"9MtAM","6ad7e6d598c42fc4":"iKGFf"}],"b96LG":[function(require,module,exports) {
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/isRestoring.ts
var isRestoring_exports = {};
__export(isRestoring_exports, {
    IsRestoringProvider: function() {
        return IsRestoringProvider;
    },
    useIsRestoring: function() {
        return useIsRestoring;
    }
});
module.exports = __toCommonJS(isRestoring_exports);
var React = __toESM(require("741e08586515addd"), 1);
var IsRestoringContext = React.createContext(false);
var useIsRestoring = function() {
    return React.useContext(IsRestoringContext);
};
var IsRestoringProvider = IsRestoringContext.Provider;
 //# sourceMappingURL=isRestoring.cjs.map

},{"741e08586515addd":"9MtAM"}],"5bm3s":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/QueryErrorResetBoundary.tsx
var QueryErrorResetBoundary_exports = {};
__export(QueryErrorResetBoundary_exports, {
    QueryErrorResetBoundary: function() {
        return QueryErrorResetBoundary;
    },
    useQueryErrorResetBoundary: function() {
        return useQueryErrorResetBoundary;
    }
});
module.exports = __toCommonJS(QueryErrorResetBoundary_exports);
var React = __toESM(require("8849911e21b7b99f"), 1);
var import_jsx_runtime = require("3a391fcf39507600");
function createValue() {
    var isReset = false;
    return {
        clearReset: function() {
            isReset = false;
        },
        reset: function() {
            isReset = true;
        },
        isReset: function() {
            return isReset;
        }
    };
}
var QueryErrorResetBoundaryContext = React.createContext(createValue());
var useQueryErrorResetBoundary = function() {
    return React.useContext(QueryErrorResetBoundaryContext);
};
var QueryErrorResetBoundary = function(param) {
    var children = param.children;
    var _React_useState = (0, _slicedToArray._)(React.useState(function() {
        return createValue();
    }), 1), value = _React_useState[0];
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(QueryErrorResetBoundaryContext.Provider, {
        value,
        children: typeof children === "function" ? children(value) : children
    });
};
 //# sourceMappingURL=QueryErrorResetBoundary.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","8849911e21b7b99f":"9MtAM","3a391fcf39507600":"iKGFf"}],"03bSm":[function(require,module,exports) {
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/errorBoundaryUtils.ts
var errorBoundaryUtils_exports = {};
__export(errorBoundaryUtils_exports, {
    ensurePreventErrorBoundaryRetry: function() {
        return ensurePreventErrorBoundaryRetry;
    },
    getHasError: function() {
        return getHasError;
    },
    useClearResetErrorBoundary: function() {
        return useClearResetErrorBoundary;
    }
});
module.exports = __toCommonJS(errorBoundaryUtils_exports);
var React = __toESM(require("56171fe590275b11"), 1);
var import_utils = require("8d5eeb9452bd43f7");
var ensurePreventErrorBoundaryRetry = function(options, errorResetBoundary) {
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var useClearResetErrorBoundary = function(errorResetBoundary) {
    React.useEffect(function() {
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var getHasError = function(param) {
    var result = param.result, errorResetBoundary = param.errorResetBoundary, throwOnError = param.throwOnError, query = param.query;
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, import_utils.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]);
};
 //# sourceMappingURL=errorBoundaryUtils.cjs.map

},{"56171fe590275b11":"9MtAM","8d5eeb9452bd43f7":"3RLgC"}],"3RLgC":[function(require,module,exports) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/utils.ts
var utils_exports = {};
__export(utils_exports, {
    noop: function() {
        return noop;
    },
    shouldThrowError: function() {
        return shouldThrowError;
    }
});
module.exports = __toCommonJS(utils_exports);
function shouldThrowError(throwError, params) {
    if (typeof throwError === "function") return throwError.apply(void 0, (0, _toConsumableArray._)(params));
    return !!throwError;
}
function noop() {}
 //# sourceMappingURL=utils.cjs.map

},{"@swc/helpers/_/_to_consumable_array":"jg7I9"}],"93At0":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/suspense.ts
var suspense_exports = {};
__export(suspense_exports, {
    defaultThrowOnError: function() {
        return defaultThrowOnError;
    },
    ensureSuspenseTimers: function() {
        return ensureSuspenseTimers;
    },
    fetchOptimistic: function() {
        return fetchOptimistic;
    },
    shouldSuspend: function() {
        return shouldSuspend;
    },
    willFetch: function() {
        return willFetch;
    }
});
module.exports = __toCommonJS(suspense_exports);
var defaultThrowOnError = function(_error, query) {
    return query.state.data === void 0;
};
var ensureSuspenseTimers = function(defaultedOptions) {
    if (defaultedOptions.suspense) {
        if (defaultedOptions.staleTime === void 0) defaultedOptions.staleTime = 1e3;
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var willFetch = function(result, isRestoring) {
    return result.isLoading && result.isFetching && !isRestoring;
};
var shouldSuspend = function(defaultedOptions, result) {
    return (defaultedOptions === null || defaultedOptions === void 0 ? void 0 : defaultedOptions.suspense) && result.isPending;
};
var fetchOptimistic = function(defaultedOptions, observer, errorResetBoundary) {
    return observer.fetchOptimistic(defaultedOptions).catch(function() {
        errorResetBoundary.clearReset();
    });
};
 //# sourceMappingURL=suspense.cjs.map

},{}],"42FwI":[function(require,module,exports) {
"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useQuery.ts
var useQuery_exports = {};
__export(useQuery_exports, {
    useQuery: function() {
        return useQuery;
    }
});
module.exports = __toCommonJS(useQuery_exports);
var import_query_core = require("d137afdb0a27ba79");
var import_useBaseQuery = require("60f75382db0fa4e9");
function useQuery(options, queryClient) {
    return (0, import_useBaseQuery.useBaseQuery)(options, import_query_core.QueryObserver, queryClient);
}
 //# sourceMappingURL=useQuery.cjs.map

},{"d137afdb0a27ba79":"eUKlt","60f75382db0fa4e9":"2Or3N"}],"2Or3N":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useBaseQuery.ts
var useBaseQuery_exports = {};
__export(useBaseQuery_exports, {
    useBaseQuery: function() {
        return useBaseQuery;
    }
});
module.exports = __toCommonJS(useBaseQuery_exports);
var React = __toESM(require("c5c57c950a87a75f"), 1);
var import_query_core = require("18c725c678d9cc42");
var import_QueryClientProvider = require("7eddec530746b44");
var import_QueryErrorResetBoundary = require("6bcef55ef3301f62");
var import_errorBoundaryUtils = require("c5c77c6eb35848cb");
var import_isRestoring = require("4e5dba27f5eca659");
var import_suspense = require("621d13ae775bdc91");
var import_utils = require("10fe3b87e66748f2");
function useBaseQuery(options, Observer, queryClient) {
    var _client_getDefaultOptions_queries__experimental_beforeQuery, _client_getDefaultOptions_queries, _client_getDefaultOptions_queries__experimental_afterQuery, _client_getDefaultOptions_queries1;
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    var isRestoring = (0, import_isRestoring.useIsRestoring)();
    var errorResetBoundary = (0, import_QueryErrorResetBoundary.useQueryErrorResetBoundary)();
    var defaultedOptions = client.defaultQueryOptions(options);
    (_client_getDefaultOptions_queries = client.getDefaultOptions().queries) === null || _client_getDefaultOptions_queries === void 0 ? void 0 : (_client_getDefaultOptions_queries__experimental_beforeQuery = _client_getDefaultOptions_queries._experimental_beforeQuery) === null || _client_getDefaultOptions_queries__experimental_beforeQuery === void 0 ? void 0 : _client_getDefaultOptions_queries__experimental_beforeQuery.call(_client_getDefaultOptions_queries, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, import_suspense.ensureSuspenseTimers)(defaultedOptions);
    (0, import_errorBoundaryUtils.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, import_errorBoundaryUtils.useClearResetErrorBoundary)(errorResetBoundary);
    var isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    var _React_useState = (0, _slicedToArray._)(React.useState(function() {
        return new Observer(client, defaultedOptions);
    }), 1), observer = _React_useState[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    React.useSyncExternalStore(React.useCallback(function(onStoreChange) {
        var unsubscribe = isRestoring ? import_utils.noop : observer.subscribe(import_query_core.notifyManager.batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), function() {
        return observer.getCurrentResult();
    }, function() {
        return observer.getCurrentResult();
    });
    React.useEffect(function() {
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, import_suspense.shouldSuspend)(defaultedOptions, result)) throw (0, import_suspense.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, import_errorBoundaryUtils.getHasError)({
        result,
        errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    (_client_getDefaultOptions_queries1 = client.getDefaultOptions().queries) === null || _client_getDefaultOptions_queries1 === void 0 ? void 0 : (_client_getDefaultOptions_queries__experimental_afterQuery = _client_getDefaultOptions_queries1._experimental_afterQuery) === null || _client_getDefaultOptions_queries__experimental_afterQuery === void 0 ? void 0 : _client_getDefaultOptions_queries__experimental_afterQuery.call(_client_getDefaultOptions_queries1, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !import_query_core.isServer && (0, import_suspense.willFetch)(result, isRestoring)) {
        var // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        _client_getQueryCache_get;
        var promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, import_suspense.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary) : (_client_getQueryCache_get = client.getQueryCache().get(defaultedOptions.queryHash)) === null || _client_getQueryCache_get === void 0 ? void 0 : _client_getQueryCache_get.promise;
        promise === null || promise === void 0 ? void 0 : promise.catch(import_utils.noop).finally(function() {
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}
 //# sourceMappingURL=useBaseQuery.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","c5c57c950a87a75f":"9MtAM","18c725c678d9cc42":"eUKlt","7eddec530746b44":"dwevj","6bcef55ef3301f62":"5bm3s","c5c77c6eb35848cb":"03bSm","4e5dba27f5eca659":"b96LG","621d13ae775bdc91":"93At0","10fe3b87e66748f2":"3RLgC"}],"eONya":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useSuspenseQuery.ts
var useSuspenseQuery_exports = {};
__export(useSuspenseQuery_exports, {
    useSuspenseQuery: function() {
        return useSuspenseQuery;
    }
});
module.exports = __toCommonJS(useSuspenseQuery_exports);
var import_query_core = require("fd1a94d37cab349");
var import_useBaseQuery = require("995545c392aec4f7");
var import_suspense = require("f5ba9ec8169e8d0f");
function useSuspenseQuery(options, queryClient) {
    return (0, import_useBaseQuery.useBaseQuery)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        enabled: true,
        suspense: true,
        throwOnError: import_suspense.defaultThrowOnError,
        placeholderData: void 0
    }), import_query_core.QueryObserver, queryClient);
}
 //# sourceMappingURL=useSuspenseQuery.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","fd1a94d37cab349":"eUKlt","995545c392aec4f7":"2Or3N","f5ba9ec8169e8d0f":"93At0"}],"02mHe":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useSuspenseInfiniteQuery.ts
var useSuspenseInfiniteQuery_exports = {};
__export(useSuspenseInfiniteQuery_exports, {
    useSuspenseInfiniteQuery: function() {
        return useSuspenseInfiniteQuery;
    }
});
module.exports = __toCommonJS(useSuspenseInfiniteQuery_exports);
var import_query_core = require("8ee622122e38eed5");
var import_useBaseQuery = require("ed9c9a358232e811");
var import_suspense = require("e6c064287fa96318");
function useSuspenseInfiniteQuery(options, queryClient) {
    return (0, import_useBaseQuery.useBaseQuery)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        enabled: true,
        suspense: true,
        throwOnError: import_suspense.defaultThrowOnError
    }), import_query_core.InfiniteQueryObserver, queryClient);
}
 //# sourceMappingURL=useSuspenseInfiniteQuery.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","8ee622122e38eed5":"eUKlt","ed9c9a358232e811":"2Or3N","e6c064287fa96318":"93At0"}],"7FUPh":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useSuspenseQueries.ts
var useSuspenseQueries_exports = {};
__export(useSuspenseQueries_exports, {
    useSuspenseQueries: function() {
        return useSuspenseQueries;
    }
});
module.exports = __toCommonJS(useSuspenseQueries_exports);
var import_query_core = require("db088bae614a0708");
var import_useQueries = require("9de6655b7ac41bae");
var import_suspense = require("6da51cfc4dbf3804");
function useSuspenseQueries(options, queryClient) {
    return (0, import_useQueries.useQueries)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        queries: options.queries.map(function(query) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, query), {
                suspense: true,
                throwOnError: import_suspense.defaultThrowOnError,
                enabled: true,
                placeholderData: void 0
            });
        })
    }), queryClient);
}
 //# sourceMappingURL=useSuspenseQueries.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","db088bae614a0708":"eUKlt","9de6655b7ac41bae":"hPR8l","6da51cfc4dbf3804":"93At0"}],"f4yGh":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/usePrefetchQuery.tsx
var usePrefetchQuery_exports = {};
__export(usePrefetchQuery_exports, {
    usePrefetchQuery: function() {
        return usePrefetchQuery;
    }
});
module.exports = __toCommonJS(usePrefetchQuery_exports);
var import_QueryClientProvider = require("d6e5379c6fe363f2");
function usePrefetchQuery(options, queryClient) {
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    if (!client.getQueryState(options.queryKey)) client.prefetchQuery(options);
}
 //# sourceMappingURL=usePrefetchQuery.cjs.map

},{"d6e5379c6fe363f2":"dwevj"}],"qhJkq":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/usePrefetchInfiniteQuery.tsx
var usePrefetchInfiniteQuery_exports = {};
__export(usePrefetchInfiniteQuery_exports, {
    usePrefetchInfiniteQuery: function() {
        return usePrefetchInfiniteQuery;
    }
});
module.exports = __toCommonJS(usePrefetchInfiniteQuery_exports);
var import_QueryClientProvider = require("3739ce0cf5a7c1b8");
function usePrefetchInfiniteQuery(options, queryClient) {
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    if (!client.getQueryState(options.queryKey)) client.prefetchInfiniteQuery(options);
}
 //# sourceMappingURL=usePrefetchInfiniteQuery.cjs.map

},{"3739ce0cf5a7c1b8":"dwevj"}],"ask9M":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/queryOptions.ts
var queryOptions_exports = {};
__export(queryOptions_exports, {
    queryOptions: function() {
        return queryOptions;
    }
});
module.exports = __toCommonJS(queryOptions_exports);
function queryOptions(options) {
    return options;
}
 //# sourceMappingURL=queryOptions.cjs.map

},{}],"k3HJr":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/infiniteQueryOptions.ts
var infiniteQueryOptions_exports = {};
__export(infiniteQueryOptions_exports, {
    infiniteQueryOptions: function() {
        return infiniteQueryOptions;
    }
});
module.exports = __toCommonJS(infiniteQueryOptions_exports);
function infiniteQueryOptions(options) {
    return options;
}
 //# sourceMappingURL=infiniteQueryOptions.cjs.map

},{}],"ag70d":[function(require,module,exports) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/HydrationBoundary.tsx
var HydrationBoundary_exports = {};
__export(HydrationBoundary_exports, {
    HydrationBoundary: function() {
        return HydrationBoundary;
    }
});
module.exports = __toCommonJS(HydrationBoundary_exports);
var React = __toESM(require("8ac8e3bb65c5e3c7"), 1);
var import_query_core = require("39aaf208a7770964");
var import_QueryClientProvider = require("e1ced0644820db23");
var HydrationBoundary = function(param) {
    var children = param.children, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options, state = param.state, queryClient = param.queryClient;
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    var _React_useState = (0, _slicedToArray._)(React.useState(), 2), hydrationQueue = _React_useState[0], setHydrationQueue = _React_useState[1];
    var optionsRef = React.useRef(options);
    optionsRef.current = options;
    React.useMemo(function() {
        if (state) {
            if (typeof state !== "object") return;
            var queryCache = client.getQueryCache();
            var queries = state.queries || [];
            var newQueries = [];
            var existingQueries = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var dehydratedQuery = _step.value;
                    var existingQuery = queryCache.get(dehydratedQuery.queryHash);
                    if (!existingQuery) newQueries.push(dehydratedQuery);
                    else {
                        var hydrationIsNewer = dehydratedQuery.state.dataUpdatedAt > existingQuery.state.dataUpdatedAt;
                        var queryAlreadyQueued = hydrationQueue === null || hydrationQueue === void 0 ? void 0 : hydrationQueue.find(function(query) {
                            return query.queryHash === dehydratedQuery.queryHash;
                        });
                        if (hydrationIsNewer && (!queryAlreadyQueued || dehydratedQuery.state.dataUpdatedAt > queryAlreadyQueued.state.dataUpdatedAt)) existingQueries.push(dehydratedQuery);
                    }
                };
                for(var _iterator = queries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (newQueries.length > 0) (0, import_query_core.hydrate)(client, {
                queries: newQueries
            }, optionsRef.current);
            if (existingQueries.length > 0) setHydrationQueue(function(prev) {
                return prev ? (0, _toConsumableArray._)(prev).concat((0, _toConsumableArray._)(existingQueries)) : existingQueries;
            });
        }
    }, [
        client,
        hydrationQueue,
        state
    ]);
    React.useEffect(function() {
        if (hydrationQueue) {
            (0, import_query_core.hydrate)(client, {
                queries: hydrationQueue
            }, optionsRef.current);
            setHydrationQueue(void 0);
        }
    }, [
        client,
        hydrationQueue
    ]);
    return children;
};
 //# sourceMappingURL=HydrationBoundary.cjs.map

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","8ac8e3bb65c5e3c7":"9MtAM","39aaf208a7770964":"eUKlt","e1ced0644820db23":"dwevj"}],"lvSSk":[function(require,module,exports) {
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useIsFetching.ts
var useIsFetching_exports = {};
__export(useIsFetching_exports, {
    useIsFetching: function() {
        return useIsFetching;
    }
});
module.exports = __toCommonJS(useIsFetching_exports);
var React = __toESM(require("1c739a7cb29e221b"), 1);
var import_query_core = require("3cd2b74c3c270388");
var import_QueryClientProvider = require("2989286d0908800f");
function useIsFetching(filters, queryClient) {
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    var queryCache = client.getQueryCache();
    return React.useSyncExternalStore(React.useCallback(function(onStoreChange) {
        return queryCache.subscribe(import_query_core.notifyManager.batchCalls(onStoreChange));
    }, [
        queryCache
    ]), function() {
        return client.isFetching(filters);
    }, function() {
        return client.isFetching(filters);
    });
}
 //# sourceMappingURL=useIsFetching.cjs.map

},{"1c739a7cb29e221b":"9MtAM","3cd2b74c3c270388":"eUKlt","2989286d0908800f":"dwevj"}],"3MFSC":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useMutationState.ts
var useMutationState_exports = {};
__export(useMutationState_exports, {
    useIsMutating: function() {
        return useIsMutating;
    },
    useMutationState: function() {
        return useMutationState;
    }
});
module.exports = __toCommonJS(useMutationState_exports);
var React = __toESM(require("b8c7a4b343837415"), 1);
var import_query_core = require("3e07f01ee4367e79");
var import_QueryClientProvider = require("4a5c8929779f7d5");
function useIsMutating(filters, queryClient) {
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    return useMutationState({
        filters: (0, _objectSpreadProps._)((0, _objectSpread._)({}, filters), {
            status: "pending"
        })
    }, client).length;
}
function getResult(mutationCache, options) {
    return mutationCache.findAll(options.filters).map(function(mutation) {
        return options.select ? options.select(mutation) : mutation.state;
    });
}
function useMutationState() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, queryClient = arguments.length > 1 ? arguments[1] : void 0;
    var mutationCache = (0, import_QueryClientProvider.useQueryClient)(queryClient).getMutationCache();
    var optionsRef = React.useRef(options);
    var result = React.useRef(null);
    if (!result.current) result.current = getResult(mutationCache, options);
    React.useEffect(function() {
        optionsRef.current = options;
    });
    return React.useSyncExternalStore(React.useCallback(function(onStoreChange) {
        return mutationCache.subscribe(function() {
            var nextResult = (0, import_query_core.replaceEqualDeep)(result.current, getResult(mutationCache, optionsRef.current));
            if (result.current !== nextResult) {
                result.current = nextResult;
                import_query_core.notifyManager.schedule(onStoreChange);
            }
        });
    }, [
        mutationCache
    ]), function() {
        return result.current;
    }, function() {
        return result.current;
    });
}
 //# sourceMappingURL=useMutationState.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","b8c7a4b343837415":"9MtAM","3e07f01ee4367e79":"eUKlt","4a5c8929779f7d5":"dwevj"}],"3NhHe":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useMutation.ts
var useMutation_exports = {};
__export(useMutation_exports, {
    useMutation: function() {
        return useMutation;
    }
});
module.exports = __toCommonJS(useMutation_exports);
var React = __toESM(require("351a7a07d8a209a2"), 1);
var import_query_core = require("6f7198c038c360ba");
var import_QueryClientProvider = require("26a3f1d92a54e9be");
var import_utils = require("1527092f3eb560aa");
function useMutation(options, queryClient) {
    var client = (0, import_QueryClientProvider.useQueryClient)(queryClient);
    var _React_useState = (0, _slicedToArray._)(React.useState(function() {
        return new import_query_core.MutationObserver(client, options);
    }), 1), observer = _React_useState[0];
    React.useEffect(function() {
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    var result = React.useSyncExternalStore(React.useCallback(function(onStoreChange) {
        return observer.subscribe(import_query_core.notifyManager.batchCalls(onStoreChange));
    }, [
        observer
    ]), function() {
        return observer.getCurrentResult();
    }, function() {
        return observer.getCurrentResult();
    });
    var mutate = React.useCallback(function(variables, mutateOptions) {
        observer.mutate(variables, mutateOptions).catch(import_utils.noop);
    }, [
        observer
    ]);
    if (result.error && (0, import_utils.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
        mutate,
        mutateAsync: result.mutate
    });
}
 //# sourceMappingURL=useMutation.cjs.map

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","351a7a07d8a209a2":"9MtAM","6f7198c038c360ba":"eUKlt","26a3f1d92a54e9be":"dwevj","1527092f3eb560aa":"3RLgC"}],"lcYLI":[function(require,module,exports) {
"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/useInfiniteQuery.ts
var useInfiniteQuery_exports = {};
__export(useInfiniteQuery_exports, {
    useInfiniteQuery: function() {
        return useInfiniteQuery;
    }
});
module.exports = __toCommonJS(useInfiniteQuery_exports);
var import_query_core = require("5c4b175c0185a368");
var import_useBaseQuery = require("c82267a9ad999b17");
function useInfiniteQuery(options, queryClient) {
    return (0, import_useBaseQuery.useBaseQuery)(options, import_query_core.InfiniteQueryObserver, queryClient);
}
 //# sourceMappingURL=useInfiniteQuery.cjs.map

},{"5c4b175c0185a368":"eUKlt","c82267a9ad999b17":"2Or3N"}],"bSoFW":[function(require,module,exports) {
module.exports = require("5cf7a53a64fc862b").getBundleURL("3PVz6") + "../horus.00f0c3fc.png";

},{"5cf7a53a64fc862b":"ggWeI"}],"678Yq":[function(require,module,exports) {
/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
var _class;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/marked.ts
var marked_exports = {};
__export(marked_exports, {
    Hooks: function() {
        return _Hooks;
    },
    Lexer: function() {
        return _Lexer;
    },
    Marked: function() {
        return Marked;
    },
    Parser: function() {
        return _Parser;
    },
    Renderer: function() {
        return _Renderer;
    },
    TextRenderer: function() {
        return _TextRenderer;
    },
    Tokenizer: function() {
        return _Tokenizer;
    },
    defaults: function() {
        return _defaults;
    },
    getDefaults: function() {
        return _getDefaults;
    },
    lexer: function() {
        return lexer;
    },
    marked: function() {
        return marked;
    },
    options: function() {
        return options;
    },
    parse: function() {
        return parse;
    },
    parseInline: function() {
        return parseInline;
    },
    parser: function() {
        return parser;
    },
    setOptions: function() {
        return setOptions;
    },
    use: function() {
        return use;
    },
    walkTokens: function() {
        return walkTokens;
    }
});
module.exports = __toCommonJS(marked_exports);
// src/defaults.ts
function _getDefaults() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
var _defaults = _getDefaults();
function changeDefaults(newDefaults) {
    _defaults = newDefaults;
}
// src/rules.ts
var noopTest = {
    exec: function() {
        return null;
    }
};
function edit(regex) {
    var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var source = typeof regex === "string" ? regex : regex.source;
    var obj = {
        replace: function(name, val) {
            var valSource = typeof val === "string" ? val : val.source;
            valSource = valSource.replace(other.caret, "$1");
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: function() {
            return new RegExp(source, opt);
        }
    };
    return obj;
}
var other = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: RegExp("[\\p{L}\\p{N}]", "u"),
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: function(bull) {
        return new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`);
    },
    nextBulletRegex: function(indent) {
        return new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`);
    },
    hrRegex: function(indent) {
        return new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
    },
    fencesBeginRegex: function(indent) {
        return new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
    },
    headingBeginRegex: function(indent) {
        return new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
    },
    htmlBeginRegex: function(indent) {
        return new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i");
    }
};
var newline = /^(?:[ \t]*(?:\n|$))+/;
var blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var bullet = /(?:[*+-]|\d{1,9}[.)])/;
var lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var lheading = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var blockText = /^[^\n]+/;
var _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
var _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
var blockNormal = {
    blockquote,
    code: blockCode,
    def,
    fences,
    heading,
    hr,
    html,
    lheading,
    list,
    newline,
    paragraph,
    table: noopTest,
    text: blockText
};
var gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockGfm = (0, _objectSpreadProps._)((0, _objectSpread._)({}, blockNormal), {
    lheading: lheadingGfm,
    table: gfmTable,
    paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex()
});
var blockPedantic = (0, _objectSpreadProps._)((0, _objectSpread._)({}, blockNormal), {
    html: edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
});
var escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var br = /^( {2,}|\\)\n(?!\s*$)/;
var inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var _punctuation = RegExp("[\\p{P}\\p{S}]", "u");
var _punctuationOrSpace = RegExp("[\\s\\p{P}\\p{S}]", "u");
var _notPunctuationOrSpace = RegExp("[^\\s\\p{P}\\p{S}]", "u");
var punctuation = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, _punctuationOrSpace).getRegex();
var _punctuationGfmStrongEm = RegExp("(?!~)[\\p{P}\\p{S}]", "u");
var _punctuationOrSpaceGfmStrongEm = RegExp("(?!~)[\\s\\p{P}\\p{S}]", "u");
var _notPunctuationOrSpaceGfmStrongEm = RegExp("(?:[^\\s\\p{P}\\p{S}]|~)", "u");
var blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var emStrongLDelim = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuation).getRegex();
var emStrongLDelimGfm = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var emStrongRDelimAst = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var anyPunctuation = edit(/\\(punct)/, "gu").replace(/punct/g, _punctuation).getRegex();
var autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
var tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var link = edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
var nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
var reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
var inlineNormal = {
    _backpedal: noopTest,
    // only used for GFM url
    anyPunctuation,
    autolink,
    blockSkip,
    br,
    code: inlineCode,
    del: noopTest,
    emStrongLDelim,
    emStrongRDelimAst,
    emStrongRDelimUnd,
    escape,
    link,
    nolink,
    punctuation,
    reflink,
    reflinkSearch,
    tag,
    text: inlineText,
    url: noopTest
};
var inlinePedantic = (0, _objectSpreadProps._)((0, _objectSpread._)({}, inlineNormal), {
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
});
var inlineGfm = (0, _objectSpreadProps._)((0, _objectSpread._)({}, inlineNormal), {
    emStrongRDelimAst: emStrongRDelimAstGfm,
    emStrongLDelim: emStrongLDelimGfm,
    url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
var inlineBreaks = (0, _objectSpreadProps._)((0, _objectSpread._)({}, inlineGfm), {
    br: edit(br).replace("{2,}", "*").getRegex(),
    text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
var block = {
    normal: blockNormal,
    gfm: blockGfm,
    pedantic: blockPedantic
};
var inline = {
    normal: inlineNormal,
    gfm: inlineGfm,
    breaks: inlineBreaks,
    pedantic: inlinePedantic
};
// src/helpers.ts
var escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var getEscapeReplacement = function(ch) {
    return escapeReplacements[ch];
};
function escape2(html2, encode) {
    if (encode) {
        if (other.escapeTest.test(html2)) return html2.replace(other.escapeReplace, getEscapeReplacement);
    } else {
        if (other.escapeTestNoEncode.test(html2)) return html2.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
    }
    return html2;
}
function cleanUrl(href) {
    try {
        href = encodeURI(href).replace(other.percentDecode, "%");
    } catch (e) {
        return null;
    }
    return href;
}
function splitCells(tableRow, count) {
    var _cells_at;
    var row = tableRow.replace(other.findPipe, function(match, offset, str) {
        var escaped = false;
        var curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row.split(other.splitPipe);
    var i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !((_cells_at = cells.at(-1)) === null || _cells_at === void 0 ? void 0 : _cells_at.trim())) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace(other.slashPipe, "|");
    return cells;
}
function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) return "";
    var suffLen = 0;
    while(suffLen < l){
        var currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    var level = 0;
    for(var i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}
// src/Tokenizer.ts
function outputLink(cap, link2, raw, lexer2, rules) {
    var href = link2.href;
    var title = link2.title || null;
    var text = cap[1].replace(rules.other.outputLinkReplace, "$1");
    lexer2.state.inLink = true;
    var token = {
        type: cap[0].charAt(0) === "!" ? "image" : "link",
        raw,
        href,
        title,
        text,
        tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
}
function indentCodeCompensation(raw, text, rules) {
    var matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    var indentToCode = matchIndentToCode[1];
    return text.split("\n").map(function(node) {
        var matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        var _matchIndentInNode = (0, _slicedToArray._)(matchIndentInNode, 1), indentInNode = _matchIndentInNode[0];
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
var _Tokenizer = /*#__PURE__*/ function() {
    function _Tokenizer(options2) {
        (0, _classCallCheck._)(this, _Tokenizer);
        (0, _defineProperty._)(this, "options", void 0);
        (0, _defineProperty._)(this, "rules", void 0);
        // set by the lexer
        (0, _defineProperty._)(this, "lexer", void 0);
        this.options = options2 || _defaults;
    }
    (0, _createClass._)(_Tokenizer, [
        {
            key: "space",
            value: function space(src) {
                var cap = this.rules.block.newline.exec(src);
                if (cap && cap[0].length > 0) return {
                    type: "space",
                    raw: cap[0]
                };
            }
        },
        {
            key: "code",
            value: function code(src) {
                var cap = this.rules.block.code.exec(src);
                if (cap) {
                    var text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
                    return {
                        type: "code",
                        raw: cap[0],
                        codeBlockStyle: "indented",
                        text: !this.options.pedantic ? rtrim(text, "\n") : text
                    };
                }
            }
        },
        {
            key: "fences",
            value: function fences(src) {
                var cap = this.rules.block.fences.exec(src);
                if (cap) {
                    var raw = cap[0];
                    var text = indentCodeCompensation(raw, cap[3] || "", this.rules);
                    return {
                        type: "code",
                        raw,
                        lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                        text
                    };
                }
            }
        },
        {
            key: "heading",
            value: function heading(src) {
                var cap = this.rules.block.heading.exec(src);
                if (cap) {
                    var text = cap[2].trim();
                    if (this.rules.other.endingHash.test(text)) {
                        var trimmed = rtrim(text, "#");
                        if (this.options.pedantic) text = trimmed.trim();
                        else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
                    }
                    return {
                        type: "heading",
                        raw: cap[0],
                        depth: cap[1].length,
                        text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
        },
        {
            key: "hr",
            value: function hr(src) {
                var cap = this.rules.block.hr.exec(src);
                if (cap) return {
                    type: "hr",
                    raw: rtrim(cap[0], "\n")
                };
            }
        },
        {
            key: "blockquote",
            value: function blockquote(src) {
                var cap = this.rules.block.blockquote.exec(src);
                if (cap) {
                    var lines = rtrim(cap[0], "\n").split("\n");
                    var raw = "";
                    var text = "";
                    var tokens = [];
                    while(lines.length > 0){
                        var inBlockquote = false;
                        var currentLines = [];
                        var i = void 0;
                        for(i = 0; i < lines.length; i++){
                            if (this.rules.other.blockquoteStart.test(lines[i])) {
                                currentLines.push(lines[i]);
                                inBlockquote = true;
                            } else if (!inBlockquote) currentLines.push(lines[i]);
                            else break;
                        }
                        lines = lines.slice(i);
                        var currentRaw = currentLines.join("\n");
                        var currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                        raw = raw ? `${raw}
${currentRaw}` : currentRaw;
                        text = text ? `${text}
${currentText}` : currentText;
                        var top = this.lexer.state.top;
                        this.lexer.state.top = true;
                        this.lexer.blockTokens(currentText, tokens, true);
                        this.lexer.state.top = top;
                        if (lines.length === 0) break;
                        var lastToken = tokens.at(-1);
                        if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "code") break;
                        else if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "blockquote") {
                            var oldToken = lastToken;
                            var newText = oldToken.raw + "\n" + lines.join("\n");
                            var newToken = this.blockquote(newText);
                            tokens[tokens.length - 1] = newToken;
                            raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                            text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                            break;
                        } else if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "list") {
                            var oldToken1 = lastToken;
                            var newText1 = oldToken1.raw + "\n" + lines.join("\n");
                            var newToken1 = this.list(newText1);
                            tokens[tokens.length - 1] = newToken1;
                            raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken1.raw;
                            text = text.substring(0, text.length - oldToken1.raw.length) + newToken1.raw;
                            lines = newText1.substring(tokens.at(-1).raw.length).split("\n");
                            continue;
                        }
                    }
                    return {
                        type: "blockquote",
                        raw,
                        tokens,
                        text
                    };
                }
            }
        },
        {
            key: "list",
            value: function list(src) {
                var _this = this;
                var cap = this.rules.block.list.exec(src);
                if (cap) {
                    var _this1 = this, _loop = function() {
                        var endEarly = false;
                        var raw = "";
                        var itemContents = "";
                        if (!(cap = itemRegex.exec(src))) return "break";
                        if (_this1.rules.block.hr.test(src)) return "break";
                        raw = cap[0];
                        src = src.substring(raw.length);
                        var line = cap[2].split("\n", 1)[0].replace(_this1.rules.other.listReplaceTabs, function(t) {
                            return " ".repeat(3 * t.length);
                        });
                        var nextLine = src.split("\n", 1)[0];
                        var blankLine = !line.trim();
                        var indent = 0;
                        if (_this1.options.pedantic) {
                            indent = 2;
                            itemContents = line.trimStart();
                        } else if (blankLine) indent = cap[1].length + 1;
                        else {
                            indent = cap[2].search(_this1.rules.other.nonSpaceChar);
                            indent = indent > 4 ? 1 : indent;
                            itemContents = line.slice(indent);
                            indent += cap[1].length;
                        }
                        if (blankLine && _this1.rules.other.blankLine.test(nextLine)) {
                            raw += nextLine + "\n";
                            src = src.substring(nextLine.length + 1);
                            endEarly = true;
                        }
                        if (!endEarly) {
                            var nextBulletRegex = _this1.rules.other.nextBulletRegex(indent);
                            var hrRegex = _this1.rules.other.hrRegex(indent);
                            var fencesBeginRegex = _this1.rules.other.fencesBeginRegex(indent);
                            var headingBeginRegex = _this1.rules.other.headingBeginRegex(indent);
                            var htmlBeginRegex = _this1.rules.other.htmlBeginRegex(indent);
                            while(src){
                                var rawLine = src.split("\n", 1)[0];
                                var nextLineWithoutTabs = void 0;
                                nextLine = rawLine;
                                if (_this1.options.pedantic) {
                                    nextLine = nextLine.replace(_this1.rules.other.listReplaceNesting, "  ");
                                    nextLineWithoutTabs = nextLine;
                                } else nextLineWithoutTabs = nextLine.replace(_this1.rules.other.tabCharGlobal, "    ");
                                if (fencesBeginRegex.test(nextLine)) break;
                                if (headingBeginRegex.test(nextLine)) break;
                                if (htmlBeginRegex.test(nextLine)) break;
                                if (nextBulletRegex.test(nextLine)) break;
                                if (hrRegex.test(nextLine)) break;
                                if (nextLineWithoutTabs.search(_this1.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                                else {
                                    if (blankLine) break;
                                    if (line.replace(_this1.rules.other.tabCharGlobal, "    ").search(_this1.rules.other.nonSpaceChar) >= 4) break;
                                    if (fencesBeginRegex.test(line)) break;
                                    if (headingBeginRegex.test(line)) break;
                                    if (hrRegex.test(line)) break;
                                    itemContents += "\n" + nextLine;
                                }
                                if (!blankLine && !nextLine.trim()) blankLine = true;
                                raw += rawLine + "\n";
                                src = src.substring(rawLine.length + 1);
                                line = nextLineWithoutTabs.slice(indent);
                            }
                        }
                        if (!list2.loose) {
                            if (endsWithBlankLine) list2.loose = true;
                            else if (_this1.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                        }
                        var istask = null;
                        var ischecked = void 0;
                        if (_this1.options.gfm) {
                            istask = _this1.rules.other.listIsTask.exec(itemContents);
                            if (istask) {
                                ischecked = istask[0] !== "[ ] ";
                                itemContents = itemContents.replace(_this1.rules.other.listReplaceTask, "");
                            }
                        }
                        list2.items.push({
                            type: "list_item",
                            raw,
                            task: !!istask,
                            checked: ischecked,
                            loose: false,
                            text: itemContents,
                            tokens: []
                        });
                        list2.raw += raw;
                    };
                    var bull = cap[1].trim();
                    var isordered = bull.length > 1;
                    var list2 = {
                        type: "list",
                        raw: "",
                        ordered: isordered,
                        start: isordered ? +bull.slice(0, -1) : "",
                        loose: false,
                        items: []
                    };
                    bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                    if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                    var itemRegex = this.rules.other.listItemRegex(bull);
                    var endsWithBlankLine = false;
                    while(src){
                        var _ret = _loop();
                        if (_ret === "break") break;
                    }
                    var lastItem = list2.items.at(-1);
                    if (lastItem) {
                        lastItem.raw = lastItem.raw.trimEnd();
                        lastItem.text = lastItem.text.trimEnd();
                    } else return;
                    list2.raw = list2.raw.trimEnd();
                    for(var i = 0; i < list2.items.length; i++){
                        this.lexer.state.top = false;
                        list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                        if (!list2.loose) {
                            var spacers = list2.items[i].tokens.filter(function(t) {
                                return t.type === "space";
                            });
                            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                                return _this.rules.other.anyLine.test(t.raw);
                            });
                            list2.loose = hasMultipleLineBreaks;
                        }
                    }
                    if (list2.loose) for(var i1 = 0; i1 < list2.items.length; i1++)list2.items[i1].loose = true;
                    return list2;
                }
            }
        },
        {
            key: "html",
            value: function html(src) {
                var cap = this.rules.block.html.exec(src);
                if (cap) {
                    var token = {
                        type: "html",
                        block: true,
                        raw: cap[0],
                        pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                        text: cap[0]
                    };
                    return token;
                }
            }
        },
        {
            key: "def",
            value: function def(src) {
                var cap = this.rules.block.def.exec(src);
                if (cap) {
                    var tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
                    var href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                    var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                    return {
                        type: "def",
                        tag: tag2,
                        raw: cap[0],
                        href,
                        title
                    };
                }
            }
        },
        {
            key: "table",
            value: function table(src) {
                var _this = this;
                var _cap_;
                var cap = this.rules.block.table.exec(src);
                if (!cap) return;
                if (!this.rules.other.tableDelimiter.test(cap[2])) return;
                var headers = splitCells(cap[1]);
                var aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
                var rows = ((_cap_ = cap[3]) === null || _cap_ === void 0 ? void 0 : _cap_.trim()) ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
                var item = {
                    type: "table",
                    raw: cap[0],
                    header: [],
                    align: [],
                    rows: []
                };
                if (headers.length !== aligns.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = aligns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var align = _step.value;
                        if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
                        else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
                        else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
                        else item.align.push(null);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var i = 0; i < headers.length; i++)item.header.push({
                    text: headers[i],
                    tokens: this.lexer.inline(headers[i]),
                    header: true,
                    align: item.align[i]
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = rows[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var row = _step1.value;
                        item.rows.push(splitCells(row, item.header.length).map(function(cell, i) {
                            return {
                                text: cell,
                                tokens: _this.lexer.inline(cell),
                                header: false,
                                align: item.align[i]
                            };
                        }));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return item;
            }
        },
        {
            key: "lheading",
            value: function lheading(src) {
                var cap = this.rules.block.lheading.exec(src);
                if (cap) return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[2].charAt(0) === "=" ? 1 : 2,
                    text: cap[1],
                    tokens: this.lexer.inline(cap[1])
                };
            }
        },
        {
            key: "paragraph",
            value: function paragraph(src) {
                var cap = this.rules.block.paragraph.exec(src);
                if (cap) {
                    var text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                    return {
                        type: "paragraph",
                        raw: cap[0],
                        text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
        },
        {
            key: "text",
            value: function text(src) {
                var cap = this.rules.block.text.exec(src);
                if (cap) return {
                    type: "text",
                    raw: cap[0],
                    text: cap[0],
                    tokens: this.lexer.inline(cap[0])
                };
            }
        },
        {
            key: "escape",
            value: function escape(src) {
                var cap = this.rules.inline.escape.exec(src);
                if (cap) return {
                    type: "escape",
                    raw: cap[0],
                    text: cap[1]
                };
            }
        },
        {
            key: "tag",
            value: function tag(src) {
                var cap = this.rules.inline.tag.exec(src);
                if (cap) {
                    if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                    else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                    if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                    else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                    return {
                        type: "html",
                        raw: cap[0],
                        inLink: this.lexer.state.inLink,
                        inRawBlock: this.lexer.state.inRawBlock,
                        block: false,
                        text: cap[0]
                    };
                }
            }
        },
        {
            key: "link",
            value: function link(src) {
                var cap = this.rules.inline.link.exec(src);
                if (cap) {
                    var trimmedUrl = cap[2].trim();
                    if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                        if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                        var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                    } else {
                        var lastParenIndex = findClosingBracket(cap[2], "()");
                        if (lastParenIndex === -2) return;
                        if (lastParenIndex > -1) {
                            var start = cap[0].indexOf("!") === 0 ? 5 : 4;
                            var linkLen = start + cap[1].length + lastParenIndex;
                            cap[2] = cap[2].substring(0, lastParenIndex);
                            cap[0] = cap[0].substring(0, linkLen).trim();
                            cap[3] = "";
                        }
                    }
                    var href = cap[2];
                    var title = "";
                    if (this.options.pedantic) {
                        var link2 = this.rules.other.pedanticHrefTitle.exec(href);
                        if (link2) {
                            href = link2[1];
                            title = link2[3];
                        }
                    } else title = cap[3] ? cap[3].slice(1, -1) : "";
                    href = href.trim();
                    if (this.rules.other.startAngleBracket.test(href)) {
                        if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                        else href = href.slice(1, -1);
                    }
                    return outputLink(cap, {
                        href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                        title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                    }, cap[0], this.lexer, this.rules);
                }
            }
        },
        {
            key: "reflink",
            value: function reflink(src, links) {
                var cap;
                if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                    var linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
                    var link2 = links[linkString.toLowerCase()];
                    if (!link2) {
                        var text = cap[0].charAt(0);
                        return {
                            type: "text",
                            raw: text,
                            text
                        };
                    }
                    return outputLink(cap, link2, cap[0], this.lexer, this.rules);
                }
            }
        },
        {
            key: "emStrong",
            value: function emStrong(src, maskedSrc) {
                var prevChar = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                var match = this.rules.inline.emStrongLDelim.exec(src);
                if (!match) return;
                if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
                var nextChar = match[1] || match[2] || "";
                if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                    var lLength = (0, _toConsumableArray._)(match[0]).length - 1;
                    var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                    var endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                    endReg.lastIndex = 0;
                    maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                    while((match = endReg.exec(maskedSrc)) != null){
                        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                        if (!rDelim) continue;
                        rLength = (0, _toConsumableArray._)(rDelim).length;
                        if (match[3] || match[4]) {
                            delimTotal += rLength;
                            continue;
                        } else if (match[5] || match[6]) {
                            if (lLength % 3 && !((lLength + rLength) % 3)) {
                                midDelimTotal += rLength;
                                continue;
                            }
                        }
                        delimTotal -= rLength;
                        if (delimTotal > 0) continue;
                        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                        var lastCharLength = (0, _toConsumableArray._)(match[0])[0].length;
                        var raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                        if (Math.min(lLength, rLength) % 2) {
                            var text2 = raw.slice(1, -1);
                            return {
                                type: "em",
                                raw,
                                text: text2,
                                tokens: this.lexer.inlineTokens(text2)
                            };
                        }
                        var text = raw.slice(2, -2);
                        return {
                            type: "strong",
                            raw,
                            text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                }
            }
        },
        {
            key: "codespan",
            value: function codespan(src) {
                var cap = this.rules.inline.code.exec(src);
                if (cap) {
                    var text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
                    var hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                    var hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                    if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                    return {
                        type: "codespan",
                        raw: cap[0],
                        text
                    };
                }
            }
        },
        {
            key: "br",
            value: function br(src) {
                var cap = this.rules.inline.br.exec(src);
                if (cap) return {
                    type: "br",
                    raw: cap[0]
                };
            }
        },
        {
            key: "del",
            value: function del(src) {
                var cap = this.rules.inline.del.exec(src);
                if (cap) return {
                    type: "del",
                    raw: cap[0],
                    text: cap[2],
                    tokens: this.lexer.inlineTokens(cap[2])
                };
            }
        },
        {
            key: "autolink",
            value: function autolink(src) {
                var cap = this.rules.inline.autolink.exec(src);
                if (cap) {
                    var text, href;
                    if (cap[2] === "@") {
                        text = cap[1];
                        href = "mailto:" + text;
                    } else {
                        text = cap[1];
                        href = text;
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text,
                        href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text
                            }
                        ]
                    };
                }
            }
        },
        {
            key: "url",
            value: function url(src) {
                var cap;
                if (cap = this.rules.inline.url.exec(src)) {
                    var text, href;
                    if (cap[2] === "@") {
                        text = cap[0];
                        href = "mailto:" + text;
                    } else {
                        var prevCapZero;
                        do {
                            var _this_rules_inline__backpedal_exec;
                            prevCapZero = cap[0];
                            var _this_rules_inline__backpedal_exec_;
                            cap[0] = (_this_rules_inline__backpedal_exec_ = (_this_rules_inline__backpedal_exec = this.rules.inline._backpedal.exec(cap[0])) === null || _this_rules_inline__backpedal_exec === void 0 ? void 0 : _this_rules_inline__backpedal_exec[0]) !== null && _this_rules_inline__backpedal_exec_ !== void 0 ? _this_rules_inline__backpedal_exec_ : "";
                        }while (prevCapZero !== cap[0]);
                        text = cap[0];
                        if (cap[1] === "www.") href = "http://" + cap[0];
                        else href = cap[0];
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text,
                        href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text
                            }
                        ]
                    };
                }
            }
        },
        {
            key: "inlineText",
            value: function inlineText(src) {
                var cap = this.rules.inline.text.exec(src);
                if (cap) {
                    var escaped = this.lexer.state.inRawBlock;
                    return {
                        type: "text",
                        raw: cap[0],
                        text: cap[0],
                        escaped
                    };
                }
            }
        }
    ]);
    return _Tokenizer;
}();
// src/Lexer.ts
var _Lexer = /*#__PURE__*/ function() {
    function __Lexer(options2) {
        (0, _classCallCheck._)(this, __Lexer);
        (0, _defineProperty._)(this, "tokens", void 0);
        (0, _defineProperty._)(this, "options", void 0);
        (0, _defineProperty._)(this, "state", void 0);
        (0, _defineProperty._)(this, "tokenizer", void 0);
        (0, _defineProperty._)(this, "inlineQueue", void 0);
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options2 || _defaults;
        this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        var rules = {
            other,
            block: block.normal,
            inline: inline.normal
        };
        if (this.options.pedantic) {
            rules.block = block.pedantic;
            rules.inline = inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = block.gfm;
            if (this.options.breaks) rules.inline = inline.breaks;
            else rules.inline = inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    (0, _createClass._)(__Lexer, [
        {
            /**
   * Preprocessing
   */ key: "lex",
            value: function lex(src) {
                src = src.replace(other.carriageReturn, "\n");
                this.blockTokens(src, this.tokens);
                for(var i = 0; i < this.inlineQueue.length; i++){
                    var next = this.inlineQueue[i];
                    this.inlineTokens(next.src, next.tokens);
                }
                this.inlineQueue = [];
                return this.tokens;
            }
        },
        {
            key: "blockTokens",
            value: function blockTokens(src) {
                var _this = this, _loop = function() {
                    var _this_options_extensions_block, _this_options_extensions, _this_options_extensions1;
                    var token = void 0;
                    if ((_this_options_extensions = _this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_block = _this_options_extensions.block) === null || _this_options_extensions_block === void 0 ? void 0 : _this_options_extensions_block.some(function(extTokenizer) {
                        if (token = extTokenizer.call({
                            lexer: _this1
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) return "continue";
                    if (token = _this.tokenizer.space(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken = tokens.at(-1);
                        if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                        else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.code(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken1 = tokens.at(-1);
                        if ((lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "paragraph" || (lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "text") {
                            lastToken1.raw += "\n" + token.raw;
                            lastToken1.text += "\n" + token.text;
                            _this.inlineQueue.at(-1).src = lastToken1.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.fences(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.heading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.hr(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.blockquote(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.list(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.html(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.def(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken2 = tokens.at(-1);
                        if ((lastToken2 === null || lastToken2 === void 0 ? void 0 : lastToken2.type) === "paragraph" || (lastToken2 === null || lastToken2 === void 0 ? void 0 : lastToken2.type) === "text") {
                            lastToken2.raw += "\n" + token.raw;
                            lastToken2.text += "\n" + token.raw;
                            _this.inlineQueue.at(-1).src = lastToken2.text;
                        } else if (!_this.tokens.links[token.tag]) _this.tokens.links[token.tag] = {
                            href: token.href,
                            title: token.title
                        };
                        return "continue";
                    }
                    if (token = _this.tokenizer.table(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.lheading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    var cutSrc = src;
                    if ((_this_options_extensions1 = _this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startBlock) {
                        var startIndex = Infinity;
                        var tempSrc = src.slice(1);
                        var tempStart = void 0;
                        _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                            tempStart = getStartIndex.call({
                                lexer: _this1
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (_this.state.top && (token = _this.tokenizer.paragraph(cutSrc))) {
                        var lastToken3 = tokens.at(-1);
                        if (lastParagraphClipped && (lastToken3 === null || lastToken3 === void 0 ? void 0 : lastToken3.type) === "paragraph") {
                            lastToken3.raw += "\n" + token.raw;
                            lastToken3.text += "\n" + token.text;
                            _this.inlineQueue.pop();
                            _this.inlineQueue.at(-1).src = lastToken3.text;
                        } else tokens.push(token);
                        lastParagraphClipped = cutSrc.length !== src.length;
                        src = src.substring(token.raw.length);
                        return "continue";
                    }
                    if (token = _this.tokenizer.text(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken4 = tokens.at(-1);
                        if ((lastToken4 === null || lastToken4 === void 0 ? void 0 : lastToken4.type) === "text") {
                            lastToken4.raw += "\n" + token.raw;
                            lastToken4.text += "\n" + token.text;
                            _this.inlineQueue.pop();
                            _this.inlineQueue.at(-1).src = lastToken4.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (src) {
                        var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (_this.options.silent) {
                            console.error(errMsg);
                            return "break";
                        } else throw new Error(errMsg);
                    }
                };
                var _this1 = this;
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lastParagraphClipped = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (this.options.pedantic) src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
                while(src){
                    var _ret = _loop();
                    if (_ret === "break") break;
                }
                this.state.top = true;
                return tokens;
            }
        },
        {
            key: "inline",
            value: function inline(src) {
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                this.inlineQueue.push({
                    src,
                    tokens
                });
                return tokens;
            }
        },
        {
            /**
   * Lexing/Compiling
   */ key: "inlineTokens",
            value: function inlineTokens(src) {
                var _this = this, _loop = function() {
                    var _this_options_extensions_inline, _this_options_extensions, _this_options_extensions1;
                    if (!keepPrevChar) prevChar = "";
                    keepPrevChar = false;
                    var token = void 0;
                    if ((_this_options_extensions = _this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_inline = _this_options_extensions.inline) === null || _this_options_extensions_inline === void 0 ? void 0 : _this_options_extensions_inline.some(function(extTokenizer) {
                        if (token = extTokenizer.call({
                            lexer: _this1
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) return "continue";
                    if (token = _this.tokenizer.escape(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.tag(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.link(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.reflink(src, _this.tokens.links)) {
                        src = src.substring(token.raw.length);
                        var lastToken = tokens.at(-1);
                        if (token.type === "text" && (lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "text") {
                            lastToken.raw += token.raw;
                            lastToken.text += token.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.codespan(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.br(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.del(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.autolink(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (!_this.state.inLink && (token = _this.tokenizer.url(src))) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    var cutSrc = src;
                    if ((_this_options_extensions1 = _this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startInline) {
                        var startIndex = Infinity;
                        var tempSrc = src.slice(1);
                        var tempStart = void 0;
                        _this.options.extensions.startInline.forEach(function(getStartIndex) {
                            tempStart = getStartIndex.call({
                                lexer: _this1
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (token = _this.tokenizer.inlineText(cutSrc)) {
                        src = src.substring(token.raw.length);
                        if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                        keepPrevChar = true;
                        var lastToken1 = tokens.at(-1);
                        if ((lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "text") {
                            lastToken1.raw += token.raw;
                            lastToken1.text += token.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (src) {
                        var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (_this.options.silent) {
                            console.error(errMsg);
                            return "break";
                        } else throw new Error(errMsg);
                    }
                };
                var _this1 = this;
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var maskedSrc = src;
                var match = null;
                if (this.tokens.links) {
                    var links = Object.keys(this.tokens.links);
                    if (links.length > 0) {
                        while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                    }
                }
                while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
                while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
                var keepPrevChar = false;
                var prevChar = "";
                while(src){
                    var _ret = _loop();
                    if (_ret === "break") break;
                }
                return tokens;
            }
        }
    ], [
        {
            key: "rules",
            get: /**
   * Expose Rules
   */ function get() {
                return {
                    block,
                    inline
                };
            }
        },
        {
            key: "lex",
            value: /**
   * Static Lex Method
   */ function lex(src, options2) {
                var lexer2 = new __Lexer(options2);
                return lexer2.lex(src);
            }
        },
        {
            key: "lexInline",
            value: /**
   * Static Lex Inline Method
   */ function lexInline(src, options2) {
                var lexer2 = new __Lexer(options2);
                return lexer2.inlineTokens(src);
            }
        }
    ]);
    return __Lexer;
}();
// src/Renderer.ts
var _Renderer = /*#__PURE__*/ function() {
    function _Renderer(options2) {
        (0, _classCallCheck._)(this, _Renderer);
        (0, _defineProperty._)(this, "options", void 0);
        (0, _defineProperty._)(this, "parser", void 0);
        this.options = options2 || _defaults;
    }
    (0, _createClass._)(_Renderer, [
        {
            key: "space",
            value: function space(token) {
                return "";
            }
        },
        {
            key: "code",
            value: function code(param) {
                var text = param.text, lang = param.lang, escaped = param.escaped;
                var _match;
                var langString = (_match = (lang || "").match(other.notSpaceStart)) === null || _match === void 0 ? void 0 : _match[0];
                var code = text.replace(other.endingNewline, "") + "\n";
                if (!langString) return "<pre><code>" + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
                return '<pre><code class="language-' + escape2(langString) + '">' + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
            }
        },
        {
            key: "blockquote",
            value: function blockquote(param) {
                var tokens = param.tokens;
                var body = this.parser.parse(tokens);
                return `<blockquote>
${body}</blockquote>
`;
            }
        },
        {
            key: "html",
            value: function html(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "heading",
            value: function heading(param) {
                var tokens = param.tokens, depth = param.depth;
                return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>
`;
            }
        },
        {
            key: "hr",
            value: function hr(token) {
                return "<hr>\n";
            }
        },
        {
            key: "list",
            value: function list(token) {
                var ordered = token.ordered;
                var start = token.start;
                var body = "";
                for(var j = 0; j < token.items.length; j++){
                    var item = token.items[j];
                    body += this.listitem(item);
                }
                var type = ordered ? "ol" : "ul";
                var startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
                return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
            }
        },
        {
            key: "listitem",
            value: function listitem(item) {
                var itemBody = "";
                if (item.task) {
                    var checkbox = this.checkbox({
                        checked: !!item.checked
                    });
                    if (item.loose) {
                        var _item_tokens_;
                        if (((_item_tokens_ = item.tokens[0]) === null || _item_tokens_ === void 0 ? void 0 : _item_tokens_.type) === "paragraph") {
                            item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                            if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                                item.tokens[0].tokens[0].text = checkbox + " " + escape2(item.tokens[0].tokens[0].text);
                                item.tokens[0].tokens[0].escaped = true;
                            }
                        } else item.tokens.unshift({
                            type: "text",
                            raw: checkbox + " ",
                            text: checkbox + " ",
                            escaped: true
                        });
                    } else itemBody += checkbox + " ";
                }
                itemBody += this.parser.parse(item.tokens, !!item.loose);
                return `<li>${itemBody}</li>
`;
            }
        },
        {
            key: "checkbox",
            value: function checkbox(param) {
                var checked = param.checked;
                return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
            }
        },
        {
            key: "paragraph",
            value: function paragraph(param) {
                var tokens = param.tokens;
                return `<p>${this.parser.parseInline(tokens)}</p>
`;
            }
        },
        {
            key: "table",
            value: function table(token) {
                var header = "";
                var cell = "";
                for(var j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
                header += this.tablerow({
                    text: cell
                });
                var body = "";
                for(var j1 = 0; j1 < token.rows.length; j1++){
                    var row = token.rows[j1];
                    cell = "";
                    for(var k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                    body += this.tablerow({
                        text: cell
                    });
                }
                if (body) body = `<tbody>${body}</tbody>`;
                return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
            }
        },
        {
            key: "tablerow",
            value: function tablerow(param) {
                var text = param.text;
                return `<tr>
${text}</tr>
`;
            }
        },
        {
            key: "tablecell",
            value: function tablecell(token) {
                var content = this.parser.parseInline(token.tokens);
                var type = token.header ? "th" : "td";
                var tag2 = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
                return tag2 + content + `</${type}>
`;
            }
        },
        {
            /**
   * span level renderer
   */ key: "strong",
            value: function strong(param) {
                var tokens = param.tokens;
                return `<strong>${this.parser.parseInline(tokens)}</strong>`;
            }
        },
        {
            key: "em",
            value: function em(param) {
                var tokens = param.tokens;
                return `<em>${this.parser.parseInline(tokens)}</em>`;
            }
        },
        {
            key: "codespan",
            value: function codespan(param) {
                var text = param.text;
                return `<code>${escape2(text, true)}</code>`;
            }
        },
        {
            key: "br",
            value: function br(token) {
                return "<br>";
            }
        },
        {
            key: "del",
            value: function del(param) {
                var tokens = param.tokens;
                return `<del>${this.parser.parseInline(tokens)}</del>`;
            }
        },
        {
            key: "link",
            value: function link(param) {
                var href = param.href, title = param.title, tokens = param.tokens;
                var text = this.parser.parseInline(tokens);
                var cleanHref = cleanUrl(href);
                if (cleanHref === null) return text;
                href = cleanHref;
                var out = '<a href="' + href + '"';
                if (title) out += ' title="' + escape2(title) + '"';
                out += ">" + text + "</a>";
                return out;
            }
        },
        {
            key: "image",
            value: function image(param) {
                var href = param.href, title = param.title, text = param.text, tokens = param.tokens;
                if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
                var cleanHref = cleanUrl(href);
                if (cleanHref === null) return escape2(text);
                href = cleanHref;
                var out = `<img src="${href}" alt="${text}"`;
                if (title) out += ` title="${escape2(title)}"`;
                out += ">";
                return out;
            }
        },
        {
            key: "text",
            value: function text(token) {
                return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : escape2(token.text);
            }
        }
    ]);
    return _Renderer;
}();
// src/TextRenderer.ts
var _TextRenderer = /*#__PURE__*/ function() {
    function _TextRenderer() {
        (0, _classCallCheck._)(this, _TextRenderer);
    }
    (0, _createClass._)(_TextRenderer, [
        {
            // no need for block level renderers
            key: "strong",
            value: function strong(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "em",
            value: function em(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "codespan",
            value: function codespan(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "del",
            value: function del(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "html",
            value: function html(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "text",
            value: function text(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "link",
            value: function link(param) {
                var text = param.text;
                return "" + text;
            }
        },
        {
            key: "image",
            value: function image(param) {
                var text = param.text;
                return "" + text;
            }
        },
        {
            key: "br",
            value: function br() {
                return "";
            }
        }
    ]);
    return _TextRenderer;
}();
// src/Parser.ts
var _Parser = /*#__PURE__*/ function() {
    function __Parser(options2) {
        (0, _classCallCheck._)(this, __Parser);
        (0, _defineProperty._)(this, "options", void 0);
        (0, _defineProperty._)(this, "renderer", void 0);
        (0, _defineProperty._)(this, "textRenderer", void 0);
        this.options = options2 || _defaults;
        this.options.renderer = this.options.renderer || new _Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new _TextRenderer();
    }
    (0, _createClass._)(__Parser, [
        {
            /**
   * Parse Loop
   */ key: "parse",
            value: function parse(tokens) {
                var top = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var out = "";
                for(var i = 0; i < tokens.length; i++){
                    var _this_options_extensions_renderers, _this_options_extensions;
                    var anyToken = tokens[i];
                    if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[anyToken.type]) {
                        var genericToken = anyToken;
                        var ret = this.options.extensions.renderers[genericToken.type].call({
                            parser: this
                        }, genericToken);
                        if (ret !== false || ![
                            "space",
                            "hr",
                            "heading",
                            "code",
                            "table",
                            "blockquote",
                            "list",
                            "html",
                            "paragraph",
                            "text"
                        ].includes(genericToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    var token = anyToken;
                    switch(token.type){
                        case "space":
                            out += this.renderer.space(token);
                            continue;
                        case "hr":
                            out += this.renderer.hr(token);
                            continue;
                        case "heading":
                            out += this.renderer.heading(token);
                            continue;
                        case "code":
                            out += this.renderer.code(token);
                            continue;
                        case "table":
                            out += this.renderer.table(token);
                            continue;
                        case "blockquote":
                            out += this.renderer.blockquote(token);
                            continue;
                        case "list":
                            out += this.renderer.list(token);
                            continue;
                        case "html":
                            out += this.renderer.html(token);
                            continue;
                        case "paragraph":
                            out += this.renderer.paragraph(token);
                            continue;
                        case "text":
                            {
                                var textToken = token;
                                var body = this.renderer.text(textToken);
                                while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                    textToken = tokens[++i];
                                    body += "\n" + this.renderer.text(textToken);
                                }
                                if (top) out += this.renderer.paragraph({
                                    type: "paragraph",
                                    raw: body,
                                    text: body,
                                    tokens: [
                                        {
                                            type: "text",
                                            raw: body,
                                            text: body,
                                            escaped: true
                                        }
                                    ]
                                });
                                else out += body;
                                continue;
                            }
                        default:
                            {
                                var errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
        },
        {
            /**
   * Parse Inline Tokens
   */ key: "parseInline",
            value: function parseInline(tokens) {
                var renderer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.renderer;
                var out = "";
                for(var i = 0; i < tokens.length; i++){
                    var _this_options_extensions_renderers, _this_options_extensions;
                    var anyToken = tokens[i];
                    if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[anyToken.type]) {
                        var ret = this.options.extensions.renderers[anyToken.type].call({
                            parser: this
                        }, anyToken);
                        if (ret !== false || ![
                            "escape",
                            "html",
                            "link",
                            "image",
                            "strong",
                            "em",
                            "codespan",
                            "br",
                            "del",
                            "text"
                        ].includes(anyToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    var token = anyToken;
                    switch(token.type){
                        case "escape":
                            out += renderer.text(token);
                            break;
                        case "html":
                            out += renderer.html(token);
                            break;
                        case "link":
                            out += renderer.link(token);
                            break;
                        case "image":
                            out += renderer.image(token);
                            break;
                        case "strong":
                            out += renderer.strong(token);
                            break;
                        case "em":
                            out += renderer.em(token);
                            break;
                        case "codespan":
                            out += renderer.codespan(token);
                            break;
                        case "br":
                            out += renderer.br(token);
                            break;
                        case "del":
                            out += renderer.del(token);
                            break;
                        case "text":
                            out += renderer.text(token);
                            break;
                        default:
                            {
                                var errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
        }
    ], [
        {
            key: "parse",
            value: /**
   * Static Parse Method
   */ function parse(tokens, options2) {
                var parser2 = new __Parser(options2);
                return parser2.parse(tokens);
            }
        },
        {
            key: "parseInline",
            value: /**
   * Static Parse Inline Method
   */ function parseInline(tokens, options2) {
                var parser2 = new __Parser(options2);
                return parser2.parseInline(tokens);
            }
        }
    ]);
    return __Parser;
}();
// src/Hooks.ts
var _Hooks = (_class = /*#__PURE__*/ function() {
    function _class(options2) {
        (0, _classCallCheck._)(this, _class);
        (0, _defineProperty._)(this, "options", void 0);
        (0, _defineProperty._)(this, "block", void 0);
        this.options = options2 || _defaults;
    }
    (0, _createClass._)(_class, [
        {
            /**
   * Process markdown before marked
   */ key: "preprocess",
            value: function preprocess(markdown) {
                return markdown;
            }
        },
        {
            /**
   * Process HTML after marked is finished
   */ key: "postprocess",
            value: function postprocess(html2) {
                return html2;
            }
        },
        {
            /**
   * Process all tokens before walk tokens
   */ key: "processAllTokens",
            value: function processAllTokens(tokens) {
                return tokens;
            }
        },
        {
            /**
   * Provide function to tokenize markdown
   */ key: "provideLexer",
            value: function provideLexer() {
                return this.block ? _Lexer.lex : _Lexer.lexInline;
            }
        },
        {
            /**
   * Provide function to parse tokens
   */ key: "provideParser",
            value: function provideParser() {
                return this.block ? _Parser.parse : _Parser.parseInline;
            }
        }
    ]);
    return _class;
}(), (0, _defineProperty._)(_class, "passThroughHooks", /* @__PURE__ */ new Set([
    "preprocess",
    "postprocess",
    "processAllTokens"
])), _class);
// src/Instance.ts
var Marked = /*#__PURE__*/ function() {
    function Marked() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, Marked);
        (0, _defineProperty._)(this, "defaults", _getDefaults());
        (0, _defineProperty._)(this, "options", this.setOptions);
        (0, _defineProperty._)(this, "parse", this.parseMarkdown(true));
        (0, _defineProperty._)(this, "parseInline", this.parseMarkdown(false));
        (0, _defineProperty._)(this, "Parser", _Parser);
        (0, _defineProperty._)(this, "Renderer", _Renderer);
        (0, _defineProperty._)(this, "TextRenderer", _TextRenderer);
        (0, _defineProperty._)(this, "Lexer", _Lexer);
        (0, _defineProperty._)(this, "Tokenizer", _Tokenizer);
        (0, _defineProperty._)(this, "Hooks", _Hooks);
        this.use.apply(this, (0, _toConsumableArray._)(args));
    }
    (0, _createClass._)(Marked, [
        {
            /**
   * Run callback for every token
   */ key: "walkTokens",
            value: function walkTokens(tokens, callback) {
                var _this = this;
                var values = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this1 = this, _loop = function() {
                        var token = _step.value;
                        values = values.concat(callback.call(_this1, token));
                        switch(token.type){
                            case "table":
                                {
                                    var tableToken = token;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = tableToken.header[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var cell = _step1.value;
                                            values = values.concat(_this1.walkTokens(cell.tokens, callback));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator1 = tableToken.rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                            var row = _step2.value;
                                            try {
                                                for(var _iterator2 = row[Symbol.iterator](), _step3; !(_iteratorNormalCompletion1 = (_step3 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                                                    var cell1 = _step3.value;
                                                    values = values.concat(_this1.walkTokens(cell1.tokens, callback));
                                                }
                                            } catch (err) {
                                                _didIteratorError1 = true;
                                                _iteratorError1 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                                                        _iterator2.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError1) {
                                                        throw _iteratorError1;
                                                    }
                                                }
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    break;
                                }
                            case "list":
                                {
                                    var listToken = token;
                                    values = values.concat(_this1.walkTokens(listToken.items, callback));
                                    break;
                                }
                            default:
                                {
                                    var _this_defaults_extensions_childTokens, _this_defaults_extensions;
                                    var genericToken = token;
                                    if ((_this_defaults_extensions = _this1.defaults.extensions) === null || _this_defaults_extensions === void 0 ? void 0 : (_this_defaults_extensions_childTokens = _this_defaults_extensions.childTokens) === null || _this_defaults_extensions_childTokens === void 0 ? void 0 : _this_defaults_extensions_childTokens[genericToken.type]) _this1.defaults.extensions.childTokens[genericToken.type].forEach(function(childTokens) {
                                        var tokens2 = genericToken[childTokens].flat(Infinity);
                                        values = values.concat(_this.walkTokens(tokens2, callback));
                                    });
                                    else if (genericToken.tokens) values = values.concat(_this1.walkTokens(genericToken.tokens, callback));
                                }
                        }
                    };
                    for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return values;
            }
        },
        {
            key: "use",
            value: function use() {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var extensions = this.defaults.extensions || {
                    renderers: {},
                    childTokens: {}
                };
                args.forEach(function(pack) {
                    var opts = (0, _objectSpread._)({}, pack);
                    opts.async = _this.defaults.async || opts.async || false;
                    if (pack.extensions) {
                        pack.extensions.forEach(function(ext) {
                            if (!ext.name) throw new Error("extension name required");
                            if ("renderer" in ext) {
                                var prevRenderer = extensions.renderers[ext.name];
                                if (prevRenderer) extensions.renderers[ext.name] = function() {
                                    for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                        args2[_key] = arguments[_key];
                                    }
                                    var ret = ext.renderer.apply(this, args2);
                                    if (ret === false) ret = prevRenderer.apply(this, args2);
                                    return ret;
                                };
                                else extensions.renderers[ext.name] = ext.renderer;
                            }
                            if ("tokenizer" in ext) {
                                if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                                var extLevel = extensions[ext.level];
                                if (extLevel) extLevel.unshift(ext.tokenizer);
                                else extensions[ext.level] = [
                                    ext.tokenizer
                                ];
                                if (ext.start) {
                                    if (ext.level === "block") {
                                        if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                        else extensions.startBlock = [
                                            ext.start
                                        ];
                                    } else if (ext.level === "inline") {
                                        if (extensions.startInline) extensions.startInline.push(ext.start);
                                        else extensions.startInline = [
                                            ext.start
                                        ];
                                    }
                                }
                            }
                            if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                        });
                        opts.extensions = extensions;
                    }
                    if (pack.renderer) {
                        var _loop = function(prop) {
                            if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                            if ([
                                "options",
                                "parser"
                            ].includes(prop)) return "continue";
                            var rendererProp = prop;
                            var rendererFunc = pack.renderer[rendererProp];
                            var prevRenderer = renderer[rendererProp];
                            renderer[rendererProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = rendererFunc.apply(renderer, args2);
                                if (ret === false) ret = prevRenderer.apply(renderer, args2);
                                return ret || "";
                            };
                        };
                        var renderer = _this.defaults.renderer || new _Renderer(_this.defaults);
                        for(var prop in pack.renderer)_loop(prop);
                        opts.renderer = renderer;
                    }
                    if (pack.tokenizer) {
                        var _loop1 = function(prop1) {
                            if (!(prop1 in tokenizer)) throw new Error(`tokenizer '${prop1}' does not exist`);
                            if ([
                                "options",
                                "rules",
                                "lexer"
                            ].includes(prop1)) return "continue";
                            var tokenizerProp = prop1;
                            var tokenizerFunc = pack.tokenizer[tokenizerProp];
                            var prevTokenizer = tokenizer[tokenizerProp];
                            tokenizer[tokenizerProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = tokenizerFunc.apply(tokenizer, args2);
                                if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                                return ret;
                            };
                        };
                        var tokenizer = _this.defaults.tokenizer || new _Tokenizer(_this.defaults);
                        for(var prop1 in pack.tokenizer)_loop1(prop1);
                        opts.tokenizer = tokenizer;
                    }
                    if (pack.hooks) {
                        var _loop2 = function(prop2) {
                            if (!(prop2 in hooks)) throw new Error(`hook '${prop2}' does not exist`);
                            if ([
                                "options",
                                "block"
                            ].includes(prop2)) return "continue";
                            var hooksProp = prop2;
                            var hooksFunc = pack.hooks[hooksProp];
                            var prevHook = hooks[hooksProp];
                            if (_Hooks.passThroughHooks.has(prop2)) hooks[hooksProp] = function(arg) {
                                if (_this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then(function(ret2) {
                                    return prevHook.call(hooks, ret2);
                                });
                                var ret = hooksFunc.call(hooks, arg);
                                return prevHook.call(hooks, ret);
                            };
                            else hooks[hooksProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = hooksFunc.apply(hooks, args2);
                                if (ret === false) ret = prevHook.apply(hooks, args2);
                                return ret;
                            };
                        };
                        var hooks = _this.defaults.hooks || new _Hooks();
                        for(var prop2 in pack.hooks)_loop2(prop2);
                        opts.hooks = hooks;
                    }
                    if (pack.walkTokens) {
                        var walkTokens2 = _this.defaults.walkTokens;
                        var packWalktokens = pack.walkTokens;
                        opts.walkTokens = function(token) {
                            var values = [];
                            values.push(packWalktokens.call(this, token));
                            if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                            return values;
                        };
                    }
                    _this.defaults = (0, _objectSpread._)({}, _this.defaults, opts);
                });
                return this;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(opt) {
                this.defaults = (0, _objectSpread._)({}, this.defaults, opt);
                return this;
            }
        },
        {
            key: "lexer",
            value: function lexer(src, options2) {
                return _Lexer.lex(src, options2 !== null && options2 !== void 0 ? options2 : this.defaults);
            }
        },
        {
            key: "parser",
            value: function parser(tokens, options2) {
                return _Parser.parse(tokens, options2 !== null && options2 !== void 0 ? options2 : this.defaults);
            }
        },
        {
            key: "parseMarkdown",
            value: function parseMarkdown(blockType) {
                var _this = this;
                var parse2 = function(src, options2) {
                    var origOpt = (0, _objectSpread._)({}, options2);
                    var opt = (0, _objectSpread._)({}, _this.defaults, origOpt);
                    var throwError = _this.onError(!!opt.silent, !!opt.async);
                    if (_this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                    if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                    if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                    if (opt.hooks) {
                        opt.hooks.options = opt;
                        opt.hooks.block = blockType;
                    }
                    var lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                    var parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                    if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src2) {
                        return lexer2(src2, opt);
                    }).then(function(tokens) {
                        return opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens;
                    }).then(function(tokens) {
                        return opt.walkTokens ? Promise.all(_this.walkTokens(tokens, opt.walkTokens)).then(function() {
                            return tokens;
                        }) : tokens;
                    }).then(function(tokens) {
                        return parser2(tokens, opt);
                    }).then(function(html2) {
                        return opt.hooks ? opt.hooks.postprocess(html2) : html2;
                    }).catch(throwError);
                    try {
                        if (opt.hooks) src = opt.hooks.preprocess(src);
                        var tokens = lexer2(src, opt);
                        if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                        if (opt.walkTokens) _this.walkTokens(tokens, opt.walkTokens);
                        var html2 = parser2(tokens, opt);
                        if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                        return html2;
                    } catch (e) {
                        return throwError(e);
                    }
                };
                return parse2;
            }
        },
        {
            key: "onError",
            value: function onError(silent, async) {
                return function(e) {
                    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                    if (silent) {
                        var msg = "<p>An error occurred:</p><pre>" + escape2(e.message + "", true) + "</pre>";
                        if (async) return Promise.resolve(msg);
                        return msg;
                    }
                    if (async) return Promise.reject(e);
                    throw e;
                };
            }
        }
    ]);
    return Marked;
}();
// src/marked.ts
var markedInstance = new Marked();
function marked(src, opt) {
    return markedInstance.parse(src, opt);
}
marked.options = marked.setOptions = function(options2) {
    markedInstance.setOptions(options2);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
marked.use = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _markedInstance;
    (_markedInstance = markedInstance).use.apply(_markedInstance, (0, _toConsumableArray._)(args));
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
marked.walkTokens = function(tokens, callback) {
    return markedInstance.walkTokens(tokens, callback);
};
marked.parseInline = markedInstance.parseInline;
marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
var options = marked.options;
var setOptions = marked.setOptions;
var use = marked.use;
var walkTokens = marked.walkTokens;
var parseInline = marked.parseInline;
var parse = marked;
var parser = _Parser.parse;
var lexer = _Lexer.lex; //# sourceMappingURL=marked.cjs.map

},{"@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_define_property":"9oyNF","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9"}]},["9DeGw"], null, "parcelRequiree0b7")

//# sourceMappingURL=index.5b47bc8d.js.map
